import React from 'react';
import PropTypes from 'prop-types';
import './icons.scss';
import Skeleton from '../skeleton/skeleton';

export function ChatIcon({ color }) {
  return (
    <svg
      width="0.833vw"
      height="0.833vw"
      viewBox="0 0 12 13"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M2.7655 10.0833L0.166748 12.125V1.33333C0.166748 1.17862 0.228206 1.03025 0.337602 0.920854C0.446999 0.811458 0.595372 0.75 0.750081 0.75H11.2501C11.4048 0.75 11.5532 0.811458 11.6626 0.920854C11.772 1.03025 11.8334 1.17862 11.8334 1.33333V9.5C11.8334 9.65471 11.772 9.80308 11.6626 9.91248C11.5532 10.0219 11.4048 10.0833 11.2501 10.0833H2.7655ZM2.36183 8.91667H10.6667V1.91667H1.33341V9.72458L2.36183 8.91667ZM5.41675 4.83333H6.58342V6H5.41675V4.83333ZM3.08342 4.83333H4.25008V6H3.08342V4.83333ZM7.75008 4.83333H8.91675V6H7.75008V4.83333Z"
        fill={color}
      />
    </svg>
  );
}
ChatIcon.propTypes = {
  color: PropTypes.string,
};
ChatIcon.defaultProps = {
  color: '#0288FA',
};
export function SearchIcon({ color, width, height }) {
  return (
    <svg
      width={width !== '' ? width : '1.111vw'}
      height={height !== '' ? height : '0.972vw'}
      viewBox="0 0 16 14"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M11.8924 10.0777L15.0019 12.9323L13.9746 13.8757L10.8658 11.0203C9.70901 11.8718 8.27021 12.3349 6.78767 12.333C3.18076 12.333 0.253418 9.64501 0.253418 6.33301C0.253418 3.02101 3.18076 0.333008 6.78767 0.333008C10.3946 0.333008 13.3219 3.02101 13.3219 6.33301C13.324 7.69434 12.8197 9.0155 11.8924 10.0777ZM10.436 9.58301C11.3574 8.71293 11.8719 7.54663 11.8699 6.33301C11.8699 3.75434 9.59521 1.66634 6.78767 1.66634C3.97939 1.66634 1.70547 3.75434 1.70547 6.33301C1.70547 8.91101 3.97939 10.9997 6.78767 10.9997C8.10935 11.0016 9.3795 10.5291 10.327 9.68301L10.436 9.58301Z"
        fill={color !== '' ? color : '#C9C9C9'}
      />
    </svg>
  );
}
SearchIcon.propTypes = {
  color: PropTypes.string,
  width: PropTypes.string,
  height: PropTypes.string,
};
SearchIcon.defaultProps = {
  color: '',
  width: '',
  height: '',
};
export function ArrowDownIcon({ color }) {
  return (
    <svg
      width="10"
      height="6"
      viewBox="0 0 10 6"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M5.00345 3.87851L8.71594 0.166016L9.77644 1.22651L5.00345 5.99951L0.230469 1.22651L1.29097 0.166016L5.00345 3.87851Z"
        fill={color !== '' ? color : 'white'}
      />
    </svg>
  );
}
ArrowDownIcon.propTypes = {
  color: PropTypes.string,
};
ArrowDownIcon.defaultProps = {
  color: '',
};
export function FilterIcon() {
  return (
    <svg
      width="0.694vw"
      height="0.833vw"
      viewBox="0 0 10 12"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M6.16658 7.16667V10.6667L3.83325 11.8333V7.16667L0.333252 1.91667V0.75H9.66658V1.91667L6.16658 7.16667ZM1.73558 1.91667L4.99992 6.81317L8.26425 1.91667H1.73558Z"
        fill="#0288FA"
      />
    </svg>
  );
}
export function FilterIconNew() {
  return (
    <svg
      width="0.972vw"
      height="1.042vw"
      viewBox="0 0 14 15"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M6.38173 13.7121C6.10173 13.7121 5.82757 13.6421 5.5709 13.5021C5.05756 13.2163 4.7484 12.6971 4.7484 12.1138V9.02211C4.7484 8.73044 4.5559 8.29294 4.37506 8.07128L2.1934 5.76128C1.8259 5.39378 1.5459 4.76378 1.5459 4.29128V2.94961C1.5459 2.01628 2.25173 1.28711 3.15007 1.28711H10.8501C11.7367 1.28711 12.4542 2.00461 12.4542 2.89128V4.17461C12.4542 4.78711 12.0867 5.48128 11.7426 5.82544L9.21673 8.05961C8.97173 8.26378 8.77923 8.71294 8.77923 9.07461V11.5829C8.77923 12.1021 8.45256 12.7029 8.04423 12.9479L7.23923 13.4671C6.97673 13.6304 6.67923 13.7121 6.38173 13.7121ZM3.15007 2.16211C2.74173 2.16211 2.4209 2.50628 2.4209 2.94961V4.29128C2.4209 4.50711 2.5959 4.92711 2.81756 5.14878L5.04007 7.48794C5.33757 7.85544 5.62923 8.46794 5.62923 9.01628V12.1079C5.62923 12.4871 5.89173 12.6738 6.00256 12.7321C6.24756 12.8663 6.54506 12.8663 6.77256 12.7263L7.5834 12.2071C7.74673 12.1079 7.91006 11.7929 7.91006 11.5829V9.07461C7.91006 8.45044 8.2134 7.76211 8.6509 7.39461L11.1476 5.18378C11.3459 4.98544 11.5851 4.51294 11.5851 4.16878V2.89128C11.5851 2.48878 11.2584 2.16211 10.8559 2.16211H3.15007Z"
        fill="#2179C4"
      />
      <path
        d="M3.49989 6.77058C3.41823 6.77058 3.34239 6.74725 3.26656 6.70641C3.06239 6.57808 2.99823 6.30391 3.12656 6.09975L6.00239 1.49141C6.13073 1.28725 6.39906 1.22308 6.60323 1.35141C6.80739 1.47975 6.87156 1.74808 6.74323 1.95225L3.86739 6.56058C3.78573 6.69475 3.64573 6.77058 3.49989 6.77058Z"
        fill="#2179C4"
      />
    </svg>
  );
}
export function OpenEyeIcon() {
  return (
    <svg
      width="0.972vw"
      height="12"
      viewBox="0 0 14 12"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M7.00005 0.75C10.1454 0.75 12.7622 3.01333 13.3111 6C12.7628 8.98667 10.1454 11.25 7.00005 11.25C3.85472 11.25 1.23788 8.98667 0.688965 6C1.2373 3.01333 3.85472 0.75 7.00005 0.75ZM7.00005 10.0833C8.18974 10.0831 9.34411 9.67898 10.2742 8.93718C11.2043 8.19538 11.8551 7.15983 12.12 6C11.8541 4.84109 11.2029 3.80667 10.2729 3.06585C9.3429 2.32503 8.18906 1.92164 7.00005 1.92164C5.81104 1.92164 4.6572 2.32503 3.72718 3.06585C2.79717 3.80667 2.146 4.84109 1.88013 6C2.14502 7.15983 2.79577 8.19538 3.72588 8.93718C4.65599 9.67898 5.81036 10.0831 7.00005 10.0833ZM7.00005 8.625C6.30386 8.625 5.63618 8.34844 5.14389 7.85615C4.65161 7.36387 4.37505 6.69619 4.37505 6C4.37505 5.30381 4.65161 4.63613 5.14389 4.14384C5.63618 3.65156 6.30386 3.375 7.00005 3.375C7.69624 3.375 8.36392 3.65156 8.8562 4.14384C9.34849 4.63613 9.62505 5.30381 9.62505 6C9.62505 6.69619 9.34849 7.36387 8.8562 7.85615C8.36392 8.34844 7.69624 8.625 7.00005 8.625ZM7.00005 7.45833C7.38682 7.45833 7.75776 7.30469 8.03125 7.0312C8.30474 6.75771 8.45838 6.38677 8.45838 6C8.45838 5.61323 8.30474 5.24229 8.03125 4.9688C7.75776 4.69531 7.38682 4.54167 7.00005 4.54167C6.61327 4.54167 6.24234 4.69531 5.96885 4.9688C5.69536 5.24229 5.54172 5.61323 5.54172 6C5.54172 6.38677 5.69536 6.75771 5.96885 7.0312C6.24234 7.30469 6.61327 7.45833 7.00005 7.45833Z"
        fill="#0288FA"
      />
    </svg>
  );
}
export function AcceptIcon({ color, size }) {
  return (
    <svg
      width={size !== '' ? size : '14'}
      height={size !== '' ? size : '10'}
      viewBox="0 0 14 10"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M5.50005 7.87912L12.3941 0.984375L13.4553 2.04488L5.50005 10.0001L0.727051 5.22712L1.78755 4.16663L5.50005 7.87912Z"
        fill={color !== '' ? color : 'white'}
      />
    </svg>
  );
}
AcceptIcon.propTypes = {
  color: PropTypes.string,
  size: PropTypes.string,
};
AcceptIcon.defaultProps = {
  color: '',
  size: '',
};
export function RejectIcon({ color, size }) {
  return (
    <svg
      width={size !== '' ? size : '10'}
      height={size !== '' ? size : '11'}
      viewBox="0 0 10 11"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M5.00005 4.43906L8.71255 0.726562L9.77305 1.78706L6.06055 5.49956L9.77305 9.21206L8.71255 10.2726L5.00005 6.56006L1.28755 10.2726L0.227051 9.21206L3.93955 5.49956L0.227051 1.78706L1.28755 0.726562L5.00005 4.43906Z"
        fill={color !== '' ? color : 'white'}
      />
    </svg>
  );
}
RejectIcon.propTypes = {
  color: PropTypes.string,
  size: PropTypes.string,
};
RejectIcon.defaultProps = {
  color: '',
  size: '',
};
export function AcceptBorderedIcon({ color, size }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 20 20"
      fill="none"
    >
      <path
        d="M12.4993 18.9587H7.49935C2.97435 18.9587 1.04102 17.0253 1.04102 12.5003V7.50033C1.04102 2.97533 2.97435 1.04199 7.49935 1.04199H12.4993C17.0243 1.04199 18.9577 2.97533 18.9577 7.50033V12.5003C18.9577 17.0253 17.0243 18.9587 12.4993 18.9587ZM7.49935 2.29199C3.65768 2.29199 2.29102 3.65866 2.29102 7.50033V12.5003C2.29102 16.342 3.65768 17.7087 7.49935 17.7087H12.4993C16.341 17.7087 17.7077 16.342 17.7077 12.5003V7.50033C17.7077 3.65866 16.341 2.29199 12.4993 2.29199H7.49935Z"
        fill={color !== '' ? color : '#616B80'}
      />
      <path
        d="M8.81719 12.9837C8.65052 12.9837 8.49219 12.917 8.37552 12.8003L6.01719 10.442C5.77552 10.2003 5.77552 9.80033 6.01719 9.55866C6.25885 9.31699 6.65885 9.31699 6.90052 9.55866L8.81719 11.4753L13.1005 7.19199C13.3422 6.95033 13.7422 6.95033 13.9839 7.19199C14.2255 7.43366 14.2255 7.83366 13.9839 8.07533L9.25885 12.8003C9.14219 12.917 8.98385 12.9837 8.81719 12.9837Z"
        fill={color !== '' ? color : '#616B80'}
      />
    </svg>
  );
}
AcceptBorderedIcon.propTypes = {
  color: PropTypes.string,
  size: PropTypes.string,
};
AcceptBorderedIcon.defaultProps = {
  color: '',
  size: '20',
};
export function RejectBorderedIcon({ color, size }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 20 20"
      fill="none"
    >
      <path
        d="M7.64245 12.9831C7.48411 12.9831 7.32578 12.9248 7.20078 12.7998C6.95911 12.5581 6.95911 12.1581 7.20078 11.9165L11.9174 7.1998C12.1591 6.95814 12.5591 6.95814 12.8008 7.1998C13.0424 7.44147 13.0424 7.84147 12.8008 8.08314L8.08411 12.7998C7.96745 12.9248 7.80078 12.9831 7.64245 12.9831Z"
        fill={color !== '' ? color : '#616B80'}
      />
      <path
        d="M12.3591 12.9831C12.2008 12.9831 12.0424 12.9248 11.9174 12.7998L7.20078 8.08314C6.95911 7.84147 6.95911 7.44147 7.20078 7.1998C7.44245 6.95814 7.84245 6.95814 8.08411 7.1998L12.8008 11.9165C13.0424 12.1581 13.0424 12.5581 12.8008 12.7998C12.6758 12.9248 12.5174 12.9831 12.3591 12.9831Z"
        fill={color !== '' ? color : '#616B80'}
      />
      <path
        d="M12.4993 18.9587H7.49935C2.97435 18.9587 1.04102 17.0253 1.04102 12.5003V7.50033C1.04102 2.97533 2.97435 1.04199 7.49935 1.04199H12.4993C17.0243 1.04199 18.9577 2.97533 18.9577 7.50033V12.5003C18.9577 17.0253 17.0243 18.9587 12.4993 18.9587ZM7.49935 2.29199C3.65768 2.29199 2.29102 3.65866 2.29102 7.50033V12.5003C2.29102 16.342 3.65768 17.7087 7.49935 17.7087H12.4993C16.341 17.7087 17.7077 16.342 17.7077 12.5003V7.50033C17.7077 3.65866 16.341 2.29199 12.4993 2.29199H7.49935Z"
        fill={color !== '' ? color : '#616B80'}
      />
    </svg>
  );
}
RejectBorderedIcon.propTypes = {
  color: PropTypes.string,
  size: PropTypes.string,
};
RejectBorderedIcon.defaultProps = {
  color: '',
  size: '20',
};

export function ApproveQuoteIcon({ color, size }) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M11.2503 7.70834H1.66699C1.32533 7.70834 1.04199 7.42501 1.04199 7.08334C1.04199 6.74168 1.32533 6.45834 1.66699 6.45834H11.2503C11.592 6.45834 11.8753 6.74168 11.8753 7.08334C11.8753 7.42501 11.592 7.70834 11.2503 7.70834Z"
        fill={color}
      />
      <path
        d="M6.66667 14.375H5C4.65833 14.375 4.375 14.0917 4.375 13.75C4.375 13.4083 4.65833 13.125 5 13.125H6.66667C7.00833 13.125 7.29167 13.4083 7.29167 13.75C7.29167 14.0917 7.00833 14.375 6.66667 14.375Z"
        fill={color}
      />
      <path
        d="M12.0833 14.375H8.75C8.40833 14.375 8.125 14.0917 8.125 13.75C8.125 13.4083 8.40833 13.125 8.75 13.125H12.0833C12.425 13.125 12.7083 13.4083 12.7083 13.75C12.7083 14.0917 12.425 14.375 12.0833 14.375Z"
        fill={color}
      />
      <path
        d="M14.6337 17.7083H5.36699C2.05033 17.7083 1.04199 16.7083 1.04199 13.425V6.57499C1.04199 3.29166 2.05033 2.29166 5.36699 2.29166H11.2503C11.592 2.29166 11.8753 2.57499 11.8753 2.91666C11.8753 3.25832 11.592 3.54166 11.2503 3.54166H5.36699C2.75033 3.54166 2.29199 3.99166 2.29199 6.57499V13.4167C2.29199 16 2.75033 16.45 5.36699 16.45H14.6253C17.242 16.45 17.7003 16 17.7003 13.4167V9.18332C17.7003 8.84166 17.9837 8.55832 18.3253 8.55832C18.667 8.55832 18.9503 8.84166 18.9503 9.18332V13.4167C18.9587 16.7083 17.9503 17.7083 14.6337 17.7083Z"
        fill={color}
      />
      <path
        d="M14.9999 6.87455C14.8415 6.87455 14.6832 6.81622 14.5582 6.69122L13.3082 5.44122C13.0665 5.19955 13.0665 4.79955 13.3082 4.55789C13.5499 4.31622 13.9499 4.31622 14.1915 4.55789L14.9999 5.36622L17.8915 2.47455C18.1332 2.23289 18.5332 2.23289 18.7749 2.47455C19.0165 2.71622 19.0165 3.11622 18.7749 3.35789L15.4415 6.69122C15.3165 6.81622 15.1582 6.87455 14.9999 6.87455Z"
        fill={color}
      />
    </svg>
  );
}
ApproveQuoteIcon.propTypes = {
  color: PropTypes.string,
  size: PropTypes.string,
};
ApproveQuoteIcon.defaultProps = {
  color: '#616B80',
  size: '1.389vw',
};

export function DeclineBorderedIcon({ color, size }) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M11.6666 14.0909C11.5082 14.0909 11.3499 14.0326 11.2249 13.9076L7.9249 10.6076C7.68324 10.3659 7.68324 9.96589 7.9249 9.72422C8.16657 9.48255 8.56657 9.48255 8.80824 9.72422L12.1082 13.0242C12.3499 13.2659 12.3499 13.6659 12.1082 13.9076C11.9832 14.0242 11.8249 14.0909 11.6666 14.0909Z"
        fill={color}
      />
      <path
        d="M8.33337 14.1251C8.17503 14.1251 8.0167 14.0667 7.8917 13.9417C7.65003 13.7001 7.65003 13.3001 7.8917 13.0584L11.1917 9.7584C11.4334 9.51673 11.8334 9.51673 12.075 9.7584C12.3167 10.0001 12.3167 10.4001 12.075 10.6417L8.77503 13.9417C8.65003 14.0667 8.4917 14.1251 8.33337 14.1251Z"
        fill={color}
      />
      <path
        d="M11.6665 5.62533H8.33317C7.53317 5.62533 6.0415 5.62533 6.0415 3.33366C6.0415 1.04199 7.53317 1.04199 8.33317 1.04199H11.6665C12.4665 1.04199 13.9582 1.04199 13.9582 3.33366C13.9582 4.13366 13.9582 5.62533 11.6665 5.62533ZM8.33317 2.29199C7.50817 2.29199 7.2915 2.29199 7.2915 3.33366C7.2915 4.37533 7.50817 4.37533 8.33317 4.37533H11.6665C12.7082 4.37533 12.7082 4.15866 12.7082 3.33366C12.7082 2.29199 12.4915 2.29199 11.6665 2.29199H8.33317Z"
        fill={color}
      />
      <path
        d="M12.5 18.9587H7.5C2.81667 18.9587 1.875 16.8087 1.875 13.3337V8.33368C1.875 4.53368 3.25 2.90868 6.63333 2.73368C6.98333 2.71702 7.275 2.97535 7.29167 3.32535C7.30833 3.67535 7.04167 3.95868 6.7 3.97535C4.33333 4.10868 3.125 4.81702 3.125 8.33368V13.3337C3.125 16.417 3.73333 17.7087 7.5 17.7087H12.5C16.2667 17.7087 16.875 16.417 16.875 13.3337V8.33368C16.875 4.81702 15.6667 4.10868 13.3 3.97535C12.9583 3.95868 12.6917 3.65868 12.7083 3.31702C12.725 2.97535 13.025 2.70868 13.3667 2.72535C16.75 2.90868 18.125 4.53368 18.125 8.32535V13.3253C18.125 16.8087 17.1833 18.9587 12.5 18.9587Z"
        fill={color}
      />
    </svg>
  );
}
DeclineBorderedIcon.propTypes = {
  color: PropTypes.string,
  size: PropTypes.string,
};
DeclineBorderedIcon.defaultProps = {
  color: '#2179C4',
  size: '20',
};

export function CreateBookingIcon({ color, size }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
    >
      <path
        d="M11.9994 13.2999C11.8694 13.2999 11.7394 13.2699 11.6194 13.1999L2.78936 8.0899C2.42936 7.8799 2.30934 7.41987 2.51934 7.05987C2.72934 6.69987 3.17934 6.57985 3.54934 6.78985L11.9994 11.6799L20.3993 6.81988C20.7593 6.60988 21.2193 6.7399 21.4293 7.0899C21.6393 7.4499 21.5094 7.90987 21.1594 8.11987L12.3894 13.1999C12.2594 13.2599 12.1294 13.2999 11.9994 13.2999Z"
        fill={color !== '' ? color : '#616B80'}
      />
      <path
        d="M12 22.36C11.59 22.36 11.25 22.02 11.25 21.61V12.54C11.25 12.13 11.59 11.79 12 11.79C12.41 11.79 12.75 12.13 12.75 12.54V21.61C12.75 22.02 12.41 22.36 12 22.36Z"
        fill={color !== '' ? color : '#616B80'}
      />
      <path
        d="M11.9989 22.7502C11.1189 22.7502 10.2389 22.5602 9.5589 22.1702L4.2189 19.2103C2.7689 18.4103 1.62891 16.4802 1.62891 14.8202V9.16021C1.62891 7.50021 2.7689 5.58026 4.2189 4.77026L9.5589 1.81023C10.9189 1.05023 13.0589 1.05023 14.4289 1.81023L19.7689 4.77026C21.2189 5.57026 22.3589 7.50021 22.3589 9.16021V14.8202C22.3589 14.8902 22.3589 14.9902 22.3289 15.1202C22.2689 15.3802 22.0789 15.5902 21.8289 15.6702C21.5789 15.7502 21.2989 15.7003 21.0989 15.5203C19.9589 14.5203 18.1789 14.4802 16.9589 15.4502C16.1889 16.0602 15.7389 16.9902 15.7389 17.9802C15.7389 18.5702 15.8989 19.1503 16.2089 19.6503C16.2889 19.7903 16.3689 19.9002 16.4589 20.0002C16.6089 20.1702 16.6689 20.4002 16.6289 20.6202C16.5889 20.8402 16.4489 21.0403 16.2489 21.1403L14.4189 22.1503C13.7489 22.5603 12.8789 22.7502 11.9989 22.7502ZM11.9989 2.75024C11.3789 2.75024 10.7489 2.88024 10.2989 3.13024L4.95889 6.09026C3.98889 6.63026 3.1489 8.06021 3.1489 9.16021V14.8202C3.1489 15.9202 3.99889 17.3603 4.95889 17.8903L10.2989 20.8502C11.2089 21.3602 12.7989 21.3602 13.7089 20.8502L14.8289 20.2302C14.4589 19.5602 14.2589 18.7802 14.2589 17.9802C14.2589 16.5202 14.9089 15.1703 16.0389 14.2703C17.4089 13.1803 19.3489 12.9502 20.8689 13.6102V9.15026C20.8689 8.05026 20.0189 6.61025 19.0589 6.08025L13.7189 3.12023C13.2489 2.88023 12.6189 2.75024 11.9989 2.75024Z"
        fill={color !== '' ? color : '#616B80'}
      />
      <path
        d="M19 22.75C16.38 22.75 14.25 20.62 14.25 18C14.25 16.54 14.9 15.19 16.03 14.29C16.87 13.62 17.93 13.25 19 13.25C21.62 13.25 23.75 15.38 23.75 18C23.75 19.36 23.16 20.66 22.13 21.56C21.26 22.33 20.15 22.75 19 22.75ZM19 14.75C18.26 14.75 17.56 15 16.97 15.47C16.2 16.08 15.75 17.01 15.75 18C15.75 19.79 17.21 21.25 19 21.25C19.78 21.25 20.54 20.96 21.15 20.44C21.85 19.82 22.25 18.94 22.25 18C22.25 16.21 20.79 14.75 19 14.75Z"
        fill={color !== '' ? color : '#616B80'}
      />
      <path
        d="M17.9999 19.75C17.7499 19.75 17.4999 19.62 17.3599 19.39C17.1499 19.03 17.2599 18.57 17.6199 18.36L18.5099 17.83V16.75C18.5099 16.34 18.8499 16 19.2599 16C19.6699 16 20.0099 16.34 20.0099 16.75V18.25C20.0099 18.51 19.8699 18.76 19.6499 18.89L18.3999 19.64C18.2599 19.72 18.1299 19.75 17.9999 19.75Z"
        fill={color !== '' ? color : '#616B80'}
      />
    </svg>
  );
}
CreateBookingIcon.propTypes = {
  color: PropTypes.string,
  size: PropTypes.string,
};
CreateBookingIcon.defaultProps = {
  color: '',
  size: '24',
};
export function DownloadDocNotificationIcon({ color, size }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
    >
      <path
        d="M12 9.75C11.9 9.75 11.81 9.73 11.71 9.69C11.43 9.58 11.25 9.3 11.25 9V2C11.25 1.59 11.59 1.25 12 1.25C12.41 1.25 12.75 1.59 12.75 2V7.19L13.47 6.47C13.76 6.18 14.24 6.18 14.53 6.47C14.82 6.76 14.82 7.24 14.53 7.53L12.53 9.53C12.39 9.67 12.2 9.75 12 9.75Z"
        fill={color !== '' ? color : '#616B80'}
      />
      <path
        d="M12.0004 9.74994C11.8104 9.74994 11.6204 9.67994 11.4704 9.52994L9.47043 7.52994C9.18043 7.23994 9.18043 6.75994 9.47043 6.46994C9.76043 6.17994 10.2404 6.17994 10.5304 6.46994L12.5304 8.46994C12.8204 8.75994 12.8204 9.23994 12.5304 9.52994C12.3804 9.67994 12.1904 9.74994 12.0004 9.74994Z"
        fill={color !== '' ? color : '#616B80'}
      />
      <path
        d="M13.7605 17.75H10.2305C9.18047 17.75 8.24047 17.17 7.77047 16.23L6.60047 13.89C6.56047 13.8 6.47047 13.75 6.38047 13.75H1.98047C1.57047 13.75 1.23047 13.41 1.23047 13C1.23047 12.59 1.57047 12.25 1.98047 12.25H6.39047C7.06047 12.25 7.66047 12.62 7.96047 13.22L9.13047 15.56C9.34047 15.99 9.77047 16.25 10.2505 16.25H13.7805C14.2605 16.25 14.6905 15.99 14.9005 15.56L16.0705 13.22C16.3705 12.62 16.9705 12.25 17.6405 12.25H22.0005C22.4105 12.25 22.7505 12.59 22.7505 13C22.7505 13.41 22.4105 13.75 22.0005 13.75H17.6405C17.5405 13.75 17.4605 13.8 17.4205 13.89L16.2505 16.23C15.7505 17.17 14.8105 17.75 13.7605 17.75Z"
        fill={color !== '' ? color : '#616B80'}
      />
      <path
        d="M15 22.7499H9C3.57 22.7499 1.25 20.4299 1.25 14.9999V10.9999C1.25 6.30993 2.99 3.95993 6.89 3.38993C7.31 3.32993 7.68 3.60993 7.74 4.01993C7.8 4.42993 7.52 4.80993 7.11 4.86993C3.97 5.32993 2.75 7.04993 2.75 10.9999V14.9999C2.75 19.6099 4.39 21.2499 9 21.2499H15C19.61 21.2499 21.25 19.6099 21.25 14.9999V10.9999C21.25 7.04993 20.03 5.32993 16.89 4.86993C16.48 4.80993 16.2 4.42993 16.26 4.01993C16.32 3.60993 16.7 3.32993 17.11 3.38993C21.01 3.95993 22.75 6.30993 22.75 10.9999V14.9999C22.75 20.4299 20.43 22.7499 15 22.7499Z"
        fill={color !== '' ? color : '#616B80'}
      />
    </svg>
  );
}
DownloadDocNotificationIcon.propTypes = {
  color: PropTypes.string,
  size: PropTypes.string,
};
DownloadDocNotificationIcon.defaultProps = {
  color: '',
  size: '24',
};

export function CreateShipmentIcon({ color, size }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
    >
      <path
        d="M13 14.7505H2C1.59 14.7505 1.25 14.4105 1.25 14.0005V7.62048C1.25 7.30048 1.44999 7.02046 1.73999 6.91046C2.03999 6.80046 2.37001 6.89049 2.57001 7.13049C3.18001 7.86049 4.13001 8.27048 5.07001 8.24048C5.87001 8.22048 6.60998 7.9205 7.16998 7.3905C7.42998 7.1705 7.63999 6.91048 7.79999 6.62048C8.10999 6.09048 8.26 5.51047 8.25 4.92047C8.23 4.00047 7.83002 3.16048 7.15002 2.55048C6.91002 2.34048 6.83 2.01046 6.94 1.72046C7.05 1.43046 7.33001 1.23047 7.64001 1.23047H15C15.41 1.23047 15.75 1.57047 15.75 1.98047V11.9805C15.75 13.5205 14.52 14.7505 13 14.7505ZM2.75 13.2505H13C13.69 13.2505 14.25 12.6905 14.25 12.0005V2.75049H9.19C9.54 3.40049 9.73 4.1305 9.75 4.8905C9.77 5.7605 9.54998 6.62048 9.10999 7.37048C8.86999 7.80048 8.53999 8.2105 8.17999 8.5105C7.37999 9.2705 6.27999 9.72049 5.10999 9.75049C4.27999 9.78049 3.46001 9.57049 2.76001 9.19049V13.2505H2.75Z"
        fill="#616B80"
      />
      <path
        d="M19 20.75H18C17.59 20.75 17.25 20.41 17.25 20C17.25 19.31 16.69 18.75 16 18.75C15.31 18.75 14.75 19.31 14.75 20C14.75 20.41 14.41 20.75 14 20.75H10C9.59 20.75 9.25 20.41 9.25 20C9.25 19.31 8.69 18.75 8 18.75C7.31 18.75 6.75 19.31 6.75 20C6.75 20.41 6.41 20.75 6 20.75H5C2.93 20.75 1.25 19.07 1.25 17V14C1.25 13.59 1.59 13.25 2 13.25H13C13.69 13.25 14.25 12.69 14.25 12V5C14.25 4.59 14.59 4.25 15 4.25H16.84C17.83 4.25 18.74 4.78001 19.23 5.64001L20.94 8.63C21.07 8.86 21.07 9.15 20.94 9.38C20.81 9.61 20.56 9.75 20.29 9.75H19C18.86 9.75 18.75 9.86 18.75 10V13C18.75 13.14 18.86 13.25 19 13.25H22C22.41 13.25 22.75 13.59 22.75 14V17C22.75 19.07 21.07 20.75 19 20.75ZM18.65 19.25H19C20.24 19.25 21.25 18.24 21.25 17V14.75H19C18.04 14.75 17.25 13.96 17.25 13V10C17.25 9.04 18.03 8.25 19 8.25L17.93 6.38C17.71 5.99 17.29 5.75 16.84 5.75H15.75V12C15.75 13.52 14.52 14.75 13 14.75H2.75V17C2.75 18.24 3.76 19.25 5 19.25H5.34998C5.67998 18.1 6.74 17.25 8 17.25C9.26 17.25 10.32 18.1 10.65 19.25H13.36C13.69 18.1 14.75 17.25 16.01 17.25C17.27 17.25 18.32 18.1 18.65 19.25Z"
        fill={color !== '' ? color : '#616B80'}
      />
      <path
        d="M8 22.75C6.48 22.75 5.25 21.52 5.25 20C5.25 18.48 6.48 17.25 8 17.25C9.52 17.25 10.75 18.48 10.75 20C10.75 21.52 9.52 22.75 8 22.75ZM8 18.75C7.31 18.75 6.75 19.31 6.75 20C6.75 20.69 7.31 21.25 8 21.25C8.69 21.25 9.25 20.69 9.25 20C9.25 19.31 8.69 18.75 8 18.75Z"
        fill={color !== '' ? color : '#616B80'}
      />
      <path
        d="M16 22.75C14.48 22.75 13.25 21.52 13.25 20C13.25 18.48 14.48 17.25 16 17.25C17.52 17.25 18.75 18.48 18.75 20C18.75 21.52 17.52 22.75 16 22.75ZM16 18.75C15.31 18.75 14.75 19.31 14.75 20C14.75 20.69 15.31 21.25 16 21.25C16.69 21.25 17.25 20.69 17.25 20C17.25 19.31 16.69 18.75 16 18.75Z"
        fill={color !== '' ? color : '#616B80'}
      />
      <path
        d="M22 14.75H19C18.04 14.75 17.25 13.96 17.25 13V10C17.25 9.04 18.04 8.25 19 8.25H20.29C20.56 8.25 20.81 8.39 20.94 8.63L22.65 11.63C22.71 11.74 22.75 11.87 22.75 12V14C22.75 14.41 22.41 14.75 22 14.75ZM19 9.75C18.86 9.75 18.75 9.86 18.75 10V13C18.75 13.14 18.86 13.25 19 13.25H21.25V12.2L19.85 9.75H19Z"
        fill={color !== '' ? color : '#616B80'}
      />
      <path
        d="M5 9.75C2.38 9.75 0.25 7.62 0.25 5C0.25 3.54 0.900029 2.18998 2.03003 1.28998C2.87003 0.619978 3.93 0.25 5 0.25C7.62 0.25 9.75 2.38 9.75 5C9.75 6.36 9.16 7.66 8.13 8.56C7.26 9.33 6.15 9.75 5 9.75ZM5 1.75C4.26 1.75 3.55997 1.99997 2.96997 2.46997C2.19997 3.07997 1.75 4.01 1.75 5C1.75 6.79 3.21 8.25 5 8.25C5.78 8.25 6.54002 7.96 7.15002 7.44C7.85002 6.82 8.25 5.94 8.25 5C8.25 3.21 6.79 1.75 5 1.75Z"
        fill={color !== '' ? color : '#616B80'}
      />
      <path
        d="M3.99989 6.75C3.74989 6.75 3.49988 6.62001 3.35988 6.39001C3.14988 6.03001 3.25989 5.56999 3.61989 5.35999L4.5099 4.83002V3.75C4.5099 3.34 4.8499 3 5.2599 3C5.6699 3 6.0099 3.34 6.0099 3.75V5.25C6.0099 5.51 5.86992 5.76001 5.64992 5.89001L4.39992 6.64001C4.25992 6.72001 4.12989 6.75 3.99989 6.75Z"
        fill={color !== '' ? color : '#616B80'}
      />
    </svg>
  );
}
CreateShipmentIcon.propTypes = {
  color: PropTypes.string,
  size: PropTypes.string,
};
CreateShipmentIcon.defaultProps = {
  color: '',
  size: '24',
};

export function ProposeChangeIcon({ color, size }) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 16 15"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M3.09725 1.82476C4.45817 0.645503 6.19924 -0.0025049 8 7.27699e-06C12.1423 7.27699e-06 15.5 3.35776 15.5 7.50001C15.5 9.10201 14.9975 10.587 14.1425 11.805L11.75 7.50001H14C14.0001 6.32373 13.6544 5.17336 13.006 4.19195C12.3576 3.21054 11.4349 2.44138 10.3529 1.9801C9.27082 1.51882 8.07704 1.38578 6.91997 1.59752C5.7629 1.80926 4.69359 2.35643 3.845 3.17101L3.09725 1.82476ZM12.9028 13.1753C11.5418 14.3545 9.80076 15.0025 8 15C3.85775 15 0.5 11.6423 0.5 7.50001C0.5 5.89801 1.0025 4.41301 1.8575 3.19501L4.25 7.50001H2C1.9999 8.67629 2.34556 9.82665 2.994 10.8081C3.64244 11.7895 4.56505 12.5586 5.64712 13.0199C6.72918 13.4812 7.92296 13.6142 9.08003 13.4025C10.2371 13.1908 11.3064 12.6436 12.155 11.829L12.9028 13.1753Z"
        fill={color !== '' ? color : 'white'}
      />
    </svg>
  );
}
ProposeChangeIcon.propTypes = {
  color: PropTypes.string,
  size: PropTypes.string,
};
ProposeChangeIcon.defaultProps = {
  color: '',
  size: '1.111vw',
};
export function CopyIcon() {
  return (
    <svg
      width="12"
      height="12"
      viewBox="0 0 12 12"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M3.08333 2.49984V0.749837C3.08333 0.595128 3.14479 0.446754 3.25419 0.337358C3.36358 0.227962 3.51196 0.166504 3.66667 0.166504H10.6667C10.8214 0.166504 10.9697 0.227962 11.0791 0.337358C11.1885 0.446754 11.25 0.595128 11.25 0.749837V8.9165C11.25 9.07121 11.1885 9.21959 11.0791 9.32898C10.9697 9.43838 10.8214 9.49984 10.6667 9.49984H8.91667V11.2498C8.91667 11.5718 8.65417 11.8332 8.32925 11.8332H1.33742C1.26049 11.8336 1.18423 11.8189 1.11302 11.7898C1.04181 11.7607 0.977053 11.7178 0.922467 11.6636C0.867882 11.6094 0.824546 11.5449 0.794948 11.4739C0.765351 11.4029 0.750075 11.3268 0.75 11.2498L0.75175 3.08317C0.75175 2.76117 1.01425 2.49984 1.33917 2.49984H3.08333ZM1.91842 3.6665L1.91667 10.6665H7.75V3.6665H1.91842ZM4.25 2.49984H8.91667V8.33317H10.0833V1.33317H4.25V2.49984Z"
        fill="#0288FA"
      />
    </svg>
  );
}
export function TokenCopyIcon({ color }) {
  return (
    <svg
      width="1.111vw"
      height="1.111vw"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M7.39967 15.1668H4.59967C1.99301 15.1668 0.833008 14.0068 0.833008 11.4002V8.60016C0.833008 5.9935 1.99301 4.8335 4.59967 4.8335H7.39967C10.0063 4.8335 11.1663 5.9935 11.1663 8.60016V11.4002C11.1663 14.0068 10.0063 15.1668 7.39967 15.1668ZM4.59967 5.8335C2.53301 5.8335 1.83301 6.5335 1.83301 8.60016V11.4002C1.83301 13.4668 2.53301 14.1668 4.59967 14.1668H7.39967C9.46634 14.1668 10.1663 13.4668 10.1663 11.4002V8.60016C10.1663 6.5335 9.46634 5.8335 7.39967 5.8335H4.59967Z"
        fill={color}
      />
      <path
        d="M11.3997 11.1668H10.6663C10.393 11.1668 10.1663 10.9402 10.1663 10.6668V8.60016C10.1663 6.5335 9.46634 5.8335 7.39967 5.8335H5.33301C5.05967 5.8335 4.83301 5.60683 4.83301 5.3335V4.60016C4.83301 1.9935 5.99301 0.833496 8.59967 0.833496H11.3997C14.0063 0.833496 15.1663 1.9935 15.1663 4.60016V7.40016C15.1663 10.0068 14.0063 11.1668 11.3997 11.1668ZM11.1663 10.1668H11.3997C13.4663 10.1668 14.1663 9.46683 14.1663 7.40016V4.60016C14.1663 2.5335 13.4663 1.8335 11.3997 1.8335H8.59967C6.53301 1.8335 5.83301 2.5335 5.83301 4.60016V4.8335H7.39967C10.0063 4.8335 11.1663 5.9935 11.1663 8.60016V10.1668Z"
        fill={color}
      />
    </svg>
  );
}
TokenCopyIcon.propTypes = {
  color: PropTypes.string,
};
TokenCopyIcon.defaultProps = {
  color: '#0088FA',
};

export function PrevIcon() {
  return (
    <svg
      width="0.972vw"
      height="13"
      viewBox="0 0 14 13"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M3.52341 7.33311L7.99342 11.8031L6.81508 12.9814L0.333416 6.49978L6.81508 0.0181122L7.99342 1.19645L3.52341 5.66645L13.6667 5.66645L13.6667 7.33311L3.52341 7.33311Z"
        fill="#0288FA"
      />
    </svg>
  );
}
export function NextIcon() {
  return (
    <svg
      width="0.972vw"
      height="0.903vw"
      viewBox="0 0 14 13"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M10.4766 5.66689L6.00658 1.19689L7.18492 0.0185547L13.6666 6.50022L7.18492 12.9819L6.00658 11.8036L10.4766 7.33355H0.333252V5.66689H10.4766Z"
        fill="white"
      />
    </svg>
  );
}
export function ArrowDownBlueIcon({ color }) {
  return (
    <svg
      width="0.694vw"
      height="0.417vw"
      viewBox="0 0 10 6"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M5.00345 3.87851L8.71594 0.166016L9.77644 1.22651L5.00345 5.99951L0.230469 1.22651L1.29097 0.166016L5.00345 3.87851Z"
        fill={color}
      />
    </svg>
  );
}
ArrowDownBlueIcon.propTypes = {
  color: PropTypes.string,
  // size: PropTypes.number,
};
ArrowDownBlueIcon.defaultProps = {
  color: '#0288FA',
  // size: 10,
};
export function EditIcon({ color, size }) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 10 10"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M6.864 3.84304L6.157 3.13604L1.5 7.79304V8.50004H2.207L6.864 3.84304ZM7.571 3.13604L8.278 2.42904L7.571 1.72204L6.864 2.42904L7.571 3.13604ZM2.621 9.50004H0.5V7.37854L7.2175 0.661042C7.31126 0.567306 7.43842 0.514648 7.571 0.514648C7.70358 0.514648 7.83074 0.567306 7.9245 0.661042L9.339 2.07554C9.43274 2.16931 9.48539 2.29646 9.48539 2.42904C9.48539 2.56162 9.43274 2.68878 9.339 2.78254L2.6215 9.50004H2.621Z"
        fill={color}
      />
    </svg>
  );
}
EditIcon.propTypes = {
  color: PropTypes.string,
  size: PropTypes.string,
};
EditIcon.defaultProps = {
  color: '#0288FA',
  size: '0.694vw',
};
export function EditFillIcon({ color }) {
  return (
    <svg
      width="0.556vw"
      height="0.556vw"
      viewBox="0 0 8 8"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M4.40715 1.70445L6.29555 3.59329L1.8884 8H0V6.11116L4.40715 1.704V1.70445ZM5.03662 1.07498L5.98082 0.130339C6.0643 0.046883 6.17751 0 6.29555 0C6.41359 0 6.5268 0.046883 6.61028 0.130339L7.86966 1.38972C7.95312 1.4732 8 1.58641 8 1.70445C8 1.82249 7.95312 1.9357 7.86966 2.01918L6.92502 2.96338L5.03662 1.07498Z"
        fill={color !== '' ? color : '#3B86F2'}
      />
    </svg>
  );
}
EditFillIcon.propTypes = {
  color: PropTypes.string,
};
EditFillIcon.defaultProps = {
  color: '',
};
export function ChevronDownIcon() {
  return (
    <svg
      width="22"
      height="22"
      viewBox="0 0 22 22"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M5.5 8.25L11 13.75L16.5 8.25"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}
export function TrashIcon({ color }) {
  return (
    <svg
      width="0.972vw"
      height="0.972vw"
      viewBox="0 0 14 14"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M4.08332 3.49996V1.74996C4.08332 1.59525 4.14478 1.44688 4.25418 1.33748C4.36357 1.22808 4.51195 1.16663 4.66666 1.16663H9.33332C9.48803 1.16663 9.63641 1.22808 9.7458 1.33748C9.8552 1.44688 9.91666 1.59525 9.91666 1.74996V3.49996H12.8333V4.66663H11.6667V12.25C11.6667 12.4047 11.6052 12.553 11.4958 12.6624C11.3864 12.7718 11.238 12.8333 11.0833 12.8333H2.91666C2.76195 12.8333 2.61357 12.7718 2.50418 12.6624C2.39478 12.553 2.33332 12.4047 2.33332 12.25V4.66663H1.16666V3.49996H4.08332ZM5.24999 2.33329V3.49996H8.74999V2.33329H5.24999Z"
        fill={color !== '' ? color : '#FA4C02'}
      />
    </svg>
  );
}
TrashIcon.propTypes = {
  color: PropTypes.string,
};
TrashIcon.defaultProps = {
  color: '',
};
export function SuccessIcon() {
  return (
    <svg
      width="30"
      height="30"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M10 20C4.477 20 0 15.523 0 10C0 4.477 4.477 0 10 0C15.523 0 20 4.477 20 10C20 15.523 15.523 20 10 20ZM10 18C12.1217 18 14.1566 17.1571 15.6569 15.6569C17.1571 14.1566 18 12.1217 18 10C18 7.87827 17.1571 5.84344 15.6569 4.34315C14.1566 2.84285 12.1217 2 10 2C7.87827 2 5.84344 2.84285 4.34315 4.34315C2.84285 5.84344 2 7.87827 2 10C2 12.1217 2.84285 14.1566 4.34315 15.6569C5.84344 17.1571 7.87827 18 10 18ZM9.003 14L4.76 9.757L6.174 8.343L9.003 11.172L14.659 5.515L16.074 6.929L9.003 14Z"
        fill="#22b678"
      />
    </svg>
  );
}
export function WarningIcon() {
  return (
    <svg
      width="44"
      height="44"
      viewBox="0 0 44 44"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M32.0833 4.58333L42.1667 22L32.0833 39.4167H11.9167L1.83334 22L11.9167 4.58333H32.0833ZM29.9695 8.25H14.0305L6.07017 22L14.0305 35.75H29.9695L37.9298 22L29.9695 8.25ZM20.1667 27.5H23.8333V31.1667H20.1667V27.5ZM20.1667 12.8333H23.8333V23.8333H20.1667V12.8333Z"
        fill="#FFA940"
      />
    </svg>
  );
}
export function ErrorIcon() {
  return (
    <svg
      width="30"
      height="30"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M10 20C4.477 20 0 15.523 0 10C0 4.477 4.477 0 10 0C15.523 0 20 4.477 20 10C20 15.523 15.523 20 10 20ZM10 18C12.1217 18 14.1566 17.1571 15.6569 15.6569C17.1571 14.1566 18 12.1217 18 10C18 7.87827 17.1571 5.84344 15.6569 4.34315C14.1566 2.84285 12.1217 2 10 2C7.87827 2 5.84344 2.84285 4.34315 4.34315C2.84285 5.84344 2 7.87827 2 10C2 12.1217 2.84285 14.1566 4.34315 15.6569C5.84344 17.1571 7.87827 18 10 18ZM10 8.586L12.828 5.757L14.243 7.172L11.414 10L14.243 12.828L12.828 14.243L10 11.414L7.172 14.243L5.757 12.828L8.586 10L5.757 7.172L7.172 5.757L10 8.586Z"
        fill="#fa4c02"
      />
    </svg>
  );
}
export function CloseIcon({ color, size }) {
  return (
    <svg
      width={size !== '' ? size : '2.083vw'}
      height={size !== '' ? size : '2.083vw'}
      viewBox="0 0 35 35"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M17.5 15.4379L24.7188 8.21917L26.7808 10.2813L19.5621 17.5L26.7808 24.7188L24.7188 26.7808L17.5 19.5621L10.2813 26.7808L8.21918 24.7188L15.4379 17.5L8.21918 10.2813L10.2813 8.21917L17.5 15.4379Z"
        fill={color !== '' ? color : '#828282'}
      />
    </svg>
  );
}
CloseIcon.propTypes = {
  color: PropTypes.string,
  size: PropTypes.string,
};
CloseIcon.defaultProps = {
  color: '',
  size: '',
};
export function BackIcon({ color }) {
  return (
    <svg
      width="0.972vw"
      height="0.972vw"
      viewBox="0 0 14 14"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M3.52341 7.83333L7.99342 12.3033L6.81508 13.4817L0.333416 6.99999L6.81508 0.518326L7.99342 1.69666L3.52341 6.16666L13.6667 6.16666L13.6667 7.83333L3.52341 7.83333Z"
        fill={color !== '' ? color : '#676767'}
      />
    </svg>
  );
}
BackIcon.propTypes = {
  color: PropTypes.string,
};
BackIcon.defaultProps = {
  color: '',
};
export function AddIcon({ marginRight }) {
  return (
    <svg
      width="0.694vw"
      height="0.694vw"
      viewBox="0 0 9 10"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      style={{ marginRight }}
    >
      <path
        d="M3.87524 4.37842V0.628418H5.12525V4.37842H8.87525V5.62842H5.12525V9.37842H3.87524V5.62842H0.125244V4.37842H3.87524Z"
        fill="white"
      />
    </svg>
  );
}
AddIcon.propTypes = {
  marginRight: PropTypes.string,
};
AddIcon.defaultProps = {
  marginRight: '',
};
export function MoreIcon({ color }) {
  return (
    <svg
      width="4"
      height="13"
      viewBox="0 0 4 13"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M2.16497 0.0412598C1.41651 0.0412598 0.804138 0.653635 0.804138 1.40209C0.804138 2.15055 1.41651 2.76293 2.16497 2.76293C2.91343 2.76293 3.5258 2.15055 3.5258 1.40209C3.5258 0.653635 2.91343 0.0412598 2.16497 0.0412598ZM2.16497 9.56709C1.41651 9.56709 0.804138 10.1795 0.804138 10.9279C0.804138 11.6764 1.41651 12.2888 2.16497 12.2888C2.91343 12.2888 3.5258 11.6764 3.5258 10.9279C3.5258 10.1795 2.91343 9.56709 2.16497 9.56709ZM2.16497 4.80418C1.41651 4.80418 0.804138 5.41655 0.804138 6.16501C0.804138 6.91347 1.41651 7.52584 2.16497 7.52584C2.91343 7.52584 3.5258 6.91347 3.5258 6.16501C3.5258 5.41655 2.91343 4.80418 2.16497 4.80418Z"
        fill={color !== '' ? color : '#797979'}
      />
    </svg>
  );
}
MoreIcon.propTypes = {
  color: PropTypes.string,
};
MoreIcon.defaultProps = {
  color: '',
};
export function MoreHorIcon({ color, height, width }) {
  return (
    <svg
      width={width !== '' ? width : '1O'}
      height={height !== '' ? height : '4'}
      viewBox="0 0 18 4"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M1.5 0.5C0.675 0.5 0 1.175 0 2C0 2.825 0.675 3.5 1.5 3.5C2.325 3.5 3 2.825 3 2C3 1.175 2.325 0.5 1.5 0.5ZM16.5 0.5C15.675 0.5 15 1.175 15 2C15 2.825 15.675 3.5 16.5 3.5C17.325 3.5 18 2.825 18 2C18 1.175 17.325 0.5 16.5 0.5ZM9 0.5C8.175 0.5 7.5 1.175 7.5 2C7.5 2.825 8.175 3.5 9 3.5C9.825 3.5 10.5 2.825 10.5 2C10.5 1.175 9.825 0.5 9 0.5Z"
        fill={color !== '' ? color : '#03053D'}
      />
    </svg>
  );
}
MoreHorIcon.propTypes = {
  color: PropTypes.string,
  height: PropTypes.string,
  width: PropTypes.string,
};
MoreHorIcon.defaultProps = {
  color: '',
  height: '',
  width: '',
};
export function MoreHorNewIcon({ color, size }) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M4.16667 12.2913C2.9 12.2913 1.875 11.2663 1.875 9.99967C1.875 8.73301 2.9 7.70801 4.16667 7.70801C5.43333 7.70801 6.45833 8.73301 6.45833 9.99967C6.45833 11.2663 5.43333 12.2913 4.16667 12.2913ZM4.16667 8.95801C3.59167 8.95801 3.125 9.42467 3.125 9.99967C3.125 10.5747 3.59167 11.0413 4.16667 11.0413C4.74167 11.0413 5.20833 10.5747 5.20833 9.99967C5.20833 9.42467 4.74167 8.95801 4.16667 8.95801Z"
        fill={color}
      />
      <path
        d="M15.8333 12.2913C14.5667 12.2913 13.5417 11.2663 13.5417 9.99967C13.5417 8.73301 14.5667 7.70801 15.8333 7.70801C17.1 7.70801 18.125 8.73301 18.125 9.99967C18.125 11.2663 17.1 12.2913 15.8333 12.2913ZM15.8333 8.95801C15.2583 8.95801 14.7917 9.42467 14.7917 9.99967C14.7917 10.5747 15.2583 11.0413 15.8333 11.0413C16.4083 11.0413 16.875 10.5747 16.875 9.99967C16.875 9.42467 16.4083 8.95801 15.8333 8.95801Z"
        fill={color}
      />
      <path
        d="M10 12.2913C8.73334 12.2913 7.70834 11.2663 7.70834 9.99967C7.70834 8.73301 8.73334 7.70801 10 7.70801C11.2667 7.70801 12.2917 8.73301 12.2917 9.99967C12.2917 11.2663 11.2667 12.2913 10 12.2913ZM10 8.95801C9.425 8.95801 8.95834 9.42467 8.95834 9.99967C8.95834 10.5747 9.425 11.0413 10 11.0413C10.575 11.0413 11.0417 10.5747 11.0417 9.99967C11.0417 9.42467 10.575 8.95801 10 8.95801Z"
        fill={color}
      />
    </svg>
  );
}
MoreHorNewIcon.propTypes = {
  color: PropTypes.string,
  size: PropTypes.string,
};
MoreHorNewIcon.defaultProps = {
  color: '#C9C9C9',
  size: '1.389vw',
};
export function ActiveFillIcon({ color }) {
  return (
    <svg
      width="0.833vw"
      height="0.833vw"
      viewBox="0 0 12 12"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M6.00002 11.8333C2.77827 11.8333 0.166687 9.22171 0.166687 5.99996C0.166687 2.77821 2.77827 0.166626 6.00002 0.166626C9.22177 0.166626 11.8334 2.77821 11.8334 5.99996C11.8334 9.22171 9.22177 11.8333 6.00002 11.8333ZM5.41844 8.33329L9.5426 4.20854L8.71777 3.38371L5.41844 6.68363L3.76819 5.03338L2.94335 5.85821L5.41844 8.33329Z"
        fill={color !== '' ? color : '#606060'}
      />
    </svg>
  );
}
ActiveFillIcon.propTypes = {
  color: PropTypes.string,
};
ActiveFillIcon.defaultProps = {
  color: '',
};
export function InactiveFillIcon({ color }) {
  return (
    <svg
      width="12"
      height="12"
      viewBox="0 0 12 12"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M6.00002 11.8334C2.77827 11.8334 0.166687 9.22183 0.166687 6.00008C0.166687 2.77833 2.77827 0.166748 6.00002 0.166748C9.22177 0.166748 11.8334 2.77833 11.8334 6.00008C11.8334 9.22183 9.22177 11.8334 6.00002 11.8334ZM6.00002 5.17525L4.35035 3.525L3.52494 4.35041L5.17519 6.00008L3.52494 7.64975L4.35035 8.47516L6.00002 6.82491L7.64969 8.47516L8.4751 7.64975L6.82485 6.00008L8.4751 4.35041L7.64969 3.525L6.00002 5.17525Z"
        fill={color !== '' ? color : '#606060'}
      />
    </svg>
  );
}
InactiveFillIcon.propTypes = {
  color: PropTypes.string,
};
InactiveFillIcon.defaultProps = {
  color: '',
};
export function OceanModeIcon({ size, color }) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 40 40"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M25.3593 7.62496C25.25 7.72652 25.2343 8.03902 25.2343 9.81246V11.875H24.1562C23.3437 11.875 23.039 11.9062 22.9218 11.9843C22.7812 12.0937 22.7734 12.2422 22.75 16.3203L22.7265 20.5468H19.6093H16.4844V18.6406C16.4844 16.2968 16.6094 16.4843 15.0625 16.4843H13.9844V14.625C13.9844 12.914 13.9687 12.75 13.8437 12.6328C13.7109 12.5156 13.4062 12.5 11.039 12.5C8.56249 12.5 8.37499 12.5078 8.2578 12.6406C8.14061 12.7656 8.12499 13.0234 8.12499 14.6328V16.4843H7.04687C5.49999 16.4843 5.62499 16.2968 5.62499 18.6406V20.5468H4.70312C3.35937 20.5468 3.30468 20.6015 3.58593 21.8203C3.96875 23.4531 4.71093 25.3047 5.42187 26.4062C5.62499 26.7187 5.76562 26.9922 5.74218 27.0156C5.66406 27.1015 4.52343 26.8281 3.86718 26.5703C3.52343 26.4375 3 26.1719 2.69531 25.9765C2.39844 25.7812 2.11719 25.625 2.0625 25.625C1.92969 25.625 1.71875 25.8906 1.71875 26.0703C1.71875 26.5469 3.57031 27.4844 5.07812 27.7656C5.89062 27.9219 7.21874 27.9219 8.02343 27.7734C9.03905 27.5781 10.1797 27.1406 10.789 26.7109C10.9844 26.5703 10.9922 26.5781 11.8828 27.0234C13.0625 27.6094 13.875 27.8203 15.1953 27.8672C16.8281 27.9297 18.289 27.5859 19.4843 26.8672L20 26.5547L20.4531 26.8281C20.9922 27.164 21.9062 27.5312 22.625 27.7109C23.0234 27.8125 23.5078 27.8437 24.4531 27.8515C26.0781 27.8515 26.789 27.6953 28.1093 27.0234L29.0078 26.5703L29.2109 26.7109C29.8671 27.1719 31.1484 27.6484 32.2109 27.8125C33.0312 27.9453 34.6171 27.875 35.4062 27.664C36.2265 27.4531 37.0624 27.0937 37.6562 26.6953C38.2343 26.3125 38.3203 26.1953 38.2499 25.914C38.164 25.5625 37.8984 25.5703 37.3749 25.9219C36.7812 26.3203 36.4999 26.4609 35.8359 26.6875L35.2968 26.875L35.3437 26.6953C35.5624 25.8203 37.3437 17.1484 37.3437 16.9687C37.3437 16.8047 37.289 16.6953 37.1953 16.6406C37.1015 16.5937 36.1718 16.5625 34.7343 16.5625H32.4218V14.2968C32.4218 12.1406 32.414 12.0312 32.2734 11.9531C32.1796 11.9062 31.3359 11.875 30.0859 11.875H28.0468V10.9531C28.0468 9.94528 27.9609 9.68746 27.6171 9.68746C27.2734 9.68746 27.1875 9.94528 27.1875 10.9531V11.875H26.6015H26.0156V9.78121C26.0156 8.25777 25.9921 7.66402 25.9218 7.59371C25.789 7.4609 25.5 7.47652 25.3593 7.62496ZM31.6406 14.6093C31.6406 16.25 31.625 16.5625 31.5312 16.5625C31.3125 16.5625 31.1875 16.7968 30.3906 18.664L29.5859 20.5468H26.5859H23.5937V16.6015V12.6562H27.6171H31.6406V14.6093ZM13.1875 14.8984L13.2031 16.4843H11.0547H8.90624V14.9375C8.90624 14.0859 8.92968 13.3593 8.96093 13.3359C8.99218 13.3047 9.9453 13.289 11.0859 13.2968L13.164 13.3203L13.1875 14.8984ZM10.625 18.9453V20.5468H8.51561H6.40624V18.9453V17.3437H8.51561H10.625V18.9453ZM15.7031 18.9453V20.5468H13.5937H11.4844V18.9453V17.3437H13.5937H15.7031V18.9453ZM36.4843 17.3593C36.4765 17.539 34.4531 26.9765 34.414 27.0156C34.3828 27.0469 33.8984 27.0703 33.3359 27.0625C32.5312 27.0625 32.164 27.0234 31.6484 26.8828C30.8593 26.6797 29.9687 26.2812 29.4453 25.8984C29.2343 25.75 29.0234 25.625 28.9687 25.625C28.9218 25.625 28.664 25.7656 28.4062 25.9297C26.0781 27.4453 23.0234 27.4844 20.7265 26.039C20.3593 25.8125 20.0234 25.625 19.9843 25.625C19.9375 25.625 19.6718 25.7812 19.3828 25.9765C18.789 26.3672 17.9297 26.7344 17.1406 26.9297C16.3047 27.1328 14.6015 27.1094 13.7578 26.8828C12.9687 26.6719 12.2422 26.3515 11.5937 25.9375C11.3359 25.7656 11.0781 25.625 11.0312 25.625C10.9765 25.625 10.7656 25.75 10.5547 25.8984C9.74999 26.4844 8.3203 26.9844 7.31249 27.0469C6.92968 27.0703 6.92187 27.0703 6.56249 26.625C5.80468 25.6875 5.09374 24.164 4.57812 22.3828L4.3125 21.4453L17.1562 21.4062C28.4375 21.375 30.0078 21.3515 30.1015 21.25C30.164 21.1875 30.5703 20.2812 31.0156 19.2343L31.8203 17.3437H34.1562C35.4374 17.3437 36.4843 17.3515 36.4843 17.3593Z"
        fill={color}
      />
      <path
        d="M24.3906 14.6255C24.3359 14.6802 24.2969 14.938 24.2969 15.2505C24.2969 15.688 24.3203 15.7896 24.4453 15.8599C24.8516 16.0708 25.0781 15.8521 25.0781 15.2661C25.0781 15.0239 25.0391 14.7661 25 14.6802C24.9062 14.5083 24.5391 14.477 24.3906 14.6255Z"
        fill={color}
      />
      <path
        d="M26.2266 14.672C26.0548 14.8595 26.0469 15.5313 26.2188 15.7657C26.3594 15.961 26.6563 15.9923 26.7969 15.8204C26.961 15.6173 26.9923 14.9532 26.8438 14.7266C26.6876 14.4923 26.4063 14.4688 26.2266 14.672Z"
        fill={color}
      />
      <path
        d="M28.0625 14.6248C27.9375 14.7498 27.9375 15.7186 28.0625 15.8436C28.2109 15.992 28.5781 15.9607 28.6719 15.7889C28.7109 15.7029 28.75 15.4529 28.75 15.2342C28.75 15.0154 28.7109 14.7654 28.6719 14.6795C28.5781 14.5076 28.2109 14.4764 28.0625 14.6248Z"
        fill={color}
      />
      <path
        d="M6.85938 22.4297C6.74219 22.4922 6.71875 22.6172 6.71875 23.0703C6.71875 23.6953 6.78906 23.8281 7.125 23.8281C7.40625 23.8281 7.5 23.6406 7.5 23.0938C7.5 22.4922 7.22656 22.2109 6.85938 22.4297Z"
        fill={color}
      />
      <path
        d="M8.90649 22.5005C8.71118 22.6958 8.68774 23.3911 8.87524 23.6567C9.01587 23.8677 9.30493 23.8833 9.47681 23.688C9.67212 23.4692 9.65649 22.7036 9.45337 22.5005C9.36743 22.4145 9.24243 22.3442 9.17993 22.3442C9.11743 22.3442 8.99243 22.4145 8.90649 22.5005Z"
        fill={color}
      />
      <path
        d="M11.0157 22.5005C10.7969 22.7192 10.7891 23.5083 11.0079 23.7036C11.211 23.8833 11.4922 23.8364 11.6251 23.5942C11.7735 23.313 11.7032 22.5864 11.5235 22.4536C11.3204 22.3051 11.1954 22.3208 11.0157 22.5005Z"
        fill={color}
      />
      <path
        d="M6.29688 30.3596C6.22656 30.4221 6.17188 30.5471 6.17188 30.6253C6.17188 30.9612 7.42969 31.7268 8.59375 32.1096C10.6406 32.7737 13.1953 32.5081 15.0078 31.4456L15.4922 31.1643L16.3594 31.6018C17.6641 32.2503 18.4844 32.4456 20 32.4456C21.5234 32.4456 22.3438 32.2503 23.6406 31.6018L24.5078 31.1643L24.9922 31.4456C26.8047 32.5081 29.3594 32.7737 31.4062 32.1096C32.5547 31.7346 33.8281 30.9612 33.8281 30.6331C33.8281 30.469 33.5938 30.2346 33.4219 30.2346C33.3516 30.2346 33.0859 30.3753 32.8203 30.555C31.7578 31.2659 30.3828 31.6487 28.9453 31.6487C27.4219 31.6487 26.1094 31.2581 24.9453 30.4612C24.5391 30.18 24.4219 30.18 23.9844 30.4768C22.7969 31.2737 21.5391 31.6487 20 31.6487C18.4688 31.6487 17.25 31.2971 16.0469 30.5003C15.8281 30.3518 15.5859 30.2346 15.5156 30.2346C15.4375 30.2346 15.2344 30.3362 15.0547 30.4612C13.8828 31.2581 12.5781 31.6487 11.0547 31.6487C9.59375 31.6487 8.21875 31.2581 7.1875 30.555C6.67969 30.2112 6.48438 30.1643 6.29688 30.3596Z"
        fill={color}
      />
    </svg>
  );
}
OceanModeIcon.propTypes = {
  size: PropTypes.string,
  color: PropTypes.string,
};
OceanModeIcon.defaultProps = {
  size: '30',
  color: '#00B2FF',
};

export function OceanModeRedIcon() {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M15.2156 4.57908C15.15 4.64002 15.1406 4.82752 15.1406 5.89158V7.12908H14.4937C14.0062 7.12908 13.8234 7.14783 13.7531 7.19471C13.6687 7.26033 13.664 7.34939 13.65 9.79627L13.6359 12.3322H11.7656H9.89061V11.1885C9.89061 9.78221 9.96561 9.89471 9.03749 9.89471H8.39061V8.77908C8.39061 7.75252 8.38124 7.65408 8.30624 7.58377C8.22655 7.51346 8.04374 7.50408 6.62343 7.50408C5.13749 7.50408 5.02499 7.50877 4.95468 7.58846C4.88437 7.66346 4.87499 7.81814 4.87499 8.78377V9.89471H4.22812C3.3 9.89471 3.375 9.78221 3.375 11.1885V12.3322H2.82187C2.01562 12.3322 1.98281 12.365 2.15156 13.0963C2.38125 14.076 2.82656 15.1869 3.25312 15.8478C3.375 16.0353 3.45937 16.1994 3.44531 16.2135C3.39843 16.265 2.71406 16.101 2.32031 15.9463C2.11406 15.8666 1.8 15.7072 1.61719 15.59C1.43906 15.4728 1.27031 15.3791 1.2375 15.3791C1.15781 15.3791 1.03125 15.5385 1.03125 15.6463C1.03125 15.9322 2.14219 16.4947 3.04687 16.6635C3.53437 16.7572 4.33124 16.7572 4.81406 16.6682C5.42343 16.551 6.1078 16.2885 6.47343 16.0307C6.59062 15.9463 6.5953 15.951 7.12968 16.2182C7.83749 16.5697 8.32499 16.6963 9.11717 16.7244C10.0969 16.7619 10.9734 16.5557 11.6906 16.1244L12 15.9369L12.2719 16.101C12.5953 16.3025 13.1437 16.5228 13.575 16.6307C13.814 16.6916 14.1047 16.7103 14.6719 16.715C15.6469 16.715 16.0734 16.6213 16.8656 16.2182L17.4047 15.9463L17.5265 16.0307C17.9203 16.3072 18.689 16.5932 19.3265 16.6916C19.8187 16.7713 20.7703 16.7291 21.2437 16.6025C21.7359 16.476 22.2375 16.2603 22.5937 16.0213C22.9406 15.7916 22.9922 15.7213 22.95 15.5525C22.8984 15.3416 22.739 15.3463 22.425 15.5572C22.0687 15.7963 21.9 15.8807 21.5015 16.0166L21.1781 16.1291L21.2062 16.0213C21.3375 15.4963 22.4062 10.2931 22.4062 10.1853C22.4062 10.0869 22.3734 10.0213 22.3172 9.98846C22.2609 9.96033 21.7031 9.94158 20.8406 9.94158H19.4531V8.58221C19.4531 7.28846 19.4484 7.22283 19.364 7.17596C19.3078 7.14783 18.8015 7.12908 18.0515 7.12908H16.8281V6.57596C16.8281 5.97127 16.7765 5.81658 16.5703 5.81658C16.364 5.81658 16.3125 5.97127 16.3125 6.57596V7.12908H15.9609H15.6094V5.87283C15.6094 4.95877 15.5953 4.60252 15.5531 4.56033C15.4734 4.48064 15.3 4.49002 15.2156 4.57908ZM18.9843 8.76971C18.9843 9.75408 18.975 9.94158 18.9187 9.94158C18.7875 9.94158 18.7125 10.0822 18.2343 11.2025L17.7515 12.3322H15.9515H14.1562V9.96502V7.59783H16.5703H18.9843V8.76971ZM7.91249 8.94315L7.92186 9.89471H6.6328H5.34374V8.96658C5.34374 8.45564 5.35781 8.01971 5.37656 8.00564C5.39531 7.98689 5.96718 7.97752 6.65155 7.98221L7.89843 7.99627L7.91249 8.94315ZM6.37499 11.3713V12.3322H5.10937H3.84375V11.3713V10.4103H5.10937H6.37499V11.3713ZM9.42186 11.3713V12.3322H8.15624H6.89062V11.3713V10.4103H8.15624H9.42186V11.3713ZM21.8906 10.4197C21.8859 10.5275 20.6718 16.19 20.6484 16.2135C20.6297 16.2322 20.339 16.2463 20.0015 16.2416C19.5187 16.2416 19.2984 16.2182 18.989 16.1338C18.5156 16.0119 17.9812 15.7728 17.6672 15.5432C17.5406 15.4541 17.414 15.3791 17.3812 15.3791C17.3531 15.3791 17.1984 15.4635 17.0437 15.5619C15.6469 16.4713 13.814 16.4947 12.4359 15.6275C12.2156 15.4916 12.014 15.3791 11.9906 15.3791C11.9625 15.3791 11.8031 15.4728 11.6297 15.59C11.2734 15.8244 10.7578 16.0447 10.2844 16.1619C9.7828 16.2838 8.76092 16.2697 8.25468 16.1338C7.78124 16.0072 7.3453 15.815 6.95624 15.5666C6.80155 15.4635 6.64687 15.3791 6.61874 15.3791C6.58593 15.3791 6.45937 15.4541 6.3328 15.5432C5.84999 15.8947 4.99218 16.1947 4.38749 16.2322C4.15781 16.2463 4.15312 16.2463 3.9375 15.9791C3.48281 15.4166 3.05625 14.5025 2.74687 13.4338L2.5875 12.8713L10.2937 12.8478C17.0625 12.8291 18.0047 12.815 18.0609 12.7541C18.0984 12.7166 18.3422 12.1728 18.6093 11.5447L19.0922 10.4103H20.4937C21.2625 10.4103 21.8906 10.415 21.8906 10.4197Z"
        fill="url(#paint0_linear_11439_30650)"
      />
      <path
        d="M14.6344 8.77471C14.6016 8.80752 14.5781 8.96221 14.5781 9.14971C14.5781 9.41221 14.5922 9.47314 14.6672 9.51533C14.9109 9.64189 15.0469 9.51064 15.0469 9.15908C15.0469 9.01377 15.0234 8.85908 15 8.80752C14.9438 8.70439 14.7234 8.68564 14.6344 8.77471Z"
        fill="url(#paint1_linear_11439_30650)"
      />
      <path
        d="M15.736 8.8061C15.6329 8.9186 15.6282 9.32173 15.7313 9.46235C15.8157 9.57954 15.9938 9.59829 16.0782 9.49516C16.1766 9.37329 16.1954 8.97485 16.1063 8.83891C16.0125 8.69829 15.8438 8.68423 15.736 8.8061Z"
        fill="url(#paint2_linear_11439_30650)"
      />
      <path
        d="M16.8375 8.7743C16.7625 8.8493 16.7625 9.43055 16.8375 9.50555C16.9266 9.59461 17.1469 9.57586 17.2031 9.47273C17.2266 9.42117 17.25 9.27117 17.25 9.13992C17.25 9.00867 17.2266 8.85867 17.2031 8.80711C17.1469 8.70398 16.9266 8.68523 16.8375 8.7743Z"
        fill="url(#paint3_linear_11439_30650)"
      />
      <path
        d="M4.11563 13.4578C4.04531 13.4953 4.03125 13.5703 4.03125 13.8422C4.03125 14.2172 4.07344 14.2969 4.275 14.2969C4.44375 14.2969 4.5 14.1844 4.5 13.8563C4.5 13.4953 4.33594 13.3266 4.11563 13.4578Z"
        fill="url(#paint4_linear_11439_30650)"
      />
      <path
        d="M5.34375 13.502C5.22656 13.6192 5.2125 14.0364 5.325 14.1958C5.40937 14.3224 5.58281 14.3317 5.68594 14.2145C5.80312 14.0833 5.79375 13.6239 5.67187 13.502C5.62031 13.4505 5.54531 13.4083 5.50781 13.4083C5.47031 13.4083 5.39531 13.4505 5.34375 13.502Z"
        fill="url(#paint5_linear_11439_30650)"
      />
      <path
        d="M6.60936 13.5018C6.47811 13.6331 6.47342 14.1065 6.60467 14.2237C6.72655 14.3315 6.8953 14.3034 6.97498 14.1581C7.06405 13.9893 7.02186 13.5534 6.91405 13.4737C6.79217 13.3846 6.71717 13.394 6.60936 13.5018Z"
        fill="url(#paint6_linear_11439_30650)"
      />
      <path
        d="M3.77813 18.2172C3.73594 18.2547 3.70312 18.3297 3.70312 18.3765C3.70312 18.5781 4.45781 19.0375 5.15625 19.2671C6.38438 19.6656 7.91719 19.5062 9.00469 18.8687L9.29531 18.7L9.81563 18.9625C10.5984 19.3515 11.0906 19.4687 12 19.4687C12.9141 19.4687 13.4062 19.3515 14.1844 18.9625L14.7047 18.7L14.9953 18.8687C16.0828 19.5062 17.6156 19.6656 18.8438 19.2671C19.5328 19.0421 20.2969 18.5781 20.2969 18.3812C20.2969 18.2828 20.1562 18.1422 20.0531 18.1422C20.0109 18.1422 19.8516 18.2265 19.6922 18.3343C19.0547 18.7609 18.2297 18.9906 17.3672 18.9906C16.4531 18.9906 15.6656 18.7562 14.9672 18.2781C14.7234 18.1093 14.6531 18.1093 14.3906 18.2875C13.6781 18.7656 12.9234 18.9906 12 18.9906C11.0813 18.9906 10.35 18.7797 9.62813 18.3015C9.49688 18.2125 9.35156 18.1422 9.30938 18.1422C9.2625 18.1422 9.14062 18.2031 9.03281 18.2781C8.32969 18.7562 7.54688 18.9906 6.63281 18.9906C5.75625 18.9906 4.93125 18.7562 4.3125 18.3343C4.00781 18.1281 3.89062 18.1 3.77813 18.2172Z"
        fill="url(#paint7_linear_11439_30650)"
      />
      <defs>
        <linearGradient
          id="paint0_linear_11439_30650"
          x1="11.9969"
          y1="16.7344"
          x2="11.9969"
          y2="4.50598"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#F09090" />
          <stop offset="1" stopColor="#FA0000" />
        </linearGradient>
        <linearGradient
          id="paint1_linear_11439_30650"
          x1="14.8125"
          y1="9.5625"
          x2="14.8125"
          y2="8.71775"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#F09090" />
          <stop offset="1" stopColor="#FA0000" />
        </linearGradient>
        <linearGradient
          id="paint2_linear_11439_30650"
          x1="15.9099"
          y1="9.5625"
          x2="15.9099"
          y2="8.72329"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#F09090" />
          <stop offset="1" stopColor="#FA0000" />
        </linearGradient>
        <linearGradient
          id="paint3_linear_11439_30650"
          x1="17.0156"
          y1="9.5625"
          x2="17.0156"
          y2="8.71734"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#F09090" />
          <stop offset="1" stopColor="#FA0000" />
        </linearGradient>
        <linearGradient
          id="paint4_linear_11439_30650"
          x1="4.26562"
          y1="14.2969"
          x2="4.26562"
          y2="13.4135"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#F09090" />
          <stop offset="1" stopColor="#FA0000" />
        </linearGradient>
        <linearGradient
          id="paint5_linear_11439_30650"
          x1="5.50829"
          y1="14.2969"
          x2="5.50829"
          y2="13.4083"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#F09090" />
          <stop offset="1" stopColor="#FA0000" />
        </linearGradient>
        <linearGradient
          id="paint6_linear_11439_30650"
          x1="6.76591"
          y1="14.2891"
          x2="6.76591"
          y2="13.4133"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#F09090" />
          <stop offset="1" stopColor="#FA0000" />
        </linearGradient>
        <linearGradient
          id="paint7_linear_11439_30650"
          x1="12"
          y1="19.4844"
          x2="12"
          y2="18.1422"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#F09090" />
          <stop offset="1" stopColor="#FA0000" />
        </linearGradient>
      </defs>
    </svg>
  );
}
export function AirModeIcon({ size }) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 40 40"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M37.6094 19.1641C37.2657 18.2032 35.3672 16.9532 33.5313 16.4844C32.6328 16.2579 31.7578 16.1719 30.3047 16.1719H29L23.4219 9.28128C19.7266 4.70315 17.7891 2.37502 17.6875 2.3594C17.461 2.32815 14.9922 3.03909 14.8281 3.18752C14.75 3.25002 14.6875 3.35159 14.6875 3.40627C14.6875 3.45315 15.3672 5.1094 16.2031 7.08597C19.5625 15.0391 20 16.0782 20 16.125C20 16.1485 19.2891 16.1719 18.4219 16.1719C15.125 16.1719 13.2578 16.4688 10.2109 17.4688C8.98438 17.875 8.88282 17.8985 8.75782 17.7735C8.67969 17.711 7.82813 16.7344 6.86719 15.625L5.11719 13.5938L4.72656 13.6016C3.98438 13.6094 2.51563 13.7969 2.39063 13.8985C2.32031 13.9532 2.26563 14.0782 2.26563 14.1641C2.26563 14.25 2.82813 15.3829 3.50781 16.6719C4.19531 17.9688 4.76563 19.0704 4.78125 19.1329C4.79688 19.1954 4.66406 19.2891 4.44531 19.3672C3.9375 19.5391 3.82813 19.6563 3.82813 20.0001C3.82813 20.3438 3.9375 20.461 4.44531 20.6329C4.67188 20.711 4.79688 20.8047 4.78125 20.8672C4.76563 20.9297 4.19531 22.0391 3.50781 23.3282C2.82813 24.6251 2.26563 25.7579 2.26563 25.8438C2.26563 25.9298 2.32031 26.0469 2.39063 26.1016C2.51563 26.2032 3.97656 26.3907 4.72656 26.3985L5.11719 26.4063L6.90625 24.336C7.89063 23.1954 8.74219 22.2266 8.79688 22.1797C8.87501 22.1172 9.23438 22.211 10.2109 22.5313C13.25 23.5313 15.1719 23.8282 18.5 23.8282C19.9063 23.8282 20.0156 23.836 19.9766 23.9688C19.9531 24.0391 18.7578 26.8907 17.3125 30.3048C15.8672 33.7188 14.6875 36.547 14.6875 36.6016C14.6875 36.6485 14.75 36.7501 14.8281 36.8126C14.9922 36.961 17.461 37.672 17.6875 37.6407C17.7969 37.6251 19.6563 35.3829 23.4141 30.7423L28.9766 23.8672L30.6797 23.8204C33.2969 23.7422 34.5782 23.3907 36.2188 22.3047C36.9844 21.7969 37.4453 21.2969 37.6094 20.8047C37.7657 20.3594 37.7578 19.6016 37.6094 19.1641ZM36.7969 20.7032C36.4532 21.3751 34.7266 22.3907 33.2422 22.7969L32.461 23.0079H24.2188C15 23.0079 14.9922 23.0079 12.5391 22.4141C11.7734 22.2266 5.15625 20.0626 5.15625 20.0001C5.15625 19.9376 11.7266 17.7813 12.5391 17.5782C14.875 16.9844 15.836 16.9375 24.8438 16.9688L32.461 16.9922L33.2422 17.2032C34.7032 17.6016 36.4453 18.6172 36.7891 19.2735C37 19.6719 37 20.3047 36.7969 20.7032ZM24.4219 16.1719H20.8828L20.2188 14.5938C19.8516 13.7188 18.6797 10.9532 17.6172 8.43753C16.5547 5.9219 15.6719 3.82815 15.6484 3.78128C15.6328 3.72659 15.9766 3.59377 16.5235 3.43752C17.4141 3.17971 17.4375 3.17971 17.5781 3.32815C17.7266 3.47659 27.961 16.1172 27.9688 16.1563C27.9688 16.1641 26.375 16.1719 24.4219 16.1719ZM22.6172 30.5001C19.8281 33.961 17.4922 36.7891 17.4375 36.7891C17.1953 36.8048 15.6172 36.297 15.6563 36.2188C15.6719 36.172 16.2813 34.7266 17.0078 33.0079C17.7344 31.2891 18.9063 28.5235 19.6094 26.8594L20.8906 23.8282H24.4375H27.9844L27.836 24.0235C27.7578 24.1251 25.4141 27.0391 22.6172 30.5001ZM6.8125 18.5782C5.97657 18.8516 5.60938 18.9376 5.57032 18.875C5.21875 18.3204 3.29688 14.5625 3.34375 14.5235C3.375 14.4922 3.70313 14.4454 4.07031 14.4141L4.74219 14.3594L6.38282 16.2657C7.28907 17.3125 8.02344 18.1719 8.01563 18.1797C8.00782 18.1875 7.46875 18.3672 6.8125 18.5782ZM6.21875 23.9376L4.74219 25.6407L4.07031 25.586C3.70313 25.5547 3.375 25.5079 3.34375 25.4766C3.27344 25.4141 5.57813 21.0469 5.67188 21.0704C5.71094 21.0704 6.25782 21.2422 6.89063 21.4454L8.04688 21.8126L7.86719 22.0235C7.77344 22.1407 7.03125 23.0001 6.21875 23.9376Z"
        fill="#5200FF"
      />
      <path
        d="M31.5469 18.4531C31.4844 18.3906 31.0938 18.3594 30.3125 18.3594C29.0781 18.3594 28.9844 18.3906 28.9844 18.7656C28.9844 19.0781 29.2031 19.1406 30.3125 19.1406C31.4219 19.1406 31.6406 19.0781 31.6406 18.7656C31.6406 18.6484 31.6016 18.5078 31.5469 18.4531Z"
        fill="#5200FF"
      />
      <path
        d="M27.6875 18.4844C27.5859 18.3828 27.3594 18.3594 26.4141 18.3594C25.2031 18.3594 25.0781 18.3906 25.0781 18.7188C25.0781 19.0625 25.3359 19.1406 26.4609 19.1406C27.3984 19.1406 27.5156 19.125 27.6563 18.9844C27.8438 18.7969 27.8516 18.6484 27.6875 18.4844Z"
        fill="#5200FF"
      />
      <path
        d="M23.8203 18.5C23.75 18.375 23.6016 18.3594 22.5547 18.3594C21.2891 18.3594 21.1719 18.3906 21.1719 18.7188C21.1719 19.0625 21.4297 19.1406 22.5547 19.1406C23.4922 19.1406 23.6094 19.125 23.75 18.9844C23.9219 18.8125 23.9375 18.6953 23.8203 18.5Z"
        fill="#5200FF"
      />
      <path
        d="M19.9141 18.5C19.8438 18.375 19.6953 18.3594 18.6484 18.3594C17.3828 18.3594 17.2656 18.3906 17.2656 18.7188C17.2656 19.0625 17.5234 19.1406 18.6328 19.1406C19.4297 19.1406 19.6875 19.1172 19.8281 19.0156C20.0156 18.8906 20.0391 18.7109 19.9141 18.5Z"
        fill="#5200FF"
      />
      <path
        d="M16 18.4531C15.9375 18.3906 15.539 18.3594 14.7109 18.3594C13.6172 18.3594 13.5156 18.375 13.4375 18.5078C13.3281 18.7266 13.3359 18.8047 13.5156 18.9844C13.6562 19.125 13.7734 19.1406 14.7109 19.1406C15.5234 19.1406 15.7812 19.1172 15.9218 19.0156C16.1093 18.8828 16.1484 18.6016 16 18.4531Z"
        fill="#5200FF"
      />
    </svg>
  );
}
AirModeIcon.propTypes = {
  size: PropTypes.string,
};
AirModeIcon.defaultProps = {
  size: '30',
};
export function FclModeIcon({ size }) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 40 40"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M19.7344 2.07806C19.625 2.17963 19.6094 2.4765 19.6094 4.13276C19.6094 6.32026 19.5938 6.27338 20.2266 6.35151C21.4766 6.50776 21.9688 8.05464 21.0625 8.95308C20.1094 9.9062 18.4453 9.21089 18.4375 7.8437C18.4375 7.62495 18.2891 7.49995 18.0391 7.49995C17.7266 7.49995 17.625 7.67182 17.6797 8.1562C17.75 8.86714 18.1797 9.5312 18.8047 9.89058C18.9922 10.0078 19.1406 10.1015 19.125 10.1171C19.1094 10.125 17.7422 11.4218 16.0703 12.9921L13.0469 15.8593H12.0391C11.2188 15.8593 11 15.8828 10.9062 15.9843C10.7969 16.0937 10.7812 16.6875 10.7812 21.3359V26.5625H6.45312C2.52344 26.5625 2.11719 26.5781 2.02344 26.6953C1.92969 26.7969 1.91406 27.7734 1.91406 32.3203C1.91406 37.6797 1.92188 37.8281 2.0625 37.9375C2.29688 38.1016 37.7031 38.1016 37.9375 37.9375C38.0781 37.8281 38.0859 37.6797 38.0859 32.3203C38.0859 27.7734 38.0703 26.7969 37.9766 26.6953C37.8828 26.5781 37.4766 26.5625 33.5469 26.5625H29.2188V21.3359C29.2188 16.6875 29.2031 16.0937 29.0938 15.9843C29 15.8828 28.7812 15.8593 27.9688 15.8593H26.9609L23.9141 12.9765L20.8672 10.0859L21.2109 9.89058C22.1172 9.35151 22.5469 8.23433 22.2344 7.17182C22.0312 6.46088 21.3125 5.76557 20.6094 5.5937L20.3906 5.54682V3.87494C20.3906 2.09369 20.3594 1.95306 20 1.95306C19.9219 1.95306 19.7969 2.00775 19.7344 2.07806ZM22.9062 13.125L25.75 15.8203L22.875 15.8437C21.2969 15.8515 18.7109 15.8515 17.125 15.8437L14.2578 15.8203L17.1094 13.1093C18.6797 11.6171 19.9844 10.4062 20.0078 10.414C20.0391 10.4218 21.3438 11.6406 22.9062 13.125ZM28.4375 21.6406V26.5625H20H11.5625V21.6406V16.7187H20H28.4375V21.6406ZM19.6094 32.2656V37.1875H11.1719H2.73438V32.2656V27.3437H11.1719H19.6094V32.2656ZM37.2656 32.2656V37.1875H28.8281H20.3906V32.2656V27.3437H28.8281H37.2656V32.2656Z"
        fill="#00FF19"
      />
      <path
        d="M21.3438 18.7185L21.1719 18.8357V21.5935C21.1719 24.281 21.1797 24.3513 21.3359 24.4998C21.4844 24.6326 21.5156 24.6326 21.7031 24.5232L21.9141 24.406L21.9375 21.6404C21.9531 18.8904 21.9531 18.867 21.7891 18.7263C21.5859 18.5623 21.5625 18.5623 21.3438 18.7185Z"
        fill="#00FF19"
      />
      <path
        d="M24.4062 18.7033C24.2656 18.8127 24.2578 18.9377 24.2578 21.6017C24.2578 24.2658 24.2656 24.3908 24.4062 24.5001C24.6172 24.6486 24.7344 24.6408 24.9219 24.4533C25.0703 24.3048 25.0781 24.1955 25.0781 21.6017C25.0781 19.008 25.0703 18.8986 24.9219 18.7502C24.7344 18.5627 24.6172 18.5548 24.4062 18.7033Z"
        fill="#00FF19"
      />
      <path
        d="M15 18.8205C14.9531 18.922 14.9219 19.9533 14.9219 21.633C14.9219 24.1955 14.9297 24.3048 15.0781 24.4533C15.2656 24.6408 15.3828 24.6486 15.5938 24.5001C15.7344 24.3908 15.7422 24.258 15.7656 21.7189C15.7813 19.3986 15.7734 19.0158 15.6641 18.8595C15.5078 18.6251 15.125 18.6017 15 18.8205Z"
        fill="#00FF19"
      />
      <path
        d="M18.1406 18.7656C18.0703 18.836 18.0469 19.5703 18.0469 21.6016C18.0469 24.2656 18.0547 24.3516 18.2031 24.4922C18.3281 24.6094 18.4063 24.625 18.5781 24.5625L18.7891 24.4922L18.8125 21.6875C18.8281 19.6875 18.8047 18.8516 18.7422 18.7813C18.6328 18.6485 18.2656 18.6406 18.1406 18.7656Z"
        fill="#00FF19"
      />
      <path
        d="M6.22656 29.4375C6.10938 29.5703 6.09375 29.8828 6.09375 32.2891C6.09375 35.2109 6.09375 35.2344 6.51562 35.2344C6.875 35.2344 6.875 35.2031 6.875 32.25C6.875 29.5703 6.86719 29.4531 6.72656 29.375C6.50781 29.2578 6.36719 29.2813 6.22656 29.4375Z"
        fill="#00FF19"
      />
      <path
        d="M9.35156 29.4375C9.23438 29.5703 9.21875 29.8828 9.21875 32.3125C9.21875 34.3359 9.24219 35.0703 9.3125 35.1406C9.42969 35.2578 9.78906 35.2578 9.90625 35.1406C9.97656 35.0703 10 34.3359 10 32.3047C10 29.7422 9.99219 29.5469 9.85938 29.4297C9.67188 29.2578 9.50781 29.2656 9.35156 29.4375Z"
        fill="#00FF19"
      />
      <path
        d="M12.4844 29.3828C12.3516 29.4531 12.3438 29.6797 12.3438 32.25C12.3438 35.2031 12.3438 35.2344 12.7031 35.2344C13.1172 35.2344 13.125 35.2031 13.125 32.3203C13.125 30.0234 13.1094 29.6172 13 29.4688C12.875 29.2813 12.6953 29.2578 12.4844 29.3828Z"
        fill="#00FF19"
      />
      <path
        d="M15.5469 29.4531C15.3984 29.6015 15.3906 29.7109 15.3906 32.289C15.3906 34.8359 15.3984 34.9843 15.5391 35.1093C15.625 35.1874 15.7734 35.2343 15.8672 35.2187C16.2344 35.1718 16.25 34.9921 16.2344 32.164C16.2109 29.6484 16.2031 29.5156 16.0625 29.4062C15.8516 29.2578 15.7344 29.2656 15.5469 29.4531Z"
        fill="#00FF19"
      />
      <path
        d="M23.9374 29.4062C23.7968 29.5156 23.789 29.6484 23.7656 32.164C23.7499 34.9921 23.7656 35.1718 24.1328 35.2187C24.2265 35.2343 24.3749 35.1874 24.4609 35.1093C24.6015 34.9843 24.6093 34.8359 24.6093 32.289C24.6093 29.7109 24.6015 29.6015 24.4531 29.4531C24.2656 29.2656 24.1484 29.2578 23.9374 29.4062Z"
        fill="#00FF19"
      />
      <path
        d="M27 29.4687C26.8906 29.6172 26.875 30.0234 26.875 32.3203C26.875 35.2031 26.8828 35.2344 27.2969 35.2344C27.6562 35.2344 27.6562 35.2031 27.6562 32.25C27.6562 29.5703 27.6484 29.4531 27.5078 29.375C27.2734 29.25 27.1328 29.2812 27 29.4687Z"
        fill="#00FF19"
      />
      <path
        d="M30.125 29.4219C30.0156 29.5234 30 29.8984 30 32.2969C30 34.3281 30.0234 35.0703 30.0938 35.1406C30.2109 35.2578 30.5703 35.2578 30.6875 35.1406C30.7578 35.0703 30.7812 34.3281 30.7812 32.2969C30.7812 29.8984 30.7656 29.5234 30.6562 29.4219C30.5938 29.3516 30.4688 29.2969 30.3906 29.2969C30.3125 29.2969 30.1875 29.3516 30.125 29.4219Z"
        fill="#00FF19"
      />
      <path
        d="M33.2187 29.3904C33.0859 29.5232 33.0859 35.0076 33.2187 35.1404C33.3672 35.2889 33.7344 35.2576 33.8281 35.0857C33.875 34.9842 33.9062 33.9451 33.9062 32.242C33.9062 29.742 33.8984 29.5467 33.7656 29.4295C33.5937 29.2732 33.3516 29.2576 33.2187 29.3904Z"
        fill="#00FF19"
      />
    </svg>
  );
}
FclModeIcon.propTypes = {
  size: PropTypes.string,
};
FclModeIcon.defaultProps = {
  size: '30',
};
export function FtlModeIcon({ size }) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 40 40"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M23.5518 5.625C23.7003 5.77344 23.7081 5.88281 23.7081 7.57031V9.36719L27.669 9.39062C31.4737 9.42188 31.6612 9.42969 32.2628 9.59375C34.3019 10.1562 35.9347 11.4844 36.8644 13.3281C37.3019 14.2031 37.5284 15.1094 37.6066 16.3203C37.6534 16.9062 37.8175 19.8984 37.9737 22.9766C38.3019 29.1953 38.3097 28.9688 37.7941 29.5391C37.3409 30.0391 36.9972 30.1797 36.0597 30.2266L35.2472 30.2734L35.1456 30.7812C34.8331 32.3125 33.63 33.6797 32.0987 34.2344C31.4503 34.4688 30.1065 34.5156 29.4112 34.3359C27.7237 33.8984 26.3956 32.5156 26.005 30.7969L25.88 30.2344H19.6534H13.4346L13.3331 30.7656C13.1612 31.6562 12.7628 32.375 12.0362 33.0859C11.0596 34.0547 10.0987 34.4531 8.76276 34.4531C7.45026 34.4531 6.39557 34.0156 5.45807 33.0859C4.82525 32.4531 4.41119 31.7031 4.20025 30.8125L4.06744 30.25L3.59088 30.2188C2.81744 30.1562 2.21588 29.7422 1.93462 29.0859C1.84869 28.875 1.83306 26.7969 1.83306 17.2734V5.71094L2.00494 5.59375C2.16119 5.48438 3.31744 5.46875 12.7862 5.46875C23.294 5.46875 23.3956 5.46875 23.5518 5.625ZM2.61432 14.4531V22.5781H12.7706H22.9268V14.4531V6.32812H12.7706H2.61432V14.4531ZM23.7081 16.6094C23.7081 20.9062 23.6847 23.1094 23.63 23.2109C23.544 23.3594 23.3487 23.3594 13.0831 23.3594H2.61432V25.9844C2.61432 28.8672 2.62994 28.9766 3.07525 29.2422C3.20807 29.3203 3.46588 29.375 3.68463 29.375H4.06744L4.20025 28.8047C4.59869 27.0859 5.94244 25.7031 7.65339 25.2734C9.95808 24.6875 12.4815 26.1016 13.2003 28.3672C13.3096 28.7109 13.3956 29.0781 13.3956 29.1875V29.375H19.6378H25.88L26.005 28.8203C26.3565 27.2578 27.5519 25.9141 29.0284 25.3906C29.7237 25.1484 30.8487 25.0938 31.6065 25.2656C33.3487 25.6562 34.794 27.1094 35.1456 28.8281L35.2472 29.3359L35.9816 29.3594C36.6066 29.375 36.755 29.3516 36.9737 29.2188C37.505 28.8906 37.505 29.2344 37.1144 22.0078C36.7237 14.8203 36.7316 14.8672 36.1378 13.6953C35.169 11.7656 33.2706 10.4453 31.169 10.2422C30.8253 10.2031 29.005 10.1719 27.1222 10.1641L23.7081 10.1562V16.6094ZM29.794 26.0156C28.5362 26.25 27.3644 27.2812 26.9034 28.5625C26.6612 29.2109 26.6612 30.3984 26.9034 31.0469C27.4737 32.625 28.9269 33.6719 30.544 33.6719C31.5987 33.6719 32.4503 33.3359 33.2315 32.6094C34.8097 31.1484 34.8409 28.5859 33.294 27.0859C32.3331 26.1406 31.1144 25.7734 29.794 26.0156ZM7.80964 26.0547C7.12214 26.2344 6.50494 26.6016 5.98932 27.1406C5.04401 28.125 4.69244 29.3828 4.99713 30.6875C5.66901 33.5469 9.13776 34.6406 11.3487 32.6953C12.755 31.4609 13.0362 29.2344 11.9815 27.6641C11.0753 26.3125 9.37214 25.6484 7.80964 26.0547Z"
        fill="#DC03FF"
      />
      <path
        d="M30.505 12.3906C30.7862 12.4453 31.3488 12.6563 31.755 12.8594C33.0206 13.4922 33.9894 14.6328 34.4659 16.0547C34.6613 16.6484 34.6769 16.7734 34.7081 18.6016C34.7316 20.3125 34.7238 20.5391 34.6066 20.6484C34.4894 20.7656 34.0753 20.7812 30.1612 20.7812C26.0753 20.7812 25.8331 20.7734 25.7159 20.6406C25.5987 20.5078 25.5831 20.1094 25.5831 16.5078C25.5831 12.75 25.5909 12.5156 25.7237 12.3985C25.8487 12.2813 26.1144 12.2656 27.9347 12.2735C29.38 12.2735 30.1456 12.3125 30.505 12.3906ZM26.4034 16.5234V19.9609L30.1847 19.9844L33.9659 20L33.9191 18.4609C33.8956 17.4141 33.8409 16.7734 33.755 16.4844C33.2628 14.7656 31.8019 13.4219 30.0909 13.1328C29.8644 13.0938 28.9425 13.0703 28.0441 13.0781L26.4034 13.086V16.5234Z"
        fill="#DC03FF"
      />
      <path
        d="M31.1689 27.3356C31.8643 27.5153 32.4658 27.984 32.8096 28.6012C33.0283 28.9919 33.0439 29.0856 33.0439 29.8044C33.0439 30.6794 32.9346 30.984 32.4111 31.5622C31.7705 32.2653 30.6064 32.5309 29.6846 32.1794C29.0518 31.945 28.3955 31.2965 28.1924 30.7028C27.6377 29.07 28.7393 27.3747 30.4111 27.2965C30.7002 27.2809 31.0361 27.2965 31.1689 27.3356ZM30.0674 28.1637C29.6299 28.2887 29.2393 28.6325 29.0049 29.0934C28.7705 29.5544 28.8252 30.3356 29.1377 30.7731C29.7549 31.6715 31.0283 31.7965 31.7783 31.0309C32.7471 30.0387 32.333 28.5309 30.9736 28.1169C30.6768 28.0309 30.4893 28.0387 30.0674 28.1637Z"
        fill="#DC03FF"
      />
      <path
        d="M9.54395 27.4062C10.6533 27.8047 11.2861 28.6875 11.2861 29.8516C11.2861 30.7891 10.708 31.6875 9.84082 32.1094C9.5127 32.2734 9.33301 32.3047 8.74707 32.3047C8.1377 32.3047 7.98926 32.2734 7.65333 32.0937C7.16895 31.8437 6.6377 31.2812 6.41895 30.7969C6.16114 30.2266 6.18458 29.3125 6.46583 28.7422C6.71583 28.2187 7.24708 27.7031 7.75489 27.4844C8.2627 27.2578 9.02832 27.2266 9.54395 27.4062ZM7.94239 28.2891C6.78614 28.8516 6.73926 30.625 7.86426 31.2812C8.60645 31.7109 9.36426 31.6172 9.95801 31.0234C10.6143 30.3594 10.6846 29.5 10.1377 28.7656C9.62989 28.0781 8.7627 27.8906 7.94239 28.2891Z"
        fill="#DC03FF"
      />
      <path
        d="M18.0598 8.21509C19.3206 8.22484 19.9242 8.24923 19.9729 8.28336C20.0215 8.32725 20.0361 8.81976 20.0361 10.8922C20.0361 13.1451 20.0264 13.4475 19.9582 13.5157C19.8901 13.584 19.5494 13.5938 16.9061 13.5938C14.2873 13.5938 13.9124 13.584 13.8151 13.5157L13.708 13.4426V10.8922C13.708 8.57594 13.7177 8.33212 13.7908 8.27361C13.8784 8.20046 14.6085 8.19071 18.0598 8.21509ZM17.7969 9.29277C17.7969 10.1705 17.8408 10.1315 16.9013 10.1315C16.3853 10.1315 16.137 10.112 16.0786 10.0681C16.0105 10.0194 15.9959 9.89745 15.9861 9.35129L15.9715 8.69298L15.0807 8.67835L14.1948 8.66859V10.8874V13.1061H16.8721H19.5494V10.8874V8.66859H18.6732H17.7969V9.29277ZM16.4826 9.15623V9.64387H16.8964H17.3102V9.19037C17.3102 8.9368 17.2956 8.71736 17.2761 8.70273C17.2615 8.68322 17.0716 8.66859 16.8623 8.66859H16.4826V9.15623Z"
        fill="#DC03FF"
      />
      <path
        d="M9.77856 8.21509C11.0393 8.22484 11.6429 8.24923 11.6916 8.28336C11.7403 8.32725 11.7549 8.81976 11.7549 10.8922C11.7549 13.1451 11.7451 13.4475 11.677 13.5157C11.6088 13.584 11.2681 13.5938 8.62489 13.5938C6.00602 13.5938 5.63121 13.584 5.53385 13.5157L5.42676 13.4426V10.8922C5.42676 8.57594 5.43649 8.33212 5.50951 8.27361C5.59713 8.20046 6.3273 8.19071 9.77856 8.21509ZM9.5157 9.29277C9.5157 10.1705 9.55951 10.1315 8.62003 10.1315C8.10404 10.1315 7.85578 10.112 7.79737 10.0681C7.72922 10.0194 7.71462 9.89745 7.70488 9.35129L7.69028 8.69298L6.79947 8.67835L5.91354 8.66859V10.8874V13.1061H8.59082H11.2681V10.8874V8.66859H10.3919H9.5157V9.29277ZM8.2014 9.15623V9.64387H8.61516H9.02892V9.19037C9.02892 8.9368 9.01432 8.71736 8.99485 8.70273C8.98024 8.68322 8.7904 8.66859 8.58108 8.66859H8.2014V9.15623Z"
        fill="#DC03FF"
      />
      <path
        d="M18.0598 15.5588C19.3206 15.5686 19.9242 15.593 19.9729 15.6271C20.0215 15.671 20.0361 16.1635 20.0361 18.236C20.0361 20.4889 20.0264 20.7912 19.9582 20.8595C19.8901 20.9277 19.5494 20.9375 16.9061 20.9375C14.2873 20.9375 13.9124 20.9277 13.8151 20.8595L13.708 20.7863V18.236C13.708 15.9197 13.7177 15.6759 13.7908 15.6174C13.8784 15.5442 14.6085 15.5345 18.0598 15.5588ZM17.7969 16.6365C17.7969 17.5143 17.8408 17.4753 16.9013 17.4753C16.3853 17.4753 16.137 17.4558 16.0786 17.4119C16.0105 17.3631 15.9959 17.2412 15.9861 16.695L15.9715 16.0367L15.0807 16.0221L14.1948 16.0123V18.2311V20.4499H16.8721H19.5494V18.2311V16.0123H18.6732H17.7969V16.6365ZM16.4826 16.5V16.9876H16.8964H17.3102V16.5341C17.3102 16.2805 17.2956 16.0611 17.2761 16.0465C17.2615 16.027 17.0716 16.0123 16.8623 16.0123H16.4826V16.5Z"
        fill="#DC03FF"
      />
      <path
        d="M9.77856 15.5588C11.0393 15.5686 11.6429 15.593 11.6916 15.6271C11.7403 15.671 11.7549 16.1635 11.7549 18.236C11.7549 20.4889 11.7451 20.7912 11.677 20.8595C11.6088 20.9277 11.2681 20.9375 8.62489 20.9375C6.00602 20.9375 5.63121 20.9277 5.53385 20.8595L5.42676 20.7863V18.236C5.42676 15.9197 5.43649 15.6759 5.50951 15.6174C5.59713 15.5442 6.3273 15.5345 9.77856 15.5588ZM9.5157 16.6365C9.5157 17.5143 9.55951 17.4753 8.62003 17.4753C8.10404 17.4753 7.85578 17.4558 7.79737 17.4119C7.72922 17.3631 7.71462 17.2412 7.70488 16.695L7.69028 16.0367L6.79947 16.0221L5.91354 16.0123V18.2311V20.4499H8.59082H11.2681V18.2311V16.0123H10.3919H9.5157V16.6365ZM8.2014 16.5V16.9876H8.61516H9.02892V16.5341C9.02892 16.2805 9.01432 16.0611 8.99485 16.0465C8.98024 16.027 8.7904 16.0123 8.58108 16.0123H8.2014V16.5Z"
        fill="#DC03FF"
      />
    </svg>
  );
}
FtlModeIcon.propTypes = {
  size: PropTypes.string,
};
FtlModeIcon.defaultProps = {
  size: '30',
};
export function LtlModeIcon({ size }) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 40 40"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M23.5518 5.625C23.7003 5.77344 23.7081 5.88281 23.7081 7.57031V9.36719L27.669 9.39062C31.4737 9.42188 31.6612 9.42969 32.2628 9.59375C34.3019 10.1562 35.9347 11.4844 36.8644 13.3281C37.3019 14.2031 37.5284 15.1094 37.6066 16.3203C37.6534 16.9062 37.8175 19.8984 37.9737 22.9766C38.3019 29.1953 38.3097 28.9688 37.7941 29.5391C37.3409 30.0391 36.9972 30.1797 36.0597 30.2266L35.2472 30.2734L35.1456 30.7812C34.8331 32.3125 33.63 33.6797 32.0987 34.2344C31.4503 34.4688 30.1065 34.5156 29.4112 34.3359C27.7237 33.8984 26.3956 32.5156 26.005 30.7969L25.88 30.2344H19.6534H13.4346L13.3331 30.7656C13.1612 31.6562 12.7628 32.375 12.0362 33.0859C11.0596 34.0547 10.0987 34.4531 8.76276 34.4531C7.45026 34.4531 6.39557 34.0156 5.45807 33.0859C4.82525 32.4531 4.41119 31.7031 4.20025 30.8125L4.06744 30.25L3.59088 30.2188C2.81744 30.1562 2.21588 29.7422 1.93462 29.0859C1.84869 28.875 1.83306 26.7969 1.83306 17.2734V5.71094L2.00494 5.59375C2.16119 5.48438 3.31744 5.46875 12.7862 5.46875C23.294 5.46875 23.3956 5.46875 23.5518 5.625ZM2.61432 14.4531V22.5781H12.7706H22.9268V14.4531V6.32812H12.7706H2.61432V14.4531ZM23.7081 16.6094C23.7081 20.9062 23.6847 23.1094 23.63 23.2109C23.544 23.3594 23.3487 23.3594 13.0831 23.3594H2.61432V25.9844C2.61432 28.8672 2.62994 28.9766 3.07525 29.2422C3.20807 29.3203 3.46588 29.375 3.68463 29.375H4.06744L4.20025 28.8047C4.59869 27.0859 5.94244 25.7031 7.65339 25.2734C9.95808 24.6875 12.4815 26.1016 13.2003 28.3672C13.3096 28.7109 13.3956 29.0781 13.3956 29.1875V29.375H19.6378H25.88L26.005 28.8203C26.3565 27.2578 27.5519 25.9141 29.0284 25.3906C29.7237 25.1484 30.8487 25.0938 31.6065 25.2656C33.3487 25.6562 34.794 27.1094 35.1456 28.8281L35.2472 29.3359L35.9816 29.3594C36.6066 29.375 36.755 29.3516 36.9737 29.2188C37.505 28.8906 37.505 29.2344 37.1144 22.0078C36.7237 14.8203 36.7316 14.8672 36.1378 13.6953C35.169 11.7656 33.2706 10.4453 31.169 10.2422C30.8253 10.2031 29.005 10.1719 27.1222 10.1641L23.7081 10.1562V16.6094ZM29.794 26.0156C28.5362 26.25 27.3644 27.2812 26.9034 28.5625C26.6612 29.2109 26.6612 30.3984 26.9034 31.0469C27.4737 32.625 28.9269 33.6719 30.544 33.6719C31.5987 33.6719 32.4503 33.3359 33.2315 32.6094C34.8097 31.1484 34.8409 28.5859 33.294 27.0859C32.3331 26.1406 31.1144 25.7734 29.794 26.0156ZM7.80964 26.0547C7.12214 26.2344 6.50494 26.6016 5.98932 27.1406C5.04401 28.125 4.69244 29.3828 4.99713 30.6875C5.66901 33.5469 9.13776 34.6406 11.3487 32.6953C12.755 31.4609 13.0362 29.2344 11.9815 27.6641C11.0753 26.3125 9.37214 25.6484 7.80964 26.0547Z"
        fill="#FF9900"
      />
      <path
        d="M30.505 12.3906C30.7862 12.4453 31.3488 12.6563 31.755 12.8594C33.0206 13.4922 33.9894 14.6328 34.4659 16.0547C34.6613 16.6484 34.6769 16.7734 34.7081 18.6016C34.7316 20.3125 34.7238 20.5391 34.6066 20.6484C34.4894 20.7656 34.0753 20.7812 30.1612 20.7812C26.0753 20.7812 25.8331 20.7734 25.7159 20.6406C25.5987 20.5078 25.5831 20.1094 25.5831 16.5078C25.5831 12.75 25.5909 12.5156 25.7237 12.3985C25.8487 12.2813 26.1144 12.2656 27.9347 12.2735C29.38 12.2735 30.1456 12.3125 30.505 12.3906ZM26.4034 16.5234V19.9609L30.1847 19.9844L33.9659 20L33.9191 18.4609C33.8956 17.4141 33.8409 16.7734 33.755 16.4844C33.2628 14.7656 31.8019 13.4219 30.0909 13.1328C29.8644 13.0938 28.9425 13.0703 28.0441 13.0781L26.4034 13.086V16.5234Z"
        fill="#FF9900"
      />
      <path
        d="M31.1689 27.3356C31.8643 27.5153 32.4658 27.984 32.8096 28.6012C33.0283 28.9919 33.0439 29.0856 33.0439 29.8044C33.0439 30.6794 32.9346 30.984 32.4111 31.5622C31.7705 32.2653 30.6064 32.5309 29.6846 32.1794C29.0518 31.945 28.3955 31.2965 28.1924 30.7028C27.6377 29.07 28.7393 27.3747 30.4111 27.2965C30.7002 27.2809 31.0361 27.2965 31.1689 27.3356ZM30.0674 28.1637C29.6299 28.2887 29.2393 28.6325 29.0049 29.0934C28.7705 29.5544 28.8252 30.3356 29.1377 30.7731C29.7549 31.6715 31.0283 31.7965 31.7783 31.0309C32.7471 30.0387 32.333 28.5309 30.9736 28.1169C30.6768 28.0309 30.4893 28.0387 30.0674 28.1637Z"
        fill="#FF9900"
      />
      <path
        d="M9.54395 27.4062C10.6533 27.8047 11.2861 28.6875 11.2861 29.8516C11.2861 30.7891 10.708 31.6875 9.84082 32.1094C9.5127 32.2734 9.33301 32.3047 8.74707 32.3047C8.1377 32.3047 7.98926 32.2734 7.65333 32.0937C7.16895 31.8437 6.6377 31.2812 6.41895 30.7969C6.16114 30.2266 6.18458 29.3125 6.46583 28.7422C6.71583 28.2187 7.24708 27.7031 7.75489 27.4844C8.2627 27.2578 9.02832 27.2266 9.54395 27.4062ZM7.94239 28.2891C6.78614 28.8516 6.73926 30.625 7.86426 31.2812C8.60645 31.7109 9.36426 31.6172 9.95801 31.0234C10.6143 30.3594 10.6846 29.5 10.1377 28.7656C9.62989 28.0781 8.7627 27.8906 7.94239 28.2891Z"
        fill="#FF9900"
      />
      <path
        d="M18.0598 8.21509C19.3206 8.22484 19.9242 8.24923 19.9729 8.28336C20.0215 8.32725 20.0361 8.81976 20.0361 10.8922C20.0361 13.1451 20.0264 13.4475 19.9582 13.5157C19.8901 13.584 19.5494 13.5938 16.9061 13.5938C14.2873 13.5938 13.9124 13.584 13.8151 13.5157L13.708 13.4426V10.8922C13.708 8.57594 13.7177 8.33212 13.7908 8.27361C13.8784 8.20046 14.6085 8.19071 18.0598 8.21509ZM17.7969 9.29277C17.7969 10.1705 17.8408 10.1315 16.9013 10.1315C16.3853 10.1315 16.137 10.112 16.0786 10.0681C16.0105 10.0194 15.9959 9.89745 15.9861 9.35129L15.9715 8.69298L15.0807 8.67835L14.1948 8.66859V10.8874V13.1061H16.8721H19.5494V10.8874V8.66859H18.6732H17.7969V9.29277ZM16.4826 9.15623V9.64387H16.8964H17.3102V9.19037C17.3102 8.9368 17.2956 8.71736 17.2761 8.70273C17.2615 8.68322 17.0716 8.66859 16.8623 8.66859H16.4826V9.15623Z"
        fill="#FF9900"
      />
      <path
        d="M18.0598 15.5588C19.3206 15.5686 19.9242 15.593 19.9729 15.6271C20.0215 15.671 20.0361 16.1635 20.0361 18.236C20.0361 20.4889 20.0264 20.7912 19.9582 20.8595C19.8901 20.9277 19.5494 20.9375 16.9061 20.9375C14.2873 20.9375 13.9124 20.9277 13.8151 20.8595L13.708 20.7863V18.236C13.708 15.9197 13.7177 15.6759 13.7908 15.6174C13.8784 15.5442 14.6085 15.5345 18.0598 15.5588ZM17.7969 16.6365C17.7969 17.5143 17.8408 17.4753 16.9013 17.4753C16.3853 17.4753 16.137 17.4558 16.0786 17.4119C16.0105 17.3631 15.9959 17.2412 15.9861 16.695L15.9715 16.0367L15.0807 16.0221L14.1948 16.0123V18.2311V20.4499H16.8721H19.5494V18.2311V16.0123H18.6732H17.7969V16.6365ZM16.4826 16.5V16.9876H16.8964H17.3102V16.5341C17.3102 16.2805 17.2956 16.0611 17.2761 16.0465C17.2615 16.027 17.0716 16.0123 16.8623 16.0123H16.4826V16.5Z"
        fill="#FF9900"
      />
      <path
        d="M9.77856 15.5588C11.0393 15.5686 11.6429 15.593 11.6916 15.6271C11.7403 15.671 11.7549 16.1635 11.7549 18.236C11.7549 20.4889 11.7451 20.7912 11.677 20.8595C11.6088 20.9277 11.2681 20.9375 8.62489 20.9375C6.00602 20.9375 5.63121 20.9277 5.53385 20.8595L5.42676 20.7863V18.236C5.42676 15.9197 5.43649 15.6759 5.50951 15.6174C5.59713 15.5442 6.3273 15.5345 9.77856 15.5588ZM9.5157 16.6365C9.5157 17.5143 9.55951 17.4753 8.62003 17.4753C8.10404 17.4753 7.85578 17.4558 7.79737 17.4119C7.72922 17.3631 7.71462 17.2412 7.70488 16.695L7.69028 16.0367L6.79947 16.0221L5.91354 16.0123V18.2311V20.4499H8.59082H11.2681V18.2311V16.0123H10.3919H9.5157V16.6365ZM8.2014 16.5V16.9876H8.61516H9.02892V16.5341C9.02892 16.2805 9.01432 16.0611 8.99485 16.0465C8.98024 16.027 8.7904 16.0123 8.58108 16.0123H8.2014V16.5Z"
        fill="#FF9900"
      />
    </svg>
  );
}
LtlModeIcon.propTypes = {
  size: PropTypes.string,
};
LtlModeIcon.defaultProps = {
  size: '30',
};
export function LclModeIcon({ size }) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 40 40"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M19.7031 2.28125C19.6406 2.34375 19.6094 2.74219 19.6094 3.57031V4.75781L18.6563 4.78125C17.7266 4.80469 17.6953 4.8125 17.6016 5C17.4531 5.28125 17.4922 10.1016 17.6406 10.25C17.7109 10.3203 18.0469 10.3594 18.6719 10.375L19.6094 10.4062V11.5234C19.6094 12.75 19.6563 12.8906 20.0625 12.8906C20.6172 12.8984 21.3516 13.4922 21.4531 14.0234C21.6406 15.0469 20.9844 15.8984 20 15.8984C19.2422 15.8984 18.6406 15.375 18.5234 14.6094C18.4531 14.1484 18.2734 13.9531 18.0156 14.0312C17.7969 14.1016 17.7344 14.2109 17.7344 14.5391C17.7344 15.1641 18.2109 15.9844 18.7734 16.3281L18.9922 16.4688L18.1875 16.9688C17.7422 17.25 15.1406 18.8672 12.4063 20.5703L7.42969 23.6719H6.5625C5.71094 23.6719 5.69531 23.6719 5.625 23.875C5.57813 24 5.54688 26.6094 5.54688 30.7656C5.54688 36.7031 5.5625 37.4844 5.67188 37.6406L5.78906 37.8125H20H34.2188L34.3359 37.6328C34.4453 37.4688 34.4531 36.6562 34.4375 30.6328C34.4141 24.6797 34.3984 23.8125 34.2969 23.75C34.2344 23.7109 33.8203 23.6719 33.3828 23.6719H32.5781L27.4844 20.5C24.6797 18.75 22.0703 17.1328 21.6953 16.8906L21 16.4688L21.2266 16.3281C21.5859 16.1094 22.0156 15.5625 22.1563 15.1328C22.3203 14.6328 22.2734 13.8359 22.0469 13.3984C21.7578 12.8281 20.9531 12.1875 20.5234 12.1875C20.4063 12.1875 20.3906 12.0781 20.3906 11.2969V10.4062L21.3281 10.375C21.9531 10.3594 22.2891 10.3203 22.3594 10.25C22.4375 10.1719 22.4688 9.57031 22.4844 7.64062C22.5 5.47656 22.4922 5.10938 22.3828 4.95312C22.2656 4.77344 22.2266 4.76562 21.3281 4.76562H20.3906V3.57031C20.3906 2.28906 20.3594 2.1875 20 2.1875C19.8906 2.1875 19.7578 2.22656 19.7031 2.28125ZM21.7031 7.55469L21.6797 9.57031H20H18.3203L18.2969 7.55469L18.2813 5.54688H20H21.7188L21.7031 7.55469ZM25.5313 20.1953C28.5 22.0391 30.9297 23.5781 30.9375 23.6094C30.9375 23.6484 26.0156 23.6719 20 23.6719C13.9844 23.6719 9.0625 23.6484 9.0625 23.6094C9.07031 23.5234 19.9453 16.7891 20.0469 16.8125C20.0859 16.8281 22.5547 18.3438 25.5313 20.1953ZM33.6719 30.7422V37.0312H20H6.32813V30.7422V24.4531H20H33.6719V30.7422Z"
        fill="#FF0000"
      />
      <path
        d="M9.87508 27.2969C9.73445 27.4062 9.72664 27.5312 9.72664 30.9375C9.72664 34.7266 9.71101 34.6016 10.1251 34.6094C10.4688 34.6094 10.4688 34.6016 10.4688 30.8828C10.4688 27.4687 10.461 27.3437 10.3204 27.2656C10.1173 27.164 10.0626 27.164 9.87508 27.2969Z"
        fill="#FF0000"
      />
      <path
        d="M13.8438 27.3123L13.6719 27.4295V30.867C13.6719 33.0857 13.7031 34.3592 13.75 34.4607C13.8438 34.6326 14.2109 34.6639 14.3594 34.5154C14.4297 34.4451 14.4531 33.5389 14.4531 30.9295V27.4295L14.2812 27.3123C14.1875 27.242 14.0859 27.1873 14.0625 27.1873C14.0391 27.1873 13.9375 27.242 13.8438 27.3123Z"
        fill="#FF0000"
      />
      <path
        d="M17.7891 27.328C17.6719 27.4608 17.6562 27.8279 17.6562 30.9451C17.6562 33.5467 17.6797 34.4451 17.75 34.5154C17.8984 34.6639 18.2656 34.6326 18.3594 34.4607C18.4062 34.3592 18.4375 33.1014 18.4375 30.9061C18.4375 27.6014 18.4297 27.492 18.2812 27.3436C18.0859 27.1483 17.9531 27.1483 17.7891 27.328Z"
        fill="#FF0000"
      />
      <path
        d="M21.7188 27.3436C21.5703 27.492 21.5625 27.6014 21.5625 30.9061C21.5625 33.1014 21.5938 34.3592 21.6406 34.4607C21.7344 34.6326 22.1016 34.6639 22.25 34.5154C22.3203 34.4451 22.3438 33.5389 22.3438 30.9295V27.4295L22.1719 27.3123C21.9453 27.1561 21.9062 27.1561 21.7188 27.3436Z"
        fill="#FF0000"
      />
      <path
        d="M25.7188 27.3123L25.5469 27.4295V30.9295C25.5469 33.5389 25.5703 34.4451 25.6406 34.5154C25.7891 34.6639 26.1562 34.6326 26.25 34.4607C26.2969 34.3592 26.3281 33.0857 26.3281 30.867V27.4295L26.1562 27.3123C26.0625 27.242 25.9609 27.1873 25.9375 27.1873C25.9141 27.1873 25.8125 27.242 25.7188 27.3123Z"
        fill="#FF0000"
      />
      <path
        d="M29.6719 27.2734C29.5391 27.3438 29.5312 27.6016 29.5312 30.8828C29.5312 34.6016 29.5312 34.6094 29.875 34.6094C30.2891 34.6016 30.2734 34.7266 30.2734 30.9375C30.2734 27.5313 30.2656 27.4063 30.125 27.2969C29.9453 27.1719 29.8516 27.1641 29.6719 27.2734Z"
        fill="#FF0000"
      />
    </svg>
  );
}
LclModeIcon.propTypes = {
  size: PropTypes.string,
};
LclModeIcon.defaultProps = {
  size: '30',
};
export function InlandPrimaryIcon() {
  return (
    <svg
      width="40"
      height="40"
      viewBox="0 0 40 40"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M36.8647 15.6402H32.2657V8.44008C32.2657 7.67188 31.6401 7.04688 30.871 7.04688H1.39469C0.625703 7.04688 0 7.67188 0 8.44008V23.8234C0 24.5916 0.625625 25.2166 1.39469 25.2166H1.53016C1.52992 28.8324 1.53016 28.6935 1.53016 28.682C1.53016 29.4504 2.15539 30.0754 2.92383 30.0754H5.76648C5.97305 31.6934 7.35719 32.9489 9.03219 32.9489C10.7072 32.9489 12.0913 31.6933 12.2979 30.0754H13.0694C13.2759 31.6934 14.6601 32.9489 16.3351 32.9489C18.0101 32.9489 19.3942 31.6933 19.6008 30.0754H31.277C31.4835 31.6934 32.8677 32.9489 34.5429 32.9489C36.2179 32.9489 37.602 31.6933 37.8086 30.0754H38.5356C39.3413 30.0754 39.9968 29.4184 39.9968 28.6114C39.999 25.8034 39.9998 21.5385 40 18.7744C40.0005 17.0417 38.5979 15.6402 36.8647 15.6402ZM0.833281 23.8234V8.44008C0.833281 8.13141 1.08516 7.88016 1.39461 7.88016H30.8709C31.1804 7.88016 31.4323 8.13141 31.4323 8.44008V16.0437C31.4321 16.0484 31.4296 16.0522 31.4296 16.0569V24.3815C31.169 24.3815 34.6806 24.3813 1.39453 24.3833C1.08523 24.3833 0.833281 24.132 0.833281 23.8234ZM2.36344 26.6527H2.87875C3.01977 26.6527 3.1343 26.7669 3.1343 26.9073V27.5516C3.1343 27.692 3.01977 27.8061 2.87875 27.8061H2.36344V26.6527ZM9.03219 32.1156C7.67461 32.1156 6.57023 31.0129 6.57023 29.6576C6.57023 28.3022 7.67461 27.1995 9.03219 27.1995C10.3898 27.1995 11.4941 28.3023 11.4941 29.6576C11.4941 31.013 10.3898 32.1156 9.03219 32.1156ZM16.335 32.1156C14.9774 32.1156 13.873 31.0129 13.873 29.6576C13.873 28.3022 14.9774 27.1995 16.335 27.1995C17.6926 27.1995 18.797 28.3023 18.797 29.6576C18.797 31.013 17.6927 32.1156 16.335 32.1156ZM34.5428 32.1156C33.1852 32.1156 32.0806 31.0129 32.0806 29.6576C32.0806 28.3022 33.1852 27.1995 34.5428 27.1995C35.9005 27.1995 37.0048 28.3023 37.0048 29.6576C37.0048 31.013 35.9005 32.1156 34.5428 32.1156ZM39.1634 28.611C39.1634 28.9589 38.8819 29.2421 38.5355 29.2421H37.8089C37.6034 27.623 36.2187 26.3661 34.5428 26.3661C32.8668 26.3661 31.482 27.623 31.2765 29.2421H19.6011C19.3956 27.623 18.0109 26.3661 16.335 26.3661C14.6591 26.3661 13.2744 27.623 13.0689 29.2421H12.2982C12.0927 27.623 10.708 26.3661 9.03211 26.3661C7.35625 26.3661 5.97148 27.623 5.76602 29.2421H2.92375C2.61469 29.2421 2.36344 28.9909 2.36344 28.682V28.6395H2.87875C3.47914 28.6395 3.96766 28.1514 3.96766 27.5516V26.9073C3.96766 26.3075 3.47922 25.8194 2.87875 25.8194H2.36344V25.2166H31.8489C32.079 25.2166 32.2655 25.0301 32.2655 24.8V16.4735H36.8645C38.137 16.4735 39.1666 17.5016 39.1666 18.7744C39.1666 21.538 39.1656 25.803 39.1634 28.611ZM34.7636 22.9298C34.7636 23.1599 34.577 23.3465 34.347 23.3465H33.513C33.283 23.3465 33.0964 23.1599 33.0964 22.9298C33.0964 22.6998 33.283 22.5132 33.513 22.5132H34.347C34.577 22.5131 34.7636 22.6998 34.7636 22.9298ZM36.8647 17.3069H33.513C33.283 17.3069 33.0964 17.4934 33.0964 17.7235V21.2634C33.0964 21.4934 33.283 21.68 33.513 21.68H37.9166C38.1466 21.68 38.3332 21.4934 38.3332 21.2634L38.3334 18.7739C38.3334 17.9649 37.6792 17.3069 36.8647 17.3069ZM37.4998 20.8467H33.9297V18.1402H36.8646C37.2122 18.1402 37.5 18.4195 37.5 18.774L37.4998 20.8467ZM34.5428 28.0345C33.6576 28.0345 32.9373 28.7529 32.9373 29.6358C32.9373 30.519 33.6576 31.2373 34.5428 31.2373C35.428 31.2373 36.148 30.5189 36.148 29.6358C36.148 28.7527 35.428 28.0345 34.5428 28.0345ZM34.5428 30.404C34.117 30.404 33.7707 30.0594 33.7707 29.6358C33.7707 29.2122 34.117 28.8678 34.5428 28.8678C34.9684 28.8678 35.3147 29.2122 35.3147 29.6358C35.3148 30.0594 34.9684 30.404 34.5428 30.404ZM9.03219 28.0345C8.14695 28.0345 7.42695 28.7529 7.42695 29.6358C7.42695 30.519 8.14695 31.2373 9.03219 31.2373C9.91742 31.2373 10.6374 30.5189 10.6374 29.6358C10.6373 28.7527 9.91734 28.0345 9.03219 28.0345ZM9.03219 30.404C8.60656 30.404 8.26031 30.0594 8.26031 29.6358C8.26031 29.2122 8.60664 28.8678 9.03219 28.8678C9.45781 28.8678 9.80406 29.2122 9.80406 29.6358C9.80406 30.0594 9.45781 30.404 9.03219 30.404ZM16.335 28.0345C15.4498 28.0345 14.7298 28.7529 14.7298 29.6358C14.7298 30.519 15.4498 31.2373 16.335 31.2373C17.2202 31.2373 17.9402 30.5189 17.9402 29.6358C17.9402 28.7527 17.2202 28.0345 16.335 28.0345ZM16.335 30.404C15.9094 30.404 15.5631 30.0594 15.5631 29.6358C15.5631 29.2122 15.9095 28.8678 16.335 28.8678C16.7605 28.8678 17.1069 29.2122 17.1069 29.6358C17.107 30.0594 16.7606 30.404 16.335 30.404ZM3.14328 22.4265V9.83695C3.14328 9.60688 3.32984 9.42031 3.55992 9.42031C3.79 9.42031 3.97656 9.60688 3.97656 9.83695V22.4266C3.97656 22.6566 3.79 22.8432 3.55992 22.8432C3.32984 22.8432 3.14328 22.6566 3.14328 22.4265ZM6.28641 22.4265V9.83695C6.28641 9.60688 6.47297 9.42031 6.70305 9.42031C6.93313 9.42031 7.11969 9.60688 7.11969 9.83695V22.4266C7.11969 22.6566 6.93313 22.8432 6.70305 22.8432C6.47297 22.8432 6.28641 22.6566 6.28641 22.4265ZM9.42969 22.4265V9.83695C9.42969 9.60688 9.61625 9.42031 9.84633 9.42031C10.0764 9.42031 10.263 9.60688 10.263 9.83695V22.4266C10.263 22.6566 10.0764 22.8432 9.84633 22.8432C9.61633 22.8432 9.42969 22.6566 9.42969 22.4265ZM12.5728 22.4265V9.83695C12.5728 9.60688 12.7594 9.42031 12.9895 9.42031C13.2195 9.42031 13.4061 9.60688 13.4061 9.83695V22.4266C13.4061 22.6566 13.2195 22.8432 12.9895 22.8432C12.7594 22.8432 12.5728 22.6566 12.5728 22.4265ZM15.7162 22.4265V9.83695C15.7162 9.60688 15.9027 9.42031 16.1328 9.42031C16.3629 9.42031 16.5495 9.60688 16.5495 9.83695V22.4266C16.5495 22.6566 16.3629 22.8432 16.1328 22.8432C15.9027 22.8432 15.7162 22.6566 15.7162 22.4265ZM18.8595 22.4265V9.83695C18.8595 9.60688 19.046 9.42031 19.2761 9.42031C19.5062 9.42031 19.6927 9.60688 19.6927 9.83695V22.4266C19.6927 22.6566 19.5062 22.8432 19.2761 22.8432C19.046 22.8432 18.8595 22.6566 18.8595 22.4265ZM22.0026 22.4265V9.83695C22.0026 9.60688 22.1891 9.42031 22.4192 9.42031C22.6493 9.42031 22.8359 9.60688 22.8359 9.83695V22.4266C22.8359 22.6566 22.6493 22.8432 22.4192 22.8432C22.1891 22.8432 22.0026 22.6566 22.0026 22.4265ZM25.1459 22.4265V9.83695C25.1459 9.60688 25.3324 9.42031 25.5625 9.42031C25.7926 9.42031 25.9791 9.60688 25.9791 9.83695V22.4266C25.9791 22.6566 25.7926 22.8432 25.5625 22.8432C25.3324 22.8432 25.1459 22.6566 25.1459 22.4265ZM28.289 22.4265V9.83695C28.289 9.60688 28.4755 9.42031 28.7056 9.42031C28.9357 9.42031 29.1223 9.60688 29.1223 9.83695V22.4266C29.1223 22.6566 28.9357 22.8432 28.7056 22.8432C28.4755 22.8432 28.289 22.6566 28.289 22.4265Z"
        fill="#E17084"
      />
    </svg>
  );
}
export function DowbleCheck({ color, size }) {
  return (
    <svg
      width={size !== '' ? size : '20'}
      height={size !== '' ? size : '11'}
      viewBox="0 0 20 11"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M9.6685 7.46659L10.8452 8.64325L17.9002 1.58825L19.0785 2.76659L10.8452 10.9999L5.54183 5.69659L6.72016 4.51826L8.491 6.28909L9.6685 7.46575V7.46659ZM9.67016 5.10992L13.7968 0.982422L14.9718 2.15742L10.8452 6.28492L9.67016 5.10992ZM7.31433 9.82242L6.13683 10.9999L0.833496 5.69659L2.01183 4.51826L3.18933 5.69576L3.1885 5.69659L7.31433 9.82242Z"
        fill={color !== '' ? color : 'white'}
      />
    </svg>
  );
}
DowbleCheck.propTypes = {
  color: PropTypes.string,
  size: PropTypes.string,
};
DowbleCheck.defaultProps = {
  color: '',
  size: '',
};

export function InfoIcon({ width, height, color }) {
  return (
    <svg
      version="1.1"
      id="Layer_1"
      xmlns="http://www.w3.org/2000/svg"
      x="0px"
      y="0px"
      viewBox="0 0 330 330"
      width={width}
      height={height}
      fill={color}
    >
      <g>
        <g>
          <g>
            <path
              d="M165,0.008C74.019,0.008,0,74.024,0,164.999c0,90.977,74.019,164.992,165,164.992s165-74.015,165-164.992
				C330,74.024,255.981,0.008,165,0.008z M165,299.992c-74.439,0-135-60.557-135-134.992S90.561,30.008,165,30.008
				s135,60.557,135,134.991C300,239.436,239.439,299.992,165,299.992z"
            />
            <path
              d="M165,130.008c-8.284,0-15,6.716-15,15v99.983c0,8.284,6.716,15,15,15s15-6.716,15-15v-99.983
				C180,136.725,173.284,130.008,165,130.008z"
            />
            <path
              d="M165,70.011c-3.95,0-7.811,1.6-10.61,4.39c-2.79,2.79-4.39,6.66-4.39,10.61s1.6,7.81,4.39,10.61
				c2.79,2.79,6.66,4.39,10.61,4.39s7.81-1.6,10.609-4.39c2.79-2.8,4.391-6.66,4.391-10.61s-1.601-7.82-4.391-10.61
				C172.81,71.61,168.95,70.011,165,70.011z"
            />
          </g>
        </g>
      </g>
    </svg>
  );
}
InfoIcon.propTypes = {
  color: PropTypes.string,
  width: PropTypes.string,
  height: PropTypes.string,
};
InfoIcon.defaultProps = {
  color: '',
  width: '',
  height: '',
};
export function BuyerIcon({ size }) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 22 22"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M9.47162 0.0623531C9.2047 0.148304 9.04971 0.23855 8.86027 0.431936C8.52016 0.767139 8.42113 1.12813 8.41683 1.98332V2.43885L7.97769 2.59786C7.73229 2.68811 7.36203 2.84282 7.14677 2.94166L6.75929 3.12645L6.30294 2.68811C5.71311 2.12084 5.55812 2.04349 5.01566 2.04349C4.4043 2.04349 4.33112 2.09506 3.20313 3.22099C2.07515 4.34693 2.02348 4.41998 2.02348 5.03023C2.02348 5.39551 2.0364 5.46427 2.14834 5.67055C2.21292 5.79947 2.45401 6.096 2.6865 6.33666L3.10841 6.7707L2.92329 7.15747C2.82427 7.36805 2.66928 7.74193 2.57886 7.98259L2.41957 8.42523H1.96321C1.10215 8.42952 0.744814 8.52837 0.404697 8.86787C0.305675 8.96671 0.172211 9.1558 0.111937 9.28472L0 9.52108V11.0037V12.4863L0.111937 12.7227C0.172211 12.8516 0.305675 13.0407 0.404697 13.1395C0.744814 13.479 1.10215 13.5779 1.96321 13.5822H2.41957L2.57886 14.0248C2.66928 14.2655 2.82427 14.6351 2.92329 14.8499L3.10841 15.2367L2.66928 15.6922C2.10098 16.281 2.02348 16.4357 2.02348 16.9772C2.02348 17.5874 2.07515 17.6648 3.20313 18.7864C4.33112 19.9124 4.4043 19.9639 5.01566 19.9639C5.3816 19.9639 5.45049 19.951 5.65714 19.8393C5.7863 19.7748 6.08337 19.5342 6.32446 19.3021L6.75929 18.881L7.14677 19.0658C7.36203 19.1646 7.73229 19.3193 7.97769 19.4096L8.41683 19.5686V20.0241C8.42113 20.8836 8.52016 21.2403 8.86027 21.5798C8.9593 21.6786 9.14873 21.8118 9.27789 21.872L9.51468 21.9837L10.9053 21.9966C12.4423 22.0095 12.5714 21.9966 12.9417 21.7517C13.1656 21.6013 13.3808 21.3176 13.4798 21.0512C13.5229 20.9309 13.5573 20.6429 13.5703 20.2132L13.5961 19.5643L14.0309 19.4053C14.272 19.3236 14.6423 19.1689 14.8532 19.0658L15.2407 18.881L15.6971 19.3193C16.2869 19.8866 16.4419 19.9639 16.9843 19.9639C17.5957 19.9639 17.6732 19.9124 18.7969 18.7907C19.9249 17.6605 19.9765 17.5874 19.9765 16.9772C19.9765 16.4357 19.899 16.281 19.3307 15.6922L18.8916 15.2367L19.0767 14.8499C19.1757 14.6351 19.3307 14.2655 19.4211 14.0205L19.5804 13.5822H20.0368C20.8978 13.5779 21.2552 13.479 21.5953 13.1395C21.6943 13.0407 21.8278 12.8516 21.8881 12.7227L22 12.4863V11.0037V9.52108L21.8881 9.28472C21.8278 9.1558 21.6943 8.96671 21.5953 8.86787C21.2552 8.52837 20.8978 8.42952 20.0368 8.42523H19.5804L19.4211 7.98259C19.3307 7.74193 19.1757 7.36805 19.0767 7.15747L18.8916 6.7707L19.3307 6.31517C19.899 5.72642 19.9765 5.57171 19.9765 5.03023C19.9765 4.41998 19.9249 4.34693 18.7969 3.2167C17.6732 2.09506 17.5957 2.04349 16.9843 2.04349C16.6184 2.04349 16.5495 2.05638 16.3429 2.16811C16.2137 2.23257 15.9166 2.47323 15.6755 2.70959L15.2407 3.12645L14.8532 2.94166C14.6423 2.83852 14.272 2.68381 14.0309 2.60216L13.5961 2.44315L13.5703 1.79423C13.5573 1.36449 13.5229 1.07656 13.4798 0.956226C13.3249 0.530777 12.9675 0.195576 12.5327 0.0666504C12.2485 -0.0192986 9.73855 -0.0235958 9.47162 0.0623531ZM12.4423 3.82694C13.4239 4.03751 14.4485 4.47585 15.2192 5.02163C15.7444 5.39121 16.6227 6.2679 16.993 6.79219C17.544 7.56573 17.9789 8.57994 18.1984 9.58554C18.2802 9.98091 18.2931 10.1571 18.2931 11.0037C18.2931 11.8503 18.2802 12.0265 18.1984 12.4219C17.9789 13.4275 17.544 14.4417 16.993 15.2152C16.6227 15.7395 15.7444 16.6162 15.2192 16.9858C14.4442 17.5359 13.4282 17.9699 12.4207 18.1891C12.0247 18.2707 11.8481 18.2836 11 18.2836C10.1519 18.2836 9.97534 18.2707 9.57926 18.1891C8.57182 17.9699 7.55577 17.5359 6.78082 16.9858C6.25558 16.6162 5.3773 15.7395 5.00704 15.2152C4.45597 14.4417 4.02113 13.4275 3.80157 12.4219C3.71976 12.0265 3.70685 11.8503 3.70685 11.0037C3.70685 10.1571 3.71976 9.98091 3.80157 9.58554C4.11585 8.15449 4.74012 6.96409 5.72603 5.94129C6.84971 4.77238 8.27906 4.02892 9.91076 3.76247C10.4834 3.66793 11.874 3.70231 12.4423 3.82694Z"
        fill="#828282"
      />
      <path
        d="M9.85897 4.20941C9.37248 4.29536 9.04528 4.38561 8.61044 4.54462C8.26602 4.67354 7.81396 4.88841 7.81396 4.92709C7.81396 4.98296 8.55447 6.23352 8.58892 6.23352C8.60614 6.23352 8.74391 6.17765 8.89459 6.1046C9.27776 5.9327 9.82453 5.77799 10.3239 5.71353L10.7416 5.66196V4.89271V4.12776L10.5177 4.13206C10.3928 4.13206 10.0958 4.17074 9.85897 4.20941Z"
        fill="#828282"
      />
      <path
        d="M11.2583 4.88841V5.66196L11.6759 5.71353C12.1538 5.77799 12.6833 5.91981 13.1182 6.1046C13.2861 6.17765 13.4239 6.23352 13.4325 6.23352C13.454 6.23352 14.1859 4.95717 14.1859 4.9185C14.1859 4.86693 13.5616 4.59189 13.1311 4.45007C12.692 4.30825 12.0289 4.17503 11.5984 4.14065L11.2583 4.11487V4.88841Z"
        fill="#828282"
      />
      <path
        d="M6.90149 5.46426C6.44513 5.80376 5.79073 6.45698 5.45061 6.91251C5.30854 7.11019 5.18799 7.28639 5.18799 7.30788C5.18799 7.33796 6.44513 8.08142 6.49679 8.08142C6.50541 8.08142 6.64317 7.91812 6.79816 7.72043C7.10384 7.33366 7.52145 6.9254 7.85726 6.69764C7.97351 6.62028 8.07253 6.53863 8.07253 6.51714C8.07253 6.45698 7.33632 5.20212 7.29758 5.20212C7.27605 5.20212 7.09953 5.32245 6.90149 5.46426Z"
        fill="#828282"
      />
      <path
        d="M14.289 5.85535L13.9102 6.50857L14.0565 6.61601C14.5861 7.02427 14.9133 7.35087 15.374 7.93103L15.5031 8.09863L16.1575 7.72046C16.5192 7.51418 16.8119 7.32509 16.8119 7.3079C16.8119 7.21765 16.2436 6.51716 15.8691 6.14328C15.4945 5.7694 14.7927 5.20214 14.7023 5.20214C14.6851 5.20214 14.4957 5.49437 14.289 5.85535Z"
        fill="#828282"
      />
      <path
        d="M4.71429 8.17596C4.4 8.85496 4.18043 9.68867 4.12446 10.4063L4.09863 10.7458H4.87358H5.64854L5.7002 10.329C5.76478 9.85198 5.90685 9.32339 6.09198 8.88934C6.16517 8.72174 6.22114 8.58422 6.22114 8.57563C6.22114 8.56703 6.09198 8.48968 5.93268 8.39943C5.76908 8.31348 5.48063 8.14588 5.2912 8.03415C5.09746 7.91812 4.92525 7.82357 4.90803 7.82357C4.89511 7.82357 4.8047 7.98258 4.71429 8.17596Z"
        fill="#828282"
      />
      <path
        d="M16.4677 8.16737C16.1491 8.35646 15.8606 8.52406 15.8305 8.54125C15.7831 8.56703 15.8004 8.64009 15.9037 8.88075C16.0931 9.32339 16.2352 9.84768 16.2998 10.329L16.3514 10.7458H17.1264H17.9013L17.8712 10.3892C17.8324 9.93793 17.7033 9.3019 17.5612 8.87215C17.4278 8.46389 17.135 7.82357 17.0833 7.82787C17.0661 7.82787 16.7863 7.98258 16.4677 8.16737Z"
        fill="#828282"
      />
      <path
        d="M4.12877 11.614C4.17182 12.1211 4.30098 12.7313 4.4818 13.2427C4.63249 13.681 4.86497 14.1838 4.91233 14.1838C4.95538 14.1838 6.22114 13.449 6.22114 13.4232C6.22114 13.4146 6.16517 13.2728 6.09628 13.1138C5.91116 12.7012 5.76478 12.1597 5.7002 11.6784L5.64854 11.2616H4.87358H4.09863L4.12877 11.614Z"
        fill="#828282"
      />
      <path
        d="M16.2997 11.6784C16.2352 12.1554 16.0931 12.684 15.908 13.1181C15.8348 13.2857 15.7788 13.4275 15.7788 13.4318C15.7788 13.4533 17.0618 14.1838 17.0919 14.1838C17.135 14.1838 17.4406 13.5005 17.5612 13.1353C17.7033 12.7055 17.8324 12.0695 17.8712 11.614L17.9013 11.2616H17.1264H16.3514L16.2997 11.6784Z"
        fill="#828282"
      />
      <path
        d="M5.83361 14.2913C5.48919 14.489 5.20504 14.6695 5.19643 14.6909C5.1706 14.7683 5.72168 15.4559 6.13068 15.8642C6.50524 16.238 7.207 16.8053 7.29741 16.8053C7.33616 16.8053 8.07236 15.5504 8.07236 15.4903C8.07236 15.4688 7.97334 15.3871 7.8571 15.3098C7.52129 15.082 7.10367 14.6738 6.798 14.287C6.64301 14.0893 6.50093 13.926 6.48802 13.926C6.4708 13.926 6.17804 14.0936 5.83361 14.2913Z"
        fill="#828282"
      />
      <path
        d="M15.2064 14.2784C14.9007 14.6695 14.608 14.9617 14.199 15.2711C14.0483 15.3871 13.9277 15.486 13.9277 15.4989C13.9277 15.5504 14.6725 16.8053 14.7027 16.8053C14.7931 16.8053 15.4949 16.238 15.8694 15.8642C16.244 15.4903 16.8123 14.7898 16.8123 14.6995C16.8123 14.6695 15.5594 13.926 15.5078 13.926C15.4949 13.926 15.3614 14.085 15.2064 14.2784Z"
        fill="#828282"
      />
      <path
        d="M8.18422 16.4142C7.98187 16.7666 7.81396 17.0675 7.81396 17.0847C7.81396 17.1276 8.48128 17.4285 8.86445 17.5531C9.29498 17.6949 9.93216 17.8238 10.3885 17.8625L10.7416 17.8926V17.119V16.3455L10.3239 16.2939C9.82453 16.2295 9.27776 16.0747 8.89459 15.9029C8.74391 15.8298 8.60614 15.7739 8.58892 15.7739C8.57169 15.7739 8.38657 16.0619 8.18422 16.4142Z"
        fill="#828282"
      />
      <path
        d="M13.1053 15.9029C12.6877 16.0833 12.1581 16.2295 11.6759 16.2939L11.2583 16.3455V17.119V17.8926L11.6156 17.8625C12.0806 17.8238 12.7264 17.6906 13.1655 17.5445C13.6176 17.3898 14.1859 17.1405 14.1859 17.089C14.1859 17.0331 13.4497 15.7739 13.4196 15.7782C13.4023 15.7782 13.2603 15.8384 13.1053 15.9029Z"
        fill="#828282"
      />
      <path
        d="M12.5084 10.75C12.8926 10.8318 13.2012 11.0235 13.4342 11.3253C13.6672 11.6207 13.7837 11.9602 13.7837 12.3437C13.7837 12.8969 13.5885 13.337 13.198 13.6639C12.8138 13.9845 12.2754 14.1448 11.5826 14.1448H8.49341V7.52502H11.4787C12.1526 7.52502 12.6784 7.67905 13.0563 7.98709C13.4405 8.29513 13.6326 8.71319 13.6326 9.24126C13.6326 9.63103 13.5287 9.95479 13.3208 10.2125C13.1193 10.4703 12.8485 10.6495 12.5084 10.75ZM10.1088 10.2031H11.1669C11.4314 10.2031 11.633 10.1465 11.7715 10.0334C11.9164 9.91393 11.9888 9.74104 11.9888 9.51473C11.9888 9.28841 11.9164 9.11553 11.7715 8.99609C11.633 8.87664 11.4314 8.81692 11.1669 8.81692H10.1088V10.2031ZM11.2992 12.8435C11.57 12.8435 11.7778 12.7838 11.9227 12.6643C12.0738 12.5386 12.1494 12.3594 12.1494 12.1268C12.1494 11.8942 12.0707 11.7119 11.9132 11.5799C11.7621 11.4479 11.5511 11.3818 11.2803 11.3818H10.1088V12.8435H11.2992Z"
        fill="#828282"
      />
    </svg>
  );
}
BuyerIcon.propTypes = {
  size: PropTypes.string,
};
BuyerIcon.defaultProps = {
  size: '1.528vw',
};
export function BuyerIconActive({ size }) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 22 22"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M9.47162 0.0623531C9.2047 0.148304 9.04971 0.23855 8.86027 0.431936C8.52016 0.767139 8.42113 1.12813 8.41683 1.98332V2.43885L7.97769 2.59786C7.73229 2.68811 7.36203 2.84282 7.14677 2.94166L6.75929 3.12645L6.30294 2.68811C5.71311 2.12084 5.55812 2.04349 5.01566 2.04349C4.4043 2.04349 4.33112 2.09506 3.20313 3.22099C2.07515 4.34693 2.02348 4.41998 2.02348 5.03023C2.02348 5.39551 2.0364 5.46427 2.14834 5.67055C2.21292 5.79947 2.45401 6.096 2.6865 6.33666L3.10841 6.7707L2.92329 7.15747C2.82427 7.36805 2.66928 7.74193 2.57886 7.98259L2.41957 8.42523H1.96321C1.10215 8.42952 0.744814 8.52837 0.404697 8.86787C0.305675 8.96671 0.172211 9.1558 0.111937 9.28472L0 9.52108V11.0037V12.4863L0.111937 12.7227C0.172211 12.8516 0.305675 13.0407 0.404697 13.1395C0.744814 13.479 1.10215 13.5779 1.96321 13.5822H2.41957L2.57886 14.0248C2.66928 14.2655 2.82427 14.6351 2.92329 14.8499L3.10841 15.2367L2.66928 15.6922C2.10098 16.281 2.02348 16.4357 2.02348 16.9772C2.02348 17.5874 2.07515 17.6648 3.20313 18.7864C4.33112 19.9124 4.4043 19.9639 5.01566 19.9639C5.3816 19.9639 5.45049 19.951 5.65714 19.8393C5.7863 19.7748 6.08337 19.5342 6.32446 19.3021L6.75929 18.881L7.14677 19.0658C7.36203 19.1646 7.73229 19.3193 7.97769 19.4096L8.41683 19.5686V20.0241C8.42113 20.8836 8.52016 21.2403 8.86027 21.5798C8.9593 21.6786 9.14873 21.8118 9.27789 21.872L9.51468 21.9837L10.9053 21.9966C12.4423 22.0095 12.5714 21.9966 12.9417 21.7517C13.1656 21.6013 13.3808 21.3176 13.4798 21.0512C13.5229 20.9309 13.5573 20.6429 13.5703 20.2132L13.5961 19.5643L14.0309 19.4053C14.272 19.3236 14.6423 19.1689 14.8532 19.0658L15.2407 18.881L15.6971 19.3193C16.2869 19.8866 16.4419 19.9639 16.9843 19.9639C17.5957 19.9639 17.6732 19.9124 18.7969 18.7907C19.9249 17.6605 19.9765 17.5874 19.9765 16.9772C19.9765 16.4357 19.899 16.281 19.3307 15.6922L18.8916 15.2367L19.0767 14.8499C19.1757 14.6351 19.3307 14.2655 19.4211 14.0205L19.5804 13.5822H20.0368C20.8978 13.5779 21.2552 13.479 21.5953 13.1395C21.6943 13.0407 21.8278 12.8516 21.8881 12.7227L22 12.4863V11.0037V9.52108L21.8881 9.28472C21.8278 9.1558 21.6943 8.96671 21.5953 8.86787C21.2552 8.52837 20.8978 8.42952 20.0368 8.42523H19.5804L19.4211 7.98259C19.3307 7.74193 19.1757 7.36805 19.0767 7.15747L18.8916 6.7707L19.3307 6.31517C19.899 5.72642 19.9765 5.57171 19.9765 5.03023C19.9765 4.41998 19.9249 4.34693 18.7969 3.2167C17.6732 2.09506 17.5957 2.04349 16.9843 2.04349C16.6184 2.04349 16.5495 2.05638 16.3429 2.16811C16.2137 2.23257 15.9166 2.47323 15.6755 2.70959L15.2407 3.12645L14.8532 2.94166C14.6423 2.83852 14.272 2.68381 14.0309 2.60216L13.5961 2.44315L13.5703 1.79423C13.5573 1.36449 13.5229 1.07656 13.4798 0.956226C13.3249 0.530777 12.9675 0.195576 12.5327 0.0666504C12.2485 -0.0192986 9.73855 -0.0235958 9.47162 0.0623531ZM12.4423 3.82694C13.4239 4.03751 14.4485 4.47585 15.2192 5.02163C15.7444 5.39121 16.6227 6.2679 16.993 6.79219C17.544 7.56573 17.9789 8.57994 18.1984 9.58554C18.2802 9.98091 18.2931 10.1571 18.2931 11.0037C18.2931 11.8503 18.2802 12.0265 18.1984 12.4219C17.9789 13.4275 17.544 14.4417 16.993 15.2152C16.6227 15.7395 15.7444 16.6162 15.2192 16.9858C14.4442 17.5359 13.4282 17.9699 12.4207 18.1891C12.0247 18.2707 11.8481 18.2836 11 18.2836C10.1519 18.2836 9.97534 18.2707 9.57926 18.1891C8.57182 17.9699 7.55577 17.5359 6.78082 16.9858C6.25558 16.6162 5.3773 15.7395 5.00704 15.2152C4.45597 14.4417 4.02113 13.4275 3.80157 12.4219C3.71976 12.0265 3.70685 11.8503 3.70685 11.0037C3.70685 10.1571 3.71976 9.98091 3.80157 9.58554C4.11585 8.15449 4.74012 6.96409 5.72603 5.94129C6.84971 4.77238 8.27906 4.02892 9.91076 3.76247C10.4834 3.66793 11.874 3.70231 12.4423 3.82694Z"
        fill="#ffffff"
      />
      <path
        d="M9.85897 4.20941C9.37248 4.29535 9.04528 4.3856 8.61044 4.54461C8.26602 4.67353 7.81396 4.88841 7.81396 4.92708C7.81396 4.98295 8.55447 6.23351 8.58892 6.23351C8.60614 6.23351 8.74391 6.17765 8.89459 6.10459C9.27776 5.93269 9.82453 5.77798 10.3239 5.71352L10.7416 5.66195V4.8927V4.12775L10.5177 4.13205C10.3928 4.13205 10.0958 4.17073 9.85897 4.20941Z"
        fill="#ffffff"
      />
      <path
        d="M11.2583 4.88841V5.66195L11.6759 5.71352C12.1538 5.77798 12.6833 5.9198 13.1182 6.10459C13.2861 6.17765 13.4239 6.23351 13.4325 6.23351C13.454 6.23351 14.1859 4.95716 14.1859 4.91849C14.1859 4.86692 13.5616 4.59188 13.1311 4.45006C12.692 4.30825 12.0289 4.17503 11.5984 4.14065L11.2583 4.11486V4.88841Z"
        fill="#ffffff"
      />
      <path
        d="M6.90149 5.46427C6.44513 5.80377 5.79073 6.45699 5.45061 6.91252C5.30854 7.1102 5.18799 7.2864 5.18799 7.30788C5.18799 7.33797 6.44513 8.08143 6.49679 8.08143C6.50541 8.08143 6.64317 7.91812 6.79816 7.72044C7.10384 7.33367 7.52145 6.92541 7.85726 6.69764C7.97351 6.62029 8.07253 6.53864 8.07253 6.51715C8.07253 6.45699 7.33632 5.20212 7.29758 5.20212C7.27605 5.20212 7.09953 5.32245 6.90149 5.46427Z"
        fill="#ffffff"
      />
      <path
        d="M14.289 5.85534L13.9102 6.50855L14.0565 6.61599C14.5861 7.02425 14.9133 7.35086 15.374 7.93102L15.5031 8.09862L16.1575 7.72044C16.5192 7.51416 16.8119 7.32507 16.8119 7.30788C16.8119 7.21764 16.2436 6.51715 15.8691 6.14327C15.4945 5.76939 14.7927 5.20212 14.7023 5.20212C14.6851 5.20212 14.4957 5.49435 14.289 5.85534Z"
        fill="#ffffff"
      />
      <path
        d="M4.71429 8.17598C4.4 8.85498 4.18043 9.68869 4.12446 10.4064L4.09863 10.7459H4.87358H5.64854L5.7002 10.329C5.76478 9.85199 5.90685 9.3234 6.09198 8.88936C6.16517 8.72176 6.22114 8.58424 6.22114 8.57564C6.22114 8.56705 6.09198 8.48969 5.93268 8.39945C5.76908 8.3135 5.48063 8.1459 5.2912 8.03416C5.09746 7.91813 4.92525 7.82359 4.90803 7.82359C4.89511 7.82359 4.8047 7.98259 4.71429 8.17598Z"
        fill="#ffffff"
      />
      <path
        d="M16.4677 8.16738C16.1491 8.35647 15.8606 8.52407 15.8305 8.54126C15.7831 8.56705 15.8004 8.64011 15.9037 8.88076C16.0931 9.3234 16.2352 9.84769 16.2998 10.329L16.3514 10.7459H17.1264H17.9013L17.8712 10.3892C17.8324 9.93794 17.7033 9.30192 17.5612 8.87217C17.4278 8.46391 17.135 7.82359 17.0833 7.82788C17.0661 7.82788 16.7863 7.98259 16.4677 8.16738Z"
        fill="#ffffff"
      />
      <path
        d="M4.12877 11.6139C4.17182 12.121 4.30098 12.7313 4.4818 13.2427C4.63249 13.681 4.86497 14.1838 4.91233 14.1838C4.95538 14.1838 6.22114 13.449 6.22114 13.4232C6.22114 13.4146 6.16517 13.2728 6.09628 13.1138C5.91116 12.7012 5.76478 12.1597 5.7002 11.6784L5.64854 11.2616H4.87358H4.09863L4.12877 11.6139Z"
        fill="#ffffff"
      />
      <path
        d="M16.2997 11.6784C16.2352 12.1554 16.0931 12.684 15.908 13.1181C15.8348 13.2857 15.7788 13.4275 15.7788 13.4318C15.7788 13.4533 17.0618 14.1838 17.0919 14.1838C17.135 14.1838 17.4406 13.5005 17.5612 13.1352C17.7033 12.7055 17.8324 12.0695 17.8712 11.6139L17.9013 11.2616H17.1264H16.3514L16.2997 11.6784Z"
        fill="#ffffff"
      />
      <path
        d="M5.83361 14.2913C5.48919 14.489 5.20504 14.6694 5.19643 14.6909C5.1706 14.7683 5.72168 15.4559 6.13068 15.8641C6.50524 16.238 7.207 16.8053 7.29741 16.8053C7.33616 16.8053 8.07236 15.5504 8.07236 15.4903C8.07236 15.4688 7.97334 15.3871 7.8571 15.3098C7.52129 15.082 7.10367 14.6737 6.798 14.287C6.64301 14.0893 6.50093 13.926 6.48802 13.926C6.4708 13.926 6.17804 14.0936 5.83361 14.2913Z"
        fill="#ffffff"
      />
      <path
        d="M15.2064 14.2784C14.9007 14.6694 14.608 14.9617 14.199 15.2711C14.0483 15.3871 13.9277 15.486 13.9277 15.4989C13.9277 15.5504 14.6725 16.8053 14.7027 16.8053C14.7931 16.8053 15.4949 16.238 15.8694 15.8641C16.244 15.4903 16.8123 14.7898 16.8123 14.6995C16.8123 14.6694 15.5594 13.926 15.5078 13.926C15.4949 13.926 15.3614 14.085 15.2064 14.2784Z"
        fill="#ffffff"
      />
      <path
        d="M8.18422 16.4142C7.98187 16.7666 7.81396 17.0674 7.81396 17.0846C7.81396 17.1276 8.48128 17.4284 8.86445 17.553C9.29498 17.6949 9.93216 17.8238 10.3885 17.8625L10.7416 17.8925V17.119V16.3455L10.3239 16.2939C9.82453 16.2294 9.27776 16.0747 8.89459 15.9028C8.74391 15.8298 8.60614 15.7739 8.58892 15.7739C8.57169 15.7739 8.38657 16.0618 8.18422 16.4142Z"
        fill="#ffffff"
      />
      <path
        d="M13.1053 15.9028C12.6877 16.0833 12.1581 16.2294 11.6759 16.2939L11.2583 16.3455V17.119V17.8925L11.6156 17.8625C12.0806 17.8238 12.7264 17.6906 13.1655 17.5445C13.6176 17.3897 14.1859 17.1405 14.1859 17.0889C14.1859 17.0331 13.4497 15.7739 13.4196 15.7782C13.4023 15.7782 13.2603 15.8384 13.1053 15.9028Z"
        fill="#ffffff"
      />
      <path
        d="M12.5084 10.7501C12.8926 10.8318 13.2012 11.0235 13.4342 11.3253C13.6672 11.6208 13.7837 11.9602 13.7837 12.3437C13.7837 12.8969 13.5885 13.337 13.198 13.6639C12.8138 13.9845 12.2754 14.1448 11.5826 14.1448H8.49341V7.52505H11.4787C12.1526 7.52505 12.6784 7.67907 13.0563 7.98711C13.4405 8.29515 13.6326 8.71321 13.6326 9.24128C13.6326 9.63105 13.5287 9.95481 13.3208 10.2126C13.1193 10.4703 12.8485 10.6495 12.5084 10.7501ZM10.1088 10.2031H11.1669C11.4314 10.2031 11.633 10.1466 11.7715 10.0334C11.9164 9.91395 11.9888 9.74107 11.9888 9.51475C11.9888 9.28843 11.9164 9.11555 11.7715 8.99611C11.633 8.87666 11.4314 8.81694 11.1669 8.81694H10.1088V10.2031ZM11.2992 12.8435C11.57 12.8435 11.7778 12.7838 11.9227 12.6643C12.0738 12.5386 12.1494 12.3594 12.1494 12.1268C12.1494 11.8942 12.0707 11.7119 11.9132 11.5799C11.7621 11.4479 11.5511 11.3819 11.2803 11.3819H10.1088V12.8435H11.2992Z"
        fill="#ffffff"
      />
    </svg>
  );
}
BuyerIconActive.propTypes = {
  size: PropTypes.string,
};
BuyerIconActive.defaultProps = {
  size: '1.528vw',
};
export function SupplierIcon({ size }) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 23 22"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M5.5826 2.06241C2.53673 3.20244 0.043457 4.14666 0.043457 4.15971C0.043457 4.17276 2.54108 5.11699 5.59131 6.25701L11.1392 8.33691L13.2147 7.55804L15.2946 6.77917L15.0553 6.67038C14.9247 6.61382 13.9892 6.22656 12.9754 5.80884C11.2436 5.09958 11.1392 5.04737 11.2566 4.9995C11.3219 4.9734 11.9528 4.70797 12.6534 4.40773L13.9283 3.86383L16.0082 4.79499L18.0925 5.73051L20.1637 4.95599C21.3037 4.52957 22.2349 4.17276 22.2349 4.15971C22.2349 4.14231 11.3437 0.0521269 11.1609 -8.7738e-05C11.1392 -0.00879002 8.62413 0.922378 5.5826 2.06241Z"
        fill="#828282"
      />
      <path
        d="M0.00870251 11.8223L0.0217563 18.0925L5.2215 20.0418L10.4213 21.9912L10.4343 15.7428C10.4387 12.3053 10.43 9.48136 10.4126 9.4683C10.3908 9.4509 8.1673 8.61111 5.46082 7.59726C2.7587 6.58342 0.422072 5.70882 0.269778 5.6566L0 5.55218L0.00870251 11.8223ZM4.1772 16.1214L5.54785 16.6348L5.5609 17.3789C5.56525 17.7923 5.56525 18.1273 5.5609 18.1273C5.5522 18.1273 4.92997 17.8967 4.1772 17.6095L2.80656 17.0961L2.79351 16.352C2.78915 15.9386 2.78915 15.6036 2.79351 15.6036C2.80221 15.6036 3.42444 15.8342 4.1772 16.1214Z"
        fill="#828282"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M18.123 7.11008L20.1899 6.33556L22.2567 5.56104L22.2698 11.8094C22.2741 15.2469 22.2654 18.0709 22.248 18.0839C22.2262 18.1013 20.0028 18.9411 17.2963 19.955C14.5941 20.9688 12.2575 21.8434 12.1052 21.8956L11.8354 22.0001L11.8442 15.7299L11.8572 9.45976L13.576 8.81577L15.2947 8.17179L15.3077 9.90794C15.3121 10.8609 15.3208 11.6441 15.3295 11.6441C15.3339 11.6441 15.9561 11.4135 16.7089 11.1263L18.0795 10.6128L18.1013 8.86364L18.123 7.11008ZM15.9788 18.5532C16.3599 18.5885 16.7913 18.5137 17.273 18.3288C17.7405 18.1493 18.1485 17.9133 18.4969 17.6207C18.8525 17.3178 19.1235 16.9868 19.3101 16.6278C19.5037 16.266 19.602 15.903 19.605 15.5388C19.6014 15.1242 19.4978 14.8312 19.2945 14.6596C19.0982 14.4778 18.8625 14.3792 18.5872 14.3638C18.3119 14.3485 17.9622 14.3655 17.5381 14.4148C17.1211 14.4614 16.8138 14.4697 16.6164 14.4396C16.4189 14.4019 16.3211 14.2769 16.3228 14.0644C16.3244 13.8747 16.3964 13.6996 16.539 13.539C16.6886 13.3756 16.898 13.2423 17.1672 13.139C17.4577 13.0275 17.6873 13.015 17.8561 13.1015C18.032 13.1776 18.1295 13.3369 18.1487 13.5791L19.5726 13.0325C19.5353 12.4115 19.3092 11.9953 18.8943 11.7839C18.4795 11.5649 17.9214 11.5901 17.2201 11.8593C16.7455 12.0415 16.3304 12.284 15.9748 12.5869C15.6263 12.8871 15.3553 13.2181 15.1616 13.5798C14.9751 13.9388 14.8804 14.2929 14.8775 14.6419C14.874 15.0668 14.9704 15.3664 15.1667 15.5407C15.3701 15.7122 15.6095 15.8056 15.8847 15.821C16.1671 15.8336 16.5274 15.8125 16.9657 15.7578C17.3897 15.716 17.6969 15.7115 17.8873 15.7443C18.0849 15.7669 18.1828 15.8805 18.1811 16.0854C18.1796 16.2751 18.0968 16.4619 17.9329 16.6459C17.7761 16.8271 17.556 16.9721 17.2726 17.0809C16.9822 17.1924 16.7384 17.2065 16.5414 17.1233C16.3514 17.0374 16.2433 16.8784 16.2169 16.6465L14.7187 17.2216C14.7367 17.6005 14.8543 17.9071 15.0713 18.1414C15.2953 18.3731 15.5979 18.5104 15.9788 18.5532Z"
        fill="#828282"
      />
    </svg>
  );
}
SupplierIcon.propTypes = {
  size: PropTypes.string,
};
SupplierIcon.defaultProps = {
  size: '1.528vw',
};
export function SupplierIconActive({ color, size }) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 23 22"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        className="bg"
        d="M5.5826 2.06256C2.53673 3.20259 0.043457 4.14681 0.043457 4.15986C0.043457 4.17292 2.54108 5.11714 5.59131 6.25717L11.1392 8.33707L13.2147 7.55819L15.2946 6.77932L15.0553 6.67054C14.9247 6.61397 13.9892 6.22671 12.9754 5.80899C11.2436 5.09973 11.1392 5.04752 11.2566 4.99966C11.3219 4.97355 11.9528 4.70812 12.6534 4.40788L13.9283 3.86398L16.0082 4.79515L18.0925 5.73067L20.1637 4.95614C21.3037 4.52972 22.2349 4.17292 22.2349 4.15986C22.2349 4.14246 11.3437 0.0522795 11.1609 6.48499e-05C11.1392 -0.00863743 8.62413 0.922531 5.5826 2.06256Z"
        fill={color}
      />
      <path
        className="bg"
        d="M0.00870251 11.8224L0.0217563 18.0926L5.2215 20.0419L10.4213 21.9913L10.4343 15.7429C10.4387 12.3054 10.43 9.48144 10.4126 9.46839C10.3908 9.45098 8.1673 8.61119 5.46082 7.59735C2.7587 6.58351 0.422072 5.7089 0.269778 5.65669L0 5.55226L0.00870251 11.8224ZM4.1772 16.1215L5.54785 16.6349L5.5609 17.379C5.56525 17.7923 5.56525 18.1274 5.5609 18.1274C5.5522 18.1274 4.92997 17.8968 4.1772 17.6096L2.80656 17.0961L2.79351 16.3521C2.78915 15.9387 2.78915 15.6037 2.79351 15.6037C2.80221 15.6037 3.42444 15.8343 4.1772 16.1215Z"
        fill={color}
      />
      <path
        className="bg"
        d="M20.1899 6.33549L18.123 7.11001L18.1013 8.86357L18.0795 10.6128L16.7089 11.1262C15.9561 11.4134 15.3339 11.644 15.3295 11.644C15.3208 11.644 15.3121 10.8608 15.3077 9.90787L15.2947 8.17172L13.576 8.8157L11.8572 9.45969L11.8442 15.7298L11.8354 22L12.1052 21.8956C12.2575 21.8434 14.5941 20.9688 17.2963 19.9549C20.0028 18.9411 22.2262 18.1013 22.248 18.0839C22.2654 18.0708 22.2741 15.2469 22.2698 11.8094L22.2567 5.56096L20.1899 6.33549Z"
        fill={color}
      />
      <path
        d="M17.273 18.3287C16.7913 18.5136 16.3599 18.5884 15.9788 18.5532C15.5979 18.5103 15.2953 18.373 15.0713 18.1414C14.8543 17.907 14.7367 17.6004 14.7187 17.2216L16.2169 16.6464C16.2433 16.8784 16.3514 17.0373 16.5414 17.1232C16.7384 17.2064 16.9822 17.1923 17.2726 17.0808C17.556 16.972 17.7761 16.827 17.9329 16.6458C18.0968 16.4618 18.1796 16.275 18.1811 16.0853C18.1828 15.8805 18.0849 15.7668 17.8873 15.7443C17.6969 15.7115 17.3897 15.7159 16.9657 15.7577C16.5274 15.8125 16.1671 15.8336 15.8847 15.8209C15.6095 15.8056 15.3701 15.7121 15.1667 15.5406C14.9704 15.3663 14.874 15.0668 14.8775 14.6418C14.8804 14.2928 14.9751 13.9388 15.1616 13.5797C15.3553 13.218 15.6263 12.887 15.9748 12.5868C16.3304 12.284 16.7455 12.0414 17.2201 11.8592C17.9214 11.59 18.4795 11.5649 18.8943 11.7838C19.3092 11.9952 19.5353 12.4114 19.5726 13.0324L18.1487 13.579C18.1295 13.3368 18.032 13.1776 17.8561 13.1014C17.6873 13.0149 17.4577 13.0274 17.1672 13.1389C16.898 13.2422 16.6886 13.3756 16.539 13.5389C16.3964 13.6995 16.3244 13.8747 16.3228 14.0643C16.3211 14.2768 16.4189 14.4019 16.6164 14.4395C16.8138 14.4696 17.1211 14.4614 17.5381 14.4147C17.9622 14.3654 18.3119 14.3484 18.5872 14.3638C18.8625 14.3791 19.0982 14.4777 19.2945 14.6595C19.4978 14.8311 19.6014 15.1242 19.605 15.5388C19.602 15.903 19.5037 16.2659 19.3101 16.6277C19.1235 16.9867 18.8525 17.3177 18.4969 17.6206C18.1485 17.9132 17.7405 18.1492 17.273 18.3287Z"
        fill="url(#paint0_linear_1272_19040)"
      />
      <defs>
        <linearGradient
          id="paint0_linear_1272_19040"
          x1="14.7282"
          y1="16.0607"
          x2="19.6004"
          y2="16.1006"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#1987D8" />
          <stop offset="1" stopColor="#45B4D0" />
        </linearGradient>
      </defs>
    </svg>
  );
}
SupplierIconActive.propTypes = {
  color: PropTypes.string,
  size: PropTypes.string,
};
SupplierIconActive.defaultProps = {
  color: '#ffffff',
  size: '1.528vw',
};
export function ForworderIcon({ color, size }) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 22 22"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M19.2875 10.6545C18.2598 10.3977 17.2017 10.2698 16.1447 10.2689C16.1407 10.2688 16.1374 10.2666 16.1333 10.2666C16.1294 10.2666 16.1262 10.2687 16.1223 10.2688C15.0647 10.2698 14.0072 10.3981 12.979 10.6545C11.8305 10.9422 10.94 11.8338 10.6534 12.9803C10.1377 15.0437 10.1377 17.2245 10.6534 19.2874C10.94 20.4345 11.8305 21.3261 12.9802 21.6137C14.0117 21.8716 15.0719 21.9999 16.1333 21.9999C17.1946 21.9999 18.256 21.871 19.2875 21.6137C20.436 21.3261 21.3266 20.4345 21.6131 19.2879C22.1289 17.2245 22.1289 15.0437 21.6131 12.9809C21.3266 11.8338 20.436 10.9422 19.2875 10.6545ZM20.1666 18.6999C20.0898 19.0042 19.4923 20.0904 19.1874 20.1666C17.4957 20.5895 14.8894 20.5895 13.1999 20.1666C12.8939 20.0904 12.1767 19.0048 12.0999 18.6999C11.6781 17.0096 11.6781 14.8909 12.0999 13.1999C12.1767 12.8957 13.2617 12.5428 13.5666 12.4666C14.031 12.3505 14.5586 12.1522 15.0333 12.0999V13.1999C15.0333 13.848 15.4845 14.2999 16.1333 14.2999C16.782 14.2999 17.2333 13.848 17.2333 13.1999V12.0999C17.7079 12.1522 18.723 12.3505 19.1874 12.4666C19.4923 12.5434 20.0898 12.8951 20.1666 13.1999C20.5884 14.8903 20.5884 17.009 20.1666 18.6999Z"
        fill={color}
      />
      <path
        d="M10.0215 0C14.6876 7.58359e-05 18.6979 3.16716 19.7725 7.70117C19.9006 8.23986 19.5675 8.77953 19.0283 8.90723C18.4912 9.03373 17.9496 8.70159 17.8232 8.16406C16.963 4.53725 13.7549 2.00398 10.0215 2.00391V3.72852C10.0216 4.19073 10.2572 4.63476 10.6367 4.88867L11.5146 5.4668C12.4639 6.09999 13.0273 7.15724 13.0273 8.29785C13.0272 9.76371 12.0946 11.0567 10.7061 11.5146L10.584 11.5615C10.2191 11.6828 9.84536 11.7421 9.47754 11.7422C8.80633 11.7422 8.15247 11.5456 7.60254 11.1689C6.82848 10.6478 5.57058 10.0216 4.00879 10.0215C3.34423 10.0215 2.67784 9.84933 2.02832 9.5498C2.01915 9.70657 2.00391 9.86246 2.00391 10.0215C2.00397 13.7555 4.53823 16.963 8.16504 17.8223C8.70323 17.95 9.0364 18.4911 8.9082 19.0293C8.79938 19.4899 8.38848 19.7998 7.93457 19.7998C7.85841 19.7998 7.78025 19.7915 7.70312 19.7734C3.16813 18.6989 6.17097e-05 14.6886 0 10.0215C0 9.219 0.105149 8.44177 0.28418 7.69336C0.294739 7.63989 0.304699 7.58881 0.324219 7.53711C1.43382 3.21124 5.35482 0 10.0215 0Z"
        fill={color}
      />
      <path
        d="M13.2002 19.8003V14.667H16.2261V15.7081H14.2297V16.8143H15.8745V17.7759H14.2297V19.8003H13.2002Z"
        fill={color}
      />
      <path
        d="M16.7743 19.8003V14.667H19.8002V15.7081H17.8039V16.8143H19.4486V17.7759H17.8039V19.8003H16.7743Z"
        fill={color}
      />
    </svg>
  );
}
ForworderIcon.propTypes = {
  color: PropTypes.string,
  size: PropTypes.string,
};
ForworderIcon.defaultProps = {
  color: '#828282',
  size: '1.528vw',
};
export function ForworderIconActive({ color, size }) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 21 21"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M18.4107 10.1701C17.4297 9.92493 16.4197 9.80282 15.4107 9.802C15.4069 9.80192 15.4037 9.7998 15.3998 9.7998C15.3961 9.7998 15.393 9.80185 15.3894 9.80192C14.3798 9.80287 13.3704 9.92533 12.3889 10.1701C11.2927 10.4447 10.4426 11.2957 10.1691 12.3902C9.67672 14.3598 9.67672 16.4415 10.1691 18.4105C10.4426 19.5055 11.2927 20.3566 12.39 20.6312C13.3747 20.8773 14.3867 20.9998 15.3998 20.9998C16.4129 20.9998 17.426 20.8767 18.4107 20.6312C19.5069 20.3566 20.357 19.5055 20.6306 18.4111C21.1229 16.4415 21.1229 14.3598 20.6306 12.3907C20.3571 11.2957 19.507 10.4447 18.4107 10.1701ZM19.2498 17.8498C19.1765 18.1402 18.6061 19.1771 18.3151 19.2498C16.7003 19.6535 14.2125 19.6535 12.5998 19.2498C12.3077 19.1771 11.6231 18.1408 11.5498 17.8498C11.1472 16.2363 11.1472 14.2139 11.5498 12.5998C11.6231 12.3094 12.6588 11.9725 12.9498 11.8998C13.3931 11.789 13.8967 11.5997 14.3498 11.5498V12.5998C14.3498 13.2184 14.7806 13.6498 15.3998 13.6498C16.019 13.6498 16.4498 13.2184 16.4498 12.5998V11.5498C16.9029 11.5997 17.8718 11.789 18.3151 11.8998C18.6062 11.9731 19.1765 12.3088 19.2498 12.5998C19.6524 14.2133 19.6524 16.2357 19.2498 17.8498Z"
        fill={color}
      />
      <path
        d="M9.56543 0C14.0194 0 17.8482 3.02276 18.874 7.35059C18.9964 7.86478 18.6787 8.38094 18.1641 8.50293C17.6513 8.62389 17.1333 8.30622 17.0127 7.79297C16.1916 4.33096 13.1293 1.91309 9.56543 1.91309V3.55859C9.56543 3.99999 9.79087 4.42457 10.1533 4.66699L10.9912 5.21777C11.8972 5.82211 12.4354 6.83131 12.4355 7.91992C12.4355 9.3193 11.5453 10.554 10.2197 10.9912L10.1025 11.0361C9.7544 11.1518 9.39781 11.2089 9.04688 11.209C8.40612 11.209 7.7818 11.0207 7.25684 10.6611C6.51792 10.1637 5.31709 9.56543 3.82617 9.56543C3.19187 9.5654 2.5555 9.4021 1.93555 9.11621C1.9268 9.26569 1.91311 9.4138 1.91309 9.56543C1.91309 13.1297 4.33195 16.1925 7.79395 17.0127C8.30758 17.1347 8.62626 17.6504 8.50391 18.1641C8.40017 18.604 8.00761 18.9004 7.57422 18.9004C7.50135 18.9004 7.42634 18.8913 7.35254 18.874C3.02379 17.8482 0 14.0204 0 9.56543C3.51478e-05 8.79956 0.100621 8.05802 0.271484 7.34375C0.281573 7.29267 0.29091 7.24373 0.30957 7.19434C1.36874 3.06527 5.11109 0.000170908 9.56543 0Z"
        fill={color}
      />
      <path
        d="M13 19V14H15.7508V15.0141H13.936V16.0915H15.4312V17.0282H13.936V19H13Z"
        fill={color}
      />
      <path
        d="M16.2492 19V14H19V15.0141H17.1852V16.0915H18.6804V17.0282H17.1852V19H16.2492Z"
        fill={color}
      />
    </svg>
  );
}
ForworderIconActive.propTypes = {
  color: PropTypes.string,
  size: PropTypes.string,
};
ForworderIconActive.defaultProps = {
  color: '#ffffff',
  size: '1.528vw',
};
export function CustomBrokerIcon({ color, size }) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 22 22"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M11.3293 13.2457L10.7117 13.3487C10.6088 13.3487 10.5059 13.3144 10.4716 13.2457L8.92757 11.324C8.82464 11.1867 8.92757 11.0152 9.09913 11.0152L10.2657 10.8436L11.1921 10.7063V12.6623C11.1921 12.8682 11.2264 13.0741 11.3293 13.2457ZM2.82025 10.1229L2.40852 10.1916L3.19766 10.2945L8.34429 10.9809C8.51584 11.0152 8.61878 11.1867 8.51584 11.2897L8.34429 11.4956L7.00617 13.2457C6.93754 13.3144 6.83461 13.3487 6.73168 13.3487L0.212622 12.4564C0.041068 12.4221 -0.0618645 12.2506 0.041068 12.1133L1.55074 10.1916H1.51643L0.041068 8.23556C-0.0618645 8.09829 0.041068 7.92671 0.212622 7.92671L6.69737 7.03449C6.8003 7.03449 6.90323 7.06881 6.97186 7.13744L8.48153 9.05915C8.58447 9.19641 8.48153 9.36799 8.30998 9.36799L7.14341 9.53957L2.82025 10.1229ZM21.0736 1.09779H19.4953L19.9757 1.99001H21.0736V12.6967H12.7704V1.9557H13.8683L14.3487 1.06348H12.7704C12.29 1.06348 11.8783 1.44095 11.8783 1.9557V12.6623C11.8783 13.1428 12.2557 13.5546 12.7704 13.5546H21.1079C21.5883 13.5546 22 13.1771 22 12.6623V1.9557C21.9657 1.47527 21.5883 1.09779 21.0736 1.09779Z"
        fill={color}
      />
      <path
        d="M18.5008 1.09812H17.7803C17.7803 1.02949 17.8146 0.960853 17.8146 0.892221C17.8146 0.411794 17.4371 0 16.9225 0C16.4421 0 16.0304 0.411794 16.0304 0.892221C16.0304 0.960853 16.0304 1.02949 16.0647 1.09812H15.3442L14.6237 2.36782H19.2213L18.5008 1.09812ZM16.9225 0.308846C17.2656 0.308846 17.5058 0.583375 17.5058 0.892221C17.5058 1.20107 17.2313 1.4756 16.9225 1.4756C16.6137 1.4756 16.3392 1.20107 16.3392 0.892221C16.3392 0.583375 16.6137 0.308846 16.9225 0.308846ZM20.1477 9.78011C20.1477 9.91738 20.0448 9.98601 19.9418 9.98601H13.9031C13.7659 9.98601 13.6973 9.88306 13.6973 9.78011C13.6973 9.64285 13.8002 9.57421 13.9031 9.57421H19.9418C20.0791 9.5399 20.1477 9.64285 20.1477 9.78011ZM20.1477 8.37315C20.1477 8.4761 20.0448 8.57904 19.9418 8.57904H13.9031C13.7659 8.57904 13.6973 8.4761 13.6973 8.37315C13.6973 8.23588 13.8002 8.16725 13.9031 8.16725H19.9418C20.0791 8.16725 20.1477 8.2702 20.1477 8.37315ZM20.1477 6.96618C20.1477 7.10345 20.0448 7.17208 19.9418 7.17208H13.9031C13.7659 7.17208 13.6973 7.06913 13.6973 6.96618C13.6973 6.86324 13.8002 6.76029 13.9031 6.76029H19.9418C20.0791 6.76029 20.1477 6.86324 20.1477 6.96618ZM20.1477 11.1528C20.1477 11.29 20.0448 11.3587 19.9418 11.3587H13.9031C13.7659 11.3587 13.6973 11.2557 13.6973 11.1528C13.6973 11.0498 13.8002 10.9469 13.9031 10.9469H19.9418C20.0791 10.9469 20.1477 11.0498 20.1477 11.1528ZM20.1477 5.59354C20.1477 5.7308 20.0448 5.79943 19.9418 5.79943H13.9031C13.7659 5.79943 13.6973 5.69649 13.6973 5.59354C13.6973 5.45627 13.8002 5.38764 13.9031 5.38764H19.9418C20.0791 5.35332 20.1477 5.45627 20.1477 5.59354ZM13.6973 4.18657C13.6973 4.04931 13.8002 3.98068 13.9031 3.98068H19.9418C20.0791 3.98068 20.1477 4.08363 20.1477 4.18657C20.1477 4.28952 20.0448 4.39247 19.9418 4.39247H13.9031C13.8002 4.42679 13.6973 4.32384 13.6973 4.18657Z"
        fill={color}
      />
      <path
        d="M9.99121 13.4893C10.1285 13.6608 10.3691 13.7979 10.6436 13.7979H10.7803L11.5693 13.6953C11.8438 14.0385 12.2902 14.2783 12.7705 14.2783H15.7559V20.6611C15.7559 20.867 15.5497 21.0731 15.3096 21.1074L8.79004 22H8.61914L2.09961 21.1074C1.82525 21.073 1.65332 20.867 1.65332 20.6611V13.1123L6.62891 13.7979H6.76562C7.04011 13.7979 7.28073 13.6952 7.41797 13.4893L8.72168 11.8418L9.99121 13.4893ZM7.00293 15.3271C6.52698 15.3271 6.09965 15.4338 5.72168 15.6484C5.34835 15.8584 5.05668 16.1554 4.84668 16.5381C4.63676 16.916 4.53223 17.3478 4.53223 17.833C4.53225 18.3183 4.6367 18.75 4.84668 19.1279C5.05664 19.5059 5.34844 19.8019 5.72168 20.0166C6.09968 20.2266 6.52693 20.332 7.00293 20.332C7.5862 20.332 8.08568 20.1803 8.50098 19.877C8.9162 19.569 9.19397 19.149 9.33398 18.6172H8.01758C7.91959 18.8224 7.77956 18.9787 7.59766 19.0859C7.42047 19.1931 7.21768 19.247 6.98926 19.2471C6.6207 19.2471 6.32141 19.1188 6.09277 18.8623C5.86413 18.6057 5.75002 18.2623 5.75 17.833C5.75 17.4037 5.86411 17.0604 6.09277 16.8037C6.32143 16.5471 6.62063 16.4189 6.98926 16.4189C7.21773 16.419 7.42045 16.4728 7.59766 16.5801C7.77962 16.6874 7.91958 16.8436 8.01758 17.0488H9.33398C9.19401 16.5169 8.91619 16.097 8.50098 15.7891C8.08568 15.4811 7.5862 15.3272 7.00293 15.3271ZM10.0664 15.3828V20.2969H12.3555C12.8688 20.2969 13.2681 20.1775 13.5527 19.9395C13.8419 19.6968 13.9863 19.3705 13.9863 18.96C13.9863 18.6753 13.9002 18.4234 13.7275 18.2041C13.5549 17.9802 13.3265 17.838 13.042 17.7773C13.2939 17.7027 13.4942 17.5692 13.6436 17.3779C13.7975 17.1867 13.8749 16.9464 13.875 16.6572C13.875 16.2653 13.7328 15.9542 13.4482 15.7256C13.1683 15.497 12.7784 15.3829 12.2793 15.3828H10.0664ZM12.1318 18.2461C12.3323 18.2461 12.4886 18.2947 12.6006 18.3926C12.7172 18.4906 12.7754 18.6262 12.7754 18.7988C12.7754 18.9715 12.7194 19.1049 12.6074 19.1982C12.5001 19.2867 12.3459 19.3311 12.1455 19.3311H11.2637V18.2461H12.1318ZM12.0479 16.3418C12.2438 16.3418 12.3934 16.3859 12.4961 16.4746C12.6034 16.5633 12.6572 16.6924 12.6572 16.8604C12.6571 17.0281 12.6033 17.1565 12.4961 17.2451C12.3934 17.3291 12.2438 17.3711 12.0479 17.3711H11.2637V16.3418H12.0479ZM11.2266 7.07227V9.64551L9.13379 9.37109C8.92792 9.37109 8.8248 9.19976 8.92773 9.0625L9.09961 8.85645L10.4375 7.10645C10.5061 7.03788 10.609 7.00391 10.7119 7.00391L11.2266 7.07227Z"
        fill={color}
      />
    </svg>
  );
}
CustomBrokerIcon.propTypes = {
  color: PropTypes.string,
  size: PropTypes.string,
};
CustomBrokerIcon.defaultProps = {
  color: '#828282',
  size: '1.528vw',
};
export function CustomBrokerIconActive({ color, size }) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 20 21"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M10.2994 12.3384L9.73794 12.432C9.64437 12.432 9.55079 12.4008 9.5196 12.3384L8.11598 10.5914C8.0224 10.4666 8.11598 10.3107 8.27193 10.3107L9.33245 10.1547L10.1746 10.0299V11.8081C10.1746 11.9953 10.2058 12.1825 10.2994 12.3384ZM2.56386 9.49956L2.18956 9.56195L2.90697 9.65554L7.58572 10.2795C7.74168 10.3107 7.83525 10.4666 7.74168 10.5602L7.58572 10.7474L6.36924 12.3384C6.30686 12.4008 6.21328 12.432 6.11971 12.432L0.193293 11.6209C0.0373345 11.5897 -0.0562405 11.4337 0.0373345 11.309L1.40977 9.56195H1.37858L0.0373345 7.78375C-0.0562405 7.65896 0.0373345 7.50298 0.193293 7.50298L6.08852 6.69187C6.18209 6.69187 6.27567 6.72306 6.33805 6.78546L7.71048 8.53246C7.80406 8.65725 7.71048 8.81323 7.55453 8.81323L6.49401 8.96921L2.56386 9.49956ZM19.1578 1.29487H17.723L18.1597 2.10598H19.1578V11.8393H11.6094V2.07478H12.6076L13.0443 1.26367H11.6094C11.1728 1.26367 10.7985 1.60683 10.7985 2.07478V11.8081C10.7985 12.2449 11.1416 12.6192 11.6094 12.6192H19.189C19.6257 12.6192 20 12.276 20 11.8081V2.07478C19.9688 1.63803 19.6257 1.29487 19.1578 1.29487Z"
        fill={color}
      />
      <path
        d="M16.819 1.29516H16.164C16.164 1.23277 16.1951 1.17038 16.1951 1.10798C16.1951 0.671233 15.852 0.296875 15.3842 0.296875C14.9475 0.296875 14.5732 0.671233 14.5732 1.10798C14.5732 1.17038 14.5732 1.23277 14.6044 1.29516H13.9493L13.2943 2.44944H17.474L16.819 1.29516ZM15.3842 0.577644C15.6961 0.577644 15.9144 0.827216 15.9144 1.10798C15.9144 1.38875 15.6649 1.63833 15.3842 1.63833C15.1034 1.63833 14.8539 1.38875 14.8539 1.10798C14.8539 0.827216 15.1034 0.577644 15.3842 0.577644ZM18.3162 9.18789C18.3162 9.31267 18.2226 9.37506 18.129 9.37506H12.6393C12.5145 9.37506 12.4521 9.28147 12.4521 9.18789C12.4521 9.0631 12.5457 9.00071 12.6393 9.00071H18.129C18.2538 8.96951 18.3162 9.0631 18.3162 9.18789ZM18.3162 7.90883C18.3162 8.00242 18.2226 8.09601 18.129 8.09601H12.6393C12.5145 8.09601 12.4521 8.00242 12.4521 7.90883C12.4521 7.78404 12.5457 7.72165 12.6393 7.72165H18.129C18.2538 7.72165 18.3162 7.81524 18.3162 7.90883ZM18.3162 6.62977C18.3162 6.75456 18.2226 6.81695 18.129 6.81695H12.6393C12.5145 6.81695 12.4521 6.72336 12.4521 6.62977C12.4521 6.53618 12.5457 6.44259 12.6393 6.44259H18.129C18.2538 6.44259 18.3162 6.53618 18.3162 6.62977ZM18.3162 10.4357C18.3162 10.5605 18.2226 10.6229 18.129 10.6229H12.6393C12.5145 10.6229 12.4521 10.5293 12.4521 10.4357C12.4521 10.3422 12.5457 10.2486 12.6393 10.2486H18.129C18.2538 10.2486 18.3162 10.3422 18.3162 10.4357ZM18.3162 5.38191C18.3162 5.50669 18.2226 5.56909 18.129 5.56909H12.6393C12.5145 5.56909 12.4521 5.4755 12.4521 5.38191C12.4521 5.25712 12.5457 5.19473 12.6393 5.19473H18.129C18.2538 5.16353 18.3162 5.25712 18.3162 5.38191ZM12.4521 4.10285C12.4521 3.97807 12.5457 3.91567 12.6393 3.91567H18.129C18.2538 3.91567 18.3162 4.00926 18.3162 4.10285C18.3162 4.19644 18.2226 4.29003 18.129 4.29003H12.6393C12.5457 4.32123 12.4521 4.22764 12.4521 4.10285Z"
        fill={color}
      />
      <path
        d="M9.08301 12.5596C9.20777 12.7156 9.42625 12.8408 9.67578 12.8408H9.80078L10.5176 12.7471C10.7671 13.059 11.1728 13.2773 11.6094 13.2773H14.3232V19.0801C14.3232 19.2671 14.1361 19.454 13.918 19.4854L7.99121 20.2969H7.83496L1.90918 19.4854C1.6597 19.4542 1.50398 19.2672 1.50391 19.0801V12.2168L6.02637 12.8408H6.15137C6.40074 12.8407 6.61846 12.7467 6.74316 12.5596L7.92871 11.0625L9.08301 12.5596ZM5.70215 14.3271C5.2262 14.3271 4.79887 14.4338 4.4209 14.6484C4.04756 14.8584 3.7559 15.1554 3.5459 15.5381C3.33597 15.916 3.23145 16.3478 3.23145 16.833C3.23146 17.3183 3.33592 17.75 3.5459 18.1279C3.75586 18.5059 4.04766 18.8019 4.4209 19.0166C4.7989 19.2266 5.22615 19.332 5.70215 19.332C6.28542 19.332 6.7849 19.1803 7.2002 18.877C7.61542 18.569 7.89319 18.149 8.0332 17.6172H6.7168C6.6188 17.8224 6.47878 17.9787 6.29688 18.0859C6.11969 18.1931 5.9169 18.247 5.68848 18.2471C5.31992 18.2471 5.02063 18.1188 4.79199 17.8623C4.56335 17.6057 4.44924 17.2623 4.44922 16.833C4.44922 16.4037 4.56333 16.0604 4.79199 15.8037C5.02065 15.5471 5.31985 15.4189 5.68848 15.4189C5.91695 15.419 6.11967 15.4728 6.29688 15.5801C6.47884 15.6874 6.6188 15.8436 6.7168 16.0488H8.0332C7.89323 15.5169 7.61541 15.097 7.2002 14.7891C6.7849 14.4811 6.28542 14.3272 5.70215 14.3271ZM8.76562 14.3828V19.2969H11.0547C11.568 19.2969 11.9673 19.1775 12.252 18.9395C12.5412 18.6968 12.6855 18.3705 12.6855 17.96C12.6855 17.6753 12.5994 17.4234 12.4268 17.2041C12.2541 16.9802 12.0258 16.838 11.7412 16.7773C11.9931 16.7027 12.1935 16.5692 12.3428 16.3779C12.4967 16.1867 12.5742 15.9464 12.5742 15.6572C12.5742 15.2653 12.432 14.9542 12.1475 14.7256C11.8676 14.497 11.4776 14.3829 10.9785 14.3828H8.76562ZM10.8311 17.2461C11.0315 17.2461 11.1878 17.2947 11.2998 17.3926C11.4165 17.4906 11.4746 17.6262 11.4746 17.7988C11.4746 17.9715 11.4186 18.1049 11.3066 18.1982C11.1993 18.2867 11.0451 18.3311 10.8447 18.3311H9.96289V17.2461H10.8311ZM10.7471 15.3418C10.9431 15.3418 11.0927 15.3859 11.1953 15.4746C11.3026 15.5633 11.3564 15.6924 11.3564 15.8604C11.3563 16.0281 11.3025 16.1565 11.1953 16.2451C11.0927 16.3291 10.9431 16.3711 10.7471 16.3711H9.96289V15.3418H10.7471ZM10.2061 6.72656V9.06543L8.30273 8.81641C8.11591 8.81614 8.02272 8.65984 8.11621 8.53516L8.27246 8.34863L9.48828 6.75684C9.55066 6.69453 9.64477 6.66406 9.73828 6.66406L10.2061 6.72656Z"
        fill={color}
      />
    </svg>
  );
}
CustomBrokerIconActive.propTypes = {
  color: PropTypes.string,
  size: PropTypes.string,
};
CustomBrokerIconActive.defaultProps = {
  color: '#ffffff',
  size: '1.528vw',
};

export function AddUserIcon({ color, width, height }) {
  return (
    <svg
      width={width !== '' ? width : '14'}
      height={height !== '' ? height : '15'}
      viewBox="0 0 14 15"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M7.33333 9.50132V10.8947C6.72994 10.6813 6.08418 10.6159 5.45027 10.7038C4.81635 10.7918 4.2128 11.0306 3.69028 11.4001C3.16777 11.7697 2.74156 12.2592 2.44744 12.8276C2.15332 13.396 1.99988 14.0267 2 14.6667L0.666664 14.666C0.666457 13.8519 0.852612 13.0486 1.21086 12.3176C1.56911 11.5866 2.08996 10.9473 2.73348 10.4487C3.377 9.95008 4.12611 9.60541 4.92343 9.44109C5.72075 9.27676 6.5451 9.29714 7.33333 9.50066V9.50132ZM6 8.66666C3.79 8.66666 2 6.87666 2 4.66666C2 2.45666 3.79 0.666656 6 0.666656C8.21 0.666656 10 2.45666 10 4.66666C10 6.87666 8.21 8.66666 6 8.66666ZM6 7.33332C7.47333 7.33332 8.66666 6.13999 8.66666 4.66666C8.66666 3.19332 7.47333 1.99999 6 1.99999C4.52666 1.99999 3.33333 3.19332 3.33333 4.66666C3.33333 6.13999 4.52666 7.33332 6 7.33332ZM10 11.3333V9.33332H11.3333V11.3333H13.3333V12.6667H11.3333V14.6667H10V12.6667H8V11.3333H10Z"
        fill={color !== '' ? color : 'white'}
      />
    </svg>
  );
}
AddUserIcon.propTypes = {
  color: PropTypes.string,
  width: PropTypes.string,
  height: PropTypes.string,
};
AddUserIcon.defaultProps = {
  color: '',
  width: '',
  height: '',
};
export function CloseFillIcon() {
  return (
    <svg
      width="12"
      height="12"
      viewBox="0 0 12 12"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M5.99999 11.8333C2.77824 11.8333 0.166656 9.22176 0.166656 6C0.166656 2.77826 2.77824 0.166672 5.99999 0.166672C9.22174 0.166672 11.8333 2.77826 11.8333 6C11.8333 9.22176 9.22174 11.8333 5.99999 11.8333ZM5.99999 5.17517L4.35032 3.52492L3.52491 4.35034L5.17516 6L3.52491 7.64967L4.35032 8.47509L5.99999 6.82484L7.64966 8.47509L8.47507 7.64967L6.82482 6L8.47507 4.35034L7.64966 3.52492L5.99999 5.17517Z"
        fill="#008AFF"
      />
    </svg>
  );
}
export function ShortDownIcon({ color, size }) {
  return (
    <svg width={size} focusable="false" viewBox="0 0 24 24" aria-hidden="true">
      <path
        d="M7.41 8.59L12 13.17l4.59-4.58L18 10l-6 6-6-6 1.41-1.41z"
        fill={color}
      />
    </svg>
  );
}
ShortDownIcon.propTypes = {
  color: PropTypes.string,
  size: PropTypes.string,
};
ShortDownIcon.defaultProps = {
  color: '#999999',
  size: '1.111vw',
};
export function ShortUpIcon({ color, size }) {
  return (
    <svg width={size} focusable="false" viewBox="0 0 24 24" aria-hidden="true">
      <path
        d="M7.41 15.41L12 10.83l4.59 4.58L18 14l-6-6-6 6 1.41 1.41z"
        fill={color}
      />
    </svg>
  );
}
ShortUpIcon.propTypes = {
  color: PropTypes.string,
  size: PropTypes.string,
};
ShortUpIcon.defaultProps = {
  color: '#999999',
  size: '1.111vw',
};
export function ShortBothIcon({ color, size }) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M6.645 14L12 19.5628L17.355 14L19 15.7126L12 23L5 15.7126L6.645 14Z"
        fill={color}
      />
      <path
        d="M6.645 11L12 5.43725L17.355 11L19 9.28745L12 2L5 9.28745L6.645 11Z"
        fill={color}
      />
    </svg>
  );
}
ShortBothIcon.propTypes = {
  color: PropTypes.string,
  size: PropTypes.string,
};
ShortBothIcon.defaultProps = {
  color: '#999999',
  size: '0.833vw',
};
export function RightDirectionIcon({ color, size }) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 8 14"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M5.17192 7.00001L0.221924 2.05001L1.63592 0.636008L7.99992 7.00001L1.63592 13.364L0.221924 11.95L5.17192 7.00001Z"
        fill={color !== '' ? color : '#4D4D4D'}
      />
    </svg>
  );
}
RightDirectionIcon.propTypes = {
  color: PropTypes.string,
  size: PropTypes.string,
};
RightDirectionIcon.defaultProps = {
  color: '',
  size: '0.972vw',
};
export function PlusIcon({ color, width, height }) {
  return (
    <svg
      width={width !== '' ? width : '0.694vw'}
      height={height !== '' ? height : '0.694vw'}
      viewBox="0 0 9 10"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M3.87524 4.37842V0.628418H5.12525V4.37842H8.87525V5.62842H5.12525V9.37842H3.87524V5.62842H0.125244V4.37842H3.87524Z"
        fill={color !== '' ? color : 'white'}
      />
    </svg>
  );
}
PlusIcon.propTypes = {
  color: PropTypes.string,
  width: PropTypes.string,
  height: PropTypes.string,
};
PlusIcon.defaultProps = {
  color: '',
  width: '',
  height: '',
};

export function MinusIcon({ color, width, height }) {
  return (
    <svg
      width={width !== '' ? width : '0.694vw'}
      height={height !== '' ? height : '0.694vw'}
      viewBox="0 0 14 14"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <line
        x1="1.5"
        y1="6.5"
        x2="12.5"
        y2="6.5"
        stroke={color !== '' ? color : 'white'}
        strokeLinecap="round"
      />
    </svg>
  );
}
MinusIcon.propTypes = {
  color: PropTypes.string,
  width: PropTypes.string,
  height: PropTypes.string,
};
MinusIcon.defaultProps = {
  color: '',
  width: '',
  height: '',
};
<svg
  width="14"
  height="14"
  viewBox="0 0 14 14"
  fill="none"
  xmlns="http://www.w3.org/2000/svg"
>
  <line
    x1="1"
    y1="6"
    x2="13"
    y2="6"
    stroke="black"
    stroke-width="2"
    stroke-linecap="round"
  />
</svg>;

export function AttachIcon() {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M14.8283 7.75689L9.17229 13.4139C9.07678 13.5061 9.0006 13.6165 8.94819 13.7385C8.89578 13.8605 8.86819 13.9917 8.86704 14.1245C8.86588 14.2573 8.89118 14.3889 8.94147 14.5118C8.99175 14.6347 9.066 14.7464 9.15989 14.8403C9.25378 14.9342 9.36544 15.0084 9.48833 15.0587C9.61123 15.109 9.74291 15.1343 9.87569 15.1331C10.0085 15.132 10.1397 15.1044 10.2617 15.052C10.3837 14.9996 10.494 14.9234 10.5863 14.8279L16.2433 9.17189C16.8059 8.60923 17.122 7.8461 17.122 7.05039C17.122 6.25467 16.8059 5.49154 16.2433 4.92889C15.6806 4.36623 14.9175 4.05013 14.1218 4.05013C13.3261 4.05013 12.5629 4.36623 12.0003 4.92889L6.34329 10.5859C5.86936 11.048 5.49192 11.5996 5.23284 12.2088C4.97377 12.8179 4.83823 13.4724 4.83408 14.1344C4.82994 14.7963 4.95727 15.4525 5.20868 16.0648C5.4601 16.6771 5.83061 17.2334 6.2987 17.7015C6.7668 18.1695 7.32317 18.5399 7.93554 18.7913C8.54791 19.0426 9.20409 19.1698 9.86602 19.1656C10.5279 19.1614 11.1824 19.0257 11.7915 18.7666C12.4006 18.5074 12.9522 18.1299 13.4143 17.6559L19.0713 11.9999L20.4853 13.4139L14.8283 19.0709C14.1782 19.7209 13.4065 20.2366 12.5572 20.5884C11.7079 20.9402 10.7976 21.1212 9.87829 21.1212C8.95899 21.1212 8.04869 20.9402 7.19937 20.5884C6.35004 20.2366 5.57833 19.7209 4.92829 19.0709C4.27824 18.4208 3.7626 17.6491 3.4108 16.7998C3.059 15.9505 2.87793 15.0402 2.87793 14.1209C2.87793 13.2016 3.059 12.2913 3.4108 11.442C3.7626 10.5926 4.27824 9.82093 4.92829 9.17089L10.5863 3.51489C11.5293 2.6041 12.7923 2.10013 14.1033 2.11152C15.4143 2.12291 16.6683 2.64875 17.5954 3.57579C18.5224 4.50284 19.0483 5.7569 19.0597 7.06788C19.071 8.37887 18.5671 9.64188 17.6563 10.5849L12.0003 16.2439C11.7216 16.5225 11.3908 16.7435 11.0267 16.8942C10.6627 17.045 10.2725 17.1225 9.87843 17.1225C9.48439 17.1224 9.09421 17.0448 8.73018 16.894C8.36615 16.7431 8.03539 16.5221 7.75679 16.2434C7.47819 15.9647 7.2572 15.6339 7.10645 15.2698C6.9557 14.9058 6.87813 14.5156 6.87818 14.1215C6.87823 13.7275 6.95588 13.3373 7.10672 12.9733C7.25756 12.6092 7.47862 12.2785 7.75729 11.9999L13.4143 6.34289L14.8283 7.75689Z"
        fill="#424242"
      />
    </svg>
  );
}
export function MicIcon() {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M11.9997 3C11.204 3 10.441 3.31607 9.87837 3.87868C9.31576 4.44129 8.99969 5.20435 8.99969 6V10C8.99969 10.7956 9.31576 11.5587 9.87837 12.1213C10.441 12.6839 11.204 13 11.9997 13C12.7953 13 13.5584 12.6839 14.121 12.1213C14.6836 11.5587 14.9997 10.7956 14.9997 10V6C14.9997 5.20435 14.6836 4.44129 14.121 3.87868C13.5584 3.31607 12.7953 3 11.9997 3ZM11.9997 1C12.6563 1 13.3065 1.12933 13.9131 1.3806C14.5197 1.63188 15.0709 2.00017 15.5352 2.46447C15.9995 2.92876 16.3678 3.47995 16.6191 4.08658C16.8704 4.69321 16.9997 5.34339 16.9997 6V10C16.9997 11.3261 16.4729 12.5979 15.5352 13.5355C14.5975 14.4732 13.3258 15 11.9997 15C10.6736 15 9.40184 14.4732 8.46415 13.5355C7.52647 12.5979 6.99969 11.3261 6.99969 10V6C6.99969 4.67392 7.52647 3.40215 8.46415 2.46447C9.40184 1.52678 10.6736 1 11.9997 1ZM3.05469 11H5.06969C5.31198 12.6648 6.14556 14.1867 7.41792 15.2873C8.69028 16.3879 10.3164 16.9936 11.9987 16.9936C13.681 16.9936 15.3071 16.3879 16.5795 15.2873C17.8518 14.1867 18.6854 12.6648 18.9277 11H20.9437C20.7163 13.0287 19.8063 14.9199 18.3629 16.3635C16.9195 17.8071 15.0284 18.7174 12.9997 18.945V23H10.9997V18.945C8.97082 18.7176 7.07947 17.8074 5.63586 16.3638C4.19226 14.9202 3.2821 13.0289 3.05469 11Z"
        fill="#424242"
      />
    </svg>
  );
}
export function SmillyIcon() {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M12 22C6.477 22 2 17.523 2 12C2 6.477 6.477 2 12 2C17.523 2 22 6.477 22 12C22 17.523 17.523 22 12 22ZM12 20C14.1217 20 16.1566 19.1571 17.6569 17.6569C19.1571 16.1566 20 14.1217 20 12C20 9.87827 19.1571 7.84344 17.6569 6.34315C16.1566 4.84285 14.1217 4 12 4C9.87827 4 7.84344 4.84285 6.34315 6.34315C4.84285 7.84344 4 9.87827 4 12C4 14.1217 4.84285 16.1566 6.34315 17.6569C7.84344 19.1571 9.87827 20 12 20ZM8 13H16C16 14.0609 15.5786 15.0783 14.8284 15.8284C14.0783 16.5786 13.0609 17 12 17C10.9391 17 9.92172 16.5786 9.17157 15.8284C8.42143 15.0783 8 14.0609 8 13ZM8 11C7.60218 11 7.22064 10.842 6.93934 10.5607C6.65804 10.2794 6.5 9.89782 6.5 9.5C6.5 9.10218 6.65804 8.72064 6.93934 8.43934C7.22064 8.15804 7.60218 8 8 8C8.39782 8 8.77936 8.15804 9.06066 8.43934C9.34196 8.72064 9.5 9.10218 9.5 9.5C9.5 9.89782 9.34196 10.2794 9.06066 10.5607C8.77936 10.842 8.39782 11 8 11ZM16 11C15.6022 11 15.2206 10.842 14.9393 10.5607C14.658 10.2794 14.5 9.89782 14.5 9.5C14.5 9.10218 14.658 8.72064 14.9393 8.43934C15.2206 8.15804 15.6022 8 16 8C16.3978 8 16.7794 8.15804 17.0607 8.43934C17.342 8.72064 17.5 9.10218 17.5 9.5C17.5 9.89782 17.342 10.2794 17.0607 10.5607C16.7794 10.842 16.3978 11 16 11Z"
        fill="#424242"
      />
    </svg>
  );
}
export function SendIcon({ color, size }) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M5.41 21.75C4.29 21.75 3.58 21.37 3.13 20.92C2.25 20.04 1.63 18.17 3.61 14.2L4.48 12.47C4.59 12.24 4.59 11.76 4.48 11.53L3.61 9.79999C1.62 5.82999 2.25 3.94999 3.13 3.07999C4 2.19999 5.88 1.56999 9.84 3.55999L18.4 7.83999C20.53 8.89999 21.7 10.38 21.7 12C21.7 13.62 20.53 15.1 18.41 16.16L9.85 20.44C7.91 21.41 6.47 21.75 5.41 21.75ZM5.41 3.74999C4.87 3.74999 4.45 3.87999 4.19 4.13999C3.46 4.85999 3.75 6.72999 4.95 9.11999L5.82 10.86C6.14 11.51 6.14 12.49 5.82 13.14L4.95 14.87C3.75 17.27 3.46 19.13 4.19 19.85C4.91 20.58 6.78 20.29 9.18 19.09L17.74 14.81C19.31 14.03 20.2 13 20.2 11.99C20.2 10.98 19.3 9.94999 17.73 9.16999L9.17 4.89999C7.65 4.13999 6.34 3.74999 5.41 3.74999Z"
        fill={color}
      />
      <path
        d="M10.84 12.75H5.44C5.03 12.75 4.69 12.41 4.69 12C4.69 11.59 5.03 11.25 5.44 11.25H10.84C11.25 11.25 11.59 11.59 11.59 12C11.59 12.41 11.25 12.75 10.84 12.75Z"
        fill={color}
      />
    </svg>
  );
}
SendIcon.propTypes = {
  color: PropTypes.string,
  size: PropTypes.number,
};
SendIcon.defaultProps = {
  color: '#292D32',
  size: 24,
};
export function SendRightUpIcon({ color, size }) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 34 34"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M20.1537 9.844L7.64496 13.726C4.67511 14.6453 4.63268 18.8313 7.58132 19.8142L11.0179 20.9597C11.9724 21.2779 12.722 22.0275 13.0402 22.982L14.1857 26.4186C15.1686 29.3672 19.3476 29.3177 20.2739 26.3549L24.1559 13.8462C24.9196 11.3855 22.6144 9.08033 20.1537 9.844Z"
        stroke={color}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}
SendRightUpIcon.propTypes = {
  color: PropTypes.string,
  size: PropTypes.number,
};
SendRightUpIcon.defaultProps = {
  color: '#292D32',
  size: 24,
};
export function VideoIcon() {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 12 12"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M9.5 9.12799C9.5 9.33299 9.333 9.49999 9.128 9.49999H8.5V8.5H9.5V9.12799ZM2.5 9.12799V8.5H3.5V9.49999H2.872C2.667 9.49999 2.5 9.33299 2.5 9.12799ZM2.872 2.5H3.5V3.5H2.5V2.872C2.5 2.667 2.667 2.5 2.872 2.5ZM9.5 2.872V3.5H8.5V2.5H9.128C9.333 2.5 9.5 2.667 9.5 2.872ZM8.5 7.50001H9.5V6.5H8.5V7.50001ZM8.5 5.5H9.5V4.50001H8.5V5.5ZM4.5 9.49999H7.5V2.5H4.5V9.49999ZM2.5 7.50001H3.5V6.5H2.5V7.50001ZM2.5 5.5H3.5V4.50001H2.5V5.5ZM9.128 1.5H2.872C2.1155 1.5 1.5 2.116 1.5 2.872V9.128C1.5 9.8845 2.1155 10.5 2.872 10.5H9.128C9.8845 10.5 10.5 9.8845 10.5 9.128V2.872C10.5 2.116 9.8845 1.5 9.128 1.5Z"
        fill="white"
      />
      <mask
        id="mask0_3_3497"
        maskUnits="userSpaceOnUse"
        x="1"
        y="1"
        width="10"
        height="10"
      >
        <path
          d="M9.5 9.12799C9.5 9.33299 9.333 9.49999 9.128 9.49999H8.5V8.5H9.5V9.12799ZM2.5 9.12799V8.5H3.5V9.49999H2.872C2.667 9.49999 2.5 9.33299 2.5 9.12799ZM2.872 2.5H3.5V3.5H2.5V2.872C2.5 2.667 2.667 2.5 2.872 2.5ZM9.5 2.872V3.5H8.5V2.5H9.128C9.333 2.5 9.5 2.667 9.5 2.872ZM8.5 7.50001H9.5V6.5H8.5V7.50001ZM8.5 5.5H9.5V4.50001H8.5V5.5ZM4.5 9.49999H7.5V2.5H4.5V9.49999ZM2.5 7.50001H3.5V6.5H2.5V7.50001ZM2.5 5.5H3.5V4.50001H2.5V5.5ZM9.128 1.5H2.872C2.1155 1.5 1.5 2.116 1.5 2.872V9.128C1.5 9.8845 2.1155 10.5 2.872 10.5H9.128C9.8845 10.5 10.5 9.8845 10.5 9.128V2.872C10.5 2.116 9.8845 1.5 9.128 1.5Z"
          fill="white"
        />
      </mask>
      <g mask="url(#mask0_3_3497)">
        <rect width="8" height="8" fill="white" />
      </g>
    </svg>
  );
}
export function PhotoIcon() {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 12 12"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M4 5C4.414 5 4.75 4.664 4.75 4.25C4.75 3.836 4.414 3.5 4 3.5C3.586 3.5 3.25 3.836 3.25 4.25C3.25 4.664 3.586 5 4 5ZM9 9.49999H3.2805L6.783 6.57749C6.906 6.47299 7.129 6.47349 7.2495 6.57699L9.5 8.49699V8.99999C9.5 9.27599 9.276 9.49999 9 9.49999ZM3 2.49999H9C9.276 2.49999 9.5 2.72399 9.5 2.99999V7.182L7.8985 5.816C7.4035 5.395 6.629 5.395 6.1385 5.813L2.5 8.849V2.99999C2.5 2.72399 2.724 2.49999 3 2.49999ZM9 1.5H3C2.173 1.5 1.5 2.173 1.5 3V9C1.5 9.827 2.173 10.5 3 10.5H9C9.827 10.5 10.5 9.827 10.5 9V3C10.5 2.173 9.827 1.5 9 1.5Z"
        fill="white"
      />
      <mask
        id="mask0_3_3494"
        maskUnits="userSpaceOnUse"
        x="1"
        y="1"
        width="10"
        height="10"
      >
        <path
          d="M4 5C4.414 5 4.75 4.664 4.75 4.25C4.75 3.836 4.414 3.5 4 3.5C3.586 3.5 3.25 3.836 3.25 4.25C3.25 4.664 3.586 5 4 5ZM9 9.49999H3.2805L6.783 6.57749C6.906 6.47299 7.129 6.47349 7.2495 6.57699L9.5 8.49699V8.99999C9.5 9.27599 9.276 9.49999 9 9.49999ZM3 2.49999H9C9.276 2.49999 9.5 2.72399 9.5 2.99999V7.182L7.8985 5.816C7.4035 5.395 6.629 5.395 6.1385 5.813L2.5 8.849V2.99999C2.5 2.72399 2.724 2.49999 3 2.49999ZM9 1.5H3C2.173 1.5 1.5 2.173 1.5 3V9C1.5 9.827 2.173 10.5 3 10.5H9C9.827 10.5 10.5 9.827 10.5 9V3C10.5 2.173 9.827 1.5 9 1.5Z"
          fill="white"
        />
      </mask>
      <g mask="url(#mask0_3_3494)">
        <rect width="12" height="12" fill="white" />
      </g>
    </svg>
  );
}
export function FileIcon() {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 12 12"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M8.72224 9.99999H3.27775C3.12475 9.99999 3.00025 9.88799 3.00025 9.74999V2.24999C3.00025 2.112 3.12475 2 3.27775 2H5.50024V4.07499C5.50024 4.86099 6.10874 5.49999 6.85724 5.49999H9.00024V9.74999C9.00024 9.88799 8.87524 9.99999 8.72224 9.99999ZM8.82474 4.49999H6.85725C6.66025 4.49999 6.50025 4.30949 6.50025 4.07499V2H6.55625L8.82474 4.49999ZM9.87025 4.164L7.14825 1.164C7.05375 1.0595 6.91925 1 6.77775 1H3.27774C2.57324 1 2.00024 1.561 2.00024 2.25V9.75C2.00024 10.439 2.57324 11 3.27774 11H8.72225C9.42675 11 10.0002 10.439 10.0002 9.75V4.5C10.0002 4.3755 9.95375 4.256 9.87025 4.164Z"
        fill="white"
      />
      <mask
        id="mask0_3_3491"
        maskUnits="userSpaceOnUse"
        x="2"
        y="1"
        width="9"
        height="10"
      >
        <path
          d="M8.72224 9.99999H3.27775C3.12475 9.99999 3.00025 9.88799 3.00025 9.74999V2.24999C3.00025 2.112 3.12475 2 3.27775 2H5.50024V4.07499C5.50024 4.86099 6.10874 5.49999 6.85724 5.49999H9.00024V9.74999C9.00024 9.88799 8.87524 9.99999 8.72224 9.99999ZM8.82474 4.49999H6.85725C6.66025 4.49999 6.50025 4.30949 6.50025 4.07499V2H6.55625L8.82474 4.49999ZM9.87025 4.164L7.14825 1.164C7.05375 1.0595 6.91925 1 6.77775 1H3.27774C2.57324 1 2.00024 1.561 2.00024 2.25V9.75C2.00024 10.439 2.57324 11 3.27774 11H8.72225C9.42675 11 10.0002 10.439 10.0002 9.75V4.5C10.0002 4.3755 9.95375 4.256 9.87025 4.164Z"
          fill="white"
        />
      </mask>
      <g mask="url(#mask0_3_3491)">
        <rect x="3.6001" y="3.6001" width="12" height="12" fill="white" />
      </g>
    </svg>
  );
}
export function FreshdeskIcon() {
  return (
    <svg
      width="26"
      height="24"
      viewBox="0 0 26 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M25.5 8.24251C25.5007 7.25777 25.3071 6.28256 24.9303 5.37274C24.5535 4.46292 24.001 3.63636 23.3043 2.94039C22.6076 2.24442 21.7805 1.69271 20.8703 1.31685C19.9601 0.940989 18.9847 0.748366 18 0.75001H8C3.85875 0.75001 0.5 4.11876 0.5 8.24251V23.25H18C22.1412 23.25 25.5 19.8813 25.5 15.7575V8.24251ZM3 20.75V8.24251C3.00331 6.91814 3.53139 5.64906 4.46857 4.71328C5.40575 3.77751 6.67562 3.25133 8 3.25001H18C18.6564 3.24837 19.3067 3.37632 19.9136 3.62654C20.5205 3.87676 21.072 4.24433 21.5365 4.70815C22.0011 5.17198 22.3695 5.72294 22.6206 6.32945C22.8717 6.93595 23.0007 7.58607 23 8.24251V15.7575C22.9967 17.0819 22.4686 18.351 21.5314 19.2867C20.5942 20.2225 19.3244 20.7487 18 20.75H3ZM10.5 10.75H8V13.25H10.5V10.75ZM18 10.75H15.5V13.25H18V10.75Z"
        fill="#0288FA"
      />
    </svg>
  );
}
export function SupportIcon() {
  return (
    <svg
      width="12"
      height="13"
      viewBox="0 0 12 13"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M11.8334 8.91785C11.8331 9.7156 11.5604 10.4893 11.0605 11.111C10.5605 11.7326 9.86323 12.1649 9.0841 12.3362L8.71194 11.2197C9.05274 11.1636 9.37685 11.0325 9.6609 10.836C9.94496 10.6395 10.1819 10.3825 10.3546 10.0834H8.91669C8.60727 10.0834 8.31052 9.96044 8.09173 9.74164C7.87294 9.52285 7.75002 9.22611 7.75002 8.91669V6.58335C7.75002 6.27393 7.87294 5.97719 8.09173 5.7584C8.31052 5.5396 8.60727 5.41669 8.91669 5.41669H10.6305C10.4882 4.28904 9.93922 3.2521 9.08669 2.50041C8.23415 1.74873 7.13661 1.33398 6.00002 1.33398C4.86343 1.33398 3.76589 1.74873 2.91335 2.50041C2.06082 3.2521 1.51187 4.28904 1.36952 5.41669H3.08335C3.39277 5.41669 3.68952 5.5396 3.90831 5.7584C4.1271 5.97719 4.25002 6.27393 4.25002 6.58335V8.91669C4.25002 9.22611 4.1271 9.52285 3.90831 9.74164C3.68952 9.96044 3.39277 10.0834 3.08335 10.0834H1.33335C1.02393 10.0834 0.727188 9.96044 0.508396 9.74164C0.289603 9.52285 0.166687 9.22611 0.166687 8.91669V6.00002C0.166687 2.77827 2.77827 0.166687 6.00002 0.166687C9.22177 0.166687 11.8334 2.77827 11.8334 6.00002V8.91785ZM10.6667 8.91669V6.58335H8.91669V8.91669H10.6667ZM1.33335 6.58335V8.91669H3.08335V6.58335H1.33335Z"
        fill="#606060"
      />
    </svg>
  );
}
export function FAQIcon() {
  return (
    <svg
      width="12"
      height="13"
      viewBox="0 0 12 13"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M2.36177 8.91667H10.6667V1.91667H1.33335V9.72458L2.36177 8.91667ZM2.76544 10.0833L0.166687 12.125V1.33333C0.166687 1.17862 0.228145 1.03025 0.337541 0.920854C0.446938 0.811458 0.595311 0.75 0.75002 0.75H11.25C11.4047 0.75 11.5531 0.811458 11.6625 0.920854C11.7719 1.03025 11.8334 1.17862 11.8334 1.33333V9.5C11.8334 9.65471 11.7719 9.80308 11.6625 9.91248C11.5531 10.0219 11.4047 10.0833 11.25 10.0833H2.76544ZM5.41669 7.16667H6.58335V8.33333H5.41669V7.16667ZM3.99744 4.14092C4.07323 3.76163 4.25516 3.41166 4.52208 3.13174C4.789 2.85181 5.12993 2.65344 5.50518 2.55971C5.88044 2.46598 6.2746 2.48073 6.6418 2.60227C7.00899 2.7238 7.33413 2.94711 7.57937 3.24621C7.82461 3.54531 7.97986 3.90791 8.02708 4.2918C8.07429 4.67569 8.01151 5.0651 7.84605 5.41471C7.6806 5.76432 7.41926 6.05976 7.09245 6.26664C6.76564 6.47352 6.38681 6.58335 6.00002 6.58333H5.41669V5.41667H6.00002C6.16573 5.41666 6.32804 5.36959 6.46804 5.28094C6.60805 5.19229 6.72001 5.06571 6.79089 4.91592C6.86177 4.76613 6.88865 4.5993 6.86842 4.43482C6.84818 4.27035 6.78166 4.11501 6.67659 3.98686C6.57152 3.85872 6.43222 3.76305 6.2749 3.71098C6.11758 3.65891 5.94871 3.65259 5.78793 3.69274C5.62716 3.7329 5.4811 3.81788 5.36673 3.93781C5.25237 4.05773 5.17442 4.20767 5.14194 4.37017L3.99744 4.14092Z"
        fill="#606060"
      />
    </svg>
  );
}
export function DownloadIcon({ color, width, height }) {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 24 25"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M15.26 22.7503H8.73998C3.82998 22.7503 1.72998 20.6503 1.72998 15.7403V15.6103C1.72998 11.1703 3.47998 9.03027 7.39998 8.66027C7.79998 8.63027 8.17998 8.93027 8.21998 9.34027C8.25998 9.75027 7.95998 10.1203 7.53998 10.1603C4.39998 10.4503 3.22998 11.9303 3.22998 15.6203V15.7503C3.22998 19.8203 4.66998 21.2603 8.73998 21.2603H15.26C19.33 21.2603 20.77 19.8203 20.77 15.7503V15.6203C20.77 11.9103 19.58 10.4303 16.38 10.1603C15.97 10.1203 15.66 9.76027 15.7 9.35027C15.74 8.94027 16.09 8.63027 16.51 8.67027C20.49 9.01027 22.27 11.1603 22.27 15.6303V15.7603C22.27 20.6503 20.17 22.7503 15.26 22.7503Z"
        fill={color}
      />
      <path
        d="M12 16.13C11.59 16.13 11.25 15.79 11.25 15.38V2.5C11.25 2.09 11.59 1.75 12 1.75C12.41 1.75 12.75 2.09 12.75 2.5V15.38C12.75 15.8 12.41 16.13 12 16.13Z"
        fill={color}
      />
      <path
        d="M12.0001 17.2498C11.8101 17.2498 11.6201 17.1798 11.4701 17.0298L8.12009 13.6798C7.83009 13.3898 7.83009 12.9098 8.12009 12.6198C8.41009 12.3298 8.89009 12.3298 9.18009 12.6198L12.0001 15.4398L14.8201 12.6198C15.1101 12.3298 15.5901 12.3298 15.8801 12.6198C16.1701 12.9098 16.1701 13.3898 15.8801 13.6798L12.5301 17.0298C12.3801 17.1798 12.1901 17.2498 12.0001 17.2498Z"
        fill={color}
      />
    </svg>
  );
}
DownloadIcon.propTypes = {
  color: PropTypes.string,
  width: PropTypes.number,
  height: PropTypes.string,
};
DownloadIcon.defaultProps = {
  color: '#7D7D7D',
  width: '1.667vw',
  height: '1.667vw',
};
export function DownloadZipIcon() {
  return (
    <svg
      width="1.111vw"
      height="1.111vw"
      viewBox="0 0 16 17"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clip-path="url(#clip0_24234_58806)">
        <path
          d="M5.85352 5.69727H5.44727V6.35977H5.85352C5.96914 6.35977 6.05664 6.32852 6.11602 6.26602C6.17539 6.20352 6.20352 6.12539 6.20352 6.03164C6.20352 5.93789 6.17539 5.85664 6.11602 5.79414C6.05664 5.72852 5.96914 5.69727 5.85352 5.69727Z"
          fill="#616B80"
        />
        <path
          d="M7.95664 6.38125C7.95664 5.49062 7.28164 4.76875 6.44727 4.76875H1.15039V7.99687H6.44727C7.28164 7.99687 7.95664 7.27187 7.95664 6.38125ZM3.91289 7.31875H2.59414V7.125L3.50977 5.69687H2.60039V5.44687H3.87852V5.63437L2.95977 7.07187H3.91289V7.31875ZM4.63477 7.31875H4.32227V5.44375H4.63477V7.31875ZM5.85352 6.60937H5.44727V7.31875H5.13477V5.44375H5.85352C6.05977 5.44375 6.22227 5.49687 6.34102 5.60312C6.45977 5.70937 6.51602 5.85 6.51602 6.025C6.51602 6.2 6.45664 6.34062 6.34102 6.44687C6.22227 6.55625 6.05977 6.60937 5.85352 6.60937ZM11.6691 1.60937H13.8785V1.89375H11.6691V1.60937ZM13.8754 0.89375C13.8754 0.78125 13.7848 0.6875 13.6691 0.6875H11.8754C11.7629 0.6875 11.6691 0.78125 11.6691 0.89375V1.325H13.8754V0.89375ZM14.8285 3.95625C14.7941 3.88437 14.7223 3.84062 14.6441 3.84062H13.8754V2.175H11.666V3.84062H10.9004C10.8223 3.84062 10.7504 3.88437 10.716 3.95625C10.6816 4.02812 10.691 4.1125 10.7379 4.17187L12.6098 6.575C12.6473 6.625 12.7098 6.65312 12.7723 6.65312C12.8348 6.65312 12.8973 6.625 12.9348 6.575L14.8066 4.17187C14.8535 4.10937 14.8629 4.025 14.8285 3.95625Z"
          fill="#616B80"
        />
        <path
          d="M12.266 6.84336L10.3941 4.44023C10.2441 4.24648 10.216 3.98086 10.3254 3.76211C10.4316 3.54336 10.6598 3.40273 10.9035 3.40273H11.2348V1.75586H2.67227C1.83164 1.75586 1.15039 2.43711 1.15039 3.27773V4.33398H6.44727C7.52227 4.33398 8.39414 5.25273 8.39414 6.38398C8.39414 7.51523 7.51914 8.43398 6.44727 8.43398H1.15039V14.7902C1.15039 15.6309 1.83164 16.3121 2.67227 16.3121H11.2504C12.091 16.3121 12.7723 15.6309 12.7723 14.7902V7.09336C12.5723 7.09336 12.3879 7.00273 12.266 6.84336Z"
          fill="#616B80"
        />
      </g>
      <defs>
        <clipPath id="clip0_24234_58806">
          <rect
            width="16"
            height="16"
            fill="white"
            transform="translate(0 0.5)"
          />
        </clipPath>
      </defs>
    </svg>
  );
}
export function SendReminderIcon({ color }) {
  return (
    <svg
      width="12"
      height="12"
      viewBox="0 0 12 12"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M1.33327 10.6666V7.16663C1.33327 5.92895 1.82494 4.74196 2.70011 3.86679C3.57528 2.99162 4.76226 2.49996 5.99994 2.49996C7.23762 2.49996 8.4246 2.99162 9.29977 3.86679C10.1749 4.74196 10.6666 5.92895 10.6666 7.16663V10.6666H11.2499V11.8333H0.749939V10.6666H1.33327ZM2.49994 10.6666H9.49994V7.16663C9.49994 6.23837 9.13119 5.34813 8.47481 4.69175C7.81844 4.03537 6.9282 3.66663 5.99994 3.66663C5.07168 3.66663 4.18144 4.03537 3.52507 4.69175C2.86869 5.34813 2.49994 6.23837 2.49994 7.16663V10.6666ZM5.41661 0.166626H6.58327V1.91663H5.41661V0.166626ZM10.5371 1.80463L11.3619 2.62946L10.1253 3.86671L9.29986 3.04188L10.5371 1.80463ZM0.637939 2.62946L1.46277 1.80463L2.70002 3.04129L1.87577 3.86729L0.637939 2.62946ZM3.08327 7.16663C3.08327 6.39308 3.39056 5.65121 3.93754 5.10423C4.48453 4.55725 5.22639 4.24996 5.99994 4.24996V5.41663C5.53581 5.41663 5.09069 5.601 4.7625 5.92919C4.43431 6.25738 4.24994 6.7025 4.24994 7.16663H3.08327Z"
        fill={color !== '' ? color : '#828282'}
      />
    </svg>
  );
}
SendReminderIcon.propTypes = {
  color: PropTypes.string,
};
SendReminderIcon.defaultProps = {
  color: '',
};
export function EnvelopIcon() {
  return (
    <svg
      width="18"
      height="1.111vw"
      viewBox="0 0 18 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M1.5 0.5H16.5C16.721 0.5 16.933 0.587797 17.0893 0.744078C17.2455 0.900358 17.3333 1.11232 17.3333 1.33333V14.6667C17.3333 14.8877 17.2455 15.0996 17.0893 15.2559C16.933 15.4122 16.721 15.5 16.5 15.5H1.5C1.27899 15.5 1.06703 15.4122 0.910749 15.2559C0.754469 15.0996 0.666672 14.8877 0.666672 14.6667V1.33333C0.666672 1.11232 0.754469 0.900358 0.910749 0.744078C1.06703 0.587797 1.27899 0.5 1.5 0.5ZM15.6667 4.03167L9.06 9.94833L2.33334 4.01333V13.8333H15.6667V4.03167ZM2.75917 2.16667L9.05084 7.71833L15.2517 2.16667H2.75917Z"
        fill="#0288FA"
      />
    </svg>
  );
}
export function MapMarkerIcon() {
  return (
    <svg width="1.667vw" height="1.667vw" viewBox="0 0 24 24" version="1.1">
      <g transform="translate(0 -1028.4)">
        <path
          d="m12 0c-4.4183 2.3685e-15 -8 3.5817-8 8 0 1.421 0.3816 2.75 1.0312 3.906 0.1079 0.192 0.221 0.381 0.3438 0.563l6.625 11.531 6.625-11.531c0.102-0.151 0.19-0.311 0.281-0.469l0.063-0.094c0.649-1.156 1.031-2.485 1.031-3.906 0-4.4183-3.582-8-8-8zm0 4c2.209 0 4 1.7909 4 4 0 2.209-1.791 4-4 4-2.2091 0-4-1.791-4-4 0-2.2091 1.7909-4 4-4z"
          transform="translate(0 1028.4)"
          fill="#e74c3c"
        />
        <path
          d="m12 3c-2.7614 0-5 2.2386-5 5 0 2.761 2.2386 5 5 5 2.761 0 5-2.239 5-5 0-2.7614-2.239-5-5-5zm0 2c1.657 0 3 1.3431 3 3s-1.343 3-3 3-3-1.3431-3-3 1.343-3 3-3z"
          transform="translate(0 1028.4)"
          fill="#c0392b"
        />
      </g>
    </svg>
  );
}
export function EventOnTimeIcon() {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M10 20C4.477 20 0 15.523 0 10C0 4.477 4.477 0 10 0C15.523 0 20 4.477 20 10C20 15.523 15.523 20 10 20ZM11 10V5H9V12H15V10H11Z"
        fill="#00B468"
      />
    </svg>
  );
}
export function EventDelayIcon() {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M14.218 0.500023L19.901 6.18202V14.218L14.218 19.901H6.182L0.499001 14.218V6.18202L6.182 0.499023H14.218V0.500023ZM9 13V15H11V13H9ZM9 5.00002V11H11V5.00002H9Z"
        fill="#FF981E"
      />
    </svg>
  );
}
export function EventBehindScheduledIcon() {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M20 10C20 15.523 15.523 20 10 20C4.477 20 0 15.523 0 10C0 4.477 4.477 0 10 0C15.523 0 20 4.477 20 10ZM10 9H5V11H12V5H10V9Z"
        fill="#E80000"
      />
    </svg>
  );
}
export function EventModeOceanIcon() {
  return (
    <svg
      width="25"
      height="18"
      viewBox="0 0 25 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M4.35548 0.0967302C4.27321 0.188677 4.26353 0.299981 4.24901 1.35495L4.2345 2.51154H3.91994C3.45053 2.51154 3.41665 2.54058 3.41665 2.97128C3.41665 3.49876 3.37794 3.4794 4.54421 3.4794C5.7492 3.4794 5.73952 3.48424 5.73952 2.99547C5.73952 2.5551 5.69597 2.51154 5.22655 2.51154H4.86844V1.35011C4.86844 0.251588 4.86361 0.183838 4.77166 0.0918911C4.64584 -0.0339308 4.47162 -0.0290916 4.35548 0.0967302Z"
        fill="#00B468"
      />
      <path
        d="M3.47479 4.26348C3.39252 4.34575 3.39252 6.87187 3.47479 6.95414C3.51834 6.99769 3.82806 7.01221 4.55879 7.01221C5.42986 7.01221 5.59924 7.00253 5.66215 6.93478C5.7299 6.87187 5.73958 6.6783 5.73958 5.58945C5.73958 4.66999 5.72506 4.30704 5.68151 4.26348C5.59924 4.18122 3.55706 4.18122 3.47479 4.26348Z"
        fill="#00B468"
      />
      <path
        d="M10.0174 5.62339C10.0078 5.65727 10.0029 6.19443 10.0078 6.8187L10.0223 7.95594L11.1595 7.97045C12.1854 7.98013 12.3016 7.97529 12.3548 7.89786C12.4419 7.78172 12.4419 5.70082 12.3597 5.61855C12.2726 5.53145 10.0513 5.53628 10.0174 5.62339Z"
        fill="#00B468"
      />
      <path
        d="M13.4051 5.62342C13.3955 5.6573 13.3906 6.19446 13.3955 6.81873L13.41 7.95597L14.5424 7.97049C15.336 7.98016 15.6941 7.96565 15.7377 7.92693C15.8296 7.8495 15.8393 5.71053 15.7474 5.61858C15.6602 5.53148 13.439 5.53632 13.4051 5.62342Z"
        fill="#00B468"
      />
      <path
        d="M1.41333 7.83964L1.28751 7.93643V9.43177V10.9271L1.41817 11.0239C1.54399 11.1255 1.56335 11.1255 4.60727 11.1158C7.47697 11.1013 7.67538 11.0965 7.75765 11.0142C7.83992 10.9368 7.84476 10.8061 7.84476 9.42693V7.92191L7.72862 7.82996C7.62215 7.74285 7.49633 7.73801 4.57823 7.73801C1.5827 7.73801 1.53915 7.73801 1.41333 7.83964Z"
        fill="#00B468"
      />
      <path
        d="M10.0319 8.7883C10.0126 8.80281 9.99805 9.33514 9.99805 9.96909C9.99805 10.9708 10.0077 11.1208 10.0755 11.145C10.119 11.1596 10.6272 11.1741 11.2079 11.1741C12.1031 11.1741 12.2774 11.1644 12.3403 11.0966C12.408 11.0337 12.4177 10.8595 12.4177 9.96425C12.4177 9.38353 12.4032 8.8754 12.3887 8.83185C12.3645 8.7641 12.2144 8.75442 11.2127 8.75442C10.5788 8.75442 10.0464 8.76894 10.0319 8.7883Z"
        fill="#00B468"
      />
      <path
        d="M13.4197 8.78359C13.3568 8.8465 13.3809 11.0532 13.4439 11.1161C13.5261 11.1984 15.607 11.1984 15.7232 11.1113C15.8006 11.0581 15.8054 10.9419 15.7958 9.91599L15.7812 8.77875L14.615 8.76424C13.9762 8.7594 13.439 8.76908 13.4197 8.78359Z"
        fill="#00B468"
      />
      <path
        d="M16.8068 8.78359C16.7439 8.8465 16.7681 11.0532 16.831 11.1161C16.9133 11.1984 18.9942 11.1984 19.1103 11.1113C19.1877 11.0581 19.1926 10.9419 19.1829 9.91599L19.1684 8.77875L18.0021 8.76424C17.3633 8.7594 16.8262 8.76908 16.8068 8.78359Z"
        fill="#00B468"
      />
      <path
        d="M20.1946 11.5853L19.9188 11.9483H9.97401C1.49555 11.9483 0.024403 11.958 0.000206496 12.016C-0.02399 12.0741 2.08595 17.3732 2.28436 17.77L2.35695 17.9006H11.5177C20.1801 17.9006 20.6834 17.8958 20.7511 17.8135C20.9544 17.5861 24.7629 11.3531 24.7387 11.2901C24.7145 11.2321 24.3903 11.2224 22.5949 11.2224L20.4753 11.2272L20.1946 11.5853ZM16.9039 13.5791C17.0345 13.6662 17.1265 13.9276 17.0829 14.0969C17.0684 14.1647 16.9862 14.276 16.9087 14.3437C16.5119 14.6777 15.9457 14.2324 16.1683 13.763C16.3087 13.4775 16.6184 13.4001 16.9039 13.5791ZM19.3623 13.613C19.73 13.9808 19.4155 14.5664 18.9219 14.4454C18.5638 14.3534 18.4379 13.8985 18.6944 13.6324C18.8686 13.4485 19.188 13.4388 19.3623 13.613Z"
        fill="#00B468"
      />
    </svg>
  );
}
export function EventModeAirIcon() {
  return (
    <svg
      width="20"
      height="19"
      viewBox="0 0 20 19"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M13.053 11L8 19H6L8.526 11L3.166 11L1.5 14H0L1 9.5L0 5H1.5L3.167 8L8.527 8L6 0L8 0L13.053 8H18.5C18.8978 8 19.2794 8.15804 19.5607 8.43934C19.842 8.72064 20 9.10218 20 9.5C20 9.89782 19.842 10.2794 19.5607 10.5607C19.2794 10.842 18.8978 11 18.5 11H13.053Z"
        fill="#FF981E"
      />
    </svg>
  );
}
export function EventModeRoadIcon() {
  return (
    <svg
      width="23"
      height="12"
      viewBox="0 0 23 12"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M16.1094 4.35141V7.89047H8.53906H0.96875V8.71078V9.5311H1.8125H2.65625V9.82172C2.66094 11.1811 4.09531 12.0811 5.32344 11.4905C5.65625 11.3311 6.04531 10.9327 6.19531 10.6045C6.33125 10.3045 6.41094 9.86391 6.37344 9.65766L6.35 9.5311H7.28281H8.22031L8.24844 9.87797C8.3 10.4873 8.53438 10.9373 8.98438 11.2936C9.60781 11.7905 10.6109 11.7905 11.2344 11.2936C11.6844 10.9373 11.9281 10.4733 11.9703 9.8686L11.9984 9.5311H14.2391H16.475L16.4797 9.84985C16.4844 10.5342 16.9063 11.1952 17.525 11.4952C18.7484 12.0811 20.1828 11.1811 20.1875 9.82172V9.5311H21.5938H23V7.0561V4.58578L22.1609 2.71078L21.3219 0.835783L18.7156 0.82172L16.1094 0.812346V4.35141ZM20.9047 2.42016C21.0266 2.69672 21.2844 3.28266 21.4766 3.7186L21.8234 4.51547L19.5641 4.5061L17.3047 4.49203L17.2906 3.24985C17.2859 2.56547 17.2906 1.98422 17.3047 1.95141C17.3188 1.89985 17.675 1.89047 19.0016 1.89985L20.6797 1.91391L20.9047 2.42016ZM4.89219 9.18422C5.50625 9.58266 5.24375 10.5155 4.51719 10.5155C4.22656 10.5155 3.99688 10.3842 3.875 10.1358C3.53281 9.47016 4.26875 8.78578 4.89219 9.18422ZM10.5219 9.18891C10.8219 9.41391 10.9297 9.91547 10.7328 10.1827C10.3391 10.7123 9.575 10.5905 9.41094 9.97641C9.32188 9.6436 9.49531 9.26391 9.8 9.12797C9.99219 9.03891 10.3625 9.07172 10.5219 9.18891ZM18.6875 9.16547C19.0391 9.40922 19.1516 9.77953 18.9734 10.1264C18.7109 10.6467 17.9469 10.6514 17.6938 10.1405C17.5766 9.91078 17.5859 9.62485 17.7172 9.43266C17.9609 9.07172 18.3781 8.95453 18.6875 9.16547Z"
        fill="#E80000"
      />
    </svg>
  );
}
export function LeftArrowIcon() {
  return (
    <svg
      width="0.417vw"
      height="0.694vw"
      viewBox="0 0 6 10"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M2.828 5.00008L5.657 7.82808L4.243 9.24308L0 5.00008L4.243 0.75708L5.657 2.17208L2.828 5.00008Z"
        fill="#03053D"
      />
    </svg>
  );
}
export function RightArrowIcon({ color }) {
  return (
    <svg
      width="0.417vw"
      height="0.694vw"
      viewBox="0 0 6 10"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M3.17199 5.00008L0.342987 2.17208L1.75699 0.75708L5.99999 5.00008L1.75699 9.24308L0.342987 7.82808L3.17199 5.00008Z"
        fill={color || '#03053D'}
      />
    </svg>
  );
}
RightArrowIcon.propTypes = {
  color: PropTypes.string,
};
RightArrowIcon.defaultProps = {
  color: '',
};
export function LocationIcon({ color, size }) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 12 15"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M6 14.8187L1.75734 10.576C0.918228 9.73689 0.346791 8.66779 0.115286 7.5039C-0.11622 6.34002 0.00260456 5.13362 0.456732 4.03727C0.91086 2.94092 1.6799 2.00385 2.66659 1.34457C3.65328 0.685281 4.81332 0.333389 6 0.333389C7.18669 0.333389 8.34672 0.685281 9.33342 1.34457C10.3201 2.00385 11.0891 2.94092 11.5433 4.03727C11.9974 5.13362 12.1162 6.34002 11.8847 7.5039C11.6532 8.66779 11.0818 9.73689 10.2427 10.576L6 14.8187ZM9.3 9.63334C9.9526 8.98067 10.397 8.14915 10.577 7.24392C10.7571 6.33869 10.6646 5.4004 10.3114 4.54771C9.95817 3.69501 9.36003 2.96621 8.59261 2.45345C7.82519 1.94069 6.92296 1.66701 6 1.66701C5.07704 1.66701 4.17481 1.94069 3.40739 2.45345C2.63997 2.96621 2.04183 3.69501 1.68861 4.54771C1.33539 5.4004 1.24294 6.33869 1.42297 7.24392C1.603 8.14915 2.04741 8.98067 2.7 9.63334L6 12.9333L9.3 9.63334ZM6 7.66667C5.64638 7.66667 5.30724 7.52619 5.05719 7.27615C4.80715 7.0261 4.66667 6.68696 4.66667 6.33334C4.66667 5.97971 4.80715 5.64058 5.05719 5.39053C5.30724 5.14048 5.64638 5 6 5C6.35362 5 6.69276 5.14048 6.94281 5.39053C7.19286 5.64058 7.33334 5.97971 7.33334 6.33334C7.33334 6.68696 7.19286 7.0261 6.94281 7.27615C6.69276 7.52619 6.35362 7.66667 6 7.66667Z"
        fill={color}
      />
    </svg>
  );
}
LocationIcon.propTypes = {
  color: PropTypes.string,
  size: PropTypes.number,
};
LocationIcon.defaultProps = {
  color: '#797979',
  size: '1.111vw',
};
export function TransferAccountIcon({ color }) {
  return (
    <svg
      version="1.1"
      id="Layer_1"
      xmlns="http://www.w3.org/2000/svg"
      x="0px"
      y="0px"
      viewBox="0 0 489.9 489.9"
    >
      <g>
        <g>
          <path
            fill={color !== '' ? color : '#3C92CA'}
            d="M90.3,96.956c-3.8,3.9-3.8,10.2,0.2,14c3.9,3.8,10.2,3.8,14-0.2c35.8-36.7,83.8-57.2,135-57.8
			c50-0.6,97.4,18,133.7,52.2l-18.2,0.2c-5.5,0.1-9.8,4.5-9.8,10c0.1,5.4,4.5,9.8,9.9,9.8h0.1l42.2-0.5c5.5-0.1,9.8-4.5,9.8-10
			l-0.4-42.1c-0.1-5.4-4.5-9.8-9.9-9.8h-0.1c-5.5,0.1-9.8,4.5-9.8,10l0.2,18.4c-40.1-38-92.6-58.6-147.9-58
			C182.7,33.956,129.8,56.556,90.3,96.956z"
          />
          <path
            fill={color !== '' ? color : '#3C92CA'}
            d="M378.9,379.056c-35.8,36.7-83.8,57.2-135,57.8c-50,0.6-97.4-18-133.7-52.2l18.2-0.2
			c5.5-0.1,9.8-4.5,9.8-10c-0.1-5.4-4.5-9.8-9.9-9.8h-0.1l-42.2,0.5c-5.5,0.1-9.8,4.5-9.8,10l0.5,42.2c0.1,5.4,4.5,9.8,9.9,9.8h0.1
			c5.5-0.1,9.8-4.5,9.8-10l-0.2-18.4c39.5,37.4,90.9,58,145.4,58c0.8,0,1.7,0,2.5,0c56.5-0.7,109.5-23.3,149-63.7
			c3.8-3.9,3.8-10.2-0.2-14C389,375.056,382.8,375.156,378.9,379.056z"
          />
          <path
            fill={color !== '' ? color : '#2C2F33'}
            d="M78.2,240.256c0-3.3-1.7-6.4-4.4-8.2c-1.8-1.2-2.8-3.2-2.8-5.3v-36.1c0-12.5,10.1-22.6,22.6-22.6
			h7.8c12.5,0,22.6,10.1,22.6,22.6v36.1c0,2.1-1.1,4.1-2.8,5.3c-2.8,1.8-4.4,4.9-4.4,8.2v34.8c0,4.4,2.5,8.4,6.5,10.3
			c4.5,2.2,27.8,14,49.4,31.7c1.7,1.4,2.7,3.6,2.7,5.9v24.7c0,5.5,4.4,9.9,9.9,9.9s9.9-4.4,9.9-9.9v-24.7c0-8.2-3.6-15.9-10-21.2
			c-18.9-15.6-39.2-26.9-48.6-31.8v-25.1c4.6-4.8,7.3-11.3,7.3-18.1v-36.1c0-23.4-19-42.4-42.4-42.4h-7.8c-23.4,0-42.4,19-42.4,42.4
			v36.1c0,6.8,2.6,13.3,7.3,18.1v25.1c-9.5,4.9-29.7,16.3-48.6,31.8c-6.3,5.2-10,12.9-10,21.2v24.7c0,5.5,4.4,9.9,9.9,9.9
			s9.9-4.4,9.9-9.9v-24.7c0-2.3,1-4.4,2.7-5.9c21.5-17.7,44.9-29.5,49.4-31.7c3.9-1.9,6.5-6,6.5-10.3v-34.8H78.2z"
          />
          <path
            fill={color !== '' ? color : '#2C2F33'}
            d="M479.9,301.856c-18.9-15.6-39.2-26.9-48.6-31.8v-25.1c4.6-4.8,7.3-11.3,7.3-18.1v-36.1
			c0-23.4-19-42.4-42.4-42.4h-7.8c-23.4,0-42.4,19-42.4,42.4v36.1c0,6.8,2.6,13.3,7.3,18.1v25c-9.5,4.9-29.7,16.3-48.6,31.8
			c-6.3,5.2-10,12.9-10,21.2v24.7c0,5.5,4.4,9.9,9.9,9.9s9.9-4.4,9.9-9.9v-24.7c0-2.3,1-4.4,2.7-5.9c21.5-17.7,44.9-29.5,49.4-31.7
			c3.9-1.9,6.4-6,6.4-10.3v-34.8c0-3.3-1.7-6.4-4.4-8.2c-1.8-1.2-2.8-3.2-2.8-5.3v-36.1c0-12.5,10.1-22.6,22.6-22.6h7.8
			c12.5,0,22.6,10.1,22.6,22.6v36.1c0,2.1-1.1,4.1-2.8,5.3c-2.8,1.8-4.4,4.9-4.4,8.2v34.8c0,4.4,2.5,8.4,6.4,10.3
			c4.5,2.2,27.9,14,49.4,31.7c1.7,1.4,2.7,3.6,2.7,5.9v24.7c0,5.5,4.4,9.9,9.9,9.9s9.9-4.4,9.9-9.9v-24.7
			C489.8,314.756,486.2,307.056,479.9,301.856z"
          />
        </g>
      </g>
    </svg>
  );
}
TransferAccountIcon.propTypes = {
  color: PropTypes.string,
};
TransferAccountIcon.defaultProps = {
  color: '',
};
export function TransferButtonIcon() {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M17.0168 10.1833C16.6751 10.1833 16.3918 9.89998 16.3918 9.55831V6.79169C16.3918 5.75835 15.5501 4.91669 14.5168 4.91669H2.9834C2.64173 4.91669 2.3584 4.63335 2.3584 4.29169C2.3584 3.95002 2.64173 3.66669 2.9834 3.66669H14.5168C16.2418 3.66669 17.6418 5.06669 17.6418 6.79169V9.55831C17.6418 9.90831 17.3584 10.1833 17.0168 10.1833Z"
        fill="#603ACB"
      />
      <path
        d="M5.61673 7.55832C5.4584 7.55832 5.30007 7.49996 5.17507 7.37496L2.54173 4.74164C2.42507 4.62498 2.3584 4.46662 2.3584 4.29995C2.3584 4.13329 2.42507 3.97498 2.54173 3.85831L5.17507 1.22495C5.41674 0.983285 5.81673 0.983285 6.0584 1.22495C6.30007 1.46662 6.30007 1.86667 6.0584 2.10833L3.86676 4.29995L6.0584 6.49162C6.30007 6.73329 6.30007 7.13329 6.0584 7.37496C5.9334 7.49162 5.77507 7.55832 5.61673 7.55832Z"
        fill="#603ACB"
      />
      <path
        d="M17.0168 16.325H5.4834C3.7584 16.325 2.3584 14.925 2.3584 13.2V10.4333C2.3584 10.0917 2.64173 9.80835 2.9834 9.80835C3.32507 9.80835 3.6084 10.0917 3.6084 10.4333V13.2C3.6084 14.2334 4.45007 15.075 5.4834 15.075H17.0168C17.3584 15.075 17.6418 15.3584 17.6418 15.7C17.6418 16.0417 17.3584 16.325 17.0168 16.325Z"
        fill="#603ACB"
      />
      <path
        d="M14.3837 18.9583C14.2253 18.9583 14.067 18.9 13.942 18.775C13.7003 18.5333 13.7003 18.1333 13.942 17.8916L16.1336 15.7L13.942 13.5083C13.7003 13.2667 13.7003 12.8667 13.942 12.625C14.1837 12.3833 14.5837 12.3833 14.8253 12.625L17.4587 15.2583C17.5753 15.375 17.642 15.5333 17.642 15.7C17.642 15.8667 17.5753 16.025 17.4587 16.1416L14.8253 18.775C14.7087 18.9 14.5503 18.9583 14.3837 18.9583Z"
        fill="#603ACB"
      />
    </svg>
  );
}
export function PieNoDataIcon() {
  return (
    <svg
      width="102"
      height="102"
      viewBox="0 0 102 102"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_2_2)">
        <path
          d="M47.5 44.2288V8.9525C47.5 5.84588 44.6666 3.48193 41.6582 4.25714C2.88552 14.2485 -0.747774 50.127 5.37545 67.3902C6.31046 70.0262 9.44593 70.7838 11.8178 69.3014L45.15 48.4688C46.6119 47.5551 47.5 45.9527 47.5 44.2288Z"
          stroke="#E3E3E3"
          strokeWidth="2"
        />
        <path
          d="M56 44.2286V8.95241C56 5.84583 58.8334 3.48188 61.8417 4.25701C100.618 14.2482 104.252 50.1275 98.1277 67.3906C97.1927 70.0265 94.0574 70.784 91.6856 69.3017L58.3502 48.4687C56.8882 47.5551 56 45.9527 56 44.2286Z"
          stroke="#E3E3E3"
          strokeWidth="2"
        />
        <path
          d="M54.2545 56.1231L87.7377 75.8529C90.3431 77.3881 90.9971 80.8978 88.9519 83.1255C61.9716 112.514 28.1911 98.39 15.9297 84.8346C14.1505 82.8676 14.7861 79.9069 16.9671 78.3976L48.871 56.3194C50.4738 55.2101 52.5752 55.1335 54.2545 56.1231Z"
          stroke="#E3E3E3"
          strokeWidth="2"
        />
        <g filter="url(#filter0_i_2_2)">
          <path
            d="M74.9979 64.5C76.9224 61.1667 81.7336 61.1667 83.6581 64.5L100.979 94.5C102.903 97.8333 100.497 102 96.6485 102H62.0075C58.1585 102 55.7528 97.8333 57.6774 94.5L74.9979 64.5Z"
            fill="#47ABFF"
          />
          <path
            d="M80.5 77.5455L80.3295 90.0909H78.3523L78.1818 77.5455H80.5ZM79.3409 95.1364C78.9205 95.1364 78.5597 94.9858 78.2585 94.6847C77.9574 94.3835 77.8068 94.0227 77.8068 93.6023C77.8068 93.1818 77.9574 92.821 78.2585 92.5199C78.5597 92.2187 78.9205 92.0682 79.3409 92.0682C79.7614 92.0682 80.1222 92.2187 80.4233 92.5199C80.7244 92.821 80.875 93.1818 80.875 93.6023C80.875 93.8807 80.804 94.1364 80.6619 94.3693C80.5256 94.6023 80.3409 94.7898 80.108 94.9318C79.8807 95.0682 79.625 95.1364 79.3409 95.1364Z"
            fill="white"
          />
        </g>
      </g>
      <defs>
        <filter
          id="filter0_i_2_2"
          x="57"
          y="62"
          width="44.6559"
          height="41"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="BackgroundImageFix"
            result="shape"
          />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy="1" />
          <feGaussianBlur stdDeviation="5" />
          <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
          />
          <feBlend mode="normal" in2="shape" result="effect1_innerShadow_2_2" />
        </filter>
        <clipPath id="clip0_2_2">
          <rect width="102" height="102" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
}
export function ShippingProgressNoDataIcon({ height, width }) {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 39 51"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M17.5078 0.607231C14.1484 0.958794 10.916 2.22832 8.14254 4.27911C6.98043 5.13848 5.14449 6.95488 4.31441 8.06816C-1.27153 15.5486 -0.705121 25.8221 5.6816 32.6971C6.62886 33.7322 7.84957 34.7186 9.70504 35.9588C13.0253 38.1951 15.4375 40.4022 17.664 43.2244C18.5039 44.2791 18.9628 44.6404 19.5 44.6307C20.0468 44.6307 20.4375 44.3475 21.1504 43.4393C23.4843 40.4705 25.916 38.2244 29.1777 36.0467C31.7363 34.3377 33.0156 33.1951 34.5 31.3104C38.2793 26.4666 39.5 19.9236 37.7226 14.0643C35.0664 5.31426 26.5605 -0.3498 17.5078 0.607231ZM22.2246 3.66387C28.3671 4.78692 33.25 9.16191 34.9687 15.0799C36.2968 19.66 35.5156 24.533 32.8105 28.6248C31.6484 30.3729 29.9785 31.9842 27.8593 33.41C26.9511 34.0154 25.8281 34.7967 25.3691 35.1482C23.6992 36.4178 21.6093 38.3807 20.0566 40.1482L19.5 40.783L18.9043 40.0994C17.8203 38.8592 15.5058 36.6522 14.2851 35.6756C13.6211 35.1482 12.2734 34.1717 11.2871 33.4979C9.7734 32.4822 9.29488 32.0916 8.2109 31.0174C7.26363 30.0701 6.74605 29.4647 6.18941 28.6248C3.33785 24.3084 2.63472 19.2791 4.22652 14.4647C6.17965 8.53691 11.375 4.32793 17.7128 3.52715C18.6503 3.40997 21.248 3.48809 22.2246 3.66387Z"
        fill="#84B1FC"
      />
      <path
        d="M18.1328 6.41846C14.9883 6.80908 12.3613 8.08838 10.1738 10.3052C8.23047 12.2681 7.11719 14.3579 6.54102 17.1021C6.30664 18.2446 6.30664 20.813 6.54102 22.0044C7.61523 27.3657 11.6777 31.4575 17.0586 32.6001C18.2109 32.8442 20.7891 32.8442 21.9414 32.6001C26.668 31.604 30.3789 28.3618 31.9316 23.8794C32.4785 22.2876 32.625 21.3696 32.625 19.5435C32.6348 18.3813 32.5859 17.6978 32.459 17.1021C32.0781 15.2954 31.3848 13.6255 30.3887 12.1216C29.7734 11.1938 27.8691 9.27979 26.9609 8.68408C25.3887 7.63916 23.6895 6.92627 22.0195 6.604C21.2285 6.44775 18.8164 6.33057 18.1328 6.41846ZM21.8438 9.56299C23.7773 10.0708 25.4082 10.9888 26.7363 12.3071C28.0547 13.6255 28.9434 15.2075 29.4902 17.1997C29.6465 17.8052 29.6855 18.2153 29.6855 19.5435C29.6855 20.9692 29.6562 21.2622 29.4316 22.1021C27.7129 28.5376 20.7305 31.731 14.8809 28.7622C12.8984 27.7563 11.3164 26.1353 10.3105 24.0845C7.58594 18.5181 10.3887 11.7896 16.248 9.84619C16.8242 9.65088 17.5859 9.45557 17.9375 9.39697C18.8945 9.25049 20.9746 9.33838 21.8438 9.56299Z"
        fill="#84B1FC"
      />
      <path
        d="M18.7969 12.4238C18.377 12.6387 18.0352 13.2148 18.0352 13.6836C18.0352 14.1719 18.377 14.7285 18.8164 14.9531C19.0215 15.0605 19.334 15.1484 19.5 15.1484C20.2422 15.1484 20.9648 14.4258 20.9648 13.6836C20.9648 13.1953 20.623 12.6387 20.1836 12.4141C19.7051 12.1699 19.2656 12.1699 18.7969 12.4238Z"
        fill="#84B1FC"
      />
      <path
        d="M18.7969 18.2832C18.5723 18.4004 18.3477 18.625 18.2305 18.8594C18.0449 19.2207 18.0352 19.4258 18.0352 22.5215C18.0352 25.6172 18.0449 25.8223 18.2305 26.1836C18.4551 26.623 19.0117 26.9648 19.5 26.9648C19.9883 26.9648 20.5449 26.623 20.7695 26.1836C20.9551 25.8223 20.9648 25.6172 20.9648 22.5215C20.9648 19.4258 20.9551 19.2207 20.7695 18.8594C20.4082 18.1465 19.5293 17.8926 18.7969 18.2832Z"
        fill="#84B1FC"
      />
      <path
        d="M10.0078 47.7754C9.58789 47.9902 9.24609 48.5664 9.24609 49.0352C9.24609 49.5234 9.58789 50.0801 10.0273 50.3047C10.3984 50.5 10.584 50.5 19.5 50.5C28.416 50.5 28.6016 50.5 28.9727 50.3047C29.4121 50.0801 29.7539 49.5234 29.7539 49.0352C29.7539 48.5469 29.4121 47.9902 28.9727 47.7656C28.6016 47.5703 28.4258 47.5703 19.4805 47.5703C10.6035 47.5801 10.3594 47.5801 10.0078 47.7754Z"
        fill="#84B1FC"
      />
    </svg>
  );
}
ShippingProgressNoDataIcon.propTypes = {
  height: PropTypes.string,
  width: PropTypes.string,
};
ShippingProgressNoDataIcon.defaultProps = {
  height: '3.542vw',
  width: '2.708vw',
};
export function DocumentIcon() {
  return (
    <svg
      version="1.1"
      id="Layer_1"
      xmlns="http://www.w3.org/2000/svg"
      x="0px"
      y="0px"
      viewBox="0 0 512 512"
    >
      <g>
        <g>
          <path
            d="M322.783,367.304c-9.206,0-16.696,7.49-16.696,16.696s7.49,16.696,16.696,16.696c9.206,0,16.696-7.49,16.696-16.696
			S331.989,367.304,322.783,367.304z"
          />
        </g>
      </g>
      <g>
        <g>
          <path
            d="M189.217,233.739c-9.206,0-16.696,7.49-16.696,16.696c0,9.206,7.49,16.696,16.696,16.696s16.696-7.49,16.696-16.696
			C205.913,241.229,198.423,233.739,189.217,233.739z"
          />
        </g>
      </g>
      <g>
        <g>
          <path
            d="M456.348,0H55.652c-9.217,0-16.696,7.473-16.696,16.696v478.609c0,5.788,3,11.157,7.913,14.201
			c4.935,3.043,11.065,3.31,16.25,0.733l59.315-29.658l59.315,29.658c4.696,2.347,10.239,2.347,14.935,0L256,480.581l59.315,29.658
			c2.347,1.174,4.913,1.761,7.467,1.761s5.12-0.587,7.467-1.761l59.315-29.658l59.315,29.658c5.185,2.581,11.315,2.31,16.25-0.733
			c4.913-3.044,7.913-8.414,7.913-14.201V16.696C473.043,7.473,465.565,0,456.348,0z M122.435,66.783
			c9.22,0,16.696,7.475,16.696,16.696s-7.475,16.696-16.696,16.696c-9.22,0-16.696-7.475-16.696-16.696
			S113.214,66.783,122.435,66.783z M122.435,166.957c-9.22,0-16.696-7.475-16.696-16.696s7.475-16.696,16.696-16.696
			c9.22,0,16.696,7.475,16.696,16.696S131.655,166.957,122.435,166.957z M139.13,250.435c0-27.619,22.468-50.087,50.087-50.087
			c27.619,0,50.087,22.468,50.087,50.087c0,27.619-22.468,50.087-50.087,50.087C161.598,300.522,139.13,278.054,139.13,250.435z
			 M196.968,399.863c-3.261,3.262-7.533,4.892-11.805,4.892s-8.544-1.631-11.804-4.892c-6.521-6.516-6.521-17.087,0-23.609
			l141.663-141.668c6.521-6.521,17.087-6.521,23.609,0c6.521,6.516,6.521,17.087,0,23.609L196.968,399.863z M322.783,434.087
			c-27.619,0-50.087-22.468-50.087-50.087s22.468-50.087,50.087-50.087c27.619,0,50.087,22.468,50.087,50.087
			S350.402,434.087,322.783,434.087z M389.565,166.957H189.217c-9.217,0-16.696-7.473-16.696-16.696s7.479-16.696,16.696-16.696
			h200.348c9.217,0,16.696,7.473,16.696,16.696C406.261,159.484,398.782,166.957,389.565,166.957z M389.565,100.174H189.217
			c-9.217,0-16.696-7.473-16.696-16.696S180,66.783,189.217,66.783h200.348c9.217,0,16.696,7.473,16.696,16.696
			S398.782,100.174,389.565,100.174z"
          />
        </g>
      </g>
    </svg>
  );
}
export function StatusIcon() {
  return (
    <svg
      width="1.111vw"
      height="1.111vw"
      viewBox="0 0 16 16"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fill="#ffffff"
        fillRule="evenodd"
        d="M7.0513157,1.68377223 C7.34140089,0.813516663 8.52958649,0.773959592 8.90131717,1.56510102 L8.9486823,1.68377223 L11.999,10.838 L13.0513157,7.68377223 C13.1750557,7.31255211 13.5021221,7.05117665 13.8839548,7.00672177 L13.999999,7 L14.999999,7 C15.5522837,7 15.999999,7.44771525 15.999999,8 C15.999999,8.51283584 15.6139588,8.93550716 15.1166201,8.99327227 L14.999999,9 L14.72,9 L12.9486823,14.3162278 C12.6585971,15.1864833 11.4704115,15.2260404 11.0986808,14.434899 L11.0513157,14.3162278 L7.999999,5.161 L5.9486823,11.3162278 C5.66748671,12.1598145 4.52796777,12.2312701 4.12404882,11.4837549 L4.07152231,11.3713907 L2.961,8.596 L2.89017501,8.6833128 C2.73101502,8.85332296 2.51533249,8.96455528 2.27945404,8.99286635 L2.16,9 L0.999999,9 C0.44771425,9 -1e-06,8.55228475 -1e-06,8 C-1e-06,7.48716416 0.38603919,7.06449284 0.883377875,7.00672773 L0.999999,7 L1.495,7 L2.07801673,5.61276791 C2.40786899,4.82740446 3.48655852,4.79910618 3.87548912,5.51555754 L3.92847569,5.62860932 L4.914,8.094 L7.0513157,1.68377223 Z"
      />
    </svg>
  );
}
export function MentionsIcon() {
  return (
    <svg
      width="1.667vw"
      height="1.667vw"
      viewBox="0 0 24 24"
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
      className="feather feather-at-sign"
    >
      <circle cx="12" cy="12" r="4" />
      <path d="M16 8v5a3 3 0 0 0 6 0v-1a10 10 0 1 0-3.92 7.94" />
    </svg>
  );
}
export function DraftIcon({ color }) {
  return (
    <svg
      width="1.667vw"
      height="1.667vw"
      viewBox="0 0 24 24"
      xmlns="http://www.w3.org/2000/svg"
      mirror-in-rtl="true"
    >
      <path
        fill={color !== '' ? color : '#494c4e'}
        d="M8 6H5c-.553 0-1-.448-1-1s.447-1 1-1h3c.553 0 1 .448 1 1s-.447 1-1 1zM13 10H5c-.553 0-1-.448-1-1s.447-1 1-1h8c.553 0 1 .448 1 1s-.447 1-1 1zM13 14H5c-.553 0-1-.448-1-1s.447-1 1-1h8c.553 0 1 .448 1 1s-.447 1-1 1z"
      />
      <path
        fill={color !== '' ? color : '#494c4e'}
        d="M18 2v8c0 .55-.45 1-1 1s-1-.45-1-1V2.5c0-.28-.22-.5-.5-.5h-13c-.28 0-.5.22-.5.5v19c0 .28.22.5.5.5h13c.28 0 .5-.22.5-.5V21c0-.55.45-1 1-1s1 .45 1 1v1c0 1.1-.9 2-2 2H2c-1.1 0-2-.9-2-2V2C0 .9.9 0 2 0h14c1.1 0 2 .9 2 2z"
      />
      <path
        fill={color !== '' ? color : '#494c4e'}
        d="M23.71 8.817c.44.438.372 1.212-.148 1.732l-7.835 7.84c-.07.068-.148.126-.227.173l-2.382 1.317c-.33.183-.7.152-.927-.075-.226-.227-.25-.603-.07-.923l1.328-2.373c.042-.085.1-.153.162-.216 0-.012.007-.018.007-.018l7.835-7.84c.52-.52 1.294-.587 1.73-.15l.53.53z"
      />
    </svg>
  );
}
DraftIcon.propTypes = {
  color: PropTypes.string,
};
DraftIcon.defaultProps = {
  color: '',
};
export function ManufacturingIcon({ color }) {
  return (
    <svg
      version="1.0"
      xmlns="http://www.w3.org/2000/svg"
      width="200.000000pt"
      height="200.000000pt"
      viewBox="0 0 200.000000 200.000000"
      preserveAspectRatio="xMidYMid meet"
    >
      <g
        transform="translate(0.000000,200.000000) scale(0.050000,-0.050000)"
        fill={color !== '' ? color : '#000000'}
        stroke="none"
      >
        <path
          d="M3045 3913 c-101 -36 -206 -130 -246 -220 l-37 -83 -865 -162 c-711
    -133 -879 -159 -936 -143 -346 96 -657 -358 -454 -663 l53 -81 0 -567 0 -566
    -70 -25 c-146 -53 -170 -126 -170 -508 l0 -335 -72 0 c-138 0 -188 -81 -188
    -308 l0 -192 822 0 c742 0 821 3 810 32 -7 17 -12 106 -12 197 0 196 -48 271
    -173 271 l-67 0 0 309 c0 387 -31 474 -195 544 l-66 28 6 572 5 572 840 287
    c462 158 856 287 875 288 32 0 35 -30 35 -360 l0 -360 -75 0 c-63 0 -103 -22
    -250 -141 l-175 -140 0 -255 0 -254 174 -135 c153 -119 184 -135 260 -135 103
    0 101 -18 16 189 -91 221 -99 391 -19 428 67 30 69 30 69 -17 0 -38 13 -40
    250 -40 237 0 250 2 250 40 0 48 7 49 71 8 77 -51 67 -192 -29 -423 l-77 -185
    92 0 c84 1 110 14 267 135 l174 135 1 253 1 253 -180 142 c-145 115 -193 142
    -250 142 l-70 0 0 347 0 347 68 73 c303 321 -49 857 -463 706z m267 -131 c247
    -112 243 -456 -7 -566 -366 -162 -604 378 -246 559 108 54 146 55 253 7z
    m-551 -347 c0 -25 12 -72 26 -105 l26 -60 -751 -254 c-414 -140 -753 -255
    -754 -255 -1 -1 -1 52 0 116 1 99 -9 134 -62 220 -63 100 -63 103 -20 104 24
    0 368 62 764 137 855 163 770 152 771 97z m-1726 -295 c209 -127 193 -434 -27
    -541 -274 -132 -547 151 -404 419 82 154 285 211 431 122z m2285 -575 l0 -505
    -130 0 -130 0 0 505 0 505 130 0 130 0 0 -505z m-2476 -120 c51 -5 121 0 155
    12 l61 21 0 -519 0 -519 -190 0 -190 0 0 522 c0 490 2 521 35 508 19 -8 77
    -19 129 -25z m2096 -206 c0 -81 -1 -82 -130 -140 l-130 -59 0 -145 c1 -101 13
    -172 40 -232 22 -48 40 -92 40 -97 0 -5 -45 25 -99 68 l-99 76 -1 191 -1 190
    135 113 c174 146 245 156 245 35z m735 -34 l145 -115 0 -183 0 -183 -100 -84
    c-110 -92 -114 -91 -70 13 18 43 30 135 30 229 l0 157 -120 61 c-116 59 -120
    63 -120 140 0 115 56 106 235 -35z m-2425 -946 c28 -28 57 -84 63 -125 l12
    -74 -382 0 -383 0 0 -60 0 -60 380 0 380 0 0 -190 0 -190 -440 0 -440 0 0 65
    0 65 374 0 374 0 0 60 0 60 -374 0 -374 0 0 186 c0 307 29 326 465 319 286 -5
    296 -6 345 -56z m306 -954 l6 -125 -691 0 -691 0 0 106 c0 163 -35 155 709
    149 l661 -5 6 -125z"
        />
        <path
          d="M3052 3618 c-150 -177 85 -402 261 -250 128 110 42 312 -132 312 -62
    0 -88 -12 -129 -62z m188 -88 c20 -24 20 -36 0 -60 -53 -64 -142 -17 -113 60
    7 17 29 30 50 30 21 0 49 -13 63 -30z"
        />
        <path
          d="M766 3030 c-57 -40 -93 -150 -69 -212 77 -200 363 -150 363 63 0 136
    -182 228 -294 149z m150 -114 c35 -35 29 -72 -15 -95 -55 -30 -110 25 -80 80
    23 44 60 50 95 15z"
        />
        <path
          d="M3013 1307 c-7 -8 -13 -30 -13 -49 0 -51 -29 -62 -89 -35 -87 40
    -302 -183 -259 -267 29 -56 28 -58 -31 -79 l-61 -21 0 -169 0 -169 60 -21 c57
    -20 58 -23 31 -76 -44 -84 188 -315 272 -270 51 27 54 26 74 -31 l21 -60 169
    0 169 0 21 61 c21 59 23 60 79 31 85 -44 307 172 267 260 -27 58 -16 80 47 91
    36 7 41 26 46 180 l5 173 -60 21 c-62 21 -78 50 -41 73 41 25 17 74 -90 180
    -106 107 -155 131 -180 90 -23 -37 -52 -21 -73 40 l-21 60 -165 0 c-90 0 -170
    -6 -178 -13z m267 -157 c0 -43 120 -90 168 -65 54 28 165 -83 137 -137 -25
    -48 22 -168 65 -168 47 0 42 -174 -6 -189 -47 -15 -88 -125 -64 -171 27 -50
    -81 -152 -132 -124 -46 25 -161 -27 -175 -79 -14 -55 -164 -53 -179 3 -12 46
    -105 87 -163 72 -57 -15 -154 80 -139 137 15 61 -25 153 -72 165 -56 15 -58
    165 -3 179 52 14 104 129 79 175 -28 51 74 159 124 132 46 -24 156 17 171 64
    15 48 189 53 189 6z"
        />
        <path
          d="M3032 956 c-201 -119 -203 -412 -4 -535 209 -129 494 49 467 292 -26
    227 -271 356 -463 243z m280 -144 c98 -98 78 -234 -41 -288 -222 -101 -382
    210 -169 328 79 44 137 33 210 -40z"
        />
      </g>
    </svg>
  );
}
ManufacturingIcon.propTypes = {
  color: PropTypes.string,
};
ManufacturingIcon.defaultProps = {
  color: '',
};
export function AllNotificationIcon({ color }) {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M12 10.5199C11.59 10.5199 11.25 10.1799 11.25 9.76994V6.43994C11.25 6.02994 11.59 5.68994 12 5.68994C12.41 5.68994 12.75 6.02994 12.75 6.43994V9.76994C12.75 10.1899 12.41 10.5199 12 10.5199Z"
        fill={color !== '' ? color : '#292D32'}
      />
      <path
        d="M12.0201 20.35C9.44011 20.35 6.87011 19.94 4.42011 19.12C3.51011 18.82 2.82011 18.17 2.52011 17.35C2.22011 16.53 2.32011 15.59 2.81011 14.77L4.08011 12.65C4.36011 12.18 4.61011 11.3 4.61011 10.75V8.64999C4.61011 4.55999 7.93011 1.23999 12.0201 1.23999C16.1101 1.23999 19.4301 4.55999 19.4301 8.64999V10.75C19.4301 11.29 19.6801 12.18 19.9601 12.65L21.2301 14.77C21.7001 15.55 21.7801 16.48 21.4701 17.33C21.1601 18.18 20.4801 18.83 19.6201 19.12C17.1701 19.95 14.6001 20.35 12.0201 20.35ZM12.0201 2.74999C8.76011 2.74999 6.11011 5.39999 6.11011 8.65999V10.76C6.11011 11.57 5.79011 12.74 5.37011 13.43L4.10011 15.56C3.84011 15.99 3.78011 16.45 3.93011 16.85C4.08011 17.25 4.42011 17.55 4.90011 17.71C9.50011 19.24 14.5601 19.24 19.1601 17.71C19.5901 17.57 19.9201 17.25 20.0701 16.83C20.2301 16.41 20.1801 15.95 19.9501 15.56L18.6801 13.44C18.2601 12.75 17.9401 11.58 17.9401 10.77V8.66999C17.9301 5.39999 15.2801 2.74999 12.0201 2.74999Z"
        fill={color !== '' ? color : '#292D32'}
      />
      <path
        d="M11.9999 22.9001C10.9299 22.9001 9.87992 22.4601 9.11992 21.7001C8.35992 20.9401 7.91992 19.8901 7.91992 18.8201H9.41992C9.41992 19.5001 9.69992 20.1601 10.1799 20.6401C10.6599 21.1201 11.3199 21.4001 11.9999 21.4001C13.4199 21.4001 14.5799 20.2401 14.5799 18.8201H16.0799C16.0799 21.0701 14.2499 22.9001 11.9999 22.9001Z"
        fill={color !== '' ? color : '#292D32'}
      />
    </svg>
  );
}
AllNotificationIcon.propTypes = {
  color: PropTypes.string,
};
AllNotificationIcon.defaultProps = {
  color: '',
};
export function NotificationFilterIcon({ color }) {
  return (
    <svg
      width="1.667vw"
      height="1.667vw"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M9 5a1 1 0 1 0 0 2 1 1 0 0 0 0-2zM6.17 5a3.001 3.001 0 0 1 5.66 0H19a1 1 0 1 1 0 2h-7.17a3.001 3.001 0 0 1-5.66 0H5a1 1 0 0 1 0-2h1.17zM15 11a1 1 0 1 0 0 2 1 1 0 0 0 0-2zm-2.83 0a3.001 3.001 0 0 1 5.66 0H19a1 1 0 1 1 0 2h-1.17a3.001 3.001 0 0 1-5.66 0H5a1 1 0 1 1 0-2h7.17zM9 17a1 1 0 1 0 0 2 1 1 0 0 0 0-2zm-2.83 0a3.001 3.001 0 0 1 5.66 0H19a1 1 0 1 1 0 2h-7.17a3.001 3.001 0 0 1-5.66 0H5a1 1 0 1 1 0-2h1.17z"
        fill={color !== '' ? color : '#0D0D0D'}
      />
    </svg>
  );
}
NotificationFilterIcon.propTypes = {
  color: PropTypes.string,
};
NotificationFilterIcon.defaultProps = {
  color: '',
};
export function CloseEyeIcon({ color }) {
  return (
    <svg
      width="45"
      height="17"
      viewBox="0 0 45 17"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M30.6688 12.2804C31.6868 12.1075 32.6234 11.8748 33.4759 11.5866L36.0464 16.068C36.3827 16.6564 37.0907 17 37.8263 17C38.1113 17 38.399 16.9489 38.6709 16.8412C39.6534 16.4563 40.0711 15.4819 39.6048 14.6685L36.9029 9.95537C38.001 9.24743 38.9139 8.4514 39.7046 7.64233L41.3675 9.79225C41.7419 10.2784 42.3803 10.5415 43.0305 10.5415C43.3917 10.5415 43.7674 10.4589 44.0957 10.286C45.0087 9.79987 45.2753 8.7907 44.6882 8.03273L42.153 4.75618C42.7914 3.93514 43.3562 3.22611 43.8843 2.7846C44.654 2.14734 44.654 1.11425 43.8843 0.476991C43.1145 -0.159178 41.868 -0.159178 41.0983 0.478079C40.2497 1.18385 39.5286 2.10819 38.7668 3.08583C38.5763 3.32616 38.3871 3.5741 38.1875 3.82422C38.1875 3.82422 38.1875 3.8264 38.1849 3.82857C34.5832 8.32634 28.4109 13.9257 2.87588 2.96621C1.91569 2.55188 0.723001 2.86399 0.221233 3.66545C-0.279222 4.46365 0.0977604 5.44999 1.06583 5.86323C1.54527 6.06876 2.01026 6.26233 2.47919 6.45698C2.45292 6.60488 2.44898 6.75278 2.47394 6.90611L3.20032 10.9776C3.34349 11.7888 4.18547 12.3706 5.14434 12.3706C5.24023 12.3706 5.33612 12.3652 5.43726 12.3511C6.51173 12.2217 7.2565 11.3908 7.10019 10.5013L6.67854 8.1219C7.87254 8.57211 9.02713 8.98209 10.1423 9.35727L10.9869 13.5223C11.1485 14.3194 11.9839 14.8838 12.9296 14.8838C13.0373 14.8838 13.1477 14.8773 13.258 14.8609C14.3259 14.7109 15.0536 13.8714 14.8723 12.9807L14.4074 10.672C15.7747 11.0548 17.062 11.3647 18.2915 11.6236L18.8589 14.8251C19.0021 15.6352 19.8441 16.2192 20.8056 16.2192C20.8975 16.2192 20.996 16.2127 21.0932 16.1996C22.1677 16.0702 22.9151 15.2394 22.7588 14.3498L22.4015 12.3217C23.941 12.512 25.3596 12.6055 26.6586 12.6055L27.8789 15.5732C28.1587 16.2529 28.9232 16.6814 29.7441 16.6814C29.9543 16.6814 30.1671 16.6553 30.3746 16.5944C31.4031 16.304 31.9548 15.3786 31.6067 14.5271L30.6688 12.2804Z"
        fill={color !== '' ? color : 'black'}
      />
    </svg>
  );
}
CloseEyeIcon.propTypes = {
  color: PropTypes.string,
};
CloseEyeIcon.defaultProps = {
  color: '',
};
export function BarNoDataIcon() {
  return (
    <svg
      width="595"
      height="395"
      viewBox="0 0 595 395"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_33_25)">
        <path
          d="M593 20V60C593 64.4183 589.418 68 585 68L10 68C5.58173 68 2 64.4183 2 60V20C2 15.5817 5.58173 12 10 12L585 12C589.418 12 593 15.5817 593 20Z"
          stroke="#E3E3E3"
          strokeWidth="4"
        />
        <path
          d="M381 100V140C381 144.418 377.418 148 373 148L9.99997 148C5.5817 148 2 144.418 2 140V100C2 95.5817 5.5817 92 10 92L373 92C377.418 92 381 95.5817 381 100Z"
          stroke="#E3E3E3"
          strokeWidth="4"
        />
        <path
          d="M473 180V220C473 224.418 469.418 228 465 228L10 228C5.58173 228 2 224.418 2 220V180C2 175.582 5.58173 172 10 172L465 172C469.418 172 473 175.582 473 180Z"
          stroke="#E3E3E3"
          strokeWidth="4"
        />
        <path
          d="M353 342V382C353 386.418 349.418 390 345 390H12C7.5817 390 4 386.418 4 382V342C4 337.582 7.5817 334 12 334H345C349.418 334 353 337.582 353 342Z"
          stroke="#E3E3E3"
          strokeWidth="4"
        />
        <path
          d="M237 260V300C237 304.418 233.418 308 229 308H10.0001C5.58185 308 2.00012 304.418 2.00012 300V260C2.00012 255.582 5.58185 252 10.0001 252H229C233.418 252 237 255.582 237 260Z"
          stroke="#E3E3E3"
          strokeWidth="4"
        />
        <path
          d="M479.647 229.786C487.95 215.405 508.706 215.405 517.009 229.786L591.734 359.213C600.036 373.593 589.658 391.569 573.053 391.569H423.603C406.998 391.569 396.619 373.593 404.922 359.213L479.647 229.786Z"
          fill="#47ABFF"
        />
        <path
          d="M504.22 288.597L503.453 345.051H494.556L493.789 288.597H504.22ZM499.004 367.756C497.112 367.756 495.489 367.078 494.134 365.723C492.779 364.368 492.101 362.745 492.101 360.853C492.101 358.961 492.779 357.337 494.134 355.982C495.489 354.627 497.112 353.949 499.004 353.949C500.897 353.949 502.52 354.627 503.875 355.982C505.23 357.337 505.908 358.961 505.908 360.853C505.908 362.105 505.588 363.256 504.949 364.304C504.335 365.353 503.504 366.196 502.456 366.836C501.433 367.449 500.283 367.756 499.004 367.756Z"
          fill="white"
        />
      </g>
      <defs>
        <clipPath id="clip0_33_25">
          <rect
            width="395"
            height="595"
            fill="white"
            transform="translate(595) rotate(90)"
          />
        </clipPath>
      </defs>
    </svg>
  );
}
export function SpinnerIcon({ color }) {
  return (
    <svg
      version="1.1"
      id="L9"
      xmlns="http://www.w3.org/2000/svg"
      x="0px"
      y="0px"
      viewBox="0 0 100 100"
      enable-background="new 0 0 0 0"
    >
      <path
        fill={color !== '' ? color : '#fff'}
        d="M73,50c0-12.7-10.3-23-23-23S27,37.3,27,50 M30.9,50c0-10.5,8.5-19.1,19.1-19.1S69.1,39.5,69.1,50"
      >
        <animateTransform
          attributeName="transform"
          attributeType="XML"
          type="rotate"
          dur="1s"
          from="0 50 50"
          to="360 50 50"
          repeatCount="indefinite"
        />
      </path>
    </svg>
  );
}
SpinnerIcon.propTypes = {
  color: PropTypes.string,
};
SpinnerIcon.defaultProps = {
  color: '',
};
// Icons for Login & Register
export function NameIcon({ color }) {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M12 22C6.477 22 2 17.523 2 12C2 6.477 6.477 2 12 2C17.523 2 22 6.477 22 12C22 17.523 17.523 22 12 22ZM7.013 18.256C8.42855 19.3877 10.1877 20.0029 12 20C13.97 20 15.773 19.288 17.167 18.108C16.5157 17.4397 15.7371 16.9089 14.877 16.5468C14.017 16.1847 13.0931 15.9988 12.16 16C11.1926 15.9989 10.2355 16.1989 9.34947 16.5872C8.46343 16.9756 7.66778 17.5439 7.013 18.256ZM5.616 16.82C6.45645 15.9281 7.47067 15.2177 8.59614 14.7327C9.72161 14.2477 10.9345 13.9984 12.16 14C13.3417 13.9985 14.512 14.2304 15.6037 14.6824C16.6955 15.1344 17.6873 15.7976 18.522 16.634C19.3781 15.4291 19.8836 14.0106 19.9826 12.5359C20.0815 11.0612 19.77 9.58789 19.0825 8.27946C18.395 6.97102 17.3585 5.87862 16.088 5.12345C14.8174 4.36827 13.3625 3.97984 11.8846 4.00125C10.4067 4.02267 8.96366 4.45308 7.71552 5.24476C6.46738 6.03643 5.46296 7.1584 4.81369 8.4862C4.16442 9.814 3.89569 11.2957 4.03732 12.7669C4.17894 14.2382 4.72537 15.6414 5.616 16.821V16.82ZM12 13C10.9391 13 9.92172 12.5786 9.17157 11.8284C8.42143 11.0783 8 10.0609 8 9C8 7.93913 8.42143 6.92172 9.17157 6.17157C9.92172 5.42143 10.9391 5 12 5C13.0609 5 14.0783 5.42143 14.8284 6.17157C15.5786 6.92172 16 7.93913 16 9C16 10.0609 15.5786 11.0783 14.8284 11.8284C14.0783 12.5786 13.0609 13 12 13ZM12 11C12.5304 11 13.0391 10.7893 13.4142 10.4142C13.7893 10.0391 14 9.53043 14 9C14 8.46957 13.7893 7.96086 13.4142 7.58579C13.0391 7.21071 12.5304 7 12 7C11.4696 7 10.9609 7.21071 10.5858 7.58579C10.2107 7.96086 10 8.46957 10 9C10 9.53043 10.2107 10.0391 10.5858 10.4142C10.9609 10.7893 11.4696 11 12 11Z"
        fill={color !== '' ? color : '#A6A6A6'}
      />
    </svg>
  );
}
NameIcon.propTypes = {
  color: PropTypes.string,
};
NameIcon.defaultProps = {
  color: '',
};
export function EmailIcon({ color }) {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M4.636 5.04492H19.363C20.267 5.04492 21 5.77792 21 6.68192V17.3179C21 18.2219 20.267 18.9539 19.364 18.9539H4.636C3.733 18.9549 3 18.2219 3 17.3179V6.68192C3 5.77792 3.733 5.04492 4.636 5.04492Z"
        stroke={color !== '' ? color : '#828282'}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M3.11914 6.07504L10.8131 11.578C11.5081 12.075 12.4421 12.076 13.1381 11.58L20.8761 6.06104"
        stroke={color !== '' ? color : '#828282'}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}
EmailIcon.propTypes = {
  color: PropTypes.string,
};
EmailIcon.defaultProps = {
  color: '',
};
export function PasswordIcon({ color }) {
  return (
    <svg
      version="1.1"
      id="Layer_1"
      xmlns="http://www.w3.org/2000/svg"
      x="0px"
      y="0px"
      viewBox="0 0 485 485"
      xmlSpace="preserve"
      fill={color !== '' ? color : '#A6A6A6'}
    >
      <g>
        <path
          d="M345,175v-72.5C345,45.981,299.019,0,242.5,0S140,45.981,140,102.5V175H70v310h345V175H345z M170,102.5
		c0-39.977,32.523-72.5,72.5-72.5S315,62.523,315,102.5V175H170V102.5z M385,455H100V205h285V455z"
        />
        <path
          d="M227.5,338.047v53.568h30v-53.569c11.814-5.628,20-17.682,20-31.616c0-19.299-15.701-35-35-35c-19.299,0-35,15.701-35,35
		C207.5,320.365,215.686,332.42,227.5,338.047z"
        />
      </g>
    </svg>
  );
}
PasswordIcon.propTypes = {
  color: PropTypes.string,
};
PasswordIcon.defaultProps = {
  color: '',
};
export function TimezoneIcon({ color, width, height }) {
  return (
    <svg
      version="1.1"
      id="Capa_1"
      xmlns="http://www.w3.org/2000/svg"
      x="0px"
      y="0px"
      viewBox="0 0 83.001 83.001"
      xmlSpace="preserve"
      fill={color !== '' ? color : '#A6A6A6'}
      width={width}
      height={height}
    >
      <g>
        <path
          d="M41.5,0C18.617,0,0.001,18.617,0.001,41.5c0,22.884,18.616,41.501,41.499,41.501C64.383,83.001,83,64.384,83,41.5
		C83,18.617,64.382,0,41.5,0z M41.5,77.001C21.926,77.001,6,61.075,6,41.5S21.925,6,41.5,6C61.075,6,77,21.925,77,41.5
		S61.075,77.001,41.5,77.001z"
        />
        <path
          d="M53.508,45.32c-0.016,0-0.03,0-0.046,0L44.5,45.454V22c0-1.657-1.343-3-3-3s-3,1.343-3,3v26.5
		c0,0.006,0.002,0.012,0.002,0.018c0,0.01-0.002,0.019-0.002,0.027c0.002,0.122,0.025,0.237,0.041,0.354
		c0.01,0.073,0.011,0.148,0.025,0.22c0.027,0.129,0.072,0.249,0.115,0.37c0.022,0.063,0.036,0.129,0.062,0.189
		c0.052,0.123,0.122,0.235,0.189,0.35c0.031,0.051,0.054,0.107,0.087,0.157c0.076,0.111,0.167,0.21,0.257,0.311
		c0.038,0.042,0.069,0.09,0.109,0.131c0.097,0.096,0.206,0.177,0.315,0.26c0.044,0.033,0.083,0.073,0.128,0.104
		c0.118,0.08,0.247,0.143,0.376,0.205c0.045,0.021,0.085,0.051,0.131,0.07c0.15,0.063,0.31,0.107,0.472,0.146
		c0.03,0.007,0.058,0.021,0.089,0.027c0.194,0.039,0.395,0.061,0.601,0.061c0.015,0,0.031,0,0.046,0l12.008-0.18
		c1.656-0.025,2.979-1.389,2.955-3.045C56.483,46.634,55.144,45.32,53.508,45.32z"
        />
      </g>
    </svg>
  );
}
TimezoneIcon.propTypes = {
  color: PropTypes.string,
  width: PropTypes.string,
  height: PropTypes.string,
};
TimezoneIcon.defaultProps = {
  color: '',
  width: '',
  height: '',
};

export function StopWatchIcon({ color, width, height }) {
  return (
    <svg
      viewBox="0 0 21 21"
      xmlns="http://www.w3.org/2000/svg"
      fill={color !== '' ? color : '#A6A6A6'}
      width={width}
      height={height}
    >
      <path
        d="M10.4933 19.4583C6.12666 19.4583 2.57666 15.9083 2.57666 11.5417C2.57666 7.175 6.12666 3.625 10.4933 3.625C14.86 3.625 18.41 7.175 18.41 11.5417C18.41 11.8833 18.1267 12.1667 17.785 12.1667C17.4433 12.1667 17.16 11.8833 17.16 11.5417C17.16 7.86667 14.1683 4.875 10.4933 4.875C6.81833 4.875 3.82666 7.86667 3.82666 11.5417C3.82666 15.2167 6.81833 18.2083 10.4933 18.2083C10.835 18.2083 11.1183 18.4917 11.1183 18.8333C11.1183 19.175 10.835 19.4583 10.4933 19.4583Z"
        fill={color}
      />
      <path
        d="M10.5 11.9582C10.1583 11.9582 9.875 11.6748 9.875 11.3332V7.1665C9.875 6.82484 10.1583 6.5415 10.5 6.5415C10.8417 6.5415 11.125 6.82484 11.125 7.1665V11.3332C11.125 11.6748 10.8417 11.9582 10.5 11.9582Z"
        fill={color}
      />
      <path
        d="M13 2.7915H8C7.65833 2.7915 7.375 2.50817 7.375 2.1665C7.375 1.82484 7.65833 1.5415 8 1.5415H13C13.3417 1.5415 13.625 1.82484 13.625 2.1665C13.625 2.50817 13.3417 2.7915 13 2.7915Z"
        fill={color}
      />
      <path
        d="M16.3267 18.6248C15.985 18.6248 15.7017 18.3415 15.7017 17.9998V14.6665C15.7017 14.3248 15.985 14.0415 16.3267 14.0415C16.6683 14.0415 16.9517 14.3248 16.9517 14.6665V17.9998C16.9517 18.3415 16.6683 18.6248 16.3267 18.6248Z"
        fill={color}
      />
      <path
        d="M13.8267 18.6248C13.485 18.6248 13.2017 18.3415 13.2017 17.9998V14.6665C13.2017 14.3248 13.485 14.0415 13.8267 14.0415C14.1683 14.0415 14.4517 14.3248 14.4517 14.6665V17.9998C14.4517 18.3415 14.1683 18.6248 13.8267 18.6248Z"
        fill={color}
      />
    </svg>
  );
}
StopWatchIcon.propTypes = {
  color: PropTypes.string,
  width: PropTypes.string,
  height: PropTypes.string,
};
StopWatchIcon.defaultProps = {
  color: '#ffffff',
  width: '',
  height: '',
};
export function GlobeIcon({ color }) {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M6.235 6.453C4.96004 7.77629 4.1795 9.49815 4.02457 11.3292C3.86964 13.1602 4.34977 14.9887 5.38426 16.5074C6.41874 18.0261 7.94451 19.1424 9.70511 19.6686C11.4657 20.1948 13.3538 20.0989 15.052 19.397C15.167 18.647 14.915 17.927 14.812 17.675C14.582 17.115 13.824 16.158 12.559 14.831C12.221 14.476 12.243 14.203 12.364 13.394L12.377 13.303C12.459 12.749 12.597 12.421 14.462 12.125C15.41 11.975 15.659 12.353 16.004 12.878L16.12 13.05C16.448 13.53 16.691 13.64 17.058 13.806C17.223 13.881 17.428 13.976 17.703 14.131C18.355 14.504 18.355 14.925 18.355 15.847V15.952C18.355 16.343 18.317 16.687 18.257 16.986C19.0244 16.0229 19.5591 14.8957 19.8196 13.6922C20.0801 12.4886 20.0593 11.2412 19.7588 10.047C19.4584 8.85284 18.8863 7.7441 18.0873 6.80714C17.2883 5.87017 16.2838 5.13026 15.152 4.645C14.599 5.018 13.84 5.547 13.575 5.91C13.44 6.095 13.248 7.042 12.625 7.12C12.463 7.14 12.244 7.126 12.012 7.111C11.39 7.071 10.54 7.016 10.268 7.755C10.095 8.223 10.065 9.495 10.624 10.155C10.714 10.26 10.731 10.455 10.67 10.674C10.59 10.961 10.429 11.136 10.378 11.172C10.282 11.116 10.09 10.893 9.959 10.742C9.646 10.377 9.254 9.922 8.748 9.782C8.564 9.731 8.362 9.689 8.165 9.647C7.616 9.532 6.995 9.401 6.85 9.093C6.744 8.867 6.745 8.556 6.745 8.228C6.745 7.811 6.745 7.34 6.541 6.883C6.47008 6.71991 6.36585 6.57344 6.235 6.453ZM12 22C6.477 22 2 17.523 2 12C2 6.477 6.477 2 12 2C17.523 2 22 6.477 22 12C22 17.523 17.523 22 12 22Z"
        fill={color !== '' ? color : '#A6A6A6'}
      />
    </svg>
  );
}
GlobeIcon.propTypes = {
  color: PropTypes.string,
};
GlobeIcon.defaultProps = {
  color: '',
};
export function CompanyIcon({ color }) {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M21 20H23V22H1V20H3V3C3 2.73478 3.10536 2.48043 3.29289 2.29289C3.48043 2.10536 3.73478 2 4 2H20C20.2652 2 20.5196 2.10536 20.7071 2.29289C20.8946 2.48043 21 2.73478 21 3V20ZM19 20V4H5V20H19ZM8 11H11V13H8V11ZM8 7H11V9H8V7ZM8 15H11V17H8V15ZM13 15H16V17H13V15ZM13 11H16V13H13V11ZM13 7H16V9H13V7Z"
        fill={color !== '' ? color : '#A6A6A6'}
      />
    </svg>
  );
}
CompanyIcon.propTypes = {
  color: PropTypes.string,
};
CompanyIcon.defaultProps = {
  color: '',
};
export function PhoneIcon({ color }) {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M7 2H18C18.2652 2 18.5196 2.10536 18.7071 2.29289C18.8946 2.48043 19 2.73478 19 3V21C19 21.2652 18.8946 21.5196 18.7071 21.7071C18.5196 21.8946 18.2652 22 18 22H6C5.73478 22 5.48043 21.8946 5.29289 21.7071C5.10536 21.5196 5 21.2652 5 21V0H7V2ZM7 9H17V4H7V9ZM7 11V20H17V11H7Z"
        fill={color !== '' ? color : '#A6A6A6'}
      />
    </svg>
  );
}
PhoneIcon.propTypes = {
  color: PropTypes.string,
};
PhoneIcon.defaultProps = {
  color: '',
};

export function LandlineIcon({ color }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="0.694vw"
      height="0.694vw"
      viewBox="0 0 10 9"
      fill="none"
    >
      <path
        d="M9.15384 7.1362C9.15384 7.2862 9.12051 7.44036 9.04967 7.59036C8.97884 7.74036 8.88718 7.88203 8.76634 8.01536C8.56218 8.24036 8.33717 8.40286 8.08301 8.50703C7.83301 8.6112 7.56218 8.66536 7.27051 8.66536C6.84551 8.66536 6.39134 8.56536 5.91217 8.3612C5.43301 8.15703 4.95384 7.88203 4.47884 7.5362C3.99967 7.1862 3.54551 6.7987 3.11217 6.36953C2.68301 5.9362 2.29551 5.48203 1.94967 5.00703C1.60801 4.53203 1.33301 4.05703 1.13301 3.5862C0.933008 3.1112 0.833008 2.65703 0.833008 2.2237C0.833008 1.94036 0.883008 1.66953 0.983008 1.41953C1.08301 1.16536 1.24134 0.932031 1.46217 0.723698C1.72884 0.461198 2.02051 0.332031 2.32884 0.332031C2.44551 0.332031 2.56217 0.357031 2.66634 0.407031C2.77467 0.457031 2.87051 0.532031 2.94551 0.640365L3.91217 2.00286C3.98717 2.10703 4.04134 2.20286 4.07884 2.29453C4.11634 2.38203 4.13717 2.46953 4.13717 2.5487C4.13717 2.6487 4.10801 2.7487 4.04967 2.84453C3.99551 2.94036 3.91634 3.04036 3.81634 3.14036L3.49967 3.46953C3.45384 3.51536 3.43301 3.56953 3.43301 3.6362C3.43301 3.66953 3.43717 3.6987 3.44551 3.73203C3.45801 3.76536 3.47051 3.79036 3.47884 3.81536C3.55384 3.95286 3.68301 4.13203 3.86634 4.3487C4.05384 4.56536 4.25384 4.7862 4.47051 5.00703C4.69551 5.22786 4.91217 5.43203 5.13301 5.61953C5.34967 5.80286 5.52884 5.92786 5.67051 6.00286C5.69134 6.0112 5.71634 6.0237 5.74551 6.0362C5.77884 6.0487 5.81217 6.05286 5.84967 6.05286C5.92051 6.05286 5.97467 6.02786 6.02051 5.98203L6.33717 5.66953C6.44134 5.56536 6.54134 5.4862 6.63718 5.4362C6.73301 5.37786 6.82884 5.3487 6.93301 5.3487C7.01217 5.3487 7.09551 5.36536 7.18717 5.40286C7.27884 5.44036 7.37468 5.49453 7.47884 5.56536L8.85801 6.54453C8.96634 6.61953 9.04134 6.70703 9.08717 6.8112C9.12884 6.91536 9.15384 7.01953 9.15384 7.1362Z"
        fill={color !== '' ? color : '#455F7D'}
      />
    </svg>
  );
}
LandlineIcon.propTypes = {
  color: PropTypes.string,
};
LandlineIcon.defaultProps = {
  color: '',
};
export function EmptyWalletIcon({ color }) {
  return (
    <svg
      width="0.694vw"
      height="0.694vw"
      viewBox="0 0 10 11"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M6.18734 2.14714V3.73047H5.56234V2.14714C5.56234 2.03464 5.46234 1.98047 5.39567 1.98047C5.37484 1.98047 5.354 1.98464 5.33317 1.99297L2.029 3.2388C1.80817 3.32214 1.6665 3.53047 1.6665 3.76797V4.04714C1.28734 4.33047 1.0415 4.78464 1.0415 5.29714V3.76797C1.0415 3.27214 1.34567 2.83047 1.80817 2.65547L5.1165 1.40547C5.20817 1.37214 5.304 1.35547 5.39567 1.35547C5.81234 1.35547 6.18734 1.69297 6.18734 2.14714Z"
        fill={color !== '' ? color : '#455F7D'}
      />
      <path
        d="M8.95845 6.54232V6.95898C8.95845 7.07148 8.87095 7.16315 8.75428 7.16732H8.14595C7.92511 7.16732 7.72511 7.00482 7.70845 6.78815C7.69595 6.65898 7.74595 6.53815 7.82928 6.45482C7.90428 6.37565 8.00845 6.33398 8.12095 6.33398H8.75011C8.87095 6.33815 8.95845 6.42982 8.95845 6.54232Z"
        fill={color !== '' ? color : '#455F7D'}
      />
      <path
        d="M8.1165 5.89518H8.5415C8.77067 5.89518 8.95817 5.70768 8.95817 5.47852V5.29518C8.95817 4.43268 8.254 3.72852 7.3915 3.72852H2.60817C2.254 3.72852 1.929 3.84518 1.6665 4.04518C1.28734 4.32852 1.0415 4.78268 1.0415 5.29518V8.09935C1.0415 8.96185 1.74567 9.66602 2.60817 9.66602H7.3915C8.254 9.66602 8.95817 8.96185 8.95817 8.09935V8.02018C8.95817 7.79102 8.77067 7.60352 8.5415 7.60352H8.179C7.779 7.60352 7.39567 7.35768 7.2915 6.97018C7.204 6.65352 7.30817 6.34935 7.5165 6.14518C7.67067 5.98685 7.88317 5.89518 8.1165 5.89518ZM5.83317 5.81185H2.9165C2.74567 5.81185 2.604 5.67018 2.604 5.49935C2.604 5.32852 2.74567 5.18685 2.9165 5.18685H5.83317C6.004 5.18685 6.14567 5.32852 6.14567 5.49935C6.14567 5.67018 6.004 5.81185 5.83317 5.81185Z"
        fill={color !== '' ? color : '#455F7D'}
      />
    </svg>
  );
}
EmptyWalletIcon.propTypes = {
  color: PropTypes.string,
};
EmptyWalletIcon.defaultProps = {
  color: '',
};
export function GlobeNewIcon({ color }) {
  return (
    <svg
      width="0.694vw"
      height="0.764vw"
      viewBox="0 0 10 11"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M3.1874 9.21276C3.1749 9.21276 3.15824 9.22109 3.14574 9.22109C2.3374 8.82109 1.67907 8.15859 1.2749 7.35026C1.2749 7.33776 1.28324 7.32109 1.28324 7.30859C1.79157 7.45859 2.31657 7.57109 2.8374 7.65859C2.92907 8.18359 3.0374 8.70443 3.1874 9.21276Z"
        fill={color !== '' ? color : '#455F7D'}
      />
      <path
        d="M8.7251 7.35443C8.3126 8.18359 7.6251 8.85443 6.7876 9.25859C6.94593 8.72943 7.07926 8.19609 7.16676 7.65859C7.69176 7.57109 8.20843 7.45859 8.71676 7.30859C8.7126 7.32526 8.7251 7.34193 8.7251 7.35443Z"
        fill={color !== '' ? color : '#455F7D'}
      />
      <path
        d="M8.75843 3.71302C8.23343 3.55469 7.70426 3.42552 7.16676 3.33385C7.07926 2.79635 6.9501 2.26302 6.7876 1.74219C7.6501 2.15469 8.34593 2.85052 8.75843 3.71302Z"
        fill={color !== '' ? color : '#455F7D'}
      />
      <path
        d="M3.18753 1.78789C3.03753 2.29622 2.9292 2.81289 2.8417 3.33789C2.3042 3.42122 1.77087 3.55456 1.2417 3.71289C1.64587 2.87539 2.3167 2.18789 3.14587 1.77539C3.15837 1.77539 3.17503 1.78789 3.18753 1.78789Z"
        fill={color !== '' ? color : '#455F7D'}
      />
      <path
        d="M6.45423 3.24648C5.48756 3.13815 4.51257 3.13815 3.5459 3.24648C3.65007 2.67565 3.7834 2.10482 3.9709 1.55482C3.97923 1.52148 3.97507 1.49648 3.97923 1.46315C4.3084 1.38398 4.6459 1.33398 5.00006 1.33398C5.35006 1.33398 5.69173 1.38398 6.01673 1.46315C6.0209 1.49648 6.0209 1.52148 6.02923 1.55482C6.21673 2.10898 6.35006 2.67565 6.45423 3.24648Z"
        fill={color !== '' ? color : '#455F7D'}
      />
      <path
        d="M2.746 6.95325C2.171 6.84909 1.60433 6.71576 1.05433 6.52826C1.021 6.51992 0.995996 6.52409 0.962663 6.51992C0.883496 6.19075 0.833496 5.85326 0.833496 5.49909C0.833496 5.14909 0.883496 4.80742 0.962663 4.48242C0.995996 4.47826 1.021 4.47826 1.05433 4.46992C1.6085 4.28659 2.171 4.14909 2.746 4.04492C2.64183 5.01159 2.64183 5.98659 2.746 6.95325Z"
        fill={color !== '' ? color : '#455F7D'}
      />
      <path
        d="M9.16689 5.49909C9.16689 5.85326 9.11689 6.19075 9.03773 6.51992C9.00439 6.52409 8.97939 6.51992 8.94606 6.52826C8.39189 6.71159 7.82523 6.84909 7.25439 6.95325C7.36273 5.98659 7.36273 5.01159 7.25439 4.04492C7.82523 4.14909 8.39606 4.28242 8.94606 4.46992C8.97939 4.47826 9.00439 4.48242 9.03773 4.48242C9.11689 4.81159 9.16689 5.14909 9.16689 5.49909Z"
        fill={color !== '' ? color : '#455F7D'}
      />
      <path
        d="M6.45423 7.75391C6.35006 8.32891 6.21673 8.89557 6.02923 9.44557C6.0209 9.47891 6.0209 9.50391 6.01673 9.53724C5.69173 9.61641 5.35006 9.66641 5.00006 9.66641C4.6459 9.66641 4.3084 9.61641 3.97923 9.53724C3.97507 9.50391 3.97923 9.47891 3.9709 9.44557C3.78756 8.89141 3.65007 8.32891 3.5459 7.75391C4.02923 7.80807 4.51257 7.84557 5.00006 7.84557C5.48756 7.84557 5.97506 7.80807 6.45423 7.75391Z"
        fill={color !== '' ? color : '#455F7D'}
      />
      <path
        d="M6.56822 7.06871C5.52609 7.20019 4.47423 7.20019 3.43211 7.06871C3.30063 6.02658 3.30063 4.97472 3.43211 3.9326C4.47423 3.80111 5.52609 3.80111 6.56822 3.9326C6.6997 4.97472 6.6997 6.02658 6.56822 7.06871Z"
        fill={color !== '' ? color : '#455F7D'}
      />
    </svg>
  );
}
GlobeNewIcon.propTypes = {
  color: PropTypes.string,
};
GlobeNewIcon.defaultProps = {
  color: '',
};
export function MapIcon({ width, color }) {
  return (
    <svg
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      stroke={color !== '' ? color : '#00bfff'}
      width={width}
    >
      <g id="SVGRepo_bgCarrier" strokeWidth="0" />
      <g
        id="SVGRepo_tracerCarrier"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <g id="SVGRepo_iconCarrier">
        <path
          d="M22 9.00002V15C22 17.5 21.5 19.25 20.38 20.38L14 14L21.73 6.27002C21.91 7.06002 22 7.96002 22 9.00002Z"
          stroke={color !== '' ? color : '#84B1FC'}
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M21.73 6.27L6.26999 21.73C3.25999 21.04 2 18.96 2 15V9C2 4 4 2 9 2H15C18.96 2 21.04 3.26 21.73 6.27Z"
          stroke={color !== '' ? color : '#84B1FC'}
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M20.38 20.38C19.25 21.5 17.5 22 15 22H9.00003C7.96003 22 7.06002 21.91 6.27002 21.73L14 14L20.38 20.38Z"
          stroke={color !== '' ? color : '#84B1FC'}
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M6.24002 7.97997C6.92002 5.04997 11.32 5.04997 12 7.97997C12.39 9.69997 11.31 11.16 10.36 12.06C9.67001 12.72 8.58003 12.72 7.88003 12.06C6.93003 11.16 5.84002 9.69997 6.24002 7.97997Z"
          stroke={color !== '' ? color : '#84B1FC'}
          strokeWidth="1.5"
        />
        <path
          d="M9.0946 8.69995H9.10359"
          stroke={color !== '' ? color : '#84B1FC'}
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
    </svg>
  );
}
MapIcon.propTypes = {
  width: PropTypes.string,
  color: PropTypes.string,
};
MapIcon.defaultProps = {
  width: '13.889vw',
  color: '',
};
export function NotificationNoData({ Width, Height }) {
  return (
    <svg
      width={Width !== '' ? Width : '460'}
      height={Height !== '' ? Height : '330'}
      viewBox="0 0 460 330"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      style={{ width: Width, height: Height }}
    >
      <g clipPath="url(#clip0_1_2)">
        <path
          d="M202.549 0.52502C202.549 0.52502 285.825 -7.2464 352.131 37.0096C418.437 81.2655 437.72 151.113 455.39 207.423C473.06 263.732 438.681 312.609 373.726 326.998C308.771 341.388 279.778 300.158 199.055 285.467C118.332 270.777 93.9338 275.764 36.5678 231.288C-20.7982 186.811 -9.28498 105.336 61.3864 55.0352C132.058 4.73393 202.549 0.52502 202.549 0.52502Z"
          fill="#0075FF"
          fillOpacity="0.19"
        />
        <path
          opacity="0.75"
          d="M202.549 0.525019C202.549 0.525019 285.825 -7.2464 352.131 37.0096C418.437 81.2655 437.72 151.113 455.39 207.423C473.06 263.732 433.955 289.611 369 304C304.045 318.39 301.723 263.691 221 249C140.277 234.31 105.366 299.476 48 255C-9.366 210.523 -9.28498 105.336 61.3864 55.0352C132.058 4.73393 202.549 0.525019 202.549 0.525019Z"
          fill="#D5EBFF"
          fillOpacity="0.5"
        />
        <path
          d="M230.154 46.7962C204.225 46.7962 183.154 67.8679 183.154 93.7962V116.435C183.154 121.213 181.117 128.498 178.689 132.572L169.68 147.533C164.119 156.777 167.957 167.038 178.14 170.485C211.902 181.765 248.327 181.765 282.089 170.485C291.567 167.352 295.719 156.15 290.549 147.533L281.54 132.572C279.19 128.498 277.154 121.213 277.154 116.435V93.7962C277.154 67.9462 256.004 46.7962 230.154 46.7962Z"
          stroke="#59A3FF"
          strokeWidth="10"
          strokeMiterlimit="10"
          strokeLinecap="round"
        />
        <path
          d="M244.648 49.0662C242.219 48.3612 239.713 47.8129 237.128 47.4995C229.608 46.5595 222.401 47.1079 215.664 49.0662C217.936 43.2695 223.576 39.1962 230.156 39.1962C236.736 39.1962 242.376 43.2695 244.648 49.0662Z"
          stroke="#59A3FF"
          strokeWidth="10"
          strokeMiterlimit="10"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          opacity="0.4"
          d="M253.653 173.304C253.653 186.229 243.078 196.804 230.153 196.804C223.729 196.804 217.776 194.141 213.546 189.911C209.316 185.681 206.653 179.727 206.653 173.304"
          stroke="#59A3FF"
          strokeWidth="10"
          strokeMiterlimit="10"
        />
      </g>
      <defs>
        <clipPath id="clip0_1_2">
          <rect width="460" height="330" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
}
NotificationNoData.propTypes = {
  Height: PropTypes.string,
  Width: PropTypes.string,
};
NotificationNoData.defaultProps = {
  Height: '',
  Width: '',
};
export function AllNotificationNoDataIcon({ Height, Width }) {
  return (
    <svg
      style={{ height: Height, width: Width }}
      width="335"
      height="220"
      viewBox="0 0 335 220"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_1503_21306)">
        <path
          d="M218.323 96.0614C217.938 98.0864 217.476 100.091 216.936 102.075C216.878 102.305 216.812 102.532 216.747 102.762H209.248C208.609 102.763 207.997 103.017 207.545 103.468C207.094 103.919 206.84 104.531 206.839 105.169V126.526C206.612 126.949 206.381 127.368 206.151 127.788C204.96 129.954 203.721 132.096 202.454 134.21C181.803 168.576 152.999 197.333 118.587 217.944L120.625 213.351C119.878 213.299 119.127 213.248 118.381 213.196C102.119 212.086 85.8029 210.855 69.9235 207.204C53.3111 203.384 37.0602 196.759 24.0407 185.774C11.0178 174.786 1.471 159.095 0.145971 142.118C-0.295857 136.283 0.294832 130.416 1.89095 124.786C4.94348 113.95 11.6133 104.199 21.2359 98.4302C36.3512 89.3709 56.0679 91.2171 72.0022 98.7534C87.9332 106.286 100.901 118.756 113.563 131.009C100.779 109.11 82.9799 90.5501 61.626 76.8529C54.5501 72.3284 47.0407 68.299 41.0249 62.4371C35.0124 56.5787 30.5762 48.3651 31.6397 40.0416C32.8476 30.6007 40.5878 23.4358 48.3415 17.9108C51.4389 15.7036 54.6361 13.6098 57.9332 11.6845C67.2356 6.23859 77.2988 2.1301 87.9263 0.607044C102.322 -1.45923 117.871 1.67628 128.908 11.1378C141.343 21.7992 146.443 38.993 145.958 55.4407C153.619 44.3151 165.434 35.799 178.776 35.438C192.629 35.0667 205.796 43.8097 212.734 55.7948C219.669 67.7764 220.915 82.4638 218.323 96.0614Z"
          fill="#E6E6E6"
        />
        <path
          d="M130.682 142.267C138.795 141.553 146.29 140.719 154.152 138.497C161.772 136.343 169.106 132.736 174.531 126.848C180.366 120.514 183.516 112.289 185.738 104.101C186.977 99.5363 187.995 94.9074 188.956 90.2769C189.998 85.2528 190.924 80.2065 191.734 75.138C193.346 65.049 194.497 54.9005 195.187 44.6927C195.27 43.4536 195.347 42.2141 195.416 40.9741C195.459 40.2092 194.268 40.2117 194.225 40.9741C193.659 51.0361 192.639 61.0589 191.168 71.0425C189.715 80.8513 187.857 90.6176 185.499 100.251C183.501 108.411 180.915 116.699 175.791 123.493C170.987 129.863 164.048 134.026 156.556 136.515C148.932 139.048 140.893 140.059 132.926 140.811C131.949 140.903 131.659 140.991 130.682 141.077C129.924 141.144 129.917 142.334 130.682 142.267Z"
          fill="white"
        />
        <path
          d="M2.5783 125.664C12.8147 126.231 22.9471 128.015 32.761 130.978C42.5792 133.934 52.0141 138.036 60.8703 143.2C69.4277 148.194 77.3719 154.169 84.5414 161.005C91.4994 167.642 97.7007 175.029 103.032 183.03C108.387 191.05 112.826 199.646 116.263 208.655C116.683 209.757 117.086 210.865 117.475 211.979C117.726 212.698 118.877 212.389 118.623 211.663C115.407 202.464 111.167 193.655 105.983 185.401C100.8 177.146 94.7169 169.491 87.8456 162.575C80.8643 155.552 73.0945 149.358 64.6907 144.115C47.0454 133.135 27.0447 126.492 6.33078 124.733C5.08128 124.628 3.83046 124.542 2.57831 124.475C1.81257 124.433 1.8149 125.623 2.5783 125.664Z"
          fill="white"
        />
        <path
          d="M58.2547 13.0788C64.7997 15.1583 71.0035 18.1868 76.6675 22.0674C82.4551 26.0597 87.7335 30.7426 92.3857 36.0122C97.2883 41.5556 101.647 47.5563 105.402 53.9317C109.384 60.6633 112.844 67.6901 115.75 74.9505C118.743 82.4043 121.26 90.0401 123.287 97.8119C125.347 105.676 126.956 113.651 128.106 121.698C129.25 129.66 129.943 137.679 130.18 145.719C130.42 153.407 130.192 161.102 129.499 168.763C128.865 175.909 127.708 183 126.036 189.978C124.551 196.28 122.459 202.423 119.788 208.322C119.169 209.661 118.513 210.981 117.818 212.283C117.458 212.958 118.486 213.56 118.847 212.883C121.798 207.249 124.155 201.323 125.879 195.202C127.813 188.387 129.215 181.433 130.073 174.402C131.023 166.773 131.486 159.092 131.458 151.405C131.441 143.328 130.96 135.26 130.017 127.239C129.074 119.118 127.673 111.057 125.822 103.093C123.975 95.1163 121.632 87.2624 118.808 79.5769C116.085 72.1368 112.825 64.9042 109.054 57.9359C105.462 51.2864 101.276 44.9747 96.5466 39.0778C92.0555 33.4631 86.9282 28.3871 81.2674 23.9516C75.8087 19.6875 69.7768 16.2116 63.3488 13.6263C61.778 13.0017 60.1855 12.4368 58.5712 11.9317C57.8385 11.7014 57.525 12.8495 58.2547 13.0788Z"
          fill="white"
        />
        <path
          d="M128.887 220C175.93 220 214.066 218.461 214.066 216.562C214.066 214.663 175.93 213.124 128.887 213.124C81.8447 213.124 43.709 214.663 43.709 216.562C43.709 218.461 81.8447 220 128.887 220Z"
          fill="#E6E6E6"
        />
        <path
          d="M204.144 108.878C204.102 109.063 204.074 109.252 204.061 109.442L189.277 117.962L185.684 115.895L181.853 120.905L189.54 126.379L206.407 113.087C207.095 113.341 207.844 113.38 208.555 113.198C209.265 113.017 209.904 112.624 210.385 112.071C210.867 111.518 211.168 110.832 211.25 110.104C211.332 109.376 211.19 108.64 210.843 107.995C210.495 107.349 209.96 106.824 209.307 106.49C208.654 106.156 207.915 106.029 207.188 106.125C206.461 106.221 205.78 106.535 205.236 107.027C204.692 107.519 204.311 108.164 204.144 108.878Z"
          fill="#FFB8B8"
        />
        <path
          d="M170.474 114.105L182.115 122.393L187.321 115.872L176.005 106.802C175.518 106.412 174.957 106.125 174.355 105.959C173.754 105.793 173.124 105.752 172.506 105.837C171.888 105.923 171.293 106.134 170.76 106.457C170.226 106.78 169.763 107.208 169.401 107.716C168.695 108.705 168.412 109.934 168.613 111.133C168.814 112.331 169.484 113.4 170.474 114.105Z"
          fill="#3B86F2"
        />
        <path
          d="M146.445 208.675L150.527 209.744L156.594 194.525L150.57 192.948L146.445 208.675Z"
          fill="#FFB8B8"
        />
        <path
          d="M157.405 215.591L144.577 212.233L145.876 207.282L153.747 209.342C155.062 209.687 156.186 210.538 156.871 211.71C157.557 212.882 157.749 214.278 157.405 215.591Z"
          fill="#2F2E41"
        />
        <path
          d="M182.726 211.579L186.88 210.838L185.995 194.48L179.865 195.574L182.726 211.579Z"
          fill="#FFB8B8"
        />
        <path
          d="M195.58 213.261L182.526 215.59L181.625 210.552L189.635 209.122C190.297 209.004 190.977 209.017 191.634 209.161C192.291 209.305 192.913 209.577 193.465 209.962C194.017 210.346 194.488 210.835 194.851 211.401C195.214 211.967 195.461 212.599 195.58 213.261Z"
          fill="#2F2E41"
        />
        <path
          d="M174.548 91.2832C175.571 91.532 176.404 92.5739 176.904 93.7809C177.365 95.0486 177.677 96.3655 177.834 97.7052C178.227 100.2 178.605 102.901 177.792 105.212C176.84 107.92 174.302 109.339 172.1 108.672C169.899 108.005 168.148 105.503 167.55 102.623C167.005 99.7127 167.356 96.7059 168.556 93.9989C169.181 92.5765 170.043 91.2643 171.189 90.6226C171.751 90.2831 172.421 90.1688 173.063 90.3026C173.706 90.4365 174.275 90.8085 174.654 91.3439"
          fill="#2F2E41"
        />
        <path
          d="M180.339 136.455L188.247 207.208L181.716 209.686L169.67 162.241L152.9 205.621L145.751 206.018C145.751 206.018 155.56 138.518 162.829 136.984L180.339 136.455Z"
          fill="#2F2E41"
        />
        <path
          d="M173.697 100.313C178.365 100.313 182.15 96.5327 182.15 91.869C182.15 87.2054 178.365 83.4248 173.697 83.4248C169.029 83.4248 165.244 87.2054 165.244 91.869C165.244 96.5327 169.029 100.313 173.697 100.313Z"
          fill="#FFB8B8"
        />
        <path
          d="M177.325 103.855L168.19 102.665C168.19 102.665 162.233 109.807 162.63 122.106C163.027 134.405 161.637 138.174 161.637 138.174L180.683 138.518C177.93 134.736 189.446 113.015 177.325 103.855Z"
          fill="#3B86F2"
        />
        <path
          d="M182.232 140.237C182.041 140.239 181.851 140.255 181.664 140.286L169.978 127.859L171.169 123.891L165.41 121.312L161.836 130.041L178.649 143.401C178.558 144.128 178.692 144.866 179.031 145.515C179.37 146.165 179.9 146.696 180.548 147.038C181.197 147.379 181.935 147.516 182.663 147.429C183.391 147.341 184.076 147.035 184.626 146.549C185.175 146.064 185.564 145.423 185.74 144.712C185.916 144.001 185.871 143.253 185.611 142.567C185.351 141.882 184.889 141.292 184.285 140.876C183.682 140.46 182.965 140.237 182.232 140.237Z"
          fill="#FFB8B8"
        />
        <path
          d="M169.433 108.69L164.02 121.907L171.566 125.478L177.815 112.398C178.084 111.835 178.235 111.223 178.259 110.6C178.283 109.977 178.179 109.356 177.954 108.774C177.729 108.193 177.388 107.663 176.951 107.218C176.514 106.772 175.991 106.421 175.413 106.185C174.856 105.957 174.259 105.841 173.657 105.844C173.054 105.846 172.459 105.968 171.903 106.2C171.348 106.433 170.844 106.772 170.42 107.2C169.996 107.627 169.661 108.133 169.433 108.69Z"
          fill="#3B86F2"
        />
        <path
          d="M171.486 99.546C172.81 98.7827 172.952 96.9414 172.772 95.4246C172.592 93.9077 172.291 92.2167 173.183 90.9764C174.249 89.4961 176.389 89.4667 178.213 89.4184C180.037 89.37 182.259 88.8364 182.732 87.0755C183.044 85.912 182.376 84.6634 181.417 83.9331C180.458 83.2027 179.258 82.8798 178.092 82.573C175.484 81.8865 172.79 81.1942 170.119 81.5715C167.474 81.9452 165.082 83.3445 163.461 85.4665C161.841 87.5885 161.122 90.2626 161.46 92.9103C161.892 96.2971 162.519 97.776 162.107 99.2694C161.341 102.051 158.036 103.838 157.97 106.722C157.918 108.978 159.913 110.718 161.859 111.864C163.403 112.773 165.069 113.544 166.848 113.756C168.627 113.969 170.543 113.562 171.868 112.357C173.577 110.803 174 108.208 173.51 105.952C173.02 103.696 171.762 101.692 170.519 99.7463"
          fill="#2F2E41"
        />
        <path
          d="M331.423 102.074H209.248C208.427 102.075 207.64 102.402 207.059 102.982C206.478 103.562 206.152 104.348 206.15 105.168V183.556C206.152 184.377 206.478 185.163 207.059 185.743C207.64 186.323 208.427 186.649 209.248 186.651H331.423C332.244 186.649 333.031 186.323 333.612 185.743C334.192 185.163 334.519 184.377 334.52 183.556V105.168C334.519 104.348 334.192 103.562 333.612 102.982C333.031 102.402 332.244 102.075 331.423 102.074ZM333.832 183.556C333.831 184.194 333.577 184.806 333.126 185.257C332.674 185.708 332.062 185.962 331.423 185.963H209.248C208.609 185.962 207.997 185.708 207.545 185.257C207.093 184.806 206.839 184.194 206.839 183.556V105.168C206.839 104.53 207.093 103.919 207.545 103.468C207.997 103.016 208.609 102.763 209.248 102.762H331.423C332.062 102.763 332.674 103.016 333.126 103.468C333.577 103.919 333.831 104.53 333.832 105.168V183.556Z"
          fill="#3F3D56"
        />
        <path
          d="M235.326 141.095H216.054C215.278 141.094 214.535 140.786 213.986 140.238C213.438 139.69 213.129 138.947 213.128 138.173V118.919C213.129 118.145 213.438 117.402 213.986 116.854C214.535 116.306 215.278 115.998 216.054 115.997H235.326C236.102 115.998 236.846 116.306 237.394 116.854C237.942 117.402 238.251 118.145 238.252 118.919V138.173C238.251 138.947 237.942 139.69 237.394 140.238C236.846 140.786 236.102 141.094 235.326 141.095Z"
          fill="#3B86F2"
        />
        <path
          d="M325.06 161.554H215.619C215.026 161.554 214.457 161.319 214.037 160.9C213.618 160.481 213.382 159.912 213.382 159.32C213.382 158.727 213.618 158.159 214.037 157.74C214.457 157.32 215.026 157.085 215.619 157.085H325.06C325.654 157.085 326.223 157.32 326.642 157.74C327.062 158.159 327.297 158.727 327.297 159.32C327.297 159.912 327.062 160.481 326.642 160.9C326.223 161.319 325.654 161.554 325.06 161.554Z"
          fill="#CCCCCC"
        />
        <path
          d="M325.134 150.724H215.692C215.099 150.724 214.53 150.489 214.11 150.07C213.691 149.651 213.455 149.082 213.455 148.49C213.455 147.897 213.691 147.329 214.11 146.909C214.53 146.49 215.099 146.255 215.692 146.255H325.134C325.727 146.255 326.296 146.49 326.715 146.909C327.135 147.329 327.371 147.897 327.371 148.49C327.371 149.082 327.135 149.651 326.715 150.07C326.296 150.489 325.727 150.724 325.134 150.724Z"
          fill="#CCCCCC"
        />
        <path
          d="M271.101 135.938H254.926C254.333 135.938 253.764 135.703 253.344 135.284C252.925 134.865 252.689 134.296 252.689 133.703C252.689 133.111 252.925 132.542 253.344 132.123C253.764 131.704 254.333 131.469 254.926 131.469H271.101C271.695 131.469 272.264 131.704 272.683 132.123C273.103 132.542 273.338 133.111 273.338 133.703C273.338 134.296 273.103 134.865 272.683 135.284C272.264 135.703 271.695 135.938 271.101 135.938Z"
          fill="#CCCCCC"
        />
        <path
          d="M325.134 124.939H254.926C254.333 124.939 253.764 124.704 253.344 124.285C252.925 123.866 252.689 123.297 252.689 122.704C252.689 122.112 252.925 121.543 253.344 121.124C253.764 120.705 254.333 120.47 254.926 120.47H325.134C325.727 120.47 326.296 120.705 326.715 121.124C327.135 121.543 327.371 122.112 327.371 122.704C327.371 123.297 327.135 123.866 326.715 124.285C326.296 124.704 325.727 124.939 325.134 124.939Z"
          fill="#CCCCCC"
        />
        <path
          d="M268.348 172.556H215.619C215.026 172.556 214.457 172.321 214.037 171.902C213.618 171.483 213.382 170.914 213.382 170.322C213.382 169.729 213.618 169.161 214.037 168.741C214.457 168.322 215.026 168.087 215.619 168.087H268.348C268.941 168.087 269.51 168.322 269.93 168.741C270.349 169.161 270.585 169.729 270.585 170.322C270.585 170.914 270.349 171.483 269.93 171.902C269.51 172.321 268.941 172.556 268.348 172.556Z"
          fill="#CCCCCC"
        />
      </g>
      <defs>
        <clipPath id="clip0_1503_21306">
          <rect width="334.521" height="220" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
}
AllNotificationNoDataIcon.propTypes = {
  Height: PropTypes.string,
  Width: PropTypes.string,
};
AllNotificationNoDataIcon.defaultProps = {
  Height: '',
  Width: '',
};
export function ActionableNotificationNoDataIcon({ Height, Width }) {
  return (
    <svg
      style={{ height: Height, width: Width }}
      width="300"
      height="220"
      viewBox="0 0 300 220"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_1503_20572)">
        <path
          d="M79.5241 162.478C35.6742 162.478 0 126.796 0 82.9365C0 39.0768 35.6742 3.39453 79.5241 3.39453C92.2651 3.40762 104.817 6.47587 116.128 12.342C127.439 18.2082 137.179 26.7013 144.532 37.1092L143.779 37.6409C136.512 27.3533 126.885 18.9584 115.705 13.16C104.525 7.36159 92.1177 4.32876 79.5241 4.31578C36.1824 4.31578 0.921043 39.5851 0.921043 82.9365C0.921043 126.288 36.1824 161.557 79.5241 161.557C91.5977 161.597 103.516 158.835 114.343 153.491C125.17 148.146 134.61 140.364 141.923 130.754L142.653 131.315C135.255 141.037 125.704 148.91 114.751 154.318C103.797 159.725 91.739 162.518 79.5241 162.478Z"
          fill="#E6E6E6"
        />
        <path
          d="M112.401 69.6161C111.529 69.6161 110.677 69.3575 109.952 68.873C109.227 68.3885 108.662 67.6999 108.328 66.8942C107.995 66.0886 107.907 65.2021 108.077 64.3468C108.247 63.4915 108.667 62.7059 109.284 62.0893C109.9 61.4726 110.686 61.0527 111.541 60.8826C112.396 60.7124 113.282 60.7998 114.088 61.1335C114.893 61.4672 115.582 62.0323 116.066 62.7574C116.55 63.4825 116.809 64.3349 116.809 65.207C116.809 66.3763 116.344 67.4978 115.518 68.3247C114.691 69.1515 113.57 69.6161 112.401 69.6161Z"
          fill="#E6E6E6"
        />
        <path
          d="M113.938 66.1298L113.016 65.2071L113.938 64.2845C113.979 64.2442 114.011 64.1962 114.033 64.1434C114.055 64.0906 114.066 64.0339 114.066 63.9767C114.066 63.9194 114.055 63.8627 114.033 63.8098C114.012 63.7569 113.979 63.7089 113.939 63.6684C113.899 63.6279 113.85 63.5959 113.798 63.574C113.745 63.5521 113.688 63.5409 113.631 63.541C113.574 63.5411 113.517 63.5525 113.464 63.5745C113.411 63.5966 113.363 63.6288 113.323 63.6694L112.401 64.592L111.478 63.6694C111.397 63.5878 111.286 63.542 111.171 63.542C111.055 63.542 110.945 63.5878 110.863 63.6694C110.782 63.751 110.736 63.8616 110.736 63.977C110.736 64.0923 110.782 64.2029 110.863 64.2845L111.786 65.2071L110.863 66.1298C110.782 66.2114 110.737 66.3219 110.737 66.437C110.737 66.5521 110.783 66.6625 110.864 66.7439C110.946 66.8253 111.056 66.8711 111.171 66.8713C111.286 66.8714 111.397 66.826 111.478 66.7449L112.401 65.8222L113.323 66.7449C113.363 66.7852 113.411 66.8173 113.464 66.8391C113.517 66.861 113.573 66.8722 113.63 66.8722C113.688 66.8722 113.744 66.861 113.797 66.8391C113.85 66.8173 113.898 66.7852 113.938 66.7449C113.978 66.7045 114.01 66.6565 114.032 66.6037C114.054 66.551 114.065 66.4944 114.065 66.4373C114.065 66.3802 114.054 66.3236 114.032 66.2709C114.01 66.2181 113.978 66.1702 113.938 66.1298Z"
          fill="white"
        />
        <path
          d="M90.4779 17.5487C95.3228 17.5487 99.2503 13.6203 99.2503 8.77433C99.2503 3.9284 95.3228 0 90.4779 0C85.6331 0 81.7056 3.9284 81.7056 8.77433C81.7056 13.6203 85.6331 17.5487 90.4779 17.5487Z"
          fill="#E6E6E6"
        />
        <path
          d="M89.2811 13.341C89.1296 13.341 88.9802 13.3057 88.8447 13.2379C88.7092 13.1701 88.5914 13.0717 88.5005 12.9505L86.1072 9.75871C86.0304 9.65618 85.9744 9.53949 85.9426 9.41533C85.9108 9.29117 85.9038 9.16196 85.9219 9.03508C85.94 8.9082 85.983 8.78613 86.0483 8.67585C86.1136 8.56556 86.1999 8.46921 86.3024 8.39232C86.405 8.31542 86.5216 8.25947 86.6458 8.22766C86.7699 8.19586 86.8991 8.18882 87.0259 8.20695C87.1528 8.22508 87.2748 8.26803 87.3851 8.33333C87.4953 8.39864 87.5917 8.48502 87.6685 8.58756L89.2343 10.6755L93.2557 4.64216C93.4 4.42865 93.6229 4.28093 93.8758 4.23122C94.1286 4.18151 94.3909 4.23385 94.6053 4.37682C94.8197 4.5198 94.9689 4.74179 95.0203 4.99436C95.0716 5.24693 95.021 5.50958 94.8795 5.72498L90.0931 12.9063C90.0065 13.0362 89.89 13.1434 89.7535 13.219C89.6169 13.2945 89.4642 13.3363 89.3082 13.3406L89.2811 13.341Z"
          fill="white"
        />
        <path
          d="M101.219 24.6045H80.1237C78.8343 24.6045 77.7891 25.65 77.7891 26.9396V27.78C77.7891 29.0697 78.8343 30.1152 80.1237 30.1152H101.219C102.508 30.1152 103.554 29.0697 103.554 27.78V26.9396C103.554 25.65 102.508 24.6045 101.219 24.6045Z"
          fill="#E6E6E6"
        />
        <path
          d="M114.304 35.625H67.0387C65.7493 35.625 64.7041 36.6705 64.7041 37.9601V38.8005C64.7041 40.0902 65.7493 41.1357 67.0387 41.1357H114.304C115.593 41.1357 116.638 40.0902 116.638 38.8005V37.9601C116.638 36.6705 115.593 35.625 114.304 35.625Z"
          fill="#E6E6E6"
        />
        <path
          d="M114.304 46.6465H67.0387C65.7493 46.6465 64.7041 47.692 64.7041 48.9816V49.822C64.7041 51.1117 65.7493 52.1572 67.0387 52.1572H114.304C115.593 52.1572 116.638 51.1117 116.638 49.822V48.9816C116.638 47.692 115.593 46.6465 114.304 46.6465Z"
          fill="#E6E6E6"
        />
        <path
          d="M85.5551 164.158C84.6832 164.158 83.831 163.899 83.1061 163.415C82.3812 162.931 81.8162 162.242 81.4825 161.436C81.1489 160.631 81.0616 159.744 81.2317 158.889C81.4018 158.033 81.8216 157.248 82.4381 156.631C83.0546 156.015 83.84 155.595 84.6951 155.425C85.5502 155.254 86.4365 155.342 87.242 155.675C88.0475 156.009 88.7359 156.574 89.2203 157.299C89.7047 158.024 89.9632 158.877 89.9632 159.749C89.9632 160.918 89.4988 162.04 88.6721 162.867C87.8454 163.694 86.7242 164.158 85.5551 164.158Z"
          fill="#E6E6E6"
        />
        <path
          d="M87.0927 160.672L86.1703 159.749L87.0927 158.826C87.1743 158.745 87.2201 158.634 87.2201 158.519C87.2201 158.404 87.1743 158.293 87.0927 158.211C87.0112 158.13 86.9006 158.084 86.7853 158.084C86.6699 158.084 86.5593 158.13 86.4778 158.211L85.5553 159.134L84.6329 158.211C84.5514 158.13 84.4408 158.084 84.3255 158.084C84.2101 158.084 84.0995 158.13 84.018 158.211C83.9364 158.293 83.8906 158.404 83.8906 158.519C83.8906 158.634 83.9364 158.745 84.018 158.826L84.9404 159.749L84.018 160.672C83.9364 160.753 83.8906 160.864 83.8906 160.979C83.8906 161.095 83.9364 161.205 84.018 161.287C84.0995 161.368 84.2101 161.414 84.3255 161.414C84.4408 161.414 84.5514 161.368 84.6329 161.287L85.5554 160.364L86.4778 161.287C86.5593 161.368 86.6699 161.414 86.7853 161.414C86.9006 161.414 87.0112 161.368 87.0927 161.287C87.1743 161.205 87.2201 161.095 87.2201 160.979C87.2201 160.864 87.1743 160.753 87.0927 160.672Z"
          fill="white"
        />
        <path
          d="M63.6322 112.091C68.4771 112.091 72.4046 108.162 72.4046 103.316C72.4046 98.4704 68.4771 94.542 63.6322 94.542C58.7874 94.542 54.8599 98.4704 54.8599 103.316C54.8599 108.162 58.7874 112.091 63.6322 112.091Z"
          fill="#E6E6E6"
        />
        <path
          d="M62.4358 107.883C62.2843 107.883 62.1349 107.848 61.9994 107.78C61.864 107.712 61.7461 107.614 61.6553 107.492L59.262 104.301C59.1852 104.198 59.1292 104.082 59.0974 103.957C59.0656 103.833 59.0586 103.704 59.0767 103.577C59.0948 103.45 59.1378 103.328 59.2031 103.218C59.2683 103.108 59.3547 103.011 59.4572 102.934C59.5598 102.857 59.6764 102.801 59.8005 102.77C59.9247 102.738 60.0539 102.731 60.1807 102.749C60.3076 102.767 60.4296 102.81 60.5399 102.875C60.6501 102.941 60.7464 103.027 60.8233 103.13L62.3891 105.218L66.4104 99.1842C66.4811 99.0766 66.5724 98.9841 66.6789 98.9119C66.7855 98.8398 66.9053 98.7894 67.0314 98.7637C67.1575 98.7381 67.2875 98.7376 67.4138 98.7624C67.54 98.7872 67.6602 98.8367 67.7673 98.9081C67.8743 98.9795 67.9662 99.0714 68.0377 99.1784C68.1091 99.2855 68.1587 99.4057 68.1835 99.532C68.2083 99.6583 68.2079 99.7882 68.1823 99.9144C68.1567 100.041 68.1064 100.16 68.0343 100.267L63.2478 107.448C63.1613 107.578 63.0448 107.685 62.9082 107.761C62.7717 107.837 62.619 107.878 62.463 107.883L62.4358 107.883Z"
          fill="white"
        />
        <path
          d="M74.3738 119.146H53.2785C51.9891 119.146 50.9438 120.192 50.9438 121.482V122.322C50.9438 123.612 51.9891 124.657 53.2785 124.657H74.3738C75.6631 124.657 76.7084 123.612 76.7084 122.322V121.482C76.7084 120.192 75.6631 119.146 74.3738 119.146Z"
          fill="#E6E6E6"
        />
        <path
          d="M87.4586 130.168H40.1935C38.9041 130.168 37.8589 131.213 37.8589 132.503V133.344C37.8589 134.633 38.9041 135.679 40.1935 135.679H87.4586C88.748 135.679 89.7933 134.633 89.7933 133.344V132.503C89.7933 131.213 88.748 130.168 87.4586 130.168Z"
          fill="#E6E6E6"
        />
        <path
          d="M87.4586 141.188H40.1935C38.9041 141.188 37.8589 142.234 37.8589 143.524V144.364C37.8589 145.654 38.9041 146.699 40.1935 146.699H87.4586C88.748 146.699 89.7933 145.654 89.7933 144.364V143.524C89.7933 142.234 88.748 141.188 87.4586 141.188Z"
          fill="#E6E6E6"
        />
        <path
          d="M176.743 145.346C175.54 145.346 174.363 144.989 173.362 144.32C172.361 143.651 171.58 142.7 171.12 141.588C170.659 140.475 170.538 139.251 170.773 138.07C171.008 136.889 171.588 135.804 172.439 134.952C173.29 134.101 174.375 133.521 175.556 133.286C176.737 133.051 177.961 133.172 179.073 133.632C180.185 134.093 181.136 134.874 181.805 135.875C182.474 136.876 182.831 138.053 182.831 139.258C182.831 140.872 182.189 142.421 181.048 143.563C179.906 144.705 178.358 145.346 176.743 145.346Z"
          fill="#E6E6E6"
        />
        <path
          d="M178.866 140.531L177.592 139.257L178.866 137.983C178.979 137.871 179.042 137.718 179.042 137.559C179.042 137.399 178.979 137.247 178.866 137.134C178.754 137.021 178.601 136.958 178.442 136.958C178.282 136.958 178.13 137.021 178.017 137.134L176.743 138.408L175.469 137.134C175.357 137.021 175.204 136.958 175.045 136.958C174.886 136.958 174.733 137.021 174.62 137.134C174.508 137.247 174.444 137.399 174.444 137.559C174.444 137.718 174.508 137.871 174.62 137.983L175.894 139.257L174.62 140.531C174.508 140.644 174.444 140.797 174.444 140.956C174.444 141.115 174.508 141.268 174.62 141.381C174.733 141.493 174.886 141.557 175.045 141.557C175.204 141.557 175.357 141.493 175.469 141.381L176.743 140.107L178.017 141.381C178.13 141.493 178.282 141.557 178.442 141.557C178.601 141.557 178.754 141.493 178.866 141.381C178.979 141.268 179.042 141.115 179.042 140.956C179.042 140.797 178.979 140.644 178.866 140.531Z"
          fill="white"
        />
        <path
          d="M150.222 73.4459C156.912 73.4459 162.335 68.0212 162.335 61.3294C162.335 54.6376 156.912 49.2129 150.222 49.2129C143.531 49.2129 138.108 54.6376 138.108 61.3294C138.108 68.0212 143.531 73.4459 150.222 73.4459Z"
          fill="#3B86F2"
        />
        <path
          d="M148.569 67.6361C148.36 67.6362 148.154 67.5874 147.967 67.4938C147.779 67.4002 147.617 67.2643 147.491 67.0969L144.186 62.6894C144.08 62.5478 144.003 62.3867 143.959 62.2152C143.915 62.0438 143.906 61.8654 143.931 61.6902C143.956 61.5149 144.015 61.3464 144.105 61.1941C144.195 61.0418 144.314 60.9087 144.456 60.8026C144.598 60.6964 144.759 60.6191 144.93 60.5752C145.101 60.5313 145.28 60.5215 145.455 60.5466C145.63 60.5716 145.799 60.6309 145.951 60.7211C146.103 60.8113 146.236 60.9306 146.342 61.0722L148.505 63.9554L154.058 55.6239C154.156 55.4766 154.282 55.3501 154.429 55.2515C154.576 55.153 154.741 55.0844 154.915 55.0496C155.088 55.0149 155.267 55.0147 155.441 55.049C155.614 55.0834 155.779 55.1516 155.927 55.2498C156.074 55.348 156.2 55.4743 156.299 55.6214C156.397 55.7685 156.466 55.9335 156.501 56.1071C156.535 56.2807 156.535 56.4594 156.501 56.6331C156.467 56.8068 156.398 56.9719 156.3 57.1192L149.69 67.0359C149.571 67.2153 149.41 67.3633 149.222 67.4677C149.033 67.572 148.822 67.6297 148.607 67.6357C148.594 67.6359 148.582 67.6361 148.569 67.6361Z"
          fill="white"
        />
        <path
          d="M165.944 83.1895H135.035C133.745 83.1895 132.7 84.2349 132.7 85.5246V88.464C132.7 89.7537 133.745 90.7992 135.035 90.7992H165.944C167.233 90.7992 168.279 89.7537 168.279 88.464V85.5246C168.279 84.2349 167.233 83.1895 165.944 83.1895Z"
          fill="#3F3D56"
        />
        <path
          d="M184.013 98.4082H116.965C115.676 98.4082 114.631 99.4537 114.631 100.743V103.683C114.631 104.972 115.676 106.018 116.965 106.018H184.013C185.302 106.018 186.347 104.972 186.347 103.683V100.743C186.347 99.4537 185.302 98.4082 184.013 98.4082Z"
          fill="#3F3D56"
        />
        <path
          d="M184.013 113.628H116.965C115.676 113.628 114.631 114.673 114.631 115.963V118.903C114.631 120.192 115.676 121.238 116.965 121.238H184.013C185.302 121.238 186.347 120.192 186.347 118.903V115.963C186.347 114.673 185.302 113.628 184.013 113.628Z"
          fill="#3F3D56"
        />
        <path
          d="M207.546 213.563L201.671 213.563L198.876 190.898L207.547 190.899L207.546 213.563Z"
          fill="#FFB6B6"
        />
        <path
          d="M207.39 211.644L201.117 209.092L200.938 209.019L197.475 211.644C195.519 211.644 193.644 212.421 192.261 213.804C190.879 215.187 190.102 217.063 190.102 219.019V219.258H209.043V211.644H207.39Z"
          fill="#2F2E41"
        />
        <path
          d="M257.2 208.641L251.59 210.385L242.196 189.571L250.476 186.998L257.2 208.641Z"
          fill="#FFB6B6"
        />
        <path
          d="M256.48 206.855L249.733 206.28L249.54 206.263L247.012 209.798C245.145 210.379 243.584 211.677 242.674 213.408C241.764 215.139 241.579 217.161 242.159 219.029L242.23 219.258L260.318 213.635L258.059 206.364L256.48 206.855Z"
          fill="#2F2E41"
        />
        <path
          d="M233.694 97.4619L236.084 104.259V107.933L235.751 111.973L239.449 125.448L242.35 155.162L256.949 199.148L245.755 202.372L217.175 130.504L208.148 203.197L197.911 202.923C197.911 202.923 196.16 198.687 196.62 196.384C197.081 194.081 197.081 196.845 197.081 194.081C197.081 191.317 195.084 192.518 196.543 190.305C198.002 188.093 197.82 186.156 197.911 184.821C198.002 183.487 197.081 129.594 197.081 127.751C197.081 125.909 196.762 126.312 196.921 124.498C197.081 122.684 199.105 123.43 198.553 120.293C198.002 117.157 197.82 117.705 197.911 115.358C198.002 113.011 199.271 99.2499 199.271 99.2499L233.694 97.4619Z"
          fill="#2F2E41"
        />
        <path
          d="M195.382 99.6725L215.904 79.8772L221.592 63.7682L213.202 60.1191C208.892 64.2482 204.234 77.1089 204.234 77.1089L190.112 95.0793C190.002 95.117 189.892 95.157 189.784 95.2049C189.148 95.4854 188.595 95.9253 188.178 96.4821C187.762 97.0388 187.496 97.6936 187.407 98.3832C187.317 99.0727 187.407 99.7736 187.668 100.418C187.928 101.063 188.35 101.629 188.894 102.063C189.437 102.497 190.083 102.783 190.77 102.894C191.456 103.005 192.159 102.937 192.811 102.696C193.464 102.456 194.043 102.051 194.493 101.522C194.943 100.992 195.25 100.355 195.382 99.6725Z"
          fill="#FFB8B8"
        />
        <path
          d="M210.841 61.9186L221.483 65.2978L221.523 65.2911C225.484 64.6275 228.771 58.1568 230.83 52.8454C231.508 51.0935 231.495 49.1495 230.795 47.4066C230.095 45.6636 228.759 44.2517 227.057 43.4562C225.798 42.8779 224.403 42.6633 223.028 42.8368C221.654 43.0102 220.355 43.5648 219.279 44.4378L213.814 48.9042L210.841 61.9186Z"
          fill="#3B86F2"
        />
        <path
          d="M235.503 106.193L235.565 106.111C238.885 101.706 234.344 90.7983 233.657 89.2163L236.745 88.3016L236.206 82.422L235.947 79.8003L238.348 77.5202L238.356 77.462L240.007 65.711L242.167 57.9335C242.981 54.9933 242.998 51.8893 242.216 48.9403C241.435 45.9912 239.883 43.3033 237.72 41.1524L233.304 36.7673L228.014 28.4849L219.144 28.2559L215.954 33.9232C212.988 34.5287 210.328 36.1558 208.438 38.5211C206.548 40.8864 205.547 43.84 205.611 46.8674L205.911 61.9549L202.728 80.6485L202.639 84.0441L199.515 87.3412L200.093 90.6746L197.756 91.6056L196.613 96.3422C196.176 96.8887 193.292 100.534 193.266 101.551C193.262 101.703 193.371 101.854 193.608 102.023C195.475 103.359 205.907 106.253 210.602 104.513C215.603 102.661 235.203 106.139 235.401 106.175L235.503 106.193Z"
          fill="#3B86F2"
        />
        <path
          d="M213.759 58.3643L209.228 49.3291C202.652 49.7784 189.599 57.3842 189.599 57.3842L164.903 62.6215C164.171 62.3402 163.378 62.2566 162.604 62.3792C161.83 62.5018 161.102 62.8262 160.493 63.3198C159.884 63.8133 159.416 64.4586 159.136 65.1907C158.855 65.9228 158.773 66.7159 158.896 67.49C159.02 68.2642 159.345 68.9922 159.839 69.6007C160.333 70.2092 160.979 70.6767 161.711 70.9563C162.443 71.2358 163.236 71.3175 164.01 71.193C164.784 71.0686 165.511 70.7424 166.119 70.2474L197.534 67.9951L213.759 58.3643Z"
          fill="#FFB8B8"
        />
        <path
          d="M211.932 59.8482L223.765 51.0525L225.849 43.5393C226.253 42.0629 226.236 40.5029 225.8 39.0357C225.364 37.5684 224.526 36.2524 223.382 35.2363C221.821 33.8694 219.799 33.1463 217.726 33.2132C215.652 33.2802 213.682 34.1321 212.212 35.5968C207.759 40.0425 202.68 46.2446 203.771 50.5454L203.782 50.589L211.932 59.8482Z"
          fill="#3B86F2"
        />
        <path
          d="M223.871 26.2027C229.682 26.2027 234.393 21.4907 234.393 15.678C234.393 9.86539 229.682 5.15332 223.871 5.15332C218.06 5.15332 213.349 9.86539 213.349 15.678C213.349 21.4907 218.06 26.2027 223.871 26.2027Z"
          fill="#FFB8B8"
        />
        <path
          d="M230.795 26.6846C229.035 25.8577 226.98 26.3602 225.037 26.4367C223.094 26.5132 220.74 25.7806 220.327 23.8799C220.023 22.4745 220.939 20.9341 220.361 19.6171C219.732 18.1808 217.842 17.9764 216.327 17.5742C214.427 17.0252 212.752 15.885 211.544 14.319C210.336 12.753 209.659 10.8427 209.61 8.86555C209.505 9.6503 210.847 9.90805 211.288 9.25049C211.729 8.59293 211.426 7.68279 210.939 7.05796C210.453 6.43313 209.797 5.93413 209.43 5.23241C209.064 4.53069 209.135 3.48855 209.851 3.15085C210.218 3.8917 210.738 4.54632 211.376 5.07154C212.014 5.59675 212.757 5.98063 213.554 6.19783C213.229 5.20832 213.689 4.09585 214.43 3.36396C215.218 2.67823 216.125 2.14385 217.106 1.7877C219.532 0.736033 222.364 -0.310493 224.713 0.902885C225.319 1.22211 225.845 1.67423 226.253 2.2255C226.66 2.77676 226.937 3.41292 227.064 4.08645C231.409 4.45392 235.871 9.16158 235.623 13.516C235.357 18.2036 235.163 18.5828 231.261 26.471"
          fill="#2F2E41"
        />
        <path
          d="M283.506 219.528H268.223L268.157 219.408C267.962 219.054 267.773 218.678 267.597 218.292C266.023 214.921 265.357 211.066 264.77 207.664L264.328 205.1C264.275 204.79 264.315 204.47 264.444 204.183C264.573 203.895 264.785 203.653 265.052 203.487C265.32 203.32 265.631 203.238 265.946 203.249C266.261 203.261 266.565 203.366 266.82 203.551C269.142 205.242 271.466 206.931 273.79 208.618C274.67 209.258 275.676 210 276.638 210.801C276.731 210.35 276.828 209.897 276.925 209.451C276.992 209.143 277.15 208.862 277.377 208.644C277.605 208.425 277.892 208.28 278.203 208.227C278.514 208.173 278.833 208.213 279.121 208.342C279.409 208.471 279.651 208.683 279.818 208.951L281.606 211.824C282.91 213.923 284.061 215.991 283.827 218.221C283.828 218.248 283.826 218.275 283.821 218.302C283.774 218.668 283.687 219.028 283.561 219.376L283.506 219.528Z"
          fill="#F0F0F0"
        />
        <path
          d="M298.846 219.859L153.617 220C153.472 219.999 153.333 219.941 153.231 219.839C153.129 219.736 153.071 219.597 153.071 219.452C153.071 219.307 153.129 219.168 153.231 219.065C153.333 218.962 153.472 218.904 153.617 218.903L298.846 218.762C298.991 218.762 299.13 218.821 299.232 218.923C299.334 219.026 299.391 219.165 299.391 219.31C299.391 219.455 299.334 219.594 299.232 219.697C299.13 219.8 298.991 219.858 298.846 219.859Z"
          fill="#CACACA"
        />
      </g>
      <defs>
        <clipPath id="clip0_1503_20572">
          <rect width="299.391" height="220" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
}
ActionableNotificationNoDataIcon.propTypes = {
  Height: PropTypes.string,
  Width: PropTypes.string,
};
ActionableNotificationNoDataIcon.defaultProps = {
  Height: '',
  Width: '',
};
export function ResponceNotificationNoDataIcon({ Height, Width }) {
  return (
    <svg
      style={{ height: Height, width: Width }}
      width="288"
      height="220"
      viewBox="0 0 288 220"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_1503_20925)">
        <path
          d="M26.556 219.656L26.5426 219.743C26.5267 219.658 26.5113 219.571 26.4968 219.486C26.4702 219.347 26.4471 219.209 26.4253 219.07C25.5612 213.624 26.0367 208.051 27.8106 202.831C28.1516 201.812 28.5399 200.812 28.9757 199.83C30.6421 196.029 33.0044 192.574 35.9407 189.643C36.8941 188.667 37.9818 187.831 39.1711 187.162C39.3457 187.07 39.5213 186.982 39.7007 186.901C40.8006 186.367 42.0388 186.187 43.2449 186.387C43.6831 186.469 44.1077 186.612 44.5068 186.811C44.6467 186.879 44.7815 186.954 44.9136 187.034C45.7198 187.563 46.4082 188.253 46.9356 189.061C47.463 189.868 47.8181 190.776 47.9787 191.728C48.2078 193.147 48.1554 194.598 47.8246 195.997C47.7961 196.131 47.7656 196.264 47.7329 196.396C47.4984 197.329 47.2036 198.245 46.8506 199.14C43.3167 208.241 35.7224 216.316 26.556 219.656Z"
          fill="#F2F2F2"
        />
        <path
          d="M44.4833 186.841C41.7258 190.807 39.121 194.874 36.6689 199.041C34.2197 203.205 31.9307 207.458 29.8018 211.8C28.6109 214.23 27.4721 216.684 26.3853 219.162C26.265 219.436 26.6709 219.675 26.7928 219.397C28.7336 214.973 30.8399 210.626 33.1115 206.357C35.3817 202.093 37.8113 197.919 40.4004 193.835C41.849 191.55 43.3458 189.297 44.8907 187.076C45.0635 186.827 44.6554 186.593 44.4833 186.841Z"
          fill="white"
        />
        <path
          d="M47.4342 196.022C45.3621 198.717 42.3121 200.487 38.9454 200.946C38.0061 201.074 37.0552 201.093 36.1116 201.002C35.8097 200.974 35.8076 201.445 36.1069 201.473C39.6184 201.769 43.1047 200.666 45.8089 198.404C46.5674 197.77 47.2496 197.049 47.8417 196.257C48.023 196.015 47.6143 195.782 47.4342 196.022Z"
          fill="white"
        />
        <path
          d="M29.7361 210.644C29.2544 209.957 28.8541 209.216 28.5434 208.437C27.8335 206.659 27.5816 204.732 27.8106 202.832C28.1516 201.813 28.54 200.813 28.9757 199.831C29.0021 199.87 29.018 199.914 29.0218 199.961C29.0256 200.008 29.0172 200.055 28.9974 200.097C28.6906 200.833 28.47 201.603 28.3401 202.39C27.8737 205.197 28.5212 208.075 30.1444 210.41C30.165 210.436 30.1786 210.466 30.1841 210.499C30.1896 210.531 30.1866 210.564 30.1757 210.595C30.1575 210.636 30.1289 210.671 30.0928 210.698C30.0567 210.724 30.0144 210.741 29.9699 210.746C29.9255 210.75 29.8805 210.744 29.8395 210.726C29.7985 210.708 29.7628 210.68 29.7361 210.644Z"
          fill="white"
        />
        <path
          d="M39.2413 186.865C38.6741 189.127 38.843 191.511 39.7234 193.671C39.7546 193.725 39.8057 193.764 39.8658 193.78C39.9258 193.797 39.9899 193.789 40.0442 193.758C40.0972 193.726 40.1358 193.675 40.1521 193.615C40.1684 193.556 40.1611 193.492 40.1317 193.437C39.3074 191.388 39.1544 189.13 39.6949 186.989C39.7089 186.929 39.6994 186.867 39.6682 186.814C39.6371 186.762 39.5868 186.724 39.5279 186.708C39.4691 186.691 39.4063 186.699 39.3528 186.728C39.2993 186.758 39.2593 186.807 39.2413 186.865Z"
          fill="white"
        />
        <path
          d="M26.4985 208.29L26.527 208.373C26.4736 208.305 26.4196 208.235 26.367 208.166C26.2792 208.056 26.1945 207.944 26.1105 207.831C22.8184 203.411 20.6528 198.254 19.8014 192.807C19.6306 191.746 19.5103 190.679 19.4407 189.608C19.1525 185.467 19.6411 181.309 20.8812 177.348C21.2722 176.04 21.8478 174.794 22.5905 173.649C22.7021 173.485 22.8169 173.326 22.9382 173.171C23.6643 172.187 24.6776 171.452 25.8383 171.068C26.2645 170.937 26.7068 170.866 27.1525 170.857C27.3081 170.852 27.4621 170.855 27.6162 170.865C28.5757 170.958 29.5055 171.249 30.3474 171.72C31.1893 172.19 31.9252 172.829 32.509 173.597C33.3705 174.747 33.9973 176.056 34.3536 177.449C34.3905 177.58 34.4252 177.712 34.4578 177.845C34.6828 178.78 34.8471 179.728 34.9494 180.685C36.0437 190.388 33.0658 201.07 26.4985 208.29Z"
          fill="#F2F2F2"
        />
        <path
          d="M27.1454 170.893C26.5442 175.688 26.1248 180.501 25.8873 185.331C25.6508 190.158 25.5974 194.988 25.7272 199.823C25.7999 202.528 25.9302 205.231 26.118 207.931C26.1387 208.23 26.6089 208.253 26.5879 207.95C26.2534 203.129 26.1015 198.301 26.1321 193.464C26.1635 188.632 26.378 183.806 26.7756 178.986C26.9982 176.289 27.2781 173.598 27.6153 170.912C27.653 170.612 27.1829 170.594 27.1454 170.893Z"
          fill="white"
        />
        <path
          d="M34.0183 177.651C33.4343 181.002 31.5544 183.987 28.7863 185.959C28.014 186.51 27.1806 186.968 26.3029 187.327C26.0223 187.442 26.239 187.86 26.5172 187.746C29.764 186.375 32.3396 183.777 33.6847 180.517C34.062 179.602 34.3316 178.647 34.4882 177.67C34.5367 177.372 34.0664 177.355 34.0183 177.651Z"
          fill="white"
        />
        <path
          d="M25.1317 198.829C24.3863 198.445 23.6881 197.975 23.0512 197.429C21.5978 196.185 20.4802 194.596 19.8012 192.806C19.6303 191.745 19.51 190.679 19.4404 189.607C19.4817 189.629 19.5166 189.662 19.5416 189.701C19.5666 189.741 19.5809 189.786 19.583 189.833C19.653 190.627 19.8148 191.411 20.065 192.169C20.9545 194.871 22.8635 197.119 25.3849 198.433C25.4149 198.446 25.4411 198.466 25.461 198.492C25.4808 198.518 25.4936 198.549 25.4982 198.581C25.5011 198.626 25.4922 198.671 25.4725 198.711C25.4528 198.751 25.423 198.785 25.3859 198.811C25.3489 198.836 25.3059 198.851 25.2613 198.854C25.2167 198.857 25.172 198.849 25.1317 198.829Z"
          fill="white"
        />
        <path
          d="M22.5137 173.351C23.0612 175.618 24.3172 177.651 26.0989 179.154C26.1516 179.187 26.2152 179.199 26.276 179.185C26.3368 179.172 26.3898 179.135 26.4237 179.083C26.4558 179.03 26.4662 178.966 26.4529 178.906C26.4396 178.845 26.4035 178.792 26.3522 178.758C24.6714 177.326 23.4881 175.398 22.9729 173.25C22.9578 173.191 22.9203 173.14 22.8683 173.108C22.8164 173.076 22.754 173.066 22.6944 173.079C22.6349 173.092 22.5827 173.128 22.549 173.179C22.5153 173.229 22.5026 173.291 22.5137 173.351Z"
          fill="white"
        />
        <path
          d="M26.7019 219.714L26.7709 219.769C26.6893 219.741 26.6063 219.711 26.5248 219.681C26.3916 219.636 26.2599 219.587 26.1282 219.537C20.9761 217.587 16.3767 214.41 12.7285 210.279C12.0138 209.477 11.3388 208.644 10.7035 207.778C8.23278 204.444 6.40718 200.677 5.32098 196.672C4.94659 195.358 4.76135 193.999 4.77086 192.633C4.77713 192.435 4.78808 192.239 4.8069 192.043C4.88904 190.822 5.34741 189.657 6.11884 188.708C6.40765 188.368 6.74206 188.069 7.11254 187.821C7.24104 187.733 7.37274 187.653 7.50753 187.578C8.36643 187.14 9.30646 186.884 10.2688 186.826C11.2311 186.768 12.195 186.91 13.1 187.242C14.4449 187.747 15.6773 188.512 16.7269 189.494C16.8288 189.585 16.9291 189.677 17.0279 189.771C17.7205 190.438 18.3692 191.149 18.9699 191.899C25.1125 199.485 28.3508 210.091 26.7019 219.714Z"
          fill="#F2F2F2"
        />
        <path
          d="M7.12574 187.857C9.19882 192.22 11.4349 196.502 13.8338 200.7C16.2313 204.894 18.7854 208.993 21.4962 212.997C23.0129 215.237 24.5767 217.444 26.1878 219.618C26.3661 219.858 26.7744 219.624 26.5938 219.38C23.7183 215.499 20.9924 211.512 18.416 207.421C15.8426 203.332 13.4267 199.15 11.1682 194.874C9.90475 192.482 8.69261 190.064 7.53176 187.619C7.40188 187.346 6.99633 187.584 7.12574 187.857Z"
          fill="white"
        />
        <path
          d="M16.5535 189.845C17.8641 192.983 17.8863 196.512 16.6151 199.666C16.2605 200.546 15.8052 201.382 15.2584 202.157C15.0839 202.405 15.4914 202.641 15.6644 202.395C17.6625 199.489 18.4351 195.912 17.8143 192.44C17.6401 191.466 17.3532 190.515 16.9595 189.608C16.8399 189.33 16.4347 189.57 16.5535 189.845Z"
          fill="white"
        />
        <path
          d="M20.4602 212.48C19.6253 212.558 18.7842 212.539 17.9539 212.422C16.06 212.158 14.263 211.421 12.7282 210.279C12.0134 209.477 11.3384 208.644 10.7031 207.778C10.7497 207.774 10.7965 207.783 10.8388 207.803C10.8811 207.822 10.9176 207.853 10.9445 207.891C11.4311 208.523 11.9891 209.096 12.6075 209.6C14.811 211.397 17.6288 212.262 20.4602 212.01C20.4925 212.004 20.5256 212.008 20.5563 212.019C20.587 212.03 20.6144 212.049 20.6357 212.074C20.6621 212.11 20.6787 212.152 20.6838 212.197C20.6888 212.241 20.6821 212.286 20.6644 212.327C20.6466 212.369 20.6184 212.404 20.5826 212.431C20.5468 212.458 20.5046 212.475 20.4602 212.48Z"
          fill="white"
        />
        <path
          d="M4.54689 192.424C6.22793 194.039 8.37999 195.075 10.6898 195.381C10.8168 195.398 10.9237 195.26 10.9249 195.145C10.9235 195.083 10.8982 195.024 10.8545 194.981C10.8107 194.937 10.7517 194.912 10.6898 194.91C8.50363 194.61 6.46902 193.623 4.87939 192.092C4.66144 191.881 4.32852 192.214 4.54689 192.424Z"
          fill="white"
        />
        <path
          d="M58.7964 157.637C59.2556 157.322 59.6402 156.91 59.9231 156.43C60.206 155.95 60.3803 155.414 60.4338 154.859C60.4872 154.304 60.4185 153.745 60.2325 153.219C60.0465 152.694 59.7477 152.216 59.3572 151.819L60.8344 118.812L53.3136 119.657L53.7506 151.942C53.1275 152.643 52.783 153.549 52.7822 154.487C52.7815 155.425 53.1246 156.331 53.7466 157.033C54.3685 157.735 55.2261 158.184 56.1569 158.295C57.0876 158.407 58.0267 158.172 58.7964 157.637Z"
          fill="#FFB8B8"
        />
        <path
          d="M72.5166 213.51L76.7971 214.263L81.0276 198.095L75.4192 196.983L72.5166 213.51Z"
          fill="#FFB8B8"
        />
        <path
          d="M84.3535 219.693L70.9009 217.326L71.8147 212.123L80.0697 213.576C80.7522 213.696 81.4045 213.95 81.9892 214.322C82.5738 214.695 83.0795 215.179 83.4773 215.747C83.8751 216.315 84.1572 216.956 84.3076 217.633C84.4579 218.31 84.4735 219.01 84.3535 219.693Z"
          fill="#2F2E41"
        />
        <path
          d="M60.7683 215.654L65.1144 215.654L67.1818 198.874L60.7676 198.874L60.7683 215.654Z"
          fill="#FFB8B8"
        />
        <path
          d="M73.4961 219.693L59.8372 219.694L59.8369 214.412L68.2186 214.411C69.6182 214.411 70.9605 214.968 71.9502 215.958C72.94 216.949 73.496 218.292 73.4961 219.693Z"
          fill="#2F2E41"
        />
        <path
          d="M79.2561 211.059C79.1883 211.059 79.1205 211.055 79.0531 211.047L73.9378 210.626C73.7049 210.599 73.48 210.524 73.2767 210.407C73.0735 210.29 72.8962 210.133 72.7555 209.945C72.6149 209.757 72.5138 209.543 72.4585 209.314C72.4032 209.086 72.3948 208.849 72.4339 208.618L77.1574 182.118L73.9657 165.272C73.9396 165.136 73.8651 165.013 73.7557 164.927C73.6463 164.841 73.5095 164.797 73.3704 164.804C73.2314 164.811 73.0996 164.868 72.9993 164.964C72.899 165.061 72.8369 165.19 72.8246 165.329L68.8345 210.262C68.7906 210.713 68.5735 211.129 68.229 211.423C67.8845 211.716 67.4394 211.865 66.9877 211.836L62.1684 211.656C61.7461 211.627 61.3493 211.443 61.053 211.14C60.7568 210.837 60.5815 210.436 60.5603 210.013L60.2363 156.16L85.2215 153.034L86.9668 180.016L86.9599 180.045L80.9368 209.736C80.845 210.113 80.6296 210.448 80.3248 210.688C80.0201 210.928 79.6438 211.059 79.2561 211.059Z"
          fill="#2F2E41"
        />
        <path
          d="M68.4733 97.4236C73.2819 97.4236 77.1801 93.5216 77.1801 88.7084C77.1801 83.8951 73.2819 79.9932 68.4733 79.9932C63.6647 79.9932 59.7666 83.8951 59.7666 88.7084C59.7666 93.5216 63.6647 97.4236 68.4733 97.4236Z"
          fill="#FFB8B8"
        />
        <path
          d="M76.6777 160.096C75.3159 160.104 73.9804 159.722 72.8289 158.994C68.6114 156.355 63.8211 157.404 61.3409 158.264C61.0948 158.35 60.8324 158.38 60.5733 158.35C60.3142 158.321 60.0652 158.233 59.8448 158.093C59.6269 157.956 59.4428 157.772 59.3062 157.554C59.1697 157.335 59.0842 157.089 59.0562 156.833L54.5462 116.514C53.7904 109.759 57.8557 103.408 64.2124 101.413C64.4512 101.338 64.6941 101.266 64.941 101.199C66.9191 100.662 68.9908 100.566 71.0101 100.917C73.0295 101.268 74.9476 102.057 76.6293 103.23C78.3423 104.415 79.775 105.962 80.8264 107.762C81.8778 109.561 82.5224 111.57 82.7148 113.645L86.5116 154.234C86.5375 154.497 86.5021 154.762 86.4081 155.009C86.3142 155.256 86.1643 155.477 85.9703 155.656C84.6393 156.889 80.7764 160.096 76.6777 160.096Z"
          fill="#3B86F2"
        />
        <path
          d="M62.9443 125.161L52.7691 124.041C52.4796 124.009 52.2004 123.915 51.9504 123.765C51.7004 123.616 51.4856 123.414 51.3206 123.174C51.1556 122.933 51.0442 122.66 50.9941 122.373C50.944 122.086 50.9563 121.791 51.0302 121.509L53.6201 111.628C53.7914 110.147 54.5427 108.793 55.7093 107.865C56.8758 106.937 58.3625 106.51 59.8433 106.677C61.324 106.845 62.678 107.593 63.6085 108.758C64.5389 109.923 64.9698 111.41 64.8067 112.893L65.1912 123.068C65.2021 123.359 65.1501 123.649 65.0389 123.919C64.9276 124.188 64.7597 124.431 64.5464 124.629C64.3332 124.828 64.0797 124.978 63.8033 125.07C63.5268 125.161 63.2338 125.192 62.9443 125.161Z"
          fill="#3B86F2"
        />
        <path
          d="M86.4707 156.223C86.8886 155.855 87.2208 155.399 87.4438 154.889C87.6669 154.378 87.7754 153.825 87.7617 153.268C87.748 152.711 87.6124 152.163 87.3645 151.664C87.1166 151.165 86.7624 150.727 86.3269 150.38L83.8196 117.436L76.4502 119.096L80.776 151.178C80.2419 151.949 80.0089 152.89 80.1211 153.821C80.2333 154.753 80.683 155.611 81.385 156.233C82.0869 156.854 82.9923 157.197 83.9297 157.195C84.867 157.193 85.7711 156.847 86.4707 156.223Z"
          fill="#FFB8B8"
        />
        <path
          d="M73.6246 123.089C73.4113 122.891 73.2433 122.648 73.132 122.379C73.0208 122.109 72.9689 121.819 72.98 121.528L73.3645 111.353C73.2013 109.87 73.6322 108.383 74.5627 107.218C75.4931 106.053 76.8471 105.305 78.3279 105.137C79.8087 104.97 81.2953 105.397 82.4619 106.325C83.6284 107.253 84.3797 108.607 84.551 110.088L87.141 119.969C87.2148 120.251 87.2271 120.546 87.177 120.833C87.1269 121.12 87.0156 121.393 86.8505 121.634C86.6855 121.874 86.4707 122.076 86.2207 122.225C85.9708 122.375 85.6915 122.469 85.402 122.501L75.2268 123.62C74.9373 123.653 74.6443 123.622 74.3677 123.53C74.0912 123.438 73.8378 123.288 73.6246 123.089Z"
          fill="#3B86F2"
        />
        <path
          d="M67.9553 97.7518C67.8005 97.7516 67.6463 97.7336 67.4956 97.6981L67.4514 97.6873C59.7963 96.5151 58.1046 92.0768 57.7332 90.2233C57.3488 88.3042 57.7865 86.4519 58.7755 85.7325C58.2363 84.0283 58.3228 82.5173 59.0333 81.2395C60.2724 79.011 62.9615 78.2575 63.3221 78.1653C65.4696 76.5795 68.0391 77.6381 68.5066 77.8528C72.6608 76.3144 74.2486 77.5949 74.5357 77.8808C76.3927 78.2147 77.5245 78.9327 77.9003 80.0154C78.6061 82.049 76.374 84.5786 76.2787 84.6853L76.2292 84.7406L72.904 84.8991C72.5885 84.9142 72.2796 84.9955 71.9975 85.1377C71.7154 85.2799 71.4663 85.4799 71.2663 85.7248C71.0664 85.9696 70.9201 86.2537 70.837 86.5587C70.7538 86.8638 70.7357 87.1829 70.7837 87.4954C70.8737 87.8987 70.9874 88.2962 71.1242 88.6861C71.692 90.4625 72.1175 91.9801 71.5687 92.5571C71.4444 92.6687 71.2912 92.7431 71.1266 92.7717C70.962 92.8002 70.7927 92.7818 70.6381 92.7186C70.1182 92.5796 69.7652 92.6087 69.5893 92.8054C69.3163 93.1103 69.3996 93.8822 69.8241 94.9789C69.9572 95.3257 69.9931 95.7024 69.9277 96.0681C69.8623 96.4338 69.6983 96.7746 69.4533 97.0537C69.2688 97.2715 69.0394 97.4467 68.7808 97.5672C68.5221 97.6877 68.2405 97.7507 67.9553 97.7518Z"
          fill="#2F2E41"
        />
        <path
          d="M170.78 125.613H127.887C126.289 125.611 124.757 124.975 123.627 123.844C122.498 122.713 121.862 121.18 121.86 119.58V55.0596C121.862 53.4603 122.498 51.927 123.627 50.7961C124.757 49.6653 126.289 49.0291 127.887 49.0273H170.78C172.378 49.0291 173.91 49.6653 175.04 50.7961C176.17 51.927 176.805 53.4603 176.807 55.0596V119.58C176.805 121.18 176.17 122.713 175.04 123.844C173.91 124.975 172.378 125.611 170.78 125.613ZM127.887 49.737C126.477 49.7386 125.125 50.2999 124.129 51.2977C123.132 52.2956 122.571 53.6485 122.569 55.0596V119.58C122.571 120.992 123.132 122.345 124.129 123.342C125.125 124.34 126.477 124.901 127.887 124.903H170.78C172.19 124.901 173.542 124.34 174.539 123.342C175.536 122.345 176.096 120.992 176.098 119.58V55.0596C176.096 53.6485 175.536 52.2956 174.539 51.2977C173.542 50.2999 172.19 49.7386 170.78 49.737H127.887Z"
          fill="#3F3D56"
        />
        <path
          d="M164.222 80.0461H134.445C133.646 80.0452 132.88 79.7272 132.315 79.1617C131.75 78.5963 131.433 77.8296 131.432 77.03V62.8364C131.433 62.0368 131.75 61.2701 132.315 60.7047C132.88 60.1393 133.646 59.8212 134.445 59.8203H164.222C165.021 59.8212 165.787 60.1393 166.352 60.7047C166.917 61.2702 167.235 62.0368 167.236 62.8364V77.03C167.235 77.8296 166.917 78.5963 166.352 79.1617C165.787 79.7271 165.021 80.0452 164.222 80.0461Z"
          fill="#3B86F2"
        />
        <path
          d="M162.096 93.3522H136.572C135.82 93.3522 135.099 93.0531 134.567 92.5208C134.035 91.9884 133.736 91.2664 133.736 90.5135C133.736 89.7606 134.035 89.0386 134.567 88.5062C135.099 87.9739 135.82 87.6748 136.572 87.6748H162.096C162.848 87.6748 163.569 87.9739 164.101 88.5062C164.633 89.0386 164.932 89.7606 164.932 90.5135C164.932 91.2664 164.633 91.9884 164.101 92.5208C163.569 93.0531 162.848 93.3522 162.096 93.3522Z"
          fill="#CCCCCC"
        />
        <path
          d="M162.096 103.998H136.572C135.82 103.998 135.099 103.699 134.567 103.166C134.035 102.634 133.736 101.912 133.736 101.159C133.736 100.406 134.035 99.6841 134.567 99.1517C135.099 98.6194 135.82 98.3203 136.572 98.3203H162.096C162.848 98.3203 163.569 98.6194 164.101 99.1517C164.633 99.6841 164.932 100.406 164.932 101.159C164.932 101.912 164.633 102.634 164.101 103.166C163.569 103.699 162.848 103.998 162.096 103.998Z"
          fill="#CCCCCC"
        />
        <path
          d="M162.096 114.643H136.572C135.82 114.643 135.099 114.344 134.567 113.812C134.035 113.279 133.736 112.557 133.736 111.805C133.736 111.052 134.035 110.33 134.567 109.797C135.099 109.265 135.82 108.966 136.572 108.966H162.096C162.848 108.966 163.569 109.265 164.101 109.797C164.633 110.33 164.932 111.052 164.932 111.805C164.932 112.557 164.633 113.279 164.101 113.812C163.569 114.344 162.848 114.643 162.096 114.643Z"
          fill="#CCCCCC"
        />
        <path
          d="M275.357 161.806H232.463C230.865 161.804 229.333 161.168 228.204 160.037C227.074 158.906 226.438 157.373 226.437 155.774V91.253C226.438 89.6537 227.074 88.1204 228.204 86.9895C229.333 85.8586 230.865 85.2225 232.463 85.2207H275.357C276.954 85.2225 278.486 85.8586 279.616 86.9895C280.746 88.1204 281.381 89.6537 281.383 91.253V155.774C281.381 157.373 280.746 158.906 279.616 160.037C278.486 161.168 276.954 161.804 275.357 161.806ZM232.463 85.9304C231.053 85.932 229.702 86.4933 228.705 87.4911C227.708 88.4889 227.147 89.8418 227.146 91.253V155.774C227.147 157.185 227.708 158.538 228.705 159.536C229.702 160.534 231.053 161.095 232.463 161.096H275.357C276.766 161.095 278.118 160.534 279.115 159.536C280.112 158.538 280.672 157.185 280.674 155.774V91.253C280.672 89.8418 280.112 88.4889 279.115 87.4911C278.118 86.4933 276.766 85.932 275.357 85.9304H232.463Z"
          fill="#3F3D56"
        />
        <path
          d="M266.671 101.159H241.147C240.395 101.159 239.674 100.86 239.142 100.327C238.61 99.7951 238.312 99.073 238.312 98.3202C238.312 97.5673 238.61 96.8452 239.142 96.3129C239.674 95.7805 240.395 95.4814 241.147 95.4814H266.671C267.423 95.4814 268.144 95.7805 268.676 96.3129C269.208 96.8452 269.507 97.5673 269.507 98.3202C269.507 99.073 269.208 99.7951 268.676 100.327C268.144 100.86 267.423 101.159 266.671 101.159Z"
          fill="#CCCCCC"
        />
        <path
          d="M266.671 111.804H241.147C240.395 111.804 239.674 111.505 239.142 110.973C238.61 110.441 238.312 109.719 238.312 108.966C238.312 108.213 238.61 107.491 239.142 106.958C239.674 106.426 240.395 106.127 241.147 106.127H266.671C267.423 106.127 268.144 106.426 268.676 106.958C269.208 107.491 269.507 108.213 269.507 108.966C269.507 109.719 269.208 110.441 268.676 110.973C268.144 111.505 267.423 111.804 266.671 111.804Z"
          fill="#CCCCCC"
        />
        <path
          d="M268.798 138.949H239.021C238.222 138.948 237.456 138.63 236.891 138.065C236.327 137.5 236.009 136.733 236.008 135.933V121.74C236.009 120.94 236.327 120.174 236.891 119.608C237.456 119.043 238.222 118.725 239.021 118.724H268.798C269.597 118.725 270.363 119.043 270.928 119.608C271.493 120.174 271.811 120.94 271.812 121.74V135.933C271.811 136.733 271.493 137.5 270.928 138.065C270.363 138.63 269.597 138.948 268.798 138.949Z"
          fill="#E6E6E6"
        />
        <path
          d="M266.671 151.546H241.147C240.395 151.546 239.674 151.247 239.142 150.714C238.61 150.182 238.312 149.46 238.312 148.707C238.312 147.954 238.61 147.232 239.142 146.7C239.674 146.167 240.395 145.868 241.147 145.868H266.671C267.423 145.868 268.144 146.167 268.676 146.7C269.208 147.232 269.507 147.954 269.507 148.707C269.507 149.46 269.208 150.182 268.676 150.714C268.144 151.247 267.423 151.546 266.671 151.546Z"
          fill="#CCCCCC"
        />
        <path
          d="M249.124 59.2578H206.23C204.633 59.256 203.101 58.6198 201.971 57.489C200.841 56.3581 200.206 54.8248 200.204 53.2255V13.1885C200.206 11.5892 200.841 10.0559 201.971 8.92505C203.101 7.79417 204.633 7.15805 206.23 7.15625H249.124C250.722 7.15805 252.254 7.79417 253.384 8.92505C254.513 10.0559 255.149 11.5892 255.151 13.1885V53.2255C255.149 54.8248 254.513 56.3581 253.384 57.489C252.254 58.6198 250.722 59.256 249.124 59.2578ZM206.23 7.86593C204.821 7.86752 203.469 8.42881 202.472 9.42664C201.475 10.4245 200.915 11.7774 200.913 13.1885V53.2255C200.915 54.6367 201.475 55.9895 202.472 56.9874C203.469 57.9852 204.821 58.5465 206.23 58.5481H249.124C250.534 58.5465 251.886 57.9852 252.882 56.9874C253.879 55.9895 254.44 54.6367 254.442 53.2255V13.1885C254.44 11.7774 253.879 10.4245 252.882 9.42664C251.886 8.42881 250.534 7.86752 249.124 7.86593H206.23Z"
          fill="#3F3D56"
        />
        <path
          d="M240.439 46.6911H214.915C214.163 46.6911 213.442 46.392 212.91 45.8596C212.378 45.3273 212.079 44.6053 212.079 43.8524C212.079 43.0995 212.378 42.3775 212.91 41.8451C213.442 41.3128 214.163 41.0137 214.915 41.0137H240.439C241.191 41.0137 241.912 41.3128 242.444 41.8451C242.976 42.3775 243.275 43.0995 243.275 43.8524C243.275 44.6053 242.976 45.3273 242.444 45.8596C241.912 46.392 241.191 46.6911 240.439 46.6911Z"
          fill="#CCCCCC"
        />
        <path
          d="M240.439 36.0456H214.915C214.163 36.0456 213.442 35.7465 212.91 35.2141C212.378 34.6818 212.079 33.9597 212.079 33.2069C212.079 32.454 212.378 31.732 212.91 31.1996C213.442 30.6672 214.163 30.3682 214.915 30.3682H240.439C241.191 30.3682 241.912 30.6672 242.444 31.1996C242.976 31.732 243.275 32.454 243.275 33.2069C243.275 33.9597 242.976 34.6818 242.444 35.2141C241.912 35.7465 241.191 36.0456 240.439 36.0456Z"
          fill="#CCCCCC"
        />
        <path
          d="M240.439 25.4011H214.915C214.163 25.4011 213.442 25.102 212.91 24.5696C212.378 24.0373 212.079 23.3152 212.079 22.5623C212.079 21.8095 212.378 21.0874 212.91 20.5551C213.442 20.0227 214.163 19.7236 214.915 19.7236H240.439C241.191 19.7236 241.912 20.0227 242.444 20.5551C242.976 21.0874 243.275 21.8095 243.275 22.5623C243.275 23.3152 242.976 24.0373 242.444 24.5696C241.912 25.102 241.191 25.4011 240.439 25.4011Z"
          fill="#CCCCCC"
        />
        <path
          d="M173.263 58.9036C177.766 58.9036 181.416 55.2497 181.416 50.7423C181.416 46.235 177.766 42.5811 173.263 42.5811C168.76 42.5811 165.109 46.235 165.109 50.7423C165.109 55.2497 168.76 58.9036 173.263 58.9036Z"
          fill="#3B86F2"
        />
        <path
          d="M172.454 53.8554C172.271 53.8557 172.092 53.7964 171.946 53.6862L171.937 53.6794L170.021 52.2109C169.931 52.143 169.856 52.0582 169.8 51.9612C169.744 51.8643 169.707 51.7572 169.692 51.646C169.677 51.5349 169.684 51.4219 169.713 51.3135C169.742 51.2051 169.792 51.1035 169.86 51.0145C169.928 50.9254 170.013 50.8507 170.11 50.7947C170.207 50.7386 170.315 50.7023 170.426 50.6878C170.537 50.6732 170.65 50.6808 170.758 50.7101C170.866 50.7393 170.967 50.7896 171.056 50.8581L172.297 51.8107L175.23 47.9821C175.298 47.8933 175.383 47.8187 175.48 47.7627C175.576 47.7068 175.683 47.6704 175.794 47.6558C175.905 47.6411 176.018 47.6485 176.126 47.6774C176.234 47.7063 176.335 47.7563 176.424 47.8243L176.405 47.8491L176.424 47.8247C176.603 47.9624 176.72 48.1655 176.75 48.3894C176.779 48.6134 176.719 48.84 176.582 49.0194L173.132 53.5228C173.052 53.6266 172.949 53.7106 172.832 53.7683C172.714 53.8259 172.585 53.8557 172.454 53.8554Z"
          fill="white"
        />
        <path
          d="M279.61 95.4515C284.113 95.4515 287.764 91.7976 287.764 87.2902C287.764 82.7828 284.113 79.1289 279.61 79.1289C275.107 79.1289 271.457 82.7828 271.457 87.2902C271.457 91.7976 275.107 95.4515 279.61 95.4515Z"
          fill="#3F3D56"
        />
        <path
          d="M278.802 90.4032C278.619 90.4036 278.44 90.3442 278.293 90.2341L278.284 90.2272L276.368 88.7588C276.279 88.6909 276.204 88.606 276.148 88.5091C276.091 88.4122 276.055 88.305 276.04 88.1939C276.025 88.0827 276.032 87.9697 276.061 87.8613C276.09 87.753 276.14 87.6513 276.208 87.5623C276.276 87.4733 276.361 87.3986 276.458 87.3425C276.555 87.2865 276.662 87.2501 276.773 87.2356C276.884 87.2211 276.997 87.2287 277.105 87.2579C277.214 87.2871 277.315 87.3375 277.404 87.406L278.645 88.3586L281.578 84.5299C281.646 84.4411 281.73 84.3666 281.827 84.3106C281.924 84.2546 282.031 84.2183 282.142 84.2036C282.253 84.189 282.365 84.1963 282.473 84.2253C282.581 84.2542 282.682 84.3041 282.771 84.3722L282.753 84.397L282.772 84.3726C282.951 84.5102 283.068 84.7133 283.097 84.9373C283.127 85.1613 283.066 85.3878 282.929 85.5673L279.479 90.0707C279.4 90.1745 279.297 90.2584 279.18 90.3161C279.062 90.3738 278.933 90.4036 278.802 90.4032Z"
          fill="white"
        />
        <path
          d="M253.732 16.3226C258.235 16.3226 261.886 12.6686 261.886 8.16129C261.886 3.65393 258.235 0 253.732 0C249.229 0 245.579 3.65393 245.579 8.16129C245.579 12.6686 249.229 16.3226 253.732 16.3226Z"
          fill="#3F3D56"
        />
        <path
          d="M252.924 11.2743C252.741 11.2747 252.562 11.2153 252.415 11.1052L252.406 11.0983L250.49 9.62987C250.401 9.56198 250.326 9.47712 250.27 9.38018C250.213 9.28325 250.177 9.17613 250.162 9.06497C250.147 8.95381 250.154 8.8408 250.183 8.73242C250.212 8.62404 250.262 8.52243 250.33 8.4334C250.398 8.34437 250.483 8.26969 250.58 8.21363C250.677 8.15757 250.784 8.12123 250.895 8.10671C251.006 8.09219 251.119 8.09976 251.228 8.129C251.336 8.15824 251.437 8.20856 251.526 8.27709L252.767 9.22968L255.7 5.40101C255.768 5.3122 255.853 5.23768 255.949 5.18169C256.046 5.12571 256.153 5.08936 256.264 5.07471C256.375 5.06007 256.487 5.06742 256.595 5.09634C256.703 5.12527 256.805 5.17521 256.893 5.2433L256.875 5.26808L256.894 5.24366C257.073 5.38133 257.19 5.58442 257.219 5.8084C257.249 6.03237 257.188 6.25892 257.051 6.43835L253.601 10.9418C253.522 11.0456 253.419 11.1295 253.302 11.1872C253.184 11.2449 253.055 11.2747 252.924 11.2743Z"
          fill="white"
        />
        <path
          d="M135.417 220H0.354494C0.260476 220 0.170309 219.962 0.103829 219.896C0.0373481 219.829 0 219.739 0 219.645C0 219.551 0.0373481 219.461 0.103829 219.394C0.170309 219.327 0.260476 219.29 0.354494 219.29H135.417C135.511 219.29 135.601 219.327 135.667 219.394C135.734 219.461 135.771 219.551 135.771 219.645C135.771 219.739 135.734 219.829 135.667 219.896C135.601 219.962 135.511 220 135.417 220Z"
          fill="#3F3D56"
        />
      </g>
      <defs>
        <clipPath id="clip0_1503_20925">
          <rect width="287.764" height="220" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
}
ResponceNotificationNoDataIcon.propTypes = {
  Height: PropTypes.string,
  Width: PropTypes.string,
};
ResponceNotificationNoDataIcon.defaultProps = {
  Height: '',
  Width: '',
};
export function MessageNotificationNoDataIcon({ Height, Width }) {
  return (
    <svg
      style={{ height: Height, width: Width }}
      width="379"
      height="274"
      viewBox="0 0 379 274"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_3364_45738)">
        <path
          d="M56.1867 194.23C55.8757 193.76 55.4654 193.363 54.9844 193.068C54.5035 192.773 53.9638 192.587 53.4032 192.523C52.8427 192.459 52.275 192.519 51.7401 192.698C51.2052 192.878 50.7161 193.172 50.3073 193.561L38.1211 187.271L38.8786 194.357L50.3347 199.243C51.0334 199.887 51.9438 200.252 52.8935 200.269C53.8432 200.286 54.7662 199.954 55.4875 199.336C56.2088 198.718 56.6784 197.857 56.8073 196.916C56.9362 195.975 56.7153 195.019 56.1867 194.23Z"
          fill="#A0616A"
        />
        <path
          d="M45.3569 197.083C45.1364 197.184 44.897 197.237 44.6544 197.24C44.4119 197.243 44.1714 197.194 43.9488 197.098L32.3737 192.077C28.4159 190.361 25.2162 187.266 23.3698 183.367L17.2845 170.523C16.8354 169.946 16.5044 169.286 16.3105 168.581C16.1166 167.876 16.0636 167.14 16.1545 166.415C16.2453 165.689 16.4783 164.989 16.84 164.353C17.2018 163.718 17.6853 163.16 18.2628 162.712C18.8403 162.264 19.5005 161.933 20.2057 161.74C20.911 161.547 21.6473 161.495 22.3727 161.587C23.098 161.679 23.7982 161.912 24.4331 162.275C25.0681 162.638 25.6253 163.122 26.073 163.7L36.7695 183.544L46.6464 191.005C46.9291 191.219 47.1391 191.515 47.248 191.853C47.3569 192.191 47.3594 192.554 47.2553 192.893L46.2858 196.024C46.1817 196.36 45.9777 196.656 45.7011 196.873C45.595 196.956 45.4795 197.027 45.3569 197.083Z"
          fill="#CCCCCC"
        />
        <path
          d="M17.0164 155.417C22.2221 155.417 26.4421 151.198 26.4421 145.992C26.4421 140.787 22.2221 136.567 17.0164 136.567C11.8108 136.567 7.59082 140.787 7.59082 145.992C7.59082 151.198 11.8108 155.417 17.0164 155.417Z"
          fill="#A0616A"
        />
        <path
          d="M20.8342 269.632L25.5387 269.632L27.7772 251.485L20.833 251.486L20.8342 269.632Z"
          fill="#A0616A"
        />
        <path
          d="M34.6123 273.999L19.8256 274L19.8254 268.287L28.899 268.287C30.4142 268.287 31.8674 268.888 32.9388 269.96C34.0103 271.031 34.6122 272.484 34.6123 273.999Z"
          fill="#2F2E41"
        />
        <path
          d="M5.48357 269.632L10.1881 269.632L12.4266 251.485L5.48242 251.486L5.48357 269.632Z"
          fill="#A0616A"
        />
        <path
          d="M19.2617 273.999L4.47503 274L4.47476 268.287L13.5484 268.287C15.0636 268.287 16.5168 268.888 17.5882 269.96C18.6597 271.031 19.2616 272.484 19.2617 273.999Z"
          fill="#2F2E41"
        />
        <path
          d="M3.84078 264.438C3.67867 264.253 3.558 264.035 3.48685 263.8C3.4157 263.564 3.39571 263.316 3.42824 263.072L11.6656 201.296L32.1311 204.771L34.3153 203.461L28.6673 262.075C28.6203 262.47 28.4383 262.838 28.1519 263.115C27.8655 263.392 27.4923 263.562 27.0953 263.596L20.8984 264.112C20.652 264.133 20.4041 264.1 20.1714 264.017C19.9387 263.933 19.7267 263.801 19.5496 263.628C19.3725 263.456 19.2346 263.247 19.1451 263.017C19.0556 262.786 19.0166 262.539 19.0308 262.292L20.6352 234.378C20.638 234.331 20.6232 234.284 20.5935 234.247C20.5638 234.21 20.5214 234.185 20.4745 234.178C20.4277 234.17 20.3796 234.18 20.3397 234.206C20.2997 234.231 20.2708 234.271 20.2584 234.317L12.321 263.75C12.2217 264.116 12.0047 264.44 11.7034 264.671C11.4021 264.901 11.0332 265.027 10.6536 265.027H5.14011C4.89403 265.027 4.65079 264.975 4.42669 264.873C4.2026 264.771 4.00283 264.623 3.84078 264.438Z"
          fill="#2F2E41"
        />
        <path
          d="M18.0138 205.62C17.779 205.407 17.477 205.283 17.1604 205.27C16.8438 205.257 16.5325 205.355 16.2807 205.547L12.1891 208.73C11.9664 208.903 11.7045 209.02 11.4264 209.068C11.1483 209.117 10.8624 209.097 10.5939 209.01C10.3254 208.922 10.0824 208.77 9.88632 208.567C9.69022 208.364 9.54699 208.116 9.4692 207.844C7.46222 200.816 2.91515 183.125 4.03533 170.673C4.67029 163.615 10.7654 158.251 17.6225 158.701C22.3104 159.014 25.3945 161.718 26.7891 166.738C30.2132 179.065 33.9763 201.675 34.6958 206.083C34.7526 206.425 34.7047 206.776 34.5584 207.09C34.4121 207.405 34.1742 207.667 33.8759 207.844C31.94 209.006 29.7281 209.629 27.4702 209.647C24.7381 209.647 21.4623 208.695 18.0138 205.62Z"
          fill="#CCCCCC"
        />
        <path
          d="M19.5577 210.004C19.6035 209.442 19.5255 208.877 19.3291 208.348C19.1327 207.819 18.8228 207.34 18.4211 206.944C18.0194 206.547 17.5357 206.244 17.0042 206.055C16.4726 205.866 15.9061 205.796 15.3444 205.85L9.63718 193.381L5.86035 199.424L11.8591 210.338C12.0118 211.275 12.503 212.124 13.2398 212.724C13.9765 213.323 14.9076 213.632 15.8565 213.59C16.8055 213.549 17.7064 213.162 18.3886 212.501C19.0707 211.84 19.4867 210.952 19.5577 210.004Z"
          fill="#A0616A"
        />
        <path
          d="M9.27593 205.566C9.04 205.51 8.8186 205.404 8.62613 205.256C8.43365 205.109 8.2744 204.922 8.15874 204.709L2.14932 193.615C0.0941807 189.823 -0.51329 185.413 0.439902 181.206L3.5785 167.344C3.58135 166.613 3.72824 165.89 4.01079 165.216C4.29334 164.541 4.70601 163.929 5.22519 163.415C5.74438 162.9 6.35991 162.493 7.03659 162.216C7.71327 161.94 8.43783 161.799 9.16886 161.803C9.89989 161.806 10.6231 161.954 11.297 162.237C11.9709 162.52 12.5825 162.934 13.0966 163.453C13.6107 163.973 14.0174 164.589 14.2934 165.266C14.5693 165.943 14.7091 166.667 14.7048 167.398L10.8743 189.614L14.0418 201.579C14.1318 201.922 14.1143 202.285 13.9915 202.618C13.8688 202.951 13.6467 203.238 13.3554 203.441L10.6602 205.306C10.3711 205.506 10.0279 205.613 9.67635 205.613C9.54148 205.613 9.40707 205.598 9.27593 205.566Z"
          fill="#CCCCCC"
        />
        <path
          opacity="0.2"
          d="M13.9402 176.767L10.4863 191.349L15.4753 203.628L12.0214 191.732L13.9402 176.767Z"
          fill="black"
        />
        <path
          d="M11.6377 153.742C10.7993 153.758 9.9661 153.607 9.18626 153.299C8.84314 153.167 8.48695 153.058 8.14446 152.926C5.11975 151.757 3.12726 148.536 3.0559 145.295C2.98454 142.053 4.66336 138.907 7.15627 136.833C9.64919 134.76 12.8781 133.695 16.1114 133.449C19.5941 133.184 23.5158 134.067 25.4619 136.967C25.98 137.739 26.3422 138.676 26.0353 139.608C25.9433 139.889 25.7791 140.141 25.5591 140.339C24.69 141.112 23.8235 140.531 22.9376 140.48C21.7198 140.409 20.626 141.395 20.2329 142.549C19.8398 143.704 20.0128 144.975 20.3302 146.153C20.572 146.862 20.7245 147.598 20.784 148.344C20.8096 148.718 20.7393 149.093 20.5795 149.433C20.4198 149.772 20.176 150.065 19.8712 150.284C19.1103 150.744 18.1109 150.478 17.3495 150.018C16.5881 149.559 15.9302 148.921 15.1077 148.583C14.2853 148.245 13.1803 148.32 12.7016 149.069C12.5495 149.342 12.4465 149.639 12.3974 149.947C11.9683 151.902 12.0669 151.787 11.6377 153.742Z"
          fill="#2F2E41"
        />
        <path
          d="M290.638 88.4443H57.6932C56.8059 88.4451 55.9551 88.7979 55.3277 89.4252C54.7003 90.0526 54.3475 90.9033 54.3467 91.7905V249.63C54.3475 250.517 54.7003 251.368 55.3277 251.995C55.9551 252.622 56.8059 252.975 57.6932 252.976H290.638C291.121 252.976 291.6 252.871 292.039 252.668C292.478 252.466 292.868 252.17 293.182 251.802C293.209 251.773 293.233 251.742 293.255 251.71C293.455 251.465 293.616 251.193 293.735 250.9C293.903 250.498 293.989 250.066 293.988 249.63V151.374H293.032V249.63C293.033 250.097 292.895 250.553 292.637 250.942C292.408 251.285 292.096 251.564 291.731 251.756C291.393 251.93 291.018 252.021 290.638 252.021H57.6932C57.0593 252.02 56.4516 251.768 56.0033 251.32C55.5551 250.871 55.3029 250.264 55.3022 249.63V91.7905C55.3029 91.1567 55.5551 90.549 56.0033 90.1008C56.4516 89.6527 57.0593 89.4006 57.6932 89.3998H290.638C291.272 89.3998 291.881 89.6515 292.33 90.0998C292.779 90.548 293.031 91.1561 293.032 91.7905V113H293.988V91.7905C293.987 90.9027 293.633 90.0516 293.005 89.4242C292.377 88.7967 291.526 88.4443 290.638 88.4443Z"
          fill="#3F3D56"
        />
        <path
          d="M293.507 101.856H54.8223V102.813H293.507V101.856Z"
          fill="#3F3D56"
        />
        <path
          d="M62.9539 98.4895C64.539 98.4895 65.8239 97.2047 65.8239 95.6198C65.8239 94.0348 64.539 92.75 62.9539 92.75C61.3689 92.75 60.084 94.0348 60.084 95.6198C60.084 97.2047 61.3689 98.4895 62.9539 98.4895Z"
          fill="#CCCCCC"
        />
        <path
          d="M71.2049 98.4895C72.7899 98.4895 74.0749 97.2047 74.0749 95.6198C74.0749 94.0348 72.7899 92.75 71.2049 92.75C69.6199 92.75 68.335 94.0348 68.335 95.6198C68.335 97.2047 69.6199 98.4895 71.2049 98.4895Z"
          fill="#CCCCCC"
        />
        <path
          d="M79.4559 98.4895C81.0409 98.4895 82.3258 97.2047 82.3258 95.6198C82.3258 94.0348 81.0409 92.75 79.4559 92.75C77.8709 92.75 76.5859 94.0348 76.5859 95.6198C76.5859 97.2047 77.8709 98.4895 79.4559 98.4895Z"
          fill="#CCCCCC"
        />
        <path
          d="M137.102 233.629C136.114 233.624 135.142 233.374 134.276 232.899C133.409 232.425 132.675 231.741 132.139 230.911C131.603 230.082 131.282 229.131 131.206 228.146C131.13 227.161 131.301 226.173 131.703 225.271L138.541 210.017C133.156 205.254 128.847 199.4 125.9 192.844C122.952 186.287 121.435 179.178 121.447 171.99C121.447 143.906 144.297 121.058 172.383 121.058C200.469 121.058 223.319 143.906 223.319 171.99C223.319 200.074 200.469 222.922 172.383 222.922C167.47 222.918 162.583 222.198 157.878 220.786L140.428 232.598C139.447 233.267 138.289 233.627 137.102 233.629ZM172.383 128.164C163.293 128.159 154.427 130.982 147.013 136.241C139.599 141.5 134.005 148.935 131.007 157.515C128.008 166.096 127.753 175.396 130.278 184.128C132.802 192.86 137.98 200.59 145.095 206.247L147.249 207.965L139.892 224.379L156.775 212.95L158.441 213.51C164.463 215.533 170.853 216.223 177.168 215.531C183.483 214.839 189.572 212.782 195.012 209.503C200.453 206.224 205.116 201.802 208.678 196.542C212.239 191.282 214.614 185.31 215.638 179.041C216.662 172.772 216.311 166.355 214.608 160.235C212.906 154.115 209.893 148.439 205.778 143.599C201.663 138.76 196.546 134.873 190.779 132.207C185.013 129.542 178.736 128.163 172.383 128.164Z"
          fill="#3F3D56"
        />
        <path
          d="M172.384 176.728C176.309 176.728 179.491 173.546 179.491 169.621C179.491 165.696 176.309 162.515 172.384 162.515C168.458 162.515 165.276 165.696 165.276 169.621C165.276 173.546 168.458 176.728 172.384 176.728Z"
          fill="#3F3D56"
        />
        <path
          d="M152.246 176.728C156.171 176.728 159.353 173.546 159.353 169.621C159.353 165.696 156.171 162.515 152.246 162.515C148.321 162.515 145.139 165.696 145.139 169.621C145.139 173.546 148.321 176.728 152.246 176.728Z"
          fill="#3F3D56"
        />
        <path
          d="M192.52 176.728C196.446 176.728 199.628 173.546 199.628 169.621C199.628 165.696 196.446 162.515 192.52 162.515C188.595 162.515 185.413 165.696 185.413 169.621C185.413 173.546 188.595 176.728 192.52 176.728Z"
          fill="#3F3D56"
        />
        <path
          d="M351.11 141.492H283.567C282.753 141.492 281.972 141.169 281.396 140.593C280.821 140.017 280.497 139.237 280.497 138.422C280.497 137.608 280.821 136.827 281.396 136.252C281.972 135.676 282.753 135.353 283.567 135.353H351.11C351.924 135.353 352.705 135.676 353.28 136.252C353.856 136.827 354.18 137.608 354.18 138.422C354.18 139.237 353.856 140.017 353.28 140.593C352.705 141.169 351.924 141.492 351.11 141.492Z"
          fill="#CCCCCC"
        />
        <path
          d="M306.977 128.445H283.567C282.753 128.445 281.972 128.122 281.396 127.546C280.821 126.971 280.497 126.19 280.497 125.376C280.497 124.561 280.821 123.781 281.396 123.205C281.972 122.629 282.753 122.306 283.567 122.306H306.977C307.791 122.306 308.572 122.629 309.148 123.205C309.723 123.781 310.047 124.561 310.047 125.376C310.047 126.19 309.723 126.971 309.148 127.546C308.572 128.122 307.791 128.445 306.977 128.445Z"
          fill="#CCCCCC"
        />
        <path
          d="M252.976 145.234C260.182 145.234 266.024 139.392 266.024 132.187C266.024 124.981 260.182 119.14 252.976 119.14C245.77 119.14 239.928 124.981 239.928 132.187C239.928 139.392 245.77 145.234 252.976 145.234Z"
          fill="#3B86F2"
        />
        <path
          d="M357.88 112.232H236.227C234.498 112.235 232.84 112.923 231.617 114.146C230.394 115.369 229.706 117.027 229.703 118.756V145.618C229.706 147.347 230.394 149.005 231.617 150.228C232.84 151.451 234.498 152.139 236.227 152.141H357.88C359.61 152.139 361.268 151.451 362.491 150.228C363.714 149.005 364.402 147.347 364.404 145.618V118.756C364.402 117.027 363.714 115.369 362.491 114.146C361.268 112.923 359.61 112.235 357.88 112.232ZM363.637 145.618C363.635 147.144 363.028 148.607 361.949 149.686C360.869 150.765 359.406 151.372 357.88 151.374H236.227C234.701 151.372 233.238 150.765 232.159 149.686C231.08 148.607 230.473 147.144 230.471 145.618V118.756C230.473 117.23 231.08 115.767 232.159 114.688C233.238 113.609 234.701 113.002 236.227 113H357.88C359.406 113.002 360.869 113.609 361.949 114.688C363.028 115.767 363.635 117.23 363.637 118.756V145.618Z"
          fill="#3F3D56"
        />
        <path
          d="M363.637 122.977C368.512 122.977 372.464 119.026 372.464 114.151C372.464 109.277 368.512 105.325 363.637 105.325C358.762 105.325 354.811 109.277 354.811 114.151C354.811 119.026 358.762 122.977 363.637 122.977Z"
          fill="#3B86F2"
        />
        <path
          d="M363.365 119.115C363.33 119.079 363.301 119.037 363.282 118.99C363.263 118.944 363.253 118.894 363.253 118.843V109.075C363.253 108.973 363.293 108.876 363.365 108.804C363.437 108.732 363.535 108.691 363.637 108.691C363.738 108.691 363.836 108.732 363.908 108.804C363.98 108.876 364.02 108.973 364.02 109.075V118.843C364.02 118.919 363.998 118.994 363.956 119.057C363.914 119.12 363.854 119.169 363.784 119.198C363.713 119.227 363.636 119.235 363.562 119.22C363.487 119.205 363.419 119.168 363.365 119.115Z"
          fill="white"
        />
        <path
          d="M358.481 114.23C358.427 114.177 358.39 114.108 358.376 114.034C358.361 113.959 358.368 113.882 358.397 113.812C358.426 113.742 358.476 113.682 358.539 113.64C358.602 113.598 358.676 113.575 358.752 113.575H368.521C368.623 113.575 368.72 113.616 368.792 113.688C368.864 113.76 368.905 113.857 368.905 113.959C368.905 114.061 368.864 114.158 368.792 114.23C368.72 114.302 368.623 114.343 368.521 114.343H358.752C358.701 114.343 358.652 114.333 358.605 114.314C358.558 114.294 358.516 114.266 358.481 114.23Z"
          fill="white"
        />
        <path
          d="M374.203 231.462H355.779C355.779 231.991 336.79 232.421 336.79 232.421C336.492 232.646 336.22 232.903 335.98 233.189C335.259 234.049 334.865 235.136 334.867 236.259V237.026C334.868 238.298 335.373 239.518 336.273 240.417C337.172 241.317 338.392 241.822 339.664 241.823H374.203C375.475 241.822 376.694 241.316 377.594 240.417C378.493 239.517 378.999 238.298 379 237.026V236.259C378.998 234.987 378.492 233.768 377.593 232.869C376.694 231.97 375.475 231.464 374.203 231.462Z"
          fill="#3F3D56"
        />
        <path
          d="M359.618 241.633H354.629V273.867H359.618V241.633Z"
          fill="#3F3D56"
        />
        <path
          d="M373.817 273.691C373.817 274.23 366.257 273.9 356.931 273.9C347.606 273.9 340.046 274.23 340.046 273.691C340.046 273.152 347.606 268.878 356.931 268.878C366.257 268.878 373.817 273.152 373.817 273.691Z"
          fill="#3F3D56"
        />
        <path
          d="M358.724 188.266C364.658 188.266 369.469 183.455 369.469 177.521C369.469 171.587 364.658 166.776 358.724 166.776C352.789 166.776 347.979 171.587 347.979 177.521C347.979 183.455 352.789 188.266 358.724 188.266Z"
          fill="#2F2E41"
        />
        <path
          d="M331.983 269.451L327.279 269.451L325.04 251.305L331.984 251.305L331.983 269.451Z"
          fill="#FFB8B8"
        />
        <path
          d="M323.918 268.107H332.992V273.82H318.205C318.205 272.305 318.807 270.852 319.878 269.781C320.95 268.709 322.403 268.107 323.918 268.107Z"
          fill="#2F2E41"
        />
        <path
          d="M324.639 266.825L320.15 265.417L323.448 247.433L330.073 249.512L324.639 266.825Z"
          fill="#FFB8B8"
        />
        <path
          d="M317.346 263.128L326.004 265.845L324.293 271.296L310.185 266.869C310.639 265.423 311.648 264.217 312.991 263.515C314.334 262.814 315.901 262.675 317.346 263.128Z"
          fill="#2F2E41"
        />
        <path
          d="M361.603 228.317C361.494 227.402 361.299 226.5 361.019 225.623L360.14 224.518L357.853 221.647L357.753 221.651C357.584 221.659 356.882 221.697 355.796 221.782H355.785C355.113 221.835 354.292 221.905 353.359 221.993C353.114 222.02 352.857 222.043 352.592 222.07V226.076H357.389C357.622 226.076 357.847 226.161 358.022 226.315C358.197 226.469 358.31 226.681 358.341 226.912C358.344 226.955 358.348 226.993 358.348 227.035C358.348 227.29 358.247 227.534 358.067 227.713C357.887 227.893 357.643 227.994 357.389 227.994H329.528C329.173 228.23 328.832 228.486 328.507 228.762C327.525 229.522 326.818 230.581 326.492 231.778C324.865 238.931 321.898 252.27 321.023 256.188C320.96 256.483 320.974 256.79 321.065 257.078C321.156 257.365 321.32 257.625 321.541 257.83C321.705 257.982 321.896 258.101 322.106 258.179L325.567 259.476C325.709 259.529 325.858 259.564 326.008 259.58C326.028 259.58 326.043 259.584 326.062 259.584C326.098 259.587 326.134 259.588 326.17 259.588C326.52 259.586 326.861 259.479 327.149 259.281C327.438 259.082 327.659 258.801 327.785 258.475L330.518 251.307L334.728 240.255L336.393 235.884C338.323 236.337 354.518 239.921 359.941 234.146C360.476 233.577 360.898 232.911 361.184 232.185C361.641 230.95 361.784 229.621 361.603 228.317Z"
          fill="#2F2E41"
        />
        <path
          d="M366.3 229.36C366.215 229.018 366.119 228.665 366.008 228.309L362.842 224.333L362.742 224.337C362.543 224.348 361.595 224.398 360.14 224.517C358.49 224.655 356.184 224.878 353.593 225.227C353.517 225.235 353.436 225.246 353.359 225.258C353.106 225.292 352.849 225.327 352.592 225.365V226.075H357.389C357.622 226.076 357.847 226.161 358.022 226.314C358.197 226.468 358.31 226.681 358.341 226.912C358.344 226.954 358.348 226.992 358.348 227.035C358.348 227.289 358.247 227.533 358.067 227.713C357.887 227.893 357.643 227.994 357.389 227.994H340.434C339.694 228.236 338.98 228.489 338.297 228.761C334.712 230.181 332.03 232.042 331.481 234.464C331.297 235.277 331.093 236.171 330.878 237.123C330.08 240.661 329.109 244.994 328.231 248.931V248.935C328.05 249.748 327.87 250.539 327.697 251.306C326.964 254.606 326.342 257.404 326.012 258.873C326.005 258.916 325.997 258.954 325.989 258.996V259.004C325.951 259.301 325.988 259.603 326.097 259.883L326.101 259.886V259.89C326.206 260.158 326.378 260.394 326.6 260.577C326.748 260.699 326.915 260.797 327.095 260.865L330.556 262.162C330.749 262.234 330.953 262.272 331.159 262.273C331.447 262.274 331.731 262.201 331.984 262.062C332.346 261.866 332.627 261.546 332.774 261.16L340.227 241.605L341.382 238.57C343.312 239.022 359.507 242.603 364.93 236.831C366.001 235.672 366.612 234.161 366.649 232.583C366.687 231.498 366.569 230.412 366.3 229.36Z"
          fill="#2F2E41"
        />
        <path
          d="M365.873 195.506C365.812 195.433 365.747 195.361 365.678 195.292C364.656 194.217 363.394 193.4 361.995 192.907C360.596 192.414 359.1 192.259 357.63 192.456C356.348 192.624 355.078 192.874 353.827 193.204C352.212 193.619 350.733 194.449 349.537 195.61C348.605 196.514 347.871 197.601 347.381 198.803C346.892 200.006 346.657 201.296 346.693 202.594C346.708 203.12 346.712 203.657 346.705 204.202C346.705 204.455 346.701 204.712 346.697 204.969H350.481C350.645 204.969 350.809 204.988 350.968 205.027C351.43 205.137 351.841 205.4 352.136 205.772C352.43 206.145 352.591 206.605 352.592 207.08V224.931C352.849 225.004 353.106 225.077 353.359 225.154C353.44 225.181 353.516 225.204 353.593 225.227C353.681 225.254 353.77 225.281 353.854 225.307C354.633 225.549 355.394 225.805 356.137 226.075H357.389C357.622 226.075 357.847 226.16 358.022 226.314C358.197 226.468 358.31 226.68 358.34 226.912C358.601 227.015 358.854 227.119 359.104 227.222C359.99 227.591 360.831 227.959 361.602 228.316C362.642 228.792 363.567 229.245 364.342 229.64C364.586 229.764 364.855 229.83 365.129 229.832C365.488 229.831 365.838 229.715 366.127 229.502C366.187 229.457 366.244 229.41 366.299 229.36C366.505 229.167 366.66 228.927 366.752 228.661C366.843 228.395 366.869 228.111 366.825 227.832C366.429 224.818 366.313 221.774 366.48 218.738C366.587 216.186 366.818 213.569 367.117 211.04C367.278 209.67 367.458 208.327 367.647 207.034C367.827 205.798 368.019 204.612 368.207 203.492C368.454 202.071 368.372 200.613 367.967 199.228C367.563 197.844 366.846 196.571 365.873 195.506Z"
          fill="#3B86F2"
        />
        <path
          d="M350.143 195.822C349.946 195.737 349.744 195.667 349.537 195.611C348.514 195.335 347.426 195.437 346.472 195.897C345.518 196.357 344.762 197.145 344.341 198.117L341.704 204.203L341.374 204.97H350.481C350.645 204.97 350.809 204.989 350.968 205.028L351.275 204.318L352.442 201.624C352.905 200.55 352.923 199.335 352.492 198.248C352.061 197.16 351.217 196.287 350.143 195.822Z"
          fill="#3B86F2"
        />
        <path
          d="M358.332 189.459C363.537 189.459 367.757 185.24 367.757 180.034C367.757 174.829 363.537 170.609 358.332 170.609C353.126 170.609 348.906 174.829 348.906 180.034C348.906 185.24 353.126 189.459 358.332 189.459Z"
          fill="#FFB8B8"
        />
        <path
          d="M348.736 175.404C353.201 178.13 358.234 179.788 363.445 180.25L361.894 178.393C363.023 178.81 364.211 179.046 365.414 179.092C366.615 179.073 367.873 178.61 368.555 177.621C368.859 177.129 369.04 176.572 369.082 175.995C369.123 175.418 369.025 174.84 368.795 174.31C368.323 173.252 367.587 172.332 366.659 171.639C365.014 170.337 363.072 169.463 361.006 169.094C358.941 168.725 356.816 168.872 354.822 169.523C353.454 169.932 352.229 170.718 351.287 171.791C350.393 172.893 348.673 173.875 349.13 175.218L348.736 175.404Z"
          fill="#2F2E41"
        />
        <path
          d="M359.916 167.798C356.943 164.784 353.346 162.458 349.377 160.983C346.829 160.04 344.056 159.457 341.393 159.993C338.729 160.529 336.21 162.371 335.467 164.984C334.86 167.121 335.487 169.422 336.43 171.433C337.373 173.445 338.632 175.31 339.394 177.396C340.172 179.525 340.406 181.815 340.075 184.057C339.744 186.3 338.858 188.424 337.497 190.237C336.137 192.05 334.345 193.494 332.284 194.439C330.224 195.384 327.96 195.8 325.698 195.648C328.315 195.999 330.728 197.228 333.286 197.883C335.844 198.538 338.863 198.493 340.764 196.661C342.775 194.722 342.815 191.57 342.718 188.778C342.573 184.628 342.429 180.478 342.284 176.327C342.211 174.211 342.148 172.027 342.911 170.051C343.674 168.076 345.488 166.346 347.606 166.364C349.211 166.377 350.632 167.35 351.919 168.309C353.206 169.267 354.569 170.291 356.168 170.433C357.766 170.576 359.592 169.393 359.472 167.792L359.916 167.798Z"
          fill="#2F2E41"
        />
        <path
          d="M367.647 207.034L362.267 207.18L361.875 210.96L361.787 211.835L353.359 215.618L352.592 215.964V222.691L353.359 222.472L355.785 221.781H355.796L366.48 218.738L366.603 218.704C367.466 218.454 368.226 217.933 368.77 217.218C369.313 216.502 369.611 215.63 369.619 214.732L369.646 210.269L369.669 206.98L367.647 207.034Z"
          fill="#FFB8B8"
        />
        <path
          d="M369.397 199.559C369.325 198.391 368.792 197.299 367.915 196.523C367.038 195.748 365.889 195.353 364.72 195.424C363.552 195.496 362.46 196.029 361.685 196.906C360.909 197.783 360.514 198.932 360.585 200.1L361.172 209.678C361.188 209.93 361.26 210.176 361.381 210.397C361.502 210.619 361.671 210.811 361.875 210.96C362.199 211.202 362.599 211.32 363.003 211.294L367.117 211.041L368.364 210.964C368.592 210.953 368.814 210.896 369.019 210.796C369.223 210.696 369.405 210.556 369.554 210.384C369.587 210.348 369.618 210.309 369.646 210.269C369.89 209.943 370.01 209.54 369.984 209.133L369.397 199.559Z"
          fill="#3B86F2"
        />
        <path
          d="M353.855 225.308H353.36V225.258C353.106 225.292 352.849 225.327 352.592 225.365V226.075H356.138C355.394 225.807 354.632 225.551 353.855 225.308ZM353.855 225.308H353.36V225.258C353.106 225.292 352.849 225.327 352.592 225.365V226.075H356.138C355.394 225.807 354.632 225.551 353.855 225.308ZM357.389 225.308H353.36V207.08C353.358 206.456 353.154 205.849 352.779 205.351C352.403 204.853 351.875 204.49 351.276 204.317C351.018 204.24 350.75 204.201 350.481 204.202H316.326C315.563 204.203 314.832 204.507 314.292 205.046C313.753 205.586 313.449 206.317 313.448 207.08V225.883C313.449 226.647 313.752 227.379 314.292 227.918C314.831 228.458 315.563 228.761 316.326 228.761H357.389C357.814 228.761 358.224 228.603 358.541 228.32C358.857 228.036 359.058 227.645 359.104 227.223C359.112 227.16 359.116 227.097 359.116 227.035C359.115 226.577 358.933 226.138 358.61 225.814C358.286 225.491 357.847 225.308 357.389 225.308ZM358.349 227.035C358.348 227.289 358.247 227.533 358.067 227.713C357.888 227.893 357.644 227.994 357.389 227.994H316.326C315.767 227.994 315.23 227.771 314.834 227.375C314.439 226.98 314.216 226.443 314.216 225.883V207.08C314.216 206.521 314.439 205.984 314.834 205.588C315.23 205.192 315.767 204.97 316.326 204.97H350.481C350.646 204.969 350.809 204.989 350.969 205.027C351.431 205.138 351.842 205.4 352.136 205.772C352.431 206.145 352.591 206.605 352.592 207.08V226.075H357.389C357.622 226.076 357.847 226.161 358.022 226.315C358.198 226.468 358.311 226.681 358.341 226.912C358.345 226.954 358.349 226.992 358.349 227.035ZM353.855 225.308H353.36V225.258C353.106 225.292 352.849 225.327 352.592 225.365V226.075H356.138C355.394 225.807 354.632 225.551 353.855 225.308Z"
          fill="#3F3D56"
        />
        <path
          d="M333.402 218.785C334.674 218.785 335.705 217.754 335.705 216.482C335.705 215.211 334.674 214.18 333.402 214.18C332.131 214.18 331.1 215.211 331.1 216.482C331.1 217.754 332.131 218.785 333.402 218.785Z"
          fill="#3B86F2"
        />
      </g>
      <defs>
        <clipPath id="clip0_3364_45738">
          <rect width="379" height="274" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
}
MessageNotificationNoDataIcon.propTypes = {
  Height: PropTypes.string,
  Width: PropTypes.string,
};
MessageNotificationNoDataIcon.defaultProps = {
  Height: '',
  Width: '',
};
export function DocumetsNotificationNoDataIcon({ Height, Width }) {
  return (
    <svg
      style={{ height: Height, width: Width }}
      width="324"
      height="200"
      viewBox="0 0 324 200"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_3364_45802)">
        <path
          d="M15.8714 184.38C16.007 189.455 16.8548 194.486 18.3899 199.324C18.4239 199.436 18.4617 199.547 18.4984 199.659H27.8961C27.8863 199.558 27.876 199.446 27.8662 199.324C27.2396 192.1 30.8193 148.657 35.1388 141.139C34.7604 141.749 15.1427 161.427 15.8714 184.38Z"
          fill="#F1F1F1"
        />
        <path
          d="M16.5758 199.323C16.6544 199.436 16.7361 199.548 16.8198 199.659H23.8702C23.8168 199.563 23.7549 199.451 23.6831 199.323C22.5184 197.216 19.0712 190.913 15.8713 184.38C12.4339 177.359 9.27765 170.071 9.54345 167.434C9.46109 168.028 7.08147 186.163 16.5758 199.323Z"
          fill="#F1F1F1"
        />
        <path
          d="M221.658 41.153C221.927 41.8202 222.339 42.4201 222.864 42.9105C223.389 43.4009 224.015 43.7698 224.698 43.9913C225.38 44.2129 226.103 44.2816 226.815 44.1926C227.527 44.1037 228.211 43.8592 228.819 43.4765L242.426 54.4218L243.268 45.3711L230.218 36.3649C229.509 35.3837 228.466 34.6974 227.286 34.436C226.107 34.1745 224.872 34.3561 223.817 34.9463C222.762 35.5365 221.959 36.4943 221.562 37.6382C221.164 38.7822 221.198 40.0328 221.658 41.153Z"
          fill="#9F616A"
        />
        <path
          d="M242.729 44.5211L237.651 40.9229L231.891 47.5969L238.591 51.5792L242.729 44.5211Z"
          fill="#3B86F2"
        />
        <path
          d="M241.617 42.08L258.732 48.6837L275.207 37.8654C276.91 36.7473 278.96 36.2888 280.975 36.5756C282.99 36.8623 284.832 37.8747 286.157 39.4237C287.482 40.9726 288.2 42.9523 288.177 44.9931C288.153 47.0339 287.389 48.9963 286.028 50.5139L285.881 50.678L260.542 64.302L232.863 51.6218L241.617 42.08Z"
          fill="#3F3D56"
        />
        <path
          d="M236.792 198.976H58.4561L64.9224 72.3545H92.83L118.564 90.4432H243.259L236.792 198.976Z"
          fill="#E5E5E5"
        />
        <path
          d="M193.137 160.363L90.0615 117.793C89.7011 117.644 89.4145 117.358 89.2646 116.997C89.1147 116.636 89.1136 116.23 89.2617 115.868L135.967 2.13728C136.116 1.77591 136.402 1.48852 136.762 1.33816C137.122 1.18779 137.526 1.18673 137.887 1.33521L240.963 43.9045C241.323 44.0539 241.61 44.3404 241.76 44.7013C241.91 45.0623 241.911 45.4681 241.763 45.8298L195.057 159.561C194.908 159.922 194.623 160.209 194.263 160.36C193.903 160.51 193.498 160.511 193.137 160.363Z"
          fill="white"
        />
        <path
          d="M193.137 160.363L90.0615 117.793C89.7011 117.644 89.4145 117.358 89.2646 116.997C89.1147 116.636 89.1136 116.23 89.2617 115.868L135.967 2.13728C136.116 1.77591 136.402 1.48852 136.762 1.33816C137.122 1.18779 137.526 1.18673 137.887 1.33521L240.963 43.9045C241.323 44.0539 241.61 44.3404 241.76 44.7013C241.91 45.0623 241.911 45.4681 241.763 45.8298L195.057 159.561C194.908 159.922 194.623 160.209 194.263 160.36C193.903 160.51 193.498 160.511 193.137 160.363ZM137.663 1.88068C137.447 1.79158 137.204 1.79221 136.988 1.88243C136.772 1.97265 136.601 2.14509 136.511 2.36193L89.8056 116.093C89.7167 116.31 89.7174 116.553 89.8073 116.77C89.8973 116.986 90.0693 117.158 90.2855 117.248L193.361 159.817C193.578 159.906 193.821 159.906 194.037 159.816C194.253 159.725 194.424 159.553 194.513 159.336L241.219 45.6052C241.308 45.3882 241.307 45.1446 241.217 44.9281C241.127 44.7115 240.955 44.5396 240.739 44.45L137.663 1.88068Z"
          fill="#3F3D56"
        />
        <path
          d="M166.775 57.6338L141.21 47.0757C140.85 46.9264 140.563 46.6398 140.413 46.2789C140.263 45.918 140.262 45.5121 140.41 45.1504L150.938 19.5133C151.087 19.1519 151.373 18.8645 151.733 18.7141C152.093 18.5638 152.498 18.5627 152.858 18.7112L178.423 29.2693C178.784 29.4186 179.07 29.7051 179.22 30.0661C179.37 30.427 179.371 30.8328 179.223 31.1946L168.695 56.8317C168.546 57.1931 168.26 57.4805 167.9 57.6309C167.54 57.7812 167.136 57.7823 166.775 57.6338ZM152.634 19.2567C152.418 19.1676 152.175 19.1682 151.959 19.2584C151.743 19.3486 151.572 19.5211 151.482 19.7379L140.954 45.3751C140.865 45.5921 140.866 45.8356 140.956 46.0522C141.046 46.2687 141.218 46.4407 141.434 46.5302L166.999 57.0883C167.215 57.1774 167.458 57.1768 167.674 57.0866C167.89 56.9964 168.062 56.8239 168.151 56.6071L178.679 30.9699C178.768 30.7529 178.767 30.5094 178.677 30.2928C178.588 30.0763 178.416 29.9043 178.199 29.8148L152.634 19.2567Z"
          fill="#F2F2F2"
        />
        <path
          d="M158.144 57.7377L132.579 47.1796C132.255 47.0453 131.997 46.7874 131.862 46.4625C131.727 46.1377 131.726 45.7724 131.859 45.4469L142.387 19.8097C142.521 19.4845 142.779 19.2258 143.103 19.0905C143.426 18.9551 143.791 18.9542 144.115 19.0878L169.68 29.6459C170.005 29.7803 170.263 30.0382 170.397 30.363C170.532 30.6879 170.533 31.0531 170.4 31.3787L159.872 57.0159C159.738 57.3411 159.481 57.5998 159.157 57.7351C158.833 57.8704 158.468 57.8714 158.144 57.7377Z"
          fill="#3B86F2"
        />
        <path
          d="M207.386 92.7476L127.427 59.7255C127.266 59.6591 127.12 59.5617 126.997 59.4387C126.874 59.3157 126.776 59.1695 126.709 59.0086C126.642 58.8477 126.608 58.6752 126.607 58.5009C126.607 58.3266 126.641 58.1539 126.707 57.9928C126.773 57.8316 126.871 57.6851 126.993 57.5616C127.116 57.4381 127.262 57.34 127.422 57.273C127.582 57.2059 127.754 57.1713 127.928 57.1709C128.102 57.1705 128.274 57.2045 128.435 57.2709L208.394 90.293C208.718 90.4271 208.976 90.6849 209.111 91.0099C209.246 91.3348 209.247 91.7003 209.113 92.0258C208.98 92.3513 208.723 92.6102 208.399 92.7456C208.075 92.8809 207.71 92.8817 207.386 92.7476Z"
          fill="#CCCCCC"
        />
        <path
          d="M184.604 93.227L123.955 68.1796C123.795 68.1132 123.648 68.0158 123.525 67.8928C123.402 67.7698 123.304 67.6236 123.238 67.4627C123.171 67.3018 123.136 67.1293 123.136 66.955C123.135 66.7807 123.169 66.608 123.235 66.4469C123.302 66.2857 123.399 66.1392 123.522 66.0157C123.644 65.8922 123.79 65.7941 123.95 65.7271C124.111 65.66 124.283 65.6254 124.457 65.625C124.63 65.6246 124.803 65.6586 124.963 65.725L185.612 90.7724C185.937 90.9065 186.195 91.1643 186.33 91.4893C186.465 91.8142 186.466 92.1796 186.332 92.5051C186.198 92.8306 185.941 93.0896 185.617 93.2249C185.293 93.3603 184.929 93.3611 184.604 93.227Z"
          fill="#CCCCCC"
        />
        <path
          d="M219.882 61.5429L184.527 46.9413C184.366 46.8749 184.22 46.7775 184.097 46.6545C183.973 46.5315 183.876 46.3854 183.809 46.2245C183.742 46.0636 183.707 45.891 183.707 45.7167C183.707 45.5424 183.741 45.3698 183.807 45.2086C183.873 45.0474 183.97 44.9009 184.093 44.7774C184.215 44.6539 184.361 44.5558 184.522 44.4888C184.682 44.4218 184.854 44.3871 185.028 44.3867C185.202 44.3864 185.374 44.4203 185.535 44.4867L220.89 59.0883C221.215 59.2224 221.473 59.4803 221.608 59.8052C221.743 60.1302 221.744 60.4956 221.61 60.8211C221.477 61.1466 221.219 61.4055 220.895 61.5409C220.571 61.6763 220.207 61.677 219.882 61.5429Z"
          fill="#CCCCCC"
        />
        <path
          d="M207.586 66.354L181.054 55.3964C180.729 55.2624 180.471 55.0045 180.336 54.6795C180.201 54.3546 180.2 53.9892 180.334 53.6637C180.468 53.3382 180.725 53.0792 181.049 52.9439C181.373 52.8085 181.737 52.8078 182.062 52.9418L208.594 63.8994C208.919 64.0334 209.177 64.2913 209.312 64.6162C209.447 64.9412 209.448 65.3066 209.314 65.6321C209.18 65.9576 208.923 66.2165 208.599 66.3519C208.275 66.4873 207.911 66.488 207.586 66.354Z"
          fill="#CCCCCC"
        />
        <path
          d="M200.441 109.657L120.483 76.6347C120.322 76.5683 120.176 76.4709 120.053 76.3478C119.93 76.2248 119.832 76.0787 119.765 75.9178C119.698 75.7569 119.663 75.5844 119.663 75.4101C119.663 75.2358 119.697 75.0631 119.763 74.902C119.829 74.7408 119.926 74.5943 120.049 74.4707C120.171 74.3472 120.317 74.2492 120.478 74.1822C120.638 74.1151 120.81 74.0804 120.984 74.0801C121.158 74.0797 121.33 74.1137 121.491 74.1801L201.449 107.202C201.774 107.336 202.032 107.594 202.167 107.919C202.302 108.244 202.303 108.609 202.169 108.935C202.035 109.26 201.778 109.519 201.454 109.655C201.13 109.79 200.766 109.791 200.441 109.657Z"
          fill="#CCCCCC"
        />
        <path
          d="M177.66 110.137L117.011 85.0898C116.85 85.0234 116.704 84.9259 116.581 84.8029C116.458 84.6799 116.36 84.5338 116.293 84.3729C116.226 84.212 116.192 84.0395 116.191 83.8652C116.191 83.6909 116.225 83.5182 116.291 83.357C116.357 83.1958 116.455 83.0493 116.577 82.9258C116.7 82.8023 116.846 82.7043 117.006 82.6372C117.166 82.5702 117.338 82.5355 117.512 82.5352C117.686 82.5348 117.858 82.5688 118.019 82.6352L178.668 107.683C178.829 107.749 178.975 107.846 179.098 107.969C179.221 108.092 179.319 108.239 179.386 108.399C179.452 108.56 179.487 108.733 179.487 108.907C179.488 109.081 179.454 109.254 179.388 109.415C179.321 109.576 179.224 109.723 179.102 109.846C178.979 109.97 178.833 110.068 178.673 110.135C178.512 110.202 178.34 110.237 178.167 110.237C177.993 110.238 177.821 110.204 177.66 110.137Z"
          fill="#CCCCCC"
        />
        <path
          d="M193.497 126.567L113.538 93.5448C113.214 93.4108 112.956 93.1529 112.821 92.828C112.686 92.503 112.685 92.1376 112.818 91.8121C112.952 91.4866 113.209 91.2277 113.533 91.0923C113.857 90.9569 114.222 90.9562 114.546 91.0902L194.505 124.112C194.83 124.246 195.088 124.504 195.223 124.829C195.358 125.154 195.358 125.52 195.225 125.845C195.091 126.171 194.834 126.43 194.51 126.565C194.186 126.7 193.821 126.701 193.497 126.567Z"
          fill="#CCCCCC"
        />
        <path
          d="M190.025 135.021L110.067 101.999C109.742 101.865 109.484 101.607 109.349 101.282C109.214 100.957 109.213 100.592 109.347 100.266C109.48 99.9407 109.738 99.6818 110.062 99.5464C110.386 99.411 110.75 99.4103 111.075 99.5443L191.033 132.566C191.194 132.633 191.34 132.73 191.463 132.853C191.586 132.976 191.684 133.122 191.751 133.283C191.818 133.444 191.852 133.617 191.853 133.791C191.853 133.965 191.819 134.138 191.753 134.299C191.687 134.46 191.59 134.607 191.467 134.73C191.344 134.854 191.199 134.952 191.038 135.019C190.878 135.086 190.706 135.121 190.532 135.121C190.358 135.121 190.186 135.087 190.025 135.021Z"
          fill="#CCCCCC"
        />
        <path
          d="M151.018 134.393C152.618 134.478 154.223 134.429 155.815 134.246C157.248 134.078 158.742 133.847 159.998 133.091C160.542 132.78 161.005 132.345 161.349 131.821C161.693 131.297 161.909 130.699 161.98 130.075C162.035 129.482 161.901 128.887 161.597 128.375C161.292 127.864 160.833 127.463 160.286 127.23C159.732 126.996 159.124 126.916 158.528 127C157.931 127.084 157.369 127.328 156.9 127.706C156.398 128.143 156.002 128.687 155.74 129.299C155.477 129.911 155.356 130.574 155.385 131.239C155.451 133.971 157.607 136.669 160 137.805C162.696 139.085 166.377 137.997 167.068 134.846C167.211 134.19 166.321 133.962 165.948 134.383C165.44 134.945 165.165 135.68 165.179 136.439C165.194 137.197 165.496 137.922 166.025 138.464C166.554 139.006 167.269 139.326 168.025 139.357C168.78 139.388 169.52 139.129 170.091 138.632L169.089 138.218C169.38 139.442 169.988 140.567 170.85 141.481C171.713 142.394 172.8 143.064 174.003 143.422C174.596 143.601 175.211 143.695 175.831 143.702C176.584 143.704 177.357 144.083 178.077 144.318L183.265 146.013C184.028 146.262 184.512 145.101 183.743 144.849L179.044 143.314C178.261 143.058 177.48 142.795 176.695 142.547C176.134 142.369 175.519 142.465 174.933 142.36C173.837 142.152 172.823 141.636 172.008 140.872C171.194 140.108 170.612 139.127 170.332 138.045C170.315 137.937 170.271 137.835 170.203 137.75C170.136 137.664 170.048 137.597 169.947 137.556C169.846 137.514 169.737 137.499 169.629 137.512C169.521 137.526 169.418 137.566 169.33 137.631C169.002 137.944 168.564 138.115 168.111 138.105C167.658 138.096 167.227 137.907 166.911 137.581C166.596 137.254 166.422 136.816 166.428 136.362C166.433 135.908 166.618 135.474 166.94 135.155L165.821 134.693C165.376 136.726 162.903 137.489 161.12 136.901C159.127 136.244 157.413 134.33 156.819 132.326C156.66 131.845 156.601 131.335 156.647 130.83C156.694 130.325 156.843 129.835 157.086 129.39C157.303 128.985 157.642 128.658 158.054 128.455C158.466 128.253 158.931 128.185 159.384 128.262C159.788 128.319 160.154 128.531 160.405 128.854C160.656 129.177 160.772 129.585 160.728 129.992C160.662 130.45 160.484 130.884 160.211 131.257C159.938 131.63 159.577 131.93 159.161 132.13C158.039 132.734 156.696 132.884 155.449 133.021C154.029 133.176 152.598 133.217 151.17 133.143C150.369 133.103 150.208 134.352 151.018 134.393Z"
          fill="#3B86F2"
        />
        <path
          d="M236.792 98.9764V198.976H58.4561V80.8877H86.3636L112.096 98.9764H236.792Z"
          fill="white"
        />
        <path
          d="M142.179 180.205H69.3467V186.007H142.179V180.205Z"
          fill="#3B86F2"
        />
        <path
          d="M105.763 168.942H69.3467V174.744H105.763V168.942Z"
          fill="#3B86F2"
        />
        <path
          d="M237.133 199.317H58.1162V80.5459H86.4715L112.206 98.6346H237.133V199.317ZM58.7969 198.635H236.452V99.3172H111.991L86.2567 81.2285H58.7969V198.635Z"
          fill="#3F3D56"
        />
        <path
          d="M309.415 187.248L303.38 189.41L292.19 167.098L301.097 163.906L309.415 187.248Z"
          fill="#9F616A"
        />
        <path
          d="M293.587 199.535L293.499 199.288C292.783 197.274 292.894 195.057 293.807 193.124C294.719 191.192 296.359 189.701 298.366 188.979L310.249 184.72L313.044 192.562L293.587 199.535Z"
          fill="#2F2E41"
        />
        <path
          d="M270.175 193.232H263.767L260.719 168.445L270.176 168.446L270.175 193.232Z"
          fill="#9F616A"
        />
        <path
          d="M271.809 199.463L251.146 199.462V199.2C251.147 198.141 251.355 197.092 251.759 196.113C252.163 195.135 252.755 194.246 253.502 193.497C254.249 192.748 255.136 192.154 256.111 191.749C257.087 191.343 258.133 191.135 259.189 191.135H259.19L271.809 191.135L271.809 199.463Z"
          fill="#2F2E41"
        />
        <path
          d="M284.78 34.8759L281.993 29.3535C281.993 29.3535 271.611 31.962 270.667 37.9961L284.78 34.8759Z"
          fill="#3B86F2"
        />
        <path
          d="M296.278 98.0198L288.699 140.432L308.823 176.122L296.801 180.839L276.416 146.244L273.803 136.809L272.234 186.081L261.392 185.751L256.421 139.742L264.394 96.9717L296.278 98.0198Z"
          fill="#2F2E41"
        />
        <path
          d="M294.711 78.8583L294.448 53.9875C294.448 43.4469 287.531 35.6779 286.572 34.9593C286.121 33.5152 285.311 32.5171 284.166 31.9947C281.86 30.9467 279.04 32.2043 278.921 32.2609L270.46 35.4417L270.421 35.5581C270.331 35.8243 261.794 63.9159 259.651 70.9662C259.346 71.9777 259.17 72.5566 259.17 72.5566C259.17 72.5566 259.203 74.1869 259.263 76.7222C259.452 85.4395 259.9 104.857 260.079 105.672C260.079 105.672 275.706 108.048 281.894 108.048C293.025 108.048 300.095 105.912 300.255 105.875L300.51 105.822L294.711 78.8583Z"
          fill="#3F3D56"
        />
        <path
          d="M278.823 26.2087C284.366 23.1701 286.403 16.2007 283.373 10.6421C280.343 5.08351 273.393 3.04063 267.85 6.07921C262.307 9.1178 260.27 16.0872 263.3 21.6458C266.33 27.2044 273.28 29.2473 278.823 26.2087Z"
          fill="#9F616A"
        />
        <path
          opacity="0.2"
          d="M274.604 73.5943L259.263 76.7219C259.203 74.1866 259.17 72.5562 259.17 72.5562C259.17 72.5562 259.346 71.9773 259.651 70.9658L274.604 73.5943Z"
          fill="black"
        />
        <path
          d="M229.172 70.3167C229.717 70.7851 230.357 71.1281 231.048 71.3214C231.74 71.5146 232.465 71.5536 233.173 71.4355C233.88 71.3174 234.554 71.0451 235.145 70.6377C235.737 70.2304 236.232 69.6979 236.596 69.0778L253.698 72.5229L250.296 64.0975L234.578 62.1177C233.498 61.5732 232.257 61.4447 231.09 61.7565C229.922 62.0683 228.91 62.7988 228.243 63.8094C227.577 64.8201 227.303 66.0407 227.475 67.24C227.646 68.4394 228.25 69.5341 229.172 70.3167Z"
          fill="#9F616A"
        />
        <path
          d="M249.428 63.5909L243.268 62.7373L241.214 71.3202L248.99 71.7667L249.428 63.5909Z"
          fill="#3B86F2"
        />
        <path
          d="M247.321 61.9368L265.547 59.9091L275.217 42.705C276.216 40.927 277.826 39.5745 279.747 38.8999C281.668 38.2254 283.768 38.275 285.655 39.0394C287.542 39.8038 289.087 41.2308 290.002 43.054C290.917 44.8772 291.138 46.9719 290.626 48.9471L290.57 49.1607L274.316 72.9436L243.923 74.4468L247.321 61.9368Z"
          fill="#3F3D56"
        />
        <path
          d="M283.079 26.1033L273.586 26.445C273.007 26.4659 271.437 20.2029 271.231 18.9037C271.068 18.0578 270.605 17.3002 269.926 16.7723C269.247 16.2445 268.4 15.9824 267.542 16.0351C266.832 16.1025 265.04 14.771 263.19 13.1945C259.68 10.2013 259.862 4.57978 263.719 2.05057C263.824 1.98145 263.928 1.91833 264.029 1.86122C266.462 0.495647 269.308 0.0370718 272.096 0.00210248C274.623 -0.0295972 277.222 0.289393 279.449 1.48897C283.44 3.63956 285.565 8.3392 285.751 12.8793C285.938 17.4195 284.486 21.8589 282.839 26.0921"
          fill="#2F2E41"
        />
        <path
          d="M323.66 200H0.340336C0.250073 200 0.163507 199.964 0.0996819 199.9C0.0358565 199.836 0 199.749 0 199.659C0 199.568 0.0358565 199.481 0.0996819 199.417C0.163507 199.353 0.250073 199.317 0.340336 199.317H323.66C323.75 199.317 323.837 199.353 323.9 199.417C323.964 199.481 324 199.568 324 199.659C324 199.749 323.964 199.836 323.9 199.9C323.837 199.964 323.75 200 323.66 200Z"
          fill="#CBCBCB"
        />
      </g>
      <defs>
        <clipPath id="clip0_3364_45802">
          <rect width="324" height="200" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
}
DocumetsNotificationNoDataIcon.propTypes = {
  Height: PropTypes.string,
  Width: PropTypes.string,
};
DocumetsNotificationNoDataIcon.defaultProps = {
  Height: '',
  Width: '',
};
// annimation
export function DownloadExcel() {
  return (
    <div className="animate-exel">
      <div className="page-cover">X</div>
      <div className="page">
        <Skeleton
          skHeight="0.347vw"
          skWidth="100%"
          skRadius="0.694vw"
          skMargin="0 0 0.347vw"
        />
        <Skeleton
          skHeight="0.347vw"
          skWidth="100%"
          skRadius="0.694vw"
          skMargin="0 0 0.347vw"
        />
        <Skeleton skHeight="0.347vw" skWidth="60%" skRadius="0.694vw" />
      </div>
    </div>
  );
}
export function DownloadZip() {
  return (
    <div className="animate-zip">
      <div className="page">
        {[1, 1, 1, 1, 1, 1, 1, 1].map(() => (
          <div className="col-zip">
            <Skeleton skHeight="0.347vw" skWidth="1%" skRadius="0.694vw" />
          </div>
        ))}
      </div>
    </div>
  );
}
export function BotIcon() {
  return (
    <svg
      width="2.153vw"
      height="2.083vw"
      viewBox="0 0 31 30"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M15.2769 29.5C23.3506 29.5 29.9034 23.0124 29.9034 15C29.9034 6.98764 23.3506 0.5 15.2769 0.5C7.20315 0.5 0.650391 6.98764 0.650391 15C0.650391 23.0124 7.20315 29.5 15.2769 29.5Z"
        fill="white"
        stroke="url(#paint0_linear_6436_47107)"
      />
      <path
        d="M6.19531 13.7694C6.36655 13.4113 6.35564 13.0141 6.44072 12.6367C7.20419 9.23955 10.2319 6.4759 13.6545 6.06576C18.0172 5.54395 22.0026 8.17232 23.1069 12.3613C23.89 15.3311 23.2508 18.0233 21.2663 20.3988C21.166 20.5599 20.9986 20.5266 20.8503 20.5277C20.2127 20.533 19.5758 20.5347 18.9383 20.5277C18.7022 20.5217 18.4691 20.5809 18.2653 20.6984C17.1348 21.3388 16.0076 21.9868 14.8646 22.6047C14.4011 22.8559 13.9332 23.1211 13.3922 23.2022C10.2216 22.5977 8.06801 20.7762 6.82518 17.8762C6.53288 17.1939 6.37473 16.4724 6.27111 15.7396C6.2613 15.6682 6.30056 15.5716 6.19531 15.5302V14.9231C6.24494 14.7442 6.24494 14.5555 6.19531 14.3766V13.7694Z"
        fill="url(#paint1_linear_6436_47107)"
      />
      <path
        d="M6.19531 14.3771C6.24411 14.4603 6.2698 14.5545 6.2698 14.6504C6.2698 14.7462 6.24411 14.8405 6.19531 14.9236V14.3771Z"
        fill="#597392"
      />
      <path
        d="M13.3936 23.2022C15.1354 22.4683 16.7201 21.4478 18.3682 20.5448C18.4914 20.4736 18.632 20.4365 18.775 20.4374C19.4839 20.4423 20.1929 20.4374 20.9018 20.4374C21.0245 20.4374 21.1488 20.4466 21.2661 20.3977C21.6309 20.4777 22.0001 20.4256 22.3671 20.4321C22.9528 20.4417 23.5391 20.4396 24.1248 20.4321C24.2938 20.4321 24.3593 20.4739 24.3576 20.6516C24.3494 21.5208 24.3451 22.3899 24.3576 23.2591C24.362 23.5328 24.1891 23.4786 24.0331 23.4776C21.3921 23.4555 18.7504 23.4239 16.1088 23.4142C15.1975 23.4104 14.289 23.4008 13.3936 23.2022Z"
        fill="#1A3F6A"
      />
      <path
        d="M19.8235 14.7045C19.7826 16.3445 19.1369 17.7586 17.7594 18.7995C15.8147 20.2699 13.1197 20.0793 11.3718 18.3765C9.32572 16.3827 9.27937 13.0387 11.2999 11.0218C12.6332 9.69149 14.2605 9.21048 16.0989 9.71404C17.9885 10.2315 19.1326 11.5216 19.6567 13.3597C19.7761 13.7806 19.8072 14.216 19.8235 14.7045Z"
        fill="white"
      />
      <defs>
        <linearGradient
          id="paint0_linear_6436_47107"
          x1="1.15039"
          y1="15"
          x2="29.4034"
          y2="15"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#1D4069" />
          <stop offset="1" stopColor="#266CBD" />
        </linearGradient>
        <linearGradient
          id="paint1_linear_6436_47107"
          x1="6.19531"
          y1="14.6011"
          x2="23.4319"
          y2="14.6011"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#1D4069" />
          <stop offset="1" stopColor="#266CBD" />
        </linearGradient>
      </defs>
    </svg>
  );
}

export function NotificationDowanloadIcon() {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M12 9.75C11.9 9.75 11.81 9.73 11.71 9.69C11.43 9.58 11.25 9.3 11.25 9V2C11.25 1.59 11.59 1.25 12 1.25C12.41 1.25 12.75 1.59 12.75 2V7.19L13.47 6.47C13.76 6.18 14.24 6.18 14.53 6.47C14.82 6.76 14.82 7.24 14.53 7.53L12.53 9.53C12.39 9.67 12.2 9.75 12 9.75Z"
        fill="#616B80"
      />
      <path
        d="M12.0004 9.74994C11.8104 9.74994 11.6204 9.67994 11.4704 9.52994L9.47043 7.52994C9.18043 7.23994 9.18043 6.75994 9.47043 6.46994C9.76043 6.17994 10.2404 6.17994 10.5304 6.46994L12.5304 8.46994C12.8204 8.75994 12.8204 9.23994 12.5304 9.52994C12.3804 9.67994 12.1904 9.74994 12.0004 9.74994Z"
        fill="#616B80"
      />
      <path
        d="M13.7605 17.75H10.2305C9.18047 17.75 8.24047 17.17 7.77047 16.23L6.60047 13.89C6.56047 13.8 6.47047 13.75 6.38047 13.75H1.98047C1.57047 13.75 1.23047 13.41 1.23047 13C1.23047 12.59 1.57047 12.25 1.98047 12.25H6.39047C7.06047 12.25 7.66047 12.62 7.96047 13.22L9.13047 15.56C9.34047 15.99 9.77047 16.25 10.2505 16.25H13.7805C14.2605 16.25 14.6905 15.99 14.9005 15.56L16.0705 13.22C16.3705 12.62 16.9705 12.25 17.6405 12.25H22.0005C22.4105 12.25 22.7505 12.59 22.7505 13C22.7505 13.41 22.4105 13.75 22.0005 13.75H17.6405C17.5405 13.75 17.4605 13.8 17.4205 13.89L16.2505 16.23C15.7505 17.17 14.8105 17.75 13.7605 17.75Z"
        fill="#616B80"
      />
      <path
        d="M15 22.7499H9C3.57 22.7499 1.25 20.4299 1.25 14.9999V10.9999C1.25 6.30993 2.99 3.95993 6.89 3.38993C7.31 3.32993 7.68 3.60993 7.74 4.01993C7.8 4.42993 7.52 4.80993 7.11 4.86993C3.97 5.32993 2.75 7.04993 2.75 10.9999V14.9999C2.75 19.6099 4.39 21.2499 9 21.2499H15C19.61 21.2499 21.25 19.6099 21.25 14.9999V10.9999C21.25 7.04993 20.03 5.32993 16.89 4.86993C16.48 4.80993 16.2 4.42993 16.26 4.01993C16.32 3.60993 16.7 3.32993 17.11 3.38993C21.01 3.95993 22.75 6.30993 22.75 10.9999V14.9999C22.75 20.4299 20.43 22.7499 15 22.7499Z"
        fill="#616B80"
      />
    </svg>
  );
}
export function GlobalSearch() {
  return (
    <svg
      width="42"
      height="43"
      viewBox="0 0 42 43"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M38.1325 37.2499L36.8725 35.9899C37.52 35.0099 37.905 33.8199 37.905 32.5599C37.905 29.0949 35.105 26.2949 31.64 26.2949C28.175 26.2949 25.375 29.0949 25.375 32.5599C25.375 36.0249 28.175 38.8249 31.64 38.8249C32.9175 38.8249 34.09 38.4399 35.07 37.7924L36.33 39.0524C36.575 39.2974 36.9075 39.4199 37.2225 39.4199C37.555 39.4199 37.87 39.2974 38.115 39.0524C38.6225 38.5449 38.6225 37.7399 38.1325 37.2499Z"
        fill="#7D7D7D"
      />
      <path
        d="M3.55249 26.5225C3.55249 26.575 3.51749 26.645 3.51749 26.6975C5.12749 29.9175 7.75249 32.56 10.9725 34.1525C11.025 34.1525 11.095 34.1175 11.1475 34.1175C10.5525 32.0875 10.0975 30.005 9.76499 27.9225C7.66499 27.5725 5.58249 27.1175 3.55249 26.5225Z"
        fill="#7D7D7D"
      />
      <path
        d="M33.3725 12.1724C31.7275 8.72494 28.945 5.94244 25.515 4.31494C26.145 6.39744 26.67 8.53244 27.02 10.6674C29.155 11.0174 31.29 11.5249 33.3725 12.1724Z"
        fill="#7D7D7D"
      />
      <path
        d="M3.3775 12.1726C5.4775 11.5426 7.6125 11.0176 9.7475 10.6676C10.0975 8.58508 10.535 6.52008 11.13 4.49008C11.0775 4.49008 11.0075 4.45508 10.955 4.45508C7.665 6.08258 4.9875 8.83008 3.3775 12.1726Z"
        fill="#7D7D7D"
      />
      <path
        d="M24.185 10.2999C23.765 8.02492 23.24 5.74992 22.4875 3.54492C22.4525 3.42242 22.4525 3.31742 22.435 3.17742C21.14 2.86242 19.775 2.66992 18.375 2.66992C16.9575 2.66992 15.61 2.86242 14.2975 3.19492C14.28 3.31742 14.2975 3.42242 14.2625 3.56242C13.5275 5.76742 12.985 8.02492 12.565 10.2999C16.4325 9.87992 20.3175 9.87992 24.185 10.2999Z"
        fill="#7D7D7D"
      />
      <path
        d="M9.38 13.4849C7.0875 13.9049 4.8475 14.4474 2.625 15.1824C2.5025 15.2174 2.3975 15.2174 2.275 15.2349C1.9425 16.5299 1.75 17.8949 1.75 19.2949C1.75 20.7124 1.9425 22.0599 2.275 23.3724C2.3975 23.3899 2.5025 23.3724 2.6425 23.4074C4.8475 24.1424 7.105 24.6849 9.3975 25.1049C8.96 21.2374 8.96 17.3524 9.38 13.4849Z"
        fill="#7D7D7D"
      />
      <path
        d="M34.475 15.2349C34.3525 15.2349 34.2475 15.2174 34.1075 15.1824C31.9025 14.4474 29.6275 13.9049 27.3525 13.4849C27.79 17.3524 27.79 21.2374 27.3525 25.0874C29.6275 24.6674 31.9025 24.1424 34.1075 23.3899C34.23 23.3549 34.335 23.3724 34.475 23.3549C34.79 22.0424 35 20.6949 35 19.2774C35 17.8949 34.8075 16.5474 34.475 15.2349Z"
        fill="#7D7D7D"
      />
      <path
        d="M12.565 28.29C12.985 30.5825 13.51 32.84 14.2625 35.045C14.2975 35.1675 14.28 35.2725 14.2975 35.4125C15.61 35.7275 16.9575 35.92 18.375 35.92C19.775 35.92 21.14 35.7275 22.435 35.395C22.4525 35.2725 22.4525 35.1675 22.4875 35.0275C23.2225 32.8225 23.765 30.565 24.185 28.2725C22.26 28.4825 20.3175 28.64 18.375 28.64C16.4325 28.64 14.49 28.5 12.565 28.29Z"
        fill="#7D7D7D"
      />
      <path
        d="M12.1625 13.0822C11.6375 17.2122 11.6375 21.3772 12.1625 25.5247C16.2925 26.0497 20.4575 26.0497 24.605 25.5247C25.13 21.3947 25.13 17.2297 24.605 13.0822C20.4575 12.5572 16.2925 12.5572 12.1625 13.0822Z"
        fill="#7D7D7D"
      />
    </svg>
  );
}
export function CalenderIcon({ color, size }) {
  return (
    <svg
      width={size !== '' ? size : '1.111vw'}
      height={size !== '' ? size : '1.111vw'}
      viewBox="0 0 16 17"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M5.33301 4.3335C5.05967 4.3335 4.83301 4.10683 4.83301 3.8335V1.8335C4.83301 1.56016 5.05967 1.3335 5.33301 1.3335C5.60634 1.3335 5.83301 1.56016 5.83301 1.8335V3.8335C5.83301 4.10683 5.60634 4.3335 5.33301 4.3335Z"
        fill={color !== '' ? color : '#3B86F2'}
      />
      <path
        d="M10.667 4.3335C10.3937 4.3335 10.167 4.10683 10.167 3.8335V1.8335C10.167 1.56016 10.3937 1.3335 10.667 1.3335C10.9403 1.3335 11.167 1.56016 11.167 1.8335V3.8335C11.167 4.10683 10.9403 4.3335 10.667 4.3335Z"
        fill={color !== '' ? color : '#3B86F2'}
      />
      <path
        d="M5.66667 10.1665C5.58 10.1665 5.49333 10.1466 5.41333 10.1132C5.32667 10.0799 5.26 10.0332 5.19333 9.97321C5.07333 9.84654 5 9.67988 5 9.49988C5 9.41322 5.02 9.32655 5.05333 9.24655C5.08667 9.16655 5.13333 9.09322 5.19333 9.02655C5.26 8.96655 5.32667 8.91987 5.41333 8.88654C5.65333 8.78654 5.95333 8.83989 6.14 9.02655C6.26 9.15322 6.33333 9.32655 6.33333 9.49988C6.33333 9.53988 6.32667 9.58656 6.32 9.63322C6.31333 9.67322 6.3 9.71322 6.28 9.75322C6.26667 9.79322 6.24667 9.83321 6.22 9.87321C6.2 9.90655 6.16667 9.93988 6.14 9.97321C6.01333 10.0932 5.84 10.1665 5.66667 10.1665Z"
        fill={color !== '' ? color : '#3B86F2'}
      />
      <path
        d="M7.99967 10.1666C7.91301 10.1666 7.82634 10.1466 7.74634 10.1133C7.65967 10.0799 7.59301 10.0332 7.52634 9.97324C7.40634 9.84658 7.33301 9.67992 7.33301 9.49992C7.33301 9.41325 7.35301 9.32658 7.38634 9.24658C7.41968 9.16658 7.46634 9.09325 7.52634 9.02659C7.59301 8.96659 7.65967 8.91991 7.74634 8.88657C7.98634 8.77991 8.28634 8.83992 8.47301 9.02659C8.59301 9.15325 8.66634 9.32658 8.66634 9.49992C8.66634 9.53992 8.65967 9.58659 8.65301 9.63326C8.64634 9.67326 8.63301 9.71325 8.61301 9.75325C8.59967 9.79325 8.57968 9.83325 8.55301 9.87325C8.53301 9.90658 8.49967 9.93991 8.47301 9.97324C8.34634 10.0932 8.17301 10.1666 7.99967 10.1666Z"
        fill={color !== '' ? color : '#3B86F2'}
      />
      <path
        d="M10.3337 10.1666C10.247 10.1666 10.1603 10.1466 10.0803 10.1133C9.99366 10.0799 9.92699 10.0332 9.86033 9.97324C9.83366 9.93991 9.80699 9.90658 9.78032 9.87325C9.75366 9.83325 9.73366 9.79325 9.72033 9.75325C9.70033 9.71325 9.68699 9.67326 9.68033 9.63326C9.67366 9.58659 9.66699 9.53992 9.66699 9.49992C9.66699 9.32658 9.74033 9.15325 9.86033 9.02659C9.92699 8.96659 9.99366 8.91991 10.0803 8.88657C10.327 8.77991 10.6203 8.83992 10.807 9.02659C10.927 9.15325 11.0003 9.32658 11.0003 9.49992C11.0003 9.53992 10.9937 9.58659 10.987 9.63326C10.9803 9.67326 10.967 9.71325 10.947 9.75325C10.9337 9.79325 10.9137 9.83325 10.887 9.87325C10.867 9.90658 10.8337 9.93991 10.807 9.97324C10.6803 10.0932 10.507 10.1666 10.3337 10.1666Z"
        fill={color !== '' ? color : '#3B86F2'}
      />
      <path
        d="M5.66667 12.4998C5.58 12.4998 5.49333 12.4798 5.41333 12.4465C5.33333 12.4131 5.26 12.3665 5.19333 12.3065C5.07333 12.1798 5 12.0065 5 11.8331C5 11.7465 5.02 11.6598 5.05333 11.5798C5.08667 11.4931 5.13333 11.4198 5.19333 11.3598C5.44 11.1131 5.89333 11.1131 6.14 11.3598C6.26 11.4865 6.33333 11.6598 6.33333 11.8331C6.33333 12.0065 6.26 12.1798 6.14 12.3065C6.01333 12.4265 5.84 12.4998 5.66667 12.4998Z"
        fill={color !== '' ? color : '#3B86F2'}
      />
      <path
        d="M7.99967 12.4998C7.82634 12.4998 7.65301 12.4265 7.52634 12.3065C7.40634 12.1798 7.33301 12.0065 7.33301 11.8331C7.33301 11.7465 7.35301 11.6598 7.38634 11.5798C7.41968 11.4931 7.46634 11.4198 7.52634 11.3598C7.77301 11.1131 8.22634 11.1131 8.47301 11.3598C8.53301 11.4198 8.57967 11.4931 8.61301 11.5798C8.64634 11.6598 8.66634 11.7465 8.66634 11.8331C8.66634 12.0065 8.59301 12.1798 8.47301 12.3065C8.34634 12.4265 8.17301 12.4998 7.99967 12.4998Z"
        fill={color !== '' ? color : '#3B86F2'}
      />
      <path
        d="M10.3337 12.4999C10.1603 12.4999 9.98699 12.4266 9.86033 12.3066C9.80033 12.2466 9.75366 12.1733 9.72033 12.0866C9.68699 12.0066 9.66699 11.9199 9.66699 11.8333C9.66699 11.7466 9.68699 11.6599 9.72033 11.5799C9.75366 11.4933 9.80033 11.4199 9.86033 11.3599C10.0137 11.2066 10.247 11.1333 10.4603 11.1799C10.507 11.1866 10.547 11.1999 10.587 11.2199C10.627 11.2333 10.667 11.2533 10.707 11.28C10.7403 11.3 10.7737 11.3333 10.807 11.3599C10.927 11.4866 11.0003 11.6599 11.0003 11.8333C11.0003 12.0066 10.927 12.1799 10.807 12.3066C10.6803 12.4266 10.507 12.4999 10.3337 12.4999Z"
        fill={color !== '' ? color : '#3B86F2'}
      />
      <path
        d="M13.6663 7.06006H2.33301C2.05967 7.06006 1.83301 6.83339 1.83301 6.56006C1.83301 6.28673 2.05967 6.06006 2.33301 6.06006H13.6663C13.9397 6.06006 14.1663 6.28673 14.1663 6.56006C14.1663 6.83339 13.9397 7.06006 13.6663 7.06006Z"
        fill={color !== '' ? color : '#3B86F2'}
      />
      <path
        d="M10.6667 15.6668H5.33333C2.9 15.6668 1.5 14.2668 1.5 11.8335V6.16683C1.5 3.7335 2.9 2.3335 5.33333 2.3335H10.6667C13.1 2.3335 14.5 3.7335 14.5 6.16683V11.8335C14.5 14.2668 13.1 15.6668 10.6667 15.6668ZM5.33333 3.3335C3.42667 3.3335 2.5 4.26016 2.5 6.16683V11.8335C2.5 13.7402 3.42667 14.6668 5.33333 14.6668H10.6667C12.5733 14.6668 13.5 13.7402 13.5 11.8335V6.16683C13.5 4.26016 12.5733 3.3335 10.6667 3.3335H5.33333Z"
        fill={color !== '' ? color : '#3B86F2'}
      />
    </svg>
  );
}
CalenderIcon.propTypes = {
  color: PropTypes.string,
  size: PropTypes.string,
};
CalenderIcon.defaultProps = {
  color: '',
  size: '',
};
export function EditCalenderIcon({ color }) {
  return (
    <svg
      width="1.25vw"
      height="1.25vw"
      viewBox="0 0 18 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M6 4.3125C5.6925 4.3125 5.4375 4.0575 5.4375 3.75V1.5C5.4375 1.1925 5.6925 0.9375 6 0.9375C6.3075 0.9375 6.5625 1.1925 6.5625 1.5V3.75C6.5625 4.0575 6.3075 4.3125 6 4.3125Z"
        fill={color !== '' ? color : '#3B86F2'}
      />
      <path
        d="M12 4.3125C11.6925 4.3125 11.4375 4.0575 11.4375 3.75V1.5C11.4375 1.1925 11.6925 0.9375 12 0.9375C12.3075 0.9375 12.5625 1.1925 12.5625 1.5V3.75C12.5625 4.0575 12.3075 4.3125 12 4.3125Z"
        fill={color !== '' ? color : '#3B86F2'}
      />
      <path
        d="M6.375 10.875C6.2775 10.875 6.18 10.8526 6.09 10.8151C5.9925 10.7776 5.91751 10.725 5.84251 10.6575C5.70751 10.515 5.625 10.32 5.625 10.125C5.625 9.93004 5.70751 9.73505 5.84251 9.59255C5.91751 9.52505 6 9.47253 6.09 9.43503C6.27 9.36003 6.48 9.36003 6.66 9.43503C6.75 9.47253 6.83249 9.52505 6.90749 9.59255C6.93749 9.63005 6.97499 9.66755 6.99749 9.70505C7.02749 9.75005 7.05001 9.79504 7.06501 9.84004C7.08751 9.88504 7.10251 9.93004 7.11001 9.97504C7.11751 10.0275 7.125 10.08 7.125 10.125C7.125 10.32 7.04249 10.515 6.90749 10.6575C6.83249 10.725 6.75 10.7776 6.66 10.8151C6.57 10.8526 6.4725 10.875 6.375 10.875Z"
        fill={color !== '' ? color : '#3B86F2'}
      />
      <path
        d="M9 10.875C8.9025 10.875 8.805 10.8525 8.715 10.815C8.6175 10.7775 8.54251 10.725 8.46751 10.6575C8.33251 10.515 8.25 10.32 8.25 10.125C8.25 10.08 8.25749 10.0275 8.26499 9.97501C8.27249 9.93001 8.28749 9.88501 8.30999 9.84001C8.32499 9.79501 8.34751 9.75002 8.37751 9.70502C8.40751 9.66752 8.43751 9.63002 8.46751 9.59252C8.74501 9.31502 9.24749 9.31502 9.53249 9.59252C9.56249 9.63002 9.59249 9.66752 9.62249 9.70502C9.65249 9.75002 9.67501 9.79501 9.69001 9.84001C9.71251 9.88501 9.72751 9.93001 9.73501 9.97501C9.74251 10.0275 9.75 10.08 9.75 10.125C9.75 10.32 9.66749 10.515 9.53249 10.6575C9.38999 10.7925 9.2025 10.875 9 10.875Z"
        fill={color !== '' ? color : '#3B86F2'}
      />
      <path
        d="M6.375 13.5C6.2775 13.5 6.18 13.4776 6.09 13.4401C6 13.4026 5.91751 13.35 5.84251 13.2825C5.70751 13.14 5.625 12.945 5.625 12.75C5.625 12.705 5.63249 12.6525 5.63999 12.6075C5.64749 12.555 5.66249 12.51 5.68499 12.465C5.69999 12.42 5.72251 12.375 5.75251 12.33C5.77501 12.2925 5.81251 12.2551 5.84251 12.2176C5.91751 12.1501 6 12.0975 6.09 12.06C6.27 11.985 6.48 11.985 6.66 12.06C6.75 12.0975 6.83249 12.1501 6.90749 12.2176C6.93749 12.2551 6.97499 12.2925 6.99749 12.33C7.02749 12.375 7.05001 12.42 7.06501 12.465C7.08751 12.51 7.10251 12.555 7.11001 12.6075C7.11751 12.6525 7.125 12.705 7.125 12.75C7.125 12.945 7.04249 13.14 6.90749 13.2825C6.83249 13.35 6.75 13.4026 6.66 13.4401C6.57 13.4776 6.4725 13.5 6.375 13.5Z"
        fill={color !== '' ? color : '#3B86F2'}
      />
      <path
        d="M15.375 7.38H2.625C2.3175 7.38 2.0625 7.125 2.0625 6.8175C2.0625 6.51 2.3175 6.255 2.625 6.255H15.375C15.6825 6.255 15.9375 6.51 15.9375 6.8175C15.9375 7.125 15.6825 7.38 15.375 7.38Z"
        fill={color !== '' ? color : '#3B86F2'}
      />
      <path
        d="M11.8647 17.085C11.5797 17.085 11.3097 16.98 11.1147 16.785C10.8822 16.5525 10.7772 16.215 10.8297 15.8625L10.9722 14.8499C11.0097 14.5874 11.1672 14.2725 11.3547 14.085L14.0097 11.43C14.3697 11.07 14.7222 10.8825 15.1047 10.845C15.5772 10.8 16.0347 10.995 16.4697 11.43C16.9272 11.8875 17.5422 12.8174 16.4697 13.8899L13.8147 16.545C13.6272 16.7325 13.3122 16.89 13.0497 16.9275L12.0372 17.07C11.9772 17.0775 11.9247 17.085 11.8647 17.085ZM15.2322 11.9625C15.2247 11.9625 15.2172 11.9625 15.2097 11.9625C15.1047 11.97 14.9622 12.0674 14.8047 12.2249L12.1497 14.88C12.1272 14.9025 12.0897 14.9775 12.0897 15.0075L11.9547 15.945L12.8922 15.8099C12.9222 15.8024 12.9972 15.765 13.0197 15.7425L15.6747 13.0875C16.0047 12.7575 16.0497 12.5925 15.6747 12.2175C15.5547 12.105 15.3822 11.9625 15.2322 11.9625Z"
        fill={color !== '' ? color : '#3B86F2'}
      />
      <path
        d="M15.6904 14.4374C15.6379 14.4374 15.5854 14.4299 15.5404 14.4149C14.5504 14.1374 13.7629 13.35 13.4854 12.36C13.4029 12.06 13.5754 11.7524 13.8754 11.6624C14.1754 11.5799 14.4829 11.7525 14.5729 12.0525C14.7454 12.6675 15.2329 13.1549 15.8479 13.3274C16.1479 13.4099 16.3204 13.725 16.2379 14.025C16.1629 14.2725 15.9379 14.4374 15.6904 14.4374Z"
        fill={color !== '' ? color : '#3B86F2'}
      />
      <path
        d="M9 17.0625H6C3.2625 17.0625 1.6875 15.4875 1.6875 12.75V6.375C1.6875 3.6375 3.2625 2.0625 6 2.0625H12C14.7375 2.0625 16.3125 3.6375 16.3125 6.375V9C16.3125 9.3075 16.0575 9.5625 15.75 9.5625C15.4425 9.5625 15.1875 9.3075 15.1875 9V6.375C15.1875 4.23 14.145 3.1875 12 3.1875H6C3.855 3.1875 2.8125 4.23 2.8125 6.375V12.75C2.8125 14.895 3.855 15.9375 6 15.9375H9C9.3075 15.9375 9.5625 16.1925 9.5625 16.5C9.5625 16.8075 9.3075 17.0625 9 17.0625Z"
        fill={color !== '' ? color : '#3B86F2'}
      />
    </svg>
  );
}
EditCalenderIcon.propTypes = {
  color: PropTypes.string,
};
EditCalenderIcon.defaultProps = {
  color: '',
};
export function ArrowCircleDownIcon() {
  return (
    <svg
      width="1.111vw"
      height="1.111vw"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M0.733008 8.00016C0.733008 12.0087 3.99111 15.2668 7.99967 15.2668C12.0082 15.2668 15.2663 12.0087 15.2663 8.00016C15.2663 3.9916 12.0082 0.733496 7.99967 0.733496C3.99111 0.733496 0.733008 3.9916 0.733008 8.00016ZM1.93301 8.00016C1.93301 4.65539 4.6549 1.9335 7.99967 1.9335C11.3444 1.9335 14.0663 4.65539 14.0663 8.00016C14.0663 11.3449 11.3444 14.0668 7.99967 14.0668C4.6549 14.0668 1.93301 11.3449 1.93301 8.00016Z"
        fill="url(#paint0_linear_2591_3732)"
        stroke="url(#paint1_linear_2591_3732)"
        strokeWidth="0.2"
      />
      <path
        d="M7.61142 9.89514C7.72129 10.005 7.86089 10.0565 8.0001 10.0565C8.13932 10.0565 8.27892 10.005 8.38879 9.89514L10.7421 7.54181C10.955 7.32895 10.955 6.97729 10.7421 6.76443C10.5293 6.55157 10.1776 6.55157 9.96475 6.76443L8.0001 8.72907L6.03546 6.76443C5.8226 6.55157 5.47094 6.55157 5.25808 6.76443C5.04522 6.97729 5.04522 7.32895 5.25808 7.54181L7.61142 9.89514Z"
        fill="url(#paint2_linear_2591_3732)"
        stroke="url(#paint3_linear_2591_3732)"
        strokeWidth="0.1"
      />
      <defs>
        <linearGradient
          id="paint0_linear_2591_3732"
          x1="0.833008"
          y1="8.00016"
          x2="15.1663"
          y2="8.00016"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#1987D8" />
          <stop offset="1" stopColor="#45B4D0" />
        </linearGradient>
        <linearGradient
          id="paint1_linear_2591_3732"
          x1="0.833008"
          y1="8.00016"
          x2="15.1663"
          y2="8.00016"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#1987D8" />
          <stop offset="1" stopColor="#45B4D0" />
        </linearGradient>
        <linearGradient
          id="paint2_linear_2591_3732"
          x1="5.14844"
          y1="8.33062"
          x2="10.8518"
          y2="8.33062"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#1987D8" />
          <stop offset="1" stopColor="#45B4D0" />
        </linearGradient>
        <linearGradient
          id="paint3_linear_2591_3732"
          x1="5.14844"
          y1="8.33062"
          x2="10.8518"
          y2="8.33062"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#1987D8" />
          <stop offset="1" stopColor="#45B4D0" />
        </linearGradient>
      </defs>
    </svg>
  );
}
// Dashboard
export function DashboardPending() {
  return (
    <svg
      width="32"
      height="36"
      viewBox="0 0 32 36"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M23.7818 13.0656C28.561 20.0407 23.0321 28.519 15.7775 28.2832C8.73459 28.519 3.22444 20.1475 7.83561 13.1749C0.054724 16.1503 -3.19384 25.2746 4.01195 31.0758C3.55544 32.6136 2.84202 33.8683 2.42519 34.5231C2.28764 34.7392 2.455 35.0149 2.71102 35.0062C5.50109 34.9112 6.96668 34.1728 7.73201 33.338C25.1342 40.8902 42.8128 22.1666 23.7818 13.0656Z"
        fill="#FFA602"
      />
      <path
        d="M7.0439 21.0788C10.0867 31.1739 24.7519 29.2736 24.9687 18.5895C25.021 13.9634 21.5517 10.4862 17.5104 9.67285C17.6078 9.27521 17.2949 8.54794 17.7829 8.39328C22.8094 5.10187 17.4261 -1.89886 12.9562 2.11669C10.786 4.34459 11.9026 7.43709 14.0895 8.53484C14.0898 8.84504 14.0903 9.28203 14.0919 9.64241C9.05271 10.487 5.54402 16.1443 7.0439 21.0788ZM15.8716 26.0421C15.1287 26.0364 15.1157 24.9098 15.864 24.9C16.611 24.8975 16.613 26.0352 15.8716 26.0421ZM22.6882 18.0283C23.4355 18.0293 23.4313 19.1618 22.6878 19.1685C21.9442 19.1663 21.941 18.03 22.6882 18.0283ZM20.7941 14.4434C20.7941 14.4433 18.7356 16.5175 17.3888 17.8746C18.436 20.4516 14.3196 21.4112 14.1306 18.6294C14.1623 17.1639 15.5652 16.651 16.5655 17.0844C17.912 15.7277 19.984 13.6398 19.984 13.6398C20.5101 13.1151 21.3185 13.9096 20.7941 14.4434ZM15.8198 12.6355C14.6991 12.6129 14.681 10.9518 15.8097 10.9225C16.9481 10.9383 16.9354 12.6107 15.8198 12.6355ZM14.3675 2.45639C17.6466 0.640601 20.4381 5.48667 17.213 7.38921C16.5189 6.34049 15.0111 6.48532 14.3792 7.40039C12.7881 6.42514 12.1218 3.91648 14.3675 2.45639ZM8.99296 18.076C9.73959 18.0808 9.74029 19.2128 8.99996 19.2181C8.24709 19.2184 8.24967 18.0835 8.99296 18.076Z"
        fill="#FFA602"
      />
    </svg>
  );
}
export function DashboardAcBooking() {
  return (
    <svg
      width="32"
      height="28"
      viewBox="0 0 32 28"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M15.2249 3.85248H8.49988C8.29488 3.85248 8.12988 4.01748 8.12988 4.21748V10.1325C8.12988 10.3325 8.29488 10.4975 8.49988 10.4975H15.2249C15.4249 10.4975 15.5899 10.3325 15.5899 10.1325V4.21748C15.5899 4.01748 15.4249 3.85248 15.2249 3.85248ZM11.3599 4.58248H12.4199V5.11248L12.1099 4.87748C11.9799 4.77748 11.7999 4.77748 11.6649 4.87748L11.3599 5.11248V4.58248ZM14.8549 9.76248H8.86488V4.58248H10.6249V5.85248C10.6249 5.99248 10.7049 6.11748 10.8299 6.18248C10.9549 6.24248 11.1049 6.22748 11.2149 6.14248L11.8899 5.62748L12.5649 6.14248C12.6299 6.19248 12.7049 6.21748 12.7849 6.21748C12.8399 6.21748 12.8949 6.20748 12.9499 6.18248C13.0749 6.11748 13.1499 5.99248 13.1499 5.85248V4.58248H14.8549V9.76248Z"
        fill="white"
      />
      <path
        d="M12.4201 4.58246V5.11246L12.1101 4.87746C11.9801 4.77746 11.8001 4.77746 11.6651 4.87746L11.3601 5.11246V4.58246H12.4201Z"
        fill="#14B8A6"
      />
      <path
        d="M14.855 4.58246V9.76246H8.86499V4.58246H10.625V5.85246C10.625 5.99246 10.705 6.11746 10.83 6.18246C10.955 6.24246 11.105 6.22746 11.215 6.14246L11.89 5.62746L12.565 6.14246C12.63 6.19246 12.705 6.21746 12.785 6.21746C12.84 6.21746 12.895 6.20746 12.95 6.18246C13.075 6.11746 13.15 5.99246 13.15 5.85246V4.58246H14.855Z"
        fill="#14B8A6"
      />
      <path
        d="M30.615 20.3525V18.7225C30.615 18.6075 30.605 18.4925 30.59 18.3925C30.49 17.3525 29.88 16.4425 28.975 15.9525C28.69 15.7875 28.38 15.6725 28.045 15.6125C28.04 15.5825 28.03 15.5425 28.02 15.4975C28.02 15.4825 28.01 15.4525 28.005 15.4375C28.005 15.4225 28 15.4075 28 15.3925C27.99 15.3475 27.985 15.2975 27.975 15.2825C27.775 14.3175 27.405 12.9675 26.77 11.9925C26.225 11.1575 25.585 10.7325 24.87 10.7325H20.105C19.9 10.7325 19.74 10.8975 19.74 11.1025V14.5475H19.525V11.1075C19.525 10.9075 19.36 10.7425 19.16 10.7425H16.81C16.8 10.7425 16.79 10.7375 16.78 10.7375C16.77 10.7375 16.76 10.7425 16.75 10.7425H15.015C15.005 10.7425 14.995 10.7375 14.985 10.7375C14.975 10.7375 14.965 10.7425 14.96 10.7425H12.435C12.23 10.7425 12.065 10.9075 12.065 11.1075V14.5475H11.655V11.1075C11.655 10.9075 11.49 10.7425 11.285 10.7425H8.85C8.84 10.7425 8.83 10.7375 8.82 10.7375C8.81 10.7375 8.805 10.7425 8.795 10.7425H7.055C7.045 10.7425 7.035 10.7375 7.025 10.7375C7.015 10.7375 7.01 10.7425 7 10.7425H4.56C4.36 10.7425 4.195 10.9075 4.195 11.1075V14.5475H1.44C1.24 14.5475 1.075 14.7075 1.075 14.9125V20.3925C0.46 20.5425 0 21.1025 0 21.7925C0 22.5675 0.63 23.2025 1.41 23.2025H2.365C2.355 23.3175 2.345 23.4325 2.345 23.5475C2.345 25.4575 3.895 27.0125 5.805 27.0125C7.715 27.0125 9.27 25.4575 9.27 23.5475C9.27 23.4325 9.26 23.3175 9.245 23.2025H9.63C9.62 23.3175 9.61 23.4325 9.61 23.5525C9.61 25.4575 11.165 27.0125 13.075 27.0125C14.985 27.0125 16.535 25.4575 16.535 23.5525C16.535 23.4325 16.53 23.3175 16.52 23.2025H21.73C21.72 23.3175 21.715 23.4325 21.715 23.5525C21.715 25.4575 23.265 27.0125 25.175 27.0125C27.085 27.0125 28.64 25.4575 28.64 23.5525C28.64 23.4325 28.63 23.3175 28.62 23.2025H30.595C31.37 23.2025 32 22.5675 32 21.7625C32 20.9875 31.38 20.3625 30.615 20.3525ZM29.16 16.9975C29.455 17.2875 29.67 17.6525 29.78 18.0625H29.16V16.9975ZM27.255 15.4175C27.26 15.4225 27.255 15.4275 27.255 15.4375C27.265 15.4725 27.275 15.5075 27.28 15.5425C27.285 15.5525 27.285 15.5525 27.285 15.5625C27.1 15.5575 26.885 15.5525 26.715 15.5525H22.51C22.155 15.5525 21.87 15.2675 21.87 14.9175V13.1975C21.87 12.8425 22.155 12.5575 22.51 12.5575H26.25C26.785 13.4625 27.105 14.6925 27.255 15.4175ZM15.35 11.4725H16.415V11.9975L16.105 11.7625C15.975 11.6625 15.795 11.6625 15.66 11.7625L15.35 11.9975V11.4725ZM12.8 14.9125V11.4725H14.62V12.7375C14.62 12.8775 14.7 13.0025 14.825 13.0625C14.95 13.1275 15.095 13.1125 15.21 13.0275L15.885 12.5125L16.56 13.0275C16.625 13.0775 16.7 13.1025 16.78 13.1025C16.835 13.1025 16.89 13.0925 16.945 13.0625C17.065 13.0025 17.145 12.8775 17.145 12.7375V11.4725H18.79V14.9025C18.79 14.9075 18.79 14.9075 18.79 14.9125C18.79 14.9175 18.79 14.9175 18.79 14.9225V16.6525H12.8V14.9125ZM7.395 11.4725H8.455V11.9975L8.145 11.7625C8.015 11.6625 7.835 11.6625 7.7 11.7625L7.395 11.9975V11.4725ZM4.93 14.9125C4.93 14.9075 4.93 14.9075 4.93 14.9025V11.4725H6.66V12.7375C6.66 12.8775 6.74 13.0025 6.865 13.0625C6.99 13.1275 7.14 13.1125 7.25 13.0275L7.925 12.5125L8.6 13.0275C8.665 13.0775 8.745 13.1025 8.82 13.1025C8.875 13.1025 8.935 13.0925 8.985 13.0625C9.11 13.0025 9.19 12.8775 9.19 12.7375V11.4725H10.92V16.6525H4.93V14.9125ZM1.81 15.2775H4.195V17.0225C4.195 17.2225 4.36 17.3875 4.56 17.3875H11.285C11.49 17.3875 11.655 17.2225 11.655 17.0225V15.2775H12.065V17.0225C12.065 17.2225 12.23 17.3875 12.435 17.3875H19.16C19.36 17.3875 19.525 17.2225 19.525 17.0225V15.2775H19.74V20.3475H14.39C13.98 20.1825 13.54 20.0875 13.075 20.0875C12.61 20.0875 12.165 20.1825 11.76 20.3475H7.105C6.27 20.0075 5.335 20.0125 4.505 20.3475H1.81V15.2775ZM1.41 22.4675C1.035 22.4675 0.735 22.1675 0.735 21.7625C0.735 21.3875 1.035 21.0825 1.44 21.0825H3.385C2.99 21.4675 2.695 21.9425 2.525 22.4675H1.41ZM5.805 26.2825C4.3 26.2825 3.08 25.0575 3.08 23.5475C3.08 23.3375 3.105 23.1275 3.16 22.9175C3.345 22.0875 3.93 21.3925 4.715 21.0525C5.065 20.8975 5.43 20.8225 5.805 20.8225C6.18 20.8225 6.545 20.8975 6.895 21.0525C6.895 21.0525 6.895 21.0525 6.9 21.0525C7.685 21.3925 8.265 22.0925 8.455 22.9175C8.46 22.9225 8.46 22.9225 8.46 22.9275C8.51 23.1275 8.535 23.3325 8.535 23.5475C8.535 25.0575 7.31 26.2825 5.805 26.2825ZM9.085 22.4675C8.915 21.9425 8.62 21.4675 8.23 21.0825H10.65C10.26 21.4675 9.96 21.9375 9.785 22.4675H9.085ZM13.075 26.2775C11.57 26.2775 10.345 25.0575 10.345 23.5525C10.345 22.4375 11.015 21.4775 11.97 21.0575C11.98 21.0525 11.985 21.0475 11.995 21.0425C12.325 20.9025 12.69 20.8225 13.075 20.8225C13.46 20.8225 13.825 20.9025 14.16 21.0475C14.165 21.0525 14.17 21.0525 14.175 21.0525C15.13 21.4775 15.805 22.4375 15.805 23.5525C15.805 25.0575 14.58 26.2775 13.075 26.2775ZM21.89 22.4675H16.36C16.185 21.9375 15.885 21.4675 15.495 21.0825H19.74V21.8675C19.74 22.0725 19.9 22.2375 20.105 22.2375H21.975C21.945 22.3125 21.915 22.3925 21.89 22.4675ZM25.175 26.2775C23.67 26.2775 22.445 25.0575 22.445 23.5525C22.445 22.0475 23.67 20.8225 25.175 20.8225C26.68 20.8225 27.905 22.0475 27.905 23.5525C27.905 25.0575 26.68 26.2775 25.175 26.2775ZM25.175 20.0875C24.035 20.0875 23.02 20.6475 22.39 21.5025H20.47V11.4675H24.87C25.15 11.4675 25.425 11.5875 25.685 11.8225H22.51C21.75 11.8225 21.135 12.4375 21.135 13.1975V14.9175C21.135 15.6725 21.75 16.2875 22.51 16.2875H26.715C27.065 16.2875 27.59 16.2975 27.7 16.3025C27.96 16.3275 28.2 16.4075 28.43 16.5075V18.4325C28.43 18.6325 28.595 18.7975 28.795 18.7975H29.88V21.3575C29.88 21.4375 29.815 21.5025 29.735 21.5025H27.96C27.33 20.6475 26.32 20.0875 25.175 20.0875ZM30.595 22.4675H28.465C28.435 22.3925 28.41 22.3125 28.375 22.2375H29.735C30.22 22.2375 30.615 21.8425 30.615 21.3575V21.0825C30.975 21.0925 31.27 21.3925 31.27 21.7925C31.27 22.1675 30.965 22.4675 30.595 22.4675Z"
        fill="white"
      />
      <path
        d="M3.38511 21.0825C2.99011 21.4675 2.69511 21.9425 2.52511 22.4675H1.41011C1.03511 22.4675 0.735107 22.1675 0.735107 21.7625C0.735107 21.3875 1.03511 21.0825 1.44011 21.0825H3.38511ZM10.6501 21.0825C10.2601 21.4675 9.96011 21.9375 9.78511 22.4675H9.08511C8.91511 21.9425 8.62011 21.4675 8.23011 21.0825H10.6501ZM31.2701 21.7925C31.2701 22.1675 30.9651 22.4675 30.5951 22.4675H28.4651C28.4351 22.3925 28.4101 22.3125 28.3751 22.2375H29.7351C30.2201 22.2375 30.6151 21.8425 30.6151 21.3575V21.0825C30.9751 21.0925 31.2701 21.3925 31.2701 21.7925ZM21.9751 22.2375C21.9451 22.3125 21.9151 22.3925 21.8901 22.4675H16.3601C16.1851 21.9375 15.8851 21.4675 15.4951 21.0825H19.7401V21.8675C19.7401 22.0725 19.9001 22.2375 20.1051 22.2375H21.9751Z"
        fill="#14B8A6"
      />
      <path
        d="M29.7799 18.0625H29.1599V16.9975C29.4549 17.2875 29.6699 17.6525 29.7799 18.0625Z"
        fill="#14B8A6"
      />
      <path
        d="M8.46008 22.9275C8.46008 22.9225 8.46008 22.9225 8.45508 22.9175C8.26508 22.0925 7.68508 21.3925 6.90008 21.0525C6.89508 21.0525 6.89508 21.0525 6.89508 21.0525C6.54508 20.8975 6.18008 20.8225 5.80508 20.8225C5.43008 20.8225 5.06508 20.8975 4.71508 21.0525C3.93008 21.3925 3.34508 22.0875 3.16008 22.9175C3.10508 23.1275 3.08008 23.3375 3.08008 23.5475C3.08008 25.0575 4.30008 26.2825 5.80508 26.2825C7.31008 26.2825 8.53508 25.0575 8.53508 23.5475C8.53508 23.3325 8.51008 23.1275 8.46008 22.9275ZM5.80508 25.8625C4.53008 25.8625 3.49508 24.8225 3.49508 23.5475C3.49508 23.2575 3.55008 22.9725 3.65508 22.7025C4.00508 21.8125 4.85008 21.2375 5.80508 21.2375C6.75008 21.2375 7.61508 21.8275 7.96008 22.7025C8.06508 22.9725 8.12008 23.2575 8.12008 23.5475C8.12008 24.8225 7.08008 25.8625 5.80508 25.8625ZM14.1751 21.0525C14.1701 21.0525 14.1651 21.0525 14.1601 21.0475C13.8251 20.9025 13.4601 20.8225 13.0751 20.8225C12.6901 20.8225 12.3251 20.9025 11.9951 21.0425C11.9851 21.0475 11.9801 21.0525 11.9701 21.0575C11.0151 21.4775 10.3451 22.4375 10.3451 23.5525C10.3451 25.0575 11.5701 26.2775 13.0751 26.2775C14.5801 26.2775 15.8051 25.0575 15.8051 23.5525C15.8051 22.4375 15.1301 21.4775 14.1751 21.0525ZM13.0751 25.8625C11.8001 25.8625 10.7601 24.8275 10.7601 23.5525C10.7601 22.2775 11.8001 21.2375 13.0751 21.2375C14.3501 21.2375 15.3851 22.2775 15.3851 23.5525C15.3851 24.8275 14.3501 25.8625 13.0751 25.8625ZM25.1751 20.8225C23.6701 20.8225 22.4451 22.0475 22.4451 23.5525C22.4451 25.0575 23.6701 26.2775 25.1751 26.2775C26.6801 26.2775 27.9051 25.0575 27.9051 23.5525C27.9051 22.0475 26.6801 20.8225 25.1751 20.8225ZM25.1751 25.8625C23.9001 25.8625 22.8651 24.8275 22.8651 23.5525C22.8651 22.2775 23.9001 21.2375 25.1751 21.2375C26.4501 21.2375 27.4901 22.2775 27.4901 23.5525C27.4901 24.8275 26.4501 25.8625 25.1751 25.8625Z"
        fill="#14B8A6"
      />
      <path
        d="M19.7401 15.2775V20.3475H14.3901C13.9801 20.1825 13.5401 20.0875 13.0751 20.0875C12.6101 20.0875 12.1651 20.1825 11.7601 20.3475H7.10506C6.27006 20.0075 5.33506 20.0125 4.50506 20.3475H1.81006V15.2775H4.19506V17.0225C4.19506 17.2225 4.36006 17.3875 4.56006 17.3875H11.2851C11.4901 17.3875 11.6551 17.2225 11.6551 17.0225V15.2775H12.0651V17.0225C12.0651 17.2225 12.2301 17.3875 12.4351 17.3875H19.1601C19.3601 17.3875 19.5251 17.2225 19.5251 17.0225V15.2775H19.7401Z"
        fill="#14B8A6"
      />
      <path
        d="M28.795 18.7975C28.595 18.7975 28.43 18.6325 28.43 18.4325V16.5075C28.2 16.4075 27.96 16.3275 27.7 16.3025C27.59 16.2975 27.065 16.2875 26.715 16.2875H22.51C21.75 16.2875 21.135 15.6725 21.135 14.9175V13.1975C21.135 12.4375 21.75 11.8225 22.51 11.8225H25.685C25.425 11.5875 25.15 11.4675 24.87 11.4675H20.47V21.5025H22.39C23.02 20.6475 24.035 20.0875 25.175 20.0875C26.32 20.0875 27.33 20.6475 27.96 21.5025H29.735C29.815 21.5025 29.88 21.4375 29.88 21.3575V18.7975H28.795ZM24.405 17.5525H22.43C22.225 17.5525 22.06 17.3925 22.06 17.1875C22.06 16.9875 22.225 16.8225 22.43 16.8225H24.405C24.61 16.8225 24.77 16.9875 24.77 17.1875C24.77 17.3925 24.61 17.5525 24.405 17.5525Z"
        fill="#14B8A6"
      />
      <path
        d="M27.2849 15.5625C27.0999 15.5575 26.8849 15.5525 26.7149 15.5525H22.5099C22.1549 15.5525 21.8699 15.2675 21.8699 14.9175V13.1975C21.8699 12.8425 22.1549 12.5575 22.5099 12.5575H26.2499C26.7849 13.4625 27.1049 14.6925 27.2549 15.4175C27.2599 15.4225 27.2549 15.4275 27.2549 15.4375C27.2649 15.4725 27.2749 15.5075 27.2799 15.5425C27.2849 15.5525 27.2849 15.5525 27.2849 15.5625Z"
        fill="#14B8A6"
      />
      <path
        d="M8.45502 11.4725V11.9975L8.14502 11.7625C8.01502 11.6625 7.83502 11.6625 7.70002 11.7625L7.39502 11.9975V11.4725H8.45502ZM16.415 11.4725V11.9975L16.105 11.7625C15.975 11.6625 15.795 11.6625 15.66 11.7625L15.35 11.9975V11.4725H16.415Z"
        fill="#14B8A6"
      />
      <path
        d="M18.7899 11.4725V14.9025C18.7899 14.9075 18.7899 14.9075 18.7899 14.9125C18.7899 14.9175 18.7899 14.9175 18.7899 14.9225V16.6525H12.7999V14.9125C12.7999 14.9125 12.7999 14.9125 12.7999 14.9075V11.4725H14.6199V12.7375C14.6199 12.8775 14.6999 13.0025 14.8249 13.0625C14.9499 13.1275 15.0949 13.1125 15.2099 13.0275L15.8849 12.5125L16.5599 13.0275C16.6249 13.0775 16.6999 13.1025 16.7799 13.1025C16.8349 13.1025 16.8899 13.0925 16.9449 13.0625C17.0649 13.0025 17.1449 12.8775 17.1449 12.7375V11.4725H18.7899ZM10.9199 11.4725V16.6525H4.92993V14.9125C4.92993 14.9075 4.92993 14.9075 4.92993 14.9025V11.4725H6.65993V12.7375C6.65993 12.8775 6.73993 13.0025 6.86493 13.0625C6.98993 13.1275 7.13993 13.1125 7.24993 13.0275L7.92493 12.5125L8.59993 13.0275C8.66493 13.0775 8.74493 13.1025 8.81993 13.1025C8.87493 13.1025 8.93493 13.0925 8.98493 13.0625C9.10993 13.0025 9.18993 12.8775 9.18993 12.7375V11.4725H10.9199Z"
        fill="#14B8A6"
      />
      <path
        d="M7.96012 22.7025C7.61512 21.8275 6.75012 21.2375 5.80512 21.2375C4.85012 21.2375 4.00512 21.8125 3.65512 22.7025C3.55012 22.9725 3.49512 23.2575 3.49512 23.5475C3.49512 24.8225 4.53012 25.8625 5.80512 25.8625C7.08012 25.8625 8.12012 24.8225 8.12012 23.5475C8.12012 23.2575 8.06512 22.9725 7.96012 22.7025ZM5.80512 25.1275C4.93512 25.1275 4.22512 24.4175 4.22512 23.5475C4.22512 23.3475 4.26512 23.1575 4.34012 22.9675C4.57512 22.3625 5.15012 21.9725 5.80512 21.9725C6.45012 21.9725 7.04012 22.3725 7.27512 22.9725C7.35012 23.1575 7.39012 23.3525 7.39012 23.5475C7.39012 24.4175 6.68012 25.1275 5.80512 25.1275ZM13.0751 21.2375C11.8001 21.2375 10.7601 22.2775 10.7601 23.5525C10.7601 24.8275 11.8001 25.8625 13.0751 25.8625C14.3501 25.8625 15.3851 24.8275 15.3851 23.5525C15.3851 22.2775 14.3501 21.2375 13.0751 21.2375ZM13.0751 25.1275C12.2001 25.1275 11.4951 24.4225 11.4951 23.5525C11.4951 22.6775 12.2001 21.9725 13.0751 21.9725C13.9451 21.9725 14.6501 22.6775 14.6501 23.5525C14.6501 24.4225 13.9451 25.1275 13.0751 25.1275ZM25.1751 21.2375C23.9001 21.2375 22.8651 22.2775 22.8651 23.5525C22.8651 24.8275 23.9001 25.8625 25.1751 25.8625C26.4501 25.8625 27.4901 24.8275 27.4901 23.5525C27.4901 22.2775 26.4501 21.2375 25.1751 21.2375ZM25.1751 25.1275C24.3051 25.1275 23.5951 24.4225 23.5951 23.5525C23.5951 22.6775 24.3051 21.9725 25.1751 21.9725C26.0451 21.9725 26.7551 22.6775 26.7551 23.5525C26.7551 24.4225 26.0451 25.1275 25.1751 25.1275ZM22.0401 0.987488C19.4551 0.987488 17.3501 3.09249 17.3501 5.68249C17.3501 8.26749 19.4551 10.3725 22.0401 10.3725C24.6301 10.3725 26.7351 8.26749 26.7351 5.68249C26.7351 3.09249 24.6301 0.987488 22.0401 0.987488ZM22.0401 9.64249C19.8601 9.64249 18.0851 7.86749 18.0851 5.68249C18.0851 3.49749 19.8601 1.72249 22.0401 1.72249C24.2251 1.72249 26.0001 3.49749 26.0001 5.68249C26.0001 7.86749 24.2251 9.64249 22.0401 9.64249Z"
        fill="white"
      />
      <path
        d="M22.04 1.72247C19.86 1.72247 18.085 3.49747 18.085 5.68247C18.085 7.86747 19.86 9.64247 22.04 9.64247C24.225 9.64247 26 7.86747 26 5.68247C26 3.49747 24.225 1.72247 22.04 1.72247ZM24.215 4.38247L21.54 7.43747C21.47 7.51247 21.375 7.55747 21.275 7.56247C21.27 7.56247 21.265 7.56247 21.265 7.56247C21.165 7.56247 21.07 7.52247 21.005 7.45247L19.57 6.02247C19.43 5.87747 19.43 5.64747 19.57 5.50247C19.715 5.35747 19.945 5.36247 20.09 5.50247L21.245 6.65747L23.665 3.89747C23.795 3.74747 24.03 3.73247 24.18 3.86247C24.335 3.99747 24.35 4.22747 24.215 4.38247Z"
        fill="#14B8A6"
      />
      <path
        d="M24.7701 17.1875C24.7701 17.3925 24.6101 17.5525 24.4051 17.5525H22.4301C22.2251 17.5525 22.0601 17.3925 22.0601 17.1875C22.0601 16.9875 22.2251 16.8225 22.4301 16.8225H24.4051C24.6101 16.8225 24.7701 16.9875 24.7701 17.1875ZM24.2151 4.38251L21.5401 7.43751C21.4701 7.51251 21.3751 7.55751 21.2751 7.56251C21.2701 7.56251 21.2651 7.56251 21.2651 7.56251C21.1651 7.56251 21.0701 7.52251 21.0051 7.45251L19.5701 6.02251C19.4301 5.87751 19.4301 5.64751 19.5701 5.50251C19.7151 5.35751 19.9451 5.36251 20.0901 5.50251L21.2451 6.65751L23.6651 3.89751C23.7951 3.74751 24.0301 3.73251 24.1801 3.86251C24.3351 3.99751 24.3501 4.22751 24.2151 4.38251Z"
        fill="white"
      />
    </svg>
  );
}
export function DashboardAllBooking() {
  return (
    <svg
      width="32"
      height="32"
      viewBox="0 0 32 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M22.2 30.1H9.8C9.65 30.1 9.55 30.2 9.55 30.35V31.05H22.45V30.35C22.45 30.25 22.35 30.1 22.2 30.1ZM20.25 0.950012H6.1C5.5 0.950012 5.05 1.45001 5.05 2.00001V11.7H21.3V2.00001C21.3 1.40001 20.8 0.950012 20.25 0.950012ZM15.85 5.20001C15.85 5.40001 15.75 5.60001 15.55 5.65001C15.35 5.75001 15.15 5.70001 15 5.60001L13.15 4.25001L11.3 5.60001C11.2 5.65001 11.1 5.70001 11 5.70001C10.9 5.70001 10.85 5.70001 10.75 5.65001C10.55 5.55001 10.45 5.40001 10.45 5.20001V2.00001C10.45 1.70001 10.7 1.50001 10.95 1.50001C11.25 1.50001 11.45 1.75001 11.45 2.00001V4.20001L12.75 3.25001C12.95 3.10001 13.2 3.10001 13.35 3.25001L14.65 4.20001V2.00001C14.65 1.70001 14.9 1.50001 15.15 1.50001C15.45 1.50001 15.65 1.75001 15.65 2.00001V5.20001H15.85ZM30.45 3.25001H22.35V4.65001H23.65C24.2 4.65001 24.75 4.90001 25.15 5.30001L27.4 7.50001C27.8 7.90001 28 8.45001 28 9.00001V15.15C28 15.7 27.7 16.25 27.2 16.5C26.95 16.65 26.65 16.55 26.5 16.3C26.35 16.05 26.45 15.75 26.7 15.6C26.85 15.5 26.95 15.35 26.95 15.15V9.05001C26.95 8.80001 26.85 8.50001 26.65 8.30001L24.4 6.05001C24.2 5.85001 23.95 5.75001 23.65 5.75001H22.35V12.25C22.35 12.55 22.1 12.75 21.85 12.75H5.05V15.2C5.05 15.5 5.3 15.75 5.6 15.75H7.05C7.2 14.55 8.2 13.6 9.45 13.6C10.7 13.6 11.75 14.55 11.85 15.75H21C21.15 14.55 22.15 13.6 23.4 13.6C24.75 13.6 25.85 14.7 25.85 16.05C25.85 17.4 24.75 18.5 23.4 18.5C22.3 18.5 21.4 17.8 21.1 16.85H11.8C11.45 17.8 10.55 18.5 9.5 18.5C8.4 18.5 7.5 17.8 7.2 16.85H5.6C4.7 16.85 4 16.15 4 15.25V12.25V3.25001H1.55C0.7 3.25001 0 4.00001 0 4.85001V20.25H32V4.85001C32 4.00001 31.3 3.25001 30.45 3.25001ZM9.5 14.6C8.75 14.6 8.1 15.2 8.1 16C8.1 16.75 8.7 17.4 9.5 17.4C10.25 17.4 10.9 16.8 10.9 16C10.85 15.25 10.25 14.6 9.5 14.6ZM23.45 14.6C22.7 14.6 22.05 15.2 22.05 16C22.05 16.75 22.65 17.4 23.45 17.4C24.2 17.4 24.85 16.8 24.85 16C24.85 15.25 24.2 14.6 23.45 14.6ZM12.2 26.4V29.05H19.75V26.4H12.2ZM19.65 22.85C19.4 22.85 19.2 23.05 19.2 23.3C19.2 23.55 19.4 23.75 19.65 23.75C19.9 23.75 20.1 23.55 20.1 23.3C20.1 23.05 19.9 22.85 19.65 22.85ZM19.65 22.85C19.4 22.85 19.2 23.05 19.2 23.3C19.2 23.55 19.4 23.75 19.65 23.75C19.9 23.75 20.1 23.55 20.1 23.3C20.1 23.05 19.9 22.85 19.65 22.85ZM12.35 22.85C12.1 22.85 11.9 23.05 11.9 23.3C11.9 23.55 12.1 23.75 12.35 23.75C12.6 23.75 12.8 23.55 12.8 23.3C12.85 23.05 12.6 22.85 12.35 22.85ZM16 22.85C15.75 22.85 15.55 23.05 15.55 23.3C15.55 23.55 15.75 23.75 16 23.75C16.25 23.75 16.45 23.55 16.45 23.3C16.45 23.05 16.25 22.85 16 22.85ZM19.65 22.85C19.4 22.85 19.2 23.05 19.2 23.3C19.2 23.55 19.4 23.75 19.65 23.75C19.9 23.75 20.1 23.55 20.1 23.3C20.1 23.05 19.9 22.85 19.65 22.85ZM19.65 22.85C19.4 22.85 19.2 23.05 19.2 23.3C19.2 23.55 19.4 23.75 19.65 23.75C19.9 23.75 20.1 23.55 20.1 23.3C20.1 23.05 19.9 22.85 19.65 22.85ZM16 22.85C15.75 22.85 15.55 23.05 15.55 23.3C15.55 23.55 15.75 23.75 16 23.75C16.25 23.75 16.45 23.55 16.45 23.3C16.45 23.05 16.25 22.85 16 22.85ZM12.35 22.85C12.1 22.85 11.9 23.05 11.9 23.3C11.9 23.55 12.1 23.75 12.35 23.75C12.6 23.75 12.8 23.55 12.8 23.3C12.85 23.05 12.6 22.85 12.35 22.85ZM0 21.25V23.75C0 24.6 0.7 25.3 1.55 25.3H30.4C31.25 25.3 31.95 24.6 31.95 23.75V21.25H0ZM12.35 24.8C11.5 24.8 10.85 24.1 10.85 23.3C10.85 22.45 11.55 21.8 12.35 21.8C13.2 21.8 13.85 22.5 13.85 23.3C13.9 24.15 13.2 24.8 12.35 24.8ZM16 24.8C15.15 24.8 14.5 24.1 14.5 23.3C14.5 22.45 15.2 21.8 16 21.8C16.85 21.8 17.5 22.5 17.5 23.3C17.5 24.15 16.85 24.8 16 24.8ZM19.65 24.8C18.8 24.8 18.15 24.1 18.15 23.3C18.15 22.45 18.85 21.8 19.65 21.8C20.5 21.8 21.15 22.5 21.15 23.3C21.15 24.15 20.45 24.8 19.65 24.8ZM19.65 22.85C19.4 22.85 19.2 23.05 19.2 23.3C19.2 23.55 19.4 23.75 19.65 23.75C19.9 23.75 20.1 23.55 20.1 23.3C20.1 23.05 19.9 22.85 19.65 22.85ZM16 22.85C15.75 22.85 15.55 23.05 15.55 23.3C15.55 23.55 15.75 23.75 16 23.75C16.25 23.75 16.45 23.55 16.45 23.3C16.45 23.05 16.25 22.85 16 22.85ZM12.35 22.85C12.1 22.85 11.9 23.05 11.9 23.3C11.9 23.55 12.1 23.75 12.35 23.75C12.6 23.75 12.8 23.55 12.8 23.3C12.85 23.05 12.6 22.85 12.35 22.85ZM16 22.85C15.75 22.85 15.55 23.05 15.55 23.3C15.55 23.55 15.75 23.75 16 23.75C16.25 23.75 16.45 23.55 16.45 23.3C16.45 23.05 16.25 22.85 16 22.85ZM19.65 22.85C19.4 22.85 19.2 23.05 19.2 23.3C19.2 23.55 19.4 23.75 19.65 23.75C19.9 23.75 20.1 23.55 20.1 23.3C20.1 23.05 19.9 22.85 19.65 22.85ZM19.65 22.85C19.4 22.85 19.2 23.05 19.2 23.3C19.2 23.55 19.4 23.75 19.65 23.75C19.9 23.75 20.1 23.55 20.1 23.3C20.1 23.05 19.9 22.85 19.65 22.85ZM16 22.85C15.75 22.85 15.55 23.05 15.55 23.3C15.55 23.55 15.75 23.75 16 23.75C16.25 23.75 16.45 23.55 16.45 23.3C16.45 23.05 16.25 22.85 16 22.85Z"
        fill="#6366F1"
      />
    </svg>
  );
}
export function DashboardRejectedBooking() {
  return (
    <svg
      width="32"
      height="32"
      viewBox="0 0 32 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_2904_43395)">
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M23.1775 29.4206V30.3444C23.1775 31.2544 22.4318 32 21.5212 32H2.08434C1.17371 32 0.428711 31.255 0.428711 30.3444V5.00311C0.428711 4.09186 1.17371 3.34686 2.08434 3.34686H3.00746V26.9969C3.00746 28.3319 4.09684 29.4206 5.43121 29.4206H23.1775Z"
          fill="#C03D3B"
        />
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M26.5244 26.4844V26.9969C26.5244 27.9075 25.7788 28.6531 24.8681 28.6531H5.43126C4.52063 28.6531 3.77563 27.9081 3.77563 26.9969V1.65562C3.77563 0.745 4.52063 0 5.43126 0H24.8681C25.7794 0 26.5244 0.745 26.5244 1.65562V14.8537C23.3125 14.8537 20.7094 17.4575 20.7094 20.6687C20.7094 23.8806 23.3125 26.4844 26.5244 26.4844ZM6.19313 26.1C5.98126 26.1 5.80876 25.9281 5.80876 25.7162C5.80876 25.5037 5.98126 25.3319 6.19313 25.3319H22.3556C22.5681 25.3319 22.74 25.5037 22.74 25.7162C22.74 25.9281 22.5681 26.1 22.3556 26.1H6.19313ZM6.19313 22.8925C5.98126 22.8925 5.80876 22.7206 5.80876 22.5081C5.80876 22.2962 5.98126 22.1244 6.19313 22.1244H20.1706C20.3825 22.1244 20.5544 22.2962 20.5544 22.5081C20.5544 22.7206 20.3825 22.8925 20.1706 22.8925H6.19313ZM6.19313 19.685C5.98126 19.685 5.80876 19.5131 5.80876 19.3006C5.80876 19.0887 5.98126 18.9169 6.19313 18.9169H19.2038C19.4163 18.9169 19.5881 19.0887 19.5881 19.3006C19.5881 19.5131 19.4163 19.685 19.2038 19.685H6.19313ZM6.19313 16.4775C5.98126 16.4775 5.80876 16.3056 5.80876 16.0931C5.80876 15.8812 5.98126 15.7094 6.19313 15.7094H21.4769C21.6894 15.7094 21.8613 15.8812 21.8613 16.0931C21.8613 16.3056 21.6894 16.4775 21.4769 16.4775H6.19313ZM6.19313 13.2694C5.98126 13.2694 5.80876 13.0975 5.80876 12.8856C5.80876 12.6737 5.98126 12.5019 6.19313 12.5019H24.1069C24.3188 12.5019 24.4906 12.6737 24.4906 12.8856C24.4906 13.0975 24.3188 13.2694 24.1069 13.2694H6.19313ZM6.28438 10.0619C6.07251 10.0619 5.90064 9.89 5.90064 9.67812C5.90064 9.46625 6.07251 9.29437 6.28438 9.29437H24.1069C24.3188 9.29437 24.4906 9.46625 24.4906 9.67812C24.4906 9.89 24.3188 10.0619 24.1069 10.0619H6.28438ZM6.19313 6.85437C5.98126 6.85437 5.80876 6.6825 5.80876 6.47062C5.80876 6.25875 5.98126 6.08625 6.19313 6.08625H24.1069C24.3188 6.08625 24.4906 6.25875 24.4906 6.47062C24.4906 6.6825 24.3188 6.85437 24.1069 6.85437H6.19313ZM6.19313 3.64687C5.98126 3.64687 5.80876 3.475 5.80876 3.26312C5.80876 3.05125 5.98126 2.87875 6.19313 2.87875H24.1069C24.3188 2.87875 24.4906 3.05125 24.4906 3.26312C24.4906 3.475 24.3188 3.64687 24.1069 3.64687H6.19313Z"
          fill="#C03D3B"
        />
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M26.5243 15.6219C29.3118 15.6219 31.5712 17.8819 31.5712 20.6688C31.5712 23.4563 29.3118 25.7163 26.5243 25.7163C23.7368 25.7163 21.4768 23.4563 21.4768 20.6688C21.4768 17.8819 23.7368 15.6219 26.5243 15.6219ZM29.3824 17.8106C29.6168 18.045 29.7337 18.3531 29.7337 18.6606C29.7337 18.9681 29.6168 19.2763 29.3824 19.51L28.2237 20.6688L29.3824 21.8275V21.8281C29.6168 22.0619 29.7337 22.37 29.7337 22.6775C29.7337 22.985 29.6168 23.2931 29.3824 23.5269V23.5275C29.1487 23.7613 28.8406 23.8781 28.5324 23.8781C28.2249 23.8781 27.9174 23.7613 27.6831 23.5275L26.5243 22.3688L25.3656 23.5275C25.1312 23.7613 24.8231 23.8781 24.5156 23.8781C24.2081 23.8781 23.8999 23.7613 23.6662 23.5275L23.6656 23.5269C23.4318 23.2931 23.3149 22.985 23.3149 22.6775C23.3149 22.37 23.4318 22.0619 23.6656 21.8281L23.6662 21.8275L24.8249 20.6688L23.6662 19.51H23.6656C23.4318 19.2763 23.3149 18.9681 23.3149 18.6606C23.3149 18.3531 23.4318 18.045 23.6656 17.8106H23.6662C23.8999 17.5769 24.2081 17.46 24.5156 17.46C24.8231 17.46 25.1312 17.5769 25.3656 17.8106L26.5243 18.9694L27.6831 17.8106C27.9174 17.5769 28.2249 17.46 28.5324 17.46C28.8406 17.46 29.1487 17.5769 29.3824 17.8106ZM28.8393 18.3538C28.7556 18.27 28.6443 18.2275 28.5324 18.2275C28.4212 18.2275 28.3099 18.27 28.2262 18.3538L26.7956 19.7838C26.6456 19.9338 26.4024 19.9338 26.2524 19.7838L24.8224 18.3538C24.7381 18.27 24.6268 18.2275 24.5156 18.2275C24.4043 18.2275 24.2931 18.27 24.2093 18.3538H24.2087C24.1249 18.4381 24.0831 18.5494 24.0831 18.6606C24.0831 18.7719 24.1249 18.8831 24.2087 18.9669L25.6393 20.3975C25.7893 20.5475 25.7893 20.7906 25.6393 20.9406L24.2087 22.3706V22.3713C24.1249 22.455 24.0831 22.5663 24.0831 22.6775C24.0831 22.7888 24.1249 22.9 24.2087 22.9838V22.9844H24.2093C24.2931 23.0681 24.4043 23.1106 24.5156 23.1106C24.6268 23.1106 24.7381 23.0681 24.8224 22.9844L26.2524 21.5538C26.4024 21.4044 26.6456 21.4044 26.7956 21.5538L28.2262 22.9844C28.3099 23.0681 28.4212 23.1106 28.5324 23.1106C28.6443 23.1106 28.7556 23.0681 28.8393 22.9844V22.9838C28.9237 22.9 28.9656 22.7888 28.9656 22.6775C28.9656 22.5663 28.9237 22.455 28.8393 22.3713V22.3706L27.4093 20.9406C27.2593 20.7906 27.2593 20.5475 27.4093 20.3975L28.8393 18.9669C28.9237 18.8831 28.9656 18.7719 28.9656 18.6606C28.9656 18.5494 28.9237 18.4381 28.8393 18.3538Z"
          fill="#C03D3B"
        />
      </g>
      <defs>
        <clipPath id="clip0_2904_43395">
          <rect width="32" height="32" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
}
// Small Card Icon
export function DashboardOrderIcon({ size }) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect width="24" height="24" rx="12" fill="#4470E2" fill-opacity="0.1" />
      <path
        d="M16.7908 9.56151L12.2991 12.1632C12.1183 12.2682 11.8908 12.2682 11.7041 12.1632L7.21242 9.56151C6.89159 9.37484 6.80992 8.93734 7.05492 8.66318C7.22409 8.47068 7.41659 8.31318 7.62076 8.20234L10.7824 6.45234C11.4591 6.07318 12.5558 6.07318 13.2324 6.45234L16.3941 8.20234C16.5983 8.31318 16.7908 8.47651 16.9599 8.66318C17.1933 8.93734 17.1116 9.37484 16.7908 9.56151Z"
        fill="#4470E2"
      />
      <path
        d="M11.6674 13.2483V17.2267C11.6674 17.67 11.2183 17.9617 10.8216 17.7692C9.61995 17.18 7.59578 16.0775 7.59578 16.0775C6.88411 15.675 6.30078 14.66 6.30078 13.8258V10.8158C6.30078 10.355 6.78495 10.0633 7.18161 10.2908L11.3758 12.7233C11.5508 12.8342 11.6674 13.0325 11.6674 13.2483Z"
        fill="#4470E2"
      />
      <path
        d="M12.332 13.2483V17.2267C12.332 17.67 12.7812 17.9617 13.1779 17.7692C14.3795 17.18 16.4037 16.0775 16.4037 16.0775C17.1154 15.675 17.6987 14.66 17.6987 13.8258V10.8158C17.6987 10.355 17.2145 10.0633 16.8179 10.2908L12.6237 12.7233C12.4487 12.8342 12.332 13.0325 12.332 13.2483Z"
        fill="#4470E2"
      />
    </svg>
  );
}
DashboardOrderIcon.propTypes = {
  size: PropTypes.string,
};
DashboardOrderIcon.defaultProps = {
  size: '1.667vw',
};
export function DashboardBookingIcon({ size }) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect width="24" height="24" rx="12" fill="#A855F7" fill-opacity="0.1" />
      <path
        d="M15.2627 8.09693L11.9669 6.32359C11.6169 6.13693 11.2027 6.13693 10.8527 6.32359L7.56271 8.09693C7.32354 8.23109 7.17188 8.48776 7.17188 8.76776C7.17188 9.05359 7.31771 9.31026 7.56271 9.43859L10.8585 11.2119C11.0335 11.3053 11.226 11.3519 11.4127 11.3519C11.5994 11.3519 11.7977 11.3053 11.9669 11.2119L15.2627 9.43859C15.5019 9.31026 15.6535 9.05359 15.6535 8.76776C15.6535 8.48776 15.5019 8.23109 15.2627 8.09693Z"
        fill="#A855F7"
      />
      <path
        d="M10.3174 11.8305L7.2549 10.3022C7.01573 10.1797 6.7474 10.1972 6.5199 10.3314C6.29823 10.4714 6.16406 10.7105 6.16406 10.973V13.8664C6.16406 14.368 6.44406 14.8172 6.89323 15.0447L9.95573 16.573C10.0607 16.6255 10.1774 16.6547 10.2941 16.6547C10.4282 16.6547 10.5682 16.6139 10.6907 16.5439C10.9124 16.4039 11.0466 16.1647 11.0466 15.9022V13.0089C11.0407 12.5072 10.7607 12.058 10.3174 11.8305Z"
        fill="#A855F7"
      />
      <path
        d="M16.6657 10.973V12.408C16.3857 12.3264 16.0882 12.2914 15.7907 12.2914C14.9974 12.2914 14.2216 12.5655 13.6091 13.0555C12.7691 13.7147 12.2907 14.7122 12.2907 15.7914C12.2907 16.0772 12.3257 16.363 12.4016 16.6372C12.3141 16.6255 12.2266 16.5905 12.1449 16.538C11.9232 16.4039 11.7891 16.1647 11.7891 15.9022V13.0089C11.7891 12.5072 12.0691 12.058 12.5124 11.8305L15.5749 10.3022C15.8141 10.1797 16.0824 10.1972 16.3099 10.3314C16.5316 10.4714 16.6657 10.7105 16.6657 10.973Z"
        fill="#A855F7"
      />
      <path
        d="M17.823 14.1295C17.3446 13.5403 16.6155 13.167 15.793 13.167C15.1746 13.167 14.603 13.3828 14.1538 13.7445C13.5471 14.2228 13.168 14.9637 13.168 15.792C13.168 16.6145 13.5413 17.3437 14.1305 17.822C14.5796 18.1953 15.163 18.417 15.793 18.417C16.458 18.417 17.0588 18.1662 17.5255 17.7637C18.068 17.2795 18.418 16.5795 18.418 15.792C18.418 15.162 18.1963 14.5787 17.823 14.1295ZM16.3938 15.9553C16.3938 16.107 16.3121 16.2528 16.1838 16.3287L15.3613 16.8187C15.2913 16.8595 15.2155 16.8828 15.1338 16.8828C14.988 16.8828 14.8421 16.807 14.7605 16.6728C14.638 16.4628 14.7021 16.1945 14.9121 16.072L15.5188 15.7103V14.9753C15.5188 14.7362 15.7171 14.5378 15.9563 14.5378C16.1955 14.5378 16.3938 14.7362 16.3938 14.9753V15.9553Z"
        fill="#A855F7"
      />
    </svg>
  );
}
DashboardBookingIcon.propTypes = {
  size: PropTypes.string,
};
DashboardBookingIcon.defaultProps = {
  size: '1.667vw',
};
export function DashboardShipmentIcon({ size }) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect width="24" height="24" rx="12" fill="#2179C4" fill-opacity="0.1" />
      <path
        d="M13.168 6.70366V11.5512C13.168 12.1462 12.6838 12.6303 12.0888 12.6303H6.7513C6.43047 12.6303 6.16797 12.3678 6.16797 12.047V8.31949C6.16797 7.12949 7.13047 6.16699 8.32047 6.16699H12.6255C12.9288 6.16699 13.168 6.40616 13.168 6.70366Z"
        fill="#2179C4"
      />
      <path
        d="M17.543 14.042C17.7063 14.042 17.8346 14.1703 17.8346 14.3337V14.917C17.8346 15.8853 17.053 16.667 16.0846 16.667C16.0846 15.7045 15.2971 14.917 14.3346 14.917C13.3721 14.917 12.5846 15.7045 12.5846 16.667H11.418C11.418 15.7045 10.6305 14.917 9.66797 14.917C8.70547 14.917 7.91797 15.7045 7.91797 16.667C6.94964 16.667 6.16797 15.8853 6.16797 14.917V13.7503C6.16797 13.4295 6.43047 13.167 6.7513 13.167H12.293C13.098 13.167 13.7513 12.5137 13.7513 11.7087V8.50033C13.7513 8.17949 14.0138 7.91699 14.3346 7.91699H14.8246C15.2446 7.91699 15.6296 8.14449 15.8396 8.50616L16.213 9.15949C16.2655 9.25283 16.1955 9.37533 16.0846 9.37533C15.2796 9.37533 14.6263 10.0287 14.6263 10.8337V12.5837C14.6263 13.3887 15.2796 14.042 16.0846 14.042H17.543Z"
        fill="#2179C4"
      />
      <path
        d="M9.66667 17.8333C10.311 17.8333 10.8333 17.311 10.8333 16.6667C10.8333 16.0223 10.311 15.5 9.66667 15.5C9.02233 15.5 8.5 16.0223 8.5 16.6667C8.5 17.311 9.02233 17.8333 9.66667 17.8333Z"
        fill="#2179C4"
      />
      <path
        d="M14.3346 17.8333C14.979 17.8333 15.5013 17.311 15.5013 16.6667C15.5013 16.0223 14.979 15.5 14.3346 15.5C13.6903 15.5 13.168 16.0223 13.168 16.6667C13.168 17.311 13.6903 17.8333 14.3346 17.8333Z"
        fill="#2179C4"
      />
      <path
        d="M17.8333 12.3092V13.1667H16.0833C15.7625 13.1667 15.5 12.9042 15.5 12.5833V10.8333C15.5 10.5125 15.7625 10.25 16.0833 10.25H16.8358L17.6817 11.7317C17.7808 11.9067 17.8333 12.105 17.8333 12.3092Z"
        fill="#2179C4"
      />
    </svg>
  );
}
DashboardShipmentIcon.propTypes = {
  size: PropTypes.string,
};
DashboardShipmentIcon.defaultProps = {
  size: '1.667vw',
};
export function DashboardMilestoneIcon({ size }) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect width="24" height="24" rx="12" fill="#14B8A6" fill-opacity="0.1" />
      <path
        d="M16.082 9.66699C17.0485 9.66699 17.832 8.88349 17.832 7.91699C17.832 6.95049 17.0485 6.16699 16.082 6.16699C15.1155 6.16699 14.332 6.95049 14.332 7.91699C14.332 8.88349 15.1155 9.66699 16.082 9.66699Z"
        fill="#14B8A6"
      />
      <path
        d="M16.5513 10.495C16.5396 10.495 16.528 10.5008 16.5163 10.5008C16.458 10.5125 16.3996 10.5183 16.3355 10.53C16.0905 10.5533 15.828 10.5417 15.5596 10.4892C15.4896 10.4717 15.4313 10.46 15.3671 10.4367C15.1746 10.39 14.9938 10.3142 14.8246 10.215C14.7546 10.18 14.6846 10.1333 14.6205 10.0925C14.3405 9.9 14.1013 9.66083 13.9088 9.38083C13.868 9.31667 13.8213 9.24667 13.7863 9.17667C13.6871 9.0075 13.6113 8.82667 13.5646 8.63417C13.5413 8.57 13.5296 8.51167 13.5121 8.44167C13.4596 8.17333 13.448 7.91083 13.4713 7.66583C13.483 7.60167 13.4888 7.54333 13.5005 7.485C13.5005 7.47333 13.5063 7.46167 13.5063 7.45C13.5763 7.08833 13.308 6.75 12.9346 6.75H9.38797C9.3063 6.75 9.22464 6.75583 9.1488 6.76167C9.0788 6.7675 9.01464 6.77333 8.94464 6.785C8.87464 6.79083 8.80464 6.8025 8.74047 6.81417C7.33464 7.01833 6.4363 7.91083 6.23214 9.3225C6.22047 9.38667 6.2088 9.45667 6.20297 9.52667C6.1913 9.59667 6.18547 9.66083 6.17964 9.73083C6.1738 9.80667 6.16797 9.88833 6.16797 9.97V14.6133C6.16797 14.695 6.1738 14.7767 6.17964 14.8525C6.18547 14.9225 6.1913 14.9867 6.20297 15.0567C6.2088 15.1267 6.22047 15.1967 6.23214 15.2608C6.4363 16.6725 7.33464 17.565 8.74047 17.7692C8.80464 17.7808 8.87464 17.7925 8.94464 17.7983C9.01464 17.81 9.0788 17.8158 9.1488 17.8217C9.22464 17.8275 9.3063 17.8333 9.38797 17.8333H14.0313C14.113 17.8333 14.1946 17.8275 14.2705 17.8217C14.3405 17.8158 14.4046 17.81 14.4746 17.7983C14.5446 17.7925 14.6146 17.7808 14.6788 17.7692C16.0846 17.565 16.983 16.6725 17.1871 15.2608C17.1988 15.1967 17.2105 15.1267 17.2163 15.0567C17.228 14.9867 17.2338 14.9225 17.2396 14.8525C17.2455 14.7767 17.2513 14.695 17.2513 14.6133V11.0667C17.2513 10.6933 16.913 10.425 16.5513 10.495ZM8.9388 12.2917H11.8555C12.0946 12.2917 12.293 12.49 12.293 12.7292C12.293 12.9683 12.0946 13.1667 11.8555 13.1667H8.9388C8.69964 13.1667 8.5013 12.9683 8.5013 12.7292C8.5013 12.49 8.69964 12.2917 8.9388 12.2917ZM14.1888 15.5H8.9388C8.69964 15.5 8.5013 15.3017 8.5013 15.0625C8.5013 14.8233 8.69964 14.625 8.9388 14.625H14.1888C14.428 14.625 14.6263 14.8233 14.6263 15.0625C14.6263 15.3017 14.428 15.5 14.1888 15.5Z"
        fill="#14B8A6"
      />
    </svg>
  );
}
DashboardMilestoneIcon.propTypes = {
  size: PropTypes.string,
};
DashboardMilestoneIcon.defaultProps = {
  size: '1.667vw',
};
export function DashboardCustomsIcon({ size }) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect width="24" height="24" rx="12" fill="#F29C4C" fill-opacity="0.1" />
      <path
        d="M7.91536 13.167C6.6262 13.167 5.58203 14.2112 5.58203 15.5003C5.58203 16.7895 6.6262 17.8337 7.91536 17.8337C9.20453 17.8337 10.2487 16.7895 10.2487 15.5003C10.2487 14.2112 9.20453 13.167 7.91536 13.167ZM8.4987 15.3137C8.4987 15.6695 8.3062 16.0078 8.00286 16.1887L7.55953 16.457C7.48953 16.5037 7.40786 16.5212 7.33203 16.5212C7.1862 16.5212 7.04036 16.4453 6.9587 16.3112C6.8362 16.107 6.90036 15.8328 7.11036 15.7103L7.5537 15.442C7.59453 15.4187 7.6237 15.3662 7.6237 15.3195V14.777C7.6237 14.532 7.82203 14.3337 8.0612 14.3337C8.30036 14.3337 8.4987 14.532 8.4987 14.7712V15.3137Z"
        fill="#F29C4C"
      />
      <path
        d="M14.918 7.33301H9.08464C7.33464 7.33301 6.16797 8.20801 6.16797 10.2497V12.3263C6.16797 12.5422 6.38964 12.6763 6.58214 12.5888C7.1538 12.3263 7.81297 12.2272 8.50714 12.3497C10.0413 12.6238 11.1671 14.0472 11.1263 15.6047C11.1205 15.8497 11.0855 16.0888 11.0213 16.3222C10.9746 16.503 11.1205 16.6722 11.3071 16.6722H14.918C16.668 16.6722 17.8346 15.7972 17.8346 13.7555V10.2497C17.8346 8.20801 16.668 7.33301 14.918 7.33301ZM12.0013 13.458C11.1963 13.458 10.543 12.8047 10.543 11.9997C10.543 11.1947 11.1963 10.5413 12.0013 10.5413C12.8063 10.5413 13.4596 11.1947 13.4596 11.9997C13.4596 12.8047 12.8063 13.458 12.0013 13.458ZM16.2305 13.1663C16.2305 13.4055 16.0321 13.6038 15.793 13.6038C15.5538 13.6038 15.3555 13.4055 15.3555 13.1663V10.833C15.3555 10.5938 15.5538 10.3955 15.793 10.3955C16.0321 10.3955 16.2305 10.5938 16.2305 10.833V13.1663Z"
        fill="#F29C4C"
      />
    </svg>
  );
}
DashboardCustomsIcon.propTypes = {
  size: PropTypes.string,
};
DashboardCustomsIcon.defaultProps = {
  size: '1.667vw',
};
export function DashboardQuotesIcon({ size }) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect width="24" height="24" rx="12" fill="#C7598F" fill-opacity="0.1" />
      <path
        d="M15.5045 6.16699V7.04199C15.8895 7.04199 16.257 7.19949 16.5254 7.46199C16.8054 7.74783 16.957 8.11533 16.957 8.50033V9.91199C16.957 10.3437 16.7645 10.542 16.327 10.542H15.207V7.33949C15.207 7.17616 15.3412 7.04199 15.5045 7.04199V6.16699ZM15.5045 6.16699C14.857 6.16699 14.332 6.69199 14.332 7.33949V11.417H16.327C17.2487 11.417 17.832 10.8337 17.832 9.91199V8.50033C17.832 7.85866 17.5695 7.27533 17.1495 6.84949C16.7237 6.42949 16.1462 6.17283 15.5045 6.16699C15.5104 6.16699 15.5045 6.16699 15.5045 6.16699Z"
        fill="#C7598F"
      />
      <path
        d="M9.08464 6.16699H8.5013C6.7513 6.16699 6.16797 7.21116 6.16797 8.50033V9.08366V17.2503C6.16797 17.7345 6.7163 18.0087 7.1013 17.717L8.0988 16.9703C8.33214 16.7953 8.6588 16.8187 8.8688 17.0287L9.83714 18.0028C10.0646 18.2303 10.438 18.2303 10.6655 18.0028L11.6455 17.0228C11.8496 16.8187 12.1763 16.7953 12.4038 16.9703L13.4013 17.717C13.7863 18.0028 14.3346 17.7287 14.3346 17.2503V7.33366C14.3346 6.69199 14.8596 6.16699 15.5013 6.16699H9.08464ZM11.8555 11.2712H10.6888V12.4378C10.6888 12.677 10.4905 12.8753 10.2513 12.8753C10.0121 12.8753 9.8138 12.677 9.8138 12.4378V11.2712H8.64714C8.40797 11.2712 8.20964 11.0728 8.20964 10.8337C8.20964 10.5945 8.40797 10.3962 8.64714 10.3962H9.8138V9.22949C9.8138 8.99033 10.0121 8.79199 10.2513 8.79199C10.4905 8.79199 10.6888 8.99033 10.6888 9.22949V10.3962H11.8555C12.0946 10.3962 12.293 10.5945 12.293 10.8337C12.293 11.0728 12.0946 11.2712 11.8555 11.2712Z"
        fill="#C7598F"
      />
    </svg>
  );
}
DashboardQuotesIcon.propTypes = {
  size: PropTypes.string,
};
DashboardQuotesIcon.defaultProps = {
  size: '1.667vw',
};

export function ExportIcon() {
  return (
    <svg
      width="0.972vw"
      height="15"
      viewBox="0 0 14 15"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M7.5835 7.35414C7.47267 7.35414 7.36184 7.31331 7.27434 7.22581C7.10517 7.05664 7.10517 6.77664 7.27434 6.60747L12.0577 1.82414C12.2268 1.65497 12.5068 1.65497 12.676 1.82414C12.8452 1.99331 12.8452 2.27331 12.676 2.44247L7.89267 7.22581C7.80517 7.31331 7.69434 7.35414 7.5835 7.35414Z"
        fill="white"
      />
      <path
        d="M12.8332 4.90425C12.594 4.90425 12.3957 4.70591 12.3957 4.46675V2.10425H10.0332C9.79404 2.10425 9.5957 1.90591 9.5957 1.66675C9.5957 1.42758 9.79404 1.22925 10.0332 1.22925H12.8332C13.0724 1.22925 13.2707 1.42758 13.2707 1.66675V4.46675C13.2707 4.70591 13.0724 4.90425 12.8332 4.90425Z"
        fill="white"
      />
      <path
        d="M8.74984 13.7709H5.24984C2.08234 13.7709 0.729004 12.4176 0.729004 9.25008V5.75008C0.729004 2.58258 2.08234 1.22925 5.24984 1.22925H6.4165C6.65567 1.22925 6.854 1.42758 6.854 1.66675C6.854 1.90591 6.65567 2.10425 6.4165 2.10425H5.24984C2.56067 2.10425 1.604 3.06091 1.604 5.75008V9.25008C1.604 11.9392 2.56067 12.8959 5.24984 12.8959H8.74984C11.439 12.8959 12.3957 11.9392 12.3957 9.25008V8.08342C12.3957 7.84425 12.594 7.64592 12.8332 7.64592C13.0723 7.64592 13.2707 7.84425 13.2707 8.08342V9.25008C13.2707 12.4176 11.9173 13.7709 8.74984 13.7709Z"
        fill="white"
      />
    </svg>
  );
}
export function RemoveIcon() {
  return (
    <svg
      width="12"
      height="13"
      viewBox="0 0 12 13"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M5.99984 0.666748C2.77692 0.666748 0.166504 3.27716 0.166504 6.50008C0.166504 9.723 2.77692 12.3334 5.99984 12.3334C9.22275 12.3334 11.8332 9.723 11.8332 6.50008C11.8332 3.27716 9.22275 0.666748 5.99984 0.666748ZM8.9165 7.08341H3.08317V5.91675H8.9165V7.08341Z"
        fill="#7D7D7D"
      />
    </svg>
  );
}
export function ReportIcon() {
  return (
    <svg
      width="0.972vw"
      height="0.972vw"
      viewBox="0 0 14 14"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M2.5 2C2.5 2.375 2.33333 2.66146 2 2.85938V12.75C2 12.8177 1.97526 12.8763 1.92578 12.9258C1.8763 12.9753 1.81771 13 1.75 13H1.25C1.18229 13 1.1237 12.9753 1.07422 12.9258C1.02474 12.8763 1 12.8177 1 12.75V2.85938C0.666667 2.66146 0.5 2.375 0.5 2C0.5 1.72396 0.597656 1.48828 0.792969 1.29297C0.988281 1.09766 1.22396 1 1.5 1C1.77604 1 2.01172 1.09766 2.20703 1.29297C2.40234 1.48828 2.5 1.72396 2.5 2ZM14 2.5V8.46094C14 8.59115 13.9674 8.69141 13.9023 8.76172C13.8372 8.83203 13.7344 8.90365 13.5938 8.97656C12.474 9.58073 11.513 9.88281 10.7109 9.88281C10.3932 9.88281 10.0716 9.82552 9.74609 9.71094C9.42057 9.59635 9.13802 9.47135 8.89844 9.33594C8.65885 9.20052 8.35807 9.07552 7.99609 8.96094C7.63411 8.84635 7.26302 8.78906 6.88281 8.78906C5.88281 8.78906 4.67448 9.16927 3.25781 9.92969C3.16927 9.97656 3.08333 10 3 10C2.86458 10 2.7474 9.95052 2.64844 9.85156C2.54948 9.7526 2.5 9.63542 2.5 9.5V3.70312C2.5 3.53646 2.58073 3.39323 2.74219 3.27344C2.85156 3.20052 3.05729 3.08854 3.35938 2.9375C4.58854 2.3125 5.6849 2 6.64844 2C7.20573 2 7.72656 2.07552 8.21094 2.22656C8.69531 2.3776 9.26562 2.60677 9.92188 2.91406C10.1198 3.01302 10.349 3.0625 10.6094 3.0625C10.8906 3.0625 11.1966 3.00781 11.5273 2.89844C11.8581 2.78906 12.1445 2.66667 12.3867 2.53125C12.6289 2.39583 12.8581 2.27344 13.0742 2.16406C13.2904 2.05469 13.4323 2 13.5 2C13.6354 2 13.7526 2.04948 13.8516 2.14844C13.9505 2.2474 14 2.36458 14 2.5Z"
        fill="#7D7D7D"
      />
    </svg>
  );
}
export function UndoIcon() {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M15.13 19.06H7.13C6.72 19.06 6.38 18.72 6.38 18.31C6.38 17.9 6.72 17.56 7.13 17.56H15.13C17.47 17.56 19.38 15.65 19.38 13.31C19.38 10.97 17.47 9.06 15.13 9.06H4.13C3.72 9.06 3.38 8.72 3.38 8.31C3.38 7.9 3.72 7.56 4.13 7.56H15.13C18.3 7.56 20.88 10.14 20.88 13.31C20.88 16.48 18.3 19.06 15.13 19.06Z"
        fill="url(#paint0_linear_3794_124)"
      />
      <path
        d="M6.43006 11.56C6.24006 11.56 6.05006 11.49 5.90006 11.34L3.34006 8.78C3.05006 8.49 3.05006 8.01 3.34006 7.72L5.90006 5.16C6.19006 4.87 6.67006 4.87 6.96006 5.16C7.25006 5.45 7.25006 5.93 6.96006 6.22L4.93006 8.25L6.96006 10.28C7.25006 10.57 7.25006 11.05 6.96006 11.34C6.82006 11.49 6.62006 11.56 6.43006 11.56Z"
        fill="url(#paint1_linear_3794_124)"
      />
      <defs>
        <linearGradient
          id="paint0_linear_3794_124"
          x1="3.38"
          y1="13.31"
          x2="20.88"
          y2="13.31"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#1987D8" />
          <stop offset="1" stopColor="#45B4D0" />
        </linearGradient>
        <linearGradient
          id="paint1_linear_3794_124"
          x1="3.12256"
          y1="8.25125"
          x2="7.17756"
          y2="8.25125"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#1987D8" />
          <stop offset="1" stopColor="#45B4D0" />
        </linearGradient>
      </defs>
    </svg>
  );
}
export function TextEditIcon() {
  return (
    <svg
      width="1.181vw"
      height="1.111vw"
      viewBox="0 0 17 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M4.19332 13.0133C3.78666 13.0133 3.40666 12.8733 3.13332 12.6133C2.78666 12.2867 2.61999 11.7933 2.67999 11.26L2.92666 9.09999C2.97332 8.69333 3.21999 8.15333 3.50666 7.85999L8.97999 2.06666C10.3467 0.619992 11.7733 0.579992 13.22 1.94666C14.6667 3.31333 14.7067 4.73999 13.34 6.18666L7.86666 11.98C7.58666 12.28 7.06666 12.56 6.65999 12.6267L4.51332 12.9933C4.39999 13 4.29999 13.0133 4.19332 13.0133ZM11.12 1.93999C10.6067 1.93999 10.16 2.25999 9.70666 2.73999L4.23332 8.53999C4.09999 8.67999 3.94666 9.01333 3.91999 9.20666L3.67332 11.3667C3.64666 11.5867 3.69999 11.7667 3.81999 11.88C3.93999 11.9933 4.11999 12.0333 4.33999 12L6.48666 11.6333C6.67999 11.6 6.99999 11.4267 7.13332 11.2867L12.6067 5.49332C13.4333 4.61332 13.7333 3.79999 12.5267 2.66666C11.9933 2.15333 11.5333 1.93999 11.12 1.93999Z"
        fill="#1D3E69"
      />
      <path
        d="M12.06 7.29998C12.0466 7.29998 12.0266 7.29998 12.0133 7.29998C9.9333 7.09331 8.25996 5.51331 7.93996 3.44665C7.89996 3.17331 8.08663 2.91998 8.35996 2.87331C8.6333 2.83331 8.88663 3.01998 8.9333 3.29331C9.18663 4.90665 10.4933 6.14665 12.12 6.30665C12.3933 6.33331 12.5933 6.57998 12.5666 6.85331C12.5333 7.10665 12.3133 7.29998 12.06 7.29998Z"
        fill="#1D3E69"
      />
      <path
        d="M14.5 15.1667H2.5C2.22667 15.1667 2 14.94 2 14.6667C2 14.3934 2.22667 14.1667 2.5 14.1667H14.5C14.7733 14.1667 15 14.3934 15 14.6667C15 14.94 14.7733 15.1667 14.5 15.1667Z"
        fill="#1D3E69"
      />
    </svg>
  );
}

export function DocumentDownloadIcon({ color }) {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M9 17.75C8.9 17.75 8.81 17.73 8.71 17.69C8.43 17.58 8.25 17.3 8.25 17V11C8.25 10.59 8.59 10.25 9 10.25C9.41 10.25 9.75 10.59 9.75 11V15.19L10.47 14.47C10.76 14.18 11.24 14.18 11.53 14.47C11.82 14.76 11.82 15.24 11.53 15.53L9.53 17.53C9.39 17.67 9.19 17.75 9 17.75Z"
        fill={color}
      />
      <path
        d="M8.99994 17.7499C8.80994 17.7499 8.61994 17.6799 8.46994 17.5299L6.46994 15.5299C6.17994 15.2399 6.17994 14.7599 6.46994 14.4699C6.75994 14.1799 7.23994 14.1799 7.52994 14.4699L9.52994 16.4699C9.81994 16.7599 9.81994 17.2399 9.52994 17.5299C9.37994 17.6799 9.18994 17.7499 8.99994 17.7499Z"
        fill={color}
      />
      <path
        d="M15 22.75H9C3.57 22.75 1.25 20.43 1.25 15V9C1.25 3.57 3.57 1.25 9 1.25H14C14.41 1.25 14.75 1.59 14.75 2C14.75 2.41 14.41 2.75 14 2.75H9C4.39 2.75 2.75 4.39 2.75 9V15C2.75 19.61 4.39 21.25 9 21.25H15C19.61 21.25 21.25 19.61 21.25 15V10C21.25 9.59 21.59 9.25 22 9.25C22.41 9.25 22.75 9.59 22.75 10V15C22.75 20.43 20.43 22.75 15 22.75Z"
        fill={color}
      />
      <path
        d="M22 10.75H18C14.58 10.75 13.25 9.41999 13.25 5.99999V1.99999C13.25 1.69999 13.43 1.41999 13.71 1.30999C13.99 1.18999 14.31 1.25999 14.53 1.46999L22.53 9.46999C22.74 9.67999 22.81 10.01 22.69 10.29C22.57 10.57 22.3 10.75 22 10.75ZM14.75 3.80999V5.99999C14.75 8.57999 15.42 9.24999 18 9.24999H20.19L14.75 3.80999Z"
        fill={color}
      />
    </svg>
  );
}
DocumentDownloadIcon.propTypes = {
  color: PropTypes.string,
};
DocumentDownloadIcon.defaultProps = {
  color: '#3B86F2',
};
export function DocumentDownloadFillIcon({ color }) {
  return (
    <svg
      width="1.111vw"
      height="1.111vw"
      viewBox="0 0 16 17"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M13.667 7.29398H11.7403C10.1603 7.29398 8.87366 6.00732 8.87366 4.42732V2.50065C8.87366 2.13398 8.57366 1.83398 8.20699 1.83398H5.38033C3.32699 1.83398 1.66699 3.16732 1.66699 5.54732V11.454C1.66699 13.834 3.32699 15.1673 5.38033 15.1673H10.6203C12.6737 15.1673 14.3337 13.834 14.3337 11.454V7.96065C14.3337 7.59398 14.0337 7.29398 13.667 7.29398ZM8.18699 11.0206L6.85366 12.354C6.80699 12.4007 6.74699 12.4407 6.68699 12.4607C6.62699 12.4873 6.56699 12.5007 6.50033 12.5007C6.43366 12.5007 6.37366 12.4873 6.31366 12.4607C6.26033 12.4407 6.20699 12.4007 6.16699 12.3607C6.16033 12.354 6.15366 12.354 6.15366 12.3473L4.82033 11.014C4.62699 10.8207 4.62699 10.5007 4.82033 10.3073C5.01366 10.114 5.33366 10.114 5.52699 10.3073L6.00033 10.794V8.00065C6.00033 7.72732 6.22699 7.50065 6.50033 7.50065C6.77366 7.50065 7.00033 7.72732 7.00033 8.00065V10.794L7.48033 10.314C7.67366 10.1207 7.99366 10.1207 8.18699 10.314C8.38033 10.5073 8.38033 10.8273 8.18699 11.0206Z"
        fill={color}
      />
      <path
        d="M11.6195 6.37365C12.2528 6.38032 13.1328 6.38032 13.8861 6.38032C14.2661 6.38032 14.4661 5.93365 14.1995 5.66699C13.2395 4.70032 11.5195 2.96032 10.5328 1.97365C10.2595 1.70032 9.78613 1.88699 9.78613 2.26699V4.59365C9.78613 5.56699 10.6128 6.37365 11.6195 6.37365Z"
        fill={color}
      />
    </svg>
  );
}
DocumentDownloadFillIcon.propTypes = {
  color: PropTypes.string,
};
DocumentDownloadFillIcon.defaultProps = {
  color: '#616B80',
};
export function EditImageIcon({ size, color }) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 12 12"
      fill={color}
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M6.6 2.57205L9.428 5.40072L2.828 12.0001H0V9.17139L6.6 2.57139V2.57205ZM7.54266 1.62939L8.95666 0.214722C9.08168 0.0897416 9.25122 0.0195312 9.428 0.0195312C9.60477 0.0195312 9.77431 0.0897416 9.89933 0.214722L11.7853 2.10072C11.9103 2.22574 11.9805 2.39528 11.9805 2.57205C11.9805 2.74883 11.9103 2.91837 11.7853 3.04339L10.3707 4.45739L7.54266 1.62939Z"
        fill={color}
      />
    </svg>
  );
}
EditImageIcon.propTypes = {
  size: PropTypes.string,
  color: PropTypes.string,
};
EditImageIcon.defaultProps = {
  size: '0.694vw',
  color: '#2179c4',
};
export function DocumentsAllFolder() {
  return (
    <svg
      width="0.972vw"
      height="1.042vw"
      viewBox="0 0 14 15"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path d="M9.9165 13.7712H4.08317C1.51067 13.7712 0.729004 12.9895 0.729004 10.417V4.58366C0.729004 2.01116 1.51067 1.22949 4.08317 1.22949H4.95817C5.979 1.22949 6.29984 1.56199 6.70817 2.10449L7.58317 3.27116C7.77567 3.52783 7.80484 3.56283 8.1665 3.56283H9.9165C12.489 3.56283 13.2707 4.34449 13.2707 6.91699V10.417C13.2707 12.9895 12.489 13.7712 9.9165 13.7712ZM4.08317 2.10449C1.99484 2.10449 1.604 2.50116 1.604 4.58366V10.417C1.604 12.4995 1.99484 12.8962 4.08317 12.8962H9.9165C12.0048 12.8962 12.3957 12.4995 12.3957 10.417V6.91699C12.3957 4.83449 12.0048 4.43783 9.9165 4.43783H8.1665C7.41984 4.43783 7.17484 4.18116 6.88317 3.79616L6.00817 2.62949C5.70484 2.22699 5.6115 2.10449 4.95817 2.10449H4.08317Z" />
      <path d="M11.6665 4.65949C11.4273 4.65949 11.229 4.46116 11.229 4.22199V3.41699C11.229 2.49533 10.8382 2.10449 9.9165 2.10449H4.6665C4.42734 2.10449 4.229 1.90616 4.229 1.66699C4.229 1.42783 4.42734 1.22949 4.6665 1.22949H9.9165C11.3282 1.22949 12.104 2.00533 12.104 3.41699V4.22199C12.104 4.46116 11.9057 4.65949 11.6665 4.65949Z" />
    </svg>
  );
}
export function DocumentsSharedWithMe() {
  return (
    <svg
      width="0.972vw"
      height="1.042vw"
      viewBox="0 0 14 15"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path d="M7 6.18783C6.94167 6.18783 6.88917 6.17616 6.83083 6.15283C6.6675 6.08866 6.5625 5.92533 6.5625 5.75033V1.66699C6.5625 1.42783 6.76083 1.22949 7 1.22949C7.23917 1.22949 7.4375 1.42783 7.4375 1.66699V4.69449L7.8575 4.27449C8.02667 4.10533 8.30667 4.10533 8.47583 4.27449C8.645 4.44366 8.645 4.72366 8.47583 4.89283L7.30917 6.05949C7.2275 6.14116 7.11667 6.18783 7 6.18783Z" />
      <path d="M7.00017 6.18767C6.88934 6.18767 6.7785 6.14684 6.691 6.05934L5.52434 4.89267C5.35517 4.7235 5.35517 4.4435 5.52434 4.27434C5.6935 4.10517 5.9735 4.10517 6.14267 4.27434L7.30934 5.441C7.4785 5.61017 7.4785 5.89017 7.30934 6.05934C7.22184 6.14684 7.111 6.18767 7.00017 6.18767Z" />
      <path d="M8.02645 10.8538H5.96729C5.35478 10.8538 4.80645 10.5155 4.53228 9.96717L3.84979 8.60217C3.82645 8.54967 3.77395 8.52051 3.72145 8.52051H1.15479C0.915618 8.52051 0.717285 8.32217 0.717285 8.08301C0.717285 7.84384 0.915618 7.64551 1.15479 7.64551H3.72728C4.11812 7.64551 4.46812 7.86134 4.64312 8.21134L5.32562 9.57634C5.44812 9.82717 5.69895 9.97884 5.97895 9.97884H8.03812C8.31812 9.97884 8.56895 9.82717 8.69145 9.57634L9.37395 8.21134C9.54895 7.86134 9.89895 7.64551 10.2898 7.64551H12.8331C13.0723 7.64551 13.2706 7.84384 13.2706 8.08301C13.2706 8.32217 13.0723 8.52051 12.8331 8.52051H10.2898C10.2315 8.52051 10.1848 8.54967 10.1615 8.60217L9.47895 9.96717C9.18729 10.5155 8.63895 10.8538 8.02645 10.8538Z" />
      <path d="M8.74984 13.7707H5.24984C2.08234 13.7707 0.729004 12.4174 0.729004 9.24988V6.91654C0.729004 4.18071 1.744 2.80988 4.019 2.47738C4.264 2.44238 4.47984 2.60571 4.51484 2.84488C4.54984 3.08404 4.3865 3.30571 4.14734 3.34071C2.31567 3.60904 1.604 4.61238 1.604 6.91654V9.24988C1.604 11.939 2.56067 12.8957 5.24984 12.8957H8.74984C11.439 12.8957 12.3957 11.939 12.3957 9.24988V6.91654C12.3957 4.61238 11.684 3.60904 9.85234 3.34071C9.61317 3.30571 9.44984 3.08404 9.48484 2.84488C9.51984 2.60571 9.7415 2.44238 9.98067 2.47738C12.2557 2.80988 13.2707 4.18071 13.2707 6.91654V9.24988C13.2707 12.4174 11.9173 13.7707 8.74984 13.7707Z" />
    </svg>
  );
}
export function DocumentsSharedByMe() {
  return (
    <svg
      width="0.972vw"
      height="1.042vw"
      viewBox="0 0 14 15"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path d="M7.00017 6.18794C6.761 6.18794 6.56267 5.98961 6.56267 5.75044V2.72294L6.14267 3.14294C5.9735 3.31211 5.6935 3.31211 5.52434 3.14294C5.35517 2.97377 5.35517 2.69377 5.52434 2.52461L6.691 1.35794C6.8135 1.23544 7.006 1.19461 7.16934 1.26461C7.33267 1.32877 7.43767 1.49211 7.43767 1.66711V5.75044C7.43767 5.98961 7.23934 6.18794 7.00017 6.18794Z" />
      <path d="M8.16667 3.27068C8.05584 3.27068 7.94501 3.22984 7.85751 3.14234L6.69084 1.97568C6.52167 1.80651 6.52167 1.52651 6.69084 1.35734C6.86001 1.18818 7.14001 1.18818 7.30917 1.35734L8.47584 2.52401C8.64501 2.69318 8.64501 2.97318 8.47584 3.14234C8.38834 3.22984 8.27751 3.27068 8.16667 3.27068Z" />
      <path d="M8.02645 10.8538H5.96729C5.35478 10.8538 4.80645 10.5155 4.53228 9.96717L3.84979 8.60217C3.82645 8.54967 3.77395 8.52051 3.72145 8.52051H1.15479C0.915618 8.52051 0.717285 8.32217 0.717285 8.08301C0.717285 7.84384 0.915618 7.64551 1.15479 7.64551H3.72728C4.11812 7.64551 4.46812 7.86134 4.64312 8.21134L5.32562 9.57634C5.44812 9.82717 5.69895 9.97884 5.97895 9.97884H8.03812C8.31812 9.97884 8.56895 9.82717 8.69145 9.57634L9.37395 8.21134C9.54895 7.86134 9.89895 7.64551 10.2898 7.64551H12.8331C13.0723 7.64551 13.2706 7.84384 13.2706 8.08301C13.2706 8.32217 13.0723 8.52051 12.8331 8.52051H10.2898C10.2315 8.52051 10.1848 8.54967 10.1615 8.60217L9.47895 9.96717C9.18729 10.5155 8.63895 10.8538 8.02645 10.8538Z" />
      <path d="M8.74984 13.7704H5.24984C2.08234 13.7704 0.729004 12.4171 0.729004 9.24955V7.49955C0.729004 4.76372 1.744 3.39288 4.019 3.06038C4.264 3.02538 4.47984 3.18872 4.51484 3.42788C4.54984 3.66705 4.3865 3.88872 4.14734 3.92372C2.31567 4.19205 1.604 5.19538 1.604 7.49955V9.24955C1.604 11.9387 2.56067 12.8954 5.24984 12.8954H8.74984C11.439 12.8954 12.3957 11.9387 12.3957 9.24955V7.49955C12.3957 5.19538 11.684 4.19205 9.85234 3.92372C9.61317 3.88872 9.44984 3.66705 9.48484 3.42788C9.51984 3.18872 9.7415 3.02538 9.98067 3.06038C12.2557 3.39288 13.2707 4.76372 13.2707 7.49955V9.24955C13.2707 12.4171 11.9173 13.7704 8.74984 13.7704Z" />
    </svg>
  );
}
export function DocumentsFav() {
  return (
    <svg
      width="0.972vw"
      height="1.042vw"
      viewBox="0 0 14 15"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path d="M7.0001 10.9304C6.85426 10.9304 6.7026 10.8779 6.58593 10.7729L5.08093 9.45455C4.5151 8.95872 4.43926 8.10705 4.91176 7.51788C5.3901 6.92288 6.24176 6.81205 6.85426 7.27288L7.0001 7.38372L7.15176 7.26705C7.76426 6.80622 8.61593 6.91705 9.09426 7.51205C9.56676 8.10122 9.49093 8.95288 8.9251 9.44872L7.4201 10.7671C7.2976 10.8779 7.14593 10.9304 7.0001 10.9304ZM5.6526 8.79538L7.0001 9.97372L8.3476 8.79538C8.56343 8.60872 8.5926 8.28788 8.41176 8.06622C8.23093 7.83872 7.9101 7.79788 7.67676 7.97288L7.2626 8.28205C7.1051 8.39872 6.8951 8.39872 6.7376 8.28205L6.32343 7.97288C6.09593 7.79788 5.76926 7.83872 5.58843 8.06622C5.41343 8.28788 5.44259 8.60872 5.6526 8.79538Z" />
      <path d="M9.9165 13.7712H4.08317C1.51067 13.7712 0.729004 12.9895 0.729004 10.417V4.58366C0.729004 2.01116 1.51067 1.22949 4.08317 1.22949H4.95817C5.979 1.22949 6.29984 1.56199 6.70817 2.10449L7.58317 3.27116C7.77567 3.52783 7.80484 3.56283 8.1665 3.56283H9.9165C12.489 3.56283 13.2707 4.34449 13.2707 6.91699V10.417C13.2707 12.9895 12.489 13.7712 9.9165 13.7712ZM4.08317 2.10449C1.99484 2.10449 1.604 2.50116 1.604 4.58366V10.417C1.604 12.4995 1.99484 12.8962 4.08317 12.8962H9.9165C12.0048 12.8962 12.3957 12.4995 12.3957 10.417V6.91699C12.3957 4.83449 12.0048 4.43783 9.9165 4.43783H8.1665C7.41984 4.43783 7.17484 4.18116 6.88317 3.79616L6.00817 2.62949C5.70484 2.22699 5.6115 2.10449 4.95817 2.10449H4.08317Z" />
    </svg>
  );
}
export function NormalSearchIcon({ color, size }) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M11 20.75C5.62 20.75 1.25 16.38 1.25 11C1.25 5.62 5.62 1.25 11 1.25C16.38 1.25 20.75 5.62 20.75 11C20.75 16.38 16.38 20.75 11 20.75ZM11 2.75C6.45 2.75 2.75 6.45 2.75 11C2.75 15.55 6.45 19.25 11 19.25C15.55 19.25 19.25 15.55 19.25 11C19.25 6.45 15.55 2.75 11 2.75Z"
        fill={color}
      />
      <path
        d="M20.1601 22.79C20.0801 22.79 20.0001 22.78 19.9301 22.77C19.4601 22.71 18.6101 22.39 18.1301 20.96C17.8801 20.21 17.9701 19.46 18.3801 18.89C18.7901 18.32 19.4801 18 20.2701 18C21.2901 18 22.0901 18.39 22.4501 19.08C22.8101 19.77 22.7101 20.65 22.1401 21.5C21.4301 22.57 20.6601 22.79 20.1601 22.79ZM19.5601 20.49C19.7301 21.01 19.9701 21.27 20.1301 21.29C20.2901 21.31 20.5901 21.12 20.9001 20.67C21.1901 20.24 21.2101 19.93 21.1401 19.79C21.0701 19.65 20.7901 19.5 20.2701 19.5C19.9601 19.5 19.7301 19.6 19.6001 19.77C19.4801 19.94 19.4601 20.2 19.5601 20.49Z"
        fill={color}
      />
    </svg>
  );
}
NormalSearchIcon.propTypes = {
  color: PropTypes.string,
  size: PropTypes.string,
};
NormalSearchIcon.defaultProps = {
  color: '#616B80',
  size: '1.667vw',
};
export function CloudUploadIcon() {
  return (
    <svg
      width="3.333vw"
      height="3.333vw"
      viewBox="0 0 47 39"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M31.5 27.5L23.5 19.5L15.5 27.5"
        stroke="black"
        strokeOpacity="0.4"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M23.5 19.5V37.5"
        stroke="black"
        strokeOpacity="0.4"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M40.2799 32.28C42.2306 31.2165 43.7716 29.5337 44.6597 27.4972C45.5477 25.4607 45.7323 23.1864 45.1843 21.0334C44.6363 18.8803 43.3869 16.971 41.6333 15.6069C39.8796 14.2427 37.7216 13.5014 35.4999 13.5H32.9799C32.3745 11.1585 31.2462 8.98464 29.6798 7.14195C28.1134 5.29927 26.1496 3.83567 23.9361 2.86118C21.7226 1.8867 19.317 1.42669 16.9002 1.51573C14.4833 1.60478 12.1181 2.24057 9.98227 3.3753C7.84649 4.51003 5.99574 6.11417 4.56916 8.06713C3.14259 10.0201 2.1773 12.271 1.74588 14.6508C1.31446 17.0305 1.42813 19.477 2.07835 21.8065C2.72856 24.136 3.8984 26.2877 5.49992 28.1"
        stroke="black"
        strokeOpacity="0.4"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M31.5 27.5L23.5 19.5L15.5 27.5"
        stroke="black"
        strokeOpacity="0.4"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}
export function POChangesIcon({ color, width, height }) {
  return (
    <svg
      width={width !== '' ? width : '19'}
      height={height !== '' ? height : '19'}
      viewBox="0 0 19 19"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M11.875 18.0104C11.6612 18.0104 11.4633 17.8917 11.3604 17.7096C11.2575 17.5275 11.2575 17.2979 11.3683 17.1158L12.1996 15.7304C12.3658 15.4454 12.73 15.3583 13.015 15.5246C13.3 15.6908 13.3871 16.055 13.2208 16.34L13.0071 16.6963C15.1921 16.1817 16.8308 14.2183 16.8308 11.875C16.8308 11.5504 17.1 11.2812 17.4246 11.2812C17.7491 11.2812 18.0183 11.5504 18.0183 11.875C18.0104 15.2554 15.2554 18.0104 11.875 18.0104Z"
        fill={color}
      />
      <path
        d="M1.5835 7.71875C1.25891 7.71875 0.989746 7.44958 0.989746 7.125C0.989746 3.74458 3.74475 0.989584 7.12516 0.989584C7.33891 0.989584 7.53683 1.10834 7.63974 1.29042C7.74266 1.4725 7.74266 1.70209 7.63183 1.88417L6.80058 3.26959C6.63433 3.55459 6.27016 3.64168 5.98516 3.47543C5.70016 3.30918 5.61308 2.94499 5.77933 2.65999L5.99309 2.30373C3.80809 2.81831 2.16933 4.78167 2.16933 7.125C2.17725 7.44958 1.90808 7.71875 1.5835 7.71875Z"
        fill={color}
      />
      <path
        d="M13.9966 5.9374C13.8937 5.9374 13.7908 5.91367 13.6958 5.85825L10.5529 4.03738C10.2679 3.87113 10.1729 3.50699 10.3391 3.22199C10.5054 2.93699 10.8695 2.84197 11.1466 3.00822L13.9966 4.6549L16.8229 3.01615C17.1079 2.8499 17.4721 2.95283 17.6304 3.22991C17.7966 3.51491 17.6937 3.87905 17.4166 4.04531L14.2895 5.85033C14.2025 5.90574 14.0995 5.9374 13.9966 5.9374Z"
        fill={color}
      />
      <path
        d="M13.9966 9.15949C13.672 9.15949 13.4028 8.89033 13.4028 8.56574V5.33573C13.4028 5.01114 13.672 4.74198 13.9966 4.74198C14.3212 4.74198 14.5903 5.01114 14.5903 5.33573V8.56574C14.5903 8.89824 14.3212 9.15949 13.9966 9.15949Z"
        fill={color}
      />
      <path
        d="M13.9967 9.30204C13.6325 9.30204 13.2604 9.22287 12.9675 9.05662L11.0675 8.00369C10.45 7.66328 9.98291 6.86373 9.98291 6.15915V4.14828C9.98291 3.43578 10.45 2.64414 11.0754 2.29581L12.9754 1.24288C13.5612 0.918295 14.44 0.918295 15.0337 1.24288L16.9337 2.29581C17.5512 2.63623 18.0183 3.43577 18.0183 4.14036V6.15122C18.0183 6.86372 17.5512 7.65535 16.9337 7.99577L15.0337 9.0487C14.725 9.22287 14.3608 9.30204 13.9967 9.30204ZM13.5454 2.27204L11.6454 3.32497C11.4079 3.45955 11.1704 3.86327 11.1704 4.13243V6.1433C11.1704 6.42038 11.4079 6.82415 11.6454 6.95081L13.5454 8.01162C13.775 8.13829 14.2183 8.13829 14.4479 8.01162L16.3479 6.95869C16.5854 6.82411 16.8229 6.42039 16.8229 6.15122V4.14036C16.8229 3.86327 16.5854 3.45956 16.3479 3.33289L14.4479 2.27996C14.2183 2.14538 13.7671 2.14537 13.5454 2.27204Z"
        fill={color}
      />
      <path
        d="M5.00347 14.6457C4.90056 14.6457 4.79764 14.622 4.70264 14.5666L1.55972 12.7457C1.27472 12.5795 1.17971 12.2153 1.34596 11.9303C1.51221 11.6453 1.87638 11.5503 2.15347 11.7166L5.00347 13.3632L7.82972 11.7245C8.11472 11.5582 8.47889 11.6612 8.63722 11.9382C8.80347 12.2232 8.70055 12.5874 8.42347 12.7536L5.29639 14.5587C5.2093 14.6141 5.10639 14.6457 5.00347 14.6457Z"
        fill={color}
      />
      <path
        d="M5.00342 17.8678C4.67883 17.8678 4.40967 17.5987 4.40967 17.2741V14.0441C4.40967 13.7195 4.67883 13.4503 5.00342 13.4503C5.328 13.4503 5.59717 13.7195 5.59717 14.0441V17.2741C5.59717 17.6066 5.33592 17.8678 5.00342 17.8678Z"
        fill={color}
      />
      <path
        d="M5.0035 18.0104C4.63934 18.0104 4.26725 17.9312 3.97433 17.765L2.07433 16.712C1.45683 16.3716 0.989746 15.5721 0.989746 14.8675V12.8566C0.989746 12.1441 1.45683 11.3524 2.07433 11.012L3.97433 9.95914C4.56017 9.63455 5.44683 9.63455 6.03266 9.95914L7.93267 11.012C8.55017 11.3524 9.01725 12.152 9.01725 12.8566V14.8675C9.01725 15.58 8.55016 16.3716 7.92474 16.72L6.02475 17.7729C5.73975 17.9312 5.37559 18.0104 5.0035 18.0104ZM4.55225 10.9804L2.65225 12.0333C2.41475 12.1679 2.17725 12.5716 2.17725 12.8408V14.8516C2.17725 15.1287 2.41475 15.5325 2.65225 15.6591L4.55225 16.712C4.78183 16.8387 5.22516 16.8387 5.45475 16.712L7.35474 15.6591C7.59224 15.5246 7.82975 15.1208 7.82975 14.8516V12.8408C7.82975 12.5637 7.59224 12.16 7.35474 12.0333L5.45475 10.9724C5.23308 10.8537 4.78183 10.8537 4.55225 10.9804Z"
        fill={color}
      />
    </svg>
  );
}
POChangesIcon.propTypes = {
  color: PropTypes.string,
  height: PropTypes.string,
  width: PropTypes.string,
};
POChangesIcon.defaultProps = {
  color: '#ffffff',
  height: '',
  width: '',
};

export function RemoveProfileIcon({ size }) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 10 10"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M4.99999 4.05781L8.29999 0.757812L9.24266 1.70048L5.94266 5.00048L9.24266 8.30048L8.29999 9.24315L4.99999 5.94315L1.69999 9.24315L0.757324 8.30048L4.05732 5.00048L0.757324 1.70048L1.69999 0.757812L4.99999 4.05781Z"
        fill="#828282"
      />
    </svg>
  );
}
RemoveProfileIcon.propTypes = {
  size: PropTypes.string,
};
RemoveProfileIcon.defaultProps = {
  size: '0.694vw',
};
export function NoAddressIcon() {
  return (
    <svg
      width="281"
      height="267"
      viewBox="0 0 281 267"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M130.701 253.402C194.049 253.402 245.402 202.049 245.402 138.701C245.402 75.3534 194.049 24 130.701 24C67.3534 24 16 75.3534 16 138.701C16 202.049 67.3534 253.402 130.701 253.402Z"
        fill="url(#paint0_linear_5954_71093)"
      />
      <g filter="url(#filter0_f_5954_71093)">
        <ellipse cx="140.5" cy="223" rx="118.5" ry="12" fill="#647F96" />
      </g>
      <path
        d="M235.031 120.24H89.4052C85.3297 120.24 82.0259 123.544 82.0259 127.619V216.172C82.0259 220.247 85.3297 223.551 89.4052 223.551H235.031C239.106 223.551 242.41 220.247 242.41 216.172V127.619C242.41 123.544 239.106 120.24 235.031 120.24Z"
        fill="url(#paint1_linear_5954_71093)"
      />
      <path
        d="M177.794 130.172V216.172C177.794 218.131 177.016 220.01 175.63 221.395C174.245 222.781 172.366 223.559 170.406 223.559H45.0556C43.0962 223.559 41.2172 222.781 39.8317 221.395C38.4463 220.01 37.668 218.131 37.668 216.172V123.556C37.6666 122.515 37.8853 121.485 38.3097 120.535C38.734 119.584 39.3546 118.734 40.1305 118.04L95.4635 68.8386C96.7944 67.6572 98.507 66.9959 100.287 66.9763C102.066 66.9567 103.793 67.5801 105.149 68.7319L177.474 130.172H177.794Z"
        fill="url(#paint2_linear_5954_71093)"
      />
      <path
        d="M177.794 130.172V120.24L106.249 59.2512H162.887C164.682 59.2595 166.42 59.8823 167.812 61.016L249.002 127.299C249.248 127.516 249.424 127.802 249.506 128.12C249.589 128.439 249.574 128.774 249.463 129.084C249.353 129.393 249.152 129.662 248.887 129.856C248.621 130.05 248.304 130.16 247.976 130.172H177.794Z"
        fill="url(#paint3_linear_5954_71093)"
      />
      <path
        d="M126.625 159.812H86.7021C85.5976 159.812 84.7021 160.708 84.7021 161.813V223.551H128.625V161.812C128.625 160.708 127.73 159.812 126.625 159.812Z"
        fill="url(#paint4_linear_5954_71093)"
      />
      <path
        d="M242.419 130.172H177.827V145.16H242.419V130.172Z"
        fill="url(#paint5_linear_5954_71093)"
      />
      <path
        d="M109.713 62.2063L106.381 59.2512L106.315 59.3169L106.241 59.2512L101.554 63.4211L27.5798 127.274C27.3348 127.485 27.1598 127.766 27.0781 128.079C26.9964 128.391 27.0118 128.722 27.1222 129.025C27.2327 129.329 27.433 129.592 27.6966 129.779C27.9601 129.967 28.2744 130.069 28.5976 130.073L36.2151 130.172L106.381 69.758L177.474 130.172H177.794L189.286 130.024L109.713 62.2063Z"
        fill="url(#paint6_linear_5954_71093)"
      />
      <path
        d="M106.028 137.666C113.802 137.666 120.105 131.364 120.105 123.589C120.105 115.814 113.802 109.511 106.028 109.511C98.2529 109.511 91.9502 115.814 91.9502 123.589C91.9502 131.364 98.2529 137.666 106.028 137.666Z"
        fill="url(#paint7_linear_5954_71093)"
      />
      <path
        d="M71.2842 159.812H48.771C47.6664 159.812 46.771 160.708 46.771 161.813V197.689C46.771 198.794 47.6664 199.689 48.771 199.689H71.2842C72.3888 199.689 73.2842 198.794 73.2842 197.689V161.812C73.2842 160.708 72.3888 159.812 71.2842 159.812Z"
        fill="url(#paint8_linear_5954_71093)"
      />
      <path
        d="M162.258 173.168H139.745C138.64 173.168 137.745 174.063 137.745 175.168V197.681C137.745 198.786 138.64 199.681 139.745 199.681H162.258C163.362 199.681 164.258 198.786 164.258 197.681V175.168C164.258 174.063 163.362 173.168 162.258 173.168Z"
        fill="url(#paint9_linear_5954_71093)"
      />
      <g filter="url(#filter1_f_5954_71093)">
        <ellipse
          cx="184"
          cy="99.5"
          rx="35"
          ry="64.5"
          fill="#0088FA"
          fillOpacity="0.6"
        />
      </g>
      <path
        d="M162.258 159.911H139.745C138.64 159.911 137.745 160.807 137.745 161.911V165.643C137.745 166.748 138.64 167.643 139.745 167.643H162.258C163.362 167.643 164.258 166.748 164.258 165.643V161.911C164.258 160.807 163.362 159.911 162.258 159.911Z"
        fill="url(#paint10_linear_5954_71093)"
      />
      <path
        d="M242.053 186.461C241.535 184.317 238.485 184.317 237.968 186.461L236.226 193.677C236.041 194.443 235.443 195.041 234.676 195.226L227.46 196.968C225.316 197.486 225.316 200.535 227.46 201.053L234.676 202.795C235.443 202.98 236.041 203.578 236.226 204.344L237.968 211.56C238.485 213.704 241.535 213.704 242.053 211.56L243.794 204.344C243.979 203.578 244.578 202.98 245.344 202.795L252.56 201.053C254.704 200.535 254.704 197.486 252.56 196.968L245.344 195.226C244.578 195.041 243.979 194.443 243.794 193.677L242.053 186.461Z"
        fill="url(#paint11_linear_5954_71093)"
      />
      <path
        d="M119.053 232.461C118.535 230.317 115.485 230.317 114.968 232.461L113.226 239.677C113.041 240.443 112.443 241.041 111.676 241.226L104.46 242.968C102.316 243.486 102.316 246.535 104.46 247.053L111.676 248.795C112.443 248.98 113.041 249.578 113.226 250.344L114.968 257.56C115.485 259.704 118.535 259.704 119.053 257.56L120.794 250.344C120.979 249.578 121.578 248.98 122.344 248.795L129.56 247.053C131.704 246.535 131.704 243.486 129.56 242.968L122.344 241.226C121.578 241.041 120.979 240.443 120.794 239.677L119.053 232.461Z"
        fill="url(#paint12_linear_5954_71093)"
      />
      <path
        d="M52.0525 51.4607C51.5349 49.3167 48.4853 49.3167 47.9678 51.4607L46.2258 58.6767C46.0409 59.4429 45.4427 60.0411 44.6765 60.2261L37.4605 61.968C35.3165 62.4856 35.3165 65.5352 37.4605 66.0528L44.6765 67.7947C45.4427 67.9796 46.0409 68.5778 46.2258 69.344L47.9678 76.56C48.4853 78.7041 51.5349 78.7041 52.0525 76.56L53.7944 69.344C53.9794 68.5778 54.5776 67.9796 55.3438 67.7947L62.5598 66.0528C64.7038 65.5352 64.7038 62.4856 62.5598 61.968L55.3438 60.2261C54.5776 60.0411 53.9794 59.4429 53.7944 58.6767L52.0525 51.4607Z"
        fill="url(#paint13_linear_5954_71093)"
      />
      <circle
        cx="6.12803"
        cy="6.12803"
        r="4.81488"
        transform="matrix(-1 0 0 1 115.256 31)"
        fill="url(#paint14_linear_5954_71093)"
        stroke="url(#paint15_linear_5954_71093)"
        strokeWidth="2.6263"
      />
      <path
        d="M257.89 91.4916C258.979 90.6974 258.799 89.0222 257.567 88.4762L249.249 84.7908C248.017 84.2448 246.656 85.2375 246.799 86.5777L247.766 95.6239C247.91 96.964 249.45 97.6465 250.539 96.8524L257.89 91.4916Z"
        fill="url(#paint16_linear_5954_71093)"
      />
      <path
        d="M201.046 231.018C199.74 230.687 198.564 231.894 198.931 233.191L201.403 241.947C201.77 243.244 203.403 243.658 204.343 242.692L210.689 236.173C211.629 235.207 211.171 233.586 209.865 233.255L201.046 231.018Z"
        fill="url(#paint17_linear_5954_71093)"
      />
      <circle
        cx="6.12803"
        cy="6.12803"
        r="4.81488"
        transform="matrix(-1 0 0 1 39.2559 236)"
        fill="url(#paint18_linear_5954_71093)"
        stroke="url(#paint19_linear_5954_71093)"
        strokeWidth="2.6263"
      />
      <g filter="url(#filter2_dd_5954_71093)">
        <path
          d="M223.357 35.4726C218.139 30.2504 211.942 26.1077 205.122 23.2812C198.301 20.4548 190.991 19 183.608 19C176.225 19 168.915 20.4548 162.094 23.2812C155.274 26.1077 149.077 30.2504 143.859 35.4726C138.827 40.3876 134.831 46.2612 132.107 52.7465C129.383 59.2318 127.987 66.1973 128 73.2314C128 87.4976 133.508 102.199 143.859 114.922L175.945 156.522C176.85 157.694 178.011 158.643 179.339 159.296C180.667 159.949 182.128 160.289 183.608 160.289C185.088 160.289 186.549 159.949 187.877 159.296C189.206 158.643 190.366 157.694 191.271 156.522L223.357 114.922C233.708 102.199 239.208 87.4976 239.208 73.2314C239.223 66.1978 237.828 59.2326 235.105 52.7472C232.383 46.2619 228.388 40.388 223.357 35.4726Z"
          fill="url(#paint20_linear_5954_71093)"
        />
      </g>
      <path
        d="M183.604 97.6924C196.479 97.6924 206.916 87.2553 206.916 74.3805C206.916 61.5057 196.479 51.0686 183.604 51.0686C170.729 51.0686 160.292 61.5057 160.292 74.3805C160.292 87.2553 170.729 97.6924 183.604 97.6924Z"
        fill="white"
      />
      <path
        d="M119.681 202.573L104.921 218.845L146.525 256.583L161.285 240.311L119.681 202.573Z"
        fill="url(#paint21_linear_5954_71093)"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M135.279 175.64C135.279 209.682 107.682 237.279 73.6396 237.279C39.597 237.279 12 209.682 12 175.64C12 141.597 39.597 114 73.6396 114C107.682 114 135.279 141.597 135.279 175.64ZM125.824 175.64C125.824 204.461 102.46 227.825 73.6394 227.825C44.8185 227.825 21.4546 204.461 21.4546 175.64C21.4546 146.819 44.8185 123.455 73.6394 123.455C102.46 123.455 125.824 146.819 125.824 175.64Z"
        fill="url(#paint22_linear_5954_71093)"
      />
      <g filter="url(#filter3_b_5954_71093)">
        <path
          d="M73.6399 227.825C102.461 227.825 125.825 204.461 125.825 175.64C125.825 146.819 102.461 123.455 73.6399 123.455C44.819 123.455 21.4551 146.819 21.4551 175.64C21.4551 204.461 44.819 227.825 73.6399 227.825Z"
          fill="url(#paint23_linear_5954_71093)"
          fillOpacity="0.2"
        />
      </g>
      <path
        d="M86.1794 175.64L101.104 160.682C102.502 159.202 103.268 157.236 103.239 155.2C103.21 153.165 102.389 151.22 100.949 149.781C99.5097 148.341 97.5656 147.52 95.53 147.491C93.4944 147.462 91.5278 148.228 90.0481 149.626L75.0905 164.584L60.1662 149.626C59.4481 148.866 58.5848 148.258 57.6274 147.837C56.6701 147.417 55.6381 147.193 54.5925 147.178C53.547 147.163 52.5091 147.358 51.5402 147.751C50.5713 148.145 49.6911 148.728 48.9517 149.468C48.2123 150.207 47.6287 151.087 47.2354 152.056C46.8421 153.025 46.6471 154.063 46.6619 155.108C46.6767 156.154 46.9011 157.186 47.3217 158.143C47.7423 159.101 48.3506 159.964 49.1106 160.682L64.0599 175.64L49.1106 190.597C48.3506 191.315 47.7423 192.179 47.3217 193.136C46.9011 194.093 46.6767 195.125 46.6619 196.171C46.6471 197.216 46.8421 198.254 47.2354 199.223C47.6287 200.192 48.2123 201.072 48.9517 201.812C49.6911 202.551 50.5713 203.135 51.5402 203.528C52.5091 203.921 53.547 204.116 54.5925 204.102C55.6381 204.087 56.6701 203.862 57.6274 203.442C58.5848 203.021 59.4481 202.413 60.1662 201.653L75.1238 186.695L90.0814 201.653C91.5752 202.969 93.5144 203.665 95.504 203.601C97.4935 203.536 99.3836 202.715 100.789 201.306C102.194 199.896 103.009 198.004 103.068 196.014C103.126 194.024 102.424 192.087 101.104 190.597L86.1794 175.64Z"
        fill="url(#paint24_linear_5954_71093)"
      />
      <path
        d="M146.522 256.585L161.282 240.313L163.505 242.329C165.662 244.286 166.954 247.019 167.096 249.928C167.237 252.837 166.218 255.683 164.261 257.84V257.84C162.305 259.997 159.571 261.288 156.663 261.43C153.754 261.572 150.908 260.552 148.751 258.596L146.528 256.579L146.522 256.585Z"
        fill="#1987D8"
      />
      <defs>
        <filter
          id="filter0_f_5954_71093"
          x="0.114187"
          y="189.114"
          width="280.772"
          height="67.7716"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="BackgroundImageFix"
            result="shape"
          />
          <feGaussianBlur
            stdDeviation="10.9429"
            result="effect1_foregroundBlur_5954_71093"
          />
        </filter>
        <filter
          id="filter1_f_5954_71093"
          x="127.114"
          y="13.1142"
          width="113.772"
          height="172.772"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="BackgroundImageFix"
            result="shape"
          />
          <feGaussianBlur
            stdDeviation="10.9429"
            result="effect1_foregroundBlur_5954_71093"
          />
        </filter>
        <filter
          id="filter2_dd_5954_71093"
          x="109"
          y="0"
          width="149.208"
          height="179.289"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dx="-4" dy="-4" />
          <feGaussianBlur stdDeviation="7.5" />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0.409836 0 0 0 0 1 0 0 0 0.15 0"
          />
          <feBlend
            mode="normal"
            in2="BackgroundImageFix"
            result="effect1_dropShadow_5954_71093"
          />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dx="4" dy="4" />
          <feGaussianBlur stdDeviation="7.5" />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0.411765 0 0 0 0 1 0 0 0 0.15 0"
          />
          <feBlend
            mode="normal"
            in2="effect1_dropShadow_5954_71093"
            result="effect2_dropShadow_5954_71093"
          />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect2_dropShadow_5954_71093"
            result="shape"
          />
        </filter>
        <filter
          id="filter3_b_5954_71093"
          x="4.77994"
          y="106.78"
          width="137.72"
          height="137.72"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feGaussianBlur in="BackgroundImageFix" stdDeviation="8.33757" />
          <feComposite
            in2="SourceAlpha"
            operator="in"
            result="effect1_backgroundBlur_5954_71093"
          />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect1_backgroundBlur_5954_71093"
            result="shape"
          />
        </filter>
        <linearGradient
          id="paint0_linear_5954_71093"
          x1="129.817"
          y1="-13.3495"
          x2="132.167"
          y2="389.463"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="white" stopOpacity="0" />
          <stop offset="1" stopColor="#9BD0FF" />
        </linearGradient>
        <linearGradient
          id="paint1_linear_5954_71093"
          x1="145"
          y1="188"
          x2="248.911"
          y2="327.436"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#0088FA" />
          <stop offset="1" stopColor="#F7F7FF" />
        </linearGradient>
        <linearGradient
          id="paint2_linear_5954_71093"
          x1="263"
          y1="279"
          x2="64.5086"
          y2="65.2037"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#0088FA" />
          <stop offset="1" stopColor="#F7F7FF" />
        </linearGradient>
        <linearGradient
          id="paint3_linear_5954_71093"
          x1="156.5"
          y1="120"
          x2="186.414"
          y2="43.3627"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#0088FA" />
          <stop offset="1" stopColor="#F7F7FF" />
        </linearGradient>
        <linearGradient
          id="paint4_linear_5954_71093"
          x1="106.664"
          y1="159.812"
          x2="106.664"
          y2="223.551"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#0088FA" />
          <stop offset="1" stopColor="#82C5FD" />
        </linearGradient>
        <linearGradient
          id="paint5_linear_5954_71093"
          x1="181.5"
          y1="105"
          x2="132.478"
          y2="129.949"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#0088FA" />
          <stop offset="1" stopColor="#F7F7FF" />
        </linearGradient>
        <linearGradient
          id="paint6_linear_5954_71093"
          x1="165.46"
          y1="108.621"
          x2="141.906"
          y2="5.90337"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#0088FA" />
          <stop offset="1" stopColor="#F7F7FF" />
        </linearGradient>
        <linearGradient
          id="paint7_linear_5954_71093"
          x1="79.0001"
          y1="120"
          x2="139.71"
          y2="156.977"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#0088FA" />
          <stop offset="1" stopColor="#F7F7FF" />
        </linearGradient>
        <linearGradient
          id="paint8_linear_5954_71093"
          x1="60.0276"
          y1="159.812"
          x2="60.0276"
          y2="199.689"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#0088FA" />
          <stop offset="1" stopColor="#82C5FD" />
        </linearGradient>
        <linearGradient
          id="paint9_linear_5954_71093"
          x1="151.001"
          y1="173.168"
          x2="151.001"
          y2="199.681"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#0088FA" />
          <stop offset="1" stopColor="#82C5FD" />
        </linearGradient>
        <linearGradient
          id="paint10_linear_5954_71093"
          x1="151.001"
          y1="159.911"
          x2="151.001"
          y2="167.643"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#0088FA" />
          <stop offset="1" stopColor="#82C5FD" />
        </linearGradient>
        <linearGradient
          id="paint11_linear_5954_71093"
          x1="261.021"
          y1="199.01"
          x2="219"
          y2="199.01"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#1987D8" />
          <stop offset="1" stopColor="#45B4D0" />
        </linearGradient>
        <linearGradient
          id="paint12_linear_5954_71093"
          x1="138.021"
          y1="245.01"
          x2="95.9997"
          y2="245.01"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#1987D8" />
          <stop offset="1" stopColor="#45B4D0" />
        </linearGradient>
        <linearGradient
          id="paint13_linear_5954_71093"
          x1="71.0205"
          y1="64.0104"
          x2="28.9997"
          y2="64.0104"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#1987D8" />
          <stop offset="1" stopColor="#45B4D0" />
        </linearGradient>
        <linearGradient
          id="paint14_linear_5954_71093"
          x1="0"
          y1="6.12803"
          x2="12.2561"
          y2="6.12803"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#1987D8" />
          <stop offset="1" stopColor="#45B4D0" />
        </linearGradient>
        <linearGradient
          id="paint15_linear_5954_71093"
          x1="10.4564"
          y1="8.53171"
          x2="2.76961"
          y2="-6.11983"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#0088FA" />
          <stop offset="1" stopColor="#F7F7FF" />
        </linearGradient>
        <linearGradient
          id="paint16_linear_5954_71093"
          x1="252.566"
          y1="99.3401"
          x2="250.704"
          y2="81.9307"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#1987D8" />
          <stop offset="1" stopColor="#45B4D0" />
        </linearGradient>
        <linearGradient
          id="paint17_linear_5954_71093"
          x1="210.486"
          y1="230.106"
          x2="198.273"
          y2="242.652"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#1987D8" />
          <stop offset="1" stopColor="#45B4D0" />
        </linearGradient>
        <linearGradient
          id="paint18_linear_5954_71093"
          x1="0"
          y1="6.12803"
          x2="12.2561"
          y2="6.12803"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#1987D8" />
          <stop offset="1" stopColor="#45B4D0" />
        </linearGradient>
        <linearGradient
          id="paint19_linear_5954_71093"
          x1="10.4564"
          y1="8.53171"
          x2="2.76961"
          y2="-6.11983"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#0088FA" />
          <stop offset="1" stopColor="#F7F7FF" />
        </linearGradient>
        <linearGradient
          id="paint20_linear_5954_71093"
          x1="128"
          y1="89.6443"
          x2="239.208"
          y2="89.6443"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#1987D8" />
          <stop offset="1" stopColor="#45B4D0" />
        </linearGradient>
        <linearGradient
          id="paint21_linear_5954_71093"
          x1="125.723"
          y1="237.714"
          x2="140.483"
          y2="221.442"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#1987D8" />
          <stop offset="1" stopColor="#45B4D0" />
        </linearGradient>
        <linearGradient
          id="paint22_linear_5954_71093"
          x1="12"
          y1="175.64"
          x2="135.279"
          y2="175.64"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#1987D8" />
          <stop offset="1" stopColor="#45B4D0" />
        </linearGradient>
        <linearGradient
          id="paint23_linear_5954_71093"
          x1="73.6399"
          y1="123.455"
          x2="126.225"
          y2="259.907"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="white" />
          <stop offset="1" stopColor="#D2F7FF" />
        </linearGradient>
        <linearGradient
          id="paint24_linear_5954_71093"
          x1="46.9316"
          y1="151.007"
          x2="103.597"
          y2="203.948"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#FF698D" />
          <stop offset="1" stopColor="#FF3868" />
        </linearGradient>
      </defs>
    </svg>
  );
}
export function PoweredBy() {
  return (
    <svg
      width="41"
      height="21"
      viewBox="0 0 41 21"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M3.927 4.584C3.927 4.83133 3.86867 5.06467 3.752 5.284C3.63533 5.50333 3.44867 5.683 3.192 5.823C2.93533 5.95833 2.60633 6.026 2.205 6.026H1.323V8H0.525V3.135H2.205C2.57833 3.135 2.89333 3.20033 3.15 3.331C3.41133 3.457 3.605 3.62967 3.731 3.849C3.86167 4.06833 3.927 4.31333 3.927 4.584ZM2.205 5.375C2.50833 5.375 2.73467 5.30733 2.884 5.172C3.03333 5.032 3.108 4.836 3.108 4.584C3.108 4.052 2.807 3.786 2.205 3.786H1.323V5.375H2.205ZM6.36109 8.063C5.99709 8.063 5.66809 7.98133 5.37409 7.818C5.08009 7.65 4.84909 7.41667 4.68109 7.118C4.51309 6.81467 4.42909 6.46467 4.42909 6.068C4.42909 5.676 4.51542 5.32833 4.68809 5.025C4.86075 4.72167 5.09642 4.48833 5.39509 4.325C5.69375 4.16167 6.02742 4.08 6.39609 4.08C6.76475 4.08 7.09842 4.16167 7.39709 4.325C7.69575 4.48833 7.93142 4.72167 8.10409 5.025C8.27675 5.32833 8.36309 5.676 8.36309 6.068C8.36309 6.46 8.27442 6.80767 8.09709 7.111C7.91975 7.41433 7.67709 7.65 7.36909 7.818C7.06575 7.98133 6.72975 8.063 6.36109 8.063ZM6.36109 7.37C6.56642 7.37 6.75775 7.321 6.93509 7.223C7.11709 7.125 7.26409 6.978 7.37609 6.782C7.48809 6.586 7.54409 6.348 7.54409 6.068C7.54409 5.788 7.49042 5.55233 7.38309 5.361C7.27575 5.165 7.13342 5.018 6.95609 4.92C6.77875 4.822 6.58742 4.773 6.38209 4.773C6.17675 4.773 5.98542 4.822 5.80809 4.92C5.63542 5.018 5.49775 5.165 5.39509 5.361C5.29242 5.55233 5.24109 5.788 5.24109 6.068C5.24109 6.48333 5.34609 6.80533 5.55609 7.034C5.77075 7.258 6.03909 7.37 6.36109 7.37ZM14.332 4.143L13.135 8H12.295L11.518 5.151L10.741 8H9.90095L8.69695 4.143H9.50895L10.314 7.244L11.133 4.143H11.966L12.75 7.23L13.548 4.143H14.332ZM18.4633 5.977C18.4633 6.12167 18.454 6.25233 18.4353 6.369H15.4883C15.5117 6.677 15.626 6.92433 15.8313 7.111C16.0367 7.29767 16.2887 7.391 16.5873 7.391C17.0167 7.391 17.32 7.21133 17.4973 6.852H18.3583C18.2417 7.20667 18.0293 7.49833 17.7213 7.727C17.418 7.951 17.04 8.063 16.5873 8.063C16.2187 8.063 15.8873 7.98133 15.5933 7.818C15.304 7.65 15.0753 7.41667 14.9073 7.118C14.744 6.81467 14.6623 6.46467 14.6623 6.068C14.6623 5.67133 14.7417 5.32367 14.9003 5.025C15.0637 4.72167 15.29 4.48833 15.5793 4.325C15.8733 4.16167 16.2093 4.08 16.5873 4.08C16.9513 4.08 17.2757 4.15933 17.5603 4.318C17.845 4.47667 18.0667 4.70067 18.2253 4.99C18.384 5.27467 18.4633 5.60367 18.4633 5.977ZM17.6303 5.725C17.6257 5.431 17.5207 5.19533 17.3153 5.018C17.11 4.84067 16.8557 4.752 16.5523 4.752C16.277 4.752 16.0413 4.84067 15.8453 5.018C15.6493 5.19067 15.5327 5.42633 15.4953 5.725H17.6303ZM20.0466 4.703C20.1633 4.507 20.3173 4.35533 20.5086 4.248C20.7046 4.136 20.9356 4.08 21.2016 4.08V4.906H20.9986C20.686 4.906 20.448 4.98533 20.2846 5.144C20.126 5.30267 20.0466 5.578 20.0466 5.97V8H19.2486V4.143H20.0466V4.703ZM25.4702 5.977C25.4702 6.12167 25.4608 6.25233 25.4422 6.369H22.4952C22.5185 6.677 22.6328 6.92433 22.8382 7.111C23.0435 7.29767 23.2955 7.391 23.5942 7.391C24.0235 7.391 24.3268 7.21133 24.5042 6.852H25.3652C25.2485 7.20667 25.0362 7.49833 24.7282 7.727C24.4248 7.951 24.0468 8.063 23.5942 8.063C23.2255 8.063 22.8942 7.98133 22.6002 7.818C22.3108 7.65 22.0822 7.41667 21.9142 7.118C21.7508 6.81467 21.6692 6.46467 21.6692 6.068C21.6692 5.67133 21.7485 5.32367 21.9072 5.025C22.0705 4.72167 22.2968 4.48833 22.5862 4.325C22.8802 4.16167 23.2162 4.08 23.5942 4.08C23.9582 4.08 24.2825 4.15933 24.5672 4.318C24.8518 4.47667 25.0735 4.70067 25.2322 4.99C25.3908 5.27467 25.4702 5.60367 25.4702 5.977ZM24.6372 5.725C24.6325 5.431 24.5275 5.19533 24.3222 5.018C24.1168 4.84067 23.8625 4.752 23.5592 4.752C23.2838 4.752 23.0482 4.84067 22.8522 5.018C22.6562 5.19067 22.5395 5.42633 22.5022 5.725H24.6372ZM25.9895 6.054C25.9895 5.66667 26.0688 5.32367 26.2275 5.025C26.3908 4.72633 26.6101 4.49533 26.8855 4.332C27.1655 4.164 27.4758 4.08 27.8165 4.08C28.0685 4.08 28.3158 4.136 28.5585 4.248C28.8058 4.35533 29.0018 4.5 29.1465 4.682V2.82H29.9515V8H29.1465V7.419C29.0158 7.60567 28.8338 7.75967 28.6005 7.881C28.3718 8.00233 28.1081 8.063 27.8095 8.063C27.4735 8.063 27.1655 7.979 26.8855 7.811C26.6101 7.63833 26.3908 7.40033 26.2275 7.097C26.0688 6.789 25.9895 6.44133 25.9895 6.054ZM29.1465 6.068C29.1465 5.802 29.0905 5.571 28.9785 5.375C28.8711 5.179 28.7288 5.02967 28.5515 4.927C28.3741 4.82433 28.1828 4.773 27.9775 4.773C27.7721 4.773 27.5808 4.82433 27.4035 4.927C27.2261 5.025 27.0815 5.172 26.9695 5.368C26.8621 5.55933 26.8085 5.788 26.8085 6.054C26.8085 6.32 26.8621 6.55333 26.9695 6.754C27.0815 6.95467 27.2261 7.10867 27.4035 7.216C27.5855 7.31867 27.7768 7.37 27.9775 7.37C28.1828 7.37 28.3741 7.31867 28.5515 7.216C28.7288 7.11333 28.8711 6.964 28.9785 6.768C29.0905 6.56733 29.1465 6.334 29.1465 6.068ZM35.422 5.501C35.6833 5.54767 35.905 5.68533 36.087 5.914C36.269 6.14267 36.36 6.40167 36.36 6.691C36.36 6.93833 36.2946 7.16233 36.164 7.363C36.038 7.559 35.8536 7.71533 35.611 7.832C35.3683 7.944 35.086 8 34.764 8H32.818V3.135H34.673C35.0043 3.135 35.289 3.191 35.527 3.303C35.765 3.415 35.9446 3.56667 36.066 3.758C36.1873 3.94467 36.248 4.15467 36.248 4.388C36.248 4.668 36.1733 4.90133 36.024 5.088C35.8746 5.27467 35.674 5.41233 35.422 5.501ZM33.616 5.179H34.603C34.8643 5.179 35.0673 5.12067 35.212 5.004C35.3613 4.88267 35.436 4.71 35.436 4.486C35.436 4.26667 35.3613 4.09633 35.212 3.975C35.0673 3.849 34.8643 3.786 34.603 3.786H33.616V5.179ZM34.694 7.349C34.9646 7.349 35.177 7.28367 35.331 7.153C35.485 7.02233 35.562 6.84033 35.562 6.607C35.562 6.369 35.4803 6.18 35.317 6.04C35.1536 5.9 34.9366 5.83 34.666 5.83H33.616V7.349H34.694ZM40.6991 4.143L38.3331 9.813H37.5071L38.2911 7.937L36.7721 4.143H37.6611L38.7461 7.083L39.8731 4.143H40.6991Z"
        fill="#B5B5B5"
      />
      <path
        d="M10.1056 20.4781H4.94102C2.39608 20.4781 0.294922 18.5678 0.294922 15.8989C0.294922 13.2677 2.30778 11.2948 4.92819 11.2948C7.44747 11.2948 9.49806 13.2171 9.49806 15.7729C9.49806 17.291 8.77654 18.7835 7.44747 19.3906V19.4162H10.1056V20.4781ZM8.20673 15.8227C8.20673 13.9253 6.80142 12.4328 4.8897 12.4328C3.01571 12.4328 1.5855 13.9381 1.5855 15.7978C1.5855 17.7586 2.94024 19.3393 4.8897 19.3393C6.85275 19.3393 8.20673 17.7835 8.20673 15.8227Z"
        fill="#F2F2F2"
        fillOpacity="0.94902"
      />
      <path
        d="M10.3994 20.7725H4.94044C2.16984 20.7725 0 18.6314 0 15.8992C0 13.1066 2.11852 11.001 4.92761 11.001C7.6552 11.001 9.79183 13.0975 9.79183 15.7732C9.79183 17.1307 9.26352 18.3554 8.39181 19.1224H10.3994V20.7725ZM4.92761 11.5885C2.45437 11.5885 0.588687 13.4414 0.588687 15.8984C0.588687 18.3411 2.45966 20.1835 4.94044 20.1835H9.8107V19.7091H7.15255V19.2008L7.32463 19.1224C8.46577 18.6013 9.20314 17.286 9.20314 15.7725C9.20314 13.4263 7.32538 11.5885 4.92761 11.5885ZM4.88988 19.6337C2.83853 19.6337 1.29134 17.9844 1.29134 15.7981C1.29134 13.7461 2.87174 12.139 4.88988 12.139C6.94877 12.139 8.50125 13.7227 8.50125 15.823C8.50125 17.9957 6.94877 19.6337 4.88988 19.6337ZM4.88988 12.7272C3.20231 12.7272 1.88003 14.0764 1.88003 15.7981C1.88003 17.6495 3.17363 19.0455 4.88988 19.0455C6.64084 19.0455 7.9118 17.6903 7.9118 15.823C7.9118 14.0583 6.61292 12.7272 4.88988 12.7272Z"
        fill="#F2F2F2"
        fillOpacity="0.94902"
      />
      <path
        d="M13.1106 11.5219V17.012C13.1106 18.1252 13.6676 19.5671 15.3642 19.5671C17.0609 19.5671 17.6178 18.1252 17.6178 17.012V11.5219H18.833V17.2013C18.833 19.276 17.3265 20.7051 15.3642 20.7051C13.4019 20.7051 11.8955 19.276 11.8955 17.2013V11.5219H13.1106Z"
        fill="#F2F2F2"
        fillOpacity="0.94902"
      />
      <path
        d="M15.3637 21C13.1832 21 11.6006 19.4027 11.6006 17.2021V11.2278H13.4044V17.0121C13.4044 18.0551 13.9176 19.273 15.3637 19.273C16.8097 19.273 17.3229 18.0551 17.3229 17.0121V11.2278H19.1267V17.2014C19.1267 19.4027 17.5441 21 15.3637 21ZM12.1893 11.816V17.2014C12.1893 19.0611 13.5244 20.411 15.3637 20.411C17.2029 20.411 18.5373 19.0619 18.5373 17.2014V11.816H17.9109V17.0113C17.9109 18.4299 17.1229 19.8605 15.3629 19.8605C13.6029 19.8605 12.8149 18.4291 12.8149 17.0113V11.816H12.1893Z"
        fill="#F2F2F2"
        fillOpacity="0.94902"
      />
      <path
        d="M21.3652 11.5219H22.5803V19.3393H26.6944V20.4781H21.3652V11.5219Z"
        fill="#F2F2F2"
        fillOpacity="0.94902"
      />
      <path
        d="M26.9899 20.7723H21.0713V11.2278H22.8751V19.0453H26.9899V20.7723ZM21.6607 20.184H26.4012V19.6343H22.2872V11.816H21.6607V20.184Z"
        fill="#F2F2F2"
        fillOpacity="0.94902"
      />
      <path
        d="M27.2969 15.9999C27.2969 13.3438 29.2335 11.2941 31.9679 11.2941C34.7023 11.2941 36.6389 13.3431 36.6389 15.9999C36.6389 18.6568 34.7023 20.7058 31.9679 20.7058C29.2335 20.7058 27.2969 18.6561 27.2969 15.9999ZM35.3483 15.9999C35.3483 14.0392 34.0192 12.4328 31.9679 12.4328C29.9165 12.4328 28.5882 14.0392 28.5882 15.9999C28.5882 17.9607 29.9173 19.5671 31.9686 19.5671C34.02 19.5671 35.3483 17.9607 35.3483 15.9999Z"
        fill="#F2F2F2"
        fillOpacity="0.94902"
      />
      <path
        d="M31.9683 21C29.1373 21 27.0029 18.8507 27.0029 16C27.0029 13.1493 29.1381 11 31.9683 11C34.7985 11 36.9336 13.1493 36.9336 16C36.9336 18.8507 34.7993 21 31.9683 21ZM31.9683 11.5882C29.4324 11.5882 27.5916 13.4434 27.5916 16C27.5916 18.5566 29.4324 20.4118 31.9683 20.4118C34.5042 20.4118 36.3449 18.5566 36.3449 16C36.3449 13.4434 34.5042 11.5882 31.9683 11.5882ZM31.9683 19.8612C29.8392 19.8612 28.2935 18.2376 28.2935 16C28.2935 13.7624 29.8392 12.1388 31.9683 12.1388C34.0974 12.1388 35.643 13.7624 35.643 16C35.643 18.2376 34.0974 19.8612 31.9683 19.8612ZM31.9683 12.727C30.1803 12.727 28.883 14.1033 28.883 16C28.883 17.8967 30.1803 19.273 31.9683 19.273C33.7562 19.273 35.0536 17.8967 35.0536 16C35.0536 14.1033 33.7562 12.727 31.9683 12.727Z"
        fill="#F2F2F2"
        fillOpacity="0.94902"
      />
      <path
        d="M38.8105 11.5219H40.0257V20.4774H38.8105V11.5219Z"
        fill="#F2F2F2"
        fillOpacity="0.94902"
      />
      <path
        d="M40.3204 20.7723H38.5166V11.2278H40.3204V20.7723ZM39.1053 20.184H39.7317V11.816H39.1053V20.184Z"
        fill="#F2F2F2"
        fillOpacity="0.94902"
      />
      <path
        d="M7.13551 19.1244L4.19434 20.7752H10.3989V19.1244H7.13551Z"
        fill="#F2F2F2"
        fillOpacity="0.94902"
      />
    </svg>
  );
}
export function PowredByColored({ width }) {
  return (
    <svg
      width={width !== '' ? width : '173'}
      height="72"
      viewBox="0 0 173 72"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M7.27539 13.1798H3.57422V11.2365H7.27539C7.91992 11.2365 8.44076 11.1323 8.83789 10.924C9.23503 10.7156 9.52474 10.4292 9.70703 10.0646C9.89583 9.69348 9.99023 9.2703 9.99023 8.79504C9.99023 8.34583 9.89583 7.9259 9.70703 7.53528C9.52474 7.13814 9.23503 6.81913 8.83789 6.57825C8.44076 6.33736 7.91992 6.21692 7.27539 6.21692H4.32617V18.4825H1.875V4.26379H7.27539C8.37565 4.26379 9.3099 4.45911 10.0781 4.84973C10.8529 5.23385 11.4421 5.7677 11.8457 6.45129C12.2493 7.12838 12.4512 7.90312 12.4512 8.77551C12.4512 9.69348 12.2493 10.4812 11.8457 11.1388C11.4421 11.7963 10.8529 12.3009 10.0781 12.6525C9.3099 13.004 8.37565 13.1798 7.27539 13.1798ZM13.8281 13.3165V13.0919C13.8281 12.3302 13.9388 11.6238 14.1602 10.9728C14.3815 10.3152 14.7005 9.74556 15.1172 9.26379C15.5404 8.77551 16.0547 8.39791 16.6602 8.13098C17.2721 7.85754 17.9622 7.72083 18.7305 7.72083C19.5052 7.72083 20.1953 7.85754 20.8008 8.13098C21.4128 8.39791 21.9303 8.77551 22.3535 9.26379C22.7767 9.74556 23.099 10.3152 23.3203 10.9728C23.5417 11.6238 23.6523 12.3302 23.6523 13.0919V13.3165C23.6523 14.0782 23.5417 14.7846 23.3203 15.4357C23.099 16.0867 22.7767 16.6564 22.3535 17.1447C21.9303 17.6264 21.416 18.004 20.8105 18.2775C20.2051 18.5444 19.5182 18.6779 18.75 18.6779C17.9753 18.6779 17.2819 18.5444 16.6699 18.2775C16.0645 18.004 15.5501 17.6264 15.127 17.1447C14.7038 16.6564 14.3815 16.0867 14.1602 15.4357C13.9388 14.7846 13.8281 14.0782 13.8281 13.3165ZM16.1816 13.0919V13.3165C16.1816 13.7918 16.2305 14.241 16.3281 14.6642C16.4258 15.0874 16.5788 15.4585 16.7871 15.7775C16.9954 16.0965 17.2624 16.3471 17.5879 16.5294C17.9134 16.7117 18.3008 16.8029 18.75 16.8029C19.1862 16.8029 19.5638 16.7117 19.8828 16.5294C20.2083 16.3471 20.4753 16.0965 20.6836 15.7775C20.8919 15.4585 21.0449 15.0874 21.1426 14.6642C21.2467 14.241 21.2988 13.7918 21.2988 13.3165V13.0919C21.2988 12.6232 21.2467 12.1805 21.1426 11.7638C21.0449 11.3406 20.8887 10.9663 20.6738 10.6407C20.4655 10.3152 20.1986 10.0613 19.873 9.87903C19.554 9.69023 19.1732 9.59583 18.7305 9.59583C18.2878 9.59583 17.9036 9.69023 17.5781 9.87903C17.2591 10.0613 16.9954 10.3152 16.7871 10.6407C16.5788 10.9663 16.4258 11.3406 16.3281 11.7638C16.2305 12.1805 16.1816 12.6232 16.1816 13.0919ZM28.4961 16.1388L30.9375 7.91614H32.4414L32.0312 10.3771L29.5703 18.4825H28.2227L28.4961 16.1388ZM27.0605 7.91614L28.9648 16.1779L29.1211 18.4825H27.6172L24.7559 7.91614H27.0605ZM34.7266 16.0802L36.5723 7.91614H38.8672L36.0156 18.4825H34.5117L34.7266 16.0802ZM32.6953 7.91614L35.1074 16.0411L35.4102 18.4825H34.0625L31.5723 10.3673L31.1621 7.91614H32.6953ZM45.127 18.6779C44.3457 18.6779 43.6393 18.5509 43.0078 18.297C42.3828 18.0366 41.849 17.6753 41.4062 17.213C40.9701 16.7508 40.6348 16.2072 40.4004 15.5822C40.166 14.9572 40.0488 14.2833 40.0488 13.5607V13.17C40.0488 12.3432 40.1693 11.5945 40.4102 10.924C40.651 10.2534 40.9863 9.68046 41.416 9.2052C41.8457 8.72343 42.3535 8.35559 42.9395 8.10168C43.5254 7.84778 44.1602 7.72083 44.8438 7.72083C45.599 7.72083 46.2598 7.84778 46.8262 8.10168C47.3926 8.35559 47.8613 8.71366 48.2324 9.1759C48.61 9.63163 48.89 10.1753 49.0723 10.8068C49.2611 11.4383 49.3555 12.1349 49.3555 12.8966V13.9025H41.1914V12.213H47.0312V12.0275C47.0182 11.6043 46.9336 11.2072 46.7773 10.8361C46.6276 10.465 46.3965 10.1655 46.084 9.93762C45.7715 9.70976 45.3548 9.59583 44.834 9.59583C44.4434 9.59583 44.0951 9.68046 43.7891 9.84973C43.4896 10.0125 43.2389 10.2501 43.0371 10.5626C42.8353 10.8751 42.679 11.2527 42.5684 11.6954C42.4642 12.1316 42.4121 12.6232 42.4121 13.17V13.5607C42.4121 14.0229 42.474 14.4526 42.5977 14.8497C42.7279 15.2404 42.9167 15.5822 43.1641 15.8751C43.4115 16.1681 43.7109 16.3992 44.0625 16.5685C44.4141 16.7312 44.8145 16.8126 45.2637 16.8126C45.8301 16.8126 46.3346 16.6987 46.7773 16.4708C47.2201 16.243 47.6042 15.9207 47.9297 15.504L49.1699 16.7052C48.9421 17.0372 48.6458 17.3562 48.2812 17.6622C47.9167 17.9617 47.4707 18.2059 46.9434 18.3947C46.4225 18.5835 45.8171 18.6779 45.127 18.6779ZM53.5547 9.92786V18.4825H51.2012V7.91614H53.4473L53.5547 9.92786ZM56.7871 7.84778L56.7676 10.0353C56.6243 10.0092 56.4681 9.98971 56.2988 9.97668C56.1361 9.96366 55.9733 9.95715 55.8105 9.95715C55.4069 9.95715 55.0521 10.0157 54.7461 10.1329C54.4401 10.2436 54.1829 10.4064 53.9746 10.6212C53.7728 10.8295 53.6165 11.0835 53.5059 11.3829C53.3952 11.6824 53.3301 12.0177 53.3105 12.3888L52.7734 12.4279C52.7734 11.7638 52.8385 11.1486 52.9688 10.5822C53.099 10.0157 53.2943 9.5177 53.5547 9.08801C53.8216 8.65833 54.1536 8.32304 54.5508 8.08215C54.9544 7.84127 55.4199 7.72083 55.9473 7.72083C56.0905 7.72083 56.2435 7.73385 56.4062 7.75989C56.5755 7.78593 56.7025 7.81523 56.7871 7.84778ZM62.7246 18.6779C61.9434 18.6779 61.237 18.5509 60.6055 18.297C59.9805 18.0366 59.4466 17.6753 59.0039 17.213C58.5677 16.7508 58.2324 16.2072 57.998 15.5822C57.7637 14.9572 57.6465 14.2833 57.6465 13.5607V13.17C57.6465 12.3432 57.7669 11.5945 58.0078 10.924C58.2487 10.2534 58.584 9.68046 59.0137 9.2052C59.4434 8.72343 59.9512 8.35559 60.5371 8.10168C61.123 7.84778 61.7578 7.72083 62.4414 7.72083C63.1966 7.72083 63.8574 7.84778 64.4238 8.10168C64.9902 8.35559 65.459 8.71366 65.8301 9.1759C66.2077 9.63163 66.4876 10.1753 66.6699 10.8068C66.8587 11.4383 66.9531 12.1349 66.9531 12.8966V13.9025H58.7891V12.213H64.6289V12.0275C64.6159 11.6043 64.5312 11.2072 64.375 10.8361C64.2253 10.465 63.9941 10.1655 63.6816 9.93762C63.3691 9.70976 62.9525 9.59583 62.4316 9.59583C62.041 9.59583 61.6927 9.68046 61.3867 9.84973C61.0872 10.0125 60.8366 10.2501 60.6348 10.5626C60.4329 10.8751 60.2767 11.2527 60.166 11.6954C60.0618 12.1316 60.0098 12.6232 60.0098 13.17V13.5607C60.0098 14.0229 60.0716 14.4526 60.1953 14.8497C60.3255 15.2404 60.5143 15.5822 60.7617 15.8751C61.0091 16.1681 61.3086 16.3992 61.6602 16.5685C62.0117 16.7312 62.4121 16.8126 62.8613 16.8126C63.4277 16.8126 63.9323 16.6987 64.375 16.4708C64.8177 16.243 65.2018 15.9207 65.5273 15.504L66.7676 16.7052C66.5397 17.0372 66.2435 17.3562 65.8789 17.6622C65.5143 17.9617 65.0684 18.2059 64.541 18.3947C64.0202 18.5835 63.4147 18.6779 62.7246 18.6779ZM75.2344 16.295V3.48254H77.5977V18.4825H75.459L75.2344 16.295ZM68.3594 13.3165V13.1115C68.3594 12.3107 68.4538 11.5815 68.6426 10.924C68.8314 10.2599 69.1048 9.69023 69.4629 9.21497C69.821 8.73319 70.2572 8.36536 70.7715 8.11145C71.2858 7.85103 71.8652 7.72083 72.5098 7.72083C73.1478 7.72083 73.7077 7.84452 74.1895 8.09192C74.6712 8.33931 75.0814 8.69413 75.4199 9.15637C75.7585 9.6121 76.0286 10.159 76.2305 10.797C76.4323 11.4285 76.5755 12.1316 76.6602 12.9064V13.5607C76.5755 14.3159 76.4323 15.006 76.2305 15.631C76.0286 16.256 75.7585 16.7963 75.4199 17.2521C75.0814 17.7078 74.668 18.0594 74.1797 18.3068C73.6979 18.5542 73.1348 18.6779 72.4902 18.6779C71.8522 18.6779 71.276 18.5444 70.7617 18.2775C70.2539 18.0105 69.821 17.6362 69.4629 17.1544C69.1048 16.6726 68.8314 16.1062 68.6426 15.4552C68.4538 14.7976 68.3594 14.0848 68.3594 13.3165ZM70.7129 13.1115V13.3165C70.7129 13.7983 70.7552 14.2475 70.8398 14.6642C70.931 15.0809 71.071 15.4487 71.2598 15.7677C71.4486 16.0802 71.6927 16.3276 71.9922 16.5099C72.2982 16.6857 72.6628 16.7736 73.0859 16.7736C73.6198 16.7736 74.0592 16.6564 74.4043 16.422C74.7493 16.1876 75.0195 15.8719 75.2148 15.4747C75.4167 15.0711 75.5534 14.6219 75.625 14.1271V12.3595C75.5859 11.9754 75.5046 11.6173 75.3809 11.2853C75.2637 10.9532 75.1042 10.6635 74.9023 10.4161C74.7005 10.1622 74.4499 9.96692 74.1504 9.8302C73.8574 9.68697 73.5091 9.61536 73.1055 9.61536C72.6758 9.61536 72.3112 9.7065 72.0117 9.88879C71.7122 10.0711 71.4648 10.3217 71.2695 10.6407C71.0807 10.9598 70.9408 11.3309 70.8496 11.754C70.7585 12.1772 70.7129 12.6297 70.7129 13.1115ZM90.6055 12.0568H86.9824L86.9629 10.2697H90.127C90.6608 10.2697 91.1133 10.1915 91.4844 10.0353C91.862 9.87252 92.1484 9.6414 92.3438 9.34192C92.5391 9.03593 92.6367 8.66809 92.6367 8.2384C92.6367 7.76314 92.5456 7.37577 92.3633 7.07629C92.181 6.77681 91.901 6.55872 91.5234 6.422C91.1523 6.28528 90.6771 6.21692 90.0977 6.21692H87.7246V18.4825H85.2734V4.26379H90.0977C90.8789 4.26379 91.5755 4.33866 92.1875 4.4884C92.806 4.63814 93.3301 4.87252 93.7598 5.19153C94.196 5.50403 94.5247 5.90116 94.7461 6.38293C94.974 6.86471 95.0879 7.43762 95.0879 8.10168C95.0879 8.68762 94.9479 9.22473 94.668 9.71301C94.388 10.1948 93.9746 10.5887 93.4277 10.8947C92.8809 11.2006 92.2005 11.3829 91.3867 11.4415L90.6055 12.0568ZM90.498 18.4825H86.2109L87.3145 16.5392H90.498C91.0514 16.5392 91.5137 16.448 91.8848 16.2657C92.2559 16.0769 92.5326 15.8198 92.7148 15.4943C92.9036 15.1622 92.998 14.7749 92.998 14.3322C92.998 13.8699 92.9167 13.4695 92.7539 13.131C92.5911 12.7859 92.334 12.5223 91.9824 12.34C91.6309 12.1512 91.1719 12.0568 90.6055 12.0568H87.8516L87.8711 10.2697H91.4551L92.0117 10.9435C92.793 10.9695 93.4342 11.142 93.9355 11.4611C94.4434 11.7801 94.821 12.1935 95.0684 12.7013C95.3158 13.2091 95.4395 13.756 95.4395 14.3419C95.4395 15.2469 95.2409 16.0053 94.8438 16.6173C94.4531 17.2293 93.89 17.6948 93.1543 18.0138C92.4186 18.3263 91.5332 18.4825 90.498 18.4825ZM100.742 17.3302L103.613 7.91614H106.133L101.895 20.0939C101.797 20.3543 101.67 20.6375 101.514 20.9435C101.357 21.2495 101.152 21.5392 100.898 21.8126C100.651 22.0926 100.342 22.3172 99.9707 22.4865C99.5996 22.6622 99.1504 22.7501 98.623 22.7501C98.4147 22.7501 98.2129 22.7306 98.0176 22.6915C97.8288 22.659 97.6497 22.6232 97.4805 22.5841L97.4707 20.7872C97.5358 20.7937 97.6139 20.8003 97.7051 20.8068C97.8027 20.8133 97.8809 20.8165 97.9395 20.8165C98.3301 20.8165 98.6556 20.7677 98.916 20.67C99.1764 20.5789 99.388 20.4292 99.5508 20.2208C99.7201 20.0125 99.8633 19.7325 99.9805 19.381L100.742 17.3302ZM99.1211 7.91614L101.631 15.8263L102.051 18.3068L100.42 18.7267L96.582 7.91614H99.1211Z"
        fill="#C9C9C9"
      />
      <path
        d="M43.6778 69.0484H21.5736C10.6813 69.0484 1.68848 60.8726 1.68848 49.4497C1.68848 38.1882 10.3034 29.7445 21.5187 29.7445C32.3011 29.7445 41.0775 37.972 41.0775 48.9107C41.0775 55.4081 37.9894 61.7958 32.3011 64.3941V64.5038H43.6778V69.0484ZM35.5506 49.1237C35.5506 41.0028 29.536 34.6151 21.3539 34.6151C13.3333 34.6151 7.21212 41.0577 7.21212 49.0172C7.21212 57.4093 13.0103 64.1746 21.3539 64.1746C29.7557 64.1746 35.5506 57.5158 35.5506 49.1237Z"
        fill="#1D3E69"
      />
      <path
        d="M44.9386 70.3074H21.5746C9.71651 70.3074 0.429688 61.1439 0.429688 49.4499C0.429688 37.4976 9.49685 28.4858 21.5197 28.4858C33.1936 28.4858 42.3383 37.4589 42.3383 48.9109C42.3383 54.7207 40.0771 59.9626 36.3463 63.2451H44.9386V70.3074ZM21.5197 31.0002C10.9343 31.0002 2.94924 38.9307 2.94924 49.4466C2.94924 59.9012 10.9569 67.7866 21.5746 67.7866H42.419V65.7563H31.0423V63.5808L31.7788 63.2451C36.6628 61.0148 39.8187 55.3857 39.8187 48.9076C39.8187 38.8662 31.782 31.0002 21.5197 31.0002ZM21.3581 65.4335C12.5785 65.4335 5.95656 58.3745 5.95656 49.0174C5.95656 40.2347 12.7206 33.3565 21.3581 33.3565C30.1701 33.3565 36.8146 40.1347 36.8146 49.1239C36.8146 58.4229 30.1701 65.4335 21.3581 65.4335ZM21.3581 35.8741C14.1354 35.8741 8.47611 41.6485 8.47611 49.0174C8.47611 56.9414 14.0127 62.9159 21.3581 62.9159C28.8522 62.9159 34.2919 57.1157 34.2919 49.1239C34.2919 41.571 28.7327 35.8741 21.3581 35.8741Z"
        fill="#1D3E69"
      />
      <path
        d="M56.5405 30.7161V54.2139C56.5405 58.978 58.9244 65.1494 66.1858 65.1494C73.4473 65.1494 75.8312 58.978 75.8312 54.2139V30.7161H81.0318V55.024C81.0318 63.9035 74.5844 70.02 66.1858 70.02C57.7873 70.02 51.3398 63.9035 51.3398 55.024V30.7161H56.5405Z"
        fill="#1D3E69"
      />
      <path
        d="M66.1868 71.2821C56.8548 71.2821 50.0811 64.4458 50.0811 55.0273V29.4573H57.8012V54.2139C57.8012 58.6778 59.9978 63.8906 66.1868 63.8906C72.3759 63.8906 74.5724 58.6778 74.5724 54.2139V29.4573H82.2926V55.024C82.2926 64.4458 75.5189 71.2821 66.1868 71.2821ZM52.6006 31.9749V55.024C52.6006 62.9836 58.3148 68.7612 66.1868 68.7612C74.0588 68.7612 79.7698 62.9868 79.7698 55.024V31.9749H77.0888V54.2107C77.0888 60.282 73.7164 66.405 66.1836 66.405C58.6508 66.405 55.2784 60.2788 55.2784 54.2107V31.9749H52.6006Z"
        fill="#1D3E69"
      />
      <path
        d="M91.876 30.7161H97.0766V64.1746H114.684V69.0485H91.876V30.7161Z"
        fill="#2DC1DB"
      />
      <path
        d="M115.948 70.3073H90.6172V29.4573H98.3374V62.9158H115.948V70.3073ZM93.14 67.7897H113.429V65.4367H95.821V31.9749H93.14V67.7897Z"
        fill="#2DC1DB"
      />
      <path
        d="M117.26 49.8823C117.26 38.5143 125.548 29.7413 137.251 29.7413C148.954 29.7413 157.243 38.511 157.243 49.8823C157.243 61.2536 148.954 70.0233 137.251 70.0233C125.548 70.0233 117.26 61.2503 117.26 49.8823ZM151.72 49.8823C151.72 41.4902 146.031 34.6152 137.251 34.6152C128.472 34.6152 122.787 41.4902 122.787 49.8823C122.787 58.2744 128.475 65.1494 137.255 65.1494C146.034 65.1494 151.72 58.2744 151.72 49.8823Z"
        fill="#2DC1DB"
      />
      <path
        d="M137.254 71.2821C125.138 71.2821 116.003 62.0831 116.003 49.8823C116.003 37.6815 125.141 28.4825 137.254 28.4825C149.368 28.4825 158.506 37.6815 158.506 49.8823C158.506 62.0831 149.371 71.2821 137.254 71.2821ZM137.254 31.0002C126.401 31.0002 118.522 38.9404 118.522 49.8823C118.522 60.8243 126.401 68.7645 137.254 68.7645C148.108 68.7645 155.986 60.8243 155.986 49.8823C155.986 38.9404 148.108 31.0002 137.254 31.0002ZM137.254 66.4082C128.142 66.4082 121.527 59.459 121.527 49.8823C121.527 40.3057 128.142 33.3564 137.254 33.3564C146.367 33.3564 152.982 40.3057 152.982 49.8823C152.982 59.459 146.367 66.4082 137.254 66.4082ZM137.254 35.874C129.602 35.874 124.049 41.7646 124.049 49.8823C124.049 58 129.602 63.8906 137.254 63.8906C144.907 63.8906 150.459 58 150.459 49.8823C150.459 41.7646 144.907 35.874 137.254 35.874Z"
        fill="#2DC1DB"
      />
      <path
        d="M166.538 30.7161H171.739V69.0452H166.538V30.7161Z"
        fill="#2DC1DB"
      />
      <path
        d="M172.999 70.3073H165.279V29.4573H172.999V70.3073ZM167.799 67.7897H170.48V31.9749H167.799V67.7897Z"
        fill="#2DC1DB"
      />
      <path
        d="M30.967 63.2548L18.3789 70.3202H44.9344V63.2548H30.967Z"
        fill="#2DC1DB"
      />
    </svg>
  );
}
PowredByColored.propTypes = {
  width: PropTypes.number,
};
PowredByColored.defaultProps = {
  width: 172,
};
export function ReviewNoData() {
  return (
    <svg
      width="34.653vw"
      height="25.972vw"
      viewBox="0 0 499 374"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect width="34.653vw" height="25.972vw" fill="white" />
      <g filter="url(#filter0_f_7122_29280)">
        <ellipse cx="246.5" cy="291.5" rx="92.5" ry="21.5" fill="#FFEBE7" />
      </g>
      <path
        d="M247.701 308.402C311.049 308.402 362.402 257.049 362.402 193.701C362.402 130.353 311.049 79 247.701 79C184.353 79 133 130.353 133 193.701C133 257.049 184.353 308.402 247.701 308.402Z"
        fill="url(#paint0_linear_7122_29280)"
      />
      <path
        d="M304.577 94H189.08C184.782 94 180.661 95.7072 177.622 98.746C174.583 101.785 172.876 105.906 172.876 110.204V241.815H173.074V288.032C173.074 289.816 173.531 291.571 174.402 293.129C175.273 294.686 176.528 295.995 178.048 296.929C179.569 297.864 181.303 298.393 183.086 298.466C184.869 298.54 186.641 298.155 188.233 297.349L241.508 270.343C242.959 269.615 244.561 269.236 246.185 269.236C247.808 269.236 249.41 269.615 250.861 270.343L305.774 297.547C307.367 298.336 309.136 298.706 310.912 298.621C312.687 298.535 314.412 297.998 315.922 297.059C317.432 296.121 318.678 294.812 319.541 293.258C320.404 291.703 320.855 289.954 320.853 288.176L320.709 241.815V110.159C320.697 105.882 318.994 101.782 315.972 98.7554C312.95 95.7284 308.854 94.019 304.577 94V94Z"
        fill="url(#paint1_linear_7122_29280)"
      />
      <g filter="url(#filter1_dd_7122_29280)">
        <path
          d="M377 136.625C377.004 140.128 375.734 143.512 373.426 146.148C371.118 148.783 367.931 150.489 364.459 150.948C363.824 151.029 363.185 151.071 362.545 151.073H314.487C313.445 151.07 312.404 150.984 311.375 150.816C306.958 150.054 302.978 147.684 300.203 144.164C297.428 140.644 296.052 136.221 296.342 131.748C296.632 127.275 298.566 123.066 301.772 119.934C304.979 116.801 309.23 114.965 313.709 114.778C316.031 109.738 319.928 105.589 324.814 102.958C329.699 100.326 335.308 99.3545 340.794 100.19C346.28 101.025 351.346 103.621 355.227 107.588C359.109 111.554 361.595 116.674 362.311 122.177H362.529C364.428 122.174 366.31 122.546 368.065 123.27C369.821 123.995 371.416 125.059 372.76 126.401C374.104 127.743 375.171 129.336 375.898 131.091C376.626 132.845 377 134.726 377 136.625Z"
          fill="url(#paint2_linear_7122_29280)"
        />
      </g>
      <g filter="url(#filter2_dd_7122_29280)">
        <path
          d="M132.625 108.328C132.625 111.217 133.773 113.987 135.815 116.03C137.858 118.073 140.628 119.22 143.517 119.22H179.679C183.242 119.201 186.657 117.792 189.196 115.293C191.735 112.793 193.198 109.401 193.273 105.839C193.348 102.277 192.029 98.8258 189.598 96.2216C187.166 93.6174 183.814 92.0655 180.255 91.8966C178.499 88.1158 175.565 85.0063 171.892 83.0351C168.219 81.0638 164.006 80.3371 159.885 80.964C155.764 81.5909 151.958 83.5377 149.037 86.5119C146.117 89.4862 144.24 93.3276 143.688 97.4593H143.525C140.639 97.4573 137.87 98.6007 135.826 100.639C133.783 102.676 132.631 105.442 132.625 108.328V108.328Z"
          fill="url(#paint3_linear_7122_29280)"
        />
      </g>
      <g filter="url(#filter3_f_7122_29280)">
        <ellipse
          cx="251.612"
          cy="216.179"
          rx="52.1402"
          ry="11.1729"
          fill="#39A8D3"
          fillOpacity="0.39"
        />
      </g>
      <g filter="url(#filter4_dd_7122_29280)">
        <path
          d="M251.113 119.8L263.932 145.771C264.312 146.541 264.874 147.207 265.569 147.712C266.263 148.217 267.07 148.546 267.92 148.67L296.574 152.802C297.544 152.951 298.454 153.366 299.202 154.001C299.951 154.636 300.508 155.466 300.812 156.4C301.116 157.333 301.156 158.332 300.925 159.286C300.695 160.241 300.205 161.112 299.509 161.804L278.804 182.014C278.188 182.613 277.728 183.353 277.462 184.171C277.197 184.988 277.135 185.857 277.282 186.704L282.179 215.241C282.347 216.216 282.239 217.22 281.866 218.137C281.493 219.054 280.871 219.848 280.07 220.43C279.269 221.012 278.321 221.358 277.334 221.429C276.346 221.499 275.359 221.292 274.483 220.831L248.854 207.328C248.093 206.929 247.246 206.72 246.387 206.72C245.528 206.72 244.681 206.929 243.92 207.328L218.291 220.831C217.416 221.29 216.429 221.495 215.443 221.423C214.457 221.351 213.511 221.005 212.712 220.423C211.912 219.842 211.291 219.048 210.918 218.133C210.546 217.217 210.437 216.215 210.604 215.241L215.492 186.704C215.639 185.857 215.577 184.988 215.312 184.171C215.046 183.353 214.586 182.613 213.97 182.014L193.265 161.804C192.569 161.112 192.079 160.241 191.849 159.286C191.618 158.332 191.658 157.333 191.962 156.4C192.266 155.466 192.823 154.636 193.572 154.001C194.32 153.366 195.23 152.951 196.2 152.802L224.854 148.643C225.704 148.519 226.511 148.19 227.205 147.685C227.9 147.18 228.462 146.514 228.842 145.744L241.661 119.773C242.107 118.902 242.785 118.172 243.621 117.663C244.457 117.153 245.417 116.885 246.395 116.888C247.374 116.891 248.332 117.164 249.165 117.678C249.998 118.192 250.672 118.927 251.113 119.8Z"
          fill="url(#paint4_linear_7122_29280)"
        />
      </g>
      <g filter="url(#filter5_dd_7122_29280)">
        <path
          d="M123 247.589C122.998 251.077 124.265 254.447 126.564 257.071C128.862 259.694 132.037 261.393 135.495 261.85C136.124 261.937 136.758 261.981 137.393 261.982H185.241C186.283 261.98 187.324 261.895 188.353 261.725C192.776 260.989 196.769 258.635 199.555 255.122C202.342 251.608 203.724 247.184 203.433 242.709C203.142 238.234 201.199 234.027 197.982 230.903C194.764 227.779 190.5 225.962 186.019 225.805C183.704 220.789 179.822 216.661 174.958 214.043C170.093 211.425 164.51 210.459 159.048 211.29C153.587 212.122 148.544 214.705 144.679 218.652C140.814 222.599 138.336 227.695 137.619 233.172H137.393C135.501 233.172 133.628 233.545 131.88 234.27C130.132 234.995 128.544 236.057 127.207 237.396C125.871 238.735 124.811 240.325 124.089 242.074C123.367 243.823 122.997 245.697 123 247.589V247.589Z"
          fill="url(#paint5_linear_7122_29280)"
        />
      </g>
      <path
        d="M338.523 168.046C338.208 166.811 339.348 165.699 340.575 166.043L348.855 168.37C350.081 168.715 350.475 170.258 349.563 171.148L343.408 177.156C342.496 178.046 340.963 177.615 340.648 176.38L338.523 168.046Z"
        fill="url(#paint6_linear_7122_29280)"
      />
      <path
        d="M244.631 306.559C244.316 305.324 245.456 304.212 246.683 304.556L254.963 306.883C256.19 307.228 256.583 308.771 255.671 309.661L249.516 315.669C248.604 316.559 247.071 316.128 246.756 314.893L244.631 306.559Z"
        fill="url(#paint7_linear_7122_29280)"
      />
      <path
        d="M291.631 79.5587C291.316 78.324 292.456 77.2115 293.683 77.5563L301.963 79.8831C303.19 80.2278 303.583 81.7712 302.671 82.6612L296.516 88.6686C295.604 89.5586 294.071 89.1277 293.756 87.893L291.631 79.5587Z"
        fill="url(#paint8_linear_7122_29280)"
      />
      <path
        d="M128.928 202.681C130.167 202.386 131.262 203.543 130.898 204.765L128.441 213.007C128.077 214.228 126.527 214.597 125.652 213.671L119.742 207.422C118.867 206.496 119.322 204.97 120.561 204.675L128.928 202.681Z"
        fill="url(#paint9_linear_7122_29280)"
      />
      <path
        d="M211.611 68.9987C212.1 66.9717 214.983 66.9717 215.472 68.9987L217.119 75.8206C217.294 76.5449 217.86 77.1105 218.584 77.2853L225.406 78.9321C227.433 79.4214 227.433 82.3045 225.406 82.7938L218.584 84.4406C217.86 84.6154 217.294 85.181 217.119 85.9053L215.472 92.7272C214.983 94.7542 212.1 94.7542 211.611 92.7272L209.964 85.9053C209.789 85.181 209.224 84.6154 208.499 84.4406L201.677 82.7938C199.65 82.3045 199.65 79.4214 201.677 78.9321L208.499 77.2853C209.224 77.1105 209.789 76.5449 209.964 75.8206L211.611 68.9987Z"
        fill="url(#paint10_linear_7122_29280)"
      />
      <path
        d="M306.345 297.793C306.345 300.307 304.307 302.345 301.793 302.345C299.279 302.345 297.241 300.307 297.241 297.793C297.241 295.279 299.279 293.241 301.793 293.241C304.307 293.241 306.345 295.279 306.345 297.793Z"
        stroke="url(#paint11_linear_7122_29280)"
        strokeWidth="2.48287"
      />
      <path
        d="M337.41 250.248C337.899 248.221 340.782 248.221 341.271 250.248L342.918 257.07C343.093 257.794 343.658 258.36 344.383 258.535L351.205 260.182C353.232 260.671 353.232 263.554 351.205 264.043L344.383 265.69C343.658 265.865 343.093 266.43 342.918 267.155L341.271 273.977C340.782 276.004 337.899 276.004 337.41 273.977L335.763 267.155C335.588 266.43 335.022 265.865 334.298 265.69L327.476 264.043C325.449 263.554 325.449 260.671 327.476 260.182L334.298 258.535C335.022 258.36 335.588 257.794 335.763 257.07L337.41 250.248Z"
        fill="url(#paint12_linear_7122_29280)"
      />
      <path
        d="M191.932 291.999C192.421 289.972 195.304 289.972 195.794 291.999L197.441 298.821C197.615 299.545 198.181 300.11 198.905 300.285L205.727 301.932C207.754 302.421 207.754 305.304 205.727 305.794L198.905 307.441C198.181 307.615 197.615 308.181 197.441 308.905L195.794 315.727C195.304 317.754 192.421 317.754 191.932 315.727L190.285 308.905C190.11 308.181 189.545 307.615 188.821 307.441L181.999 305.794C179.972 305.304 179.972 302.421 181.999 301.932L188.821 300.285C189.545 300.11 190.11 299.545 190.285 298.821L191.932 291.999Z"
        fill="url(#paint13_linear_7122_29280)"
      />
      <circle
        cx="345.134"
        cy="221.559"
        r="4.55192"
        stroke="url(#paint14_linear_7122_29280)"
        strokeWidth="2.48287"
      />
      <circle
        cx="125.793"
        cy="130.793"
        r="4.55192"
        stroke="url(#paint15_linear_7122_29280)"
        strokeWidth="2.48287"
      />
      <path
        d="M126.278 166.624C126.983 171.891 129.011 176.893 132.173 181.164C135.334 185.435 139.526 188.836 144.356 191.05C149.187 193.263 154.5 194.216 159.799 193.821C165.098 193.426 170.211 191.696 174.66 188.791L186.783 192.912C187.148 193.032 187.541 193.045 187.914 192.95C188.287 192.854 188.625 192.654 188.887 192.373C189.15 192.091 189.327 191.74 189.396 191.362C189.466 190.983 189.426 190.592 189.28 190.236L184.419 178.64C187.004 174.332 188.521 169.468 188.84 164.455C189.16 159.441 188.275 154.424 186.257 149.823C184.24 145.222 181.15 141.171 177.246 138.01C173.342 134.848 168.737 132.668 163.818 131.651C158.898 130.634 153.806 130.811 148.968 132.166C144.131 133.521 139.688 136.015 136.013 139.439C132.337 142.864 129.535 147.119 127.841 151.849C126.148 156.578 125.612 161.645 126.278 166.624V166.624Z"
        fill="url(#paint16_linear_7122_29280)"
      />
      <path
        d="M156.628 178.545C160.044 178.545 162.477 176.206 162.477 172.931C162.477 169.656 160.044 167.316 156.628 167.316C153.26 167.316 150.78 169.656 150.78 172.931C150.78 176.206 153.26 178.545 156.628 178.545ZM161.307 166.381C161.307 163.293 163.085 162.17 165.518 161.047C168.746 159.55 171.132 156.509 171.132 152.766C171.132 146.871 165.331 142.754 157.471 142.754C149.049 142.754 143.107 147.479 142.593 154.076L153.353 156.041C153.634 153.468 154.991 151.643 156.909 151.643C158.36 151.643 159.436 152.626 159.436 153.982C159.436 155.573 157.845 156.556 156.582 157.304C153.213 159.503 151.95 161.936 151.95 166.381H161.307Z"
        fill="white"
      />
      <defs>
        <filter
          id="filter0_f_7122_29280"
          x="132.227"
          y="248.227"
          width="228.546"
          height="86.546"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="BackgroundImageFix"
            result="shape"
          />
          <feGaussianBlur
            stdDeviation="10.8865"
            result="effect1_foregroundBlur_7122_29280"
          />
        </filter>
        <filter
          id="filter1_dd_7122_29280"
          x="277.304"
          y="80.8983"
          width="118.696"
          height="89.1742"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dx="-4" dy="-4" />
          <feGaussianBlur stdDeviation="7.5" />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0.409836 0 0 0 0 1 0 0 0 0.15 0"
          />
          <feBlend
            mode="normal"
            in2="BackgroundImageFix"
            result="effect1_dropShadow_7122_29280"
          />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dx="4" dy="4" />
          <feGaussianBlur stdDeviation="7.5" />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0.411765 0 0 0 0 1 0 0 0 0.15 0"
          />
          <feBlend
            mode="normal"
            in2="effect1_dropShadow_7122_29280"
            result="effect2_dropShadow_7122_29280"
          />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect2_dropShadow_7122_29280"
            result="shape"
          />
        </filter>
        <filter
          id="filter2_dd_7122_29280"
          x="113.625"
          y="61.7449"
          width="98.6511"
          height="76.4753"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dx="-4" dy="-4" />
          <feGaussianBlur stdDeviation="7.5" />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0.409836 0 0 0 0 1 0 0 0 0.15 0"
          />
          <feBlend
            mode="normal"
            in2="BackgroundImageFix"
            result="effect1_dropShadow_7122_29280"
          />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dx="4" dy="4" />
          <feGaussianBlur stdDeviation="7.5" />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0.411765 0 0 0 0 1 0 0 0 0.15 0"
          />
          <feBlend
            mode="normal"
            in2="effect1_dropShadow_7122_29280"
            result="effect2_dropShadow_7122_29280"
          />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect2_dropShadow_7122_29280"
            result="shape"
          />
        </filter>
        <filter
          id="filter3_f_7122_29280"
          x="178.782"
          y="184.316"
          width="145.662"
          height="63.727"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="BackgroundImageFix"
            result="shape"
          />
          <feGaussianBlur
            stdDeviation="10.3453"
            result="effect1_foregroundBlur_7122_29280"
          />
        </filter>
        <filter
          id="filter4_dd_7122_29280"
          x="172.701"
          y="97.8881"
          width="147.373"
          height="142.554"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dx="-4" dy="-4" />
          <feGaussianBlur stdDeviation="7.5" />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0.409836 0 0 0 0 1 0 0 0 0.15 0"
          />
          <feBlend
            mode="normal"
            in2="BackgroundImageFix"
            result="effect1_dropShadow_7122_29280"
          />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dx="4" dy="4" />
          <feGaussianBlur stdDeviation="7.5" />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0.411765 0 0 0 0 1 0 0 0 0.15 0"
          />
          <feBlend
            mode="normal"
            in2="effect1_dropShadow_7122_29280"
            result="effect2_dropShadow_7122_29280"
          />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect2_dropShadow_7122_29280"
            result="shape"
          />
        </filter>
        <filter
          id="filter5_dd_7122_29280"
          x="104"
          y="192"
          width="118.471"
          height="88.9819"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dx="-4" dy="-4" />
          <feGaussianBlur stdDeviation="7.5" />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0.409836 0 0 0 0 1 0 0 0 0.15 0"
          />
          <feBlend
            mode="normal"
            in2="BackgroundImageFix"
            result="effect1_dropShadow_7122_29280"
          />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dx="4" dy="4" />
          <feGaussianBlur stdDeviation="7.5" />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0.411765 0 0 0 0 1 0 0 0 0.15 0"
          />
          <feBlend
            mode="normal"
            in2="effect1_dropShadow_7122_29280"
            result="effect2_dropShadow_7122_29280"
          />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect2_dropShadow_7122_29280"
            result="shape"
          />
        </filter>
        <linearGradient
          id="paint0_linear_7122_29280"
          x1="246.817"
          y1="41.6505"
          x2="249.167"
          y2="444.463"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#CAE0FF" stopOpacity="0" />
          <stop offset="1" stopColor="#BCD8FF" />
        </linearGradient>
        <linearGradient
          id="paint1_linear_7122_29280"
          x1="246.864"
          y1="94"
          x2="246.864"
          y2="298.633"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#90B6F0" />
          <stop offset="1" stopColor="#0088FA" />
        </linearGradient>
        <linearGradient
          id="paint2_linear_7122_29280"
          x1="336.652"
          y1="99.8983"
          x2="336.652"
          y2="151.073"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#90B6F0" />
          <stop offset="1" stopColor="#0088FA" />
        </linearGradient>
        <linearGradient
          id="paint3_linear_7122_29280"
          x1="162.951"
          y1="80.7449"
          x2="162.951"
          y2="119.22"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#90B6F0" />
          <stop offset="1" stopColor="#0088FA" />
        </linearGradient>
        <linearGradient
          id="paint4_linear_7122_29280"
          x1="200.525"
          y1="144.939"
          x2="396.375"
          y2="221.347"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#FFDEAC" />
          <stop offset="0.70369" stopColor="#FF426F" />
        </linearGradient>
        <linearGradient
          id="paint5_linear_7122_29280"
          x1="163.235"
          y1="211"
          x2="163.235"
          y2="261.982"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#90B6F0" />
          <stop offset="1" stopColor="#0088FA" />
        </linearGradient>
        <linearGradient
          id="paint6_linear_7122_29280"
          x1="337.672"
          y1="176.971"
          x2="349.518"
          y2="165.41"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#1987D8" />
          <stop offset="1" stopColor="#45B4D0" />
        </linearGradient>
        <linearGradient
          id="paint7_linear_7122_29280"
          x1="243.781"
          y1="315.484"
          x2="255.626"
          y2="303.923"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#1987D8" />
          <stop offset="1" stopColor="#45B4D0" />
        </linearGradient>
        <linearGradient
          id="paint8_linear_7122_29280"
          x1="290.781"
          y1="88.4841"
          x2="302.626"
          y2="76.9229"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#1987D8" />
          <stop offset="1" stopColor="#45B4D0" />
        </linearGradient>
        <linearGradient
          id="paint9_linear_7122_29280"
          x1="120.017"
          y1="201.69"
          x2="131.39"
          y2="213.717"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#1987D8" />
          <stop offset="1" stopColor="#45B4D0" />
        </linearGradient>
        <linearGradient
          id="paint10_linear_7122_29280"
          x1="193.679"
          y1="80.8629"
          x2="233.405"
          y2="80.8629"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#1987D8" />
          <stop offset="1" stopColor="#45B4D0" />
        </linearGradient>
        <linearGradient
          id="paint11_linear_7122_29280"
          x1="296"
          y1="297.793"
          x2="307.587"
          y2="297.793"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#1987D8" />
          <stop offset="1" stopColor="#45B4D0" />
        </linearGradient>
        <linearGradient
          id="paint12_linear_7122_29280"
          x1="319.478"
          y1="262.112"
          x2="359.203"
          y2="262.112"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#1987D8" />
          <stop offset="1" stopColor="#45B4D0" />
        </linearGradient>
        <linearGradient
          id="paint13_linear_7122_29280"
          x1="174"
          y1="303.863"
          x2="213.726"
          y2="303.863"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#1987D8" />
          <stop offset="1" stopColor="#45B4D0" />
        </linearGradient>
        <linearGradient
          id="paint14_linear_7122_29280"
          x1="339.34"
          y1="221.559"
          x2="350.927"
          y2="221.559"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#1987D8" />
          <stop offset="1" stopColor="#45B4D0" />
        </linearGradient>
        <linearGradient
          id="paint15_linear_7122_29280"
          x1="120"
          y1="130.793"
          x2="131.587"
          y2="130.793"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#1987D8" />
          <stop offset="1" stopColor="#45B4D0" />
        </linearGradient>
        <linearGradient
          id="paint16_linear_7122_29280"
          x1="126.303"
          y1="135.233"
          x2="188.979"
          y2="194.636"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#FF698D" />
          <stop offset="1" stopColor="#FF3868" />
        </linearGradient>
      </defs>
    </svg>
  );
}
export function GraphIcon({ color }) {
  return (
    <svg
      width="0.694vw"
      height="0.764vw"
      viewBox="0 0 10 11"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M9.02923 3.39624C8.76257 2.49207 8.0084 1.73791 7.10423 1.47124C6.41673 1.27124 5.94173 1.28791 5.61257 1.53374C5.21673 1.82957 5.1709 2.36291 5.1709 2.74207V3.77957C5.1709 4.80457 5.63756 5.32541 6.55423 5.32541H7.75007C8.12507 5.32541 8.66256 5.27957 8.9584 4.88374C9.21256 4.55874 9.2334 4.08374 9.02923 3.39624Z"
        fill={color !== '' ? color : '#0088FA'}
      />
      <path
        d="M7.87925 6.06648C7.77091 5.94148 7.61258 5.87065 7.45008 5.87065H5.95841C5.22508 5.87065 4.62925 5.27482 4.62925 4.54148V3.04982C4.62925 2.88732 4.55841 2.72899 4.43341 2.62065C4.31258 2.51232 4.14591 2.46232 3.98758 2.48315C3.00841 2.60815 2.10841 3.14565 1.52091 3.95398C0.929246 4.76648 0.71258 5.75815 0.90008 6.74982C1.17091 8.18315 2.31675 9.32899 3.75425 9.59982C3.98341 9.64565 4.21258 9.66649 4.44175 9.66649C5.19591 9.66649 5.92508 9.43315 6.54591 8.97898C7.35425 8.39148 7.89175 7.49148 8.01675 6.51232C8.03758 6.34982 7.98758 6.18732 7.87925 6.06648Z"
        fill={color !== '' ? color : '#0088FA'}
      />
    </svg>
  );
}
GraphIcon.propTypes = {
  color: PropTypes.string,
};
GraphIcon.defaultProps = {
  color: '',
};
export function DetailsIcon() {
  return (
    <svg
      width="0.694vw"
      height="0.694vw"
      viewBox="0 0 10 10"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M7.91669 3.3335C8.60704 3.3335 9.16669 2.77385 9.16669 2.0835C9.16669 1.39314 8.60704 0.833496 7.91669 0.833496C7.22633 0.833496 6.66669 1.39314 6.66669 2.0835C6.66669 2.77385 7.22633 3.3335 7.91669 3.3335Z"
        fill="#0088FA"
      />
      <path
        d="M8.24998 3.925C8.24165 3.925 8.23331 3.92917 8.22498 3.92917C8.18331 3.9375 8.14165 3.94167 8.09581 3.95C7.92081 3.96667 7.73331 3.95833 7.54165 3.92083C7.49165 3.90833 7.44998 3.9 7.40415 3.88333C7.26665 3.85 7.13748 3.79583 7.01665 3.725C6.96665 3.7 6.91665 3.66667 6.87081 3.6375C6.67081 3.5 6.49998 3.32917 6.36248 3.12917C6.33331 3.08333 6.29998 3.03333 6.27498 2.98333C6.20415 2.8625 6.14998 2.73333 6.11665 2.59583C6.09998 2.55 6.09165 2.50833 6.07915 2.45833C6.04165 2.26667 6.03331 2.07917 6.04998 1.90417C6.05831 1.85833 6.06248 1.81667 6.07081 1.775C6.07081 1.76667 6.07498 1.75833 6.07498 1.75C6.12498 1.49167 5.93331 1.25 5.66665 1.25H3.13331C3.07498 1.25 3.01665 1.25417 2.96248 1.25833C2.91248 1.2625 2.86665 1.26667 2.81665 1.275C2.76665 1.27917 2.71665 1.2875 2.67081 1.29583C1.66665 1.44167 1.02498 2.07917 0.879146 3.0875C0.870813 3.13333 0.86248 3.18333 0.858313 3.23333C0.84998 3.28333 0.845813 3.32917 0.841646 3.37917C0.83748 3.43333 0.833313 3.49167 0.833313 3.55V6.86667C0.833313 6.925 0.83748 6.98333 0.841646 7.0375C0.845813 7.0875 0.84998 7.13333 0.858313 7.18333C0.86248 7.23333 0.870813 7.28333 0.879146 7.32917C1.02498 8.3375 1.66665 8.975 2.67081 9.12083C2.71665 9.12917 2.76665 9.1375 2.81665 9.14167C2.86665 9.15 2.91248 9.15417 2.96248 9.15833C3.01665 9.1625 3.07498 9.16667 3.13331 9.16667H6.44998C6.50831 9.16667 6.56665 9.1625 6.62081 9.15833C6.67081 9.15417 6.71665 9.15 6.76665 9.14167C6.81665 9.1375 6.86665 9.12917 6.91248 9.12083C7.91665 8.975 8.55831 8.3375 8.70415 7.32917C8.71248 7.28333 8.72081 7.23333 8.72498 7.18333C8.73331 7.13333 8.73748 7.0875 8.74165 7.0375C8.74581 6.98333 8.74998 6.925 8.74998 6.86667V4.33333C8.74998 4.06667 8.50831 3.875 8.24998 3.925ZM2.81248 5.20833H4.89581C5.06665 5.20833 5.20831 5.35 5.20831 5.52083C5.20831 5.69167 5.06665 5.83333 4.89581 5.83333H2.81248C2.64165 5.83333 2.49998 5.69167 2.49998 5.52083C2.49998 5.35 2.64165 5.20833 2.81248 5.20833ZM6.56248 7.5H2.81248C2.64165 7.5 2.49998 7.35833 2.49998 7.1875C2.49998 7.01667 2.64165 6.875 2.81248 6.875H6.56248C6.73331 6.875 6.87498 7.01667 6.87498 7.1875C6.87498 7.35833 6.73331 7.5 6.56248 7.5Z"
        fill="#0088FA"
      />
    </svg>
  );
}
export function MurkerFill({ size, color }) {
  return (
    <svg
      width={size !== '' ? size : '20'}
      height={size !== '' ? size : '28'}
      viewBox="0 0 34 44"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M17.0189 0.567871C7.8119 0.567871 0.321301 8.05217 0.321301 17.2518C0.321301 22.9426 3.0231 29.0522 8.3518 35.4111C12.2655 40.0816 16.1261 43.0855 16.2885 43.2111C16.5037 43.3774 16.7613 43.4605 17.0191 43.4605C17.2767 43.4605 17.5345 43.3774 17.7497 43.2111C17.912 43.0855 21.7726 40.0816 25.6864 35.4111C31.0152 29.0522 33.717 22.9428 33.717 17.2518C33.7167 8.05217 26.226 0.567871 17.0189 0.567871ZM23.2027 17.2516C23.2027 20.6639 20.4341 23.4305 17.0189 23.4305C13.6038 23.4305 10.8352 20.6641 10.8352 17.2516C10.8352 13.8391 13.6038 11.073 17.0189 11.073C20.434 11.073 23.2027 13.8393 23.2027 17.2516Z"
        fill={color}
      />
    </svg>
  );
}
MurkerFill.propTypes = {
  size: PropTypes.string,
  color: PropTypes.string,
};
MurkerFill.defaultProps = {
  size: '',
  color: '#0088FA',
};
export function SMSIconFill({ color, fillOpacity }) {
  return (
    <svg
      width="0.694vw"
      height="0.694vw"
      viewBox="0 0 10 10"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M7.08337 1.45837H2.91671C1.66671 1.45837 0.833374 2.08337 0.833374 3.54171V6.45837C0.833374 7.91671 1.66671 8.54171 2.91671 8.54171H7.08337C8.33337 8.54171 9.16671 7.91671 9.16671 6.45837V3.54171C9.16671 2.08337 8.33337 1.45837 7.08337 1.45837ZM7.27921 3.99587L5.97504 5.03754C5.70004 5.25837 5.35004 5.36671 5.00004 5.36671C4.65004 5.36671 4.29587 5.25837 4.02504 5.03754L2.72087 3.99587C2.58754 3.88754 2.56671 3.68754 2.67087 3.55421C2.77921 3.42087 2.97504 3.39587 3.10837 3.50421L4.41254 4.54587C4.72921 4.80004 5.26671 4.80004 5.58337 4.54587L6.88754 3.50421C7.02087 3.39587 7.22087 3.41671 7.32504 3.55421C7.43337 3.68754 7.41254 3.88754 7.27921 3.99587Z"
        fill={color !== '' ? color : '#0088FA'}
        fillOpacity={fillOpacity}
      />
    </svg>
  );
}
SMSIconFill.propTypes = {
  color: PropTypes.string,
  fillOpacity: PropTypes.number,
};
SMSIconFill.defaultProps = {
  color: '',
  fillOpacity: 1,
};
export function AddFolderIcon() {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M21.0169 7.99175C21.4148 8.55833 20.9405 9.25 20.2482 9.25H3C2.44772 9.25 2 8.80228 2 8.25V6.42C2 3.98 3.98 2 6.42 2H8.74C10.37 2 10.88 2.53 11.53 3.4L12.93 5.26C13.24 5.67 13.28 5.72 13.86 5.72H16.65C18.4546 5.72 20.0516 6.61709 21.0169 7.99175Z"
        fill="#292D32"
      />
      <path
        d="M21.9834 11.7461C21.9815 11.1952 21.5343 10.7495 20.9834 10.7495L2.99998 10.7498C2.44771 10.7499 2 11.1976 2 11.7498V16.6499C2 19.5999 4.4 21.9999 7.35 21.9999H16.65C19.6 21.9999 22 19.5999 22 16.6499L21.9834 11.7461ZM14.5 16.7499H12.81V18.4999C12.81 18.9099 12.47 19.2499 12.06 19.2499C11.64 19.2499 11.31 18.9099 11.31 18.4999V16.7499H9.5C9.09 16.7499 8.75 16.4099 8.75 15.9999C8.75 15.5899 9.09 15.2499 9.5 15.2499H11.31V13.4999C11.31 13.0899 11.64 12.7499 12.06 12.7499C12.47 12.7499 12.81 13.0899 12.81 13.4999V15.2499H14.5C14.91 15.2499 15.25 15.5899 15.25 15.9999C15.25 16.4099 14.91 16.7499 14.5 16.7499Z"
        fill="#292D32"
      />
    </svg>
  );
}
export function AddFileIcon() {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M16 2H8C4.5 2 3 4 3 7V17C3 20 4.5 22 8 22H16C19.5 22 21 20 21 17V7C21 4 19.5 2 16 2ZM8 12.25H12C12.41 12.25 12.75 12.59 12.75 13C12.75 13.41 12.41 13.75 12 13.75H8C7.59 13.75 7.25 13.41 7.25 13C7.25 12.59 7.59 12.25 8 12.25ZM16 17.75H8C7.59 17.75 7.25 17.41 7.25 17C7.25 16.59 7.59 16.25 8 16.25H16C16.41 16.25 16.75 16.59 16.75 17C16.75 17.41 16.41 17.75 16 17.75ZM18.5 9.25H16.5C14.98 9.25 13.75 8.02 13.75 6.5V4.5C13.75 4.09 14.09 3.75 14.5 3.75C14.91 3.75 15.25 4.09 15.25 4.5V6.5C15.25 7.19 15.81 7.75 16.5 7.75H18.5C18.91 7.75 19.25 8.09 19.25 8.5C19.25 8.91 18.91 9.25 18.5 9.25Z"
        fill="#292D32"
      />
    </svg>
  );
}
export function LocationNoData() {
  return (
    <svg
      width="371"
      height="366"
      viewBox="0 0 371 366"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect width="371" height="366" fill="white" />
      <path
        d="M186.701 286.402C250.049 286.402 301.402 235.049 301.402 171.701C301.402 108.353 250.049 57 186.701 57C123.353 57 72 108.353 72 171.701C72 235.049 123.353 286.402 186.701 286.402Z"
        fill="url(#paint0_linear_5954_71128)"
      />
      <g filter="url(#filter0_f_5954_71128)">
        <ellipse cx="196.5" cy="256" rx="118.5" ry="12" fill="#647F96" />
      </g>
      <path
        d="M291.031 153.24H145.405C141.33 153.24 138.026 156.544 138.026 160.619V249.172C138.026 253.247 141.33 256.551 145.405 256.551H291.031C295.106 256.551 298.41 253.247 298.41 249.172V160.619C298.41 156.544 295.106 153.24 291.031 153.24Z"
        fill="url(#paint1_linear_5954_71128)"
      />
      <path
        d="M233.794 163.172V249.172C233.794 251.131 233.016 253.01 231.63 254.395C230.245 255.781 228.366 256.559 226.406 256.559H101.056C99.0962 256.559 97.2172 255.781 95.8317 254.395C94.4463 253.01 93.668 251.131 93.668 249.172V156.556C93.6666 155.515 93.8853 154.485 94.3097 153.535C94.734 152.584 95.3546 151.734 96.1305 151.04L151.463 101.839C152.794 100.657 154.507 99.9959 156.287 99.9763C158.066 99.9567 159.793 100.58 161.149 101.732L233.474 163.172H233.794Z"
        fill="url(#paint2_linear_5954_71128)"
      />
      <path
        d="M233.794 163.172V153.24L162.249 92.2512H218.887C220.682 92.2595 222.42 92.8823 223.812 94.016L305.002 160.299C305.248 160.516 305.424 160.802 305.506 161.12C305.589 161.439 305.574 161.774 305.463 162.084C305.353 162.393 305.152 162.662 304.887 162.856C304.621 163.05 304.304 163.16 303.976 163.172H233.794Z"
        fill="url(#paint3_linear_5954_71128)"
      />
      <path
        d="M182.625 192.812H142.702C141.598 192.812 140.702 193.708 140.702 194.813V256.551H184.625V194.812C184.625 193.708 183.73 192.812 182.625 192.812Z"
        fill="url(#paint4_linear_5954_71128)"
      />
      <path
        d="M298.419 163.172H233.827V178.16H298.419V163.172Z"
        fill="url(#paint5_linear_5954_71128)"
      />
      <path
        d="M165.713 95.2063L162.381 92.2512L162.315 92.3169L162.241 92.2512L157.554 96.4211L83.5798 160.274C83.3348 160.485 83.1598 160.766 83.0781 161.079C82.9964 161.391 83.0118 161.722 83.1222 162.025C83.2327 162.329 83.433 162.592 83.6966 162.779C83.9601 162.967 84.2744 163.069 84.5976 163.073L92.2151 163.172L162.381 102.758L233.474 163.172H233.794L245.286 163.024L165.713 95.2063Z"
        fill="url(#paint6_linear_5954_71128)"
      />
      <path
        d="M162.028 170.666C169.802 170.666 176.105 164.364 176.105 156.589C176.105 148.814 169.802 142.511 162.028 142.511C154.253 142.511 147.95 148.814 147.95 156.589C147.95 164.364 154.253 170.666 162.028 170.666Z"
        fill="url(#paint7_linear_5954_71128)"
      />
      <path
        d="M127.284 192.812H104.771C103.666 192.812 102.771 193.708 102.771 194.813V230.689C102.771 231.794 103.666 232.689 104.771 232.689H127.284C128.389 232.689 129.284 231.794 129.284 230.689V194.812C129.284 193.708 128.389 192.812 127.284 192.812Z"
        fill="url(#paint8_linear_5954_71128)"
      />
      <path
        d="M218.258 206.168H195.745C194.64 206.168 193.745 207.063 193.745 208.168V230.681C193.745 231.786 194.64 232.681 195.745 232.681H218.258C219.362 232.681 220.258 231.786 220.258 230.681V208.168C220.258 207.063 219.362 206.168 218.258 206.168Z"
        fill="url(#paint9_linear_5954_71128)"
      />
      <g filter="url(#filter1_f_5954_71128)">
        <ellipse
          cx="240"
          cy="132.5"
          rx="35"
          ry="64.5"
          fill="#0088FA"
          fillOpacity="0.6"
        />
      </g>
      <path
        d="M218.258 192.911H195.745C194.64 192.911 193.745 193.807 193.745 194.911V198.643C193.745 199.748 194.64 200.643 195.745 200.643H218.258C219.362 200.643 220.258 199.748 220.258 198.643V194.911C220.258 193.807 219.362 192.911 218.258 192.911Z"
        fill="url(#paint10_linear_5954_71128)"
      />
      <path
        d="M298.053 219.461C297.535 217.317 294.485 217.317 293.968 219.461L292.226 226.677C292.041 227.443 291.443 228.041 290.676 228.226L283.46 229.968C281.316 230.486 281.316 233.535 283.46 234.053L290.676 235.795C291.443 235.98 292.041 236.578 292.226 237.344L293.968 244.56C294.485 246.704 297.535 246.704 298.053 244.56L299.794 237.344C299.979 236.578 300.578 235.98 301.344 235.795L308.56 234.053C310.704 233.535 310.704 230.486 308.56 229.968L301.344 228.226C300.578 228.041 299.979 227.443 299.794 226.677L298.053 219.461Z"
        fill="url(#paint11_linear_5954_71128)"
      />
      <path
        d="M175.053 265.461C174.535 263.317 171.485 263.317 170.968 265.461L169.226 272.677C169.041 273.443 168.443 274.041 167.676 274.226L160.46 275.968C158.316 276.486 158.316 279.535 160.46 280.053L167.676 281.795C168.443 281.98 169.041 282.578 169.226 283.344L170.968 290.56C171.485 292.704 174.535 292.704 175.053 290.56L176.794 283.344C176.979 282.578 177.578 281.98 178.344 281.795L185.56 280.053C187.704 279.535 187.704 276.486 185.56 275.968L178.344 274.226C177.578 274.041 176.979 273.443 176.794 272.677L175.053 265.461Z"
        fill="url(#paint12_linear_5954_71128)"
      />
      <path
        d="M108.053 84.4607C107.535 82.3167 104.485 82.3167 103.968 84.4607L102.226 91.6767C102.041 92.4429 101.443 93.0411 100.676 93.2261L93.4605 94.968C91.3165 95.4856 91.3165 98.5352 93.4605 99.0528L100.676 100.795C101.443 100.98 102.041 101.578 102.226 102.344L103.968 109.56C104.485 111.704 107.535 111.704 108.053 109.56L109.794 102.344C109.979 101.578 110.578 100.98 111.344 100.795L118.56 99.0528C120.704 98.5352 120.704 95.4856 118.56 94.968L111.344 93.2261C110.578 93.0411 109.979 92.4429 109.794 91.6767L108.053 84.4607Z"
        fill="url(#paint13_linear_5954_71128)"
      />
      <circle
        cx="6.12803"
        cy="6.12803"
        r="4.81488"
        transform="matrix(-1 0 0 1 171.256 64)"
        fill="url(#paint14_linear_5954_71128)"
        stroke="url(#paint15_linear_5954_71128)"
        strokeWidth="2.6263"
      />
      <path
        d="M313.89 124.492C314.979 123.697 314.799 122.022 313.567 121.476L305.249 117.791C304.017 117.245 302.656 118.237 302.799 119.578L303.766 128.624C303.91 129.964 305.45 130.647 306.539 129.852L313.89 124.492Z"
        fill="url(#paint16_linear_5954_71128)"
      />
      <path
        d="M257.046 264.018C255.74 263.687 254.564 264.894 254.931 266.191L257.403 274.947C257.77 276.244 259.403 276.658 260.343 275.692L266.689 269.173C267.629 268.207 267.171 266.586 265.865 266.255L257.046 264.018Z"
        fill="url(#paint17_linear_5954_71128)"
      />
      <circle
        cx="6.12803"
        cy="6.12803"
        r="4.81488"
        transform="matrix(-1 0 0 1 95.2559 269)"
        fill="url(#paint18_linear_5954_71128)"
        stroke="url(#paint19_linear_5954_71128)"
        strokeWidth="2.6263"
      />
      <g filter="url(#filter2_dd_5954_71128)">
        <path
          d="M279.357 68.4726C274.139 63.2504 267.942 59.1077 261.122 56.2812C254.301 53.4548 246.991 52 239.608 52C232.225 52 224.915 53.4548 218.094 56.2812C211.274 59.1077 205.077 63.2504 199.859 68.4726C194.827 73.3876 190.831 79.2612 188.107 85.7465C185.383 92.2318 183.987 99.1973 184 106.231C184 120.498 189.508 135.199 199.859 147.922L231.945 189.522C232.85 190.694 234.011 191.643 235.339 192.296C236.667 192.949 238.128 193.289 239.608 193.289C241.088 193.289 242.549 192.949 243.877 192.296C245.206 191.643 246.366 190.694 247.271 189.522L279.357 147.922C289.708 135.199 295.208 120.498 295.208 106.231C295.223 99.1978 293.828 92.2326 291.105 85.7472C288.383 79.2619 284.388 73.388 279.357 68.4726Z"
          fill="url(#paint20_linear_5954_71128)"
        />
      </g>
      <path
        d="M239.604 130.692C252.479 130.692 262.916 120.255 262.916 107.381C262.916 94.5057 252.479 84.0686 239.604 84.0686C226.729 84.0686 216.292 94.5057 216.292 107.381C216.292 120.255 226.729 130.692 239.604 130.692Z"
        fill="white"
      />
      <path
        d="M175.681 235.573L160.921 251.845L202.525 289.583L217.285 273.311L175.681 235.573Z"
        fill="url(#paint21_linear_5954_71128)"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M191.279 208.64C191.279 242.682 163.682 270.279 129.64 270.279C95.597 270.279 68 242.682 68 208.64C68 174.597 95.597 147 129.64 147C163.682 147 191.279 174.597 191.279 208.64ZM181.824 208.64C181.824 237.461 158.46 260.825 129.639 260.825C100.819 260.825 77.4546 237.461 77.4546 208.64C77.4546 179.819 100.819 156.455 129.639 156.455C158.46 156.455 181.824 179.819 181.824 208.64Z"
        fill="url(#paint22_linear_5954_71128)"
      />
      <g filter="url(#filter3_b_5954_71128)">
        <path
          d="M129.64 260.825C158.461 260.825 181.825 237.461 181.825 208.64C181.825 179.819 158.461 156.455 129.64 156.455C100.819 156.455 77.4551 179.819 77.4551 208.64C77.4551 237.461 100.819 260.825 129.64 260.825Z"
          fill="url(#paint23_linear_5954_71128)"
          fillOpacity="0.2"
        />
      </g>
      <path
        d="M142.179 208.64L157.104 193.682C158.502 192.202 159.268 190.236 159.239 188.2C159.21 186.165 158.389 184.22 156.949 182.781C155.51 181.341 153.566 180.52 151.53 180.491C149.494 180.462 147.528 181.228 146.048 182.626L131.09 197.584L116.166 182.626C115.448 181.866 114.585 181.258 113.627 180.837C112.67 180.417 111.638 180.193 110.593 180.178C109.547 180.163 108.509 180.358 107.54 180.751C106.571 181.145 105.691 181.728 104.952 182.468C104.212 183.207 103.629 184.087 103.235 185.056C102.842 186.025 102.647 187.063 102.662 188.108C102.677 189.154 102.901 190.186 103.322 191.143C103.742 192.101 104.351 192.964 105.111 193.682L120.06 208.64L105.111 223.597C104.351 224.315 103.742 225.179 103.322 226.136C102.901 227.093 102.677 228.125 102.662 229.171C102.647 230.216 102.842 231.254 103.235 232.223C103.629 233.192 104.212 234.072 104.952 234.812C105.691 235.551 106.571 236.135 107.54 236.528C108.509 236.921 109.547 237.116 110.593 237.102C111.638 237.087 112.67 236.862 113.627 236.442C114.585 236.021 115.448 235.413 116.166 234.653L131.124 219.695L146.081 234.653C147.575 235.969 149.514 236.665 151.504 236.601C153.493 236.536 155.384 235.715 156.789 234.306C158.194 232.896 159.009 231.004 159.068 229.014C159.126 227.024 158.424 225.087 157.104 223.597L142.179 208.64Z"
        fill="url(#paint24_linear_5954_71128)"
      />
      <path
        d="M202.522 289.585L217.282 273.313L219.505 275.329C221.662 277.286 222.954 280.019 223.096 282.928C223.237 285.837 222.218 288.683 220.261 290.84C218.305 292.997 215.571 294.288 212.663 294.43C209.754 294.572 206.908 293.552 204.751 291.596L202.528 289.579L202.522 289.585Z"
        fill="#1987D8"
      />
      <defs>
        <filter
          id="filter0_f_5954_71128"
          x="56.1142"
          y="222.114"
          width="280.772"
          height="67.7716"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="BackgroundImageFix"
            result="shape"
          />
          <feGaussianBlur
            stdDeviation="10.9429"
            result="effect1_foregroundBlur_5954_71128"
          />
        </filter>
        <filter
          id="filter1_f_5954_71128"
          x="183.114"
          y="46.1142"
          width="113.772"
          height="172.772"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="BackgroundImageFix"
            result="shape"
          />
          <feGaussianBlur
            stdDeviation="10.9429"
            result="effect1_foregroundBlur_5954_71128"
          />
        </filter>
        <filter
          id="filter2_dd_5954_71128"
          x="165"
          y="33"
          width="149.208"
          height="179.289"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dx="-4" dy="-4" />
          <feGaussianBlur stdDeviation="7.5" />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0.409836 0 0 0 0 1 0 0 0 0.15 0"
          />
          <feBlend
            mode="normal"
            in2="BackgroundImageFix"
            result="effect1_dropShadow_5954_71128"
          />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dx="4" dy="4" />
          <feGaussianBlur stdDeviation="7.5" />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0.411765 0 0 0 0 1 0 0 0 0.15 0"
          />
          <feBlend
            mode="normal"
            in2="effect1_dropShadow_5954_71128"
            result="effect2_dropShadow_5954_71128"
          />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect2_dropShadow_5954_71128"
            result="shape"
          />
        </filter>
        <filter
          id="filter3_b_5954_71128"
          x="60.7799"
          y="139.78"
          width="137.72"
          height="137.72"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feGaussianBlur in="BackgroundImageFix" stdDeviation="8.33757" />
          <feComposite
            in2="SourceAlpha"
            operator="in"
            result="effect1_backgroundBlur_5954_71128"
          />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect1_backgroundBlur_5954_71128"
            result="shape"
          />
        </filter>
        <linearGradient
          id="paint0_linear_5954_71128"
          x1="185.817"
          y1="19.6505"
          x2="188.167"
          y2="422.463"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="white" stopOpacity="0" />
          <stop offset="1" stopColor="#9BD0FF" />
        </linearGradient>
        <linearGradient
          id="paint1_linear_5954_71128"
          x1="201"
          y1="221"
          x2="304.911"
          y2="360.436"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#0088FA" />
          <stop offset="1" stopColor="#F7F7FF" />
        </linearGradient>
        <linearGradient
          id="paint2_linear_5954_71128"
          x1="319"
          y1="312"
          x2="120.509"
          y2="98.2037"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#0088FA" />
          <stop offset="1" stopColor="#F7F7FF" />
        </linearGradient>
        <linearGradient
          id="paint3_linear_5954_71128"
          x1="212.5"
          y1="153"
          x2="242.414"
          y2="76.3627"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#0088FA" />
          <stop offset="1" stopColor="#F7F7FF" />
        </linearGradient>
        <linearGradient
          id="paint4_linear_5954_71128"
          x1="162.664"
          y1="192.812"
          x2="162.664"
          y2="256.551"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#0088FA" />
          <stop offset="1" stopColor="#82C5FD" />
        </linearGradient>
        <linearGradient
          id="paint5_linear_5954_71128"
          x1="237.5"
          y1="138"
          x2="188.478"
          y2="162.949"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#0088FA" />
          <stop offset="1" stopColor="#F7F7FF" />
        </linearGradient>
        <linearGradient
          id="paint6_linear_5954_71128"
          x1="221.46"
          y1="141.621"
          x2="197.906"
          y2="38.9034"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#0088FA" />
          <stop offset="1" stopColor="#F7F7FF" />
        </linearGradient>
        <linearGradient
          id="paint7_linear_5954_71128"
          x1="135"
          y1="153"
          x2="195.71"
          y2="189.977"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#0088FA" />
          <stop offset="1" stopColor="#F7F7FF" />
        </linearGradient>
        <linearGradient
          id="paint8_linear_5954_71128"
          x1="116.028"
          y1="192.812"
          x2="116.028"
          y2="232.689"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#0088FA" />
          <stop offset="1" stopColor="#82C5FD" />
        </linearGradient>
        <linearGradient
          id="paint9_linear_5954_71128"
          x1="207.001"
          y1="206.168"
          x2="207.001"
          y2="232.681"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#0088FA" />
          <stop offset="1" stopColor="#82C5FD" />
        </linearGradient>
        <linearGradient
          id="paint10_linear_5954_71128"
          x1="207.001"
          y1="192.911"
          x2="207.001"
          y2="200.643"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#0088FA" />
          <stop offset="1" stopColor="#82C5FD" />
        </linearGradient>
        <linearGradient
          id="paint11_linear_5954_71128"
          x1="317.021"
          y1="232.01"
          x2="275"
          y2="232.01"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#1987D8" />
          <stop offset="1" stopColor="#45B4D0" />
        </linearGradient>
        <linearGradient
          id="paint12_linear_5954_71128"
          x1="194.021"
          y1="278.01"
          x2="152"
          y2="278.01"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#1987D8" />
          <stop offset="1" stopColor="#45B4D0" />
        </linearGradient>
        <linearGradient
          id="paint13_linear_5954_71128"
          x1="127.021"
          y1="97.0104"
          x2="84.9997"
          y2="97.0104"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#1987D8" />
          <stop offset="1" stopColor="#45B4D0" />
        </linearGradient>
        <linearGradient
          id="paint14_linear_5954_71128"
          x1="0"
          y1="6.12803"
          x2="12.2561"
          y2="6.12803"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#1987D8" />
          <stop offset="1" stopColor="#45B4D0" />
        </linearGradient>
        <linearGradient
          id="paint15_linear_5954_71128"
          x1="10.4564"
          y1="8.53171"
          x2="2.76961"
          y2="-6.11983"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#0088FA" />
          <stop offset="1" stopColor="#F7F7FF" />
        </linearGradient>
        <linearGradient
          id="paint16_linear_5954_71128"
          x1="308.566"
          y1="132.34"
          x2="306.704"
          y2="114.931"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#1987D8" />
          <stop offset="1" stopColor="#45B4D0" />
        </linearGradient>
        <linearGradient
          id="paint17_linear_5954_71128"
          x1="266.486"
          y1="263.106"
          x2="254.273"
          y2="275.652"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#1987D8" />
          <stop offset="1" stopColor="#45B4D0" />
        </linearGradient>
        <linearGradient
          id="paint18_linear_5954_71128"
          x1="0"
          y1="6.12803"
          x2="12.2561"
          y2="6.12803"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#1987D8" />
          <stop offset="1" stopColor="#45B4D0" />
        </linearGradient>
        <linearGradient
          id="paint19_linear_5954_71128"
          x1="10.4564"
          y1="8.53171"
          x2="2.76961"
          y2="-6.11983"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#0088FA" />
          <stop offset="1" stopColor="#F7F7FF" />
        </linearGradient>
        <linearGradient
          id="paint20_linear_5954_71128"
          x1="184"
          y1="122.644"
          x2="295.208"
          y2="122.644"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#1987D8" />
          <stop offset="1" stopColor="#45B4D0" />
        </linearGradient>
        <linearGradient
          id="paint21_linear_5954_71128"
          x1="181.723"
          y1="270.714"
          x2="196.483"
          y2="254.442"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#1987D8" />
          <stop offset="1" stopColor="#45B4D0" />
        </linearGradient>
        <linearGradient
          id="paint22_linear_5954_71128"
          x1="68"
          y1="208.64"
          x2="191.279"
          y2="208.64"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#1987D8" />
          <stop offset="1" stopColor="#45B4D0" />
        </linearGradient>
        <linearGradient
          id="paint23_linear_5954_71128"
          x1="129.64"
          y1="156.455"
          x2="182.225"
          y2="292.907"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="white" />
          <stop offset="1" stopColor="#D2F7FF" />
        </linearGradient>
        <linearGradient
          id="paint24_linear_5954_71128"
          x1="102.932"
          y1="184.007"
          x2="159.597"
          y2="236.948"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#FF698D" />
          <stop offset="1" stopColor="#FF3868" />
        </linearGradient>
      </defs>
    </svg>
  );
}
export function NoContact() {
  return (
    <svg
      width="467"
      height="362"
      viewBox="0 0 467 362"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect width="467" height="362" fill="white" />
      <g filter="url(#filter0_f_5958_71186)">
        <ellipse
          cx="225.607"
          cy="266.338"
          rx="110.607"
          ry="21.3375"
          fill="#1F88F8"
          fillOpacity="0.35"
        />
      </g>
      <path
        d="M229.701 292.402C293.049 292.402 344.402 241.049 344.402 177.701C344.402 114.353 293.049 63 229.701 63C166.354 63 115 114.353 115 177.701C115 241.049 166.354 292.402 229.701 292.402Z"
        fill="url(#paint0_linear_5958_71186)"
      />
      <path
        d="M318.433 109.366H172.743V181.262H318.433V109.366Z"
        fill="url(#paint1_linear_5958_71186)"
      />
      <path
        d="M318.433 109.366H333.056C342.589 109.366 351.731 113.153 358.472 119.893C365.213 126.634 369 135.777 369 145.31C369 154.843 365.213 163.985 358.472 170.726C351.731 177.467 342.589 181.254 333.056 181.254H318.433V109.366Z"
        fill="url(#paint2_linear_5958_71186)"
      />
      <path
        d="M327.891 119.942H336.257C342.691 119.942 348.861 122.498 353.41 127.047C357.96 131.596 360.516 137.767 360.516 144.201V146.428C360.516 152.862 357.96 159.032 353.41 163.581C348.861 168.131 342.691 170.687 336.257 170.687H327.891V119.942Z"
        fill="url(#paint3_linear_5958_71186)"
      />
      <path
        d="M318.433 121.432H184.978V181.262H318.433V121.432Z"
        fill="url(#paint4_linear_5958_71186)"
      />
      <rect
        x="137.934"
        y="193.231"
        width="54.1073"
        height="69.2953"
        fill="url(#paint5_linear_5958_71186)"
      />
      <rect
        x="204.382"
        y="193.231"
        width="54.1073"
        height="69.2953"
        fill="url(#paint6_linear_5958_71186)"
      />
      <rect
        x="270.83"
        y="193.231"
        width="35.1223"
        height="69.2953"
        fill="url(#paint7_linear_5958_71186)"
      />
      <path
        d="M318.433 109.366H305.994V181.262H318.433V109.366Z"
        fill="url(#paint8_linear_5958_71186)"
      />
      <path
        d="M204.382 180.891L192.042 180.891L192.042 274.867L204.382 274.867L204.382 180.891Z"
        fill="url(#paint9_linear_5958_71186)"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M130.34 180.891L138.463 180.891L138.463 274.867H130.34C127.719 274.867 125.594 272.742 125.594 270.121L125.594 185.637C125.594 183.016 127.719 180.891 130.34 180.891ZM264.185 193.231V180.891H138.463V193.231H264.185ZM264.185 274.867V262.527H138.463V274.867H264.185Z"
        fill="url(#paint10_linear_5958_71186)"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M270.83 180.891H263.236C260.614 180.891 258.49 183.016 258.49 185.637L258.49 274.867H270.83V274.867H305.952L305.952 274.867H313.546C316.167 274.867 318.292 272.742 318.292 270.121L318.292 180.891L305.952 180.891H270.83ZM305.952 193.231H270.83L270.83 262.527H305.952V193.231Z"
        fill="url(#paint11_linear_5958_71186)"
      />
      <path
        d="M182.506 181.415V181.55V185.826V216.978H216.502C217.026 216.978 217.451 216.553 217.451 216.029V185.826V182.364C217.451 181.84 217.026 181.415 216.502 181.415H182.506Z"
        fill="url(#paint12_linear_5958_71186)"
      />
      <path
        d="M180.449 181.415C179.925 181.415 179.5 181.84 179.5 182.364V216.029C179.5 216.553 179.925 216.978 180.449 216.978H214.445V181.415H180.449Z"
        fill="url(#paint13_linear_5958_71186)"
      />
      <path
        d="M208.617 184.819H185.336C184.287 184.819 183.437 185.669 183.437 186.717V211.387C183.437 212.436 184.287 213.286 185.336 213.286H208.617C209.666 213.286 210.516 212.436 210.516 211.387V186.717C210.516 185.669 209.666 184.819 208.617 184.819Z"
        fill="url(#paint14_linear_5958_71186)"
      />
      <g filter="url(#filter1_d_5958_71186)">
        <path
          d="M118 157.347L131.142 189.667C131.321 190.11 131.586 190.514 131.922 190.854C132.258 191.194 132.657 191.465 133.098 191.651C133.538 191.836 134.011 191.933 134.489 191.936C134.967 191.938 135.441 191.847 135.883 191.666L165.333 179.701C166.228 179.337 166.943 178.632 167.319 177.741C167.695 176.851 167.703 175.847 167.34 174.951L152.149 137.593C151.785 136.7 151.081 135.987 150.192 135.613C149.303 135.238 148.301 135.232 147.407 135.595L122.937 145.544L118 157.347Z"
          fill="url(#paint15_linear_5958_71186)"
        />
      </g>
      <g filter="url(#filter2_d_5958_71186)">
        <path
          d="M326.132 138.362L312.991 170.682C312.811 171.125 312.546 171.529 312.21 171.869C311.875 172.209 311.475 172.48 311.035 172.666C310.594 172.851 310.121 172.948 309.643 172.951C309.165 172.953 308.691 172.861 308.249 172.681L278.799 160.716C277.904 160.352 277.19 159.647 276.813 158.756C276.437 157.866 276.43 156.862 276.793 155.966L291.983 118.608C292.347 117.714 293.051 117.002 293.941 116.628C294.83 116.253 295.831 116.246 296.725 116.61L321.196 126.559L326.132 138.362Z"
          fill="url(#paint16_linear_5958_71186)"
        />
      </g>
      <path
        d="M118 157.347L126.358 153.952L122.945 145.544L118 157.347Z"
        fill="url(#paint17_linear_5958_71186)"
      />
      <path
        d="M326.132 138.362L317.775 134.967L321.187 126.559L326.132 138.362Z"
        fill="url(#paint18_linear_5958_71186)"
      />
      <path
        d="M277.155 104.192C277.155 105.524 276.955 106.848 276.562 108.121C275.926 110.162 274.801 112.016 273.285 113.523C272.84 113.974 272.362 114.39 271.854 114.768C271.52 115.028 271.17 115.266 270.804 115.479C270.44 115.703 270.064 115.906 269.678 116.089C269.102 116.373 268.505 116.611 267.891 116.8C266.619 117.193 265.294 117.393 263.962 117.393H261.507V181.025H192.921V102.812C192.932 99.6828 194.18 96.6848 196.393 94.4721C198.606 92.2593 201.604 91.0113 204.733 91.0001H263.929C265.578 90.9938 267.213 91.3012 268.747 91.9061C269.172 92.0711 269.588 92.2605 269.991 92.4734C270.194 92.575 270.389 92.6851 270.584 92.8036C270.744 92.8915 270.9 92.9876 271.05 93.0915C271.85 93.5975 272.591 94.1911 273.26 94.8612C274.157 95.7609 274.922 96.7845 275.529 97.901C275.939 98.6534 276.274 99.4448 276.528 100.263L276.706 100.898C276.815 101.323 276.903 101.752 276.968 102.186C277.082 102.849 277.145 103.52 277.155 104.192Z"
        fill="url(#paint19_linear_5958_71186)"
      />
      <path
        d="M277.155 104.192C277.155 105.524 276.955 106.848 276.562 108.121C276.302 108.938 275.968 109.728 275.563 110.483C274.95 111.598 274.183 112.622 273.285 113.523C272.84 113.974 272.362 114.39 271.854 114.768C271.516 115.022 271.168 115.251 270.804 115.479C270.44 115.702 270.064 115.906 269.678 116.089C269.101 116.369 268.504 116.607 267.891 116.8C266.619 117.193 265.294 117.393 263.963 117.393H261.507V102.812C261.512 100.48 262.205 98.202 263.499 96.2621C264.793 94.3223 266.63 92.807 268.781 91.906C269.204 92.0754 269.627 92.2616 270.025 92.4733C270.228 92.5749 270.423 92.685 270.618 92.8035C270.778 92.8914 270.934 92.9875 271.084 93.0914C271.884 93.5974 272.625 94.191 273.294 94.8611C274.191 95.7608 274.956 96.7844 275.563 97.9009C275.97 98.655 276.304 99.446 276.562 100.263L276.74 100.898C276.85 101.322 276.938 101.752 277.002 102.185C277.105 102.849 277.156 103.52 277.155 104.192Z"
        fill="url(#paint20_linear_5958_71186)"
      />
      <path
        d="M247.815 157.858H204.504C203.779 157.858 203.192 158.444 203.192 159.167C203.192 159.889 203.779 160.475 204.504 160.475H247.815C248.54 160.475 249.127 159.889 249.127 159.167C249.127 158.444 248.54 157.858 247.815 157.858Z"
        fill="#AACCE9"
      />
      <path
        d="M247.815 144.438H204.504C203.779 144.438 203.192 145.023 203.192 145.746C203.192 146.468 203.779 147.054 204.504 147.054H247.815C248.54 147.054 249.127 146.468 249.127 145.746C249.127 145.023 248.54 144.438 247.815 144.438Z"
        fill="#AACCE9"
      />
      <path
        d="M247.815 131.008H219.923C219.198 131.008 218.611 131.594 218.611 132.317C218.611 133.039 219.198 133.625 219.923 133.625H247.815C248.539 133.625 249.127 133.039 249.127 132.317C249.127 131.594 248.539 131.008 247.815 131.008Z"
        fill="#AACCE9"
      />
      <path
        d="M229.517 117.579H204.199C203.643 117.579 203.192 118.03 203.192 118.587V119.188C203.192 119.744 203.643 120.196 204.199 120.196H229.517C230.073 120.196 230.524 119.744 230.524 119.188V118.587C230.524 118.03 230.073 117.579 229.517 117.579Z"
        fill="#AACCE9"
      />
      <path
        d="M213.818 131.008H204.504C203.779 131.008 203.192 131.594 203.192 132.317C203.192 133.039 203.779 133.625 204.504 133.625H213.818C214.543 133.625 215.131 133.039 215.131 132.317C215.131 131.594 214.543 131.008 213.818 131.008Z"
        fill="#AACCE9"
      />
      <path
        d="M138.409 193.231H142.681V262.527H138.409V193.231Z"
        fill="url(#paint21_linear_5958_71186)"
      />
      <path
        d="M204.382 216.962H208.179V262.526H204.382V216.962Z"
        fill="url(#paint22_linear_5958_71186)"
      />
      <path
        d="M270.83 193.231H275.102V262.527H270.83V193.231Z"
        fill="url(#paint23_linear_5958_71186)"
      />
      <g filter="url(#filter3_f_5958_71186)">
        <ellipse
          cx="154.579"
          cy="134.757"
          rx="36.5786"
          ry="11.7574"
          fill="#FF4C77"
          fillOpacity="0.3"
        />
      </g>
      <path
        d="M120.278 117.624C120.984 122.891 123.012 127.893 126.173 132.164C129.334 136.435 133.526 139.836 138.357 142.05C143.188 144.263 148.5 145.216 153.799 144.821C159.099 144.426 164.211 142.696 168.661 139.791L180.783 143.912C181.149 144.032 181.541 144.045 181.914 143.95C182.287 143.854 182.625 143.654 182.888 143.373C183.15 143.091 183.327 142.74 183.397 142.362C183.466 141.983 183.426 141.592 183.281 141.236L178.419 129.64C181.005 125.332 182.521 120.468 182.841 115.455C183.161 110.441 182.275 105.424 180.258 100.823C178.24 96.222 175.15 92.1712 171.246 89.0096C167.342 85.848 162.738 83.6676 157.818 82.6509C152.898 81.6341 147.806 81.8107 142.969 83.1658C138.131 84.5208 133.689 87.015 130.013 90.4395C126.337 93.8639 123.535 98.119 121.842 102.849C120.148 107.578 119.612 112.645 120.278 117.624Z"
        fill="url(#paint24_linear_5958_71186)"
      />
      <path
        d="M150.629 129.545C154.044 129.545 156.477 127.206 156.477 123.931C156.477 120.656 154.044 118.316 150.629 118.316C147.26 118.316 144.781 120.656 144.781 123.931C144.781 127.206 147.26 129.545 150.629 129.545ZM155.307 117.381C155.307 114.293 157.085 113.17 159.518 112.047C162.746 110.55 165.132 107.509 165.132 103.766C165.132 97.8711 159.331 93.7539 151.471 93.7539C143.049 93.7539 137.108 98.4793 136.593 105.076L147.354 107.041C147.634 104.468 148.991 102.643 150.909 102.643C152.36 102.643 153.436 103.626 153.436 104.982C153.436 106.573 151.845 107.556 150.582 108.304C147.213 110.503 145.95 112.936 145.95 117.381H155.307Z"
        fill="white"
      />
      <path
        d="M307.887 95.0964C307.887 97.7419 305.742 99.8865 303.097 99.8865C300.451 99.8865 298.307 97.7419 298.307 95.0964C298.307 92.451 300.451 90.3064 303.097 90.3064C305.742 90.3064 307.887 92.451 307.887 95.0964Z"
        fill="url(#paint25_linear_5958_71186)"
        stroke="url(#paint26_linear_5958_71186)"
        strokeWidth="2.61276"
      />
      <circle
        cx="275.097"
        cy="286.096"
        r="4.79006"
        fill="url(#paint27_linear_5958_71186)"
        stroke="url(#paint28_linear_5958_71186)"
        strokeWidth="2.61276"
      />
      <path
        d="M114.031 224.236C115.355 224.024 116.412 225.325 115.934 226.577L112.705 235.033C112.227 236.285 110.572 236.55 109.726 235.51L104.018 228.486C103.172 227.445 103.77 225.879 105.094 225.667L114.031 224.236Z"
        fill="url(#paint29_linear_5958_71186)"
      />
      <path
        d="M334.978 217.006C334.647 215.707 335.847 214.536 337.137 214.899L345.851 217.348C347.142 217.71 347.556 219.335 346.596 220.271L340.119 226.593C339.159 227.529 337.546 227.076 337.214 225.777L334.978 217.006Z"
        fill="url(#paint30_linear_5958_71186)"
      />
      <path
        d="M218.87 57.4171C219.385 55.2841 222.419 55.2841 222.934 57.4171L224.667 64.5959C224.851 65.3582 225.446 65.9533 226.208 66.1373L233.387 67.8702C235.52 68.3851 235.52 71.419 233.387 71.9339L226.208 73.6668C225.446 73.8508 224.851 74.446 224.667 75.2082L222.934 82.387C222.419 84.52 219.385 84.52 218.87 82.387L217.138 75.2082C216.954 74.446 216.358 73.8508 215.596 73.6668L208.417 71.9339C206.284 71.419 206.284 68.3851 208.417 67.8702L215.596 66.1373C216.358 65.9533 216.954 65.3582 217.138 64.5959L218.87 57.4171Z"
        fill="url(#paint31_linear_5958_71186)"
      />
      <path
        d="M165.87 279.417C166.385 277.284 169.419 277.284 169.934 279.417L171.667 286.596C171.851 287.358 172.446 287.953 173.208 288.137L180.387 289.87C182.52 290.385 182.52 293.419 180.387 293.934L173.208 295.667C172.446 295.851 171.851 296.446 171.667 297.208L169.934 304.387C169.419 306.52 166.385 306.52 165.87 304.387L164.138 297.208C163.954 296.446 163.358 295.851 162.596 295.667L155.417 293.934C153.284 293.419 153.284 290.385 155.417 289.87L162.596 288.137C163.358 287.953 163.954 287.358 164.138 286.596L165.87 279.417Z"
        fill="url(#paint32_linear_5958_71186)"
      />
      <g filter="url(#filter4_dd_5958_71186)">
        <ellipse
          cx="196.668"
          cy="195.28"
          rx="4.84914"
          ry="5.28017"
          fill="#0368BD"
        />
        <path
          d="M207.336 207.996C207.336 207.076 207.06 206.165 206.524 205.315C205.988 204.465 205.202 203.693 204.212 203.043C203.221 202.392 202.045 201.877 200.751 201.525C199.456 201.173 198.069 200.991 196.668 200.991C195.267 200.991 193.88 201.173 192.586 201.525C191.291 201.877 190.115 202.392 189.125 203.043C188.134 203.693 187.348 204.465 186.812 205.315C186.276 206.165 186 207.076 186 207.996L196.668 207.996H207.336Z"
          fill="#0368BD"
        />
      </g>
      <defs>
        <filter
          id="filter0_f_5958_71186"
          x="93.2272"
          y="223.227"
          width="264.76"
          height="86.221"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="BackgroundImageFix"
            result="shape"
          />
          <feGaussianBlur
            stdDeviation="10.8865"
            result="effect1_foregroundBlur_5958_71186"
          />
        </filter>
        <filter
          id="filter1_d_5958_71186"
          x="115.152"
          y="135.327"
          width="68.5914"
          height="76.5433"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dx="6.64476" dy="10.4418" />
          <feGaussianBlur stdDeviation="4.74626" />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0.184314 0 0 0 0 0.254902 0 0 0 0 0.443137 0 0 0 0.15 0"
          />
          <feBlend
            mode="normal"
            in2="BackgroundImageFix"
            result="effect1_dropShadow_5958_71186"
          />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect1_dropShadow_5958_71186"
            result="shape"
          />
        </filter>
        <filter
          id="filter2_d_5958_71186"
          x="273.678"
          y="116.342"
          width="68.5914"
          height="76.5433"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dx="6.64476" dy="10.4418" />
          <feGaussianBlur stdDeviation="4.74626" />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0.184314 0 0 0 0 0.254902 0 0 0 0 0.443137 0 0 0 0.15 0"
          />
          <feBlend
            mode="normal"
            in2="BackgroundImageFix"
            result="effect1_dropShadow_5958_71186"
          />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect1_dropShadow_5958_71186"
            result="shape"
          />
        </filter>
        <filter
          id="filter3_f_5958_71186"
          x="96.2272"
          y="101.227"
          width="116.703"
          height="67.0609"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="BackgroundImageFix"
            result="shape"
          />
          <feGaussianBlur
            stdDeviation="10.8865"
            result="effect1_foregroundBlur_5958_71186"
          />
        </filter>
        <filter
          id="filter4_dd_5958_71186"
          x="167"
          y="171"
          width="59.3362"
          height="55.9956"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dx="-4" dy="-4" />
          <feGaussianBlur stdDeviation="7.5" />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0.409836 0 0 0 0 1 0 0 0 0.15 0"
          />
          <feBlend
            mode="normal"
            in2="BackgroundImageFix"
            result="effect1_dropShadow_5958_71186"
          />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dx="4" dy="4" />
          <feGaussianBlur stdDeviation="7.5" />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0.411765 0 0 0 0 1 0 0 0 0.15 0"
          />
          <feBlend
            mode="normal"
            in2="effect1_dropShadow_5958_71186"
            result="effect2_dropShadow_5958_71186"
          />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect2_dropShadow_5958_71186"
            result="shape"
          />
        </filter>
        <linearGradient
          id="paint0_linear_5958_71186"
          x1="228.817"
          y1="25.6505"
          x2="231.167"
          y2="428.463"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#CAE0FF" stopOpacity="0" />
          <stop offset="1" stopColor="#BCD8FF" />
        </linearGradient>
        <linearGradient
          id="paint1_linear_5958_71186"
          x1="245.588"
          y1="109.366"
          x2="245.588"
          y2="181.262"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#ABCCFF" />
          <stop offset="1" stopColor="#0088FA" />
        </linearGradient>
        <linearGradient
          id="paint2_linear_5958_71186"
          x1="343.716"
          y1="109.366"
          x2="343.716"
          y2="181.254"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#70A8FF" />
          <stop offset="1" stopColor="#0088FA" />
        </linearGradient>
        <linearGradient
          id="paint3_linear_5958_71186"
          x1="365.28"
          y1="172.348"
          x2="333.005"
          y2="129.631"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#EDF4FF" />
          <stop offset="1" stopColor="#ABCCFF" />
        </linearGradient>
        <linearGradient
          id="paint4_linear_5958_71186"
          x1="251.705"
          y1="121.432"
          x2="251.705"
          y2="181.262"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#0088FA" />
          <stop offset="1" stopColor="#6095E7" />
        </linearGradient>
        <linearGradient
          id="paint5_linear_5958_71186"
          x1="206.755"
          y1="288.156"
          x2="140.307"
          y2="225.506"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#EDF4FF" />
          <stop offset="1" stopColor="#ABCCFF" />
        </linearGradient>
        <linearGradient
          id="paint6_linear_5958_71186"
          x1="261.337"
          y1="268.697"
          x2="194.89"
          y2="241.168"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#EDF4FF" />
          <stop offset="1" stopColor="#ABCCFF" />
        </linearGradient>
        <linearGradient
          id="paint7_linear_5958_71186"
          x1="320.191"
          y1="270.121"
          x2="258.49"
          y2="211.742"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#EDF4FF" />
          <stop offset="1" stopColor="#ABCCFF" />
        </linearGradient>
        <linearGradient
          id="paint8_linear_5958_71186"
          x1="312.214"
          y1="109.366"
          x2="312.214"
          y2="181.262"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#ABCCFF" />
          <stop offset="1" stopColor="#0088FA" />
        </linearGradient>
        <linearGradient
          id="paint9_linear_5958_71186"
          x1="176.854"
          y1="209.843"
          x2="168.31"
          y2="292.903"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#ABCCFF" />
          <stop offset="1" stopColor="#0088FA" />
        </linearGradient>
        <linearGradient
          id="paint10_linear_5958_71186"
          x1="123.221"
          y1="197.503"
          x2="258.964"
          y2="260.154"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#ABCCFF" />
          <stop offset="1" stopColor="#0088FA" />
        </linearGradient>
        <linearGradient
          id="paint11_linear_5958_71186"
          x1="365.28"
          y1="239.27"
          x2="280.322"
          y2="242.118"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#70A8FF" />
          <stop offset="1" stopColor="#0088FA" />
        </linearGradient>
        <linearGradient
          id="paint12_linear_5958_71186"
          x1="199.979"
          y1="181.415"
          x2="199.979"
          y2="216.978"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#70A8FF" />
          <stop offset="1" stopColor="#0088FA" />
        </linearGradient>
        <linearGradient
          id="paint13_linear_5958_71186"
          x1="196.973"
          y1="181.415"
          x2="196.973"
          y2="216.978"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#ABCCFF" />
          <stop offset="1" stopColor="#0088FA" />
        </linearGradient>
        <linearGradient
          id="paint14_linear_5958_71186"
          x1="196.977"
          y1="184.819"
          x2="196.977"
          y2="213.286"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#70A8FF" />
          <stop offset="1" stopColor="#0088FA" />
        </linearGradient>
        <linearGradient
          id="paint15_linear_5958_71186"
          x1="162.223"
          y1="160.521"
          x2="128.823"
          y2="157.186"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#C6DDFF" />
          <stop offset="1" stopColor="white" />
        </linearGradient>
        <linearGradient
          id="paint16_linear_5958_71186"
          x1="281.909"
          y1="141.535"
          x2="315.309"
          y2="138.201"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#C6DDFF" />
          <stop offset="1" stopColor="white" />
        </linearGradient>
        <linearGradient
          id="paint17_linear_5958_71186"
          x1="122.179"
          y1="145.544"
          x2="122.179"
          y2="157.347"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#EDF4FF" />
          <stop offset="1" stopColor="#0088FA" />
        </linearGradient>
        <linearGradient
          id="paint18_linear_5958_71186"
          x1="321.953"
          y1="126.559"
          x2="321.953"
          y2="138.362"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#EDF4FF" />
          <stop offset="1" stopColor="#0088FA" />
        </linearGradient>
        <linearGradient
          id="paint19_linear_5958_71186"
          x1="235.038"
          y1="91"
          x2="235.038"
          y2="181.025"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#EDF4FF" />
          <stop offset="1" stopColor="#0088FA" />
        </linearGradient>
        <linearGradient
          id="paint20_linear_5958_71186"
          x1="271.305"
          y1="113.969"
          x2="252.794"
          y2="99.7299"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#EDF4FF" />
          <stop offset="1" stopColor="#ABCCFF" />
        </linearGradient>
        <linearGradient
          id="paint21_linear_5958_71186"
          x1="108.508"
          y1="259.204"
          x2="198.363"
          y2="249.11"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0.09375" stopColor="#0088FA" />
          <stop offset="1" stopColor="#2A64BE" stopOpacity="0" />
        </linearGradient>
        <linearGradient
          id="paint22_linear_5958_71186"
          x1="177.803"
          y1="260.342"
          x2="256.859"
          y2="248.336"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0.09375" stopColor="#0088FA" />
          <stop offset="1" stopColor="#2A64BE" stopOpacity="0" />
        </linearGradient>
        <linearGradient
          id="paint23_linear_5958_71186"
          x1="240.929"
          y1="259.204"
          x2="314.57"
          y2="265.666"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0.09375" stopColor="#0088FA" />
          <stop offset="1" stopColor="#84B4FF" />
        </linearGradient>
        <linearGradient
          id="paint24_linear_5958_71186"
          x1="120.304"
          y1="86.2325"
          x2="182.98"
          y2="145.636"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#FF698D" />
          <stop offset="1" stopColor="#FF3868" />
        </linearGradient>
        <linearGradient
          id="paint25_linear_5958_71186"
          x1="297"
          y1="95.0964"
          x2="309.193"
          y2="95.0964"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#1987D8" />
          <stop offset="1" stopColor="#45B4D0" />
        </linearGradient>
        <linearGradient
          id="paint26_linear_5958_71186"
          x1="297"
          y1="95.0964"
          x2="309.193"
          y2="95.0964"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#1987D8" />
          <stop offset="1" stopColor="#45B4D0" />
        </linearGradient>
        <linearGradient
          id="paint27_linear_5958_71186"
          x1="269"
          y1="286.096"
          x2="281.193"
          y2="286.096"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#1987D8" />
          <stop offset="1" stopColor="#45B4D0" />
        </linearGradient>
        <linearGradient
          id="paint28_linear_5958_71186"
          x1="267.603"
          y1="282.286"
          x2="286.655"
          y2="298.797"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#94BFFF" />
          <stop offset="1" stopColor="#0088FA" />
        </linearGradient>
        <linearGradient
          id="paint29_linear_5958_71186"
          x1="104.759"
          y1="222.492"
          x2="115.744"
          y2="236.01"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#1987D8" />
          <stop offset="1" stopColor="#45B4D0" />
        </linearGradient>
        <linearGradient
          id="paint30_linear_5958_71186"
          x1="334.083"
          y1="226.399"
          x2="346.549"
          y2="214.233"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#1987D8" />
          <stop offset="1" stopColor="#45B4D0" />
        </linearGradient>
        <linearGradient
          id="paint31_linear_5958_71186"
          x1="200"
          y1="69.9021"
          x2="241.804"
          y2="69.9021"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#1987D8" />
          <stop offset="1" stopColor="#45B4D0" />
        </linearGradient>
        <linearGradient
          id="paint32_linear_5958_71186"
          x1="147"
          y1="291.902"
          x2="188.804"
          y2="291.902"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#1987D8" />
          <stop offset="1" stopColor="#45B4D0" />
        </linearGradient>
      </defs>
    </svg>
  );
}
export function StatusActive({ color }) {
  return (
    <svg
      width="1.111vw"
      height="1.111vw"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M16 8.375C16 8.93437 15.8656 9.45312 15.5969 9.92813C15.3281 10.4031 14.9688 10.775 14.5156 11.0344C14.5281 11.1188 14.5344 11.25 14.5344 11.4281C14.5344 12.275 14.25 12.9937 13.6875 13.5875C13.1219 14.1844 12.4406 14.4812 11.6438 14.4812C11.2875 14.4812 10.9469 14.4156 10.625 14.2844C10.375 14.7969 10.0156 15.2094 9.54375 15.525C9.075 15.8438 8.55937 16 8 16C7.42812 16 6.90938 15.8469 6.44688 15.5344C5.98125 15.225 5.625 14.8094 5.375 14.2844C5.05312 14.4156 4.71562 14.4812 4.35625 14.4812C3.55937 14.4812 2.875 14.1844 2.30312 13.5875C1.73125 12.9937 1.44687 12.2719 1.44687 11.4281C1.44687 11.3344 1.45938 11.2031 1.48125 11.0344C1.02813 10.7719 0.66875 10.4031 0.4 9.92813C0.134375 9.45312 0 8.93437 0 8.375C0 7.78125 0.15 7.23438 0.446875 6.74062C0.74375 6.24687 1.14375 5.88125 1.64375 5.64375C1.5125 5.2875 1.44687 4.92812 1.44687 4.57188C1.44687 3.72813 1.73125 3.00625 2.30312 2.4125C2.875 1.81875 3.55937 1.51875 4.35625 1.51875C4.7125 1.51875 5.05312 1.58438 5.375 1.71563C5.625 1.20312 5.98438 0.790625 6.45625 0.475C6.925 0.159375 7.44063 0 8 0C8.55937 0 9.075 0.159375 9.54375 0.471875C10.0125 0.7875 10.375 1.2 10.625 1.7125C10.9469 1.58125 11.2844 1.51562 11.6438 1.51562C12.4406 1.51562 13.1219 1.8125 13.6875 2.40937C14.2531 3.00625 14.5344 3.725 14.5344 4.56875C14.5344 4.9625 14.475 5.31875 14.3562 5.64062C14.8562 5.87813 15.2563 6.24375 15.5531 6.7375C15.85 7.23438 16 7.78125 16 8.375ZM7.65938 10.7844L10.9625 5.8375C11.0469 5.70625 11.0719 5.5625 11.0437 5.40938C11.0125 5.25625 10.9344 5.13438 10.8031 5.05312C10.6719 4.96875 10.5281 4.94063 10.375 4.9625C10.2188 4.9875 10.0938 5.0625 10 5.19375L7.09062 9.56875L5.75 8.23125C5.63125 8.1125 5.49375 8.05625 5.34062 8.0625C5.18437 8.06875 5.05 8.125 4.93125 8.23125C4.825 8.3375 4.77187 8.47187 4.77187 8.63437C4.77187 8.79375 4.825 8.92813 4.93125 9.0375L6.77187 10.8781L6.8625 10.95C6.96875 11.0219 7.07812 11.0562 7.18437 11.0562C7.39375 11.0531 7.55313 10.9656 7.65938 10.7844Z"
        fill={color}
      />
    </svg>
  );
}
StatusActive.propTypes = {
  color: PropTypes.string,
};
StatusActive.defaultProps = {
  color: '#3897F0',
};
export function StatusInactive() {
  return (
    <svg
      width="0.972vw"
      height="0.972vw"
      viewBox="0 0 14 14"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M6.99992 0.333252C3.32659 0.333252 0.333252 3.32659 0.333252 6.99992C0.333252 10.6733 3.32659 13.6666 6.99992 13.6666C10.6733 13.6666 13.6666 10.6733 13.6666 6.99992C13.6666 3.32659 10.6733 0.333252 6.99992 0.333252ZM9.89992 9.37992C9.80659 9.53992 9.63992 9.62659 9.46659 9.62659C9.37992 9.62659 9.29325 9.60659 9.21325 9.55325L7.14659 8.31992C6.63325 8.01325 6.25325 7.33992 6.25325 6.74659V4.01325C6.25325 3.73992 6.47992 3.51325 6.75325 3.51325C7.02659 3.51325 7.25325 3.73992 7.25325 4.01325V6.74659C7.25325 6.98659 7.45325 7.33992 7.65992 7.45992L9.72659 8.69325C9.96659 8.83325 10.0466 9.13992 9.89992 9.37992Z"
        fill="#F2C94C"
      />
    </svg>
  );
}
export function PricePerUnitIcon() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="40"
      height="40"
      viewBox="10 10 20 20"
      fill="none"
    >
      <g clipPath="url(#clip0_2066_39185)">
        <path
          d="M19.9997 3.33325C10.783 3.33325 3.33301 10.7833 3.33301 19.9999C3.33301 29.2166 10.783 36.6666 19.9997 36.6666C29.2163 36.6666 36.6663 29.2166 36.6663 19.9999C36.6663 10.7833 29.2163 3.33325 19.9997 3.33325Z"
          fill="url(#paint0_linear_2066_39185)"
        />
        <path
          d="M26.183 19.7917H23.333C22.9913 19.7917 22.708 19.5084 22.708 19.1667V13.3417C22.708 12.7251 22.9497 12.1501 23.383 11.7167C23.8163 11.2834 24.3913 11.0417 25.008 11.0417H25.0163C26.058 11.0501 27.0413 11.4584 27.7913 12.2001C28.5413 12.9584 28.9497 13.9584 28.9497 15.0001V17.0167C28.958 18.6751 27.8413 19.7917 26.183 19.7917ZM23.958 18.5417H26.183C27.1497 18.5417 27.708 17.9834 27.708 17.0167V15.0001C27.708 14.2834 27.4247 13.6001 26.9163 13.0834C26.408 12.5834 25.7247 12.3001 25.0163 12.2917C25.0163 12.2917 25.0163 12.2917 25.008 12.2917C24.733 12.2917 24.4663 12.4001 24.2663 12.6001C24.0663 12.8001 23.958 13.0584 23.958 13.3417V18.5417Z"
          fill="white"
        />
        <path
          d="M17.5003 29.4417C17.1087 29.4417 16.742 29.2917 16.467 29.0084L15.0837 27.6167C15.0087 27.5417 14.892 27.5334 14.8087 27.6001L13.3753 28.6667C12.9337 29.0001 12.3503 29.0584 11.8503 28.8084C11.3503 28.5584 11.042 28.0584 11.042 27.5001V15.0001C11.042 12.4834 12.4837 11.0417 15.0003 11.0417H25.0003C25.342 11.0417 25.6253 11.3251 25.6253 11.6667C25.6253 12.0084 25.342 12.2917 25.0003 12.2917C24.4253 12.2917 23.9587 12.7584 23.9587 13.3334V27.5001C23.9587 28.0584 23.6503 28.5584 23.1503 28.8084C22.6503 29.0584 22.067 29.0084 21.6253 28.6751L20.2003 27.6084C20.117 27.5417 20.0003 27.5584 19.9337 27.6251L18.5337 29.0251C18.2587 29.2917 17.892 29.4417 17.5003 29.4417ZM14.9253 26.3084C15.3087 26.3084 15.6837 26.4501 15.967 26.7417L17.3503 28.1334C17.4003 28.1834 17.467 28.1917 17.5003 28.1917C17.5337 28.1917 17.6003 28.1834 17.6503 28.1334L19.0503 26.7334C19.567 26.2167 20.3837 26.1667 20.9587 26.6084L22.3753 27.6667C22.467 27.7334 22.5503 27.7084 22.592 27.6834C22.6337 27.6584 22.7087 27.6084 22.7087 27.5001V13.3334C22.7087 12.9584 22.8003 12.6001 22.9587 12.2917H15.0003C13.1503 12.2917 12.292 13.1501 12.292 15.0001V27.5001C12.292 27.6167 12.367 27.6667 12.4087 27.6917C12.4587 27.7168 12.542 27.7334 12.6253 27.6667L14.0503 26.6001C14.3087 26.4084 14.617 26.3084 14.9253 26.3084Z"
          fill="white"
        />
        <path
          d="M20 21.4668H17.5C17.1583 21.4668 16.875 21.1835 16.875 20.8418C16.875 20.5001 17.1583 20.2168 17.5 20.2168H20C20.3417 20.2168 20.625 20.5001 20.625 20.8418C20.625 21.1835 20.3417 21.4668 20 21.4668Z"
          fill="white"
        />
        <path
          d="M20 18.1333H17.5C17.1583 18.1333 16.875 17.85 16.875 17.5083C16.875 17.1666 17.1583 16.8833 17.5 16.8833H20C20.3417 16.8833 20.625 17.1666 20.625 17.5083C20.625 17.85 20.3417 18.1333 20 18.1333Z"
          fill="white"
        />
        <path
          d="M14.9749 18.3417C14.5166 18.3417 14.1416 17.9667 14.1416 17.5084C14.1416 17.05 14.5166 16.675 14.9749 16.675C15.4333 16.675 15.8083 17.05 15.8083 17.5084C15.8083 17.9667 15.4333 18.3417 14.9749 18.3417Z"
          fill="white"
        />
        <path
          d="M14.9749 21.675C14.5166 21.675 14.1416 21.3 14.1416 20.8416C14.1416 20.3833 14.5166 20.0083 14.9749 20.0083C15.4333 20.0083 15.8083 20.3833 15.8083 20.8416C15.8083 21.3 15.4333 21.675 14.9749 21.675Z"
          fill="white"
        />
      </g>
    </svg>
  );
}
export function DiscountIcon() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="40"
      height="40"
      viewBox="10 10 20 20"
      fill="none"
    >
      <g clipPath="url(#clip0_2066_39209)">
        <path
          d="M19.9997 3.33325C10.783 3.33325 3.33301 10.7833 3.33301 19.9999C3.33301 29.2166 10.783 36.6666 19.9997 36.6666C29.2163 36.6666 36.6663 29.2166 36.6663 19.9999C36.6663 10.7833 29.2163 3.33325 19.9997 3.33325Z"
          fill="url(#paint0_linear_2066_39209)"
        />
        <path
          d="M26.183 19.7917H23.333C22.9913 19.7917 22.708 19.5084 22.708 19.1667V13.3417C22.708 12.7251 22.9497 12.1501 23.383 11.7167C23.8163 11.2834 24.3913 11.0417 25.008 11.0417H25.0163C26.058 11.0501 27.0413 11.4584 27.7913 12.2001C28.5413 12.9584 28.9497 13.9584 28.9497 15.0001V17.0167C28.958 18.6751 27.8413 19.7917 26.183 19.7917ZM23.958 18.5417H26.183C27.1497 18.5417 27.708 17.9834 27.708 17.0167V15.0001C27.708 14.2834 27.4247 13.6001 26.9163 13.0834C26.408 12.5834 25.7247 12.3001 25.0163 12.2917C25.0163 12.2917 25.0163 12.2917 25.008 12.2917C24.733 12.2917 24.4663 12.4001 24.2663 12.6001C24.0663 12.8001 23.958 13.0584 23.958 13.3417V18.5417Z"
          fill="white"
        />
        <path
          d="M17.4998 29.4417C17.1081 29.4417 16.7415 29.2917 16.4665 29.0084L15.0831 27.6167C15.0081 27.5417 14.8915 27.5334 14.8081 27.6001L13.3831 28.6667C12.9415 29.0001 12.3581 29.0584 11.8581 28.8084C11.3581 28.5584 11.0498 28.0584 11.0498 27.5001V15.0001C11.0498 12.4834 12.4915 11.0417 15.0081 11.0417H25.0081C25.3498 11.0417 25.6331 11.3251 25.6331 11.6667C25.6331 12.0084 25.3498 12.2917 25.0081 12.2917C24.4331 12.2917 23.9665 12.7584 23.9665 13.3334V27.5001C23.9665 28.0584 23.6581 28.5584 23.1581 28.8084C22.6581 29.0584 22.0748 29.0084 21.6331 28.6751L20.2081 27.6084C20.1248 27.5417 20.0081 27.5584 19.9415 27.6251L18.5415 29.0251C18.2581 29.2917 17.8915 29.4417 17.4998 29.4417ZM14.9248 26.3084C15.3081 26.3084 15.6831 26.4501 15.9665 26.7417L17.3498 28.1334C17.3998 28.1834 17.4665 28.1917 17.4998 28.1917C17.5331 28.1917 17.5998 28.1834 17.6498 28.1334L19.0498 26.7334C19.5665 26.2167 20.3831 26.1667 20.9581 26.6084L22.3748 27.6667C22.4665 27.7334 22.5498 27.7084 22.5915 27.6834C22.6331 27.6584 22.7081 27.6084 22.7081 27.5001V13.3334C22.7081 12.9584 22.7998 12.6001 22.9581 12.2917H14.9998C13.1498 12.2917 12.2915 13.1501 12.2915 15.0001V27.5001C12.2915 27.6167 12.3665 27.6667 12.4081 27.6917C12.4581 27.7168 12.5415 27.7334 12.6248 27.6667L14.0498 26.6001C14.3081 26.4084 14.6165 26.3084 14.9248 26.3084Z"
          fill="white"
        />
        <path
          d="M19.5247 21.7333C19.0581 21.7333 18.6914 21.3583 18.6914 20.9C18.6914 20.4417 19.0664 20.0667 19.5247 20.0667C19.9831 20.0667 20.3581 20.4417 20.3581 20.9C20.3581 21.3583 19.9831 21.7333 19.5247 21.7333Z"
          fill="white"
        />
        <path
          d="M15.4749 18.3583C15.0083 18.3583 14.6416 17.9833 14.6416 17.525C14.6416 17.0667 15.0166 16.6917 15.4749 16.6917C15.9333 16.6917 16.3083 17.0667 16.3083 17.525C16.3083 17.9833 15.9333 18.3583 15.4749 18.3583Z"
          fill="white"
        />
        <path
          d="M15.2245 22.0667C15.0661 22.0667 14.9078 22.0084 14.7828 21.8834C14.5411 21.6417 14.5411 21.2417 14.7828 21L19.3328 16.45C19.5745 16.2084 19.9745 16.2084 20.2161 16.45C20.4578 16.6917 20.4578 17.0917 20.2161 17.3334L15.6661 21.8834C15.5495 22 15.3828 22.0667 15.2245 22.0667Z"
          fill="white"
        />
      </g>
    </svg>
  );
}
export function QuantityIcon() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="40"
      height="40"
      viewBox="10 10 20 20"
      fill="none"
    >
      <g clipPath="url(#clip0_2066_39230)">
        <path
          d="M19.9997 3.33325C10.783 3.33325 3.33301 10.7833 3.33301 19.9999C3.33301 29.2166 10.783 36.6666 19.9997 36.6666C29.2163 36.6666 36.6663 29.2166 36.6663 19.9999C36.6663 10.7833 29.2163 3.33325 19.9997 3.33325Z"
          fill="url(#paint0_linear_2066_39230)"
        />
        <path
          d="M23.1501 28.9582H12.2001C11.4084 28.9582 10.6751 28.5916 10.2001 27.9499C9.71677 27.2999 9.57511 26.4832 9.81678 25.7082L13.3251 14.4332C13.6418 13.3832 14.6085 12.6665 15.7085 12.6665H25.9584C26.9668 12.6665 27.8751 13.2666 28.2584 14.1999C28.4668 14.6832 28.5084 15.2333 28.3834 15.7749L25.5751 27.0498C25.3084 28.1748 24.3084 28.9582 23.1501 28.9582ZM15.7168 13.9248C15.1751 13.9248 14.6834 14.2832 14.5251 14.8082L11.0168 26.0833C10.9001 26.4749 10.9668 26.8832 11.2168 27.2166C11.4501 27.5332 11.8168 27.7166 12.2084 27.7166H23.1585C23.7335 27.7166 24.2334 27.3249 24.3668 26.7665L27.1751 15.4832C27.2418 15.2082 27.2251 14.9332 27.1168 14.6915C26.9168 14.2165 26.4751 13.9165 25.9668 13.9165H15.7168V13.9248Z"
          fill="white"
        />
        <path
          d="M26.8163 28.9584H22.833C22.4913 28.9584 22.208 28.6751 22.208 28.3334C22.208 27.9917 22.4913 27.7084 22.833 27.7084H26.8163C27.158 27.7084 27.4747 27.5667 27.708 27.3167C27.9413 27.0667 28.058 26.7334 28.033 26.3918L27.208 15.0418C27.183 14.7001 27.4413 14.4001 27.783 14.3751C28.1247 14.3584 28.4247 14.6083 28.4497 14.95L29.2747 26.3001C29.3247 26.9834 29.083 27.6668 28.6163 28.1668C28.158 28.6751 27.4997 28.9584 26.8163 28.9584Z"
          fill="white"
        />
        <path
          d="M17.5661 15.9416C17.5161 15.9416 17.4662 15.9332 17.4162 15.9249C17.0828 15.8416 16.8745 15.5082 16.9578 15.1665L17.8245 11.5666C17.9078 11.2333 18.2411 11.0249 18.5828 11.1082C18.9161 11.1916 19.1245 11.5249 19.0412 11.8666L18.1745 15.4666C18.1078 15.75 17.8495 15.9416 17.5661 15.9416Z"
          fill="white"
        />
        <path
          d="M23.1502 15.95C23.1085 15.95 23.0585 15.95 23.0169 15.9333C22.6835 15.8583 22.4669 15.525 22.5335 15.1917L23.3168 11.575C23.3918 11.2334 23.7252 11.0251 24.0585 11.0917C24.3919 11.1584 24.6085 11.5 24.5418 11.8333L23.7585 15.4501C23.7002 15.7501 23.4419 15.95 23.1502 15.95Z"
          fill="white"
        />
        <path
          d="M22.5837 20.625H15.917C15.5753 20.625 15.292 20.3417 15.292 20C15.292 19.6583 15.5753 19.375 15.917 19.375H22.5837C22.9253 19.375 23.2087 19.6583 23.2087 20C23.2087 20.3417 22.9253 20.625 22.5837 20.625Z"
          fill="white"
        />
        <path
          d="M21.7507 23.9583H15.084C14.7423 23.9583 14.459 23.6749 14.459 23.3333C14.459 22.9916 14.7423 22.7083 15.084 22.7083H21.7507C22.0923 22.7083 22.3757 22.9916 22.3757 23.3333C22.3757 23.6749 22.0923 23.9583 21.7507 23.9583Z"
          fill="white"
        />
      </g>
    </svg>
  );
}
export function DocumentCopyIcon() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="0.972vw"
      height="15"
      viewBox="0 0 14 15"
      fill="none"
    >
      <path
        d="M9.04163 8.17087H7.77579C6.73746 8.17087 5.89163 7.33087 5.89163 6.28671V5.02087C5.89163 4.78171 5.69913 4.58337 5.45413 4.58337H3.60496C2.25746 4.58337 1.16663 5.45837 1.16663 7.02171V10.895C1.16663 12.4584 2.25746 13.3334 3.60496 13.3334H7.04079C8.38829 13.3334 9.47913 12.4584 9.47913 10.895V8.60837C9.47913 8.36337 9.28079 8.17087 9.04163 8.17087Z"
        fill="#616B80"
      />
      <path
        d="M10.3949 1.66663H9.24578H8.60994H6.95911C5.64078 1.66663 4.57328 2.50663 4.52661 4.00579C4.56161 4.00579 4.59078 3.99996 4.62578 3.99996H6.27661H6.91244H8.06161C9.40911 3.99996 10.4999 4.87496 10.4999 6.43829V7.58746V9.16829V10.3175C10.4999 10.3525 10.4941 10.3816 10.4941 10.4108C11.7949 10.37 12.8333 9.50663 12.8333 7.98413V6.83496V5.25413V4.10496C12.8333 2.54163 11.7424 1.66663 10.3949 1.66663Z"
        fill="#616B80"
      />
      <path
        d="M6.98829 4.67081C6.80746 4.48998 6.49829 4.61248 6.49829 4.86331V6.39164C6.49829 7.03331 7.04079 7.55831 7.70579 7.55831C8.11996 7.56414 8.69746 7.56414 9.19329 7.56414C9.44412 7.56414 9.57246 7.27248 9.39746 7.09748C8.76162 6.46164 7.62996 5.32414 6.98829 4.67081Z"
        fill="#616B80"
      />
    </svg>
  );
}
export function DocumentUplaoadIcon() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="0.972vw"
      height="15"
      viewBox="0 0 14 15"
      fill="none"
    >
      <path
        d="M11.9584 6.44413H10.2725C8.89004 6.44413 7.76421 5.31829 7.76421 3.93579V2.24996C7.76421 1.92913 7.50171 1.66663 7.18087 1.66663H4.70754C2.91087 1.66663 1.45837 2.83329 1.45837 4.91579V10.0841C1.45837 12.1666 2.91087 13.3333 4.70754 13.3333H9.29254C11.0892 13.3333 12.5417 12.1666 12.5417 10.0841V7.02746C12.5417 6.70663 12.2792 6.44413 11.9584 6.44413ZM6.72587 8.39246C6.63837 8.47996 6.52754 8.52079 6.41671 8.52079C6.30587 8.52079 6.19504 8.47996 6.10754 8.39246L5.68754 7.97246V10.4166C5.68754 10.6558 5.48921 10.8541 5.25004 10.8541C5.01087 10.8541 4.81254 10.6558 4.81254 10.4166V7.97246L4.39254 8.39246C4.22337 8.56163 3.94337 8.56163 3.77421 8.39246C3.60504 8.22329 3.60504 7.94329 3.77421 7.77413L4.94087 6.60746C4.98171 6.57246 5.02254 6.54329 5.06921 6.51996C5.08087 6.51413 5.09837 6.50829 5.11004 6.50246C5.14504 6.49079 5.18004 6.48496 5.22087 6.47913C5.23837 6.47913 5.25004 6.47913 5.26754 6.47913C5.31421 6.47913 5.36087 6.49079 5.40754 6.50829C5.41337 6.50829 5.41337 6.50829 5.41921 6.50829C5.46587 6.52579 5.51254 6.56079 5.54754 6.59579C5.55337 6.60163 5.55921 6.60163 5.55921 6.60746L6.72587 7.77413C6.89504 7.94329 6.89504 8.22329 6.72587 8.39246Z"
        fill="#616B80"
      />
      <path
        d="M10.1675 5.6392C10.7217 5.64504 11.4917 5.64504 12.1509 5.64504C12.4834 5.64504 12.6584 5.2542 12.425 5.02087C11.585 4.17504 10.08 2.65254 9.21669 1.7892C8.97752 1.55004 8.56335 1.71337 8.56335 2.04587V4.0817C8.56335 4.93337 9.28669 5.6392 10.1675 5.6392Z"
        fill="#616B80"
      />
    </svg>
  );
}
export function IncidentsNoData({ size }) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 940 940"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect width="940" height="940" fill="white" />
      <path
        d="M806.311 272.6C842.344 299.756 858.419 336.804 850.527 400.719C843.562 457.119 820.933 479.749 836.601 530.927C851.189 578.575 905.934 705.824 817.8 795.867C729.666 885.909 576.187 862.362 521.179 854.703C466.171 847.044 397.933 833.467 319.949 855.4C248.905 875.381 186.902 862.004 165.283 808.4C143.871 755.308 173.727 688.986 195.312 651.386C216.898 613.786 219.209 581.231 186.957 567.83C148.833 551.989 123.244 506.033 163.455 447.022C199.144 394.648 266.932 343.841 421.609 308.111C491.689 291.922 542.067 286.7 629.104 258.674C680.692 242.063 758.783 236.782 806.311 272.6Z"
        fill="url(#paint0_linear_8356_28822)"
      />
      <path
        d="M836.601 530.926C820.933 479.749 843.562 457.119 850.526 400.718C858.419 336.804 842.344 299.756 806.311 272.6C773.527 247.894 726.204 242.744 683.066 247.376V740.511L825.664 787.301C902.544 697.931 850.731 577.083 836.601 530.926Z"
        fill="url(#paint1_linear_8356_28822)"
      />
      <path
        d="M757.745 769.313V250.871C756.704 250.628 755.66 250.393 754.611 250.168V769.313H757.745Z"
        fill="#0088FA"
      />
      <g opacity="0.7">
        <path
          d="M633.804 748.321V257.215C632.216 257.692 630.648 258.177 629.104 258.673L628.582 258.839V747.491C630.352 747.763 632.093 748.039 633.804 748.321Z"
          fill="url(#paint2_linear_8356_28822)"
        />
        <path
          d="M556.933 741.386V279.197C555.178 279.628 553.443 280.047 551.711 280.463V741.291C553.465 741.316 555.208 741.347 556.933 741.386Z"
          fill="url(#paint3_linear_8356_28822)"
        />
        <path
          d="M480.062 744.196V295.754L474.84 296.799V744.702C476.589 744.528 478.331 744.357 480.062 744.196Z"
          fill="url(#paint4_linear_8356_28822)"
        />
        <path
          d="M403.191 756.956V312.544C401.438 312.981 399.697 313.422 397.969 313.864V758.324C399.707 757.858 401.448 757.402 403.191 756.956Z"
          fill="url(#paint5_linear_8356_28822)"
        />
        <path
          d="M326.321 784.03V335.597C324.563 336.229 322.822 336.864 321.099 337.502V786.42C322.835 785.613 324.576 784.816 326.321 784.03Z"
          fill="url(#paint6_linear_8356_28822)"
        />
        <path
          d="M249.449 826.847V370.442C247.7 371.447 245.959 372.467 244.227 373.501V830.406C245.96 829.21 247.701 828.023 249.449 826.847Z"
          fill="url(#paint7_linear_8356_28822)"
        />
      </g>
      <path
        d="M319.949 855.4C397.933 833.467 466.171 847.044 521.179 854.703C576.187 862.362 729.666 885.909 817.8 795.867C826.933 786.536 834.511 776.8 840.779 766.801C790.807 740.221 687.167 702.956 507.252 711.267C310.213 720.369 223.854 786.018 191.642 843.621C221.701 866.821 268.441 869.886 319.949 855.4Z"
        fill="url(#paint8_linear_8356_28822)"
      />
      <path
        d="M779.156 444.933C782.905 444.933 785.944 441.894 785.944 438.144C785.944 434.395 782.905 431.356 779.156 431.356C775.406 431.356 772.367 434.395 772.367 438.144C772.367 441.894 775.406 444.933 779.156 444.933Z"
        fill="url(#paint9_linear_8356_28822)"
      />
      <path
        d="M732.417 443.628C736.166 443.628 739.206 440.588 739.206 436.839C739.206 433.089 736.166 430.05 732.417 430.05C728.667 430.05 725.628 433.089 725.628 436.839C725.628 440.588 728.667 443.628 732.417 443.628Z"
        fill="url(#paint10_linear_8356_28822)"
      />
      <path
        d="M150.4 319.426C122.722 300.103 160.6 263.145 136.126 235C115.237 210.978 74.6361 189.185 83.5765 143.241C92.9557 95.0444 171.289 80.0744 214.836 88.6295C242.379 94.0407 247.01 93.0548 295.23 85.2966C357.983 75.2 406.811 96.0889 431.356 128.989C454.566 160.101 458.163 207.844 417.699 230.16C384.862 248.27 326.389 257.456 288.267 271.033C211.502 298.374 179.339 339.628 150.4 319.426Z"
        fill="url(#paint11_linear_8356_28822)"
      />
      <path
        d="M635.257 780.224C630.463 775.549 625.246 771.331 619.671 767.623C611.001 761.843 601.545 757.265 591.678 753.901C571.912 747.189 550.58 745.321 529.782 748.21C509.001 751.128 488.61 759.007 471.565 772.137C463.064 778.692 455.428 786.566 449.291 795.646C446.2 800.206 443.531 805.038 441.316 810.082C440.14 812.77 439.103 815.517 438.209 818.312L454.612 822.468C456.441 816.128 459.164 810.059 462.692 804.344C467.469 796.6 473.662 789.615 480.79 783.636C495.073 771.647 512.976 763.741 531.726 760.327C550.501 756.92 570.248 757.8 588.702 763.242C603.405 767.575 617.378 774.895 628.937 785.013L635.257 780.224Z"
        fill="url(#paint12_linear_8356_28822)"
      />
      <path
        d="M524.629 745.917C519.835 741.243 514.617 737.024 509.042 733.316C500.372 727.536 490.917 722.958 481.049 719.594C461.284 712.882 439.951 711.014 419.153 713.903C398.373 716.821 377.981 724.7 360.937 737.83C352.435 744.385 344.799 752.259 338.662 761.339C335.571 765.899 332.902 770.731 330.688 775.775C329.512 778.463 328.475 781.21 327.581 784.005L340.85 786.072C342.679 779.732 345.402 773.663 348.93 767.949C353.707 760.204 359.9 753.219 367.028 747.24C381.311 735.251 399.214 727.345 417.965 723.932C436.74 720.525 456.486 721.404 474.94 726.847C489.643 731.179 503.616 738.499 515.175 748.617L524.629 745.917Z"
        fill="url(#paint13_linear_8356_28822)"
      />
      <path
        d="M744.341 504.816L570.266 463.994C570.266 463.994 551.26 583.849 488.452 611.697C414.644 644.422 345.711 644.422 345.711 644.422L381.345 727.231C381.345 727.231 441.8 769.756 534.408 760.008C683.87 744.275 726.15 608.389 744.341 504.816Z"
        fill="url(#paint14_linear_8356_28822)"
      />
      <path
        d="M186.433 754.09C181.959 757.123 139.632 770.713 131.383 771.154C122.527 771.626 93.5739 724.48 94.5223 715.836C95.1061 710.508 100.649 712.898 104.053 715.053C107.457 717.21 127.031 731.111 136.692 732.025C148.935 733.182 165.729 721.073 165.729 721.073L186.433 754.09Z"
        fill="url(#paint15_linear_8356_28822)"
      />
      <path
        d="M124.758 722.984C125.783 725.907 119.655 743.383 106.011 752.327C82.8433 722.89 86.3777 708.84 86.3777 708.84C86.3777 708.84 88.0854 707.311 91.7075 707.935C96.1757 708.704 124.758 722.984 124.758 722.984Z"
        fill="url(#paint16_linear_8356_28822)"
      />
      <path
        d="M87.6999 708.149C88.219 718.909 96.7563 734.464 106.177 749.53C114.236 762.419 121.32 772.591 121.504 773.15C121.689 773.708 117.406 775.711 115.604 774.505C113.802 773.299 105.649 761.405 96.1766 743.383C86.3411 724.67 84.0141 716.454 84.3368 712.444C84.6606 708.435 87.6999 708.149 87.6999 708.149Z"
        fill="url(#paint17_linear_8356_28822)"
      />
      <path
        d="M448.713 578.918C448.713 578.918 322.297 642.861 271.208 666.703C224.208 688.638 154.468 723.219 154.23 725.54C153.992 727.861 175.487 758.081 183.127 758.615C198.097 759.659 302.89 711.615 334.224 702.91C359.259 695.956 479.229 663.789 496.722 660.894L448.713 578.918Z"
        fill="url(#paint18_linear_8356_28822)"
      />
      <path
        d="M172.239 751.414C171.991 751.414 171.751 751.325 171.562 751.164C171.374 751.003 171.248 750.779 171.209 750.534C171.17 750.289 171.22 750.038 171.349 749.826C171.478 749.614 171.679 749.455 171.915 749.377C177.964 747.394 278.135 710.278 305.57 697.095C305.694 697.035 305.828 697.001 305.965 696.993C306.102 696.986 306.239 697.005 306.368 697.051C306.498 697.096 306.617 697.167 306.719 697.258C306.821 697.35 306.904 697.46 306.964 697.584C307.023 697.708 307.058 697.842 307.065 697.979C307.073 698.116 307.053 698.253 307.008 698.382C306.962 698.512 306.892 698.631 306.8 698.733C306.709 698.835 306.598 698.918 306.475 698.978C278.977 712.19 178.624 749.375 172.565 751.362C172.46 751.397 172.35 751.415 172.239 751.414Z"
        fill="#0088FA"
      />
      <path
        d="M594.915 477.63C580.031 474.611 560.894 470.763 547.192 474.002C514.042 481.838 495.249 535.341 465.998 542.763C448.716 547.148 410.663 538.207 381.478 532.215L376.158 562.006C406.59 573.803 440.797 585.675 458.773 587.238C488.8 589.85 605.844 479.846 594.915 477.63Z"
        fill="url(#paint19_linear_8356_28822)"
      />
      <path
        d="M355.372 527.706C329.261 525.094 320.116 533.246 315.944 537.106C315.944 537.106 343.934 549.515 376.157 562.007L381.477 532.216C371.27 530.12 362.138 528.381 355.372 527.706Z"
        fill="url(#paint20_linear_8356_28822)"
      />
      <path
        d="M341.065 538.306C340.969 538.305 340.875 538.279 340.793 538.228C340.711 538.178 340.645 538.106 340.601 538.02C340.558 537.935 340.539 537.839 340.546 537.743C340.553 537.647 340.587 537.555 340.644 537.477C343.347 533.744 351.94 534.435 358.849 534.99C361.42 535.196 363.638 535.375 365.088 535.279C365.221 535.278 365.35 535.328 365.447 535.419C365.545 535.51 365.604 535.635 365.613 535.768C365.622 535.901 365.579 536.032 365.495 536.135C365.41 536.238 365.289 536.304 365.157 536.321C363.634 536.423 361.378 536.24 358.767 536.03C352.472 535.525 343.849 534.831 341.492 538.089C341.443 538.156 341.378 538.211 341.304 538.249C341.23 538.286 341.148 538.306 341.065 538.306Z"
        fill="#C68D50"
      />
      <path
        d="M376.157 563.052C376.005 563.052 375.854 563.019 375.715 562.954C375.576 562.89 375.454 562.795 375.355 562.678C375.257 562.561 375.186 562.424 375.147 562.276C375.107 562.128 375.101 561.974 375.128 561.823L380.448 532.033C380.507 531.77 380.665 531.54 380.889 531.391C381.113 531.242 381.387 531.185 381.652 531.232C381.917 531.279 382.153 531.427 382.312 531.645C382.471 531.862 382.54 532.132 382.505 532.399L377.184 562.19C377.141 562.431 377.015 562.65 376.827 562.807C376.64 562.965 376.403 563.051 376.157 563.052Z"
        fill="#FDD3A7"
      />
      <path
        d="M403.025 740.381C404.908 744.831 424.697 774.586 423.653 781.897C422.531 789.746 370.099 818.955 362.683 816.625C358.114 815.189 361.639 810.097 364.119 807.486C366.6 804.875 385.661 785.422 383.703 773.672C382.648 767.342 373.781 753.567 373.781 753.567L403.025 740.381Z"
        fill="url(#paint21_linear_8356_28822)"
      />
      <path
        d="M372.344 787.642C375.086 787.25 391.014 793.778 396.497 805.919C366.666 821.13 353.283 818.844 353.283 818.844C353.283 818.844 352.239 817.081 353.414 814.014C354.864 810.229 372.344 787.642 372.344 787.642Z"
        fill="url(#paint22_linear_8356_28822)"
      />
      <path
        d="M352.858 816.759C356.22 816.756 377.097 810.356 392.051 805.005C407.005 799.653 427.765 789.208 428.287 789.143C428.809 789.077 429.919 792.406 428.548 793.778C427.177 795.149 401.675 808.313 384.551 814.471C368.389 820.283 359.549 822.24 356.09 821.26C352.63 820.281 352.858 816.759 352.858 816.759Z"
        fill="url(#paint23_linear_8356_28822)"
      />
      <path
        d="M306.719 533.016C272.861 537.367 271.035 575.572 278.519 598.468C291.661 638.678 366.256 754.652 369.038 757.92C373.106 762.7 407.682 744.69 409.074 741.557C410.467 738.423 388.619 689.55 377.741 668.445C364.86 643.455 339.793 599.86 339.793 599.86C339.793 599.86 428.745 723.539 520.482 706.393C521.349 706.231 522.208 706.055 523.069 705.885L448.714 578.919C429.377 576.39 342.775 528.381 306.719 533.016Z"
        fill="url(#paint24_linear_8356_28822)"
      />
      <path
        d="M505.75 683.445C472.512 683.445 420.618 652.872 355.233 594.692C353.593 593.232 352.436 592.202 351.83 591.694C351.724 591.606 351.638 591.498 351.574 591.377C351.511 591.255 351.472 591.122 351.46 590.985C351.448 590.849 351.463 590.711 351.504 590.58C351.545 590.449 351.612 590.328 351.7 590.223C351.788 590.118 351.896 590.031 352.018 589.968C352.139 589.904 352.272 589.865 352.409 589.853C352.546 589.841 352.683 589.856 352.814 589.898C352.945 589.939 353.067 590.005 353.172 590.093C353.787 590.609 354.958 591.652 356.622 593.132C441.698 668.832 486.526 682.822 509.172 681.238C509.309 681.226 509.447 681.242 509.578 681.285C509.709 681.328 509.83 681.396 509.934 681.487C510.038 681.577 510.122 681.687 510.183 681.811C510.243 681.934 510.279 682.069 510.286 682.206C510.296 682.343 510.279 682.48 510.236 682.61C510.192 682.74 510.124 682.861 510.034 682.964C509.944 683.068 509.834 683.152 509.711 683.214C509.589 683.275 509.455 683.311 509.318 683.32C508.155 683.404 506.963 683.445 505.75 683.445Z"
        fill="#0088FA"
      />
      <path
        d="M319.078 602.383C318.88 602.383 318.686 602.327 318.519 602.222C318.352 602.116 318.218 601.965 318.134 601.786C316.596 598.542 311.918 588.665 316.016 581.744C318.33 577.836 323.029 575.645 329.983 575.231C330.121 575.22 330.261 575.236 330.393 575.28C330.524 575.323 330.646 575.393 330.751 575.484C330.856 575.575 330.942 575.686 331.003 575.811C331.065 575.935 331.1 576.071 331.109 576.209C331.117 576.348 331.098 576.487 331.052 576.618C331.006 576.749 330.934 576.87 330.841 576.973C330.748 577.076 330.635 577.159 330.509 577.218C330.383 577.277 330.247 577.31 330.108 577.316C323.89 577.685 319.753 579.534 317.815 582.808C315.471 586.768 316.214 592.852 320.023 600.893C320.098 601.052 320.132 601.228 320.121 601.404C320.11 601.579 320.055 601.75 319.961 601.898C319.866 602.047 319.736 602.169 319.581 602.254C319.427 602.339 319.254 602.383 319.078 602.383ZM397.393 750.139C397.184 750.139 396.98 750.076 396.807 749.959C396.634 749.842 396.501 749.676 396.423 749.482C386.571 724.863 339.196 632.101 333.081 622.529C332.941 622.295 332.897 622.017 332.959 621.752C333.021 621.487 333.185 621.257 333.414 621.111C333.643 620.964 333.92 620.913 334.187 620.968C334.453 621.023 334.688 621.18 334.841 621.405C340.976 631.006 388.485 724.026 398.362 748.707C398.425 748.865 398.448 749.037 398.43 749.206C398.412 749.376 398.352 749.538 398.257 749.679C398.161 749.821 398.033 749.936 397.882 750.016C397.732 750.097 397.564 750.139 397.393 750.139Z"
        fill="#0088FA"
      />
      <path
        d="M468.379 674.056C468.233 674.056 468.089 674.026 467.955 673.967C467.822 673.908 467.702 673.822 467.604 673.714C467.506 673.605 467.432 673.478 467.386 673.34C467.34 673.201 467.324 673.055 467.339 672.909C468.005 666.136 474.613 652.234 486.683 643.905C486.911 643.756 487.188 643.702 487.456 643.755C487.724 643.807 487.96 643.962 488.115 644.187C488.27 644.411 488.331 644.687 488.285 644.956C488.239 645.225 488.091 645.465 487.87 645.625C475.93 653.863 469.961 667.593 469.418 673.113C469.392 673.371 469.272 673.61 469.08 673.785C468.888 673.959 468.638 674.056 468.379 674.056Z"
        fill="#0088FA"
      />
      <path
        d="M675.059 553.903C675.495 511.778 630.322 489.061 608.216 481.141C604.689 479.877 586.43 474.939 570.763 473.895C555.096 472.85 538.523 492.654 522.57 520.134C504.989 550.422 476.098 581.76 449.111 578.971C448.986 578.957 448.845 578.935 448.713 578.918L523.068 705.884C616.174 687.397 674.407 616.942 675.059 553.903Z"
        fill="url(#paint25_linear_8356_28822)"
      />
      <path
        d="M523.07 706.929C522.888 706.929 522.708 706.882 522.55 706.791C522.392 706.7 522.26 706.57 522.168 706.412L447.813 579.446C447.738 579.328 447.688 579.196 447.665 579.057C447.643 578.919 447.648 578.778 447.682 578.642C447.715 578.506 447.775 578.378 447.859 578.265C447.942 578.153 448.048 578.059 448.169 577.988C448.289 577.917 448.423 577.872 448.562 577.854C448.701 577.836 448.842 577.846 448.977 577.883C449.112 577.921 449.238 577.985 449.347 578.073C449.457 578.16 449.548 578.268 449.614 578.391L523.97 705.357C524.063 705.516 524.112 705.696 524.113 705.88C524.113 706.063 524.066 706.244 523.974 706.403C523.883 706.563 523.752 706.695 523.593 706.787C523.434 706.88 523.254 706.929 523.07 706.929Z"
        fill="white"
      />
      <path
        d="M589.263 382.724C587.379 382.416 589.415 389.835 586.456 390.536C583.061 391.341 578.688 389.708 578.275 397.063C577.999 402.002 579.669 409.944 580.364 411.424C581.06 412.904 602.645 401.503 602.645 399.152C602.645 398.108 590.364 382.904 589.263 382.724Z"
        fill="url(#paint26_linear_8356_28822)"
      />
      <path
        d="M588.545 465.997C587.337 469.014 578.971 491.063 578.971 492.456C578.971 493.848 582.67 505.119 597.88 505.25C612.244 505.373 618.486 497.157 619.008 495.241C619.53 493.326 621.925 450.167 621.925 450.167C621.925 450.167 606.474 452.94 600.556 456.073C594.638 459.207 588.545 465.997 588.545 465.997Z"
        fill="url(#paint27_linear_8356_28822)"
      />
      <path
        d="M625.433 444.572C626.08 443.302 626.624 441.982 627.059 440.625C628.469 436.134 639.722 420.911 627.059 406.55C614.395 392.189 597.957 393.101 597.957 393.101C569.745 403.808 562.86 449.927 572.747 461.514C583.954 474.647 602.032 468.814 614.417 458.152C616.171 459.721 618.614 460.698 621.318 460.698C626.656 460.698 630.985 456.906 630.985 452.229C630.986 448.842 628.711 445.928 625.433 444.572Z"
        fill="url(#paint28_linear_8356_28822)"
      />
      <path
        d="M595.256 416.064C592.606 417.525 574.518 429.859 574.792 433.878C575.066 437.897 581.917 437.258 585.755 436.709C589.591 436.162 596.9 418.221 596.9 416.978C596.9 415.561 595.256 416.064 595.256 416.064Z"
        fill="url(#paint29_linear_8356_28822)"
      />
      <path
        d="M576.925 443.824C578.558 446.957 587.631 449.243 591.091 449.373C590.372 450.94 585.708 456.792 580.124 454.987C573.661 452.897 576.925 443.824 576.925 443.824Z"
        fill="white"
      />
      <path
        d="M601.99 432.139C601.594 432.139 601.204 432.038 600.857 431.847C600.51 431.655 600.217 431.379 600.005 431.044C599.794 430.709 599.67 430.326 599.646 429.931C599.622 429.535 599.699 429.14 599.869 428.782C601.283 425.796 604.633 422.609 606.229 421.811C606.787 421.533 607.432 421.487 608.023 421.684C608.615 421.881 609.104 422.305 609.382 422.862C609.661 423.42 609.707 424.065 609.51 424.656C609.313 425.248 608.889 425.737 608.332 426.015C607.688 426.347 605.09 428.738 604.116 430.795C603.925 431.197 603.624 431.537 603.248 431.775C602.871 432.013 602.435 432.139 601.99 432.139ZM582.746 420.394C582.394 420.394 582.047 420.305 581.739 420.135C581.43 419.965 581.17 419.719 580.981 419.421C580.793 419.124 580.683 418.783 580.662 418.431C580.641 418.08 580.709 417.728 580.86 417.41C581.927 415.155 584.59 412.439 586.083 411.692C586.576 411.46 587.141 411.43 587.656 411.608C588.172 411.787 588.597 412.159 588.841 412.647C589.085 413.134 589.129 413.698 588.964 414.218C588.798 414.737 588.436 415.172 587.955 415.428C587.425 415.711 585.406 417.573 584.635 419.198C584.466 419.556 584.199 419.859 583.864 420.07C583.53 420.282 583.142 420.394 582.746 420.394Z"
        fill="#0051B2"
      />
      <path
        d="M629.147 390.1C626.536 387.75 627.04 380.587 622.75 378.742C618.399 376.87 612.552 380.563 609.694 379.133C607.432 378.002 607.083 372.997 606.169 369.733C605.255 366.469 603.254 362.597 599.25 362.944C587.073 364.002 584.383 381.86 593.785 395.019C603.515 408.639 626.668 410.64 626.406 427.264C626.262 436.403 614.83 439.972 617.105 444.611C619.34 449.168 625.211 444.741 625.417 444.582C625.421 444.575 625.425 444.568 625.43 444.56C627.893 445.576 629.788 447.477 630.58 449.794C636.843 446.367 649.643 437.575 650.168 422.739C650.871 402.81 631.758 392.45 629.147 390.1Z"
        fill="url(#paint30_linear_8356_28822)"
      />
      <path
        d="M448.981 469.608C448.981 467.911 448.589 448.85 450.156 448.067C451.722 447.283 474.263 454.529 476.006 460.6C477.899 467.194 476.933 511.981 473.918 514.084C469.61 517.087 450.116 504.957 449.333 500.648C448.549 496.34 448.981 469.608 448.981 469.608Z"
        fill="url(#paint31_linear_8356_28822)"
      />
      <path
        d="M442.097 440.677L438.448 438.642C441.907 432.444 447.716 428.744 453.985 428.744C457.107 428.744 460.196 429.676 462.915 431.439L460.644 434.944C458.573 433.602 456.332 432.921 453.985 432.921C449.251 432.922 444.806 435.822 442.097 440.677ZM435.813 428.334L431.475 426.527C434.398 419.511 440.212 414.735 447.425 413.428C453.926 412.248 460.253 414.154 464.354 418.524L460.927 421.739C457.967 418.585 453.116 417.172 448.265 418.052C442.65 419.07 438.112 422.818 435.813 428.334ZM426.662 412.264L421.483 408.734C428.581 398.323 439.109 392.352 450.371 392.352C455.473 392.352 460.417 393.558 465.064 395.937L462.208 401.516C458.454 399.593 454.47 398.619 450.371 398.619C441.215 398.62 432.574 403.592 426.662 412.264Z"
        fill="#FFCE9B"
      />
      <path
        d="M487.822 528.558L487.818 528.552C484.062 520.173 481.75 499.157 481.402 490.714C481.055 482.272 479.924 480.756 478.182 480.704C475.941 480.639 474.961 482.402 473.852 487.624C472.819 492.487 473.395 503.943 470.914 504.727C468.433 505.51 458.249 485.963 455.639 479.268C452.636 471.566 452.372 464.882 449.427 464.737C447.588 464.646 447.251 467.136 447.153 470.848C447.063 474.244 448.067 480.183 448.067 480.183C448.067 480.183 446.022 480.619 445.586 483.839C444.936 488.645 446.239 493.369 446.239 493.369C446.239 493.369 444.906 495.77 445.651 501.203C446.761 509.297 450.649 517.761 455.726 525.878C456.905 527.763 459.072 534.908 461.677 543.808C466.995 543.178 476.123 540.293 487.822 528.558Z"
        fill="url(#paint32_linear_8356_28822)"
      />
      <path
        d="M454.725 494.936C454.642 494.936 454.561 494.917 454.487 494.88C454.414 494.842 454.35 494.788 454.302 494.721C452.14 491.747 448.097 481.536 447.426 479.451C447.384 479.319 447.395 479.176 447.458 479.053C447.522 478.929 447.631 478.836 447.763 478.794C447.895 478.751 448.038 478.763 448.162 478.826C448.285 478.889 448.378 478.999 448.42 479.131C449.058 481.115 453.084 491.272 455.146 494.107C455.203 494.185 455.237 494.277 455.245 494.373C455.253 494.469 455.234 494.565 455.19 494.651C455.146 494.737 455.08 494.809 454.998 494.859C454.916 494.91 454.821 494.936 454.725 494.936ZM450.022 502.246C449.954 502.246 449.886 502.233 449.824 502.206C449.761 502.18 449.704 502.142 449.656 502.094C449.02 501.459 446.249 496.08 445.727 493.471C445.71 493.402 445.708 493.331 445.72 493.262C445.731 493.193 445.757 493.126 445.795 493.067C445.833 493.008 445.882 492.957 445.94 492.917C445.998 492.878 446.064 492.85 446.133 492.836C446.202 492.823 446.273 492.823 446.342 492.837C446.41 492.852 446.476 492.88 446.533 492.92C446.591 492.96 446.64 493.012 446.677 493.071C446.715 493.131 446.739 493.198 446.75 493.267C447.27 495.86 449.973 500.924 450.395 501.355C450.467 501.429 450.515 501.522 450.535 501.623C450.554 501.725 450.543 501.829 450.503 501.924C450.464 502.019 450.397 502.101 450.311 502.158C450.225 502.215 450.125 502.246 450.022 502.246Z"
        fill="#C68D50"
      />
      <path
        d="M642.333 535.278C596.378 533.189 554.559 601.6 541.196 600.557C534.495 600.033 497.163 549.387 487.821 528.558C476.123 540.292 466.996 543.178 461.678 543.808C464.936 554.944 468.88 568.828 472.438 578.622C485.144 613.611 500.289 646.163 527.183 655.128C560.961 666.386 601.078 642.856 628.233 617.267C655.389 591.678 688.289 537.367 642.333 535.278Z"
        fill="url(#paint33_linear_8356_28822)"
      />
      <path
        d="M545.7 659.104C539.403 659.104 533.084 658.196 526.853 656.119C499.474 646.994 484.049 613.652 471.456 578.98C468.334 570.386 464.934 558.717 461.935 548.421L460.674 544.102C460.631 543.957 460.62 543.803 460.643 543.653C460.665 543.503 460.72 543.359 460.804 543.232C460.888 543.106 460.998 542.999 461.128 542.919C461.257 542.84 461.403 542.789 461.553 542.772C467.048 542.122 475.938 539 487.081 527.823C487.201 527.703 487.347 527.615 487.509 527.565C487.67 527.514 487.842 527.504 488.008 527.535C488.174 527.565 488.331 527.636 488.464 527.74C488.597 527.844 488.703 527.979 488.773 528.133C498.619 550.085 535.683 599.081 541.278 599.517C545.49 599.865 554.202 591.136 564.25 581.043C584.496 560.712 612.228 532.884 642.381 534.236C651.214 534.639 657.705 536.985 661.674 541.212C661.773 541.311 661.85 541.429 661.902 541.559C661.954 541.688 661.98 541.827 661.977 541.966C661.975 542.106 661.944 542.243 661.888 542.371C661.831 542.499 661.75 542.614 661.648 542.709C661.546 542.805 661.427 542.879 661.296 542.927C661.165 542.976 661.026 542.998 660.886 542.991C660.747 542.985 660.61 542.951 660.484 542.891C660.358 542.831 660.245 542.746 660.152 542.642C656.568 538.826 650.556 536.7 642.286 536.323C613.061 534.967 585.701 562.462 565.73 582.518C554.466 593.832 546.328 601.978 541.116 601.601C533.79 601.029 497.482 551.251 487.498 530.347C477.187 540.357 468.695 543.718 463.018 544.674L463.941 547.838C466.931 558.103 470.321 569.739 473.418 578.268C485.833 612.448 500.978 645.294 527.514 654.141C568.695 667.868 614.468 628.807 627.518 616.51C632.711 611.616 638.027 605.747 642.892 599.536C643.063 599.318 643.313 599.177 643.588 599.143C643.863 599.11 644.139 599.187 644.357 599.358C644.575 599.528 644.717 599.778 644.75 600.053C644.784 600.328 644.707 600.605 644.536 600.823C639.607 607.116 634.218 613.067 628.95 618.03C617.64 628.684 582.123 659.101 545.7 659.104Z"
        fill="white"
      />
      <path
        d="M569.715 713.024C573.251 704.712 578.172 697.039 584.1 690.327C590.026 683.602 596.952 677.838 604.463 673.112C611.976 668.383 620.077 664.684 628.431 661.947C635.894 659.503 643.574 657.781 651.366 656.802C651.268 654.974 650.831 653.268 650.001 651.725C643.09 638.883 611.984 642.654 585.491 656.863C558.547 671.313 545.891 691.788 552.801 704.629C555.673 709.963 561.602 712.992 569.444 713.698C569.538 713.474 569.62 713.247 569.715 713.024Z"
        fill="url(#paint34_linear_8356_28822)"
      />
      <path
        d="M649.97 654.129C641.234 655.031 632.619 656.864 624.272 659.598C615.918 662.335 607.818 666.034 600.304 670.763C592.793 675.489 585.868 681.255 579.941 687.978C574.012 694.691 569.091 702.363 565.556 710.676C562.013 718.982 559.869 727.924 559.318 736.989C558.925 743.275 559.33 749.635 560.439 755.841C563.907 755.086 567.298 754.251 570.636 753.356C569.626 748.139 569.221 742.823 569.432 737.514C569.752 729.605 571.459 721.742 574.434 714.356C577.4 706.965 581.624 700.054 586.818 693.926C592.008 687.787 598.163 682.434 604.942 677.975C618.521 669.055 634.514 663.675 650.826 661.618C663.775 660.02 677.081 660.521 689.779 663.483C691.029 661.509 692.254 659.519 693.452 657.512C679.334 653.611 664.495 652.642 649.97 654.129Z"
        fill="url(#paint35_linear_8356_28822)"
      />
      <path
        d="M851.627 746.463H758.491L773.019 829.854C789.097 820.902 804.225 809.735 817.8 795.867C833.028 780.309 843.985 763.64 851.627 746.463Z"
        fill="url(#paint36_linear_8356_28822)"
      />
      <path
        d="M807.132 720.491C780.203 720.491 758.371 732.956 758.371 748.33C758.371 763.707 780.202 776.169 807.132 776.169C819.416 776.169 830.629 773.571 839.203 769.291C845.077 760.282 850.046 750.714 854.037 740.727C848.241 729.049 829.442 720.491 807.132 720.491Z"
        fill="#FFCE9B"
      />
      <path
        d="M807.132 768.917C828.932 768.917 846.605 759.131 846.605 747.06C846.605 734.988 828.932 725.203 807.132 725.203C785.332 725.203 767.659 734.988 767.659 747.06C767.659 759.131 785.332 768.917 807.132 768.917Z"
        fill="url(#paint37_linear_8356_28822)"
      />
      <path
        d="M827.855 533.658C829.338 536.84 827.128 539.965 822.96 541.672C818.226 543.61 814.626 543.283 813.017 547.552C811.408 551.822 812.562 556.73 809.731 556.699C806.899 556.669 802.18 544.985 807.408 536.425C812.682 527.789 824.469 526.391 827.855 533.658Z"
        fill="url(#paint38_linear_8356_28822)"
      />
      <path
        d="M800.684 704.347C798.394 698.048 775.057 665.119 734.112 661.97C697.124 659.124 682.511 676.095 686.151 683.588C688.584 688.599 697.317 687.167 700.896 686.165C704.475 685.163 710.755 681.573 714.927 683.731C719.08 685.879 718.585 691.375 722.801 693.466C730.362 697.215 738.144 690.952 744.563 688.455C752.293 685.449 765.322 682.729 774.628 691.319C786.02 701.835 788.403 710.927 791.968 726.894C795.53 742.859 797.216 750.757 797.965 751.735C798.895 752.953 800.398 754.312 804.407 752.737C808.415 751.162 803.261 730.69 803.69 722.386C804.12 714.081 800.684 704.347 800.684 704.347Z"
        fill="url(#paint39_linear_8356_28822)"
      />
      <path
        d="M791.235 752.022C791.199 750.553 786.08 740.951 785.079 731.836C783.772 719.956 777.846 707.439 772.48 702.629C766.036 696.856 757.731 694.076 754.154 698.477C751.051 702.296 754.106 709.263 757.733 712.794C762.377 717.313 783.667 729.793 779.971 736.656C777.967 740.378 774.309 734.878 772.623 732.266C769.663 727.684 764.672 723.185 761.552 725.203C758.307 727.302 759.354 733.793 766.419 737.896C773.331 741.913 779.479 745.236 782.454 748.587C785.266 751.753 782.548 751.64 784.076 753.454C785.836 755.543 791.332 755.935 791.235 752.022Z"
        fill="url(#paint40_linear_8356_28822)"
      />
      <path
        d="M821.301 751.879C819.426 750.765 821.158 740.712 824.737 735.701C828.316 730.69 835.045 728.257 835.045 724.677C835.045 721.097 833.273 717.943 835.331 713.51C837.192 709.502 844.493 711.077 844.78 704.633C845.066 698.191 841.792 690.25 839.286 676.226C837.048 663.688 839.087 659.367 842.346 657.389C846.355 654.955 847.214 649.086 844.207 640.782C842.114 635.002 843.303 598.614 856.09 597.689C866.97 596.901 871.455 616.285 871.552 626.179C871.695 640.71 866.088 644.325 868.26 651.805C870.837 660.681 874.369 661.923 875.132 671.706C875.761 679.767 875.705 690.746 858.811 711.364C842.823 730.874 832.298 739.248 829.461 743.289C825.977 748.253 824.593 753.836 821.301 751.879Z"
        fill="url(#paint41_linear_8356_28822)"
      />
      <path
        d="M807.27 751.162C807.27 744.004 804.12 720.811 810.706 708.498C817.292 696.186 821.014 683.587 817.865 669.843C814.716 656.099 799.254 629.612 800.399 620.45C801.543 611.288 806.268 595.825 797.821 565.903C791.425 543.245 776.909 527.863 766.897 534.12C760.026 538.414 763.176 554.45 766.612 560.462C770.047 566.475 776.018 576.969 774.872 582.982C773.727 588.995 769.959 589.649 770.278 597.812C770.908 613.864 793.384 638.489 798.68 660.394C803.077 678.569 804.694 700.481 800.112 701.339C795.53 702.198 800.424 745.318 802.558 749.744C804.693 754.169 807.27 751.162 807.27 751.162Z"
        fill="url(#paint42_linear_8356_28822)"
      />
      <path
        d="M821.111 559.511C816.816 562.373 816.337 569.245 818.055 574.018C819.773 578.79 821.355 580.992 820.917 584.137C820.441 587.571 813.855 588.717 811.756 595.779C809.656 602.843 813.093 616.967 816.719 627.086C820.346 637.204 819.392 644.648 815.764 645.22C812.138 645.794 808.892 640.829 807.746 634.72C806.601 628.613 807.15 601.707 790.949 606.468C784.459 608.376 784.935 619.352 789.04 627.085C792.204 633.046 802.879 646.078 808.319 663.735C813.353 680.07 817.312 693.033 807.366 695.042C798.87 696.759 794.194 687.215 793.049 681.107C791.903 674.998 788.012 653.986 769.187 657.628C760.311 659.345 765.854 680.901 778.922 692.179C787.833 699.87 799.149 709.447 802.402 722.721C805.933 737.132 800.874 751.927 802.974 754.79C805.075 757.654 813.283 755.937 813.092 754.027C812.9 752.119 810.802 748.301 814.812 745.054C818.82 741.81 828.143 737.322 834.472 732.839C840.802 728.356 840.198 721.385 836.953 718.904C833.71 716.422 829.961 719.545 828.555 721.194C825.786 724.438 819.392 744.149 811.756 738.947C806.897 735.636 814.679 719.418 820.155 712.03C828.362 700.957 846.784 696.758 857.189 682.824C864.522 673.002 860.214 661.986 855.279 660.109C848.502 657.53 842.29 663.669 840.937 669.868C839.123 678.169 835.466 691.363 825.692 683.97C814.332 675.379 831.433 659.2 839.816 649.992C855.374 632.907 862.818 606.086 849.362 601.888C843.37 600.019 838.385 608.376 836.953 617.924C835.311 628.878 827.253 663.932 820.155 659.919C815.764 657.435 825.5 649.039 825.882 641.975C826.263 634.912 825.308 624.794 828.745 615.822C832.181 606.85 841.204 583.108 836.379 569.055C831.991 556.264 823.021 558.237 821.111 559.511Z"
        fill="url(#paint43_linear_8356_28822)"
      />
      <path
        d="M726.452 701.698C722.514 703.56 723.875 709.502 731.085 714.777C737.904 719.767 747.686 719.963 747.928 717.342C748.169 714.721 742.679 714.563 738.193 710.288C733.705 706.013 731.694 699.221 726.452 701.698Z"
        fill="url(#paint44_linear_8356_28822)"
      />
      <path
        d="M302.805 188.987C301.06 189.772 306.418 200.035 308.126 202.913C309.834 205.79 331.239 226.695 339.503 243.809C347.769 260.923 347.866 283.603 347.273 288.713C346.68 293.822 359.923 295.931 359.923 295.931C359.923 295.931 366.427 267.528 353.904 242.446C343.612 221.832 322.138 204.215 317.718 200.241C312.481 195.53 304.624 188.168 302.805 188.987Z"
        fill="url(#paint45_linear_8356_28822)"
      />
      <path
        d="M350.386 236.169C351.653 238.207 352.828 240.301 353.906 242.445C354.323 243.28 354.715 244.12 355.092 244.962C353.415 244.357 344.581 245.271 341.938 249.397C341.196 247.505 340.384 245.641 339.504 243.809C339.28 243.346 339.048 242.887 338.811 242.431C340.837 238.089 348.017 236.001 350.386 236.169Z"
        fill="url(#paint46_linear_8356_28822)"
      />
      <path
        d="M361.354 285.141C360.882 291.727 359.924 295.93 359.924 295.93C359.924 295.93 346.681 293.821 347.274 288.712C347.425 287.411 347.475 284.915 347.52 281.737C352.544 280.433 358.027 282.436 361.354 285.141Z"
        fill="url(#paint47_linear_8356_28822)"
      />
      <path
        d="M355.088 289.287C351.201 287.313 341.405 283.934 332.238 297.057C323.071 310.179 320.218 323.38 326.293 331.877C332.366 340.375 346.028 344.796 352.795 338.78C360.859 331.61 366.308 309.939 362.69 298.212C360.943 292.555 356.261 289.882 355.088 289.287Z"
        fill="url(#paint48_linear_8356_28822)"
      />
      <path
        d="M332.237 297.057C338.709 287.792 345.491 286.755 350.289 287.639C345.715 289.563 328.321 313.328 327.898 333.839C327.322 333.219 326.785 332.564 326.291 331.877C320.217 323.38 323.069 310.179 332.237 297.057Z"
        fill="url(#paint49_linear_8356_28822)"
      />
      <path
        d="M210.978 444.933L349.889 450.852V340.141H210.978V444.933Z"
        fill="url(#paint50_linear_8356_28822)"
      />
      <path
        d="M310.548 427.352H310.524L247.857 425.872C247.584 425.866 247.325 425.753 247.134 425.558C246.943 425.363 246.837 425.101 246.837 424.828V361.03C246.837 360.751 246.947 360.485 247.146 360.288C247.347 360.098 247.612 359.99 247.889 359.986L310.556 360.508C310.832 360.51 311.095 360.621 311.289 360.817C311.483 361.012 311.592 361.277 311.592 361.552V426.308C311.593 426.445 311.566 426.581 311.514 426.708C311.462 426.835 311.385 426.95 311.288 427.048C311.19 427.145 311.075 427.222 310.948 427.274C310.821 427.326 310.685 427.353 310.548 427.352ZM248.926 423.807L309.503 425.238V362.588L248.926 362.084V423.807Z"
        fill="white"
      />
      <path
        d="M379.481 403.156L349.889 450.852V340.141L379.481 299.756V403.156Z"
        fill="url(#paint51_linear_8356_28822)"
      />
      <path
        d="M379.481 299.756H259.283L210.978 340.141H349.889L379.481 299.756Z"
        fill="url(#paint52_linear_8356_28822)"
      />
      <path
        d="M363.521 430.346C363.244 430.346 362.978 430.236 362.782 430.04C362.587 429.844 362.477 429.578 362.477 429.301V321.537C362.477 321.26 362.587 320.995 362.782 320.799C362.978 320.603 363.244 320.493 363.521 320.493C363.798 320.493 364.064 320.603 364.26 320.799C364.455 320.995 364.565 321.26 364.565 321.537V429.301C364.565 429.578 364.455 429.844 364.26 430.04C364.064 430.236 363.798 430.346 363.521 430.346Z"
        fill="#FBC081"
      />
      <path
        d="M167.111 199.75C167.533 194.258 174.77 129.511 215.417 115.672C225.745 112.156 246.75 112.626 261.198 119.414C285.043 130.619 310.158 150.264 316.989 166.067C325.867 186.608 323.645 234.279 322.237 237.896C320.409 242.596 307.85 253.931 293.228 257.456C281.579 260.264 240.483 262.939 225.078 257.456C209.672 251.972 165.544 220.117 167.111 199.75Z"
        fill="url(#paint53_linear_8356_28822)"
      />
      <path
        d="M260.791 128.404C264.779 131.735 268.813 135.429 272.029 139.785C275.279 144.115 277.789 148.933 279.757 153.887C283.688 163.834 285.632 174.284 287.142 184.625C288.622 194.997 289.598 205.404 290.253 215.834C290.88 226.269 291.234 236.716 290.873 247.246L285.921 247.037C286.366 236.787 286.113 226.423 285.586 216.103C285.031 205.779 284.155 195.458 282.79 185.232C281.397 175.022 279.574 164.854 275.928 155.391C274.103 150.676 271.8 146.174 268.838 142.154C265.899 138.103 262.245 134.677 258.297 131.315L260.791 128.404Z"
        fill="url(#paint54_linear_8356_28822)"
      />
      <path
        d="M285.133 178.078C267.24 178.529 245.967 171.637 242.438 167.172C242.438 167.172 240.092 191.786 242.311 209.586C249.622 223.511 271.529 231.217 288.092 229.952C307.458 228.472 320.47 214.46 323.441 207.333C323.015 192.638 321.329 176.11 316.988 166.068C316.049 163.893 314.752 161.646 313.17 159.358C311.889 169.205 300.664 177.686 285.133 178.078Z"
        fill="#FDD3A7"
      />
      <path
        d="M240.222 248.317C243.356 243.878 244.468 196.352 243.356 176.25C242.137 154.23 234.739 138.781 218.637 131.774C208.063 127.174 193.823 130.31 186.8 139.417C170.994 163.495 167.405 195.933 167.11 199.75C165.543 220.117 209.671 251.972 225.077 257.456C225.766 257.701 226.522 257.925 227.31 258.138C233.249 255.618 237.854 251.67 240.222 248.317Z"
        fill="url(#paint55_linear_8356_28822)"
      />
      <path
        d="M228.799 124.518C235.525 130.593 248.984 140.406 264.941 135.778C277.975 131.998 263.38 118.547 257.293 116.137C243.511 111.661 226.863 112.713 219.769 113.105C217.542 113.228 210.489 115.308 208.184 116.13C207.633 116.326 207.584 117.827 207.696 119.104C210.55 117.639 219.505 116.122 228.799 124.518Z"
        fill="url(#paint56_linear_8356_28822)"
      />
      <path
        d="M183.3 215.547C183.692 209.281 185.235 166.516 207.714 172.464C223.337 176.598 220.622 207.248 219.986 218.158C219.492 226.634 217.897 240.875 217.897 240.875L183.3 215.547Z"
        fill="#FDD3A7"
      />
      <path
        d="M207.714 172.464C206.489 172.133 205.23 171.946 203.962 171.908C217.307 178.079 214.82 206.444 214.213 216.855C213.852 223.052 212.904 232.323 212.419 236.865L217.897 240.876C217.897 240.876 219.492 226.635 219.986 218.159C220.622 207.248 223.337 176.598 207.714 172.464Z"
        fill="url(#paint57_linear_8356_28822)"
      />
      <path
        d="M243.356 176.25C242.137 154.23 234.739 138.781 218.637 131.774C217.234 131.17 215.778 130.697 214.288 130.362C230.059 137.465 237.336 152.813 238.543 174.614C239.655 194.717 238.543 242.242 235.409 246.681C233.093 249.963 229.103 254.171 223.595 256.883C224.114 257.097 224.609 257.289 225.077 257.456C225.766 257.701 226.522 257.925 227.31 258.138C233.248 255.618 237.854 251.67 240.221 248.317C243.356 243.878 244.468 196.352 243.356 176.25Z"
        fill="url(#paint58_linear_8356_28822)"
      />
      <path
        d="M229.234 120.372C236.866 125.26 247.547 138.186 263.505 133.558C276.539 129.778 261.716 116.951 255.628 114.541C245.097 109.58 225.076 109.488 216.113 112.539C213.274 113.51 210.533 114.749 207.929 116.24C211.322 114.63 220.213 114.596 229.234 120.372Z"
        fill="url(#paint59_linear_8356_28822)"
      />
      <path
        d="M242.584 121.031C247.951 123.209 253.099 123.012 254.081 120.592C255.064 118.171 251.509 114.443 246.142 112.265C240.774 110.086 235.627 110.283 234.644 112.704C233.662 115.124 237.217 118.852 242.584 121.031Z"
        fill="#3638AD"
      />
      <path
        d="M322.689 235.426C322.559 235.54 322.427 235.651 322.299 235.766L321.15 236.81L320.596 237.325C320.454 237.456 320.306 237.581 320.153 237.7C318.86 238.688 317.088 239.441 315.299 240.055C311.67 241.272 307.771 242.033 303.866 242.651C299.931 243.247 295.978 243.721 292.014 244.072C288.039 244.431 284.048 244.684 280.052 244.877C276.058 245.095 272.058 245.241 268.057 245.319C260.069 245.427 252.017 245.507 244.161 244.951C242.202 244.795 240.288 244.625 238.557 244.232C236.748 243.851 234.926 243.296 233.119 242.653C229.502 241.352 225.945 239.68 222.46 237.843C215.48 234.165 208.769 229.833 202.226 225.264C195.668 220.686 189.319 215.815 183.2 210.664C180.131 208.101 177.1 205.489 174.199 202.761C172.751 201.408 171.345 200.011 169.983 198.571C169.141 197.669 168.282 196.727 167.553 195.785C167.374 197.103 167.226 198.424 167.111 199.749C167.102 199.876 167.102 200.006 167.094 200.134C167.251 200.329 167.406 200.525 167.566 200.716C168.895 202.281 170.273 203.803 171.697 205.282C174.522 208.22 177.443 211.064 180.455 213.809C186.499 219.26 192.786 224.434 199.298 229.316C205.836 234.178 212.632 238.733 219.866 242.692C223.496 244.651 227.237 246.463 231.198 247.932C233.182 248.66 235.22 249.307 237.353 249.78C239.562 250.269 241.682 250.44 243.739 250.605C251.98 251.148 260.081 251.145 268.214 250.837C272.276 250.685 276.334 250.467 280.39 250.176C284.443 249.856 288.493 249.454 292.539 248.954C296.584 248.449 300.626 247.858 304.65 247.047C308.674 246.228 312.691 245.278 316.658 243.76C317.265 243.518 317.866 243.263 318.461 242.994C320.414 240.993 321.736 239.192 322.239 237.897C322.384 237.522 322.538 236.668 322.689 235.426Z"
        fill="url(#paint60_linear_8356_28822)"
      />
      <path
        d="M190.477 207.792C189.402 215.065 191.841 221.451 195.925 222.055C200.01 222.659 204.193 217.253 205.269 209.98C206.344 202.706 203.905 196.321 199.821 195.717C195.736 195.112 191.553 200.519 190.477 207.792Z"
        fill="#3638AD"
      />
      <path
        d="M320.698 193.339C320.698 184.736 315.531 180.631 308.512 180.631C305.693 180.631 303.097 181.561 300.99 183.114L300.98 183.106C300.98 183.106 296.499 187.079 285.999 187.478C275.283 187.885 268.634 184.989 266.213 183.687C265.891 183.48 265.56 183.288 265.221 183.111L265.162 183.072L265.153 183.079C263.364 182.158 261.381 181.677 259.369 181.677C252.351 181.677 246.661 187.366 246.661 194.385C246.661 196.116 247.01 197.765 247.638 199.269L247.637 199.272C248.446 202.361 259.996 222.305 285.916 222.38C309.536 222.449 320.698 201.839 320.698 193.339Z"
        fill="#A0A1F6"
      />
      <path
        d="M259.273 200.533L256.261 197.639C257.459 196.383 258.901 195.384 260.498 194.704C262.095 194.024 263.814 193.676 265.55 193.682C268.48 193.682 271.24 194.641 273.534 196.454L270.944 199.731C269.411 198.513 267.508 197.852 265.55 197.86C264.377 197.855 263.215 198.09 262.136 198.549C261.056 199.009 260.082 199.684 259.273 200.533ZM299.681 198.136L296.669 195.242C297.868 193.986 299.309 192.987 300.906 192.307C302.504 191.627 304.223 191.279 305.959 191.285C308.888 191.285 311.649 192.244 313.942 194.057L311.352 197.334C309.819 196.116 307.917 195.455 305.959 195.463C304.785 195.458 303.624 195.693 302.545 196.153C301.465 196.613 300.491 197.288 299.681 198.136Z"
        fill="#212266"
      />
      <path
        d="M285.688 215.939C280.836 215.939 276.476 213.011 275.087 208.821L277.069 208.164C278.179 211.513 281.723 213.85 285.688 213.85C289.837 213.85 293.421 211.376 294.407 207.834L296.42 208.394C295.184 212.836 290.77 215.939 285.688 215.939Z"
        fill="#3638AD"
      />
      <path
        d="M244.293 74.8574L281.015 64.1111L282.245 69.1861L244.681 76.4565L244.293 74.8574Z"
        fill="#A0A1F6"
      />
      <path
        d="M244.254 76.3687L211.034 67.4325L212.662 62.4703L244.721 74.9451L244.254 76.3687Z"
        fill="#A0A1F6"
      />
      <path
        d="M244.776 76.5724L207.412 90.0927L205.84 85.1128L244.198 74.7415L244.776 76.5724Z"
        fill="#A0A1F6"
      />
      <path
        d="M244.845 74.8397L278.955 87.8869L276.863 92.6715L244.129 76.4742L244.845 74.8397Z"
        fill="#A0A1F6"
      />
      <path
        d="M247.185 74.4323H241.789V116.803H241.794C241.794 116.812 241.789 116.82 241.789 116.828C241.789 117.525 242.997 118.09 244.487 118.09C245.976 118.09 247.184 117.525 247.184 116.828C247.184 116.82 247.179 116.812 247.179 116.803H247.184V74.4323H247.185Z"
        fill="url(#paint61_linear_8356_28822)"
      />
      <path
        d="M244.487 79.1177C248.308 79.1177 251.406 77.5685 251.406 75.6575C251.406 73.7464 248.308 72.1972 244.487 72.1972C240.665 72.1972 237.567 73.7464 237.567 75.6575C237.567 77.5685 240.665 79.1177 244.487 79.1177Z"
        fill="#FFAE58"
      />
      <path
        d="M244.487 75.9833C246.633 75.9833 248.373 74.5258 248.373 72.7278C248.373 70.9298 246.633 69.4723 244.487 69.4723C242.34 69.4723 240.6 70.9298 240.6 72.7278C240.6 74.5258 242.34 75.9833 244.487 75.9833Z"
        fill="#3638AD"
      />
      <path
        d="M244.617 59.2722C211.089 59.2722 183.909 68.1573 183.909 79.1167C183.909 90.076 211.089 98.9611 244.617 98.9611C278.146 98.9611 305.326 90.076 305.326 79.1167C305.326 68.1573 278.146 59.2722 244.617 59.2722ZM244.896 89.8222C219.38 89.8222 198.696 84.1519 198.696 77.1583C198.696 70.1647 219.38 64.4944 244.896 64.4944C270.412 64.4944 291.096 70.1647 291.096 77.1583C291.096 84.1519 270.411 89.8222 244.896 89.8222Z"
        fill="url(#paint62_linear_8356_28822)"
      />
      <path
        d="M275.628 86.6137C275.597 86.598 274.041 87.0168 274.025 86.9855C272.086 87.4179 270.014 87.8064 267.833 88.149C267.984 88.2796 268.148 88.3986 268.329 88.4989C268.268 88.4467 268.389 88.501 268.439 88.5219C268.669 88.6302 268.889 88.76 269.095 88.9094C270.007 89.571 270.645 90.5437 270.888 91.6437C271.265 93.225 270.906 95.223 270.148 97.1208C271.357 96.937 275.166 96.2497 276.331 96.0408C277.594 95.2408 279.682 88.5825 275.628 86.6137ZM212.465 95.4559C211.705 93.5571 211.344 91.557 211.722 89.9737C211.966 88.8735 212.604 87.9006 213.516 87.2393C213.66 87.1349 213.809 87.0398 213.958 86.9584C214.031 86.9176 214.105 86.8811 214.172 86.8518C214.222 86.8309 214.343 86.7766 214.281 86.8288C214.356 86.7881 214.417 86.7338 214.486 86.6878C212.398 86.1865 207.74 84.5895 207.605 84.6355C203.177 86.1343 205.07 93.3806 206.075 94.4491C207.22 94.7207 211.364 95.7233 212.567 95.9688C212.566 95.799 212.533 95.6309 212.471 95.4727L212.465 95.4559ZM213.523 67.8628C215.176 67.4816 219.306 66.6094 221.145 66.294C221.145 66.294 219.421 61.8833 215.464 61.7089C212.751 62.1946 208.54 63.167 206.1 63.778C210.956 63.145 213.481 67.7844 213.523 67.8628ZM271.839 66.8695C273.623 67.2654 279.443 68.7902 280.994 69.254C281.011 69.1736 282.545 65.1692 288.062 65.2611C285.024 64.2427 281.656 63.332 278.012 62.5455C273.841 62.6667 271.882 66.7358 271.839 66.8695Z"
        fill="#F9A349"
      />
      <path
        d="M288.228 103.736C292.779 102.305 297.282 100.87 301.695 99.2546C306.102 97.6399 310.428 95.8633 314.499 93.7472C316.521 92.6683 318.51 91.5602 320.331 90.2745C322.152 88.995 323.824 87.5756 325.23 86.0612C326.618 84.5342 327.735 82.9038 328.229 81.1283C328.367 80.7011 328.465 80.2039 328.522 79.7987L328.574 79.0634C328.586 78.8253 328.592 78.585 328.58 78.3417C328.537 77.3704 328.347 76.3552 328.034 75.3055L328.018 75.2533C327.93 74.9552 327.948 74.6359 328.069 74.3495C328.19 74.0631 328.406 73.8272 328.68 73.682C328.955 73.5367 329.272 73.491 329.576 73.5526C329.881 73.6142 330.155 73.7792 330.352 74.0198C331.226 75.0869 331.878 76.3181 332.269 77.6409C332.373 77.9814 332.457 78.3292 332.529 78.6822C332.601 79.0112 332.64 79.4791 332.67 79.7266C332.727 80.51 332.714 81.2014 332.636 81.9408C332.265 84.8684 330.816 87.4555 329.06 89.4598C327.302 91.4996 325.217 93.0579 323.094 94.4188C320.991 95.7542 318.788 96.9257 316.505 97.9229C312 99.9084 307.353 101.36 302.657 102.47C297.978 103.576 293.225 104.341 288.435 104.759C288.366 104.765 288.297 104.758 288.231 104.737C288.165 104.717 288.104 104.684 288.051 104.64C287.998 104.595 287.954 104.541 287.922 104.48C287.89 104.419 287.87 104.352 287.864 104.284C287.853 104.165 287.884 104.046 287.95 103.946C288.016 103.847 288.114 103.773 288.228 103.736ZM174.079 94.2078C174.567 95.7411 175.419 96.8294 176.582 97.7861C177.733 98.7345 179.148 99.4729 180.644 100.116C183.665 101.37 187.005 102.231 190.39 102.957C193.78 103.715 197.259 104.254 200.761 104.72L211.338 106.012C211.467 106.029 211.585 106.093 211.669 106.191C211.753 106.289 211.798 106.416 211.795 106.545C211.792 106.675 211.742 106.799 211.653 106.893C211.564 106.988 211.443 107.046 211.314 107.057C207.743 107.34 204.161 107.448 200.568 107.384C196.974 107.331 193.367 107.128 189.744 106.676C186.137 106.16 182.486 105.392 179.002 103.728C177.269 102.9 175.565 101.809 174.159 100.272C173.441 99.4929 172.858 98.599 172.435 97.6274C172.223 97.1375 172.063 96.6272 171.955 96.1046C171.85 95.6029 171.8 95.0912 171.807 94.5786L171.809 94.5201C171.82 94.2472 171.926 93.9867 172.11 93.7843C172.294 93.582 172.542 93.4507 172.813 93.4135C173.084 93.3762 173.359 93.4354 173.59 93.5807C173.822 93.7259 173.995 93.9479 174.079 94.2078ZM222.691 44.3774C217.013 45.3085 211.359 46.3815 205.735 47.5953C202.936 48.2126 200.156 48.8998 197.401 49.6424C194.649 50.3647 191.919 51.171 189.216 52.0603C183.823 53.8066 178.579 55.9363 173.709 58.5505C168.868 61.1794 164.333 64.3221 161.113 68.4477L161.092 68.4738C160.729 68.9387 160.195 69.2404 159.61 69.3125C159.024 69.3845 158.433 69.2211 157.968 68.8581C157.538 68.5198 157.247 68.0357 157.151 67.4973C157.054 66.9589 157.158 66.4037 157.443 65.9368C159.109 63.2348 161.292 60.9266 163.673 58.9808C166.064 57.035 168.652 55.4151 171.323 54.0354C176.675 51.2707 182.33 49.4179 188.004 47.917C190.843 47.195 193.705 46.5621 196.583 46.0193C199.458 45.4939 202.342 45.0636 205.229 44.6886C210.999 43.9283 216.799 43.5063 222.589 43.3392C222.728 43.3347 222.863 43.3854 222.964 43.4802C223.065 43.5749 223.125 43.706 223.13 43.8447C223.133 43.9715 223.091 44.0951 223.01 44.193C222.929 44.2908 222.816 44.3563 222.691 44.3774Z"
        fill="#0088FA"
      />
      <path
        d="M197.052 204.537C198.953 204.766 199.391 215.38 198.619 218.637C197.847 221.893 183.649 248.229 180.863 267.029C178.078 285.829 182.256 308.284 184.345 312.984C186.433 317.684 174.422 323.646 174.422 323.646C174.422 323.646 159.745 298.475 164.218 270.799C167.895 248.055 183.137 224.835 186.172 219.724C189.768 213.668 195.072 204.297 197.052 204.537Z"
        fill="url(#paint63_linear_8356_28822)"
      />
      <path
        d="M170.971 263.438C169.21 263.417 167.45 263.525 165.705 263.762C165.102 266.085 164.606 268.434 164.217 270.801C164.07 271.717 163.943 272.636 163.836 273.558C164.434 273.32 165.041 273.105 165.655 272.912C167.473 272.349 169.344 271.971 171.238 271.784C174.449 271.473 177.607 271.822 180.206 273.089C180.351 271.062 180.569 269.041 180.862 267.03C180.936 266.529 181.023 266.019 181.113 265.507C180.287 265.134 179.437 264.814 178.571 264.548C176.049 263.795 173.485 263.476 170.971 263.438Z"
        fill="url(#paint64_linear_8356_28822)"
      />
      <path
        d="M169.84 313.776C172.255 319.922 174.422 323.647 174.422 323.647C174.422 323.647 186.433 317.686 184.345 312.986C183.813 311.79 183.147 309.441 182.495 306.3C177.311 307.302 172.578 310.909 169.84 313.776Z"
        fill="url(#paint65_linear_8356_28822)"
      />
      <path
        d="M177.057 315.864C180.179 312.82 188.522 306.675 201.186 316.467C213.85 326.258 220.508 338.008 217.245 347.931C213.981 357.853 202.259 366.147 194.006 362.422C184.17 357.983 172.508 338.922 172.464 326.65C172.443 320.73 176.115 316.783 177.057 315.864Z"
        fill="url(#paint66_linear_8356_28822)"
      />
      <path
        d="M196.442 321.341C193.918 322.647 185.258 333.613 185.128 337.791C185.016 341.359 187.927 344.154 190.103 343.632C192.278 343.109 200.533 330.958 204.016 328.566C206.196 327.066 196.442 321.341 196.442 321.341Z"
        fill="url(#paint67_linear_8356_28822)"
      />
      <path
        d="M219.007 330.371C218.289 331.482 217.832 338.793 219.204 339.837C220.575 340.882 224.315 338.118 227.429 337.487C230.867 336.791 233.893 336.913 234.806 336.025C235.718 335.137 236.173 329.026 231.474 327.577C226.775 326.129 219.942 328.925 219.007 330.371Z"
        fill="url(#paint68_linear_8356_28822)"
      />
      <path
        d="M219.399 353.219C221.494 352.574 230.707 361.721 230.757 363.924C230.823 366.796 225.34 374.26 220.727 374.26C216.113 374.26 210.13 366.209 209.869 363.794C209.681 362.063 218.267 353.566 219.399 353.219Z"
        fill="url(#paint69_linear_8356_28822)"
      />
      <path
        d="M193.744 368.95C194.247 367.786 203.144 365.033 204.45 366.208C205.756 367.383 211.965 373.585 211.631 376.261C211.369 378.35 207.126 382.332 203.862 381.288C200.598 380.244 192.505 371.822 193.744 368.95Z"
        fill="url(#paint70_linear_8356_28822)"
      />
      <path
        d="M231.624 327.636C232.77 329.93 232.377 332.785 231.776 333.371C230.863 334.259 227.837 334.137 224.399 334.833C222.385 335.241 220.113 336.537 218.385 337.122C218.493 338.417 218.743 339.484 219.204 339.835C220.575 340.88 224.315 338.116 227.429 337.485C230.867 336.788 233.893 336.911 234.806 336.023C235.707 335.147 236.153 329.173 231.624 327.636Z"
        fill="url(#paint71_linear_8356_28822)"
      />
      <path
        d="M218.907 356.238C220.84 355.644 228.814 363.371 230.08 366.302C230.515 365.379 230.771 364.541 230.756 363.924C230.706 361.721 221.493 352.574 219.398 353.219C218.267 353.566 209.681 362.063 209.868 363.794C209.902 364.109 210.038 364.524 210.251 365C212.427 361.915 218.009 356.514 218.907 356.238Z"
        fill="url(#paint72_linear_8356_28822)"
      />
      <path
        d="M204.45 366.208C203.144 365.033 194.247 367.786 193.744 368.95C193.55 369.399 193.605 369.993 193.813 370.663C196.675 369.515 201.395 368.378 202.319 369.21C203.625 370.385 209.834 376.587 209.5 379.263C209.491 379.332 209.467 379.407 209.451 379.48C210.656 378.426 211.518 377.167 211.632 376.261C211.965 373.585 205.756 367.383 204.45 366.208Z"
        fill="url(#paint73_linear_8356_28822)"
      />
      <path
        d="M201.186 316.467C192.246 309.553 185.463 310.586 181.146 312.861C186.086 313.333 209.776 330.831 216.295 350.283C216.661 349.512 216.982 348.727 217.245 347.932C220.508 338.008 213.85 326.258 201.186 316.467Z"
        fill="url(#paint74_linear_8356_28822)"
      />
      <defs>
        <linearGradient
          id="paint0_linear_8356_28822"
          x1="273.192"
          y1="331.858"
          x2="777.509"
          y2="836.174"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#5596F8" />
          <stop offset="1" stopColor="#6ACCE2" />
        </linearGradient>
        <linearGradient
          id="paint1_linear_8356_28822"
          x1="683.066"
          y1="516.571"
          x2="866.799"
          y2="516.571"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#1987D8" />
          <stop offset="1" stopColor="#45B4D0" />
        </linearGradient>
        <linearGradient
          id="paint2_linear_8356_28822"
          x1="631.193"
          y1="257.215"
          x2="631.193"
          y2="748.321"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#90B6F0" />
          <stop offset="1" stopColor="#0088FA" />
        </linearGradient>
        <linearGradient
          id="paint3_linear_8356_28822"
          x1="554.322"
          y1="279.197"
          x2="554.322"
          y2="741.386"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#90B6F0" />
          <stop offset="1" stopColor="#0088FA" />
        </linearGradient>
        <linearGradient
          id="paint4_linear_8356_28822"
          x1="477.451"
          y1="295.754"
          x2="477.451"
          y2="744.702"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#90B6F0" />
          <stop offset="1" stopColor="#0088FA" />
        </linearGradient>
        <linearGradient
          id="paint5_linear_8356_28822"
          x1="400.58"
          y1="312.544"
          x2="400.58"
          y2="758.324"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#90B6F0" />
          <stop offset="1" stopColor="#0088FA" />
        </linearGradient>
        <linearGradient
          id="paint6_linear_8356_28822"
          x1="323.71"
          y1="335.597"
          x2="323.71"
          y2="786.42"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#90B6F0" />
          <stop offset="1" stopColor="#0088FA" />
        </linearGradient>
        <linearGradient
          id="paint7_linear_8356_28822"
          x1="246.838"
          y1="370.442"
          x2="246.838"
          y2="830.406"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#90B6F0" />
          <stop offset="1" stopColor="#0088FA" />
        </linearGradient>
        <linearGradient
          id="paint8_linear_8356_28822"
          x1="516.211"
          y1="710.083"
          x2="516.211"
          y2="864.194"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#90B6F0" />
          <stop offset="1" stopColor="#0088FA" />
        </linearGradient>
        <linearGradient
          id="paint9_linear_8356_28822"
          x1="772.367"
          y1="438.144"
          x2="785.944"
          y2="438.144"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#FFAD57" />
          <stop offset="1" stopColor="#FEB66A" />
        </linearGradient>
        <linearGradient
          id="paint10_linear_8356_28822"
          x1="725.628"
          y1="436.839"
          x2="739.206"
          y2="436.839"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#FFAD57" />
          <stop offset="1" stopColor="#FEB66A" />
        </linearGradient>
        <linearGradient
          id="paint11_linear_8356_28822"
          x1="82.3101"
          y1="203.773"
          x2="448.556"
          y2="203.773"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#1987D8" />
          <stop offset="1" stopColor="#45B4D0" />
        </linearGradient>
        <linearGradient
          id="paint12_linear_8356_28822"
          x1="438.21"
          y1="784.682"
          x2="635.257"
          y2="784.682"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#FFD5A8" />
          <stop offset="0.418" stopColor="#97E2A4" />
          <stop offset="1" stopColor="#006CEC" />
        </linearGradient>
        <linearGradient
          id="paint13_linear_8356_28822"
          x1="327.582"
          y1="749.329"
          x2="524.629"
          y2="749.329"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#FFD5A8" />
          <stop offset="0.418" stopColor="#97E2A4" />
          <stop offset="1" stopColor="#006CEC" />
        </linearGradient>
        <linearGradient
          id="paint14_linear_8356_28822"
          x1="345.711"
          y1="612.728"
          x2="744.341"
          y2="612.728"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#454699" />
          <stop offset="1" stopColor="#25266F" />
        </linearGradient>
        <linearGradient
          id="paint15_linear_8356_28822"
          x1="94.4993"
          y1="741.882"
          x2="186.433"
          y2="741.882"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#F4CDA3" />
          <stop offset="1" stopColor="#E8B987" />
        </linearGradient>
        <linearGradient
          id="paint16_linear_8356_28822"
          x1="86.1845"
          y1="730.056"
          x2="124.868"
          y2="730.056"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#FEB66A" />
          <stop offset="1" stopColor="#1C1FC9" />
        </linearGradient>
        <linearGradient
          id="paint17_linear_8356_28822"
          x1="84.3076"
          y1="741.517"
          x2="121.51"
          y2="741.517"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#454699" />
          <stop offset="1" stopColor="#25266F" />
        </linearGradient>
        <linearGradient
          id="paint18_linear_8356_28822"
          x1="154.228"
          y1="668.775"
          x2="496.722"
          y2="668.775"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#1987D8" />
          <stop offset="1" stopColor="#45B4D0" />
        </linearGradient>
        <linearGradient
          id="paint19_linear_8356_28822"
          x1="439.766"
          y1="473.927"
          x2="522.314"
          y2="556.475"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#F9A144" />
          <stop offset="1" stopColor="#FDD3A7" />
        </linearGradient>
        <linearGradient
          id="paint20_linear_8356_28822"
          x1="315.944"
          y1="544.604"
          x2="381.477"
          y2="544.604"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#F4CDA3" />
          <stop offset="1" stopColor="#E8B987" />
        </linearGradient>
        <linearGradient
          id="paint21_linear_8356_28822"
          x1="360.468"
          y1="778.569"
          x2="423.693"
          y2="778.569"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#F4CDA3" />
          <stop offset="1" stopColor="#E8B987" />
        </linearGradient>
        <linearGradient
          id="paint22_linear_8356_28822"
          x1="352.855"
          y1="803.296"
          x2="396.497"
          y2="803.296"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#FEB66A" />
          <stop offset="1" stopColor="#1C1FC9" />
        </linearGradient>
        <linearGradient
          id="paint23_linear_8356_28822"
          x1="352.855"
          y1="805.322"
          x2="429.208"
          y2="805.322"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#454699" />
          <stop offset="1" stopColor="#25266F" />
        </linearGradient>
        <linearGradient
          id="paint24_linear_8356_28822"
          x1="274.91"
          y1="645.711"
          x2="523.069"
          y2="645.711"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#1987D8" />
          <stop offset="1" stopColor="#45B4D0" />
        </linearGradient>
        <linearGradient
          id="paint25_linear_8356_28822"
          x1="504.568"
          y1="523.065"
          x2="630.97"
          y2="649.467"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#FDD3A7" />
          <stop offset="1" stopColor="#F9A144" />
        </linearGradient>
        <linearGradient
          id="paint26_linear_8356_28822"
          x1="578.245"
          y1="397.135"
          x2="602.645"
          y2="397.135"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#181BC5" />
          <stop offset="1" stopColor="#3638AD" />
        </linearGradient>
        <linearGradient
          id="paint27_linear_8356_28822"
          x1="578.971"
          y1="477.709"
          x2="621.925"
          y2="477.709"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#E8B987" />
          <stop offset="1" stopColor="#E8B987" />
        </linearGradient>
        <linearGradient
          id="paint28_linear_8356_28822"
          x1="568.486"
          y1="431.083"
          x2="633.013"
          y2="431.083"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#F4CDA3" />
          <stop offset="1" stopColor="#E8B987" />
        </linearGradient>
        <linearGradient
          id="paint29_linear_8356_28822"
          x1="574.789"
          y1="426.547"
          x2="596.9"
          y2="426.547"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#FFAD57" />
          <stop offset="1" stopColor="#EFC69A" />
        </linearGradient>
        <linearGradient
          id="paint30_linear_8356_28822"
          x1="588.138"
          y1="406.358"
          x2="650.186"
          y2="406.358"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#2023CB" />
          <stop offset="1" stopColor="#25266F" />
        </linearGradient>
        <linearGradient
          id="paint31_linear_8356_28822"
          x1="448.863"
          y1="481.282"
          x2="476.978"
          y2="481.282"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#454699" />
          <stop offset="1" stopColor="#25266F" />
        </linearGradient>
        <linearGradient
          id="paint32_linear_8356_28822"
          x1="445.405"
          y1="504.271"
          x2="487.822"
          y2="504.271"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#F4CDA3" />
          <stop offset="1" stopColor="#E8B987" />
        </linearGradient>
        <linearGradient
          id="paint33_linear_8356_28822"
          x1="461.677"
          y1="593.287"
          x2="665.254"
          y2="593.287"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#FDD3A7" />
          <stop offset="1" stopColor="#F9A144" />
        </linearGradient>
        <linearGradient
          id="paint34_linear_8356_28822"
          x1="550.942"
          y1="678.786"
          x2="651.366"
          y2="678.786"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#FFAD57" />
          <stop offset="1" stopColor="#FEB66A" />
        </linearGradient>
        <linearGradient
          id="paint35_linear_8356_28822"
          x1="559.169"
          y1="704.655"
          x2="693.448"
          y2="704.655"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#FFD5A8" />
          <stop offset="0.105" stopColor="#FAD3A9" />
          <stop offset="0.228" stopColor="#ECCDAD" />
          <stop offset="0.362" stopColor="#B3E2BB" />
          <stop offset="0.502" stopColor="#B3E2BB" />
          <stop offset="0.647" stopColor="#88E298" />
          <stop offset="0.797" stopColor="#54E26D" />
          <stop offset="0.948" stopColor="#1775E6" />
          <stop offset="1" stopColor="#006CEC" />
        </linearGradient>
        <linearGradient
          id="paint36_linear_8356_28822"
          x1="757.923"
          y1="733.758"
          x2="822.913"
          y2="798.748"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#5596F8" />
          <stop offset="1" stopColor="#6AA1E2" />
        </linearGradient>
        <linearGradient
          id="paint37_linear_8356_28822"
          x1="829.697"
          y1="724.496"
          x2="784.569"
          y2="769.624"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#454699" />
          <stop offset="1" stopColor="#25266F" />
        </linearGradient>
        <linearGradient
          id="paint38_linear_8356_28822"
          x1="828.317"
          y1="542.837"
          x2="805.058"
          y2="542.837"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#F9A144" />
          <stop offset="1" stopColor="#FDD3A7" />
        </linearGradient>
        <linearGradient
          id="paint39_linear_8356_28822"
          x1="805.943"
          y1="707.55"
          x2="685.611"
          y2="707.55"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#0051B2" />
          <stop offset="1" stopColor="#006CEC" />
        </linearGradient>
        <linearGradient
          id="paint40_linear_8356_28822"
          x1="791.237"
          y1="725.659"
          x2="752.873"
          y2="725.659"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#F9A144" />
          <stop offset="1" stopColor="#FDD3A7" />
        </linearGradient>
        <linearGradient
          id="paint41_linear_8356_28822"
          x1="875.314"
          y1="674.972"
          x2="820.536"
          y2="674.972"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#0051B2" />
          <stop offset="1" stopColor="#006CEC" />
        </linearGradient>
        <linearGradient
          id="paint42_linear_8356_28822"
          x1="819.001"
          y1="642.44"
          x2="762.817"
          y2="642.44"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#F9A144" />
          <stop offset="1" stopColor="#FDD3A7" />
        </linearGradient>
        <linearGradient
          id="paint43_linear_8356_28822"
          x1="861.111"
          y1="657.443"
          x2="764.862"
          y2="657.443"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#FEB66A" />
          <stop offset="1" stopColor="#FFAD57" />
        </linearGradient>
        <linearGradient
          id="paint44_linear_8356_28822"
          x1="747.935"
          y1="710.09"
          x2="724.286"
          y2="710.09"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#0051B2" />
          <stop offset="1" stopColor="#006CEC" />
        </linearGradient>
        <linearGradient
          id="paint45_linear_8356_28822"
          x1="332.036"
          y1="295.93"
          x2="332.036"
          y2="188.924"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#454699" />
          <stop offset="1" stopColor="#25266F" />
        </linearGradient>
        <linearGradient
          id="paint46_linear_8356_28822"
          x1="338.811"
          y1="242.778"
          x2="355.091"
          y2="242.778"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#FDD3A7" />
          <stop offset="1" stopColor="#F9A144" />
        </linearGradient>
        <linearGradient
          id="paint47_linear_8356_28822"
          x1="347.255"
          y1="288.629"
          x2="361.354"
          y2="288.629"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#FDD3A7" />
          <stop offset="1" stopColor="#F9A144" />
        </linearGradient>
        <linearGradient
          id="paint48_linear_8356_28822"
          x1="323.08"
          y1="314.471"
          x2="363.829"
          y2="314.471"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#454699" />
          <stop offset="1" stopColor="#25266F" />
        </linearGradient>
        <linearGradient
          id="paint49_linear_8356_28822"
          x1="323.08"
          y1="310.611"
          x2="350.289"
          y2="310.611"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#A0A1F6" />
          <stop offset="1" stopColor="#FFAD57" />
        </linearGradient>
        <linearGradient
          id="paint50_linear_8356_28822"
          x1="210.978"
          y1="395.497"
          x2="349.889"
          y2="395.497"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#FDD3A7" />
          <stop offset="1" stopColor="#F9A144" />
        </linearGradient>
        <linearGradient
          id="paint51_linear_8356_28822"
          x1="349.889"
          y1="375.304"
          x2="379.482"
          y2="375.304"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#FE9526" />
          <stop offset="0.096" stopColor="#DE882E" />
          <stop offset="0.269" stopColor="#BE8447" />
          <stop offset="0.5" stopColor="#709D78" />
          <stop offset="0.777" stopColor="#53D86A" />
          <stop offset="1" stopColor="#0566DA" />
        </linearGradient>
        <linearGradient
          id="paint52_linear_8356_28822"
          x1="263.2"
          y1="287.92"
          x2="332.656"
          y2="357.374"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#006CEC" />
          <stop offset="0.017" stopColor="#076FEA" />
          <stop offset="0.179" stopColor="#48E263" />
          <stop offset="0.34" stopColor="#80E291" />
          <stop offset="0.494" stopColor="#ADE2B6" />
          <stop offset="0.64" stopColor="#B4E2BC" />
          <stop offset="0.777" stopColor="#EACDAE" />
          <stop offset="0.901" stopColor="#FAD3A9" />
          <stop offset="1" stopColor="#FFD5A8" />
        </linearGradient>
        <linearGradient
          id="paint53_linear_8356_28822"
          x1="245.314"
          y1="260.642"
          x2="245.314"
          y2="113.515"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#FEB66A" />
          <stop offset="1" stopColor="#FFAD57" />
        </linearGradient>
        <linearGradient
          id="paint54_linear_8356_28822"
          x1="258.297"
          y1="187.826"
          x2="291.019"
          y2="187.826"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#FDD3A7" />
          <stop offset="1" stopColor="#F9A144" />
        </linearGradient>
        <linearGradient
          id="paint55_linear_8356_28822"
          x1="174.403"
          y1="151.562"
          x2="255.899"
          y2="233.058"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#A0A1F6" />
          <stop offset="1" stopColor="#FFAD57" />
        </linearGradient>
        <linearGradient
          id="paint56_linear_8356_28822"
          x1="207.646"
          y1="124.846"
          x2="270.191"
          y2="124.846"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#FDD3A7" />
          <stop offset="1" stopColor="#F9A144" />
        </linearGradient>
        <linearGradient
          id="paint57_linear_8356_28822"
          x1="203.962"
          y1="206.392"
          x2="220.569"
          y2="206.392"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#FDD3A7" />
          <stop offset="1" stopColor="#F9A144" />
        </linearGradient>
        <linearGradient
          id="paint58_linear_8356_28822"
          x1="214.288"
          y1="194.25"
          x2="243.775"
          y2="194.25"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#FDD3A7" />
          <stop offset="1" stopColor="#F9A144" />
        </linearGradient>
        <linearGradient
          id="paint59_linear_8356_28822"
          x1="207.929"
          y1="122.513"
          x2="268.708"
          y2="122.513"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#A0A1F6" />
          <stop offset="1" stopColor="#FFAD57" />
        </linearGradient>
        <linearGradient
          id="paint60_linear_8356_28822"
          x1="167.094"
          y1="223.416"
          x2="322.689"
          y2="223.416"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#FDD3A7" />
          <stop offset="1" stopColor="#F9A144" />
        </linearGradient>
        <linearGradient
          id="paint61_linear_8356_28822"
          x1="241.789"
          y1="96.2612"
          x2="247.185"
          y2="96.2612"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#FDD3A7" />
          <stop offset="1" stopColor="#F9A144" />
        </linearGradient>
        <linearGradient
          id="paint62_linear_8356_28822"
          x1="212.675"
          y1="47.1734"
          x2="276.562"
          y2="111.06"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#3638AD" />
          <stop offset="1" stopColor="#25266F" />
        </linearGradient>
        <linearGradient
          id="paint63_linear_8356_28822"
          x1="181.175"
          y1="323.647"
          x2="181.175"
          y2="204.532"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#454699" />
          <stop offset="1" stopColor="#25266F" />
        </linearGradient>
        <linearGradient
          id="paint64_linear_8356_28822"
          x1="163.837"
          y1="268.495"
          x2="181.114"
          y2="268.495"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#FDD3A7" />
          <stop offset="1" stopColor="#F9A144" />
        </linearGradient>
        <linearGradient
          id="paint65_linear_8356_28822"
          x1="169.84"
          y1="314.973"
          x2="184.588"
          y2="314.973"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#FDD3A7" />
          <stop offset="1" stopColor="#F9A144" />
        </linearGradient>
        <linearGradient
          id="paint66_linear_8356_28822"
          x1="172.464"
          y1="337.24"
          x2="218.069"
          y2="337.24"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#FFAD57" />
          <stop offset="1" stopColor="#FEB66A" />
        </linearGradient>
        <linearGradient
          id="paint67_linear_8356_28822"
          x1="185.125"
          y1="332.518"
          x2="204.333"
          y2="332.518"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#FDD3A7" />
          <stop offset="1" stopColor="#F9A144" />
        </linearGradient>
        <linearGradient
          id="paint68_linear_8356_28822"
          x1="218.318"
          y1="333.621"
          x2="235.394"
          y2="333.621"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#FFAD57" />
          <stop offset="1" stopColor="#FEB66A" />
        </linearGradient>
        <linearGradient
          id="paint69_linear_8356_28822"
          x1="209.865"
          y1="363.723"
          x2="230.757"
          y2="363.723"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#FFAD57" />
          <stop offset="1" stopColor="#FEB66A" />
        </linearGradient>
        <linearGradient
          id="paint70_linear_8356_28822"
          x1="193.616"
          y1="373.691"
          x2="211.644"
          y2="373.691"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#FFAD57" />
          <stop offset="1" stopColor="#FEB66A" />
        </linearGradient>
        <linearGradient
          id="paint71_linear_8356_28822"
          x1="218.384"
          y1="333.854"
          x2="235.392"
          y2="333.854"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#25266F" />
          <stop offset="1" stopColor="#454699" />
        </linearGradient>
        <linearGradient
          id="paint72_linear_8356_28822"
          x1="209.865"
          y1="359.743"
          x2="230.757"
          y2="359.743"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#25266F" />
          <stop offset="1" stopColor="#454699" />
        </linearGradient>
        <linearGradient
          id="paint73_linear_8356_28822"
          x1="193.624"
          y1="372.702"
          x2="211.644"
          y2="372.702"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#25266F" />
          <stop offset="1" stopColor="#454699" />
        </linearGradient>
        <linearGradient
          id="paint74_linear_8356_28822"
          x1="181.146"
          y1="330.716"
          x2="218.069"
          y2="330.716"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#25266F" />
          <stop offset="1" stopColor="#454699" />
        </linearGradient>
      </defs>
    </svg>
  );
}
IncidentsNoData.propTypes = {
  size: PropTypes.number,
};
IncidentsNoData.defaultProps = {
  size: 100,
};
export function InfoFillIcon({ color }) {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g id="Vector">
        <path
          id="Vector_2"
          d="M10 0C8.02219 0 6.08879 0.58649 4.4443 1.6853C2.79981 2.78412 1.51809 4.3459 0.761209 6.17316C0.00433294 8.00043 -0.1937 10.0111 0.192152 11.9509C0.578004 13.8907 1.53041 15.6725 2.92894 17.0711C4.32746 18.4696 6.10929 19.422 8.0491 19.8078C9.98891 20.1937 11.9996 19.9957 13.8268 19.2388C15.6541 18.4819 17.2159 17.2002 18.3147 15.5557C19.4135 13.9112 20 11.9778 20 10C20 7.34783 18.9464 4.8043 17.0711 2.92893C15.1957 1.05357 12.6522 0 10 0ZM11.3333 14.6667C11.3333 15.0203 11.1929 15.3594 10.9428 15.6095C10.6928 15.8595 10.3536 16 10 16C9.64638 16 9.30724 15.8595 9.05719 15.6095C8.80715 15.3594 8.66667 15.0203 8.66667 14.6667V10C8.66667 9.64638 8.80715 9.30724 9.05719 9.05719C9.30724 8.80714 9.64638 8.66667 10 8.66667C10.3536 8.66667 10.6928 8.80714 10.9428 9.05719C11.1929 9.30724 11.3333 9.64638 11.3333 10V14.6667ZM10 7.46C9.71124 7.46 9.42897 7.37437 9.18887 7.21394C8.94877 7.05352 8.76164 6.8255 8.65114 6.55872C8.54063 6.29194 8.51172 5.99838 8.56806 5.71517C8.62439 5.43195 8.76344 5.17181 8.96763 4.96762C9.17181 4.76344 9.43196 4.62439 9.71517 4.56805C9.99838 4.51172 10.2919 4.54063 10.5587 4.65114C10.8255 4.76164 11.0535 4.94877 11.2139 5.18887C11.3744 5.42896 11.46 5.71124 11.46 6C11.46 6.19173 11.4222 6.38158 11.3489 6.55872C11.2755 6.73585 11.168 6.8968 11.0324 7.03237C10.8968 7.16795 10.7359 7.27549 10.5587 7.34886C10.3816 7.42223 10.1917 7.46 10 7.46Z"
          fill={color !== '' ? color : '#EF5C53'}
        />
      </g>
    </svg>
  );
}
InfoFillIcon.propTypes = {
  color: PropTypes.string,
};
InfoFillIcon.defaultProps = {
  color: '',
};
export function InfoGradientIcon() {
  return (
    <svg
      width="13"
      height="12"
      viewBox="0 0 13 12"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M6.5 1C3.745 1 1.5 3.245 1.5 6C1.5 8.755 3.745 11 6.5 11C9.255 11 11.5 8.755 11.5 6C11.5 3.245 9.255 1 6.5 1ZM6.125 4C6.125 3.795 6.295 3.625 6.5 3.625C6.705 3.625 6.875 3.795 6.875 4V6.5C6.875 6.705 6.705 6.875 6.5 6.875C6.295 6.875 6.125 6.705 6.125 6.5V4ZM6.96 8.19C6.935 8.255 6.9 8.305 6.855 8.355C6.805 8.4 6.75 8.435 6.69 8.46C6.63 8.485 6.565 8.5 6.5 8.5C6.435 8.5 6.37 8.485 6.31 8.46C6.25 8.435 6.195 8.4 6.145 8.355C6.1 8.305 6.065 8.255 6.04 8.19C6.015 8.13 6 8.065 6 8C6 7.935 6.015 7.87 6.04 7.81C6.065 7.75 6.1 7.695 6.145 7.645C6.195 7.6 6.25 7.565 6.31 7.54C6.43 7.49 6.57 7.49 6.69 7.54C6.75 7.565 6.805 7.6 6.855 7.645C6.9 7.695 6.935 7.75 6.96 7.81C6.985 7.87 7 7.935 7 8C7 8.065 6.985 8.13 6.96 8.19Z"
        fill="url(#paint0_linear_21172_13807)"
      />
      <defs>
        <linearGradient
          id="paint0_linear_21172_13807"
          x1="6.5"
          y1="1"
          x2="6.5"
          y2="11"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="#F09090" />
          <stop offset="1" stop-color="#FA0000" />
        </linearGradient>
      </defs>
    </svg>
  );
}
export function InfoBlueGradientIcon({ size }) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M10.0007 18.333C14.5923 18.333 18.334 14.5913 18.334 9.99967C18.334 5.40801 14.5923 1.66634 10.0007 1.66634C5.40898 1.66634 1.66732 5.40801 1.66732 9.99967C1.66732 14.5913 5.40898 18.333 10.0007 18.333ZM10.6257 13.333C10.6257 13.6747 10.3423 13.958 10.0007 13.958C9.65898 13.958 9.37565 13.6747 9.37565 13.333V9.16634C9.37565 8.82467 9.65898 8.54134 10.0007 8.54134C10.3423 8.54134 10.6257 8.82467 10.6257 9.16634V13.333ZM9.23398 6.34968C9.27565 6.24134 9.33398 6.15801 9.40898 6.07468C9.49232 5.99968 9.58398 5.94134 9.68398 5.89967C9.78398 5.85801 9.89232 5.83301 10.0007 5.83301C10.109 5.83301 10.2173 5.85801 10.3173 5.89967C10.4173 5.94134 10.509 5.99968 10.5923 6.07468C10.6673 6.15801 10.7257 6.24134 10.7673 6.34968C10.809 6.44968 10.834 6.55801 10.834 6.66634C10.834 6.77467 10.809 6.88301 10.7673 6.98301C10.7257 7.08301 10.6673 7.17467 10.5923 7.25801C10.509 7.33301 10.4173 7.39134 10.3173 7.43301C10.1173 7.51634 9.88398 7.51634 9.68398 7.43301C9.58398 7.39134 9.49232 7.33301 9.40898 7.25801C9.33398 7.17467 9.27565 7.08301 9.23398 6.98301C9.19232 6.88301 9.16732 6.77467 9.16732 6.66634C9.16732 6.55801 9.19232 6.44968 9.23398 6.34968Z"
        fill="url(#paint0_linear_39266_15004)"
      />
      <defs>
        <linearGradient
          id="paint0_linear_39266_15004"
          x1="18.334"
          y1="18.333"
          x2="-1.77702"
          y2="9.58099"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="#849BEA" />
          <stop offset="1" stop-color="#5DB1FF" />
        </linearGradient>
      </defs>
    </svg>
  );
}
InfoBlueGradientIcon.propTypes = {
  size: PropTypes.string,
};
InfoBlueGradientIcon.defaultProps = {
  size: '1.389vw',
};
export function InfoRedGredientIcon() {
  return (
    <svg
      width="14"
      height="14"
      viewBox="0 0 14 14"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M7 0C5.61553 0 4.26215 0.410543 3.11101 1.17971C1.95987 1.94888 1.06266 3.04213 0.532846 4.32122C0.00303306 5.6003 -0.13559 7.00776 0.134506 8.36563C0.404603 9.7235 1.07129 10.9708 2.05026 11.9497C3.02922 12.9287 4.2765 13.5954 5.63437 13.8655C6.99224 14.1356 8.3997 13.997 9.67879 13.4672C10.9579 12.9373 12.0511 12.0401 12.8203 10.889C13.5895 9.73785 14 8.38447 14 7C14 5.14348 13.2625 3.36301 11.9497 2.05025C10.637 0.737498 8.85652 0 7 0ZM7.93333 10.2667C7.93333 10.5142 7.835 10.7516 7.65997 10.9266C7.48493 11.1017 7.24754 11.2 7 11.2C6.75247 11.2 6.51507 11.1017 6.34004 10.9266C6.165 10.7516 6.06667 10.5142 6.06667 10.2667V7C6.06667 6.75246 6.165 6.51507 6.34004 6.34003C6.51507 6.165 6.75247 6.06667 7 6.06667C7.24754 6.06667 7.48493 6.165 7.65997 6.34003C7.835 6.51507 7.93333 6.75246 7.93333 7V10.2667ZM7 5.222C6.79787 5.222 6.60028 5.16206 6.43221 5.04976C6.26414 4.93746 6.13315 4.77785 6.0558 4.5911C5.97844 4.40436 5.95821 4.19887 5.99764 4.00062C6.03707 3.80237 6.13441 3.62027 6.27734 3.47734C6.42027 3.33441 6.60237 3.23707 6.80062 3.19764C6.99887 3.1582 7.20436 3.17844 7.3911 3.25579C7.57785 3.33315 7.73746 3.46414 7.84976 3.63221C7.96206 3.80027 8.022 3.99787 8.022 4.2C8.022 4.33421 7.99557 4.46711 7.94421 4.5911C7.89285 4.7151 7.81757 4.82776 7.72266 4.92266C7.62776 5.01756 7.5151 5.09284 7.3911 5.1442C7.26711 5.19556 7.13421 5.222 7 5.222Z"
        fill="url(#paint0_linear_1336_37323)"
      />
      <defs>
        <linearGradient
          id="paint0_linear_1336_37323"
          x1="7"
          y1="0"
          x2="7"
          y2="14"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="#D76766" />
          <stop offset="0.9998" stop-color="#A32828" />
        </linearGradient>
      </defs>
    </svg>
  );
}

// InfoRedGredientIcon.propTypes = {
//   size: PropTypes.string,
// };
// InfoRedGredientIcon.defaultProps = {
//   size: '0.694vw',
// };
export function InfoPinkGredientIcon({ size }) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 10 9"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M4.99935 8.66602C7.29518 8.66602 9.16602 6.79518 9.16602 4.49935C9.16602 2.20352 7.29518 0.332683 4.99935 0.332683C2.70352 0.332683 0.832683 2.20352 0.832683 4.49935C0.832683 6.79518 2.70352 8.66602 4.99935 8.66602ZM5.31185 6.16602C5.31185 6.33685 5.17018 6.47852 4.99935 6.47852C4.82852 6.47852 4.68685 6.33685 4.68685 6.16602V4.08268C4.68685 3.91185 4.82852 3.77018 4.99935 3.77018C5.17018 3.77018 5.31185 3.91185 5.31185 4.08268V6.16602ZM4.61602 2.67435C4.63685 2.62018 4.66602 2.57852 4.70352 2.53685C4.74518 2.49935 4.79102 2.47018 4.84102 2.44935C4.89102 2.42852 4.94518 2.41602 4.99935 2.41602C5.05352 2.41602 5.10768 2.42852 5.15768 2.44935C5.20768 2.47018 5.25352 2.49935 5.29518 2.53685C5.33268 2.57852 5.36185 2.62018 5.38268 2.67435C5.40352 2.72435 5.41602 2.77852 5.41602 2.83268C5.41602 2.88685 5.40352 2.94102 5.38268 2.99102C5.36185 3.04102 5.33268 3.08685 5.29518 3.12852C5.25352 3.16602 5.20768 3.19518 5.15768 3.21602C5.05768 3.25768 4.94102 3.25768 4.84102 3.21602C4.79102 3.19518 4.74518 3.16602 4.70352 3.12852C4.66602 3.08685 4.63685 3.04102 4.61602 2.99102C4.59518 2.94102 4.58268 2.88685 4.58268 2.83268C4.58268 2.77852 4.59518 2.72435 4.61602 2.67435Z"
        fill="url(#paint0_linear_41303_12176)"
        fill-opacity="0.7"
      />
      <defs>
        <linearGradient
          id="paint0_linear_41303_12176"
          x1="4.99935"
          y1="8.66602"
          x2="4.99935"
          y2="0.332683"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="#FB93BE" />
          <stop offset="1" stop-color="#BF185E" />
        </linearGradient>
      </defs>
    </svg>
  );
}
InfoPinkGredientIcon.propTypes = {
  size: PropTypes.string,
};
InfoPinkGredientIcon.defaultProps = {
  size: '0.694vw',
};
export function UploadNewIcon() {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g id="direct-inbox">
        <g id="vuesax/outline/direct-inbox">
          <g id="direct-inbox_2">
            <path
              id="Vector"
              d="M11.9705 1.2501C12.0705 1.2494 12.1606 1.26876 12.2609 1.30806C12.5417 1.41609 12.7236 1.69481 12.7257 1.99481L12.775 8.99463C12.7779 9.40462 12.4403 9.74701 12.0303 9.74989C11.6203 9.75278 11.2779 9.41518 11.275 9.00519L11.2385 3.81531L10.5236 4.54036C10.2356 4.8324 9.75566 4.83577 9.46363 4.54782C9.17159 4.25987 9.16822 3.77988 9.45617 3.48785L11.442 1.47382C11.5811 1.33284 11.7705 1.25151 11.9705 1.2501Z"
              fill="#616B80"
            />
            <path
              id="Vector_2"
              d="M11.9701 1.24968C12.1601 1.24834 12.3506 1.317 12.5017 1.46594L14.5157 3.45182C14.8077 3.73977 14.8111 4.21976 14.5232 4.5118C14.2352 4.80383 13.7552 4.80721 13.4632 4.51925L11.4492 2.53338C11.1571 2.24542 11.1538 1.76544 11.4417 1.4734C11.5906 1.32235 11.7802 1.25101 11.9701 1.24968Z"
              fill="#616B80"
            />
            <path
              id="Vector_3"
              d="M13.7605 17.75H10.2305C9.18047 17.75 8.24047 17.17 7.77047 16.23L6.60047 13.89C6.56047 13.8 6.47047 13.75 6.38047 13.75H1.98047C1.57047 13.75 1.23047 13.41 1.23047 13C1.23047 12.59 1.57047 12.25 1.98047 12.25H6.39047C7.06047 12.25 7.66047 12.62 7.96047 13.22L9.13047 15.56C9.34047 15.99 9.77047 16.25 10.2505 16.25H13.7805C14.2605 16.25 14.6905 15.99 14.9005 15.56L16.0705 13.22C16.3705 12.62 16.9705 12.25 17.6405 12.25H22.0005C22.4105 12.25 22.7505 12.59 22.7505 13C22.7505 13.41 22.4105 13.75 22.0005 13.75H17.6405C17.5405 13.75 17.4605 13.8 17.4205 13.89L16.2505 16.23C15.7505 17.17 14.8105 17.75 13.7605 17.75Z"
              fill="#616B80"
            />
            <path
              id="Vector_4"
              d="M15 22.75H9C3.57 22.75 1.25 20.43 1.25 15V11C1.25 6.31 2.99 3.96 6.89 3.39C7.31 3.33 7.68 3.61 7.74 4.02C7.8 4.43 7.52 4.81 7.11 4.87C3.97 5.33 2.75 7.05 2.75 11V15C2.75 19.61 4.39 21.25 9 21.25H15C19.61 21.25 21.25 19.61 21.25 15V11C21.25 7.05 20.03 5.33 16.89 4.87C16.48 4.81 16.2 4.43 16.26 4.02C16.32 3.61 16.7 3.33 17.11 3.39C21.01 3.96 22.75 6.31 22.75 11V15C22.75 20.43 20.43 22.75 15 22.75Z"
              fill="#616B80"
            />
          </g>
        </g>
      </g>
    </svg>
  );
}
export function SpeedomeaterIcon() {
  return (
    <svg
      width="28.75vw"
      height="28.333vw"
      viewBox="0 0 414 408"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g filter="url(#filter0_f_9484_85755)">
        <ellipse
          cx="206.629"
          cy="189.59"
          rx="6.66782"
          ry="3.70434"
          fill="white"
        />
      </g>
      <path
        d="M358.275 216.404C358.298 216.035 358.32 215.667 358.34 215.298L348.072 214.733C348.053 215.077 348.033 215.42 348.012 215.764L358.275 216.404Z"
        fill="#603ACB"
      />
      <path
        d="M358.35 198.965C358.331 198.596 358.309 198.227 358.287 197.859L348.023 198.486C348.044 198.83 348.063 199.173 348.082 199.517L358.35 198.965Z"
        fill="#603ACB"
      />
      <path
        d="M356.394 181.564C356.331 181.199 356.268 180.836 356.202 180.472L346.081 182.288C346.141 182.627 346.201 182.966 346.259 183.305L356.394 181.564Z"
        fill="#603ACB"
      />
      <path
        d="M352.457 164.604C352.353 164.25 352.247 163.896 352.14 163.542L342.296 166.516C342.396 166.846 342.494 167.175 342.591 167.506L352.457 164.604Z"
        fill="#603ACB"
      />
      <path
        d="M346.576 148.189C346.431 147.849 346.285 147.51 346.138 147.171L336.705 151.264C336.842 151.58 336.978 151.896 337.112 152.213L346.576 148.189Z"
        fill="#603ACB"
      />
      <path
        d="M329.226 117.793C329.007 117.495 328.787 117.199 328.565 116.903L320.333 123.066C320.539 123.341 320.745 123.618 320.949 123.895L329.226 117.793Z"
        fill="#3B86F2"
      />
      <path
        d="M318.056 104.352C317.804 104.082 317.551 103.813 317.296 103.545L309.835 110.622C310.072 110.871 310.308 111.122 310.543 111.374L318.056 104.352Z"
        fill="#3B86F2"
      />
      <path
        d="M305.407 92.3024C305.125 92.0635 304.842 91.8257 304.559 91.5889L297.968 99.4828C298.233 99.7033 298.496 99.9249 298.758 100.147L305.407 92.3024Z"
        fill="#3B86F2"
      />
      <path
        d="M291.524 81.8525C291.216 81.6477 290.908 81.4441 290.599 81.2416L284.963 89.843C285.251 90.0316 285.538 90.2213 285.825 90.4121L291.524 81.8525Z"
        fill="#3B86F2"
      />
      <path
        d="M276.578 73.099C276.249 72.931 275.919 72.7641 275.589 72.5985L270.979 81.7908C271.287 81.9451 271.594 82.1005 271.9 82.2571L276.578 73.099Z"
        fill="#3B86F2"
      />
      <path
        d="M243.557 60.8636C243.198 60.7767 242.839 60.691 242.479 60.6068L240.133 70.619C240.468 70.6975 240.803 70.7773 241.138 70.8583L243.557 60.8636Z"
        fill="#F2C94C"
      />
      <path
        d="M226.725 57.7902C226.359 57.7447 225.992 57.7004 225.625 57.6575L224.432 67.8714C224.773 67.9114 225.115 67.9526 225.457 67.9951L226.725 57.7902Z"
        fill="#F2C94C"
      />
      <path
        d="M209.154 56.6445C208.785 56.6421 208.415 56.641 208.046 56.6413L208.054 66.9247C208.399 66.9244 208.743 66.9254 209.087 66.9277L209.154 56.6445Z"
        fill="#F2C94C"
      />
      <path
        d="M191.703 57.5456C191.335 57.5861 190.968 57.6279 190.601 57.6711L191.803 67.884C192.145 67.8438 192.487 67.8049 192.829 67.7672L191.703 57.5456Z"
        fill="#F2C94C"
      />
      <path
        d="M174.502 60.4585C174.142 60.5412 173.782 60.6252 173.422 60.7106L175.798 70.7157C176.133 70.6362 176.468 70.5579 176.804 70.4809L174.502 60.4585Z"
        fill="#F2C94C"
      />
      <path
        d="M141.845 72.0563C141.514 72.2192 141.183 72.3833 140.852 72.5487L145.455 81.7444C145.763 81.5904 146.071 81.4374 146.38 81.2856L141.845 72.0563Z"
        fill="#F29C4C"
      />
      <path
        d="M126.61 80.6777C126.299 80.878 125.99 81.0795 125.681 81.2822L131.321 89.8807C131.609 89.6919 131.897 89.5042 132.186 89.3176L126.61 80.6777Z"
        fill="#F29C4C"
      />
      <path
        d="M112.569 90.9369C112.284 91.1717 112 91.4076 111.716 91.6445L118.311 99.5346C118.575 99.3138 118.84 99.0941 119.106 98.8753L112.569 90.9369Z"
        fill="#F29C4C"
      />
      <path
        d="M99.8067 102.748C99.5505 103.014 99.2953 103.282 99.0411 103.55L106.503 110.626C106.74 110.376 106.977 110.127 107.216 109.879L99.8067 102.748Z"
        fill="#F29C4C"
      />
      <path
        d="M88.4069 116.067C88.1834 116.361 87.961 116.656 87.7397 116.952L95.9742 123.112C96.1804 122.836 96.3876 122.561 96.5957 122.287L88.4069 116.067Z"
        fill="#F29C4C"
      />
      <path
        d="M70.7616 145.9C70.6114 146.238 70.4625 146.576 70.3148 146.915L79.7407 151.026C79.8783 150.71 80.0171 150.395 80.157 150.081L70.7616 145.9Z"
        fill="#F24C4C"
      />
      <path
        d="M64.5841 162.295C64.4741 162.648 64.3655 163.001 64.2582 163.354L74.0983 166.341C74.1982 166.012 74.2994 165.683 74.4018 165.354L64.5841 162.295Z"
        fill="#F24C4C"
      />
      <path
        d="M60.3464 179.343C60.2784 179.706 60.2117 180.069 60.1463 180.433L70.2676 182.252C70.3284 181.913 70.3906 181.575 70.454 181.236L60.3464 179.343Z"
        fill="#F24C4C"
      />
      <path
        d="M58.1261 196.759C58.1008 197.128 58.077 197.497 58.0544 197.865L68.3187 198.493C68.3397 198.149 68.3619 197.806 68.3854 197.462L58.1261 196.759Z"
        fill="#F24C4C"
      />
      <path
        d="M57.9354 213.993C57.9524 214.362 57.9709 214.731 57.9907 215.1L68.2593 214.548C68.2409 214.205 68.2237 213.861 68.2077 213.517L57.9354 213.993Z"
        fill="#F24C4C"
      />
      <path
        d="M365.191 237.681C365.448 236.357 365.688 235.03 365.912 233.7L345.565 230.281C345.37 231.441 345.161 232.598 344.937 233.753L365.191 237.681Z"
        fill="#603ACB"
      />
      <path
        d="M348.246 129.442C347.597 128.26 346.933 127.086 346.254 125.92L328.425 136.301C329.016 137.318 329.595 138.341 330.161 139.372L348.246 129.442Z"
        fill="#3B86F2"
      />
      <path
        d="M265.802 56.973C264.546 56.4808 263.284 56.0045 262.017 55.544L254.973 74.936C256.078 75.3375 257.178 75.7529 258.273 76.182L265.802 56.973Z"
        fill="#F2C94C"
      />
      <path
        d="M155.145 54.4325C153.868 54.8665 152.597 55.3165 151.331 55.7824L158.459 75.1439C159.563 74.7376 160.671 74.3452 161.785 73.9668L155.145 54.4325Z"
        fill="#F29C4C"
      />
      <path
        d="M68.8775 124.006C68.1829 125.162 67.5028 126.327 66.8374 127.5L84.7834 137.679C85.3636 136.656 85.9566 135.641 86.5623 134.633L68.8775 124.006Z"
        fill="#F24C4C"
      />
      <path
        d="M47.8777 232.414C48.0904 233.745 48.3198 235.074 48.5659 236.4L68.8513 232.636C68.6368 231.48 68.4367 230.321 68.2513 229.16L47.8777 232.414Z"
        fill="#F24C4C"
      />
      <path
        d="M41.6397 199.334L49.508 203.578L49.34 204.826L40.6298 206.839L40.785 205.685L48.2831 204.042L41.486 200.476L41.6397 199.334ZM47.3805 192.845C47.5866 192.872 47.8031 192.914 48.0298 192.968L47.3288 198.177C47.9763 198.224 48.5092 198.074 48.9272 197.726C49.3384 197.37 49.5824 196.907 49.6592 196.336C49.7222 195.868 49.6674 195.465 49.495 195.127C49.3157 194.78 49.0522 194.518 48.7045 194.343L48.8614 193.177C49.4643 193.436 49.9287 193.853 50.2547 194.43C50.5728 195.006 50.6795 195.682 50.575 196.459C50.4918 197.077 50.2783 197.614 49.9347 198.068C49.5921 198.514 49.1484 198.842 48.6036 199.051C48.0509 199.259 47.4376 199.318 46.7637 199.227C46.0898 199.137 45.5173 198.922 45.0461 198.584C44.575 198.247 44.2371 197.818 44.0326 197.298C43.8213 196.769 43.7583 196.187 43.8437 195.553C43.9269 194.935 44.1353 194.406 44.4689 193.966C44.8025 193.527 45.2242 193.212 45.734 193.023C46.237 192.824 46.7859 192.765 47.3805 192.845ZM47.0041 193.932C46.5918 193.877 46.2267 193.92 45.9088 194.063C45.583 194.205 45.3234 194.424 45.1301 194.721C44.9299 195.009 44.8042 195.343 44.753 195.724C44.6794 196.271 44.7909 196.762 45.0874 197.198C45.3851 197.625 45.8394 197.908 46.4503 198.047L47.0041 193.932ZM45.768 190.071C45.4209 189.831 45.1678 189.522 45.0086 189.146C44.8505 188.761 44.8056 188.315 44.8738 187.808L45.9918 187.958L45.9534 188.244C45.7901 189.457 46.3666 190.152 47.6827 190.329L51.2268 190.806L51.0811 191.888L44.5639 191.011L44.7095 189.929L45.768 190.071ZM45.9163 180.961L54.9738 186.176L54.8233 187.294L51.8565 185.587L45.0569 187.348L45.2185 186.146L50.7742 184.811L45.7659 182.079L45.9163 180.961ZM47.8893 171.249C48.5791 171.341 49.1219 171.657 49.5177 172.194C49.9067 172.723 50.0361 173.471 49.9059 174.438L49.6915 176.032L53.1523 176.497L53.0066 177.58L44.7174 176.464L45.0775 173.788C45.2034 172.853 45.5248 172.173 46.0418 171.751C46.5599 171.32 47.1757 171.153 47.8893 171.249ZM49.014 174.318C49.0951 173.715 49.024 173.254 48.8008 172.933C48.5775 172.613 48.2241 172.42 47.7405 172.355C46.7177 172.217 46.1273 172.735 45.9694 173.908L45.755 175.502L48.7995 175.912L49.014 174.318ZM54.423 167.865C54.3408 168.475 54.1274 169.011 53.7827 169.473C53.439 169.928 52.9943 170.263 52.4485 170.481C51.8958 170.689 51.2825 170.747 50.6085 170.657C49.9425 170.567 49.375 170.345 48.906 169.992C48.4301 169.629 48.091 169.18 47.8887 168.644C47.6784 168.107 47.6149 167.53 47.6981 166.911C47.7813 166.293 47.9953 165.752 48.34 165.29C48.6768 164.827 49.1181 164.487 49.6639 164.27C50.2108 164.045 50.8213 163.977 51.4952 164.068C52.1691 164.159 52.7435 164.389 53.2183 164.76C53.6862 165.122 54.0248 165.575 54.234 166.12C54.4432 166.664 54.5062 167.246 54.423 167.865ZM53.4716 167.736C53.5239 167.348 53.4818 166.971 53.3453 166.606C53.2088 166.24 52.9721 165.93 52.6351 165.674C52.2992 165.411 51.8696 165.245 51.3463 165.174C50.8231 165.104 50.3652 165.147 49.9727 165.304C49.5803 165.461 49.2744 165.694 49.0552 166.004C48.828 166.312 48.6883 166.661 48.636 167.049C48.5827 167.446 48.6248 167.823 48.7623 168.18C48.893 168.529 49.1274 168.827 49.4654 169.074C49.8034 169.321 50.2341 169.48 50.7574 169.551C51.2886 169.622 51.7493 169.587 52.1397 169.446C52.5311 169.297 52.8398 169.072 53.0659 168.772C53.2841 168.47 53.4193 168.125 53.4716 167.736ZM55.4467 160.257C55.3646 160.868 55.1511 161.404 54.8064 161.866C54.4628 162.321 54.018 162.656 53.4722 162.873C52.9195 163.081 52.3062 163.14 51.6323 163.05C50.9663 162.96 50.3987 162.738 49.9297 162.385C49.4539 162.022 49.1147 161.573 48.9124 161.037C48.7021 160.5 48.6386 159.922 48.7218 159.304C48.805 158.685 49.019 158.145 49.3637 157.683C49.7005 157.22 50.1418 156.88 50.6877 156.662C51.2346 156.437 51.845 156.37 52.5189 156.461C53.1928 156.552 53.7672 156.782 54.242 157.153C54.7099 157.515 55.0485 157.968 55.2577 158.513C55.467 159.057 55.53 159.639 55.4467 160.257ZM54.4953 160.129C54.5476 159.741 54.5055 159.364 54.369 158.998C54.2325 158.633 53.9958 158.323 53.6588 158.067C53.3229 157.804 52.8933 157.637 52.3701 157.567C51.8468 157.497 51.3889 157.54 50.9965 157.697C50.604 157.854 50.2982 158.087 50.0789 158.397C49.8517 158.705 49.712 159.054 49.6597 159.442C49.6064 159.839 49.6485 160.216 49.786 160.573C49.9167 160.922 50.1511 161.22 50.4891 161.467C50.8271 161.714 51.2578 161.873 51.7811 161.943C52.3123 162.015 52.7731 161.98 53.1634 161.839C53.5548 161.69 53.8635 161.465 54.0896 161.164C54.3078 160.863 54.443 160.518 54.4953 160.129ZM50.6678 153.661C50.3207 153.421 50.0676 153.112 49.9084 152.736C49.7503 152.351 49.7054 151.905 49.7736 151.398L50.8916 151.548L50.8532 151.834C50.6899 153.047 51.2664 153.742 52.5825 153.919L56.1265 154.396L55.9809 155.478L49.4637 154.601L49.6093 153.519L50.6678 153.661Z"
        fill="#F24C4C"
      />
      <path
        d="M96.6282 87.5223C97.0484 88.0771 97.2073 88.6843 97.1048 89.344C97.0039 89.9925 96.5644 90.6114 95.7864 91.2007L94.5046 92.1716L96.613 94.9552L95.7425 95.6146L90.6925 88.9472L92.8447 87.317C93.5973 86.747 94.3057 86.4965 94.97 86.5653C95.6407 86.6294 96.1934 86.9483 96.6282 87.5223ZM95.243 90.4833C95.7277 90.1162 96.0051 89.7405 96.0753 89.3561C96.1454 88.9718 96.0332 88.5851 95.7386 88.1961C95.1154 87.3735 94.332 87.3196 93.3882 88.0344L92.1063 89.0053L93.9612 91.4542L95.243 90.4833ZM103.633 89.7732C103.142 90.1451 102.612 90.3716 102.041 90.4527C101.476 90.529 100.925 90.45 100.386 90.2158C99.8488 89.9703 99.3749 89.5766 98.9643 89.0345C98.5586 88.4988 98.3159 87.94 98.2364 87.3579C98.1584 86.7647 98.2381 86.2075 98.4757 85.6864C98.7084 85.1589 99.0734 84.7067 99.5708 84.33C100.068 83.9532 100.602 83.7243 101.173 83.6432C101.739 83.5557 102.292 83.6291 102.83 83.8633C103.375 84.0927 103.853 84.4785 104.264 85.0205C104.674 85.5626 104.915 86.1326 104.987 86.7307C105.06 87.3176 104.977 87.8772 104.738 88.4095C104.499 88.9418 104.131 89.3964 103.633 89.7732ZM103.054 89.0079C103.366 88.7712 103.604 88.4757 103.767 88.1213C103.93 87.7669 103.984 87.3803 103.927 86.9613C103.877 86.5376 103.693 86.1152 103.374 85.6943C103.055 85.2735 102.702 84.9791 102.314 84.8114C101.926 84.6436 101.545 84.591 101.171 84.6536C100.792 84.7098 100.446 84.8562 100.134 85.0929C99.8148 85.3344 99.577 85.6299 99.4203 85.9795C99.2651 86.3178 99.2188 86.6941 99.2816 87.1082C99.3444 87.5223 99.5352 87.9398 99.854 88.3607C100.178 88.7879 100.527 89.0903 100.902 89.2677C101.284 89.4403 101.661 89.5009 102.034 89.4495C102.401 89.3918 102.741 89.2446 103.054 89.0079ZM109.752 85.1386C109.261 85.5106 108.73 85.7371 108.159 85.8182C107.595 85.8945 107.043 85.8155 106.505 85.5812C105.968 85.3358 105.494 84.942 105.083 84.4C104.677 83.8643 104.435 83.3054 104.355 82.7234C104.277 82.1302 104.357 81.573 104.594 81.0518C104.827 80.5243 105.192 80.0722 105.69 79.6954C106.187 79.3187 106.721 79.0897 107.292 79.0086C107.858 78.9211 108.41 78.9945 108.949 79.2288C109.494 79.4582 109.972 79.8439 110.382 80.386C110.793 80.928 111.034 81.4981 111.106 82.0962C111.179 82.683 111.096 83.2426 110.857 83.775C110.618 84.3073 110.25 84.7619 109.752 85.1386ZM109.173 84.3734C109.485 84.1367 109.723 83.8412 109.886 83.4868C110.049 83.1324 110.102 82.7457 110.046 82.3268C109.996 81.903 109.812 81.4807 109.493 81.0598C109.174 80.6389 108.821 80.3446 108.433 80.1768C108.045 80.0091 107.664 79.9565 107.29 80.019C106.911 80.0752 106.565 80.2217 106.252 80.4584C105.934 80.6999 105.696 80.9954 105.539 81.345C105.384 81.6833 105.338 82.0595 105.4 82.4736C105.463 82.8877 105.654 83.3052 105.973 83.7261C106.296 84.1534 106.646 84.4558 107.021 84.6332C107.403 84.8058 107.78 84.8664 108.152 84.815C108.52 84.7573 108.86 84.6101 109.173 84.3734ZM111.064 77.0996C110.99 76.684 111.031 76.287 111.186 75.9087C111.347 75.5255 111.632 75.1793 112.04 74.8702L112.721 75.7694L112.492 75.9433C111.516 76.6823 111.429 77.5811 112.231 78.6397L114.39 81.4903L113.52 82.1497L109.549 76.9076L110.419 76.2483L111.064 77.0996Z"
        fill="#F29C4C"
      />
      <path
        d="M202.666 43.8889L202.669 44.7769L199.033 44.789L199.042 47.609L201.994 47.5992L201.997 48.4872L199.045 48.497L199.057 52.265L197.965 52.2686L197.938 43.9046L202.666 43.8889ZM203.593 48.9379C203.591 48.2659 203.725 47.6775 203.995 47.1726C204.266 46.6597 204.636 46.2624 205.107 45.9809C205.587 45.6993 206.118 45.5575 206.702 45.5556C207.278 45.5536 207.778 45.676 208.203 45.9226C208.628 46.1692 208.945 46.4801 209.154 46.8554L209.15 45.6554L210.254 45.6518L210.276 52.2277L209.172 52.2314L209.168 51.0074C208.953 51.3921 208.631 51.7132 208.199 51.9706C207.776 52.22 207.281 52.3457 206.713 52.3476C206.129 52.3495 205.6 52.2073 205.127 51.9208C204.654 51.6344 204.281 51.2316 204.007 50.7125C203.733 50.1934 203.595 49.6019 203.593 48.9379ZM209.161 48.9314C209.16 48.4354 209.058 48.0038 208.857 47.6364C208.656 47.2691 208.383 46.99 208.038 46.7991C207.702 46.6002 207.329 46.5015 206.921 46.5028C206.513 46.5042 206.142 46.6014 205.806 46.7945C205.471 46.9877 205.204 47.2685 205.005 47.6372C204.806 48.0059 204.708 48.4382 204.709 48.9342C204.711 49.4382 204.812 49.8779 205.014 50.2532C205.215 50.6205 205.484 50.9036 205.82 51.1025C206.157 51.2934 206.529 51.3882 206.937 51.3868C207.345 51.3855 207.717 51.2882 208.052 51.0951C208.396 50.894 208.667 50.6091 208.866 50.2404C209.064 49.8637 209.163 49.4274 209.161 48.9314ZM212.66 44.5758C212.452 44.5765 212.276 44.5051 212.132 44.3615C211.987 44.218 211.914 44.0423 211.914 43.8343C211.913 43.6263 211.984 43.45 212.128 43.3055C212.272 43.1611 212.447 43.0885 212.655 43.0878C212.855 43.0871 213.024 43.1586 213.16 43.3021C213.304 43.4456 213.377 43.6214 213.378 43.8294C213.378 44.0374 213.307 44.2136 213.163 44.3581C213.028 44.5026 212.86 44.5751 212.66 44.5758ZM213.192 45.642L213.214 52.218L212.122 52.2216L212.1 45.6456L213.192 45.642ZM216.148 46.7002C216.339 46.3236 216.61 46.0307 216.961 45.8215C217.321 45.6123 217.756 45.5069 218.268 45.5052L218.272 46.6332L217.984 46.6341C216.76 46.6382 216.15 47.3042 216.155 48.6322L216.167 52.2082L215.075 52.2118L215.053 45.6358L216.145 45.6322L216.148 46.7002Z"
        fill="#F2C94C"
      />
      <path
        d="M309.795 75.1183C309.962 74.6045 309.977 74.1005 309.839 73.6062C309.707 73.1061 309.429 72.6552 309.005 72.2535C308.581 71.8518 308.104 71.5874 307.574 71.4601C307.056 71.3326 306.525 71.3582 305.981 71.537C305.448 71.7154 304.956 72.0427 304.504 72.5189C304.053 72.995 303.753 73.5039 303.603 74.0455C303.46 74.5927 303.463 75.1245 303.612 75.6411C303.773 76.1574 304.066 76.6164 304.49 77.0181C305.082 77.5794 305.738 77.8645 306.457 77.8734C307.175 77.8824 307.853 77.6152 308.489 77.0718L306.068 74.7772L306.678 74.1326L309.945 77.2279L309.367 77.8376C308.847 78.293 308.256 78.6031 307.593 78.7681C306.935 78.9273 306.273 78.9225 305.606 78.7536C304.945 78.579 304.347 78.2386 303.813 77.7323C303.25 77.1986 302.859 76.5809 302.643 75.8794C302.431 75.1721 302.412 74.4539 302.585 73.7249C302.763 73.0014 303.133 72.3435 303.694 71.7512C304.256 71.1589 304.893 70.7542 305.606 70.5369C306.33 70.3194 307.048 70.3001 307.76 70.479C308.478 70.6521 309.118 71.0055 309.681 71.5393C310.326 72.1501 310.744 72.849 310.935 73.6361C311.131 74.4287 311.068 75.2227 310.744 76.018L309.795 75.1183ZM309.897 83.5472C309.45 83.1235 309.14 82.6367 308.966 82.0868C308.799 81.5424 308.787 80.9853 308.93 80.4156C309.084 79.8455 309.395 79.3137 309.863 78.8201C310.325 78.3323 310.837 78.0017 311.398 77.8281C311.971 77.6543 312.533 77.642 313.086 77.7912C313.645 77.9346 314.151 78.221 314.603 78.6502C315.056 79.0794 315.37 79.5689 315.543 80.1188C315.721 80.663 315.739 81.2199 315.596 81.7896C315.459 82.3649 315.156 82.8993 314.689 83.3929C314.221 83.8864 313.698 84.2174 313.12 84.3858C312.552 84.5538 311.987 84.5634 311.423 84.4144C310.858 84.2655 310.35 83.9764 309.897 83.5472ZM310.557 82.8504C310.842 83.12 311.172 83.3064 311.548 83.4094C311.925 83.5125 312.315 83.502 312.719 83.3779C313.129 83.2594 313.515 83.0085 313.879 82.6252C314.242 82.242 314.474 81.8453 314.577 81.4351C314.679 81.0249 314.668 80.6404 314.545 80.2815C314.428 79.9168 314.227 79.5997 313.943 79.33C313.652 79.0549 313.322 78.8685 312.952 78.771C312.592 78.6731 312.214 78.689 311.815 78.8185C311.417 78.9481 311.036 79.2045 310.673 79.5877C310.304 79.9768 310.063 80.3709 309.949 80.7701C309.842 81.1748 309.843 81.5567 309.955 81.9159C310.072 82.2693 310.273 82.5807 310.557 82.8504ZM315.468 88.8269C315.021 88.4032 314.711 87.9164 314.538 87.3665C314.37 86.8221 314.358 86.265 314.501 85.6953C314.656 85.1252 314.967 84.5934 315.435 84.0998C315.897 83.612 316.409 83.2814 316.97 83.1078C317.542 82.934 318.105 82.9217 318.658 83.0709C319.216 83.2143 319.722 83.5007 320.175 83.9299C320.628 84.3591 320.941 84.8486 321.114 85.3985C321.293 85.9427 321.311 86.4996 321.168 87.0693C321.03 87.6446 320.728 88.179 320.26 88.6726C319.792 89.1661 319.269 89.4971 318.691 89.6655C318.124 89.8335 317.558 89.8431 316.994 89.6941C316.43 89.5452 315.921 89.2561 315.468 88.8269ZM316.129 88.1301C316.413 88.3997 316.744 88.5861 317.12 88.6891C317.496 88.7922 317.886 88.7817 318.29 88.6576C318.7 88.5391 319.087 88.2882 319.45 87.9049C319.813 87.5217 320.046 87.125 320.148 86.7148C320.25 86.3046 320.24 85.9201 320.117 85.5612C320 85.1965 319.799 84.8794 319.514 84.6097C319.224 84.3346 318.894 84.1482 318.523 84.0507C318.164 83.9528 317.785 83.9687 317.387 84.0982C316.989 84.2278 316.608 84.4842 316.245 84.8674C315.876 85.2565 315.635 85.6506 315.521 86.0498C315.413 86.4545 315.415 86.8364 315.526 87.1956C315.643 87.549 315.844 87.8604 316.129 88.1301ZM321.014 89.3708C321.477 88.883 321.98 88.5498 322.524 88.371C323.074 88.1865 323.616 88.1549 324.151 88.2763C324.692 88.4032 325.178 88.6703 325.607 89.0775C325.979 89.4297 326.242 89.8442 326.396 90.321C326.556 90.7921 326.588 91.2468 326.492 91.6851L328.886 89.1591L329.687 89.9185L323.579 96.3641L322.778 95.6047L323.628 94.7076C323.202 94.8435 322.747 94.8586 322.263 94.7528C321.784 94.6412 321.339 94.39 320.927 93.9993C320.503 93.5976 320.216 93.1272 320.065 92.5879C319.921 92.0542 319.929 91.5051 320.089 90.9406C320.249 90.376 320.558 89.8528 321.014 89.3708ZM325.048 93.2094C325.389 92.8494 325.614 92.467 325.721 92.0623C325.829 91.6576 325.825 91.2673 325.707 90.8913C325.601 90.515 325.399 90.1866 325.103 89.9059C324.807 89.6253 324.471 89.4391 324.095 89.3474C323.719 89.2556 323.332 89.2745 322.934 89.4041C322.535 89.5336 322.166 89.7784 321.825 90.1384C321.478 90.5043 321.248 90.8924 321.134 91.3029C321.026 91.7076 321.026 92.0981 321.132 92.4744C321.244 92.8449 321.448 93.1704 321.744 93.4511C322.04 93.7317 322.376 93.9179 322.752 94.0096C323.139 94.1011 323.532 94.082 323.93 93.9525C324.334 93.8171 324.707 93.5694 325.048 93.2094Z"
        fill="#3B86F2"
      />
      <path
        d="M367.632 152.718L364.86 153.081L365.257 156.103L364.364 156.221L363.968 153.198L361.112 153.573L361.555 156.952L360.663 157.069L360.078 152.608L368.382 151.518L368.968 155.98L368.076 156.097L367.632 152.718ZM361.325 162.11L363.549 160.245L360.927 159.076L360.778 157.946L364.291 159.627L367.298 157.091L367.459 158.316L365.247 160.18L367.856 161.338L368.004 162.468L364.505 160.798L361.485 163.336L361.325 162.11ZM364.844 163.567C365.518 163.479 366.123 163.536 366.658 163.741C367.201 163.944 367.643 164.265 367.983 164.704C368.324 165.152 368.535 165.685 368.616 166.304C368.721 167.105 368.613 167.789 368.292 168.355C367.972 168.93 367.478 169.345 366.81 169.603L366.657 168.437C367.039 168.274 367.324 168.014 367.511 167.659C367.7 167.311 367.763 166.9 367.7 166.424C367.619 165.805 367.339 165.333 366.861 165.009C366.39 164.683 365.767 164.572 364.989 164.674C364.204 164.777 363.622 165.047 363.244 165.484C362.865 165.921 362.717 166.448 362.798 167.067C362.861 167.543 363.024 167.925 363.287 168.213C363.551 168.501 363.897 168.678 364.325 168.743L364.478 169.909C363.789 169.822 363.208 169.543 362.734 169.072C362.269 168.601 361.985 167.973 361.882 167.187C361.801 166.569 361.867 165.999 362.081 165.479C362.297 164.966 362.64 164.542 363.112 164.206C363.585 163.87 364.162 163.657 364.844 163.567ZM366.864 177.117C366.658 177.144 366.438 177.16 366.205 177.167L365.521 171.955C364.884 172.079 364.409 172.364 364.096 172.808C363.792 173.259 363.678 173.771 363.753 174.342C363.814 174.81 363.972 175.184 364.227 175.466C364.491 175.754 364.813 175.937 365.195 176.016L365.348 177.182C364.698 177.09 364.141 176.808 363.676 176.337C363.218 175.864 362.939 175.239 362.837 174.462C362.755 173.843 362.821 173.27 363.034 172.742C363.249 172.221 363.591 171.789 364.062 171.445C364.542 171.1 365.118 170.883 365.792 170.794C366.467 170.706 367.075 170.763 367.618 170.966C368.161 171.169 368.6 171.495 368.933 171.943C369.275 172.399 369.488 172.944 369.571 173.578C369.652 174.197 369.589 174.762 369.382 175.273C369.175 175.785 368.85 176.198 368.407 176.515C367.973 176.838 367.459 177.038 366.864 177.117ZM366.943 175.968C367.356 175.914 367.697 175.777 367.966 175.556C368.244 175.334 368.437 175.054 368.546 174.717C368.664 174.387 368.698 174.032 368.648 173.651C368.577 173.104 368.341 172.658 367.941 172.316C367.542 171.981 367.029 171.826 366.403 171.852L366.943 175.968ZM372.488 178.934L363.684 180.089L363.542 179.006L372.346 177.851L372.488 178.934ZM372.873 181.862L364.068 183.017L363.926 181.934L372.731 180.779L372.873 181.862ZM368.601 190.351C368.395 190.378 368.175 190.394 367.942 190.401L367.258 185.19C366.621 185.314 366.146 185.598 365.833 186.042C365.529 186.494 365.414 187.005 365.489 187.576C365.551 188.044 365.709 188.419 365.964 188.7C366.227 188.988 366.55 189.172 366.931 189.251L367.084 190.417C366.435 190.324 365.878 190.042 365.412 189.571C364.955 189.098 364.675 188.474 364.573 187.696C364.492 187.077 364.558 186.504 364.771 185.976C364.985 185.456 365.328 185.023 365.799 184.679C366.278 184.334 366.855 184.117 367.529 184.028C368.203 183.94 368.812 183.997 369.355 184.2C369.898 184.403 370.336 184.729 370.669 185.178C371.011 185.633 371.224 186.178 371.307 186.812C371.389 187.431 371.326 187.996 371.118 188.507C370.911 189.019 370.586 189.433 370.144 189.749C369.71 190.072 369.196 190.273 368.601 190.351ZM368.68 189.203C369.093 189.148 369.434 189.011 369.703 188.79C369.981 188.568 370.174 188.289 370.283 187.951C370.401 187.621 370.435 187.266 370.385 186.885C370.313 186.338 370.077 185.893 369.677 185.55C369.278 185.215 368.766 185.06 368.14 185.086L368.68 189.203ZM372.334 194.546C372.438 195.339 372.281 196.013 371.862 196.569C371.45 197.123 370.792 197.459 369.888 197.578L366.045 198.082L365.905 197.012L369.593 196.528C370.243 196.442 370.718 196.215 371.016 195.845C371.322 195.474 371.439 195.006 371.365 194.443C371.29 193.872 371.052 193.44 370.65 193.145C370.249 192.859 369.708 192.761 369.026 192.85L365.421 193.323L365.278 192.24L371.799 191.385L371.941 192.468L371.013 192.589C371.374 192.76 371.67 193.015 371.9 193.356C372.131 193.705 372.276 194.102 372.334 194.546ZM372.078 200.433L368.235 200.937C367.918 200.979 367.701 201.076 367.583 201.229C367.474 201.38 367.442 201.623 367.485 201.956L367.59 202.753L366.674 202.873L366.546 201.897C366.467 201.295 366.546 200.824 366.784 200.486C367.022 200.149 367.459 199.938 368.093 199.855L371.936 199.35L371.825 198.506L372.718 198.389L372.828 199.233L374.47 199.018L374.612 200.101L372.971 200.316L373.194 202.017L372.301 202.135L372.078 200.433Z"
        fill="#603ACB"
      />
      <path
        d="M42.0674 241.847C40.9368 242.039 40.0249 242.004 39.3315 241.743C38.6315 241.483 38.2035 240.893 38.0474 239.973C37.8925 239.06 38.1026 238.365 38.6777 237.888C39.2463 237.413 40.0959 237.08 41.2264 236.888C42.3766 236.693 43.3017 236.726 44.0017 236.986C44.7017 237.246 45.1292 237.832 45.2841 238.746C45.4401 239.666 45.2306 240.364 44.6555 240.841C44.0803 241.317 43.2176 241.652 42.0674 241.847ZM41.3769 237.776C40.805 237.873 40.3286 237.994 39.9476 238.14C39.5589 238.28 39.2631 238.489 39.06 238.767C38.8558 239.038 38.7911 239.394 38.8657 239.834C38.9415 240.281 39.1211 240.603 39.4044 240.798C39.6866 240.987 40.0349 241.087 40.4492 241.097C40.8558 241.103 41.3451 241.057 41.9169 240.96C42.5084 240.86 42.9986 240.739 43.3872 240.599C43.7748 240.452 44.0707 240.243 44.2749 239.972C44.4779 239.694 44.5416 239.332 44.4658 238.885C44.3911 238.444 44.2127 238.13 43.9304 237.941C43.6471 237.746 43.2989 237.646 42.8857 237.641C42.4713 237.631 41.9684 237.675 41.3769 237.776ZM39.1678 236.173C38.7209 236.249 38.3431 236.174 38.0345 235.949C37.7193 235.726 37.526 235.403 37.4547 234.983C37.3834 234.562 37.4596 234.194 37.6834 233.879C37.9006 233.565 38.2327 233.37 38.6796 233.294C39.1331 233.217 39.5175 233.291 39.8327 233.514C40.1413 233.739 40.3313 234.062 40.4026 234.483C40.4739 234.903 40.401 235.271 40.1838 235.585C39.96 235.9 39.6214 236.096 39.1678 236.173ZM36.8308 230.646L44.3897 233.472L44.5402 234.359L36.9813 231.533L36.8308 230.646ZM38.0068 234.889C38.0447 235.113 38.1537 235.277 38.3337 235.381C38.5061 235.481 38.7434 235.505 39.0458 235.453C39.3481 235.402 39.5676 235.301 39.7042 235.149C39.8396 234.991 39.8884 234.8 39.8505 234.576C39.8126 234.353 39.7036 234.189 39.5236 234.084C39.337 233.981 39.0958 233.954 38.8 234.004C38.4976 234.055 38.282 234.159 38.1531 234.317C38.0177 234.475 37.9689 234.666 38.0068 234.889ZM42.6881 231.691C42.2345 231.768 41.8535 231.694 41.5449 231.469C41.2297 231.246 41.0364 230.923 40.9651 230.503C40.8937 230.082 40.9705 229.717 41.1954 229.409C41.4126 229.095 41.748 228.899 42.2015 228.822C42.6485 228.747 43.0295 228.821 43.3447 229.044C43.6588 229.262 43.8515 229.581 43.9228 230.001C43.9942 230.422 43.9212 230.789 43.704 231.103C43.4802 231.418 43.1416 231.614 42.6881 231.691ZM41.5287 230.417C41.5666 230.641 41.6756 230.805 41.8556 230.91C42.0291 231.015 42.267 231.043 42.5694 230.991C42.8651 230.941 43.0808 230.837 43.2162 230.679C43.3451 230.522 43.3906 230.331 43.3527 230.108C43.3148 229.885 43.2091 229.72 43.0356 229.614C42.8556 229.509 42.6177 229.482 42.3219 229.532C42.0196 229.584 41.8039 229.688 41.6751 229.845C41.5396 230.003 41.4908 230.194 41.5287 230.417Z"
        fill="#616B80"
      />
      <path
        d="M59.1217 131.008C58.9624 129.934 58.8169 129.081 58.6853 128.448C58.5479 127.811 58.3575 127.232 58.1139 126.711C57.8679 126.181 57.5464 125.8 57.1494 125.568C56.7754 125.349 56.4281 125.269 56.1074 125.329C55.7844 125.379 55.5051 125.606 55.2694 126.009C55.0405 126.4 54.9857 126.777 55.1052 127.141C55.2223 127.495 55.4801 127.8 55.8785 128.057L55.4341 128.816C54.8031 128.416 54.4199 127.929 54.2843 127.356C54.1488 126.782 54.2511 126.204 54.5911 125.623C54.9379 125.031 55.3763 124.658 55.9063 124.504C56.4396 124.345 56.994 124.434 57.5694 124.771C58.047 125.05 58.4289 125.467 58.7151 126.02C58.999 126.565 59.2075 127.119 59.3406 127.684C59.468 128.245 59.594 128.941 59.7186 129.77L61.4559 126.801L62.1119 127.185L59.6827 131.337L59.1217 131.008ZM59.5273 124.454C58.5376 123.875 57.8608 123.263 57.4969 122.617C57.1273 121.969 57.1782 121.241 57.6495 120.436C58.1175 119.636 58.7248 119.238 59.4715 119.243C60.2125 119.244 61.0778 119.534 62.0675 120.113C63.0744 120.702 63.7627 121.321 64.1323 121.97C64.5019 122.618 64.4528 123.343 63.9848 124.143C63.5134 124.948 62.9044 125.349 62.1577 125.344C61.4111 125.34 60.5342 125.043 59.5273 124.454ZM61.613 120.889C61.1124 120.597 60.6692 120.384 60.2836 120.251C59.8956 120.109 59.5345 120.079 59.2004 120.161C58.8696 120.238 58.5915 120.469 58.3659 120.855C58.137 121.246 58.0684 121.608 58.1601 121.939C58.2551 122.265 58.458 122.566 58.7685 122.84C59.0768 123.105 59.4812 123.384 59.9818 123.677C60.4996 123.98 60.9526 124.203 61.3406 124.345C61.732 124.481 62.0931 124.511 62.4238 124.434C62.7579 124.352 63.0395 124.115 63.2684 123.723C63.494 123.338 63.5592 122.982 63.4642 122.656C63.3725 122.324 63.1696 122.024 62.8557 121.756C62.5451 121.481 62.1308 121.192 61.613 120.889ZM60.9488 118.242C60.5576 118.014 60.3159 117.714 60.2237 117.343C60.1258 116.969 60.1846 116.598 60.4001 116.23C60.6156 115.862 60.9103 115.628 61.2843 115.531C61.6525 115.429 62.0322 115.493 62.4235 115.722C62.8205 115.954 63.068 116.258 63.1658 116.632C63.258 117.002 63.1963 117.372 62.9808 117.74C62.7653 118.108 62.4735 118.343 62.1053 118.444C61.7314 118.542 61.3459 118.475 60.9488 118.242ZM62.707 112.505L66.6862 119.526L66.2317 120.302L62.2525 113.282L62.707 112.505ZM60.8835 116.513C60.769 116.708 60.7471 116.904 60.8179 117.1C60.8863 117.287 61.0528 117.457 61.3175 117.612C61.5822 117.767 61.8156 117.83 62.0176 117.802C62.2231 117.768 62.383 117.653 62.4975 117.457C62.6119 117.261 62.6338 117.066 62.563 116.87C62.4865 116.67 62.3188 116.495 62.0599 116.344C61.7952 116.189 61.563 116.13 61.3633 116.168C61.1579 116.202 60.9979 116.317 60.8835 116.513ZM66.5254 117.068C66.1283 116.836 65.8838 116.534 65.7916 116.164C65.6937 115.79 65.7525 115.418 65.968 115.05C66.1835 114.682 66.4765 114.452 66.8471 114.36C67.2153 114.258 67.5979 114.324 67.9949 114.556C68.3862 114.785 68.6308 115.087 68.7287 115.461C68.8299 115.829 68.7728 116.197 68.5574 116.565C68.3419 116.934 68.05 117.168 67.6818 117.27C67.3079 117.367 66.9224 117.3 66.5254 117.068ZM66.4549 115.347C66.3405 115.542 66.3186 115.738 66.3894 115.934C66.4544 116.126 66.6192 116.3 66.8839 116.455C67.1429 116.607 67.375 116.665 67.5805 116.631C67.7802 116.593 67.9372 116.477 68.0517 116.281C68.1662 116.085 68.1909 115.891 68.1259 115.699C68.0551 115.503 67.8903 115.329 67.6313 115.178C67.3667 115.023 67.1345 114.964 66.9348 115.002C66.7294 115.036 66.5694 115.151 66.4549 115.347Z"
        fill="#616B80"
      />
      <path
        d="M141.431 53.5778L141.207 52.9253L142.946 47.1881L143.977 46.8337L145.525 51.3351L146.47 51.0099L146.727 51.757L145.781 52.0822L146.305 53.6047L145.454 53.8973L144.93 52.3748L141.431 53.5778ZM143.472 48.0117L142.167 52.4894L144.711 51.6147L143.472 48.0117ZM146.91 49.4944C146.538 48.4101 146.424 47.5046 146.569 46.778C146.711 46.0451 147.224 45.5269 148.107 45.2234C148.983 44.9221 149.703 45.0165 150.266 45.5067C150.827 45.9905 151.294 46.7746 151.667 47.8589C152.046 48.9622 152.165 49.8803 152.022 50.6132C151.879 51.3461 151.37 51.8633 150.493 52.1646C149.611 52.468 148.888 52.3747 148.324 51.8846C147.761 51.3944 147.29 50.5977 146.91 49.4944ZM150.816 48.1516C150.627 47.6031 150.43 47.1527 150.225 46.8005C150.023 46.4397 149.769 46.1818 149.461 46.0265C149.161 45.8691 148.799 45.8631 148.377 46.0083C147.948 46.1557 147.66 46.3851 147.513 46.6963C147.373 47.0055 147.331 47.3653 147.388 47.7759C147.448 48.178 147.573 48.6533 147.762 49.2018C147.957 49.7692 148.155 50.2333 148.357 50.594C148.564 50.9526 148.819 51.2105 149.12 51.3679C149.427 51.5232 149.795 51.5271 150.223 51.3797C150.646 51.2344 150.927 51.0072 151.068 50.6981C151.214 50.3868 151.256 50.027 151.194 49.6185C151.137 49.208 151.011 48.719 150.816 48.1516ZM152.038 45.7116C151.891 45.2828 151.903 44.898 152.075 44.5569C152.245 44.2096 152.531 43.9665 152.935 43.8278C153.338 43.6891 153.713 43.7045 154.061 43.8741C154.406 44.0374 154.652 44.3334 154.8 44.7621C154.949 45.1971 154.939 45.5883 154.77 45.9357C154.598 46.2767 154.31 46.5166 153.907 46.6553C153.503 46.7941 153.129 46.7818 152.784 46.6185C152.436 46.4489 152.188 46.1466 152.038 45.7116ZM157.112 42.5077L155.552 50.4252L154.701 50.7179L156.261 42.8003L157.112 42.5077ZM153.117 44.3574C152.902 44.4311 152.758 44.5652 152.684 44.7599C152.614 44.9461 152.629 45.1842 152.729 45.4742C152.828 45.7642 152.964 45.9643 153.136 46.0744C153.314 46.1823 153.51 46.1995 153.725 46.1258C153.939 46.0521 154.083 45.9179 154.157 45.7232C154.229 45.5223 154.216 45.2799 154.119 44.9962C154.019 44.7062 153.881 44.5104 153.705 44.4087C153.527 44.3008 153.331 44.2837 153.117 44.3574ZM157.032 48.4569C156.883 48.0219 156.894 47.6339 157.066 47.2928C157.235 46.9455 157.522 46.7024 157.925 46.5637C158.329 46.425 158.701 46.4415 159.042 46.6133C159.387 46.7766 159.635 47.0757 159.784 47.5107C159.932 47.9394 159.921 48.3275 159.751 48.6748C159.588 49.02 159.304 49.262 158.901 49.4007C158.497 49.5394 158.123 49.5271 157.778 49.3638C157.43 49.1942 157.182 48.8919 157.032 48.4569ZM158.101 47.106C157.887 47.1797 157.743 47.3139 157.669 47.5085C157.592 47.6969 157.604 47.9361 157.704 48.2261C157.801 48.5098 157.939 48.7056 158.117 48.8135C158.293 48.9152 158.488 48.9292 158.703 48.8555C158.917 48.7818 159.062 48.6507 159.139 48.4624C159.213 48.2677 159.201 48.0285 159.103 47.7448C159.004 47.4548 158.866 47.259 158.69 47.1574C158.512 47.0494 158.316 47.0323 158.101 47.106Z"
        fill="#616B80"
      />
      <path
        d="M263.688 45.7716C263.81 45.0271 263.512 44.5205 262.794 44.2518C262.239 44.0438 261.743 44.1038 261.307 44.4318C260.873 44.7536 260.476 45.4058 260.115 46.3884C260.381 46.1175 260.712 45.9534 261.111 45.8962C261.518 45.835 261.928 45.8816 262.34 46.0358C262.983 46.2765 263.42 46.6679 263.652 47.21C263.889 47.7545 263.876 48.3795 263.612 49.0851C263.453 49.5096 263.226 49.859 262.932 50.133C262.643 50.4094 262.293 50.5844 261.881 50.6581C261.475 50.734 261.035 50.6832 260.561 50.5056C259.917 50.2649 259.469 49.9332 259.214 49.5105C258.959 49.0877 258.855 48.5966 258.9 48.0371C258.946 47.4776 259.108 46.8264 259.386 46.0834C260.244 43.7919 261.472 42.9453 263.07 43.5435C263.682 43.7725 264.101 44.1179 264.327 44.5797C264.552 45.0414 264.602 45.5369 264.475 46.066L263.688 45.7716ZM261.892 46.6904C261.624 46.5899 261.35 46.5514 261.071 46.575C260.794 46.5924 260.538 46.6854 260.304 46.8541C260.079 47.0189 259.906 47.2605 259.787 47.5789C259.61 48.0534 259.602 48.492 259.765 48.8945C259.93 49.2907 260.268 49.5847 260.78 49.7763C261.217 49.9399 261.614 49.9353 261.97 49.7626C262.335 49.5861 262.604 49.2667 262.777 48.8047C262.96 48.3177 262.977 47.8901 262.83 47.5219C262.686 47.1475 262.373 46.8703 261.892 46.6904ZM265.221 48.2885C265.623 47.2145 266.111 46.4433 266.685 45.9748C267.261 45.5 267.986 45.4262 268.86 45.7533C269.728 46.0781 270.224 46.6088 270.347 47.3453C270.472 48.0755 270.334 48.9776 269.932 50.0515C269.523 51.1442 269.03 51.9279 268.454 52.4027C267.878 52.8775 267.156 52.9525 266.288 52.6277C265.414 52.3005 264.915 51.7687 264.792 51.0322C264.669 50.2957 264.812 49.3811 265.221 48.2885ZM269.089 49.7361C269.292 49.1929 269.427 48.7199 269.492 48.3173C269.566 47.9107 269.533 47.5498 269.395 47.2347C269.263 46.9219 268.988 46.6872 268.57 46.5306C268.145 46.3718 267.777 46.3658 267.466 46.5126C267.161 46.6619 266.9 46.9129 266.682 47.2657C266.473 47.6147 266.267 48.0607 266.064 48.6039C265.854 49.1659 265.712 49.6501 265.638 50.0567C265.57 50.4656 265.602 50.8265 265.734 51.1393C265.873 51.4544 266.154 51.6914 266.579 51.8503C266.997 52.0069 267.359 52.0105 267.664 51.8613C267.975 51.7144 268.236 51.4634 268.447 51.1082C268.665 50.7554 268.879 50.298 269.089 49.7361ZM271.584 48.6305C271.743 48.2059 271.997 47.9166 272.347 47.7627C272.698 47.6025 273.074 47.5972 273.474 47.7467C273.873 47.8963 274.153 48.147 274.313 48.4988C274.476 48.8443 274.478 49.2294 274.319 49.654C274.158 50.0848 273.901 50.3803 273.549 50.5405C273.2 50.6944 272.825 50.6966 272.426 50.5471C272.026 50.3975 271.745 50.15 271.583 49.8044C271.422 49.4526 271.423 49.0613 271.584 48.6305ZM277.537 49.385L271.298 54.5026L270.455 54.1872L276.694 49.0695L277.537 49.385ZM273.277 48.2712C273.065 48.1918 272.869 48.2036 272.688 48.3067C272.515 48.4059 272.375 48.5991 272.268 48.8863C272.16 49.1736 272.138 49.4143 272.2 49.6085C272.269 49.8051 272.41 49.9431 272.622 50.0226C272.834 50.102 273.031 50.0902 273.212 49.9871C273.395 49.8777 273.539 49.6826 273.645 49.4016C273.752 49.1144 273.77 48.8756 273.699 48.6853C273.63 48.4887 273.49 48.3507 273.277 48.2712ZM273.692 53.9252C273.853 53.4944 274.109 53.202 274.458 53.0481C274.81 52.8879 275.186 52.8826 275.585 53.0321C275.985 53.1817 276.261 53.4312 276.415 53.7806C276.578 54.1262 276.579 54.5144 276.417 54.9452C276.258 55.3698 276.003 55.6621 275.651 55.8223C275.306 55.9848 274.933 55.9913 274.534 55.8418C274.134 55.6922 273.853 55.4447 273.69 55.0991C273.53 54.7473 273.531 54.356 273.692 53.9252ZM275.376 53.5624C275.164 53.483 274.967 53.4948 274.786 53.5979C274.607 53.6948 274.464 53.8869 274.357 54.1741C274.252 54.455 274.234 54.6938 274.302 54.8904C274.374 55.0807 274.515 55.2156 274.728 55.2951C274.94 55.3745 275.135 55.3658 275.314 55.2689C275.495 55.1658 275.638 54.9738 275.743 54.6928C275.851 54.4056 275.869 54.1668 275.798 53.9765C275.729 53.7799 275.588 53.6419 275.376 53.5624Z"
        fill="#616B80"
      />
      <path
        d="M349.701 117.274C349.643 116.877 349.686 116.523 349.83 116.21C349.974 115.898 350.22 115.642 350.567 115.444C350.88 115.265 351.206 115.183 351.544 115.197C351.888 115.208 352.22 115.326 352.54 115.55C352.869 115.777 353.159 116.11 353.41 116.55C353.661 116.99 353.799 117.407 353.824 117.799C353.857 118.195 353.792 118.543 353.626 118.845C353.47 119.149 353.235 119.39 352.922 119.569C352.587 119.761 352.24 119.839 351.883 119.805C351.532 119.768 351.206 119.628 350.906 119.385C351.001 119.806 350.969 120.201 350.81 120.568C350.66 120.937 350.391 121.233 350.003 121.454C349.627 121.669 349.244 121.765 348.854 121.742C348.471 121.715 348.103 121.576 347.752 121.323C347.41 121.073 347.113 120.728 346.862 120.288C346.611 119.848 346.464 119.417 346.423 118.996C346.391 118.576 346.461 118.195 346.633 117.851C346.811 117.504 347.088 117.223 347.465 117.008C347.853 116.786 348.245 116.701 348.642 116.75C349.039 116.8 349.392 116.975 349.701 117.274ZM352.391 118.859C352.744 118.658 352.95 118.387 353.009 118.046C353.068 117.705 352.981 117.332 352.75 116.927C352.522 116.527 352.246 116.266 351.923 116.144C351.6 116.021 351.259 116.063 350.9 116.268C350.575 116.453 350.383 116.72 350.321 117.07C350.263 117.425 350.343 117.794 350.561 118.176C350.783 118.564 351.06 118.821 351.392 118.946C351.734 119.073 352.066 119.044 352.391 118.859ZM349.953 118.523C349.709 118.095 349.408 117.802 349.05 117.646C348.697 117.486 348.322 117.52 347.922 117.749C347.552 117.96 347.328 118.261 347.251 118.65C347.177 119.045 347.267 119.466 347.522 119.912C347.776 120.357 348.091 120.646 348.465 120.778C348.84 120.909 349.212 120.869 349.583 120.658C349.971 120.436 350.19 120.135 350.241 119.753C350.297 119.367 350.201 118.958 349.953 118.523ZM352.113 121.641C353.109 121.073 353.978 120.792 354.718 120.799C355.465 120.803 356.07 121.21 356.533 122.02C356.992 122.825 357.033 123.55 356.657 124.195C356.286 124.836 355.603 125.441 354.607 126.01C353.594 126.588 352.714 126.875 351.967 126.872C351.221 126.868 350.618 126.464 350.158 125.659C349.695 124.849 349.652 124.121 350.029 123.476C350.405 122.831 351.1 122.22 352.113 121.641ZM354.161 125.228C354.665 124.94 355.07 124.663 355.378 124.395C355.695 124.13 355.901 123.832 355.996 123.501C356.095 123.176 356.033 122.82 355.812 122.432C355.587 122.038 355.308 121.798 354.975 121.712C354.645 121.632 354.284 121.657 353.891 121.79C353.507 121.924 353.063 122.135 352.56 122.423C352.039 122.72 351.62 123.002 351.303 123.267C350.989 123.538 350.783 123.836 350.685 124.161C350.589 124.492 350.654 124.854 350.879 125.248C351.1 125.636 351.376 125.87 351.706 125.95C352.039 126.036 352.401 126.01 352.79 125.872C353.183 125.74 353.64 125.525 354.161 125.228ZM356.786 125.974C357.18 125.749 357.56 125.689 357.927 125.795C358.3 125.896 358.592 126.133 358.804 126.503C359.015 126.874 359.07 127.245 358.968 127.618C358.872 127.988 358.628 128.285 358.234 128.51C357.834 128.738 357.448 128.801 357.075 128.699C356.708 128.594 356.419 128.356 356.207 127.985C355.996 127.615 355.938 127.245 356.034 126.875C356.136 126.502 356.387 126.202 356.786 125.974ZM360.88 130.361L352.81 130.305L352.364 129.523L360.434 129.58L360.88 130.361ZM358.318 126.781C358.205 126.584 358.047 126.467 357.841 126.431C357.646 126.397 357.414 126.456 357.148 126.608C356.882 126.76 356.71 126.931 356.634 127.12C356.561 127.315 356.581 127.511 356.694 127.708C356.806 127.905 356.965 128.021 357.17 128.058C357.381 128.091 357.616 128.033 357.877 127.884C358.143 127.732 358.31 127.561 358.377 127.369C358.45 127.174 358.43 126.978 358.318 126.781ZM355.02 131.392C355.42 131.164 355.803 131.103 356.17 131.208C356.543 131.31 356.835 131.546 357.047 131.917C357.258 132.287 357.311 132.656 357.206 133.023C357.11 133.393 356.862 133.691 356.463 133.919C356.069 134.144 355.686 134.206 355.313 134.104C354.943 134.008 354.653 133.774 354.441 133.404C354.23 133.033 354.172 132.663 354.268 132.294C354.37 131.921 354.621 131.62 355.02 131.392ZM356.547 132.19C356.434 131.994 356.276 131.877 356.07 131.84C355.871 131.801 355.638 131.857 355.372 132.009C355.112 132.158 354.945 132.329 354.872 132.525C354.805 132.716 354.828 132.911 354.94 133.108C355.052 133.304 355.208 133.423 355.407 133.463C355.613 133.499 355.845 133.443 356.106 133.294C356.372 133.142 356.539 132.97 356.606 132.778C356.679 132.583 356.659 132.387 356.547 132.19Z"
        fill="#616B80"
      />
      <path
        d="M377.309 228.21L378.125 228.363L377.778 230.211L370.672 228.875L370.842 227.971L377.132 229.153L377.309 228.21ZM374.01 231.093C375.137 231.305 375.98 231.653 376.54 232.138C377.107 232.625 377.304 233.327 377.131 234.244C376.96 235.155 376.522 235.734 375.818 235.981C375.12 236.23 374.207 236.248 373.081 236.036C371.934 235.821 371.077 235.47 370.511 234.984C369.944 234.497 369.747 233.799 369.918 232.888C370.09 231.971 370.529 231.388 371.233 231.141C371.938 230.893 372.863 230.878 374.01 231.093ZM373.247 235.152C373.817 235.259 374.306 235.31 374.714 235.306C375.127 235.309 375.477 235.215 375.764 235.025C376.049 234.841 376.233 234.53 376.316 234.091C376.399 233.645 376.342 233.282 376.144 233C375.945 232.725 375.653 232.511 375.268 232.357C374.888 232.211 374.413 232.085 373.843 231.978C373.254 231.867 372.752 231.81 372.339 231.807C371.925 231.81 371.575 231.904 371.289 232.088C371.002 232.278 370.817 232.596 370.733 233.041C370.651 233.48 370.709 233.837 370.909 234.112C371.107 234.394 371.399 234.608 371.785 234.755C372.17 234.909 372.657 235.041 373.247 235.152ZM372.85 237.264C373.977 237.476 374.82 237.825 375.38 238.31C375.947 238.796 376.144 239.498 375.971 240.415C375.8 241.326 375.362 241.905 374.658 242.152C373.96 242.401 373.048 242.42 371.921 242.208C370.774 241.992 369.917 241.641 369.351 241.155C368.784 240.669 368.587 239.97 368.758 239.059C368.93 238.142 369.369 237.56 370.073 237.312C370.778 237.065 371.703 237.049 372.85 237.264ZM372.087 241.323C372.657 241.43 373.146 241.482 373.554 241.477C373.967 241.48 374.317 241.386 374.604 241.196C374.889 241.012 375.073 240.701 375.156 240.262C375.239 239.816 375.182 239.453 374.984 239.171C374.785 238.896 374.493 238.682 374.108 238.528C373.728 238.382 373.254 238.256 372.684 238.149C372.094 238.038 371.592 237.981 371.179 237.978C370.765 237.981 370.415 238.075 370.129 238.259C369.842 238.449 369.657 238.767 369.574 239.213C369.491 239.652 369.549 240.008 369.749 240.283C369.947 240.565 370.239 240.779 370.625 240.926C371.01 241.08 371.497 241.212 372.087 241.323ZM373.604 243.592C374.049 243.676 374.378 243.876 374.59 244.194C374.808 244.513 374.877 244.883 374.799 245.302C374.72 245.721 374.521 246.04 374.202 246.258C373.889 246.477 373.51 246.545 373.065 246.462C372.612 246.377 372.277 246.174 372.059 245.855C371.848 245.537 371.781 245.169 371.86 244.75C371.939 244.33 372.135 244.011 372.447 243.792C372.766 243.573 373.152 243.507 373.604 243.592ZM373.881 249.586L367.77 244.317L367.936 243.432L374.048 248.702L373.881 249.586ZM374.248 245.198C374.29 244.976 374.245 244.784 374.112 244.623C373.985 244.471 373.77 244.366 373.469 244.309C373.168 244.253 372.927 244.272 372.746 244.367C372.564 244.468 372.452 244.63 372.41 244.853C372.369 245.076 372.414 245.267 372.547 245.428C372.686 245.59 372.903 245.698 373.198 245.754C373.499 245.811 373.737 245.788 373.913 245.685C374.094 245.583 374.206 245.421 374.248 245.198ZM368.749 246.576C369.201 246.661 369.533 246.863 369.745 247.181C369.963 247.5 370.032 247.869 369.954 248.288C369.875 248.708 369.676 249.023 369.358 249.235C369.046 249.454 368.664 249.521 368.212 249.436C367.766 249.352 367.434 249.151 367.216 248.832C366.997 248.519 366.926 248.153 367.005 247.734C367.084 247.315 367.28 246.995 367.592 246.776C367.911 246.558 368.297 246.491 368.749 246.576ZM369.395 248.173C369.437 247.95 369.392 247.759 369.259 247.598C369.133 247.439 368.919 247.331 368.618 247.274C368.323 247.219 368.085 247.242 367.903 247.343C367.728 247.446 367.619 247.609 367.577 247.831C367.535 248.054 367.577 248.245 367.703 248.405C367.836 248.565 368.05 248.673 368.345 248.729C368.646 248.785 368.884 248.762 369.06 248.66C369.241 248.558 369.353 248.396 369.395 248.173Z"
        fill="#616B80"
      />
      <defs>
        <filter
          id="filter0_f_9484_85755"
          x="196.962"
          y="182.885"
          width="19.3356"
          height="13.4087"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="BackgroundImageFix"
            result="shape"
          />
          <feGaussianBlur
            stdDeviation="1.5"
            result="effect1_foregroundBlur_9484_85755"
          />
        </filter>
      </defs>
    </svg>
  );
}
export function SpeedomeaterIndicatorIcon() {
  return (
    <svg
      width="28.75vw"
      height="28.75vw"
      viewBox="0 0 414 414"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g opacity="0.9" filter="url(#filter0_f_9639_22536)">
        <circle cx="207.346" cy="207.346" r="73.346" fill="#D8EBFC" />
      </g>
      <g filter="url(#filter1_d_9639_22536)">
        <path
          d="M81.3766 229.29C81.0585 230.361 81.0584 230.361 81.7241 231.259L194.281 215.981L192.197 204.164L81.3768 229.289L81.3766 229.29Z"
          fill="url(#paint0_linear_9639_22536)"
          fillOpacity="0.5"
          shape-rendering="crispEdges"
        />
      </g>
      <g filter="url(#filter2_ddddd_9639_22536)">
        <circle
          cx="207.34"
          cy="207.169"
          r="17.4104"
          transform="rotate(-100 207.34 207.169)"
          fill="white"
        />
        <circle
          cx="207.34"
          cy="207.169"
          r="17.4104"
          transform="rotate(-100 207.34 207.169)"
          fill="url(#paint1_radial_9639_22536)"
          fillOpacity="0.3"
        />
        <circle
          cx="207.34"
          cy="207.169"
          r="17.4104"
          transform="rotate(-100 207.34 207.169)"
          fill="url(#paint2_linear_9639_22536)"
          fillOpacity="0.6"
        />
        <circle
          cx="207.34"
          cy="207.169"
          r="17.4104"
          transform="rotate(-100 207.34 207.169)"
          fill="url(#paint3_linear_9639_22536)"
          fillOpacity="0.6"
        />
        <circle
          cx="207.34"
          cy="207.169"
          r="17.4104"
          transform="rotate(-100 207.34 207.169)"
          fill="url(#paint4_radial_9639_22536)"
          fillOpacity="0.5"
        />
      </g>
      <mask
        id="mask0_9639_22536"
        maskUnits="userSpaceOnUse"
        x="189"
        y="189"
        width="36"
        height="36"
      >
        <circle
          cx="207.34"
          cy="207.169"
          r="17.4104"
          transform="rotate(-100 207.34 207.169)"
          fill="white"
        />
        <circle
          cx="207.34"
          cy="207.169"
          r="17.4104"
          transform="rotate(-100 207.34 207.169)"
          fill="url(#paint5_radial_9639_22536)"
          fillOpacity="0.3"
        />
      </mask>
      <g mask="url(#mask0_9639_22536)">
        <g filter="url(#filter3_f_9639_22536)">
          <circle
            cx="207.34"
            cy="207.169"
            r="17.4104"
            transform="rotate(-100 207.34 207.169)"
            stroke="white"
          />
        </g>
      </g>
      <defs>
        <filter
          id="filter0_f_9639_22536"
          x="24"
          y="24"
          width="366.692"
          height="366.692"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="BackgroundImageFix"
            result="shape"
          />
          <feGaussianBlur
            stdDeviation="55"
            result="effect1_foregroundBlur_9639_22536"
          />
        </filter>
        <filter
          id="filter1_d_9639_22536"
          x="76.1697"
          y="203.164"
          width="123.112"
          height="37.0952"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy="4" />
          <feGaussianBlur stdDeviation="2.5" />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0.203922 0 0 0 0 0.470588 0 0 0 0 0.988235 0 0 0 0.5 0"
          />
          <feBlend
            mode="normal"
            in2="BackgroundImageFix"
            result="effect1_dropShadow_9639_22536"
          />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect1_dropShadow_9639_22536"
            result="shape"
          />
        </filter>
        <filter
          id="filter2_ddddd_9639_22536"
          x="178.927"
          y="187.756"
          width="56.8266"
          height="74.8267"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0.533333 0 0 0 0 0.980392 0 0 0 0.9 0"
          />
          <feBlend
            mode="normal"
            in2="BackgroundImageFix"
            result="effect1_dropShadow_9639_22536"
          />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy="2" />
          <feGaussianBlur stdDeviation="2" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0.533333 0 0 0 0 0.980392 0 0 0 0.5 0"
          />
          <feBlend
            mode="normal"
            in2="effect1_dropShadow_9639_22536"
            result="effect2_dropShadow_9639_22536"
          />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy="7" />
          <feGaussianBlur stdDeviation="3.5" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0.533333 0 0 0 0 0.980392 0 0 0 0.3 0"
          />
          <feBlend
            mode="normal"
            in2="effect2_dropShadow_9639_22536"
            result="effect3_dropShadow_9639_22536"
          />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy="15" />
          <feGaussianBlur stdDeviation="4.5" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0.533333 0 0 0 0 0.980392 0 0 0 0.15 0"
          />
          <feBlend
            mode="normal"
            in2="effect3_dropShadow_9639_22536"
            result="effect4_dropShadow_9639_22536"
          />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy="27" />
          <feGaussianBlur stdDeviation="5.5" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0.533333 0 0 0 0 0.980392 0 0 0 0.12 0"
          />
          <feBlend
            mode="normal"
            in2="effect4_dropShadow_9639_22536"
            result="effect5_dropShadow_9639_22536"
          />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect5_dropShadow_9639_22536"
            result="shape"
          />
        </filter>
        <filter
          id="filter3_f_9639_22536"
          x="188.427"
          y="188.256"
          width="37.8268"
          height="37.8267"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="BackgroundImageFix"
            result="shape"
          />
          <feGaussianBlur
            stdDeviation="0.5"
            result="effect1_foregroundBlur_9639_22536"
          />
        </filter>
        <linearGradient
          id="paint0_linear_9639_22536"
          x1="194.281"
          y1="215.981"
          x2="190.201"
          y2="198.39"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0.0598112" stopColor="#333333" stopOpacity="0.5" />
          <stop offset="0.187826" stopColor="#0E0E0E" stopOpacity="0.7" />
          <stop offset="0.328032" stopColor="#0E0E0E" />
        </linearGradient>
        <radialGradient
          id="paint1_radial_9639_22536"
          cx="0"
          cy="0"
          r="1"
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(207.34 207.169) rotate(90) scale(17.4104)"
        >
          <stop stopColor="white" />
          <stop offset="0.578125" stopColor="white" />
          <stop offset="1" stopColor="#0A0422" />
        </radialGradient>
        <linearGradient
          id="paint2_linear_9639_22536"
          x1="199.932"
          y1="190.87"
          x2="206.97"
          y2="224.58"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0.177083" stopColor="white" />
          <stop offset="1" stopColor="white" stopOpacity="0" />
        </linearGradient>
        <linearGradient
          id="paint3_linear_9639_22536"
          x1="218.083"
          y1="192.722"
          x2="206.97"
          y2="224.58"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0.177083" stopColor="white" />
          <stop offset="1" stopColor="white" stopOpacity="0" />
        </linearGradient>
        <radialGradient
          id="paint4_radial_9639_22536"
          cx="0"
          cy="0"
          r="1"
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(207.711 198.649) rotate(90) scale(5.55652)"
        >
          <stop stopColor="white" />
          <stop offset="1" stopColor="white" stopOpacity="0" />
        </radialGradient>
        <radialGradient
          id="paint5_radial_9639_22536"
          cx="0"
          cy="0"
          r="1"
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(207.34 207.169) rotate(90) scale(17.4104)"
        >
          <stop stopColor="white" />
          <stop offset="0.578125" stopColor="white" />
          <stop offset="1" stopColor="#0A0422" />
        </radialGradient>
      </defs>
    </svg>
  );
}
export function TickCircleIcon({ color }) {
  return (
    <svg
      width="1.389vw"
      height="1.389vw"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M10.0003 1.66667C5.40866 1.66667 1.66699 5.40833 1.66699 10C1.66699 14.5917 5.40866 18.3333 10.0003 18.3333C14.592 18.3333 18.3337 14.5917 18.3337 10C18.3337 5.40833 14.592 1.66667 10.0003 1.66667ZM13.9837 8.08333L9.25866 12.8083C9.14199 12.925 8.98366 12.9917 8.81699 12.9917C8.65033 12.9917 8.49199 12.925 8.37533 12.8083L6.01699 10.45C5.77533 10.2083 5.77533 9.80833 6.01699 9.56667C6.25866 9.325 6.65866 9.325 6.90033 9.56667L8.81699 11.4833L13.1003 7.2C13.342 6.95833 13.742 6.95833 13.9837 7.2C14.2253 7.44167 14.2253 7.83333 13.9837 8.08333Z"
        fill={color !== '' ? color : '#C9C9C9'}
      />
    </svg>
  );
}
TickCircleIcon.propTypes = {
  color: PropTypes.string,
};
TickCircleIcon.defaultProps = {
  color: '',
};

export function WebhookIcon() {
  return (
    <svg
      width="1.667vw"
      height="1.667vw"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_8548_71270)">
        <path
          d="M11.2067 10.2265C10.212 11.8915 9.25903 13.5037 8.28619 15.1039C8.03635 15.5147 7.91269 15.8493 8.11228 16.3715C8.66335 17.8141 7.88597 19.2179 6.42497 19.5989C5.04713 19.9584 3.70472 19.0568 3.43135 17.588C3.1891 16.288 4.20235 15.0135 5.64197 14.8103C5.76253 14.7931 5.88572 14.7912 6.08841 14.776L8.27822 11.1199C6.90094 9.75626 6.08119 8.16237 6.2626 6.18717C6.39085 4.79099 6.94228 3.5844 7.9501 2.59549C9.88041 0.701688 12.8253 0.395047 15.0982 1.84863C17.281 3.2449 18.2808 5.96463 17.4286 8.2924C16.786 8.11897 16.139 7.94404 15.4277 7.75193C15.6953 6.45769 15.4973 5.29553 14.6207 4.2999C14.0415 3.64256 13.2983 3.29802 12.4532 3.17107C10.7589 2.91623 9.09553 3.99998 8.60194 5.65575C8.04169 7.53481 8.88966 9.06979 11.2067 10.2265Z"
          fill="#C73A63"
        />
        <path
          d="M14.0475 8.25755C14.7483 9.4885 15.4599 10.738 16.165 11.9761C19.7294 10.8781 22.4169 12.8427 23.381 14.9461C24.5455 17.4869 23.7494 20.4961 21.4624 22.0637C19.1149 23.6728 16.1461 23.3979 14.0663 21.3309C14.5963 20.889 15.129 20.4453 15.6982 19.9712C17.7524 21.2959 19.5491 21.2336 20.883 19.6648C22.0205 18.3265 21.9958 16.331 20.8254 15.0208C19.4746 13.5089 17.6653 13.4628 15.4783 14.9141C14.5711 13.3116 13.6481 11.7218 12.7696 10.1077C12.4734 9.56365 12.1464 9.24795 11.4787 9.13285C10.3637 8.94037 9.64389 7.98703 9.60067 6.91896C9.5582 5.86266 10.1832 4.90782 11.1601 4.53584C12.1278 4.16722 13.2634 4.46471 13.9143 5.28391C14.4462 5.95321 14.6153 6.70651 14.3353 7.53197C14.2575 7.76216 14.1567 7.98479 14.0475 8.25755Z"
          fill="#4B4B4B"
        />
        <path
          d="M15.7224 18.3205H11.4315C11.0202 20.0048 10.1318 21.3647 8.60118 22.2294C7.41122 22.9015 6.12872 23.1294 4.76372 22.9099C2.25047 22.5064 0.195465 20.2537 0.0145279 17.7171C-0.190222 14.8435 1.79343 12.2893 4.43747 11.7156C4.62 12.3756 4.8045 13.042 4.98703 13.7005C2.56115 14.9328 1.72153 16.4856 2.40047 18.4272C2.99812 20.1358 4.69584 21.0723 6.53925 20.7101C8.42175 20.3403 9.37087 18.7825 9.255 16.2825C11.0396 16.2825 12.8257 16.2641 14.6106 16.2916C15.3075 16.3025 15.8455 16.2305 16.3705 15.6187C17.2349 14.6121 18.8259 14.7029 19.7569 15.6537C20.7082 16.6253 20.6627 18.1887 19.6559 19.1193C18.6846 20.0173 17.15 19.9693 16.2412 19.0017C16.0544 18.8023 15.9072 18.5655 15.7224 18.3205Z"
          fill="#4A4A4A"
        />
      </g>
      <defs>
        <clipPath id="clip0_8548_71270">
          <rect
            width="24"
            height="22.3099"
            fill="white"
            transform="translate(0 0.844971)"
          />
        </clipPath>
      </defs>
    </svg>
  );
}
export function SelectProductIcon({ width, height, color }) {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M22 9.75C21.59 9.75 21.25 9.41 21.25 9V7C21.25 4.42 19.58 2.75 17 2.75H7C4.42 2.75 2.75 4.42 2.75 7V9C2.75 9.41 2.41 9.75 2 9.75C1.59 9.75 1.25 9.41 1.25 9V7C1.25 3.56 3.56 1.25 7 1.25H17C20.44 1.25 22.75 3.56 22.75 7V9C22.75 9.41 22.41 9.75 22 9.75Z"
        fill={color}
      />
      <path
        d="M17 22.75H7C3.56 22.75 1.25 20.44 1.25 17V15C1.25 14.59 1.59 14.25 2 14.25C2.41 14.25 2.75 14.59 2.75 15V17C2.75 19.58 4.42 21.25 7 21.25H17C19.58 21.25 21.25 19.58 21.25 17V15C21.25 14.59 21.59 14.25 22 14.25C22.41 14.25 22.75 14.59 22.75 15V17C22.75 20.44 20.44 22.75 17 22.75Z"
        fill={color}
      />
      <path
        d="M12.0001 13.079C11.8701 13.079 11.7401 13.0489 11.6201 12.9789L6.32011 9.91894C5.96011 9.70894 5.84011 9.24897 6.05011 8.88897C6.26011 8.52897 6.72011 8.40895 7.07011 8.61895L11.9901 11.4689L16.8801 8.63897C17.2401 8.42897 17.7001 8.55893 17.9001 8.90893C18.1101 9.26893 17.9801 9.72896 17.6301 9.93896L12.3701 12.9789C12.2601 13.0389 12.1301 13.079 12.0001 13.079Z"
        fill={color}
      />
      <path
        d="M12 18.5181C11.59 18.5181 11.25 18.1781 11.25 17.7681V12.3281C11.25 11.9181 11.59 11.5781 12 11.5781C12.41 11.5781 12.75 11.9181 12.75 12.3281V17.7681C12.75 18.1781 12.41 18.5181 12 18.5181Z"
        fill={color}
      />
      <path
        d="M12.0002 18.7469C11.4202 18.7469 10.8502 18.6169 10.3902 18.3669L7.19023 16.5869C6.23023 16.0569 5.49023 14.7869 5.49023 13.6869V10.2969C5.49023 9.20687 6.24023 7.9369 7.19023 7.3969L10.3902 5.61687C11.3102 5.10688 12.6902 5.10688 13.6102 5.61687L16.8102 7.3969C17.7702 7.9269 18.5102 9.19687 18.5102 10.2969V13.6869C18.5102 14.7769 17.7602 16.0469 16.8102 16.5869L13.6102 18.3669C13.1502 18.6169 12.5802 18.7469 12.0002 18.7469ZM11.1202 6.93688L7.92023 8.71685C7.43023 8.98685 6.99023 9.74687 6.99023 10.2969V13.6869C6.99023 14.2469 7.43023 14.9969 7.92023 15.2669L11.1202 17.0469C11.5802 17.2969 12.4202 17.2969 12.8802 17.0469L16.0802 15.2669C16.5702 14.9969 17.0102 14.2369 17.0102 13.6869V10.2969C17.0102 9.73687 16.5702 8.98685 16.0802 8.71685L12.8802 6.93688C12.4202 6.68688 11.5802 6.68688 11.1202 6.93688Z"
        fill={color}
      />
    </svg>
  );
}
SelectProductIcon.propTypes = {
  width: PropTypes.string,
  height: PropTypes.string,
  color: PropTypes.string,
};
SelectProductIcon.defaultProps = {
  width: '1.667vw',
  height: '1.667vw',
  color: 'white',
};
export function AddPackageDetailsIcon() {
  return (
    <svg
      width="25"
      height="24"
      viewBox="0 0 25 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M12.7501 13.3008C12.6201 13.3008 12.4901 13.2708 12.3701 13.2008L3.54008 8.09083C3.19008 7.88083 3.06008 7.42083 3.27008 7.06083C3.48008 6.70083 3.94008 6.58083 4.30008 6.79083L12.7501 11.6808L21.1501 6.82083C21.5101 6.61083 21.9701 6.74083 22.1801 7.09083C22.3901 7.45083 22.2601 7.91083 21.9101 8.12083L13.1401 13.2008C13.0101 13.2608 12.8801 13.3008 12.7501 13.3008Z"
        fill="#395C85"
      />
      <path
        d="M12.75 22.3591C12.34 22.3591 12 22.0191 12 21.6091V12.5391C12 12.1291 12.34 11.7891 12.75 11.7891C13.16 11.7891 13.5 12.1291 13.5 12.5391V21.6091C13.5 22.0191 13.16 22.3591 12.75 22.3591Z"
        fill="#395C85"
      />
      <path
        d="M12.7499 22.75C11.8699 22.75 10.9999 22.56 10.3099 22.18L4.96989 19.21C3.51989 18.41 2.38989 16.48 2.38989 14.82V9.17C2.38989 7.51 3.51989 5.59 4.96989 4.78L10.3099 1.82C11.6799 1.06 13.8199 1.06 15.1899 1.82L20.5299 4.79C21.9799 5.59 23.1099 7.52 23.1099 9.18V14.83C23.1099 16.49 21.9799 18.41 20.5299 19.22L15.1899 22.18C14.4999 22.56 13.6299 22.75 12.7499 22.75ZM12.7499 2.75C12.1199 2.75 11.4999 2.88 11.0399 3.13L5.69989 6.1C4.73989 6.63 3.88989 8.07 3.88989 9.17V14.82C3.88989 15.92 4.73989 17.36 5.69989 17.9L11.0399 20.87C11.9499 21.38 13.5499 21.38 14.4599 20.87L19.7999 17.9C20.7599 17.36 21.6099 15.93 21.6099 14.82V9.17C21.6099 8.07 20.7599 6.63 19.7999 6.09L14.4599 3.12C13.9999 2.88 13.3799 2.75 12.7499 2.75Z"
        fill="#395C85"
      />
    </svg>
  );
}
export function AddDocumantsIcon() {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M13.5 9.25H2C1.59 9.25 1.25 8.91 1.25 8.5C1.25 8.09 1.59 7.75 2 7.75H13.5C13.91 7.75 14.25 8.09 14.25 8.5C14.25 8.91 13.91 9.25 13.5 9.25Z"
        fill="#395C85"
      />
      <path
        d="M8 17.25H6C5.59 17.25 5.25 16.91 5.25 16.5C5.25 16.09 5.59 15.75 6 15.75H8C8.41 15.75 8.75 16.09 8.75 16.5C8.75 16.91 8.41 17.25 8 17.25Z"
        fill="#395C85"
      />
      <path
        d="M14.5 17.25H10.5C10.09 17.25 9.75 16.91 9.75 16.5C9.75 16.09 10.09 15.75 10.5 15.75H14.5C14.91 15.75 15.25 16.09 15.25 16.5C15.25 16.91 14.91 17.25 14.5 17.25Z"
        fill="#395C85"
      />
      <path
        d="M17.56 21.25H6.44C2.46 21.25 1.25 20.05 1.25 16.11V7.89C1.25 3.95 2.46 2.75 6.44 2.75H13.5C13.91 2.75 14.25 3.09 14.25 3.5C14.25 3.91 13.91 4.25 13.5 4.25H6.44C3.3 4.25 2.75 4.79 2.75 7.89V16.1C2.75 19.2 3.3 19.74 6.44 19.74H17.55C20.69 19.74 21.24 19.2 21.24 16.1V11.02C21.24 10.61 21.58 10.27 21.99 10.27C22.4 10.27 22.74 10.61 22.74 11.02V16.1C22.75 20.05 21.54 21.25 17.56 21.25Z"
        fill="#395C85"
      />
      <path
        d="M17.9999 8.2475C17.8099 8.2475 17.6199 8.1775 17.4699 8.0275L15.9699 6.5275C15.6799 6.2375 15.6799 5.7575 15.9699 5.4675C16.2599 5.1775 16.7399 5.1775 17.0299 5.4675L17.9999 6.4375L21.4699 2.9675C21.7599 2.6775 22.2399 2.6775 22.5299 2.9675C22.8199 3.2575 22.8199 3.7375 22.5299 4.0275L18.5299 8.0275C18.3799 8.1775 18.1899 8.2475 17.9999 8.2475Z"
        fill="#395C85"
      />
    </svg>
  );
}
export function ArrowBlueDownIcon() {
  return (
    <svg
      width="15"
      height="0.972vw"
      viewBox="0 0 15 14"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M3.52135 8.42042C3.52135 8.30958 3.56219 8.19875 3.64969 8.11125C3.81885 7.94208 4.09885 7.94208 4.26802 8.11125L7.49969 11.3429L10.7314 8.11125C10.9005 7.94208 11.1805 7.94208 11.3497 8.11125C11.5189 8.28042 11.5189 8.56042 11.3497 8.72958L7.80885 12.2704C7.63969 12.4396 7.35969 12.4396 7.19052 12.2704L3.64969 8.72958C3.56219 8.64208 3.52135 8.53125 3.52135 8.42042Z"
        fill="#0088FA"
      />
      <path
        d="M7.0625 11.8566L7.0625 2.03906C7.0625 1.7999 7.26083 1.60156 7.5 1.60156C7.73917 1.60156 7.9375 1.7999 7.9375 2.03906L7.9375 11.8566C7.9375 12.0957 7.73917 12.2941 7.5 12.2941C7.26083 12.2941 7.0625 12.0957 7.0625 11.8566Z"
        fill="#0088FA"
      />
    </svg>
  );
}
export function BorderedBoxIcon() {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M15 22.75H9C3.57 22.75 1.25 20.43 1.25 15V9C1.25 3.57 3.57 1.25 9 1.25H15C20.43 1.25 22.75 3.57 22.75 9V15C22.75 20.43 20.43 22.75 15 22.75ZM9 2.75C4.39 2.75 2.75 4.39 2.75 9V15C2.75 19.61 4.39 21.25 9 21.25H15C19.61 21.25 21.25 19.61 21.25 15V9C21.25 4.39 19.61 2.75 15 2.75H9Z"
        fill="#395C85"
      />
      <path
        d="M12.0001 13.0768C11.8701 13.0768 11.7401 13.0468 11.6201 12.9768L6.32013 9.91677C5.96013 9.70677 5.84011 9.24677 6.05011 8.89677C6.26011 8.53677 6.72013 8.41677 7.07013 8.62677L11.9901 11.4768L16.8801 8.64677C17.2401 8.43677 17.7001 8.56677 17.9001 8.91677C18.1001 9.26677 17.9801 9.73677 17.6301 9.93677L12.3701 12.9768C12.2601 13.0368 12.1301 13.0768 12.0001 13.0768Z"
        fill="#395C85"
      />
      <path
        d="M12 18.5181C11.59 18.5181 11.25 18.1781 11.25 17.7681V12.3281C11.25 11.9181 11.59 11.5781 12 11.5781C12.41 11.5781 12.75 11.9181 12.75 12.3281V17.7681C12.75 18.1781 12.41 18.5181 12 18.5181Z"
        fill="#395C85"
      />
      <path
        d="M12.0002 18.7469C11.4202 18.7469 10.8503 18.6169 10.3903 18.3669L7.19025 16.5869C6.23025 16.0569 5.49023 14.7869 5.49023 13.6869V10.2969C5.49023 9.20688 6.24025 7.93687 7.19025 7.39687L10.3903 5.61687C11.3103 5.10688 12.6902 5.10688 13.6102 5.61687L16.8102 7.39687C17.7702 7.92687 18.5103 9.19688 18.5103 10.2969V13.6869C18.5103 14.7769 17.7602 16.0469 16.8102 16.5869L13.6102 18.3669C13.1502 18.6269 12.5802 18.7469 12.0002 18.7469ZM12.0002 6.74687C11.6702 6.74687 11.3502 6.80687 11.1202 6.93687L7.92026 8.71687C7.43026 8.98687 6.99023 9.74688 6.99023 10.2969V13.6869C6.99023 14.2469 7.43026 14.9969 7.92026 15.2669L11.1202 17.0469C11.5802 17.3069 12.4202 17.3069 12.8802 17.0469L16.0802 15.2669C16.5702 14.9969 17.0103 14.2369 17.0103 13.6869V10.2969C17.0103 9.73688 16.5702 8.98687 16.0802 8.71687L12.8802 6.93687C12.6502 6.80687 12.3302 6.74687 12.0002 6.74687Z"
        fill="#395C85"
      />
    </svg>
  );
}
export function ProductDetailsIcon() {
  return (
    <svg
      width="25"
      height="24"
      viewBox="0 0 25 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M12.7506 13.3C12.6206 13.3 12.4906 13.27 12.3706 13.2L3.54057 8.08998C3.19057 7.87998 3.06057 7.41998 3.27057 7.05998C3.48057 6.69998 3.94057 6.57998 4.30057 6.78998L12.7506 11.68L21.1506 6.81998C21.5106 6.60998 21.9706 6.73998 22.1806 7.08998C22.3906 7.44998 22.2606 7.90998 21.9106 8.11998L13.1406 13.2C13.0106 13.26 12.8806 13.3 12.7506 13.3Z"
        fill="white"
      />
      <path
        d="M12.7505 22.36C12.3405 22.36 12.0005 22.02 12.0005 21.61V12.54C12.0005 12.13 12.3405 11.79 12.7505 11.79C13.1605 11.79 13.5005 12.13 13.5005 12.54V21.61C13.5005 22.02 13.1605 22.36 12.7505 22.36Z"
        fill="white"
      />
      <path
        d="M12.7504 22.75C11.8704 22.75 11.0004 22.56 10.3104 22.18L4.97038 19.21C3.52038 18.41 2.39038 16.48 2.39038 14.82V9.17C2.39038 7.51 3.52038 5.59 4.97038 4.78L10.3104 1.82C11.6804 1.06 13.8204 1.06 15.1904 1.82L20.5304 4.79C21.9804 5.59 23.1104 7.52 23.1104 9.18V14.83C23.1104 16.49 21.9804 18.41 20.5304 19.22L15.1904 22.18C14.5004 22.56 13.6304 22.75 12.7504 22.75ZM12.7504 2.75C12.1204 2.75 11.5004 2.88 11.0404 3.13L5.70038 6.1C4.74038 6.63 3.89038 8.07 3.89038 9.17V14.82C3.89038 15.92 4.74038 17.36 5.70038 17.9L11.0404 20.87C11.9504 21.38 13.5504 21.38 14.4604 20.87L19.8004 17.9C20.7604 17.36 21.6104 15.93 21.6104 14.82V9.17C21.6104 8.07 20.7604 6.63 19.8004 6.09L14.4604 3.12C14.0004 2.88 13.3804 2.75 12.7504 2.75Z"
        fill="white"
      />
    </svg>
  );
}
export function BookingDetailsIcon() {
  return (
    <svg
      width="25"
      height="24"
      viewBox="0 0 25 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M15.5 22.75H9.5C4.07 22.75 1.75 20.43 1.75 15V9C1.75 3.57 4.07 1.25 9.5 1.25H15.5C20.93 1.25 23.25 3.57 23.25 9V15C23.25 20.43 20.93 22.75 15.5 22.75ZM9.5 2.75C4.89 2.75 3.25 4.39 3.25 9V15C3.25 19.61 4.89 21.25 9.5 21.25H15.5C20.11 21.25 21.75 19.61 21.75 15V9C21.75 4.39 20.11 2.75 15.5 2.75H9.5Z"
        fill="white"
      />
      <path
        d="M12.5001 13.0768C12.3701 13.0768 12.2401 13.0468 12.1201 12.9768L6.82013 9.91677C6.46013 9.70677 6.34011 9.24677 6.55011 8.89677C6.76011 8.53677 7.22013 8.41677 7.57013 8.62677L12.4901 11.4768L17.3801 8.64677C17.7401 8.43677 18.2001 8.56677 18.4001 8.91677C18.6001 9.26677 18.4801 9.73677 18.1301 9.93677L12.8701 12.9768C12.7601 13.0368 12.6301 13.0768 12.5001 13.0768Z"
        fill="white"
      />
      <path
        d="M12.5 18.5181C12.09 18.5181 11.75 18.1781 11.75 17.7681V12.3281C11.75 11.9181 12.09 11.5781 12.5 11.5781C12.91 11.5781 13.25 11.9181 13.25 12.3281V17.7681C13.25 18.1781 12.91 18.5181 12.5 18.5181Z"
        fill="white"
      />
      <path
        d="M12.5002 18.7469C11.9202 18.7469 11.3503 18.6169 10.8903 18.3669L7.69025 16.5869C6.73025 16.0569 5.99023 14.7869 5.99023 13.6869V10.2969C5.99023 9.20688 6.74025 7.93687 7.69025 7.39687L10.8903 5.61687C11.8103 5.10688 13.1902 5.10688 14.1102 5.61687L17.3102 7.39687C18.2702 7.92687 19.0103 9.19688 19.0103 10.2969V13.6869C19.0103 14.7769 18.2602 16.0469 17.3102 16.5869L14.1102 18.3669C13.6502 18.6269 13.0802 18.7469 12.5002 18.7469ZM12.5002 6.74687C12.1702 6.74687 11.8502 6.80687 11.6202 6.93687L8.42026 8.71687C7.93026 8.98687 7.49023 9.74688 7.49023 10.2969V13.6869C7.49023 14.2469 7.93026 14.9969 8.42026 15.2669L11.6202 17.0469C12.0802 17.3069 12.9202 17.3069 13.3802 17.0469L16.5802 15.2669C17.0702 14.9969 17.5103 14.2369 17.5103 13.6869V10.2969C17.5103 9.73688 17.0702 8.98687 16.5802 8.71687L13.3802 6.93687C13.1502 6.80687 12.8302 6.74687 12.5002 6.74687Z"
        fill="white"
      />
    </svg>
  );
}
export function BagTickIcon() {
  return (
    <svg
      width="1.111vw"
      height="17"
      viewBox="0 0 16 17"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M8.00016 13.6693C6.2535 13.6693 4.8335 12.2493 4.8335 10.5026C4.8335 8.75594 6.2535 7.33594 8.00016 7.33594C9.74683 7.33594 11.1668 8.75594 11.1668 10.5026C11.1668 12.2493 9.74683 13.6693 8.00016 13.6693ZM8.00016 8.33594C6.80683 8.33594 5.8335 9.30927 5.8335 10.5026C5.8335 11.6959 6.80683 12.6693 8.00016 12.6693C9.1935 12.6693 10.1668 11.6959 10.1668 10.5026C10.1668 9.30927 9.1935 8.33594 8.00016 8.33594Z"
        fill="#0088FA"
      />
      <path
        d="M7.62643 11.5291C7.41309 11.5291 7.19976 11.4491 7.03976 11.2825L6.60643 10.8491C6.41309 10.6558 6.41309 10.3358 6.60643 10.1425C6.79976 9.94914 7.11976 9.94914 7.31309 10.1425L7.63309 10.4625L8.70643 9.4758C8.90643 9.28914 9.22643 9.30247 9.41309 9.50247C9.59976 9.70247 9.58643 10.0225 9.38643 10.2091L8.19976 11.3025C8.03309 11.4558 7.82643 11.5291 7.62643 11.5291Z"
        fill="#0088FA"
      />
      <path
        d="M9.99988 15.6693H5.99988C2.91988 15.6693 2.34655 14.2359 2.19988 12.8426L1.69988 8.84927C1.62655 8.12927 1.59988 7.09594 2.29988 6.3226C2.89988 5.65594 3.89321 5.33594 5.33321 5.33594H10.6665C12.1132 5.33594 13.1065 5.6626 13.6999 6.3226C14.3932 7.09594 14.3732 8.12927 14.2999 8.83594L13.7999 12.8426C13.6532 14.2359 13.0799 15.6693 9.99988 15.6693ZM5.33321 6.33594C4.20655 6.33594 3.43321 6.55594 3.03988 6.99594C2.71321 7.35594 2.60655 7.90927 2.69321 8.73594L3.19321 12.7293C3.30655 13.7959 3.59988 14.6759 5.99988 14.6759H9.99988C12.3999 14.6759 12.6932 13.8026 12.8065 12.7426L13.3065 8.73594C13.3932 7.9226 13.2865 7.36927 12.9599 7.0026C12.5665 6.55594 11.7932 6.33594 10.6665 6.33594H5.33321Z"
        fill="#0088FA"
      />
      <path
        d="M11 6.25093C10.7267 6.25093 10.5 6.02426 10.5 5.75093V4.83093C10.5 4.13093 10.2 3.45093 9.68 2.9776C9.15333 2.4976 8.46667 2.2776 7.75333 2.34426C6.55333 2.4576 5.5 3.68426 5.5 4.96426V5.61093C5.5 5.88426 5.27333 6.11093 5 6.11093C4.72667 6.11093 4.5 5.88426 4.5 5.61093V4.95759C4.5 3.16426 5.94667 1.51093 7.66 1.34426C8.66 1.25093 9.62 1.56426 10.3533 2.2376C11.08 2.8976 11.5 3.84426 11.5 4.83093V5.75093C11.5 6.02426 11.2733 6.25093 11 6.25093Z"
        fill="#0088FA"
      />
    </svg>
  );
}
export function ShipmentIcon({ size, color }) {
  return (
    <svg
      width={size !== '' ? size : '24'}
      height={size !== '' ? size : '24'}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M13 14.75H2C1.59 14.75 1.25 14.41 1.25 14V6C1.25 3.38 3.38 1.25 6 1.25H15C15.41 1.25 15.75 1.59 15.75 2V12C15.75 13.52 14.52 14.75 13 14.75ZM2.75 13.25H13C13.69 13.25 14.25 12.69 14.25 12V2.75H6C4.21 2.75 2.75 4.21 2.75 6V13.25Z"
        fill={color !== '' ? color : '#395C85'}
      />
      <path
        d="M19 20.75H18C17.59 20.75 17.25 20.41 17.25 20C17.25 19.31 16.69 18.75 16 18.75C15.31 18.75 14.75 19.31 14.75 20C14.75 20.41 14.41 20.75 14 20.75H10C9.59 20.75 9.25 20.41 9.25 20C9.25 19.31 8.69 18.75 8 18.75C7.31 18.75 6.75 19.31 6.75 20C6.75 20.41 6.41 20.75 6 20.75H5C2.93 20.75 1.25 19.07 1.25 17V14C1.25 13.59 1.59 13.25 2 13.25H13C13.69 13.25 14.25 12.69 14.25 12V5C14.25 4.59 14.59 4.25 15 4.25H16.84C17.83 4.25 18.74 4.78001 19.23 5.64001L20.94 8.63C21.07 8.86 21.07 9.15 20.94 9.38C20.81 9.61 20.56 9.75 20.29 9.75H19C18.86 9.75 18.75 9.86 18.75 10V13C18.75 13.14 18.86 13.25 19 13.25H22C22.41 13.25 22.75 13.59 22.75 14V17C22.75 19.07 21.07 20.75 19 20.75ZM18.65 19.25H19C20.24 19.25 21.25 18.24 21.25 17V14.75H19C18.04 14.75 17.25 13.96 17.25 13V10C17.25 9.04 18.03 8.25 19 8.25L17.93 6.38C17.71 5.99 17.29 5.75 16.84 5.75H15.75V12C15.75 13.52 14.52 14.75 13 14.75H2.75V17C2.75 18.24 3.76 19.25 5 19.25H5.35001C5.68001 18.1 6.74 17.25 8 17.25C9.26 17.25 10.32 18.1 10.65 19.25H13.36C13.69 18.1 14.75 17.25 16.01 17.25C17.27 17.25 18.32 18.1 18.65 19.25Z"
        fill={color !== '' ? color : '#395C85'}
      />
      <path
        d="M8 22.75C6.48 22.75 5.25 21.52 5.25 20C5.25 18.48 6.48 17.25 8 17.25C9.52 17.25 10.75 18.48 10.75 20C10.75 21.52 9.52 22.75 8 22.75ZM8 18.75C7.31 18.75 6.75 19.31 6.75 20C6.75 20.69 7.31 21.25 8 21.25C8.69 21.25 9.25 20.69 9.25 20C9.25 19.31 8.69 18.75 8 18.75Z"
        fill={color !== '' ? color : '#395C85'}
      />
      <path
        d="M16 22.75C14.48 22.75 13.25 21.52 13.25 20C13.25 18.48 14.48 17.25 16 17.25C17.52 17.25 18.75 18.48 18.75 20C18.75 21.52 17.52 22.75 16 22.75ZM16 18.75C15.31 18.75 14.75 19.31 14.75 20C14.75 20.69 15.31 21.25 16 21.25C16.69 21.25 17.25 20.69 17.25 20C17.25 19.31 16.69 18.75 16 18.75Z"
        fill={color !== '' ? color : '#395C85'}
      />
      <path
        d="M22 14.75H19C18.04 14.75 17.25 13.96 17.25 13V10C17.25 9.04 18.04 8.25 19 8.25H20.29C20.56 8.25 20.81 8.39 20.94 8.63L22.65 11.63C22.71 11.74 22.75 11.87 22.75 12V14C22.75 14.41 22.41 14.75 22 14.75ZM19 9.75C18.86 9.75 18.75 9.86 18.75 10V13C18.75 13.14 18.86 13.25 19 13.25H21.25V12.2L19.85 9.75H19Z"
        fill={color !== '' ? color : '#395C85'}
      />
    </svg>
  );
}
ShipmentIcon.propTypes = {
  color: PropTypes.string,
  size: PropTypes.string,
};
ShipmentIcon.defaultProps = {
  color: '',
  size: '',
};
export function AddForwarderIcon({ size, color }) {
  return (
    <svg
      width={size !== '' ? size : '24'}
      height={size !== '' ? size : '24'}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M12.9998 14.75H11.9998C11.5898 14.75 11.2498 14.41 11.2498 14C11.2498 13.59 11.5898 13.25 11.9998 13.25H12.9998C13.6898 13.25 14.2498 12.69 14.2498 12V2.75H5.99978C4.81978 2.75 3.73975 3.38998 3.15975 4.41998C2.95975 4.77998 2.49979 4.91002 2.13979 4.71002C1.77979 4.51002 1.64975 4.05 1.84975 3.69C2.68975 2.19 4.27978 1.25 5.99978 1.25H14.9998C15.4098 1.25 15.7498 1.59 15.7498 2V12C15.7498 13.52 14.5198 14.75 12.9998 14.75Z"
        fill={color !== '' ? color : 'white'}
      />
      <path
        d="M19 20.75H18C17.59 20.75 17.25 20.41 17.25 20C17.25 19.31 16.69 18.75 16 18.75C15.31 18.75 14.75 19.31 14.75 20C14.75 20.41 14.41 20.75 14 20.75H10C9.59 20.75 9.25 20.41 9.25 20C9.25 19.31 8.69 18.75 8 18.75C7.31 18.75 6.75 19.31 6.75 20C6.75 20.41 6.41 20.75 6 20.75H5C2.93 20.75 1.25 19.07 1.25 17C1.25 16.59 1.59 16.25 2 16.25C2.41 16.25 2.75 16.59 2.75 17C2.75 18.24 3.76 19.25 5 19.25H5.34998C5.67998 18.1 6.74 17.25 8 17.25C9.26 17.25 10.32 18.1 10.65 19.25H13.36C13.69 18.1 14.75 17.25 16.01 17.25C17.27 17.25 18.33 18.1 18.66 19.25H19C20.24 19.25 21.25 18.24 21.25 17V14.75H19C18.04 14.75 17.25 13.96 17.25 13V10C17.25 9.04 18.03 8.25 19 8.25L17.93 6.38C17.71 5.99 17.29 5.75 16.84 5.75H15.75V12C15.75 13.52 14.52 14.75 13 14.75H12C11.59 14.75 11.25 14.41 11.25 14C11.25 13.59 11.59 13.25 12 13.25H13C13.69 13.25 14.25 12.69 14.25 12V5C14.25 4.59 14.59 4.25 15 4.25H16.84C17.83 4.25 18.74 4.78001 19.23 5.64001L20.94 8.63C21.07 8.86 21.07 9.15 20.94 9.38C20.81 9.61 20.56 9.75 20.29 9.75H19C18.86 9.75 18.75 9.86 18.75 10V13C18.75 13.14 18.86 13.25 19 13.25H22C22.41 13.25 22.75 13.59 22.75 14V17C22.75 19.07 21.07 20.75 19 20.75Z"
        fill={color !== '' ? color : 'white'}
      />
      <path
        d="M8 22.75C6.48 22.75 5.25 21.52 5.25 20C5.25 18.48 6.48 17.25 8 17.25C9.52 17.25 10.75 18.48 10.75 20C10.75 21.52 9.52 22.75 8 22.75ZM8 18.75C7.31 18.75 6.75 19.31 6.75 20C6.75 20.69 7.31 21.25 8 21.25C8.69 21.25 9.25 20.69 9.25 20C9.25 19.31 8.69 18.75 8 18.75Z"
        fill={color !== '' ? color : 'white'}
      />
      <path
        d="M16 22.75C14.48 22.75 13.25 21.52 13.25 20C13.25 18.48 14.48 17.25 16 17.25C17.52 17.25 18.75 18.48 18.75 20C18.75 21.52 17.52 22.75 16 22.75ZM16 18.75C15.31 18.75 14.75 19.31 14.75 20C14.75 20.69 15.31 21.25 16 21.25C16.69 21.25 17.25 20.69 17.25 20C17.25 19.31 16.69 18.75 16 18.75Z"
        fill={color !== '' ? color : 'white'}
      />
      <path
        d="M22 14.75H19C18.04 14.75 17.25 13.96 17.25 13V10C17.25 9.04 18.04 8.25 19 8.25H20.29C20.56 8.25 20.81 8.39 20.94 8.63L22.65 11.63C22.71 11.74 22.75 11.87 22.75 12V14C22.75 14.41 22.41 14.75 22 14.75ZM19 9.75C18.86 9.75 18.75 9.86 18.75 10V13C18.75 13.14 18.86 13.25 19 13.25H21.25V12.2L19.85 9.75H19Z"
        fill={color !== '' ? color : 'white'}
      />
      <path
        d="M8 8.75H2C1.59 8.75 1.25 8.41 1.25 8C1.25 7.59 1.59 7.25 2 7.25H8C8.41 7.25 8.75 7.59 8.75 8C8.75 8.41 8.41 8.75 8 8.75Z"
        fill={color !== '' ? color : 'white'}
      />
      <path
        d="M6 11.75H2C1.59 11.75 1.25 11.41 1.25 11C1.25 10.59 1.59 10.25 2 10.25H6C6.41 10.25 6.75 10.59 6.75 11C6.75 11.41 6.41 11.75 6 11.75Z"
        fill={color !== '' ? color : 'white'}
      />
      <path
        d="M4 14.75H2C1.59 14.75 1.25 14.41 1.25 14C1.25 13.59 1.59 13.25 2 13.25H4C4.41 13.25 4.75 13.59 4.75 14C4.75 14.41 4.41 14.75 4 14.75Z"
        fill={color !== '' ? color : 'white'}
      />
    </svg>
  );
}
AddForwarderIcon.propTypes = {
  color: PropTypes.string,
  size: PropTypes.string,
};
AddForwarderIcon.defaultProps = {
  color: '',
  size: '',
};
export function TruckTime({ size, color }) {
  return (
    <svg
      width={size !== '' ? size : '24'}
      height={size !== '' ? size : '24'}
      viewBox="0 0 14 15"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M7.58317 9.10543H1.1665C0.927337 9.10543 0.729004 8.9071 0.729004 8.66793V4.94626C0.729004 4.75959 0.845665 4.59625 1.01483 4.53208C1.18983 4.46791 1.38234 4.52043 1.49901 4.66043C1.85484 5.08626 2.40901 5.32542 2.95734 5.30792C3.42401 5.29626 3.85566 5.12127 4.18233 4.8121C4.33399 4.68377 4.4565 4.53209 4.54983 4.36293C4.73066 4.05376 4.81817 3.71542 4.81234 3.37125C4.80067 2.83458 4.56735 2.34459 4.17068 1.98875C4.03068 1.86625 3.98401 1.67374 4.04817 1.50458C4.11234 1.33541 4.27568 1.21875 4.45651 1.21875H8.74984C8.989 1.21875 9.18734 1.41708 9.18734 1.65625V7.48958C9.18734 8.38792 8.46984 9.10543 7.58317 9.10543ZM1.604 8.23043H7.58317C7.98567 8.23043 8.31234 7.90376 8.31234 7.50126V2.10543H5.36067C5.56484 2.48459 5.67567 2.91044 5.68734 3.35377C5.699 3.86127 5.57066 4.36293 5.314 4.80043C5.174 5.05126 4.9815 5.29043 4.7715 5.46543C4.30483 5.90877 3.66316 6.17126 2.98066 6.18876C2.49066 6.20626 2.01818 6.08376 1.60984 5.8621V8.23043H1.604Z"
        fill={color !== '' ? color : '#616B80'}
      />
      <path
        d="M11.0832 12.6016H10.4998C10.2607 12.6016 10.0623 12.4032 10.0623 12.1641C10.0623 11.7616 9.73567 11.4349 9.33317 11.4349C8.93067 11.4349 8.604 11.7616 8.604 12.1641C8.604 12.4032 8.40567 12.6016 8.1665 12.6016H5.83317C5.594 12.6016 5.39567 12.4032 5.39567 12.1641C5.39567 11.7616 5.069 11.4349 4.6665 11.4349C4.264 11.4349 3.93734 11.7616 3.93734 12.1641C3.93734 12.4032 3.739 12.6016 3.49984 12.6016H2.9165C1.709 12.6016 0.729004 11.6216 0.729004 10.4141V8.66406C0.729004 8.4249 0.927337 8.22656 1.1665 8.22656H7.58317C7.98567 8.22656 8.31234 7.8999 8.31234 7.4974V3.41406C8.31234 3.1749 8.51067 2.97656 8.74984 2.97656H9.82319C10.4007 2.97656 10.9315 3.28574 11.2173 3.7874L12.2148 5.53157C12.2907 5.66573 12.2907 5.8349 12.2148 5.96907C12.139 6.10323 11.9932 6.1849 11.8357 6.1849H11.0832C11.0015 6.1849 10.9373 6.24906 10.9373 6.33073V8.08073C10.9373 8.1624 11.0015 8.22656 11.0832 8.22656H12.8332C13.0723 8.22656 13.2707 8.4249 13.2707 8.66406V10.4141C13.2707 11.6216 12.2907 12.6016 11.0832 12.6016ZM10.879 11.7266H11.0832C11.8065 11.7266 12.3957 11.1374 12.3957 10.4141V9.10156H11.0832C10.5232 9.10156 10.0623 8.64073 10.0623 8.08073V6.33073C10.0623 5.77073 10.5173 5.3099 11.0832 5.3099L10.459 4.21907C10.3307 3.99157 10.0857 3.85156 9.82319 3.85156H9.18734V7.4974C9.18734 8.38406 8.46984 9.10156 7.58317 9.10156H1.604V10.4141C1.604 11.1374 2.19317 11.7266 2.9165 11.7266H3.12066C3.31316 11.0557 3.9315 10.5599 4.6665 10.5599C5.4015 10.5599 6.01985 11.0557 6.21235 11.7266H7.79316C7.98566 11.0557 8.60401 10.5599 9.33901 10.5599C10.074 10.5599 10.6865 11.0557 10.879 11.7266Z"
        fill={color !== '' ? color : '#616B80'}
      />
      <path
        d="M4.66667 13.7708C3.78 13.7708 3.0625 13.0533 3.0625 12.1667C3.0625 11.28 3.78 10.5625 4.66667 10.5625C5.55333 10.5625 6.27083 11.28 6.27083 12.1667C6.27083 13.0533 5.55333 13.7708 4.66667 13.7708ZM4.66667 11.4375C4.26417 11.4375 3.9375 11.7642 3.9375 12.1667C3.9375 12.5692 4.26417 12.8958 4.66667 12.8958C5.06917 12.8958 5.39583 12.5692 5.39583 12.1667C5.39583 11.7642 5.06917 11.4375 4.66667 11.4375Z"
        fill={color !== '' ? color : '#616B80'}
      />
      <path
        d="M9.33317 13.7708C8.4465 13.7708 7.729 13.0533 7.729 12.1667C7.729 11.28 8.4465 10.5625 9.33317 10.5625C10.2198 10.5625 10.9373 11.28 10.9373 12.1667C10.9373 13.0533 10.2198 13.7708 9.33317 13.7708ZM9.33317 11.4375C8.93067 11.4375 8.604 11.7642 8.604 12.1667C8.604 12.5692 8.93067 12.8958 9.33317 12.8958C9.73567 12.8958 10.0623 12.5692 10.0623 12.1667C10.0623 11.7642 9.73567 11.4375 9.33317 11.4375Z"
        fill={color !== '' ? color : '#616B80'}
      />
      <path
        d="M12.8333 9.10417H11.0833C10.5233 9.10417 10.0625 8.64333 10.0625 8.08333V6.33333C10.0625 5.77333 10.5233 5.3125 11.0833 5.3125H11.8358C11.9933 5.3125 12.1392 5.39417 12.215 5.53417L13.2125 7.28417C13.2475 7.34834 13.2708 7.42417 13.2708 7.5V8.66667C13.2708 8.90583 13.0725 9.10417 12.8333 9.10417ZM11.0833 6.1875C11.0017 6.1875 10.9375 6.25167 10.9375 6.33333V8.08333C10.9375 8.165 11.0017 8.22917 11.0833 8.22917H12.3958V7.61667L11.5792 6.1875H11.0833Z"
        fill={color !== '' ? color : '#616B80'}
      />
      <path
        d="M2.9111 6.1901C2.1061 6.1901 1.34777 5.84009 0.834432 5.22759C0.752765 5.14009 0.665275 5.01759 0.589442 4.90092C0.315275 4.48676 0.163609 3.99676 0.151942 3.48343C0.128609 2.63176 0.490283 1.83259 1.14362 1.29009C1.63945 0.881757 2.23442 0.660104 2.86442 0.648438C3.55275 0.654271 4.24112 0.881772 4.75445 1.34261C5.33778 1.85594 5.67611 2.57345 5.69361 3.35511C5.70528 3.86261 5.57693 4.36427 5.32027 4.80177C5.18027 5.0526 4.98777 5.29178 4.77777 5.46678C4.3111 5.91011 3.66943 6.1726 2.98693 6.1901C2.95777 6.1901 2.93443 6.1901 2.9111 6.1901ZM2.9111 1.52344C2.89943 1.52344 2.88777 1.52344 2.8761 1.52344C2.45027 1.52927 2.04192 1.68678 1.69775 1.96678C1.25442 2.33428 1.00944 2.88261 1.0211 3.46011C1.03277 3.81011 1.13194 4.14262 1.31861 4.41678C1.37111 4.49845 1.4236 4.57426 1.48776 4.64426C1.8611 5.08759 2.41527 5.32093 2.95777 5.30927C3.42444 5.2976 3.85609 5.12261 4.18276 4.81345C4.33443 4.68511 4.45693 4.53343 4.55026 4.36427C4.7311 4.0551 4.8186 3.71676 4.81277 3.37259C4.8011 2.83593 4.56778 2.34593 4.17112 1.9901C3.82112 1.6926 3.37776 1.52344 2.9111 1.52344Z"
        fill={color !== '' ? color : '#616B80'}
      />
      <path
        d="M2.59584 4.43894C2.48501 4.43894 2.38 4.3981 2.2925 4.31643L1.70333 3.75645C1.52833 3.58729 1.52252 3.31312 1.69168 3.13812C1.86085 2.96312 2.13502 2.95728 2.31002 3.12644L2.59584 3.40059L3.51168 2.51395C3.68668 2.34478 3.96085 2.35059 4.13001 2.52559C4.29918 2.70059 4.29333 2.97479 4.11833 3.14396L2.89915 4.32227C2.81165 4.3981 2.70084 4.43894 2.59584 4.43894Z"
        fill={color !== '' ? color : '#616B80'}
      />
    </svg>
  );
}
TruckTime.propTypes = {
  color: PropTypes.string,
  size: PropTypes.string,
};
TruckTime.defaultProps = {
  color: '',
  size: '',
};
export function BoxIcon({ size, color }) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M15.8334 18.9563C14.6667 18.9563 13.575 18.4479 12.825 17.5563C12.8167 17.5396 12.7667 17.4979 12.725 17.4312C12.6334 17.3396 12.525 17.1729 12.4334 17.0146C12.0667 16.4229 11.8667 15.7229 11.8667 14.9896C11.8667 13.7729 12.4084 12.6479 13.35 11.8979C14.05 11.3396 14.9334 11.0312 15.825 11.0312C16.7917 11.0312 17.6834 11.3646 18.4 11.9896C18.5 12.0563 18.6167 12.1813 18.725 12.2979C19.4 13.0396 19.775 13.9896 19.775 14.9812C19.775 15.7062 19.575 16.4146 19.2 17.0229C19 17.3729 18.725 17.6896 18.4084 17.9562C17.7334 18.6062 16.8084 18.9563 15.8334 18.9563ZM15.8334 12.2896C15.2167 12.2896 14.6334 12.4979 14.1417 12.8896C13.5 13.3979 13.125 14.1729 13.125 14.9979C13.125 15.4896 13.2584 15.9729 13.5167 16.3896C13.5834 16.5062 13.65 16.5979 13.725 16.6896C13.7417 16.7063 13.7917 16.7563 13.8334 16.8229C14.2917 17.3646 15.0417 17.7146 15.8334 17.7146C16.4917 17.7146 17.125 17.4729 17.6084 17.0396C17.825 16.8563 18.0084 16.6396 18.1417 16.4063C18.4084 15.9813 18.5417 15.4979 18.5417 15.0063C18.5417 14.3313 18.2834 13.6729 17.8167 13.1646C17.7584 13.0979 17.6917 13.0313 17.625 12.9813C17.1 12.5146 16.4917 12.2896 15.8334 12.2896Z"
        fill={color !== '' ? color : '#616B80'}
      />
      <path
        d="M17.0752 15.6094H14.5835C14.2418 15.6094 13.9585 15.326 13.9585 14.9844C13.9585 14.6427 14.2418 14.3594 14.5835 14.3594H17.0752C17.4168 14.3594 17.7002 14.6427 17.7002 14.9844C17.7002 15.326 17.4252 15.6094 17.0752 15.6094Z"
        fill={color !== '' ? color : '#616B80'}
      />
      <path
        d="M15.8335 16.8823C15.4918 16.8823 15.2085 16.599 15.2085 16.2573V13.7656C15.2085 13.424 15.4918 13.1406 15.8335 13.1406C16.1752 13.1406 16.4585 13.424 16.4585 13.7656V16.2573C16.4585 16.6073 16.1752 16.8823 15.8335 16.8823Z"
        fill={color !== '' ? color : '#616B80'}
      />
      <path
        d="M9.99978 11.0814C9.89145 11.0814 9.78311 11.0564 9.68311 10.9981L2.32478 6.73979C2.02478 6.56479 1.92479 6.18144 2.09979 5.88144C2.27479 5.58144 2.65811 5.48142 2.94978 5.65642L9.99145 9.73143L16.9914 5.68144C17.2914 5.50644 17.6748 5.61479 17.8415 5.90646C18.0165 6.20646 17.9081 6.58977 17.6164 6.76477L10.3081 10.9981C10.2164 11.0481 10.1081 11.0814 9.99978 11.0814Z"
        fill={color !== '' ? color : '#616B80'}
      />
      <path
        d="M10 18.6365C9.65833 18.6365 9.375 18.3531 9.375 18.0115V10.4531C9.375 10.1115 9.65833 9.82812 10 9.82812C10.3417 9.82812 10.625 10.1115 10.625 10.4531V18.0115C10.625 18.3531 10.3417 18.6365 10 18.6365Z"
        fill={color !== '' ? color : '#616B80'}
      />
      <path
        d="M10.0001 18.9625C9.26673 18.9625 8.53339 18.8042 7.96673 18.4792L3.51673 16.0125C2.3084 15.3459 1.3584 13.7375 1.3584 12.3542V7.63748C1.3584 6.25415 2.3084 4.65418 3.51673 3.97918L7.96673 1.5125C9.10006 0.870833 10.8834 0.870833 12.0251 1.5125L16.4751 3.97918C17.6834 4.64585 18.6334 6.25415 18.6334 7.63748V12.3542C18.6334 12.4375 18.6334 12.5041 18.6167 12.5875C18.5751 12.8041 18.4167 12.9875 18.2084 13.0541C18.0001 13.1291 17.7667 13.0792 17.5917 12.9375C16.6334 12.1042 15.1501 12.0708 14.1417 12.8792C13.5001 13.3875 13.1251 14.1625 13.1251 14.9875C13.1251 15.4792 13.2584 15.9625 13.5167 16.3792C13.5834 16.4959 13.6501 16.5875 13.7251 16.6792C13.8501 16.8208 13.9001 17.0125 13.8667 17.1958C13.8334 17.3792 13.7167 17.5375 13.5501 17.6292L12.0251 18.4708C11.4584 18.8041 10.7334 18.9625 10.0001 18.9625ZM10.0001 2.29584C9.48339 2.29584 8.9584 2.40417 8.5834 2.61251L4.1334 5.07919C3.32507 5.52086 2.62506 6.72081 2.62506 7.63748V12.3542C2.62506 13.2708 3.3334 14.4708 4.1334 14.9125L8.5834 17.3791C9.34173 17.8041 10.6667 17.8041 11.4251 17.3791L12.3584 16.8625C12.0501 16.3042 11.8834 15.6542 11.8834 14.9875C11.8834 13.7708 12.4251 12.6459 13.3667 11.8959C14.5001 10.9875 16.1251 10.7958 17.3917 11.3375V7.62085C17.3917 6.70418 16.6834 5.50417 15.8834 5.06251L11.4334 2.59582C11.0417 2.40416 10.5167 2.29584 10.0001 2.29584Z"
        fill={color !== '' ? color : '#616B80'}
      />
    </svg>
  );
}
BoxIcon.propTypes = {
  color: PropTypes.string,
  size: PropTypes.string,
};
BoxIcon.defaultProps = {
  color: '',
  size: '1.389vw',
};
export function EditReceiptIcon({ size, color }) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M8.78361 18.2807C8.59194 18.2807 8.40861 18.1974 8.28361 18.0307L7.44193 16.9057C7.26693 16.6724 7.03362 16.5391 6.78362 16.5224C6.52528 16.5057 6.28359 16.6224 6.08359 16.8307C4.87526 18.1224 3.9586 18.0141 3.51694 17.8474C3.06694 17.6724 2.30859 17.0974 2.30859 15.2474V5.86407C2.30859 2.16407 3.37526 1.03906 6.86693 1.03906H13.1586C16.6503 1.03906 17.7169 2.16407 17.7169 5.86407V9.41405C17.7169 9.75572 17.4336 10.0391 17.0919 10.0391C16.7503 10.0391 16.4669 9.75572 16.4669 9.41405V5.86407C16.4669 2.85574 15.9419 2.28906 13.1586 2.28906H6.86693C4.08359 2.28906 3.55859 2.85574 3.55859 5.86407V15.2474C3.55859 16.1224 3.77526 16.6057 3.97526 16.6807C4.12526 16.7391 4.53361 16.6557 5.16695 15.9807C5.62528 15.4974 6.22527 15.2391 6.85027 15.2724C7.46694 15.3057 8.05027 15.6307 8.44194 16.1557L9.29193 17.2807C9.50026 17.5557 9.44194 17.9474 9.16694 18.1557C9.04194 18.2474 8.90861 18.2807 8.78361 18.2807Z"
        fill={color !== '' ? color : '#616B80'}
      />
      <path
        d="M13.3332 6.46094H6.6665C6.32484 6.46094 6.0415 6.1776 6.0415 5.83594C6.0415 5.49427 6.32484 5.21094 6.6665 5.21094H13.3332C13.6748 5.21094 13.9582 5.49427 13.9582 5.83594C13.9582 6.1776 13.6748 6.46094 13.3332 6.46094Z"
        fill={color !== '' ? color : '#616B80'}
      />
      <path
        d="M12.5 9.78906H7.5C7.15833 9.78906 6.875 9.50573 6.875 9.16406C6.875 8.8224 7.15833 8.53906 7.5 8.53906H12.5C12.8417 8.53906 13.125 8.8224 13.125 9.16406C13.125 9.50573 12.8417 9.78906 12.5 9.78906Z"
        fill={color !== '' ? color : '#616B80'}
      />
      <path
        d="M12.3503 18.1513C12.0336 18.1513 11.7336 18.0346 11.517 17.818C11.2586 17.5596 11.142 17.1846 11.2003 16.793L11.3586 15.668C11.4003 15.3763 11.5753 15.0263 11.7836 14.818L14.7336 11.868C15.1336 11.468 15.5253 11.2596 15.9503 11.218C16.467 11.168 16.9836 11.3846 17.4669 11.868C17.9503 12.3513 18.1669 12.8596 18.1169 13.3846C18.0753 13.8013 17.8586 14.2013 17.4669 14.6013L14.517 17.5513C14.3086 17.7596 13.9586 17.9346 13.6669 17.9763L12.5419 18.1347C12.4753 18.143 12.417 18.1513 12.3503 18.1513ZM16.092 12.4597C16.0836 12.4597 16.0753 12.4597 16.067 12.4597C15.9503 12.468 15.7919 12.5763 15.6169 12.7513L12.667 15.7013C12.642 15.7263 12.6003 15.8097 12.6003 15.843L12.4503 16.8847L13.492 16.7346C13.5253 16.7263 13.6086 16.6846 13.6336 16.6596L16.5836 13.7097C16.7586 13.5263 16.867 13.3763 16.8753 13.2596C16.892 13.093 16.7253 12.893 16.5836 12.7513C16.4503 12.618 16.2586 12.4597 16.092 12.4597Z"
        fill={color !== '' ? color : '#616B80'}
      />
      <path
        d="M16.5998 15.2078C16.5415 15.2078 16.4832 15.1995 16.4332 15.1828C15.3332 14.8745 14.4582 13.9995 14.1498 12.8995C14.0582 12.5661 14.2498 12.2244 14.5832 12.1244C14.9165 12.0328 15.2582 12.2245 15.3498 12.5578C15.5415 13.2411 16.0832 13.7828 16.7665 13.9744C17.0998 14.0661 17.2915 14.4161 17.1998 14.7495C17.1248 15.0245 16.8748 15.2078 16.5998 15.2078Z"
        fill={color !== '' ? color : '#616B80'}
      />
    </svg>
  );
}
EditReceiptIcon.propTypes = {
  color: PropTypes.string,
  size: PropTypes.string,
};
EditReceiptIcon.defaultProps = {
  color: '',
  size: '1.389vw',
};
export function ConfirmEntitiesIcon({ size, color }) {
  return (
    <svg
      width={size !== '' ? size : '24'}
      height={size !== '' ? size : '24'}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M8 5.75C7.59 5.75 7.25 5.41 7.25 5V2C7.25 1.59 7.59 1.25 8 1.25C8.41 1.25 8.75 1.59 8.75 2V5C8.75 5.41 8.41 5.75 8 5.75Z"
        fill={color !== '' ? color : 'white'}
      />
      <path
        d="M16 5.75C15.59 5.75 15.25 5.41 15.25 5V2C15.25 1.59 15.59 1.25 16 1.25C16.41 1.25 16.75 1.59 16.75 2V5C16.75 5.41 16.41 5.75 16 5.75Z"
        fill={color !== '' ? color : 'white'}
      />
      <path
        d="M14.68 22.75H8C4.35 22.75 2.25 20.65 2.25 17V8.5C2.25 4.85 4.35 2.75 8 2.75H16C19.65 2.75 21.75 4.85 21.75 8.5V13.63C21.75 13.92 21.58 14.18 21.33 14.31C21.07 14.43 20.76 14.4 20.54 14.22C18.96 12.96 16.53 12.96 14.95 14.25C13.87 15.1 13.26 16.37 13.26 17.76C13.26 18.58 13.48 19.38 13.91 20.07C14.24 20.61 14.65 21.06 15.13 21.4C15.39 21.59 15.51 21.93 15.41 22.24C15.29 22.54 15.01 22.75 14.68 22.75ZM8 4.25C5.14 4.25 3.75 5.64 3.75 8.5V17C3.75 19.86 5.14 21.25 8 21.25H12.89C12.79 21.12 12.7 20.98 12.62 20.84C12.05 19.92 11.75 18.85 11.75 17.75C11.75 15.9 12.57 14.2 14.01 13.07C15.72 11.68 18.25 11.38 20.25 12.3V8.5C20.25 5.64 18.86 4.25 16 4.25H8Z"
        fill={color !== '' ? color : 'white'}
      />
      <path
        d="M13 11.75H7C6.59 11.75 6.25 11.41 6.25 11C6.25 10.59 6.59 10.25 7 10.25H13C13.41 10.25 13.75 10.59 13.75 11C13.75 11.41 13.41 11.75 13 11.75Z"
        fill={color !== '' ? color : 'white'}
      />
      <path
        d="M9.62 16.75H7C6.59 16.75 6.25 16.41 6.25 16C6.25 15.59 6.59 15.25 7 15.25H9.62C10.03 15.25 10.37 15.59 10.37 16C10.37 16.41 10.04 16.75 9.62 16.75Z"
        fill={color !== '' ? color : 'white'}
      />
      <path
        d="M17.75 23.7519C16.47 23.7519 15.26 23.3519 14.24 22.6119C13.6 22.1519 13.05 21.552 12.62 20.842C12.05 19.922 11.75 18.8519 11.75 17.7519C11.75 15.9019 12.57 14.2019 14.01 13.0719C16.09 11.3819 19.37 11.3719 21.47 13.0419C22.92 14.1819 23.75 15.9019 23.75 17.7519C23.75 18.8519 23.45 19.922 22.88 20.842C22.56 21.392 22.15 21.8719 21.68 22.2619C20.61 23.2219 19.21 23.7519 17.75 23.7519ZM17.75 13.2519C16.73 13.2519 15.73 13.6019 14.94 14.2419C13.86 15.0919 13.25 16.3619 13.25 17.7519C13.25 18.5719 13.47 19.3719 13.9 20.0619C14.23 20.6019 14.64 21.0519 15.12 21.3919C15.89 21.9519 16.8 22.2519 17.75 22.2519C18.86 22.2519 19.88 21.8619 20.7 21.1319C21.06 20.8319 21.35 20.4819 21.59 20.0719C22.02 19.3719 22.25 18.5719 22.25 17.7519C22.25 16.3619 21.63 15.0819 20.54 14.2219C19.74 13.5819 18.78 13.2519 17.75 13.2519Z"
        fill={color !== '' ? color : 'white'}
      />
      <path
        d="M17.75 21C17.34 21 17 20.66 17 20.25C17 19.29 16.21 18.5 15.25 18.5C14.84 18.5 14.5 18.16 14.5 17.75C14.5 17.34 14.84 17 15.25 17C16.21 17 17 16.21 17 15.25C17 14.84 17.34 14.5 17.75 14.5C18.16 14.5 18.5 14.84 18.5 15.25C18.5 16.21 19.29 17 20.25 17C20.66 17 21 17.34 21 17.75C21 18.16 20.66 18.5 20.25 18.5C19.29 18.5 18.5 19.29 18.5 20.25C18.5 20.66 18.16 21 17.75 21ZM17.32 17.75C17.47 17.88 17.62 18.02 17.75 18.18C17.88 18.03 18.02 17.88 18.18 17.75C18.03 17.62 17.88 17.48 17.75 17.32C17.62 17.48 17.48 17.62 17.32 17.75Z"
        fill={color !== '' ? color : 'white'}
      />
    </svg>
  );
}
ConfirmEntitiesIcon.propTypes = {
  color: PropTypes.string,
  size: PropTypes.string,
};
ConfirmEntitiesIcon.defaultProps = {
  color: '',
  size: '',
};
export function UploadDocumentIcon({ color }) {
  return (
    <svg
      width="25"
      height="24"
      viewBox="0 0 25 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M21 10.19H18.11C15.74 10.19 13.81 8.26 13.81 5.89V3C13.81 2.45 13.36 2 12.81 2H8.57C5.49 2 3 4 3 7.57V16.43C3 20 5.49 22 8.57 22H16.43C19.51 22 22 20 22 16.43V11.19C22 10.64 21.55 10.19 21 10.19ZM12.03 13.53C11.88 13.68 11.69 13.75 11.5 13.75C11.31 13.75 11.12 13.68 10.97 13.53L10.25 12.81V17C10.25 17.41 9.91 17.75 9.5 17.75C9.09 17.75 8.75 17.41 8.75 17V12.81L8.03 13.53C7.74 13.82 7.26 13.82 6.97 13.53C6.68 13.24 6.68 12.76 6.97 12.47L8.97 10.47C9.04 10.41 9.11 10.36 9.19 10.32C9.21 10.31 9.24 10.3 9.26 10.29C9.32 10.27 9.38 10.26 9.45 10.25C9.48 10.25 9.5 10.25 9.53 10.25C9.61 10.25 9.69 10.27 9.77 10.3C9.78 10.3 9.78 10.3 9.79 10.3C9.87 10.33 9.95 10.39 10.01 10.45C10.02 10.46 10.03 10.46 10.03 10.47L12.03 12.47C12.32 12.76 12.32 13.24 12.03 13.53Z"
        fill={color !== '' ? color : '#0088FA'}
      />
      <path
        d="M17.9302 8.81048C18.8802 8.82048 20.2002 8.82048 21.3302 8.82048C21.9002 8.82048 22.2002 8.15048 21.8002 7.75048C20.3602 6.30048 17.7802 3.69048 16.3002 2.21048C15.8902 1.80048 15.1802 2.08048 15.1802 2.65048V6.14048C15.1802 7.60048 16.4202 8.81048 17.9302 8.81048Z"
        fill={color !== '' ? color : '#0088FA'}
      />
    </svg>
  );
}
UploadDocumentIcon.propTypes = {
  color: PropTypes.string,
};
UploadDocumentIcon.defaultProps = {
  color: '',
};
export function OriginDoorIcon() {
  return (
    <svg
      width="33"
      height="32"
      viewBox="0 0 33 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M31 23.5H30V9.31C30.3193 8.94798 30.4969 8.4827 30.5 8C30.5008 7.98152 30.4991 7.96302 30.495 7.945L30 3.47V1.5C30 1.36739 29.9473 1.24021 29.8536 1.14645C29.7598 1.05268 29.6326 1 29.5 1H3.5C3.36739 1 3.24021 1.05268 3.14645 1.14645C3.05268 1.24021 3 1.36739 3 1.5V3.47L2.505 7.945C2.50086 7.96302 2.49918 7.98152 2.5 8C2.50312 8.4827 2.68071 8.94798 3 9.31V23.5H2C1.86739 23.5 1.74021 23.5527 1.64645 23.6464C1.55268 23.7402 1.5 23.8674 1.5 24V26C1.5 26.1326 1.55268 26.2598 1.64645 26.3536C1.74021 26.4473 1.86739 26.5 2 26.5H7V27.5C7 27.6326 7.05268 27.7598 7.14645 27.8536C7.24021 27.9473 7.36739 28 7.5 28V29C7.5 29.1326 7.55268 29.2598 7.64645 29.3536C7.74021 29.4473 7.86739 29.5 8 29.5H9.71C9.90493 29.9451 10.2253 30.3237 10.632 30.5896C11.0387 30.8555 11.5141 30.9971 12 30.9971C12.4859 30.9971 12.9613 30.8555 13.368 30.5896C13.7747 30.3237 14.0951 29.9451 14.29 29.5H21.21C21.4049 29.9451 21.7253 30.3237 22.132 30.5896C22.5387 30.8555 23.0141 30.9971 23.5 30.9971C23.9859 30.9971 24.4613 30.8555 24.868 30.5896C25.2747 30.3237 25.5951 29.9451 25.79 29.5H27C27.1326 29.5 27.2598 29.4473 27.3536 29.3536C27.4473 29.2598 27.5 29.1326 27.5 29V28C27.6326 28 27.7598 27.9473 27.8536 27.8536C27.9473 27.7598 28 27.6326 28 27.5V26.5H31C31.1326 26.5 31.2598 26.4473 31.3536 26.3536C31.4473 26.2598 31.5 26.1326 31.5 26V24C31.5 23.8674 31.4473 23.7402 31.3536 23.6464C31.2598 23.5527 31.1326 23.5 31 23.5ZM29.5 8.025C29.4967 8.29022 29.3881 8.54325 29.1983 8.72845C29.0084 8.91364 28.7527 9.01581 28.4875 9.0125C28.2223 9.00918 27.9692 8.90065 27.7841 8.71077C27.5989 8.52089 27.4967 8.26522 27.5 8V7.365H29.425L29.5 8.025ZM29.315 6.365H27.5V4H29.05L29.315 6.365ZM4 2H29V3H4V2ZM24.5 6.365V4H26.5V6.365H24.5ZM26.5 7.365V8C26.5 8.26522 26.3946 8.51957 26.2071 8.70711C26.0196 8.89464 25.7652 9 25.5 9C25.2348 9 24.9804 8.89464 24.7929 8.70711C24.6054 8.51957 24.5 8.26522 24.5 8V7.365H26.5ZM21.5 6.365V4H23.5V6.365H21.5ZM23.5 7.365V8C23.5 8.26522 23.3946 8.51957 23.2071 8.70711C23.0196 8.89464 22.7652 9 22.5 9C22.2348 9 21.9804 8.89464 21.7929 8.70711C21.6054 8.51957 21.5 8.26522 21.5 8V7.365H23.5ZM18.5 6.365V4H20.5V6.365H18.5ZM20.5 7.365V8C20.5 8.26522 20.3946 8.51957 20.2071 8.70711C20.0196 8.89464 19.7652 9 19.5 9C19.2348 9 18.9804 8.89464 18.7929 8.70711C18.6054 8.51957 18.5 8.26522 18.5 8V7.365H20.5ZM15.5 6.365V4H17.5V6.365H15.5ZM17.5 7.365V8C17.5 8.26522 17.3946 8.51957 17.2071 8.70711C17.0196 8.89464 16.7652 9 16.5 9C16.2348 9 15.9804 8.89464 15.7929 8.70711C15.6054 8.51957 15.5 8.26522 15.5 8V7.365H17.5ZM12.5 6.365V4H14.5V6.365H12.5ZM14.5 7.365V8C14.5 8.26522 14.3946 8.51957 14.2071 8.70711C14.0196 8.89464 13.7652 9 13.5 9C13.2348 9 12.9804 8.89464 12.7929 8.70711C12.6054 8.51957 12.5 8.26522 12.5 8V7.365H14.5ZM9.5 6.365V4H11.5V6.365H9.5ZM11.5 7.365V8C11.5 8.26522 11.3946 8.51957 11.2071 8.70711C11.0196 8.89464 10.7652 9 10.5 9C10.2348 9 9.98043 8.89464 9.79289 8.70711C9.60536 8.51957 9.5 8.26522 9.5 8V7.365H11.5ZM6.5 6.365V4H8.5V6.365H6.5ZM8.5 7.365V8C8.5 8.26522 8.39464 8.51957 8.20711 8.70711C8.01957 8.89464 7.76522 9 7.5 9C7.23478 9 6.98043 8.89464 6.79289 8.70711C6.60536 8.51957 6.5 8.26522 6.5 8V7.365H8.5ZM3.95 4H5.5V6.365H3.685L3.95 4ZM3.575 7.365H5.5V8C5.50331 8.26522 5.40114 8.52089 5.21595 8.71077C5.03075 8.90065 4.77772 9.00918 4.5125 9.0125C4.24728 9.01581 3.99161 8.91364 3.80173 8.72845C3.61185 8.54325 3.50332 8.29022 3.5 8.025L3.575 7.365ZM7 25.5H2.5V24.5H7V25.5ZM7.5 17C7.36739 17 7.24021 17.0527 7.14645 17.1464C7.05268 17.2402 7 17.3674 7 17.5V23.5H6V15H11V17H7.5ZM9.5 28.5H8.5V28H9.55C9.51802 28.1648 9.50128 28.3322 9.5 28.5ZM12 30C11.7033 30 11.4133 29.912 11.1666 29.7472C10.92 29.5824 10.7277 29.3481 10.6142 29.074C10.5006 28.7999 10.4709 28.4983 10.5288 28.2074C10.5867 27.9164 10.7296 27.6491 10.9393 27.4393C11.1491 27.2296 11.4164 27.0867 11.7074 27.0288C11.9983 26.9709 12.2999 27.0007 12.574 27.1142C12.8481 27.2277 13.0824 27.42 13.2472 27.6666C13.412 27.9133 13.5 28.2033 13.5 28.5C13.4988 28.8975 13.3404 29.2783 13.0593 29.5593C12.7783 29.8404 12.3975 29.9988 12 30ZM13.985 27C13.7553 26.6898 13.4561 26.4377 13.1113 26.2641C12.7666 26.0904 12.386 25.9999 12 25.9999C11.614 25.9999 11.2334 26.0904 10.8887 26.2641C10.5439 26.4377 10.2447 26.6898 10.015 27H8V18H19.5V27H13.985ZM22.36 17.5H20.5C20.5 17.3674 20.4473 17.2402 20.3536 17.1464C20.2598 17.0527 20.1326 17 20 17H14.5V12.5H26.5V22.735L26.455 22.68C26.4082 22.6233 26.3493 22.5778 26.2828 22.5467C26.2162 22.5155 26.1435 22.4996 26.07 22.5H25.41L24.81 19.51C24.6968 18.9435 24.3908 18.4337 23.9442 18.0672C23.4975 17.7008 22.9377 17.5003 22.36 17.5ZM24.39 22.5H20.5V18.5H22.36C22.7065 18.5002 23.0423 18.6203 23.3102 18.8399C23.5782 19.0596 23.7619 19.3653 23.83 19.705L24.39 22.5ZM21 28.5H14.5C14.4987 28.3322 14.482 28.1648 14.45 28H21.05C21.018 28.1648 21.0013 28.3322 21 28.5ZM23.5 30C23.2033 30 22.9133 29.912 22.6666 29.7472C22.42 29.5824 22.2277 29.3481 22.1142 29.074C22.0007 28.7999 21.9709 28.4983 22.0288 28.2074C22.0867 27.9164 22.2296 27.6491 22.4393 27.4393C22.6491 27.2296 22.9164 27.0867 23.2074 27.0288C23.4983 26.9709 23.7999 27.0007 24.074 27.1142C24.3481 27.2277 24.5824 27.42 24.7472 27.6666C24.912 27.9133 25 28.2033 25 28.5C24.9988 28.8975 24.8404 29.2783 24.5593 29.5593C24.2783 29.8404 23.8975 29.9988 23.5 30ZM26.5 28.5H26C25.9987 28.3322 25.982 28.1648 25.95 28H26.5V28.5ZM27 27H25.485C25.2553 26.6898 24.9561 26.4377 24.6113 26.2641C24.2666 26.0904 23.886 25.9999 23.5 25.9999C23.114 25.9999 22.7334 26.0904 22.3887 26.2641C22.0439 26.4377 21.7447 26.6898 21.515 27H20.5V23.5H25.835L27 24.885V27ZM27.5 23.5V12C27.5 11.8674 27.4473 11.7402 27.3536 11.6464C27.2598 11.5527 27.1326 11.5 27 11.5H14C13.8674 11.5 13.7402 11.5527 13.6464 11.6464C13.5527 11.7402 13.5 11.8674 13.5 12V17H12V14.5C12 14.3674 11.9473 14.2402 11.8536 14.1464C11.7598 14.0527 11.6326 14 11.5 14H5.5C5.36739 14 5.24021 14.0527 5.14645 14.1464C5.05268 14.2402 5 14.3674 5 14.5V23.5H4V9.93C4.16314 9.97389 4.33108 9.9974 4.5 10C4.78491 9.99947 5.06637 9.93756 5.32521 9.81849C5.58405 9.69943 5.8142 9.526 6 9.31C6.18546 9.5264 6.41554 9.70011 6.67446 9.8192C6.93338 9.9383 7.215 9.99996 7.5 9.99996C7.785 9.99996 8.06662 9.9383 8.32554 9.8192C8.58446 9.70011 8.81454 9.5264 9 9.31C9.18546 9.5264 9.41554 9.70011 9.67446 9.8192C9.93338 9.9383 10.215 9.99996 10.5 9.99996C10.785 9.99996 11.0666 9.9383 11.3255 9.8192C11.5845 9.70011 11.8145 9.5264 12 9.31C12.1855 9.5264 12.4155 9.70011 12.6745 9.8192C12.9334 9.9383 13.215 9.99996 13.5 9.99996C13.785 9.99996 14.0666 9.9383 14.3255 9.8192C14.5845 9.70011 14.8145 9.5264 15 9.31C15.1855 9.5264 15.4155 9.70011 15.6745 9.8192C15.9334 9.9383 16.215 9.99996 16.5 9.99996C16.785 9.99996 17.0666 9.9383 17.3255 9.8192C17.5845 9.70011 17.8145 9.5264 18 9.31C18.1855 9.5264 18.4155 9.70011 18.6745 9.8192C18.9334 9.9383 19.215 9.99996 19.5 9.99996C19.785 9.99996 20.0666 9.9383 20.3255 9.8192C20.5845 9.70011 20.8145 9.5264 21 9.31C21.1855 9.5264 21.4155 9.70011 21.6745 9.8192C21.9334 9.9383 22.215 9.99996 22.5 9.99996C22.785 9.99996 23.0666 9.9383 23.3255 9.8192C23.5845 9.70011 23.8145 9.5264 24 9.31C24.1855 9.5264 24.4155 9.70011 24.6745 9.8192C24.9334 9.9383 25.215 9.99996 25.5 9.99996C25.785 9.99996 26.0666 9.9383 26.3255 9.8192C26.5845 9.70011 26.8145 9.5264 27 9.31C27.1858 9.526 27.416 9.69943 27.6748 9.81849C27.9336 9.93756 28.2151 9.99947 28.5 10C28.6689 9.9974 28.8369 9.97389 29 9.93V23.5H27.5ZM30.5 25.5H28V24.705C27.9983 24.6339 27.9812 24.5639 27.95 24.5H30.5V25.5Z"
        fill="url(#paint0_linear_11440_31220)"
      />
      <path
        d="M11 25.5H16.5C16.6326 25.5 16.7598 25.4473 16.8536 25.3536C16.9473 25.2598 17 25.1326 17 25V19.5C17 19.3674 16.9473 19.2402 16.8536 19.1464C16.7598 19.0527 16.6326 19 16.5 19H11C10.8674 19 10.7402 19.0527 10.6464 19.1464C10.5527 19.2402 10.5 19.3674 10.5 19.5V25C10.5 25.1326 10.5527 25.2598 10.6464 25.3536C10.7402 25.4473 10.8674 25.5 11 25.5ZM16 24.5H11.5V21.5H16V24.5ZM11.5 20H16V20.5H11.5V20Z"
        fill="url(#paint1_linear_11440_31220)"
      />
      <path d="M12 23H13.5V24H12V23Z" fill="url(#paint2_linear_11440_31220)" />
      <defs>
        <linearGradient
          id="paint0_linear_11440_31220"
          x1="1.5"
          y1="1"
          x2="37.6987"
          y2="16.7547"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0.234375" stopColor="#A584EA" />
          <stop offset="1" stopColor="#5D87FF" />
        </linearGradient>
        <linearGradient
          id="paint1_linear_11440_31220"
          x1="10.5"
          y1="19"
          x2="18.3433"
          y2="22.4133"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0.234375" stopColor="#A584EA" />
          <stop offset="1" stopColor="#5D87FF" />
        </linearGradient>
        <linearGradient
          id="paint2_linear_11440_31220"
          x1="12"
          y1="23"
          x2="13.5095"
          y2="23.9854"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0.234375" stopColor="#A584EA" />
          <stop offset="1" stopColor="#5D87FF" />
        </linearGradient>
      </defs>
    </svg>
  );
}
export function OriginPortIcon({ size }) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 32 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_11440_31231)">
        <path
          d="M31 7C31.1326 7 31.2598 6.94732 31.3536 6.85355C31.4473 6.75979 31.5 6.63261 31.5 6.5V4.5C31.5 4.36739 31.4473 4.24021 31.3536 4.14645C31.2598 4.05268 31.1326 4 31 4H25.5V1C25.5 0.867392 25.4473 0.740215 25.3536 0.646447C25.2598 0.552678 25.1326 0.5 25 0.5H21C20.8674 0.5 20.7402 0.552678 20.6464 0.646447C20.5527 0.740215 20.5 0.867392 20.5 1V4H1C0.867392 4 0.740215 4.05268 0.646447 4.14645C0.552678 4.24021 0.5 4.36739 0.5 4.5V6.5C0.5 6.63261 0.552678 6.75979 0.646447 6.85355C0.740215 6.94732 0.867392 7 1 7H9.5V8H9C8.73478 8 8.48043 8.10536 8.29289 8.29289C8.10536 8.48043 8 8.73478 8 9V11C8 11.2652 8.10536 11.5196 8.29289 11.7071C8.48043 11.8946 8.73478 12 9 12H9.5V13.5C9.5 13.6326 9.44732 13.7598 9.35355 13.8536C9.25979 13.9473 9.13261 14 9 14C8.86739 14 8.74021 13.9473 8.64645 13.8536C8.55268 13.7598 8.5 13.6326 8.5 13.5V13H7.5V13.5C7.50062 13.7119 7.54643 13.9212 7.63438 14.114C7.72232 14.3068 7.85038 14.4786 8.01 14.618L2.7 18.6L2.705 18.607C2.64235 18.6518 2.59114 18.7107 2.55552 18.779C2.5199 18.8473 2.50088 18.923 2.5 19V25C2.5 25.1326 2.55268 25.2598 2.64645 25.3536C2.74021 25.4473 2.86739 25.5 3 25.5H15C15.1326 25.5 15.2598 25.4473 15.3536 25.3536C15.4473 25.2598 15.5 25.1326 15.5 25V19C15.4991 18.923 15.4801 18.8473 15.4445 18.779C15.4089 18.7107 15.3576 18.6518 15.295 18.607L15.3 18.6L9.99 14.618C10.1496 14.4786 10.2777 14.3068 10.3656 14.114C10.4536 13.9212 10.4994 13.7119 10.5 13.5V12H11C11.2652 12 11.5196 11.8946 11.7071 11.7071C11.8946 11.5196 12 11.2652 12 11V9C12 8.73478 11.8946 8.48043 11.7071 8.29289C11.5196 8.10536 11.2652 8 11 8H10.5V7H20.5V23.5H19.5C19.2348 23.5 18.9804 23.6054 18.7929 23.7929C18.6054 23.9804 18.5 24.2348 18.5 24.5V28.592C18.2085 28.695 17.956 28.8856 17.777 29.1376C17.598 29.3897 17.5013 29.6909 17.5 30V31C17.5 31.1326 17.5527 31.2598 17.6464 31.3536C17.7402 31.4473 17.8674 31.5 18 31.5H28C28.1326 31.5 28.2598 31.4473 28.3536 31.3536C28.4473 31.2598 28.5 31.1326 28.5 31V30C28.4987 29.6909 28.402 29.3897 28.223 29.1376C28.044 28.8856 27.7915 28.695 27.5 28.592V24.5C27.5 24.2348 27.3946 23.9804 27.2071 23.7929C27.0196 23.6054 26.7652 23.5 26.5 23.5H25.5V7H27.5V8H27C26.8674 8 26.7402 8.05268 26.6464 8.14645C26.5527 8.24021 26.5 8.36739 26.5 8.5V12.5C26.5 12.6326 26.5527 12.7598 26.6464 12.8536C26.7402 12.9473 26.8674 13 27 13H31C31.1326 13 31.2598 12.9473 31.3536 12.8536C31.4473 12.7598 31.5 12.6326 31.5 12.5V8.5C31.5 8.36739 31.4473 8.24021 31.3536 8.14645C31.2598 8.05268 31.1326 8 31 8H30.5V7H31ZM9 15.125L13.5 18.5H4.5L9 15.125ZM14.5 24.5H3.5V19.5H14.5V24.5ZM11 11H9V9H11V11ZM24.5 3.4L22.3305 1.5H24.5V3.4ZM21.5 2.1L23.6695 4H21.5V2.1ZM1.5 6V5H9.5V6H1.5ZM10.5 5H30.5V6H10.5V5ZM21.5 13.45L24.1175 15.25L21.5 17.05V13.45ZM21.5 18.95L24.1175 20.75L21.5 22.55V18.95ZM24.5 19.8L21.8825 18L24.5 16.2V19.8ZM24.5 14.3L21.8825 12.5L24.5 10.7V14.3ZM21.5 11.55V7.95L24.1175 9.75L21.5 11.55ZM27.5 30.5H18.5V30C18.5 29.8674 18.5527 29.7402 18.6464 29.6464C18.7402 29.5527 18.8674 29.5 19 29.5H27C27.1326 29.5 27.2598 29.5527 27.3536 29.6464C27.4473 29.7402 27.5 29.8674 27.5 30V30.5ZM26.5 28.5H19.5V24.5H26.5V28.5ZM21.8825 23.5L24.5 21.7V23.5H21.8825ZM24.5 8.8L21.8825 7H24.5V8.8ZM30.5 12H27.5V9H30.5V12ZM29.5 8H28.5V7H29.5V8Z"
          fill="url(#paint0_linear_11440_31231)"
        />
        <path
          d="M5.5 20.5H4.5V23.5H5.5V20.5Z"
          fill="url(#paint1_linear_11440_31231)"
        />
        <path
          d="M7.5 20.5H6.5V23.5H7.5V20.5Z"
          fill="url(#paint2_linear_11440_31231)"
        />
        <path
          d="M9.5 20.5H8.5V23.5H9.5V20.5Z"
          fill="url(#paint3_linear_11440_31231)"
        />
        <path
          d="M11.5 20.5H10.5V23.5H11.5V20.5Z"
          fill="url(#paint4_linear_11440_31231)"
        />
        <path
          d="M13.5 20.5H12.5V23.5H13.5V20.5Z"
          fill="url(#paint5_linear_11440_31231)"
        />
      </g>
      <defs>
        <linearGradient
          id="paint0_linear_11440_31231"
          x1="0.5"
          y1="0.5"
          x2="37.9065"
          y2="16.7788"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0.234375" stopColor="#A584EA" />
          <stop offset="1" stopColor="#5D87FF" />
        </linearGradient>
        <linearGradient
          id="paint1_linear_11440_31231"
          x1="4.5"
          y1="20.5"
          x2="5.90561"
          y2="20.7039"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0.234375" stopColor="#A584EA" />
          <stop offset="1" stopColor="#5D87FF" />
        </linearGradient>
        <linearGradient
          id="paint2_linear_11440_31231"
          x1="6.5"
          y1="20.5"
          x2="7.90561"
          y2="20.7039"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0.234375" stopColor="#A584EA" />
          <stop offset="1" stopColor="#5D87FF" />
        </linearGradient>
        <linearGradient
          id="paint3_linear_11440_31231"
          x1="8.5"
          y1="20.5"
          x2="9.90561"
          y2="20.7039"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0.234375" stopColor="#A584EA" />
          <stop offset="1" stopColor="#5D87FF" />
        </linearGradient>
        <linearGradient
          id="paint4_linear_11440_31231"
          x1="10.5"
          y1="20.5"
          x2="11.9056"
          y2="20.7039"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0.234375" stopColor="#A584EA" />
          <stop offset="1" stopColor="#5D87FF" />
        </linearGradient>
        <linearGradient
          id="paint5_linear_11440_31231"
          x1="12.5"
          y1="20.5"
          x2="13.9056"
          y2="20.7039"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0.234375" stopColor="#A584EA" />
          <stop offset="1" stopColor="#5D87FF" />
        </linearGradient>
        <clipPath id="clip0_11440_31231">
          <rect width="32" height="32" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
}
OriginPortIcon.propTypes = {
  size: PropTypes.string,
};
OriginPortIcon.defaultProps = {
  size: '32',
};

export function DestinationPortIcon() {
  return (
    <svg
      width="32"
      height="32"
      viewBox="0 0 32 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_11439_30663)">
        <path
          d="M1 7C0.867392 7 0.740215 6.94732 0.646446 6.85355C0.552677 6.75979 0.5 6.63261 0.5 6.5V4.5C0.5 4.36739 0.552677 4.24021 0.646446 4.14645C0.740215 4.05268 0.867392 4 1 4H6.5V1C6.5 0.867392 6.55268 0.740215 6.64645 0.646447C6.74022 0.552678 6.86739 0.5 7 0.5H11C11.1326 0.5 11.2598 0.552678 11.3536 0.646447C11.4473 0.740215 11.5 0.867392 11.5 1V4H31C31.1326 4 31.2598 4.05268 31.3536 4.14645C31.4473 4.24021 31.5 4.36739 31.5 4.5V6.5C31.5 6.63261 31.4473 6.75979 31.3536 6.85355C31.2598 6.94732 31.1326 7 31 7H22.5V8H23C23.2652 8 23.5196 8.10536 23.7071 8.29289C23.8946 8.48043 24 8.73478 24 9V11C24 11.2652 23.8946 11.5196 23.7071 11.7071C23.5196 11.8946 23.2652 12 23 12H22.5V13.5C22.5 13.6326 22.5527 13.7598 22.6464 13.8536C22.7402 13.9473 22.8674 14 23 14C23.1326 14 23.2598 13.9473 23.3536 13.8536C23.4473 13.7598 23.5 13.6326 23.5 13.5V13H24.5V13.5C24.4994 13.7119 24.4536 13.9212 24.3656 14.114C24.2777 14.3068 24.1496 14.4786 23.99 14.618L29.3 18.6L29.295 18.607C29.3577 18.6518 29.4089 18.7107 29.4445 18.779C29.4801 18.8473 29.4991 18.923 29.5 19V25C29.5 25.1326 29.4473 25.2598 29.3536 25.3536C29.2598 25.4473 29.1326 25.5 29 25.5H17C16.8674 25.5 16.7402 25.4473 16.6464 25.3536C16.5527 25.2598 16.5 25.1326 16.5 25V19C16.5009 18.923 16.5199 18.8473 16.5555 18.779C16.5911 18.7107 16.6424 18.6518 16.705 18.607L16.7 18.6L22.01 14.618C21.8504 14.4786 21.7223 14.3068 21.6344 14.114C21.5464 13.9212 21.5006 13.7119 21.5 13.5V12H21C20.7348 12 20.4804 11.8946 20.2929 11.7071C20.1054 11.5196 20 11.2652 20 11V9C20 8.73478 20.1054 8.48043 20.2929 8.29289C20.4804 8.10536 20.7348 8 21 8H21.5V7H11.5V23.5H12.5C12.7652 23.5 13.0196 23.6054 13.2071 23.7929C13.3946 23.9804 13.5 24.2348 13.5 24.5V28.592C13.7915 28.695 14.044 28.8856 14.223 29.1376C14.402 29.3897 14.4987 29.6909 14.5 30V31C14.5 31.1326 14.4473 31.2598 14.3536 31.3536C14.2598 31.4473 14.1326 31.5 14 31.5H4C3.86739 31.5 3.74022 31.4473 3.64645 31.3536C3.55268 31.2598 3.5 31.1326 3.5 31V30C3.50128 29.6909 3.59804 29.3897 3.77704 29.1376C3.95605 28.8856 4.20855 28.695 4.5 28.592V24.5C4.5 24.2348 4.60536 23.9804 4.79289 23.7929C4.98043 23.6054 5.23478 23.5 5.5 23.5H6.5V7H4.5V8H5C5.13261 8 5.25978 8.05268 5.35355 8.14645C5.44732 8.24021 5.5 8.36739 5.5 8.5V12.5C5.5 12.6326 5.44732 12.7598 5.35355 12.8536C5.25978 12.9473 5.13261 13 5 13H1C0.867392 13 0.740215 12.9473 0.646446 12.8536C0.552677 12.7598 0.5 12.6326 0.5 12.5V8.5C0.5 8.36739 0.552677 8.24021 0.646446 8.14645C0.740215 8.05268 0.867392 8 1 8H1.5V7H1ZM23 15.125L18.5 18.5H27.5L23 15.125ZM17.5 24.5H28.5V19.5H17.5V24.5ZM21 11H23V9H21V11ZM7.5 3.4L9.6695 1.5H7.5V3.4ZM10.5 2.1L8.3305 4H10.5V2.1ZM30.5 6V5H22.5V6H30.5ZM21.5 5H1.5V6H21.5V5ZM10.5 13.45L7.8825 15.25L10.5 17.05V13.45ZM10.5 18.95L7.8825 20.75L10.5 22.55V18.95ZM7.5 19.8L10.1175 18L7.5 16.2V19.8ZM7.5 14.3L10.1175 12.5L7.5 10.7V14.3ZM10.5 11.55V7.95L7.8825 9.75L10.5 11.55ZM4.5 30.5H13.5V30C13.5 29.8674 13.4473 29.7402 13.3536 29.6464C13.2598 29.5527 13.1326 29.5 13 29.5H5C4.86739 29.5 4.74022 29.5527 4.64645 29.6464C4.55268 29.7402 4.5 29.8674 4.5 30V30.5ZM5.5 28.5H12.5V24.5H5.5V28.5ZM10.1175 23.5L7.5 21.7V23.5H10.1175ZM7.5 8.8L10.1175 7H7.5V8.8ZM1.5 12H4.5V9H1.5V12ZM2.5 8H3.5V7H2.5V8Z"
          fill="url(#paint0_linear_11439_30663)"
        />
        <path
          d="M26.5 20.5H27.5V23.5H26.5V20.5Z"
          fill="url(#paint1_linear_11439_30663)"
        />
        <path
          d="M24.5 20.5H25.5V23.5H24.5V20.5Z"
          fill="url(#paint2_linear_11439_30663)"
        />
        <path
          d="M22.5 20.5H23.5V23.5H22.5V20.5Z"
          fill="url(#paint3_linear_11439_30663)"
        />
        <path
          d="M20.5 20.5H21.5V23.5H20.5V20.5Z"
          fill="url(#paint4_linear_11439_30663)"
        />
        <path
          d="M18.5 20.5H19.5V23.5H18.5V20.5Z"
          fill="url(#paint5_linear_11439_30663)"
        />
      </g>
      <defs>
        <linearGradient
          id="paint0_linear_11439_30663"
          x1="31.5"
          y1="0.5"
          x2="-5.90647"
          y2="16.7788"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0.234375" stopColor="#A584EA" />
          <stop offset="1" stopColor="#5D87FF" />
        </linearGradient>
        <linearGradient
          id="paint1_linear_11439_30663"
          x1="27.5"
          y1="20.5"
          x2="26.0944"
          y2="20.7039"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0.234375" stopColor="#A584EA" />
          <stop offset="1" stopColor="#5D87FF" />
        </linearGradient>
        <linearGradient
          id="paint2_linear_11439_30663"
          x1="25.5"
          y1="20.5"
          x2="24.0944"
          y2="20.7039"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0.234375" stopColor="#A584EA" />
          <stop offset="1" stopColor="#5D87FF" />
        </linearGradient>
        <linearGradient
          id="paint3_linear_11439_30663"
          x1="23.5"
          y1="20.5"
          x2="22.0944"
          y2="20.7039"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0.234375" stopColor="#A584EA" />
          <stop offset="1" stopColor="#5D87FF" />
        </linearGradient>
        <linearGradient
          id="paint4_linear_11439_30663"
          x1="21.5"
          y1="20.5"
          x2="20.0944"
          y2="20.7039"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0.234375" stopColor="#A584EA" />
          <stop offset="1" stopColor="#5D87FF" />
        </linearGradient>
        <linearGradient
          id="paint5_linear_11439_30663"
          x1="19.5"
          y1="20.5"
          x2="18.0944"
          y2="20.7039"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0.234375" stopColor="#A584EA" />
          <stop offset="1" stopColor="#5D87FF" />
        </linearGradient>
        <clipPath id="clip0_11439_30663">
          <rect
            width="32"
            height="32"
            fill="white"
            transform="matrix(-1 0 0 1 32 0)"
          />
        </clipPath>
      </defs>
    </svg>
  );
}
export function DestinationDoorIcon() {
  return (
    <svg
      width="33"
      height="32"
      viewBox="0 0 33 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M16.479 3.00065C16.3932 3.00338 16.3095 3.02818 16.236 3.07265L1.74202 12.0686C1.65003 12.1261 1.57923 12.212 1.54031 12.3133C1.50139 12.4145 1.49645 12.5257 1.52626 12.63C1.55606 12.7343 1.61898 12.8261 1.70552 12.8915C1.79207 12.9569 1.89754 12.9924 2.00602 12.9926H3.50002V28.4966C3.50002 28.6293 3.5527 28.7564 3.64647 28.8502C3.74024 28.944 3.86741 28.9966 4.00002 28.9966H7.00002C7.13263 28.9966 7.25981 28.944 7.35358 28.8502C7.44734 28.7564 7.50002 28.6293 7.50002 28.4966V14.9926H25.5V28.4966C25.5 28.6293 25.5527 28.7564 25.6465 28.8502C25.7402 28.944 25.8674 28.9966 26 28.9966H29C29.1326 28.9966 29.2598 28.944 29.3536 28.8502C29.4473 28.7564 29.5 28.6293 29.5 28.4966V12.9926H30.994C31.1025 12.9924 31.208 12.9569 31.2945 12.8915C31.3811 12.8261 31.444 12.7343 31.4738 12.63C31.5036 12.5257 31.4987 12.4145 31.4597 12.3133C31.4208 12.212 31.35 12.1261 31.258 12.0686L16.764 3.07265C16.6784 3.02063 16.5791 2.99555 16.479 3.00065ZM16.5 4.08865L29.238 11.9946H29C28.8674 11.9946 28.7402 12.0473 28.6465 12.1411C28.5527 12.2349 28.5 12.362 28.5 12.4946V27.9986H26.5V14.4946C26.5 14.362 26.4473 14.2349 26.3536 14.1411C26.2598 14.0473 26.1326 13.9946 26 13.9946H7.00002C6.86741 13.9946 6.74024 14.0473 6.64647 14.1411C6.5527 14.2349 6.50002 14.362 6.50002 14.4946V27.9986H4.50002V12.4946C4.50002 12.362 4.44734 12.2349 4.35358 12.1411C4.25981 12.0473 4.13263 11.9946 4.00002 11.9946H3.76202L16.5 4.08865ZM13.45 7.99865C13.3844 8.00193 13.32 8.01811 13.2606 8.04628C13.2012 8.07444 13.1479 8.11402 13.1038 8.16277C13.0147 8.26123 12.9684 8.39104 12.975 8.52365C12.9817 8.65626 13.0407 8.7808 13.1391 8.86988C13.2376 8.95896 13.3674 9.00528 13.5 8.99865H19.5C19.6326 8.99865 19.7598 8.94597 19.8536 8.8522C19.9473 8.75843 20 8.63126 20 8.49865C20 8.36604 19.9473 8.23886 19.8536 8.14509C19.7598 8.05133 19.6326 7.99865 19.5 7.99865H13.5C13.4834 7.99781 13.4667 7.99781 13.45 7.99865ZM11.45 9.99865C11.3174 10.0053 11.1929 10.0643 11.1038 10.1628C11.0147 10.2612 10.9684 10.391 10.975 10.5236C10.9817 10.6563 11.0407 10.7808 11.1391 10.8699C11.2376 10.959 11.3674 11.0053 11.5 10.9986H21.5C21.6326 10.9986 21.7598 10.946 21.8536 10.8522C21.9473 10.7584 22 10.6313 22 10.4986C22 10.366 21.9473 10.2389 21.8536 10.1451C21.7598 10.0513 21.6326 9.99865 21.5 9.99865H11.5C11.4834 9.99781 11.4667 9.99781 11.45 9.99865ZM16.992 16.9926C16.9672 16.9928 16.9425 16.9948 16.918 16.9986H15C14.8674 16.9986 14.7402 17.0513 14.6465 17.1451C14.5527 17.2389 14.5 17.366 14.5 17.4986V21.5626L12.273 20.6026C12.1852 20.5478 12.0824 20.5216 11.979 20.5276C11.897 20.5305 11.817 20.5535 11.746 20.5946L8.90202 21.8206C8.79987 21.8427 8.7072 21.8962 8.63702 21.9736C8.61683 21.994 8.59843 22.0161 8.58202 22.0396C8.57998 22.043 8.57798 22.0463 8.57602 22.0496C8.50977 22.1524 8.48344 22.2758 8.50202 22.3966V26.1566C8.49835 26.2001 8.50037 26.2438 8.50802 26.2866C8.5093 26.291 8.51063 26.2953 8.51202 26.2996C8.51261 26.3047 8.51328 26.3097 8.51402 26.3146C8.51605 26.3247 8.51838 26.3347 8.52102 26.3446C8.52232 26.348 8.52365 26.3513 8.52502 26.3546C8.52915 26.3678 8.53382 26.3808 8.53902 26.3936C8.54034 26.396 8.54167 26.3983 8.54302 26.4006C8.54843 26.4142 8.55444 26.4276 8.56102 26.4406C8.56427 26.4457 8.5676 26.4507 8.57102 26.4556C8.6349 26.5662 8.73866 26.6481 8.86102 26.6846L11.756 27.9346C11.76 27.9364 11.764 27.938 11.768 27.9396C11.7918 27.9523 11.8165 27.963 11.842 27.9716C11.9107 27.9939 11.9833 28.0011 12.055 27.9926C12.0557 27.9926 12.0564 27.9926 12.057 27.9926C12.0688 27.9911 12.0804 27.9891 12.092 27.9866C12.097 27.9861 12.102 27.9854 12.107 27.9846C12.1184 27.9827 12.1298 27.9804 12.141 27.9776C12.1454 27.9764 12.1497 27.975 12.154 27.9736C12.17 27.9678 12.1857 27.9611 12.201 27.9536C12.2164 27.9474 12.2314 27.9404 12.246 27.9326C12.2474 27.932 12.2487 27.9313 12.25 27.9306L14.5 26.9586V27.4976C14.5 27.6303 14.5527 27.7574 14.6465 27.8512C14.7402 27.945 14.8674 27.9976 15 27.9976H21C21.1326 27.9976 21.2598 27.945 21.3536 27.8512C21.4473 27.7574 21.5 27.6303 21.5 27.4976V17.4976C21.5 17.365 21.4473 17.2379 21.3536 17.1441C21.2598 17.0503 21.1326 16.9976 21 16.9976H19.078C19.0496 16.9932 19.0208 16.9912 18.992 16.9916C18.9672 16.9918 18.9425 16.9938 18.918 16.9976H17.078C17.0496 16.9932 17.0208 16.9922 16.992 16.9926ZM15.5 17.9986H16.5V19.4046C16.4854 19.4823 16.4895 19.5624 16.5118 19.6382C16.5341 19.714 16.5741 19.7834 16.6284 19.8408C16.6828 19.8982 16.75 19.9419 16.8245 19.9683C16.899 19.9947 16.9787 20.003 17.057 19.9926C17.0715 19.9906 17.0858 19.9879 17.1 19.9846C17.1024 19.984 17.1047 19.9833 17.107 19.9826C17.1365 19.9756 17.1653 19.9659 17.193 19.9536C17.1957 19.953 17.1984 19.9523 17.201 19.9516C17.2064 19.9491 17.2117 19.9464 17.217 19.9436L17.247 19.9306C17.2494 19.9293 17.2517 19.928 17.254 19.9266L17.992 19.5556L18.77 19.9436C18.8586 19.9884 18.9585 20.0058 19.057 19.9936C19.0745 19.9912 19.0919 19.9879 19.109 19.9836C19.1144 19.9821 19.1197 19.9804 19.125 19.9786C19.1351 19.9766 19.1451 19.9743 19.155 19.9716C19.156 19.971 19.157 19.9703 19.158 19.9696C19.1886 19.9592 19.2181 19.9458 19.246 19.9296C19.2467 19.9293 19.2474 19.929 19.248 19.9286C19.2621 19.9207 19.2758 19.912 19.289 19.9026C19.2897 19.902 19.2904 19.9013 19.291 19.9006C19.3048 19.8913 19.3182 19.8813 19.331 19.8706C19.3422 19.8605 19.3528 19.8498 19.363 19.8386C19.4525 19.7442 19.5016 19.6187 19.5 19.4886V17.9986H20.5V21.9986H19.117C19.0761 21.9887 19.0341 21.984 18.992 21.9846C18.9539 21.985 18.916 21.9897 18.879 21.9986H17.117C17.0761 21.9887 17.0341 21.984 16.992 21.9846C16.9539 21.985 16.916 21.9897 16.879 21.9986H15.5V17.9986ZM17.5 17.9986H18.5V18.6896L18.217 18.5496C18.1421 18.512 18.0589 18.4937 17.975 18.4966C17.9037 18.4995 17.8338 18.5175 17.77 18.5496L17.5 18.6846V17.9986ZM12 21.5746L13.734 22.3226L12 23.0706L11.293 22.7666L10.263 22.3226L12 21.5746ZM15.5 22.9986H16.5V24.4046C16.4877 24.47 16.4884 24.5371 16.5023 24.6021C16.5162 24.6672 16.543 24.7288 16.581 24.7833C16.619 24.8379 16.6674 24.8843 16.7236 24.9199C16.7798 24.9555 16.8425 24.9796 16.908 24.9906C16.9216 24.9932 16.9353 24.9952 16.949 24.9966C16.9686 24.9985 16.9883 24.9991 17.008 24.9986C17.1002 24.9971 17.1902 24.9701 17.268 24.9206L17.992 24.5596L18.77 24.9456C18.7998 24.9604 18.8309 24.9721 18.863 24.9806C18.8779 24.9847 18.8929 24.988 18.908 24.9906C18.941 24.9967 18.9745 24.9993 19.008 24.9986C19.0094 24.9987 19.0107 24.9987 19.012 24.9986C19.0134 24.9987 19.0147 24.9987 19.016 24.9986C19.1469 24.9945 19.2709 24.9391 19.3614 24.8445C19.4519 24.7499 19.5017 24.6236 19.5 24.4926V22.9986H20.5V26.9986H15.5V26.2366C15.5009 26.22 15.5009 26.2033 15.5 26.1866V22.9986ZM17.5 22.9986H18.5V23.6936L18.217 23.5516C18.1419 23.5147 18.0587 23.4971 17.975 23.5006C17.9039 23.5025 17.834 23.5196 17.77 23.5506L17.5 23.6866V22.9986ZM9.50202 23.0826L9.80502 23.2126L10.896 23.6846L11.5 23.9446V26.7346L9.50202 25.8716V23.0826ZM14.498 23.0826V25.8716L12.5 26.7346V23.9446L14.498 23.0826Z"
        fill="url(#paint0_linear_11439_30677)"
      />
      <defs>
        <linearGradient
          id="paint0_linear_11439_30677"
          x1="1.50702"
          y1="3"
          x2="35.8812"
          y2="20.2547"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0.234375" stopColor="#A584EA" />
          <stop offset="1" stopColor="#5D87FF" />
        </linearGradient>
      </defs>
    </svg>
  );
}
export function ByAirRedIcon() {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M22.5656 11.4975C22.3594 10.9209 21.2203 10.1709 20.1188 9.88968C19.5797 9.75374 19.0547 9.70218 18.1828 9.70218H17.4L14.0531 5.56779C11.8359 2.82091 10.6734 1.42404 10.6125 1.41466C10.4766 1.39591 8.99532 1.82248 8.89688 1.91154C8.85001 1.94904 8.81251 2.00998 8.81251 2.04279C8.81251 2.07091 9.22032 3.06466 9.72188 4.2506C11.7375 9.02249 12 9.64593 12 9.67405C12 9.68811 11.5734 9.70218 11.0531 9.70218C9.07501 9.70218 7.95469 9.8803 6.12657 10.4803C5.39063 10.7241 5.32969 10.7381 5.25469 10.6631C5.20782 10.6256 4.69688 10.0397 4.12032 9.37405L3.07031 8.1553L2.83594 8.15999C2.39063 8.16467 1.50938 8.27717 1.43438 8.33811C1.39219 8.37092 1.35938 8.44592 1.35938 8.49749C1.35938 8.54905 1.69688 9.22874 2.10469 10.0022C2.51719 10.7803 2.85938 11.4412 2.86875 11.4787C2.87813 11.5162 2.79844 11.5725 2.66719 11.6194C2.3625 11.7225 2.29688 11.7928 2.29688 11.9991C2.29688 12.2053 2.3625 12.2756 2.66719 12.3787C2.80313 12.4256 2.87813 12.4819 2.86875 12.5194C2.85938 12.5569 2.51719 13.2225 2.10469 13.9959C1.69688 14.7741 1.35938 15.4537 1.35938 15.5053C1.35938 15.5569 1.39219 15.6272 1.43438 15.66C1.50938 15.7209 2.38594 15.8334 2.83594 15.8381L3.07031 15.8428L4.14375 14.6006C4.73438 13.9162 5.24532 13.335 5.27813 13.3069C5.325 13.2694 5.54063 13.3256 6.12657 13.5178C7.95001 14.1178 9.10313 14.2959 11.1 14.2959C11.9438 14.2959 12.0094 14.3006 11.9859 14.3803C11.9719 14.4225 11.2547 16.1334 10.3875 18.1819C9.52032 20.2303 8.81251 21.9272 8.81251 21.96C8.81251 21.9881 8.85001 22.0491 8.89688 22.0866C8.99532 22.1756 10.4766 22.6022 10.6125 22.5834C10.6781 22.5741 11.7938 21.2288 14.0485 18.4444L17.386 14.3194L18.4078 14.2912C19.9781 14.2444 20.7469 14.0334 21.7313 13.3819C22.1906 13.0772 22.4672 12.7772 22.5656 12.4819C22.6594 12.2147 22.6547 11.76 22.5656 11.4975ZM22.0781 12.4209C21.8719 12.8241 20.836 13.4334 19.9453 13.6772L19.4766 13.8037L14.5313 13.8037C9.00001 13.8037 8.99532 13.8037 7.52344 13.4475C7.06407 13.335 3.09375 12.0366 3.09375 11.9991C3.09375 11.9616 7.03594 10.6678 7.52344 10.5459C8.92501 10.1897 9.50157 10.1616 14.9063 10.1803L19.4766 10.1944L19.9453 10.3209C20.8219 10.56 21.8672 11.1694 22.0735 11.5631C22.2 11.8022 22.2 12.1819 22.0781 12.4209ZM14.6531 9.70218H12.5297L12.1313 8.7553C11.9109 8.2303 11.2078 6.57092 10.5703 5.06154C9.93282 3.55217 9.40313 2.29591 9.38907 2.26779C9.3797 2.23498 9.58595 2.15529 9.91407 2.06154C10.4484 1.90685 10.4625 1.90685 10.5469 1.99591C10.6359 2.08498 16.7766 9.66936 16.7813 9.6928C16.7813 9.69749 15.825 9.70218 14.6531 9.70218ZM13.5703 18.2991C11.8969 20.3756 10.4953 22.0725 10.4625 22.0725C10.3172 22.0819 9.37032 21.7772 9.39376 21.7303C9.40313 21.7022 9.76876 20.835 10.2047 19.8038C10.6406 18.7725 11.3438 17.1131 11.7656 16.1147L12.5344 14.2959H14.6625H16.7906L16.7016 14.4131C16.6547 14.4741 15.2485 16.2225 13.5703 18.2991ZM4.0875 11.1459C3.58594 11.31 3.36563 11.3616 3.34219 11.3241C3.13125 10.9912 1.97813 8.73655 2.00625 8.71311C2.025 8.69436 2.22188 8.66624 2.44219 8.64749L2.84531 8.61467L3.82969 9.75843C4.37344 10.3866 4.81407 10.9022 4.80938 10.9069C4.80469 10.9116 4.48125 11.0194 4.0875 11.1459ZM3.73125 14.3616L2.84531 15.3834L2.44219 15.3506C2.22188 15.3319 2.025 15.3037 2.00625 15.285C1.96406 15.2475 3.34688 12.6272 3.40313 12.6412C3.42656 12.6412 3.75469 12.7444 4.13438 12.8662L4.82813 13.0866L4.72032 13.2131C4.66407 13.2834 4.21875 13.7991 3.73125 14.3616Z"
        fill="url(#paint0_linear_11439_27234)"
      />
      <path
        d="M18.9281 11.0719C18.8906 11.0344 18.6562 11.0156 18.1875 11.0156C17.4469 11.0156 17.3906 11.0344 17.3906 11.2594C17.3906 11.4469 17.5219 11.4844 18.1875 11.4844C18.8531 11.4844 18.9844 11.4469 18.9844 11.2594C18.9844 11.1891 18.9609 11.1047 18.9281 11.0719Z"
        fill="url(#paint1_linear_11439_27234)"
      />
      <path
        d="M16.6125 11.0906C16.5516 11.0297 16.4156 11.0156 15.8484 11.0156C15.1219 11.0156 15.0469 11.0344 15.0469 11.2313C15.0469 11.4375 15.2016 11.4844 15.8766 11.4844C16.4391 11.4844 16.5094 11.475 16.5938 11.3906C16.7063 11.2781 16.7109 11.1891 16.6125 11.0906Z"
        fill="url(#paint2_linear_11439_27234)"
      />
      <path
        d="M14.2922 11.1C14.25 11.025 14.1609 11.0156 13.5328 11.0156C12.7734 11.0156 12.7031 11.0344 12.7031 11.2313C12.7031 11.4375 12.8578 11.4844 13.5328 11.4844C14.0953 11.4844 14.1656 11.475 14.25 11.3906C14.3531 11.2875 14.3625 11.2172 14.2922 11.1Z"
        fill="url(#paint3_linear_11439_27234)"
      />
      <path
        d="M11.9484 11.1C11.9063 11.025 11.8172 11.0156 11.1891 11.0156C10.4297 11.0156 10.3594 11.0344 10.3594 11.2313C10.3594 11.4375 10.5141 11.4844 11.1797 11.4844C11.6578 11.4844 11.8125 11.4703 11.8969 11.4094C12.0094 11.3344 12.0234 11.2266 11.9484 11.1Z"
        fill="url(#paint4_linear_11439_27234)"
      />
      <path
        d="M9.60008 11.0719C9.56258 11.0344 9.32352 11.0156 8.82665 11.0156C8.1704 11.0156 8.10946 11.025 8.06258 11.1047C7.99696 11.2359 8.00165 11.2828 8.10946 11.3906C8.19383 11.475 8.26415 11.4844 8.82665 11.4844C9.31414 11.4844 9.46883 11.4703 9.55321 11.4094C9.66571 11.3297 9.68914 11.1609 9.60008 11.0719Z"
        fill="url(#paint5_linear_11439_27234)"
      />
      <defs>
        <linearGradient
          id="paint0_linear_11439_27234"
          x1="1.35938"
          y1="11.9991"
          x2="22.6342"
          y2="11.9991"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#F09090" />
          <stop offset="1" stopColor="#FA0000" />
        </linearGradient>
        <linearGradient
          id="paint1_linear_11439_27234"
          x1="17.3906"
          y1="11.25"
          x2="18.9844"
          y2="11.25"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#F09090" />
          <stop offset="1" stopColor="#FA0000" />
        </linearGradient>
        <linearGradient
          id="paint2_linear_11439_27234"
          x1="15.0469"
          y1="11.25"
          x2="16.6825"
          y2="11.25"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#F09090" />
          <stop offset="1" stopColor="#FA0000" />
        </linearGradient>
        <linearGradient
          id="paint3_linear_11439_27234"
          x1="12.7031"
          y1="11.25"
          x2="14.3376"
          y2="11.25"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#F09090" />
          <stop offset="1" stopColor="#FA0000" />
        </linearGradient>
        <linearGradient
          id="paint4_linear_11439_27234"
          x1="10.3594"
          y1="11.25"
          x2="11.9951"
          y2="11.25"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#F09090" />
          <stop offset="1" stopColor="#FA0000" />
        </linearGradient>
        <linearGradient
          id="paint5_linear_11439_27234"
          x1="8.01953"
          y1="11.25"
          x2="9.65451"
          y2="11.25"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#F09090" />
          <stop offset="1" stopColor="#FA0000" />
        </linearGradient>
      </defs>
    </svg>
  );
}
export function RedDomesticTruckIcon({ size, color }) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_11439_29336)">
        <path
          d="M1.125 3C1.02554 3 0.930161 3.03951 0.859835 3.10984C0.789509 3.18016 0.75 3.27554 0.75 3.375V14.25H0.375C0.275544 14.25 0.180161 14.2895 0.109835 14.3598C0.0395088 14.4302 0 14.5255 0 14.625L0 16.125C0 16.2245 0.0395088 16.3198 0.109835 16.3902C0.180161 16.4605 0.275544 16.5 0.375 16.5H2.391C2.47658 16.5116 2.56354 16.4933 2.63719 16.4482C2.71084 16.4031 2.76667 16.334 2.79525 16.2525C2.97525 15.741 3.29475 15.3 3.702 14.9573C3.74794 14.9328 3.7883 14.8991 3.8205 14.8583C4.34391 14.4601 4.98436 14.2464 5.64196 14.2505C6.29955 14.2546 6.93731 14.4762 7.45575 14.8807C7.4783 14.9053 7.50403 14.9267 7.53225 14.9445C7.9561 15.2915 8.27672 15.748 8.45925 16.2645C8.47434 16.3163 8.50045 16.3643 8.53578 16.4051C8.57111 16.4459 8.61484 16.4786 8.66397 16.501C8.7131 16.5233 8.76649 16.5348 8.82047 16.5347C8.87445 16.5345 8.92776 16.5227 8.97675 16.5H14.7555C14.7585 16.5 14.7615 16.5 14.7645 16.5C14.8502 16.5118 14.9373 16.4936 15.0111 16.4485C15.0849 16.4034 15.1409 16.3341 15.1695 16.2525C15.3757 15.6666 15.7588 15.1592 16.2659 14.8005C16.7729 14.4418 17.3789 14.2494 18 14.25C18.6233 14.2495 19.2313 14.4432 19.7394 14.8042C20.2475 15.1653 20.6305 15.6757 20.835 16.2645C20.8501 16.3162 20.8762 16.3641 20.9115 16.4048C20.9468 16.4456 20.9904 16.4782 21.0394 16.5006C21.0885 16.5229 21.1418 16.5345 21.1957 16.5344C21.2496 16.5342 21.3028 16.5225 21.3517 16.5H23.625C23.7245 16.5 23.8198 16.4605 23.8902 16.3902C23.9605 16.3198 24 16.2245 24 16.125V14.625C24 14.5255 23.9605 14.4302 23.8902 14.3598C23.8198 14.2895 23.7245 14.25 23.625 14.25H23.25V12.4012C23.2503 12.3925 23.2503 12.3837 23.25 12.375V8.625C23.2498 8.56538 23.2355 8.50665 23.2081 8.4537C23.1807 8.40074 23.1411 8.35508 23.0925 8.3205C23.0913 8.31949 23.09 8.31849 23.0887 8.3175L19.203 3.8775C19.1677 3.83731 19.1242 3.80514 19.0754 3.78315C19.0267 3.76116 18.9737 3.74985 18.9202 3.75H13.5V3.375C13.5 3.27554 13.4605 3.18016 13.3902 3.10984C13.3198 3.03951 13.2245 3 13.125 3H1.125ZM1.5 3.75H12.75V9.75H1.5V3.75ZM13.5 4.5H18.75L22.0328 8.25H13.5V4.5ZM13.5 9H22.5V10.5H21.375C21.2755 10.5 21.1802 10.5395 21.1098 10.6098C21.0395 10.6802 21 10.7755 21 10.875V12.375C21 12.4745 21.0395 12.5698 21.1098 12.6402C21.1802 12.7105 21.2755 12.75 21.375 12.75H22.5V14.25H20.241C19.5948 13.7636 18.8078 13.5007 17.999 13.5009C17.1902 13.5012 16.4034 13.7647 15.7575 14.2515C15.751 14.2508 15.7445 14.2503 15.738 14.25H13.5V9ZM15.2797 10.125C15.1803 10.125 15.0849 10.1645 15.0146 10.2348C14.9443 10.3052 14.9047 10.4005 14.9047 10.5C14.9047 10.5995 14.9443 10.6948 15.0146 10.7652C15.0849 10.8355 15.1803 10.875 15.2797 10.875H16.9642C17.0637 10.875 17.1591 10.8355 17.2294 10.7652C17.2997 10.6948 17.3392 10.5995 17.3392 10.5C17.3392 10.4005 17.2997 10.3052 17.2294 10.2348C17.1591 10.1645 17.0637 10.125 16.9642 10.125H15.2797ZM1.5 10.5H12.75V14.25H7.866C7.22008 13.7637 6.43351 13.5007 5.625 13.5007C4.81649 13.5007 4.02992 13.7637 3.384 14.25H1.5V12.75H2.7C2.79946 12.75 2.89484 12.7105 2.96517 12.6402C3.03549 12.5698 3.075 12.4745 3.075 12.375C3.075 12.2755 3.03549 12.1802 2.96517 12.1098C2.89484 12.0395 2.79946 12 2.7 12H1.5V10.5ZM21.75 11.25H22.5V12H21.75V11.25ZM0.75 15H2.6265C2.454 15.2295 2.31675 15.4838 2.2005 15.75H0.75V15ZM5.625 15C4.92929 15.0016 4.26254 15.2787 3.7706 15.7706C3.27866 16.2625 3.00158 16.9293 3 17.625C3 19.0702 4.17975 20.25 5.625 20.25C7.07025 20.25 8.25 19.0702 8.25 17.625C8.25 16.1798 7.07025 15 5.625 15ZM8.625 15H13.0568C13.0997 15.0075 13.1436 15.0075 13.1865 15H15.0015C14.829 15.2295 14.6917 15.4838 14.5755 15.75H9.0495C8.93735 15.4845 8.79491 15.2328 8.625 15ZM18 15C17.3043 15.0016 16.6375 15.2787 16.1456 15.7706C15.6537 16.2625 15.3766 16.9293 15.375 17.625C15.375 19.0702 16.5548 20.25 18 20.25C19.4452 20.25 20.625 19.0702 20.625 17.625C20.625 16.1798 19.4452 15 18 15ZM21 15H23.25V15.75H21.4245C21.3124 15.4845 21.1699 15.2328 21 15ZM5.625 15.75C6.66525 15.75 7.5 16.5848 7.5 17.625C7.5 18.6652 6.66525 19.5 5.625 19.5C5.37855 19.5008 5.13438 19.4528 4.90653 19.3589C4.67869 19.2649 4.47168 19.1269 4.29741 18.9526C4.12314 18.7783 3.98506 18.5713 3.89111 18.3435C3.79716 18.1156 3.74921 17.8715 3.75 17.625C3.75 16.5848 4.58475 15.75 5.625 15.75ZM18 15.75C19.0403 15.75 19.875 16.5848 19.875 17.625C19.875 18.6652 19.0403 19.5 18 19.5C17.7535 19.5008 17.5094 19.4528 17.2815 19.3589C17.0537 19.2649 16.8467 19.1269 16.6724 18.9526C16.4981 18.7783 16.3601 18.5713 16.2661 18.3435C16.1722 18.1156 16.1242 17.8715 16.125 17.625C16.125 16.5848 16.9597 15.75 18 15.75ZM5.625 16.5C5.00775 16.5 4.5 17.0077 4.5 17.625C4.5 18.2423 5.00775 18.75 5.625 18.75C6.24225 18.75 6.75 18.2423 6.75 17.625C6.75 17.0077 6.24225 16.5 5.625 16.5ZM18 16.5C17.3827 16.5 16.875 17.0077 16.875 17.625C16.875 18.2423 17.3827 18.75 18 18.75C18.6173 18.75 19.125 18.2423 19.125 17.625C19.125 17.0077 18.6173 16.5 18 16.5ZM5.625 17.25C5.8365 17.25 6 17.4135 6 17.625C6 17.8365 5.8365 18 5.625 18C5.57556 18.0007 5.52648 17.9915 5.48066 17.9729C5.43484 17.9543 5.39322 17.9267 5.35826 17.8917C5.3233 17.8568 5.2957 17.8152 5.2771 17.7693C5.25851 17.7235 5.24929 17.6744 5.25 17.625C5.25 17.4135 5.4135 17.25 5.625 17.25ZM18 17.25C18.2115 17.25 18.375 17.4135 18.375 17.625C18.375 17.8365 18.2115 18 18 18C17.9506 18.0007 17.9015 17.9915 17.8557 17.9729C17.8098 17.9543 17.7682 17.9267 17.7333 17.8917C17.6983 17.8568 17.6707 17.8152 17.6521 17.7693C17.6335 17.7235 17.6243 17.6744 17.625 17.625C17.625 17.4135 17.7885 17.25 18 17.25Z"
          fill={color}
        />
      </g>
    </svg>
  );
}
RedDomesticTruckIcon.propTypes = {
  size: PropTypes.string,
  color: PropTypes.string,
};
RedDomesticTruckIcon.defaultProps = {
  size: '40',
  color: '#FA0000',
};
export function PurpleDomesticTruckIcon({ size }) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 40 40"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_13721_6039)">
        <path
          d="M1.875 5C1.70924 5 1.55027 5.06585 1.43306 5.18306C1.31585 5.30027 1.25 5.45924 1.25 5.625V23.75H0.625C0.45924 23.75 0.300269 23.8158 0.183058 23.9331C0.065848 24.0503 0 24.2092 0 24.375L0 26.875C0 27.0408 0.065848 27.1997 0.183058 27.3169C0.300269 27.4342 0.45924 27.5 0.625 27.5H3.985C4.12763 27.5193 4.27256 27.4889 4.39531 27.4137C4.51807 27.3385 4.61112 27.2233 4.65875 27.0875C4.95875 26.235 5.49125 25.5 6.17 24.9288C6.24657 24.888 6.31383 24.8319 6.3675 24.7638C7.23984 24.1002 8.30727 23.7441 9.40326 23.7509C10.4993 23.7576 11.5622 24.127 12.4263 24.8013C12.4638 24.8422 12.5067 24.8779 12.5538 24.9075C13.2602 25.4858 13.7945 26.2467 14.0988 27.1075C14.1239 27.1939 14.1674 27.2738 14.2263 27.3418C14.2852 27.4099 14.3581 27.4644 14.44 27.5016C14.5218 27.5389 14.6108 27.558 14.7008 27.5578C14.7907 27.5575 14.8796 27.5378 14.9613 27.5H24.5925C24.5975 27.5001 24.6025 27.5001 24.6075 27.5C24.7503 27.5196 24.8955 27.4893 25.0186 27.4141C25.1416 27.339 25.2348 27.2236 25.2825 27.0875C25.6262 26.111 26.2647 25.2654 27.1098 24.6675C27.9549 24.0697 28.9648 23.749 30 23.75C31.0389 23.7491 32.0522 24.072 32.899 24.6737C33.7458 25.2755 34.3841 26.1262 34.725 27.1075C34.7502 27.1937 34.7937 27.2735 34.8525 27.3414C34.9113 27.4093 34.984 27.4637 35.0657 27.501C35.1475 27.5382 35.2363 27.5574 35.3261 27.5573C35.4159 27.5571 35.5047 27.5376 35.5863 27.5H39.375C39.5408 27.5 39.6997 27.4342 39.8169 27.3169C39.9342 27.1997 40 27.0408 40 26.875V24.375C40 24.2092 39.9342 24.0503 39.8169 23.9331C39.6997 23.8158 39.5408 23.75 39.375 23.75H38.75V20.6687C38.7505 20.6542 38.7505 20.6396 38.75 20.625V14.375C38.7497 14.2756 38.7258 14.1778 38.6801 14.0895C38.6345 14.0012 38.5684 13.9251 38.4875 13.8675C38.4854 13.8658 38.4833 13.8642 38.4813 13.8625L32.005 6.4625C31.9462 6.39552 31.8737 6.3419 31.7924 6.30524C31.7111 6.26859 31.6229 6.24976 31.5337 6.25H22.5V5.625C22.5 5.45924 22.4342 5.30027 22.3169 5.18306C22.1997 5.06585 22.0408 5 21.875 5H1.875ZM2.5 6.25H21.25V16.25H2.5V6.25ZM22.5 7.5H31.25L36.7213 13.75H22.5V7.5ZM22.5 15H37.5V17.5H35.625C35.4592 17.5 35.3003 17.5658 35.1831 17.6831C35.0658 17.8003 35 17.9592 35 18.125V20.625C35 20.7908 35.0658 20.9497 35.1831 21.0669C35.3003 21.1842 35.4592 21.25 35.625 21.25H37.5V23.75H33.735C32.658 22.9393 31.3464 22.5011 29.9983 22.5015C28.6503 22.502 27.339 22.9411 26.2625 23.7525C26.2517 23.7514 26.2409 23.7506 26.23 23.75H22.5V15ZM25.4662 16.875C25.3005 16.875 25.1415 16.9408 25.0243 17.0581C24.9071 17.1753 24.8412 17.3342 24.8412 17.5C24.8412 17.6658 24.9071 17.8247 25.0243 17.9419C25.1415 18.0592 25.3005 18.125 25.4662 18.125H28.2738C28.4395 18.125 28.5985 18.0592 28.7157 17.9419C28.8329 17.8247 28.8988 17.6658 28.8988 17.5C28.8988 17.3342 28.8329 17.1753 28.7157 17.0581C28.5985 16.9408 28.4395 16.875 28.2738 16.875H25.4662ZM2.5 17.5H21.25V23.75H13.11C12.0335 22.9395 10.7225 22.5012 9.375 22.5012C8.02749 22.5012 6.71654 22.9395 5.64 23.75H2.5V21.25H4.5C4.66576 21.25 4.82473 21.1842 4.94194 21.0669C5.05915 20.9497 5.125 20.7908 5.125 20.625C5.125 20.4592 5.05915 20.3003 4.94194 20.1831C4.82473 20.0658 4.66576 20 4.5 20H2.5V17.5ZM36.25 18.75H37.5V20H36.25V18.75ZM1.25 25H4.3775C4.09 25.3825 3.86125 25.8062 3.6675 26.25H1.25V25ZM9.375 25C8.21549 25.0026 7.10423 25.4644 6.28433 26.2843C5.46443 27.1042 5.00264 28.2155 5 29.375C5 31.7838 6.96625 33.75 9.375 33.75C11.7838 33.75 13.75 31.7838 13.75 29.375C13.75 26.9662 11.7838 25 9.375 25ZM14.375 25H21.7612C21.8328 25.0126 21.906 25.0126 21.9775 25H25.0025C24.715 25.3825 24.4862 25.8062 24.2925 26.25H15.0825C14.8956 25.8075 14.6582 25.388 14.375 25ZM30 25C28.8405 25.0026 27.7292 25.4644 26.9093 26.2843C26.0894 27.1042 25.6276 28.2155 25.625 29.375C25.625 31.7838 27.5912 33.75 30 33.75C32.4087 33.75 34.375 31.7838 34.375 29.375C34.375 26.9662 32.4087 25 30 25ZM35 25H38.75V26.25H35.7075C35.5206 25.8075 35.2832 25.388 35 25ZM9.375 26.25C11.1088 26.25 12.5 27.6413 12.5 29.375C12.5 31.1087 11.1088 32.5 9.375 32.5C8.96425 32.5013 8.55729 32.4214 8.17755 32.2648C7.79781 32.1082 7.45279 31.8781 7.16235 31.5877C6.8719 31.2972 6.64176 30.9522 6.48519 30.5724C6.32861 30.1927 6.24868 29.7858 6.25 29.375C6.25 27.6413 7.64125 26.25 9.375 26.25ZM30 26.25C31.7337 26.25 33.125 27.6413 33.125 29.375C33.125 31.1087 31.7337 32.5 30 32.5C29.5892 32.5013 29.1823 32.4214 28.8026 32.2648C28.4228 32.1082 28.0778 31.8781 27.7873 31.5877C27.4969 31.2972 27.2668 30.9522 27.1102 30.5724C26.9536 30.1927 26.8737 29.7858 26.875 29.375C26.875 27.6413 28.2663 26.25 30 26.25ZM9.375 27.5C8.34625 27.5 7.5 28.3463 7.5 29.375C7.5 30.4037 8.34625 31.25 9.375 31.25C10.4038 31.25 11.25 30.4037 11.25 29.375C11.25 28.3463 10.4038 27.5 9.375 27.5ZM30 27.5C28.9713 27.5 28.125 28.3463 28.125 29.375C28.125 30.4037 28.9713 31.25 30 31.25C31.0287 31.25 31.875 30.4037 31.875 29.375C31.875 28.3463 31.0287 27.5 30 27.5ZM9.375 28.75C9.7275 28.75 10 29.0225 10 29.375C10 29.7275 9.7275 30 9.375 30C9.2926 30.0012 9.2108 29.9858 9.13444 29.9548C9.05807 29.9238 8.98871 29.8778 8.93043 29.8196C8.87216 29.7613 8.82617 29.6919 8.79517 29.6156C8.76418 29.5392 8.74882 29.4574 8.75 29.375C8.75 29.0225 9.0225 28.75 9.375 28.75ZM30 28.75C30.3525 28.75 30.625 29.0225 30.625 29.375C30.625 29.7275 30.3525 30 30 30C29.9176 30.0012 29.8358 29.9858 29.7594 29.9548C29.6831 29.9238 29.6137 29.8778 29.5554 29.8196C29.4972 29.7613 29.4512 29.6919 29.4202 29.6156C29.3892 29.5392 29.3738 29.4574 29.375 29.375C29.375 29.0225 29.6475 28.75 30 28.75Z"
          fill="#4444E2"
        />
      </g>
      <defs>
        <clipPath id="clip0_13721_6039">
          <rect width="40" height="40" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
}
PurpleDomesticTruckIcon.propTypes = {
  size: PropTypes.string,
};
PurpleDomesticTruckIcon.defaultProps = {
  size: '24',
};
export function BoxOutlineIcon({ height, width }) {
  return (
    <svg
      width={width !== '' ? width : '13'}
      height={height !== '' ? height : '12'}
      viewBox="0 0 13 12"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M6.49992 6.65042C6.43492 6.65042 6.36992 6.63543 6.30992 6.60043L1.89493 4.04544C1.71493 3.94044 1.65492 3.71042 1.75992 3.53042C1.86492 3.35042 2.08992 3.29041 2.27492 3.39541L6.49992 5.84042L10.6999 3.41043C10.8799 3.30543 11.1099 3.37044 11.2149 3.54544C11.3199 3.72544 11.2549 3.95542 11.0799 4.06042L6.69493 6.60043C6.62993 6.63043 6.56492 6.65042 6.49992 6.65042Z"
        fill="url(#paint0_linear_11817_9248)"
      />
      <path
        d="M6.5 11.1756C6.295 11.1756 6.125 11.0056 6.125 10.8006V6.26562C6.125 6.06063 6.295 5.89062 6.5 5.89062C6.705 5.89062 6.875 6.06063 6.875 6.26562V10.8006C6.875 11.0056 6.705 11.1756 6.5 11.1756Z"
        fill="url(#paint1_linear_11817_9248)"
      />
      <path
        d="M6.50006 11.375C6.06006 11.375 5.62506 11.28 5.28006 11.09L2.61006 9.60501C1.88506 9.20501 1.32007 8.24 1.32007 7.41V4.58499C1.32007 3.75499 1.88506 2.79501 2.61006 2.39001L5.28006 0.91C5.96506 0.53 7.03506 0.53 7.72006 0.91L10.3901 2.39499C11.1151 2.79499 11.6801 3.75999 11.6801 4.58999V7.415C11.6801 8.245 11.1151 9.20498 10.3901 9.60998L7.72006 11.09C7.37506 11.28 6.94006 11.375 6.50006 11.375ZM6.50006 1.375C6.18506 1.375 5.87507 1.44 5.64507 1.565L2.97507 3.04998C2.49507 3.31998 2.07007 4.03499 2.07007 4.58999V7.415C2.07007 7.965 2.49507 8.68498 2.97507 8.95498L5.64507 10.44C6.10007 10.695 6.90006 10.695 7.35506 10.44L10.0251 8.95498C10.5051 8.68498 10.9301 7.97 10.9301 7.415V4.58999C10.9301 4.03999 10.5051 3.31998 10.0251 3.04998L7.35506 1.565C7.12506 1.44 6.81506 1.375 6.50006 1.375Z"
        fill="url(#paint2_linear_11817_9248)"
      />
      <path
        d="M9.00009 6.99917C8.79509 6.99917 8.62509 6.82917 8.62509 6.62417V5.01419L4.06509 2.38418C3.88509 2.27918 3.82508 2.04917 3.93008 1.87417C4.03508 1.69417 4.26009 1.63416 4.44009 1.73916L9.18509 4.47918C9.30009 4.54418 9.37509 4.66917 9.37509 4.80417V6.63418C9.37509 6.82918 9.20509 6.99917 9.00009 6.99917Z"
        fill="url(#paint3_linear_11817_9248)"
      />
      <defs>
        <linearGradient
          id="paint0_linear_11817_9248"
          x1="1.70825"
          y1="4.99708"
          x2="11.2655"
          y2="4.99708"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#A4C9FF" />
          <stop offset="1" stopColor="#C4DCFF" />
        </linearGradient>
        <linearGradient
          id="paint1_linear_11817_9248"
          x1="6.125"
          y1="8.53313"
          x2="6.875"
          y2="8.53313"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#A4C9FF" />
          <stop offset="1" stopColor="#C4DCFF" />
        </linearGradient>
        <linearGradient
          id="paint2_linear_11817_9248"
          x1="1.32007"
          y1="6"
          x2="11.6801"
          y2="6"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#A4C9FF" />
          <stop offset="1" stopColor="#C4DCFF" />
        </linearGradient>
        <linearGradient
          id="paint3_linear_11817_9248"
          x1="3.87842"
          y1="4.34334"
          x2="9.37509"
          y2="4.34334"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#A4C9FF" />
          <stop offset="1" stopColor="#C4DCFF" />
        </linearGradient>
      </defs>
    </svg>
  );
}
BoxOutlineIcon.propTypes = {
  width: PropTypes.string,
  height: PropTypes.string,
};
BoxOutlineIcon.defaultProps = {
  width: '',
  height: '',
};
export function BoxOutlineAddIcon() {
  return (
    <svg
      width="13"
      height="12"
      viewBox="0 0 13 12"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M10 11.3751C9.19003 11.3751 8.42503 10.9551 7.99503 10.2651C7.76503 9.9101 7.63503 9.48507 7.62503 9.05007C7.61003 8.32007 7.92004 7.64007 8.47504 7.18007C8.89004 6.83507 9.41004 6.64008 9.94504 6.62508C10.595 6.62008 11.18 6.84509 11.64 7.28509C12.1 7.72509 12.36 8.31509 12.37 8.95009C12.38 9.38509 12.27 9.81008 12.05 10.1851C11.93 10.3951 11.775 10.5901 11.59 10.7551C11.18 11.1401 10.63 11.3651 10.045 11.3751C10.035 11.3751 10.02 11.3751 10 11.3751ZM10 7.37508C9.99003 7.37508 9.97503 7.37508 9.96503 7.37508C9.59503 7.38508 9.24503 7.51509 8.95503 7.75509C8.57503 8.07009 8.36503 8.53509 8.37503 9.03509C8.38003 9.33009 8.47003 9.62007 8.62503 9.86507C8.93003 10.3551 9.46003 10.6551 10.03 10.6251C10.425 10.6151 10.8 10.4651 11.085 10.2001C11.215 10.0851 11.32 9.95508 11.4 9.81508C11.55 9.55508 11.625 9.26508 11.62 8.97008C11.61 8.53508 11.435 8.13007 11.12 7.83007C10.82 7.53507 10.42 7.37508 10 7.37508Z"
        fill="url(#paint0_linear_11831_12791)"
      />
      <path
        d="M9.72494 9.8807C9.62994 9.8807 9.53993 9.84569 9.46493 9.77569L8.95994 9.29571C8.80994 9.15071 8.80493 8.91571 8.94993 8.76571C9.09493 8.61571 9.32993 8.6107 9.47993 8.7557L9.72494 8.99069L10.5099 8.23071C10.6599 8.08571 10.8949 8.09069 11.0399 8.24069C11.1849 8.39069 11.1799 8.62572 11.0299 8.77071L9.98493 9.78069C9.90993 9.84569 9.81494 9.8807 9.72494 9.8807Z"
        fill="url(#paint1_linear_11831_12791)"
      />
      <path
        d="M6.49992 6.65042C6.43492 6.65042 6.36992 6.63543 6.30992 6.60043L1.89493 4.04544C1.71493 3.94044 1.65492 3.71042 1.75992 3.53042C1.86492 3.35042 2.09493 3.29041 2.26993 3.39541L6.49492 5.84042L10.6949 3.41043C10.8749 3.30543 11.1049 3.37044 11.2049 3.54544C11.3099 3.72544 11.2449 3.95542 11.0699 4.06042L6.68492 6.60043C6.62992 6.63043 6.56492 6.65042 6.49992 6.65042Z"
        fill="url(#paint2_linear_11831_12791)"
      />
      <path
        d="M6.5 11.1756C6.295 11.1756 6.125 11.0056 6.125 10.8006V6.26562C6.125 6.06063 6.295 5.89062 6.5 5.89062C6.705 5.89062 6.875 6.06063 6.875 6.26562V10.8006C6.875 11.0056 6.705 11.1756 6.5 11.1756Z"
        fill="url(#paint3_linear_11831_12791)"
      />
      <path
        d="M6.49994 11.3759C6.05994 11.3759 5.61994 11.2809 5.27994 11.0859L2.60994 9.60595C1.88494 9.20595 1.31494 8.24094 1.31494 7.41094V4.58093C1.31494 3.75093 1.88494 2.79095 2.60994 2.38595L5.27994 0.905937C5.95994 0.520938 7.02994 0.520938 7.71494 0.905937L10.3849 2.38595C11.1099 2.78595 11.6799 3.75093 11.6799 4.58093V7.41094C11.6799 7.46094 11.6799 7.50093 11.6699 7.55093C11.6449 7.68093 11.5499 7.79093 11.4249 7.83093C11.2999 7.87593 11.1599 7.84595 11.0549 7.76095C10.4799 7.26095 9.58994 7.24094 8.98494 7.72594C8.59994 8.03094 8.37494 8.49593 8.37494 8.99093C8.37494 9.28593 8.45494 9.57595 8.60994 9.82595C8.64994 9.89595 8.68994 9.95094 8.73494 10.0059C8.80994 10.0909 8.83995 10.2059 8.81995 10.3159C8.79995 10.4259 8.72994 10.521 8.62994 10.576L7.71494 11.0809C7.37494 11.2809 6.93994 11.3759 6.49994 11.3759ZM6.49994 1.37594C6.18994 1.37594 5.87493 1.44094 5.64993 1.56594L2.97993 3.04595C2.49493 3.31095 2.07494 4.03093 2.07494 4.58093V7.41094C2.07494 7.96094 2.49993 8.68095 2.97993 8.94595L5.64993 10.4259C6.10493 10.6809 6.89993 10.6809 7.35493 10.4259L7.91493 10.1159C7.72993 9.78093 7.62994 9.39093 7.62994 8.99093C7.62994 8.26093 7.95494 7.58595 8.51994 7.13595C9.19994 6.59095 10.1699 6.47593 10.9349 6.80093V4.57095C10.9349 4.02095 10.5099 3.30094 10.0299 3.03594L7.35994 1.55593C7.12494 1.44093 6.80994 1.37594 6.49994 1.37594Z"
        fill="url(#paint4_linear_11831_12791)"
      />
      <defs>
        <linearGradient
          id="paint0_linear_11831_12791"
          x1="7.62451"
          y1="9.00004"
          x2="12.3707"
          y2="9.00004"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#A4C9FF" />
          <stop offset="1" stopColor="#C4DCFF" />
        </linearGradient>
        <linearGradient
          id="paint1_linear_11831_12791"
          x1="8.84424"
          y1="9.00285"
          x2="11.1456"
          y2="9.00285"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#A4C9FF" />
          <stop offset="1" stopColor="#C4DCFF" />
        </linearGradient>
        <linearGradient
          id="paint2_linear_11831_12791"
          x1="1.70825"
          y1="4.99708"
          x2="11.2555"
          y2="4.99708"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#A4C9FF" />
          <stop offset="1" stopColor="#C4DCFF" />
        </linearGradient>
        <linearGradient
          id="paint3_linear_11831_12791"
          x1="6.125"
          y1="8.53313"
          x2="6.875"
          y2="8.53313"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#A4C9FF" />
          <stop offset="1" stopColor="#C4DCFF" />
        </linearGradient>
        <linearGradient
          id="paint4_linear_11831_12791"
          x1="1.31494"
          y1="5.99656"
          x2="11.6799"
          y2="5.99656"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#A4C9FF" />
          <stop offset="1" stopColor="#C4DCFF" />
        </linearGradient>
      </defs>
    </svg>
  );
}
export function TruckMulticolorIcon({ size }) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 13 12"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        opacity="0.3"
        d="M1.25 7.07812L4.525 5.20312L11.5 8.70312L8 10.4531L1.25 7.07812Z"
        fill="black"
      />
      <path
        d="M1.82495 6.25313V7.20312L2.44995 6.87813V5.95312L1.82495 6.25313Z"
        fill="#2D3134"
      />
      <path
        opacity="0.39"
        d="M1.82495 6.25313V7.20312L2.44995 6.87813V5.95312L1.82495 6.25313Z"
        fill="black"
      />
      <path
        d="M7.05 8.22347C6.875 8.12347 6.7 8.12347 6.575 8.17347L6.225 8.34847C6.075 8.39847 6 8.54847 6 8.74847C6 9.12347 6.325 9.59847 6.7 9.79847C6.9 9.89847 7.075 9.89847 7.2 9.84847C7.2 9.84847 7.55 9.67347 7.575 9.64847C7.7 9.57347 7.75 9.44847 7.75 9.27347C7.75 8.87347 7.425 8.39847 7.05 8.22347Z"
        fill="#2D3134"
      />
      <path
        opacity="0.39"
        d="M7.19995 9.82187C7.24995 9.79687 7.54995 9.64687 7.57495 9.64687C7.69995 9.57187 7.74995 9.44687 7.74995 9.27187C7.74995 9.12187 7.69995 8.94688 7.62495 8.79688L7.27495 8.97188C7.34995 9.12188 7.39995 9.29687 7.39995 9.44687C7.39995 9.62187 7.32495 9.77187 7.19995 9.82187Z"
        fill="black"
      />
      <path
        d="M7.22505 9.35329C7.22505 9.65329 7.00005 9.75329 6.70005 9.60329C6.40005 9.45329 6.17505 9.10329 6.17505 8.80329C6.17505 8.50329 6.40005 8.40329 6.70005 8.55329C7.00005 8.70329 7.22505 9.05329 7.22505 9.35329Z"
        fill="#999999"
      />
      <path
        opacity="0.15"
        d="M6.75005 9.6C6.45005 9.45 6.22505 9.1 6.22505 8.8C6.22505 8.65 6.27505 8.55 6.37505 8.5C6.25005 8.525 6.17505 8.65 6.17505 8.8C6.17505 9.1 6.40005 9.45 6.70005 9.6C6.85005 9.675 6.97505 9.675 7.07505 9.625C6.97505 9.675 6.87505 9.65 6.75005 9.6Z"
        fill="black"
      />
      <path
        d="M6.9749 9.17274C6.9749 9.29774 6.8749 9.34774 6.7499 9.27274C6.6249 9.19774 6.5249 9.07274 6.5249 8.94774C6.5249 8.82274 6.6249 8.77274 6.7499 8.84774C6.8749 8.92274 6.9749 9.04774 6.9749 9.17274Z"
        fill="#2D3134"
      />
      <path
        opacity="0.39"
        d="M6.9749 9.17274C6.9749 9.29774 6.8749 9.34774 6.7499 9.27274C6.6249 9.19774 6.5249 9.07274 6.5249 8.94774C6.5249 8.82274 6.6249 8.77274 6.7499 8.84774C6.8749 8.92274 6.9749 9.04774 6.9749 9.17274Z"
        fill="black"
      />
      <path
        d="M6.9251 9.19618C6.9251 9.32118 6.8251 9.37118 6.7001 9.29618C6.5751 9.24618 6.4751 9.09618 6.4751 8.97118C6.4751 8.84618 6.5751 8.79618 6.7001 8.87118C6.8251 8.92118 6.9251 9.07118 6.9251 9.19618Z"
        fill="#2D3134"
      />
      <path
        opacity="0.06"
        d="M7.4 9.44617C7.4 9.82117 7.075 9.99617 6.7 9.79617C6.325 9.59617 6 9.12117 6 8.74617C6 8.37117 6.325 8.19617 6.7 8.39617C7.075 8.57117 7.4 9.04617 7.4 9.44617Z"
        fill="black"
      />
      <path
        d="M2.925 6.15316C2.75 6.05316 2.575 6.05316 2.45 6.10316L2.1 6.27816C1.975 6.32816 1.875 6.47816 1.875 6.67816C1.875 7.05316 2.2 7.52816 2.575 7.72816C2.775 7.82816 2.95 7.82816 3.075 7.77816C3.075 7.77816 3.425 7.60316 3.45 7.57816C3.575 7.50315 3.625 7.37815 3.625 7.20316C3.625 6.82816 3.3 6.35316 2.925 6.15316Z"
        fill="#2D3134"
      />
      <path
        opacity="0.39"
        d="M3.07495 7.775C3.12495 7.75 3.42495 7.6 3.44995 7.6C3.57495 7.525 3.62495 7.4 3.62495 7.225C3.62495 7.075 3.57495 6.9 3.49995 6.75L3.14995 6.925C3.22495 7.075 3.27495 7.25 3.27495 7.4C3.27495 7.575 3.19995 7.7 3.07495 7.775Z"
        fill="black"
      />
      <path
        d="M3.10005 7.2986C3.10005 7.5986 2.87505 7.6986 2.57505 7.5486C2.27505 7.3986 2.05005 7.0486 2.05005 6.7486C2.05005 6.4486 2.27505 6.3486 2.57505 6.4986C2.87505 6.6486 3.10005 6.9986 3.10005 7.2986Z"
        fill="#999999"
      />
      <path
        opacity="0.15"
        d="M2.62505 7.52187C2.32505 7.37187 2.10005 7.02187 2.10005 6.72187C2.10005 6.57187 2.15005 6.47188 2.25005 6.42188C2.12505 6.44688 2.05005 6.57187 2.05005 6.72187C2.05005 7.02187 2.27505 7.37187 2.57505 7.52187C2.72505 7.59687 2.85005 7.59687 2.95005 7.54688C2.85005 7.59687 2.75005 7.59687 2.62505 7.52187Z"
        fill="black"
      />
      <path
        d="M2.8499 7.12586C2.8499 7.25086 2.7499 7.30086 2.6249 7.22586C2.4999 7.17586 2.3999 7.02586 2.3999 6.90086C2.3999 6.77586 2.4999 6.72586 2.6249 6.80086C2.7499 6.85086 2.8499 7.00086 2.8499 7.12586Z"
        fill="#2D3134"
      />
      <path
        opacity="0.39"
        d="M2.8499 7.12586C2.8499 7.25086 2.7499 7.30086 2.6249 7.22586C2.4999 7.17586 2.3999 7.02586 2.3999 6.90086C2.3999 6.77586 2.4999 6.72586 2.6249 6.80086C2.7499 6.85086 2.8499 7.00086 2.8499 7.12586Z"
        fill="black"
      />
      <path
        d="M2.8001 7.12586C2.8001 7.25086 2.7001 7.30086 2.5751 7.22586C2.4501 7.15086 2.3501 7.02586 2.3501 6.90086C2.3501 6.77586 2.4501 6.72586 2.5751 6.80086C2.7001 6.87586 2.8001 7.02586 2.8001 7.12586Z"
        fill="#2D3134"
      />
      <path
        opacity="0.06"
        d="M3.275 7.37586C3.275 7.75086 2.95 7.92586 2.575 7.72586C2.2 7.52586 1.875 7.05086 1.875 6.67586C1.875 6.30086 2.2 6.12586 2.575 6.32586C2.95 6.52586 3.275 7.00086 3.275 7.37586Z"
        fill="black"
      />
      <path
        d="M4.75 0.25L1.25 2V5.825L5.75 8.075L9.25 6.25V2.5L4.75 0.25Z"
        fill="#FF9900"
      />
      <path
        d="M1.25 5.5V6L5.75 8.25V7.75L1.25 5.5ZM9.25 6V6.5L5.75 8.25V7.75L9.25 6Z"
        fill="#2D3134"
      />
      <path opacity="0.06" d="M1.25 2V6L5.75 8.25V4.25L1.25 2Z" fill="black" />
      <path
        opacity="0.39"
        d="M9.25 2.5V6.5L5.75 8.25V4.25L9.25 2.5Z"
        fill="black"
      />
      <path
        d="M11 4.5L9.5 3.75L6 5.5V8.325C6 8.4 6.1 8.45 6.175 8.4C6.475 8.15 7 8.325 7.375 8.775C7.6 9.05 7.7 9.35 7.7 9.6L8 9.75L11.5 8V6L11 4.5Z"
        fill="#E5E5E5"
      />
      <path
        d="M8.10009 7.62856L7.67509 6.37856C7.65009 6.32856 7.67509 6.30356 7.72509 6.27856L10.8501 4.72856C10.9001 4.70356 10.9501 4.72856 10.9751 4.77856L11.3751 5.95356C11.4001 6.00356 11.3751 6.02856 11.3251 6.05356L8.22509 7.67856C8.17509 7.70356 8.10009 7.67856 8.10009 7.62856Z"
        fill="#3399CC"
      />
      <path
        opacity="0.15"
        d="M8.67505 5.80356L10.825 4.72856C10.875 4.70356 10.925 4.72856 10.95 4.77856L11.325 5.87856L8.67505 5.80356Z"
        fill="black"
      />
      <path
        d="M11.35 5.95L11.325 5.875C11.325 5.925 11.325 5.95 11.275 5.975L8.17505 7.6C8.12505 7.625 8.07505 7.6 8.05005 7.55L8.07505 7.625C8.10005 7.675 8.15005 7.7 8.20005 7.675L11.3 6.05C11.35 6.025 11.375 6 11.35 5.95Z"
        fill="#2D3134"
      />
      <path d="M8.875 7.5L10.625 6.625V8.075L8.875 8.95V7.5Z" fill="white" />
      <path
        d="M9 8.75313L10.5 8.00313V6.82812L9 7.57812V8.75313Z"
        fill="#2D3134"
      />
      <path
        d="M11.5 8V7.5L8 9.25V9.75L11.5 8ZM7.5 9.5L8 9.75V9.25L7.5 9V9.5Z"
        fill="#2D3134"
      />
      <path d="M9 8.75V9L10.5 8.25V8L9 8.75Z" fill="white" />
      <path
        d="M7.3751 6.32856L6.4251 5.85356C6.4001 5.82856 6.3501 5.85356 6.3501 5.90356V6.65356C6.3501 6.70356 6.3751 6.75356 6.4251 6.75356L6.7501 6.92856C6.7751 6.95356 6.8001 6.95356 6.8251 6.97856L7.1501 7.37856H7.1751L7.7251 7.65356C7.7501 7.67856 7.8001 7.62856 7.7751 7.60356L7.3501 6.35356C7.4001 6.35356 7.4001 6.32856 7.3751 6.32856Z"
        fill="#3399CC"
      />
      <path
        opacity="0.15"
        d="M7.825 7.57856L7.325 7.32856H7.3L6.975 6.92856C6.95 6.90356 6.925 6.87856 6.9 6.87856L6.575 6.70356C6.525 6.67856 6.5 6.65356 6.5 6.60356V5.87856L6.45 5.85356C6.425 5.82856 6.375 5.85356 6.375 5.90356V6.65356C6.375 6.70356 6.4 6.75356 6.45 6.75356L6.775 6.92856C6.8 6.95356 6.825 6.95356 6.85 6.97856L7.175 7.37856H7.2L7.75 7.65356C7.8 7.67856 7.825 7.65356 7.825 7.57856Z"
        fill="black"
      />
      <path
        d="M8 8.75313V9.25313L7.875 9.20312V8.70312L8 8.75313Z"
        fill="#FFCC00"
      />
      <path
        d="M9 7.75V7.825L10.5 7.075V7L9 7.75ZM9 8V8.075L10.5 7.325V7.25L9 8ZM9 8.25V8.325L10.5 7.575V7.5L9 8.25ZM9 8.5V8.575L10.5 7.825V7.75L9 8.5Z"
        fill="#E5E5E5"
      />
      <path
        opacity="0.5"
        d="M6.375 7.07812V7.20312L6.625 7.32812V7.20312L6.375 7.07812Z"
        fill="#2D3134"
      />
      <path
        opacity="0.5"
        d="M6.625 7.37813L6.375 7.25313V7.20312L6.625 7.32812V7.37813Z"
        fill="white"
      />
      <path
        d="M9.87505 5.97188C9.85005 5.94688 9.82505 5.94688 9.80005 5.97188L8.85005 7.04688C8.82505 7.07188 8.82505 7.09688 8.85005 7.12188C8.87505 7.14688 8.90005 7.14688 8.92505 7.12188L9.17505 6.82187V7.07187H9.25005V6.74688L9.87505 6.02188C9.90005 6.02188 9.90005 5.97188 9.87505 5.97188ZM10.775 5.47188C10.75 5.44688 10.725 5.44688 10.7 5.47188L9.75005 6.54688C9.72505 6.57188 9.72505 6.59688 9.75005 6.62188C9.77505 6.64688 9.80005 6.64688 9.82505 6.62188L10.05 6.37188V6.64688H10.125V6.29688L10.775 5.54688C10.8 5.52188 10.8 5.49688 10.775 5.47188Z"
        fill="#2D3134"
      />
      <path
        d="M11 7.75L11.5 7.5V7L11.25 7.125C11.1 7.2 11 7.35 11 7.525V7.75Z"
        fill="white"
      />
      <path
        opacity="0.3"
        d="M11.0927 7.30979C11.023 7.39546 11.0098 7.50024 11.0634 7.54382C11.1169 7.5874 11.2169 7.55328 11.2866 7.46761C11.3563 7.38195 11.3694 7.27717 11.3159 7.23359C11.2624 7.19001 11.1624 7.22413 11.0927 7.30979Z"
        fill="#2D3134"
      />
      <path
        opacity="0.3"
        d="M11.2182 7.30979C11.1485 7.39546 11.1353 7.50024 11.1889 7.54382C11.2424 7.5874 11.3423 7.55328 11.4121 7.46761C11.4818 7.38195 11.4949 7.27717 11.4414 7.23359C11.3878 7.19001 11.2879 7.22413 11.2182 7.30979Z"
        fill="#2D3134"
      />
      <path opacity="0.3" d="M11 7.75L11.5 7.5V7L11 7.75Z" fill="white" />
      <path
        d="M8 9.25004L8.5 9.00004V8.77504C8.5 8.65004 8.375 8.57504 8.25 8.62504L8 8.75004V9.25004Z"
        fill="white"
      />
      <path
        opacity="0.3"
        d="M8.21819 8.80979C8.14846 8.89546 8.13533 9.00024 8.18888 9.04382C8.24242 9.0874 8.34235 9.05328 8.41208 8.96761C8.4818 8.88195 8.49493 8.77717 8.44138 8.73359C8.38784 8.69001 8.28791 8.72413 8.21819 8.80979Z"
        fill="#2D3134"
      />
      <path
        opacity="0.3"
        d="M8.09319 8.80979C8.02346 8.89546 8.01033 9.00024 8.06388 9.04382C8.11742 9.0874 8.21735 9.05328 8.28708 8.96761C8.3568 8.88195 8.36993 8.77717 8.31638 8.73359C8.26284 8.69001 8.16291 8.72413 8.09319 8.80979Z"
        fill="#2D3134"
      />
      <path opacity="0.3" d="M8 9.25L8.5 9L8 8.75V9.25Z" fill="white" />
      <path
        opacity="0.06"
        d="M7.5 6.25L6 5.5V8.325C6 8.4 6.1 8.45 6.175 8.4C6.475 8.15 7 8.325 7.375 8.775C7.45 8.85 7.5 8.925 7.525 9.025L7.5 9V9.5L8 9.75V7.75L7.5 6.25Z"
        fill="black"
      />
      <path
        opacity="0.39"
        d="M11 4.5L7.5 6.25L8 7.75V9.75L11.5 8V6L11 4.5Z"
        fill="black"
      />
    </svg>
  );
}
TruckMulticolorIcon.propTypes = {
  size: PropTypes.string,
};
TruckMulticolorIcon.defaultProps = {
  size: '13',
};
export function LinkIcon() {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M8.98993 21.4972C7.32993 21.4972 5.65993 20.8672 4.38993 19.5972C1.85993 17.0572 1.85993 12.9372 4.38993 10.4072C4.67993 10.1172 5.15993 10.1172 5.44993 10.4072C5.73993 10.6972 5.73993 11.1772 5.44993 11.4672C3.49993 13.4172 3.49993 16.5872 5.44993 18.5372C7.39993 20.4872 10.5699 20.4872 12.5199 18.5372C13.4599 17.5972 13.9799 16.3372 13.9799 14.9972C13.9799 13.6672 13.4599 12.4072 12.5199 11.4572C12.2299 11.1672 12.2299 10.6872 12.5199 10.3972C12.8099 10.1072 13.2899 10.1072 13.5799 10.3972C14.8099 11.6272 15.4799 13.2572 15.4799 14.9972C15.4799 16.7372 14.7999 18.3672 13.5799 19.5972C12.3199 20.8672 10.6599 21.4972 8.98993 21.4972Z"
        fill="url(#paint0_linear_10548_9935)"
      />
      <path
        d="M19.0701 14.1622C18.8801 14.1622 18.6901 14.0922 18.5401 13.9422C18.2501 13.6522 18.2501 13.1722 18.5401 12.8822C20.5901 10.8322 20.5901 7.50219 18.5401 5.46219C16.4901 3.41219 13.1601 3.41219 11.1201 5.46219C10.1301 6.45219 9.58008 7.77219 9.58008 9.17219C9.58008 10.5722 10.1301 11.8922 11.1201 12.8822C11.4101 13.1722 11.4101 13.6522 11.1201 13.9422C10.8301 14.2322 10.3501 14.2322 10.0601 13.9422C8.79008 12.6722 8.08008 10.9722 8.08008 9.17219C8.08008 7.37219 8.78008 5.67219 10.0601 4.40219C12.6901 1.77219 16.9701 1.77219 19.6101 4.40219C22.2401 7.03219 22.2401 11.3222 19.6101 13.9522C19.4601 14.0922 19.2601 14.1622 19.0701 14.1622Z"
        fill="url(#paint1_linear_10548_9935)"
      />
      <defs>
        <linearGradient
          id="paint0_linear_10548_9935"
          x1="2.49243"
          y1="10.1797"
          x2="17.4112"
          y2="17.6301"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0.234375" stopColor="#A584EA" />
          <stop offset="1" stopColor="#5D87FF" />
        </linearGradient>
        <linearGradient
          id="paint1_linear_10548_9935"
          x1="8.08008"
          y1="2.42969"
          x2="23.5725"
          y2="10.1889"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0.234375" stopColor="#A584EA" />
          <stop offset="1" stopColor="#5D87FF" />
        </linearGradient>
      </defs>
    </svg>
  );
}
export function AccordionToggleRightIcon() {
  return (
    <svg
      width="0.972vw"
      height="0.972vw"
      viewBox="0 0 14 14"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M5.46967 8.96967C5.17678 9.26256 5.17678 9.73744 5.46967 10.0303C5.76256 10.3232 6.23744 10.3232 6.53033 10.0303L9.03033 7.53033C9.32322 7.23744 9.32322 6.76256 9.03033 6.46967L6.53033 3.96967C6.23744 3.67678 5.76256 3.67678 5.46967 3.96967C5.17678 4.26256 5.17678 4.73744 5.46967 5.03033L7.43934 7L5.46967 8.96967Z"
        fill="url(#paint0_linear_12448_2733)"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M7 0C10.866 -1.68988e-07 14 3.13401 14 7C14 10.866 10.866 14 7 14C3.13401 14 1.68988e-07 10.866 0 7C-1.68988e-07 3.13401 3.13401 1.68988e-07 7 0ZM7 1.5C10.0376 1.5 12.5 3.96243 12.5 7C12.5 10.0376 10.0376 12.5 7 12.5C3.96243 12.5 1.5 10.0376 1.5 7C1.5 3.96243 3.96243 1.5 7 1.5Z"
        fill="url(#paint1_linear_12448_2733)"
      />
      <defs>
        <linearGradient
          id="paint0_linear_12448_2733"
          x1="0"
          y1="0"
          x2="16.8932"
          y2="7.35169"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#A584EA" />
          <stop offset="1" stopColor="#5D87FF" />
        </linearGradient>
        <linearGradient
          id="paint1_linear_12448_2733"
          x1="0"
          y1="0"
          x2="16.8932"
          y2="7.35169"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#A584EA" />
          <stop offset="1" stopColor="#5D87FF" />
        </linearGradient>
      </defs>
    </svg>
  );
}
export function AccordionToggleDownIcon() {
  return (
    <svg
      width="0.972vw"
      height="0.972vw"
      viewBox="0 0 14 14"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M5.03033 5.46967C4.73744 5.17678 4.26256 5.17678 3.96967 5.46967C3.67678 5.76256 3.67678 6.23744 3.96967 6.53033L6.46967 9.03033C6.76256 9.32322 7.23744 9.32322 7.53033 9.03033L10.0303 6.53033C10.3232 6.23744 10.3232 5.76256 10.0303 5.46967C9.73744 5.17678 9.26256 5.17678 8.96967 5.46967L7 7.43934L5.03033 5.46967Z"
        fill="url(#paint0_linear_20_3)"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M14 7C14 10.866 10.866 14 7 14C3.13401 14 1.68988e-07 10.866 0 7C-1.68988e-07 3.13401 3.13401 1.68988e-07 7 0C10.866 -1.68988e-07 14 3.13401 14 7ZM12.5 7C12.5 10.0376 10.0376 12.5 7 12.5C3.96243 12.5 1.5 10.0376 1.5 7C1.5 3.96243 3.96243 1.5 7 1.5C10.0376 1.5 12.5 3.96243 12.5 7Z"
        fill="url(#paint1_linear_20_3)"
      />
      <defs>
        <linearGradient
          id="paint0_linear_20_3"
          x1="0.972vw"
          y1="0"
          x2="6.64831"
          y2="16.8932"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#A584EA" />
          <stop offset="1" stopColor="#5D87FF" />
        </linearGradient>
        <linearGradient
          id="paint1_linear_20_3"
          x1="0.972vw"
          y1="0"
          x2="6.64831"
          y2="16.8932"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#A584EA" />
          <stop offset="1" stopColor="#5D87FF" />
        </linearGradient>
      </defs>
    </svg>
  );
}
export function AddAnotherIcon() {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M8.98993 21.4972C7.32993 21.4972 5.65993 20.8672 4.38993 19.5972C1.85993 17.0572 1.85993 12.9372 4.38993 10.4072C4.67993 10.1172 5.15993 10.1172 5.44993 10.4072C5.73993 10.6972 5.73993 11.1772 5.44993 11.4672C3.49993 13.4172 3.49993 16.5872 5.44993 18.5372C7.39993 20.4872 10.5699 20.4872 12.5199 18.5372C13.4599 17.5972 13.9799 16.3372 13.9799 14.9972C13.9799 13.6672 13.4599 12.4072 12.5199 11.4572C12.2299 11.1672 12.2299 10.6872 12.5199 10.3972C12.8099 10.1072 13.2899 10.1072 13.5799 10.3972C14.8099 11.6272 15.4799 13.2572 15.4799 14.9972C15.4799 16.7372 14.7999 18.3672 13.5799 19.5972C12.3199 20.8672 10.6599 21.4972 8.98993 21.4972Z"
        fill="url(#paint0_linear_10548_9935)"
      />
      <path
        d="M19.0701 14.1622C18.8801 14.1622 18.6901 14.0922 18.5401 13.9422C18.2501 13.6522 18.2501 13.1722 18.5401 12.8822C20.5901 10.8322 20.5901 7.50219 18.5401 5.46219C16.4901 3.41219 13.1601 3.41219 11.1201 5.46219C10.1301 6.45219 9.58008 7.77219 9.58008 9.17219C9.58008 10.5722 10.1301 11.8922 11.1201 12.8822C11.4101 13.1722 11.4101 13.6522 11.1201 13.9422C10.8301 14.2322 10.3501 14.2322 10.0601 13.9422C8.79008 12.6722 8.08008 10.9722 8.08008 9.17219C8.08008 7.37219 8.78008 5.67219 10.0601 4.40219C12.6901 1.77219 16.9701 1.77219 19.6101 4.40219C22.2401 7.03219 22.2401 11.3222 19.6101 13.9522C19.4601 14.0922 19.2601 14.1622 19.0701 14.1622Z"
        fill="url(#paint1_linear_10548_9935)"
      />
      <defs>
        <linearGradient
          id="paint0_linear_10548_9935"
          x1="2.49243"
          y1="10.1797"
          x2="17.4112"
          y2="17.6301"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#A584EA" />
          <stop offset="1" stopColor="#5D87FF" />
        </linearGradient>
        <linearGradient
          id="paint1_linear_10548_9935"
          x1="8.08008"
          y1="2.42969"
          x2="23.5725"
          y2="10.1889"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#A584EA" />
          <stop offset="1" stopColor="#5D87FF" />
        </linearGradient>
      </defs>
    </svg>
  );
}
export function UploadDocumentFillIcon() {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M20.5 10.19H17.61C15.24 10.19 13.31 8.26 13.31 5.89V3C13.31 2.45 12.86 2 12.31 2H8.07C4.99 2 2.5 4 2.5 7.57V16.43C2.5 20 4.99 22 8.07 22H15.93C19.01 22 21.5 20 21.5 16.43V11.19C21.5 10.64 21.05 10.19 20.5 10.19ZM11.53 13.53C11.38 13.68 11.19 13.75 11 13.75C10.81 13.75 10.62 13.68 10.47 13.53L9.75 12.81V17C9.75 17.41 9.41 17.75 9 17.75C8.59 17.75 8.25 17.41 8.25 17V12.81L7.53 13.53C7.24 13.82 6.76 13.82 6.47 13.53C6.18 13.24 6.18 12.76 6.47 12.47L8.47 10.47C8.54 10.41 8.61 10.36 8.69 10.32C8.71 10.31 8.74 10.3 8.76 10.29C8.82 10.27 8.88 10.26 8.95 10.25C8.98 10.25 9 10.25 9.03 10.25C9.11 10.25 9.19 10.27 9.27 10.3C9.28 10.3 9.28 10.3 9.29 10.3C9.37 10.33 9.45 10.39 9.51 10.45C9.52 10.46 9.53 10.46 9.53 10.47L11.53 12.47C11.82 12.76 11.82 13.24 11.53 13.53Z"
        fill="#0088FA"
      />
      <path
        d="M17.4297 8.80999C18.3797 8.81999 19.6997 8.81999 20.8297 8.81999C21.3997 8.81999 21.6997 8.14999 21.2997 7.74999C19.8597 6.29999 17.2797 3.68999 15.7997 2.20999C15.3897 1.79999 14.6797 2.07999 14.6797 2.64999V6.13999C14.6797 7.59999 15.9197 8.80999 17.4297 8.80999Z"
        fill="#0088FA"
      />
    </svg>
  );
}
export function CloseOutlined() {
  return (
    <svg
      width="0.972vw"
      height="0.972vw"
      viewBox="0 0 14 14"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M7.00033 12.8334C10.2087 12.8334 12.8337 10.2084 12.8337 7.00008C12.8337 3.79175 10.2087 1.16675 7.00033 1.16675C3.79199 1.16675 1.16699 3.79175 1.16699 7.00008C1.16699 10.2084 3.79199 12.8334 7.00033 12.8334Z"
        fill="#EDF7FF"
        stroke="#616B80"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M5.34961 8.65079L8.65128 5.34912"
        stroke="#616B80"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M8.65128 8.65079L5.34961 5.34912"
        stroke="#616B80"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}
export function CurgoTruckIcon({ size }) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 25 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M22.6188 5.38253H19.8594V1.06248C19.8594 0.601562 19.484 0.226562 19.0226 0.226562H1.33681C0.875422 0.226562 0.5 0.601562 0.5 1.06248V10.2925C0.5 10.7534 0.875375 11.1284 1.33681 11.1284H1.41809C1.41795 13.2979 1.41809 13.2145 1.41809 13.2076C1.41809 13.6687 1.79323 14.0437 2.2543 14.0437H3.95989C4.08383 15.0145 4.91431 15.7678 5.91931 15.7678C6.92431 15.7678 7.7548 15.0144 7.87873 14.0437H8.34162C8.46556 15.0145 9.29605 15.7678 10.301 15.7678C11.306 15.7678 12.1365 15.0144 12.2605 14.0437H19.2662C19.3901 15.0145 20.2206 15.7678 21.2257 15.7678C22.2307 15.7678 23.0612 15.0144 23.1852 14.0437H23.6214C24.1047 14.0437 24.4981 13.6495 24.4981 13.1653C24.4994 11.4805 24.4999 8.92155 24.5 7.26306C24.5003 6.22347 23.6587 5.38253 22.6188 5.38253ZM0.999969 10.2925V1.06248C0.999969 0.877281 1.15109 0.726531 1.33677 0.726531H19.0226C19.2082 0.726531 19.3594 0.877281 19.3594 1.06248V5.62469C19.3593 5.62745 19.3578 5.62975 19.3578 5.63256V10.6273C19.2014 10.6273 21.3084 10.6272 1.33672 10.6284C1.15114 10.6284 0.999969 10.4777 0.999969 10.2925ZM1.91806 11.9901H2.22725C2.31186 11.9901 2.38058 12.0586 2.38058 12.1428V12.5294C2.38058 12.6136 2.31186 12.6821 2.22725 12.6821H1.91806V11.9901ZM5.91931 15.2678C5.10477 15.2678 4.44214 14.6062 4.44214 13.793C4.44214 12.9798 5.10477 12.3182 5.91931 12.3182C6.73386 12.3182 7.39648 12.9798 7.39648 13.793C7.39644 14.6062 6.73391 15.2678 5.91931 15.2678ZM10.301 15.2678C9.48645 15.2678 8.82383 14.6062 8.82383 13.793C8.82383 12.9798 9.48645 12.3182 10.301 12.3182C11.1155 12.3182 11.7782 12.9798 11.7782 13.793C11.7782 14.6062 11.1156 15.2678 10.301 15.2678ZM21.2257 15.2678C20.4111 15.2678 19.7484 14.6062 19.7484 13.793C19.7484 12.9798 20.4111 12.3182 21.2257 12.3182C22.0403 12.3182 22.7029 12.9798 22.7029 13.793C22.7029 14.6062 22.0403 15.2678 21.2257 15.2678ZM23.9981 13.165C23.9981 13.3738 23.8291 13.5437 23.6213 13.5437H23.1853C23.0621 12.5722 22.2312 11.8181 21.2257 11.8181C20.2201 11.8181 19.3892 12.5722 19.2659 13.5437H12.2607C12.1374 12.5722 11.3065 11.8181 10.301 11.8181C9.29548 11.8181 8.46462 12.5722 8.34134 13.5437H7.87892C7.75564 12.5722 6.92478 11.8181 5.91927 11.8181C4.91375 11.8181 4.08289 12.5722 3.95961 13.5437H2.25425C2.06881 13.5437 1.91806 13.393 1.91806 13.2077V13.1821H2.22725C2.58748 13.1821 2.88059 12.8893 2.88059 12.5294V12.1428C2.88059 11.7829 2.58753 11.4901 2.22725 11.4901H1.91806V11.1284H19.6093C19.7474 11.1284 19.8593 11.0165 19.8593 10.8784V5.88255H22.6187C23.3822 5.88255 23.9999 6.49942 23.9999 7.26306C23.9999 8.92122 23.9994 11.4802 23.9981 13.165ZM21.3582 9.75634C21.3582 9.89439 21.2462 10.0063 21.1082 10.0063H20.6078C20.4698 10.0063 20.3578 9.89439 20.3578 9.75634C20.3578 9.6183 20.4698 9.50636 20.6078 9.50636H21.1082C21.2462 9.50631 21.3582 9.6183 21.3582 9.75634ZM22.6188 6.38256H20.6078C20.4698 6.38256 20.3578 6.4945 20.3578 6.63255V8.75645C20.3578 8.8945 20.4698 9.00644 20.6078 9.00644H23.2499C23.388 9.00644 23.4999 8.8945 23.4999 8.75645L23.5001 7.26278C23.5 6.77739 23.1075 6.38256 22.6188 6.38256ZM22.9999 8.50647H20.8578V6.88258H22.6188C22.8273 6.88258 23 7.05016 23 7.26283L22.9999 8.50647ZM21.2257 12.8191C20.6945 12.8191 20.2624 13.2502 20.2624 13.7799C20.2624 14.3098 20.6945 14.7408 21.2257 14.7408C21.7568 14.7408 22.1888 14.3098 22.1888 13.7799C22.1888 13.2501 21.7568 12.8191 21.2257 12.8191ZM21.2257 14.2408C20.9702 14.2408 20.7624 14.0341 20.7624 13.7799C20.7624 13.5258 20.9702 13.3191 21.2257 13.3191C21.4811 13.3191 21.6888 13.5258 21.6888 13.7799C21.6889 14.0341 21.4811 14.2408 21.2257 14.2408ZM5.91931 12.8191C5.38817 12.8191 4.95617 13.2502 4.95617 13.7799C4.95617 14.3098 5.38817 14.7408 5.91931 14.7408C6.45045 14.7408 6.88245 14.3098 6.88245 13.7799C6.88241 13.2501 6.45041 12.8191 5.91931 12.8191ZM5.91931 14.2408C5.66394 14.2408 5.45619 14.0341 5.45619 13.7799C5.45619 13.5258 5.66398 13.3191 5.91931 13.3191C6.17469 13.3191 6.38244 13.5258 6.38244 13.7799C6.38244 14.0341 6.17469 14.2408 5.91931 14.2408ZM10.301 12.8191C9.76986 12.8191 9.33786 13.2502 9.33786 13.7799C9.33786 14.3098 9.76986 14.7408 10.301 14.7408C10.8321 14.7408 11.2641 14.3098 11.2641 13.7799C11.2641 13.2501 10.8321 12.8191 10.301 12.8191ZM10.301 14.2408C10.0456 14.2408 9.83787 14.0341 9.83787 13.7799C9.83787 13.5258 10.0457 13.3191 10.301 13.3191C10.5563 13.3191 10.7641 13.5258 10.7641 13.7799C10.7642 14.0341 10.5564 14.2408 10.301 14.2408ZM2.38597 9.45433V1.90061C2.38597 1.76256 2.49791 1.65063 2.63595 1.65063C2.774 1.65063 2.88594 1.76256 2.88594 1.90061V9.45438C2.88594 9.59242 2.774 9.70436 2.63595 9.70436C2.49791 9.70436 2.38597 9.59238 2.38597 9.45433ZM4.27184 9.45433V1.90061C4.27184 1.76256 4.38378 1.65063 4.52183 1.65063C4.65988 1.65063 4.77181 1.76256 4.77181 1.90061V9.45438C4.77181 9.59242 4.65988 9.70436 4.52183 9.70436C4.38378 9.70436 4.27184 9.59238 4.27184 9.45433ZM6.15781 9.45433V1.90061C6.15781 1.76256 6.26975 1.65063 6.4078 1.65063C6.54584 1.65063 6.65778 1.76256 6.65778 1.90061V9.45438C6.65778 9.59242 6.54584 9.70436 6.4078 9.70436C6.2698 9.70436 6.15781 9.59238 6.15781 9.45433ZM8.04369 9.45433V1.90061C8.04369 1.76256 8.15562 1.65063 8.29367 1.65063C8.43172 1.65063 8.54366 1.76256 8.54366 1.90061V9.45438C8.54366 9.59242 8.43172 9.70436 8.29367 9.70436C8.15562 9.70436 8.04369 9.59238 8.04369 9.45433ZM9.9297 9.45433V1.90061C9.9297 1.76256 10.0416 1.65063 10.1797 1.65063C10.3177 1.65063 10.4297 1.76256 10.4297 1.90061V9.45438C10.4297 9.59242 10.3177 9.70436 10.1797 9.70436C10.0416 9.70436 9.9297 9.59238 9.9297 9.45433ZM11.8157 9.45433V1.90061C11.8157 1.76256 11.9276 1.65063 12.0657 1.65063C12.2037 1.65063 12.3156 1.76256 12.3156 1.90061V9.45438C12.3156 9.59242 12.2037 9.70436 12.0657 9.70436C11.9276 9.70436 11.8157 9.59238 11.8157 9.45433ZM13.7015 9.45433V1.90061C13.7015 1.76256 13.8135 1.65063 13.9515 1.65063C14.0896 1.65063 14.2015 1.76256 14.2015 1.90061V9.45438C14.2015 9.59242 14.0896 9.70436 13.9515 9.70436C13.8135 9.70436 13.7015 9.59238 13.7015 9.45433ZM15.5875 9.45433V1.90061C15.5875 1.76256 15.6995 1.65063 15.8375 1.65063C15.9755 1.65063 16.0875 1.76256 16.0875 1.90061V9.45438C16.0875 9.59242 15.9755 9.70436 15.8375 9.70436C15.6995 9.70436 15.5875 9.59238 15.5875 9.45433ZM17.4734 9.45433V1.90061C17.4734 1.76256 17.5853 1.65063 17.7234 1.65063C17.8614 1.65063 17.9734 1.76256 17.9734 1.90061V9.45438C17.9734 9.59242 17.8614 9.70436 17.7234 9.70436C17.5853 9.70436 17.4734 9.59238 17.4734 9.45433Z"
        fill="url(#paint0_linear_13556_30379)"
      />
      <defs>
        <linearGradient
          id="paint0_linear_13556_30379"
          x1="12.5"
          y1="0.226563"
          x2="12.5"
          y2="15.7678"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#F09090" />
          <stop offset="1" stopColor="#FA0000" />
        </linearGradient>
      </defs>
    </svg>
  );
}
CurgoTruckIcon.propTypes = {
  size: PropTypes.string,
};
CurgoTruckIcon.defaultProps = {
  size: '25',
};
export function CalenderNewIcon({ color }) {
  return (
    <svg
      width="1.111vw"
      height="1.111vw"
      viewBox="0 0 17 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M6.08301 3.83594C5.80967 3.83594 5.58301 3.60927 5.58301 3.33594V1.33594C5.58301 1.0626 5.80967 0.835938 6.08301 0.835938C6.35634 0.835938 6.58301 1.0626 6.58301 1.33594V3.33594C6.58301 3.60927 6.35634 3.83594 6.08301 3.83594Z"
        fill={color}
      />
      <path
        d="M11.417 3.83594C11.1437 3.83594 10.917 3.60927 10.917 3.33594V1.33594C10.917 1.0626 11.1437 0.835938 11.417 0.835938C11.6903 0.835938 11.917 1.0626 11.917 1.33594V3.33594C11.917 3.60927 11.6903 3.83594 11.417 3.83594Z"
        fill={color}
      />
      <path
        d="M10.75 15.1693H6.75C3.00333 15.1693 2.25 13.4026 2.25 10.5493V6.43594C2.25 3.27594 3.31667 1.98927 6.05667 1.83594H11.4167C11.4233 1.83594 11.4367 1.83594 11.4433 1.83594C14.1833 1.98927 15.25 3.27594 15.25 6.43594V10.5493C15.25 13.4026 14.4967 15.1693 10.75 15.1693ZM6.08333 2.83594C4.21667 2.9426 3.25 3.52927 3.25 6.43594V10.5493C3.25 13.1026 3.73667 14.1693 6.75 14.1693H10.75C13.7633 14.1693 14.25 13.1026 14.25 10.5493V6.43594C14.25 3.53594 13.29 2.9426 11.4033 2.83594H6.08333Z"
        fill={color}
      />
      <path
        d="M14.5837 12.2344H2.91699C2.64366 12.2344 2.41699 12.0077 2.41699 11.7344C2.41699 11.461 2.64366 11.2344 2.91699 11.2344H14.5837C14.857 11.2344 15.0837 11.461 15.0837 11.7344C15.0837 12.0077 14.857 12.2344 14.5837 12.2344Z"
        fill={color}
      />
      <path
        d="M8.74967 5.5C7.92967 5.5 7.23634 5.94667 7.23634 6.81333C7.23634 7.22667 7.42967 7.54 7.72301 7.74C7.31634 7.98 7.08301 8.36667 7.08301 8.82C7.08301 9.64667 7.71634 10.16 8.74967 10.16C9.77634 10.16 10.4163 9.64667 10.4163 8.82C10.4163 8.36667 10.183 7.97333 9.76967 7.74C10.0697 7.53333 10.2563 7.22667 10.2563 6.81333C10.2563 5.94667 9.56967 5.5 8.74967 5.5ZM8.74967 7.39333C8.40301 7.39333 8.14967 7.18667 8.14967 6.86C8.14967 6.52667 8.40301 6.33333 8.74967 6.33333C9.09634 6.33333 9.34967 6.52667 9.34967 6.86C9.34967 7.18667 9.09634 7.39333 8.74967 7.39333ZM8.74967 9.33333C8.30967 9.33333 7.98967 9.11333 7.98967 8.71333C7.98967 8.31333 8.30967 8.1 8.74967 8.1C9.18967 8.1 9.50967 8.32 9.50967 8.71333C9.50967 9.11333 9.18967 9.33333 8.74967 9.33333Z"
        fill={color}
      />
    </svg>
  );
}
CalenderNewIcon.propTypes = {
  color: PropTypes.string,
};
CalenderNewIcon.defaultProps = {
  color: '#ffffff',
};
export function KeyboardIcon() {
  return (
    <svg
      width="1.111vw"
      height="1.111vw"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M11.0003 13.8307H5.00033C4.50033 13.8307 4.13366 13.8107 3.82033 13.7641C1.60699 13.5241 1.16699 12.1974 1.16699 9.9974V5.9974C1.16699 3.7974 1.60699 2.47073 3.84033 2.22406C4.13366 2.18406 4.50033 2.16406 5.00033 2.16406H11.0003C11.5003 2.16406 11.867 2.18406 12.1803 2.23073C14.3937 2.47073 14.8337 3.7974 14.8337 5.9974V9.9974C14.8337 12.1974 14.3937 13.5241 12.1603 13.7707C11.867 13.8107 11.5003 13.8307 11.0003 13.8307ZM5.00033 3.16406C4.54699 3.16406 4.22699 3.18406 3.96699 3.2174C2.61366 3.37073 2.16699 3.79073 2.16699 5.9974V9.9974C2.16699 12.2041 2.61366 12.6241 3.94699 12.7774C4.22699 12.8174 4.54699 12.8307 5.00033 12.8307H11.0003C11.4537 12.8307 11.7737 12.8107 12.0337 12.7774C13.387 12.6307 13.8337 12.2041 13.8337 9.9974V5.9974C13.8337 3.79073 13.387 3.37073 12.0537 3.2174C11.7737 3.1774 11.4537 3.16406 11.0003 3.16406H5.00033Z"
        fill="#0088FA"
      />
      <path
        d="M11.3333 7.16406H9C8.72667 7.16406 8.5 6.9374 8.5 6.66406C8.5 6.39073 8.72667 6.16406 9 6.16406H11.3333C11.6067 6.16406 11.8333 6.39073 11.8333 6.66406C11.8333 6.9374 11.6067 7.16406 11.3333 7.16406Z"
        fill="#0088FA"
      />
      <path
        d="M6.73307 7.33333C6.36641 7.33333 6.06641 7.03333 6.06641 6.66667C6.06641 6.3 6.35974 6 6.73307 6H6.73974C7.10641 6 7.40641 6.3 7.40641 6.66667C7.40641 7.03333 7.10641 7.33333 6.73307 7.33333Z"
        fill="#0088FA"
      />
      <path
        d="M4.73307 7.33333C4.36641 7.33333 4.06641 7.03333 4.06641 6.66667C4.06641 6.3 4.35974 6 4.73307 6C5.09974 6 5.39974 6.3 5.39974 6.66667C5.39974 7.03333 5.10641 7.33333 4.73307 7.33333Z"
        fill="#0088FA"
      />
      <path
        d="M11.3329 10.8359H4.67952C4.40618 10.8359 4.17285 10.6093 4.17285 10.3359C4.17285 10.0626 4.39285 9.83594 4.66618 9.83594H11.3329C11.6062 9.83594 11.8329 10.0626 11.8329 10.3359C11.8329 10.6093 11.6062 10.8359 11.3329 10.8359Z"
        fill="#0088FA"
      />
    </svg>
  );
}
export function PLusSquare({ color, size }) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 21 21"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M7.16602 10.4502H13.8327"
        stroke={color}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M10.5 13.7839V7.11719"
        stroke={color}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M7.99935 18.7839H12.9993C17.166 18.7839 18.8327 17.1172 18.8327 12.9505V7.95052C18.8327 3.78385 17.166 2.11719 12.9993 2.11719H7.99935C3.83268 2.11719 2.16602 3.78385 2.16602 7.95052V12.9505C2.16602 17.1172 3.83268 18.7839 7.99935 18.7839Z"
        stroke={color}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}
PLusSquare.propTypes = {
  color: PropTypes.string,
  size: PropTypes.string,
};
PLusSquare.defaultProps = {
  color: '#C9C9C9',
  size: '1.458vw',
};
export function Settingsicon({ color }) {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M12 15.75C9.93 15.75 8.25 14.07 8.25 12C8.25 9.93 9.93 8.25 12 8.25C14.07 8.25 15.75 9.93 15.75 12C15.75 14.07 14.07 15.75 12 15.75ZM12 9.75C10.76 9.75 9.75 10.76 9.75 12C9.75 13.24 10.76 14.25 12 14.25C13.24 14.25 14.25 13.24 14.25 12C14.25 10.76 13.24 9.75 12 9.75Z"
        fill={color}
      />
      <path
        d="M15.21 22.1903C15 22.1903 14.79 22.1603 14.58 22.1103C13.96 21.9403 13.44 21.5503 13.11 21.0003L12.99 20.8003C12.4 19.7803 11.59 19.7803 11 20.8003L10.89 20.9903C10.56 21.5503 10.04 21.9503 9.42 22.1103C8.79 22.2803 8.14 22.1903 7.59 21.8603L5.87 20.8703C5.26 20.5203 4.82 19.9503 4.63 19.2603C4.45 18.5703 4.54 17.8603 4.89 17.2503C5.18 16.7403 5.26 16.2803 5.09 15.9903C4.92 15.7003 4.49 15.5303 3.9 15.5303C2.44 15.5303 1.25 14.3403 1.25 12.8803V11.1203C1.25 9.66029 2.44 8.47029 3.9 8.47029C4.49 8.47029 4.92 8.30029 5.09 8.01029C5.26 7.72029 5.19 7.26029 4.89 6.75029C4.54 6.14029 4.45 5.42029 4.63 4.74029C4.81 4.05029 5.25 3.48029 5.87 3.13029L7.6 2.14029C8.73 1.47029 10.22 1.86029 10.9 3.01029L11.02 3.21029C11.61 4.23029 12.42 4.23029 13.01 3.21029L13.12 3.02029C13.8 1.86029 15.29 1.47029 16.43 2.15029L18.15 3.14029C18.76 3.49029 19.2 4.06029 19.39 4.75029C19.57 5.44029 19.48 6.15029 19.13 6.76029C18.84 7.27029 18.76 7.73029 18.93 8.02029C19.1 8.31029 19.53 8.48029 20.12 8.48029C21.58 8.48029 22.77 9.67029 22.77 11.1303V12.8903C22.77 14.3503 21.58 15.5403 20.12 15.5403C19.53 15.5403 19.1 15.7103 18.93 16.0003C18.76 16.2903 18.83 16.7503 19.13 17.2603C19.48 17.8703 19.58 18.5903 19.39 19.2703C19.21 19.9603 18.77 20.5303 18.15 20.8803L16.42 21.8703C16.04 22.0803 15.63 22.1903 15.21 22.1903ZM12 18.4903C12.89 18.4903 13.72 19.0503 14.29 20.0403L14.4 20.2303C14.52 20.4403 14.72 20.5903 14.96 20.6503C15.2 20.7103 15.44 20.6803 15.64 20.5603L17.37 19.5603C17.63 19.4103 17.83 19.1603 17.91 18.8603C17.99 18.5603 17.95 18.2503 17.8 17.9903C17.23 17.0103 17.16 16.0003 17.6 15.2303C18.04 14.4603 18.95 14.0203 20.09 14.0203C20.73 14.0203 21.24 13.5103 21.24 12.8703V11.1103C21.24 10.4803 20.73 9.96029 20.09 9.96029C18.95 9.96029 18.04 9.52029 17.6 8.75029C17.16 7.98029 17.23 6.97029 17.8 5.99029C17.95 5.73029 17.99 5.42029 17.91 5.12029C17.83 4.82029 17.64 4.58029 17.38 4.42029L15.65 3.43029C15.22 3.17029 14.65 3.32029 14.39 3.76029L14.28 3.95029C13.71 4.94029 12.88 5.50029 11.99 5.50029C11.1 5.50029 10.27 4.94029 9.7 3.95029L9.59 3.75029C9.34 3.33029 8.78 3.18029 8.35 3.43029L6.62 4.43029C6.36 4.58029 6.16 4.83029 6.08 5.13029C6 5.43029 6.04 5.74029 6.19 6.00029C6.76 6.98029 6.83 7.99029 6.39 8.76029C5.95 9.53029 5.04 9.97029 3.9 9.97029C3.26 9.97029 2.75 10.4803 2.75 11.1203V12.8803C2.75 13.5103 3.26 14.0303 3.9 14.0303C5.04 14.0303 5.95 14.4703 6.39 15.2403C6.83 16.0103 6.76 17.0203 6.19 18.0003C6.04 18.2603 6 18.5703 6.08 18.8703C6.16 19.1703 6.35 19.4103 6.61 19.5703L8.34 20.5603C8.55 20.6903 8.8 20.7203 9.03 20.6603C9.27 20.6003 9.47 20.4403 9.6 20.2303L9.71 20.0403C10.28 19.0603 11.11 18.4903 12 18.4903Z"
        fill={color}
      />
    </svg>
  );
}
Settingsicon.propTypes = {
  color: PropTypes.string,
};
Settingsicon.defaultProps = {
  color: '#C9C9C9',
};
export function LampIcon() {
  return (
    <svg
      width="10vw"
      height="8.889vw"
      viewBox="0 0 144 113"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_38_55)">
        <path
          d="M116 79L71.7883 20.9788V14.921H70.8062V0H68.6768L68.9752 14.921L67.8033 14.921V20.984L24 79"
          fill="#A5CCFA"
        />
        <path
          d="M116 79L72.1975 21.5158C71.932 21.1675 71.7883 20.7416 71.7883 20.3037V15.4121C71.7883 15.1409 71.5684 14.921 71.2972 14.921V14.921C71.0261 14.921 70.8062 14.7012 70.8062 14.43V1.05407C70.8062 0.471924 70.3343 0 69.7522 0V0C69.1618 0 68.6865 0.48487 68.6983 1.07515L68.9634 14.3294C68.9699 14.6542 68.7083 14.921 68.3834 14.921V14.921C68.063 14.921 67.8033 15.1808 67.8033 15.5011V20.3138C67.8033 20.7487 67.6615 21.1718 67.3994 21.5189L24 79"
          fill="url(#paint0_linear_38_55)"
        />
        <path
          d="M71.7457 21.0398C71.7589 21.0297 71.7518 21.0085 71.7351 21.0085V21.0085V21.0088C71.7351 21.02 71.7388 21.0309 71.7457 21.0398V21.0398V21.0398ZM71.7867 14.9054C71.7867 14.9339 71.8099 14.9571 71.8384 14.9571V14.9571V14.9571C71.8384 14.9286 71.8153 14.9054 71.7867 14.9054V14.9054V14.9054ZM70.8056 15.0088C70.8056 14.9803 70.7825 14.9571 70.7539 14.9571V14.9571V14.9571C70.7539 14.9856 70.7771 15.0088 70.8056 15.0088V15.0088V15.0088ZM70.8056 0C70.8056 0.0285223 70.8287 0.0516996 70.8572 0.0516996V0.0516996V0.0516996C70.8572 0.0231773 70.8341 0 70.8056 0V0V0ZM68.6264 0.0516996C68.6549 0.0516996 68.6781 0.0285223 68.6781 0V0V0C68.6495 0 68.6264 0.0231773 68.6264 0.0516996V0.0516996V0.0516996ZM69.0274 14.9571C68.9988 14.9571 68.9757 14.9803 68.9757 15.0088V15.0088V15.0088C69.0042 15.0088 69.0274 14.9856 69.0274 14.9571V14.9571V14.9571ZM67.7537 14.9571C67.7822 14.9571 67.8053 14.9339 67.8053 14.9054V14.9054V14.9054C67.7768 14.9054 67.7537 14.9286 67.7537 14.9571V14.9571V14.9571ZM67.857 21.0137C67.8404 21.0137 67.8334 21.0349 67.8467 21.0449V21.0449V21.0449C67.8533 21.0359 67.857 21.0249 67.857 21.0137V21.0137V21.0137ZM115.959 78.9687C115.982 78.9514 115.986 78.9191 115.969 78.8964L71.8903 21.0593C71.8558 21.014 71.791 21.0052 71.7457 21.0398V21.0398L115.887 78.959C115.904 78.9816 115.936 78.986 115.959 78.9687V78.9687ZM71.7351 21.0085C71.7921 21.0085 71.8384 20.9623 71.8384 20.9052V14.9571V14.9571C71.7813 14.9571 71.7351 15.0033 71.7351 15.0604V21.0085V21.0085ZM71.7867 14.9054H70.909C70.8519 14.9054 70.8056 14.9517 70.8056 15.0088V15.0088H71.6833C71.7404 15.0088 71.7867 14.9625 71.7867 14.9054V14.9054ZM70.7539 14.9571C70.811 14.9571 70.8572 14.9108 70.8572 14.8538V0.0516996V0.0516996C70.8002 0.0516996 70.7539 0.0979417 70.7539 0.154984V14.9571V14.9571ZM70.8056 0H68.6781V0C68.6781 0.0571058 68.7243 0.103399 68.7814 0.103399H70.7022C70.7593 0.103399 70.8056 0.0571058 70.8056 0V0ZM68.6264 0.0516996L68.922 14.8538C68.9232 14.9112 68.97 14.9571 69.0274 14.9571V14.9571L68.7317 0.154956C68.7306 0.097599 68.6838 0.0516996 68.6264 0.0516996V0.0516996ZM68.9757 15.0088C68.9757 14.9517 68.9294 14.9054 68.8723 14.9054H67.8053V14.9054C67.8053 14.9625 67.8516 15.0088 67.9087 15.0088H68.9757V15.0088ZM67.7537 14.9571V20.9104C67.7537 20.9674 67.7999 21.0137 67.857 21.0137V21.0137V15.0604C67.857 15.0033 67.8107 14.9571 67.7537 14.9571V14.9571ZM67.8467 21.0449C67.8012 21.0104 67.7364 21.0194 67.702 21.0649L24.0311 78.8963C24.0139 78.919 24.0184 78.9514 24.0411 78.9686V78.9686C24.0639 78.9859 24.0964 78.9815 24.1136 78.9586L67.8467 21.0449V21.0449Z"
          fill="#6FA5E4"
        />
        <g filter="url(#filter0_f_38_55)">
          <path
            d="M24.0004 79.9618C23.8944 81.4038 46.4073 83.9707 69.6768 83.9998C93.3884 84.0286 116.106 81.3004 116 79.8464C115.858 77.9311 75.7612 78.0003 69.969 78.0003C64.249 78.0003 24.1425 78.0499 24.0004 79.9618Z"
            fill="#A8C0E2"
          />
        </g>
        <g filter="url(#filter1_f_38_55)">
          <path
            d="M24.0004 79.2887C23.8944 80.971 46.4073 83.9658 69.6768 83.9997C93.3884 84.0334 116.106 80.8504 116 79.1541C115.858 76.9196 75.7612 77.0004 69.969 77.0004C64.249 77.0004 24.1425 77.0582 24.0004 79.2887Z"
            stroke="url(#paint1_linear_38_55)"
            strokeOpacity="0.4"
            strokeWidth="2"
            strokeMiterlimit="10"
          />
        </g>
        <path
          d="M0 113L29.7931 79H110.731L144 113H0Z"
          fill="url(#paint2_linear_38_55)"
        />
      </g>
      <defs>
        <filter
          id="filter0_f_38_55"
          x="23"
          y="77"
          width="94"
          height="8"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="BackgroundImageFix"
            result="shape"
          />
          <feGaussianBlur
            stdDeviation="0.5"
            result="effect1_foregroundBlur_38_55"
          />
        </filter>
        <filter
          id="filter1_f_38_55"
          x="21.9998"
          y="75"
          width="96.0004"
          height="11"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="BackgroundImageFix"
            result="shape"
          />
          <feGaussianBlur
            stdDeviation="0.5"
            result="effect1_foregroundBlur_38_55"
          />
        </filter>
        <linearGradient
          id="paint0_linear_38_55"
          x1="20.7552"
          y1="80.878"
          x2="85.9263"
          y2="39.6409"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#588ECD" />
          <stop offset="0.275204" stopColor="#5F89BA" />
          <stop offset="0.522415" stopColor="#779ECC" />
          <stop offset="0.770747" stopColor="#8AB4E6" />
          <stop offset="1" stopColor="#94C0F2" />
        </linearGradient>
        <linearGradient
          id="paint1_linear_38_55"
          x1="70.0645"
          y1="77.0004"
          x2="70.0645"
          y2="84"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#38659A" />
          <stop offset="1" stopColor="#747474" stopOpacity="0.27" />
        </linearGradient>
        <linearGradient
          id="paint2_linear_38_55"
          x1="68.8171"
          y1="77.0286"
          x2="68.8171"
          y2="113"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#B5CEFF" stopOpacity="0.36" />
          <stop offset="1" stopColor="#E9E9E9" stopOpacity="0" />
        </linearGradient>
        <clipPath id="clip0_38_55">
          <rect width="144" height="113" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
}
export function QuloiLogo({ width, height }) {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 138 45"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g filter="url(#filter0_d_7936_150043)">
        <path
          d="M36.5799 30.5593H19.9282C11.7228 30.5593 4.94824 24.4003 4.94824 15.7951C4.94824 7.31155 11.4381 0.950684 19.8868 0.950684C28.0095 0.950684 34.621 7.14863 34.621 15.3891C34.621 20.2837 32.2947 25.0957 28.0095 27.0531V27.1357H36.5799V30.5593ZM30.4575 15.5495C30.4575 9.43183 25.9265 4.61985 19.7627 4.61985C13.7206 4.61985 9.10934 9.47317 9.10934 15.4693C9.10934 21.7913 13.4773 26.8877 19.7627 26.8877C26.092 26.8877 30.4575 21.8715 30.4575 15.5495Z"
          fill="#F5F5F5"
        />
        <path
          d="M37.5297 31.5077H19.929C10.996 31.5077 4 24.6046 4 15.7952C4 6.79125 10.8305 0.00244141 19.8876 0.00244141C28.6819 0.00244141 35.5708 6.76207 35.5708 15.3891C35.5708 19.7659 33.8674 23.7146 31.0569 26.1875H37.5297V31.5077ZM19.8876 1.8966C11.9134 1.8966 5.89804 7.87085 5.89804 15.7927C5.89804 23.6684 11.9304 29.6087 19.929 29.6087H35.6316V28.0792H27.0612V26.4404L27.616 26.1875C31.2953 24.5073 33.6728 20.2667 33.6728 15.3867C33.6728 7.82222 27.6185 1.8966 19.8876 1.8966ZM19.7659 27.8361C13.152 27.8361 8.16353 22.5183 8.16353 15.4694C8.16353 8.85318 13.259 3.67161 19.7659 3.67161C26.4042 3.67161 31.4097 8.7778 31.4097 15.5496C31.4097 22.5548 26.4042 27.8361 19.7659 27.8361ZM19.7659 5.5682C14.3249 5.5682 10.0616 9.91819 10.0616 15.4694C10.0616 21.4387 14.2324 25.9395 19.7659 25.9395C25.4114 25.9395 29.5092 21.57 29.5092 15.5496C29.5092 9.85983 25.3214 5.5682 19.7659 5.5682Z"
          fill="#F5F5F5"
        />
        <path
          d="M46.2703 1.68164V19.3831C46.2703 22.972 48.0661 27.6211 53.5364 27.6211C59.0067 27.6211 60.8025 22.972 60.8025 19.3831V1.68164H64.7203V19.9934C64.7203 26.6825 59.8632 31.2903 53.5364 31.2903C47.2096 31.2903 42.3525 26.6825 42.3525 19.9934V1.68164H46.2703Z"
          fill="#F5F5F5"
        />
        <path
          d="M53.5372 32.2411C46.5071 32.2411 41.4043 27.0911 41.4043 19.9959V0.733398H47.2201V19.3832C47.2201 22.746 48.8748 26.6729 53.5372 26.6729C58.1996 26.6729 59.8543 22.746 59.8543 19.3832V0.733398H65.6701V19.9935C65.6701 27.0911 60.5672 32.2411 53.5372 32.2411ZM43.3023 2.62998V19.9935C43.3023 25.9896 47.607 30.342 53.5372 30.342C59.4674 30.342 63.7696 25.992 63.7696 19.9935V2.62998H61.7499V19.3807C61.7499 23.9544 59.2094 28.567 53.5347 28.567C47.8601 28.567 45.3196 23.952 45.3196 19.3807V2.62998H43.3023Z"
          fill="#F5F5F5"
        />
        <path
          d="M72.8887 1.68311H76.8064V26.8883H90.0708V30.5599H72.8887V1.68311Z"
          fill="#56E6FF"
        />
        <path
          d="M91.0231 31.5082H71.9404V0.734863H77.7562V25.94H91.0231V31.5082ZM73.8409 29.6116H89.125V27.839H75.8606V2.63145H73.8409V29.6116Z"
          fill="#56E6FF"
        />
        <path
          d="M92.0117 16.1209C92.0117 7.55712 98.2558 0.948242 107.072 0.948242C115.888 0.948242 122.132 7.55469 122.132 16.1209C122.132 24.6872 115.888 31.2936 107.072 31.2936C98.2558 31.2936 92.0117 24.6848 92.0117 16.1209ZM117.971 16.1209C117.971 9.79898 113.686 4.61984 107.072 4.61984C100.458 4.61984 96.1753 9.79898 96.1753 16.1209C96.1753 22.4429 100.46 27.622 107.074 27.622C113.688 27.622 117.971 22.4429 117.971 16.1209Z"
          fill="#56E6FF"
        />
        <path
          d="M107.074 32.242C97.9461 32.242 91.0645 25.3121 91.0645 16.121C91.0645 6.92984 97.9485 0 107.074 0C116.199 0 123.083 6.92984 123.083 16.121C123.083 25.3121 116.201 32.242 107.074 32.242ZM107.074 1.89659C98.8975 1.89659 92.9625 7.87813 92.9625 16.121C92.9625 24.3639 98.8975 30.3454 107.074 30.3454C115.25 30.3454 121.185 24.3639 121.185 16.121C121.185 7.87813 115.25 1.89659 107.074 1.89659ZM107.074 28.5704C100.209 28.5704 95.2255 23.3353 95.2255 16.121C95.2255 8.90667 100.209 3.6716 107.074 3.6716C113.938 3.6716 118.922 8.90667 118.922 16.121C118.922 23.3353 113.938 28.5704 107.074 28.5704ZM107.074 5.56819C101.309 5.56819 97.126 10.0057 97.126 16.121C97.126 22.2363 101.309 26.6738 107.074 26.6738C112.838 26.6738 117.021 22.2363 117.021 16.121C117.021 10.0057 112.838 5.56819 107.074 5.56819Z"
          fill="#56E6FF"
        />
        <path
          d="M129.132 1.68213H133.05V30.5564H129.132V1.68213Z"
          fill="#56E6FF"
        />
        <path
          d="M133.999 31.5072H128.184V0.733887H133.999V31.5072ZM130.082 29.6106H132.101V2.63047H130.082V29.6106Z"
          fill="#56E6FF"
        />
        <path
          d="M27.0044 26.1948L17.5215 31.5174H37.5264V26.1948H27.0044Z"
          fill="#56E6FF"
        />
      </g>
      <defs>
        <filter
          id="filter0_d_7936_150043"
          x="0"
          y="0"
          width="137.999"
          height="46.2422"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy="10" />
          <feGaussianBlur stdDeviation="2" />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
          />
          <feBlend
            mode="normal"
            in2="BackgroundImageFix"
            result="effect1_dropShadow_7936_150043"
          />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect1_dropShadow_7936_150043"
            result="shape"
          />
        </filter>
      </defs>
    </svg>
  );
}
QuloiLogo.propTypes = {
  width: PropTypes.string,
  height: PropTypes.string,
};
QuloiLogo.defaultProps = {
  width: '9.028vw',
  height: '',
};
export function CalenderFillIcon() {
  return (
    <svg
      width="18"
      height="18"
      viewBox="0 0 18 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M12.5625 2.67V1.5C12.5625 1.1925 12.3075 0.9375 12 0.9375C11.6925 0.9375 11.4375 1.1925 11.4375 1.5V2.625H6.5625V1.5C6.5625 1.1925 6.3075 0.9375 6 0.9375C5.6925 0.9375 5.4375 1.1925 5.4375 1.5V2.67C3.4125 2.8575 2.43 4.065 2.28 5.8575C2.265 6.075 2.445 6.255 2.655 6.255H15.345C15.5625 6.255 15.7425 6.0675 15.72 5.8575C15.57 4.065 14.5875 2.8575 12.5625 2.67Z"
        fill="#C7E8ED"
      />
      <path
        d="M15 7.37988H3C2.5875 7.37988 2.25 7.71738 2.25 8.12988V12.7499C2.25 14.9999 3.375 16.4999 6 16.4999H12C14.625 16.4999 15.75 14.9999 15.75 12.7499V8.12988C15.75 7.71738 15.4125 7.37988 15 7.37988ZM6.9075 13.6574C6.87 13.6874 6.8325 13.7249 6.795 13.7474C6.75 13.7774 6.705 13.7999 6.66 13.8149C6.615 13.8374 6.57 13.8524 6.525 13.8599C6.4725 13.8674 6.4275 13.8749 6.375 13.8749C6.2775 13.8749 6.18 13.8524 6.09 13.8149C5.9925 13.7774 5.9175 13.7249 5.8425 13.6574C5.7075 13.5149 5.625 13.3199 5.625 13.1249C5.625 12.9299 5.7075 12.7349 5.8425 12.5924C5.9175 12.5249 5.9925 12.4724 6.09 12.4349C6.225 12.3749 6.375 12.3599 6.525 12.3899C6.57 12.3974 6.615 12.4124 6.66 12.4349C6.705 12.4499 6.75 12.4724 6.795 12.5024C6.8325 12.5324 6.87 12.5624 6.9075 12.5924C7.0425 12.7349 7.125 12.9299 7.125 13.1249C7.125 13.3199 7.0425 13.5149 6.9075 13.6574ZM6.9075 11.0324C6.765 11.1674 6.57 11.2499 6.375 11.2499C6.18 11.2499 5.985 11.1674 5.8425 11.0324C5.7075 10.8899 5.625 10.6949 5.625 10.4999C5.625 10.3049 5.7075 10.1099 5.8425 9.96738C6.0525 9.75738 6.3825 9.68988 6.66 9.80988C6.7575 9.84738 6.84 9.89988 6.9075 9.96738C7.0425 10.1099 7.125 10.3049 7.125 10.4999C7.125 10.6949 7.0425 10.8899 6.9075 11.0324ZM9.5325 13.6574C9.39 13.7924 9.195 13.8749 9 13.8749C8.805 13.8749 8.61 13.7924 8.4675 13.6574C8.3325 13.5149 8.25 13.3199 8.25 13.1249C8.25 12.9299 8.3325 12.7349 8.4675 12.5924C8.745 12.3149 9.255 12.3149 9.5325 12.5924C9.6675 12.7349 9.75 12.9299 9.75 13.1249C9.75 13.3199 9.6675 13.5149 9.5325 13.6574ZM9.5325 11.0324C9.495 11.0624 9.4575 11.0924 9.42 11.1224C9.375 11.1524 9.33 11.1749 9.285 11.1899C9.24 11.2124 9.195 11.2274 9.15 11.2349C9.0975 11.2424 9.0525 11.2499 9 11.2499C8.805 11.2499 8.61 11.1674 8.4675 11.0324C8.3325 10.8899 8.25 10.6949 8.25 10.4999C8.25 10.3049 8.3325 10.1099 8.4675 9.96738C8.535 9.89988 8.6175 9.84738 8.715 9.80988C8.9925 9.68988 9.3225 9.75738 9.5325 9.96738C9.6675 10.1099 9.75 10.3049 9.75 10.4999C9.75 10.6949 9.6675 10.8899 9.5325 11.0324ZM12.1575 13.6574C12.015 13.7924 11.82 13.8749 11.625 13.8749C11.43 13.8749 11.235 13.7924 11.0925 13.6574C10.9575 13.5149 10.875 13.3199 10.875 13.1249C10.875 12.9299 10.9575 12.7349 11.0925 12.5924C11.37 12.3149 11.88 12.3149 12.1575 12.5924C12.2925 12.7349 12.375 12.9299 12.375 13.1249C12.375 13.3199 12.2925 13.5149 12.1575 13.6574ZM12.1575 11.0324C12.12 11.0624 12.0825 11.0924 12.045 11.1224C12 11.1524 11.955 11.1749 11.91 11.1899C11.865 11.2124 11.82 11.2274 11.775 11.2349C11.7225 11.2424 11.67 11.2499 11.625 11.2499C11.43 11.2499 11.235 11.1674 11.0925 11.0324C10.9575 10.8899 10.875 10.6949 10.875 10.4999C10.875 10.3049 10.9575 10.1099 11.0925 9.96738C11.1675 9.89988 11.2425 9.84738 11.34 9.80988C11.475 9.74988 11.625 9.73488 11.775 9.76488C11.82 9.77238 11.865 9.78738 11.91 9.80988C11.955 9.82488 12 9.84738 12.045 9.87738C12.0825 9.90738 12.12 9.93738 12.1575 9.96738C12.2925 10.1099 12.375 10.3049 12.375 10.4999C12.375 10.6949 12.2925 10.8899 12.1575 11.0324Z"
        fill="#C7E8ED"
      />
    </svg>
  );
}
export function CurgoReadyIcon({ color, size }) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M13 14.75H2C1.59 14.75 1.25 14.41 1.25 14V7.62C1.25 7.3 1.44999 7.01997 1.73999 6.90997C2.03999 6.79997 2.37001 6.89 2.57001 7.13C3.18001 7.86 4.13001 8.26999 5.07001 8.23999C5.87001 8.21999 6.60998 7.92001 7.16998 7.39001C7.42998 7.17001 7.63999 6.91 7.79999 6.62C8.10999 6.09 8.26 5.50998 8.25 4.91998C8.23 3.99998 7.83002 3.15999 7.15002 2.54999C6.91002 2.33999 6.83 2.00997 6.94 1.71997C7.05 1.42997 7.33001 1.22998 7.64001 1.22998H15C15.41 1.22998 15.75 1.56998 15.75 1.97998V11.98C15.75 13.52 14.52 14.75 13 14.75ZM2.75 13.25H13C13.69 13.25 14.25 12.69 14.25 12V2.75H9.19C9.54 3.4 9.73 4.13001 9.75 4.89001C9.77 5.76001 9.54999 6.62 9.10999 7.37C8.86999 7.8 8.53999 8.21001 8.17999 8.51001C7.37999 9.27001 6.27999 9.72 5.10999 9.75C4.26999 9.78 3.46001 9.57 2.76001 9.19V13.25H2.75Z"
        fill={color}
      />
      <path
        d="M19 20.75H18C17.59 20.75 17.25 20.41 17.25 20C17.25 19.31 16.69 18.75 16 18.75C15.31 18.75 14.75 19.31 14.75 20C14.75 20.41 14.41 20.75 14 20.75H10C9.59 20.75 9.25 20.41 9.25 20C9.25 19.31 8.69 18.75 8 18.75C7.31 18.75 6.75 19.31 6.75 20C6.75 20.41 6.41 20.75 6 20.75H5C2.93 20.75 1.25 19.07 1.25 17V14C1.25 13.59 1.59 13.25 2 13.25H13C13.69 13.25 14.25 12.69 14.25 12V5C14.25 4.59 14.59 4.25 15 4.25H16.84C17.83 4.25 18.74 4.78001 19.23 5.64001L20.94 8.63C21.07 8.86 21.07 9.15 20.94 9.38C20.81 9.61 20.56 9.75 20.29 9.75H19C18.86 9.75 18.75 9.86 18.75 10V13C18.75 13.14 18.86 13.25 19 13.25H22C22.41 13.25 22.75 13.59 22.75 14V17C22.75 19.07 21.07 20.75 19 20.75ZM18.65 19.25H19C20.24 19.25 21.25 18.24 21.25 17V14.75H19C18.04 14.75 17.25 13.96 17.25 13V10C17.25 9.04 18.03 8.25 19 8.25L17.93 6.38C17.71 5.99 17.29 5.75 16.84 5.75H15.75V12C15.75 13.52 14.52 14.75 13 14.75H2.75V17C2.75 18.24 3.76 19.25 5 19.25H5.34998C5.67998 18.1 6.74 17.25 8 17.25C9.26 17.25 10.32 18.1 10.65 19.25H13.36C13.69 18.1 14.75 17.25 16.01 17.25C17.27 17.25 18.32 18.1 18.65 19.25Z"
        fill={color}
      />
      <path
        d="M8 22.75C6.48 22.75 5.25 21.52 5.25 20C5.25 18.48 6.48 17.25 8 17.25C9.52 17.25 10.75 18.48 10.75 20C10.75 21.52 9.52 22.75 8 22.75ZM8 18.75C7.31 18.75 6.75 19.31 6.75 20C6.75 20.69 7.31 21.25 8 21.25C8.69 21.25 9.25 20.69 9.25 20C9.25 19.31 8.69 18.75 8 18.75Z"
        fill={color}
      />
      <path
        d="M16 22.75C14.48 22.75 13.25 21.52 13.25 20C13.25 18.48 14.48 17.25 16 17.25C17.52 17.25 18.75 18.48 18.75 20C18.75 21.52 17.52 22.75 16 22.75ZM16 18.75C15.31 18.75 14.75 19.31 14.75 20C14.75 20.69 15.31 21.25 16 21.25C16.69 21.25 17.25 20.69 17.25 20C17.25 19.31 16.69 18.75 16 18.75Z"
        fill={color}
      />
      <path
        d="M22 14.75H19C18.04 14.75 17.25 13.96 17.25 13V10C17.25 9.04 18.04 8.25 19 8.25H20.29C20.56 8.25 20.81 8.39 20.94 8.63L22.65 11.63C22.71 11.74 22.75 11.87 22.75 12V14C22.75 14.41 22.41 14.75 22 14.75ZM19 9.75C18.86 9.75 18.75 9.86 18.75 10V13C18.75 13.14 18.86 13.25 19 13.25H21.25V12.2L19.85 9.75H19Z"
        fill={color}
      />
      <path
        d="M4.9901 9.75C3.6101 9.75 2.31011 9.14998 1.43011 8.09998C1.29011 7.94998 1.14012 7.73998 1.01012 7.53998C0.540123 6.82998 0.280123 5.98999 0.260123 5.10999C0.220123 3.64999 0.840136 2.27998 1.96014 1.34998C2.81014 0.649976 3.83009 0.27 4.91009 0.25C6.09009 0.26 7.27014 0.650002 8.15014 1.44C9.15014 2.32 9.73012 3.55001 9.76012 4.89001C9.78012 5.76001 9.56011 6.62 9.12011 7.37C8.88011 7.8 8.55012 8.21001 8.19012 8.51001C7.39012 9.27001 6.29011 9.72 5.12011 9.75C5.07011 9.75 5.0301 9.75 4.9901 9.75ZM4.9901 1.75C4.9701 1.75 4.95011 1.75 4.93011 1.75C4.20011 1.76 3.50009 2.03001 2.91009 2.51001C2.15009 3.14001 1.73011 4.08001 1.75011 5.07001C1.77011 5.67001 1.94012 6.24002 2.26012 6.71002C2.35012 6.85002 2.4401 6.97998 2.5501 7.09998C3.1901 7.85998 4.14012 8.25999 5.07012 8.23999C5.87012 8.21999 6.6101 7.92001 7.1701 7.39001C7.4301 7.17001 7.6401 6.91 7.8001 6.62C8.1101 6.09 8.26011 5.50998 8.25011 4.91998C8.23011 3.99998 7.83014 3.15999 7.15014 2.54999C6.55014 2.03999 5.7901 1.75 4.9901 1.75Z"
        fill={color}
      />
      <path
        d="M4.44988 6.74993C4.25988 6.74993 4.07986 6.6799 3.92986 6.5399L2.91985 5.57994C2.61985 5.28994 2.60989 4.81995 2.89989 4.51995C3.18989 4.21995 3.65989 4.20993 3.95989 4.49993L4.44988 4.9699L6.01988 3.44994C6.31988 3.15994 6.78988 3.1699 7.07988 3.4699C7.36988 3.7699 7.35986 4.23996 7.05986 4.52996L4.96984 6.54991C4.81984 6.67991 4.62988 6.74993 4.44988 6.74993Z"
        fill={color}
      />
    </svg>
  );
}
CurgoReadyIcon.propTypes = {
  color: PropTypes.string,
  size: PropTypes.string,
};
CurgoReadyIcon.defaultProps = {
  color: '#292D32',
  size: '24',
};
export function BookedIcon({ color, size }) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M19.0001 22.7499C17.3801 22.7499 15.8501 21.9099 14.9901 20.5299C14.5301 19.8199 14.2701 18.9699 14.2501 18.0999C14.2201 16.6399 14.8401 15.2799 15.9501 14.3599C16.7801 13.6699 17.8201 13.2799 18.8901 13.2499C20.1901 13.2399 21.3601 13.6899 22.2801 14.5699C23.2001 15.4499 23.7201 16.6299 23.7401 17.8999C23.7601 18.7699 23.5401 19.6199 23.1001 20.3699C22.8601 20.7899 22.5501 21.1799 22.1801 21.5099C21.3601 22.2799 20.2601 22.7299 19.0901 22.7499C19.0701 22.7499 19.0401 22.7499 19.0001 22.7499ZM19.0001 14.7499C18.9801 14.7499 18.9501 14.7499 18.9301 14.7499C18.1901 14.7699 17.4901 15.0299 16.9101 15.5099C16.1501 16.1399 15.7301 17.0699 15.7501 18.0699C15.7601 18.6599 15.9401 19.2399 16.2501 19.7299C16.8601 20.7099 17.9201 21.3099 19.0601 21.2499C19.8501 21.2299 20.6001 20.9299 21.1701 20.3999C21.4301 20.1699 21.6401 19.9099 21.8001 19.6299C22.1001 19.1099 22.2501 18.5299 22.2401 17.9399C22.2201 17.0699 21.8701 16.2599 21.2401 15.6599C20.6401 15.0699 19.8401 14.7499 19.0001 14.7499Z"
        fill={color}
      />
      <path
        d="M18.4499 19.7499C18.2599 19.7499 18.0799 19.6799 17.9299 19.5399L16.9199 18.5799C16.6199 18.2899 16.6099 17.8199 16.8999 17.5199C17.1899 17.2199 17.6599 17.2099 17.9599 17.4999L18.4499 17.9699L20.0199 16.4499C20.3199 16.1599 20.7899 16.1699 21.0799 16.4699C21.3699 16.7699 21.3599 17.24 21.0599 17.53L18.9699 19.5499C18.8199 19.6799 18.6299 19.7499 18.4499 19.7499Z"
        fill={color}
      />
      <path
        d="M11.9998 13.2999C11.8698 13.2999 11.7398 13.2699 11.6198 13.1999L2.78985 8.0899C2.42985 7.8799 2.30983 7.41987 2.51983 7.05987C2.72983 6.69987 3.18985 6.57985 3.53985 6.78985L11.9898 11.6799L20.3899 6.81988C20.7499 6.60988 21.2098 6.7399 21.4098 7.0899C21.6198 7.4499 21.4899 7.90987 21.1399 8.11987L12.3698 13.1999C12.2598 13.2599 12.1298 13.2999 11.9998 13.2999Z"
        fill={color}
      />
      <path
        d="M12 22.3598C11.59 22.3598 11.25 22.0198 11.25 21.6098V12.5398C11.25 12.1298 11.59 11.7898 12 11.7898C12.41 11.7898 12.75 12.1298 12.75 12.5398V21.6098C12.75 22.0198 12.41 22.3598 12 22.3598Z"
        fill={color}
      />
      <path
        d="M11.9999 22.7499C11.1199 22.7499 10.2399 22.5599 9.55988 22.1699L4.21988 19.2099C2.76988 18.4099 1.62988 16.4799 1.62988 14.8199V9.1599C1.62988 7.4999 2.76988 5.57994 4.21988 4.76994L9.55988 1.80992C10.9199 1.03992 13.0599 1.03992 14.4299 1.80992L19.7699 4.76994C21.2199 5.56994 22.3599 7.4999 22.3599 9.1599V14.8199C22.3599 14.9199 22.3599 14.9999 22.3399 15.0999C22.2899 15.3599 22.0999 15.5799 21.8499 15.6599C21.5999 15.7499 21.3199 15.6899 21.1099 15.5199C19.9599 14.5199 18.1799 14.4799 16.9699 15.4499C16.1999 16.0599 15.7499 16.9899 15.7499 17.9799C15.7499 18.5699 15.9099 19.1499 16.2199 19.6499C16.2999 19.7899 16.3799 19.8999 16.4699 20.0099C16.6199 20.1799 16.6799 20.4099 16.6399 20.6299C16.5999 20.8499 16.4599 21.0399 16.2599 21.1499L14.4299 22.1599C13.7499 22.5599 12.8799 22.7499 11.9999 22.7499ZM11.9999 2.74992C11.3799 2.74992 10.7499 2.87993 10.2999 3.12993L4.95987 6.08995C3.98987 6.61995 3.14987 8.0599 3.14987 9.1599V14.8199C3.14987 15.9199 3.99987 17.3599 4.95987 17.8899L10.2999 20.8499C11.2099 21.3599 12.7999 21.3599 13.7099 20.8499L14.8299 20.2299C14.4599 19.5599 14.2599 18.7799 14.2599 17.9799C14.2599 16.5199 14.9099 15.1699 16.0399 14.2699C17.3999 13.1799 19.3399 12.9499 20.8699 13.5999V9.13994C20.8699 8.03994 20.0199 6.59993 19.0599 6.06993L13.7199 3.10991C13.2499 2.87991 12.6199 2.74992 11.9999 2.74992Z"
        fill={color}
      />
    </svg>
  );
}
BookedIcon.propTypes = {
  color: PropTypes.string,
  size: PropTypes.string,
};
BookedIcon.defaultProps = {
  color: '#292D32',
  size: '24',
};
export function AddUserNewIcon() {
  return (
    <svg
      width="1.111vw"
      height="1.111vw"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M7.99935 8.49967C5.88602 8.49967 4.16602 6.77967 4.16602 4.66634C4.16602 2.55301 5.88602 0.833008 7.99935 0.833008C10.1127 0.833008 11.8327 2.55301 11.8327 4.66634C11.8327 6.77967 10.1127 8.49967 7.99935 8.49967ZM7.99935 1.83301C6.43935 1.83301 5.16602 3.10634 5.16602 4.66634C5.16602 6.22634 6.43935 7.49967 7.99935 7.49967C9.55935 7.49967 10.8327 6.22634 10.8327 4.66634C10.8327 3.10634 9.55935 1.83301 7.99935 1.83301Z"
        fill="#603ACB"
      />
      <path
        d="M2.27344 15.1667C2.0001 15.1667 1.77344 14.94 1.77344 14.6667C1.77344 11.82 4.56677 9.5 8.0001 9.5C8.67344 9.5 9.33343 9.58668 9.97343 9.76668C10.2401 9.84002 10.3934 10.1133 10.3201 10.38C10.2468 10.6467 9.97343 10.8 9.70677 10.7267C9.1601 10.5734 8.58677 10.5 8.0001 10.5C5.1201 10.5 2.77344 12.3667 2.77344 14.6667C2.77344 14.94 2.54677 15.1667 2.27344 15.1667Z"
        fill="#603ACB"
      />
      <path
        d="M12.0007 15.1663C11.214 15.1663 10.4673 14.873 9.88731 14.3464C9.65398 14.1464 9.44731 13.8997 9.28731 13.6263C8.99398 13.1463 8.83398 12.5797 8.83398 11.9997C8.83398 11.1663 9.15398 10.3863 9.72732 9.79301C10.3273 9.17301 11.134 8.83301 12.0007 8.83301C12.9073 8.83301 13.7673 9.21969 14.354 9.88635C14.874 10.4664 15.1673 11.213 15.1673 11.9997C15.1673 12.253 15.134 12.5063 15.0673 12.7463C15.0007 13.0463 14.874 13.3597 14.7006 13.633C14.1473 14.5797 13.1073 15.1663 12.0007 15.1663ZM12.0007 9.83301C11.4073 9.83301 10.8607 10.0663 10.4473 10.4863C10.054 10.893 9.83398 11.4263 9.83398 11.9997C9.83398 12.393 9.94065 12.7797 10.1473 13.113C10.254 13.2997 10.394 13.4663 10.554 13.6063C10.954 13.973 11.4673 14.173 12.0007 14.173C12.754 14.173 13.4673 13.773 13.854 13.1263C13.9673 12.9397 14.054 12.7264 14.1006 12.5197C14.1473 12.3464 14.1673 12.1797 14.1673 12.0063C14.1673 11.473 13.9673 10.9597 13.6073 10.5597C13.2073 10.093 12.6207 9.83301 12.0007 9.83301Z"
        fill="#603ACB"
      />
      <path
        d="M12.9992 12.4873H11.0059C10.7325 12.4873 10.5059 12.2606 10.5059 11.9873C10.5059 11.714 10.7325 11.4873 11.0059 11.4873H12.9992C13.2725 11.4873 13.4992 11.714 13.4992 11.9873C13.4992 12.2606 13.2725 12.4873 12.9992 12.4873Z"
        fill="#603ACB"
      />
      <path
        d="M12 13.506C11.7267 13.506 11.5 13.2794 11.5 13.006V11.0127C11.5 10.7394 11.7267 10.5127 12 10.5127C12.2733 10.5127 12.5 10.7394 12.5 11.0127V13.006C12.5 13.286 12.2733 13.506 12 13.506Z"
        fill="#603ACB"
      />
    </svg>
  );
}
export function EditNewIcon() {
  return (
    <svg
      width="1.111vw"
      height="1.111vw"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M7.33398 1.33301H6.00065C2.66732 1.33301 1.33398 2.66634 1.33398 5.99967V9.99967C1.33398 13.333 2.66732 14.6663 6.00065 14.6663H10.0007C13.334 14.6663 14.6673 13.333 14.6673 9.99967V8.66634"
        stroke="#F29C4C"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M10.6913 2.0135L5.43797 7.26684C5.23797 7.46684 5.03797 7.86017 4.99797 8.14684L4.7113 10.1535C4.60463 10.8802 5.11797 11.3868 5.84463 11.2868L7.8513 11.0002C8.1313 10.9602 8.52463 10.7602 8.7313 10.5602L13.9846 5.30684C14.8913 4.40017 15.318 3.34684 13.9846 2.0135C12.6513 0.680168 11.598 1.10684 10.6913 2.0135Z"
        stroke="#F29C4C"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M9.93945 2.7666C10.3861 4.35993 11.6328 5.6066 13.2328 6.05993"
        stroke="#F29C4C"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}
export function KeyOutlineIcon({ color, size }) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M4.12009 15.1669C4.05342 15.1669 3.98009 15.1603 3.92009 15.1536L2.47342 14.9536C1.78009 14.8603 1.15342 14.2403 1.04676 13.5336L0.846758 12.0736C0.780091 11.6069 0.980091 11.0003 1.31342 10.6603L4.24009 7.73361C3.76676 5.84028 4.31343 3.84027 5.70676 2.46027C7.86676 0.306941 11.3801 0.300274 13.5468 2.46027C14.5934 3.50694 15.1668 4.90027 15.1668 6.38027C15.1668 7.86027 14.5934 9.25361 13.5468 10.3003C12.1468 11.6869 10.1534 12.2336 8.27342 11.7536L5.34009 14.6803C5.06009 14.9736 4.56009 15.1669 4.12009 15.1669ZM9.62009 1.84027C8.45342 1.84027 7.29342 2.28027 6.40676 3.16694C5.20676 4.36027 4.77342 6.10694 5.27342 7.73361C5.32676 7.91361 5.28009 8.10028 5.14676 8.23361L2.01342 11.3669C1.90009 11.4803 1.80676 11.7736 1.82676 11.9269L2.02676 13.3869C2.06676 13.6403 2.34009 13.9269 2.59342 13.9603L4.04676 14.1603C4.20676 14.1869 4.50009 14.0936 4.61342 13.9803L7.76009 10.8403C7.89342 10.7069 8.08676 10.6669 8.26009 10.7203C9.86676 11.2269 11.6201 10.7936 12.8201 9.59361C13.6734 8.74027 14.1468 7.59361 14.1468 6.38027C14.1468 5.16027 13.6734 4.02027 12.8201 3.16694C11.9534 2.28694 10.7868 1.84027 9.62009 1.84027Z"
        fill={color}
      />
      <path
        d="M6.12737 13.6928C6.0007 13.6928 5.87404 13.6461 5.77404 13.5461L4.2407 12.0128C4.04737 11.8195 4.04737 11.4995 4.2407 11.3061C4.43404 11.1128 4.75404 11.1128 4.94737 11.3061L6.4807 12.8395C6.67404 13.0328 6.67404 13.3528 6.4807 13.5461C6.3807 13.6461 6.25404 13.6928 6.12737 13.6928Z"
        fill={color}
      />
      <path
        d="M9.66602 7.83301C8.83935 7.83301 8.16602 7.15967 8.16602 6.33301C8.16602 5.50634 8.83935 4.83301 9.66602 4.83301C10.4927 4.83301 11.166 5.50634 11.166 6.33301C11.166 7.15967 10.4927 7.83301 9.66602 7.83301ZM9.66602 5.83301C9.39268 5.83301 9.16602 6.05967 9.16602 6.33301C9.16602 6.60634 9.39268 6.83301 9.66602 6.83301C9.93935 6.83301 10.166 6.60634 10.166 6.33301C10.166 6.05967 9.93935 5.83301 9.66602 5.83301Z"
        fill={color}
      />
    </svg>
  );
}
KeyOutlineIcon.propTypes = {
  color: PropTypes.string,
  size: PropTypes.string,
};
KeyOutlineIcon.defaultProps = {
  color: '#1D3E69',
  size: '1.111vw',
};
export function NewTrashIcon() {
  return (
    <svg
      width="1.111vw"
      height="1.111vw"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M14.0004 4.4873C13.9871 4.4873 13.9671 4.4873 13.9471 4.4873C10.4204 4.13397 6.90043 4.00064 3.41377 4.35397L2.05377 4.4873C1.77377 4.51397 1.5271 4.31397 1.50043 4.03397C1.47377 3.75397 1.67377 3.51397 1.9471 3.4873L3.3071 3.35397C6.85377 2.99397 10.4471 3.13397 14.0471 3.4873C14.3204 3.51397 14.5204 3.76064 14.4938 4.03397C14.4738 4.29397 14.2538 4.4873 14.0004 4.4873Z"
        fill="#F37A90"
      />
      <path
        d="M5.66651 3.81301C5.63984 3.81301 5.61318 3.81301 5.57984 3.80634C5.31318 3.75967 5.12651 3.49967 5.17318 3.23301L5.31984 2.35967C5.42651 1.71967 5.57318 0.833008 7.12651 0.833008H8.87318C10.4332 0.833008 10.5798 1.75301 10.6798 2.36634L10.8265 3.23301C10.8732 3.50634 10.6865 3.76634 10.4198 3.80634C10.1465 3.85301 9.88651 3.66634 9.84651 3.39967L9.69984 2.53301C9.60651 1.95301 9.58651 1.83967 8.87984 1.83967H7.13318C6.42651 1.83967 6.41318 1.93301 6.31318 2.52634L6.15984 3.39301C6.11984 3.63967 5.90651 3.81301 5.66651 3.81301Z"
        fill="#F37A90"
      />
      <path
        d="M10.1396 15.1667H5.85961C3.53294 15.1667 3.43961 13.88 3.36627 12.84L2.93294 6.12672C2.91294 5.85338 3.12627 5.61338 3.39961 5.59338C3.67961 5.58005 3.91294 5.78672 3.93294 6.06005L4.36627 12.7734C4.43961 13.7867 4.46627 14.1667 5.85961 14.1667H10.1396C11.5396 14.1667 11.5663 13.7867 11.6329 12.7734L12.0663 6.06005C12.0863 5.78672 12.3263 5.58005 12.5996 5.59338C12.8729 5.61338 13.0863 5.84672 13.0663 6.12672L12.6329 12.84C12.5596 13.88 12.4663 15.1667 10.1396 15.1667Z"
        fill="#F37A90"
      />
      <path
        d="M9.10672 11.5H6.88672C6.61339 11.5 6.38672 11.2733 6.38672 11C6.38672 10.7267 6.61339 10.5 6.88672 10.5H9.10672C9.38005 10.5 9.60672 10.7267 9.60672 11C9.60672 11.2733 9.38005 11.5 9.10672 11.5Z"
        fill="#F37A90"
      />
      <path
        d="M9.66732 8.83301H6.33398C6.06065 8.83301 5.83398 8.60634 5.83398 8.33301C5.83398 8.05967 6.06065 7.83301 6.33398 7.83301H9.66732C9.94065 7.83301 10.1673 8.05967 10.1673 8.33301C10.1673 8.60634 9.94065 8.83301 9.66732 8.83301Z"
        fill="#F37A90"
      />
    </svg>
  );
}
export function TrashIconFillIcon({ color, size }) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 16 17"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M14.0461 3.98732C12.9728 3.88065 11.8995 3.80065 10.8195 3.74065V3.73398L10.6728 2.86732C10.5728 2.25398 10.4261 1.33398 8.86612 1.33398H7.11945C5.56612 1.33398 5.41945 2.21398 5.31279 2.86065L5.17279 3.71398C4.55279 3.75398 3.93279 3.79398 3.31279 3.85398L1.95279 3.98732C1.67279 4.01398 1.47279 4.26065 1.49945 4.53398C1.52612 4.80732 1.76612 5.00732 2.04612 4.98065L3.40612 4.84732C6.89945 4.50065 10.4195 4.63398 13.9528 4.98732C13.9728 4.98732 13.9861 4.98732 14.0061 4.98732C14.2595 4.98732 14.4795 4.79398 14.5061 4.53398C14.5261 4.26065 14.3261 4.01398 14.0461 3.98732Z"
        fill={color}
      />
      <path
        d="M12.8202 5.92602C12.6602 5.75935 12.4402 5.66602 12.2135 5.66602H3.78683C3.56016 5.66602 3.33349 5.75935 3.18016 5.92602C3.02683 6.09268 2.94016 6.31935 2.95349 6.55268L3.36683 13.3927C3.44016 14.406 3.53349 15.6727 5.86016 15.6727H10.1402C12.4668 15.6727 12.5602 14.4127 12.6335 13.3927L13.0468 6.55935C13.0602 6.31935 12.9735 6.09268 12.8202 5.92602ZM9.10682 12.3327H6.88683C6.61349 12.3327 6.38683 12.106 6.38683 11.8327C6.38683 11.5593 6.61349 11.3327 6.88683 11.3327H9.10682C9.38016 11.3327 9.60682 11.5593 9.60682 11.8327C9.60682 12.106 9.38016 12.3327 9.10682 12.3327ZM9.66683 9.66602H6.33349C6.06016 9.66602 5.83349 9.43935 5.83349 9.16602C5.83349 8.89268 6.06016 8.66602 6.33349 8.66602H9.66683C9.94016 8.66602 10.1668 8.89268 10.1668 9.16602C10.1668 9.43935 9.94016 9.66602 9.66683 9.66602Z"
        fill={color}
      />
    </svg>
  );
}
TrashIconFillIcon.propTypes = {
  color: PropTypes.string,
  size: PropTypes.string,
};
TrashIconFillIcon.defaultProps = {
  color: '#616B80',
  size: '1.111vw',
};
export function NewShortIcon() {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M21 7.75H3C2.59 7.75 2.25 7.41 2.25 7C2.25 6.59 2.59 6.25 3 6.25H21C21.41 6.25 21.75 6.59 21.75 7C21.75 7.41 21.41 7.75 21 7.75Z"
        fill="#616B80"
      />
      <path
        d="M18 12.75H6C5.59 12.75 5.25 12.41 5.25 12C5.25 11.59 5.59 11.25 6 11.25H18C18.41 11.25 18.75 11.59 18.75 12C18.75 12.41 18.41 12.75 18 12.75Z"
        fill="#616B80"
      />
      <path
        d="M14 17.75H10C9.59 17.75 9.25 17.41 9.25 17C9.25 16.59 9.59 16.25 10 16.25H14C14.41 16.25 14.75 16.59 14.75 17C14.75 17.41 14.41 17.75 14 17.75Z"
        fill="#616B80"
      />
    </svg>
  );
}
export function KeyFrameIcon() {
  return (
    <svg
      width="17"
      height="1.111vw"
      viewBox="0 0 17 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M8.50091 15.1733C7.77424 15.1733 7.05424 14.96 6.48758 14.54L3.62091 12.4C2.86091 11.8333 2.26758 10.6533 2.26758 9.70663V4.74663C2.26758 3.71996 3.02091 2.62663 3.98758 2.26663L7.31424 1.01996C7.97424 0.773294 9.01424 0.773294 9.67424 1.01996L13.0076 2.26663C13.9742 2.62663 14.7276 3.71996 14.7276 4.74663V9.69996C14.7276 10.6466 14.1342 11.8266 13.3742 12.3933L10.5076 14.5333C9.94758 14.96 9.22758 15.1733 8.50091 15.1733ZM7.66758 1.95996L4.34091 3.20663C3.76758 3.41996 3.26758 4.13996 3.26758 4.75329V9.70663C3.26758 10.34 3.71424 11.2266 4.21424 11.6L7.08091 13.74C7.84758 14.3133 9.14758 14.3133 9.91424 13.74L12.7809 11.6C13.2876 11.22 13.7276 10.3333 13.7276 9.70663V4.74663C13.7276 4.13996 13.2276 3.41996 12.6542 3.19996L9.32758 1.95329C8.88758 1.79329 8.11424 1.79329 7.66758 1.95996Z"
        fill="white"
      />
      <path
        d="M8.49935 8.83366C7.48602 8.83366 6.66602 8.01366 6.66602 7.00033C6.66602 5.98699 7.48602 5.16699 8.49935 5.16699C9.51268 5.16699 10.3327 5.98699 10.3327 7.00033C10.3327 8.01366 9.51268 8.83366 8.49935 8.83366ZM8.49935 6.16699C8.03935 6.16699 7.66602 6.54033 7.66602 7.00033C7.66602 7.46033 8.03935 7.83366 8.49935 7.83366C8.95935 7.83366 9.33268 7.46033 9.33268 7.00033C9.33268 6.54033 8.95935 6.16699 8.49935 6.16699Z"
        fill="white"
      />
      <path
        d="M8.5 10.833C8.22667 10.833 8 10.6063 8 10.333V8.33301C8 8.05967 8.22667 7.83301 8.5 7.83301C8.77333 7.83301 9 8.05967 9 8.33301V10.333C9 10.6063 8.77333 10.833 8.5 10.833Z"
        fill="white"
      />
    </svg>
  );
}
export function AddUserNewCircleIcon({ color }) {
  return (
    <svg
      width="1.111vw"
      height="1.111vw"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M7.64091 9.65291C6.33424 9.65291 5.26758 8.58625 5.26758 7.27958C5.26758 5.97292 6.33424 4.90625 7.64091 4.90625C8.94758 4.90625 10.0142 5.97292 10.0142 7.27958C10.0142 8.58625 8.94758 9.65291 7.64091 9.65291ZM7.64091 5.91292C6.88758 5.91292 6.26758 6.52625 6.26758 7.28625C6.26758 8.04625 6.88091 8.65959 7.64091 8.65959C8.40091 8.65959 9.01424 8.04625 9.01424 7.28625C9.01424 6.52625 8.40091 5.91292 7.64091 5.91292Z"
        fill={color}
      />
      <path
        d="M11.0997 13.9665C10.8264 13.9665 10.5997 13.7398 10.5997 13.4665C10.5997 12.1865 9.27302 11.1465 7.63969 11.1465C6.00635 11.1465 4.67969 12.1865 4.67969 13.4665C4.67969 13.7398 4.45302 13.9665 4.17969 13.9665C3.90635 13.9665 3.67969 13.7398 3.67969 13.4665C3.67969 11.6398 5.45302 10.1465 7.63969 10.1465C9.82635 10.1465 11.5997 11.6332 11.5997 13.4665C11.5997 13.7398 11.373 13.9665 11.0997 13.9665Z"
        fill={color}
      />
      <path
        d="M7.66732 15.1667C3.90065 15.1667 0.833984 12.1 0.833984 8.33333C0.833984 4.56667 3.90065 1.5 7.66732 1.5C8.59398 1.5 9.48732 1.67999 10.3273 2.03333C10.5673 2.13333 10.6873 2.39998 10.6073 2.64665C10.534 2.86665 10.5007 3.1 10.5007 3.33333C10.5007 3.72667 10.6073 4.11332 10.814 4.44666C10.9207 4.63332 11.0607 4.79998 11.2207 4.93998C11.8007 5.46665 12.6607 5.63335 13.334 5.39335C13.5807 5.30002 13.8607 5.42667 13.9607 5.67334C14.3207 6.52001 14.5007 7.42001 14.5007 8.34001C14.5007 12.1 11.434 15.1667 7.66732 15.1667ZM7.66732 2.5C4.45398 2.5 1.83398 5.11333 1.83398 8.33333C1.83398 11.5533 4.45398 14.1667 7.66732 14.1667C10.8807 14.1667 13.5007 11.5533 13.5007 8.33333C13.5007 7.69333 13.394 7.06 13.194 6.45333C12.274 6.61333 11.2673 6.32668 10.5607 5.68001C10.3273 5.48001 10.1207 5.23334 9.96065 4.96C9.66732 4.48 9.50732 3.91333 9.50732 3.33333C9.50732 3.15333 9.52065 2.98001 9.55399 2.80668C8.94732 2.60001 8.31398 2.5 7.66732 2.5Z"
        fill={color}
      />
      <path
        d="M12.6667 6.50033C11.88 6.50033 11.1333 6.20701 10.5533 5.68034C10.32 5.48034 10.1133 5.23366 9.95333 4.96033C9.66 4.48033 9.5 3.91366 9.5 3.33366C9.5 2.99366 9.55333 2.66033 9.66 2.34033C9.80667 1.887 10.06 1.46699 10.4 1.12699C11 0.51366 11.8067 0.166992 12.6733 0.166992C13.58 0.166992 14.44 0.55367 15.0267 1.22034C15.5467 1.80034 15.84 2.54699 15.84 3.33366C15.84 3.58699 15.8067 3.84032 15.74 4.08032C15.6733 4.38032 15.5467 4.69367 15.3733 4.967C14.9867 5.62033 14.3733 6.10699 13.6533 6.33366C13.3533 6.44699 13.02 6.50033 12.6667 6.50033ZM12.6667 1.16699C12.0733 1.16699 11.52 1.40031 11.1133 1.82031C10.88 2.06031 10.7133 2.33364 10.6133 2.64697C10.54 2.86697 10.5067 3.10033 10.5067 3.33366C10.5067 3.72699 10.6133 4.11365 10.82 4.44698C10.9267 4.63365 11.0667 4.80031 11.2267 4.94031C11.8067 5.46697 12.6667 5.63368 13.34 5.39368C13.8467 5.23368 14.26 4.90032 14.5267 4.45365C14.6467 4.26032 14.7267 4.05367 14.7733 3.84701C14.82 3.67367 14.84 3.50699 14.84 3.33366C14.84 2.80033 14.64 2.287 14.28 1.887C13.8733 1.427 13.2867 1.16699 12.6667 1.16699Z"
        fill={color}
      />
      <path
        d="M13.6593 3.82031H11.666C11.3927 3.82031 11.166 3.59365 11.166 3.32031C11.166 3.04698 11.3927 2.82031 11.666 2.82031H13.6593C13.9327 2.82031 14.1593 3.04698 14.1593 3.32031C14.1593 3.59365 13.9393 3.82031 13.6593 3.82031Z"
        fill={color}
      />
      <path
        d="M12.666 4.84001C12.3927 4.84001 12.166 4.61334 12.166 4.34001V2.34668C12.166 2.07335 12.3927 1.84668 12.666 1.84668C12.9393 1.84668 13.166 2.07335 13.166 2.34668V4.34001C13.166 4.62001 12.9393 4.84001 12.666 4.84001Z"
        fill={color}
      />
    </svg>
  );
}
AddUserNewCircleIcon.propTypes = {
  color: PropTypes.string,
};
AddUserNewCircleIcon.defaultProps = {
  color: '#395C85',
};
export function LocationOutlined({ margin, color, size }) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 14 15"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      style={{ margin }}
    >
      <path
        d="M7.00018 8.766C5.75768 8.766 4.74268 7.75684 4.74268 6.5085C4.74268 5.26017 5.75768 4.25684 7.00018 4.25684C8.24268 4.25684 9.25768 5.266 9.25768 6.51434C9.25768 7.76267 8.24268 8.766 7.00018 8.766ZM7.00018 5.13184C6.24184 5.13184 5.61768 5.75017 5.61768 6.51434C5.61768 7.2785 6.23601 7.89684 7.00018 7.89684C7.76434 7.89684 8.38268 7.2785 8.38268 6.51434C8.38268 5.75017 7.75851 5.13184 7.00018 5.13184Z"
        fill={color}
      />
      <path
        d="M6.99998 13.777C6.13665 13.777 5.26748 13.4503 4.59081 12.8028C2.86998 11.1462 0.968314 8.50366 1.68581 5.35949C2.33331 2.50699 4.82415 1.22949 6.99998 1.22949C6.99998 1.22949 6.99998 1.22949 7.00581 1.22949C9.18165 1.22949 11.6725 2.50699 12.32 5.36533C13.0316 8.50949 11.13 11.1462 9.40915 12.8028C8.73248 13.4503 7.86331 13.777 6.99998 13.777ZM6.99998 2.10449C5.30248 2.10449 3.12081 3.00866 2.54331 5.55199C1.91331 8.29949 3.63998 10.6678 5.20331 12.167C6.21248 13.1412 7.79331 13.1412 8.80248 12.167C10.36 10.6678 12.0866 8.29949 11.4683 5.55199C10.885 3.00866 8.69748 2.10449 6.99998 2.10449Z"
        fill={color}
      />
    </svg>
  );
}
LocationOutlined.propTypes = {
  color: PropTypes.string,
  size: PropTypes.string,
  margin: PropTypes.string,
};
LocationOutlined.defaultProps = {
  color: '#ffffff',
  size: '1.042vw',
  margin: '0',
};
export function FAQIconNew() {
  return (
    <svg
      width="20"
      height="21"
      viewBox="0 0 20 21"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M12.1875 6.75H9.6875C9.60462 6.75 9.52513 6.71708 9.46653 6.65847C9.40792 6.59987 9.375 6.52038 9.375 6.4375C9.375 6.35462 9.40792 6.27513 9.46653 6.21653C9.52513 6.15792 9.60462 6.125 9.6875 6.125H12.1875C12.2704 6.125 12.3499 6.15792 12.4085 6.21653C12.4671 6.27513 12.5 6.35462 12.5 6.4375C12.5 6.52038 12.4671 6.59987 12.4085 6.65847C12.3499 6.71708 12.2704 6.75 12.1875 6.75Z"
        fill="#1D3E69"
      />
      <path
        d="M17.5 15.8125H16.5625C16.4796 15.8125 16.4001 15.7796 16.3415 15.721C16.2829 15.6624 16.25 15.5829 16.25 15.5C16.25 15.4171 16.2829 15.3376 16.3415 15.279C16.4001 15.2204 16.4796 15.1875 16.5625 15.1875H17.1875V5.8125H2.8125V6.4375C2.8125 6.52038 2.77958 6.59987 2.72097 6.65847C2.66237 6.71708 2.58288 6.75 2.5 6.75C2.41712 6.75 2.33763 6.71708 2.27903 6.65847C2.22042 6.59987 2.1875 6.52038 2.1875 6.4375V5.5C2.1875 5.41712 2.22042 5.33763 2.27903 5.27903C2.33763 5.22042 2.41712 5.1875 2.5 5.1875H17.5C17.5829 5.1875 17.6624 5.22042 17.721 5.27903C17.7796 5.33763 17.8125 5.41712 17.8125 5.5V15.5C17.8125 15.5829 17.7796 15.6624 17.721 15.721C17.6624 15.7796 17.5829 15.8125 17.5 15.8125Z"
        fill="#1D3E69"
      />
      <path
        d="M16.5625 16.75H4.6875C4.60463 16.75 4.52515 16.717 4.46656 16.6584L1.34156 13.5334C1.28295 13.4748 1.25002 13.3954 1.25 13.3125V6.4375C1.25 6.35462 1.28292 6.27513 1.34153 6.21653C1.40013 6.15792 1.47962 6.125 1.5625 6.125H12.1875C12.2704 6.125 12.3499 6.15792 12.4085 6.21653C12.4671 6.27513 12.5 6.35462 12.5 6.4375C12.5 6.52038 12.4671 6.59987 12.4085 6.65847C12.3499 6.71708 12.2704 6.75 12.1875 6.75H1.875V13.1831L4.81687 16.125H16.25V6.75H15.9375C15.8546 6.75 15.7751 6.71708 15.7165 6.65847C15.6579 6.59987 15.625 6.52038 15.625 6.4375C15.625 6.35462 15.6579 6.27513 15.7165 6.21653C15.7751 6.15792 15.8546 6.125 15.9375 6.125H16.5625C16.6454 6.125 16.7249 6.15792 16.7835 6.21653C16.8421 6.27513 16.875 6.35462 16.875 6.4375V16.4375C16.875 16.5204 16.8421 16.5999 16.7835 16.6585C16.7249 16.7171 16.6454 16.75 16.5625 16.75Z"
        fill="#1D3E69"
      />
      <path
        d="M4.68743 16.7501C4.60456 16.7501 4.52509 16.7172 4.4665 16.6586L1.3415 13.5336C1.29781 13.4899 1.26805 13.4342 1.256 13.3736C1.24395 13.313 1.25014 13.2501 1.27378 13.193C1.29743 13.1359 1.33747 13.0871 1.38885 13.0528C1.44023 13.0185 1.50064 13.0001 1.56243 13.0001H4.68743C4.77031 13.0001 4.8498 13.033 4.9084 13.0916C4.96701 13.1503 4.99993 13.2297 4.99993 13.3126V16.4376C4.99993 16.5205 4.96701 16.6 4.9084 16.6586C4.8498 16.7172 4.77031 16.7501 4.68743 16.7501ZM2.31681 13.6251L4.37493 15.6832V13.6251H2.31681ZM14.0624 8.39074C13.837 8.39316 13.6168 8.32305 13.4343 8.19074C13.3403 8.12533 13.2633 8.03851 13.2095 7.93744C13.1557 7.83638 13.1267 7.72397 13.1249 7.60949V5.50012C13.1249 4.79918 13.8112 4.25012 14.6874 4.25012C15.0708 4.24577 15.4457 4.36354 15.7577 4.58637C15.9055 4.68964 16.0269 4.82609 16.1124 4.98477C16.1979 5.14345 16.245 5.31995 16.2499 5.50012C16.2499 5.583 16.217 5.66248 16.1584 5.72109C16.0998 5.77969 16.0203 5.81262 15.9374 5.81262C15.8546 5.81262 15.7751 5.77969 15.7165 5.72109C15.6579 5.66248 15.6249 5.583 15.6249 5.50012C15.6188 5.41759 15.594 5.33755 15.5523 5.26607C15.5106 5.19459 15.4531 5.13356 15.3843 5.08762C15.1798 4.94593 14.9362 4.87164 14.6874 4.87512C14.1793 4.87512 13.7499 5.16137 13.7499 5.50012V7.60949C13.7532 7.62587 13.7598 7.64136 13.7695 7.65494C13.7793 7.66853 13.7917 7.67988 13.8062 7.68824C13.8812 7.7406 13.971 7.76775 14.0624 7.76574C14.2562 7.76574 14.3749 7.66449 14.3749 7.60949V6.43762C14.3749 6.35474 14.4079 6.27525 14.4665 6.21665C14.5251 6.15804 14.6046 6.12512 14.6874 6.12512C14.7703 6.12512 14.8498 6.15804 14.9084 6.21665C14.967 6.27525 14.9999 6.35474 14.9999 6.43762V7.60949C14.99 7.72246 14.9578 7.83234 14.9052 7.93283C14.8526 8.03331 14.7807 8.12241 14.6936 8.19501C14.6065 8.26761 14.5059 8.32228 14.3975 8.35587C14.2892 8.38946 14.1753 8.40131 14.0624 8.39074ZM13.2812 12.6876C12.9083 12.6872 12.5509 12.5389 12.2873 12.2753C12.0236 12.0116 11.8753 11.6542 11.8749 11.2814V10.3439C11.8749 9.97091 12.0231 9.61322 12.2868 9.3495C12.5505 9.08577 12.9082 8.93762 13.2812 8.93762C13.6541 8.93762 14.0118 9.08577 14.2756 9.3495C14.5393 9.61322 14.6874 9.97091 14.6874 10.3439V11.2814C14.687 11.6542 14.5387 12.0116 14.2751 12.2753C14.0115 12.5389 13.654 12.6872 13.2812 12.6876ZM13.2812 9.56262C13.0741 9.56286 12.8755 9.64525 12.729 9.79171C12.5826 9.93817 12.5002 10.1367 12.4999 10.3439V11.2814C12.4999 11.4886 12.5822 11.6873 12.7288 11.8338C12.8753 11.9803 13.074 12.0626 13.2812 12.0626C13.4884 12.0626 13.6871 11.9803 13.8336 11.8338C13.9801 11.6873 14.0624 11.4886 14.0624 11.2814V10.3439C14.0622 10.1367 13.9798 9.93817 13.8333 9.79171C13.6869 9.64525 13.4883 9.56286 13.2812 9.56262Z"
        fill="#1D3E69"
      />
      <path
        d="M14.6875 12.6875C14.6465 12.6875 14.6058 12.6795 14.5679 12.6638C14.53 12.648 14.4955 12.625 14.4666 12.5959L13.5291 11.6584C13.4721 11.5995 13.4406 11.5206 13.4414 11.4386C13.4421 11.3567 13.4749 11.2783 13.5329 11.2204C13.5908 11.1624 13.6692 11.1296 13.7511 11.1289C13.8331 11.1281 13.912 11.1596 13.9709 11.2166L14.9084 12.1541C14.9521 12.1978 14.9819 12.2534 14.9939 12.3141C15.006 12.3747 14.9998 12.4375 14.9761 12.4946C14.9525 12.5517 14.9125 12.6005 14.8611 12.6348C14.8097 12.6692 14.7493 12.6875 14.6875 12.6875ZM10.7812 12.6875C10.6984 12.6875 10.6189 12.6546 10.5603 12.596C10.5017 12.5374 10.4688 12.4579 10.4688 12.375V10.3438C10.4688 10.1365 10.3864 9.93784 10.2399 9.79132C10.0934 9.64481 9.8947 9.5625 9.6875 9.5625C9.4803 9.5625 9.28159 9.64481 9.13507 9.79132C8.98856 9.93784 8.90625 10.1365 8.90625 10.3438V12.375C8.90625 12.4579 8.87333 12.5374 8.81472 12.596C8.75612 12.6546 8.67663 12.6875 8.59375 12.6875C8.51087 12.6875 8.43138 12.6546 8.37278 12.596C8.31417 12.5374 8.28125 12.4579 8.28125 12.375V10.3438C8.28125 9.97079 8.42941 9.6131 8.69313 9.34938C8.95685 9.08566 9.31454 8.9375 9.6875 8.9375C10.0605 8.9375 10.4181 9.08566 10.6819 9.34938C10.9456 9.6131 11.0938 9.97079 11.0938 10.3438V12.375C11.0938 12.4579 11.0608 12.5374 11.0022 12.596C10.9436 12.6546 10.8641 12.6875 10.7812 12.6875Z"
        fill="#1D3E69"
      />
      <path
        d="M10.625 11.4375H8.75C8.66712 11.4375 8.58763 11.4046 8.52903 11.346C8.47042 11.2874 8.4375 11.2079 8.4375 11.125C8.4375 11.0421 8.47042 10.9626 8.52903 10.904C8.58763 10.8454 8.66712 10.8125 8.75 10.8125H10.625C10.7079 10.8125 10.7874 10.8454 10.846 10.904C10.9046 10.9626 10.9375 11.0421 10.9375 11.125C10.9375 11.2079 10.9046 11.2874 10.846 11.346C10.7874 11.4046 10.7079 11.4375 10.625 11.4375ZM5.625 12.6875C5.54212 12.6875 5.46263 12.6546 5.40403 12.596C5.34542 12.5374 5.3125 12.4579 5.3125 12.375V9.25C5.3125 9.16712 5.34542 9.08763 5.40403 9.02903C5.46263 8.97042 5.54212 8.9375 5.625 8.9375H7.5C7.58288 8.9375 7.66237 8.97042 7.72097 9.02903C7.77958 9.08763 7.8125 9.16712 7.8125 9.25C7.8125 9.33288 7.77958 9.41237 7.72097 9.47097C7.66237 9.52958 7.58288 9.5625 7.5 9.5625H5.9375V12.375C5.9375 12.4579 5.90458 12.5374 5.84597 12.596C5.78737 12.6546 5.70788 12.6875 5.625 12.6875Z"
        fill="#1D3E69"
      />
      <path
        d="M6.5625 11.4375H5.9375C5.85462 11.4375 5.77513 11.4046 5.71653 11.346C5.65792 11.2874 5.625 11.2079 5.625 11.125C5.625 11.0421 5.65792 10.9626 5.71653 10.904C5.77513 10.8454 5.85462 10.8125 5.9375 10.8125H6.5625C6.64538 10.8125 6.72487 10.8454 6.78347 10.904C6.84208 10.9626 6.875 11.0421 6.875 11.125C6.875 11.2079 6.84208 11.2874 6.78347 11.346C6.72487 11.4046 6.64538 11.4375 6.5625 11.4375Z"
        fill="#1D3E69"
      />
    </svg>
  );
}
export function SupportIconNew() {
  return (
    <svg
      width="20"
      height="21"
      viewBox="0 0 20 21"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_17975_3762)">
        <path
          d="M17.6 8.5002C17.6 8.0586 17.2416 7.7002 16.8 7.7002C16.3584 7.7002 16 8.0586 16 8.5002C16 8.6906 16 14.3098 16 14.5002C16 14.9418 16.3584 15.3002 16.8 15.3002C17.2416 15.3002 17.6 14.9418 17.6 14.5002C17.6 14.3098 17.6 8.6906 17.6 8.5002Z"
          stroke="#1D3E69"
          strokeMiterlimit="10"
        />
        <path
          d="M11.2004 19.3002C11.642 19.3002 12.0004 18.9418 12.0004 18.5002C12.0004 18.0586 11.642 17.7002 11.2004 17.7002C11.01 17.7002 9.39079 17.7002 9.20039 17.7002C8.75879 17.7002 8.40039 18.0586 8.40039 18.5002C8.40039 18.9418 8.75879 19.3002 9.20039 19.3002C9.39079 19.3002 11.01 19.3002 11.2004 19.3002Z"
          stroke="#1D3E69"
          strokeMiterlimit="10"
        />
        <path
          d="M3.19922 8.0998C3.19922 4.3442 6.24362 1.2998 9.99922 1.2998C13.7548 1.2998 16.7992 4.3442 16.7992 8.0998"
          stroke="#1D3E69"
          strokeMiterlimit="10"
        />
        <path
          d="M17.5996 8.5C18.7044 8.5 19.5996 9.8428 19.5996 11.5C19.5996 13.1564 18.7044 14.5 17.5996 14.5"
          stroke="#1D3E69"
          strokeMiterlimit="10"
        />
        <path
          d="M2.40039 8.5002C2.40039 8.0586 2.75879 7.7002 3.20039 7.7002C3.64199 7.7002 4.00039 8.0586 4.00039 8.5002C4.00039 8.6906 4.00039 14.3098 4.00039 14.5002C4.00039 14.9418 3.64199 15.3002 3.20039 15.3002C2.75879 15.3002 2.40039 14.9418 2.40039 14.5002C2.40039 14.3098 2.40039 8.6906 2.40039 8.5002Z"
          stroke="#1D3E69"
          strokeMiterlimit="10"
        />
        <path
          d="M2.40039 8.5C1.29599 8.5 0.400391 9.8428 0.400391 11.5C0.400391 13.1564 1.29599 14.5 2.40039 14.5"
          stroke="#1D3E69"
          strokeMiterlimit="10"
        />
        <path
          d="M16.8 15.2998C16.8 17.2998 15.6 18.4998 13.6 18.4998H12"
          stroke="#1D3E69"
          strokeMiterlimit="10"
        />
      </g>
      <defs>
        <clipPath id="clip0_17975_3762">
          <rect
            width="20"
            height="20"
            fill="white"
            transform="translate(0 0.5)"
          />
        </clipPath>
      </defs>
    </svg>
  );
}
export function BoxTimeIcon() {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M11.9994 13.3008C11.8694 13.3008 11.7394 13.2709 11.6194 13.2009L2.78936 8.09088C2.42936 7.88088 2.30934 7.42085 2.51934 7.06085C2.72934 6.70085 3.17934 6.58083 3.54934 6.79083L11.9994 11.6808L20.3993 6.82086C20.7593 6.61086 21.2193 6.74088 21.4293 7.09088C21.6393 7.45088 21.5094 7.91085 21.1594 8.12085L12.3894 13.2009C12.2594 13.2609 12.1294 13.3008 11.9994 13.3008Z"
        fill="white"
      />
      <path
        d="M12 22.3591C11.59 22.3591 11.25 22.0191 11.25 21.6091V12.5391C11.25 12.1291 11.59 11.7891 12 11.7891C12.41 11.7891 12.75 12.1291 12.75 12.5391V21.6091C12.75 22.0191 12.41 22.3591 12 22.3591Z"
        fill="white"
      />
      <path
        d="M11.9999 22.7522C11.1199 22.7522 10.2399 22.5622 9.55988 22.1722L4.21988 19.2122C2.76988 18.4122 1.62988 16.4822 1.62988 14.8222V9.16216C1.62988 7.50216 2.76988 5.58221 4.21988 4.77221L9.55988 1.81219C10.9199 1.05219 13.0599 1.05219 14.4299 1.81219L19.7699 4.77221C21.2199 5.57221 22.3599 7.50216 22.3599 9.16216V14.8222C22.3599 14.8922 22.3599 14.9922 22.3299 15.1222C22.2699 15.3822 22.0799 15.5922 21.8299 15.6722C21.5799 15.7522 21.2999 15.7022 21.0999 15.5222C19.9599 14.5222 18.1799 14.4822 16.9599 15.4522C16.1899 16.0622 15.7399 16.9922 15.7399 17.9822C15.7399 18.5722 15.8999 19.1522 16.2099 19.6522C16.2899 19.7922 16.3699 19.9022 16.4599 20.0022C16.6099 20.1722 16.6699 20.4022 16.6299 20.6222C16.5899 20.8422 16.4499 21.0422 16.2499 21.1422L14.4199 22.1522C13.7499 22.5622 12.8799 22.7522 11.9999 22.7522ZM11.9999 2.75219C11.3799 2.75219 10.7499 2.88219 10.2999 3.13219L4.95987 6.09222C3.98987 6.63222 3.14987 8.06216 3.14987 9.16216V14.8222C3.14987 15.9222 3.99987 17.3622 4.95987 17.8922L10.2999 20.8522C11.2099 21.3622 12.7999 21.3622 13.7099 20.8522L14.8299 20.2322C14.4599 19.5622 14.2599 18.7822 14.2599 17.9822C14.2599 16.5222 14.9099 15.1722 16.0399 14.2722C17.4099 13.1822 19.3499 12.9522 20.8699 13.6122V9.15221C20.8699 8.05221 20.0199 6.61221 19.0599 6.08221L13.7199 3.12218C13.2499 2.88218 12.6199 2.75219 11.9999 2.75219Z"
        fill="white"
      />
      <path
        d="M19 22.75C16.38 22.75 14.25 20.62 14.25 18C14.25 16.54 14.9 15.19 16.03 14.29C16.87 13.62 17.93 13.25 19 13.25C21.62 13.25 23.75 15.38 23.75 18C23.75 19.36 23.16 20.66 22.13 21.56C21.26 22.33 20.15 22.75 19 22.75ZM19 14.75C18.26 14.75 17.56 15 16.97 15.47C16.2 16.08 15.75 17.01 15.75 18C15.75 19.79 17.21 21.25 19 21.25C19.78 21.25 20.54 20.96 21.15 20.44C21.85 19.82 22.25 18.94 22.25 18C22.25 16.21 20.79 14.75 19 14.75Z"
        fill="white"
      />
      <path
        d="M17.9999 19.75C17.7499 19.75 17.4999 19.62 17.3599 19.39C17.1499 19.03 17.2599 18.57 17.6199 18.36L18.5099 17.83V16.75C18.5099 16.34 18.8499 16 19.2599 16C19.6699 16 20.0099 16.34 20.0099 16.75V18.25C20.0099 18.51 19.8699 18.76 19.6499 18.89L18.3999 19.64C18.2599 19.72 18.1299 19.75 17.9999 19.75Z"
        fill="white"
      />
    </svg>
  );
}
export function AddQuotationIcon() {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M10.0003 18.4029C9.75033 18.4029 9.50033 18.3445 9.29199 18.2279C7.73366 17.3779 4.99199 16.4779 3.27533 16.2529L3.03366 16.2195C1.94199 16.0862 1.04199 15.0612 1.04199 13.9529V3.88619C1.04199 3.22785 1.30033 2.62785 1.77533 2.19452C2.25033 1.76119 2.86699 1.55285 3.51699 1.61119C5.35033 1.75285 8.11699 2.66952 9.68366 3.65285L9.88366 3.76952C9.94199 3.80285 10.067 3.80286 10.117 3.77785L10.2503 3.69452C11.817 2.71119 14.5837 1.77785 16.4253 1.61952C16.442 1.61952 16.5087 1.61952 16.5253 1.61952C17.1337 1.56119 17.7587 1.77785 18.2253 2.21119C18.7003 2.64452 18.9587 3.24452 18.9587 3.90285V13.9612C18.9587 15.0779 18.0587 16.0945 16.9587 16.2279L16.6837 16.2612C14.967 16.4862 12.217 17.3945 10.692 18.2362C10.492 18.3529 10.2503 18.4029 10.0003 18.4029ZM3.31699 2.85285C3.05033 2.85285 2.80866 2.94452 2.61699 3.11952C2.40866 3.31119 2.29199 3.58619 2.29199 3.88619V13.9529C2.29199 14.4445 2.71699 14.9195 3.19199 14.9862L3.44199 15.0195C5.31699 15.2695 8.19199 16.2112 9.85866 17.1195C9.93366 17.1529 10.042 17.1612 10.0837 17.1445C11.7503 16.2195 14.642 15.2695 16.5253 15.0195L16.8087 14.9862C17.2837 14.9279 17.7087 14.4445 17.7087 13.9529V3.89452C17.7087 3.58619 17.592 3.31952 17.3837 3.11952C17.167 2.92785 16.892 2.83619 16.5837 2.85285C16.567 2.85285 16.5003 2.85285 16.4837 2.85285C14.892 2.99452 12.3253 3.85285 10.9253 4.72785L10.792 4.81952C10.3337 5.10285 9.68366 5.10285 9.24199 4.82785L9.04199 4.71119C7.61699 3.83619 5.05033 2.98619 3.41699 2.85285C3.38366 2.85285 3.35033 2.85285 3.31699 2.85285Z"
        fill="#616B80"
      />
      <path
        d="M10 17.7031C9.65833 17.7031 9.375 17.4198 9.375 17.0781V4.57812C9.375 4.23646 9.65833 3.95312 10 3.95312C10.3417 3.95312 10.625 4.23646 10.625 4.57812V17.0781C10.625 17.4281 10.3417 17.7031 10 17.7031Z"
        fill="#616B80"
      />
      <path
        d="M6.45801 7.70312H4.58301C4.24134 7.70312 3.95801 7.41979 3.95801 7.07812C3.95801 6.73646 4.24134 6.45312 4.58301 6.45312H6.45801C6.79967 6.45312 7.08301 6.73646 7.08301 7.07812C7.08301 7.41979 6.79967 7.70312 6.45801 7.70312Z"
        fill="#616B80"
      />
      <path
        d="M7.08301 10.2031H4.58301C4.24134 10.2031 3.95801 9.91979 3.95801 9.57812C3.95801 9.23646 4.24134 8.95312 4.58301 8.95312H7.08301C7.42467 8.95312 7.70801 9.23646 7.70801 9.57812C7.70801 9.91979 7.42467 10.2031 7.08301 10.2031Z"
        fill="#616B80"
      />
    </svg>
  );
}
export function MilestoneIcon() {
  return (
    <svg
      width="20"
      height="21"
      viewBox="0 0 20 21"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M15.833 7.78906C14.108 7.78906 12.708 6.38906 12.708 4.66406C12.708 2.93906 14.108 1.53906 15.833 1.53906C17.558 1.53906 18.958 2.93906 18.958 4.66406C18.958 6.38906 17.558 7.78906 15.833 7.78906ZM15.833 2.78906C14.7997 2.78906 13.958 3.63073 13.958 4.66406C13.958 5.6974 14.7997 6.53906 15.833 6.53906C16.8663 6.53906 17.708 5.6974 17.708 4.66406C17.708 3.63073 16.8663 2.78906 15.833 2.78906Z"
        fill="#CDD1D1"
      />
      <path
        d="M9.99967 11.9609H5.83301C5.49134 11.9609 5.20801 11.6776 5.20801 11.3359C5.20801 10.9943 5.49134 10.7109 5.83301 10.7109H9.99967C10.3413 10.7109 10.6247 10.9943 10.6247 11.3359C10.6247 11.6776 10.3413 11.9609 9.99967 11.9609Z"
        fill="#CDD1D1"
      />
      <path
        d="M13.333 15.2891H5.83301C5.49134 15.2891 5.20801 15.0057 5.20801 14.6641C5.20801 14.3224 5.49134 14.0391 5.83301 14.0391H13.333C13.6747 14.0391 13.958 14.3224 13.958 14.6641C13.958 15.0057 13.6747 15.2891 13.333 15.2891Z"
        fill="#CDD1D1"
      />
      <path
        d="M12.5003 19.4557H7.50033C2.97533 19.4557 1.04199 17.5224 1.04199 12.9974V7.9974C1.04199 3.4724 2.97533 1.53906 7.50033 1.53906H11.667C12.0087 1.53906 12.292 1.8224 12.292 2.16406C12.292 2.50573 12.0087 2.78906 11.667 2.78906H7.50033C3.65866 2.78906 2.29199 4.15573 2.29199 7.9974V12.9974C2.29199 16.8391 3.65866 18.2057 7.50033 18.2057H12.5003C16.342 18.2057 17.7087 16.8391 17.7087 12.9974V8.83073C17.7087 8.48906 17.992 8.20573 18.3337 8.20573C18.6753 8.20573 18.9587 8.48906 18.9587 8.83073V12.9974C18.9587 17.5224 17.0253 19.4557 12.5003 19.4557Z"
        fill="#CDD1D1"
      />
    </svg>
  );
}

export function ProgressUpIcon({ height, width }) {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 15 12"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M5.56072 6.55228C4.76773 7.34639 4.00923 8.10714 3.24999 8.86826C2.6001 9.51815 1.95021 10.167 1.30032 10.8149C1.08773 11.026 0.831269 11.0913 0.542193 11.0062C0.253116 10.921 0.0810205 10.716 0.0172812 10.4261C-0.0442085 10.1442 0.0633984 9.91284 0.260615 9.71374C1.16196 8.8129 2.06256 7.9118 2.96241 7.01045C3.62955 6.34356 4.29719 5.67705 4.96532 5.01091C5.33164 4.64722 5.75569 4.64535 6.1205 5.00529C6.62742 5.5052 7.13096 6.00887 7.63112 6.51628C7.68774 6.57327 7.72336 6.65088 7.76348 6.71087L11.9763 2.49433C11.9163 2.49058 11.8585 2.48421 11.8004 2.48383C11.313 2.48383 10.8256 2.48871 10.3382 2.48084C10.0161 2.47596 9.77351 2.31961 9.64116 2.02679C9.51481 1.74708 9.5568 1.47563 9.75364 1.23717C9.82425 1.14879 9.91422 1.07781 10.0166 1.0297C10.119 0.981599 10.2311 0.957654 10.3442 0.959716C11.511 0.957092 12.6808 0.954842 13.8491 0.960841C14.2904 0.963091 14.6169 1.29828 14.6184 1.73884C14.6222 2.90114 14.6222 4.06344 14.6184 5.22575C14.6184 5.66742 14.2724 6.01312 13.8532 6.00937C13.434 6.00562 13.1108 5.67567 13.1033 5.23287C13.0962 4.7582 13.1015 4.28316 13.1015 3.80811V3.61127L13.0332 3.56703C12.9908 3.63384 12.9434 3.69738 12.8915 3.75712C11.3997 5.25162 9.90687 6.74499 8.41287 8.23724C8.02406 8.6253 7.60375 8.62605 7.21644 8.24062C6.70778 7.7342 6.19999 7.22616 5.69308 6.7165C5.64958 6.67263 5.61471 6.61864 5.56072 6.55228Z"
        fill="#55B938"
      />
    </svg>
  );
}
ProgressUpIcon.propTypes = {
  height: PropTypes.string,
  width: PropTypes.string,
};
ProgressUpIcon.defaultProps = {
  height: '0.833vw',
  width: '1.042vw',
};
export function ProgressDownIcon({ height, width }) {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 15 12"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M9.06037 5.44772C9.85336 4.65361 10.6119 3.89286 11.3711 3.13174C12.021 2.48185 12.6709 1.83296 13.3208 1.18507C13.5334 0.973977 13.7898 0.908739 14.0789 0.99385C14.368 1.07896 14.5401 1.28405 14.6038 1.57388C14.6653 1.85583 14.5577 2.08716 14.3605 2.28626C13.4591 3.1871 12.5585 4.0882 11.6587 4.98955C10.9915 5.65644 10.3239 6.32295 9.65577 6.98909C9.28946 7.35278 8.8654 7.35465 8.50059 6.99471C7.99367 6.4948 7.49013 5.99113 6.98997 5.48372C6.93335 5.42673 6.89773 5.34912 6.85762 5.28913L2.64482 9.50567C2.70481 9.50942 2.76256 9.51579 2.82067 9.51617C3.30809 9.51617 3.79551 9.51129 4.28292 9.51916C4.605 9.52404 4.84758 9.68039 4.97993 9.97321C5.10629 10.2529 5.06429 10.5244 4.86745 10.7628C4.79684 10.8512 4.70687 10.9222 4.60449 10.9703C4.5021 11.0184 4.39003 11.0423 4.27693 11.0403C3.11012 11.0429 1.94032 11.0452 0.772017 11.0392C0.330715 11.0369 0.00414467 10.7017 0.00264454 10.2612C-0.00110435 9.09886 -0.00110435 7.93656 0.00264454 6.77425C0.00264454 6.33258 0.348712 5.98688 0.767891 5.99063C1.18707 5.99438 1.51027 6.32433 1.51777 6.76713C1.52489 7.2418 1.51964 7.71684 1.51964 8.19189V8.38873L1.58788 8.43297C1.63031 8.36616 1.67768 8.30262 1.7296 8.24288C3.22135 6.74838 4.71423 5.25501 6.20823 3.76276C6.59704 3.3747 7.01734 3.37395 7.40465 3.75938C7.91331 4.2658 8.4211 4.77384 8.92802 5.2835C8.97151 5.32737 9.00638 5.38136 9.06037 5.44772Z"
        fill="#F37A90"
      />
    </svg>
  );
}
ProgressDownIcon.propTypes = {
  height: PropTypes.string,
  width: PropTypes.string,
};
ProgressDownIcon.defaultProps = {
  height: '0.833vw',
  width: '1.042vw',
};

export function MedelIcon() {
  return (
    <svg
      width="1.111vw"
      height="18"
      viewBox="0 0 16 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M3.96649 17.4673L3.14462 14.7042L0.272744 14.9542C0.0621187 14.9723 -0.0747564 14.7386 0.0439936 14.5636L4.07212 8.64355L8.44212 11.6173L4.41399 17.5373C4.29524 17.7117 4.02649 17.6698 3.96649 17.4673Z"
        fill="#E47676"
      />
      <path
        d="M11.7041 17.4673L12.526 14.7042L15.3979 14.9542C15.6085 14.9723 15.7454 14.7386 15.6266 14.5636L11.5985 8.64355L7.22852 11.6173L11.2566 17.5373C11.3754 17.7117 11.6441 17.6698 11.7041 17.4673Z"
        fill="#E47676"
      />
      <path
        d="M13.9848 12.1531C12.8348 13.5156 11.241 14.4906 9.43477 14.8594L7.22852 11.6156L11.5973 8.64062L13.9848 12.1531Z"
        fill="#EA8686"
      />
      <path
        d="M8.4418 11.6156L6.23555 14.8594C4.4293 14.4906 2.83555 13.5156 1.68555 12.1531L4.07305 8.64062L8.4418 11.6156Z"
        fill="#EA8686"
      />
      <path
        d="M7.83512 13.764C11.5955 13.764 14.6439 10.7156 14.6439 6.95523C14.6439 3.19487 11.5955 0.146484 7.83512 0.146484C4.07475 0.146484 1.02637 3.19487 1.02637 6.95523C1.02637 10.7156 4.07475 13.764 7.83512 13.764Z"
        fill="#FADF6B"
      />
      <path
        d="M14.6439 6.95512C14.6439 10.7145 11.5945 13.7639 7.83512 13.7639C6.09887 13.7639 4.51324 13.112 3.30762 12.0376C4.18324 12.4901 5.18012 12.7426 6.23074 12.7426C9.77637 12.7426 12.6501 9.86824 12.6501 6.32324C12.6501 3.39074 10.6801 0.915117 7.99074 0.151367C11.677 0.228867 14.6439 3.24887 14.6439 6.95512Z"
        fill="#F9D266"
      />
      <path
        d="M6.20821 1.40664C6.16071 1.26789 6.01008 1.19414 5.87071 1.24226C5.00946 1.53976 4.21071 2.03976 3.56258 2.68914C3.45883 2.79289 3.45883 2.96101 3.56258 3.06476C3.61446 3.11664 3.68258 3.14226 3.75071 3.14226C3.81883 3.14226 3.88696 3.11601 3.93883 3.06414C4.53008 2.47226 5.25821 2.01539 6.04446 1.74476C6.18258 1.69664 6.25696 1.54601 6.20821 1.40664ZM3.06258 3.69414C2.93883 3.61664 2.77446 3.65539 2.69758 3.78101L2.60633 3.93414C2.53258 4.06101 2.57571 4.22351 2.70258 4.29726C2.74446 4.32164 2.79008 4.33289 2.83571 4.33289C2.92696 4.33289 3.01633 4.28539 3.06508 4.20039L3.14946 4.05914C3.22696 3.93476 3.18758 3.77101 3.06258 3.69414Z"
        fill="#FAE899"
      />
      <path
        d="M7.835 11.7276C10.4708 11.7276 12.6075 9.5909 12.6075 6.95512C12.6075 4.31934 10.4708 2.18262 7.835 2.18262C5.19922 2.18262 3.0625 4.31934 3.0625 6.95512C3.0625 9.5909 5.19922 11.7276 7.835 11.7276Z"
        fill="#F2A44F"
      />
      <path
        d="M12.607 6.95527C12.607 9.59152 10.472 11.7265 7.8357 11.7265C6.5907 11.7265 5.46258 11.2496 4.61133 10.4765C5.12695 10.6565 5.68133 10.754 6.25508 10.754C8.97383 10.754 11.177 8.5509 11.177 5.83215C11.177 4.66465 10.7732 3.59027 10.0926 2.74902C11.5901 3.5559 12.607 5.1359 12.607 6.95527Z"
        fill="#EF9E4D"
      />
      <path
        d="M5.3106 4.58784C5.24123 4.58784 5.1706 4.56097 5.11873 4.50659C5.01748 4.40097 5.0206 4.23284 5.12685 4.13097C5.46123 3.80972 5.84498 3.55284 6.2681 3.36784C6.40185 3.30972 6.55873 3.36972 6.61873 3.50472C6.67748 3.63909 6.61623 3.79534 6.48185 3.85472C6.11623 4.01472 5.78435 4.23722 5.49435 4.51472C5.4431 4.56347 5.37623 4.58784 5.3106 4.58784Z"
        fill="#FDC393"
      />
      <path
        d="M8.05605 4.37621L8.7548 5.79121L10.3123 6.01746C10.5154 6.04684 10.596 6.29621 10.4492 6.43934L9.3223 7.53809L9.58917 9.09371C9.62355 9.29434 9.41292 9.44684 9.23292 9.35246L7.83605 8.61809L6.43917 9.35246C6.25917 9.44684 6.04855 9.29434 6.08292 9.09371L6.3498 7.53809L5.2198 6.43621C5.07417 6.29434 5.1548 6.04684 5.35605 6.01746L6.91792 5.79059L7.61667 4.37559C7.70605 4.19371 7.96605 4.19371 8.05605 4.37621Z"
        fill="#FADF6B"
      />
    </svg>
  );
}

export function TranslateIcon({ margin, size }) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 19 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      style={{ margin }}
    >
      <g clip-path="url(#clip0_18676_121808)">
        <path
          d="M5.75749 7.50016C5.81805 7.49814 5.87724 7.48163 5.93009 7.45201C5.98295 7.42238 6.02792 7.38051 6.06124 7.32991C6.0953 7.27837 6.11677 7.21955 6.12393 7.15819C6.1311 7.09684 6.12376 7.03466 6.10249 6.97666C5.99449 6.67966 5.50549 6.67966 5.39824 6.97666L5.39074 6.99691C5.37128 7.05413 5.36582 7.11518 5.37482 7.17495C5.38383 7.23472 5.40703 7.29146 5.44249 7.34041C5.47877 7.3899 5.52619 7.43015 5.58091 7.4579C5.63564 7.48566 5.69613 7.50013 5.75749 7.50016Z"
          fill="url(#paint0_linear_18676_121808)"
        />
        <path
          d="M13.5553 14.8433C13.5901 14.7948 13.6127 14.7388 13.6213 14.6798C13.63 14.6208 13.6243 14.5606 13.6047 14.5043L8.72975 0.25425C8.70455 0.18015 8.65679 0.115793 8.59317 0.0701986C8.52956 0.0246042 8.45327 5.79001e-05 8.375 0L2.375 0C1.8779 0.000595447 1.40133 0.198331 1.04983 0.549832C0.698331 0.901334 0.500595 1.3779 0.5 1.875L0.5 13.125C0.5 14.1585 1.3415 15 2.375 15H13.25C13.3097 15 13.3685 14.9859 13.4216 14.9586C13.4747 14.9313 13.5205 14.8918 13.5553 14.8433ZM3.52175 9.999L5.39675 4.749C5.50325 4.452 5.9975 4.452 6.10325 4.749L7.97825 9.999C8.0113 10.0926 8.00605 10.1955 7.96363 10.2852C7.92121 10.375 7.84506 10.4444 7.75175 10.4782C7.65804 10.5113 7.55506 10.5061 7.46518 10.4637C7.37531 10.4213 7.3058 10.3451 7.27175 10.2517L6.64625 8.49975C6.62038 8.42673 6.57253 8.36352 6.50927 8.3188C6.44602 8.27408 6.37047 8.25004 6.293 8.25H5.207C5.12962 8.24999 5.05414 8.27391 4.9909 8.31849C4.92765 8.36307 4.87975 8.42612 4.85375 8.499L4.2275 10.251C4.19344 10.3442 4.12409 10.4203 4.03442 10.4628C3.94476 10.5053 3.84197 10.5109 3.74825 10.4782C3.65494 10.4444 3.57879 10.375 3.53637 10.2852C3.49395 10.1955 3.48869 10.0926 3.52175 9.999ZM12.734 9.4695C12.7827 9.50563 12.8216 9.55332 12.8472 9.60825C12.9215 9.792 13.0798 10.0305 13.3453 10.3575C13.3804 10.4011 13.4248 10.4362 13.4753 10.4604C13.5258 10.4845 13.581 10.497 13.637 10.497H13.649C13.7068 10.495 13.7634 10.4798 13.8144 10.4525C13.8653 10.4252 13.9093 10.3865 13.943 10.3395C14.3 9.837 14.621 9.28275 14.8475 8.7795C14.8727 8.72226 14.8834 8.65964 14.8784 8.59728C14.8734 8.53491 14.853 8.47476 14.819 8.42225C14.785 8.36973 14.7385 8.32649 14.6837 8.29642C14.6288 8.26635 14.5673 8.2504 14.5048 8.25H12.7828C12.7232 8.25004 12.6644 8.26429 12.6115 8.29155C12.5585 8.31882 12.5127 8.35831 12.4781 8.40677C12.4434 8.45523 12.4208 8.51126 12.4121 8.57021C12.4033 8.62916 12.4088 8.68933 12.428 8.74575L12.6178 9.3015C12.6402 9.3675 12.6807 9.42525 12.734 9.4695Z"
          fill="url(#paint1_linear_18676_121808)"
        />
        <path
          d="M16.6252 3H10.9867C10.9271 3.00004 10.8684 3.01429 10.8154 3.04155C10.7624 3.06882 10.7167 3.10831 10.682 3.15677C10.6473 3.20523 10.6247 3.26126 10.616 3.32021C10.6073 3.37916 10.6128 3.43933 10.632 3.49575L11.9145 7.24575C11.967 7.398 12.1095 7.5 12.2692 7.5H12.8752C12.9747 7.5 13.07 7.46049 13.1404 7.39017C13.2107 7.31984 13.2502 7.22446 13.2502 7.125C13.2502 7.02554 13.2897 6.93016 13.36 6.85983C13.4304 6.78951 13.5258 6.75 13.6252 6.75C13.7247 6.75 13.82 6.78951 13.8904 6.85983C13.9607 6.93016 14.0002 7.02554 14.0002 7.125C14.0002 7.22446 14.0397 7.31984 14.11 7.39017C14.1804 7.46049 14.2758 7.5 14.3752 7.5H16.6252C16.7247 7.5 16.82 7.53951 16.8904 7.60983C16.9607 7.68016 17.0002 7.77554 17.0002 7.875C17.0002 7.97446 16.9607 8.06984 16.8904 8.14017C16.82 8.21049 16.7247 8.25 16.6252 8.25H16.104C16.0236 8.25003 15.9455 8.27585 15.8809 8.32364C15.8164 8.37144 15.7689 8.43869 15.7455 8.5155C15.5182 9.25725 15.0015 10.197 14.3625 11.0302C14.3077 11.1016 14.2804 11.1902 14.2855 11.2799C14.2906 11.3697 14.3277 11.4546 14.3902 11.5192C14.8317 11.9754 15.2862 12.4188 15.753 12.849C15.7893 12.8821 15.8187 12.9221 15.8396 12.9667C15.8604 13.0112 15.8722 13.0594 15.8744 13.1085C15.8766 13.1577 15.869 13.2067 15.8521 13.2529C15.8353 13.2991 15.8095 13.3416 15.7762 13.3778C15.7078 13.4491 15.6145 13.4914 15.5157 13.4957C15.417 13.5001 15.3203 13.4661 15.246 13.401C15.123 13.2885 14.862 13.0462 14.5417 12.735C14.4816 12.6754 14.403 12.6379 14.3188 12.6288C14.2346 12.6196 14.1497 12.6392 14.0782 12.6845C14.0066 12.7298 13.9525 12.798 13.9247 12.878C13.8969 12.958 13.8971 13.0451 13.9252 13.125L14.3137 14.2605C14.3719 14.4298 14.3888 14.6106 14.363 14.7877C14.3372 14.9649 14.2694 15.1333 14.1654 15.279C14.0614 15.4247 13.9241 15.5435 13.7649 15.6254C13.6057 15.7073 13.4292 15.75 13.2502 15.75H10.0627C10.0022 15.75 9.94256 15.7647 9.88894 15.7928C9.83532 15.8209 9.7893 15.8616 9.75481 15.9113C9.72032 15.9611 9.69839 16.0184 9.69088 16.0785C9.68338 16.1386 9.69052 16.1995 9.71171 16.2562L10.2742 17.7562C10.3009 17.8278 10.3489 17.8895 10.4116 17.933C10.4743 17.9766 10.5488 17.9999 10.6252 18H16.6252C17.6587 18 18.5002 17.1585 18.5002 16.125V4.875C18.5002 3.8415 17.6587 3 16.6252 3Z"
          fill="url(#paint2_linear_18676_121808)"
        />
      </g>
      <defs>
        <linearGradient
          id="paint0_linear_18676_121808"
          x1="6.1266"
          y1="6.7884"
          x2="5.31478"
          y2="7.47748"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="#1D4069" />
          <stop offset="1" stop-color="#266CBD" />
        </linearGradient>
        <linearGradient
          id="paint1_linear_18676_121808"
          x1="14.8796"
          y1="0.693277"
          x2="-1.26888"
          y2="13.664"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="#1D4069" />
          <stop offset="1" stop-color="#266CBD" />
        </linearGradient>
        <linearGradient
          id="paint2_linear_18676_121808"
          x1="18.5002"
          y1="3.69328"
          x2="5.39472"
          y2="10.1442"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="#1D4069" />
          <stop offset="1" stop-color="#266CBD" />
        </linearGradient>
        <clipPath id="clip0_18676_121808">
          <rect
            width="18"
            height="18"
            fill="white"
            transform="translate(0.5)"
          />
        </clipPath>
      </defs>
    </svg>
  );
}
TranslateIcon.propTypes = {
  margin: PropTypes.string,
  size: PropTypes.string,
};
TranslateIcon.defaultProps = {
  margin: '0',
  size: '1.25vw',
};

export function ProductListIcon() {
  return (
    <svg
      width="1.667vw"
      height="1.667vw"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M21 20.25H11C10.59 20.25 10.25 19.91 10.25 19.5C10.25 19.09 10.59 18.75 11 18.75H21C21.41 18.75 21.75 19.09 21.75 19.5C21.75 19.91 21.41 20.25 21 20.25Z"
        fill="white"
      />
      <path
        d="M21 13.25H11C10.59 13.25 10.25 12.91 10.25 12.5C10.25 12.09 10.59 11.75 11 11.75H21C21.41 11.75 21.75 12.09 21.75 12.5C21.75 12.91 21.41 13.25 21 13.25Z"
        fill="white"
      />
      <path
        d="M21 6.25H11C10.59 6.25 10.25 5.91 10.25 5.5C10.25 5.09 10.59 4.75 11 4.75H21C21.41 4.75 21.75 5.09 21.75 5.5C21.75 5.91 21.41 6.25 21 6.25Z"
        fill="white"
      />
      <path
        d="M4.00043 7.25043C3.81043 7.25043 3.62043 7.18043 3.47043 7.03043L2.47043 6.03043C2.18043 5.74043 2.18043 5.26043 2.47043 4.97043C2.76043 4.68043 3.24043 4.68043 3.53043 4.97043L4.00043 5.44043L6.47043 2.97043C6.76043 2.68043 7.24043 2.68043 7.53043 2.97043C7.82043 3.26043 7.82043 3.74043 7.53043 4.03043L4.53043 7.03043C4.38043 7.18043 4.19043 7.25043 4.00043 7.25043Z"
        fill="white"
      />
      <path
        d="M4.00043 14.2504C3.81043 14.2504 3.62043 14.1804 3.47043 14.0304L2.47043 13.0304C2.18043 12.7404 2.18043 12.2604 2.47043 11.9704C2.76043 11.6804 3.24043 11.6804 3.53043 11.9704L4.00043 12.4404L6.47043 9.97043C6.76043 9.68043 7.24043 9.68043 7.53043 9.97043C7.82043 10.2604 7.82043 10.7404 7.53043 11.0304L4.53043 14.0304C4.38043 14.1804 4.19043 14.2504 4.00043 14.2504Z"
        fill="white"
      />
      <path
        d="M4.00043 21.2504C3.81043 21.2504 3.62043 21.1804 3.47043 21.0304L2.47043 20.0304C2.18043 19.7404 2.18043 19.2604 2.47043 18.9704C2.76043 18.6804 3.24043 18.6804 3.53043 18.9704L4.00043 19.4404L6.47043 16.9704C6.76043 16.6804 7.24043 16.6804 7.53043 16.9704C7.82043 17.2604 7.82043 17.7404 7.53043 18.0304L4.53043 21.0304C4.38043 21.1804 4.19043 21.2504 4.00043 21.2504Z"
        fill="white"
      />
    </svg>
  );
}

export function MinusRoundIcon() {
  return (
    <svg
      width="0.972vw"
      height="0.139vw"
      viewBox="0 0 14 2"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M1 1H13"
        stroke="#ffffff"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

export function BookmarkIcon() {
  return (
    <svg
      width="1.667vw"
      height="1.667vw"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M4.93 22.75C4.51 22.75 4.12 22.65 3.77 22.45C3 22 2.56 21.09 2.56 19.96V5.86C2.56 3.32 4.63 1.25 7.17 1.25H16.82C19.36 1.25 21.43 3.32 21.43 5.86V19.95C21.43 21.08 20.99 21.99 20.22 22.44C19.45 22.89 18.44 22.84 17.45 22.29L12.57 19.58C12.28 19.42 11.71 19.42 11.42 19.58L6.54 22.29C6 22.59 5.45 22.75 4.93 22.75ZM7.18 2.75C5.47 2.75 4.07 4.15 4.07 5.86V19.95C4.07 20.54 4.24 20.98 4.54 21.15C4.84 21.32 5.31 21.27 5.82 20.98L10.7 18.27C11.44 17.86 12.56 17.86 13.3 18.27L18.18 20.98C18.69 21.27 19.16 21.33 19.46 21.15C19.76 20.97 19.93 20.53 19.93 19.95V5.86C19.93 4.15 18.53 2.75 16.82 2.75H7.18Z"
        fill="#616B80"
      />
      <path
        d="M11.09 13.25C10.9 13.25 10.71 13.18 10.56 13.03L9.06 11.53C8.77 11.24 8.77 10.76 9.06 10.47C9.35 10.18 9.83 10.18 10.12 10.47L11.09 11.44L14.56 7.97C14.85 7.68 15.33 7.68 15.62 7.97C15.91 8.26 15.91 8.74 15.62 9.03L11.62 13.03C11.47 13.18 11.28 13.25 11.09 13.25Z"
        fill="#616B80"
      />
    </svg>
  );
}
export function SliderPrevIcon() {
  return (
    <svg
      width="0.972vw"
      height="1.111vw"
      viewBox="0 0 14 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M10.1 15.1498C9.26 15.1498 8.34 14.8798 7.41 14.3398L2.78 11.6698C1.15 10.7198 0.25 9.4198 0.25 7.9998C0.25 6.5798 1.15 5.2798 2.78 4.3398L7.41 1.6698C9.04 0.729802 10.61 0.599802 11.85 1.3098C13.08 2.0198 13.76 3.4498 13.76 5.3298V10.6698C13.76 12.5498 13.08 13.9798 11.85 14.6898C11.32 14.9998 10.73 15.1498 10.1 15.1498ZM10.1 2.3598C9.52 2.3598 8.86 2.5598 8.16 2.9698L3.53 5.6398C2.38 6.2998 1.75 7.1398 1.75 7.9998C1.75 8.8598 2.38 9.6998 3.53 10.3598L8.16 13.0298C9.31 13.6898 10.35 13.8198 11.1 13.3898C11.85 12.9598 12.26 11.9898 12.26 10.6698V5.3298C12.26 4.0098 11.85 3.0398 11.1 2.6098C10.8 2.4398 10.46 2.3598 10.1 2.3598Z"
        fill="#616B80"
      />
    </svg>
  );
}
export function SliderNextIcon() {
  return (
    <svg
      width="0.972vw"
      height="1.111vw"
      viewBox="0 0 14 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M3.9 15.1498C3.27 15.1498 2.68 14.9998 2.16 14.6998C0.93 13.9898 0.25 12.5598 0.25 10.6798V5.3298C0.25 3.4498 0.93 2.0198 2.16 1.3098C3.39 0.599802 4.96 0.729802 6.6 1.6698L11.23 4.3398C12.86 5.2798 13.76 6.5798 13.76 7.9998C13.76 9.4198 12.86 10.7198 11.23 11.6598L6.6 14.3298C5.66 14.8798 4.74 15.1498 3.9 15.1498ZM3.9 2.3598C3.53 2.3598 3.19 2.4398 2.9 2.6098C2.16 3.0398 1.75 3.9998 1.75 5.3298V10.6698C1.75 11.9898 2.16 12.9598 2.91 13.3898C3.66 13.8198 4.7 13.6898 5.85 13.0298L10.48 10.3598C11.63 9.6998 12.26 8.8598 12.26 7.9998C12.26 7.1398 11.63 6.2998 10.48 5.6398L5.85 2.9698C5.14 2.5598 4.48 2.3598 3.9 2.3598Z"
        fill="#616B80"
      />
    </svg>
  );
}
export function POChangesNoData({ Height, Width }) {
  return (
    <svg
      width="379"
      height="243"
      viewBox="0 0 379 243"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      style={{ height: Height, width: Width }}
    >
      <g clip-path="url(#clip0_20706_153740)">
        <path
          d="M75.0848 241.879L74.0781 241.859C74.4675 230.667 75.6617 219.517 77.6515 208.496C82.0044 184.9 89.2426 169.403 99.165 162.436L99.743 163.26C76.5642 179.534 75.0966 241.257 75.0848 241.879Z"
          fill="#2F2E41"
        />
        <path
          d="M87.6678 241.638L86.6611 241.619C86.6828 240.504 87.3119 214.231 97.655 206.969L98.2331 207.793C88.3072 214.762 87.6727 241.37 87.6678 241.638Z"
          fill="#2F2E41"
        />
        <path
          d="M105.471 163.352C108.25 163.352 110.504 161.098 110.504 158.318C110.504 155.539 108.25 153.285 105.471 153.285C102.691 153.285 100.438 155.539 100.438 158.318C100.438 161.098 102.691 163.352 105.471 163.352Z"
          fill="url(#paint0_linear_20706_153740)"
        />
        <path
          d="M102.978 206.637C105.757 206.637 108.011 204.383 108.011 201.604C108.011 198.824 105.757 196.57 102.978 196.57C100.198 196.57 97.9443 198.824 97.9443 201.604C97.9443 204.383 100.198 206.637 102.978 206.637Z"
          fill="url(#paint1_linear_20706_153740)"
        />
        <path
          d="M85.3221 166.368C86.2681 172.41 83.8027 177.814 83.8027 177.814C83.8027 177.814 79.8036 173.422 78.8577 167.38C77.9118 161.339 80.3772 155.935 80.3772 155.935C80.3772 155.935 84.3762 160.326 85.3221 166.368Z"
          fill="#2F2E41"
        />
        <path
          d="M101.774 181.042C95.9891 183.026 90.2383 181.54 90.2383 181.54C90.2383 181.54 93.8662 176.837 99.6508 174.853C105.435 172.869 111.186 174.355 111.186 174.355C111.186 174.355 107.558 179.058 101.774 181.042Z"
          fill="#2F2E41"
        />
        <path
          d="M101.96 219.376C99.3424 220.198 96.5542 220.319 93.875 219.725C95.5762 217.559 97.8673 215.931 100.472 215.038C103.078 214.144 105.885 214.023 108.558 214.689C106.807 216.802 104.532 218.418 101.96 219.376Z"
          fill="#2F2E41"
        />
        <path
          d="M305.35 235.278H298.736L295.59 209.768L305.351 209.768L305.35 235.278Z"
          fill="#9E616A"
        />
        <path
          d="M307.037 241.69L285.711 241.689V241.419C285.711 239.218 286.586 237.107 288.142 235.55C289.699 233.993 291.81 233.119 294.012 233.119L307.037 233.119L307.037 241.69Z"
          fill="#2F2E41"
        />
        <path
          d="M264.53 235.278H257.916L254.77 209.768L264.531 209.768L264.53 235.278Z"
          fill="#9E616A"
        />
        <path
          d="M266.216 241.69L244.891 241.689V241.419C244.891 239.218 245.765 237.107 247.322 235.55C248.879 233.993 250.99 233.119 253.191 233.119H253.192L266.217 233.119L266.216 241.69Z"
          fill="#2F2E41"
        />
        <path
          d="M248.03 92.4178L238.87 91.0024L235.911 95.7659L204.065 103.884L204.151 104.323C203.25 103.382 202.068 102.761 200.783 102.553C199.497 102.344 198.179 102.56 197.028 103.168C195.876 103.775 194.954 104.742 194.4 105.92C193.847 107.099 193.692 108.425 193.96 109.7C194.228 110.974 194.904 112.126 195.885 112.982C196.866 113.838 198.099 114.351 199.398 114.443C200.697 114.536 201.99 114.203 203.083 113.495C204.175 112.786 205.007 111.742 205.453 110.518L244.02 102.475L248.03 92.4178Z"
          fill="#9E616A"
        />
        <path
          d="M339.517 86.746C338.762 86.7467 338.015 86.8903 337.314 87.1693L337.497 86.8506L297.008 65.9224L291.488 74.8462L333.583 93.5321C333.736 94.6725 334.215 95.7447 334.961 96.6204C335.708 97.4961 336.69 98.1383 337.792 98.4701C338.894 98.8019 340.068 98.8093 341.174 98.4914C342.28 98.1735 343.271 97.5438 344.028 96.6776C344.786 95.8113 345.277 94.7452 345.445 93.6068C345.612 92.4684 345.448 91.3058 344.972 90.2582C344.496 89.2106 343.729 88.3222 342.761 87.6993C341.794 87.0765 340.667 86.7455 339.517 86.746Z"
          fill="#9E616A"
        />
        <path
          d="M275.643 32.1627C277.225 22.4116 270.603 13.2239 260.852 11.6415C251.101 10.0591 241.913 16.6812 240.331 26.4323C238.749 36.1835 245.371 45.3712 255.122 46.9536C264.873 48.536 274.061 41.9139 275.643 32.1627Z"
          fill="#2F2E41"
        />
        <path
          d="M257.833 47.0303C264.134 47.0303 269.243 41.9216 269.243 35.6197C269.243 29.3177 264.134 24.209 257.833 24.209C251.531 24.209 246.422 29.3177 246.422 35.6197C246.422 41.9216 251.531 47.0303 257.833 47.0303Z"
          fill="#A0616A"
        />
        <path
          d="M257.987 31.7649C264.8 31.7649 270.323 28.4512 270.323 24.3634C270.323 20.2757 264.8 16.9619 257.987 16.9619C251.174 16.9619 245.651 20.2757 245.651 24.3634C245.651 28.4512 251.174 31.7649 257.987 31.7649Z"
          fill="#2F2E41"
        />
        <path
          d="M259.221 18.8123C263.309 18.8123 266.622 15.4985 266.622 11.4108C266.622 7.32305 263.309 4.00928 259.221 4.00928C255.133 4.00928 251.819 7.32305 251.819 11.4108C251.819 15.4985 255.133 18.8123 259.221 18.8123Z"
          fill="#2F2E41"
        />
        <path
          d="M249.352 7.40148C249.352 5.57198 250.029 3.80733 251.254 2.44795C252.478 1.08857 254.163 0.230765 255.982 0.0400208C255.726 0.0134252 255.469 6.59815e-05 255.211 0C253.25 0.00228753 251.369 0.783093 249.983 2.1709C248.597 3.5587 247.818 5.44001 247.818 7.40151C247.818 9.36302 248.597 11.2443 249.983 12.6321C251.369 14.0199 253.25 14.8007 255.211 14.803C255.469 14.803 255.726 14.7896 255.982 14.763C254.163 14.5723 252.478 13.7145 251.254 12.3551C250.029 10.9957 249.352 9.231 249.352 7.40148Z"
          fill="#2F2E41"
        />
        <path
          d="M251.901 63.9477L252.821 55.1011C252.821 55.1011 265.306 46.8732 269.55 51.7361L294.911 95.1288C294.911 95.1288 310.676 100.734 310.119 122.136L309.365 225.588L291.489 227.548L280.633 146.891L270.825 230.455L250.012 229.803L251.885 174.753L261.809 121.387L261.714 103.679L257.343 96.5324C257.343 96.5324 249.337 93.316 249.113 84.2263L248.938 71.4492L251.901 63.9477Z"
          fill="#2F2E41"
        />
        <path
          d="M264.992 54.1645L265.238 50.0176C265.238 50.0176 303.004 59.9692 300.008 67.0846C297.012 74.2 291.394 76.447 291.394 76.447L269.673 67.8336L264.992 54.1645Z"
          fill="#2F2E41"
        />
        <path
          d="M255.123 64.4839L252.281 61.4536C252.281 61.4536 229.616 93.2579 236.47 96.8114C243.324 100.365 249.079 98.4993 249.079 98.4993L260.267 77.9856L255.123 64.4839Z"
          fill="#2F2E41"
        />
        <path
          d="M209.756 168.045L351.975 139.656L340.09 80.1147L197.871 108.504L209.756 168.045Z"
          fill="white"
        />
        <path
          d="M353.139 140.432L208.98 169.209L196.707 107.727L340.866 78.9507L353.139 140.432ZM210.533 166.881L350.811 138.879L339.313 81.2784L199.035 109.28L210.533 166.881Z"
          fill="#E4E4E4"
        />
        <path
          d="M330.373 99.1895L215.277 122.165L215.876 125.165L330.972 102.19L330.373 99.1895Z"
          fill="#E4E4E4"
        />
        <path
          d="M332.706 110.874L217.61 133.849L218.209 136.85L333.305 113.875L332.706 110.874Z"
          fill="#E4E4E4"
        />
        <path
          d="M335.052 122.626L219.956 145.601L220.555 148.602L335.651 125.627L335.052 122.626Z"
          fill="#E4E4E4"
        />
        <path
          d="M275.381 117.837L271.356 118.641C271.062 118.699 270.756 118.638 270.507 118.472C270.258 118.306 270.084 118.047 270.025 117.753L268.122 108.219C268.064 107.925 268.125 107.62 268.291 107.37C268.457 107.121 268.716 106.948 269.01 106.889L273.035 106.085C273.329 106.027 273.634 106.087 273.884 106.254C274.133 106.42 274.307 106.679 274.366 106.973L276.269 116.507C276.327 116.801 276.266 117.106 276.1 117.356C275.934 117.605 275.675 117.778 275.381 117.837Z"
          fill="url(#paint2_linear_20706_153740)"
        />
        <path
          d="M321.233 120.835L317.207 121.638C316.913 121.697 316.608 121.636 316.359 121.47C316.109 121.303 315.936 121.045 315.877 120.751L313.974 111.217C313.915 110.922 313.976 110.617 314.142 110.368C314.309 110.118 314.567 109.945 314.861 109.886L318.887 109.083C319.181 109.024 319.486 109.085 319.735 109.251C319.985 109.418 320.158 109.676 320.217 109.97L322.12 119.504C322.179 119.798 322.118 120.104 321.952 120.353C321.785 120.602 321.527 120.776 321.233 120.835Z"
          fill="url(#paint3_linear_20706_153740)"
        />
        <path
          d="M296.402 138.011L292.376 138.815C292.082 138.873 291.777 138.813 291.528 138.646C291.278 138.48 291.105 138.221 291.046 137.927L289.143 128.393C289.084 128.099 289.145 127.794 289.311 127.545C289.478 127.295 289.736 127.122 290.03 127.063L294.056 126.259C294.35 126.201 294.655 126.262 294.904 126.428C295.154 126.595 295.327 126.853 295.386 127.147L297.289 136.681C297.348 136.975 297.287 137.28 297.12 137.53C296.954 137.779 296.696 137.952 296.402 138.011Z"
          fill="url(#paint4_linear_20706_153740)"
        />
        <path
          d="M378.497 242.073H0.50332C0.369831 242.073 0.241809 242.02 0.147419 241.925C0.0530278 241.831 0 241.703 0 241.569C0 241.436 0.0530278 241.308 0.147419 241.213C0.241809 241.119 0.369831 241.066 0.50332 241.066H378.497C378.63 241.066 378.758 241.119 378.853 241.213C378.947 241.308 379 241.436 379 241.569C379 241.703 378.947 241.831 378.853 241.925C378.758 242.02 378.63 242.073 378.497 242.073Z"
          fill="#CACACA"
        />
      </g>
      <defs>
        <linearGradient
          id="paint0_linear_20706_153740"
          x1="100.437"
          y1="158.318"
          x2="110.504"
          y2="158.318"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="#1D4069" />
          <stop offset="1" stop-color="#266CBD" />
        </linearGradient>
        <linearGradient
          id="paint1_linear_20706_153740"
          x1="97.9443"
          y1="201.604"
          x2="108.011"
          y2="201.604"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="#1D4069" />
          <stop offset="1" stop-color="#266CBD" />
        </linearGradient>
        <linearGradient
          id="paint2_linear_20706_153740"
          x1="268.101"
          y1="112.363"
          x2="276.29"
          y2="112.363"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="#1D4069" />
          <stop offset="1" stop-color="#266CBD" />
        </linearGradient>
        <linearGradient
          id="paint3_linear_20706_153740"
          x1="313.952"
          y1="115.36"
          x2="322.142"
          y2="115.36"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="#1D4069" />
          <stop offset="1" stop-color="#266CBD" />
        </linearGradient>
        <linearGradient
          id="paint4_linear_20706_153740"
          x1="289.121"
          y1="132.537"
          x2="297.311"
          y2="132.537"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="#1D4069" />
          <stop offset="1" stop-color="#266CBD" />
        </linearGradient>
        <clipPath id="clip0_20706_153740">
          <rect width="379" height="242.072" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
}
POChangesNoData.propTypes = {
  Height: PropTypes.string,
  Width: PropTypes.string,
};
POChangesNoData.defaultProps = {
  Height: '',
  Width: '',
};
export function ChatNoData({ Height, Width }) {
  return (
    <svg
      width="379"
      height="274"
      viewBox="0 0 379 274"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      style={{ height: Height, width: Width }}
    >
      <g clip-path="url(#clip0_3364_45738)">
        <path
          d="M56.1867 194.23C55.8757 193.76 55.4654 193.363 54.9844 193.068C54.5035 192.773 53.9638 192.587 53.4032 192.523C52.8427 192.459 52.275 192.519 51.7401 192.698C51.2052 192.878 50.7161 193.172 50.3073 193.561L38.1211 187.271L38.8786 194.357L50.3347 199.243C51.0334 199.887 51.9438 200.252 52.8935 200.269C53.8432 200.286 54.7662 199.954 55.4875 199.336C56.2088 198.718 56.6784 197.857 56.8073 196.916C56.9362 195.975 56.7153 195.019 56.1867 194.23Z"
          fill="#A0616A"
        />
        <path
          d="M45.3569 197.083C45.1364 197.184 44.897 197.237 44.6544 197.24C44.4119 197.243 44.1714 197.194 43.9488 197.098L32.3737 192.077C28.4159 190.361 25.2162 187.266 23.3698 183.367L17.2845 170.523C16.8354 169.946 16.5044 169.286 16.3105 168.581C16.1166 167.876 16.0636 167.14 16.1545 166.415C16.2453 165.689 16.4783 164.989 16.84 164.353C17.2018 163.718 17.6853 163.16 18.2628 162.712C18.8403 162.264 19.5005 161.933 20.2057 161.74C20.911 161.547 21.6473 161.495 22.3727 161.587C23.098 161.679 23.7982 161.912 24.4331 162.275C25.0681 162.638 25.6253 163.122 26.073 163.7L36.7695 183.544L46.6464 191.005C46.9291 191.219 47.1391 191.515 47.248 191.853C47.3569 192.191 47.3594 192.554 47.2553 192.893L46.2858 196.024C46.1817 196.36 45.9777 196.656 45.7011 196.873C45.595 196.956 45.4795 197.027 45.3569 197.083Z"
          fill="#CCCCCC"
        />
        <path
          d="M17.0164 155.417C22.2221 155.417 26.4421 151.198 26.4421 145.992C26.4421 140.787 22.2221 136.567 17.0164 136.567C11.8108 136.567 7.59082 140.787 7.59082 145.992C7.59082 151.198 11.8108 155.417 17.0164 155.417Z"
          fill="#A0616A"
        />
        <path
          d="M20.8342 269.632L25.5387 269.632L27.7772 251.485L20.833 251.486L20.8342 269.632Z"
          fill="#A0616A"
        />
        <path
          d="M34.6123 273.999L19.8256 274L19.8254 268.287L28.899 268.287C30.4142 268.287 31.8674 268.888 32.9388 269.96C34.0103 271.031 34.6122 272.484 34.6123 273.999Z"
          fill="#2F2E41"
        />
        <path
          d="M5.48357 269.632L10.1881 269.632L12.4266 251.485L5.48242 251.486L5.48357 269.632Z"
          fill="#A0616A"
        />
        <path
          d="M19.2617 273.999L4.47503 274L4.47476 268.287L13.5484 268.287C15.0636 268.287 16.5168 268.888 17.5882 269.96C18.6597 271.031 19.2616 272.484 19.2617 273.999Z"
          fill="#2F2E41"
        />
        <path
          d="M3.84078 264.438C3.67867 264.253 3.558 264.035 3.48685 263.8C3.4157 263.564 3.39571 263.316 3.42824 263.072L11.6656 201.296L32.1311 204.771L34.3153 203.461L28.6673 262.075C28.6203 262.47 28.4383 262.838 28.1519 263.115C27.8655 263.392 27.4923 263.562 27.0953 263.596L20.8984 264.112C20.652 264.133 20.4041 264.1 20.1714 264.017C19.9387 263.933 19.7267 263.801 19.5496 263.628C19.3725 263.456 19.2346 263.247 19.1451 263.017C19.0556 262.786 19.0166 262.539 19.0308 262.292L20.6352 234.378C20.638 234.331 20.6232 234.284 20.5935 234.247C20.5638 234.21 20.5214 234.185 20.4745 234.178C20.4277 234.17 20.3796 234.18 20.3397 234.206C20.2997 234.231 20.2708 234.271 20.2584 234.317L12.321 263.75C12.2217 264.116 12.0047 264.44 11.7034 264.671C11.4021 264.901 11.0332 265.027 10.6536 265.027H5.14011C4.89403 265.027 4.65079 264.975 4.42669 264.873C4.2026 264.771 4.00283 264.623 3.84078 264.438Z"
          fill="#2F2E41"
        />
        <path
          d="M18.0138 205.62C17.779 205.407 17.477 205.283 17.1604 205.27C16.8438 205.257 16.5325 205.355 16.2807 205.547L12.1891 208.73C11.9664 208.903 11.7045 209.02 11.4264 209.068C11.1483 209.117 10.8624 209.097 10.5939 209.01C10.3254 208.922 10.0824 208.77 9.88632 208.567C9.69022 208.364 9.54699 208.116 9.4692 207.844C7.46222 200.816 2.91515 183.125 4.03533 170.673C4.67029 163.615 10.7654 158.251 17.6225 158.701C22.3104 159.014 25.3945 161.718 26.7891 166.738C30.2132 179.065 33.9763 201.675 34.6958 206.083C34.7526 206.425 34.7047 206.776 34.5584 207.09C34.4121 207.405 34.1742 207.667 33.8759 207.844C31.94 209.006 29.7281 209.629 27.4702 209.647C24.7381 209.647 21.4623 208.695 18.0138 205.62Z"
          fill="#CCCCCC"
        />
        <path
          d="M19.5577 210.004C19.6035 209.442 19.5255 208.877 19.3291 208.348C19.1327 207.819 18.8228 207.34 18.4211 206.944C18.0194 206.547 17.5357 206.244 17.0042 206.055C16.4726 205.866 15.9061 205.796 15.3444 205.85L9.63718 193.381L5.86035 199.424L11.8591 210.338C12.0118 211.275 12.503 212.124 13.2398 212.724C13.9765 213.323 14.9076 213.632 15.8565 213.59C16.8055 213.549 17.7064 213.162 18.3886 212.501C19.0707 211.84 19.4867 210.952 19.5577 210.004Z"
          fill="#A0616A"
        />
        <path
          d="M9.27593 205.566C9.04 205.51 8.8186 205.404 8.62613 205.256C8.43365 205.109 8.2744 204.922 8.15874 204.709L2.14932 193.615C0.0941807 189.823 -0.51329 185.413 0.439902 181.206L3.5785 167.344C3.58135 166.613 3.72824 165.89 4.01079 165.216C4.29334 164.541 4.70601 163.929 5.22519 163.415C5.74438 162.9 6.35991 162.493 7.03659 162.216C7.71327 161.94 8.43783 161.799 9.16886 161.803C9.89989 161.806 10.6231 161.954 11.297 162.237C11.9709 162.52 12.5825 162.934 13.0966 163.453C13.6107 163.973 14.0174 164.589 14.2934 165.266C14.5693 165.943 14.7091 166.667 14.7048 167.398L10.8743 189.614L14.0418 201.579C14.1318 201.922 14.1143 202.285 13.9915 202.618C13.8688 202.951 13.6467 203.238 13.3554 203.441L10.6602 205.306C10.3711 205.506 10.0279 205.613 9.67635 205.613C9.54148 205.613 9.40707 205.598 9.27593 205.566Z"
          fill="#CCCCCC"
        />
        <path
          opacity="0.2"
          d="M13.9402 176.767L10.4863 191.349L15.4753 203.628L12.0214 191.732L13.9402 176.767Z"
          fill="black"
        />
        <path
          d="M11.6377 153.742C10.7993 153.758 9.9661 153.607 9.18626 153.299C8.84314 153.167 8.48695 153.058 8.14446 152.926C5.11975 151.757 3.12726 148.536 3.0559 145.295C2.98454 142.053 4.66336 138.907 7.15627 136.833C9.64919 134.76 12.8781 133.695 16.1114 133.449C19.5941 133.184 23.5158 134.067 25.4619 136.967C25.98 137.739 26.3422 138.676 26.0353 139.608C25.9433 139.889 25.7791 140.141 25.5591 140.339C24.69 141.112 23.8235 140.531 22.9376 140.48C21.7198 140.409 20.626 141.395 20.2329 142.549C19.8398 143.704 20.0128 144.975 20.3302 146.153C20.572 146.862 20.7245 147.598 20.784 148.344C20.8096 148.718 20.7393 149.093 20.5795 149.433C20.4198 149.772 20.176 150.065 19.8712 150.284C19.1103 150.744 18.1109 150.478 17.3495 150.018C16.5881 149.559 15.9302 148.921 15.1077 148.583C14.2853 148.245 13.1803 148.32 12.7016 149.069C12.5495 149.342 12.4465 149.639 12.3974 149.947C11.9683 151.902 12.0669 151.787 11.6377 153.742Z"
          fill="#2F2E41"
        />
        <path
          d="M290.638 88.4443H57.6932C56.8059 88.4451 55.9551 88.7979 55.3277 89.4252C54.7003 90.0526 54.3475 90.9033 54.3467 91.7905V249.63C54.3475 250.517 54.7003 251.368 55.3277 251.995C55.9551 252.622 56.8059 252.975 57.6932 252.976H290.638C291.121 252.976 291.6 252.871 292.039 252.668C292.478 252.466 292.868 252.17 293.182 251.802C293.209 251.773 293.233 251.742 293.255 251.71C293.455 251.465 293.616 251.193 293.735 250.9C293.903 250.498 293.989 250.066 293.988 249.63V151.374H293.032V249.63C293.033 250.097 292.895 250.553 292.637 250.942C292.408 251.285 292.096 251.564 291.731 251.756C291.393 251.93 291.018 252.021 290.638 252.021H57.6932C57.0593 252.02 56.4516 251.768 56.0033 251.32C55.5551 250.871 55.3029 250.264 55.3022 249.63V91.7905C55.3029 91.1567 55.5551 90.549 56.0033 90.1008C56.4516 89.6527 57.0593 89.4006 57.6932 89.3998H290.638C291.272 89.3998 291.881 89.6515 292.33 90.0998C292.779 90.548 293.031 91.1561 293.032 91.7905V113H293.988V91.7905C293.987 90.9027 293.633 90.0516 293.005 89.4242C292.377 88.7967 291.526 88.4443 290.638 88.4443Z"
          fill="#3F3D56"
        />
        <path
          d="M293.507 101.856H54.8223V102.813H293.507V101.856Z"
          fill="#3F3D56"
        />
        <path
          d="M62.9539 98.4895C64.539 98.4895 65.8239 97.2047 65.8239 95.6198C65.8239 94.0348 64.539 92.75 62.9539 92.75C61.3689 92.75 60.084 94.0348 60.084 95.6198C60.084 97.2047 61.3689 98.4895 62.9539 98.4895Z"
          fill="#CCCCCC"
        />
        <path
          d="M71.2049 98.4895C72.7899 98.4895 74.0749 97.2047 74.0749 95.6198C74.0749 94.0348 72.7899 92.75 71.2049 92.75C69.6199 92.75 68.335 94.0348 68.335 95.6198C68.335 97.2047 69.6199 98.4895 71.2049 98.4895Z"
          fill="#CCCCCC"
        />
        <path
          d="M79.4559 98.4895C81.0409 98.4895 82.3258 97.2047 82.3258 95.6198C82.3258 94.0348 81.0409 92.75 79.4559 92.75C77.8709 92.75 76.5859 94.0348 76.5859 95.6198C76.5859 97.2047 77.8709 98.4895 79.4559 98.4895Z"
          fill="#CCCCCC"
        />
        <path
          d="M137.102 233.629C136.114 233.624 135.142 233.374 134.276 232.899C133.409 232.425 132.675 231.741 132.139 230.911C131.603 230.082 131.282 229.131 131.206 228.146C131.13 227.161 131.301 226.173 131.703 225.271L138.541 210.017C133.156 205.254 128.847 199.4 125.9 192.844C122.952 186.287 121.435 179.178 121.447 171.99C121.447 143.906 144.297 121.058 172.383 121.058C200.469 121.058 223.319 143.906 223.319 171.99C223.319 200.074 200.469 222.922 172.383 222.922C167.47 222.918 162.583 222.198 157.878 220.786L140.428 232.598C139.447 233.267 138.289 233.627 137.102 233.629ZM172.383 128.164C163.293 128.159 154.427 130.982 147.013 136.241C139.599 141.5 134.005 148.935 131.007 157.515C128.008 166.096 127.753 175.396 130.278 184.128C132.802 192.86 137.98 200.59 145.095 206.247L147.249 207.965L139.892 224.379L156.775 212.95L158.441 213.51C164.463 215.533 170.853 216.223 177.168 215.531C183.483 214.839 189.572 212.782 195.012 209.503C200.453 206.224 205.116 201.802 208.678 196.542C212.239 191.282 214.614 185.31 215.638 179.041C216.662 172.772 216.311 166.355 214.608 160.235C212.906 154.115 209.893 148.439 205.778 143.599C201.663 138.76 196.546 134.873 190.779 132.207C185.013 129.542 178.736 128.163 172.383 128.164Z"
          fill="#3F3D56"
        />
        <path
          d="M172.384 176.728C176.309 176.728 179.491 173.546 179.491 169.621C179.491 165.696 176.309 162.515 172.384 162.515C168.458 162.515 165.276 165.696 165.276 169.621C165.276 173.546 168.458 176.728 172.384 176.728Z"
          fill="#3F3D56"
        />
        <path
          d="M152.246 176.728C156.171 176.728 159.353 173.546 159.353 169.621C159.353 165.696 156.171 162.515 152.246 162.515C148.321 162.515 145.139 165.696 145.139 169.621C145.139 173.546 148.321 176.728 152.246 176.728Z"
          fill="#3F3D56"
        />
        <path
          d="M192.52 176.728C196.446 176.728 199.628 173.546 199.628 169.621C199.628 165.696 196.446 162.515 192.52 162.515C188.595 162.515 185.413 165.696 185.413 169.621C185.413 173.546 188.595 176.728 192.52 176.728Z"
          fill="#3F3D56"
        />
        <path
          d="M351.11 141.492H283.567C282.753 141.492 281.972 141.169 281.396 140.593C280.821 140.017 280.497 139.237 280.497 138.422C280.497 137.608 280.821 136.827 281.396 136.252C281.972 135.676 282.753 135.353 283.567 135.353H351.11C351.924 135.353 352.705 135.676 353.28 136.252C353.856 136.827 354.18 137.608 354.18 138.422C354.18 139.237 353.856 140.017 353.28 140.593C352.705 141.169 351.924 141.492 351.11 141.492Z"
          fill="#CCCCCC"
        />
        <path
          d="M306.977 128.445H283.567C282.753 128.445 281.972 128.122 281.396 127.546C280.821 126.971 280.497 126.19 280.497 125.376C280.497 124.561 280.821 123.781 281.396 123.205C281.972 122.629 282.753 122.306 283.567 122.306H306.977C307.791 122.306 308.572 122.629 309.148 123.205C309.723 123.781 310.047 124.561 310.047 125.376C310.047 126.19 309.723 126.971 309.148 127.546C308.572 128.122 307.791 128.445 306.977 128.445Z"
          fill="#CCCCCC"
        />
        <path
          d="M252.976 145.234C260.182 145.234 266.024 139.392 266.024 132.187C266.024 124.981 260.182 119.14 252.976 119.14C245.77 119.14 239.928 124.981 239.928 132.187C239.928 139.392 245.77 145.234 252.976 145.234Z"
          fill="url(#paint0_linear_3364_45738)"
        />
        <path
          d="M357.88 112.232H236.227C234.498 112.235 232.84 112.923 231.617 114.146C230.394 115.369 229.706 117.027 229.703 118.756V145.618C229.706 147.347 230.394 149.005 231.617 150.228C232.84 151.451 234.498 152.139 236.227 152.141H357.88C359.61 152.139 361.268 151.451 362.491 150.228C363.714 149.005 364.402 147.347 364.404 145.618V118.756C364.402 117.027 363.714 115.369 362.491 114.146C361.268 112.923 359.61 112.235 357.88 112.232ZM363.637 145.618C363.635 147.144 363.028 148.607 361.949 149.686C360.869 150.765 359.406 151.372 357.88 151.374H236.227C234.701 151.372 233.238 150.765 232.159 149.686C231.08 148.607 230.473 147.144 230.471 145.618V118.756C230.473 117.23 231.08 115.767 232.159 114.688C233.238 113.609 234.701 113.002 236.227 113H357.88C359.406 113.002 360.869 113.609 361.949 114.688C363.028 115.767 363.635 117.23 363.637 118.756V145.618Z"
          fill="#3F3D56"
        />
        <path
          d="M363.637 122.977C368.512 122.977 372.464 119.026 372.464 114.151C372.464 109.277 368.512 105.325 363.637 105.325C358.762 105.325 354.811 109.277 354.811 114.151C354.811 119.026 358.762 122.977 363.637 122.977Z"
          fill="url(#paint1_linear_3364_45738)"
        />
        <path
          d="M363.365 119.115C363.33 119.079 363.301 119.037 363.282 118.99C363.263 118.944 363.253 118.894 363.253 118.843V109.075C363.253 108.973 363.293 108.876 363.365 108.804C363.437 108.732 363.535 108.691 363.637 108.691C363.738 108.691 363.836 108.732 363.908 108.804C363.98 108.876 364.02 108.973 364.02 109.075V118.843C364.02 118.919 363.998 118.994 363.956 119.057C363.914 119.12 363.854 119.169 363.784 119.198C363.713 119.227 363.636 119.235 363.562 119.22C363.487 119.205 363.419 119.168 363.365 119.115Z"
          fill="white"
        />
        <path
          d="M358.481 114.23C358.427 114.177 358.39 114.108 358.376 114.034C358.361 113.959 358.368 113.882 358.397 113.812C358.426 113.742 358.476 113.682 358.539 113.64C358.602 113.598 358.676 113.575 358.752 113.575H368.521C368.623 113.575 368.72 113.616 368.792 113.688C368.864 113.76 368.905 113.857 368.905 113.959C368.905 114.061 368.864 114.158 368.792 114.23C368.72 114.302 368.623 114.343 368.521 114.343H358.752C358.701 114.343 358.652 114.333 358.605 114.314C358.558 114.294 358.516 114.266 358.481 114.23Z"
          fill="white"
        />
        <path
          d="M374.203 231.462H355.779C355.779 231.991 336.79 232.421 336.79 232.421C336.492 232.646 336.22 232.903 335.98 233.189C335.259 234.049 334.865 235.136 334.867 236.259V237.026C334.868 238.298 335.373 239.518 336.273 240.417C337.172 241.317 338.392 241.822 339.664 241.823H374.203C375.475 241.822 376.694 241.316 377.594 240.417C378.493 239.517 378.999 238.298 379 237.026V236.259C378.998 234.987 378.492 233.768 377.593 232.869C376.694 231.97 375.475 231.464 374.203 231.462Z"
          fill="#3F3D56"
        />
        <path
          d="M359.618 241.633H354.629V273.867H359.618V241.633Z"
          fill="#3F3D56"
        />
        <path
          d="M373.817 273.691C373.817 274.23 366.257 273.9 356.931 273.9C347.606 273.9 340.046 274.23 340.046 273.691C340.046 273.152 347.606 268.878 356.931 268.878C366.257 268.878 373.817 273.152 373.817 273.691Z"
          fill="#3F3D56"
        />
        <path
          d="M358.724 188.266C364.658 188.266 369.469 183.455 369.469 177.521C369.469 171.587 364.658 166.776 358.724 166.776C352.789 166.776 347.979 171.587 347.979 177.521C347.979 183.455 352.789 188.266 358.724 188.266Z"
          fill="#2F2E41"
        />
        <path
          d="M331.983 269.451L327.279 269.451L325.04 251.305L331.984 251.305L331.983 269.451Z"
          fill="#FFB8B8"
        />
        <path
          d="M323.918 268.107H332.992V273.82H318.205C318.205 272.305 318.807 270.852 319.878 269.781C320.95 268.709 322.403 268.107 323.918 268.107Z"
          fill="#2F2E41"
        />
        <path
          d="M324.639 266.825L320.15 265.417L323.448 247.433L330.073 249.512L324.639 266.825Z"
          fill="#FFB8B8"
        />
        <path
          d="M317.346 263.128L326.004 265.845L324.293 271.296L310.185 266.869C310.639 265.423 311.648 264.217 312.991 263.515C314.334 262.814 315.901 262.675 317.346 263.128Z"
          fill="#2F2E41"
        />
        <path
          d="M361.603 228.317C361.494 227.402 361.299 226.5 361.019 225.623L360.14 224.518L357.853 221.647L357.753 221.651C357.584 221.659 356.882 221.697 355.796 221.782H355.785C355.113 221.835 354.292 221.905 353.359 221.993C353.114 222.02 352.857 222.043 352.592 222.07V226.076H357.389C357.622 226.076 357.847 226.161 358.022 226.315C358.197 226.469 358.31 226.681 358.341 226.912C358.344 226.955 358.348 226.993 358.348 227.035C358.348 227.29 358.247 227.534 358.067 227.713C357.887 227.893 357.643 227.994 357.389 227.994H329.528C329.173 228.23 328.832 228.486 328.507 228.762C327.525 229.522 326.818 230.581 326.492 231.778C324.865 238.931 321.898 252.27 321.023 256.188C320.96 256.483 320.974 256.79 321.065 257.078C321.156 257.365 321.32 257.625 321.541 257.83C321.705 257.982 321.896 258.101 322.106 258.179L325.567 259.476C325.709 259.529 325.858 259.564 326.008 259.58C326.028 259.58 326.043 259.584 326.062 259.584C326.098 259.587 326.134 259.588 326.17 259.588C326.52 259.586 326.861 259.479 327.149 259.281C327.438 259.082 327.659 258.801 327.785 258.475L330.518 251.307L334.728 240.255L336.393 235.884C338.323 236.337 354.518 239.921 359.941 234.146C360.476 233.577 360.898 232.911 361.184 232.185C361.641 230.95 361.784 229.621 361.603 228.317Z"
          fill="#2F2E41"
        />
        <path
          d="M366.3 229.36C366.215 229.018 366.119 228.665 366.008 228.309L362.842 224.333L362.742 224.337C362.543 224.348 361.595 224.398 360.14 224.517C358.49 224.655 356.184 224.878 353.593 225.227C353.517 225.235 353.436 225.246 353.359 225.258C353.106 225.292 352.849 225.327 352.592 225.365V226.075H357.389C357.622 226.076 357.847 226.161 358.022 226.314C358.197 226.468 358.31 226.681 358.341 226.912C358.344 226.954 358.348 226.992 358.348 227.035C358.348 227.289 358.247 227.533 358.067 227.713C357.887 227.893 357.643 227.994 357.389 227.994H340.434C339.694 228.236 338.98 228.489 338.297 228.761C334.712 230.181 332.03 232.042 331.481 234.464C331.297 235.277 331.093 236.171 330.878 237.123C330.08 240.661 329.109 244.994 328.231 248.931V248.935C328.05 249.748 327.87 250.539 327.697 251.306C326.964 254.606 326.342 257.404 326.012 258.873C326.005 258.916 325.997 258.954 325.989 258.996V259.004C325.951 259.301 325.988 259.603 326.097 259.883L326.101 259.886V259.89C326.206 260.158 326.378 260.394 326.6 260.577C326.748 260.699 326.915 260.797 327.095 260.865L330.556 262.162C330.749 262.234 330.953 262.272 331.159 262.273C331.447 262.274 331.731 262.201 331.984 262.062C332.346 261.866 332.627 261.546 332.774 261.16L340.227 241.605L341.382 238.57C343.312 239.022 359.507 242.603 364.93 236.831C366.001 235.672 366.612 234.161 366.649 232.583C366.687 231.498 366.569 230.412 366.3 229.36Z"
          fill="#2F2E41"
        />
        <path
          d="M365.873 195.506C365.812 195.433 365.747 195.361 365.678 195.292C364.656 194.217 363.394 193.4 361.995 192.907C360.596 192.414 359.1 192.259 357.63 192.456C356.348 192.624 355.078 192.874 353.827 193.204C352.212 193.619 350.733 194.449 349.537 195.61C348.605 196.514 347.871 197.601 347.381 198.803C346.892 200.006 346.657 201.296 346.693 202.594C346.708 203.12 346.712 203.657 346.705 204.202C346.705 204.455 346.701 204.712 346.697 204.969H350.481C350.645 204.969 350.809 204.988 350.968 205.027C351.43 205.137 351.841 205.4 352.136 205.772C352.43 206.145 352.591 206.605 352.592 207.08V224.931C352.849 225.004 353.106 225.077 353.359 225.154C353.44 225.181 353.516 225.204 353.593 225.227C353.681 225.254 353.77 225.281 353.854 225.307C354.633 225.549 355.394 225.805 356.137 226.075H357.389C357.622 226.075 357.847 226.16 358.022 226.314C358.197 226.468 358.31 226.68 358.34 226.912C358.601 227.015 358.854 227.119 359.104 227.222C359.99 227.591 360.831 227.959 361.602 228.316C362.642 228.792 363.567 229.245 364.342 229.64C364.586 229.764 364.855 229.83 365.129 229.832C365.488 229.831 365.838 229.715 366.127 229.502C366.187 229.457 366.244 229.41 366.299 229.36C366.505 229.167 366.66 228.927 366.752 228.661C366.843 228.395 366.869 228.111 366.825 227.832C366.429 224.818 366.313 221.774 366.48 218.738C366.587 216.186 366.818 213.569 367.117 211.04C367.278 209.67 367.458 208.327 367.647 207.034C367.827 205.798 368.019 204.612 368.207 203.492C368.454 202.071 368.372 200.613 367.967 199.228C367.563 197.844 366.846 196.571 365.873 195.506Z"
          fill="url(#paint2_linear_3364_45738)"
        />
        <path
          d="M350.143 195.822C349.946 195.737 349.744 195.667 349.537 195.611C348.514 195.335 347.426 195.437 346.472 195.897C345.518 196.357 344.762 197.145 344.341 198.117L341.704 204.203L341.374 204.97H350.481C350.645 204.97 350.809 204.989 350.968 205.028L351.275 204.318L352.442 201.624C352.905 200.55 352.923 199.335 352.492 198.248C352.061 197.16 351.217 196.287 350.143 195.822Z"
          fill="url(#paint3_linear_3364_45738)"
        />
        <path
          d="M358.332 189.459C363.537 189.459 367.757 185.24 367.757 180.034C367.757 174.829 363.537 170.609 358.332 170.609C353.126 170.609 348.906 174.829 348.906 180.034C348.906 185.24 353.126 189.459 358.332 189.459Z"
          fill="#FFB8B8"
        />
        <path
          d="M348.736 175.404C353.201 178.13 358.234 179.788 363.445 180.25L361.894 178.393C363.023 178.81 364.211 179.046 365.414 179.092C366.615 179.073 367.873 178.61 368.555 177.621C368.859 177.129 369.04 176.572 369.082 175.995C369.123 175.418 369.025 174.84 368.795 174.31C368.323 173.252 367.587 172.332 366.659 171.639C365.014 170.337 363.072 169.463 361.006 169.094C358.941 168.725 356.816 168.872 354.822 169.523C353.454 169.932 352.229 170.718 351.287 171.791C350.393 172.893 348.673 173.875 349.13 175.218L348.736 175.404Z"
          fill="#2F2E41"
        />
        <path
          d="M359.916 167.798C356.943 164.784 353.346 162.458 349.377 160.983C346.829 160.04 344.056 159.457 341.393 159.993C338.729 160.529 336.21 162.371 335.467 164.984C334.86 167.121 335.487 169.422 336.43 171.433C337.373 173.445 338.632 175.31 339.394 177.396C340.172 179.525 340.406 181.815 340.075 184.057C339.744 186.3 338.858 188.424 337.497 190.237C336.137 192.05 334.345 193.494 332.284 194.439C330.224 195.384 327.96 195.8 325.698 195.648C328.315 195.999 330.728 197.228 333.286 197.883C335.844 198.538 338.863 198.493 340.764 196.661C342.775 194.722 342.815 191.57 342.718 188.778C342.573 184.628 342.429 180.478 342.284 176.327C342.211 174.211 342.148 172.027 342.911 170.051C343.674 168.076 345.488 166.346 347.606 166.364C349.211 166.377 350.632 167.35 351.919 168.309C353.206 169.267 354.569 170.291 356.168 170.433C357.766 170.576 359.592 169.393 359.472 167.792L359.916 167.798Z"
          fill="#2F2E41"
        />
        <path
          d="M367.647 207.034L362.267 207.18L361.875 210.96L361.787 211.835L353.359 215.618L352.592 215.964V222.691L353.359 222.472L355.785 221.781H355.796L366.48 218.738L366.603 218.704C367.466 218.454 368.226 217.933 368.77 217.218C369.313 216.502 369.611 215.63 369.619 214.732L369.646 210.269L369.669 206.98L367.647 207.034Z"
          fill="#FFB8B8"
        />
        <path
          d="M369.397 199.559C369.325 198.391 368.792 197.299 367.915 196.523C367.038 195.748 365.889 195.353 364.72 195.424C363.552 195.496 362.46 196.029 361.685 196.906C360.909 197.783 360.514 198.932 360.585 200.1L361.172 209.678C361.188 209.93 361.26 210.176 361.381 210.397C361.502 210.619 361.671 210.811 361.875 210.96C362.199 211.202 362.599 211.32 363.003 211.294L367.117 211.041L368.364 210.964C368.592 210.953 368.814 210.896 369.019 210.796C369.223 210.696 369.405 210.556 369.554 210.384C369.587 210.348 369.618 210.309 369.646 210.269C369.89 209.943 370.01 209.54 369.984 209.133L369.397 199.559Z"
          fill="url(#paint4_linear_3364_45738)"
        />
        <path
          d="M353.855 225.308H353.36V225.258C353.106 225.292 352.849 225.327 352.592 225.365V226.075H356.138C355.394 225.807 354.632 225.551 353.855 225.308ZM353.855 225.308H353.36V225.258C353.106 225.292 352.849 225.327 352.592 225.365V226.075H356.138C355.394 225.807 354.632 225.551 353.855 225.308ZM357.389 225.308H353.36V207.08C353.358 206.456 353.154 205.849 352.779 205.351C352.403 204.853 351.875 204.49 351.276 204.317C351.018 204.24 350.75 204.201 350.481 204.202H316.326C315.563 204.203 314.832 204.507 314.292 205.046C313.753 205.586 313.449 206.317 313.448 207.08V225.883C313.449 226.647 313.752 227.379 314.292 227.918C314.831 228.458 315.563 228.761 316.326 228.761H357.389C357.814 228.761 358.224 228.603 358.541 228.32C358.857 228.036 359.058 227.645 359.104 227.223C359.112 227.16 359.116 227.097 359.116 227.035C359.115 226.577 358.933 226.138 358.61 225.814C358.286 225.491 357.847 225.308 357.389 225.308ZM358.349 227.035C358.348 227.289 358.247 227.533 358.067 227.713C357.888 227.893 357.644 227.994 357.389 227.994H316.326C315.767 227.994 315.23 227.771 314.834 227.375C314.439 226.98 314.216 226.443 314.216 225.883V207.08C314.216 206.521 314.439 205.984 314.834 205.588C315.23 205.192 315.767 204.97 316.326 204.97H350.481C350.646 204.969 350.809 204.989 350.969 205.027C351.431 205.138 351.842 205.4 352.136 205.772C352.431 206.145 352.591 206.605 352.592 207.08V226.075H357.389C357.622 226.076 357.847 226.161 358.022 226.315C358.198 226.468 358.311 226.681 358.341 226.912C358.345 226.954 358.349 226.992 358.349 227.035ZM353.855 225.308H353.36V225.258C353.106 225.292 352.849 225.327 352.592 225.365V226.075H356.138C355.394 225.807 354.632 225.551 353.855 225.308Z"
          fill="#3F3D56"
        />
        <path
          d="M333.402 218.785C334.674 218.785 335.705 217.754 335.705 216.482C335.705 215.211 334.674 214.18 333.402 214.18C332.131 214.18 331.1 215.211 331.1 216.482C331.1 217.754 332.131 218.785 333.402 218.785Z"
          fill="url(#paint5_linear_3364_45738)"
        />
      </g>
      <defs>
        <linearGradient
          id="paint0_linear_3364_45738"
          x1="239.928"
          y1="132.187"
          x2="266.024"
          y2="132.187"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="#1D4069" />
          <stop offset="1" stop-color="#266CBD" />
        </linearGradient>
        <linearGradient
          id="paint1_linear_3364_45738"
          x1="354.811"
          y1="114.151"
          x2="372.464"
          y2="114.151"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="#1D4069" />
          <stop offset="1" stop-color="#266CBD" />
        </linearGradient>
        <linearGradient
          id="paint2_linear_3364_45738"
          x1="346.689"
          y1="211.102"
          x2="368.346"
          y2="211.102"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="#1D4069" />
          <stop offset="1" stop-color="#266CBD" />
        </linearGradient>
        <linearGradient
          id="paint3_linear_3364_45738"
          x1="341.374"
          y1="200.243"
          x2="352.803"
          y2="200.243"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="#1D4069" />
          <stop offset="1" stop-color="#266CBD" />
        </linearGradient>
        <linearGradient
          id="paint4_linear_3364_45738"
          x1="360.577"
          y1="203.357"
          x2="369.987"
          y2="203.357"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="#1D4069" />
          <stop offset="1" stop-color="#266CBD" />
        </linearGradient>
        <linearGradient
          id="paint5_linear_3364_45738"
          x1="331.1"
          y1="216.482"
          x2="335.705"
          y2="216.482"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="#1D4069" />
          <stop offset="1" stop-color="#266CBD" />
        </linearGradient>
        <clipPath id="clip0_3364_45738">
          <rect width="379" height="274" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
}
ChatNoData.propTypes = {
  Height: PropTypes.string,
  Width: PropTypes.string,
};
ChatNoData.defaultProps = {
  Height: '',
  Width: '',
};

export function NewOrderBox({ color }) {
  return (
    <svg
      width="21"
      height="20"
      viewBox="0 0 21 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M15.6596 16.5999C15.5076 16.5999 15.3636 16.5439 15.2436 16.4319L14.4356 15.6639C14.1956 15.4319 14.1876 15.0559 14.4196 14.8159C14.6516 14.5759 15.0276 14.5679 15.2676 14.7999L15.6596 15.1759L16.9156 13.9599C17.1556 13.7279 17.5316 13.7359 17.7636 13.9759C17.9956 14.2159 17.9876 14.5919 17.7476 14.8239L16.0756 16.4399C15.9556 16.5439 15.8036 16.5999 15.6596 16.5999Z"
        fill={color !== '' ? color : '#0E803C'}
      />
      <path
        d="M10.4997 11.4398C10.3957 11.4398 10.2917 11.4159 10.1957 11.3599L3.13169 7.27187C2.84369 7.10387 2.74767 6.73585 2.91567 6.44785C3.08367 6.15985 3.45169 6.06383 3.73169 6.23183L10.4917 10.1438L17.2117 6.25586C17.4997 6.08786 17.8677 6.19187 18.0277 6.47187C18.1957 6.75987 18.0917 7.12785 17.8117 7.29585L10.7957 11.3599C10.7077 11.4079 10.6037 11.4398 10.4997 11.4398Z"
        fill={color !== '' ? color : 'white'}
      />
      <path
        d="M10.4999 18.6879C10.1719 18.6879 9.8999 18.4159 9.8999 18.0879V10.8319C9.8999 10.5039 10.1719 10.2319 10.4999 10.2319C10.8279 10.2319 11.0999 10.5039 11.0999 10.8319V18.0879C11.0999 18.4159 10.8279 18.6879 10.4999 18.6879Z"
        fill={color !== '' ? color : 'white'}
      />
      <path
        d="M10.4996 18.9999C9.79561 18.9999 9.09161 18.8479 8.54761 18.5359L4.27561 16.1679C3.11561 15.5279 2.20361 13.9839 2.20361 12.6559V8.12787C2.20361 6.79987 3.11561 5.26391 4.27561 4.61591L8.54761 2.24789C9.63561 1.63189 11.3476 1.63189 12.4436 2.24789L16.7156 4.61591C17.8756 5.25591 18.7876 6.79987 18.7876 8.12787V12.6559C18.7876 12.7359 18.7876 12.7999 18.7716 12.8799C18.7316 13.0879 18.5796 13.2639 18.3796 13.3279C18.1796 13.3999 17.9556 13.3519 17.7876 13.2159C16.8676 12.4159 15.4436 12.3839 14.4756 13.1599C13.8596 13.6479 13.4996 14.3919 13.4996 15.1839C13.4996 15.6559 13.6276 16.1199 13.8756 16.5199C13.9396 16.6319 14.0036 16.7199 14.0756 16.8079C14.1956 16.9439 14.2436 17.1279 14.2116 17.3039C14.1796 17.4799 14.0676 17.6319 13.9076 17.7199L12.4436 18.5279C11.8996 18.8479 11.2036 18.9999 10.4996 18.9999ZM10.4996 2.99989C10.0036 2.99989 9.4996 3.10389 9.1396 3.30389L4.8676 5.67191C4.0916 6.09591 3.4196 7.24787 3.4196 8.12787V12.6559C3.4196 13.5359 4.0996 14.6879 4.8676 15.1119L9.1396 17.4799C9.8676 17.8879 11.1396 17.8879 11.8676 17.4799L12.7636 16.9839C12.4676 16.4479 12.3076 15.8239 12.3076 15.1839C12.3076 14.0159 12.8276 12.9359 13.7316 12.2159C14.8196 11.3439 16.3716 11.1599 17.5956 11.6799V8.1119C17.5956 7.2319 16.9156 6.0799 16.1476 5.6559L11.8756 3.28788C11.4996 3.10388 10.9956 2.99989 10.4996 2.99989Z"
        fill={color !== '' ? color : 'white'}
      />
      <path
        d="M16.1001 19C14.8041 19 13.5801 18.3281 12.8921 17.2241C12.5241 16.6561 12.3161 15.976 12.3001 15.28C12.2761 14.112 12.7722 13.024 13.6602 12.288C14.3242 11.736 15.1562 11.424 16.0122 11.4C17.0522 11.392 17.9881 11.752 18.7241 12.456C19.4601 13.16 19.8761 14.1041 19.8921 15.1201C19.9081 15.8161 19.7322 16.496 19.3802 17.096C19.1882 17.432 18.9401 17.744 18.6441 18.008C17.9881 18.624 17.1081 18.984 16.1721 19C16.1561 19 16.1321 19 16.1001 19ZM16.1001 12.6C16.0841 12.6 16.0601 12.6 16.0441 12.6C15.4521 12.616 14.8922 12.824 14.4282 13.208C13.8202 13.712 13.4841 14.456 13.5001 15.256C13.5081 15.728 13.6521 16.192 13.9001 16.584C14.3881 17.368 15.2361 17.848 16.1481 17.8C16.7801 17.784 17.3802 17.5441 17.8362 17.1201C18.0442 16.9361 18.2121 16.728 18.3401 16.504C18.5801 16.088 18.7001 15.624 18.6921 15.152C18.6761 14.456 18.3961 13.808 17.8921 13.328C17.4121 12.856 16.7721 12.6 16.1001 12.6Z"
        fill={color !== '' ? color : '#0E803C'}
      />
    </svg>
  );
}
NewOrderBox.propTypes = {
  color: PropTypes.string,
  // width: PropTypes.string,
  // height: PropTypes.string,
};
NewOrderBox.defaultProps = {
  color: '',
  // width: '',
  // height: '',
};

export function DelayedOrderBox() {
  return (
    <svg
      width="21"
      height="20"
      viewBox="0 0 21 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M10.4997 11.4398C10.3957 11.4398 10.2917 11.4159 10.1957 11.3599L3.13169 7.27187C2.84369 7.10387 2.74767 6.73585 2.91567 6.44785C3.08367 6.15985 3.45169 6.06383 3.73169 6.23183L10.4917 10.1438L17.2117 6.25586C17.4997 6.08786 17.8677 6.19187 18.0277 6.47187C18.1957 6.75987 18.0917 7.12785 17.8117 7.29585L10.7957 11.3599C10.7077 11.4079 10.6037 11.4398 10.4997 11.4398Z"
        fill="white"
        fill-opacity="0.7"
      />
      <path
        d="M10.4999 18.6879C10.1719 18.6879 9.8999 18.4159 9.8999 18.0879V10.8319C9.8999 10.5039 10.1719 10.2319 10.4999 10.2319C10.8279 10.2319 11.0999 10.5039 11.0999 10.8319V18.0879C11.0999 18.4159 10.8279 18.6879 10.4999 18.6879Z"
        fill="white"
        fill-opacity="0.7"
      />
      <path
        d="M10.4996 18.9999C9.79561 18.9999 9.09161 18.8479 8.54761 18.5359L4.27561 16.1679C3.11561 15.5279 2.20361 13.9839 2.20361 12.6559V8.12787C2.20361 6.79987 3.11561 5.26391 4.27561 4.61591L8.54761 2.24789C9.63561 1.63189 11.3476 1.63189 12.4436 2.24789L16.7156 4.61591C17.8756 5.25591 18.7876 6.79987 18.7876 8.12787V12.6559C18.7876 12.7359 18.7876 12.7999 18.7716 12.8799C18.7316 13.0879 18.5796 13.2639 18.3796 13.3279C18.1796 13.3999 17.9556 13.3519 17.7876 13.2159C16.8676 12.4159 15.4436 12.3839 14.4756 13.1599C13.8596 13.6479 13.4996 14.3919 13.4996 15.1839C13.4996 15.6559 13.6276 16.1199 13.8756 16.5199C13.9396 16.6319 14.0036 16.7199 14.0756 16.8079C14.1956 16.9439 14.2436 17.1279 14.2116 17.3039C14.1796 17.4799 14.0676 17.6319 13.9076 17.7199L12.4436 18.5279C11.8996 18.8479 11.2036 18.9999 10.4996 18.9999ZM10.4996 2.99989C10.0036 2.99989 9.4996 3.10389 9.1396 3.30389L4.8676 5.67191C4.0916 6.09591 3.4196 7.24787 3.4196 8.12787V12.6559C3.4196 13.5359 4.0996 14.6879 4.8676 15.1119L9.1396 17.4799C9.8676 17.8879 11.1396 17.8879 11.8676 17.4799L12.7636 16.9839C12.4676 16.4479 12.3076 15.8239 12.3076 15.1839C12.3076 14.0159 12.8276 12.9359 13.7316 12.2159C14.8196 11.3439 16.3796 11.1599 17.5956 11.6799V8.1119C17.5956 7.2319 16.9156 6.0799 16.1476 5.6559L11.8756 3.28788C11.4996 3.10388 10.9956 2.99989 10.4996 2.99989Z"
        fill="white"
        fill-opacity="0.7"
      />
      <path
        d="M16.9559 16.6321C16.8039 16.6321 16.6519 16.5761 16.5319 16.4561L14.8439 14.7681C14.6119 14.5361 14.6119 14.1521 14.8439 13.9201C15.0759 13.6881 15.4599 13.6881 15.6919 13.9201L17.3799 15.6081C17.6119 15.8401 17.6119 16.2241 17.3799 16.4561C17.2599 16.5761 17.1079 16.6321 16.9559 16.6321Z"
        fill="#BF182C"
      />
      <path
        d="M15.244 16.656C15.092 16.656 14.94 16.6 14.82 16.48C14.588 16.248 14.588 15.864 14.82 15.632L16.508 13.944C16.74 13.712 17.124 13.712 17.356 13.944C17.588 14.176 17.588 14.56 17.356 14.792L15.668 16.48C15.548 16.6 15.396 16.656 15.244 16.656Z"
        fill="#BF182C"
      />
      <path
        d="M16.0998 19.0001C14.7718 19.0001 13.5238 18.2961 12.8518 17.1521C12.4918 16.5761 12.2998 15.8961 12.2998 15.2001C12.2998 14.0321 12.8198 12.9521 13.7238 12.2321C14.3958 11.6961 15.2438 11.4001 16.0998 11.4001C18.1958 11.4001 19.8998 13.1041 19.8998 15.2001C19.8998 15.8961 19.7078 16.5762 19.3478 17.1602C19.1558 17.4962 18.8918 17.8002 18.5878 18.0562C17.9238 18.6642 17.0358 19.0001 16.0998 19.0001ZM16.0998 12.6001C15.5078 12.6001 14.9478 12.8001 14.4758 13.1761C13.8598 13.6641 13.4998 14.4081 13.4998 15.2001C13.4998 15.6721 13.6278 16.1361 13.8758 16.5361C14.3478 17.3361 15.1798 17.8001 16.0998 17.8001C16.7318 17.8001 17.3398 17.5681 17.8038 17.1521C18.0118 16.9761 18.1878 16.7681 18.3158 16.5441C18.5718 16.1361 18.6998 15.6721 18.6998 15.2001C18.6998 13.7681 17.5318 12.6001 16.0998 12.6001Z"
        fill="#BF182C"
      />
    </svg>
  );
}

export function ExpectedCargoReady() {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M12.0003 18.1999C11.7843 18.1999 11.5844 18.0799 11.4804 17.8959C11.3764 17.7119 11.3763 17.4799 11.4883 17.2959L12.3283 15.8959C12.4963 15.6079 12.8643 15.5199 13.1523 15.6879C13.4403 15.8559 13.5283 16.2239 13.3603 16.5119L13.1443 16.8719C15.3523 16.3519 17.0083 14.3679 17.0083 11.9999C17.0083 11.6719 17.2803 11.3999 17.6083 11.3999C17.9363 11.3999 18.2083 11.6719 18.2083 11.9999C18.2003 15.4159 15.4163 18.1999 12.0003 18.1999Z"
        fill="#2179C4"
      />
      <path
        d="M1.6 7.8C1.272 7.8 1 7.528 1 7.2C1 3.784 3.784 1 7.2 1C7.416 1 7.616 1.12 7.72 1.304C7.824 1.488 7.824 1.72 7.712 1.904L6.872 3.304C6.704 3.592 6.336 3.68001 6.048 3.51201C5.76 3.34401 5.672 2.97599 5.84 2.68799L6.05601 2.32798C3.84801 2.84798 2.192 4.832 2.192 7.2C2.2 7.528 1.928 7.8 1.6 7.8Z"
        fill="#2179C4"
      />
      <path
        d="M14.1439 5.99995C14.0399 5.99995 13.9359 5.97597 13.8399 5.91997L10.6639 4.07993C10.3759 3.91193 10.2799 3.54395 10.4479 3.25595C10.6159 2.96795 10.9839 2.87194 11.2639 3.03994L14.1439 4.70395L16.9999 3.04795C17.2879 2.87995 17.6559 2.98396 17.8159 3.26396C17.9839 3.55196 17.8799 3.91994 17.5999 4.08794L14.4399 5.91196C14.3519 5.96796 14.2479 5.99995 14.1439 5.99995Z"
        fill="white"
        fill-opacity="0.7"
      />
      <path
        d="M14.1439 9.25576C13.8159 9.25576 13.5439 8.98376 13.5439 8.65576V5.39175C13.5439 5.06375 13.8159 4.79175 14.1439 4.79175C14.4719 4.79175 14.7439 5.06375 14.7439 5.39175V8.65576C14.7439 8.99176 14.4719 9.25576 14.1439 9.25576Z"
        fill="white"
        fill-opacity="0.7"
      />
      <path
        d="M14.1439 9.4C13.7759 9.4 13.3999 9.32001 13.1039 9.15201L11.1839 8.08799C10.5599 7.74399 10.0879 6.93603 10.0879 6.22403V4.192C10.0879 3.472 10.5599 2.67202 11.1919 2.32002L13.1119 1.25601C13.7039 0.92801 14.5919 0.92801 15.1919 1.25601L17.1119 2.32002C17.7359 2.66402 18.2079 3.47199 18.2079 4.18399V6.21602C18.2079 6.93602 17.7359 7.73598 17.1119 8.07998L15.1919 9.144C14.8799 9.32 14.5119 9.4 14.1439 9.4ZM13.6879 2.296L11.7679 3.36001C11.5279 3.49601 11.2879 3.90398 11.2879 4.17598V6.20801C11.2879 6.48801 11.5279 6.89603 11.7679 7.02403L13.6879 8.096C13.9199 8.224 14.3679 8.224 14.5999 8.096L16.5199 7.03199C16.7599 6.89599 16.9999 6.48802 16.9999 6.21602V4.18399C16.9999 3.90399 16.7599 3.49602 16.5199 3.36802L14.5999 2.30401C14.3679 2.16801 13.9119 2.168 13.6879 2.296Z"
        fill="white"
        fill-opacity="0.7"
      />
      <path
        d="M5.05602 14.8C4.95202 14.8 4.84801 14.776 4.75201 14.72L1.57601 12.88C1.28801 12.712 1.19201 12.344 1.36001 12.056C1.52801 11.768 1.89601 11.672 2.17601 11.84L5.05602 13.504L7.91201 11.848C8.20001 11.68 8.56801 11.784 8.72801 12.064C8.89601 12.352 8.79201 12.72 8.51201 12.888L5.35201 14.712C5.26401 14.768 5.16002 14.8 5.05602 14.8Z"
        fill="white"
        fill-opacity="0.7"
      />
      <path
        d="M5.05605 18.0558C4.72805 18.0558 4.45605 17.7838 4.45605 17.4558V14.1918C4.45605 13.8638 4.72805 13.5918 5.05605 13.5918C5.38405 13.5918 5.65605 13.8638 5.65605 14.1918V17.4558C5.65605 17.7918 5.39205 18.0558 5.05605 18.0558Z"
        fill="white"
        fill-opacity="0.7"
      />
      <path
        d="M5.05601 18.1999C4.68801 18.1999 4.312 18.1199 4.016 17.9519L2.096 16.8878C1.472 16.5438 1 15.7359 1 15.0239V12.9918C1 12.2718 1.472 11.4718 2.096 11.1278L4.016 10.0639C4.608 9.73587 5.504 9.73587 6.096 10.0639L8.016 11.1278C8.64 11.4718 9.112 12.2798 9.112 12.9918V15.0239C9.112 15.7439 8.64 16.5439 8.008 16.8959L6.088 17.9599C5.8 18.1199 5.43201 18.1999 5.05601 18.1999ZM4.6 11.0959L2.68 12.1599C2.44 12.2959 2.2 12.7038 2.2 12.9758V15.0079C2.2 15.2879 2.44 15.6959 2.68 15.8239L4.6 16.8878C4.832 17.0158 5.28 17.0158 5.512 16.8878L7.43199 15.8239C7.67199 15.6879 7.912 15.2799 7.912 15.0079V12.9758C7.912 12.6958 7.67199 12.2879 7.43199 12.1599L5.512 11.0878C5.288 10.9678 4.832 10.9679 4.6 11.0959Z"
        fill="white"
        fill-opacity="0.7"
      />
    </svg>
  );
}

export function UpdatedCargoReady() {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M9.99968 11.4398C9.89568 11.4398 9.79168 11.4159 9.69568 11.3599L2.63169 7.27187C2.34369 7.10387 2.24767 6.73585 2.41567 6.44785C2.58367 6.15985 2.94367 6.06383 3.23967 6.23183L9.99968 10.1438L16.7197 6.25586C17.0077 6.08786 17.3757 6.19187 17.5437 6.47187C17.7117 6.75987 17.6077 7.12785 17.3277 7.29585L10.3117 11.3599C10.2077 11.4079 10.1037 11.4398 9.99968 11.4398Z"
        fill="white"
      />
      <path
        d="M9.9999 18.6882C9.6719 18.6882 9.3999 18.4162 9.3999 18.0882V10.8322C9.3999 10.5042 9.6719 10.2322 9.9999 10.2322C10.3279 10.2322 10.5999 10.5042 10.5999 10.8322V18.0882C10.5999 18.4162 10.3279 18.6882 9.9999 18.6882Z"
        fill="white"
      />
      <path
        d="M9.99961 19C9.29561 19 8.59161 18.848 8.04761 18.536L3.77561 16.168C2.61561 15.528 1.70361 13.984 1.70361 12.656V8.12797C1.70361 6.79997 2.61561 5.26401 3.77561 4.61601L8.04761 2.24799C9.13561 1.63999 10.8476 1.63999 11.9436 2.24799L16.2156 4.61601C17.3756 5.25601 18.2876 6.79997 18.2876 8.12797V12.656C18.2876 12.712 18.2876 12.792 18.2636 12.896C18.2156 13.104 18.0636 13.272 17.8636 13.336C17.6636 13.4 17.4396 13.36 17.2796 13.216C16.3676 12.416 14.9436 12.384 13.9676 13.16C13.3516 13.648 12.9916 14.392 12.9916 15.184C12.9916 15.656 13.1196 16.12 13.3676 16.52C13.4316 16.632 13.4956 16.72 13.5676 16.8C13.6876 16.936 13.7356 17.12 13.7036 17.296C13.6716 17.472 13.5596 17.632 13.3996 17.712L11.9356 18.52C11.3996 18.848 10.7036 19 9.99961 19ZM9.99961 2.99999C9.50361 2.99999 8.9996 3.104 8.6396 3.304L4.3676 5.67202C3.5916 6.10402 2.9196 7.24797 2.9196 8.12797V12.656C2.9196 13.536 3.5996 14.688 4.3676 15.112L8.6396 17.48C9.3676 17.888 10.6396 17.888 11.3676 17.48L12.2636 16.984C11.9676 16.448 11.8076 15.824 11.8076 15.184C11.8076 14.016 12.3276 12.936 13.2316 12.216C14.3276 11.344 15.8796 11.16 17.0956 11.688V8.12001C17.0956 7.24001 16.4156 6.08801 15.6476 5.66401L11.3756 3.29599C10.9996 3.10399 10.4956 2.99999 9.99961 2.99999Z"
        fill="white"
      />
      <path
        d="M15.5998 19.0001C13.5038 19.0001 11.7998 17.2961 11.7998 15.2001C11.7998 14.0321 12.3198 12.9521 13.2238 12.2321C13.8958 11.6961 14.7438 11.4001 15.5998 11.4001C17.6958 11.4001 19.3998 13.1041 19.3998 15.2001C19.3998 16.2881 18.9278 17.3281 18.1038 18.0481C17.4078 18.6641 16.5198 19.0001 15.5998 19.0001ZM15.5998 12.6001C15.0078 12.6001 14.4478 12.8001 13.9758 13.1761C13.3598 13.6641 12.9998 14.4081 12.9998 15.2001C12.9998 16.6321 14.1678 17.8001 15.5998 17.8001C16.2238 17.8001 16.8318 17.5681 17.3198 17.1521C17.8798 16.6561 18.1998 15.9521 18.1998 15.2001C18.1998 13.7681 17.0318 12.6001 15.5998 12.6001Z"
        fill="#FFEE51"
      />
      <path
        d="M14.7999 16.6001C14.5999 16.6001 14.3999 16.4961 14.2879 16.3121C14.1199 16.0241 14.2079 15.6561 14.4959 15.4881L15.2079 15.0641V14.2001C15.2079 13.8721 15.4799 13.6001 15.8079 13.6001C16.1359 13.6001 16.4079 13.8721 16.4079 14.2001V15.4001C16.4079 15.6081 16.2959 15.8081 16.1199 15.9121L15.1199 16.5121C15.0079 16.5761 14.9039 16.6001 14.7999 16.6001Z"
        fill="#FFEE51"
      />
    </svg>
  );
}
export function InProgress() {
  return (
    <svg
      width="1.111vw"
      height="1.111vw"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect
        width="1.111vw"
        height="1.111vw"
        rx="5"
        fill="url(#paint0_linear_18457_7048)"
      />
      <path
        d="M9.5 13.375H6.5C3.785 13.375 2.625 12.215 2.625 9.5V6.5C2.625 3.785 3.785 2.625 6.5 2.625H9.5C12.215 2.625 13.375 3.785 13.375 6.5V9.5C13.375 12.215 12.215 13.375 9.5 13.375ZM6.5 3.375C4.195 3.375 3.375 4.195 3.375 6.5V9.5C3.375 11.805 4.195 12.625 6.5 12.625H9.5C11.805 12.625 12.625 11.805 12.625 9.5V6.5C12.625 4.195 11.805 3.375 9.5 3.375H6.5Z"
        fill="url(#paint1_linear_18457_7048)"
      />
      <path
        d="M8.0003 8.53985C7.9353 8.53985 7.8703 8.52485 7.8103 8.48985L5.16031 6.95985C4.98031 6.85485 4.9203 6.62485 5.0253 6.44985C5.1303 6.26985 5.36031 6.20985 5.53531 6.31485L7.9953 7.73985L10.4403 6.32485C10.6203 6.21985 10.8503 6.28485 10.9503 6.45985C11.0503 6.63485 10.9903 6.86985 10.8153 6.96985L8.1853 8.48985C8.1303 8.51985 8.0653 8.53985 8.0003 8.53985Z"
        fill="url(#paint2_linear_18457_7048)"
      />
      <path
        d="M8 11.26C7.795 11.26 7.625 11.09 7.625 10.885V8.16504C7.625 7.96004 7.795 7.79004 8 7.79004C8.205 7.79004 8.375 7.96004 8.375 8.16504V10.885C8.375 11.09 8.205 11.26 8 11.26Z"
        fill="url(#paint3_linear_18457_7048)"
      />
      <path
        d="M8.00012 11.3749C7.71012 11.3749 7.42513 11.3099 7.19513 11.1849L5.59512 10.2949C5.11512 10.0299 4.74512 9.3949 4.74512 8.8449V7.1499C4.74512 6.6049 5.12012 5.9699 5.59512 5.6999L7.19513 4.8099C7.65513 4.5549 8.34511 4.5549 8.80511 4.8099L10.4051 5.6999C10.8851 5.9649 11.2551 6.5999 11.2551 7.1499V8.8449C11.2551 9.3899 10.8801 10.0249 10.4051 10.2949L8.80511 11.1849C8.57511 11.3149 8.29012 11.3749 8.00012 11.3749ZM8.00012 5.3749C7.83512 5.3749 7.67512 5.4049 7.56012 5.4699L5.96013 6.3599C5.71513 6.4949 5.49512 6.8749 5.49512 7.1499V8.8449C5.49512 9.1249 5.71513 9.4999 5.96013 9.6349L7.56012 10.5249C7.79012 10.6549 8.21012 10.6549 8.44012 10.5249L10.0401 9.6349C10.2851 9.4999 10.5051 9.1199 10.5051 8.8449V7.1499C10.5051 6.8699 10.2851 6.4949 10.0401 6.3599L8.44012 5.4699C8.32512 5.4049 8.16512 5.3749 8.00012 5.3749Z"
        fill="url(#paint4_linear_18457_7048)"
      />
      <defs>
        <linearGradient
          id="paint0_linear_18457_7048"
          x1="1.111vw"
          y1="0.739496"
          x2="-1.36782"
          y2="15.2915"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="#1D4069" />
          <stop offset="1" stop-color="#266CBD" />
        </linearGradient>
        <linearGradient
          id="paint1_linear_18457_7048"
          x1="2.625"
          y1="8"
          x2="13.375"
          y2="8"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="#A4C9FF" />
          <stop offset="1" stop-color="#C4DCFF" />
        </linearGradient>
        <linearGradient
          id="paint2_linear_18457_7048"
          x1="4.97363"
          y1="7.40152"
          x2="10.9986"
          y2="7.40152"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="#A4C9FF" />
          <stop offset="1" stop-color="#C4DCFF" />
        </linearGradient>
        <linearGradient
          id="paint3_linear_18457_7048"
          x1="7.625"
          y1="9.52504"
          x2="8.375"
          y2="9.52504"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="#A4C9FF" />
          <stop offset="1" stop-color="#C4DCFF" />
        </linearGradient>
        <linearGradient
          id="paint4_linear_18457_7048"
          x1="4.74512"
          y1="7.99678"
          x2="11.2551"
          y2="7.99678"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="#A4C9FF" />
          <stop offset="1" stop-color="#C4DCFF" />
        </linearGradient>
      </defs>
    </svg>
  );
}

export function DashboardCardOrderIcon({ size }) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 14 14"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M11.7898 4.56151L7.29811 7.16318C7.11728 7.26818 6.88978 7.26818 6.70311 7.16318L2.21145 4.56151C1.89061 4.37484 1.80895 3.93734 2.05395 3.66318C2.22311 3.47068 2.41561 3.31318 2.61978 3.20234L5.78145 1.45234C6.45811 1.07318 7.55478 1.07318 8.23145 1.45234L11.3931 3.20234C11.5973 3.31318 11.7898 3.47651 11.9589 3.66318C12.1923 3.93734 12.1106 4.37484 11.7898 4.56151Z"
        fill="#4470E2"
      />
      <path
        d="M6.66843 8.24834V12.2267C6.66843 12.67 6.21926 12.9617 5.82259 12.7692C4.62092 12.18 2.59676 11.0775 2.59676 11.0775C1.88509 10.675 1.30176 9.66001 1.30176 8.82584V5.81584C1.30176 5.35501 1.78592 5.06334 2.18259 5.29084L6.37676 7.72334C6.55176 7.83418 6.66843 8.03251 6.66843 8.24834Z"
        fill="#4470E2"
      />
      <path
        d="M7.33203 8.24834V12.2267C7.33203 12.67 7.7812 12.9617 8.17787 12.7692C9.37953 12.18 11.4037 11.0775 11.4037 11.0775C12.1154 10.675 12.6987 9.66001 12.6987 8.82584V5.81584C12.6987 5.35501 12.2145 5.06334 11.8179 5.29084L7.6237 7.72334C7.4487 7.83418 7.33203 8.03251 7.33203 8.24834Z"
        fill="#4470E2"
      />
    </svg>
  );
}
DashboardCardOrderIcon.propTypes = {
  size: PropTypes.string,
};
DashboardCardOrderIcon.defaultProps = {
  size: '0.972vw',
};
export function CardEditIcon({ color, size }) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 25 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M2.67383 8.5H12.1738"
        stroke={color}
        strokeWidth="1.5"
        stroke-miterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M6.67383 16.5H8.67383"
        stroke={color}
        strokeWidth="1.5"
        stroke-miterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M11.1738 16.5H15.1738"
        stroke={color}
        strokeWidth="1.5"
        stroke-miterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M22.6738 12.03V16.11C22.6738 19.62 21.7838 20.5 18.2338 20.5H7.11383C3.56383 20.5 2.67383 19.62 2.67383 16.11V7.89C2.67383 4.38 3.56383 3.5 7.11383 3.5H15.1738"
        stroke={color}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M19.7541 4.13031L16.0441 7.84031C15.9041 7.98031 15.7641 8.26031 15.7341 8.46031L15.5341 9.88031C15.4641 10.3903 15.8241 10.7503 16.3341 10.6803L17.7541 10.4803C17.9541 10.4503 18.2341 10.3103 18.3741 10.1703L22.0841 6.46031C22.7241 5.82031 23.0241 5.08031 22.0841 4.14031C21.1341 3.19031 20.3941 3.49031 19.7541 4.13031Z"
        stroke={color}
        strokeWidth="1.5"
        stroke-miterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M19.2246 4.66016C19.5446 5.79016 20.4246 6.67016 21.5446 6.98016"
        stroke={color}
        strokeWidth="1.5"
        stroke-miterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}
CardEditIcon.propTypes = {
  color: PropTypes.string,
  size: PropTypes.string,
};
CardEditIcon.defaultProps = {
  color: '#ffffff',
  size: '1.736vw',
};
export function MyCompanyIcon({ color, width, height }) {
  return (
    <svg
      fill={color !== '' ? color : '#A6A6A6'}
      width={width}
      height={height}
      viewBox="0 0 24 24"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M22 22.75H2C1.59 22.75 1.25 22.41 1.25 22C1.25 21.59 1.59 21.25 2 21.25H22C22.41 21.25 22.75 21.59 22.75 22C22.75 22.41 22.41 22.75 22 22.75Z"
        fill="#A6A6A6"
      />
      <path
        d="M21 22.75H3C2.59 22.75 2.25 22.41 2.25 22V6C2.25 2.98 3.98 1.25 7 1.25H17C20.02 1.25 21.75 2.98 21.75 6V22C21.75 22.41 21.41 22.75 21 22.75ZM3.75 21.25H20.25V6C20.25 3.78 19.22 2.75 17 2.75H7C4.78 2.75 3.75 3.78 3.75 6V21.25Z"
        fill="#A6A6A6"
      />
      <path
        d="M10 17.25H7C6.59 17.25 6.25 16.91 6.25 16.5C6.25 16.09 6.59 15.75 7 15.75H10C10.41 15.75 10.75 16.09 10.75 16.5C10.75 16.91 10.41 17.25 10 17.25Z"
        fill="#A6A6A6"
      />
      <path
        d="M17 17.25H14C13.59 17.25 13.25 16.91 13.25 16.5C13.25 16.09 13.59 15.75 14 15.75H17C17.41 15.75 17.75 16.09 17.75 16.5C17.75 16.91 17.41 17.25 17 17.25Z"
        fill="#A6A6A6"
      />
      <path
        d="M10 12.75H7C6.59 12.75 6.25 12.41 6.25 12C6.25 11.59 6.59 11.25 7 11.25H10C10.41 11.25 10.75 11.59 10.75 12C10.75 12.41 10.41 12.75 10 12.75Z"
        fill="#A6A6A6"
      />
      <path
        d="M17 12.75H14C13.59 12.75 13.25 12.41 13.25 12C13.25 11.59 13.59 11.25 14 11.25H17C17.41 11.25 17.75 11.59 17.75 12C17.75 12.41 17.41 12.75 17 12.75Z"
        fill="#A6A6A6"
      />
      <path
        d="M10 8.25H7C6.59 8.25 6.25 7.91 6.25 7.5C6.25 7.09 6.59 6.75 7 6.75H10C10.41 6.75 10.75 7.09 10.75 7.5C10.75 7.91 10.41 8.25 10 8.25Z"
        fill="#A6A6A6"
      />
      <path
        d="M17 8.25H14C13.59 8.25 13.25 7.91 13.25 7.5C13.25 7.09 13.59 6.75 14 6.75H17C17.41 6.75 17.75 7.09 17.75 7.5C17.75 7.91 17.41 8.25 17 8.25Z"
        fill="#A6A6A6"
      />
    </svg>
  );
}
MyCompanyIcon.propTypes = {
  color: PropTypes.string,
  width: PropTypes.string,
  height: PropTypes.string,
};
MyCompanyIcon.defaultProps = {
  color: '',
  width: '',
  height: '',
};

export function DollerIcon({ color }) {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M8.67188 14.3298C8.67188 15.6198 9.66188 16.6598 10.8919 16.6598H13.4019C14.4719 16.6598 15.3419 15.7498 15.3419 14.6298C15.3419 13.4098 14.8119 12.9798 14.0219 12.6998L9.99187 11.2998C9.20187 11.0198 8.67188 10.5898 8.67188 9.36984C8.67188 8.24984 9.54187 7.33984 10.6119 7.33984H13.1219C14.3519 7.33984 15.3419 8.37984 15.3419 9.66984"
        stroke={color}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M12 6V18"
        stroke={color}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M12 22C17.5228 22 22 17.5228 22 12C22 6.47715 17.5228 2 12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22Z"
        stroke={color}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}
DollerIcon.propTypes = {
  color: PropTypes.string,
};
DollerIcon.defaultProps = {
  color: '#292D32',
};

export function HQ({ position, left, top }) {
  const svgStyle = {
    position: position || 'absolute',
    left: left || '0',
    top: top || '0',
  };

  return (
    <svg
      width="1.389vw"
      height="1.389vw"
      viewBox="0 0 20 20"
      fill="none"
      style={svgStyle}
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M0 10C0 5.28595 -1.19209e-07 2.92893 1.46447 1.46447C2.92893 -1.19209e-07 5.28595 0 10 0C14.714 0 17.0711 -1.19209e-07 18.5355 1.46447C20 2.92893 20 5.28595 20 10C20 14.714 20 17.0711 18.5355 18.5355C17.0711 20 14.714 20 10 20C5.28595 20 2.92893 20 1.46447 18.5355C-1.19209e-07 17.0711 0 14.714 0 10ZM4.75 6C4.75 5.58579 4.41421 5.25 4 5.25C3.58579 5.25 3.25 5.58579 3.25 6V13.619C3.25 14.0333 3.58579 14.369 4 14.369C4.41421 14.369 4.75 14.0333 4.75 13.619V10.75H8.0648V13.619C8.0648 14.0333 8.4006 14.369 8.8148 14.369C9.229 14.369 9.5648 14.0333 9.5648 13.619V6C9.5648 5.58579 9.229 5.25 8.8148 5.25C8.4006 5.25 8.0648 5.58579 8.0648 6V9.25H4.75V6ZM14.0472 5.24999L14.1111 5.25L14.175 5.24999C14.5604 5.24988 14.8396 5.2498 15.0849 5.2884C16.0575 5.44147 16.964 6.06957 17.2089 7.04367C17.2693 7.28415 17.269 7.55224 17.2686 7.83606L17.2685 7.90476V11.7143L17.2686 11.783C17.269 12.0668 17.2693 12.3349 17.2089 12.5754C17.1655 12.7478 17.1015 12.9094 17.0199 13.0594L17.4654 13.4118C17.7902 13.6688 17.8452 14.1405 17.5882 14.4654C17.3312 14.7902 16.8595 14.8452 16.5346 14.5882L15.8958 14.0827C15.6405 14.2028 15.3655 14.2865 15.0849 14.3306C14.8396 14.3693 14.5604 14.3692 14.175 14.3691L14.1111 14.369L14.0472 14.3691C13.6619 14.3692 13.3826 14.3693 13.1373 14.3306C12.1647 14.1776 11.2582 13.5495 11.0133 12.5754C10.9529 12.3349 10.9533 12.0668 10.9536 11.783L10.9537 11.7143V7.90476L10.9536 7.83607C10.9533 7.55225 10.9529 7.28415 11.0133 7.04367C11.2582 6.06957 12.1647 5.44147 13.1373 5.2884C13.3826 5.2498 13.6619 5.24988 14.0472 5.24999ZM15.7656 12.0669L15.5394 11.888C15.2146 11.631 14.7429 11.686 14.4859 12.0108C14.2852 12.2645 14.2748 12.6077 14.4345 12.8683C14.3471 12.8689 14.2412 12.869 14.1111 12.869C13.635 12.869 13.4839 12.8667 13.3705 12.8489C12.8151 12.7615 12.5271 12.4445 12.4681 12.2097C12.4594 12.1751 12.4537 12.1131 12.4537 11.7143V7.90476C12.4537 7.50598 12.4594 7.44399 12.4681 7.40939C12.5271 7.17452 12.8151 6.85757 13.3705 6.77016C13.4839 6.75231 13.635 6.75 14.1111 6.75C14.5873 6.75 14.7383 6.75231 14.8517 6.77016C15.4071 6.85757 15.6951 7.17452 15.7541 7.40939C15.7628 7.44399 15.7685 7.50598 15.7685 7.90476V11.7143C15.7685 11.8861 15.7675 11.9954 15.7656 12.0669Z"
        fill="url(#paint0_linear_23866_109060)"
      />
      <defs>
        <linearGradient
          id="paint0_linear_23866_109060"
          x1="10"
          y1="0"
          x2="10"
          y2="20"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#F0DB90" />
          <stop offset="1" stopColor="#FAA500" />
        </linearGradient>
      </defs>
    </svg>
  );
}
HQ.propTypes = {
  position: PropTypes.string,
  left: PropTypes.string,
  top: PropTypes.string,
};
HQ.defaultProps = {
  position: '',
  left: '',
  top: '',
};
export function GreenTickCircle() {
  return (
    <svg
      width="1.667vw"
      height="1.667vw"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M12 2C6.49 2 2 6.49 2 12C2 17.51 6.49 22 12 22C17.51 22 22 17.51 22 12C22 6.49 17.51 2 12 2ZM16.78 9.7L11.11 15.37C10.97 15.51 10.78 15.59 10.58 15.59C10.38 15.59 10.19 15.51 10.05 15.37L7.22 12.54C6.93 12.25 6.93 11.77 7.22 11.48C7.51 11.19 7.99 11.19 8.28 11.48L10.58 13.78L15.72 8.64C16.01 8.35 16.49 8.35 16.78 8.64C17.07 8.93 17.07 9.4 16.78 9.7Z"
        fill="#55B938"
      />
    </svg>
  );
}
export function CategoryIcon() {
  return (
    <svg
      width="1.25vw"
      height="1.25vw"
      viewBox="0 0 18 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M14.25 8.0625H12.75C10.935 8.0625 9.9375 7.065 9.9375 5.25V3.75C9.9375 1.935 10.935 0.9375 12.75 0.9375H14.25C16.065 0.9375 17.0625 1.935 17.0625 3.75V5.25C17.0625 7.065 16.065 8.0625 14.25 8.0625ZM12.75 2.0625C11.565 2.0625 11.0625 2.565 11.0625 3.75V5.25C11.0625 6.435 11.565 6.9375 12.75 6.9375H14.25C15.435 6.9375 15.9375 6.435 15.9375 5.25V3.75C15.9375 2.565 15.435 2.0625 14.25 2.0625H12.75Z"
        fill="#616B80"
      />
      <path
        d="M5.25 17.0625H3.75C1.935 17.0625 0.9375 16.065 0.9375 14.25V12.75C0.9375 10.935 1.935 9.9375 3.75 9.9375H5.25C7.065 9.9375 8.0625 10.935 8.0625 12.75V14.25C8.0625 16.065 7.065 17.0625 5.25 17.0625ZM3.75 11.0625C2.565 11.0625 2.0625 11.565 2.0625 12.75V14.25C2.0625 15.435 2.565 15.9375 3.75 15.9375H5.25C6.435 15.9375 6.9375 15.435 6.9375 14.25V12.75C6.9375 11.565 6.435 11.0625 5.25 11.0625H3.75Z"
        fill="#616B80"
      />
      <path
        d="M4.5 8.0625C2.535 8.0625 0.9375 6.465 0.9375 4.5C0.9375 2.535 2.535 0.9375 4.5 0.9375C6.465 0.9375 8.0625 2.535 8.0625 4.5C8.0625 6.465 6.465 8.0625 4.5 8.0625ZM4.5 2.0625C3.1575 2.0625 2.0625 3.1575 2.0625 4.5C2.0625 5.8425 3.1575 6.9375 4.5 6.9375C5.8425 6.9375 6.9375 5.8425 6.9375 4.5C6.9375 3.1575 5.8425 2.0625 4.5 2.0625Z"
        fill="#616B80"
      />
      <path
        d="M13.5 17.0625C11.535 17.0625 9.9375 15.465 9.9375 13.5C9.9375 11.535 11.535 9.9375 13.5 9.9375C15.465 9.9375 17.0625 11.535 17.0625 13.5C17.0625 15.465 15.465 17.0625 13.5 17.0625ZM13.5 11.0625C12.1575 11.0625 11.0625 12.1575 11.0625 13.5C11.0625 14.8425 12.1575 15.9375 13.5 15.9375C14.8425 15.9375 15.9375 14.8425 15.9375 13.5C15.9375 12.1575 14.8425 11.0625 13.5 11.0625Z"
        fill="#616B80"
      />
    </svg>
  );
}
export function RedInfoCircle() {
  return (
    <svg
      width="1.667vw"
      height="1.667vw"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M12 2C6.49 2 2 6.49 2 12C2 17.51 6.49 22 12 22C17.51 22 22 17.51 22 12C22 6.49 17.51 2 12 2ZM11.25 8C11.25 7.59 11.59 7.25 12 7.25C12.41 7.25 12.75 7.59 12.75 8V13C12.75 13.41 12.41 13.75 12 13.75C11.59 13.75 11.25 13.41 11.25 13V8ZM12.92 16.38C12.87 16.51 12.8 16.61 12.71 16.71C12.61 16.8 12.5 16.87 12.38 16.92C12.26 16.97 12.13 17 12 17C11.87 17 11.74 16.97 11.62 16.92C11.5 16.87 11.39 16.8 11.29 16.71C11.2 16.61 11.13 16.51 11.08 16.38C11.03 16.26 11 16.13 11 16C11 15.87 11.03 15.74 11.08 15.62C11.13 15.5 11.2 15.39 11.29 15.29C11.39 15.2 11.5 15.13 11.62 15.08C11.86 14.98 12.14 14.98 12.38 15.08C12.5 15.13 12.61 15.2 12.71 15.29C12.8 15.39 12.87 15.5 12.92 15.62C12.97 15.74 13 15.87 13 16C13 16.13 12.97 16.26 12.92 16.38Z"
        fill="#D2253B"
      />
    </svg>
  );
}
export function LoaderCircle() {
  return (
    <svg
      width="1.667vw"
      height="1.667vw"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M20.2656 17.1145C20.2656 17.1507 20.28 17.1854 20.3056 17.211C20.3312 17.2366 20.3659 17.251 20.4021 17.251C20.4383 17.251 20.4731 17.2366 20.4987 17.211C20.5243 17.1854 20.5386 17.1507 20.5386 17.1145C20.5386 17.0783 20.5243 17.0436 20.4987 17.018C20.4731 16.9924 20.4383 16.978 20.4021 16.978C20.3659 16.978 20.3312 16.9924 20.3056 17.018C20.28 17.0436 20.2656 17.0783 20.2656 17.1145ZM17.2521 20.224C17.2521 20.296 17.2807 20.3651 17.3317 20.416C17.3826 20.4669 17.4516 20.4955 17.5236 20.4955C17.5956 20.4955 17.6647 20.4669 17.7156 20.416C17.7665 20.3651 17.7951 20.296 17.7951 20.224C17.7951 20.152 17.7665 20.083 17.7156 20.032C17.6647 19.9811 17.5956 19.9525 17.5236 19.9525C17.4516 19.9525 17.3826 19.9811 17.3317 20.032C17.2807 20.083 17.2521 20.152 17.2521 20.224ZM13.1901 21.8245C13.1901 21.9327 13.2331 22.0365 13.3096 22.113C13.3862 22.1895 13.4899 22.2325 13.5981 22.2325C13.7063 22.2325 13.8101 22.1895 13.8866 22.113C13.9632 22.0365 14.0061 21.9327 14.0061 21.8245C14.0061 21.7709 13.9956 21.7179 13.9751 21.6684C13.9546 21.6189 13.9245 21.5739 13.8866 21.536C13.8488 21.4981 13.8038 21.4681 13.7543 21.4476C13.7048 21.4271 13.6517 21.4165 13.5981 21.4165C13.5446 21.4165 13.4915 21.4271 13.442 21.4476C13.3925 21.4681 13.3475 21.4981 13.3096 21.536C13.2718 21.5739 13.2417 21.6189 13.2212 21.6684C13.2007 21.7179 13.1901 21.7709 13.1901 21.8245ZM8.81764 21.61C8.81764 21.754 8.87485 21.8921 8.97668 21.994C9.07851 22.0958 9.21663 22.153 9.36064 22.153C9.50465 22.153 9.64277 22.0958 9.7446 21.994C9.84643 21.8921 9.90364 21.754 9.90364 21.61C9.90364 21.466 9.84643 21.3279 9.7446 21.2261C9.64277 21.1242 9.50465 21.067 9.36064 21.067C9.21663 21.067 9.07851 21.1242 8.97668 21.2261C8.87485 21.3279 8.81764 21.466 8.81764 21.61ZM4.93864 19.6195C4.93864 19.7087 4.95622 19.7971 4.99036 19.8795C5.02451 19.962 5.07456 20.0369 5.13766 20.1C5.20076 20.1631 5.27567 20.2131 5.35811 20.2473C5.44055 20.2814 5.52891 20.299 5.61814 20.299C5.70737 20.299 5.79573 20.2814 5.87817 20.2473C5.96062 20.2131 6.03552 20.1631 6.09862 20.1C6.16172 20.0369 6.21177 19.962 6.24592 19.8795C6.28007 19.7971 6.29764 19.7087 6.29764 19.6195C6.29764 19.5303 6.28007 19.4419 6.24592 19.3595C6.21177 19.277 6.16172 19.2021 6.09862 19.139C6.03552 19.0759 5.96062 19.0259 5.87817 18.9917C5.79573 18.9576 5.70737 18.94 5.61814 18.94C5.52891 18.94 5.44055 18.9576 5.35811 18.9917C5.27567 19.0259 5.20076 19.0759 5.13766 19.139C5.07456 19.2021 5.02451 19.277 4.99036 19.3595C4.95622 19.4419 4.93864 19.5303 4.93864 19.6195ZM2.25214 16.2355C2.25214 16.4519 2.33811 16.6595 2.49114 16.8125C2.64417 16.9655 2.85172 17.0515 3.06814 17.0515C3.28456 17.0515 3.49211 16.9655 3.64514 16.8125C3.79817 16.6595 3.88414 16.4519 3.88414 16.2355C3.88414 16.0191 3.79817 15.8115 3.64514 15.6585C3.49211 15.5055 3.28456 15.4195 3.06814 15.4195C2.85172 15.4195 2.64417 15.5055 2.49114 15.6585C2.33811 15.8115 2.25214 16.0191 2.25214 16.2355ZM1.24414 12.0805C1.24414 12.2054 1.26874 12.3291 1.31653 12.4444C1.36432 12.5598 1.43437 12.6647 1.52268 12.753C1.61099 12.8413 1.71583 12.9113 1.83121 12.9591C1.94659 13.0069 2.07025 13.0315 2.19514 13.0315C2.32003 13.0315 2.44369 13.0069 2.55907 12.9591C2.67445 12.9113 2.77929 12.8413 2.8676 12.753C2.95591 12.6647 3.02596 12.5598 3.07375 12.4444C3.12154 12.3291 3.14614 12.2054 3.14614 12.0805C3.14614 11.8283 3.04595 11.5864 2.8676 11.4081C2.68925 11.2297 2.44736 11.1295 2.19514 11.1295C1.94292 11.1295 1.70103 11.2297 1.52268 11.4081C1.34434 11.5864 1.24414 11.8283 1.24414 12.0805ZM2.07364 7.95252C2.07364 8.09533 2.10177 8.23674 2.15642 8.36868C2.21107 8.50063 2.29118 8.62051 2.39216 8.72149C2.49315 8.82248 2.61303 8.90258 2.74497 8.95723C2.87691 9.01189 3.01833 9.04002 3.16114 9.04002C3.44956 9.04002 3.72617 8.92544 3.93012 8.72149C4.13407 8.51755 4.24864 8.24094 4.24864 7.95252C4.24864 7.66409 4.13407 7.38748 3.93012 7.18354C3.72617 6.97959 3.44956 6.86502 3.16114 6.86502C2.87272 6.86502 2.59611 6.97959 2.39216 7.18354C2.18822 7.38748 2.07364 7.66409 2.07364 7.95252ZM4.56214 4.62402C4.56214 4.78475 4.5938 4.94392 4.65531 5.09242C4.71682 5.24092 4.80698 5.37586 4.92064 5.48951C5.0343 5.60317 5.16923 5.69333 5.31774 5.75484C5.46624 5.81636 5.6254 5.84802 5.78614 5.84802C5.94688 5.84802 6.10604 5.81636 6.25455 5.75484C6.40305 5.69333 6.53798 5.60317 6.65164 5.48951C6.7653 5.37586 6.85546 5.24092 6.91697 5.09242C6.97848 4.94392 7.01014 4.78475 7.01014 4.62402C7.01014 4.29939 6.88118 3.98806 6.65164 3.75852C6.42209 3.52897 6.11077 3.40002 5.78614 3.40002C5.46152 3.40002 5.15019 3.52897 4.92064 3.75852C4.6911 3.98806 4.56214 4.29939 4.56214 4.62402ZM8.21614 2.71752C8.21614 2.89598 8.25129 3.0727 8.31959 3.23758C8.38788 3.40246 8.48799 3.55228 8.61418 3.67847C8.74038 3.80467 8.89019 3.90477 9.05507 3.97307C9.21996 4.04136 9.39667 4.07652 9.57514 4.07652C9.93557 4.07652 10.2812 3.93334 10.5361 3.67847C10.791 3.42361 10.9341 3.07794 10.9341 2.71752C10.9341 2.35709 10.791 2.01142 10.5361 1.75656C10.2812 1.5017 9.93557 1.35852 9.57514 1.35852C9.21471 1.35852 8.86904 1.5017 8.61418 1.75656C8.35932 2.01142 8.21614 2.35709 8.21614 2.71752ZM12.3201 2.59902C12.3201 2.99565 12.4777 3.37603 12.7582 3.65649C13.0386 3.93695 13.419 4.09452 13.8156 4.09452C14.2123 4.09452 14.5927 3.93695 14.8731 3.65649C15.1536 3.37603 15.3111 2.99565 15.3111 2.59902C15.3111 2.20238 15.1536 1.822 14.8731 1.54154C14.5927 1.26108 14.2123 1.10352 13.8156 1.10352C13.419 1.10352 13.0386 1.26108 12.7582 1.54154C12.4777 1.822 12.3201 2.20238 12.3201 2.59902ZM16.0776 4.28952C16.0776 4.72195 16.2494 5.13668 16.5552 5.44245C16.861 5.74823 17.2757 5.92002 17.7081 5.92002C18.1406 5.92002 18.5553 5.74823 18.8611 5.44245C19.1669 5.13668 19.3386 4.72195 19.3386 4.28952C19.3386 3.85708 19.1669 3.44236 18.8611 3.13658C18.5553 2.8308 18.1406 2.65902 17.7081 2.65902C17.2757 2.65902 16.861 2.8308 16.5552 3.13658C16.2494 3.44236 16.0776 3.85708 16.0776 4.28952ZM18.7476 7.46502C18.7476 7.69706 18.7933 7.92684 18.8821 8.14122C18.9709 8.3556 19.1011 8.55039 19.2652 8.71447C19.4293 8.87855 19.6241 9.00871 19.8384 9.09751C20.0528 9.18631 20.2826 9.23202 20.5146 9.23202C20.7467 9.23202 20.9765 9.18631 21.1908 9.09751C21.4052 9.00871 21.6 8.87855 21.7641 8.71447C21.9282 8.55039 22.0583 8.3556 22.1471 8.14122C22.2359 7.92684 22.2816 7.69706 22.2816 7.46502C22.2816 7.23297 22.2359 7.0032 22.1471 6.78881C22.0583 6.57443 21.9282 6.37964 21.7641 6.21556C21.6 6.05148 21.4052 5.92132 21.1908 5.83252C20.9765 5.74372 20.7467 5.69802 20.5146 5.69802C20.2826 5.69802 20.0528 5.74372 19.8384 5.83252C19.6241 5.92132 19.4293 6.05148 19.2652 6.21556C19.1011 6.37964 18.9709 6.57443 18.8821 6.78881C18.7933 7.0032 18.7476 7.23297 18.7476 7.46502ZM19.8096 11.578C19.8096 11.828 19.8589 12.0755 19.9545 12.3065C20.0502 12.5374 20.1904 12.7472 20.3672 12.924C20.5439 13.1007 20.7538 13.241 20.9847 13.3366C21.2156 13.4323 21.4632 13.4815 21.7131 13.4815C22.218 13.4815 22.7021 13.281 23.0591 12.924C23.4161 12.567 23.6166 12.0829 23.6166 11.578C23.6166 11.0732 23.4161 10.589 23.0591 10.232C22.7021 9.87506 22.218 9.67451 21.7131 9.67451C21.2083 9.67451 20.7241 9.87506 20.3672 10.232C20.0102 10.589 19.8096 11.0732 19.8096 11.578Z"
        fill="#2179C4"
      />
    </svg>
  );
}
export function Copiedbtn() {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      class="icon-sm"
    >
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M18.0633 5.67375C18.5196 5.98487 18.6374 6.607 18.3262 7.06331L10.8262 18.0633C10.6585 18.3093 10.3898 18.4678 10.0934 18.4956C9.79688 18.5234 9.50345 18.4176 9.29289 18.2071L4.79289 13.7071C4.40237 13.3166 4.40237 12.6834 4.79289 12.2929C5.18342 11.9023 5.81658 11.9023 6.20711 12.2929L9.85368 15.9394L16.6738 5.93664C16.9849 5.48033 17.607 5.36263 18.0633 5.67375Z"
        fill="currentColor"
      />
    </svg>
  );
}
export function Copybtn() {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      class="icon-sm"
    >
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M12 4C10.8954 4 10 4.89543 10 6H14C14 4.89543 13.1046 4 12 4ZM8.53513 4C9.22675 2.8044 10.5194 2 12 2C13.4806 2 14.7733 2.8044 15.4649 4H17C18.6569 4 20 5.34315 20 7V19C20 20.6569 18.6569 22 17 22H7C5.34315 22 4 20.6569 4 19V7C4 5.34315 5.34315 4 7 4H8.53513ZM8 6H7C6.44772 6 6 6.44772 6 7V19C6 19.5523 6.44772 20 7 20H17C17.5523 20 18 19.5523 18 19V7C18 6.44772 17.5523 6 17 6H16C16 7.10457 15.1046 8 14 8H10C8.89543 8 8 7.10457 8 6Z"
        fill="currentColor"
      />
    </svg>
  );
}
export function HierarchyIcon() {
  return (
    <svg
      width="10"
      height="10"
      viewBox="0 0 10 10"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M4.0625 8.33398C4.0625 8.85175 4.48223 9.27148 5 9.27148C5.51777 9.27148 5.9375 8.85175 5.9375 8.33398C5.9375 7.81622 5.51777 7.39648 5 7.39648C4.48223 7.39648 4.0625 7.81622 4.0625 8.33398Z"
        fill="#455F7D"
      />
      <path
        d="M7.39575 8.33398C7.39575 8.85175 7.81549 9.27148 8.33325 9.27148C8.85102 9.27148 9.27075 8.85175 9.27075 8.33398C9.27075 7.81622 8.85102 7.39648 8.33325 7.39648C7.81549 7.39648 7.39575 7.81622 7.39575 8.33398Z"
        fill="#455F7D"
      />
      <path
        d="M0.729248 8.33398C0.729248 8.85175 1.14898 9.27148 1.66675 9.27148C2.18452 9.27148 2.60425 8.85175 2.60425 8.33398C2.60425 7.81622 2.18452 7.39648 1.66675 7.39648C1.14898 7.39648 0.729248 7.81622 0.729248 8.33398Z"
        fill="#455F7D"
      />
      <path
        d="M4.0625 1.66602C4.0625 2.18378 4.48223 2.60352 5 2.60352C5.51777 2.60352 5.9375 2.18378 5.9375 1.66602C5.9375 1.14825 5.51777 0.728516 5 0.728516C4.48223 0.728516 4.0625 1.14825 4.0625 1.66602Z"
        fill="#455F7D"
      />
      <path
        d="M4.68742 7.91732C4.68742 8.08815 4.82909 8.22982 4.99992 8.22982C5.17075 8.22982 5.31242 8.08815 5.31242 7.91732V4.89648H7.08325C7.74159 4.89648 8.02075 5.17565 8.02075 5.83398V7.91732C8.02075 8.08815 8.16242 8.22982 8.33325 8.22982C8.50409 8.22982 8.64575 8.08815 8.64575 7.91732V5.83398C8.64575 4.82565 8.09159 4.27148 7.08325 4.27148H5.31242V2.08398C5.31242 1.91315 5.17075 1.77148 4.99992 1.77148C4.82909 1.77148 4.68742 1.91315 4.68742 2.08398V4.27148H2.91659C1.90825 4.27148 1.35409 4.82565 1.35409 5.83398V7.91732C1.35409 8.08815 1.49575 8.22982 1.66659 8.22982C1.83742 8.22982 1.97909 8.08815 1.97909 7.91732V5.83398C1.97909 5.17565 2.25825 4.89648 2.91659 4.89648H4.68742V7.91732Z"
        fill="#455F7D"
      />
    </svg>
  );
}
export function AddContact() {
  return (
    <svg
      width="10"
      height="11"
      viewBox="0 0 10 11"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M3.75016 1.33398C2.6585 1.33398 1.771 2.22148 1.771 3.31315C1.771 4.38398 2.6085 5.25065 3.70016 5.28815C3.7335 5.28398 3.76683 5.28398 3.79183 5.28815C3.80016 5.28815 3.80433 5.28815 3.81266 5.28815C3.81683 5.28815 3.81683 5.28815 3.821 5.28815C4.88766 5.25065 5.72516 4.38398 5.72933 3.31315C5.72933 2.22148 4.84183 1.33398 3.75016 1.33398Z"
        fill="#455F7D"
      />
      <path
        d="M5.86689 6.3957C4.70439 5.6207 2.80856 5.6207 1.63773 6.3957C1.10856 6.74987 0.816895 7.22904 0.816895 7.74154C0.816895 8.25404 1.10856 8.72904 1.63356 9.07904C2.21689 9.4707 2.98356 9.66654 3.75023 9.66654C4.51689 9.66654 5.28356 9.4707 5.86689 9.07904C6.39189 8.72487 6.68356 8.24987 6.68356 7.7332C6.67939 7.2207 6.39189 6.7457 5.86689 6.3957Z"
        fill="#455F7D"
      />
      <path
        d="M8.32939 3.55756C8.39606 4.36589 7.82106 5.07423 7.02523 5.17006C7.02106 5.17006 7.02106 5.17006 7.01689 5.17006H7.00439C6.97939 5.17006 6.95439 5.17006 6.93356 5.17839C6.52939 5.19923 6.15856 5.07006 5.87939 4.83256C6.30856 4.44923 6.55439 3.87423 6.50439 3.24923C6.47523 2.91173 6.35856 2.60339 6.18356 2.34089C6.34189 2.26173 6.52523 2.21173 6.71273 2.19506C7.52939 2.12423 8.25856 2.73256 8.32939 3.55756Z"
        fill="#455F7D"
      />
      <path
        d="M9.16243 7.41332C9.1291 7.81748 8.87077 8.16748 8.43743 8.40498C8.02077 8.63415 7.49577 8.74248 6.97493 8.72998C7.27493 8.45915 7.44993 8.12165 7.48327 7.76332C7.52493 7.24665 7.2791 6.75082 6.78744 6.35498C6.50827 6.13415 6.18327 5.95915 5.8291 5.82998C6.74993 5.56332 7.90827 5.74248 8.62077 6.31748C9.0041 6.62582 9.19993 7.01332 9.16243 7.41332Z"
        fill="#455F7D"
      />
    </svg>
  );
}
export function DandDFreeIcon() {
  return (
    <svg
      width="1.667vw"
      height="1.667vw"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M20.8324 11.9605L12 7.54414L3.16763 11.9605L2.832 11.2896L11.832 6.78964C11.8841 6.76357 11.9416 6.75 11.9998 6.75C12.0581 6.75 12.1155 6.76357 12.1676 6.78964L21.1676 11.2896L20.8324 11.9605Z"
        fill="#E6E6E6"
      />
      <path
        d="M10.311 7.55003L2.83238 11.2892L3.16801 11.96L10.7745 8.15678C10.58 7.98848 10.4222 7.78195 10.311 7.55003ZM11.5403 7.77391L12 7.54403L12.4598 7.77391C12.708 7.66169 12.9072 7.4635 13.0208 7.2159L12.1676 6.78915C12.1155 6.76308 12.0581 6.74951 11.9998 6.74951C11.9416 6.74951 11.8841 6.76308 11.832 6.78915L10.9789 7.2159C11.0925 7.4634 11.292 7.66216 11.5403 7.77391ZM21.1676 11.2892L13.6886 7.54965C13.5776 7.78168 13.4199 7.98835 13.2255 8.15678L20.832 11.96L21.1676 11.2892Z"
        fill="#E6E6E6"
      />
      <path
        d="M12 7.875C11.8358 7.875 11.6809 7.83788 11.5403 7.77413L10.7745 8.157C11.1038 8.44463 11.5294 8.625 12 8.625C12.4706 8.625 12.8963 8.44463 13.2259 8.15738L12.4601 7.7745C12.3156 7.8403 12.1588 7.87456 12 7.875ZM10.875 6.75C10.875 6.12975 11.3797 5.625 12 5.625C12.0995 5.625 12.1948 5.58549 12.2652 5.51516C12.3355 5.44484 12.375 5.34946 12.375 5.25V2.625C12.375 2.52554 12.3355 2.43016 12.2652 2.35984C12.1948 2.28951 12.0995 2.25 12 2.25C11.9005 2.25 11.8052 2.28951 11.7348 2.35984C11.6645 2.43016 11.625 2.52554 11.625 2.625V4.91287C11.2018 4.9999 10.8216 5.23012 10.5484 5.56476C10.2752 5.8994 10.1256 6.31799 10.125 6.75C10.125 7.03725 10.1951 7.3065 10.311 7.55025L10.9789 7.21613C10.911 7.07008 10.8755 6.91106 10.875 6.75ZM13.875 6.75C13.875 6.65054 13.8355 6.55516 13.7652 6.48483C13.6948 6.41451 13.5995 6.375 13.5 6.375C13.4005 6.375 13.3052 6.41451 13.2348 6.48483C13.1645 6.55516 13.125 6.65054 13.125 6.75C13.125 6.91687 13.0864 7.07363 13.0208 7.21613L13.6886 7.55025C13.8049 7.3065 13.875 7.03725 13.875 6.75Z"
        fill="#4D4D4D"
      />
      <path
        d="M13.689 7.55043L13.0211 7.21631C12.9077 7.46399 12.7084 7.66221 12.4601 7.77431L13.2259 8.15718C13.4202 7.98877 13.5778 7.78225 13.689 7.55043Z"
        fill="#4D4D4D"
      />
      <path d="M1.5 12.375H22.5V21.375H1.5V12.375Z" fill="#32D4AE" />
      <path
        d="M1.125 10.875H22.875V12.375H1.125V10.875ZM1.125 21.375H22.875V22.875H1.125V21.375Z"
        fill="#28AC8D"
      />
      <path
        d="M12.75 2.625H11.25C11.1505 2.625 11.0552 2.58549 10.9848 2.51516C10.9145 2.44484 10.875 2.34946 10.875 2.25V1.125H13.125V2.25C13.125 2.34946 13.0855 2.44484 13.0152 2.51516C12.9448 2.58549 12.8495 2.625 12.75 2.625Z"
        fill="#666666"
      />
      <path
        d="M13.875 1.5H10.125C10.0255 1.5 9.93016 1.46049 9.85983 1.39017C9.78951 1.31984 9.75 1.22446 9.75 1.125C9.75 1.02554 9.78951 0.930161 9.85983 0.859835C9.93016 0.789509 10.0255 0.75 10.125 0.75H13.875C13.9745 0.75 14.0698 0.789509 14.1402 0.859835C14.2105 0.930161 14.25 1.02554 14.25 1.125C14.25 1.22446 14.2105 1.31984 14.1402 1.39017C14.0698 1.46049 13.9745 1.5 13.875 1.5Z"
        fill="#4D4D4D"
      />
      <path
        d="M7.875 20.4565C5.62238 20.4565 3.47288 20.2311 1.5 19.825V21.3749H22.5V16.2666C19.4505 18.7821 14.0422 20.4565 7.875 20.4565Z"
        fill="#2DBF93"
      />
      <path
        d="M7.5 20.25H6.75V13.875C6.75 13.7755 6.78951 13.6802 6.85983 13.6098C6.93016 13.5395 7.02554 13.5 7.125 13.5H7.875V14.25H7.5V20.25ZM5.625 20.25H4.875V13.875C4.875 13.7755 4.91451 13.6802 4.98484 13.6098C5.05516 13.5395 5.15054 13.5 5.25 13.5H6V14.25H5.625V20.25ZM3.75 20.25H3V13.875C3 13.7755 3.03951 13.6802 3.10984 13.6098C3.18016 13.5395 3.27554 13.5 3.375 13.5H4.125V14.25H3.75V20.25ZM9.375 20.25H8.625V13.875C8.625 13.7755 8.66451 13.6802 8.73483 13.6098C8.80516 13.5395 8.90054 13.5 9 13.5H9.75V14.25H9.375V20.25ZM11.25 20.25H10.5V13.875C10.5 13.7755 10.5395 13.6802 10.6098 13.6098C10.6802 13.5395 10.7755 13.5 10.875 13.5H11.625V14.25H11.25V20.25ZM13.125 20.25H12.375V13.875C12.375 13.7755 12.4145 13.6802 12.4848 13.6098C12.5552 13.5395 12.6505 13.5 12.75 13.5H13.5V14.25H13.125V20.25ZM15 20.25H14.25V13.875C14.25 13.7755 14.2895 13.6802 14.3598 13.6098C14.4302 13.5395 14.5255 13.5 14.625 13.5H15.375V14.25H15V20.25ZM16.875 20.25H16.125V13.875C16.125 13.7755 16.1645 13.6802 16.2348 13.6098C16.3052 13.5395 16.4005 13.5 16.5 13.5H17.25V14.25H16.875V20.25ZM18.75 20.25H18V13.875C18 13.7755 18.0395 13.6802 18.1098 13.6098C18.1802 13.5395 18.2755 13.5 18.375 13.5H19.125V14.25H18.75V20.25ZM20.625 20.25H19.875V13.875C19.875 13.7755 19.9145 13.6802 19.9848 13.6098C20.0552 13.5395 20.1505 13.5 20.25 13.5H21V14.25H20.625V20.25Z"
        fill="#28AA8A"
      />
    </svg>
  );
}
export function DandDRiskIcon() {
  return (
    <svg
      width="1.667vw"
      height="1.667vw"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M20.8324 11.9605L12 7.54414L3.16763 11.9605L2.832 11.2896L11.832 6.78964C11.8841 6.76357 11.9416 6.75 11.9998 6.75C12.0581 6.75 12.1155 6.76357 12.1676 6.78964L21.1676 11.2896L20.8324 11.9605Z"
        fill="#E6E6E6"
      />
      <path
        d="M10.311 7.55003L2.83238 11.2892L3.16801 11.96L10.7745 8.15678C10.58 7.98848 10.4222 7.78195 10.311 7.55003ZM11.5403 7.77391L12 7.54403L12.4598 7.77391C12.708 7.66169 12.9072 7.4635 13.0208 7.2159L12.1676 6.78915C12.1155 6.76308 12.0581 6.74951 11.9998 6.74951C11.9416 6.74951 11.8841 6.76308 11.832 6.78915L10.9789 7.2159C11.0925 7.4634 11.292 7.66216 11.5403 7.77391ZM21.1676 11.2892L13.6886 7.54965C13.5776 7.78168 13.4199 7.98835 13.2255 8.15678L20.832 11.96L21.1676 11.2892Z"
        fill="#E6E6E6"
      />
      <path
        d="M12 7.875C11.8358 7.875 11.6809 7.83788 11.5403 7.77413L10.7745 8.157C11.1038 8.44463 11.5294 8.625 12 8.625C12.4706 8.625 12.8963 8.44463 13.2259 8.15738L12.4601 7.7745C12.3156 7.8403 12.1588 7.87456 12 7.875ZM10.875 6.75C10.875 6.12975 11.3797 5.625 12 5.625C12.0995 5.625 12.1948 5.58549 12.2652 5.51516C12.3355 5.44484 12.375 5.34946 12.375 5.25V2.625C12.375 2.52554 12.3355 2.43016 12.2652 2.35984C12.1948 2.28951 12.0995 2.25 12 2.25C11.9005 2.25 11.8052 2.28951 11.7348 2.35984C11.6645 2.43016 11.625 2.52554 11.625 2.625V4.91287C11.2018 4.9999 10.8216 5.23012 10.5484 5.56476C10.2752 5.8994 10.1256 6.31799 10.125 6.75C10.125 7.03725 10.1951 7.3065 10.311 7.55025L10.9789 7.21613C10.911 7.07008 10.8755 6.91106 10.875 6.75ZM13.875 6.75C13.875 6.65054 13.8355 6.55516 13.7652 6.48483C13.6948 6.41451 13.5995 6.375 13.5 6.375C13.4005 6.375 13.3052 6.41451 13.2348 6.48483C13.1645 6.55516 13.125 6.65054 13.125 6.75C13.125 6.91687 13.0864 7.07363 13.0208 7.21613L13.6886 7.55025C13.8049 7.3065 13.875 7.03725 13.875 6.75Z"
        fill="#4D4D4D"
      />
      <path
        d="M13.689 7.55043L13.0211 7.21631C12.9077 7.46399 12.7084 7.66221 12.4601 7.77431L13.2259 8.15718C13.4202 7.98877 13.5778 7.78225 13.689 7.55043Z"
        fill="#4D4D4D"
      />
      <path d="M1.5 12.375H22.5V21.375H1.5V12.375Z" fill="#D48332" />
      <path
        d="M1.125 10.875H22.875V12.375H1.125V10.875ZM1.125 21.375H22.875V22.875H1.125V21.375Z"
        fill="#AC6C28"
      />
      <path
        d="M12.75 2.625H11.25C11.1505 2.625 11.0552 2.58549 10.9848 2.51516C10.9145 2.44484 10.875 2.34946 10.875 2.25V1.125H13.125V2.25C13.125 2.34946 13.0855 2.44484 13.0152 2.51516C12.9448 2.58549 12.8495 2.625 12.75 2.625Z"
        fill="#666666"
      />
      <path
        d="M13.875 1.5H10.125C10.0255 1.5 9.93016 1.46049 9.85983 1.39017C9.78951 1.31984 9.75 1.22446 9.75 1.125C9.75 1.02554 9.78951 0.930161 9.85983 0.859835C9.93016 0.789509 10.0255 0.75 10.125 0.75H13.875C13.9745 0.75 14.0698 0.789509 14.1402 0.859835C14.2105 0.930161 14.25 1.02554 14.25 1.125C14.25 1.22446 14.2105 1.31984 14.1402 1.39017C14.0698 1.46049 13.9745 1.5 13.875 1.5Z"
        fill="#4D4D4D"
      />
      <path
        d="M7.875 20.4565C5.62238 20.4565 3.47288 20.2311 1.5 19.825V21.3749H22.5V16.2666C19.4505 18.7821 14.0422 20.4565 7.875 20.4565Z"
        fill="#BF782D"
      />
      <path
        d="M7.5 20.25H6.75V13.875C6.75 13.7755 6.78951 13.6802 6.85983 13.6098C6.93016 13.5395 7.02554 13.5 7.125 13.5H7.875V14.25H7.5V20.25ZM5.625 20.25H4.875V13.875C4.875 13.7755 4.91451 13.6802 4.98484 13.6098C5.05516 13.5395 5.15054 13.5 5.25 13.5H6V14.25H5.625V20.25ZM3.75 20.25H3V13.875C3 13.7755 3.03951 13.6802 3.10984 13.6098C3.18016 13.5395 3.27554 13.5 3.375 13.5H4.125V14.25H3.75V20.25ZM9.375 20.25H8.625V13.875C8.625 13.7755 8.66451 13.6802 8.73483 13.6098C8.80516 13.5395 8.90054 13.5 9 13.5H9.75V14.25H9.375V20.25ZM11.25 20.25H10.5V13.875C10.5 13.7755 10.5395 13.6802 10.6098 13.6098C10.6802 13.5395 10.7755 13.5 10.875 13.5H11.625V14.25H11.25V20.25ZM13.125 20.25H12.375V13.875C12.375 13.7755 12.4145 13.6802 12.4848 13.6098C12.5552 13.5395 12.6505 13.5 12.75 13.5H13.5V14.25H13.125V20.25ZM15 20.25H14.25V13.875C14.25 13.7755 14.2895 13.6802 14.3598 13.6098C14.4302 13.5395 14.5255 13.5 14.625 13.5H15.375V14.25H15V20.25ZM16.875 20.25H16.125V13.875C16.125 13.7755 16.1645 13.6802 16.2348 13.6098C16.3052 13.5395 16.4005 13.5 16.5 13.5H17.25V14.25H16.875V20.25ZM18.75 20.25H18V13.875C18 13.7755 18.0395 13.6802 18.1098 13.6098C18.1802 13.5395 18.2755 13.5 18.375 13.5H19.125V14.25H18.75V20.25ZM20.625 20.25H19.875V13.875C19.875 13.7755 19.9145 13.6802 19.9848 13.6098C20.0552 13.5395 20.1505 13.5 20.25 13.5H21V14.25H20.625V20.25Z"
        fill="#AA7028"
      />
    </svg>
  );
}
export function DandDPenaltyIcon() {
  return (
    <svg
      width="1.667vw"
      height="1.667vw"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M20.8324 11.9605L12 7.54414L3.16763 11.9605L2.832 11.2896L11.832 6.78964C11.8841 6.76357 11.9416 6.75 11.9998 6.75C12.0581 6.75 12.1155 6.76357 12.1676 6.78964L21.1676 11.2896L20.8324 11.9605Z"
        fill="#E6E6E6"
      />
      <path
        d="M10.311 7.55003L2.83238 11.2892L3.16801 11.96L10.7745 8.15678C10.58 7.98848 10.4222 7.78195 10.311 7.55003ZM11.5403 7.77391L12 7.54403L12.4598 7.77391C12.708 7.66169 12.9072 7.4635 13.0208 7.2159L12.1676 6.78915C12.1155 6.76308 12.0581 6.74951 11.9998 6.74951C11.9416 6.74951 11.8841 6.76308 11.832 6.78915L10.9789 7.2159C11.0925 7.4634 11.292 7.66216 11.5403 7.77391ZM21.1676 11.2892L13.6886 7.54965C13.5776 7.78168 13.4199 7.98835 13.2255 8.15678L20.832 11.96L21.1676 11.2892Z"
        fill="#E6E6E6"
      />
      <path
        d="M12 7.875C11.8358 7.875 11.6809 7.83788 11.5403 7.77413L10.7745 8.157C11.1038 8.44463 11.5294 8.625 12 8.625C12.4706 8.625 12.8963 8.44463 13.2259 8.15738L12.4601 7.7745C12.3156 7.8403 12.1588 7.87456 12 7.875ZM10.875 6.75C10.875 6.12975 11.3797 5.625 12 5.625C12.0995 5.625 12.1948 5.58549 12.2652 5.51516C12.3355 5.44484 12.375 5.34946 12.375 5.25V2.625C12.375 2.52554 12.3355 2.43016 12.2652 2.35984C12.1948 2.28951 12.0995 2.25 12 2.25C11.9005 2.25 11.8052 2.28951 11.7348 2.35984C11.6645 2.43016 11.625 2.52554 11.625 2.625V4.91287C11.2018 4.9999 10.8216 5.23012 10.5484 5.56476C10.2752 5.8994 10.1256 6.31799 10.125 6.75C10.125 7.03725 10.1951 7.3065 10.311 7.55025L10.9789 7.21613C10.911 7.07008 10.8755 6.91106 10.875 6.75ZM13.875 6.75C13.875 6.65054 13.8355 6.55516 13.7652 6.48483C13.6948 6.41451 13.5995 6.375 13.5 6.375C13.4005 6.375 13.3052 6.41451 13.2348 6.48483C13.1645 6.55516 13.125 6.65054 13.125 6.75C13.125 6.91687 13.0864 7.07363 13.0208 7.21613L13.6886 7.55025C13.8049 7.3065 13.875 7.03725 13.875 6.75Z"
        fill="#4D4D4D"
      />
      <path
        d="M13.689 7.55043L13.0211 7.21631C12.9077 7.46399 12.7084 7.66221 12.4601 7.77431L13.2259 8.15718C13.4202 7.98877 13.5778 7.78225 13.689 7.55043Z"
        fill="#4D4D4D"
      />
      <path d="M1.5 12.375H22.5V21.375H1.5V12.375Z" fill="#D43239" />
      <path
        d="M1.125 10.875H22.875V12.375H1.125V10.875ZM1.125 21.375H22.875V22.875H1.125V21.375Z"
        fill="#AC282E"
      />
      <path
        d="M12.75 2.625H11.25C11.1505 2.625 11.0552 2.58549 10.9848 2.51516C10.9145 2.44484 10.875 2.34946 10.875 2.25V1.125H13.125V2.25C13.125 2.34946 13.0855 2.44484 13.0152 2.51516C12.9448 2.58549 12.8495 2.625 12.75 2.625Z"
        fill="#666666"
      />
      <path
        d="M13.875 1.5H10.125C10.0255 1.5 9.93016 1.46049 9.85983 1.39017C9.78951 1.31984 9.75 1.22446 9.75 1.125C9.75 1.02554 9.78951 0.930161 9.85983 0.859835C9.93016 0.789509 10.0255 0.75 10.125 0.75H13.875C13.9745 0.75 14.0698 0.789509 14.1402 0.859835C14.2105 0.930161 14.25 1.02554 14.25 1.125C14.25 1.22446 14.2105 1.31984 14.1402 1.39017C14.0698 1.46049 13.9745 1.5 13.875 1.5Z"
        fill="#4D4D4D"
      />
      <path
        d="M7.875 20.4565C5.62238 20.4565 3.47288 20.2311 1.5 19.825V21.3749H22.5V16.2666C19.4505 18.7821 14.0422 20.4565 7.875 20.4565Z"
        fill="#BF2D33"
      />
      <path
        d="M7.5 20.25H6.75V13.875C6.75 13.7755 6.78951 13.6802 6.85983 13.6098C6.93016 13.5395 7.02554 13.5 7.125 13.5H7.875V14.25H7.5V20.25ZM5.625 20.25H4.875V13.875C4.875 13.7755 4.91451 13.6802 4.98484 13.6098C5.05516 13.5395 5.15054 13.5 5.25 13.5H6V14.25H5.625V20.25ZM3.75 20.25H3V13.875C3 13.7755 3.03951 13.6802 3.10984 13.6098C3.18016 13.5395 3.27554 13.5 3.375 13.5H4.125V14.25H3.75V20.25ZM9.375 20.25H8.625V13.875C8.625 13.7755 8.66451 13.6802 8.73483 13.6098C8.80516 13.5395 8.90054 13.5 9 13.5H9.75V14.25H9.375V20.25ZM11.25 20.25H10.5V13.875C10.5 13.7755 10.5395 13.6802 10.6098 13.6098C10.6802 13.5395 10.7755 13.5 10.875 13.5H11.625V14.25H11.25V20.25ZM13.125 20.25H12.375V13.875C12.375 13.7755 12.4145 13.6802 12.4848 13.6098C12.5552 13.5395 12.6505 13.5 12.75 13.5H13.5V14.25H13.125V20.25ZM15 20.25H14.25V13.875C14.25 13.7755 14.2895 13.6802 14.3598 13.6098C14.4302 13.5395 14.5255 13.5 14.625 13.5H15.375V14.25H15V20.25ZM16.875 20.25H16.125V13.875C16.125 13.7755 16.1645 13.6802 16.2348 13.6098C16.3052 13.5395 16.4005 13.5 16.5 13.5H17.25V14.25H16.875V20.25ZM18.75 20.25H18V13.875C18 13.7755 18.0395 13.6802 18.1098 13.6098C18.1802 13.5395 18.2755 13.5 18.375 13.5H19.125V14.25H18.75V20.25ZM20.625 20.25H19.875V13.875C19.875 13.7755 19.9145 13.6802 19.9848 13.6098C20.0552 13.5395 20.1505 13.5 20.25 13.5H21V14.25H20.625V20.25Z"
        fill="#AA282E"
      />
    </svg>
  );
}
export function Co2CloudIcon() {
  return (
    <svg
      width="1.25vw"
      height="1.25vw"
      viewBox="0 0 19 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M10.625 7.3125C10.4758 7.3125 10.3327 7.37176 10.2273 7.47725C10.1218 7.58274 10.0625 7.72582 10.0625 7.875V10.125C10.0625 10.2742 10.1218 10.4173 10.2273 10.5227C10.3327 10.6282 10.4758 10.6875 10.625 10.6875C10.7742 10.6875 10.9173 10.6282 11.0227 10.5227C11.1282 10.4173 11.1875 10.2742 11.1875 10.125V7.875C11.1875 7.72582 11.1282 7.58274 11.0227 7.47725C10.9173 7.37176 10.7742 7.3125 10.625 7.3125Z"
        fill="url(#paint0_linear_29914_45159)"
      />
      <path
        d="M17.375 8.99986C17.3746 8.16079 17.1042 7.34413 16.6039 6.67055C16.7417 6.33916 16.8126 5.98378 16.8125 5.62486C16.8125 5.19903 16.7158 4.77876 16.5296 4.39577C16.3435 4.01277 16.0728 3.67704 15.738 3.4139C15.4032 3.15076 15.013 2.96708 14.5969 2.87671C14.1807 2.78635 13.7495 2.79166 13.3357 2.89224C12.862 2.33807 12.2738 1.89313 11.6117 1.58806C10.9495 1.28298 10.2291 1.125 9.50004 1.125C8.77098 1.125 8.05058 1.28298 7.38843 1.58806C6.72627 1.89313 6.13808 2.33807 5.66435 2.89224C5.25057 2.79166 4.81934 2.78635 4.40321 2.87671C3.98707 2.96708 3.59689 3.15076 3.26208 3.4139C2.92728 3.67704 2.6566 4.01277 2.47046 4.39577C2.28432 4.77876 2.18758 5.19903 2.18754 5.62486C2.18745 5.98378 2.25837 6.33916 2.39623 6.67055C1.89544 7.3439 1.625 8.16071 1.625 8.99986C1.625 9.83902 1.89544 10.6558 2.39623 11.3292C2.25837 11.6606 2.18745 12.0159 2.18754 12.3749C2.18758 12.8007 2.28432 13.221 2.47046 13.604C2.6566 13.987 2.92728 14.3227 3.26208 14.5858C3.59689 14.849 3.98707 15.0326 4.40321 15.123C4.81934 15.2134 5.25057 15.2081 5.66435 15.1075C6.13808 15.6617 6.72627 16.1066 7.38843 16.4117C8.05058 16.7168 8.77098 16.8747 9.50004 16.8747C10.2291 16.8747 10.9495 16.7168 11.6117 16.4117C12.2738 16.1066 12.862 15.6617 13.3357 15.1075C13.7495 15.2081 14.1807 15.2134 14.5969 15.123C15.013 15.0326 15.4032 14.849 15.738 14.5858C16.0728 14.3227 16.3435 13.987 16.5296 13.604C16.7158 13.221 16.8125 12.8007 16.8125 12.3749C16.8126 12.0159 16.7417 11.6606 16.6039 11.3292C17.1042 10.6556 17.3746 9.83894 17.375 8.99986ZM6.68754 10.6874C6.83672 10.6874 6.9798 10.6281 7.08529 10.5226C7.19078 10.4171 7.25004 10.274 7.25004 10.1249C7.25004 9.97568 7.3093 9.8326 7.41479 9.72712C7.52028 9.62163 7.66336 9.56236 7.81254 9.56236C7.96172 9.56236 8.1048 9.62163 8.21029 9.72712C8.31578 9.8326 8.37504 9.97568 8.37504 10.1249C8.37504 10.5724 8.19725 11.0016 7.88078 11.3181C7.56431 11.6346 7.13509 11.8124 6.68754 11.8124C6.23999 11.8124 5.81076 11.6346 5.4943 11.3181C5.17783 11.0016 5.00004 10.5724 5.00004 10.1249V7.87486C5.00004 7.42731 5.17783 6.99809 5.4943 6.68162C5.81076 6.36515 6.23999 6.18736 6.68754 6.18736C7.13509 6.18736 7.56431 6.36515 7.88078 6.68162C8.19725 6.99809 8.37504 7.42731 8.37504 7.87486C8.37504 8.02405 8.31578 8.16712 8.21029 8.27261C8.1048 8.3781 7.96172 8.43736 7.81254 8.43736C7.66336 8.43736 7.52028 8.3781 7.41479 8.27261C7.3093 8.16712 7.25004 8.02405 7.25004 7.87486C7.25004 7.72568 7.19078 7.5826 7.08529 7.47712C6.9798 7.37163 6.83672 7.31236 6.68754 7.31236C6.53836 7.31236 6.39528 7.37163 6.28979 7.47712C6.1843 7.5826 6.12504 7.72568 6.12504 7.87486V10.1249C6.12504 10.274 6.1843 10.4171 6.28979 10.5226C6.39528 10.6281 6.53836 10.6874 6.68754 10.6874ZM12.3125 10.1249C12.3125 10.5724 12.1348 11.0016 11.8183 11.3181C11.5018 11.6346 11.0726 11.8124 10.625 11.8124C10.1775 11.8124 9.74826 11.6346 9.4318 11.3181C9.11533 11.0016 8.93754 10.5724 8.93754 10.1249V7.87486C8.93754 7.42731 9.11533 6.99809 9.4318 6.68162C9.74826 6.36515 10.1775 6.18736 10.625 6.18736C11.0726 6.18736 11.5018 6.36515 11.8183 6.68162C12.1348 6.99809 12.3125 7.42731 12.3125 7.87486V10.1249ZM14.2813 10.9686C14.3559 10.9686 14.4274 10.9982 14.4802 11.051C14.5329 11.1037 14.5625 11.1753 14.5625 11.2499C14.5625 11.3245 14.5329 11.396 14.4802 11.4487C14.4274 11.5015 14.3559 11.5311 14.2813 11.5311H13.1563C13.0817 11.5311 13.0102 11.5015 12.9574 11.4487C12.9047 11.396 12.875 11.3245 12.875 11.2499C12.8963 11.0401 12.966 10.8381 13.0785 10.6598C13.191 10.4815 13.3434 10.3317 13.5236 10.2222C13.647 10.1545 13.7538 10.0601 13.8362 9.94601C13.9187 9.83188 13.9746 9.70082 14 9.56236C14.0031 9.52465 13.9979 9.48673 13.9849 9.45122C13.9718 9.41571 13.9512 9.38346 13.9244 9.3567C13.8977 9.32995 13.8654 9.30933 13.8299 9.29628C13.7944 9.28323 13.7565 9.27805 13.7188 9.28111C13.6442 9.28111 13.5727 9.31074 13.5199 9.36349C13.4672 9.41623 13.4375 9.48777 13.4375 9.56236C13.4375 9.63696 13.4079 9.70849 13.3552 9.76124C13.3024 9.81398 13.2309 9.84361 13.1563 9.84361C13.0817 9.84361 13.0102 9.81398 12.9574 9.76124C12.9047 9.70849 12.875 9.63696 12.875 9.56236C12.875 9.33859 12.9639 9.12398 13.1222 8.96574C13.2804 8.80751 13.495 8.71861 13.7188 8.71861C13.8306 8.71477 13.9421 8.73396 14.0462 8.775C14.1503 8.81605 14.2448 8.87806 14.324 8.95719C14.4031 9.03632 14.4651 9.13087 14.5061 9.23498C14.5472 9.33909 14.5664 9.45052 14.5625 9.56236C14.5412 9.78431 14.4689 9.99832 14.3512 10.1877C14.2335 10.3771 14.0737 10.5367 13.8842 10.6542C13.7635 10.7484 13.6518 10.8537 13.5506 10.9686H14.2813Z"
        fill="url(#paint1_linear_29914_45159)"
      />
      <defs>
        <linearGradient
          id="paint0_linear_29914_45159"
          x1="10.625"
          y1="7.3125"
          x2="10.625"
          y2="10.6875"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="#AEED9B" />
          <stop offset="1" stop-color="#3F9B24" />
        </linearGradient>
        <linearGradient
          id="paint1_linear_29914_45159"
          x1="9.50002"
          y1="1.125"
          x2="9.50002"
          y2="16.8747"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="#AEED9B" />
          <stop offset="1" stop-color="#3F9B24" />
        </linearGradient>
      </defs>
    </svg>
  );
}
export function SubCompany({ position, left, top }) {
  const svgStyle = {
    position: position || 'absolute',
    left: left || '0',
    top: top || '0',
  };

  return (
    <svg
      width="1.667vw"
      height="1.667vw"
      viewBox="0 0 24 24"
      fill="none"
      style={svgStyle}
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M17.7558 1.99023H6.19723L0.417969 12.0002L6.19723 22.0103H17.7558L23.5351 12.0002L17.7558 1.99023ZM16.9439 20.6041H7.00916L2.04177 12.0002L7.00916 3.39648H16.9439L21.9113 12.0002L16.9439 20.6041Z"
        fill="url(#paint0_linear_28135_49491)"
      />
      <path
        d="M16.9547 3.37891H6.99859L2.02051 12.0012L6.99859 20.6235H16.9547L21.9328 12.0012L16.9547 3.37891Z"
        fill="#EBF4FF"
      />
      <path
        d="M10.3103 14.0443C10.3103 13.7095 10.1921 13.4525 9.95577 13.2732C9.71943 13.094 9.29399 12.9049 8.67946 12.706C8.06493 12.5071 7.57841 12.3111 7.22 12.118C6.24304 11.5902 5.75464 10.8792 5.75464 9.98495C5.75464 9.52019 5.88557 9.10553 6.14755 8.74117C6.40949 8.37686 6.78571 8.09223 7.27611 7.88734C7.76652 7.68255 8.31697 7.58008 8.92761 7.58008C9.54214 7.58008 10.0896 7.69141 10.5703 7.91392C11.0508 8.13653 11.4241 8.45069 11.69 8.85634C11.9558 9.26209 12.0888 9.72297 12.0888 10.239H10.3161C10.3161 9.84517 10.1921 9.5388 9.94391 9.32017C9.69575 9.10155 9.34715 8.99223 8.89808 8.99223C8.46468 8.99223 8.12788 9.08378 7.88769 9.26697C7.64736 9.45016 7.52727 9.69152 7.52727 9.99077C7.52727 10.2705 7.66808 10.5048 7.94975 10.6939C8.23133 10.883 8.64599 11.0602 9.19354 11.2257C10.2019 11.5291 10.9366 11.9052 11.3975 12.3542C11.8584 12.8033 12.0888 13.3628 12.0888 14.0324C12.0888 14.7769 11.8071 15.3609 11.2439 15.7843C10.6805 16.2078 9.9223 16.4195 8.96905 16.4195C8.30727 16.4195 7.70455 16.2984 7.16094 16.0561C6.61733 15.8139 6.20272 15.482 5.91716 15.0605C5.6315 14.6391 5.48877 14.1505 5.48877 13.5951H7.2673C7.2673 14.5445 7.83454 15.0191 8.96905 15.0191C9.3905 15.0191 9.71943 14.9335 9.95582 14.7621C10.1921 14.5908 10.3103 14.3515 10.3103 14.0443ZM15.835 15.0429C16.1501 15.0429 16.4061 14.9562 16.6031 14.7829C16.8 14.6096 16.9025 14.3792 16.9104 14.0916H18.5117C18.5077 14.5249 18.3895 14.9217 18.1572 15.2822C17.9247 15.6426 17.6067 15.9223 17.2029 16.1212C16.7991 16.32 16.353 16.4196 15.8646 16.4196C14.9507 16.4196 14.2298 16.1291 13.702 15.548C13.174 14.967 12.9102 14.1644 12.9102 13.1402V13.0279C12.9102 12.0432 13.1721 11.2573 13.6961 10.6703C14.2199 10.0834 14.9389 9.78995 15.8527 9.78995C16.6524 9.78995 17.2934 10.0174 17.776 10.4724C18.2586 10.9274 18.5037 11.533 18.5117 12.2894H16.9103C16.9024 11.9568 16.8 11.6865 16.6031 11.4786C16.4061 11.2706 16.1461 11.1667 15.8231 11.1667C15.4252 11.1667 15.1249 11.3117 14.922 11.6016C14.7191 11.8916 14.6177 12.3621 14.6177 13.013V13.1905C14.6177 13.8494 14.7182 14.3229 14.9191 14.6108C15.12 14.899 15.4252 15.0429 15.835 15.0429Z"
        fill="url(#paint1_linear_28135_49491)"
      />
      <defs>
        <linearGradient
          id="paint0_linear_28135_49491"
          x1="0.417969"
          y1="1.99023"
          x2="26.9066"
          y2="15.301"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="#849BEA" />
          <stop offset="1" stop-color="#5DB1FF" />
        </linearGradient>
        <linearGradient
          id="paint1_linear_28135_49491"
          x1="5.48877"
          y1="7.58008"
          x2="18.7343"
          y2="16.0723"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="#849BEA" />
          <stop offset="1" stop-color="#5DB1FF" />
        </linearGradient>
      </defs>
    </svg>
  );
}

SubCompany.propTypes = {
  position: PropTypes.string,
  left: PropTypes.string,
  top: PropTypes.string,
};

SubCompany.defaultProps = {
  position: '',
  left: '',
  top: '',
};
export function StopWatch() {
  return (
    <svg
      width="1.389vw"
      height="1.389vw"
      viewBox="0 0 20 21"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M9.99967 19.4583C5.63301 19.4583 2.08301 15.9083 2.08301 11.5417C2.08301 7.175 5.63301 3.625 9.99967 3.625C14.3663 3.625 17.9163 7.175 17.9163 11.5417C17.9163 15.9083 14.3663 19.4583 9.99967 19.4583ZM9.99967 4.875C6.32467 4.875 3.33301 7.86667 3.33301 11.5417C3.33301 15.2167 6.32467 18.2083 9.99967 18.2083C13.6747 18.2083 16.6663 15.2167 16.6663 11.5417C16.6663 7.86667 13.6747 4.875 9.99967 4.875Z"
        fill="#2179C4"
      />
      <path
        d="M10 11.9577C9.65833 11.9577 9.375 11.6743 9.375 11.3327V7.16602C9.375 6.82435 9.65833 6.54102 10 6.54102C10.3417 6.54102 10.625 6.82435 10.625 7.16602V11.3327C10.625 11.6743 10.3417 11.9577 10 11.9577Z"
        fill="#2179C4"
      />
      <path
        d="M12.5 2.79102H7.5C7.15833 2.79102 6.875 2.50768 6.875 2.16602C6.875 1.82435 7.15833 1.54102 7.5 1.54102H12.5C12.8417 1.54102 13.125 1.82435 13.125 2.16602C13.125 2.50768 12.8417 2.79102 12.5 2.79102Z"
        fill="#2179C4"
      />
    </svg>
  );
}
export function NewTimezoneIcon() {
  return (
    <svg
      width="1.389vw"
      height="1.389vw"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <circle
        cx="10"
        cy="10"
        r="9.75"
        fill="#EBF4FF"
        stroke="url(#paint0_linear_30562_12457)"
        stroke-width="0.5"
      />
      <path
        d="M10.0004 16.8914C6.19912 16.8914 3.10938 13.8017 3.10938 10.0004C3.10938 6.19912 6.19912 3.10938 10.0004 3.10938C13.8017 3.10938 16.8914 6.19912 16.8914 10.0004C16.8914 13.8017 13.8017 16.8914 10.0004 16.8914ZM10.0004 4.07091C6.73117 4.07091 4.07091 6.73117 4.07091 10.0004C4.07091 13.2696 6.73117 15.9299 10.0004 15.9299C13.2696 15.9299 15.9299 13.2696 15.9299 10.0004C15.9299 6.73117 13.2696 4.07091 10.0004 4.07091Z"
        fill="url(#paint1_linear_30562_12457)"
      />
      <path
        d="M12.3788 12.5208C12.2955 12.5208 12.2121 12.5016 12.1352 12.4503L10.148 11.2644C9.65445 10.9695 9.28906 10.3221 9.28906 9.75155V7.12335C9.28906 6.86053 9.50701 6.64258 9.76983 6.64258C10.0327 6.64258 10.2506 6.86053 10.2506 7.12335V9.75155C10.2506 9.98232 10.4429 10.3221 10.6416 10.4375L12.6288 11.6233C12.8596 11.758 12.9301 12.0528 12.7955 12.2836C12.6993 12.4375 12.5391 12.5208 12.3788 12.5208Z"
        fill="url(#paint2_linear_30562_12457)"
      />
      <defs>
        <linearGradient
          id="paint0_linear_30562_12457"
          x1="0"
          y1="10"
          x2="20"
          y2="10"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="#1D4069" />
          <stop offset="1" stop-color="#266CBD" />
        </linearGradient>
        <linearGradient
          id="paint1_linear_30562_12457"
          x1="3.10937"
          y1="10.0004"
          x2="16.8914"
          y2="10.0004"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="#1D4069" />
          <stop offset="1" stop-color="#266CBD" />
        </linearGradient>
        <linearGradient
          id="paint2_linear_30562_12457"
          x1="9.28906"
          y1="9.58168"
          x2="12.8634"
          y2="9.58168"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="#1D4069" />
          <stop offset="1" stop-color="#266CBD" />
        </linearGradient>
      </defs>
    </svg>
  );
}
export function RoadMovementIcon() {
  return (
    <svg
      width="4.167vw"
      height="3.472vw"
      viewBox="0 0 60 51"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect y="0.5" width="60" height="50" rx="10" fill="#FCF6EE" />
      <path
        d="M33.5332 11.1641C33.6817 11.3125 33.6895 11.4219 33.6895 13.1094V14.9063L37.6504 14.9297C41.4551 14.9609 41.6426 14.9688 42.2442 15.1328C44.2833 15.6953 45.9161 17.0235 46.8458 18.8672C47.2833 19.7422 47.5098 20.6485 47.588 21.8594C47.6348 22.4453 47.7989 25.4375 47.9551 28.5157C48.2833 34.7344 48.2911 34.5079 47.7755 35.0782C47.3223 35.5782 46.9786 35.7188 46.0411 35.7657L45.2286 35.8125L45.127 36.3203C44.8145 37.8516 43.6114 39.2188 42.0801 39.7735C41.4317 40.0079 40.0879 40.0547 39.3926 39.875C37.7051 39.4375 36.377 38.0547 35.9864 36.336L35.8614 35.7735H29.6348H23.416L23.3145 36.3047C23.1426 37.1953 22.7442 37.9141 22.0176 38.625C21.041 39.5938 20.0801 39.9922 18.7442 39.9922C17.4317 39.9922 16.377 39.5547 15.4395 38.625C14.8066 37.9922 14.3926 37.2422 14.1816 36.3516L14.0488 35.7891L13.5723 35.7579C12.7988 35.6953 12.1973 35.2813 11.916 34.625C11.8301 34.4141 11.8145 32.336 11.8145 22.8125V11.25L11.9863 11.1328C12.1426 11.0234 13.2988 11.0078 22.7676 11.0078C33.2754 11.0078 33.377 11.0078 33.5332 11.1641ZM12.5957 19.9922V28.1172H22.752H32.9082V19.9922V11.8672H22.752H12.5957V19.9922ZM33.6895 22.1485C33.6895 26.4453 33.6661 28.6485 33.6114 28.75C33.5254 28.8985 33.3301 28.8985 23.0645 28.8985H12.5957V31.5235C12.5957 34.4063 12.6113 34.5157 13.0566 34.7813C13.1895 34.8594 13.4473 34.9141 13.666 34.9141H14.0488L14.1816 34.3438C14.5801 32.625 15.9238 31.2422 17.6348 30.8125C19.9395 30.2266 22.4629 31.6407 23.1817 33.9063C23.291 34.25 23.377 34.6172 23.377 34.7266V34.9141H29.6192H35.8614L35.9864 34.3594C36.3379 32.7969 37.5333 31.4532 39.0098 30.9297C39.7051 30.6875 40.8301 30.6329 41.5879 30.8047C43.3301 31.1953 44.7754 32.6485 45.127 34.3672L45.2286 34.875L45.963 34.8985C46.588 34.9141 46.7364 34.8907 46.9551 34.7579C47.4864 34.4297 47.4864 34.7735 47.0958 27.5469C46.7051 20.3594 46.713 20.4063 46.1192 19.2344C45.1504 17.3047 43.252 15.9844 41.1504 15.7813C40.8067 15.7422 38.9864 15.711 37.1036 15.7032L33.6895 15.6953V22.1485ZM39.7754 31.5547C38.5176 31.7891 37.3458 32.8203 36.8848 34.1016C36.6426 34.75 36.6426 35.9375 36.8848 36.586C37.4551 38.1641 38.9083 39.211 40.5254 39.211C41.5801 39.211 42.4317 38.875 43.2129 38.1485C44.7911 36.6875 44.8223 34.125 43.2754 32.625C42.3145 31.6797 41.0958 31.3125 39.7754 31.5547ZM17.791 31.5938C17.1035 31.7735 16.4863 32.1407 15.9707 32.6797C15.0254 33.6641 14.6738 34.9219 14.9785 36.2266C15.6504 39.086 19.1192 40.1797 21.3301 38.2344C22.7364 37 23.0176 34.7735 21.9629 33.2032C21.0567 31.8516 19.3535 31.1875 17.791 31.5938Z"
        fill="#FF9900"
      />
      <path
        d="M40.3203 18.0846C40.6015 18.1379 41.1641 18.3435 41.5703 18.5414C42.8359 19.1582 43.8047 20.2698 44.2812 21.6556C44.4766 22.2342 44.4922 22.3561 44.5234 24.1378C44.5469 25.8053 44.5391 26.0261 44.4219 26.1327C44.3047 26.2469 43.8906 26.2621 39.9765 26.2621C35.8906 26.2621 35.6484 26.2545 35.5312 26.1251C35.414 25.9956 35.3984 25.6074 35.3984 22.0972C35.3984 18.4348 35.4062 18.2064 35.539 18.0923C35.664 17.978 35.9297 17.9627 37.75 17.9704C39.1953 17.9704 39.9609 18.0084 40.3203 18.0846ZM36.2187 22.1124V25.4626L40 25.4855L43.7812 25.5007L43.7344 24.0007C43.7109 22.9805 43.6562 22.3561 43.5703 22.0744C43.0781 20.3992 41.6172 19.0897 39.9062 18.8079C39.6797 18.7699 38.7578 18.747 37.8594 18.7546L36.2187 18.7623V22.1124Z"
        fill="#FF9900"
      />
      <path
        d="M40.9847 32.6494C41.6801 32.8245 42.2816 33.2813 42.6254 33.8829C42.8441 34.2636 42.8597 34.355 42.8597 35.0555C42.8597 35.9083 42.7504 36.2052 42.2269 36.7687C41.5863 37.4539 40.4222 37.7128 39.5004 37.3702C38.8676 37.1418 38.2113 36.5097 38.0082 35.9311C37.4535 34.3398 38.5551 32.6875 40.2269 32.6113C40.516 32.5961 40.8519 32.6113 40.9847 32.6494ZM39.8832 33.4565C39.4457 33.5783 39.0551 33.9134 38.8207 34.3626C38.5863 34.8119 38.641 35.5732 38.9535 35.9996C39.5707 36.8752 40.8441 36.997 41.5941 36.2509C42.5629 35.2839 42.1488 33.8144 40.7894 33.4109C40.4926 33.327 40.3051 33.3346 39.8832 33.4565Z"
        fill="#FF9900"
      />
      <path
        d="M19.3593 32.7185C20.4686 33.1069 21.1014 33.9673 21.1014 35.1018C21.1014 36.0155 20.5233 36.8911 19.6561 37.3023C19.328 37.4621 19.1483 37.4926 18.5624 37.4926C17.953 37.4926 17.8046 37.4621 17.4686 37.287C16.9843 37.0433 16.453 36.4951 16.2343 36.0231C15.9764 35.4673 15.9999 34.5764 16.2811 34.0206C16.5311 33.5104 17.0624 33.0079 17.5702 32.7947C18.078 32.5739 18.8436 32.5435 19.3593 32.7185ZM17.7577 33.579C16.6014 34.1272 16.5546 35.8556 17.6796 36.4951C18.4218 36.9139 19.1796 36.8226 19.7733 36.2439C20.4296 35.5967 20.4999 34.7591 19.953 34.0434C19.4452 33.3733 18.578 33.1906 17.7577 33.579Z"
        fill="#FF9900"
      />
      <path
        d="M27.8752 14.0136C29.136 14.0231 29.7396 14.0469 29.7883 14.0802C29.8369 14.1229 29.8515 14.6029 29.8515 16.6227C29.8515 18.8184 29.8418 19.1132 29.7736 19.1796C29.7055 19.2462 29.3648 19.2558 26.7215 19.2558C24.1027 19.2558 23.7278 19.2462 23.6305 19.1796L23.5234 19.1084V16.6227C23.5234 14.3653 23.5331 14.1277 23.6062 14.0706C23.6938 13.9994 24.4239 13.9899 27.8752 14.0136ZM27.6123 15.0639C27.6123 15.9194 27.6562 15.8814 26.7167 15.8814C26.2007 15.8814 25.9524 15.8624 25.894 15.8196C25.8259 15.7721 25.8113 15.6533 25.8015 15.121L25.7869 14.4794L24.8961 14.4651L24.0102 14.4556V16.6181V18.7804H26.6875H29.3648V16.6181V14.4556H28.4886H27.6123V15.0639ZM26.298 14.9309V15.4061H26.7118H27.1256V14.9641C27.1256 14.717 27.111 14.5031 27.0915 14.4889C27.0769 14.4699 26.887 14.4556 26.6777 14.4556H26.298V14.9309Z"
        fill="#FF9900"
      />
      <path
        d="M27.8752 21.1718C29.136 21.1813 29.7396 21.2051 29.7883 21.2383C29.8369 21.2811 29.8515 21.7611 29.8515 23.781C29.8515 25.9767 29.8418 26.2713 29.7736 26.3379C29.7055 26.4044 29.3648 26.4139 26.7215 26.4139C24.1027 26.4139 23.7278 26.4044 23.6305 26.3379L23.5234 26.2665V23.781C23.5234 21.5235 23.5331 21.2859 23.6062 21.2289C23.6938 21.1575 24.4239 21.1481 27.8752 21.1718ZM27.6123 22.2221C27.6123 23.0776 27.6562 23.0396 26.7167 23.0396C26.2007 23.0396 25.9524 23.0206 25.894 22.9778C25.8259 22.9303 25.8113 22.8115 25.8015 22.2791L25.7869 21.6375L24.8961 21.6233L24.0102 21.6138V23.7762V25.9387H26.6875H29.3648V23.7762V21.6138H28.4886H27.6123V22.2221ZM26.298 22.0891V22.5643H26.7118H27.1256V22.1223C27.1256 21.8751 27.111 21.6613 27.0915 21.6471C27.0769 21.6281 26.887 21.6138 26.6777 21.6138H26.298V22.0891Z"
        fill="#FF9900"
      />
      <path
        d="M19.594 21.1718C20.8547 21.1813 21.4583 21.2051 21.507 21.2383C21.5557 21.2811 21.5703 21.7611 21.5703 23.781C21.5703 25.9767 21.5605 26.2713 21.4924 26.3379C21.4242 26.4044 21.0835 26.4139 18.4403 26.4139C15.8214 26.4139 15.4466 26.4044 15.3493 26.3379L15.2422 26.2665V23.781C15.2422 21.5235 15.2519 21.2859 15.3249 21.2289C15.4126 21.1575 16.1427 21.1481 19.594 21.1718ZM19.3311 22.2221C19.3311 23.0776 19.3749 23.0396 18.4355 23.0396C17.9195 23.0396 17.6712 23.0206 17.6128 22.9778C17.5446 22.9303 17.53 22.8115 17.5203 22.2791L17.5057 21.6375L16.6149 21.6233L15.729 21.6138V23.7762V25.9387H18.4062H21.0835V23.7762V21.6138H20.2073H19.3311V22.2221ZM18.0168 22.0891V22.5643H18.4306H18.8443V22.1223C18.8443 21.8751 18.8297 21.6613 18.8103 21.6471C18.7957 21.6281 18.6058 21.6138 18.3965 21.6138H18.0168V22.0891Z"
        fill="#FF9900"
      />
    </svg>
  );
}
export function DetentionHubIcon({ size }) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M1.66667 7.49935C1.61195 7.49936 1.55776 7.4886 1.5072 7.46766C1.45664 7.44673 1.4107 7.41604 1.37201 7.37734C1.33331 7.33865 1.30262 7.29271 1.28169 7.24215C1.26075 7.19159 1.24999 7.1374 1.25 7.08268V3.74935C1.25065 3.19701 1.47035 2.66749 1.86091 2.27693C2.25147 1.88637 2.781 1.66666 3.33333 1.66602H6.66667C6.77717 1.66602 6.88315 1.70991 6.96129 1.78805C7.03943 1.86619 7.08333 1.97218 7.08333 2.08268C7.08333 2.19319 7.03943 2.29917 6.96129 2.37731C6.88315 2.45545 6.77717 2.49935 6.66667 2.49935H3.33333C3.00192 2.49971 2.68419 2.63152 2.44985 2.86586C2.21551 3.10021 2.0837 3.41794 2.08333 3.74935V7.08268C2.08335 7.1374 2.07258 7.19159 2.05165 7.24215C2.03071 7.29271 2.00002 7.33865 1.96133 7.37734C1.92263 7.41604 1.87669 7.44673 1.82613 7.46766C1.77558 7.4886 1.72139 7.49936 1.66667 7.49935ZM18.3333 7.49935C18.2786 7.49936 18.2244 7.4886 18.1739 7.46766C18.1233 7.44673 18.0774 7.41604 18.0387 7.37734C18 7.33865 17.9693 7.29271 17.9484 7.24215C17.9274 7.19159 17.9167 7.1374 17.9167 7.08268V3.74935C17.9163 3.41794 17.7845 3.10021 17.5501 2.86586C17.3158 2.63152 16.9981 2.49971 16.6667 2.49935H13.3333C13.2228 2.49935 13.1168 2.45545 13.0387 2.37731C12.9606 2.29917 12.9167 2.19319 12.9167 2.08268C12.9167 1.97218 12.9606 1.86619 13.0387 1.78805C13.1168 1.70991 13.2228 1.66602 13.3333 1.66602H16.6667C17.219 1.66666 17.7485 1.88637 18.1391 2.27693C18.5296 2.66749 18.7494 3.19701 18.75 3.74935V7.08268C18.75 7.1374 18.7392 7.19159 18.7183 7.24215C18.6974 7.29271 18.6667 7.33865 18.628 7.37734C18.5893 7.41604 18.5434 7.44673 18.4928 7.46766C18.4422 7.4886 18.3881 7.49936 18.3333 7.49935ZM16.6667 18.3327H13.3333C13.2228 18.3327 13.1168 18.2888 13.0387 18.2106C12.9606 18.1325 12.9167 18.0265 12.9167 17.916C12.9167 17.8055 12.9606 17.6995 13.0387 17.6214C13.1168 17.5432 13.2228 17.4993 13.3333 17.4993H16.6667C16.9981 17.499 17.3158 17.3672 17.5501 17.1328C17.7845 16.8985 17.9163 16.5808 17.9167 16.2493V12.916C17.9167 12.8055 17.9606 12.6995 18.0387 12.6214C18.1168 12.5432 18.2228 12.4993 18.3333 12.4993C18.4438 12.4993 18.5498 12.5432 18.628 12.6214C18.7061 12.6995 18.75 12.8055 18.75 12.916V16.2493C18.7494 16.8017 18.5296 17.3312 18.1391 17.7218C17.7485 18.1123 17.219 18.332 16.6667 18.3327ZM6.66667 18.3327H3.33333C2.781 18.332 2.25147 18.1123 1.86091 17.7218C1.47035 17.3312 1.25065 16.8017 1.25 16.2493V12.916C1.25 12.8055 1.2939 12.6995 1.37204 12.6214C1.45018 12.5432 1.55616 12.4993 1.66667 12.4993C1.77717 12.4993 1.88315 12.5432 1.96129 12.6214C2.03943 12.6995 2.08333 12.8055 2.08333 12.916V16.2493C2.0837 16.5808 2.21551 16.8985 2.44985 17.1328C2.68419 17.3672 3.00192 17.499 3.33333 17.4993H6.66667C6.77717 17.4993 6.88315 17.5432 6.96129 17.6214C7.03943 17.6995 7.08333 17.8055 7.08333 17.916C7.08333 18.0265 7.03943 18.1325 6.96129 18.2106C6.88315 18.2888 6.77717 18.3327 6.66667 18.3327Z"
        fill="#6366F1"
      />
      <path
        d="M16.2507 15.4173C16.1959 15.4173 16.1417 15.4066 16.0912 15.3856C16.0406 15.3647 15.9947 15.334 15.956 15.2953C15.9173 15.2566 15.8866 15.2107 15.8657 15.1601C15.8447 15.1096 15.834 15.0554 15.834 15.0007V5.00065C15.834 4.89014 15.8779 4.78416 15.956 4.70602C16.0342 4.62788 16.1401 4.58398 16.2507 4.58398C16.3612 4.58398 16.4671 4.62788 16.5453 4.70602C16.6234 4.78416 16.6673 4.89014 16.6673 5.00065V15.0007C16.6673 15.0554 16.6566 15.1096 16.6356 15.1601C16.6147 15.2107 16.584 15.2566 16.5453 15.2953C16.5066 15.334 16.4607 15.3647 16.4101 15.3856C16.3596 15.4066 16.3054 15.4173 16.2507 15.4173ZM3.75065 15.4173C3.69593 15.4173 3.64174 15.4066 3.59118 15.3856C3.54062 15.3647 3.49469 15.334 3.45599 15.2953C3.4173 15.2566 3.38661 15.2107 3.36567 15.1601C3.34474 15.1096 3.33397 15.0554 3.33398 15.0007V5.00065C3.33398 4.89014 3.37788 4.78416 3.45602 4.70602C3.53416 4.62788 3.64014 4.58398 3.75065 4.58398C3.86116 4.58398 3.96714 4.62788 4.04528 4.70602C4.12342 4.78416 4.16732 4.89014 4.16732 5.00065V15.0007C4.16733 15.0554 4.15656 15.1096 4.13563 15.1601C4.1147 15.2107 4.084 15.2566 4.04531 15.2953C4.00662 15.334 3.96068 15.3647 3.91012 15.3856C3.85956 15.4066 3.80537 15.4173 3.75065 15.4173ZM6.25065 12.5007C6.19593 12.5007 6.14174 12.4899 6.09118 12.469C6.04062 12.448 5.99469 12.4173 5.95599 12.3786C5.9173 12.34 5.88661 12.294 5.86567 12.2435C5.84474 12.1929 5.83397 12.1387 5.83398 12.084V5.00065C5.83398 4.89014 5.87788 4.78416 5.95602 4.70602C6.03416 4.62788 6.14014 4.58398 6.25065 4.58398C6.36116 4.58398 6.46714 4.62788 6.54528 4.70602C6.62342 4.78416 6.66732 4.89014 6.66732 5.00065V12.084C6.66733 12.1387 6.65656 12.1929 6.63563 12.2435C6.6147 12.294 6.584 12.34 6.54531 12.3786C6.50662 12.4173 6.46068 12.448 6.41012 12.469C6.35956 12.4899 6.30537 12.5007 6.25065 12.5007ZM6.25065 15.4173C6.19593 15.4173 6.14174 15.4066 6.09118 15.3856C6.04062 15.3647 5.99469 15.334 5.95599 15.2953C5.9173 15.2566 5.88661 15.2107 5.86567 15.1601C5.84474 15.1096 5.83397 15.0554 5.83398 15.0007V13.7507C5.83398 13.6401 5.87788 13.5342 5.95602 13.456C6.03416 13.3779 6.14014 13.334 6.25065 13.334C6.36116 13.334 6.46714 13.3779 6.54528 13.456C6.62342 13.5342 6.66732 13.6401 6.66732 13.7507V15.0007C6.66733 15.0554 6.65656 15.1096 6.63563 15.1601C6.6147 15.2107 6.584 15.2566 6.54531 15.2953C6.50662 15.334 6.46068 15.3647 6.41012 15.3856C6.35956 15.4066 6.30537 15.4173 6.25065 15.4173ZM8.75065 15.4173C8.69593 15.4173 8.64174 15.4066 8.59118 15.3856C8.54062 15.3647 8.49468 15.334 8.45599 15.2953C8.4173 15.2566 8.38661 15.2107 8.36567 15.1601C8.34474 15.1096 8.33397 15.0554 8.33398 15.0007V7.91732C8.33398 7.80681 8.37788 7.70083 8.45602 7.62269C8.53416 7.54455 8.64014 7.50065 8.75065 7.50065C8.86116 7.50065 8.96714 7.54455 9.04528 7.62269C9.12342 7.70083 9.16732 7.80681 9.16732 7.91732V15.0007C9.16733 15.0554 9.15656 15.1096 9.13563 15.1601C9.1147 15.2107 9.084 15.2566 9.04531 15.2953C9.00662 15.334 8.96068 15.3647 8.91012 15.3856C8.85956 15.4066 8.80537 15.4173 8.75065 15.4173ZM8.75065 6.66732C8.69593 6.66733 8.64174 6.65656 8.59118 6.63563C8.54062 6.6147 8.49468 6.584 8.45599 6.54531C8.4173 6.50662 8.38661 6.46068 8.36567 6.41012C8.34474 6.35956 8.33397 6.30537 8.33398 6.25065V5.00065C8.33398 4.89014 8.37788 4.78416 8.45602 4.70602C8.53416 4.62788 8.64014 4.58398 8.75065 4.58398C8.86116 4.58398 8.96714 4.62788 9.04528 4.70602C9.12342 4.78416 9.16732 4.89014 9.16732 5.00065V6.25065C9.16733 6.30537 9.15656 6.35956 9.13563 6.41012C9.1147 6.46068 9.084 6.50662 9.04531 6.54531C9.00662 6.584 8.96068 6.6147 8.91012 6.63563C8.85956 6.65656 8.80537 6.66733 8.75065 6.66732ZM11.2507 12.5007C11.1959 12.5007 11.1417 12.4899 11.0912 12.469C11.0406 12.448 10.9947 12.4173 10.956 12.3786C10.9173 12.34 10.8866 12.294 10.8657 12.2435C10.8447 12.1929 10.834 12.1387 10.834 12.084V5.00065C10.834 4.89014 10.8779 4.78416 10.956 4.70602C11.0342 4.62788 11.1401 4.58398 11.2507 4.58398C11.3612 4.58398 11.4671 4.62788 11.5453 4.70602C11.6234 4.78416 11.6673 4.89014 11.6673 5.00065V12.084C11.6673 12.1387 11.6566 12.1929 11.6356 12.2435C11.6147 12.294 11.584 12.34 11.5453 12.3786C11.5066 12.4173 11.4607 12.448 11.4101 12.469C11.3596 12.4899 11.3054 12.5007 11.2507 12.5007ZM11.2507 15.4173C11.1959 15.4173 11.1417 15.4066 11.0912 15.3856C11.0406 15.3647 10.9947 15.334 10.956 15.2953C10.9173 15.2566 10.8866 15.2107 10.8657 15.1601C10.8447 15.1096 10.834 15.0554 10.834 15.0007V13.7507C10.834 13.6401 10.8779 13.5342 10.956 13.456C11.0342 13.3779 11.1401 13.334 11.2507 13.334C11.3612 13.334 11.4671 13.3779 11.5453 13.456C11.6234 13.5342 11.6673 13.6401 11.6673 13.7507V15.0007C11.6673 15.0554 11.6566 15.1096 11.6356 15.1601C11.6147 15.2107 11.584 15.2566 11.5453 15.2953C11.5066 15.334 11.4607 15.3647 11.4101 15.3856C11.3596 15.4066 11.3054 15.4173 11.2507 15.4173ZM13.7507 15.4173C13.6959 15.4173 13.6417 15.4066 13.5912 15.3856C13.5406 15.3647 13.4947 15.334 13.456 15.2953C13.4173 15.2566 13.3866 15.2107 13.3657 15.1601C13.3447 15.1096 13.334 15.0554 13.334 15.0007V7.91732C13.334 7.80681 13.3779 7.70083 13.456 7.62269C13.5342 7.54455 13.6401 7.50065 13.7507 7.50065C13.8612 7.50065 13.9671 7.54455 14.0453 7.62269C14.1234 7.70083 14.1673 7.80681 14.1673 7.91732V15.0007C14.1673 15.0554 14.1566 15.1096 14.1356 15.1601C14.1147 15.2107 14.084 15.2566 14.0453 15.2953C14.0066 15.334 13.9607 15.3647 13.9101 15.3856C13.8596 15.4066 13.8054 15.4173 13.7507 15.4173ZM13.7507 6.66732C13.6959 6.66733 13.6417 6.65656 13.5912 6.63563C13.5406 6.6147 13.4947 6.584 13.456 6.54531C13.4173 6.50662 13.3866 6.46068 13.3657 6.41012C13.3447 6.35956 13.334 6.30537 13.334 6.25065V5.00065C13.334 4.89014 13.3779 4.78416 13.456 4.70602C13.5342 4.62788 13.6401 4.58398 13.7507 4.58398C13.8612 4.58398 13.9671 4.62788 14.0453 4.70602C14.1234 4.78416 14.1673 4.89014 14.1673 5.00065V6.25065C14.1673 6.30537 14.1566 6.35956 14.1356 6.41012C14.1147 6.46068 14.084 6.50662 14.0453 6.54531C14.0066 6.584 13.9607 6.6147 13.9101 6.63563C13.8596 6.65656 13.8054 6.66733 13.7507 6.66732Z"
        fill="#6366F1"
      />
    </svg>
  );
}
DetentionHubIcon.propTypes = {
  size: PropTypes.string,
};
DetentionHubIcon.defaultProps = {
  size: '4.167vw',
};

export function DemmarageHubIcon({ size }) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M2.46094 10.6641H17.5391C17.6219 10.6641 17.7014 10.6311 17.76 10.5725C17.8186 10.5139 17.8516 10.4344 17.8516 10.3516V3.59375C17.8516 3.51087 17.8186 3.43138 17.76 3.37278C17.7014 3.31417 17.6219 3.28125 17.5391 3.28125H2.46094C2.37806 3.28125 2.29857 3.31417 2.23997 3.37278C2.18136 3.43138 2.14844 3.51087 2.14844 3.59375V10.3516C2.14844 10.4344 2.18136 10.5139 2.23997 10.5725C2.29857 10.6311 2.37806 10.6641 2.46094 10.6641ZM2.77344 3.90625H17.2266V10.0391H2.77344V3.90625Z"
        fill="#A855F7"
      />
      <path
        d="M10 5.27344C9.91712 5.27344 9.83763 5.30636 9.77903 5.36497C9.72042 5.42357 9.6875 5.50306 9.6875 5.58594V8.39844C9.6875 8.48132 9.72042 8.5608 9.77903 8.61941C9.83763 8.67801 9.91712 8.71094 10 8.71094C10.0829 8.71094 10.1624 8.67801 10.221 8.61941C10.2796 8.5608 10.3125 8.48132 10.3125 8.39844V5.58594C10.3125 5.50306 10.2796 5.42357 10.221 5.36497C10.1624 5.30636 10.0829 5.27344 10 5.27344ZM11.6406 5.27344C11.5577 5.27344 11.4783 5.30636 11.4197 5.36497C11.361 5.42357 11.3281 5.50306 11.3281 5.58594V8.39844C11.3281 8.48132 11.361 8.5608 11.4197 8.61941C11.4783 8.67801 11.5577 8.71094 11.6406 8.71094C11.7235 8.71094 11.803 8.67801 11.8616 8.61941C11.9202 8.5608 11.9531 8.48132 11.9531 8.39844V5.58594C11.9531 5.50306 11.9202 5.42357 11.8616 5.36497C11.803 5.30636 11.7235 5.27344 11.6406 5.27344ZM13.2812 5.27344C13.1984 5.27344 13.1189 5.30636 13.0603 5.36497C13.0017 5.42357 12.9688 5.50306 12.9688 5.58594V8.39844C12.9688 8.48132 13.0017 8.5608 13.0603 8.61941C13.1189 8.67801 13.1984 8.71094 13.2812 8.71094C13.3641 8.71094 13.4436 8.67801 13.5022 8.61941C13.5608 8.5608 13.5938 8.48132 13.5938 8.39844V5.58594C13.5938 5.50306 13.5608 5.42357 13.5022 5.36497C13.4436 5.30636 13.3641 5.27344 13.2812 5.27344ZM14.9219 5.27344C14.839 5.27344 14.7595 5.30636 14.7009 5.36497C14.6423 5.42357 14.6094 5.50306 14.6094 5.58594V8.39844C14.6094 8.48132 14.6423 8.5608 14.7009 8.61941C14.7595 8.67801 14.839 8.71094 14.9219 8.71094C15.0048 8.71094 15.0842 8.67801 15.1428 8.61941C15.2015 8.5608 15.2344 8.48132 15.2344 8.39844V5.58594C15.2344 5.50306 15.2015 5.42357 15.1428 5.36497C15.0842 5.30636 15.0048 5.27344 14.9219 5.27344ZM5.07812 5.27344C4.99524 5.27344 4.91576 5.30636 4.85715 5.36497C4.79855 5.42357 4.76562 5.50306 4.76562 5.58594V8.39844C4.76562 8.48132 4.79855 8.5608 4.85715 8.61941C4.91576 8.67801 4.99524 8.71094 5.07812 8.71094C5.16101 8.71094 5.24049 8.67801 5.2991 8.61941C5.3577 8.5608 5.39062 8.48132 5.39062 8.39844V5.58594C5.39062 5.50306 5.3577 5.42357 5.2991 5.36497C5.24049 5.30636 5.16101 5.27344 5.07812 5.27344ZM6.71875 5.27344C6.63587 5.27344 6.55638 5.30636 6.49778 5.36497C6.43917 5.42357 6.40625 5.50306 6.40625 5.58594V8.39844C6.40625 8.48132 6.43917 8.5608 6.49778 8.61941C6.55638 8.67801 6.63587 8.71094 6.71875 8.71094C6.80163 8.71094 6.88112 8.67801 6.93972 8.61941C6.99833 8.5608 7.03125 8.48132 7.03125 8.39844V5.58594C7.03125 5.50306 6.99833 5.42357 6.93972 5.36497C6.88112 5.30636 6.80163 5.27344 6.71875 5.27344ZM8.35938 5.27344C8.27649 5.27344 8.19701 5.30636 8.1384 5.36497C8.0798 5.42357 8.04688 5.50306 8.04688 5.58594V8.39844C8.04688 8.48132 8.0798 8.5608 8.1384 8.61941C8.19701 8.67801 8.27649 8.71094 8.35938 8.71094C8.44226 8.71094 8.52174 8.67801 8.58035 8.61941C8.63895 8.5608 8.67188 8.48132 8.67188 8.39844V5.58594C8.67188 5.50306 8.63895 5.42357 8.58035 5.36497C8.52174 5.30636 8.44226 5.27344 8.35938 5.27344ZM18.75 11.3281H1.25C1.16712 11.3281 1.08763 11.361 1.02903 11.4197C0.970424 11.4783 0.9375 11.5577 0.9375 11.6406V12.8125C0.9375 12.8954 0.970424 12.9749 1.02903 13.0335C1.08763 13.0921 1.16712 13.125 1.25 13.125H18.75C18.8329 13.125 18.9124 13.0921 18.971 13.0335C19.0296 12.9749 19.0625 12.8954 19.0625 12.8125V11.6406C19.0625 11.5577 19.0296 11.4783 18.971 11.4197C18.9124 11.361 18.8329 11.3281 18.75 11.3281ZM18.4375 12.5391H1.5625V11.9531H18.4375V12.5391ZM2.63582 13.505C2.31914 13.505 2.00957 13.5989 1.74626 13.7749C1.48295 13.9508 1.27772 14.2009 1.15653 14.4935C1.03534 14.786 1.00363 15.108 1.06541 15.4186C1.1272 15.7292 1.27969 16.0145 1.50362 16.2384C1.72755 16.4623 2.01285 16.6148 2.32345 16.6766C2.63404 16.7384 2.95599 16.7067 3.24856 16.5855C3.54114 16.4643 3.79121 16.2591 3.96715 15.9958C4.14309 15.7325 4.23699 15.4229 4.23699 15.1062C4.23652 14.6817 4.06767 14.2747 3.76749 13.9745C3.46732 13.6744 3.06033 13.5055 2.63582 13.505ZM2.63582 16.0824C2.44275 16.0824 2.25402 16.0251 2.09349 15.9179C1.93296 15.8106 1.80784 15.6581 1.73396 15.4798C1.66007 15.3014 1.64074 15.1051 1.67841 14.9158C1.71607 14.7264 1.80904 14.5525 1.94556 14.416C2.08208 14.2794 2.25602 14.1865 2.44538 14.1488C2.63474 14.1111 2.83101 14.1305 3.00939 14.2043C3.18776 14.2782 3.34021 14.4033 3.44748 14.5639C3.55474 14.7244 3.61199 14.9131 3.61199 15.1062C3.6117 15.365 3.50876 15.6131 3.32576 15.7961C3.14275 15.9792 2.89463 16.0821 2.63582 16.0824ZM6.72703 13.505C6.41035 13.505 6.10078 13.5989 5.83747 13.7749C5.57416 13.9508 5.36893 14.2009 5.24774 14.4935C5.12655 14.786 5.09484 15.108 5.15663 15.4186C5.21841 15.7292 5.3709 16.0145 5.59483 16.2384C5.81876 16.4623 6.10406 16.6148 6.41466 16.6766C6.72525 16.7384 7.0472 16.7067 7.33977 16.5855C7.63235 16.4643 7.88242 16.2591 8.05836 15.9958C8.2343 15.7325 8.3282 15.4229 8.3282 15.1062C8.32773 14.6817 8.15888 14.2747 7.85871 13.9745C7.55853 13.6744 7.15154 13.5055 6.72703 13.505ZM6.72703 16.0824C6.53396 16.0824 6.34523 16.0251 6.1847 15.9179C6.02417 15.8106 5.89905 15.6581 5.82517 15.4798C5.75128 15.3014 5.73195 15.1051 5.76962 14.9158C5.80728 14.7264 5.90025 14.5525 6.03677 14.416C6.17329 14.2794 6.34723 14.1865 6.53659 14.1488C6.72595 14.1111 6.92222 14.1305 7.1006 14.2043C7.27897 14.2782 7.43143 14.4033 7.53869 14.5639C7.64595 14.7244 7.7032 14.9131 7.7032 15.1062C7.70291 15.365 7.59997 15.6131 7.41697 15.7961C7.23396 15.9792 6.98584 16.0821 6.72703 16.0824ZM13.273 13.505C12.9563 13.505 12.6467 13.5989 12.3834 13.7749C12.1201 13.9508 11.9149 14.2009 11.7937 14.4935C11.6725 14.786 11.6408 15.108 11.7026 15.4186C11.7643 15.7292 11.9168 16.0145 12.1408 16.2384C12.3647 16.4623 12.65 16.6148 12.9606 16.6766C13.2712 16.7384 13.5931 16.7067 13.8857 16.5855C14.1783 16.4643 14.4284 16.2591 14.6043 15.9958C14.7802 15.7325 14.8741 15.4229 14.8741 15.1062C14.8737 14.6817 14.7048 14.2747 14.4046 13.9745C14.1045 13.6744 13.6975 13.5055 13.273 13.505ZM13.273 16.0824C13.0799 16.0824 12.8912 16.0251 12.7306 15.9179C12.5701 15.8106 12.445 15.6581 12.3711 15.4798C12.2972 15.3014 12.2779 15.1051 12.3156 14.9158C12.3532 14.7264 12.4462 14.5525 12.5827 14.416C12.7192 14.2794 12.8932 14.1865 13.0825 14.1488C13.2719 14.1111 13.4682 14.1305 13.6465 14.2043C13.8249 14.2782 13.9774 14.4033 14.0846 14.5639C14.1919 14.7244 14.2491 14.9131 14.2491 15.1062C14.2489 15.365 14.1459 15.6131 13.9629 15.7961C13.7799 15.9792 13.5318 16.0821 13.273 16.0824ZM17.3642 13.505C17.0475 13.505 16.7379 13.5989 16.4746 13.7749C16.2113 13.9508 16.0061 14.2009 15.8849 14.4935C15.7637 14.786 15.732 15.108 15.7938 15.4186C15.8556 15.7292 16.0081 16.0145 16.232 16.2384C16.4559 16.4623 16.7412 16.6148 17.0518 16.6766C17.3624 16.7384 17.6843 16.7067 17.9769 16.5855C18.2695 16.4643 18.5196 16.2591 18.6955 15.9958C18.8714 15.7325 18.9654 15.4229 18.9654 15.1062C18.9649 14.6817 18.796 14.2747 18.4959 13.9745C18.1957 13.6744 17.7887 13.5055 17.3642 13.505ZM17.3642 16.0824C17.1711 16.0824 16.9824 16.0251 16.8218 15.9179C16.6613 15.8106 16.5362 15.6581 16.4623 15.4798C16.3884 15.3014 16.3691 15.1051 16.4068 14.9158C16.4444 14.7264 16.5374 14.5525 16.6739 14.416C16.8104 14.2794 16.9844 14.1865 17.1737 14.1488C17.3631 14.1111 17.5594 14.1305 17.7377 14.2043C17.9161 14.2782 18.0686 14.4033 18.1758 14.5639C18.2831 14.7244 18.3404 14.9131 18.3404 15.1062C18.3401 15.365 18.2371 15.6131 18.0541 15.7961C17.8711 15.9792 17.623 16.0821 17.3642 16.0824Z"
        fill="#A855F7"
      />
    </svg>
  );
}
DemmarageHubIcon.propTypes = {
  size: PropTypes.string,
};
DemmarageHubIcon.defaultProps = {
  size: '4.167vw',
};

export function OriginHubIcon({ size }) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 60 51"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect y="0.5" width="60" height="50" rx="10" fill="#F3EFFF" />
      <path
        d="M11.25 14.25C11.0842 14.25 10.9253 14.1842 10.8081 14.0669C10.6908 13.9497 10.625 13.7908 10.625 13.625V11.125C10.625 10.9592 10.6908 10.8003 10.8081 10.6831C10.9253 10.5658 11.0842 10.5 11.25 10.5H18.125V6.75C18.125 6.58424 18.1908 6.42527 18.3081 6.30806C18.4253 6.19085 18.5842 6.125 18.75 6.125H23.75C23.9158 6.125 24.0747 6.19085 24.1919 6.30806C24.3092 6.42527 24.375 6.58424 24.375 6.75V10.5H48.75C48.9158 10.5 49.0747 10.5658 49.1919 10.6831C49.3092 10.8003 49.375 10.9592 49.375 11.125V13.625C49.375 13.7908 49.3092 13.9497 49.1919 14.0669C49.0747 14.1842 48.9158 14.25 48.75 14.25H38.125V15.5H38.75C39.0815 15.5 39.3995 15.6317 39.6339 15.8661C39.8683 16.1005 40 16.4185 40 16.75V19.25C40 19.5815 39.8683 19.8995 39.6339 20.1339C39.3995 20.3683 39.0815 20.5 38.75 20.5H38.125V22.375C38.125 22.5408 38.1908 22.6997 38.3081 22.8169C38.4253 22.9342 38.5842 23 38.75 23C38.9158 23 39.0747 22.9342 39.1919 22.8169C39.3092 22.6997 39.375 22.5408 39.375 22.375V21.75H40.625V22.375C40.6242 22.6399 40.567 22.9015 40.457 23.1425C40.3471 23.3835 40.187 23.5983 39.9875 23.7725L46.625 28.75L46.6188 28.7588C46.6971 28.8147 46.7611 28.8884 46.8056 28.9737C46.8501 29.0591 46.8739 29.1537 46.875 29.25V36.75C46.875 36.9158 46.8092 37.0747 46.6919 37.1919C46.5747 37.3092 46.4158 37.375 46.25 37.375H31.25C31.0842 37.375 30.9253 37.3092 30.8081 37.1919C30.6908 37.0747 30.625 36.9158 30.625 36.75V29.25C30.6261 29.1537 30.6499 29.0591 30.6944 28.9737C30.7389 28.8884 30.8029 28.8147 30.8813 28.7588L30.875 28.75L37.5125 23.7725C37.313 23.5983 37.1529 23.3835 37.043 23.1425C36.933 22.9015 36.8758 22.6399 36.875 22.375V20.5H36.25C35.9185 20.5 35.6005 20.3683 35.3661 20.1339C35.1317 19.8995 35 19.5815 35 19.25V16.75C35 16.4185 35.1317 16.1005 35.3661 15.8661C35.6005 15.6317 35.9185 15.5 36.25 15.5H36.875V14.25H24.375V34.875H25.625C25.9565 34.875 26.2745 35.0067 26.5089 35.2411C26.7433 35.4755 26.875 35.7935 26.875 36.125V41.24C27.2393 41.3688 27.5549 41.607 27.7787 41.9221C28.0024 42.2371 28.1234 42.6136 28.125 43V44.25C28.125 44.4158 28.0592 44.5747 27.9419 44.6919C27.8247 44.8092 27.6658 44.875 27.5 44.875H15C14.8342 44.875 14.6753 44.8092 14.5581 44.6919C14.4408 44.5747 14.375 44.4158 14.375 44.25V43C14.3766 42.6136 14.4976 42.2371 14.7213 41.9221C14.9451 41.607 15.2607 41.3688 15.625 41.24V36.125C15.625 35.7935 15.7567 35.4755 15.9911 35.2411C16.2255 35.0067 16.5435 34.875 16.875 34.875H18.125V14.25H15.625V15.5H16.25C16.4158 15.5 16.5747 15.5658 16.6919 15.6831C16.8092 15.8003 16.875 15.9592 16.875 16.125V21.125C16.875 21.2908 16.8092 21.4497 16.6919 21.5669C16.5747 21.6842 16.4158 21.75 16.25 21.75H11.25C11.0842 21.75 10.9253 21.6842 10.8081 21.5669C10.6908 21.4497 10.625 21.2908 10.625 21.125V16.125C10.625 15.9592 10.6908 15.8003 10.8081 15.6831C10.9253 15.5658 11.0842 15.5 11.25 15.5H11.875V14.25H11.25ZM38.75 24.4062L33.125 28.625H44.375L38.75 24.4062ZM31.875 36.125H45.625V29.875H31.875V36.125ZM36.25 19.25H38.75V16.75H36.25V19.25ZM19.375 9.75L22.0869 7.375H19.375V9.75ZM23.125 8.125L20.4131 10.5H23.125V8.125ZM48.125 13V11.75H38.125V13H48.125ZM36.875 11.75H11.875V13H36.875V11.75ZM23.125 22.3125L19.8531 24.5625L23.125 26.8125V22.3125ZM23.125 29.1875L19.8531 31.4375L23.125 33.6875V29.1875ZM19.375 30.25L22.6469 28L19.375 25.75V30.25ZM19.375 23.375L22.6469 21.125L19.375 18.875V23.375ZM23.125 19.9375V15.4375L19.8531 17.6875L23.125 19.9375ZM15.625 43.625H26.875V43C26.875 42.8342 26.8092 42.6753 26.6919 42.5581C26.5747 42.4408 26.4158 42.375 26.25 42.375H16.25C16.0842 42.375 15.9253 42.4408 15.8081 42.5581C15.6908 42.6753 15.625 42.8342 15.625 43V43.625ZM16.875 41.125H25.625V36.125H16.875V41.125ZM22.6469 34.875L19.375 32.625V34.875H22.6469ZM19.375 16.5L22.6469 14.25H19.375V16.5ZM11.875 20.5H15.625V16.75H11.875V20.5ZM13.125 15.5H14.375V14.25H13.125V15.5Z"
        fill="#6366F1"
      />
      <path d="M16.875 31.125H15.625V34.875H16.875V31.125Z" fill="#6366F1" />
      <path d="M19.375 31.125H18.125V34.875H19.375V31.125Z" fill="#6366F1" />
      <path d="M21.875 31.125H20.625V34.875H21.875V31.125Z" fill="#6366F1" />
      <path d="M24.375 31.125H23.125V34.875H24.375V31.125Z" fill="#6366F1" />
      <path d="M26.875 31.125H25.625V34.875H26.875V31.125Z" fill="#6366F1" />
    </svg>
  );
}
OriginHubIcon.propTypes = {
  size: PropTypes.string,
};
OriginHubIcon.defaultProps = {
  size: '4.167vw',
};

export function PinkPinIcon({ size }) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M4.77593 15.2869L2.67093 18.5369L2.89493 19.5999L3.95493 19.3729L6.05893 16.1249C5.60648 15.8855 5.17701 15.6049 4.77593 15.2869ZM13.6879 14.1519C13.7019 14.1229 13.7109 14.0909 13.7239 14.0599C13.7769 13.9429 13.8239 13.8259 13.8619 13.7029C13.8679 13.6809 13.8709 13.6589 13.8779 13.6389C13.9169 13.5045 13.9497 13.3683 13.9759 13.2309V13.2099C14.1709 12.0409 13.8309 10.7369 13.0529 9.55889L14.1629 7.84489C15.4419 8.00789 16.5479 7.68589 17.0799 6.86289C18.0029 5.43989 16.8799 3.07089 14.5749 1.56989C12.2679 0.0678897 9.65193 0.00488961 8.73093 1.42589C8.19693 2.24989 8.35293 3.39289 9.02393 4.49889L7.91193 6.21289C6.52293 5.97989 5.19593 6.19689 4.20893 6.85289C4.20293 6.85489 4.19593 6.85689 4.19193 6.86089C4.07661 6.93929 3.96577 7.02409 3.85993 7.11489C3.84293 7.12889 3.82293 7.14189 3.80893 7.15589C3.71292 7.24072 3.62241 7.33157 3.53793 7.42789C3.51793 7.45189 3.48993 7.47289 3.47093 7.49789C3.36442 7.61851 3.26746 7.74723 3.18093 7.88289C1.79693 10.0159 2.97793 13.2439 5.81393 15.0919C8.65193 16.9399 12.0739 16.7059 13.4549 14.5729C13.5419 14.4379 13.6219 14.2969 13.6879 14.1519ZM12.8729 4.19389C11.9859 3.61689 11.5529 2.70689 11.9079 2.15789C12.2619 1.61089 13.2689 1.63589 14.1539 2.21289C15.0429 2.78989 15.4719 3.70189 15.1189 4.24889C14.7659 4.79589 13.7609 4.77089 12.8729 4.19389Z"
        fill="url(#paint0_linear_31776_52464)"
      />
      <defs>
        <linearGradient
          id="paint0_linear_31776_52464"
          x1="10.0022"
          y1="0.400391"
          x2="10.0022"
          y2="19.5999"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="#FB93BE" />
          <stop offset="1" stop-color="#BF185E" />
        </linearGradient>
      </defs>
    </svg>
  );
}
PinkPinIcon.propTypes = {
  size: PropTypes.string,
};
PinkPinIcon.defaultProps = {
  size: '1.389vw',
};
export function PendingTime() {
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M7.9987 1.33337C4.32536 1.33337 1.33203 4.32671 1.33203 8.00004C1.33203 11.6734 4.32536 14.6667 7.9987 14.6667C11.672 14.6667 14.6654 11.6734 14.6654 8.00004C14.6654 4.32671 11.672 1.33337 7.9987 1.33337ZM10.8987 10.38C10.8054 10.54 10.6387 10.6267 10.4654 10.6267C10.3787 10.6267 10.292 10.6067 10.212 10.5534L8.14536 9.32004C7.63203 9.01337 7.25203 8.34004 7.25203 7.74671V5.01337C7.25203 4.74004 7.4787 4.51337 7.75203 4.51337C8.02536 4.51337 8.25203 4.74004 8.25203 5.01337V7.74671C8.25203 7.98671 8.45203 8.34004 8.6587 8.46004L10.7254 9.69337C10.9654 9.83337 11.0454 10.14 10.8987 10.38Z"
        fill="#F2C94C"
      />
    </svg>
  );
}
export function BlueFlowerVerified() {
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M16 8.375C16 8.93437 15.8656 9.45312 15.5969 9.92813C15.3281 10.4031 14.9688 10.775 14.5156 11.0344C14.5281 11.1188 14.5344 11.25 14.5344 11.4281C14.5344 12.275 14.25 12.9937 13.6875 13.5875C13.1219 14.1844 12.4406 14.4812 11.6438 14.4812C11.2875 14.4812 10.9469 14.4156 10.625 14.2844C10.375 14.7969 10.0156 15.2094 9.54375 15.525C9.075 15.8438 8.55937 16 8 16C7.42812 16 6.90938 15.8469 6.44688 15.5344C5.98125 15.225 5.625 14.8094 5.375 14.2844C5.05312 14.4156 4.71562 14.4812 4.35625 14.4812C3.55937 14.4812 2.875 14.1844 2.30312 13.5875C1.73125 12.9937 1.44687 12.2719 1.44687 11.4281C1.44687 11.3344 1.45938 11.2031 1.48125 11.0344C1.02813 10.7719 0.66875 10.4031 0.4 9.92813C0.134375 9.45312 0 8.93437 0 8.375C0 7.78125 0.15 7.23438 0.446875 6.74062C0.74375 6.24687 1.14375 5.88125 1.64375 5.64375C1.5125 5.2875 1.44687 4.92812 1.44687 4.57188C1.44687 3.72813 1.73125 3.00625 2.30312 2.4125C2.875 1.81875 3.55937 1.51875 4.35625 1.51875C4.7125 1.51875 5.05312 1.58438 5.375 1.71563C5.625 1.20312 5.98438 0.790625 6.45625 0.475C6.925 0.159375 7.44063 0 8 0C8.55937 0 9.075 0.159375 9.54375 0.471875C10.0125 0.7875 10.375 1.2 10.625 1.7125C10.9469 1.58125 11.2844 1.51562 11.6438 1.51562C12.4406 1.51562 13.1219 1.8125 13.6875 2.40937C14.2531 3.00625 14.5344 3.725 14.5344 4.56875C14.5344 4.9625 14.475 5.31875 14.3562 5.64062C14.8562 5.87813 15.2563 6.24375 15.5531 6.7375C15.85 7.23438 16 7.78125 16 8.375ZM7.65938 10.7844L10.9625 5.8375C11.0469 5.70625 11.0719 5.5625 11.0437 5.40938C11.0125 5.25625 10.9344 5.13438 10.8031 5.05312C10.6719 4.96875 10.5281 4.94063 10.375 4.9625C10.2188 4.9875 10.0938 5.0625 10 5.19375L7.09062 9.56875L5.75 8.23125C5.63125 8.1125 5.49375 8.05625 5.34062 8.0625C5.18437 8.06875 5.05 8.125 4.93125 8.23125C4.825 8.3375 4.77187 8.47187 4.77187 8.63437C4.77187 8.79375 4.825 8.92813 4.93125 9.0375L6.77187 10.8781L6.8625 10.95C6.96875 11.0219 7.07812 11.0562 7.18437 11.0562C7.39375 11.0531 7.55313 10.9656 7.65938 10.7844Z"
        fill="#2179C4"
      />
    </svg>
  );
}
export function ArrowHorizontal() {
  return (
    <svg
      width="1.944vw"
      height="0.903vw"
      viewBox="0 0 28 13"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M28 6.5L18 0.726497V12.2735L28 6.5ZM0 7.5H19V5.5H0V7.5Z"
        fill="#2179C4"
      />
    </svg>
  );
}
export function FileCloudIcon() {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M7.4974 18.9583C2.9724 18.9583 1.03906 17.025 1.03906 12.5V7.49996C1.03906 2.97496 2.9724 1.04163 7.4974 1.04163H11.6641C12.0057 1.04163 12.2891 1.32496 12.2891 1.66663C12.2891 2.00829 12.0057 2.29163 11.6641 2.29163H7.4974C3.65573 2.29163 2.28906 3.65829 2.28906 7.49996V12.5C2.28906 16.3416 3.65573 17.7083 7.4974 17.7083C7.83906 17.7083 8.1224 17.9916 8.1224 18.3333C8.1224 18.675 7.83906 18.9583 7.4974 18.9583Z"
        fill="#616B80"
      />
      <path
        d="M18.3359 11.4584C17.9943 11.4584 17.7109 11.175 17.7109 10.8334V8.33337C17.7109 7.99171 17.9943 7.70837 18.3359 7.70837C18.6776 7.70837 18.9609 7.99171 18.9609 8.33337V10.8334C18.9609 11.175 18.6776 11.4584 18.3359 11.4584Z"
        fill="#616B80"
      />
      <path
        d="M18.3307 8.95828H14.9974C12.1474 8.95828 11.0391 7.84995 11.0391 4.99995V1.66662C11.0391 1.41662 11.1891 1.18328 11.4224 1.09162C11.6557 0.991616 11.9224 1.04995 12.1057 1.22495L18.7724 7.89162C18.9474 8.06662 19.0057 8.34163 18.9057 8.57496C18.8057 8.80829 18.5807 8.95828 18.3307 8.95828ZM12.2891 3.17495V4.99995C12.2891 7.14995 12.8474 7.70828 14.9974 7.70828H16.8224L12.2891 3.17495Z"
        fill="#616B80"
      />
      <path
        d="M16.1167 18.9583C16.1083 18.9583 16.1 18.9583 16.1 18.9583H11.4667C10.075 18.8583 9.375 17.7917 9.375 16.775C9.375 15.9583 9.83333 15.1 10.7167 14.75C10.5333 13.7083 10.8 12.7417 11.4917 12.0167C12.3417 11.125 13.7083 10.7666 14.8917 11.1333C15.925 11.45 16.6667 12.2666 16.975 13.4C17.85 13.6666 18.5417 14.3583 18.825 15.3C19.1583 16.3916 18.85 17.5083 18.025 18.225C17.5167 18.6917 16.8333 18.9583 16.1167 18.9583ZM11.4917 15.8417C10.8583 15.9 10.625 16.375 10.625 16.775C10.625 17.175 10.8583 17.6583 11.5083 17.7083H16.1C16.525 17.6833 16.9 17.5583 17.2 17.2917C17.7417 16.8167 17.7833 16.1417 17.6333 15.6583C17.4833 15.175 17.075 14.6333 16.375 14.5417C16.1 14.5083 15.8833 14.3 15.8333 14.025C15.65 12.9 15.0167 12.4833 14.525 12.3333C13.8 12.1083 12.925 12.3333 12.4 12.8917C12.0417 13.2667 11.6917 13.9416 12.0833 15.0166C12.2 15.3416 12.0333 15.7 11.7083 15.8167C11.6333 15.8333 11.5583 15.8417 11.4917 15.8417Z"
        fill="#616B80"
      />
    </svg>
  );
}
export function ApprovalImg() {
  return (
    <svg
      width="300"
      height="221"
      viewBox="0 0 400 321"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clip-path="url(#clip0_33060_160669)">
        <path
          d="M263.084 37.2142L273.751 28.2056L266.321 25.5747L263.084 37.2142Z"
          fill="white"
        />
        <path
          d="M396.875 118.276V95.8423L385.219 105.17L396.875 118.276Z"
          fill="#2179C4"
        />
        <path
          d="M391.74 94.2158V96.0973L394.084 94.2158H391.74Z"
          fill="#2179C4"
        />
        <path
          d="M388.727 98.5051C388.727 98.4732 388.727 98.4413 388.727 98.4254V76.6611H359.74V97.7876L374.265 110.081L388.727 98.5051ZM365.799 81.7315H382.859C383.688 81.7315 384.374 82.4012 384.374 83.2462C384.374 84.0913 383.704 84.7609 382.859 84.7609H365.799C364.97 84.7609 364.284 84.0913 364.284 83.2462C364.284 82.4012 364.97 81.7315 365.799 81.7315ZM364.3 89.8791C364.3 89.05 364.97 88.3644 365.815 88.3644H379.064C379.894 88.3644 380.579 89.0341 380.579 89.8791C380.579 90.7242 379.91 91.3939 379.064 91.3939H365.815C364.97 91.3939 364.3 90.7083 364.3 89.8791Z"
          fill="white"
        />
        <path
          d="M357.46 99.8286C357.3 99.7329 357.157 99.6213 357.045 99.4778L352.884 95.9541V117.989L363.487 104.931L357.46 99.8286Z"
          fill="#2179C4"
        />
        <path
          d="M375.158 113.206C374.887 113.429 374.552 113.541 374.218 113.541C373.867 113.541 373.516 113.429 373.245 113.19L365.799 106.876L354.542 120.732H395.025L382.859 107.051L375.158 113.206Z"
          fill="#2179C4"
        />
        <path
          d="M356.71 94.2158H355.499L356.71 95.2363V94.2158Z"
          fill="#2179C4"
        />
        <path
          d="M395.822 184.111H314.697C314.553 184.478 314.426 184.861 314.282 185.243C312.752 189.58 309.818 192.642 306.007 193.853C305.018 194.172 304.046 194.332 303.105 194.332C301.431 194.332 299.9 193.837 298.673 192.881C297.939 192.307 297.349 191.589 296.935 190.76C295.595 192.753 293.634 194.667 290.971 195.049C290.557 195.113 290.174 195.129 289.807 195.129C287.735 195.129 286.395 194.284 285.598 193.503C284.96 192.865 284.45 192.068 284.083 191.143C282.601 192.498 280.671 193.519 278.551 193.519C278.503 193.519 278.439 193.519 278.391 193.519C275.633 193.455 273.847 191.653 272.779 190.011C270.212 192.195 267.852 192.482 267.102 192.514C267.007 192.514 266.911 192.514 266.815 192.514C265.109 192.514 263.515 191.844 262.176 190.569C260.454 188.927 259.561 186.678 259.449 184.127H193.247C192.61 184.127 192.083 184.653 192.083 185.291V197.074H396.795C396.859 197.074 396.923 197.074 396.986 197.09V185.291C396.986 184.638 396.46 184.111 395.822 184.111Z"
          fill="#1D3E69"
        />
        <path
          d="M269.781 220.178V245.322L282.935 232.088L269.781 220.178Z"
          fill="#2179C4"
        />
        <path
          d="M266.975 189.484C268.601 189.421 270.291 188.273 271.503 187.077C270.849 184.366 271.216 180.683 272.587 176.681C273.719 173.349 275.377 170.351 277.243 168.151C276.637 167.959 275.808 167.8 274.771 167.832C273.065 167.895 270.53 168.501 268.186 171.1C262.478 177.446 260.74 185.036 264.248 188.368C265.093 189.165 265.97 189.516 266.975 189.484Z"
          fill="#FFD6D3"
        />
        <path
          d="M274.755 187.316C275.712 189.373 276.956 190.441 278.471 190.489C278.502 190.489 278.518 190.489 278.55 190.489C280.288 190.489 282.345 189.102 283.445 187.189C283.461 186.838 283.477 186.471 283.525 186.12C283.541 185.977 285.056 174.704 290.174 168.167C286.379 165.95 282.791 167.274 281.309 168.406C276.541 171.993 272.73 182.963 274.755 187.316Z"
          fill="#FFD6D3"
        />
        <path
          d="M315.43 218.28H272.188L293.203 237.334L315.43 218.28Z"
          fill="#2179C4"
        />
        <path
          d="M192.083 200.072V316.18C192.083 316.817 192.61 317.344 193.247 317.344H395.807C396.444 317.344 396.97 316.817 396.97 316.18V200.072C396.907 200.072 396.843 200.088 396.779 200.088H192.083V200.072ZM321.027 248.974C321.027 249.053 321.011 249.133 321.011 249.213C321.011 249.229 321.011 249.229 321.011 249.245C320.995 249.324 320.979 249.42 320.947 249.5C320.947 249.516 320.947 249.516 320.931 249.532C320.899 249.611 320.867 249.691 320.82 249.771C320.82 249.787 320.804 249.787 320.804 249.803C320.756 249.882 320.692 249.946 320.628 250.026C320.628 250.026 320.628 250.042 320.612 250.042C320.548 250.106 320.469 250.169 320.389 250.233C320.389 250.233 320.389 250.233 320.373 250.233C320.293 250.281 320.198 250.329 320.118 250.377C320.022 250.409 319.943 250.44 319.831 250.456C319.735 250.472 319.64 250.488 319.544 250.488H268.298C268.203 250.488 268.107 250.472 268.027 250.456H268.011C267.916 250.44 267.836 250.409 267.756 250.377C267.756 250.377 267.74 250.377 267.74 250.361C267.66 250.329 267.581 250.281 267.501 250.233L267.485 250.217C267.405 250.169 267.326 250.106 267.262 250.026C267.198 249.962 267.134 249.882 267.071 249.803C267.071 249.803 267.071 249.787 267.055 249.787C267.007 249.707 266.959 249.627 266.927 249.548V249.532C266.895 249.452 266.863 249.356 266.847 249.261C266.847 249.261 266.847 249.261 266.847 249.245C266.831 249.149 266.815 249.069 266.815 248.974V216.782C266.815 216.718 266.815 216.654 266.831 216.59C266.831 216.574 266.831 216.558 266.831 216.558C266.847 216.479 266.863 216.383 266.895 216.303C266.895 216.287 266.911 216.287 266.911 216.271C266.943 216.192 266.975 216.112 267.023 216.032C267.023 216.016 267.039 216.016 267.039 216C267.087 215.921 267.134 215.857 267.198 215.793C267.198 215.793 267.198 215.777 267.214 215.777L267.23 215.761C267.294 215.697 267.358 215.634 267.421 215.586C267.437 215.57 267.437 215.57 267.453 215.57C267.517 215.522 267.597 215.474 267.676 215.442C267.692 215.442 267.692 215.426 267.708 215.426C267.788 215.394 267.868 215.363 267.948 215.347C267.963 215.347 267.963 215.347 267.979 215.331C268.059 215.315 268.139 215.299 268.235 215.299C268.25 215.299 268.266 215.299 268.282 215.299C268.298 215.299 268.314 215.299 268.33 215.299H319.576C319.608 215.299 319.64 215.299 319.672 215.299C319.687 215.299 319.687 215.299 319.703 215.299C319.799 215.299 319.879 215.315 319.958 215.347C319.974 215.347 319.974 215.347 319.99 215.347C320.07 215.378 320.15 215.394 320.23 215.442C320.246 215.442 320.245 215.458 320.261 215.458C320.341 215.506 320.405 215.538 320.485 215.602C320.501 215.602 320.501 215.618 320.517 215.618C320.596 215.681 320.66 215.745 320.724 215.809C320.724 215.809 320.724 215.809 320.74 215.825C320.804 215.905 320.851 215.984 320.899 216.064V216.08C320.947 216.16 320.979 216.255 321.011 216.335C321.011 216.335 321.011 216.335 321.011 216.351C321.043 216.431 321.059 216.527 321.075 216.622V216.638C321.075 216.686 321.091 216.75 321.091 216.798V248.974H321.027Z"
          fill="white"
        />
        <path
          d="M294.16 240.491C293.873 240.73 293.522 240.857 293.172 240.857C292.805 240.857 292.438 240.73 292.151 240.459L285.152 234.113L271.886 247.458H315.749L301.718 233.985L294.16 240.491Z"
          fill="#2179C4"
        />
        <path
          d="M318.013 245.433V220.05L304.03 232.024L318.013 245.433Z"
          fill="#2179C4"
        />
        <path
          d="M286.523 186.455C286.283 188.464 286.746 190.377 287.718 191.318C288.388 191.972 289.313 192.211 290.557 192.035C294.064 191.541 296.089 185.929 296.36 185.115C296.472 184.398 296.647 183.856 296.871 183.106C296.934 182.883 297.014 182.628 297.094 182.325C298.337 178.02 300.586 173.635 303.089 170.606C303.775 169.777 304.492 169.027 305.226 168.374C303.089 167.002 299.151 165.233 295.356 167.417C292.9 168.836 290.684 172.105 288.93 176.872C287.463 180.874 286.73 184.781 286.523 186.455Z"
          fill="#FFD6D3"
        />
        <path
          d="M110.272 77.793C119.504 77.793 127.014 70.2832 127.014 61.0513C127.014 51.8194 119.504 44.3096 110.272 44.3096C101.04 44.3096 93.5303 51.8194 93.5303 61.0513C93.5303 70.2832 101.04 77.793 110.272 77.793Z"
          fill="#333333"
        />
        <path
          d="M291.609 6.20215L242.021 13.7758L253.326 17.7779L291.609 6.20215Z"
          fill="white"
        />
        <path
          d="M255.925 22.402C256.515 24.2516 257.328 26.8186 258.333 30.0235C259.002 32.176 259.672 34.3285 260.246 36.1621L263.849 23.1992C263.961 22.7687 264.264 22.4179 264.663 22.2425L292.964 8.94482L255.255 20.3452C255.431 20.8873 255.654 21.5729 255.925 22.402Z"
          fill="white"
        />
        <path
          d="M287.224 29.7683L306.947 5.70801L269.271 23.4064L287.224 29.7683Z"
          fill="white"
        />
        <path
          d="M299.757 184C299.549 184.685 299.422 185.1 299.342 185.61C299.342 185.674 299.326 185.738 299.31 185.785C299.262 186.104 299.23 186.455 299.198 186.933C299.087 188.496 299.549 189.724 300.538 190.505C301.654 191.382 303.312 191.557 305.098 190.983C308.797 189.803 310.583 186.662 311.444 184.239C311.715 183.474 312.002 182.74 312.273 182.023C312.751 180.763 313.214 179.567 313.564 178.308C313.788 177.51 314.617 177.032 315.43 177.255C316.227 177.478 316.706 178.307 316.482 179.121C316.291 179.79 316.084 180.444 315.845 181.098H329.732C328.202 177.829 323.61 169.825 314.728 168.183C311.444 167.577 308.319 169.044 305.417 172.552C303.169 175.278 301.128 179.264 299.996 183.187C299.9 183.489 299.82 183.761 299.757 184Z"
          fill="#FFD6D3"
        />
        <path
          d="M96.0495 153.402C94.8537 153.577 93.9927 154.566 93.6897 155.172C93.2273 156.16 92.9722 157.276 92.7012 158.456C92.4301 159.668 92.1431 160.912 91.601 162.139C90.8675 163.814 89.7355 165.424 88.428 166.668C87.3597 167.688 86.148 168.326 84.9202 168.549C82.9431 168.884 80.9979 168.023 79.6904 166.237C77.4741 163.208 76.8045 157.133 79.2121 153.513C80.7587 151.202 83.2142 150.325 86.1639 151.042C89.879 151.935 92.8287 151.68 94.2637 150.325C95.4436 149.208 95.4117 147.502 95.1885 146.259C94.9334 144.856 94.0724 143.676 92.6693 142.751C89.4485 140.63 83.852 140.216 77.7133 141.619C68.6728 143.692 69.199 153.067 69.2308 153.466C69.2946 154.295 68.6568 155.012 67.8277 155.076C67.7639 155.076 67.6842 155.076 67.6204 155.076C67.6045 155.076 67.6045 155.076 67.5886 155.076C67.2059 155.076 66.8232 154.933 66.5362 154.646C66.4884 154.598 66.2333 154.327 65.149 153.226C62.0877 150.101 54.9286 142.751 53.5095 141.396C52.2659 140.216 50.1612 139.068 48.2479 139.147C47.2593 139.195 46.494 139.562 45.8721 140.264C44.5806 141.746 44.8357 144.25 45.6489 146.131C48.3754 147.471 53.7965 152.286 62.9168 161.502L63.3951 161.98C63.9851 162.57 63.9851 163.527 63.3951 164.117C63.1081 164.404 62.7095 164.547 62.3269 164.547C61.9442 164.547 61.5456 164.404 61.2586 164.101L60.7802 163.606C49.348 152.063 45.3778 149.145 44.0704 148.714C43.3051 148.475 42.1571 148.252 40.9931 148.666C39.3827 149.24 38.4101 150.675 38.3463 152.621C38.2985 153.992 38.713 155.873 40.0683 156.623C40.1959 156.686 40.2915 156.766 40.3872 156.862C42.8905 157.787 45.1546 160.083 47.1955 162.171C47.5304 162.506 47.8492 162.825 48.1522 163.144C49.9858 164.962 51.8035 166.763 53.6371 168.581L55.8693 170.797C56.4593 171.387 56.4593 172.344 55.8853 172.934C55.2953 173.524 54.3387 173.524 53.7487 172.95L51.5165 170.734C49.6829 168.916 47.8652 167.114 46.0316 165.296C45.7127 164.978 45.3778 164.643 45.043 164.308C42.8586 162.076 40.1321 159.301 37.8839 159.493C35.859 159.652 34.5675 160.417 34.0413 161.773C33.1006 164.18 34.5675 168.23 37.5172 171.419C41.583 175.804 46.4461 180.874 51.7397 185.387C52.9355 186.407 54.1154 187.475 55.2634 188.496C58.7075 191.605 61.9601 194.539 65.9144 196.675C73.5677 200.837 81.6835 200.534 88.1889 195.83C94.0086 191.621 98.489 184.733 100.179 177.398C101.758 170.542 102.491 158.106 100.275 155.618C99.2065 154.486 97.644 153.179 96.0495 153.402ZM76.6769 183.968C76.3899 184.255 76.0073 184.398 75.6246 184.398C75.226 184.398 74.8433 184.239 74.5404 183.936C70.8253 180.093 65.2128 178.18 59.9192 178.913C59.0901 179.041 58.3248 178.451 58.2132 177.622C58.1016 176.792 58.6756 176.027 59.5047 175.916C65.739 175.039 72.3241 177.303 76.7088 181.815C77.2988 182.421 77.2828 183.378 76.6769 183.968Z"
          fill="#FFD6D3"
        />
        <path
          d="M189.07 185.275C189.07 182.963 190.951 181.098 193.247 181.098H259.656C259.656 181.066 259.672 181.034 259.672 181.002C242.133 172.28 221.868 167.082 197.791 165.121C190.313 170.351 183.043 171.945 176.968 171.945C174.098 171.945 171.499 171.595 169.267 171.1C162.921 169.697 158.44 166.987 156.989 166.046C152.876 166.716 148.618 167.306 144.489 167.864C130.537 169.793 116.108 171.786 103.288 177.064C103.209 177.494 103.129 177.845 103.081 178.1C101.279 185.977 96.4959 193.407 90.2616 198.047C88.5077 202.16 72.6588 239.04 66.2491 251.429C65.9781 251.955 65.4519 252.242 64.9098 252.242C64.6706 252.242 64.4315 252.194 64.2242 252.067C63.4907 251.684 63.1878 250.775 63.5705 250.026C68.9916 239.566 81.2529 211.344 85.8609 200.661C82.959 201.969 79.8817 202.639 76.7247 202.639C72.6588 202.639 68.4973 201.538 64.4474 199.338C60.1902 197.026 56.6505 193.837 53.2225 190.744C52.0904 189.723 50.9265 188.671 49.7625 187.683C46.8287 185.179 44.0384 182.517 41.4395 179.902C36.0821 187.746 7.41388 230.318 3.95393 246.486C1.49847 257.934 4.11337 268.984 11.3203 277.594C18.6229 286.315 29.9754 291.418 41.9178 291.418C42.4121 291.418 42.9064 291.402 43.4007 291.386C62.3906 290.716 71.75 283.254 98.744 253.98L97.6917 227.847C97.6598 227.018 98.3135 226.316 99.1427 226.284C99.1586 226.284 99.1905 226.284 99.2064 226.284C100.02 226.284 100.673 226.922 100.721 227.735L104.404 318.938H190.154C189.5 318.204 189.102 317.232 189.102 316.179V185.275H189.07Z"
          fill="#2179C4"
        />
        <path
          d="M210.356 133.934C210.675 133.168 211.552 132.802 212.333 133.105C213.098 133.424 213.465 134.301 213.162 135.082C213.13 135.146 213.098 135.209 213.082 135.273C214.278 135.656 215.506 135.767 216.749 135.592C221.389 134.986 224.674 130.697 224.068 126.057C223.462 121.465 219.38 118.244 214.772 118.707C214.166 118.771 213.577 118.452 213.29 117.91L209.287 110.432C191.589 111.58 177.765 108.71 168.198 101.885C163.064 98.2181 160.545 94.3436 159.461 92.207C145.031 100.339 141.061 117.352 141.013 117.527C140.838 118.276 140.152 118.771 139.387 118.691C134.779 118.213 130.697 121.433 130.091 126.041C129.788 128.289 130.394 130.522 131.765 132.323C133.152 134.125 135.145 135.289 137.394 135.576C138.589 135.736 139.753 135.64 140.901 135.305C140.79 135.05 140.694 134.811 140.598 134.556C140.296 133.774 140.662 132.897 141.444 132.594C142.225 132.292 143.102 132.658 143.405 133.44C148.236 145.605 159.285 154.231 172.264 155.937C188.464 158.106 204.137 149.049 210.356 133.934ZM211.775 126.791C215.235 124.941 218.998 124.941 219.157 124.941C219.986 124.941 220.656 125.627 220.656 126.456C220.656 127.285 219.97 127.955 219.141 127.955C219.109 127.955 215.968 127.971 213.194 129.453C212.971 129.581 212.731 129.629 212.492 129.629C211.95 129.629 211.424 129.342 211.153 128.832C210.77 128.098 211.041 127.189 211.775 126.791ZM142.958 128.832C142.687 129.342 142.161 129.629 141.619 129.629C141.38 129.629 141.141 129.565 140.917 129.453C138.143 127.971 135.002 127.955 134.97 127.955C134.141 127.955 133.455 127.285 133.455 126.456C133.455 125.627 134.125 124.941 134.954 124.941C135.098 124.941 138.861 124.941 142.336 126.791C143.086 127.189 143.357 128.098 142.958 128.832ZM173.301 122.342C174.417 121.338 177.223 120.046 179.79 122.246C180.428 122.789 180.492 123.745 179.95 124.367C179.407 125.005 178.451 125.069 177.829 124.527C176.617 123.49 175.437 124.479 175.31 124.59C175.023 124.845 174.672 124.973 174.305 124.973C173.891 124.973 173.476 124.798 173.173 124.463C172.615 123.857 172.679 122.9 173.301 122.342ZM163.83 120.54C162.028 120.54 160.561 119.074 160.561 117.272C160.561 115.47 162.028 114.003 163.83 114.003C165.631 114.003 167.098 115.47 167.098 117.272C167.098 119.089 165.631 120.54 163.83 120.54ZM185.036 130.888C181.911 132.738 179.041 133.376 176.553 133.376C171.451 133.376 168.071 130.697 167.864 130.522C167.21 129.996 167.114 129.039 167.64 128.401C168.167 127.763 169.107 127.652 169.761 128.178C170.016 128.385 175.788 132.866 183.489 128.289C184.207 127.859 185.132 128.098 185.562 128.816C185.993 129.549 185.753 130.474 185.036 130.888ZM189.835 120.54C188.033 120.54 186.567 119.074 186.567 117.272C186.567 115.47 188.033 114.003 189.835 114.003C191.637 114.003 193.104 115.47 193.104 117.272C193.104 119.089 191.637 120.54 189.835 120.54Z"
          fill="#FFD6D3"
        />
        <path
          d="M138.382 115.645C139.658 111.197 144.92 96.0656 159.493 88.7789C159.892 88.5876 160.354 88.5717 160.753 88.7311C161.151 88.9065 161.47 89.2413 161.598 89.6559C162.188 91.4257 164.723 95.7945 170.128 99.5734C176.426 103.99 188.464 108.917 210.021 107.338C210.627 107.291 211.185 107.609 211.456 108.136L215.458 115.63C217.467 115.598 219.381 116.076 221.055 116.969C221.214 116.395 222.649 110.91 223.143 104.102C223.622 97.6122 223.335 88.5717 219.237 82.2736C216.526 78.1121 212.046 75.3856 205.923 74.1738C201.22 73.249 197.297 73.6157 197.25 73.6157C196.963 73.6476 196.66 73.5838 196.389 73.4403C185.945 67.8757 175.485 66.1218 165.281 68.2424C156.543 70.0601 151.218 74.1738 151.154 74.2216C151.042 74.3173 150.899 74.3811 150.771 74.4448C150.755 74.4448 148.97 75.1623 146.307 76.9641C143.867 78.6223 140.152 81.5561 136.421 86.1481C127.205 97.4847 132.292 114.482 133.089 116.921C134.683 116.14 136.485 115.661 138.382 115.645Z"
          fill="#333333"
        />
        <path
          d="M171.85 158.95C167.258 158.345 162.889 156.941 158.903 154.853V163.654C160.402 164.595 164.483 166.955 170.032 168.166C179.136 170.143 187.826 168.342 195.862 162.777V154.406C190.17 157.547 183.681 159.285 176.968 159.285C175.278 159.301 173.572 159.19 171.85 158.95Z"
          fill="#FFD6D3"
        />
        <path
          d="M204.839 193.805C206.583 193.805 207.996 192.392 207.996 190.648C207.996 188.905 206.583 187.491 204.839 187.491C203.096 187.491 201.682 188.905 201.682 190.648C201.682 192.392 203.096 193.805 204.839 193.805Z"
          fill="white"
        />
        <path
          d="M215.012 193.805C216.755 193.805 218.169 192.392 218.169 190.648C218.169 188.905 216.755 187.491 215.012 187.491C213.268 187.491 211.854 188.905 211.854 190.648C211.854 192.392 213.268 193.805 215.012 193.805Z"
          fill="#333333"
        />
        <path
          d="M225.184 193.805C226.928 193.805 228.341 192.392 228.341 190.648C228.341 188.905 226.928 187.491 225.184 187.491C223.441 187.491 222.027 188.905 222.027 190.648C222.027 192.392 223.441 193.805 225.184 193.805Z"
          fill="#2179C4"
        />
        <path
          d="M155.555 133.567C159.456 133.567 162.618 130.404 162.618 126.503C162.618 122.602 159.456 119.44 155.555 119.44C151.654 119.44 148.491 122.602 148.491 126.503C148.491 130.404 151.654 133.567 155.555 133.567Z"
          fill="#FFBEB9"
        />
        <path
          d="M197.138 134.858C201.039 134.858 204.201 131.696 204.201 127.795C204.201 123.894 201.039 120.731 197.138 120.731C193.237 120.731 190.074 123.894 190.074 127.795C190.074 131.696 193.237 134.858 197.138 134.858Z"
          fill="#FFBEB9"
        />
        <path
          d="M323.912 300.458H263.881C252.242 300.458 242.803 291.019 242.803 279.379C242.803 267.74 252.242 258.301 263.881 258.301H323.912C335.552 258.301 344.991 267.74 344.991 279.379C344.991 291.019 335.552 300.458 323.912 300.458Z"
          fill="#1D3E69"
        />
        <path
          d="M271.359 283.892C271.359 285.088 271.057 286.156 270.435 287.097C269.829 288.053 268.92 288.787 267.74 289.329C266.56 289.871 265.157 290.142 263.531 290.142C261.586 290.142 259.991 289.776 258.715 289.042C257.823 288.516 257.089 287.814 256.531 286.921C255.973 286.044 255.686 285.183 255.686 284.354C255.686 283.876 255.861 283.461 256.196 283.111C256.531 282.76 256.962 282.6 257.472 282.6C257.886 282.6 258.253 282.728 258.54 282.999C258.827 283.27 259.082 283.669 259.289 284.195C259.545 284.817 259.816 285.343 260.103 285.773C260.39 286.188 260.804 286.539 261.33 286.81C261.857 287.081 262.558 287.224 263.419 287.224C264.599 287.224 265.556 286.953 266.305 286.395C267.039 285.837 267.405 285.152 267.405 284.338C267.405 283.685 267.198 283.159 266.815 282.744C266.417 282.329 265.906 282.026 265.269 281.803C264.631 281.58 263.786 281.357 262.734 281.118C261.314 280.783 260.135 280.4 259.178 279.954C258.221 279.507 257.472 278.901 256.914 278.136C256.356 277.371 256.069 276.414 256.069 275.282C256.069 274.198 256.372 273.241 256.962 272.396C257.552 271.551 258.413 270.913 259.529 270.451C260.645 270.004 261.968 269.765 263.483 269.765C264.695 269.765 265.731 269.909 266.624 270.212C267.501 270.515 268.234 270.913 268.824 271.407C269.398 271.902 269.829 272.428 270.1 272.97C270.371 273.512 270.498 274.054 270.498 274.564C270.498 275.043 270.323 275.473 269.988 275.84C269.653 276.223 269.239 276.414 268.729 276.414C268.266 276.414 267.931 276.302 267.692 276.079C267.453 275.856 267.198 275.473 266.927 274.963C266.576 274.214 266.146 273.64 265.635 273.225C265.141 272.811 264.328 272.603 263.212 272.603C262.175 272.603 261.346 272.826 260.724 273.289C260.103 273.751 259.784 274.277 259.784 274.915C259.784 275.314 259.895 275.649 260.103 275.936C260.31 276.223 260.613 276.462 260.996 276.669C261.378 276.876 261.745 277.036 262.144 277.147C262.526 277.259 263.164 277.434 264.057 277.658C265.173 277.913 266.178 278.2 267.07 278.519C267.963 278.838 268.729 279.22 269.366 279.667C270.004 280.113 270.483 280.687 270.849 281.373C271.184 282.058 271.359 282.903 271.359 283.892ZM287.703 273.193H278.726V278.024H287.001C287.607 278.024 288.069 278.168 288.356 278.439C288.659 278.71 288.803 279.077 288.803 279.523C288.803 279.97 288.659 280.336 288.356 280.623C288.053 280.91 287.607 281.054 286.985 281.054H278.71V286.65H288.006C288.627 286.65 289.106 286.794 289.425 287.081C289.744 287.368 289.903 287.766 289.903 288.245C289.903 288.707 289.744 289.09 289.425 289.377C289.106 289.664 288.627 289.807 288.006 289.807H277.163C276.302 289.807 275.665 289.616 275.298 289.233C274.915 288.851 274.724 288.229 274.724 287.368V272.571C274.724 271.997 274.804 271.535 274.979 271.168C275.154 270.802 275.409 270.546 275.776 270.371C276.143 270.212 276.605 270.116 277.163 270.116H287.687C288.324 270.116 288.787 270.259 289.106 270.546C289.409 270.833 289.568 271.2 289.568 271.647C289.568 272.109 289.409 272.492 289.106 272.763C288.819 273.05 288.34 273.193 287.703 273.193ZM298.274 272.173L305.943 283.78V272.077C305.943 271.312 306.103 270.738 306.437 270.371C306.756 269.988 307.203 269.797 307.761 269.797C308.335 269.797 308.781 269.988 309.116 270.371C309.451 270.754 309.61 271.328 309.61 272.077V287.559C309.61 289.281 308.893 290.158 307.458 290.158C307.107 290.158 306.772 290.11 306.485 289.999C306.198 289.903 305.927 289.728 305.672 289.504C305.417 289.281 305.194 289.026 304.971 288.723C304.763 288.42 304.54 288.117 304.333 287.798L296.855 276.334V287.862C296.855 288.612 296.679 289.186 296.329 289.568C295.978 289.951 295.531 290.142 294.989 290.142C294.431 290.142 293.969 289.951 293.634 289.552C293.299 289.17 293.124 288.596 293.124 287.846V272.651C293.124 272.013 293.188 271.503 293.331 271.136C293.506 270.738 293.777 270.403 294.176 270.148C294.575 269.893 294.989 269.765 295.452 269.765C295.802 269.765 296.121 269.829 296.376 269.941C296.632 270.052 296.855 270.212 297.046 270.403C297.237 270.594 297.429 270.849 297.636 271.168C297.859 271.503 298.067 271.838 298.274 272.173ZM316.451 270.116H321.648C323.004 270.116 324.152 270.243 325.124 270.499C326.097 270.754 326.974 271.216 327.755 271.902C329.812 273.656 330.833 276.318 330.833 279.906C330.833 281.086 330.737 282.17 330.53 283.143C330.322 284.115 330.003 284.992 329.573 285.773C329.142 286.555 328.6 287.256 327.915 287.878C327.389 288.356 326.814 288.739 326.177 289.026C325.555 289.313 324.869 289.52 324.152 289.632C323.434 289.744 322.621 289.807 321.712 289.807H316.514C315.797 289.807 315.239 289.696 314.872 289.473C314.505 289.249 314.266 288.946 314.155 288.548C314.043 288.149 313.979 287.639 313.979 287.001V272.571C313.979 271.71 314.171 271.089 314.553 270.706C314.968 270.307 315.59 270.116 316.451 270.116ZM317.997 273.273V286.634H321.011C321.68 286.634 322.191 286.618 322.573 286.587C322.956 286.555 323.339 286.459 323.737 286.316C324.136 286.172 324.487 285.965 324.79 285.71C326.129 284.578 326.783 282.632 326.783 279.874C326.783 277.929 326.496 276.478 325.906 275.505C325.316 274.533 324.598 273.927 323.737 273.656C322.876 273.385 321.84 273.257 320.628 273.257H317.997V273.273Z"
          fill="white"
        />
        <path
          d="M109.459 69.4384C108.965 69.4384 108.502 69.1992 108.215 68.8006L101.71 59.5049C101.232 58.8193 101.407 57.8786 102.077 57.4003C102.762 56.9219 103.703 57.0973 104.181 57.767L109.427 65.2769L116.331 55.1999C116.809 54.5143 117.734 54.3389 118.436 54.8013C119.121 55.2797 119.297 56.2044 118.834 56.906L110.703 68.7846C110.416 69.1833 109.953 69.4384 109.459 69.4384Z"
          fill="white"
        />
        <path
          d="M89.4485 94.8218H84.6811L84.2346 96.8308C83.2301 95.2044 81.6357 94.3913 79.4672 94.3913C77.5698 94.3913 75.8797 94.9812 74.3809 96.1452C72.8821 97.3091 71.7182 98.8079 70.905 100.642C70.0918 102.475 69.6932 104.325 69.6932 106.222C69.6932 108.04 70.0918 109.57 70.8731 110.814C71.6544 112.058 72.6908 112.935 73.9664 113.461C75.2419 113.987 76.5653 114.115 77.9206 113.844C79.2759 113.573 80.4877 112.919 81.54 111.882C81.7154 112.6 82.0821 113.126 82.6242 113.461C83.1663 113.796 83.9317 113.955 84.9043 113.955C86.5944 113.955 88.157 113.604 89.6239 112.887C91.0748 112.169 92.3504 111.197 93.4187 109.953C94.5029 108.725 95.332 107.322 95.906 105.776C96.48 104.229 96.767 102.651 96.767 101.04C96.767 98.9674 96.4162 97.0699 95.6987 95.3639C94.9812 93.6419 93.9448 92.159 92.5895 90.9154C91.2343 89.6558 89.592 88.6991 87.6786 88.0294C85.7653 87.3597 83.6766 87.0249 81.3805 87.0249C78.5903 87.0249 76.0232 87.4873 73.7112 88.4121C71.3993 89.3369 69.4381 90.6284 67.8277 92.2707C66.2173 93.9129 64.9896 95.8422 64.1286 98.0745C63.2676 100.307 62.853 102.698 62.853 105.265C62.853 107.721 63.2676 109.969 64.0967 111.994C64.9258 114.019 66.1535 115.773 67.7799 117.24C69.4062 118.707 71.3993 119.823 73.775 120.604C76.1508 121.385 78.8135 121.768 81.7792 121.768C83.7563 121.768 85.574 121.593 87.2481 121.226C88.9223 120.859 90.437 120.333 91.7764 119.647C93.1317 118.962 94.2956 118.101 95.3001 117.096C96.3046 116.092 97.1178 114.928 97.7556 113.652H93.9129C92.8447 115.008 91.5372 116.044 89.9906 116.793C88.444 117.543 86.5625 118.053 84.3303 118.308C81.5241 118.595 79.0048 118.499 76.7726 118.005C74.5404 117.511 72.643 116.698 71.0804 115.534C69.5019 114.37 68.306 112.935 67.4929 111.213C66.6638 109.491 66.2492 107.609 66.2492 105.536C66.2492 103.99 66.4405 102.459 66.8232 100.96C67.2059 99.4616 67.7639 98.1063 68.4974 96.8786C69.3265 95.4755 70.3629 94.2797 71.6066 93.323C72.8502 92.3663 74.2852 91.6329 75.9275 91.1226C77.5698 90.6124 79.3715 90.3573 81.3327 90.3573C83.262 90.3573 84.984 90.6284 86.5147 91.1545C88.0454 91.6807 89.3209 92.4142 90.3573 93.3549C91.3937 94.2956 92.1909 95.3958 92.733 96.6713C93.2752 97.9469 93.5622 99.3022 93.5622 100.753C93.5622 102.491 93.1795 104.086 92.4142 105.552C91.6488 107.019 90.7559 108.167 89.7195 109.028C88.6831 109.873 87.854 110.304 87.2003 110.304C87.009 110.304 86.8495 110.224 86.706 110.065C86.5625 109.905 86.4987 109.698 86.4987 109.411C86.4987 109.14 86.5785 108.598 86.7538 107.785L89.4485 94.8218ZM82.5604 105.871C82.114 107.243 81.4603 108.391 80.5993 109.299C79.7383 110.208 78.7338 110.655 77.6176 110.655C76.645 110.655 75.8478 110.272 75.2579 109.491C74.652 108.725 74.349 107.609 74.349 106.174C74.349 104.771 74.5722 103.4 75.0346 102.077C75.497 100.753 76.1507 99.6849 76.9958 98.8557C77.8409 98.0266 78.7975 97.6121 79.8658 97.6121C80.392 97.6121 80.8703 97.7077 81.2849 97.915C81.6994 98.1063 82.0502 98.4093 82.3532 98.792C82.6402 99.1746 82.8634 99.6211 83.0228 100.131C83.1663 100.642 83.2461 101.216 83.2461 101.853C83.2301 103.161 83.0069 104.5 82.5604 105.871ZM163.83 114.003C162.028 114.003 160.561 115.47 160.561 117.272C160.561 119.073 162.028 120.54 163.83 120.54C165.631 120.54 167.098 119.073 167.098 117.272C167.098 115.47 165.631 114.003 163.83 114.003ZM189.835 114.003C188.033 114.003 186.567 115.47 186.567 117.272C186.567 119.073 188.033 120.54 189.835 120.54C191.637 120.54 193.104 119.073 193.104 117.272C193.104 115.47 191.637 114.003 189.835 114.003ZM390.226 73.6475H358.209C357.38 73.6475 356.694 74.3171 356.694 75.1622V91.2024H351.369C351.337 91.2024 351.305 91.2024 351.257 91.2024C351.241 91.2024 351.241 91.2024 351.226 91.2024C351.13 91.2024 351.05 91.2343 350.97 91.2502C350.954 91.2502 350.954 91.2502 350.939 91.2502C350.859 91.2821 350.779 91.314 350.699 91.3459C350.683 91.3459 350.683 91.3618 350.667 91.3618C350.588 91.4096 350.508 91.4575 350.444 91.5053C350.428 91.5053 350.428 91.5213 350.412 91.5213C350.333 91.585 350.269 91.6488 350.205 91.7126C350.205 91.7126 350.205 91.7126 350.189 91.7285C350.125 91.8083 350.078 91.888 350.03 91.9677C349.982 92.0474 349.95 92.1431 349.918 92.2388C349.886 92.3344 349.87 92.4142 349.854 92.5098V92.5258C349.854 92.5736 349.838 92.6374 349.838 92.6852V122.23C349.838 122.39 349.854 122.533 349.902 122.661C349.934 122.757 349.966 122.836 350.014 122.916V122.932C350.062 123.012 350.109 123.091 350.173 123.171C350.173 123.171 350.173 123.187 350.189 123.187C350.253 123.267 350.317 123.331 350.396 123.394H350.412C350.476 123.442 350.54 123.49 350.604 123.522C350.604 123.522 350.62 123.522 350.62 123.538C350.683 123.57 350.763 123.602 350.827 123.634C350.843 123.634 350.859 123.649 350.859 123.649C350.923 123.665 351.002 123.697 351.066 123.697C351.082 123.697 351.098 123.697 351.114 123.697C351.194 123.713 351.257 123.713 351.337 123.713H398.357C398.437 123.713 398.517 123.697 398.597 123.697C398.613 123.697 398.613 123.697 398.629 123.697C398.708 123.681 398.788 123.665 398.852 123.634C398.868 123.634 398.884 123.618 398.884 123.618C398.963 123.586 399.027 123.554 399.091 123.522C399.107 123.522 399.107 123.506 399.123 123.506C399.187 123.458 399.266 123.41 399.314 123.362C399.314 123.362 399.33 123.362 399.33 123.347C399.33 123.347 399.33 123.331 399.346 123.331C399.41 123.267 399.474 123.203 399.521 123.139C399.537 123.123 399.537 123.123 399.537 123.107C399.585 123.044 399.633 122.964 399.665 122.884C399.665 122.868 399.681 122.868 399.681 122.852C399.713 122.773 399.745 122.693 399.761 122.613C399.761 122.597 399.761 122.597 399.777 122.581C399.793 122.501 399.808 122.422 399.808 122.326C399.808 122.31 399.808 122.294 399.808 122.278C399.808 122.262 399.808 122.23 399.808 122.214V92.7012C399.808 92.6693 399.808 92.6374 399.808 92.6055C399.808 92.5895 399.808 92.5895 399.808 92.5736C399.808 92.4779 399.792 92.3982 399.761 92.3185C399.761 92.3025 399.761 92.3025 399.745 92.2866C399.713 92.2069 399.681 92.1112 399.649 92.0315C399.649 92.0155 399.633 92.0155 399.633 91.9996C399.585 91.9199 399.537 91.8402 399.474 91.7604C399.474 91.7604 399.474 91.7604 399.474 91.7445C399.41 91.6648 399.346 91.601 399.266 91.5372C399.266 91.5372 399.266 91.5372 399.25 91.5213C399.171 91.4575 399.091 91.4096 399.011 91.3618C398.852 91.2661 398.66 91.2183 398.469 91.1864H398.453C398.405 91.1864 398.342 91.1705 398.294 91.1705H391.645V75.1462C391.741 74.3171 391.055 73.6475 390.226 73.6475ZM359.724 76.661H388.711V98.4093C388.711 98.4412 388.711 98.4731 388.711 98.489L374.233 110.065L359.708 97.7715V76.661H359.724ZM356.71 94.2159V95.2363L355.499 94.2159H356.71ZM352.884 95.9538L357.045 99.4776C357.157 99.6211 357.3 99.7327 357.46 99.8283L363.487 104.931L352.884 117.989V95.9538ZM354.542 120.732L365.799 106.876L373.245 113.19C373.532 113.429 373.867 113.541 374.217 113.541C374.552 113.541 374.887 113.429 375.158 113.206L382.859 107.051L395.025 120.732H354.542ZM396.875 118.276L385.219 105.17L396.875 95.8422V118.276ZM394.084 94.2159L391.741 96.0973V94.2159H394.084Z"
          fill="#333333"
        />
        <path
          d="M365.799 84.7449H382.859C383.689 84.7449 384.374 84.0752 384.374 83.2302C384.374 82.3851 383.704 81.7155 382.859 81.7155H365.799C364.97 81.7155 364.284 82.3851 364.284 83.2302C364.284 84.0752 364.97 84.7449 365.799 84.7449ZM380.563 89.8791C380.563 89.0499 379.894 88.3643 379.049 88.3643H365.799C364.97 88.3643 364.284 89.034 364.284 89.8791C364.284 90.7241 364.954 91.3938 365.799 91.3938H379.049C379.878 91.3938 380.563 90.7082 380.563 89.8791ZM234.336 13.0424C234.272 13.7281 234.687 14.3818 235.341 14.605L252.146 20.5523C253.071 23.231 256.643 34.6951 258.875 41.9817C258.875 41.9977 258.891 42.0136 258.891 42.0136C258.923 42.0933 258.939 42.1571 258.986 42.2209C259.002 42.2528 259.018 42.2687 259.034 42.3006C259.066 42.3644 259.098 42.4122 259.146 42.4601C259.162 42.476 259.162 42.492 259.178 42.492C259.194 42.5079 259.21 42.5238 259.226 42.5557C259.242 42.5717 259.258 42.5876 259.258 42.6036C259.305 42.6514 259.369 42.6992 259.417 42.7471C259.417 42.7471 259.417 42.7471 259.433 42.7471C259.481 42.7949 259.545 42.8268 259.608 42.8587C259.624 42.8587 259.64 42.8746 259.656 42.8746C259.72 42.9065 259.784 42.9384 259.847 42.9543C259.911 42.9703 259.991 42.9862 260.055 43.0022C260.071 43.0022 260.087 43.0022 260.103 43.0181C260.166 43.0341 260.246 43.0341 260.31 43.0341H260.326C260.374 43.0341 260.421 43.0181 260.469 43.0181C260.501 43.0181 260.533 43.0181 260.565 43.0022C260.645 42.9862 260.724 42.9703 260.804 42.9384C260.82 42.9225 260.852 42.9225 260.868 42.9065C260.932 42.8906 260.98 42.8587 261.027 42.8268C261.059 42.8109 261.075 42.7949 261.107 42.779C261.155 42.7471 261.203 42.7152 261.251 42.6833C261.267 42.6833 261.267 42.6674 261.283 42.6674L277.036 29.3377L287.208 32.9412C287.368 33.005 287.543 33.0209 287.719 33.0209C288.165 33.0209 288.595 32.8296 288.882 32.4629L313.501 2.4234C313.533 2.39151 313.549 2.35962 313.565 2.32773C313.581 2.31179 313.596 2.2799 313.612 2.26395C313.708 2.12045 313.772 1.96101 313.804 1.80156C313.804 1.76967 313.82 1.75373 313.82 1.72184C313.836 1.65806 313.836 1.61023 313.836 1.54645C313.836 1.51456 313.836 1.48267 313.836 1.45078C313.836 1.387 313.836 1.33917 313.82 1.27539C313.82 1.2435 313.82 1.21161 313.804 1.19567C313.788 1.11595 313.772 1.02028 313.74 0.940558C313.74 0.940558 313.74 0.940558 313.74 0.924613C313.708 0.860835 313.676 0.797057 313.644 0.733279C313.644 0.717334 313.628 0.717334 313.628 0.70139C313.612 0.669501 313.596 0.653556 313.581 0.621667C313.549 0.573834 313.517 0.526 313.485 0.494111C313.469 0.462222 313.437 0.446278 313.421 0.414389C313.389 0.366555 313.341 0.334666 313.293 0.302777C313.278 0.286832 313.246 0.270888 313.23 0.254943C313.166 0.20711 313.102 0.175221 313.038 0.143332C313.022 0.143332 313.022 0.127387 313.007 0.127387C312.927 0.0954983 312.847 0.0636093 312.767 0.0317203C312.751 0.0317203 312.719 0.0157757 312.704 0.0157757C312.64 -0.000168767 312.576 -0.0161133 312.528 -0.0161133C312.496 -0.0161133 312.464 -0.0161133 312.432 -0.0161133C312.369 -0.0161133 312.321 -0.0161133 312.257 -0.0161133C312.225 -0.0161133 312.193 -0.0161133 312.161 -0.0161133C312.146 -0.0161133 312.13 -0.0161133 312.114 -0.0161133L235.612 11.6712C234.926 11.7988 234.4 12.3568 234.336 13.0424ZM263.084 37.2143L266.321 25.5589L273.751 28.1897L263.084 37.2143ZM287.224 29.7682L269.271 23.4223L306.948 5.72391L287.224 29.7682ZM264.663 22.2424C264.264 22.4338 263.961 22.7845 263.85 23.1991L260.246 36.162C259.672 34.3284 259.002 32.1599 258.333 30.0234C257.328 26.8026 256.515 24.2355 255.925 22.4019C255.654 21.5728 255.431 20.8871 255.255 20.345L292.964 8.9447L264.663 22.2424ZM291.609 6.20225L253.326 17.778L242.006 13.7759L291.609 6.20225ZM395.822 181.082H333.017C332.108 178.738 327.086 167.385 315.271 165.201C312.704 164.723 310.184 165.169 307.809 166.508C305.529 164.85 299.709 161.422 293.841 164.818C293.299 165.137 292.789 165.488 292.311 165.902C287.033 162.411 281.803 164.276 279.587 165.887C278.503 165.233 276.876 164.818 275.17 164.802C273.177 164.786 269.334 165.313 265.938 169.075C263.355 171.945 261.506 175.039 260.453 178.004C242.898 169.378 222.713 164.196 198.876 162.171V152.557C204.233 148.938 208.713 143.979 211.775 138.016C211.807 138.031 211.855 138.047 211.886 138.063C213.577 138.637 215.33 138.813 217.116 138.574C223.414 137.744 227.863 131.941 227.034 125.643C226.667 122.82 225.328 120.397 223.398 118.627C223.653 118.436 223.861 118.165 223.94 117.83C224.004 117.591 225.583 111.835 226.141 104.389C226.89 94.2638 225.423 86.2597 221.756 80.6312C218.615 75.8 213.305 72.5474 206.401 71.208C202.208 70.3949 198.652 70.5224 197.409 70.6021C186.455 64.8462 175.437 63.0763 164.659 65.3245C155.985 67.1262 150.516 70.9689 149.464 71.7501C148.156 72.3082 141.157 75.5768 134.077 84.2825C129.517 89.9109 127.428 97.5803 128.034 106.493C128.497 113.142 130.266 118.085 130.346 118.292C130.41 118.452 130.49 118.611 130.601 118.739C128.736 120.493 127.428 122.9 127.062 125.659C126.663 128.704 127.476 131.733 129.342 134.173C131.207 136.612 133.918 138.175 136.979 138.59C137.489 138.653 138 138.685 138.51 138.685C139.753 138.685 140.981 138.478 142.161 138.079C145.366 144.282 150.133 149.448 155.889 153.131C155.873 153.211 155.873 153.274 155.873 153.354V163.16C151.999 163.782 147.965 164.34 144.074 164.866C130.537 166.732 116.57 168.661 103.846 173.572C104.739 167.322 105.521 157.037 102.459 153.609C100.721 151.664 99.0949 150.803 97.7077 150.5C98.3136 149.129 98.4571 147.487 98.1223 145.685C97.7077 143.469 96.3843 141.571 94.2797 140.2C90.3254 137.601 84.0273 137.043 76.9958 138.653C70.9369 140.056 68.3061 144.09 67.174 147.216C66.7913 148.268 66.5522 149.288 66.4087 150.197C63.0284 146.737 56.9057 140.455 55.5664 139.179C53.9879 137.681 51.07 135.975 48.0884 136.102C46.2867 136.182 44.7241 136.931 43.5761 138.255C41.8541 140.216 41.6468 142.958 42.2208 145.414C41.4395 145.43 40.6742 145.557 39.9408 145.812C37.1345 146.801 35.3966 149.304 35.285 152.509C35.2371 153.817 35.4763 155.347 36.146 156.671C33.7383 157.213 32.0004 158.584 31.2032 160.641C29.8319 164.18 31.4583 169.315 35.285 173.428C36.5446 174.784 37.868 176.203 39.2711 177.654C34.7269 184.302 4.68744 228.533 0.972373 245.864C-1.69036 258.253 1.16371 270.211 8.97652 279.539C12.9786 284.306 18.1924 288.181 24.06 290.764C29.5768 293.188 35.7155 294.447 41.886 294.447C42.4122 294.447 42.9543 294.431 43.4804 294.415C53.9719 294.049 61.5775 291.577 69.7411 285.933C77.7133 280.4 86.5785 271.535 98.8876 258.253L101.343 318.938H104.357L100.673 227.735C100.642 226.922 99.9719 226.284 99.1587 226.284C99.1427 226.284 99.1109 226.284 99.0949 226.284C98.2658 226.316 97.6121 227.018 97.644 227.847L98.6963 253.98C71.7022 283.254 62.3428 290.716 43.3529 291.386C42.8586 291.402 42.3643 291.418 41.8701 291.418C29.9276 291.418 18.5751 286.315 11.2725 277.594C4.06561 269 1.45071 257.95 3.90616 246.486C7.38207 230.302 36.0503 187.746 41.3917 179.902C43.9907 182.517 46.781 185.179 49.7147 187.683C50.8787 188.671 52.0427 189.724 53.1747 190.744C56.6028 193.837 60.1425 197.026 64.3997 199.338C68.4496 201.538 72.627 202.639 76.6769 202.639C79.8339 202.639 82.9112 201.969 85.8131 200.662C81.2052 211.344 68.9438 239.566 63.5227 250.026C63.14 250.759 63.427 251.684 64.1764 252.067C64.3997 252.178 64.6388 252.242 64.862 252.242C65.4042 252.242 65.9303 251.939 66.2014 251.429C72.6111 239.04 88.4599 202.16 90.2138 198.047C96.4481 193.407 101.231 185.993 103.033 178.1C103.097 177.845 103.161 177.494 103.24 177.064C116.06 171.786 130.49 169.793 144.441 167.864C148.571 167.29 152.844 166.7 156.942 166.046C158.393 167.003 162.873 169.697 169.219 171.1C171.451 171.595 174.05 171.945 176.92 171.945C182.995 171.945 190.266 170.351 197.744 165.121C221.82 167.082 242.069 172.28 259.624 181.002C259.624 181.034 259.608 181.066 259.608 181.098H193.247C190.935 181.098 189.07 182.979 189.07 185.275V316.18C189.07 317.232 189.468 318.204 190.122 318.938C190.887 319.815 192.004 320.357 193.263 320.357H395.822C397.066 320.357 398.198 319.799 398.963 318.938C399.617 318.204 400.016 317.232 400.016 316.18V185.275C400 182.963 398.118 181.082 395.822 181.082ZM100.131 177.414C98.4412 184.749 93.9608 191.637 88.141 195.846C81.6357 200.534 73.5199 200.853 65.8665 196.691C61.9282 194.555 58.6596 191.621 55.2156 188.512C54.0676 187.475 52.8877 186.423 51.6919 185.403C46.3983 180.89 41.5352 175.804 37.4694 171.435C34.5196 168.246 33.0527 164.196 33.9935 161.789C34.5196 160.434 35.8111 159.668 37.8361 159.509C40.0843 159.333 42.7948 162.108 44.9952 164.324C45.33 164.659 45.6648 164.994 45.9837 165.313C47.8174 167.13 49.635 168.932 51.4686 170.75L53.7009 172.966C54.2908 173.556 55.2475 173.556 55.8374 172.95C56.4274 172.36 56.4274 171.403 55.8215 170.813L53.5893 168.597C51.7556 166.779 49.938 164.962 48.1044 163.16C47.7855 162.857 47.4666 162.522 47.1477 162.187C45.0908 160.099 42.8427 157.819 40.3394 156.878C40.2437 156.782 40.1321 156.703 40.0205 156.639C38.6811 155.889 38.2506 154.008 38.2985 152.637C38.3623 150.691 39.3349 149.256 40.9453 148.682C42.1092 148.268 43.2572 148.475 44.0226 148.73C45.33 149.161 49.3002 152.079 60.7324 163.622L61.2107 164.117C61.5137 164.42 61.8964 164.563 62.279 164.563C62.6617 164.563 63.0444 164.42 63.3473 164.133C63.9373 163.543 63.9373 162.586 63.3473 161.996L62.869 161.518C53.7328 152.302 48.3276 147.487 45.6011 146.147C44.7879 144.25 44.5328 141.762 45.8243 140.28C46.4461 139.578 47.2274 139.211 48.2 139.164C50.1293 139.084 52.218 140.232 53.4617 141.412C54.8967 142.767 62.0399 150.101 65.1012 153.243C66.1854 154.343 66.4405 154.614 66.4884 154.662C66.7754 154.949 67.1581 155.092 67.5407 155.092C67.5567 155.092 67.5567 155.092 67.5726 155.092C67.6364 155.092 67.7161 155.092 67.7799 155.092C68.609 155.028 69.2308 154.311 69.183 153.482C69.1511 153.083 68.6249 143.724 77.6655 141.635C83.8041 140.216 89.4007 140.646 92.6214 142.767C94.0405 143.692 94.8856 144.872 95.1407 146.275C95.3639 147.518 95.3958 149.225 94.2159 150.341C92.7809 151.696 89.8311 151.967 86.1161 151.058C83.1663 150.341 80.6949 151.234 79.1643 153.53C76.7566 157.149 77.4263 163.224 79.6426 166.253C80.9501 168.039 82.9112 168.916 84.8724 168.565C86.1001 168.358 87.3119 167.704 88.3802 166.684C89.6876 165.44 90.8197 163.83 91.5532 162.156C92.0953 160.928 92.3823 159.684 92.6533 158.472C92.9244 157.292 93.1795 156.176 93.6419 155.188C93.9289 154.566 94.8058 153.577 96.0017 153.418C97.6121 153.179 99.1587 154.502 100.179 155.65C102.459 158.122 101.71 170.574 100.131 177.414ZM90.6603 154.582C90.2457 155.65 89.9906 156.734 89.7514 157.803C89.4963 158.919 89.2571 159.971 88.8266 160.928C88.2367 162.251 87.3598 163.511 86.3234 164.483C85.8769 164.898 85.1913 165.44 84.3781 165.568C83.1663 165.775 82.3213 164.755 82.0821 164.436C80.3761 162.108 80.1688 157.436 81.6835 155.172C82.2894 154.247 83.1345 153.801 84.2187 153.801C84.5854 153.801 84.984 153.848 85.4145 153.96C87.5033 154.47 89.2253 154.63 90.6603 154.582ZM136.437 86.1959C140.168 81.6038 143.867 78.6541 146.323 77.0118C148.969 75.2101 150.771 74.4926 150.787 74.4926C150.931 74.4448 151.058 74.365 151.17 74.2694C151.218 74.2215 156.543 70.1079 165.297 68.2902C175.501 66.1696 185.961 67.9235 196.404 73.4881C196.659 73.6316 196.962 73.6954 197.265 73.6635C197.297 73.6635 201.235 73.2968 205.939 74.2215C212.062 75.4333 216.542 78.1439 219.253 82.3214C223.35 88.6194 223.637 97.66 223.159 104.149C222.665 110.958 221.23 116.443 221.07 117.017C219.396 116.124 217.499 115.645 215.474 115.677L211.472 108.183C211.185 107.657 210.627 107.354 210.037 107.386C188.48 108.949 176.442 104.022 170.144 99.6211C164.754 95.8423 162.203 91.4735 161.613 89.7037C161.486 89.2891 161.167 88.9383 160.768 88.7789C160.37 88.6035 159.907 88.6194 159.509 88.8267C144.935 96.1133 139.658 111.245 138.398 115.693C136.501 115.709 134.699 116.188 133.121 117.017C132.291 114.529 127.221 97.5484 136.437 86.1959ZM195.862 162.793C187.826 168.358 179.136 170.176 170.032 168.183C164.467 166.971 160.386 164.627 158.903 163.67V154.869C162.889 156.942 167.258 158.361 171.85 158.967C173.572 159.19 175.278 159.301 176.984 159.301C183.696 159.301 190.186 157.564 195.878 154.422V162.793H195.862ZM172.248 155.969C159.285 154.263 148.236 145.637 143.389 133.471C143.086 132.69 142.209 132.323 141.428 132.626C140.646 132.929 140.28 133.806 140.583 134.587C140.678 134.843 140.79 135.082 140.885 135.337C139.753 135.672 138.574 135.767 137.378 135.608C135.13 135.305 133.12 134.157 131.749 132.355C130.362 130.553 129.772 128.321 130.075 126.073C130.681 121.481 134.763 118.244 139.371 118.723C140.136 118.802 140.838 118.292 140.997 117.559C141.029 117.383 145.015 100.371 159.445 92.2388C160.529 94.3754 163.032 98.2499 168.182 101.917C177.749 108.741 191.573 111.611 209.271 110.463L213.274 117.941C213.561 118.484 214.151 118.786 214.756 118.739C219.364 118.26 223.446 121.481 224.052 126.089C224.658 130.729 221.389 135.018 216.734 135.624C215.49 135.783 214.246 135.672 213.066 135.305C213.098 135.241 213.13 135.177 213.146 135.114C213.465 134.348 213.098 133.455 212.317 133.137C211.552 132.818 210.659 133.184 210.34 133.966C204.137 149.049 188.464 158.106 172.248 155.969ZM314.729 168.183C323.594 169.825 328.186 177.829 329.732 181.098H315.845C316.068 180.46 316.291 179.806 316.482 179.12C316.706 178.323 316.243 177.478 315.43 177.255C314.633 177.032 313.788 177.494 313.565 178.307C313.214 179.567 312.751 180.763 312.273 182.022C312.002 182.74 311.715 183.473 311.444 184.239C310.583 186.662 308.797 189.803 305.098 190.983C303.312 191.557 301.654 191.382 300.538 190.505C299.549 189.74 299.087 188.496 299.199 186.933C299.23 186.455 299.262 186.104 299.31 185.785C299.326 185.722 299.326 185.658 299.342 185.61C299.422 185.1 299.549 184.685 299.757 184C299.82 183.76 299.9 183.505 299.996 183.202C301.144 179.28 303.169 175.294 305.417 172.567C308.303 169.044 311.444 167.561 314.729 168.183ZM295.356 167.449C299.151 165.249 303.089 167.035 305.226 168.406C304.492 169.059 303.775 169.809 303.089 170.638C300.586 173.667 298.338 178.052 297.094 182.357C297.014 182.644 296.934 182.899 296.871 183.139C296.647 183.888 296.488 184.43 296.36 185.148C296.089 185.961 294.064 191.573 290.557 192.067C289.313 192.243 288.388 192.004 287.719 191.35C286.762 190.409 286.283 188.496 286.523 186.487C286.73 184.813 287.463 180.89 288.914 176.92C290.668 172.137 292.9 168.868 295.356 167.449ZM281.309 168.374C282.792 167.258 286.379 165.934 290.174 168.135C285.056 174.672 283.541 185.961 283.525 186.088C283.477 186.455 283.461 186.806 283.445 187.157C282.345 189.07 280.288 190.457 278.55 190.457C278.519 190.457 278.503 190.457 278.471 190.457C276.956 190.425 275.712 189.357 274.756 187.284C272.731 182.963 276.541 171.993 281.309 168.374ZM268.186 171.1C270.53 168.501 273.05 167.896 274.772 167.832C275.792 167.8 276.637 167.959 277.243 168.151C275.377 170.351 273.719 173.349 272.587 176.681C271.216 180.683 270.849 184.366 271.503 187.077C270.291 188.273 268.601 189.405 266.975 189.484C265.97 189.532 265.093 189.166 264.264 188.384C260.756 185.036 262.478 177.446 268.186 171.1ZM192.083 185.275C192.083 184.637 192.609 184.111 193.247 184.111H259.449C259.56 186.678 260.453 188.926 262.175 190.553C263.515 191.828 265.109 192.498 266.815 192.498C266.911 192.498 267.007 192.498 267.102 192.498C267.852 192.466 270.211 192.179 272.779 189.995C273.831 191.637 275.617 193.423 278.391 193.502C278.439 193.502 278.503 193.502 278.55 193.502C280.671 193.502 282.6 192.498 284.083 191.127C284.45 192.051 284.96 192.849 285.598 193.486C286.395 194.268 287.734 195.113 289.807 195.113C290.174 195.113 290.557 195.081 290.971 195.033C293.634 194.666 295.579 192.737 296.934 190.744C297.349 191.573 297.939 192.291 298.672 192.865C299.9 193.821 301.431 194.316 303.105 194.316C304.046 194.316 305.018 194.156 306.007 193.837C309.818 192.625 312.751 189.564 314.282 185.227C314.41 184.845 314.553 184.478 314.697 184.095H395.822C396.46 184.095 396.986 184.621 396.986 185.259V197.058C396.922 197.058 396.859 197.042 396.795 197.042H192.083V185.275ZM192.083 200.072H396.795C396.859 200.072 396.922 200.072 396.986 200.056V316.18C396.986 316.817 396.46 317.344 395.822 317.344H193.247C192.609 317.344 192.083 316.817 192.083 316.18V200.072Z"
          fill="#333333"
        />
        <path
          d="M142.336 126.79C138.876 124.941 135.098 124.941 134.954 124.941C134.125 124.941 133.455 125.626 133.455 126.456C133.455 127.285 134.141 127.954 134.97 127.954C135.002 127.954 138.143 127.97 140.917 129.453C141.14 129.581 141.38 129.629 141.619 129.629C142.161 129.629 142.687 129.341 142.958 128.831C143.357 128.098 143.086 127.189 142.336 126.79ZM212.492 129.644C212.731 129.644 212.971 129.581 213.194 129.469C215.968 127.986 219.109 127.97 219.141 127.97C219.97 127.97 220.64 127.301 220.656 126.471C220.656 125.642 219.986 124.957 219.157 124.957C218.998 124.957 215.251 124.957 211.775 126.806C211.041 127.205 210.754 128.114 211.153 128.847C211.44 129.341 211.95 129.644 212.492 129.644ZM174.289 124.989C174.64 124.989 175.007 124.861 175.294 124.606C175.421 124.494 176.601 123.506 177.813 124.542C178.451 125.084 179.391 125.005 179.933 124.383C180.476 123.745 180.396 122.804 179.774 122.262C177.207 120.062 174.401 121.369 173.285 122.358C172.663 122.916 172.599 123.873 173.157 124.494C173.46 124.813 173.875 124.989 174.289 124.989ZM183.505 128.305C175.82 132.881 170.032 128.385 169.777 128.193C169.123 127.667 168.182 127.763 167.656 128.417C167.13 129.07 167.226 130.011 167.879 130.537C168.087 130.713 171.467 133.391 176.569 133.391C179.041 133.391 181.927 132.754 185.052 130.904C185.769 130.474 186.008 129.549 185.578 128.831C185.147 128.114 184.223 127.875 183.505 128.305ZM59.5046 175.931C58.6755 176.043 58.1015 176.808 58.2131 177.637C58.3247 178.467 59.09 179.041 59.9191 178.929C65.2127 178.18 70.8093 180.109 74.5403 183.951C74.8432 184.254 75.2259 184.414 75.6245 184.414C76.0072 184.414 76.3898 184.27 76.6768 183.983C77.2827 183.409 77.2827 182.453 76.7087 181.847C72.324 177.319 65.7389 175.054 59.5046 175.931ZM266.767 248.989C266.767 249.085 266.783 249.18 266.799 249.26C266.799 249.26 266.799 249.26 266.799 249.276C266.815 249.372 266.847 249.452 266.879 249.547V249.563C266.911 249.643 266.959 249.739 267.006 249.802C267.006 249.802 267.006 249.818 267.022 249.818C267.07 249.898 267.134 249.978 267.214 250.041C267.278 250.105 267.357 250.169 267.437 250.233L267.453 250.249C267.533 250.297 267.612 250.344 267.692 250.376C267.692 250.376 267.708 250.376 267.708 250.392C267.788 250.424 267.883 250.456 267.963 250.472H267.979C268.075 250.488 268.154 250.504 268.25 250.504H319.496C319.591 250.504 319.687 250.488 319.783 250.472C319.878 250.456 319.974 250.424 320.07 250.392C320.165 250.36 320.245 250.313 320.325 250.249C320.325 250.249 320.325 250.249 320.341 250.249C320.421 250.185 320.5 250.121 320.564 250.057C320.564 250.057 320.564 250.041 320.58 250.041C320.644 249.978 320.708 249.898 320.755 249.818C320.755 249.802 320.771 249.802 320.771 249.786C320.819 249.707 320.851 249.627 320.883 249.547C320.883 249.531 320.883 249.531 320.899 249.515C320.931 249.436 320.947 249.356 320.963 249.26C320.963 249.244 320.963 249.244 320.963 249.228C320.979 249.149 320.979 249.069 320.979 248.989V216.797C320.979 216.733 320.979 216.686 320.963 216.638V216.622C320.947 216.526 320.931 216.446 320.899 216.351C320.899 216.351 320.899 216.351 320.899 216.335C320.867 216.239 320.835 216.159 320.787 216.08V216.064C320.739 215.984 320.692 215.904 320.628 215.825C320.628 215.825 320.628 215.825 320.612 215.809C320.548 215.745 320.484 215.681 320.405 215.617C320.389 215.617 320.389 215.601 320.373 215.601C320.309 215.553 320.229 215.506 320.15 215.458C320.134 215.458 320.134 215.442 320.118 215.442C320.038 215.41 319.958 215.378 319.878 215.346C319.863 215.346 319.863 215.346 319.847 215.346C319.767 215.33 319.671 215.314 319.591 215.298C319.576 215.298 319.576 215.298 319.56 215.298C319.528 215.298 319.496 215.298 319.464 215.298H268.218C268.202 215.298 268.186 215.298 268.17 215.298C268.154 215.298 268.139 215.298 268.123 215.298C268.043 215.298 267.947 215.314 267.867 215.33C267.852 215.33 267.852 215.33 267.836 215.346C267.756 215.362 267.676 215.394 267.596 215.426C267.58 215.426 267.58 215.442 267.565 215.442C267.485 215.474 267.405 215.522 267.341 215.569C267.325 215.569 267.325 215.585 267.309 215.585C267.246 215.633 267.166 215.697 267.118 215.761L267.102 215.777C267.102 215.777 267.102 215.793 267.086 215.793C267.022 215.856 266.975 215.936 266.927 216C266.927 216.016 266.911 216.016 266.911 216.032C266.863 216.112 266.831 216.191 266.799 216.271C266.799 216.287 266.783 216.287 266.783 216.303C266.751 216.383 266.735 216.462 266.719 216.558C266.719 216.574 266.719 216.59 266.719 216.59C266.704 216.654 266.704 216.717 266.704 216.781L266.767 248.989C266.767 248.973 266.767 248.973 266.767 248.989ZM271.901 247.458L285.167 234.113L292.167 240.459C292.454 240.714 292.821 240.857 293.187 240.857C293.538 240.857 293.889 240.73 294.176 240.491L301.75 234.001L315.781 247.474H271.901V247.458ZM318.013 245.434L304.03 232.024L318.013 220.05V245.434ZM315.43 218.28L293.203 237.318L272.188 218.28H315.43ZM269.781 220.177L282.919 232.088L269.781 245.306V220.177ZM313.836 95.1086C312.64 91.3457 310.089 87.7263 306.278 84.3461C299.597 78.4466 290.939 76.6289 282.584 74.8591C281.357 74.604 280.097 74.3329 278.885 74.0619C271.423 72.4036 257.791 67.3333 253.948 58.8349C252.369 55.3271 252.672 51.5163 254.889 47.5143C255.287 46.7808 255.032 45.872 254.299 45.4574C253.565 45.0588 252.656 45.3139 252.242 46.0474C249.547 50.9264 249.196 55.646 251.205 60.0626C253.119 64.3038 257.121 68.1146 263.084 71.3673C267.517 73.7908 273.049 75.8477 278.231 76.9957C279.459 77.2667 280.735 77.5378 281.962 77.7929C289.951 79.4671 298.194 81.205 304.285 86.5783C307.681 89.5759 309.929 92.7488 310.965 95.9856C311.731 98.3932 311.795 100.896 311.189 103.097C306.676 100.657 301.766 99.2861 296.791 99.0788C293.235 98.9353 290.588 99.4774 288.484 100.801C285.104 102.906 284.163 106.573 284.96 109.108C286.092 112.695 290.174 114.609 296.169 114.37C301.032 114.162 307.952 113.317 311.874 108.343C312.098 108.056 312.305 107.753 312.512 107.45C317.503 110.83 321.585 115.581 323.849 121.114C328.265 131.845 325.81 145.27 317.901 153.753C317.327 154.358 317.359 155.315 317.981 155.889C318.268 156.16 318.635 156.288 319.017 156.288C319.416 156.288 319.831 156.128 320.118 155.809C324.423 151.201 327.309 145.318 328.504 138.813C329.684 132.307 329.047 125.786 326.655 119.95C324.263 114.114 320.134 109.028 314.712 105.249C314.425 105.058 314.138 104.851 313.851 104.675C314.84 101.789 314.872 98.3613 313.836 95.1086ZM309.499 106.509C306.342 110.511 300.299 111.213 296.025 111.388C293.889 111.468 288.803 111.356 287.814 108.231C287.24 106.445 288.516 104.372 290.062 103.4C291.465 102.523 293.267 102.108 295.707 102.108C296.01 102.108 296.328 102.108 296.663 102.124C301.287 102.316 305.847 103.671 309.929 105.919C309.802 106.126 309.658 106.318 309.499 106.509ZM130.027 61.0511C130.027 50.161 121.162 41.2959 110.272 41.2959C99.3818 41.2959 90.5167 50.161 90.5167 61.0511C90.5167 71.9413 99.3818 80.8064 110.272 80.8064C121.162 80.8064 130.027 71.9413 130.027 61.0511ZM93.5302 61.0511C93.5302 51.8193 101.04 44.3094 110.272 44.3094C119.504 44.3094 127.014 51.8193 127.014 61.0511C127.014 70.283 119.504 77.7929 110.272 77.7929C101.04 77.7929 93.5302 70.283 93.5302 61.0511Z"
          fill="#333333"
        />
      </g>
      <defs>
        <clipPath id="clip0_33060_160669">
          <rect width="400" height="320.357" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
}

export function PdfFileIcon() {
  return (
    <svg
      width="17"
      height="20"
      viewBox="0 0 17 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M15.0501 18.876C15.0501 19.18 14.8021 19.428 14.4981 19.428H2.29809C1.99409 19.428 1.74609 19.18 1.74609 18.876V1.12402C1.74609 0.820021 1.99409 0.572021 2.29809 0.572021H11.5021V4.12002H15.0501V18.876Z"
        fill="white"
      />
      <path
        d="M11.4999 0H2.29587C1.67587 0 1.17188 0.504 1.17188 1.124V18.876C1.17188 19.496 1.67587 20 2.29587 20H14.4959C15.1159 20 15.6199 19.496 15.6199 18.876V4.124L11.4999 0ZM15.0479 18.876C15.0479 19.18 14.7999 19.428 14.4959 19.428H2.29587C1.99187 19.428 1.74387 19.18 1.74387 18.876V1.124C1.74387 0.82 1.99187 0.572 2.29587 0.572H11.4999V4.12H15.0479V18.876Z"
        fill="#2B669F"
      />
      <path d="M11.5 0V4.124H15.62L11.5 0Z" fill="#084272" />
      <path
        d="M16.792 17.7919H0V12.0799C0 11.6879 0.316 11.3719 0.708 11.3719H16.08C16.472 11.3719 16.788 11.6879 16.788 12.0799V17.7919H16.792Z"
        fill="#084272"
      />
      <path d="M15.6211 17.792V18.572L16.7931 17.792H15.6211Z" fill="#1A252D" />
      <path d="M1.172 17.792V18.572L0 17.792H1.172Z" fill="#1A252D" />
      <path
        d="M0.71875 12.0959H16.0667V17.0759H0.71875V12.0959Z"
        fill="#2B669F"
      />
      <path
        d="M10.0902 2.90404H3.01019C2.93911 2.90404 2.87094 2.87581 2.82068 2.82555C2.77042 2.77529 2.74219 2.70712 2.74219 2.63604C2.74219 2.56496 2.77042 2.4968 2.82068 2.44654C2.87094 2.39628 2.93911 2.36804 3.01019 2.36804H10.0902C10.1613 2.36804 10.2294 2.39628 10.2797 2.44654C10.33 2.4968 10.3582 2.56496 10.3582 2.63604C10.3582 2.70712 10.33 2.77529 10.2797 2.82555C10.2294 2.87581 10.1613 2.90404 10.0902 2.90404Z"
        fill="#2B669F"
      />
      <path
        d="M10.0902 4.18407H3.01019C2.93911 4.18407 2.87094 4.15584 2.82068 4.10558C2.77042 4.05532 2.74219 3.98715 2.74219 3.91607C2.74219 3.84499 2.77042 3.77683 2.82068 3.72657C2.87094 3.67631 2.93911 3.64807 3.01019 3.64807H10.0902C10.1613 3.64807 10.2294 3.67631 10.2797 3.72657C10.33 3.77683 10.3582 3.84499 10.3582 3.91607C10.3582 3.98715 10.33 4.05532 10.2797 4.10558C10.2294 4.15584 10.1613 4.18407 10.0902 4.18407Z"
        fill="#2B669F"
      />
      <path
        d="M13.8302 5.46007H3.01019C2.93911 5.46007 2.87094 5.43184 2.82068 5.38158C2.77042 5.33132 2.74219 5.26315 2.74219 5.19207C2.74219 5.12099 2.77042 5.05283 2.82068 5.00257C2.87094 4.95231 2.93911 4.92407 3.01019 4.92407H13.8302C13.9013 4.92407 13.9694 4.95231 14.0197 5.00257C14.07 5.05283 14.0982 5.12099 14.0982 5.19207C14.0982 5.26315 14.07 5.33132 14.0197 5.38158C13.9694 5.43184 13.9013 5.46007 13.8302 5.46007Z"
        fill="#2B669F"
      />
      <path
        d="M13.8302 6.7401H3.01019C2.93911 6.7401 2.87094 6.71187 2.82068 6.66161C2.77042 6.61135 2.74219 6.54318 2.74219 6.4721C2.74219 6.40102 2.77042 6.33286 2.82068 6.2826C2.87094 6.23234 2.93911 6.2041 3.01019 6.2041H13.8302C13.9013 6.2041 13.9694 6.23234 14.0197 6.2826C14.07 6.33286 14.0982 6.40102 14.0982 6.4721C14.0982 6.54318 14.07 6.61135 14.0197 6.66161C13.9694 6.71187 13.9013 6.7401 13.8302 6.7401Z"
        fill="#2B669F"
      />
      <path
        d="M13.8302 8.02001H3.01019C2.93911 8.02001 2.87094 7.99177 2.82068 7.94151C2.77042 7.89125 2.74219 7.82309 2.74219 7.75201C2.74219 7.68093 2.77042 7.61276 2.82068 7.5625C2.87094 7.51224 2.93911 7.48401 3.01019 7.48401H13.8302C13.9013 7.48401 13.9694 7.51224 14.0197 7.5625C14.07 7.61276 14.0982 7.68093 14.0982 7.75201C14.0982 7.82309 14.07 7.89125 14.0197 7.94151C13.9694 7.99177 13.9013 8.02001 13.8302 8.02001Z"
        fill="#2B669F"
      />
      <path
        d="M13.8302 9.29601H3.01019C2.93911 9.29601 2.87094 9.26777 2.82068 9.21751C2.77042 9.16725 2.74219 9.09909 2.74219 9.02801C2.74219 8.95693 2.77042 8.88877 2.82068 8.83851C2.87094 8.78825 2.93911 8.76001 3.01019 8.76001H13.8302C13.9013 8.76001 13.9694 8.78825 14.0197 8.83851C14.07 8.88877 14.0982 8.95693 14.0982 9.02801C14.0982 9.09909 14.07 9.16725 14.0197 9.21751C13.9694 9.26777 13.9013 9.29601 13.8302 9.29601Z"
        fill="#2B669F"
      />
      <path
        d="M13.8302 10.576H3.01019C2.93911 10.576 2.87094 10.5478 2.82068 10.4975C2.77042 10.4473 2.74219 10.3791 2.74219 10.308C2.74219 10.237 2.77042 10.1688 2.82068 10.1185C2.87094 10.0683 2.93911 10.04 3.01019 10.04H13.8302C13.9013 10.04 13.9694 10.0683 14.0197 10.1185C14.07 10.1688 14.0982 10.237 14.0982 10.308C14.0982 10.3791 14.07 10.4473 14.0197 10.4975C13.9694 10.5478 13.9013 10.576 13.8302 10.576Z"
        fill="#2B669F"
      />
      <path
        d="M7.32909 14.692C7.32909 14.968 7.26509 15.192 7.14109 15.36C7.01709 15.528 6.84109 15.612 6.61309 15.612C6.52509 15.612 6.44509 15.596 6.37709 15.56C6.30909 15.524 6.24909 15.476 6.19709 15.412V16.284H5.62109V13.732H6.16509L6.18109 13.932C6.23309 13.856 6.29309 13.8 6.36509 13.76C6.43709 13.72 6.51709 13.7 6.60909 13.7C6.83709 13.7 7.01309 13.788 7.14109 13.964C7.26509 14.14 7.32909 14.372 7.32909 14.66V14.692ZM6.75709 14.656C6.75709 14.5 6.73309 14.376 6.68909 14.28C6.64509 14.184 6.56909 14.14 6.47309 14.14C6.40909 14.14 6.35309 14.152 6.30909 14.176C6.26509 14.2 6.22909 14.236 6.20109 14.28V15.048C6.22909 15.088 6.26509 15.116 6.30909 15.136C6.35309 15.156 6.40909 15.164 6.47309 15.164C6.57309 15.164 6.64509 15.124 6.68909 15.04C6.73309 14.956 6.75309 14.84 6.75309 14.692V14.656H6.75709Z"
        fill="white"
      />
      <path
        d="M7.75 14.656C7.75 14.368 7.814 14.136 7.938 13.96C8.062 13.784 8.242 13.696 8.47 13.696C8.554 13.696 8.63 13.716 8.702 13.756C8.77 13.796 8.834 13.852 8.886 13.924V12.92H9.462V15.576H8.958L8.918 15.352C8.862 15.436 8.798 15.5 8.722 15.544C8.646 15.588 8.562 15.612 8.466 15.612C8.238 15.612 8.062 15.528 7.938 15.36C7.814 15.192 7.75 14.972 7.75 14.696V14.656ZM8.326 14.692C8.326 14.84 8.346 14.96 8.39 15.04C8.434 15.124 8.506 15.164 8.61 15.164C8.67 15.164 8.722 15.152 8.77 15.132C8.814 15.108 8.854 15.076 8.882 15.036V14.292C8.854 14.244 8.814 14.204 8.77 14.18C8.726 14.152 8.674 14.14 8.614 14.14C8.51 14.14 8.438 14.188 8.394 14.28C8.35 14.376 8.326 14.5 8.326 14.656V14.692Z"
        fill="white"
      />
      <path
        d="M10.1585 15.576V14.132H9.89453V13.732H10.1585V13.54C10.1585 13.328 10.2225 13.168 10.3505 13.052C10.4785 12.936 10.6585 12.88 10.8905 12.88C10.9345 12.88 10.9785 12.884 11.0225 12.888C11.0665 12.896 11.1185 12.904 11.1745 12.916L11.1305 13.34C11.0985 13.336 11.0705 13.332 11.0465 13.328C11.0225 13.324 10.9945 13.324 10.9585 13.324C10.8865 13.324 10.8305 13.344 10.7905 13.38C10.7505 13.416 10.7345 13.472 10.7345 13.54V13.732H11.0985V14.132H10.7345V15.576H10.1585Z"
        fill="white"
      />
    </svg>
  );
}
export function FileIconLeftArrow() {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M11 17.7499C10.81 17.7499 10.62 17.6799 10.47 17.5299C10.18 17.2399 10.18 16.7599 10.47 16.4699L11.19 15.7499H7C6.59 15.7499 6.25 15.4099 6.25 14.9999C6.25 14.5899 6.59 14.2499 7 14.2499H11.19L10.47 13.5299C10.32 13.3799 10.25 13.1899 10.25 12.9999C10.25 12.8099 10.32 12.6199 10.47 12.4699C10.76 12.1799 11.24 12.1799 11.53 12.4699L13.53 14.4699C13.66 14.5999 13.73 14.7699 13.74 14.9299C13.74 14.9799 13.74 15.0399 13.74 15.0899C13.72 15.2299 13.66 15.3599 13.56 15.4799C13.55 15.4899 13.53 15.5099 13.52 15.5199L11.52 17.5199C11.38 17.6799 11.19 17.7499 11 17.7499Z"
        fill="#C9C9C9"
      />
      <path
        d="M15 22.75H9C3.57 22.75 1.25 20.43 1.25 15V9C1.25 3.57 3.57 1.25 9 1.25H14C14.41 1.25 14.75 1.59 14.75 2C14.75 2.41 14.41 2.75 14 2.75H9C4.39 2.75 2.75 4.39 2.75 9V15C2.75 19.61 4.39 21.25 9 21.25H15C19.61 21.25 21.25 19.61 21.25 15V10C21.25 9.59 21.59 9.25 22 9.25C22.41 9.25 22.75 9.59 22.75 10V15C22.75 20.43 20.43 22.75 15 22.75Z"
        fill="#C9C9C9"
      />
      <path
        d="M22 10.75H18C14.58 10.75 13.25 9.41999 13.25 5.99999V1.99999C13.25 1.69999 13.43 1.41999 13.71 1.30999C13.99 1.18999 14.31 1.25999 14.53 1.46999L22.53 9.46999C22.74 9.67999 22.81 10.01 22.69 10.29C22.57 10.57 22.3 10.75 22 10.75ZM14.75 3.80999V5.99999C14.75 8.57999 15.42 9.24999 18 9.24999H20.19L14.75 3.80999Z"
        fill="#C9C9C9"
      />
    </svg>
  );
}

export function GredientInfoIcon() {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M10.0003 18.3359C14.592 18.3359 18.3336 14.5943 18.3336 10.0026C18.3336 5.41094 14.592 1.66927 10.0003 1.66927C5.40862 1.66927 1.66695 5.41094 1.66695 10.0026C1.66695 14.5943 5.40862 18.3359 10.0003 18.3359ZM10.6253 13.3359C10.6253 13.6776 10.342 13.9609 10.0003 13.9609C9.65862 13.9609 9.37529 13.6776 9.37529 13.3359V9.16927C9.37529 8.8276 9.65862 8.54427 10.0003 8.54427C10.342 8.54427 10.6253 8.8276 10.6253 9.16927V13.3359ZM9.23362 6.3526C9.27528 6.24427 9.33362 6.16094 9.40862 6.07761C9.49195 6.00261 9.58362 5.94427 9.68362 5.9026C9.78362 5.86094 9.89195 5.83594 10.0003 5.83594C10.1086 5.83594 10.217 5.86094 10.317 5.9026C10.417 5.94427 10.5086 6.00261 10.592 6.07761C10.667 6.16094 10.7253 6.24427 10.767 6.3526C10.8086 6.45261 10.8336 6.56094 10.8336 6.66927C10.8336 6.7776 10.8086 6.88594 10.767 6.98594C10.7253 7.08594 10.667 7.1776 10.592 7.26094C10.5086 7.33594 10.417 7.39427 10.317 7.43594C10.117 7.51927 9.88362 7.51927 9.68362 7.43594C9.58362 7.39427 9.49195 7.33594 9.40862 7.26094C9.33362 7.1776 9.27528 7.08594 9.23362 6.98594C9.19195 6.88594 9.16695 6.7776 9.16695 6.66927C9.16695 6.56094 9.19195 6.45261 9.23362 6.3526Z"
        fill="url(#paint0_linear_34672_23657)"
      />
      <defs>
        <linearGradient
          id="paint0_linear_34672_23657"
          x1="10.0003"
          y1="18.3359"
          x2="10.0003"
          y2="1.66927"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="#93BBFB" />
          <stop offset="1" stop-color="#1873BF" />
        </linearGradient>
      </defs>
    </svg>
  );
}
export function InspectionImg() {
  return (
    <svg
      width="350"
      height="200"
      viewBox="0 0 350 276"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M185.695 226.009C237.326 226.009 279.181 184.154 279.181 132.522C279.181 80.8912 237.326 39.0358 185.695 39.0358C134.063 39.0358 92.208 80.8912 92.208 132.522C92.208 184.154 134.063 226.009 185.695 226.009Z"
        fill="#DBE8EC"
      />
      <path
        d="M303.641 134.09V124.295C303.641 122.427 302.899 120.636 301.578 119.315C300.257 117.994 298.466 117.252 296.598 117.252H271.739C270.814 117.252 269.899 117.07 269.044 116.716C268.19 116.362 267.413 115.844 266.759 115.19C266.105 114.536 265.587 113.759 265.233 112.905C264.879 112.05 264.697 111.134 264.697 110.21V100.414C264.697 99.4894 264.879 98.5736 265.233 97.7192C265.587 96.8647 266.105 96.0883 266.759 95.4343C267.413 94.7803 268.19 94.2616 269.044 93.9076C269.899 93.5537 270.814 93.3715 271.739 93.3715H272.524C274.392 93.3715 276.184 92.6295 277.504 91.3087C278.825 89.988 279.567 88.1966 279.567 86.3287V76.5335C279.567 74.6656 278.825 72.8743 277.504 71.5535C276.184 70.2327 274.392 69.4907 272.524 69.4907H93.805C91.9372 69.4907 90.1458 70.2327 88.825 71.5535C87.5042 72.8743 86.7622 74.6656 86.7622 76.5335V86.3287C86.7622 88.1966 87.5042 89.988 88.825 91.3087C90.1458 92.6295 91.9372 93.3715 93.805 93.3715C94.7299 93.3715 95.6457 93.5537 96.5002 93.9076C97.3546 94.2616 98.131 94.7803 98.785 95.4343C99.439 96.0883 99.9578 96.8647 100.312 97.7192C100.666 98.5736 100.848 99.4894 100.848 100.414V110.21C100.848 111.134 100.666 112.05 100.312 112.905C99.9578 113.759 99.439 114.536 98.785 115.19C98.131 115.844 97.3546 116.362 96.5002 116.716C95.6457 117.07 94.7299 117.252 93.805 117.252H66.57C64.7021 117.252 62.9107 117.994 61.59 119.315C60.2692 120.636 59.5272 122.427 59.5272 124.295V134.09C59.5272 135.015 59.7093 135.931 60.0633 136.786C60.4172 137.64 60.936 138.416 61.59 139.07C62.2439 139.724 63.0203 140.243 63.8748 140.597C64.7293 140.951 65.6451 141.133 66.57 141.133H77.2566C79.1244 141.133 80.9158 141.875 82.2366 143.196C83.5574 144.517 84.2994 146.308 84.2994 148.176V157.971C84.2994 158.896 84.1172 159.812 83.7633 160.666C83.4093 161.521 82.8906 162.297 82.2366 162.951C81.5826 163.605 80.8062 164.124 79.9517 164.478C79.0973 164.832 78.1815 165.014 77.2566 165.014H77.2307C75.3629 165.014 73.5716 165.756 72.2508 167.077C70.93 168.398 70.188 170.189 70.188 172.057V181.852C70.188 182.777 70.3702 183.693 70.7241 184.547C71.078 185.402 71.5968 186.178 72.2508 186.832C72.9048 187.486 73.6812 188.005 74.5356 188.359C75.3901 188.713 76.3059 188.895 77.2308 188.895H78.7769C80.6448 188.895 82.4361 189.637 83.7569 190.958C85.0777 192.278 85.8197 194.07 85.8197 195.938V205.733C85.8197 207.601 85.0777 209.392 83.7569 210.713C82.4361 212.034 80.6448 212.776 78.7769 212.776H53.4022C52.4773 212.776 51.5615 212.958 50.707 213.312C49.8525 213.666 49.0761 214.184 48.4222 214.838C47.7682 215.492 47.2494 216.269 46.8955 217.123C46.5415 217.978 46.3594 218.894 46.3594 219.818V229.614C46.3594 230.539 46.5415 231.454 46.8955 232.309C47.2494 233.163 47.7682 233.94 48.4222 234.594C49.0761 235.248 49.8525 235.766 50.707 236.12C51.5615 236.474 52.4773 236.656 53.4022 236.656H276.305C278.173 236.656 279.965 235.914 281.285 234.594C282.606 233.273 283.348 231.482 283.348 229.614V219.818C283.348 217.951 282.606 216.159 281.285 214.838C279.965 213.518 278.173 212.776 276.305 212.776H270.199C268.331 212.776 266.54 212.034 265.219 210.713C263.898 209.392 263.156 207.601 263.156 205.733V195.938C263.156 194.07 263.898 192.278 265.219 190.958C266.54 189.637 268.331 188.895 270.199 188.895H284.597C286.465 188.895 288.256 188.153 289.577 186.832C290.898 185.511 291.64 183.72 291.64 181.852V172.057C291.64 170.189 290.898 168.398 289.577 167.077C288.256 165.756 286.465 165.014 284.597 165.014H280.229C279.305 165.014 278.389 164.832 277.534 164.478C276.68 164.124 275.903 163.605 275.249 162.951C274.595 162.297 274.077 161.521 273.723 160.666C273.369 159.812 273.187 158.896 273.187 157.971V148.176C273.187 146.308 273.929 144.517 275.249 143.196C276.57 141.875 278.362 141.133 280.229 141.133H296.598C298.466 141.133 300.257 140.391 301.578 139.07C302.899 137.75 303.641 135.958 303.641 134.09Z"
        fill="#DBE8EC"
      />
      <path
        d="M88.1914 138.415H104.518"
        stroke="#B9D4DB"
        stroke-width="3"
        stroke-miterlimit="10"
        stroke-linecap="round"
      />
      <path
        d="M88.1914 143.121H104.518"
        stroke="#B9D4DB"
        stroke-width="3"
        stroke-miterlimit="10"
        stroke-linecap="round"
      />
      <path
        d="M88.1914 147.827H104.518"
        stroke="#B9D4DB"
        stroke-width="3"
        stroke-miterlimit="10"
        stroke-linecap="round"
      />
      <path
        d="M237.618 177.199H253.944"
        stroke="#B9D4DB"
        stroke-width="3"
        stroke-miterlimit="10"
        stroke-linecap="round"
      />
      <path
        d="M237.618 181.905H253.944"
        stroke="#B9D4DB"
        stroke-width="3"
        stroke-miterlimit="10"
        stroke-linecap="round"
      />
      <path
        d="M237.618 186.61H253.944"
        stroke="#B9D4DB"
        stroke-width="3"
        stroke-miterlimit="10"
        stroke-linecap="round"
      />
      <path
        d="M165.545 55.6467H181.871"
        stroke="#B9D4DB"
        stroke-width="3"
        stroke-miterlimit="10"
        stroke-linecap="round"
      />
      <path
        d="M165.545 60.3524H181.871"
        stroke="#B9D4DB"
        stroke-width="3"
        stroke-miterlimit="10"
        stroke-linecap="round"
      />
      <path
        d="M165.545 65.0586H181.871"
        stroke="#B9D4DB"
        stroke-width="3"
        stroke-miterlimit="10"
        stroke-linecap="round"
      />
      <path
        d="M211.315 230.485C215.169 230.485 218.294 227.361 218.294 223.507C218.294 219.653 215.169 216.528 211.315 216.528C207.461 216.528 204.337 219.653 204.337 223.507C204.337 227.361 207.461 230.485 211.315 230.485Z"
        fill="#B9D4DB"
      />
      <path
        d="M202.011 210.454C204.009 210.454 205.63 208.834 205.63 206.836C205.63 204.838 204.009 203.218 202.011 203.218C200.013 203.218 198.393 204.838 198.393 206.836C198.393 208.834 200.013 210.454 202.011 210.454Z"
        fill="#B9D4DB"
      />
      <path
        d="M225.681 215.624C228.536 215.624 230.85 213.309 230.85 210.455C230.85 207.6 228.536 205.285 225.681 205.285C222.826 205.285 220.512 207.6 220.512 210.455C220.512 213.309 222.826 215.624 225.681 215.624Z"
        fill="#B9D4DB"
      />
      <path
        d="M112.221 87.5059C116.807 87.5059 120.524 83.7885 120.524 79.2029C120.524 74.6172 116.807 70.8998 112.221 70.8998C107.635 70.8998 103.918 74.6172 103.918 79.2029C103.918 83.7885 107.635 87.5059 112.221 87.5059Z"
        fill="#B9D4DB"
      />
      <path
        d="M96.3552 77.6138C98.7438 77.6138 100.68 75.6775 100.68 73.2889C100.68 70.9003 98.7438 68.964 96.3552 68.964C93.9666 68.964 92.0303 70.9003 92.0303 73.2889C92.0303 75.6775 93.9666 77.6138 96.3552 77.6138Z"
        fill="#B9D4DB"
      />
      <path
        d="M100.328 61.082C101.705 61.082 102.822 59.9651 102.822 58.5873C102.822 57.2096 101.705 56.0927 100.328 56.0927C98.9499 56.0927 97.833 57.2096 97.833 58.5873C97.833 59.9651 98.9499 61.082 100.328 61.082Z"
        fill="#B9D4DB"
      />
      <path
        d="M114.138 66.3331C117.441 66.3331 120.119 63.6554 120.119 60.3524C120.119 57.0494 117.441 54.3717 114.138 54.3717C110.835 54.3717 108.157 57.0494 108.157 60.3524C108.157 63.6554 110.835 66.3331 114.138 66.3331Z"
        fill="#B9D4DB"
      />
      <path
        d="M260.617 109.189C265.202 109.189 268.92 105.471 268.92 100.886C268.92 96.2999 265.202 92.5825 260.617 92.5825C256.031 92.5825 252.313 96.2999 252.313 100.886C252.313 105.471 256.031 109.189 260.617 109.189Z"
        fill="#B9D4DB"
      />
      <path
        d="M243.711 106.146C246.099 106.146 248.036 104.21 248.036 101.822C248.036 99.4329 246.099 97.4966 243.711 97.4966C241.322 97.4966 239.386 99.4329 239.386 101.822C239.386 104.21 241.322 106.146 243.711 106.146Z"
        fill="#B9D4DB"
      />
      <path
        d="M244.066 76.6506C246.133 76.6506 247.809 74.9746 247.809 72.9072C247.809 70.8398 246.133 69.1638 244.066 69.1638C241.998 69.1638 240.322 70.8398 240.322 72.9072C240.322 74.9746 241.998 76.6506 244.066 76.6506Z"
        fill="#B9D4DB"
      />
      <path
        d="M241.461 89.2543C242.839 89.2543 243.956 88.1374 243.956 86.7596C243.956 85.3818 242.839 84.2649 241.461 84.2649C240.084 84.2649 238.967 85.3818 238.967 86.7596C238.967 88.1374 240.084 89.2543 241.461 89.2543Z"
        fill="#B9D4DB"
      />
      <path
        d="M254.822 88.8263C258.126 88.8263 260.803 86.1486 260.803 82.8456C260.803 79.5425 258.126 76.8649 254.822 76.8649C251.519 76.8649 248.842 79.5425 248.842 82.8456C248.842 86.1486 251.519 88.8263 254.822 88.8263Z"
        fill="#B9D4DB"
      />
      <path
        d="M201.466 120.551C212.429 120.551 221.316 111.663 221.316 100.7C221.316 89.7373 212.429 80.85 201.466 80.85C190.503 80.85 181.615 89.7373 181.615 100.7C181.615 111.663 190.503 120.551 201.466 120.551Z"
        fill="#D62828"
      />
      <path
        d="M213.235 93.9853C214.955 93.9853 216.349 92.5911 216.349 90.8714C216.349 89.1516 214.955 87.7574 213.235 87.7574C211.515 87.7574 210.121 89.1516 210.121 90.8714C210.121 92.5911 211.515 93.9853 213.235 93.9853Z"
        fill="#F9AE2B"
      />
      <path
        d="M265.51 149.083C271.127 137.652 244.009 112.823 204.941 93.6265C165.873 74.4297 129.649 68.1343 124.032 79.5653C118.416 90.9962 145.533 115.825 184.601 135.022C223.669 154.218 259.893 160.514 265.51 149.083Z"
        fill="#1D406A"
      />
      <path
        d="M200.822 102.01C234.981 118.795 260.004 139.885 261.998 152.561C263.503 151.798 264.732 150.581 265.51 149.083C271.127 137.652 244.01 112.823 204.942 93.6264C165.874 74.4295 129.65 68.1339 124.033 79.565C123.322 81.0965 123.11 82.8121 123.425 84.4707C134.678 78.3038 166.663 85.2252 200.822 102.01Z"
        fill="#2179C4"
      />
      <path
        d="M218.922 136.436C221.161 131.878 210.349 121.978 194.771 114.324C179.194 106.67 164.75 104.16 162.51 108.718C160.271 113.276 171.083 123.176 186.661 130.83C202.238 138.484 216.682 140.994 218.922 136.436Z"
        fill="#F9AE2B"
      />
      <path
        d="M193.129 117.667C206.749 124.36 216.727 132.769 217.522 137.823C218.122 137.519 218.612 137.034 218.922 136.436C221.162 131.879 210.349 121.979 194.772 114.324C179.194 106.67 164.75 104.159 162.511 108.717C162.228 109.328 162.143 110.012 162.269 110.673C166.755 108.215 179.509 110.974 193.129 117.667Z"
        fill="#EA9918"
      />
      <path
        d="M185.669 232.284H61.7441L162.268 110.673L218.1 138.108L185.669 232.284Z"
        fill="url(#paint0_linear_37480_100074)"
      />
      <defs>
        <linearGradient
          id="paint0_linear_37480_100074"
          x1="207.452"
          y1="131.825"
          x2="106.577"
          y2="251.288"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="#F9AE2B" />
          <stop offset="1" stop-color="white" stop-opacity="0" />
        </linearGradient>
      </defs>
    </svg>
  );
}
export function TableHeaderFilterIcon({ size, color }) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 16 17"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M13 5.625H3M11.625 8.5H4.375M10.25 11.375H5.75"
        stroke={color}
        stroke-linecap="round"
      />
    </svg>
  );
}
TableHeaderFilterIcon.propTypes = {
  size: PropTypes.string,
  color: PropTypes.string,
};
TableHeaderFilterIcon.defaultProps = {
  size: '1.111vw',
  color: '#A6ABB5',
};
export function CurrencyWalletIcon() {
  return (
    <svg
      width="26"
      height="26"
      viewBox="0 0 26 26"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect x="0.5" y="0.5" width="25" height="25" rx="12.5" stroke="#2179C4" />
      <path
        d="M9.12626 10.205C8.96626 10.205 8.81959 10.1317 8.71959 9.99832C8.60626 9.84499 8.59293 9.64497 8.67959 9.4783C8.79293 9.25163 8.95293 9.03165 9.15959 8.83165L11.3263 6.65831C12.4329 5.55831 14.2329 5.55831 15.3396 6.65831L16.5063 7.845C16.9996 8.33167 17.2996 8.985 17.3329 9.67833C17.3396 9.83167 17.2796 9.97832 17.1663 10.0783C17.0529 10.1783 16.8996 10.225 16.7529 10.1983C16.6196 10.1783 16.4796 10.1717 16.3329 10.1717H9.66626C9.50626 10.1717 9.35293 10.185 9.19959 10.205C9.17959 10.205 9.15293 10.205 9.12626 10.205ZM10.2396 9.16499H16.2129C16.1263 8.93832 15.9863 8.73166 15.7996 8.54499L14.6263 7.3583C13.9129 6.65164 12.7463 6.65164 12.0263 7.3583L10.2396 9.16499Z"
        fill="#2179C4"
      />
      <path
        d="M8.33332 20.8333C7.22666 20.8333 6.18666 20.2467 5.62666 19.2933C5.32666 18.8133 5.16666 18.2467 5.16666 17.6667C5.16666 15.92 6.58666 14.5 8.33332 14.5C10.08 14.5 11.5 15.92 11.5 17.6667C11.5 18.2467 11.34 18.8133 11.04 19.3C10.48 20.2467 9.43999 20.8333 8.33332 20.8333ZM8.33332 15.5C7.13999 15.5 6.16666 16.4733 6.16666 17.6667C6.16666 18.06 6.27332 18.4467 6.47999 18.78C6.87332 19.4467 7.56666 19.8333 8.33332 19.8333C9.09999 19.8333 9.79332 19.44 10.1867 18.7867C10.3933 18.4467 10.5 18.0667 10.5 17.6667C10.5 16.4733 9.52666 15.5 8.33332 15.5Z"
        fill="#2179C4"
      />
      <path
        d="M9.32694 18.1528H7.34027C7.06694 18.1528 6.84027 17.9261 6.84027 17.6528C6.84027 17.3794 7.06694 17.1528 7.34027 17.1528H9.3336C9.60694 17.1528 9.8336 17.3794 9.8336 17.6528C9.8336 17.9261 9.60694 18.1528 9.32694 18.1528Z"
        fill="#2179C4"
      />
      <path
        d="M8.33334 19.1739C8.06001 19.1739 7.83334 18.9472 7.83334 18.6739V16.6805C7.83334 16.4072 8.06001 16.1805 8.33334 16.1805C8.60668 16.1805 8.83334 16.4072 8.83334 16.6805V18.6739C8.83334 18.9539 8.60668 19.1739 8.33334 19.1739Z"
        fill="#2179C4"
      />
      <path
        d="M16.3328 20.1667H10.0861C9.87279 20.1667 9.68612 20.0334 9.61279 19.84C9.53946 19.64 9.59946 19.42 9.75946 19.2867C9.91946 19.1533 10.0661 18.98 10.1728 18.7934C10.3861 18.4534 10.4928 18.0667 10.4928 17.6734C10.4928 16.48 9.51946 15.5067 8.32612 15.5067C7.70612 15.5067 7.11279 15.7734 6.69946 16.2467C6.55946 16.4 6.33946 16.46 6.14612 16.3867C5.95279 16.3134 5.81946 16.1267 5.81946 15.92V13C5.81946 10.9467 7.08612 9.46003 9.05279 9.21336C9.23279 9.18669 9.43946 9.16669 9.65279 9.16669H16.3195C16.4795 9.16669 16.6861 9.17335 16.8995 9.20669C18.8661 9.43335 20.1528 10.9267 20.1528 13V16.3334C20.1661 18.6267 18.6261 20.1667 16.3328 20.1667ZM11.1195 19.1667H16.3328C18.0528 19.1667 19.1661 18.0534 19.1661 16.3334V13C19.1661 11.44 18.2528 10.3667 16.7728 10.1933C16.6128 10.1667 16.4728 10.1667 16.3328 10.1667H9.66612C9.50612 10.1667 9.35279 10.18 9.19946 10.2C7.73279 10.3867 6.83279 11.4534 6.83279 13V14.88C7.28612 14.6334 7.80612 14.5 8.33279 14.5C10.0795 14.5 11.4995 15.92 11.4995 17.6667C11.4995 18.1934 11.3661 18.7134 11.1195 19.1667Z"
        fill="#2179C4"
      />
      <path
        d="M19.6667 16.5H17.6667C16.6533 16.5 15.8333 15.68 15.8333 14.6666C15.8333 13.6533 16.6533 12.8333 17.6667 12.8333H19.6667C19.94 12.8333 20.1667 13.06 20.1667 13.3333C20.1667 13.6066 19.94 13.8333 19.6667 13.8333H17.6667C17.2067 13.8333 16.8333 14.2066 16.8333 14.6666C16.8333 15.1266 17.2067 15.5 17.6667 15.5H19.6667C19.94 15.5 20.1667 15.7266 20.1667 16C20.1667 16.2733 19.94 16.5 19.6667 16.5Z"
        fill="#2179C4"
      />
    </svg>
  );
}
export function RedCircleMinusIcon() {
  return (
    <svg
      width="1.25vw"
      height="1.25vw"
      viewBox="0 0 18 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M8.99935 0.666016C4.40768 0.666016 0.666016 4.40768 0.666016 8.99935C0.666016 13.591 4.40768 17.3327 8.99935 17.3327C13.591 17.3327 17.3327 13.591 17.3327 8.99935C17.3327 4.40768 13.591 0.666016 8.99935 0.666016ZM12.266 9.62435H5.59935C5.25768 9.62435 4.97435 9.34102 4.97435 8.99935C4.97435 8.65768 5.25768 8.37435 5.59935 8.37435H12.266C12.6077 8.37435 12.891 8.65768 12.891 8.99935C12.891 9.34102 12.616 9.62435 12.266 9.62435Z"
        fill="#D2253B"
      />
    </svg>
  );
}
export function InfoQuestionIcon({ size }) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M20 10C20 15.5228 15.5228 20 10 20C4.47715 20 0 15.5228 0 10C0 4.47715 4.47715 0 10 0C15.5228 0 20 4.47715 20 10ZM10 5.75C9.3787 5.75 8.875 6.25368 8.875 6.875C8.875 7.28921 8.5392 7.625 8.125 7.625C7.71079 7.625 7.375 7.28921 7.375 6.875C7.375 5.42525 8.5503 4.25 10 4.25C11.4497 4.25 12.625 5.42525 12.625 6.875C12.625 7.58584 12.3415 8.232 11.883 8.704C11.7907 8.7989 11.7027 8.8869 11.6187 8.9708C11.4029 9.1864 11.2138 9.3753 11.0479 9.5885C10.8289 9.8699 10.75 10.0768 10.75 10.25V11C10.75 11.4142 10.4142 11.75 10 11.75C9.5858 11.75 9.25 11.4142 9.25 11V10.25C9.25 9.5948 9.555 9.0644 9.8642 8.6672C10.0929 8.3733 10.3804 8.0863 10.6138 7.85346C10.6842 7.78321 10.7496 7.71789 10.807 7.65877C11.0046 7.45543 11.125 7.18004 11.125 6.875C11.125 6.25368 10.6213 5.75 10 5.75ZM10 15C10.5523 15 11 14.5523 11 14C11 13.4477 10.5523 13 10 13C9.4477 13 9 13.4477 9 14C9 14.5523 9.4477 15 10 15Z"
        fill="url(#paint0_linear_28534_54733)"
      />
      <defs>
        <linearGradient
          id="paint0_linear_28534_54733"
          x1="20"
          y1="0.92437"
          x2="-1.70977"
          y2="19.1144"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="#1D4069" />
          <stop offset="1" stop-color="#266CBD" />
        </linearGradient>
      </defs>
    </svg>
  );
}
InfoQuestionIcon.propTypes = {
  size: PropTypes.string,
};
InfoQuestionIcon.defaultProps = {
  size: '1.389vw',
};
export function ActionPendingWarning() {
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M8 6V9.33333"
        stroke="#BF182C"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M8.00028 14.2716H3.96028C1.64695 14.2716 0.680281 12.6182 1.80028 10.5982L3.88028 6.85156L5.84028 3.33156C7.02695 1.19156 8.97361 1.19156 10.1603 3.33156L12.1203 6.85823L14.2003 10.6049C15.3203 12.6249 14.3469 14.2782 12.0403 14.2782H8.00028V14.2716Z"
        stroke="#BF182C"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M7.99609 11.332H8.00208"
        stroke="#BF182C"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  );
}
export function ActionPendingWarningGradient() {
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M14.5076 10.612L10.241 2.93203C9.66763 1.8987 8.87429 1.33203 8.00096 1.33203C7.12763 1.33203 6.33429 1.8987 5.76096 2.93203L1.49429 10.612C0.954295 11.592 0.894295 12.532 1.32763 13.272C1.76096 14.012 2.61429 14.4187 3.73429 14.4187H12.2676C13.3876 14.4187 14.241 14.012 14.6743 13.272C15.1076 12.532 15.0476 11.5854 14.5076 10.612ZM7.50096 5.9987C7.50096 5.72536 7.72763 5.4987 8.00096 5.4987C8.27429 5.4987 8.50096 5.72536 8.50096 5.9987V9.33203C8.50096 9.60536 8.27429 9.83203 8.00096 9.83203C7.72763 9.83203 7.50096 9.60536 7.50096 9.33203V5.9987ZM8.47429 11.8054C8.44096 11.832 8.40763 11.8587 8.37429 11.8854C8.33429 11.912 8.29429 11.932 8.25429 11.9454C8.21429 11.9654 8.17429 11.9787 8.12763 11.9854C8.08763 11.992 8.04096 11.9987 8.00096 11.9987C7.96096 11.9987 7.91429 11.992 7.86763 11.9854C7.82763 11.9787 7.78763 11.9654 7.74763 11.9454C7.70763 11.932 7.66763 11.912 7.62763 11.8854C7.59429 11.8587 7.56096 11.832 7.52763 11.8054C7.40763 11.6787 7.33429 11.5054 7.33429 11.332C7.33429 11.1587 7.40763 10.9854 7.52763 10.8587C7.56096 10.832 7.59429 10.8054 7.62763 10.7787C7.66763 10.752 7.70763 10.732 7.74763 10.7187C7.78763 10.6987 7.82763 10.6854 7.86763 10.6787C7.95429 10.6587 8.04763 10.6587 8.12763 10.6787C8.17429 10.6854 8.21429 10.6987 8.25429 10.7187C8.29429 10.732 8.33429 10.752 8.37429 10.7787C8.40763 10.8054 8.44096 10.832 8.47429 10.8587C8.59429 10.9854 8.66763 11.1587 8.66763 11.332C8.66763 11.5054 8.59429 11.6787 8.47429 11.8054Z"
        fill="url(#paint0_linear_21932_154239)"
      />
      <defs>
        <linearGradient
          id="paint0_linear_21932_154239"
          x1="8.00096"
          y1="1.33203"
          x2="8.00096"
          y2="14.4187"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="#FB93AC" />
          <stop offset="1" stop-color="#BF182C" />
        </linearGradient>
      </defs>
    </svg>
  );
}
export function InfoGradientIconBlue({ width, height }) {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 13 12"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M6.25 1C3.495 1 1.25 3.245 1.25 6C1.25 8.755 3.495 11 6.25 11C9.005 11 11.25 8.755 11.25 6C11.25 3.245 9.005 1 6.25 1ZM5.875 4C5.875 3.795 6.045 3.625 6.25 3.625C6.455 3.625 6.625 3.795 6.625 4V6.5C6.625 6.705 6.455 6.875 6.25 6.875C6.045 6.875 5.875 6.705 5.875 6.5V4ZM6.71 8.19C6.685 8.255 6.65 8.305 6.605 8.355C6.555 8.4 6.5 8.435 6.44 8.46C6.38 8.485 6.315 8.5 6.25 8.5C6.185 8.5 6.12 8.485 6.06 8.46C6 8.435 5.945 8.4 5.895 8.355C5.85 8.305 5.815 8.255 5.79 8.19C5.765 8.13 5.75 8.065 5.75 8C5.75 7.935 5.765 7.87 5.79 7.81C5.815 7.75 5.85 7.695 5.895 7.645C5.945 7.6 6 7.565 6.06 7.54C6.18 7.49 6.32 7.49 6.44 7.54C6.5 7.565 6.555 7.6 6.605 7.645C6.65 7.695 6.685 7.75 6.71 7.81C6.735 7.87 6.75 7.935 6.75 8C6.75 8.065 6.735 8.13 6.71 8.19Z"
        fill="url(#paint0_linear_31366_82099)"
      />
      <defs>
        <linearGradient
          id="paint0_linear_31366_82099"
          x1="6.25"
          y1="1"
          x2="6.25"
          y2="11"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="#93BBFB" />
          <stop offset="1" stop-color="#1873BF" />
        </linearGradient>
      </defs>
    </svg>
  );
}
InfoGradientIconBlue.propTypes = {
  width: PropTypes.string,
  height: PropTypes.string,
};
InfoGradientIconBlue.defaultProps = {
  width: '13px',
  height: '12px',
};

export function ReceiptEditIcon({ size, color }) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 18 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M7.90503 16.455C7.73253 16.455 7.56752 16.38 7.45502 16.23L6.69752 15.2175C6.54002 15.0075 6.33003 14.8875 6.10503 14.8725C5.87253 14.8575 5.65501 14.9625 5.47501 15.15C4.38751 16.3125 3.56252 16.215 3.16502 16.065C2.76002 15.9075 2.07751 15.39 2.07751 13.725V5.28001C2.07751 1.95001 3.03752 0.9375 6.18002 0.9375H11.8425C14.985 0.9375 15.945 1.95001 15.945 5.28001V8.47499C15.945 8.78249 15.69 9.03749 15.3825 9.03749C15.075 9.03749 14.82 8.78249 14.82 8.47499V5.28001C14.82 2.57251 14.3475 2.0625 11.8425 2.0625H6.18002C3.67502 2.0625 3.20251 2.57251 3.20251 5.28001V13.725C3.20251 14.5125 3.39751 14.9475 3.57751 15.015C3.71251 15.0675 4.08003 14.9925 4.65003 14.385C5.06253 13.95 5.60252 13.7175 6.16502 13.7475C6.72002 13.7775 7.24503 14.07 7.59753 14.5425L8.36252 15.555C8.55002 15.8025 8.49752 16.155 8.25002 16.3425C8.13752 16.425 8.01753 16.455 7.90503 16.455Z"
        fill={color}
      />
      <path
        d="M12 5.8125H6C5.6925 5.8125 5.4375 5.5575 5.4375 5.25C5.4375 4.9425 5.6925 4.6875 6 4.6875H12C12.3075 4.6875 12.5625 4.9425 12.5625 5.25C12.5625 5.5575 12.3075 5.8125 12 5.8125Z"
        fill={color}
      />
      <path
        d="M11.25 8.8125H6.75C6.4425 8.8125 6.1875 8.5575 6.1875 8.25C6.1875 7.9425 6.4425 7.6875 6.75 7.6875H11.25C11.5575 7.6875 11.8125 7.9425 11.8125 8.25C11.8125 8.5575 11.5575 8.8125 11.25 8.8125Z"
        fill={color}
      />
      <path
        d="M11.115 16.3352C10.83 16.3352 10.56 16.2302 10.365 16.0352C10.1325 15.8027 10.0275 15.4652 10.08 15.1127L10.2225 14.1002C10.26 13.8377 10.4175 13.5227 10.605 13.3352L13.26 10.6802C13.62 10.3202 13.9725 10.1327 14.355 10.0952C14.82 10.0502 15.285 10.2452 15.72 10.6802C16.155 11.1152 16.35 11.5727 16.305 12.0452C16.2675 12.4202 16.0725 12.7802 15.72 13.1402L13.065 15.7952C12.8775 15.9827 12.5625 16.1402 12.3 16.1777L11.2875 16.3202C11.2275 16.3277 11.175 16.3352 11.115 16.3352ZM14.4825 11.2127C14.475 11.2127 14.4675 11.2127 14.46 11.2127C14.355 11.2202 14.2125 11.3177 14.055 11.4752L11.4 14.1302C11.3775 14.1527 11.34 14.2277 11.34 14.2577L11.205 15.1952L12.1425 15.0602C12.1725 15.0527 12.2475 15.0152 12.27 14.9927L14.925 12.3377C15.0825 12.1727 15.18 12.0377 15.1875 11.9327C15.2025 11.7827 15.0525 11.6027 14.925 11.4752C14.805 11.3552 14.6325 11.2127 14.4825 11.2127Z"
        fill={color}
      />
      <path
        d="M14.9401 13.6872C14.8876 13.6872 14.8351 13.6797 14.7901 13.6647C13.8001 13.3872 13.0126 12.5997 12.7351 11.6097C12.6526 11.3097 12.8251 11.0022 13.1251 10.9122C13.4251 10.8297 13.7326 11.0022 13.8151 11.3022C13.9876 11.9172 14.4751 12.4047 15.0901 12.5772C15.3901 12.6597 15.5626 12.9747 15.4801 13.2747C15.4126 13.5222 15.1876 13.6872 14.9401 13.6872Z"
        fill={color}
      />
    </svg>
  );
}
ReceiptEditIcon.propTypes = {
  size: PropTypes.string,
  color: PropTypes.string,
};
ReceiptEditIcon.defaultProps = {
  size: '1.25vw',
  color: '#2179C4',
};
export function EditTableIcon({ size, color }) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 10 10"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M6.25065 9.47982H3.75065C1.48815 9.47982 0.521484 8.51315 0.521484 6.25065V3.75065C0.521484 1.48815 1.48815 0.521484 3.75065 0.521484H4.58398C4.75482 0.521484 4.89648 0.663151 4.89648 0.833984C4.89648 1.00482 4.75482 1.14648 4.58398 1.14648H3.75065C1.82982 1.14648 1.14648 1.82982 1.14648 3.75065V6.25065C1.14648 8.17148 1.82982 8.85482 3.75065 8.85482H6.25065C8.17148 8.85482 8.85482 8.17148 8.85482 6.25065V5.41732C8.85482 5.24648 8.99648 5.10482 9.16732 5.10482C9.33815 5.10482 9.47982 5.24648 9.47982 5.41732V6.25065C9.47982 8.51315 8.51315 9.47982 6.25065 9.47982Z"
        fill={color}
      />
      <path
        d="M3.54205 7.37025C3.28788 7.37025 3.05455 7.27858 2.88371 7.11191C2.67955 6.90775 2.59205 6.61191 2.63788 6.29941L2.81705 5.04525C2.85038 4.80358 3.00871 4.49108 3.17955 4.32025L6.46288 1.03691C7.29205 0.207747 8.13371 0.207747 8.96288 1.03691C9.41705 1.49108 9.62121 1.95358 9.57955 2.41608C9.54205 2.79108 9.34205 3.15775 8.96288 3.53275L5.67955 6.81608C5.50871 6.98691 5.19621 7.14525 4.95455 7.17858L3.70038 7.35775C3.64621 7.37025 3.59205 7.37025 3.54205 7.37025ZM6.90455 1.47858L3.62121 4.76191C3.54205 4.84108 3.45038 5.02441 3.43371 5.13275L3.25455 6.38691C3.23788 6.50775 3.26288 6.60775 3.32538 6.67025C3.38788 6.73275 3.48788 6.75775 3.60871 6.74108L4.86288 6.56191C4.97121 6.54525 5.15871 6.45358 5.23371 6.37441L8.51705 3.09108C8.78788 2.82025 8.92955 2.57858 8.95038 2.35358C8.97538 2.08275 8.83371 1.79525 8.51705 1.47441C7.85038 0.807747 7.39205 0.995247 6.90455 1.47858Z"
        fill={color}
      />
      <path
        d="M8.27114 4.09562C8.24198 4.09562 8.21281 4.09145 8.18781 4.08312C7.09197 3.77479 6.22114 2.90395 5.91281 1.80812C5.86697 1.64145 5.96281 1.47062 6.12947 1.42062C6.29614 1.37479 6.46698 1.47062 6.51281 1.63729C6.76281 2.52479 7.46697 3.22895 8.35447 3.47895C8.52114 3.52479 8.61697 3.69979 8.57114 3.86645C8.53364 4.00812 8.40864 4.09562 8.27114 4.09562Z"
        fill={color}
      />
    </svg>
  );
}
EditTableIcon.propTypes = {
  size: PropTypes.string,
  color: PropTypes.string,
};
EditTableIcon.defaultProps = {
  size: '0.694vw',
  color: '#0088FA',
};

export function ContainerBlueIcon() {
  return (
    <svg
      width="14"
      height="15"
      viewBox="0 0 14 15"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clip-path="url(#clip0_44386_35613)">
        <path
          d="M12.1523 7.43205L7.0001 4.85583L1.84788 7.43205L1.6521 7.0407L6.9021 4.4157C6.93249 4.4005 6.96601 4.39258 6.99999 4.39258C7.03397 4.39258 7.06749 4.4005 7.09788 4.4157L12.3479 7.0407L12.1523 7.43205Z"
          fill="#0088FA"
        />
        <path
          d="M6.01463 4.85955L1.6521 7.0407L1.84788 7.43205L6.28501 5.21348C6.17155 5.11531 6.07951 4.99483 6.01463 4.85955ZM6.73169 4.99014L6.99988 4.85605L7.26807 4.99014C7.41285 4.92468 7.52908 4.80907 7.59532 4.66464L7.09766 4.4157C7.06727 4.4005 7.03376 4.39258 6.99977 4.39258C6.96579 4.39258 6.93227 4.4005 6.90188 4.4157L6.40423 4.66464C6.47051 4.80902 6.58688 4.92495 6.73169 4.99014ZM12.3477 7.0407L7.98491 4.85933C7.92013 4.99468 7.82817 5.11524 7.71476 5.21348L12.1519 7.43205L12.3477 7.0407Z"
          fill="#1D3E69"
        />
        <path
          d="M7 5.04883C6.90419 5.04883 6.81384 5.02717 6.73181 4.98998L6.28513 5.21333C6.47719 5.38111 6.72547 5.48633 7 5.48633C7.27453 5.48633 7.52281 5.38111 7.71509 5.21355L7.26841 4.9902C7.18412 5.02858 7.09262 5.04857 7 5.04883ZM6.34375 4.39258C6.34375 4.03077 6.63819 3.73633 7 3.73633C7.05802 3.73633 7.11366 3.71328 7.15468 3.67226C7.1957 3.63123 7.21875 3.57559 7.21875 3.51758V1.98633C7.21875 1.92831 7.1957 1.87267 7.15468 1.83165C7.11366 1.79062 7.05802 1.76758 7 1.76758C6.94198 1.76758 6.88634 1.79062 6.84532 1.83165C6.8043 1.87267 6.78125 1.92831 6.78125 1.98633V3.32092C6.53441 3.37169 6.31261 3.50598 6.15323 3.70119C5.99384 3.89639 5.90662 4.14057 5.90625 4.39258C5.90625 4.56014 5.94716 4.7172 6.01475 4.85939L6.40434 4.66448C6.36474 4.57929 6.34406 4.48653 6.34375 4.39258ZM8.09375 4.39258C8.09375 4.33456 8.0707 4.27892 8.02968 4.2379C7.98866 4.19687 7.93302 4.17383 7.875 4.17383C7.81698 4.17383 7.76134 4.19687 7.72032 4.2379C7.6793 4.27892 7.65625 4.33456 7.65625 4.39258C7.65625 4.48992 7.63372 4.58136 7.59544 4.66448L7.98503 4.85939C8.05284 4.7172 8.09375 4.56014 8.09375 4.39258Z"
          fill="#4D4D4D"
        />
        <path
          d="M7.98515 4.85897L7.59556 4.66406C7.52939 4.80854 7.41314 4.92417 7.26831 4.98956L7.715 5.21291C7.82833 5.11466 7.92028 4.9942 7.98515 4.85897Z"
          fill="#4D4D4D"
        />
        <path d="M0.875 7.67383H13.125V12.9238H0.875V7.67383Z" fill="#326DD4" />
        <path
          d="M0.65625 6.79883H13.3438V7.67383H0.65625V6.79883ZM0.65625 12.9238H13.3438V13.7988H0.65625V12.9238Z"
          fill="#2861AC"
        />
        <path
          d="M7.4375 1.98633H6.5625C6.50448 1.98633 6.44884 1.96328 6.40782 1.92226C6.3668 1.88123 6.34375 1.82559 6.34375 1.76758V1.11133H7.65625V1.76758C7.65625 1.82559 7.6332 1.88123 7.59218 1.92226C7.55116 1.96328 7.49552 1.98633 7.4375 1.98633Z"
          fill="#666666"
        />
        <path
          d="M8.09375 1.33008H5.90625C5.84823 1.33008 5.79259 1.30703 5.75157 1.26601C5.71055 1.22498 5.6875 1.16934 5.6875 1.11133C5.6875 1.05331 5.71055 0.997672 5.75157 0.956649C5.79259 0.915625 5.84823 0.892578 5.90625 0.892578H8.09375C8.15177 0.892578 8.20741 0.915625 8.24843 0.956649C8.28945 0.997672 8.3125 1.05331 8.3125 1.11133C8.3125 1.16934 8.28945 1.22498 8.24843 1.26601C8.20741 1.30703 8.15177 1.33008 8.09375 1.33008Z"
          fill="#4D4D4D"
        />
        <path
          d="M4.59375 12.3875C3.27972 12.3875 2.02584 12.256 0.875 12.0191V12.9232H13.125V9.94336C11.3461 11.4107 8.19131 12.3875 4.59375 12.3875Z"
          fill="#2D4DBF"
        />
        <path
          d="M4.375 12.2676H3.9375V8.54883C3.9375 8.49081 3.96055 8.43517 4.00157 8.39415C4.04259 8.35312 4.09823 8.33008 4.15625 8.33008H4.59375V8.76758H4.375V12.2676ZM3.28125 12.2676H2.84375V8.54883C2.84375 8.49081 2.8668 8.43517 2.90782 8.39415C2.94884 8.35312 3.00448 8.33008 3.0625 8.33008H3.5V8.76758H3.28125V12.2676ZM2.1875 12.2676H1.75V8.54883C1.75 8.49081 1.77305 8.43517 1.81407 8.39415C1.85509 8.35312 1.91073 8.33008 1.96875 8.33008H2.40625V8.76758H2.1875V12.2676ZM5.46875 12.2676H5.03125V8.54883C5.03125 8.49081 5.0543 8.43517 5.09532 8.39415C5.13634 8.35312 5.19198 8.33008 5.25 8.33008H5.6875V8.76758H5.46875V12.2676ZM6.5625 12.2676H6.125V8.54883C6.125 8.49081 6.14805 8.43517 6.18907 8.39415C6.23009 8.35312 6.28573 8.33008 6.34375 8.33008H6.78125V8.76758H6.5625V12.2676ZM7.65625 12.2676H7.21875V8.54883C7.21875 8.49081 7.2418 8.43517 7.28282 8.39415C7.32384 8.35312 7.37948 8.33008 7.4375 8.33008H7.875V8.76758H7.65625V12.2676ZM8.75 12.2676H8.3125V8.54883C8.3125 8.49081 8.33555 8.43517 8.37657 8.39415C8.41759 8.35312 8.47323 8.33008 8.53125 8.33008H8.96875V8.76758H8.75V12.2676ZM9.84375 12.2676H9.40625V8.54883C9.40625 8.49081 9.4293 8.43517 9.47032 8.39415C9.51134 8.35312 9.56698 8.33008 9.625 8.33008H10.0625V8.76758H9.84375V12.2676ZM10.9375 12.2676H10.5V8.54883C10.5 8.49081 10.523 8.43517 10.5641 8.39415C10.6051 8.35312 10.6607 8.33008 10.7188 8.33008H11.1562V8.76758H10.9375V12.2676ZM12.0312 12.2676H11.5938V8.54883C11.5938 8.49081 11.6168 8.43517 11.6578 8.39415C11.6988 8.35312 11.7545 8.33008 11.8125 8.33008H12.25V8.76758H12.0312V12.2676Z"
          fill="#2851AA"
        />
      </g>
      <defs>
        <clipPath id="clip0_44386_35613">
          <rect
            width="14"
            height="14"
            fill="white"
            transform="translate(0 0.455078)"
          />
        </clipPath>
      </defs>
    </svg>
  );
}

export function NewCreateBookingIcon({ color, size }) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 16 17"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M14.6666 6.99992C14.3933 6.99992 14.1666 6.77325 14.1666 6.49992V5.16658C14.1666 3.44659 13.0533 2.33325 11.3333 2.33325H4.66658C2.94659 2.33325 1.83325 3.44659 1.83325 5.16658V6.49992C1.83325 6.77325 1.60659 6.99992 1.33325 6.99992C1.05992 6.99992 0.833252 6.77325 0.833252 6.49992V5.16658C0.833252 2.87325 2.37325 1.33325 4.66658 1.33325H11.3333C13.6266 1.33325 15.1666 2.87325 15.1666 5.16658V6.49992C15.1666 6.77325 14.9399 6.99992 14.6666 6.99992Z"
        fill={color}
      />
      <path
        d="M11.3333 15.6667H4.66658C2.37325 15.6667 0.833252 14.1267 0.833252 11.8333V10.5C0.833252 10.2267 1.05992 10 1.33325 10C1.60659 10 1.83325 10.2267 1.83325 10.5V11.8333C1.83325 13.5533 2.94659 14.6667 4.66658 14.6667H11.3333C13.0533 14.6667 14.1666 13.5533 14.1666 11.8333V10.5C14.1666 10.2267 14.3933 10 14.6666 10C14.9399 10 15.1666 10.2267 15.1666 10.5V11.8333C15.1666 14.1267 13.6266 15.6667 11.3333 15.6667Z"
        fill={color}
      />
      <path
        d="M8.00015 9.21997C7.91349 9.21997 7.82682 9.19994 7.74682 9.15328L4.21349 7.11328C3.97349 6.97328 3.89349 6.66663 4.03349 6.42663C4.17349 6.18663 4.48016 6.10662 4.71349 6.24662L7.99349 8.1466L11.2535 6.25997C11.4935 6.11997 11.8001 6.20661 11.9335 6.43994C12.0735 6.67994 11.9868 6.98662 11.7535 7.12662L8.24682 9.15328C8.17348 9.19328 8.08682 9.21997 8.00015 9.21997Z"
        fill={color}
      />
      <path
        d="M8 12.8466C7.72667 12.8466 7.5 12.62 7.5 12.3466V8.71997C7.5 8.44664 7.72667 8.21997 8 8.21997C8.27333 8.21997 8.5 8.44664 8.5 8.71997V12.3466C8.5 12.62 8.27333 12.8466 8 12.8466Z"
        fill={color}
      />
      <path
        d="M8.00015 12.9998C7.61349 12.9998 7.23349 12.9131 6.92682 12.7465L4.79349 11.5598C4.15349 11.2065 3.66016 10.3598 3.66016 9.62646V7.36645C3.66016 6.63978 4.16015 5.79314 4.79349 5.43314L6.92682 4.24646C7.54015 3.90646 8.46015 3.90646 9.07349 4.24646L11.2068 5.43314C11.8468 5.78647 12.3401 6.63312 12.3401 7.36645V9.62646C12.3401 10.3531 11.8402 11.1998 11.2068 11.5598L9.07349 12.7465C8.76682 12.9131 8.38682 12.9998 8.00015 12.9998ZM7.41348 5.12646L5.28015 6.31311C4.95348 6.49311 4.66016 6.99978 4.66016 7.36645V9.62646C4.66016 9.99979 4.95348 10.4998 5.28015 10.6798L7.41348 11.8664C7.72015 12.0331 8.28016 12.0331 8.58682 11.8664L10.7202 10.6798C11.0468 10.4998 11.3401 9.99313 11.3401 9.62646V7.36645C11.3401 6.99312 11.0468 6.49311 10.7202 6.31311L8.58682 5.12646C8.28016 4.95979 7.72015 4.95979 7.41348 5.12646Z"
        fill={color}
      />
    </svg>
  );
}
NewCreateBookingIcon.propTypes = {
  color: PropTypes.string,
  size: PropTypes.string,
};
NewCreateBookingIcon.defaultProps = {
  color: '#2179C4"',
  size: '16',
};
export function StarFillIcon({ size }) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 22 21"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M10.5245 1.20571C10.6741 0.745058 11.3259 0.745058 11.4755 1.20571L13.5819 7.68849C13.6488 7.8945 13.8408 8.03398 14.0574 8.03398H20.8738C21.3582 8.03398 21.5596 8.65379 21.1677 8.93849L15.6531 12.9451C15.4779 13.0724 15.4046 13.2981 15.4715 13.5041L17.5779 19.9869C17.7276 20.4475 17.2003 20.8306 16.8085 20.5459L11.2939 16.5393C11.1186 16.412 10.8814 16.412 10.7061 16.5393L5.19153 20.5459C4.79967 20.8306 4.27243 20.4475 4.42211 19.9869L6.52849 13.5041C6.59543 13.2981 6.5221 13.0724 6.34685 12.9451L0.832272 8.93849C0.440415 8.65379 0.641802 8.03398 1.12616 8.03398H7.94256C8.15917 8.03398 8.35115 7.8945 8.41809 7.68849L10.5245 1.20571Z"
        fill="#F2C94C"
      />
    </svg>
  );
}
StarFillIcon.propTypes = {
  size: PropTypes.string,
};
StarFillIcon.defaultProps = {
  size: '221.528vw',
};
export function StarEmptyIcon() {
  return (
    <svg
      width="22"
      height="20"
      viewBox="0 0 22 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M11 0.618035L13.1064 7.10081C13.2403 7.51284 13.6242 7.7918 14.0574 7.7918H20.8738L15.3593 11.7984C15.0088 12.053 14.8621 12.5044 14.996 12.9164L17.1024 19.3992L11.5878 15.3926C11.2373 15.138 10.7627 15.138 10.4122 15.3926L4.89763 19.3992L7.00402 12.9164C7.13789 12.5044 6.99123 12.053 6.64075 11.7984L1.12616 7.7918H7.94256C8.37579 7.7918 8.75974 7.51283 8.89362 7.10081L11 0.618035Z"
        fill="white"
        stroke="#CDD1D1"
      />
    </svg>
  );
}

export function QuloiBlueLogo() {
  return (
    <svg
      width="11.181vw"
      height="4.167vw"
      viewBox="0 0 161 60"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect width="161" height="60" fill="white" />
      <path
        d="M4.32068 28.3907C4.6875 27.6135 4.66431 26.7524 4.84554 25.9304C6.47668 18.5755 12.9476 12.5911 20.2609 11.6981C29.5809 10.5664 38.0947 16.2628 40.4595 25.3399C42.1327 31.7744 40.7669 37.6068 36.5259 42.7546C36.3128 43.1063 35.9546 43.0311 35.6371 43.0339C34.2756 43.0455 32.9127 43.0499 31.5513 43.0339C31.0466 43.0213 30.5485 43.1496 30.113 43.4044C27.6974 44.7909 25.2892 46.1933 22.8475 47.5349C21.8558 48.0791 20.8568 48.6522 19.7041 48.8287C12.9258 47.519 8.32241 43.5723 5.66764 37.2884C5.04273 35.8107 4.7049 34.2491 4.48307 32.6572C4.46132 32.5023 4.54686 32.291 4.32068 32.2027V30.8872C4.42653 30.4996 4.42653 30.0909 4.32068 29.7033V28.3907Z"
        fill="#1A3F6A"
      />
      <path
        d="M4.32068 29.7063C4.42463 29.8863 4.47935 30.0904 4.47935 30.2982C4.47935 30.506 4.42463 30.7101 4.32068 30.8901V29.7063Z"
        fill="#597392"
      />
      <path
        d="M123.387 48.8245C119.668 48.811 116.036 47.6972 112.952 45.6239C109.867 43.5506 107.467 40.6109 106.056 37.1765C104.645 33.742 104.286 29.967 105.024 26.3288C105.762 22.6905 107.564 19.3524 110.202 16.7364C112.841 14.1204 116.197 12.3439 119.847 11.6317C123.497 10.9195 127.276 11.3034 130.707 12.735C134.138 14.1666 137.067 16.5815 139.124 19.6744C141.18 22.7674 142.271 26.3995 142.26 30.1115C142.235 40.4825 133.826 48.8273 123.387 48.8245Z"
        fill="#2DC0DA"
      />
      <path
        d="M46.8318 24.1835C46.8318 20.0834 46.8406 15.9834 46.8203 11.8819C46.8203 11.4028 46.9174 11.2523 47.4263 11.2595C49.6263 11.2895 51.8258 11.2895 54.0248 11.2595C54.5323 11.2595 54.6323 11.4043 54.6309 11.879C54.6154 19.2242 54.612 26.5695 54.6207 33.9148C54.6207 35.5241 54.7657 37.1132 55.4472 38.5995C56.6564 41.2393 59.417 42.633 62.4342 42.1467C65.4515 41.6604 67.4292 39.6285 67.9439 36.5024C68.0788 35.5695 68.1379 34.6271 68.1208 33.6846C68.1208 26.4484 68.1164 19.2122 68.1077 11.9759C68.1077 11.4072 68.228 11.2378 68.824 11.2523C70.9988 11.2928 73.1737 11.2769 75.3572 11.261C75.7559 11.261 75.927 11.3247 75.9256 11.7863C75.9024 19.7013 75.9343 27.6163 75.8748 35.5313C75.8473 39.0858 74.7149 42.2871 72.2762 44.9515C70.1144 47.3076 67.4002 48.6651 64.264 49.1311C60.8292 49.6406 57.4495 49.4076 54.2974 47.8054C50.0811 45.6621 47.7728 42.1308 47.103 37.5184C46.6941 34.7093 46.913 31.8741 46.8695 29.0462C46.8463 27.4239 46.8695 25.8 46.8695 24.1777L46.8318 24.1835Z"
        fill="#1A3F6A"
      />
      <path
        d="M83.0982 30.1158C83.0982 24.0374 83.1084 17.9691 83.0837 11.895C83.0837 11.2799 83.2577 11.1337 83.8507 11.1467C85.566 11.1858 87.2827 11.1931 88.9964 11.1467C89.6141 11.1294 89.7083 11.3378 89.7069 11.8892C89.6914 21.7556 89.688 31.6219 89.6967 41.4883C89.6967 42.4623 89.5851 42.3364 90.5261 42.3364C95.102 42.3422 99.6774 42.3398 104.252 42.3291C104.751 42.3291 104.931 42.4276 104.919 42.9674C104.883 44.8097 104.89 46.6521 104.919 48.493C104.919 48.9662 104.774 49.0719 104.323 49.0719C97.4605 49.0584 90.5976 49.0584 83.7347 49.0719C83.191 49.0719 83.091 48.8953 83.0924 48.4032C83.105 42.3065 83.1069 36.2107 83.0982 30.1158Z"
        fill="#2DC0DA"
      />
      <path
        d="M154.622 30.1651C154.622 36.2797 154.612 42.3943 154.636 48.5089C154.636 49.153 154.445 49.3136 153.822 49.2977C152.082 49.2572 150.342 49.2847 148.611 49.2832C147.751 49.2832 147.749 49.2832 147.749 48.4453V13.9284C147.749 13.1831 147.765 12.4363 147.749 11.6924C147.738 11.3132 147.831 11.1482 148.255 11.1526C150.213 11.1728 152.17 11.1815 154.126 11.1526C154.706 11.1424 154.629 11.471 154.629 11.8241C154.624 17.9373 154.622 24.0509 154.622 30.1651Z"
        fill="#2DC0DA"
      />
      <path
        d="M19.7042 48.8287C23.4261 47.2367 26.8087 45.0282 30.3334 43.0701C30.597 42.9154 30.8976 42.8349 31.2033 42.8371C32.7185 42.8458 34.2336 42.8371 35.7488 42.8371C36.0115 42.8612 36.2764 42.8316 36.5274 42.7502C37.306 42.9239 38.0947 42.811 38.8791 42.8241C40.1318 42.8458 41.3831 42.8414 42.6358 42.8241C42.9968 42.8241 43.136 42.9138 43.1317 43.3002C43.1143 45.1816 43.107 47.063 43.1317 48.9445C43.1418 49.5378 42.7721 49.4206 42.4401 49.4177C36.7956 49.37 31.1511 49.3063 25.5052 49.2802C23.558 49.2802 21.6166 49.2585 19.7042 48.8287Z"
        fill="#2DC0DA"
      />
      <path
        d="M33.4434 30.4169C33.355 33.9699 31.9761 37.0337 29.0328 39.29C24.876 42.4739 19.1169 42.0629 15.3834 38.3739C11.0105 34.0524 10.912 26.8075 15.224 22.4324C18.0745 19.5495 21.5499 18.5075 25.4777 19.5987C29.5156 20.7203 31.9616 23.515 33.081 27.4978C33.3477 28.4154 33.4086 29.3561 33.4434 30.4169Z"
        fill="#FEFEFE"
      />
      <path
        d="M123.45 41.1598C121.989 41.1617 120.541 40.8762 119.19 40.3196C117.839 39.763 116.61 38.9462 115.575 37.9158C114.541 36.8854 113.719 35.6617 113.158 34.3144C112.597 32.9672 112.307 31.5228 112.305 30.0637C112.303 28.6047 112.589 27.1595 113.147 25.8108C113.704 24.4621 114.523 23.2362 115.555 22.2032C116.587 21.1701 117.813 20.3501 119.163 19.79C120.513 19.2299 121.96 18.9406 123.421 18.9387C129.556 18.9387 134.586 23.9636 134.577 30.0825C134.565 33.0216 133.388 35.8365 131.303 37.912C129.218 39.9876 126.395 41.1552 123.45 41.1598Z"
        fill="#FEFEFE"
      />
    </svg>
  );
}
export function SuccessActionIcon() {
  return (
    <svg
      width="301"
      height="230"
      viewBox="0 0 301 230"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g filter="url(#filter0_f_48116_100465)">
        <ellipse
          cx="147.724"
          cy="186.812"
          rx="110.607"
          ry="21.3375"
          fill="#1F88F8"
          fill-opacity="0.35"
        />
      </g>
      <path
        d="M148.939 229.402C212.286 229.402 263.64 178.049 263.64 114.701C263.64 51.3534 212.286 0 148.939 0C85.5912 0 34.2378 51.3534 34.2378 114.701C34.2378 178.049 85.5912 229.402 148.939 229.402Z"
        fill="url(#paint0_linear_48116_100465)"
      />
      <g filter="url(#filter1_d_48116_100465)">
        <path
          d="M245.02 77.624L146.729 146.219L48.4385 77.624L138.416 14.8054C140.856 13.1047 143.759 12.1929 146.733 12.1929C149.708 12.1929 152.611 13.1047 155.051 14.8054L172.999 27.3528L177.698 30.6161L225.016 63.657L230.001 67.1569L245.02 77.624Z"
          fill="url(#paint1_linear_48116_100465)"
        />
      </g>
      <path
        d="M130.747 135.066L48.4385 193.594V77.624L130.747 135.066Z"
        fill="url(#paint2_linear_48116_100465)"
      />
      <g filter="url(#filter2_f_48116_100465)">
        <ellipse
          cx="194.753"
          cy="75.3346"
          rx="36.5786"
          ry="11.7574"
          fill="#FF4C77"
          fill-opacity="0.3"
        />
      </g>
      <path
        d="M162.719 135.066L245.028 193.594V77.624L162.719 135.066Z"
        fill="url(#paint3_linear_48116_100465)"
      />
      <path
        d="M48.4385 193.594L138.31 129.698C140.77 127.947 143.714 127.006 146.733 127.006C149.753 127.006 152.697 127.947 155.157 129.698L245.02 193.594H48.4385Z"
        fill="url(#paint4_linear_48116_100465)"
      />
      <path
        d="M196.445 68.1406C199.188 68.1406 201.105 66.2679 201.105 63.6548C201.105 61.0417 199.188 59.1689 196.445 59.1689C193.744 59.1689 191.785 61.0417 191.785 63.6548C191.785 66.2679 193.744 68.1406 196.445 68.1406ZM200.19 57.5575C200.19 54.5089 201.671 53.333 203.936 52.1571C206.984 50.5892 209.249 48.0196 209.249 44.3613C209.249 38.9173 204.066 35.0847 197.142 35.0847C189.825 35.0847 184.599 39.3963 184.076 45.4501L192.481 46.9744C192.786 44.1871 194.441 42.1401 196.793 42.1401C198.666 42.1401 200.103 43.4467 200.103 45.2323C200.103 47.0179 198.492 48.0196 197.098 48.9342C194.049 50.9376 192.743 53.2023 192.743 57.5575H200.19Z"
        fill="white"
      />
      <g filter="url(#filter3_d_48116_100465)">
        <path
          d="M58.8239 56.6099C43.7553 63.6586 27.5628 67.9977 10.9888 69.4281C13.2283 74.634 29.1406 100.693 76.3765 122.165C77.6534 122.361 107.15 108.639 123.337 99.2293C122.787 100.015 73.0565 81.7159 58.8239 56.6099Z"
          fill="url(#paint5_linear_48116_100465)"
        />
      </g>
      <path
        d="M195.883 85.1295C213.995 85.1295 228.679 70.4462 228.679 52.3333C228.679 34.2205 213.995 19.5371 195.883 19.5371C177.77 19.5371 163.086 34.2205 163.086 52.3333C163.086 70.4462 177.77 85.1295 195.883 85.1295Z"
        fill="url(#paint6_linear_48116_100465)"
      />
      <path
        d="M59.99 69.566C59.2966 69.0849 58.4183 68.955 57.6153 69.2148L31.2513 77.7443C30.3069 78.0499 29.9704 79.2131 30.6059 79.9757C31.1176 80.5898 31.9552 80.8243 32.7114 80.5653L59.748 71.3048C60.5109 71.0435 60.6526 70.0257 59.99 69.566Z"
        fill="#C9DFFF"
      />
      <path
        d="M59.5329 80.0712C58.8642 79.4433 57.9044 79.2341 57.0351 79.5266L38.7837 85.6691C37.9789 85.9399 37.6947 86.9329 38.2344 87.5885C38.6753 88.1241 39.4019 88.3306 40.0586 88.107L59.2051 81.5879C59.8515 81.3678 60.0307 80.5385 59.5329 80.0712Z"
        fill="#C9DFFF"
      />
      <path
        d="M69.3291 85.2731C68.6313 84.7143 67.6928 84.5596 66.8526 84.865L45.8292 92.5059C45.0041 92.8058 44.7558 93.8526 45.3583 94.4911C45.8192 94.9797 46.527 95.1464 47.1576 94.915L69.0677 86.8748C69.7488 86.6248 69.8954 85.7266 69.3291 85.2731Z"
        fill="#C9DFFF"
      />
      <path
        d="M76.6789 101.044C76.0326 100.33 75.0141 100.086 74.1141 100.429L62.0992 105.014C61.3614 105.296 61.0954 106.203 61.5645 106.838C62.0041 107.434 62.7876 107.661 63.4777 107.394L76.3558 102.406C76.9112 102.191 77.0785 101.486 76.6789 101.044Z"
        fill="#C9DFFF"
      />
      <g filter="url(#filter4_d_48116_100465)">
        <path
          d="M233.008 92.9507C251.28 101.498 270.914 106.759 291.011 108.494C288.296 114.806 269.001 146.404 211.725 172.44C210.176 172.678 174.41 156.039 154.782 144.629C155.449 145.582 215.75 123.393 233.008 92.9507Z"
          fill="url(#paint7_linear_48116_100465)"
        />
      </g>
      <path
        d="M231.595 108.661C232.436 108.078 233.5 107.92 234.474 108.235L266.442 118.578C267.587 118.948 267.995 120.359 267.225 121.284C266.604 122.028 265.589 122.313 264.672 121.998L231.888 110.77C230.963 110.453 230.791 109.219 231.595 108.661Z"
        fill="#C9DFFF"
      />
      <path
        d="M222.644 117.175C223.455 116.413 224.619 116.16 225.673 116.514L247.804 123.962C248.78 124.291 249.124 125.495 248.47 126.29C247.935 126.939 247.054 127.19 246.258 126.919L223.042 119.014C222.258 118.747 222.04 117.741 222.644 117.175Z"
        fill="#C9DFFF"
      />
      <path
        d="M213.446 124.242C214.292 123.564 215.43 123.377 216.449 123.747L241.941 133.012C242.941 133.376 243.242 134.645 242.512 135.419C241.953 136.012 241.095 136.214 240.33 135.933L213.763 126.184C212.937 125.881 212.759 124.792 213.446 124.242Z"
        fill="#C9DFFF"
      />
      <path
        d="M192.748 138.382C193.532 137.516 194.767 137.219 195.858 137.636L210.427 143.195C211.321 143.537 211.644 144.637 211.075 145.407C210.542 146.129 209.592 146.405 208.755 146.081L193.14 140.033C192.466 139.772 192.264 138.917 192.748 138.382Z"
        fill="#C9DFFF"
      />
      <path
        d="M202.258 130.831C203.12 130.29 204.184 130.178 205.14 130.527L238.708 142.801C239.781 143.193 240.041 144.592 239.181 145.343C238.612 145.84 237.817 145.987 237.108 145.726L202.48 132.97C201.546 132.626 201.415 131.359 202.258 130.831Z"
        fill="#C9DFFF"
      />
      <path
        d="M83.95 88.7204C83.2388 88.2742 82.3613 88.1819 81.5728 88.4702L53.8892 98.5922C53.0043 98.9157 52.79 100.069 53.4995 100.689C53.9688 101.099 54.6245 101.22 55.2092 101.005L83.7664 90.4847C84.5366 90.201 84.6452 89.1565 83.95 88.7204Z"
        fill="#C9DFFF"
      />
      <path
        d="M239.17 22.2087C241.815 22.2089 243.96 24.3534 243.96 26.9988C243.96 29.6441 241.815 31.7887 239.17 31.7888C236.525 31.7888 234.38 29.6441 234.38 26.9988C234.38 24.3533 236.524 22.2087 239.17 22.2087Z"
        stroke="url(#paint8_linear_48116_100465)"
        stroke-width="2.61276"
      />
      <circle
        cx="69.3406"
        cy="204.666"
        r="4.79006"
        stroke="url(#paint9_linear_48116_100465)"
        stroke-width="2.61276"
      />
      <circle
        cx="216.526"
        cy="214.246"
        r="4.79006"
        stroke="url(#paint10_linear_48116_100465)"
        stroke-width="2.61276"
      />
      <path
        d="M85.5978 31.932C86.1127 29.799 89.1466 29.799 89.6615 31.932L91.3944 39.1108C91.5784 39.8731 92.1735 40.4682 92.9358 40.6522L100.115 42.3851C102.248 42.9 102.248 45.9339 100.115 46.4488L92.9358 48.1817C92.1735 48.3657 91.5784 48.9609 91.3944 49.7231L89.6615 56.9019C89.1466 59.0349 86.1127 59.0349 85.5978 56.9019L83.8648 49.7231C83.6808 48.9609 83.0857 48.3657 82.3235 48.1817L75.1447 46.4488C73.0117 45.9339 73.0117 42.9 75.1447 42.3851L82.3235 40.6522C83.0857 40.4682 83.6808 39.8731 83.8648 39.1108L85.5978 31.932Z"
        fill="url(#paint11_linear_48116_100465)"
      />
      <path
        d="M260.108 183.417C260.623 181.284 263.657 181.284 264.172 183.417L265.905 190.596C266.089 191.358 266.684 191.953 267.446 192.137L274.625 193.87C276.758 194.385 276.758 197.419 274.625 197.934L267.446 199.667C266.684 199.851 266.089 200.446 265.905 201.208L264.172 208.387C263.657 210.52 260.623 210.52 260.108 208.387L258.375 201.208C258.191 200.446 257.596 199.851 256.834 199.667L249.655 197.934C247.522 197.419 247.522 194.385 249.655 193.87L256.834 192.137C257.596 191.953 258.191 191.358 258.375 190.596L260.108 183.417Z"
        fill="url(#paint12_linear_48116_100465)"
      />
      <path
        d="M37.4715 166.614C38.7955 166.402 39.8525 167.703 39.3741 168.956L36.1451 177.411C35.6667 178.664 34.0117 178.929 33.1661 177.888L27.4581 170.864C26.6125 169.823 27.2105 168.258 28.5345 168.046L37.4715 166.614Z"
        fill="url(#paint13_linear_48116_100465)"
      />
      <path
        d="M263.566 80.4219C263.235 79.1226 264.435 77.9519 265.726 78.3147L274.439 80.7633C275.73 81.126 276.144 82.7502 275.184 83.6867L268.707 90.0084C267.747 90.9449 266.134 90.4915 265.803 89.1922L263.566 80.4219Z"
        fill="url(#paint14_linear_48116_100465)"
      />
      <path
        d="M207.553 37.2293C207.007 36.9247 206.406 36.731 205.784 36.6593C205.163 36.5875 204.534 36.6392 203.933 36.8113C203.331 36.9833 202.77 37.2724 202.28 37.6621C201.791 38.0517 201.383 38.5342 201.079 39.082L192.242 55.0145L187.184 49.9477C186.745 49.4922 186.22 49.1289 185.639 48.879C185.058 48.6291 184.434 48.4975 183.802 48.492C183.17 48.4865 182.543 48.6072 181.958 48.8469C181.373 49.0867 180.841 49.4408 180.394 49.8886C179.947 50.3363 179.594 50.8688 179.354 51.4548C179.115 52.0409 178.995 52.6688 179 53.302C179.006 53.9352 179.137 54.561 179.386 55.1428C179.636 55.7246 179.999 56.2508 180.453 56.6907L189.974 66.2283C190.873 67.132 192.087 67.6279 193.339 67.6279L193.998 67.5802C194.728 67.478 195.424 67.2075 196.031 66.79C196.639 66.3725 197.142 65.8195 197.499 65.1744L209.4 43.7149C209.704 43.1675 209.897 42.5656 209.969 41.9435C210.04 41.3213 209.989 40.6911 209.817 40.0889C209.646 39.4866 209.358 38.9241 208.969 38.4335C208.581 37.9428 208.099 37.5337 207.553 37.2293Z"
        fill="white"
      />
      <defs>
        <filter
          id="filter0_f_48116_100465"
          x="15.3437"
          y="143.702"
          width="264.76"
          height="86.221"
          filterUnits="userSpaceOnUse"
          color-interpolation-filters="sRGB"
        >
          <feFlood flood-opacity="0" result="BackgroundImageFix" />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="BackgroundImageFix"
            result="shape"
          />
          <feGaussianBlur
            stdDeviation="10.8865"
            result="effect1_foregroundBlur_48116_100465"
          />
        </filter>
        <filter
          id="filter1_d_48116_100465"
          x="44.9548"
          y="12.1929"
          width="203.549"
          height="140.993"
          filterUnits="userSpaceOnUse"
          color-interpolation-filters="sRGB"
        >
          <feFlood flood-opacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy="3.48368" />
          <feGaussianBlur stdDeviation="1.74184" />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
          />
          <feBlend
            mode="normal"
            in2="BackgroundImageFix"
            result="effect1_dropShadow_48116_100465"
          />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect1_dropShadow_48116_100465"
            result="shape"
          />
        </filter>
        <filter
          id="filter2_f_48116_100465"
          x="136.401"
          y="41.8042"
          width="116.703"
          height="67.0609"
          filterUnits="userSpaceOnUse"
          color-interpolation-filters="sRGB"
        >
          <feFlood flood-opacity="0" result="BackgroundImageFix" />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="BackgroundImageFix"
            result="shape"
          />
          <feGaussianBlur
            stdDeviation="10.8865"
            result="effect1_foregroundBlur_48116_100465"
          />
        </filter>
        <filter
          id="filter3_d_48116_100465"
          x="0.537732"
          y="49.6425"
          width="133.251"
          height="86.459"
          filterUnits="userSpaceOnUse"
          color-interpolation-filters="sRGB"
        >
          <feFlood flood-opacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy="3.48368" />
          <feGaussianBlur stdDeviation="5.22552" />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0.0196078 0 0 0 0 0.168627 0 0 0 0 0.396078 0 0 0 0.15 0"
          />
          <feBlend
            mode="normal"
            in2="BackgroundImageFix"
            result="effect1_dropShadow_48116_100465"
          />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect1_dropShadow_48116_100465"
            result="shape"
          />
        </filter>
        <filter
          id="filter4_d_48116_100465"
          x="134.696"
          y="91.2088"
          width="165.841"
          height="109.103"
          filterUnits="userSpaceOnUse"
          color-interpolation-filters="sRGB"
        >
          <feFlood flood-opacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dx="-5.28021" dy="13.0638" />
          <feGaussianBlur stdDeviation="7.40282" />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0.021441 0 0 0 0 0.168056 0 0 0 0 0.395833 0 0 0 0.15 0"
          />
          <feBlend
            mode="normal"
            in2="BackgroundImageFix"
            result="effect1_dropShadow_48116_100465"
          />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect1_dropShadow_48116_100465"
            result="shape"
          />
        </filter>
        <linearGradient
          id="paint0_linear_48116_100465"
          x1="148.055"
          y1="-37.3495"
          x2="150.404"
          y2="365.463"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="#CAE0FF" stop-opacity="0" />
          <stop offset="1" stop-color="#BCD8FF" />
        </linearGradient>
        <linearGradient
          id="paint1_linear_48116_100465"
          x1="146.729"
          y1="12.1929"
          x2="146.729"
          y2="146.219"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="#EDF4FF" />
          <stop offset="1" stop-color="#ABCCFF" />
        </linearGradient>
        <linearGradient
          id="paint2_linear_48116_100465"
          x1="89.5928"
          y1="77.624"
          x2="89.5928"
          y2="193.594"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="#ABCCFF" />
          <stop offset="1" stop-color="#70A8FF" />
        </linearGradient>
        <linearGradient
          id="paint3_linear_48116_100465"
          x1="203.874"
          y1="77.624"
          x2="203.874"
          y2="193.594"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="#ABCCFF" />
          <stop offset="1" stop-color="#70A8FF" />
        </linearGradient>
        <linearGradient
          id="paint4_linear_48116_100465"
          x1="146.729"
          y1="127.006"
          x2="146.729"
          y2="193.594"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="#70A8FF" />
          <stop offset="1" stop-color="#5597FD" />
        </linearGradient>
        <linearGradient
          id="paint5_linear_48116_100465"
          x1="23.1816"
          y1="85.7857"
          x2="96.7743"
          y2="71.4155"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="#C6DDFF" />
          <stop offset="1" stop-color="white" />
        </linearGradient>
        <linearGradient
          id="paint6_linear_48116_100465"
          x1="163.4"
          y1="23.9502"
          x2="228.719"
          y2="85.3501"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="#FF698D" />
          <stop offset="1" stop-color="#FF3868" />
        </linearGradient>
        <linearGradient
          id="paint7_linear_48116_100465"
          x1="276.227"
          y1="128.328"
          x2="186.991"
          y2="110.903"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="#C6DDFF" />
          <stop offset="1" stop-color="white" />
        </linearGradient>
        <linearGradient
          id="paint8_linear_48116_100465"
          x1="231.676"
          y1="23.1883"
          x2="250.728"
          y2="39.6995"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="#94BFFF" />
          <stop offset="1" stop-color="#4C94FE" />
        </linearGradient>
        <linearGradient
          id="paint9_linear_48116_100465"
          x1="61.847"
          y1="200.856"
          x2="80.8984"
          y2="217.367"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="#94BFFF" />
          <stop offset="1" stop-color="#4C94FE" />
        </linearGradient>
        <linearGradient
          id="paint10_linear_48116_100465"
          x1="209.033"
          y1="210.436"
          x2="228.084"
          y2="226.947"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="#94BFFF" />
          <stop offset="1" stop-color="#4C94FE" />
        </linearGradient>
        <linearGradient
          id="paint11_linear_48116_100465"
          x1="87.6296"
          y1="23.5149"
          x2="87.6296"
          y2="65.319"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="#70A8FF" />
          <stop offset="1" stop-color="#5597FD" />
        </linearGradient>
        <linearGradient
          id="paint12_linear_48116_100465"
          x1="262.14"
          y1="175"
          x2="262.14"
          y2="216.804"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="#70A8FF" />
          <stop offset="1" stop-color="#5597FD" />
        </linearGradient>
        <linearGradient
          id="paint13_linear_48116_100465"
          x1="40.4505"
          y1="166.137"
          x2="26.9327"
          y2="177.122"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="#70A8FF" />
          <stop offset="1" stop-color="#5597FD" />
        </linearGradient>
        <linearGradient
          id="paint14_linear_48116_100465"
          x1="262.821"
          y1="77.4985"
          x2="274.987"
          y2="89.9639"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="#70A8FF" />
          <stop offset="1" stop-color="#5597FD" />
        </linearGradient>
      </defs>
    </svg>
  );
}
export function ExpairedActionIcon() {
  return (
    <svg
      width="304"
      height="263"
      viewBox="0 0 304 263"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M155.715 242.146C219.062 242.146 270.416 190.793 270.416 127.445C270.416 64.0973 219.062 12.7439 155.715 12.7439C92.3672 12.7439 41.0138 64.0973 41.0138 127.445C41.0138 190.793 92.3672 242.146 155.715 242.146Z"
        fill="url(#paint0_linear_48116_100233)"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M3.3009 71.7143C23.4022 59.6437 46.1738 57.3457 67.9762 58.0681C71.0915 58.1714 73.5333 60.7805 73.4301 63.8958C73.3269 67.0112 70.7177 69.4529 67.6024 69.3497C46.6781 68.6564 26.4844 70.9594 9.11188 81.3914C6.43962 82.996 2.97249 82.1306 1.36783 79.4583C-0.236828 76.786 0.628637 73.3189 3.3009 71.7143Z"
        fill="url(#paint1_linear_48116_100233)"
      />
      <g filter="url(#filter0_f_48116_100233)">
        <ellipse
          cx="129.251"
          cy="110.742"
          rx="69.1592"
          ry="11.8183"
          fill="#C4C1FE"
        />
      </g>
      <g filter="url(#filter1_f_48116_100233)">
        <ellipse
          cx="246.559"
          cy="109.867"
          rx="31.5156"
          ry="11.8183"
          fill="#40DFF0"
          fill-opacity="0.6"
        />
      </g>
      <g filter="url(#filter2_f_48116_100233)">
        <ellipse
          cx="171.272"
          cy="228.926"
          rx="69.1592"
          ry="11.8183"
          fill="#C4C1FE"
        />
      </g>
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M302.632 163.421C304.237 166.094 303.371 169.561 300.699 171.165C280.6 183.235 257.817 185.533 236.016 184.812C232.901 184.708 230.459 182.099 230.562 178.984C230.665 175.869 233.274 173.427 236.389 173.53C257.313 174.223 277.518 171.919 294.888 161.488C297.56 159.884 301.028 160.749 302.632 163.421Z"
        fill="url(#paint2_linear_48116_100233)"
      />
      <path
        d="M147.651 228.192H204.976C224.198 228.192 239.783 207.374 239.783 181.686C239.783 155.998 224.198 135.172 204.976 135.172H147.651C159.543 135.172 170.041 143.138 176.313 155.329C180.35 163.538 182.449 172.563 182.449 181.71C182.449 190.858 180.35 199.883 176.313 208.091C170.041 220.25 159.543 228.192 147.651 228.192Z"
        fill="url(#paint3_linear_48116_100233)"
      />
      <path
        d="M188.867 152.249C181.868 138.68 170.153 129.795 156.89 129.795H144.078C122.632 129.795 105.24 153.031 105.24 181.686C105.24 210.341 122.632 233.57 144.078 233.578H156.93C170.193 233.578 181.925 224.709 188.907 211.123C193.408 201.966 195.748 191.898 195.748 181.694C195.748 171.491 193.408 161.423 188.907 152.265L188.867 152.249Z"
        fill="url(#paint4_linear_48116_100233)"
      />
      <path
        d="M175.91 152.249C168.928 138.704 157.237 129.827 143.998 129.795C122.567 129.795 105.2 153.048 105.2 181.686C105.2 210.325 122.567 233.546 143.998 233.578C157.237 233.578 168.928 224.709 175.91 211.123C180.416 201.967 182.76 191.899 182.76 181.694C182.76 171.49 180.416 161.421 175.91 152.265V152.249Z"
        fill="url(#paint5_linear_48116_100233)"
      />
      <path
        d="M149.113 172.119C147.18 175.518 143.944 177.744 140.28 177.744H136.742C130.818 177.744 126.014 171.923 126.014 164.744C126.014 157.565 130.818 151.746 136.742 151.744H140.292C143.955 151.744 147.196 153.966 149.124 157.37C150.367 159.664 151.014 162.186 151.014 164.742C151.014 167.298 150.367 169.821 149.124 172.115L149.113 172.119Z"
        fill="url(#paint6_linear_48116_100233)"
      />
      <path
        d="M149.113 207.119C147.18 210.518 143.944 212.744 140.28 212.744H136.742C130.818 212.744 126.014 206.923 126.014 199.744C126.014 192.565 130.818 186.746 136.742 186.744H140.292C143.955 186.744 147.196 188.966 149.124 192.37C150.367 194.664 151.014 197.186 151.014 199.742C151.014 202.298 150.367 204.821 149.124 207.115L149.113 207.119Z"
        fill="url(#paint7_linear_48116_100233)"
      />
      <path
        d="M145.159 172.119C143.269 175.512 140.103 177.736 136.519 177.744C130.716 177.744 126.014 171.919 126.014 164.744C126.014 157.569 130.716 151.752 136.519 151.744C140.103 151.744 143.269 153.966 145.159 157.37C146.379 159.663 147.014 162.186 147.014 164.742C147.014 167.299 146.379 169.821 145.159 172.115V172.119Z"
        fill="#958FFF"
      />
      <path
        d="M145.159 207.119C143.269 210.512 140.103 212.736 136.519 212.744C130.716 212.744 126.014 206.919 126.014 199.744C126.014 192.569 130.716 186.752 136.519 186.744C140.103 186.744 143.269 188.966 145.159 192.37C146.379 194.663 147.014 197.186 147.014 199.742C147.014 202.299 146.379 204.821 145.159 207.115V207.119Z"
        fill="#958FFF"
      />
      <path
        d="M156.35 114.109H99.0239C79.8024 114.109 64.2091 93.2911 64.2091 67.6033C64.2091 41.9156 79.8024 21.0896 99.0239 21.0896H156.35C144.457 21.0896 133.96 29.0556 127.687 41.2464C123.573 49.4303 121.467 58.4762 121.543 67.6356C121.467 76.7925 123.573 85.8358 127.687 94.0168C133.96 106.143 144.457 114.109 156.35 114.109Z"
        fill="url(#paint8_linear_48116_100233)"
      />
      <path
        d="M115.126 38.1985C122.132 24.629 133.847 15.7439 147.11 15.7439H159.962C181.409 15.7439 198.8 38.9806 198.8 67.6355C198.8 96.2903 181.409 119.519 159.962 119.527H147.11C133.847 119.527 122.116 110.658 115.126 97.0724C110.545 87.9406 108.199 77.8514 108.281 67.6355C108.199 57.4195 110.545 47.3303 115.126 38.1985Z"
        fill="url(#paint9_linear_48116_100233)"
      />
      <path
        d="M128.082 38.1985C135.072 24.6532 146.755 15.7761 160.002 15.7439C181.433 15.7439 198.8 38.9967 198.8 67.6355C198.8 96.2742 181.433 119.495 160.002 119.519C146.755 119.519 135.072 110.65 128.082 97.0724C123.501 87.9406 121.155 77.8514 121.237 67.6355C121.155 57.4195 123.501 47.3303 128.082 38.1985Z"
        fill="url(#paint10_linear_48116_100233)"
      />
      <path
        d="M163.34 58.7505C167.53 58.7505 170.927 54.0361 170.927 48.2206C170.927 42.4051 167.53 37.6907 163.34 37.6907C159.15 37.6907 155.753 42.4051 155.753 48.2206C155.753 54.0361 159.15 58.7505 163.34 58.7505Z"
        fill="url(#paint11_linear_48116_100233)"
      />
      <path
        d="M163.514 60.7439C168.76 60.7439 173.014 55.1475 173.014 48.2439C173.014 41.3403 168.76 35.7439 163.514 35.7439C158.267 35.7439 154.014 41.3403 154.014 48.2439C154.014 55.1475 158.267 60.7439 163.514 60.7439Z"
        fill="#7F79F6"
      />
      <path
        d="M163.514 100.744C168.76 100.744 173.014 95.1475 173.014 88.2439C173.014 81.3403 168.76 75.7439 163.514 75.7439C158.267 75.7439 154.014 81.3403 154.014 88.2439C154.014 95.1475 158.267 100.744 163.514 100.744Z"
        fill="#7F79F6"
      />
      <path
        d="M50.1703 138.025C50.6878 135.881 53.7375 135.881 54.255 138.025L55.9969 145.241C56.1819 146.007 56.7801 146.605 57.5463 146.79L64.7623 148.532C66.9063 149.05 66.9063 152.099 64.7623 152.617L57.5463 154.359C56.7801 154.544 56.1819 155.142 55.9969 155.908L54.255 163.124C53.7375 165.268 50.6878 165.268 50.1703 163.124L48.4284 155.908C48.2434 155.142 47.6452 154.544 46.879 154.359L39.663 152.617C37.519 152.099 37.519 149.05 39.663 148.532L46.879 146.79C47.6452 146.605 48.2434 146.007 48.4284 145.241L50.1703 138.025Z"
        fill="url(#paint12_linear_48116_100233)"
      />
      <path
        d="M163.34 58.7505C167.53 58.7505 170.927 54.0361 170.927 48.2206C170.927 42.4051 167.53 37.6907 163.34 37.6907C159.15 37.6907 155.753 42.4051 155.753 48.2206C155.753 54.0361 159.15 58.7505 163.34 58.7505Z"
        fill="url(#paint13_linear_48116_100233)"
      />
      <path
        d="M163.34 98.7505C167.53 98.7505 170.927 94.0361 170.927 88.2206C170.927 82.4051 167.53 77.6907 163.34 77.6907C159.15 77.6907 155.753 82.4051 155.753 88.2206C155.753 94.0361 159.15 98.7505 163.34 98.7505Z"
        fill="url(#paint14_linear_48116_100233)"
      />
      <path
        d="M224.381 8.46073C224.899 6.31671 227.948 6.3167 228.466 8.46073L230.208 15.6767C230.393 16.4429 230.991 17.0411 231.757 17.2261L238.973 18.968C241.117 19.4856 241.117 22.5352 238.973 23.0528L231.757 24.7947C230.991 24.9796 230.393 25.5778 230.208 26.344L228.466 33.56C227.948 35.7041 224.899 35.7041 224.381 33.56L222.639 26.344C222.454 25.5778 221.856 24.9796 221.09 24.7947L213.874 23.0528C211.73 22.5352 211.73 19.4856 213.874 18.968L221.09 17.2261C221.856 17.0411 222.454 16.4429 222.639 15.6767L224.381 8.46073Z"
        fill="url(#paint15_linear_48116_100233)"
      />
      <circle
        cx="52.2131"
        cy="98.9239"
        r="4.81488"
        stroke="url(#paint16_linear_48116_100233)"
        stroke-width="2.6263"
      />
      <circle
        cx="251.142"
        cy="210.872"
        r="4.81488"
        stroke="url(#paint17_linear_48116_100233)"
        stroke-width="2.6263"
      />
      <path
        d="M246.57 131.614C246.237 130.308 247.443 129.131 248.74 129.496L257.499 131.957C258.796 132.322 259.213 133.954 258.248 134.895L251.737 141.25C250.773 142.191 249.151 141.736 248.818 140.43L246.57 131.614Z"
        fill="url(#paint18_linear_48116_100233)"
      />
      <path
        d="M88.9366 216.247C90.243 215.916 91.4182 217.123 91.0519 218.42L88.5793 227.175C88.213 228.472 86.5799 228.886 85.6398 227.921L79.2938 221.402C78.3536 220.436 78.8115 218.814 80.118 218.483L88.9366 216.247Z"
        fill="url(#paint19_linear_48116_100233)"
      />
      <path
        d="M277.764 82.4135C276.925 88.7368 274.496 94.7441 270.705 99.8738C266.913 105.004 261.883 109.088 256.085 111.746C250.286 114.404 243.908 115.548 237.547 115.071C231.186 114.594 225.05 112.513 219.712 109.02L205.199 113.963C204.759 114.11 204.285 114.127 203.835 114.013C203.385 113.898 202.978 113.656 202.661 113.316C202.345 112.976 202.133 112.552 202.052 112.095C201.97 111.638 202.021 111.166 202.2 110.738L208.038 96.8054C204.95 91.6375 203.144 85.8056 202.772 79.7972C202.399 73.7887 203.47 67.7783 205.894 62.2683C208.319 56.7584 212.028 51.9088 216.71 48.1251C221.393 44.3414 226.912 41.7334 232.809 40.5191C238.705 39.3049 244.806 39.5196 250.602 41.1453C256.399 42.7711 261.722 45.7607 266.126 49.8642C270.531 53.9677 273.89 59.0659 275.921 64.7327C277.953 70.3995 278.598 76.4703 277.804 82.4377L277.764 82.4135Z"
        fill="url(#paint20_linear_48116_100233)"
      />
      <circle
        cx="123.142"
        cy="6.87192"
        r="4.81488"
        stroke="url(#paint21_linear_48116_100233)"
        stroke-width="2.6263"
      />
      <path
        d="M247.836 57.9202L246.385 84.3736H235.782L234.331 57.9202H247.836ZM241.083 100.502C238.926 100.502 237.195 99.9257 235.893 98.7723C234.591 97.6189 233.94 96.1679 233.94 94.4192C233.94 92.6333 234.591 91.1637 235.893 90.0103C237.195 88.8197 238.926 88.2244 241.083 88.2244C243.204 88.2244 244.916 88.8197 246.218 90.0103C247.52 91.1637 248.171 92.6333 248.171 94.4192C248.171 96.1679 247.52 97.6189 246.218 98.7723C244.916 99.9257 243.204 100.502 241.083 100.502Z"
        fill="white"
      />
      <rect
        x="94.0138"
        y="155.744"
        width="50"
        height="18"
        rx="9"
        fill="url(#paint22_linear_48116_100233)"
      />
      <rect
        x="94.0138"
        y="190.744"
        width="50"
        height="18"
        rx="9"
        fill="url(#paint23_linear_48116_100233)"
      />
      <defs>
        <filter
          id="filter0_f_48116_100233"
          x="38.2061"
          y="77.038"
          width="182.09"
          height="67.4083"
          filterUnits="userSpaceOnUse"
          color-interpolation-filters="sRGB"
        >
          <feFlood flood-opacity="0" result="BackgroundImageFix" />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="BackgroundImageFix"
            result="shape"
          />
          <feGaussianBlur
            stdDeviation="10.9429"
            result="effect1_foregroundBlur_48116_100233"
          />
        </filter>
        <filter
          id="filter1_f_48116_100233"
          x="193.157"
          y="76.1625"
          width="106.803"
          height="67.4083"
          filterUnits="userSpaceOnUse"
          color-interpolation-filters="sRGB"
        >
          <feFlood flood-opacity="0" result="BackgroundImageFix" />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="BackgroundImageFix"
            result="shape"
          />
          <feGaussianBlur
            stdDeviation="10.9429"
            result="effect1_foregroundBlur_48116_100233"
          />
        </filter>
        <filter
          id="filter2_f_48116_100233"
          x="80.2266"
          y="195.222"
          width="182.09"
          height="67.4083"
          filterUnits="userSpaceOnUse"
          color-interpolation-filters="sRGB"
        >
          <feFlood flood-opacity="0" result="BackgroundImageFix" />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="BackgroundImageFix"
            result="shape"
          />
          <feGaussianBlur
            stdDeviation="10.9429"
            result="effect1_foregroundBlur_48116_100233"
          />
        </filter>
        <linearGradient
          id="paint0_linear_48116_100233"
          x1="154.831"
          y1="-24.6056"
          x2="157.18"
          y2="378.207"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="white" stop-opacity="0" />
          <stop offset="1" stop-color="#9DB3FF" />
        </linearGradient>
        <linearGradient
          id="paint1_linear_48116_100233"
          x1="65.014"
          y1="82.3596"
          x2="17.1418"
          y2="35.3108"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="#5149F2" />
          <stop offset="1" stop-color="#F7F7FF" />
        </linearGradient>
        <linearGradient
          id="paint2_linear_48116_100233"
          x1="236.053"
          y1="193.033"
          x2="282.244"
          y2="224.131"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="#5149F2" />
          <stop offset="1" stop-color="#F7F7FF" />
        </linearGradient>
        <linearGradient
          id="paint3_linear_48116_100233"
          x1="226.254"
          y1="199.925"
          x2="167.598"
          y2="89.1873"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="#5149F2" />
          <stop offset="1" stop-color="#F7F7FF" />
        </linearGradient>
        <linearGradient
          id="paint4_linear_48116_100233"
          x1="182.458"
          y1="202.04"
          x2="112.569"
          y2="85.8677"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="#5149F2" />
          <stop offset="1" stop-color="#F7F7FF" />
        </linearGradient>
        <linearGradient
          id="paint5_linear_48116_100233"
          x1="111.979"
          y1="188.415"
          x2="182.974"
          y2="187.915"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="#B9B6FF" />
          <stop offset="1" stop-color="#C6C4F9" />
        </linearGradient>
        <linearGradient
          id="paint6_linear_48116_100233"
          x1="155.014"
          y1="171.744"
          x2="132.777"
          y2="140.697"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="#5149F2" />
          <stop offset="1" stop-color="#F7F7FF" />
        </linearGradient>
        <linearGradient
          id="paint7_linear_48116_100233"
          x1="155.014"
          y1="206.744"
          x2="132.777"
          y2="175.697"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="#5149F2" />
          <stop offset="1" stop-color="#F7F7FF" />
        </linearGradient>
        <linearGradient
          id="paint8_linear_48116_100233"
          x1="88.5137"
          y1="118.36"
          x2="84.1659"
          y2="-24.8998"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="#5149F2" />
          <stop offset="1" stop-color="#F7F7FF" />
        </linearGradient>
        <linearGradient
          id="paint9_linear_48116_100233"
          x1="162.514"
          y1="96.8596"
          x2="143.014"
          y2="-31.0826"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="#5149F2" />
          <stop offset="1" stop-color="#F7F7FF" />
        </linearGradient>
        <linearGradient
          id="paint10_linear_48116_100233"
          x1="128.014"
          y1="74.3597"
          x2="199.014"
          y2="73.8597"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="#B9B6FF" />
          <stop offset="1" stop-color="#C6C4F9" />
        </linearGradient>
        <linearGradient
          id="paint11_linear_48116_100233"
          x1="148.51"
          y1="59.1417"
          x2="207.717"
          y2="54.6687"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="#5149F2" />
          <stop offset="1" stop-color="#F7F7FF" />
        </linearGradient>
        <linearGradient
          id="paint12_linear_48116_100233"
          x1="67.0528"
          y1="158.816"
          x2="40.6981"
          y2="108.582"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="#5149F2" />
          <stop offset="1" stop-color="#F7F7FF" />
        </linearGradient>
        <linearGradient
          id="paint13_linear_48116_100233"
          x1="158.014"
          y1="40.244"
          x2="213.075"
          y2="55.7789"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="#5149F2" />
          <stop offset="1" stop-color="#F7F7FF" />
        </linearGradient>
        <linearGradient
          id="paint14_linear_48116_100233"
          x1="158.014"
          y1="80.244"
          x2="213.075"
          y2="95.7789"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="#5149F2" />
          <stop offset="1" stop-color="#F7F7FF" />
        </linearGradient>
        <linearGradient
          id="paint15_linear_48116_100233"
          x1="241.264"
          y1="29.2516"
          x2="214.909"
          y2="-20.9823"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="#5149F2" />
          <stop offset="1" stop-color="#F7F7FF" />
        </linearGradient>
        <linearGradient
          id="paint16_linear_48116_100233"
          x1="56.5415"
          y1="101.328"
          x2="48.8547"
          y2="86.6761"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="#5149F2" />
          <stop offset="1" stop-color="#F7F7FF" />
        </linearGradient>
        <linearGradient
          id="paint17_linear_48116_100233"
          x1="255.47"
          y1="213.276"
          x2="247.783"
          y2="198.624"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="#5149F2" />
          <stop offset="1" stop-color="#F7F7FF" />
        </linearGradient>
        <linearGradient
          id="paint18_linear_48116_100233"
          x1="258.759"
          y1="133.079"
          x2="236.281"
          y2="125.77"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="#5149F2" />
          <stop offset="1" stop-color="#F7F7FF" />
        </linearGradient>
        <linearGradient
          id="paint19_linear_48116_100233"
          x1="87.4558"
          y1="228.434"
          x2="94.794"
          y2="205.965"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="#5149F2" />
          <stop offset="1" stop-color="#F7F7FF" />
        </linearGradient>
        <linearGradient
          id="paint20_linear_48116_100233"
          x1="202.044"
          y1="39.9244"
          x2="240.074"
          y2="115.176"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="#49E2F2" />
          <stop offset="1" stop-color="#31D9EB" />
        </linearGradient>
        <linearGradient
          id="paint21_linear_48116_100233"
          x1="127.47"
          y1="9.27561"
          x2="119.783"
          y2="-5.37593"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="#5149F2" />
          <stop offset="1" stop-color="#F7F7FF" />
        </linearGradient>
        <linearGradient
          id="paint22_linear_48116_100233"
          x1="136.672"
          y1="168.274"
          x2="107.222"
          y2="138.93"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="#5149F2" />
          <stop offset="1" stop-color="#F7F7FF" />
        </linearGradient>
        <linearGradient
          id="paint23_linear_48116_100233"
          x1="136.672"
          y1="203.274"
          x2="131.668"
          y2="176.779"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="#5149F2" />
          <stop offset="1" stop-color="#F7F7FF" />
        </linearGradient>
      </defs>
    </svg>
  );
}
export function PerformedActionIcon() {
  return (
    <svg
      width="260"
      height="256"
      viewBox="0 0 260 256"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M134.54 239.402C197.888 239.402 249.241 188.049 249.241 124.701C249.241 61.3534 197.888 10 134.54 10C71.1927 10 19.8394 61.3534 19.8394 124.701C19.8394 188.049 71.1927 239.402 134.54 239.402Z"
        fill="url(#paint0_linear_48116_100384)"
      />
      <path
        d="M176.447 181.483C176.565 181.483 176.673 181.518 176.766 181.576H234.24L234.344 181.587C234.577 181.635 234.753 181.841 234.753 182.089C234.753 182.336 234.577 182.543 234.344 182.591L234.24 182.602H222.601L222.26 182.864C212.381 190.594 209.845 199.013 209.763 205.51C209.721 208.821 210.317 211.649 210.924 213.647C211.227 214.646 211.532 215.436 211.761 215.974C211.875 216.242 211.97 216.449 212.035 216.586C212.062 216.641 212.083 216.685 212.1 216.718L219.438 224.056L219.074 224.418L218.712 224.781L211.375 217.444C211.341 217.427 211.295 217.404 211.236 217.376C211.097 217.309 210.887 217.211 210.614 217.094C210.068 216.859 209.264 216.545 208.251 216.23C206.223 215.602 203.356 214.977 200.005 214.99C193.386 215.017 184.824 217.534 177.053 227.58V238.395C177.053 238.729 176.782 239 176.447 239C176.113 239 175.842 238.729 175.842 238.395V182.089C175.842 181.755 176.113 181.483 176.447 181.483ZM197.616 205.998C195.91 205.912 193.569 205.968 191.032 206.53C186.048 207.634 180.297 210.69 177.053 218.533V225.933C184.812 216.468 193.316 213.992 200 213.965C203.479 213.951 206.452 214.599 208.555 215.251C208.89 215.355 209.202 215.46 209.492 215.562L200.206 206.275C200.199 206.274 200.192 206.273 200.185 206.271C200.061 206.25 199.876 206.219 199.638 206.186C199.161 206.119 198.468 206.041 197.616 205.998ZM219.438 224.056C219.637 224.256 219.637 224.581 219.438 224.781C219.237 224.981 218.912 224.981 218.712 224.781L219.438 224.056ZM190.075 197.457C189.014 197.349 187.556 197.322 185.968 197.642C182.884 198.263 179.258 200.197 177.053 205.539V216.102C180.555 209.379 186.027 206.589 190.81 205.529C193.459 204.942 195.895 204.885 197.667 204.974C198.17 204.999 198.62 205.037 199.008 205.077L191.646 197.716C191.572 197.698 191.465 197.673 191.329 197.646C191.035 197.586 190.605 197.511 190.075 197.457ZM212.556 182.602C204.572 185.976 201.583 191.699 200.572 196.588C200.063 199.05 200.057 201.306 200.178 202.947C200.238 203.767 200.33 204.432 200.406 204.889C200.416 204.948 200.427 205.003 200.437 205.055L200.766 205.384C200.812 205.416 200.851 205.457 200.884 205.502L210.24 214.858C210.143 214.576 210.042 214.271 209.943 213.945C209.314 211.871 208.694 208.937 208.737 205.497C208.821 198.856 211.374 190.383 220.944 182.602H212.556ZM200.142 182.809C194.911 185.013 192.985 188.518 192.348 191.485C192.016 193.031 192.031 194.446 192.13 195.475C192.179 195.988 192.25 196.403 192.307 196.688C192.333 196.817 192.356 196.92 192.373 196.992L199.23 203.85C199.203 203.594 199.176 203.318 199.154 203.022C199.028 201.314 199.035 198.958 199.568 196.38C200.545 191.655 203.291 186.197 210.154 182.602H200.651L200.142 182.809ZM177.053 203.184C179.424 198.949 182.801 197.233 185.765 196.636C187.48 196.29 189.045 196.321 190.18 196.437C190.252 196.444 190.323 196.453 190.392 196.461L177.053 183.121V203.184ZM191.127 195.746C191.121 195.689 191.114 195.631 191.108 195.572C191.002 194.468 190.985 192.944 191.345 191.271C191.978 188.323 193.773 184.954 198.188 182.602H177.982L191.127 195.746Z"
        fill="url(#paint1_linear_48116_100384)"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M134.721 22.7915C134.148 22.555 133.534 22.4338 132.914 22.4349L132.909 22.4349C131.658 22.436 130.458 22.9337 129.573 23.8187C128.688 24.7032 128.19 25.9023 128.189 27.1532V33.0926H116.451L116.451 27.1452C116.454 22.784 118.189 18.6025 121.272 15.5186C124.356 12.4353 128.536 10.7012 132.897 10.6968L132.899 10.6968C135.06 10.6937 137.201 11.1165 139.199 11.9411C141.199 12.7663 143.016 13.9776 144.547 15.5058C146.078 17.0341 147.292 18.8492 148.121 20.8472C148.949 22.8453 149.376 24.9872 149.376 27.1503V32.8728H137.638V27.1503C137.638 26.5304 137.516 25.9165 137.278 25.3439C137.041 24.7712 136.693 24.2511 136.254 23.8131C135.815 23.3751 135.294 23.028 134.721 22.7915ZM132.899 10.6968L132.897 10.6968L132.899 10.6968Z"
        fill="url(#paint2_linear_48116_100384)"
      />
      <path
        d="M133.628 224.903C157.956 224.903 177.678 205.182 177.678 180.853C177.678 156.525 157.956 136.803 133.628 136.803C109.299 136.803 89.5776 156.525 89.5776 180.853C89.5776 205.182 109.299 224.903 133.628 224.903Z"
        fill="url(#paint3_linear_48116_100384)"
      />
      <path
        d="M203.131 132.29V98.4946C203.131 80.061 195.809 62.3824 182.774 49.3479C169.74 36.3134 152.061 28.9907 133.627 28.9907C115.194 28.9907 97.5153 36.3134 84.4808 49.3479C71.4463 62.3824 64.1236 80.061 64.1236 98.4946V132.29C64.1244 140.054 61.9279 147.66 57.7882 154.228C53.6485 160.797 47.7345 166.059 40.7298 169.408C39.1198 170.175 37.7608 171.383 36.8109 172.893C35.861 174.402 35.3593 176.15 35.3643 177.933V178.116C35.3631 178.76 35.4889 179.398 35.7345 179.993C35.9802 180.589 36.3408 181.13 36.7958 181.586C37.2508 182.041 37.7912 182.403 38.3861 182.65C38.981 182.897 39.6188 183.024 40.2628 183.024H226.983C227.627 183.024 228.265 182.897 228.86 182.65C229.454 182.403 229.995 182.041 230.45 181.586C230.905 181.13 231.265 180.589 231.511 179.993C231.757 179.398 231.883 178.76 231.881 178.116V177.933C231.882 176.155 231.379 174.414 230.431 172.91C229.483 171.406 228.129 170.202 226.525 169.436C219.516 166.085 213.599 160.818 209.459 154.244C205.319 147.67 203.125 140.058 203.131 132.29Z"
        fill="url(#paint4_linear_48116_100384)"
      />
      <path
        d="M106.171 105.002C106.183 105.003 106.196 105.005 106.209 105.007C106.225 105.009 106.242 105.013 106.259 105.017C106.273 105.02 106.287 105.023 106.3 105.027C106.316 105.032 106.332 105.039 106.347 105.045C106.359 105.05 106.372 105.054 106.384 105.06C106.406 105.071 106.428 105.084 106.449 105.098C106.454 105.101 106.459 105.105 106.465 105.108C106.491 105.127 106.518 105.148 106.542 105.172L131.565 130.199L131.588 130.212C131.652 130.257 131.704 130.315 131.745 130.379L164.088 162.727C164.316 162.955 164.316 163.327 164.088 163.556C163.859 163.784 163.488 163.784 163.259 163.556L147.44 147.734L146.986 147.63C134.192 144.768 124.156 148.073 117.281 152.128C113.786 154.19 111.108 156.446 109.305 158.186C108.404 159.055 107.723 159.795 107.268 160.314C107.041 160.574 106.871 160.779 106.759 160.918C106.742 160.938 106.727 160.956 106.714 160.974V163.443C106.714 163.767 106.451 164.029 106.128 164.029C105.804 164.029 105.542 163.767 105.542 163.443V160.974C105.528 160.956 105.513 160.938 105.497 160.918C105.384 160.779 105.214 160.574 104.987 160.314C104.533 159.795 103.851 159.055 102.95 158.186C101.147 156.446 98.4689 154.19 94.9734 152.128C88.0181 148.026 77.8258 144.691 64.8151 147.731L48.8396 163.711C48.6107 163.94 48.2403 163.94 48.0114 163.711C47.7826 163.482 47.7827 163.112 48.0114 162.883L64.0661 146.823C64.0869 146.799 64.1097 146.776 64.1345 146.755L80.5075 130.379C80.5521 130.308 80.613 130.247 80.6862 130.2L89.4763 121.409C89.4858 121.399 89.4962 121.389 89.5066 121.379L105.713 105.172L105.715 105.17C105.738 105.147 105.763 105.126 105.79 105.107L105.804 105.097C105.809 105.093 105.815 105.091 105.82 105.088C105.837 105.077 105.855 105.068 105.873 105.06C105.882 105.055 105.89 105.05 105.899 105.046C105.9 105.045 105.902 105.045 105.903 105.045C105.915 105.04 105.928 105.036 105.941 105.032C105.968 105.023 105.995 105.016 106.022 105.011C106.072 105.002 106.121 104.998 106.171 105.002ZM99.5622 142.316C95.048 138.856 87.4577 135.748 75.1794 137.366L66.3386 146.207C78.8511 143.778 88.7337 147.087 95.5691 151.118C99.1596 153.236 101.91 155.554 103.763 157.343C104.497 158.051 105.091 158.677 105.542 159.176V149.551C105.534 149.533 105.526 149.513 105.516 149.491C105.469 149.384 105.394 149.222 105.291 149.017C105.083 148.605 104.757 148.013 104.288 147.312C103.349 145.907 101.838 144.061 99.5622 142.316ZM137.073 137.365C124.796 135.748 117.207 138.857 112.693 142.316C110.417 144.061 108.907 145.907 107.967 147.312C107.498 148.013 107.172 148.605 106.965 149.017C106.861 149.223 106.786 149.384 106.739 149.491C106.729 149.513 106.721 149.533 106.714 149.551V159.175C107.164 158.676 107.758 158.051 108.492 157.343C110.346 155.554 113.095 153.236 116.685 151.118C123.521 147.086 133.403 143.777 145.916 146.209L137.073 137.365ZM99.1921 132.298C95.0443 129.711 89.0127 127.937 81.3708 131.174L76.5163 136.028C88.2172 134.805 95.6866 137.869 100.275 141.386C102.67 143.221 104.265 145.168 105.262 146.66C105.362 146.809 105.454 146.954 105.542 147.094V138.199L105.541 138.198C105.473 138.102 105.37 137.958 105.232 137.778C104.957 137.417 104.542 136.906 103.997 136.312C102.904 135.121 101.287 133.604 99.1921 132.298ZM130.302 130.935C122.936 128.027 117.105 129.777 113.063 132.298C110.968 133.604 109.352 135.12 108.259 136.312C107.713 136.906 107.299 137.417 107.023 137.778C106.885 137.959 106.783 138.102 106.715 138.198L106.714 138.199V147.094C106.802 146.954 106.894 146.809 106.994 146.66C107.992 145.168 109.586 143.221 111.98 141.386C116.568 137.869 124.037 134.805 135.736 136.028L130.883 131.174L130.302 130.935ZM101.836 122.748C99.329 121.128 95.5148 120.034 90.2478 122.296L83.3337 129.21C90.2664 127.074 95.8563 128.836 99.8122 131.303C102.019 132.679 103.716 134.272 104.86 135.519C105.114 135.796 105.342 136.056 105.542 136.294V126.479C105.506 126.421 105.458 126.344 105.395 126.25C105.241 126.019 105.007 125.689 104.692 125.308C104.061 124.542 103.11 123.572 101.836 122.748ZM121.605 122.132C116.541 120.089 112.856 121.169 110.415 122.748C109.141 123.572 108.193 124.542 107.562 125.308C107.248 125.689 107.014 126.018 106.86 126.249C106.798 126.342 106.749 126.42 106.714 126.479V136.294C106.914 136.056 107.141 135.796 107.395 135.519C108.539 134.272 110.236 132.679 112.443 131.303C116.399 128.836 121.987 127.075 128.919 129.209L122.013 122.303L121.605 122.132ZM92.1677 120.375C96.6382 119.143 100.07 120.212 102.471 121.764C103.837 122.646 104.855 123.676 105.542 124.498V107L92.1677 120.375ZM106.714 124.494C107.399 123.673 108.417 122.646 109.779 121.765C112.18 120.211 115.614 119.141 120.091 120.379L106.714 107V124.494Z"
        fill="url(#paint5_linear_48116_100384)"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M171.568 103.958V0H172.74V103.958H171.568Z"
        fill="#FF607B"
      />
      <path
        d="M181.626 97.7684C181.733 97.498 182.038 97.3644 182.309 97.4705C182.579 97.5768 182.713 97.8827 182.607 98.1531L181.408 101.211C181.366 101.318 181.289 101.408 181.193 101.468L181.089 101.516L177.206 102.858C177.421 103.609 177.559 104.418 177.608 105.265L180.952 104.504L181.028 104.491C181.207 104.475 181.387 104.542 181.511 104.677L184.34 107.725L184.413 107.82C184.554 108.053 184.517 108.361 184.31 108.554C184.103 108.746 183.792 108.76 183.571 108.601L183.481 108.522L180.881 105.721L177.616 106.466C177.579 107.285 177.456 108.071 177.262 108.804L179.78 108.23L179.863 108.218C180.056 108.202 180.247 108.283 180.37 108.437L182.704 111.386L182.768 111.486C182.891 111.729 182.83 112.033 182.609 112.209C182.387 112.385 182.076 112.374 181.868 112.199L181.786 112.114L179.679 109.455L176.82 110.106C176.523 110.809 176.153 111.439 175.726 111.975C175.92 112.45 176.027 112.971 176.027 113.517C176.027 115.717 174.293 117.5 172.154 117.5C170.015 117.5 168.282 115.717 168.282 113.517C168.282 112.971 168.388 112.45 168.581 111.976C168.153 111.438 167.781 110.806 167.484 110.099L164.656 109.455L162.55 112.114C162.349 112.367 161.981 112.41 161.727 112.209C161.474 112.008 161.432 111.639 161.632 111.386L163.966 108.437L164.023 108.376C164.164 108.243 164.364 108.187 164.556 108.23L167.043 108.798C166.85 108.064 166.727 107.278 166.691 106.459L163.454 105.721L160.855 108.522C160.635 108.759 160.264 108.774 160.027 108.554C159.79 108.333 159.776 107.963 159.996 107.725L162.825 104.677L162.881 104.623C163.02 104.508 163.207 104.463 163.385 104.504L166.699 105.26C166.748 104.411 166.887 103.601 167.104 102.849L163.247 101.516C163.102 101.466 162.985 101.354 162.929 101.211L161.73 98.1531L161.702 98.0506C161.66 97.8093 161.791 97.5635 162.028 97.4705C162.264 97.3779 162.528 97.4684 162.662 97.6736L162.71 97.7684L163.821 100.6L167.45 101.854C168.405 99.5228 170.154 97.9609 172.154 97.9607C174.156 97.9607 175.906 99.5269 176.861 101.863L180.515 100.6L181.626 97.7684Z"
        fill="url(#paint6_linear_48116_100384)"
      />
      <path
        d="M258.425 88.9435C258.477 88.8498 258.509 88.7461 258.518 88.6392C258.527 88.5324 258.513 88.4249 258.478 88.3237C258.442 88.2225 258.386 88.13 258.312 88.0522C258.238 87.9744 258.149 87.9131 258.05 87.8723C255.157 86.7186 244.92 83.2942 239.326 90.1979C235.583 94.7353 230.292 97.7262 224.475 98.594C224.328 98.6137 224.191 98.6771 224.081 98.776C223.972 98.8749 223.894 99.0046 223.86 99.1482C223.825 99.2917 223.835 99.4424 223.887 99.5805C223.94 99.7185 224.033 99.8374 224.154 99.9217C229.098 103.428 245.433 112.365 258.425 88.9435Z"
        fill="url(#paint7_linear_48116_100384)"
      />
      <path
        d="M41.596 137.36C41.6373 137.285 41.6622 137.202 41.6692 137.116C41.6762 137.03 41.6651 136.944 41.6366 136.863C41.6081 136.782 41.5629 136.707 41.5038 136.645C41.4448 136.582 41.3732 136.533 41.2938 136.5C38.9773 135.584 30.746 132.837 26.2504 138.331C23.2505 141.971 19.0114 144.374 14.3475 145.079C14.2304 145.095 14.1207 145.145 14.033 145.224C13.9452 145.304 13.8834 145.407 13.8557 145.522C13.828 145.637 13.8356 145.758 13.8776 145.868C13.9196 145.979 13.9941 146.074 14.0911 146.141C18.0374 148.998 31.158 156.176 41.596 137.36Z"
        fill="url(#paint8_linear_48116_100384)"
      />
      <path
        d="M235.903 126.974C235.868 126.912 235.847 126.842 235.841 126.77C235.835 126.699 235.845 126.627 235.869 126.559C235.893 126.491 235.932 126.43 235.982 126.378C236.032 126.327 236.093 126.286 236.159 126.26C238.101 125.482 244.977 123.184 248.731 127.817C251.247 130.865 254.802 132.874 258.711 133.457C258.815 133.466 258.913 133.508 258.991 133.577C259.07 133.645 259.124 133.737 259.148 133.838C259.171 133.94 259.162 134.046 259.121 134.142C259.081 134.238 259.011 134.319 258.921 134.372C255.607 136.744 244.629 142.741 235.903 126.974Z"
        fill="url(#paint9_linear_48116_100384)"
      />
      <path
        d="M0.941581 97.2598C0.885069 97.1551 0.851116 97.0397 0.84191 96.9212C0.832703 96.8026 0.848448 96.6833 0.888128 96.5712C0.927809 96.4591 0.990546 96.3565 1.07229 96.2701C1.15404 96.1836 1.25299 96.1153 1.36276 96.0695C4.56739 94.7968 15.9118 91.0062 22.1105 98.6423C26.2627 103.677 32.1354 106.992 38.5914 107.945C38.7528 107.969 38.9034 108.04 39.0236 108.151C39.1439 108.261 39.2282 108.405 39.2657 108.564C39.3031 108.723 39.2921 108.889 39.2339 109.042C39.1757 109.194 39.0731 109.326 38.9393 109.419C33.4365 113.301 15.3349 123.208 0.941581 97.2598Z"
        fill="url(#paint10_linear_48116_100384)"
      />
      <path
        d="M39.4705 67.5587C39.1557 66.324 40.2956 65.2115 41.5223 65.5563L49.8024 67.8831C51.0291 68.2278 51.4226 69.7712 50.5108 70.6612L44.3556 76.6686C43.4437 77.5586 41.9103 77.1277 41.5955 75.893L39.4705 67.5587Z"
        fill="#FFBEBD"
      />
      <path
        d="M229.771 26.9987C230.261 24.9717 233.144 24.9717 233.633 26.9987L235.28 33.8206C235.455 34.5449 236.02 35.1105 236.745 35.2853L243.567 36.9321C245.594 37.4214 245.594 40.3045 243.567 40.7938L236.745 42.4406C236.02 42.6154 235.455 43.181 235.28 43.9053L233.633 50.7272C233.144 52.7542 230.261 52.7542 229.771 50.7272L228.125 43.9053C227.95 43.181 227.384 42.6154 226.66 42.4406L219.838 40.7938C217.811 40.3045 217.811 37.4214 219.838 36.9321L226.66 35.2853C227.384 35.1105 227.95 34.5449 228.125 33.8206L229.771 26.9987Z"
        fill="#FFBEBD"
      />
      <path
        d="M87.7715 223.999C88.2608 221.972 91.1438 221.972 91.6331 223.999L93.2799 230.821C93.4548 231.545 94.0203 232.11 94.7447 232.285L101.567 233.932C103.594 234.421 103.594 237.304 101.567 237.794L94.7447 239.441C94.0203 239.615 93.4548 240.181 93.2799 240.905L91.6331 247.727C91.1438 249.754 88.2608 249.754 87.7715 247.727L86.1247 240.905C85.9498 240.181 85.3843 239.615 84.6599 239.441L77.838 237.794C75.8111 237.304 75.8111 234.421 77.838 233.932L84.6599 232.285C85.3843 232.11 85.9498 231.545 86.1247 230.821L87.7715 223.999Z"
        fill="#FFBEBD"
      />
      <path
        d="M56.6323 209.241C59.1462 209.241 61.1848 211.279 61.1851 213.793C61.1851 216.307 59.1463 218.346 56.6323 218.346C54.1185 218.345 52.0806 216.307 52.0806 213.793C52.0808 211.279 54.1187 209.241 56.6323 209.241Z"
        stroke="#FFBEBD"
        stroke-width="2.48287"
      />
      <circle
        cx="63.6327"
        cy="34.7934"
        r="4.55192"
        stroke="#FC9999"
        stroke-width="2.48287"
      />
      <circle
        cx="244.633"
        cy="204.793"
        r="4.55192"
        stroke="#FC9999"
        stroke-width="2.48287"
      />
      <defs>
        <linearGradient
          id="paint0_linear_48116_100384"
          x1="133.656"
          y1="-27.3495"
          x2="136.006"
          y2="375.463"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="#FFE1E1" stop-opacity="0" />
          <stop offset="1" stop-color="#FFE1E0" />
        </linearGradient>
        <linearGradient
          id="paint1_linear_48116_100384"
          x1="163.484"
          y1="190.948"
          x2="258.894"
          y2="201.849"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0.0844027" stop-color="#FFBEBD" />
          <stop offset="1" stop-color="#FFF6F5" />
        </linearGradient>
        <linearGradient
          id="paint2_linear_48116_100384"
          x1="157.386"
          y1="34.246"
          x2="140.936"
          y2="4.19656"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="#FF9999" />
          <stop offset="1" stop-color="#FFE7DA" />
        </linearGradient>
        <linearGradient
          id="paint3_linear_48116_100384"
          x1="207.839"
          y1="254.5"
          x2="72.372"
          y2="108.135"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="#FFDEAC" />
          <stop offset="0.70369" stop-color="#FF426F" />
        </linearGradient>
        <linearGradient
          id="paint4_linear_48116_100384"
          x1="160.839"
          y1="170.5"
          x2="118.389"
          y2="45.6981"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="#FF9999" />
          <stop offset="1" stop-color="#FFE7DA" />
        </linearGradient>
        <linearGradient
          id="paint5_linear_48116_100384"
          x1="229.599"
          y1="240.142"
          x2="114.129"
          y2="83.0438"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="#FFBEBD" />
          <stop offset="1" stop-color="#FFF6F5" />
        </linearGradient>
        <linearGradient
          id="paint6_linear_48116_100384"
          x1="204.234"
          y1="66.9998"
          x2="149.016"
          y2="100.954"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="#FFDEAC" />
          <stop offset="1" stop-color="#FF426F" />
        </linearGradient>
        <linearGradient
          id="paint7_linear_48116_100384"
          x1="266.958"
          y1="105.501"
          x2="255.215"
          y2="78.2141"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="#FF9999" />
          <stop offset="1" stop-color="#FFE7DA" />
        </linearGradient>
        <linearGradient
          id="paint8_linear_48116_100384"
          x1="48.4425"
          y1="150.656"
          x2="39.0118"
          y2="128.752"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="#FF9999" />
          <stop offset="1" stop-color="#FFE7DA" />
        </linearGradient>
        <linearGradient
          id="paint9_linear_48116_100384"
          x1="264.834"
          y1="138.129"
          x2="256.922"
          y2="119.765"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="#FF9999" />
          <stop offset="1" stop-color="#FFE7DA" />
        </linearGradient>
        <linearGradient
          id="paint10_linear_48116_100384"
          x1="48.6415"
          y1="115.6"
          x2="35.6417"
          y2="85.3677"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="#FF9999" />
          <stop offset="1" stop-color="#FFE7DA" />
        </linearGradient>
      </defs>
    </svg>
  );
}

export function SomethingWentWrongIcon() {
  return (
    <svg
      width="257"
      height="247"
      viewBox="0 0 257 247"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M127.882 246.286C191.229 246.286 242.583 194.932 242.583 131.585C242.583 68.2372 191.229 16.8838 127.882 16.8838C64.5341 16.8838 13.1807 68.2372 13.1807 131.585C13.1807 194.932 64.5341 246.286 127.882 246.286Z"
        fill="url(#paint0_linear_48290_5979)"
      />
      <path
        d="M189.762 43.5742H62.6976C54.7774 43.5742 48.3569 49.9947 48.3569 57.9148H204.103C204.103 49.9947 197.682 43.5742 189.762 43.5742Z"
        fill="url(#paint1_linear_48290_5979)"
      />
      <path
        d="M48.3569 57.5229H204.103V176.142C204.103 181.415 202.008 186.473 198.279 190.202C194.549 193.932 189.491 196.027 184.218 196.027H68.242C62.9682 196.027 57.9103 193.932 54.1811 190.202C50.452 186.473 48.3569 181.415 48.3569 176.142V57.5229Z"
        fill="url(#paint2_linear_48290_5979)"
      />
      <path
        d="M177.331 72.5056H75.1791C73.0517 72.5056 71.3271 74.2283 71.3271 76.3534C71.3271 78.4785 73.0517 80.2012 75.1791 80.2012H177.331C179.458 80.2012 181.183 78.4785 181.183 76.3534C181.183 74.2283 179.458 72.5056 177.331 72.5056Z"
        fill="url(#paint3_linear_48290_5979)"
      />
      <path
        d="M177.331 105.201H75.1791C73.0517 105.201 71.3271 106.924 71.3271 109.049C71.3271 111.174 73.0517 112.897 75.1791 112.897H177.331C179.458 112.897 181.183 111.174 181.183 109.049C181.183 106.924 179.458 105.201 177.331 105.201Z"
        fill="url(#paint4_linear_48290_5979)"
      />
      <path
        d="M177.331 137.897H75.1791C73.0517 137.897 71.3271 139.619 71.3271 141.745C71.3271 143.87 73.0517 145.592 75.1791 145.592H177.331C179.458 145.592 181.183 143.87 181.183 141.745C181.183 139.619 179.458 137.897 177.331 137.897Z"
        fill="url(#paint5_linear_48290_5979)"
      />
      <path
        d="M177.331 170.592H75.1791C73.0517 170.592 71.3271 172.315 71.3271 174.44C71.3271 176.565 73.0517 178.288 75.1791 178.288H177.331C179.458 178.288 181.183 176.565 181.183 174.44C181.183 172.315 179.458 170.592 177.331 170.592Z"
        fill="url(#paint6_linear_48290_5979)"
      />
      <g filter="url(#filter0_d_48290_5979)">
        <path
          d="M74.4873 130.884H20.093C15.7231 130.884 12.1807 134.426 12.1807 138.796V216.544C12.1807 220.914 15.7231 224.456 20.093 224.456H74.4873C78.8572 224.456 82.3997 220.914 82.3997 216.544V138.796C82.3997 134.426 78.8572 130.884 74.4873 130.884Z"
          fill="url(#paint7_linear_48290_5979)"
        />
      </g>
      <g filter="url(#filter1_d_48290_5979)">
        <path
          d="M229.33 9.44019H169.25C166.45 9.44019 164.181 11.7098 164.181 14.5094V42.7488C164.181 45.5484 166.45 47.818 169.25 47.818H229.33C232.13 47.818 234.4 45.5484 234.4 42.7488V14.5094C234.4 11.7098 232.13 9.44019 229.33 9.44019Z"
          fill="url(#paint8_linear_48290_5979)"
        />
      </g>
      <path
        d="M68.4175 169.779H26.1627C24.7399 169.779 23.5864 170.932 23.5864 172.355V172.363C23.5864 173.786 24.7399 174.94 26.1627 174.94H68.4175C69.8404 174.94 70.9938 173.786 70.9938 172.363V172.355C70.9938 170.932 69.8404 169.779 68.4175 169.779Z"
        fill="url(#paint9_linear_48290_5979)"
      />
      <path
        d="M68.4414 206.094H26.5498C25.1391 206.094 23.9956 207.211 23.9956 208.589V208.598C23.9956 209.976 25.1391 211.094 26.5498 211.094H68.4414C69.8521 211.094 70.9956 209.976 70.9956 208.598V208.589C70.9956 207.211 69.8521 206.094 68.4414 206.094Z"
        fill="url(#paint10_linear_48290_5979)"
      />
      <path
        d="M68.4414 187.094H26.5498C25.1391 187.094 23.9956 188.211 23.9956 189.589V189.598C23.9956 190.976 25.1391 192.094 26.5498 192.094H68.4414C69.8521 192.094 70.9956 190.976 70.9956 189.598V189.589C70.9956 188.211 69.8521 187.094 68.4414 187.094Z"
        fill="url(#paint11_linear_48290_5979)"
      />
      <path
        d="M41.6125 142.89H29.2645C26.5293 142.89 24.312 145.107 24.312 147.842V151.269C24.312 154.004 26.5293 156.222 29.2645 156.222H41.6125C44.3477 156.222 46.565 154.004 46.565 151.269V147.842C46.565 145.107 44.3477 142.89 41.6125 142.89Z"
        fill="url(#paint12_linear_48290_5979)"
      />
      <path
        d="M179.009 34.4528C182.227 34.4528 184.837 31.8435 184.837 28.6248C184.837 25.4061 182.227 22.7969 179.009 22.7969C175.79 22.7969 173.181 25.4061 173.181 28.6248C173.181 31.8435 175.79 34.4528 179.009 34.4528Z"
        fill="#81D5E7"
      />
      <path
        d="M199.836 34.4528C203.054 34.4528 205.664 31.8435 205.664 28.6248C205.664 25.4061 203.054 22.7969 199.836 22.7969C196.617 22.7969 194.008 25.4061 194.008 28.6248C194.008 31.8435 196.617 34.4528 199.836 34.4528Z"
        fill="#81D5E7"
      />
      <path
        d="M220.663 34.4528C223.882 34.4528 226.491 31.8435 226.491 28.6248C226.491 25.4061 223.882 22.7969 220.663 22.7969C217.444 22.7969 214.835 25.4061 214.835 28.6248C214.835 31.8435 217.444 34.4528 220.663 34.4528Z"
        fill="#81D5E7"
      />
      <path
        d="M204.861 173.457L190.101 189.729L231.706 227.467L246.466 211.195L204.861 173.457Z"
        fill="url(#paint13_linear_48290_5979)"
      />
      <path
        d="M158.82 84.8838C192.863 84.8838 220.46 112.481 220.46 146.523C220.46 180.566 192.863 208.163 158.82 208.163C124.778 208.163 97.1807 180.566 97.1807 146.523C97.1807 112.481 124.778 84.8838 158.82 84.8838ZM158.82 94.3389C129.999 94.3389 106.636 117.703 106.636 146.523C106.636 175.344 129.999 198.708 158.82 198.708C187.641 198.708 211.005 175.344 211.005 146.523C211.005 117.703 187.641 94.339 158.82 94.3389Z"
        fill="url(#paint14_linear_48290_5979)"
      />
      <foreignObject x="89.9606" y="77.6635" width="137.72" height="137.72">
        <div
          xmlns="http://www.w3.org/1999/xhtml"
          style={{
            backdropFilter: 'blur(8.34px)',
            clipPath: 'url(#bgblur_0_48290_5979_clip_path)',
            height: '100%',
            width: '100%',
          }}
        />
      </foreignObject>
      <path
        data-figma-bg-blur-radius="16.6751"
        d="M158.821 198.708C187.641 198.708 211.005 175.344 211.005 146.523C211.005 117.703 187.641 94.3386 158.821 94.3386C130 94.3386 106.636 117.703 106.636 146.523C106.636 175.344 130 198.708 158.821 198.708Z"
        fill="url(#paint15_linear_48290_5979)"
        fill-opacity="0.2"
      />
      <path
        d="M171.36 146.523L186.284 131.566C187.683 130.086 188.449 128.12 188.42 126.084C188.391 124.048 187.569 122.104 186.13 120.665C184.69 119.225 182.746 118.404 180.711 118.375C178.675 118.346 176.708 119.112 175.229 120.51L160.271 135.468L145.347 120.51C144.629 119.75 143.765 119.142 142.808 118.721C141.851 118.301 140.819 118.076 139.773 118.062C138.728 118.047 137.69 118.242 136.721 118.635C135.752 119.028 134.872 119.612 134.132 120.351C133.393 121.091 132.809 121.971 132.416 122.94C132.023 123.909 131.828 124.947 131.843 125.992C131.857 127.038 132.082 128.07 132.502 129.027C132.923 129.984 133.531 130.848 134.291 131.566L149.241 146.523L134.291 161.481C133.531 162.199 132.923 163.063 132.502 164.02C132.082 164.977 131.857 166.009 131.843 167.055C131.828 168.1 132.023 169.138 132.416 170.107C132.809 171.076 133.393 171.956 134.132 172.696C134.872 173.435 135.752 174.019 136.721 174.412C137.69 174.805 138.728 175 139.773 174.985C140.819 174.971 141.851 174.746 142.808 174.326C143.765 173.905 144.629 173.297 145.347 172.537L160.304 157.579L175.262 172.537C176.756 173.852 178.695 174.549 180.685 174.485C182.674 174.42 184.564 173.599 185.97 172.19C187.375 170.78 188.19 168.887 188.249 166.898C188.307 164.908 187.605 162.971 186.284 161.481L171.36 146.523Z"
        fill="url(#paint16_linear_48290_5979)"
      />
      <g filter="url(#filter3_f_48290_5979)">
        <ellipse
          cx="160.546"
          cy="175.346"
          rx="36.6853"
          ry="5.41942"
          fill="#EC5575"
          fill-opacity="0.56"
        />
      </g>
      <path
        d="M118.149 211.345C118.666 209.201 121.716 209.201 122.233 211.345L123.975 218.561C124.16 219.327 124.758 219.925 125.525 220.11L132.741 221.852C134.885 222.37 134.885 225.419 132.741 225.937L125.525 227.679C124.758 227.864 124.16 228.462 123.975 229.228L122.233 236.444C121.716 238.588 118.666 238.588 118.149 236.444L116.407 229.228C116.222 228.462 115.624 227.864 114.857 227.679L107.641 225.937C105.497 225.419 105.497 222.37 107.641 221.852L114.857 220.11C115.624 219.925 116.222 219.327 116.407 218.561L118.149 211.345Z"
        fill="url(#paint17_linear_48290_5979)"
      />
      <path
        d="M35.1487 19.3445C35.6662 17.2005 38.7159 17.2005 39.2334 19.3445L40.9753 26.5605C41.1603 27.3267 41.7585 27.9249 42.5247 28.1099L49.7407 29.8518C51.8847 30.3694 51.8847 33.419 49.7407 33.9365L42.5247 35.6784C41.7585 35.8634 41.1603 36.4616 40.9753 37.2278L39.2334 44.4438C38.7159 46.5878 35.6662 46.5878 35.1487 44.4438L33.4068 37.2278C33.2218 36.4616 32.6236 35.8634 31.8574 35.6784L24.6414 33.9365C22.4974 33.419 22.4974 30.3694 24.6414 29.8518L31.8574 28.1099C32.6236 27.9249 33.2218 27.3267 33.4068 26.5605L35.1487 19.3445Z"
        fill="url(#paint18_linear_48290_5979)"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M123.309 20.5135C125.243 20.5135 126.81 18.9458 126.81 17.0118C126.81 15.0779 125.243 13.5101 123.309 13.5101C121.375 13.5101 119.807 15.0779 119.807 17.0118C119.807 18.9458 121.375 20.5135 123.309 20.5135ZM123.309 23.1398C126.693 23.1398 129.437 20.3962 129.437 17.0118C129.437 13.6274 126.693 10.8838 123.309 10.8838C119.924 10.8838 117.181 13.6274 117.181 17.0118C117.181 20.3962 119.924 23.1398 123.309 23.1398Z"
        fill="url(#paint19_linear_48290_5979)"
      />
      <path
        d="M232.195 116.937C231.862 115.631 233.068 114.454 234.365 114.819L243.124 117.28C244.421 117.645 244.837 119.277 243.873 120.219L237.362 126.573C236.398 127.515 234.776 127.059 234.443 125.753L232.195 116.937Z"
        fill="url(#paint20_linear_48290_5979)"
      />
      <path
        d="M26.8935 101.902C28.1999 101.571 29.3751 102.778 29.0088 104.075L26.5362 112.83C26.1699 114.128 24.5368 114.542 23.5967 113.576L17.2507 107.057C16.3105 106.091 16.7684 104.47 18.0749 104.138L26.8935 101.902Z"
        fill="url(#paint21_linear_48290_5979)"
      />
      <path
        d="M193.893 222.902C195.2 222.571 196.375 223.778 196.009 225.075L193.536 233.831C193.17 235.128 191.537 235.542 190.597 234.576L184.251 228.057C183.311 227.091 183.768 225.47 185.075 225.139L193.893 222.902Z"
        fill="url(#paint22_linear_48290_5979)"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M240.309 71.5135C242.243 71.5135 243.81 69.9458 243.81 68.0118C243.81 66.0779 242.243 64.5101 240.309 64.5101C238.375 64.5101 236.807 66.0779 236.807 68.0118C236.807 69.9458 238.375 71.5135 240.309 71.5135ZM240.309 74.1398C243.693 74.1398 246.437 71.3962 246.437 68.0118C246.437 64.6274 243.693 61.8838 240.309 61.8838C236.924 61.8838 234.181 64.6274 234.181 68.0118C234.181 71.3962 236.924 74.1398 240.309 74.1398Z"
        fill="url(#paint23_linear_48290_5979)"
      />
      <path
        d="M231.703 227.469L246.463 211.196L248.686 213.213C250.843 215.17 252.135 217.903 252.276 220.812C252.418 223.72 251.399 226.566 249.442 228.724C247.485 230.881 244.752 232.172 241.843 232.314C238.934 232.456 236.088 231.436 233.931 229.479L231.708 227.463L231.703 227.469Z"
        fill="#65C8DE"
      />
      <defs>
        <filter
          id="filter0_d_48290_5979"
          x="0.180664"
          y="122.884"
          width="100.219"
          height="123.573"
          filterUnits="userSpaceOnUse"
          color-interpolation-filters="sRGB"
        >
          <feFlood flood-opacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dx="3" dy="7" />
          <feGaussianBlur stdDeviation="7.5" />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0.104618 0 0 0 0 0.465612 0 0 0 0 0.545833 0 0 0 0.15 0"
          />
          <feBlend
            mode="normal"
            in2="BackgroundImageFix"
            result="effect1_dropShadow_48290_5979"
          />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect1_dropShadow_48290_5979"
            result="shape"
          />
        </filter>
        <filter
          id="filter1_d_48290_5979"
          x="157.181"
          y="0.440186"
          width="96.2192"
          height="64.3779"
          filterUnits="userSpaceOnUse"
          color-interpolation-filters="sRGB"
        >
          <feFlood flood-opacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dx="6" dy="4" />
          <feGaussianBlur stdDeviation="6.5" />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0.104618 0 0 0 0 0.465612 0 0 0 0 0.545833 0 0 0 0.09 0"
          />
          <feBlend
            mode="normal"
            in2="BackgroundImageFix"
            result="effect1_dropShadow_48290_5979"
          />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect1_dropShadow_48290_5979"
            result="shape"
          />
        </filter>
        <clipPath
          id="bgblur_0_48290_5979_clip_path"
          transform="translate(-89.9606 -77.6635)"
        >
          <path d="M158.821 198.708C187.641 198.708 211.005 175.344 211.005 146.523C211.005 117.703 187.641 94.3386 158.821 94.3386C130 94.3386 106.636 117.703 106.636 146.523C106.636 175.344 130 198.708 158.821 198.708Z" />
        </clipPath>
        <filter
          id="filter3_f_48290_5979"
          x="103.017"
          y="149.083"
          width="115.058"
          height="52.5267"
          filterUnits="userSpaceOnUse"
          color-interpolation-filters="sRGB"
        >
          <feFlood flood-opacity="0" result="BackgroundImageFix" />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="BackgroundImageFix"
            result="shape"
          />
          <feGaussianBlur
            stdDeviation="10.422"
            result="effect1_foregroundBlur_48290_5979"
          />
        </filter>
        <linearGradient
          id="paint0_linear_48290_5979"
          x1="126.997"
          y1="-20.4657"
          x2="129.347"
          y2="382.347"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="white" stop-opacity="0" />
          <stop offset="1" stop-color="#8EE2F4" />
        </linearGradient>
        <linearGradient
          id="paint1_linear_48290_5979"
          x1="48.1805"
          y1="46.8838"
          x2="204.181"
          y2="57.8838"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="#90E3F5" />
          <stop offset="1" stop-color="#65C8DE" />
        </linearGradient>
        <linearGradient
          id="paint2_linear_48290_5979"
          x1="43.6806"
          y1="161.384"
          x2="268.681"
          y2="165.384"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="white" />
          <stop offset="1" stop-color="#BCF3FF" />
        </linearGradient>
        <linearGradient
          id="paint3_linear_48290_5979"
          x1="66.6809"
          y1="79.8838"
          x2="187.681"
          y2="79.8838"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="#65C8DE" />
          <stop offset="1" stop-color="#D2F7FF" />
        </linearGradient>
        <linearGradient
          id="paint4_linear_48290_5979"
          x1="66.6809"
          y1="112.579"
          x2="187.681"
          y2="112.579"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="#65C8DE" />
          <stop offset="1" stop-color="#D2F7FF" />
        </linearGradient>
        <linearGradient
          id="paint5_linear_48290_5979"
          x1="66.6809"
          y1="145.275"
          x2="187.681"
          y2="145.275"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="#65C8DE" />
          <stop offset="1" stop-color="#D2F7FF" />
        </linearGradient>
        <linearGradient
          id="paint6_linear_48290_5979"
          x1="66.6809"
          y1="177.97"
          x2="187.681"
          y2="177.97"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="#65C8DE" />
          <stop offset="1" stop-color="#D2F7FF" />
        </linearGradient>
        <linearGradient
          id="paint7_linear_48290_5979"
          x1="10.0723"
          y1="201.052"
          x2="144.659"
          y2="212.105"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="white" />
          <stop offset="1" stop-color="#BCF3FF" />
        </linearGradient>
        <linearGradient
          id="paint8_linear_48290_5979"
          x1="162.072"
          y1="38.2189"
          x2="263.462"
          y2="41.1517"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="white" />
          <stop offset="1" stop-color="#BCF3FF" />
        </linearGradient>
        <linearGradient
          id="paint9_linear_48290_5979"
          x1="76.4956"
          y1="175.093"
          x2="19.4956"
          y2="175.093"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="#D2F7FF" />
          <stop offset="1" stop-color="#65C8DE" />
        </linearGradient>
        <linearGradient
          id="paint10_linear_48290_5979"
          x1="76.4501"
          y1="211.243"
          x2="19.9399"
          y2="211.243"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="#D2F7FF" />
          <stop offset="1" stop-color="#65C8DE" />
        </linearGradient>
        <linearGradient
          id="paint11_linear_48290_5979"
          x1="76.4501"
          y1="192.243"
          x2="19.9399"
          y2="192.243"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="#D2F7FF" />
          <stop offset="1" stop-color="#65C8DE" />
        </linearGradient>
        <linearGradient
          id="paint12_linear_48290_5979"
          x1="61.9957"
          y1="156.093"
          x2="21.4957"
          y2="156.093"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0.243799" stop-color="#D2F7FF" />
          <stop offset="1" stop-color="#6BCBE0" />
        </linearGradient>
        <linearGradient
          id="paint13_linear_48290_5979"
          x1="199.686"
          y1="198.457"
          x2="214.585"
          y2="182.115"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="#90E3F5" />
          <stop offset="1" stop-color="#65C8DE" />
        </linearGradient>
        <linearGradient
          id="paint14_linear_48290_5979"
          x1="97.041"
          y1="113.335"
          x2="221.13"
          y2="114.141"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="#90E3F5" />
          <stop offset="1" stop-color="#65C8DE" />
        </linearGradient>
        <linearGradient
          id="paint15_linear_48290_5979"
          x1="158.821"
          y1="94.3386"
          x2="211.406"
          y2="230.791"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="white" />
          <stop offset="1" stop-color="#D2F7FF" />
        </linearGradient>
        <linearGradient
          id="paint16_linear_48290_5979"
          x1="132.112"
          y1="121.891"
          x2="188.778"
          y2="174.832"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="#FF698D" />
          <stop offset="1" stop-color="#FF3868" />
        </linearGradient>
        <linearGradient
          id="paint17_linear_48290_5979"
          x1="99.1331"
          y1="212.582"
          x2="141.43"
          y2="212.856"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="#90E3F5" />
          <stop offset="1" stop-color="#65C8DE" />
        </linearGradient>
        <linearGradient
          id="paint18_linear_48290_5979"
          x1="16.1331"
          y1="20.5816"
          x2="58.4299"
          y2="20.8562"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="#90E3F5" />
          <stop offset="1" stop-color="#65C8DE" />
        </linearGradient>
        <linearGradient
          id="paint19_linear_48290_5979"
          x1="117.167"
          y1="13.7123"
          x2="129.503"
          y2="13.7924"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="#90E3F5" />
          <stop offset="1" stop-color="#65C8DE" />
        </linearGradient>
        <linearGradient
          id="paint20_linear_48290_5979"
          x1="227.989"
          y1="123.019"
          x2="240.681"
          y2="110.791"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="#90E3F5" />
          <stop offset="1" stop-color="#65C8DE" />
        </linearGradient>
        <linearGradient
          id="paint21_linear_48290_5979"
          x1="20.8173"
          y1="97.6882"
          x2="33.0285"
          y2="110.396"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="#90E3F5" />
          <stop offset="1" stop-color="#65C8DE" />
        </linearGradient>
        <linearGradient
          id="paint22_linear_48290_5979"
          x1="187.817"
          y1="218.688"
          x2="200.029"
          y2="231.396"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="#90E3F5" />
          <stop offset="1" stop-color="#65C8DE" />
        </linearGradient>
        <linearGradient
          id="paint23_linear_48290_5979"
          x1="234.167"
          y1="64.7123"
          x2="246.503"
          y2="64.7924"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="#90E3F5" />
          <stop offset="1" stop-color="#65C8DE" />
        </linearGradient>
      </defs>
    </svg>
  );
}

export function GenerateDocumentIcon() {
  return (
    <svg
      width="0.972vw"
      height="0.972vw"
      viewBox="0 0 14 15"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M12.425 7.63416H10.395C9.82329 7.63416 9.31579 7.94916 9.05913 8.46249L8.56913 9.43082C8.45246 9.66416 8.21913 9.80999 7.96246 9.80999H6.04913C5.86829 9.80999 5.61163 9.76916 5.44246 9.43082L4.95246 8.46832C4.69579 7.96082 4.18246 7.63999 3.61663 7.63999H1.57496C1.34746 7.63999 1.16663 7.82082 1.16663 8.04832V9.94999C1.16663 12.0675 2.43829 13.3333 4.56163 13.3333H9.44996C11.4508 13.3333 12.6816 12.2367 12.8333 10.2883V8.04249C12.8333 7.82082 12.6525 7.63416 12.425 7.63416Z"
        fill="#616B80"
      />
      <path
        d="M9.44413 1.66663H4.55579C2.43246 1.66663 1.16663 2.93246 1.16663 5.05579V6.82913C1.29496 6.78246 1.43496 6.75913 1.57496 6.75913H3.61663C4.52079 6.75913 5.33163 7.26079 5.73413 8.07163L6.17163 8.92913H7.83996L8.27746 8.06579C8.67996 7.26079 9.49079 6.75913 10.395 6.75913H12.425C12.565 6.75913 12.705 6.78246 12.8333 6.82913V5.05579C12.8333 2.93246 11.5675 1.66663 9.44413 1.66663ZM6.09579 3.65579H7.90413C8.12579 3.65579 8.31246 3.83663 8.31246 4.05829C8.31246 4.28579 8.12579 4.46663 7.90413 4.46663H6.09579C5.87413 4.46663 5.68746 4.28579 5.68746 4.05829C5.68746 3.83663 5.87413 3.65579 6.09579 3.65579ZM8.35913 6.09413H5.64079C5.41913 6.09413 5.23829 5.91329 5.23829 5.69163C5.23829 5.46413 5.41913 5.28329 5.64079 5.28329H8.35913C8.58079 5.28329 8.76163 5.46413 8.76163 5.69163C8.76163 5.91329 8.58079 6.09413 8.35913 6.09413Z"
        fill="#616B80"
      />
    </svg>
  );
}
export function WarningFillIcon() {
  return (
    <svg
      width="0.972vw"
      height="0.972vw"
      viewBox="0 0 14 14"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M12.0068 2.89967L8.04678 0.613008C7.40011 0.239674 6.60011 0.239674 5.94678 0.613008L1.99344 2.89967C1.34678 3.27301 0.946777 3.96634 0.946777 4.71967V9.27967C0.946777 10.0263 1.34678 10.7197 1.99344 11.0997L5.95344 13.3863C6.60011 13.7597 7.40011 13.7597 8.05344 13.3863L12.0134 11.0997C12.6601 10.7263 13.0601 10.033 13.0601 9.27967V4.71967C13.0534 3.96634 12.6534 3.27967 12.0068 2.89967ZM6.50011 4.16634C6.50011 3.89301 6.72678 3.66634 7.00011 3.66634C7.27344 3.66634 7.50011 3.89301 7.50011 4.16634V7.66634C7.50011 7.93967 7.27344 8.16634 7.00011 8.16634C6.72678 8.16634 6.50011 7.93967 6.50011 7.66634V4.16634ZM7.61344 10.0863C7.58011 10.1663 7.53344 10.2397 7.47344 10.3063C7.34678 10.433 7.18011 10.4997 7.00011 10.4997C6.91344 10.4997 6.82678 10.4797 6.74678 10.4463C6.66011 10.413 6.59344 10.3663 6.52678 10.3063C6.46678 10.2397 6.42011 10.1663 6.38011 10.0863C6.34678 10.0063 6.33344 9.91967 6.33344 9.83301C6.33344 9.65967 6.40011 9.48634 6.52678 9.35967C6.59344 9.29967 6.66011 9.25301 6.74678 9.21967C6.99344 9.11301 7.28678 9.17301 7.47344 9.35967C7.53344 9.42634 7.58011 9.49301 7.61344 9.57967C7.64678 9.65967 7.66678 9.74634 7.66678 9.83301C7.66678 9.91967 7.64678 10.0063 7.61344 10.0863Z"
        fill="#BF182C"
      />
    </svg>
  );
}
export function EditsquareIcon() {
  return (
    <svg
      width="10"
      height="10"
      viewBox="0 0 10 10"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M6.25065 9.47982H3.75065C1.48815 9.47982 0.521484 8.51315 0.521484 6.25065V3.75065C0.521484 1.48815 1.48815 0.521484 3.75065 0.521484H4.58398C4.75482 0.521484 4.89648 0.663151 4.89648 0.833984C4.89648 1.00482 4.75482 1.14648 4.58398 1.14648H3.75065C1.82982 1.14648 1.14648 1.82982 1.14648 3.75065V6.25065C1.14648 8.17148 1.82982 8.85482 3.75065 8.85482H6.25065C8.17148 8.85482 8.85482 8.17148 8.85482 6.25065V5.41732C8.85482 5.24648 8.99648 5.10482 9.16732 5.10482C9.33815 5.10482 9.47982 5.24648 9.47982 5.41732V6.25065C9.47982 8.51315 8.51315 9.47982 6.25065 9.47982Z"
        fill="#0088FA"
      />
      <path
        d="M3.54107 7.37074C3.2869 7.37074 3.05357 7.27907 2.88274 7.1124C2.67857 6.90824 2.59107 6.6124 2.6369 6.2999L2.81607 5.04574C2.8494 4.80407 3.00774 4.49157 3.17857 4.32074L6.4619 1.0374C7.29107 0.208236 8.13274 0.208236 8.9619 1.0374C9.41607 1.49157 9.62024 1.95407 9.57857 2.41657C9.54107 2.79157 9.34107 3.15824 8.9619 3.53324L5.67857 6.81657C5.50774 6.9874 5.19524 7.14574 4.95357 7.17907L3.6994 7.35824C3.64524 7.37074 3.59107 7.37074 3.54107 7.37074ZM6.90357 1.47907L3.62024 4.7624C3.54107 4.84157 3.4494 5.0249 3.43274 5.13324L3.25357 6.3874C3.2369 6.50824 3.2619 6.60824 3.3244 6.67074C3.3869 6.73324 3.4869 6.75824 3.60774 6.74157L4.8619 6.5624C4.97024 6.54574 5.15774 6.45407 5.23274 6.3749L8.51607 3.09157C8.7869 2.82074 8.92857 2.57907 8.9494 2.35407C8.9744 2.08324 8.83274 1.79574 8.51607 1.4749C7.8494 0.808236 7.39107 0.995736 6.90357 1.47907Z"
        fill="#0088FA"
      />
      <path
        d="M8.27017 4.09562C8.241 4.09562 8.21183 4.09145 8.18683 4.08312C7.091 3.77479 6.22016 2.90395 5.91183 1.80812C5.866 1.64145 5.96183 1.47062 6.1285 1.42062C6.29517 1.37479 6.466 1.47062 6.51183 1.63729C6.76183 2.52479 7.466 3.22895 8.3535 3.47895C8.52016 3.52479 8.616 3.69979 8.57016 3.86645C8.53266 4.00812 8.40767 4.09562 8.27017 4.09562Z"
        fill="#0088FA"
      />
    </svg>
  );
}
export function WarningIconConnect() {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M21.7605 15.92L15.3605 4.4C14.5005 2.85 13.3105 2 12.0005 2C10.6905 2 9.50047 2.85 8.64047 4.4L2.24047 15.92C1.43047 17.39 1.34047 18.8 1.99047 19.91C2.64047 21.02 3.92047 21.63 5.60047 21.63H18.4005C20.0805 21.63 21.3605 21.02 22.0105 19.91C22.6605 18.8 22.5705 17.38 21.7605 15.92ZM11.2505 9C11.2505 8.59 11.5905 8.25 12.0005 8.25C12.4105 8.25 12.7505 8.59 12.7505 9V14C12.7505 14.41 12.4105 14.75 12.0005 14.75C11.5905 14.75 11.2505 14.41 11.2505 14V9ZM12.7105 17.71C12.6605 17.75 12.6105 17.79 12.5605 17.83C12.5005 17.87 12.4405 17.9 12.3805 17.92C12.3205 17.95 12.2605 17.97 12.1905 17.98C12.1305 17.99 12.0605 18 12.0005 18C11.9405 18 11.8705 17.99 11.8005 17.98C11.7405 17.97 11.6805 17.95 11.6205 17.92C11.5605 17.9 11.5005 17.87 11.4405 17.83C11.3905 17.79 11.3405 17.75 11.2905 17.71C11.1105 17.52 11.0005 17.26 11.0005 17C11.0005 16.74 11.1105 16.48 11.2905 16.29C11.3405 16.25 11.3905 16.21 11.4405 16.17C11.5005 16.13 11.5605 16.1 11.6205 16.08C11.6805 16.05 11.7405 16.03 11.8005 16.02C11.9305 15.99 12.0705 15.99 12.1905 16.02C12.2605 16.03 12.3205 16.05 12.3805 16.08C12.4405 16.1 12.5005 16.13 12.5605 16.17C12.6105 16.21 12.6605 16.25 12.7105 16.29C12.8905 16.48 13.0005 16.74 13.0005 17C13.0005 17.26 12.8905 17.52 12.7105 17.71Z"
        fill="#F2C94C"
      />
    </svg>
  );
}
export function AirIcon() {
  return (
    <svg
      width="26"
      height="16"
      viewBox="0 0 26 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M18.9375 14.1756C18.9375 14.4881 19.1719 14.7225 19.4844 14.7225C19.7969 14.7225 20.0312 14.4881 20.0312 14.1756C20.0312 13.8631 19.7969 13.6287 19.4844 13.6287C19.2109 13.5897 18.9375 13.8631 18.9375 14.1756ZM5.92969 14.1756C5.92969 14.4881 6.16406 14.7225 6.47656 14.7225C6.78906 14.7225 7.02344 14.4881 7.02344 14.1756C7.02344 13.8631 6.78906 13.6287 6.47656 13.6287C6.20312 13.5897 5.92969 13.8631 5.92969 14.1756Z"
        fill="#2179C4"
      />
      <path
        d="M24.9141 10.9297H17.1797C17.2188 10.6562 17.2578 10.3828 17.2578 10.1094V8.9375C17.2578 8.23438 17.1016 7.60937 16.7891 7.02344L19.1719 6.78906C19.3281 6.78906 19.4453 6.63281 19.4453 6.47656C19.4453 6.32031 19.3281 6.16406 19.1328 6.16406H16.2031C15.5781 5.42187 14.7578 4.99219 13.8984 4.75781L13.3906 0.851562C13.3516 0.65625 13.1953 0.5 13 0.5C12.8047 0.5 12.6484 0.65625 12.6094 0.851562L12.0234 4.79687C11.125 4.99219 10.3047 5.5 9.71875 6.20312H6.78906C6.63281 6.20312 6.47656 6.32031 6.47656 6.51562C6.47656 6.67187 6.59375 6.78906 6.75 6.82812L9.13281 7.0625C8.85938 7.64844 8.66406 8.27344 8.66406 8.97656V10.1484C8.66406 10.4219 8.70312 10.6953 8.74219 10.9687H1.08594C0.773438 10.9297 0.5 11.1641 0.5 11.5156C0.5 11.8281 0.734375 12.0625 1.00781 12.1016L1.94531 12.1797V12.5312C1.94531 12.6875 2.10156 12.8438 2.25781 12.8438C2.41406 12.8438 2.57031 12.6875 2.57031 12.5312V12.2578L3.19531 12.2969V12.8047C3.19531 12.9609 3.35156 13.1172 3.50781 13.1172C3.66406 13.1172 3.82031 12.9609 3.82031 12.8047V12.375L6.00781 12.6094V12.9219C5.5 13.1172 5.14844 13.5859 5.14844 14.1719C5.14844 14.9141 5.73437 15.5 6.47656 15.5C7.21875 15.5 7.80469 14.9141 7.80469 14.1719C7.80469 13.5859 7.45312 13.1172 6.94531 12.9219V12.6875L9.875 13C10.6562 13.8594 11.75 14.3672 13 14.3672C14.25 14.3672 15.3438 13.8203 16.125 13L19.0547 12.6875V12.9219C18.5469 13.1172 18.1953 13.5859 18.1953 14.1719C18.1953 14.9141 18.7812 15.5 19.5234 15.5C20.2656 15.5 20.8516 14.9141 20.8516 14.1719C20.8516 13.5859 20.5 13.1172 19.9922 12.9219V12.6094L22.1797 12.375V12.8047C22.1797 12.9609 22.3359 13.1172 22.4922 13.1172C22.6875 13.1172 22.8047 12.9609 22.8047 12.8047V12.2969L23.4297 12.2187V12.4922C23.4297 12.6484 23.5859 12.8047 23.7422 12.8047C23.9375 12.8047 24.0547 12.6484 24.0547 12.4922V12.1406L24.9922 12.0625C25.3047 12.0234 25.5 11.7891 25.5 11.4766C25.5 11.1641 25.2266 10.9297 24.9141 10.9297ZM7.49219 14.1719C7.49219 14.7187 7.0625 15.1484 6.51562 15.1484C5.96875 15.1484 5.53906 14.7187 5.53906 14.1719C5.53906 13.625 5.96875 13.1953 6.51562 13.1953C7.02344 13.1562 7.49219 13.625 7.49219 14.1719ZM14.9531 7.49219H16.0078L16.3984 9.32812H15.2266L14.9531 7.49219ZM11.0469 7.49219L10.7734 9.32812H9.60156L9.99219 7.49219H11.0469ZM12.7266 9.32812H11.3203L11.5156 7.49219H12.7656L12.7266 9.32812ZM13.2734 9.32812L13.2344 7.49219H14.4844L14.6797 9.32812H13.2734ZM20.5 14.1719C20.5 14.7187 20.0703 15.1484 19.5234 15.1484C18.9766 15.1484 18.5469 14.7187 18.5469 14.1719C18.5469 13.625 18.9766 13.1953 19.5234 13.1953C20.0312 13.1562 20.5 13.625 20.5 14.1719Z"
        fill="#2179C4"
      />
    </svg>
  );
}
export function OceanIcon() {
  return (
    <svg
      width="22"
      height="16"
      viewBox="0 0 22 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M11.8089 2.26562H10.6816V4.12472H11.8089V2.26562Z"
        fill="#2179C4"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M7.21094 6.90341V4.3125L15.3291 4.4125V6.99432L11.2496 5.64432L7.21094 6.90341Z"
        fill="#2179C4"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M11.4004 15.4974C11.4004 15.4974 12.0208 13.7474 12.6663 13.4519C13.3118 13.1565 14.7731 12.8724 15.2936 13.1565C15.814 13.4405 19.0618 14.5337 19.0618 14.5337L21.6527 15.4974H11.4004Z"
        fill="#2179C4"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M11.136 15.5017C11.136 15.5017 10.5474 13.7563 9.90419 13.4335C9.26101 13.1108 7.78374 12.8381 7.27237 13.1358C6.76101 13.4335 3.4951 14.5926 3.4951 14.5926L0.738281 15.5017H11.136Z"
        fill="#2179C4"
      />
      <path
        d="M11.8089 0.890625H10.6816V2.0179H11.8089V0.890625Z"
        fill="#2179C4"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M4.58203 8.23026L11.2502 5.64844L11.1661 14.8916C11.1661 14.8916 11.0048 14.9916 10.1866 14.1848C9.3684 13.378 8.82294 13.1553 8.16612 13.1053C7.5093 13.0553 6.51612 13.6393 6.36385 13.6848C6.21158 13.7303 4.58203 8.23026 4.58203 8.23026Z"
        fill="#2179C4"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M18.0686 8.06065L11.4004 5.47656L11.4868 14.7197C11.4868 14.7197 11.6481 14.8175 12.4663 14.0129C13.2845 13.2084 13.8299 12.9834 14.4868 12.9334C15.1436 12.8834 16.1368 13.4584 16.2845 13.5038C16.4322 13.5493 18.0686 8.06065 18.0686 8.06065Z"
        fill="#2179C4"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M16.7818 13.4273L18.4091 8L15.6818 6.96136V3.90909H12.2727V0.5H10.2273V3.90909H6.81818V6.96136L4.09091 8L5.71818 13.4273C4.25909 14.0409 2.60909 14.8182 0.681818 14.8182H0V15.5H0.681818C2.4 15.5 3.88182 14.9455 5.43636 14.2864C6.31591 13.9136 7.675 13.2636 8.64773 13.3977C9.62045 13.5318 10.2273 14.3909 10.6591 15.1568L10.8545 15.5H11.6455L11.8409 15.1568C12.2727 14.3886 12.9114 13.5273 13.8636 13.3977C14.8159 13.2682 16.1841 13.9091 17.0636 14.2864C18.6182 14.9455 20.1 15.5 21.8182 15.5V14.8182C19.8909 14.8182 18.2409 14.0409 16.7818 13.4273ZM10.9091 1.18182H11.5909V1.86364H10.9091V1.18182ZM10.9091 2.54545H11.5909V3.90909H10.9091V2.54545ZM10.9091 14.275C9.54545 12.2909 8.07955 12.5 6.36364 13.1682L4.925 8.41136L10.9091 6.13182V14.275ZM7.5 6.7V4.59091H15V6.70227L11.25 5.27273L7.5 6.7ZM11.5909 14.275V6.13182L17.5727 8.40455L16.1364 13.1682C14.4205 12.5 12.9545 12.2909 11.5909 14.275ZM6.50455 8.92954L7.35682 11.7682C7.37234 11.8117 7.37883 11.858 7.37591 11.9041C7.37299 11.9503 7.36071 11.9953 7.33983 12.0366C7.31894 12.0778 7.28988 12.1144 7.25442 12.1441C7.21896 12.1737 7.17783 12.1959 7.13354 12.2092C7.08925 12.2224 7.04272 12.2266 6.99679 12.2213C6.95085 12.216 6.90647 12.2014 6.86634 12.1785C6.82622 12.1555 6.79118 12.1246 6.76336 12.0877C6.73555 12.0508 6.71554 12.0085 6.70455 11.9636L5.85227 9.13636C5.82671 9.04987 5.83622 8.95679 5.87875 8.87726C5.92128 8.79772 5.99342 8.73813 6.07955 8.71136C6.16484 8.68417 6.25743 8.69185 6.33708 8.73274C6.41672 8.77362 6.47693 8.84438 6.50455 8.92954ZM14.675 14.8818C14.275 14.7 13.9795 14.6818 13.6773 15.0341C13.6474 15.0681 13.6112 15.0959 13.5706 15.1159C13.53 15.136 13.4858 15.1478 13.4407 15.1507C13.3495 15.1567 13.2596 15.1262 13.1909 15.0659C13.1222 15.0056 13.0802 14.9205 13.0743 14.8293C13.0683 14.7381 13.0988 14.6483 13.1591 14.5795C13.6659 13.9886 14.2795 13.9409 14.9568 14.2477C15.0394 14.2851 15.1037 14.3537 15.1357 14.4386C15.1677 14.5234 15.1646 14.6174 15.1273 14.7C15.0899 14.7826 15.0213 14.8469 14.9364 14.8789C14.8516 14.9109 14.7576 14.9078 14.675 14.8705V14.8818ZM7.82273 14.8818C8.225 14.7 8.52045 14.6818 8.82273 15.0341C8.883 15.1028 8.96811 15.1448 9.05932 15.1507C9.15053 15.1567 9.24038 15.1262 9.30909 15.0659C9.37781 15.0056 9.41976 14.9205 9.42573 14.8293C9.4317 14.7381 9.40119 14.6483 9.34091 14.5795C8.83409 13.9886 8.22045 13.9409 7.54318 14.2477C7.4606 14.2848 7.39613 14.3532 7.36395 14.4378C7.33177 14.5224 7.33452 14.6163 7.37159 14.6989C7.40866 14.7814 7.47702 14.8459 7.56162 14.8781C7.64623 14.9103 7.74015 14.9075 7.82273 14.8705V14.8818Z"
        fill="white"
      />
      <path
        d="M6.51601 8.92796C6.46055 8.74675 6.26004 8.64745 6.06815 8.70617C5.87626 8.7649 5.76566 8.9594 5.82111 9.14061L6.69268 11.9886C6.74813 12.1699 6.94864 12.2691 7.14053 12.2104C7.33242 12.1517 7.44303 11.9572 7.38757 11.776L6.51601 8.92796Z"
        fill="white"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M7.79789 14.894C8.22061 14.7122 8.52971 14.7009 8.83652 15.0759C8.86606 15.1129 8.90268 15.1437 8.94425 15.1665C8.98583 15.1893 9.03152 15.2035 9.07867 15.2084C9.12581 15.2133 9.17346 15.2088 9.21883 15.1951C9.2642 15.1814 9.30639 15.1588 9.34293 15.1286C9.37946 15.0984 9.40962 15.0612 9.43163 15.0192C9.45364 14.9773 9.46707 14.9313 9.47113 14.8841C9.47518 14.8369 9.46979 14.7893 9.45527 14.7442C9.44074 14.6991 9.41737 14.6573 9.38652 14.6213C8.87289 13.994 8.23425 13.9395 7.51834 14.2372C7.43825 14.2786 7.37677 14.3487 7.34626 14.4335C7.31575 14.5183 7.31847 14.6115 7.35387 14.6944C7.38927 14.7773 7.45473 14.8437 7.5371 14.8803C7.61947 14.917 7.71264 14.921 7.79789 14.8918V14.894Z"
        fill="white"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M14.7252 14.9014C14.3092 14.7082 14.0002 14.6742 13.6797 15.0492C13.6517 15.0906 13.6153 15.1257 13.5728 15.1521C13.5302 15.1785 13.4826 15.1956 13.433 15.2022C13.3834 15.2089 13.333 15.205 13.285 15.1908C13.237 15.1766 13.1926 15.1523 13.1547 15.1197C13.1167 15.0871 13.0861 15.0468 13.0649 15.0015C13.0436 14.9562 13.0322 14.907 13.0313 14.8569C13.0304 14.8069 13.0402 14.7573 13.0599 14.7113C13.0796 14.6653 13.1088 14.624 13.1456 14.5901C13.6797 13.9787 14.3206 13.9378 15.0252 14.2673C15.0674 14.287 15.1053 14.3149 15.1368 14.3492C15.1683 14.3836 15.1927 14.4238 15.2086 14.4676C15.2246 14.5114 15.2317 14.5579 15.2297 14.6044C15.2276 14.651 15.2164 14.6967 15.1967 14.7389C15.177 14.7812 15.1492 14.8191 15.1149 14.8506C15.0805 14.8821 15.0403 14.9065 14.9965 14.9224C14.9527 14.9383 14.9062 14.9455 14.8596 14.9434C14.8131 14.9414 14.7674 14.9302 14.7252 14.9105V14.9014Z"
        fill="white"
      />
    </svg>
  );
}
export function OwnersIcon() {
  return (
    <svg
      width="30"
      height="30"
      viewBox="0 0 30 30"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M12 5C9.38 5 7.25 7.13 7.25 9.75C7.25 12.32 9.26 14.4 11.88 14.49C11.96 14.48 12.04 14.48 12.1 14.49C12.12 14.49 12.13 14.49 12.15 14.49C12.16 14.49 12.16 14.49 12.17 14.49C14.73 14.4 16.74 12.32 16.75 9.75C16.75 7.13 14.62 5 12 5Z"
        fill="#D2253B"
      />
      <path
        d="M17.08 17.1499C14.29 15.2899 9.73996 15.2899 6.92996 17.1499C5.65996 17.9999 4.95996 19.1499 4.95996 20.3799C4.95996 21.6099 5.65996 22.7499 6.91996 23.5899C8.31996 24.5299 10.16 24.9999 12 24.9999C13.84 24.9999 15.68 24.5299 17.08 23.5899C18.34 22.7399 19.04 21.5999 19.04 20.3599C19.03 19.1299 18.34 17.9899 17.08 17.1499Z"
        fill="#D2253B"
      />
      <path
        d="M22.9899 10.3401C23.1499 12.2801 21.7699 13.9801 19.8599 14.2101C19.8499 14.2101 19.8499 14.2101 19.8399 14.2101H19.8099C19.7499 14.2101 19.6899 14.2101 19.6399 14.2301C18.6699 14.2801 17.7799 13.9701 17.1099 13.4001C18.1399 12.4801 18.7299 11.1001 18.6099 9.6001C18.5399 8.7901 18.2599 8.0501 17.8399 7.4201C18.2199 7.2301 18.6599 7.1101 19.1099 7.0701C21.0699 6.9001 22.8199 8.3601 22.9899 10.3401Z"
        fill="#D2253B"
      />
      <path
        d="M24.9902 19.5899C24.9102 20.5599 24.2902 21.3999 23.2502 21.9699C22.2502 22.5199 20.9902 22.7799 19.7402 22.7499C20.4602 22.0999 20.8802 21.2899 20.9602 20.4299C21.0602 19.1899 20.4702 17.9999 19.2902 17.0499C18.6202 16.5199 17.8402 16.0999 16.9902 15.7899C19.2002 15.1499 21.9802 15.5799 23.6902 16.9599C24.6102 17.6999 25.0802 18.6299 24.9902 19.5899Z"
        fill="#D2253B"
      />
      <path
        d="M10.5903 22.6598C10.4003 22.6598 10.2103 22.5898 10.0603 22.4398C9.77027 22.1498 9.77027 21.6698 10.0603 21.3798L12.8803 18.5598C13.1703 18.2698 13.6503 18.2698 13.9403 18.5598C14.2303 18.8498 14.2303 19.3298 13.9403 19.6198L11.1203 22.4398C10.9703 22.5898 10.7803 22.6598 10.5903 22.6598Z"
        fill="white"
      />
      <path
        d="M13.4103 22.6598C13.2203 22.6598 13.0303 22.5898 12.8803 22.4398L10.0603 19.6198C9.77027 19.3298 9.77027 18.8498 10.0603 18.5598C10.3503 18.2698 10.8303 18.2698 11.1203 18.5598L13.9403 21.3798C14.2303 21.6698 14.2303 22.1498 13.9403 22.4398C13.7903 22.5898 13.6003 22.6598 13.4103 22.6598Z"
        fill="white"
      />
    </svg>
  );
}
export function OwnersIconWhite() {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M9 2C6.38 2 4.25 4.13 4.25 6.75C4.25 9.32 6.26 11.4 8.88 11.49C8.96 11.48 9.04 11.48 9.1 11.49C9.12 11.49 9.13 11.49 9.15 11.49C9.16 11.49 9.16 11.49 9.17 11.49C11.73 11.4 13.74 9.32 13.75 6.75C13.75 4.13 11.62 2 9 2Z"
        fill="white"
      />
      <path
        d="M14.08 14.1499C11.29 12.2899 6.73996 12.2899 3.92996 14.1499C2.65996 14.9999 1.95996 16.1499 1.95996 17.3799C1.95996 18.6099 2.65996 19.7499 3.91996 20.5899C5.31996 21.5299 7.15996 21.9999 8.99996 21.9999C10.84 21.9999 12.68 21.5299 14.08 20.5899C15.34 19.7399 16.04 18.5999 16.04 17.3599C16.03 16.1299 15.34 14.9899 14.08 14.1499Z"
        fill="white"
      />
      <path
        d="M19.9901 7.3401C20.1501 9.2801 18.7701 10.9801 16.8601 11.2101C16.8501 11.2101 16.8501 11.2101 16.8401 11.2101H16.8101C16.7501 11.2101 16.6901 11.2101 16.6401 11.2301C15.6701 11.2801 14.7801 10.9701 14.1101 10.4001C15.1401 9.4801 15.7301 8.1001 15.6101 6.6001C15.5401 5.7901 15.2601 5.0501 14.8401 4.4201C15.2201 4.2301 15.6601 4.1101 16.1101 4.0701C18.0701 3.9001 19.8201 5.3601 19.9901 7.3401Z"
        fill="white"
      />
      <path
        d="M21.99 16.5899C21.91 17.5599 21.29 18.3999 20.25 18.9699C19.25 19.5199 17.99 19.7799 16.74 19.7499C17.46 19.0999 17.88 18.2899 17.96 17.4299C18.06 16.1899 17.47 14.9999 16.29 14.0499C15.62 13.5199 14.84 13.0999 13.99 12.7899C16.2 12.1499 18.98 12.5799 20.69 13.9599C21.61 14.6999 22.08 15.6299 21.99 16.5899Z"
        fill="white"
      />
      <path
        d="M7.59027 19.6598C7.40027 19.6598 7.21027 19.5898 7.06027 19.4398C6.77027 19.1498 6.77027 18.6698 7.06027 18.3798L9.88027 15.5598C10.1703 15.2698 10.6503 15.2698 10.9403 15.5598C11.2303 15.8498 11.2303 16.3298 10.9403 16.6198L8.12027 19.4398C7.97027 19.5898 7.78027 19.6598 7.59027 19.6598Z"
        fill="#BF182C"
      />
      <path
        d="M10.4103 19.6598C10.2203 19.6598 10.0303 19.5898 9.88027 19.4398L7.06027 16.6198C6.77027 16.3298 6.77027 15.8498 7.06027 15.5598C7.35027 15.2698 7.83027 15.2698 8.12027 15.5598L10.9403 18.3798C11.2303 18.6698 11.2303 19.1498 10.9403 19.4398C10.7903 19.5898 10.6003 19.6598 10.4103 19.6598Z"
        fill="#BF182C"
      />
    </svg>
  );
}
